(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target2, all) => {
    for (var name in all)
      __defProp(target2, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except2, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except2)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target2) => (target2 = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target2, "default", { value: mod, enumerable: true }) : target2,
    mod
  ));

  // node_modules/mapbox-gl/dist/mapbox-gl.js
  var require_mapbox_gl = __commonJS({
    "node_modules/mapbox-gl/dist/mapbox-gl.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global2 = typeof globalThis !== "undefined" ? globalThis : global2 || self, global2.mapboxgl = factory());
      })(exports, function() {
        "use strict";
        var shared, worker, mapboxgl2;
        function define3(_, chunk) {
          if (!shared) {
            shared = chunk;
          } else if (!worker) {
            worker = chunk;
          } else {
            var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl2 = chunk(sharedChunk);
            if (typeof window !== "undefined" && window && window.URL && window.URL.createObjectURL) {
              mapboxgl2.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: "text/javascript" }));
            }
          }
        }
        define3(["exports"], function(t) {
          var e = 1e-6, r = "undefined" != typeof Float32Array ? Float32Array : Array;
          function n(t2, e2) {
            var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], o2 = r2 * s2 - i2 * n2;
            return o2 ? (t2[0] = s2 * (o2 = 1 / o2), t2[1] = -n2 * o2, t2[2] = -i2 * o2, t2[3] = r2 * o2, t2) : null;
          }
          function i() {
            var t2 = new r(9);
            return r != Float32Array && (t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[5] = 0, t2[6] = 0, t2[7] = 0), t2[0] = 1, t2[4] = 1, t2[8] = 1, t2;
          }
          function s(t2, e2) {
            var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], o2 = e2[4], a2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8];
            return t2[0] = o2 * c2 - a2 * u2, t2[1] = i2 * u2 - n2 * c2, t2[2] = n2 * a2 - i2 * o2, t2[3] = a2 * l2 - s2 * c2, t2[4] = r2 * c2 - i2 * l2, t2[5] = i2 * s2 - r2 * a2, t2[6] = s2 * u2 - o2 * l2, t2[7] = n2 * l2 - r2 * u2, t2[8] = r2 * o2 - n2 * s2, t2;
          }
          function o(t2, e2, r2) {
            var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = e2[3], a2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h3 = e2[8], p3 = r2[0], f2 = r2[1], d2 = r2[2], m2 = r2[3], y2 = r2[4], g2 = r2[5], x2 = r2[6], v2 = r2[7], b2 = r2[8];
            return t2[0] = p3 * n2 + f2 * o2 + d2 * u2, t2[1] = p3 * i2 + f2 * a2 + d2 * c2, t2[2] = p3 * s2 + f2 * l2 + d2 * h3, t2[3] = m2 * n2 + y2 * o2 + g2 * u2, t2[4] = m2 * i2 + y2 * a2 + g2 * c2, t2[5] = m2 * s2 + y2 * l2 + g2 * h3, t2[6] = x2 * n2 + v2 * o2 + b2 * u2, t2[7] = x2 * i2 + v2 * a2 + b2 * c2, t2[8] = x2 * s2 + v2 * l2 + b2 * h3, t2;
          }
          function a() {
            var t2 = new r(16);
            return r != Float32Array && (t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0), t2[0] = 1, t2[5] = 1, t2[10] = 1, t2[15] = 1, t2;
          }
          function l(t2) {
            return t2[0] = 1, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = 1, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 1, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
          }
          function u(t2, e2) {
            var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], o2 = e2[4], a2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8], h3 = e2[9], p3 = e2[10], f2 = e2[11], d2 = e2[12], m2 = e2[13], y2 = e2[14], g2 = e2[15], x2 = r2 * a2 - n2 * o2, v2 = r2 * l2 - i2 * o2, b2 = r2 * u2 - s2 * o2, w2 = n2 * l2 - i2 * a2, _2 = n2 * u2 - s2 * a2, A2 = i2 * u2 - s2 * l2, M2 = c2 * m2 - h3 * d2, I2 = c2 * y2 - p3 * d2, S2 = c2 * g2 - f2 * d2, z2 = h3 * y2 - p3 * m2, k2 = h3 * g2 - f2 * m2, P2 = p3 * g2 - f2 * y2, E2 = x2 * P2 - v2 * k2 + b2 * z2 + w2 * S2 - _2 * I2 + A2 * M2;
            return E2 ? (t2[0] = (a2 * P2 - l2 * k2 + u2 * z2) * (E2 = 1 / E2), t2[1] = (i2 * k2 - n2 * P2 - s2 * z2) * E2, t2[2] = (m2 * A2 - y2 * _2 + g2 * w2) * E2, t2[3] = (p3 * _2 - h3 * A2 - f2 * w2) * E2, t2[4] = (l2 * S2 - o2 * P2 - u2 * I2) * E2, t2[5] = (r2 * P2 - i2 * S2 + s2 * I2) * E2, t2[6] = (y2 * b2 - d2 * A2 - g2 * v2) * E2, t2[7] = (c2 * A2 - p3 * b2 + f2 * v2) * E2, t2[8] = (o2 * k2 - a2 * S2 + u2 * M2) * E2, t2[9] = (n2 * S2 - r2 * k2 - s2 * M2) * E2, t2[10] = (d2 * _2 - m2 * b2 + g2 * x2) * E2, t2[11] = (h3 * b2 - c2 * _2 - f2 * x2) * E2, t2[12] = (a2 * I2 - o2 * z2 - l2 * M2) * E2, t2[13] = (r2 * z2 - n2 * I2 + i2 * M2) * E2, t2[14] = (m2 * v2 - d2 * w2 - y2 * x2) * E2, t2[15] = (c2 * w2 - h3 * v2 + p3 * x2) * E2, t2) : null;
          }
          function c(t2, e2, r2) {
            var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = e2[3], a2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h3 = e2[8], p3 = e2[9], f2 = e2[10], d2 = e2[11], m2 = e2[12], y2 = e2[13], g2 = e2[14], x2 = e2[15], v2 = r2[0], b2 = r2[1], w2 = r2[2], _2 = r2[3];
            return t2[0] = v2 * n2 + b2 * a2 + w2 * h3 + _2 * m2, t2[1] = v2 * i2 + b2 * l2 + w2 * p3 + _2 * y2, t2[2] = v2 * s2 + b2 * u2 + w2 * f2 + _2 * g2, t2[3] = v2 * o2 + b2 * c2 + w2 * d2 + _2 * x2, t2[4] = (v2 = r2[4]) * n2 + (b2 = r2[5]) * a2 + (w2 = r2[6]) * h3 + (_2 = r2[7]) * m2, t2[5] = v2 * i2 + b2 * l2 + w2 * p3 + _2 * y2, t2[6] = v2 * s2 + b2 * u2 + w2 * f2 + _2 * g2, t2[7] = v2 * o2 + b2 * c2 + w2 * d2 + _2 * x2, t2[8] = (v2 = r2[8]) * n2 + (b2 = r2[9]) * a2 + (w2 = r2[10]) * h3 + (_2 = r2[11]) * m2, t2[9] = v2 * i2 + b2 * l2 + w2 * p3 + _2 * y2, t2[10] = v2 * s2 + b2 * u2 + w2 * f2 + _2 * g2, t2[11] = v2 * o2 + b2 * c2 + w2 * d2 + _2 * x2, t2[12] = (v2 = r2[12]) * n2 + (b2 = r2[13]) * a2 + (w2 = r2[14]) * h3 + (_2 = r2[15]) * m2, t2[13] = v2 * i2 + b2 * l2 + w2 * p3 + _2 * y2, t2[14] = v2 * s2 + b2 * u2 + w2 * f2 + _2 * g2, t2[15] = v2 * o2 + b2 * c2 + w2 * d2 + _2 * x2, t2;
          }
          function h2(t2, e2, r2) {
            var n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2 = r2[0], y2 = r2[1], g2 = r2[2];
            return e2 === t2 ? (t2[12] = e2[0] * m2 + e2[4] * y2 + e2[8] * g2 + e2[12], t2[13] = e2[1] * m2 + e2[5] * y2 + e2[9] * g2 + e2[13], t2[14] = e2[2] * m2 + e2[6] * y2 + e2[10] * g2 + e2[14], t2[15] = e2[3] * m2 + e2[7] * y2 + e2[11] * g2 + e2[15]) : (i2 = e2[1], s2 = e2[2], o2 = e2[3], a2 = e2[4], l2 = e2[5], u2 = e2[6], c2 = e2[7], h3 = e2[8], p3 = e2[9], f2 = e2[10], d2 = e2[11], t2[0] = n2 = e2[0], t2[1] = i2, t2[2] = s2, t2[3] = o2, t2[4] = a2, t2[5] = l2, t2[6] = u2, t2[7] = c2, t2[8] = h3, t2[9] = p3, t2[10] = f2, t2[11] = d2, t2[12] = n2 * m2 + a2 * y2 + h3 * g2 + e2[12], t2[13] = i2 * m2 + l2 * y2 + p3 * g2 + e2[13], t2[14] = s2 * m2 + u2 * y2 + f2 * g2 + e2[14], t2[15] = o2 * m2 + c2 * y2 + d2 * g2 + e2[15]), t2;
          }
          function p2(t2, e2, r2) {
            var n2 = r2[0], i2 = r2[1], s2 = r2[2];
            return t2[0] = e2[0] * n2, t2[1] = e2[1] * n2, t2[2] = e2[2] * n2, t2[3] = e2[3] * n2, t2[4] = e2[4] * i2, t2[5] = e2[5] * i2, t2[6] = e2[6] * i2, t2[7] = e2[7] * i2, t2[8] = e2[8] * s2, t2[9] = e2[9] * s2, t2[10] = e2[10] * s2, t2[11] = e2[11] * s2, t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15], t2;
          }
          function f(t2, e2, r2) {
            var n2 = Math.sin(r2), i2 = Math.cos(r2), s2 = e2[4], o2 = e2[5], a2 = e2[6], l2 = e2[7], u2 = e2[8], c2 = e2[9], h3 = e2[10], p3 = e2[11];
            return e2 !== t2 && (t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[3], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[4] = s2 * i2 + u2 * n2, t2[5] = o2 * i2 + c2 * n2, t2[6] = a2 * i2 + h3 * n2, t2[7] = l2 * i2 + p3 * n2, t2[8] = u2 * i2 - s2 * n2, t2[9] = c2 * i2 - o2 * n2, t2[10] = h3 * i2 - a2 * n2, t2[11] = p3 * i2 - l2 * n2, t2;
          }
          function d(t2, e2, r2) {
            var n2 = Math.sin(r2), i2 = Math.cos(r2), s2 = e2[0], o2 = e2[1], a2 = e2[2], l2 = e2[3], u2 = e2[8], c2 = e2[9], h3 = e2[10], p3 = e2[11];
            return e2 !== t2 && (t2[4] = e2[4], t2[5] = e2[5], t2[6] = e2[6], t2[7] = e2[7], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[0] = s2 * i2 - u2 * n2, t2[1] = o2 * i2 - c2 * n2, t2[2] = a2 * i2 - h3 * n2, t2[3] = l2 * i2 - p3 * n2, t2[8] = s2 * n2 + u2 * i2, t2[9] = o2 * n2 + c2 * i2, t2[10] = a2 * n2 + h3 * i2, t2[11] = l2 * n2 + p3 * i2, t2;
          }
          function m(t2, e2, r2) {
            var n2 = Math.sin(r2), i2 = Math.cos(r2), s2 = e2[0], o2 = e2[1], a2 = e2[2], l2 = e2[3], u2 = e2[4], c2 = e2[5], h3 = e2[6], p3 = e2[7];
            return e2 !== t2 && (t2[8] = e2[8], t2[9] = e2[9], t2[10] = e2[10], t2[11] = e2[11], t2[12] = e2[12], t2[13] = e2[13], t2[14] = e2[14], t2[15] = e2[15]), t2[0] = s2 * i2 + u2 * n2, t2[1] = o2 * i2 + c2 * n2, t2[2] = a2 * i2 + h3 * n2, t2[3] = l2 * i2 + p3 * n2, t2[4] = u2 * i2 - s2 * n2, t2[5] = c2 * i2 - o2 * n2, t2[6] = h3 * i2 - a2 * n2, t2[7] = p3 * i2 - l2 * n2, t2;
          }
          function y(t2, e2) {
            return t2[0] = e2[0], t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = e2[1], t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = e2[2], t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
          }
          function g(t2, r2, n2) {
            var i2, s2, o2, a2 = n2[0], l2 = n2[1], u2 = n2[2], c2 = Math.hypot(a2, l2, u2);
            return c2 < e ? null : (a2 *= c2 = 1 / c2, l2 *= c2, u2 *= c2, i2 = Math.sin(r2), s2 = Math.cos(r2), t2[0] = a2 * a2 * (o2 = 1 - s2) + s2, t2[1] = l2 * a2 * o2 + u2 * i2, t2[2] = u2 * a2 * o2 - l2 * i2, t2[3] = 0, t2[4] = a2 * l2 * o2 - u2 * i2, t2[5] = l2 * l2 * o2 + s2, t2[6] = u2 * l2 * o2 + a2 * i2, t2[7] = 0, t2[8] = a2 * u2 * o2 + l2 * i2, t2[9] = l2 * u2 * o2 - a2 * i2, t2[10] = u2 * u2 * o2 + s2, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2);
          }
          function x(t2, e2) {
            var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], o2 = r2 + r2, a2 = n2 + n2, l2 = i2 + i2, u2 = r2 * o2, c2 = n2 * o2, h3 = n2 * a2, p3 = i2 * o2, f2 = i2 * a2, d2 = i2 * l2, m2 = s2 * o2, y2 = s2 * a2, g2 = s2 * l2;
            return t2[0] = 1 - h3 - d2, t2[1] = c2 + g2, t2[2] = p3 - y2, t2[3] = 0, t2[4] = c2 - g2, t2[5] = 1 - u2 - d2, t2[6] = f2 + m2, t2[7] = 0, t2[8] = p3 + y2, t2[9] = f2 - m2, t2[10] = 1 - u2 - h3, t2[11] = 0, t2[12] = 0, t2[13] = 0, t2[14] = 0, t2[15] = 1, t2;
          }
          Math.hypot || (Math.hypot = function() {
            for (var t2 = 0, e2 = arguments.length; e2--; ) t2 += arguments[e2] * arguments[e2];
            return Math.sqrt(t2);
          });
          var v = c;
          function b() {
            var t2 = new r(3);
            return r != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0), t2;
          }
          function w(t2) {
            var e2 = new r(3);
            return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2;
          }
          function _(t2) {
            return Math.hypot(t2[0], t2[1], t2[2]);
          }
          function A(t2, e2, n2) {
            var i2 = new r(3);
            return i2[0] = t2, i2[1] = e2, i2[2] = n2, i2;
          }
          function M(t2, e2, r2) {
            return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2[2] = e2[2] + r2[2], t2;
          }
          function I(t2, e2, r2) {
            return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2[2] = e2[2] - r2[2], t2;
          }
          function S(t2, e2, r2) {
            return t2[0] = e2[0] * r2[0], t2[1] = e2[1] * r2[1], t2[2] = e2[2] * r2[2], t2;
          }
          function z(t2, e2, r2) {
            return t2[0] = Math.min(e2[0], r2[0]), t2[1] = Math.min(e2[1], r2[1]), t2[2] = Math.min(e2[2], r2[2]), t2;
          }
          function k(t2, e2, r2) {
            return t2[0] = Math.max(e2[0], r2[0]), t2[1] = Math.max(e2[1], r2[1]), t2[2] = Math.max(e2[2], r2[2]), t2;
          }
          function P(t2, e2, r2) {
            return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2;
          }
          function E(t2, e2, r2, n2) {
            return t2[0] = e2[0] + r2[0] * n2, t2[1] = e2[1] + r2[1] * n2, t2[2] = e2[2] + r2[2] * n2, t2;
          }
          function T(t2, e2) {
            var r2 = e2[0] - t2[0], n2 = e2[1] - t2[1], i2 = e2[2] - t2[2];
            return r2 * r2 + n2 * n2 + i2 * i2;
          }
          function B(t2) {
            var e2 = t2[0], r2 = t2[1], n2 = t2[2];
            return e2 * e2 + r2 * r2 + n2 * n2;
          }
          function V(t2, e2) {
            return t2[0] = -e2[0], t2[1] = -e2[1], t2[2] = -e2[2], t2;
          }
          function C(t2, e2) {
            var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = r2 * r2 + n2 * n2 + i2 * i2;
            return s2 > 0 && (s2 = 1 / Math.sqrt(s2)), t2[0] = e2[0] * s2, t2[1] = e2[1] * s2, t2[2] = e2[2] * s2, t2;
          }
          function F(t2, e2) {
            return t2[0] * e2[0] + t2[1] * e2[1] + t2[2] * e2[2];
          }
          function D(t2, e2, r2) {
            var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = r2[0], a2 = r2[1], l2 = r2[2];
            return t2[0] = i2 * l2 - s2 * a2, t2[1] = s2 * o2 - n2 * l2, t2[2] = n2 * a2 - i2 * o2, t2;
          }
          function L(t2, e2, r2, n2) {
            var i2 = e2[0], s2 = e2[1], o2 = e2[2];
            return t2[0] = i2 + n2 * (r2[0] - i2), t2[1] = s2 + n2 * (r2[1] - s2), t2[2] = o2 + n2 * (r2[2] - o2), t2;
          }
          function R(t2, e2, r2) {
            var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = r2[3] * n2 + r2[7] * i2 + r2[11] * s2 + r2[15];
            return t2[0] = (r2[0] * n2 + r2[4] * i2 + r2[8] * s2 + r2[12]) / (o2 = o2 || 1), t2[1] = (r2[1] * n2 + r2[5] * i2 + r2[9] * s2 + r2[13]) / o2, t2[2] = (r2[2] * n2 + r2[6] * i2 + r2[10] * s2 + r2[14]) / o2, t2;
          }
          function O(t2, e2, r2) {
            var n2 = e2[0], i2 = e2[1], s2 = e2[2];
            return t2[0] = n2 * r2[0] + i2 * r2[3] + s2 * r2[6], t2[1] = n2 * r2[1] + i2 * r2[4] + s2 * r2[7], t2[2] = n2 * r2[2] + i2 * r2[5] + s2 * r2[8], t2;
          }
          function U(t2, e2, r2) {
            var n2 = r2[0], i2 = r2[1], s2 = r2[2], o2 = e2[0], a2 = e2[1], l2 = e2[2], u2 = i2 * l2 - s2 * a2, c2 = s2 * o2 - n2 * l2, h3 = n2 * a2 - i2 * o2, p3 = i2 * h3 - s2 * c2, f2 = s2 * u2 - n2 * h3, d2 = n2 * c2 - i2 * u2, m2 = 2 * r2[3];
            return c2 *= m2, h3 *= m2, f2 *= 2, d2 *= 2, t2[0] = o2 + (u2 *= m2) + (p3 *= 2), t2[1] = a2 + c2 + f2, t2[2] = l2 + h3 + d2, t2;
          }
          function N(t2, e2) {
            return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2];
          }
          var j = I, $ = S, G = _;
          function q() {
            var t2 = new r(4);
            return r != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 0), t2;
          }
          function H(t2, e2, r2) {
            return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2[2] = e2[2] * r2, t2[3] = e2[3] * r2, t2;
          }
          function X(t2, e2) {
            var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], o2 = r2 * r2 + n2 * n2 + i2 * i2 + s2 * s2;
            return o2 > 0 && (o2 = 1 / Math.sqrt(o2)), t2[0] = r2 * o2, t2[1] = n2 * o2, t2[2] = i2 * o2, t2[3] = s2 * o2, t2;
          }
          function Z(t2, e2, r2) {
            var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = e2[3];
            return t2[0] = r2[0] * n2 + r2[4] * i2 + r2[8] * s2 + r2[12] * o2, t2[1] = r2[1] * n2 + r2[5] * i2 + r2[9] * s2 + r2[13] * o2, t2[2] = r2[2] * n2 + r2[6] * i2 + r2[10] * s2 + r2[14] * o2, t2[3] = r2[3] * n2 + r2[7] * i2 + r2[11] * s2 + r2[15] * o2, t2;
          }
          function W() {
            var t2 = new r(4);
            return r != Float32Array && (t2[0] = 0, t2[1] = 0, t2[2] = 0), t2[3] = 1, t2;
          }
          function Y(t2) {
            return t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2;
          }
          function K(t2, e2, r2) {
            r2 *= 0.5;
            var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = e2[3], a2 = Math.sin(r2), l2 = Math.cos(r2);
            return t2[0] = n2 * l2 + o2 * a2, t2[1] = i2 * l2 + s2 * a2, t2[2] = s2 * l2 - i2 * a2, t2[3] = o2 * l2 - n2 * a2, t2;
          }
          function J(t2, e2, r2) {
            r2 *= 0.5;
            var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = e2[3], a2 = Math.sin(r2), l2 = Math.cos(r2);
            return t2[0] = n2 * l2 - s2 * a2, t2[1] = i2 * l2 + o2 * a2, t2[2] = s2 * l2 + n2 * a2, t2[3] = o2 * l2 - i2 * a2, t2;
          }
          b(), q();
          var Q, tt2, et, rt, nt, it = X, st = (Q = b(), tt2 = A(1, 0, 0), et = A(0, 1, 0), function(t2, e2, r2) {
            var n2 = F(e2, r2);
            return n2 < -0.999999 ? (D(Q, tt2, e2), G(Q) < 1e-6 && D(Q, et, e2), C(Q, Q), function(t3, e3, r3) {
              r3 *= 0.5;
              var n3 = Math.sin(r3);
              t3[0] = n3 * e3[0], t3[1] = n3 * e3[1], t3[2] = n3 * e3[2], t3[3] = Math.cos(r3);
            }(t2, Q, Math.PI), t2) : n2 > 0.999999 ? (t2[0] = 0, t2[1] = 0, t2[2] = 0, t2[3] = 1, t2) : (D(Q, e2, r2), t2[0] = Q[0], t2[1] = Q[1], t2[2] = Q[2], t2[3] = 1 + n2, it(t2, t2));
          });
          function ot() {
            var t2 = new r(2);
            return r != Float32Array && (t2[0] = 0, t2[1] = 0), t2;
          }
          function at(t2, e2) {
            var n2 = new r(2);
            return n2[0] = t2, n2[1] = e2, n2;
          }
          function lt(t2, e2, r2) {
            return t2[0] = e2[0] + r2[0], t2[1] = e2[1] + r2[1], t2;
          }
          function ut(t2, e2, r2) {
            return t2[0] = e2[0] - r2[0], t2[1] = e2[1] - r2[1], t2;
          }
          function ct(t2, e2, r2) {
            return t2[0] = e2[0] * r2, t2[1] = e2[1] * r2, t2;
          }
          function ht(t2) {
            return Math.hypot(t2[0], t2[1]);
          }
          function pt(t2, e2) {
            var r2 = e2[0], n2 = e2[1], i2 = r2 * r2 + n2 * n2;
            return i2 > 0 && (i2 = 1 / Math.sqrt(i2)), t2[0] = e2[0] * i2, t2[1] = e2[1] * i2, t2;
          }
          function ft(t2, e2) {
            return t2[0] * e2[0] + t2[1] * e2[1];
          }
          function dt(t2) {
            return t2 && t2.__esModule && Object.prototype.hasOwnProperty.call(t2, "default") ? t2.default : t2;
          }
          W(), W(), i(), ot();
          var mt, yt, gt = function() {
            if (nt) return rt;
            function t2(t3, e2, r2, n2) {
              this.cx = 3 * t3, this.bx = 3 * (r2 - t3) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e2, this.by = 3 * (n2 - e2) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t3, this.p1y = e2, this.p2x = r2, this.p2y = n2;
            }
            return nt = 1, rt = t2, t2.prototype = { sampleCurveX: function(t3) {
              return ((this.ax * t3 + this.bx) * t3 + this.cx) * t3;
            }, sampleCurveY: function(t3) {
              return ((this.ay * t3 + this.by) * t3 + this.cy) * t3;
            }, sampleCurveDerivativeX: function(t3) {
              return (3 * this.ax * t3 + 2 * this.bx) * t3 + this.cx;
            }, solveCurveX: function(t3, e2) {
              if (void 0 === e2 && (e2 = 1e-6), t3 < 0) return 0;
              if (t3 > 1) return 1;
              for (var r2 = t3, n2 = 0; n2 < 8; n2++) {
                var i2 = this.sampleCurveX(r2) - t3;
                if (Math.abs(i2) < e2) return r2;
                var s2 = this.sampleCurveDerivativeX(r2);
                if (Math.abs(s2) < 1e-6) break;
                r2 -= i2 / s2;
              }
              var o2 = 0, a2 = 1;
              for (r2 = t3, n2 = 0; n2 < 20 && (i2 = this.sampleCurveX(r2), !(Math.abs(i2 - t3) < e2)); n2++) t3 > i2 ? o2 = r2 : a2 = r2, r2 = 0.5 * (a2 - o2) + o2;
              return r2;
            }, solve: function(t3, e2) {
              return this.sampleCurveY(this.solveCurveX(t3, e2));
            } }, rt;
          }(), xt = dt(gt);
          function vt() {
            if (yt) return mt;
            function t2(t3, e2) {
              this.x = t3, this.y = e2;
            }
            return yt = 1, mt = t2, t2.prototype = { clone: function() {
              return new t2(this.x, this.y);
            }, add: function(t3) {
              return this.clone()._add(t3);
            }, sub: function(t3) {
              return this.clone()._sub(t3);
            }, multByPoint: function(t3) {
              return this.clone()._multByPoint(t3);
            }, divByPoint: function(t3) {
              return this.clone()._divByPoint(t3);
            }, mult: function(t3) {
              return this.clone()._mult(t3);
            }, div: function(t3) {
              return this.clone()._div(t3);
            }, rotate: function(t3) {
              return this.clone()._rotate(t3);
            }, rotateAround: function(t3, e2) {
              return this.clone()._rotateAround(t3, e2);
            }, matMult: function(t3) {
              return this.clone()._matMult(t3);
            }, unit: function() {
              return this.clone()._unit();
            }, perp: function() {
              return this.clone()._perp();
            }, round: function() {
              return this.clone()._round();
            }, mag: function() {
              return Math.sqrt(this.x * this.x + this.y * this.y);
            }, equals: function(t3) {
              return this.x === t3.x && this.y === t3.y;
            }, dist: function(t3) {
              return Math.sqrt(this.distSqr(t3));
            }, distSqr: function(t3) {
              var e2 = t3.x - this.x, r2 = t3.y - this.y;
              return e2 * e2 + r2 * r2;
            }, angle: function() {
              return Math.atan2(this.y, this.x);
            }, angleTo: function(t3) {
              return Math.atan2(this.y - t3.y, this.x - t3.x);
            }, angleWith: function(t3) {
              return this.angleWithSep(t3.x, t3.y);
            }, angleWithSep: function(t3, e2) {
              return Math.atan2(this.x * e2 - this.y * t3, this.x * t3 + this.y * e2);
            }, _matMult: function(t3) {
              var e2 = t3[2] * this.x + t3[3] * this.y;
              return this.x = t3[0] * this.x + t3[1] * this.y, this.y = e2, this;
            }, _add: function(t3) {
              return this.x += t3.x, this.y += t3.y, this;
            }, _sub: function(t3) {
              return this.x -= t3.x, this.y -= t3.y, this;
            }, _mult: function(t3) {
              return this.x *= t3, this.y *= t3, this;
            }, _div: function(t3) {
              return this.x /= t3, this.y /= t3, this;
            }, _multByPoint: function(t3) {
              return this.x *= t3.x, this.y *= t3.y, this;
            }, _divByPoint: function(t3) {
              return this.x /= t3.x, this.y /= t3.y, this;
            }, _unit: function() {
              return this._div(this.mag()), this;
            }, _perp: function() {
              var t3 = this.y;
              return this.y = this.x, this.x = -t3, this;
            }, _rotate: function(t3) {
              var e2 = Math.cos(t3), r2 = Math.sin(t3), n2 = r2 * this.x + e2 * this.y;
              return this.x = e2 * this.x - r2 * this.y, this.y = n2, this;
            }, _rotateAround: function(t3, e2) {
              var r2 = Math.cos(t3), n2 = Math.sin(t3), i2 = e2.y + n2 * (this.x - e2.x) + r2 * (this.y - e2.y);
              return this.x = e2.x + r2 * (this.x - e2.x) - n2 * (this.y - e2.y), this.y = i2, this;
            }, _round: function() {
              return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            } }, t2.convert = function(e2) {
              return e2 instanceof t2 ? e2 : Array.isArray(e2) ? new t2(e2[0], e2[1]) : e2;
            }, mt;
          }
          var bt = dt(vt());
          function wt(t2, e2) {
            if (Array.isArray(t2)) {
              if (!Array.isArray(e2) || t2.length !== e2.length) return false;
              for (let r2 = 0; r2 < t2.length; r2++) if (!wt(t2[r2], e2[r2])) return false;
              return true;
            }
            if ("object" == typeof t2 && null !== t2 && null !== e2) {
              if ("object" != typeof e2) return false;
              if (Object.keys(t2).length !== Object.keys(e2).length) return false;
              for (const r2 in t2) if (!wt(t2[r2], e2[r2])) return false;
              return true;
            }
            return t2 === e2;
          }
          const _t = Math.PI / 180, At = 180 / Math.PI;
          function Mt(t2) {
            return t2 * _t;
          }
          function It(t2) {
            return t2 * At;
          }
          const St = [[0, 0], [1, 0], [1, 1], [0, 1]];
          function zt(t2) {
            if (t2 <= 0) return 0;
            if (t2 >= 1) return 1;
            const e2 = t2 * t2, r2 = e2 * t2;
            return 4 * (t2 < 0.5 ? r2 : 3 * (t2 - e2) + r2 - 0.75);
          }
          function kt(t2, e2, r2, n2) {
            const i2 = new xt(t2, e2, r2, n2);
            return function(t3) {
              return i2.solve(t3);
            };
          }
          const Pt = kt(0.25, 0.1, 0.25, 1);
          function Et(t2, e2, r2) {
            return Math.min(r2, Math.max(e2, t2));
          }
          function Tt(t2, e2, r2) {
            return (r2 = Et((r2 - t2) / (e2 - t2), 0, 1)) * r2 * (3 - 2 * r2);
          }
          function Bt(t2, e2, r2) {
            const n2 = r2 - e2, i2 = ((t2 - e2) % n2 + n2) % n2 + e2;
            return i2 === e2 ? r2 : i2;
          }
          function Vt(t2, e2, r2) {
            if (!t2.length) return r2(null, []);
            let n2 = t2.length;
            const i2 = new Array(t2.length);
            let s2 = null;
            t2.forEach((t3, o2) => {
              e2(t3, (t4, e3) => {
                t4 && (s2 = t4), i2[o2] = e3, 0 == --n2 && r2(s2, i2);
              });
            });
          }
          function Ct(t2, ...e2) {
            for (const r2 of e2) for (const e3 in r2) t2[e3] = r2[e3];
            return t2;
          }
          let Ft = 1;
          function Dt() {
            return Ft++;
          }
          function Lt(t2) {
            return t2 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t2) / Math.LN2));
          }
          function Rt(t2, e2) {
            t2.forEach((t3) => {
              e2[t3] && (e2[t3] = e2[t3].bind(e2));
            });
          }
          function Ot(t2, e2, r2) {
            const n2 = {};
            for (const r3 in t2) n2[r3] = e2.call(this, t2[r3], r3, t2);
            return n2;
          }
          function Ut(t2, e2, r2) {
            const n2 = {};
            for (const r3 in t2) e2.call(this, t2[r3], r3, t2) && (n2[r3] = t2[r3]);
            return n2;
          }
          function Nt(t2) {
            return Array.isArray(t2) ? t2.map(Nt) : "object" == typeof t2 && t2 ? Ot(t2, Nt) : t2;
          }
          function jt(t2, e2) {
            for (let r2 = 0; r2 < t2.length; r2++) if (e2.indexOf(t2[r2]) >= 0) return true;
            return false;
          }
          const $t = {};
          function Gt(t2) {
            $t[t2] || ("undefined" != typeof console && console.warn(t2), $t[t2] = true);
          }
          function qt(t2, e2, r2) {
            return (r2.y - t2.y) * (e2.x - t2.x) > (e2.y - t2.y) * (r2.x - t2.x);
          }
          function Ht(t2) {
            let e2 = 0;
            for (let r2, n2, i2 = 0, s2 = t2.length, o2 = s2 - 1; i2 < s2; o2 = i2++) r2 = t2[i2], n2 = t2[o2], e2 += (n2.x - r2.x) * (r2.y + n2.y);
            return e2;
          }
          function Xt([t2, e2, r2]) {
            const n2 = Mt(e2 + 90), i2 = Mt(r2);
            return { x: t2 * Math.cos(n2) * Math.sin(i2), y: t2 * Math.sin(n2) * Math.sin(i2), z: t2 * Math.cos(i2), azimuthal: e2, polar: r2 };
          }
          function Zt(t2) {
            return ("undefined" != typeof self || void 0 !== t2) && "undefined" != typeof WorkerGlobalScope && (void 0 !== t2 ? t2 : self) instanceof WorkerGlobalScope;
          }
          function Wt(t2) {
            const e2 = {};
            if (t2.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (t3, r2, n2, i2) => {
              const s2 = n2 || i2;
              return e2[r2] = !s2 || s2.toLowerCase(), "";
            }), e2["max-age"]) {
              const t3 = parseInt(e2["max-age"], 10);
              isNaN(t3) ? delete e2["max-age"] : e2["max-age"] = t3;
            }
            return e2;
          }
          let Yt = null;
          function Kt(t2, e2) {
            return [t2[4 * e2], t2[4 * e2 + 1], t2[4 * e2 + 2], t2[4 * e2 + 3]];
          }
          function Jt(t2, e2, r2, n2) {
            for (; e2 < r2; ) {
              const i2 = e2 + r2 >> 1;
              t2[i2] < n2 ? e2 = i2 + 1 : r2 = i2;
            }
            return e2;
          }
          function Qt(t2, e2, r2, n2) {
            for (; e2 < r2; ) {
              const i2 = e2 + r2 >> 1;
              t2[i2] <= n2 ? e2 = i2 + 1 : r2 = i2;
            }
            return e2;
          }
          function te(t2) {
            return t2 > 0 ? 1 / (1.001 - t2) : 1 + t2;
          }
          function ee(t2) {
            return t2 > 0 ? 1 - 1 / (1.001 - t2) : -t2;
          }
          function re(t2, e2, r2) {
            return (t2 - e2.min) * (r2.max - r2.min) / (e2.max - e2.min) + r2.min;
          }
          const ne = { API_URL: "https://api.mapbox.com", get API_URL_REGEX() {
            return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
          }, get API_TILEJSON_REGEX() {
            return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
          }, get API_SPRITE_REGEX() {
            return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
          }, get API_FONTS_REGEX() {
            return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
          }, get API_STYLE_REGEX() {
            return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
          }, get API_CDN_URL_REGEX() {
            return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
          }, get EVENTS_URL() {
            if (!ne.API_URL) return null;
            try {
              const t2 = new URL(ne.API_URL);
              return "api.mapbox.cn" === t2.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === t2.hostname ? "https://events.mapbox.com/events/v2" : null;
            } catch (t2) {
              return null;
            }
          }, SESSION_PATH: "/map-sessions/v1", FEEDBACK_URL: "https://apps.mapbox.com/feedback", TILE_URL_VERSION: "v4", RASTER_URL_PREFIX: "raster/v1", RASTERARRAYS_URL_PREFIX: "rasterarrays/v1", REQUIRE_ACCESS_TOKEN: true, ACCESS_TOKEN: null, DEFAULT_STYLE: "mapbox://styles/mapbox/standard", MAX_PARALLEL_IMAGE_REQUESTS: 16, DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm", MESHOPT_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_base_v0.20.wasm", MESHOPT_SIMD_URL: "https://api.mapbox.com/mapbox-gl-js/meshopt_simd_v0.20.wasm", BUILDING_GEN_URL: "https://api.mapbox.com/mapbox-gl-js/building-gen/building_gen_v0.3.0.wasm", GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf", TILES3D_URL_PREFIX: "3dtiles/v1" };
          function ie(t2) {
            return ne.API_URL_REGEX.test(t2);
          }
          function se(t2) {
            return ne.API_SPRITE_REGEX.test(t2);
          }
          let oe, ae, le, ue, ce, he;
          function pe() {
            return null == oe && (oe = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), oe;
          }
          const fe = { now: () => void 0 !== ue ? ue : performance.now(), setNow(t2) {
            ue = t2;
          }, restoreNow() {
            ue = void 0;
          }, frame(t2) {
            const e2 = requestAnimationFrame(t2);
            return { cancel: () => cancelAnimationFrame(e2) };
          }, getImageData(t2, e2 = 0) {
            const { width: r2, height: n2 } = t2;
            ce || (ce = document.createElement("canvas"));
            const i2 = ce.getContext("2d", { willReadFrequently: true });
            if (!i2) throw new Error("failed to create canvas 2d context");
            return (r2 > ce.width || n2 > ce.height) && (ce.width = r2, ce.height = n2), i2.clearRect(-e2, -e2, r2 + 2 * e2, n2 + 2 * e2), i2.drawImage(t2, 0, 0, r2, n2), i2.getImageData(-e2, -e2, r2 + 2 * e2, n2 + 2 * e2);
          }, resolveURL: (t2) => (ae || (ae = document.createElement("a")), ae.href = t2, ae.href), get devicePixelRatio() {
            return window.devicePixelRatio;
          }, get prefersReducedMotion() {
            return !!window.matchMedia && (null == le && (le = window.matchMedia("(prefers-reduced-motion: reduce)")), le.matches);
          }, hasCanvasFingerprintNoise() {
            if (void 0 !== he) return he;
            if (!pe()) return he = false, false;
            const t2 = new OffscreenCanvas(85, 1), e2 = t2.getContext("2d", { willReadFrequently: true });
            let r2 = 0;
            for (let n3 = 0; n3 < t2.width; ++n3) e2.fillStyle = `rgba(${r2++},${r2++},${r2++}, 255)`, e2.fillRect(n3, 0, 1, 1);
            const n2 = e2.getImageData(0, 0, t2.width, t2.height);
            r2 = 0;
            for (let t3 = 0; t3 < n2.data.length; ++t3) if (t3 % 4 != 3 && r2++ !== n2.data[t3]) return he = true, true;
            return he = false, false;
          } };
          function de2(t2, e2) {
            const r2 = t2.indexOf("?");
            if (r2 < 0) return `${t2}?${new URLSearchParams(e2).toString()}`;
            const n2 = new URLSearchParams(t2.slice(r2));
            for (const t3 in e2) n2.set(t3, e2[t3]);
            return `${t2.slice(0, r2)}?${n2.toString()}`;
          }
          function me(t2, e2 = { persistentParams: [] }) {
            const r2 = t2.indexOf("?");
            if (r2 < 0) return t2;
            const n2 = new URLSearchParams(), i2 = new URLSearchParams(t2.slice(r2));
            for (const t3 of e2.persistentParams) {
              const e3 = i2.get(t3);
              e3 && n2.set(t3, e3);
            }
            const s2 = n2.toString();
            return `${t2.slice(0, r2)}${s2.length > 0 ? `?${s2}` : ""}`;
          }
          const ye = "mapbox-tiles";
          let ge = 500, xe = 50;
          const ve = ["language", "worldview", "jobid"];
          let be, we;
          function _e() {
            try {
              return caches;
            } catch (t2) {
            }
          }
          function Ae() {
            const t2 = _e();
            t2 && null == be && (be = t2.open(ye));
          }
          let Me = 1 / 0;
          const Ie = { supported: false, testSupport: function(t2) {
            !ke && ze && (Pe ? Te(t2) : Se = t2);
          } };
          let Se, ze, ke = false, Pe = false;
          const Ee = "undefined" != typeof self ? self : {};
          function Te(t2) {
            const e2 = t2.createTexture();
            t2.bindTexture(t2.TEXTURE_2D, e2);
            try {
              if (t2.texImage2D(t2.TEXTURE_2D, 0, t2.RGBA, t2.RGBA, t2.UNSIGNED_BYTE, ze), t2.isContextLost()) return;
              Ie.supported = true;
            } catch (t3) {
            }
            t2.deleteTexture(e2), ke = true;
          }
          Ee.document && (ze = Ee.document.createElement("img"), ze.onload = function() {
            Se && Te(Se), Se = null, Pe = true;
          }, ze.onerror = function() {
            ke = true, Se = null;
          }, ze.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
          const Be = { Unknown: "Unknown", Style: "Style", Source: "Source", Tile: "Tile", Glyphs: "Glyphs", SpriteImage: "SpriteImage", SpriteJSON: "SpriteJSON", Iconset: "Iconset", Image: "Image", Model: "Model" };
          "function" == typeof Object.freeze && Object.freeze(Be);
          class Ve extends Error {
            constructor(t2, e2, r2) {
              401 === e2 && ie(r2) && (t2 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(t2), this.status = e2, this.url = r2;
            }
            toString() {
              return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
          }
          const Ce = Zt() ? () => self.worker.referrer : () => ("blob:" === location.protocol ? parent : self).location.href;
          const Fe = function(t2, e2) {
            if (!(/^file:/.test(r2 = t2.url) || /^file:/.test(Ce()) && !/^\w+:/.test(r2))) {
              if (self.fetch && self.Request && self.AbortController && Request.prototype.hasOwnProperty("signal")) return function(t3, e3) {
                const r3 = new AbortController(), n2 = new Request(t3.url, { method: t3.method || "GET", body: t3.body, credentials: t3.credentials, headers: t3.headers, referrer: Ce(), referrerPolicy: t3.referrerPolicy, signal: r3.signal });
                let i2 = false, s2 = false;
                const o2 = (a2 = n2.url).indexOf("sku=") > 0 && ie(a2);
                var a2;
                "json" === t3.type && n2.headers.set("Accept", "application/json");
                const l2 = (r4, i3, a3) => {
                  if (s2) return;
                  if (r4 && "SecurityError" !== r4.message && Gt(r4.toString()), i3 && a3) return u2(i3);
                  const l3 = Date.now();
                  fetch(n2).then((r5) => {
                    if (r5.ok) {
                      const t4 = o2 ? r5.clone() : null;
                      return u2(r5, t4, l3);
                    }
                    return e3(new Ve(r5.statusText, r5.status, t3.url));
                  }).catch((r5) => {
                    "AbortError" !== r5.name && e3(new Error(`${r5.message} ${t3.url}`));
                  });
                }, u2 = (r4, o3, a3) => {
                  ("arrayBuffer" === t3.type ? r4.arrayBuffer() : "json" === t3.type ? r4.json() : r4.text()).then((t4) => {
                    s2 || (o3 && a3 && function(t5, e4, r5) {
                      if (Ae(), null == be) return;
                      const n3 = Wt(e4.headers.get("Cache-Control") || "");
                      if (n3["no-store"]) return;
                      const i3 = { status: e4.status, statusText: e4.statusText, headers: new Headers() };
                      e4.headers.forEach((t6, e5) => i3.headers.set(e5, t6)), n3["max-age"] && i3.headers.set("Expires", new Date(r5 + 1e3 * n3["max-age"]).toUTCString());
                      const s3 = i3.headers.get("Expires");
                      if (!s3) return;
                      if (new Date(s3).getTime() - r5 < 42e4) return;
                      let o4 = me(t5.url, { persistentParams: ve });
                      if (206 === e4.status) {
                        const e5 = t5.headers.get("Range");
                        if (!e5) return;
                        i3.status = 200, o4 = de2(o4, { range: e5 });
                      }
                      !function(t6, e5) {
                        if (void 0 === we) try {
                          new Response(new ReadableStream()), we = true;
                        } catch (t7) {
                          we = false;
                        }
                        we ? e5(t6.body) : t6.blob().then(e5).catch((t7) => Gt(t7.message));
                      }(e4, (t6) => {
                        const r6 = new Response(200 !== (n4 = e4.status) && 404 !== n4 && [101, 103, 204, 205, 304].includes(n4) ? null : t6, i3);
                        var n4;
                        Ae(), null != be && be.then((t7) => t7.put(o4, r6)).catch((t7) => Gt(t7.message));
                      });
                    }(n2, o3, a3), i2 = true, e3(null, t4, r4.headers.get("Cache-Control"), r4.headers.get("Expires")));
                  }).catch((t4) => {
                    s2 || e3(new Error(t4.message));
                  });
                };
                return o2 ? function(t4, e4) {
                  if (Ae(), null == be) return e4(null);
                  be.then((r4) => {
                    let n3 = me(t4.url, { persistentParams: ve });
                    const i3 = t4.headers.get("Range");
                    i3 && (n3 = de2(n3, { range: i3 })), r4.match(n3).then((t5) => {
                      const i4 = function(t6) {
                        if (!t6) return false;
                        const e5 = new Date(t6.headers.get("Expires") || 0), r5 = Wt(t6.headers.get("Cache-Control") || "");
                        return Number(e5) > Date.now() && !r5["no-cache"];
                      }(t5);
                      r4.delete(n3).catch(e4), i4 && r4.put(n3, t5.clone()).catch(e4), e4(null, t5, i4);
                    }).catch(e4);
                  }).catch(e4);
                }(n2, l2) : l2(null, null), { cancel: () => {
                  s2 = true, i2 || r3.abort();
                } };
              }(t2, e2);
              if (Zt(self) && self.worker.actor) return self.worker.actor.send("getResource", t2, e2, void 0, true);
            }
            var r2;
            return function(t3, e3) {
              const r3 = new XMLHttpRequest();
              r3.open(t3.method || "GET", t3.url, true), "arrayBuffer" === t3.type && (r3.responseType = "arraybuffer");
              for (const e4 in t3.headers) r3.setRequestHeader(e4, t3.headers[e4]);
              return "json" === t3.type && (r3.responseType = "text", r3.setRequestHeader("Accept", "application/json")), r3.withCredentials = "include" === t3.credentials, r3.onerror = () => {
                e3(new Error(r3.statusText));
              }, r3.onload = () => {
                if ((r3.status >= 200 && r3.status < 300 || 0 === r3.status) && null !== r3.response) {
                  let n2 = r3.response;
                  if ("json" === t3.type) try {
                    n2 = JSON.parse(r3.response);
                  } catch (t4) {
                    return e3(t4);
                  }
                  e3(null, n2, r3.getResponseHeader("Cache-Control"), r3.getResponseHeader("Expires"));
                } else e3(new Ve(r3.statusText, r3.status, t3.url));
              }, r3.send(t3.body), { cancel: () => r3.abort() };
            }(t2, e2);
          }, De = function(t2, e2) {
            return Fe(Ct(t2, { type: "arrayBuffer" }), e2);
          };
          function Le(t2) {
            const e2 = document.createElement("a");
            return e2.href = t2, e2.protocol === location.protocol && e2.host === location.host;
          }
          const Re = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
          let Oe, Ue;
          Oe = [], Ue = 0;
          const Ne = function(t2, e2) {
            if (Ie.supported && (t2.headers || (t2.headers = {}), t2.headers.accept = "image/webp,*/*"), Ue >= ne.MAX_PARALLEL_IMAGE_REQUESTS) {
              const r3 = { requestParameters: t2, callback: e2, cancelled: false, cancel() {
                this.cancelled = true;
              } };
              return Oe.push(r3), r3;
            }
            Ue++;
            let r2 = false;
            const n2 = () => {
              if (!r2) for (r2 = true, Ue--; Oe.length && Ue < ne.MAX_PARALLEL_IMAGE_REQUESTS; ) {
                const t3 = Oe.shift(), { requestParameters: e3, callback: r3, cancelled: n3 } = t3;
                n3 || (t3.cancel = Ne(e3, r3).cancel);
              }
            }, i2 = De(t2, (t3, r3, i3, s2) => {
              n2(), t3 ? e2(t3) : r3 && (self.createImageBitmap ? function(t4, e3) {
                const r4 = new Blob([new Uint8Array(t4)], { type: "image/png" });
                createImageBitmap(r4).then((t5) => {
                  e3(null, t5);
                }).catch((t5) => {
                  e3(new Error(`Could not load image because of ${t5.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                });
              }(r3, (t4, r4) => e2(t4, r4, i3, s2)) : function(t4, e3) {
                const r4 = new Image();
                r4.onload = () => {
                  e3(null, r4), URL.revokeObjectURL(r4.src), r4.onload = null, requestAnimationFrame(() => {
                    r4.src = Re;
                  });
                }, r4.onerror = () => e3(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                const n3 = new Blob([new Uint8Array(t4)], { type: "image/png" });
                r4.src = t4.byteLength ? URL.createObjectURL(n3) : Re;
              }(r3, (t4, r4) => e2(t4, r4, i3, s2)));
            });
            return { cancel: () => {
              i2.cancel(), n2();
            } };
          };
          var je, $e, Ge, qe = { exports: {} }, He = { exports: {} }, Xe = { exports: {} }, Ze = function() {
            if (Ge) return qe.exports;
            Ge = 1;
            var t2 = (je || (je = 1, He.exports = function(t3, e3) {
              var r2, n2, i2, s2, o2, a2, l2, u2;
              for (n2 = t3.length - (r2 = 3 & t3.length), i2 = e3, o2 = 3432918353, a2 = 461845907, u2 = 0; u2 < n2; ) l2 = 255 & t3.charCodeAt(u2) | (255 & t3.charCodeAt(++u2)) << 8 | (255 & t3.charCodeAt(++u2)) << 16 | (255 & t3.charCodeAt(++u2)) << 24, ++u2, i2 = 27492 + (65535 & (s2 = 5 * (65535 & (i2 = (i2 ^= l2 = (65535 & (l2 = (l2 = (65535 & l2) * o2 + (((l2 >>> 16) * o2 & 65535) << 16) & 4294967295) << 15 | l2 >>> 17)) * a2 + (((l2 >>> 16) * a2 & 65535) << 16) & 4294967295) << 13 | i2 >>> 19)) + ((5 * (i2 >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s2 >>> 16) & 65535) << 16);
              switch (l2 = 0, r2) {
                case 3:
                  l2 ^= (255 & t3.charCodeAt(u2 + 2)) << 16;
                case 2:
                  l2 ^= (255 & t3.charCodeAt(u2 + 1)) << 8;
                case 1:
                  i2 ^= l2 = (65535 & (l2 = (l2 = (65535 & (l2 ^= 255 & t3.charCodeAt(u2))) * o2 + (((l2 >>> 16) * o2 & 65535) << 16) & 4294967295) << 15 | l2 >>> 17)) * a2 + (((l2 >>> 16) * a2 & 65535) << 16) & 4294967295;
              }
              return i2 ^= t3.length, i2 = 2246822507 * (65535 & (i2 ^= i2 >>> 16)) + ((2246822507 * (i2 >>> 16) & 65535) << 16) & 4294967295, i2 = 3266489909 * (65535 & (i2 ^= i2 >>> 13)) + ((3266489909 * (i2 >>> 16) & 65535) << 16) & 4294967295, (i2 ^= i2 >>> 16) >>> 0;
            }), He.exports), e2 = ($e || ($e = 1, Xe.exports = function(t3, e3) {
              for (var r2, n2 = t3.length, i2 = e3 ^ n2, s2 = 0; n2 >= 4; ) r2 = 1540483477 * (65535 & (r2 = 255 & t3.charCodeAt(s2) | (255 & t3.charCodeAt(++s2)) << 8 | (255 & t3.charCodeAt(++s2)) << 16 | (255 & t3.charCodeAt(++s2)) << 24)) + ((1540483477 * (r2 >>> 16) & 65535) << 16), i2 = 1540483477 * (65535 & i2) + ((1540483477 * (i2 >>> 16) & 65535) << 16) ^ (r2 = 1540483477 * (65535 & (r2 ^= r2 >>> 24)) + ((1540483477 * (r2 >>> 16) & 65535) << 16)), n2 -= 4, ++s2;
              switch (n2) {
                case 3:
                  i2 ^= (255 & t3.charCodeAt(s2 + 2)) << 16;
                case 2:
                  i2 ^= (255 & t3.charCodeAt(s2 + 1)) << 8;
                case 1:
                  i2 = 1540483477 * (65535 & (i2 ^= 255 & t3.charCodeAt(s2))) + ((1540483477 * (i2 >>> 16) & 65535) << 16);
              }
              return i2 = 1540483477 * (65535 & (i2 ^= i2 >>> 13)) + ((1540483477 * (i2 >>> 16) & 65535) << 16), (i2 ^= i2 >>> 15) >>> 0;
            }), Xe.exports);
            return qe.exports = t2, qe.exports.murmur3 = t2, qe.exports.murmur2 = e2, qe.exports;
          }(), We = dt(Ze);
          class Ye {
            constructor(t2, ...e2) {
              Ct(this, e2[0] || {}), this.type = t2;
            }
          }
          class Ke extends Ye {
            constructor(t2, e2 = {}) {
              super("error", Ct({ error: t2 }, e2));
            }
          }
          function Je(t2, e2, r2) {
            r2[t2] && -1 !== r2[t2].indexOf(e2) || (r2[t2] = r2[t2] || [], r2[t2].push(e2));
          }
          function Qe(t2, e2, r2) {
            if (r2 && r2[t2]) {
              const n2 = r2[t2].indexOf(e2);
              -1 !== n2 && r2[t2].splice(n2, 1);
            }
          }
          class tr {
            on(t2, e2) {
              return this._listeners = this._listeners || {}, Je(t2, e2, this._listeners), this;
            }
            off(t2, e2) {
              return Qe(t2, e2, this._listeners), Qe(t2, e2, this._oneTimeListeners), this;
            }
            once(t2, e2) {
              return e2 ? (this._oneTimeListeners = this._oneTimeListeners || {}, Je(t2, e2, this._oneTimeListeners), this) : new Promise((e3) => {
                this.once(t2, e3);
              });
            }
            fire(t2, e2) {
              const r2 = "string" == typeof t2 ? new Ye(t2, e2) : t2, n2 = r2.type;
              if (this.listens(n2)) {
                r2.target = this;
                const t3 = this._listeners && this._listeners[n2] ? this._listeners[n2].slice() : [];
                for (const e4 of t3) e4.call(this, r2);
                const e3 = this._oneTimeListeners && this._oneTimeListeners[n2] ? this._oneTimeListeners[n2].slice() : [];
                for (const t4 of e3) Qe(n2, t4, this._oneTimeListeners), t4.call(this, r2);
                const i2 = this._eventedParent;
                i2 && (Ct(r2, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i2.fire(r2));
              } else r2 instanceof Ke && console.error(r2.error);
              return this;
            }
            listens(t2) {
              return !!(this._listeners && this._listeners[t2] && this._listeners[t2].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t2] && this._oneTimeListeners[t2].length > 0 || this._eventedParent && this._eventedParent.listens(t2));
            }
            setEventedParent(t2, e2) {
              return this._eventedParent = t2, this._eventedParentData = e2, this;
            }
          }
          class er {
            constructor(t2) {
              "string" == typeof t2 ? this.name = t2 : (this.name = t2.name, this.iconsetId = t2.iconsetId);
            }
            static from(t2) {
              return new er(t2);
            }
            static toString(t2) {
              return t2.iconsetId ? `${t2.name}${t2.iconsetId}` : t2.name;
            }
            static parse(t2) {
              const [e2, r2] = t2.split("");
              return new er({ name: e2, iconsetId: r2 });
            }
            static isEqual(t2, e2) {
              return t2.name === e2.name && t2.iconsetId === e2.iconsetId;
            }
            toString() {
              return er.toString(this);
            }
            serialize() {
              return { name: this.name, iconsetId: this.iconsetId };
            }
          }
          var rr, nr = {}, ir = function() {
            if (rr) return nr;
            rr = 1;
            var t2 = { transparent: [0, 0, 0, 0], aliceblue: [240, 248, 255, 1], antiquewhite: [250, 235, 215, 1], aqua: [0, 255, 255, 1], aquamarine: [127, 255, 212, 1], azure: [240, 255, 255, 1], beige: [245, 245, 220, 1], bisque: [255, 228, 196, 1], black: [0, 0, 0, 1], blanchedalmond: [255, 235, 205, 1], blue: [0, 0, 255, 1], blueviolet: [138, 43, 226, 1], brown: [165, 42, 42, 1], burlywood: [222, 184, 135, 1], cadetblue: [95, 158, 160, 1], chartreuse: [127, 255, 0, 1], chocolate: [210, 105, 30, 1], coral: [255, 127, 80, 1], cornflowerblue: [100, 149, 237, 1], cornsilk: [255, 248, 220, 1], crimson: [220, 20, 60, 1], cyan: [0, 255, 255, 1], darkblue: [0, 0, 139, 1], darkcyan: [0, 139, 139, 1], darkgoldenrod: [184, 134, 11, 1], darkgray: [169, 169, 169, 1], darkgreen: [0, 100, 0, 1], darkgrey: [169, 169, 169, 1], darkkhaki: [189, 183, 107, 1], darkmagenta: [139, 0, 139, 1], darkolivegreen: [85, 107, 47, 1], darkorange: [255, 140, 0, 1], darkorchid: [153, 50, 204, 1], darkred: [139, 0, 0, 1], darksalmon: [233, 150, 122, 1], darkseagreen: [143, 188, 143, 1], darkslateblue: [72, 61, 139, 1], darkslategray: [47, 79, 79, 1], darkslategrey: [47, 79, 79, 1], darkturquoise: [0, 206, 209, 1], darkviolet: [148, 0, 211, 1], deeppink: [255, 20, 147, 1], deepskyblue: [0, 191, 255, 1], dimgray: [105, 105, 105, 1], dimgrey: [105, 105, 105, 1], dodgerblue: [30, 144, 255, 1], firebrick: [178, 34, 34, 1], floralwhite: [255, 250, 240, 1], forestgreen: [34, 139, 34, 1], fuchsia: [255, 0, 255, 1], gainsboro: [220, 220, 220, 1], ghostwhite: [248, 248, 255, 1], gold: [255, 215, 0, 1], goldenrod: [218, 165, 32, 1], gray: [128, 128, 128, 1], green: [0, 128, 0, 1], greenyellow: [173, 255, 47, 1], grey: [128, 128, 128, 1], honeydew: [240, 255, 240, 1], hotpink: [255, 105, 180, 1], indianred: [205, 92, 92, 1], indigo: [75, 0, 130, 1], ivory: [255, 255, 240, 1], khaki: [240, 230, 140, 1], lavender: [230, 230, 250, 1], lavenderblush: [255, 240, 245, 1], lawngreen: [124, 252, 0, 1], lemonchiffon: [255, 250, 205, 1], lightblue: [173, 216, 230, 1], lightcoral: [240, 128, 128, 1], lightcyan: [224, 255, 255, 1], lightgoldenrodyellow: [250, 250, 210, 1], lightgray: [211, 211, 211, 1], lightgreen: [144, 238, 144, 1], lightgrey: [211, 211, 211, 1], lightpink: [255, 182, 193, 1], lightsalmon: [255, 160, 122, 1], lightseagreen: [32, 178, 170, 1], lightskyblue: [135, 206, 250, 1], lightslategray: [119, 136, 153, 1], lightslategrey: [119, 136, 153, 1], lightsteelblue: [176, 196, 222, 1], lightyellow: [255, 255, 224, 1], lime: [0, 255, 0, 1], limegreen: [50, 205, 50, 1], linen: [250, 240, 230, 1], magenta: [255, 0, 255, 1], maroon: [128, 0, 0, 1], mediumaquamarine: [102, 205, 170, 1], mediumblue: [0, 0, 205, 1], mediumorchid: [186, 85, 211, 1], mediumpurple: [147, 112, 219, 1], mediumseagreen: [60, 179, 113, 1], mediumslateblue: [123, 104, 238, 1], mediumspringgreen: [0, 250, 154, 1], mediumturquoise: [72, 209, 204, 1], mediumvioletred: [199, 21, 133, 1], midnightblue: [25, 25, 112, 1], mintcream: [245, 255, 250, 1], mistyrose: [255, 228, 225, 1], moccasin: [255, 228, 181, 1], navajowhite: [255, 222, 173, 1], navy: [0, 0, 128, 1], oldlace: [253, 245, 230, 1], olive: [128, 128, 0, 1], olivedrab: [107, 142, 35, 1], orange: [255, 165, 0, 1], orangered: [255, 69, 0, 1], orchid: [218, 112, 214, 1], palegoldenrod: [238, 232, 170, 1], palegreen: [152, 251, 152, 1], paleturquoise: [175, 238, 238, 1], palevioletred: [219, 112, 147, 1], papayawhip: [255, 239, 213, 1], peachpuff: [255, 218, 185, 1], peru: [205, 133, 63, 1], pink: [255, 192, 203, 1], plum: [221, 160, 221, 1], powderblue: [176, 224, 230, 1], purple: [128, 0, 128, 1], rebeccapurple: [102, 51, 153, 1], red: [255, 0, 0, 1], rosybrown: [188, 143, 143, 1], royalblue: [65, 105, 225, 1], saddlebrown: [139, 69, 19, 1], salmon: [250, 128, 114, 1], sandybrown: [244, 164, 96, 1], seagreen: [46, 139, 87, 1], seashell: [255, 245, 238, 1], sienna: [160, 82, 45, 1], silver: [192, 192, 192, 1], skyblue: [135, 206, 235, 1], slateblue: [106, 90, 205, 1], slategray: [112, 128, 144, 1], slategrey: [112, 128, 144, 1], snow: [255, 250, 250, 1], springgreen: [0, 255, 127, 1], steelblue: [70, 130, 180, 1], tan: [210, 180, 140, 1], teal: [0, 128, 128, 1], thistle: [216, 191, 216, 1], tomato: [255, 99, 71, 1], turquoise: [64, 224, 208, 1], violet: [238, 130, 238, 1], wheat: [245, 222, 179, 1], white: [255, 255, 255, 1], whitesmoke: [245, 245, 245, 1], yellow: [255, 255, 0, 1], yellowgreen: [154, 205, 50, 1] };
            function e2(t3) {
              return (t3 = Math.round(t3)) < 0 ? 0 : t3 > 255 ? 255 : t3;
            }
            function r2(t3) {
              return e2("%" === t3[t3.length - 1] ? parseFloat(t3) / 100 * 255 : parseInt(t3));
            }
            function n2(t3) {
              return (e3 = "%" === t3[t3.length - 1] ? parseFloat(t3) / 100 : parseFloat(t3)) < 0 ? 0 : e3 > 1 ? 1 : e3;
              var e3;
            }
            function i2(t3, e3, r3) {
              return r3 < 0 ? r3 += 1 : r3 > 1 && (r3 -= 1), 6 * r3 < 1 ? t3 + (e3 - t3) * r3 * 6 : 2 * r3 < 1 ? e3 : 3 * r3 < 2 ? t3 + (e3 - t3) * (2 / 3 - r3) * 6 : t3;
            }
            try {
              nr.parseCSSColor = function(s2) {
                var o2, a2 = s2.replace(/ /g, "").toLowerCase();
                if (a2 in t2) return t2[a2].slice();
                if ("#" === a2[0]) return 4 === a2.length ? (o2 = parseInt(a2.substr(1), 16)) >= 0 && o2 <= 4095 ? [(3840 & o2) >> 4 | (3840 & o2) >> 8, 240 & o2 | (240 & o2) >> 4, 15 & o2 | (15 & o2) << 4, 1] : null : 7 === a2.length && (o2 = parseInt(a2.substr(1), 16)) >= 0 && o2 <= 16777215 ? [(16711680 & o2) >> 16, (65280 & o2) >> 8, 255 & o2, 1] : null;
                var l2 = a2.indexOf("("), u2 = a2.indexOf(")");
                if (-1 !== l2 && u2 + 1 === a2.length) {
                  var c2 = a2.substr(0, l2), h3 = a2.substr(l2 + 1, u2 - (l2 + 1)).split(","), p3 = 1;
                  switch (c2) {
                    case "rgba":
                      if (4 !== h3.length) return null;
                      p3 = n2(h3.pop());
                    case "rgb":
                      return 3 !== h3.length ? null : [r2(h3[0]), r2(h3[1]), r2(h3[2]), p3];
                    case "hsla":
                      if (4 !== h3.length) return null;
                      p3 = n2(h3.pop());
                    case "hsl":
                      if (3 !== h3.length) return null;
                      var f2 = (parseFloat(h3[0]) % 360 + 360) % 360 / 360, d2 = n2(h3[1]), m2 = n2(h3[2]), y2 = m2 <= 0.5 ? m2 * (d2 + 1) : m2 + d2 - m2 * d2, g2 = 2 * m2 - y2;
                      return [e2(255 * i2(g2, y2, f2 + 1 / 3)), e2(255 * i2(g2, y2, f2)), e2(255 * i2(g2, y2, f2 - 1 / 3)), p3];
                    default:
                      return null;
                  }
                }
                return null;
              };
            } catch (t3) {
            }
            return nr;
          }();
          class sr {
            constructor(t2, e2, r2, n2 = 1) {
              this.r = t2, this.g = e2, this.b = r2, this.a = n2;
            }
            static parse(t2) {
              if (!t2) return;
              if (t2 instanceof sr) return t2;
              if ("string" != typeof t2) return;
              const e2 = ir.parseCSSColor(t2);
              return e2 ? new sr(e2[0] / 255, e2[1] / 255, e2[2] / 255, e2[3]) : void 0;
            }
            toString() {
              const [t2, e2, r2, n2] = [this.r, this.g, this.b, this.a];
              return `rgba(${Math.round(255 * t2)},${Math.round(255 * e2)},${Math.round(255 * r2)},${n2})`;
            }
            toNonPremultipliedRenderColor(t2) {
              const { r: e2, g: r2, b: n2, a: i2 } = this;
              return new ar(t2, e2, r2, n2, i2);
            }
            toPremultipliedRenderColor(t2) {
              const { r: e2, g: r2, b: n2, a: i2 } = this;
              return new lr(t2, e2 * i2, r2 * i2, n2 * i2, i2);
            }
            clone() {
              return new sr(this.r, this.g, this.b, this.a);
            }
          }
          class or {
            constructor(t2, e2, r2, n2, i2, s2 = false) {
              if (this.premultiplied = false, this.premultiplied = s2, t2) {
                const s3 = t2.image.height, o2 = s3 * s3;
                this.premultiplied ? (e2 = 0 === i2 ? 0 : e2 / i2 * (s3 - 1), r2 = 0 === i2 ? 0 : r2 / i2 * (s3 - 1), n2 = 0 === i2 ? 0 : n2 / i2 * (s3 - 1)) : (e2 *= s3 - 1, r2 *= s3 - 1, n2 *= s3 - 1);
                const a2 = Math.floor(e2), l2 = Math.floor(r2), u2 = Math.floor(n2), c2 = Math.ceil(e2), h3 = Math.ceil(r2), p3 = Math.ceil(n2), f2 = e2 - a2, d2 = r2 - l2, m2 = n2 - u2, y2 = t2.image.data, g2 = 4 * (a2 + l2 * o2 + u2 * s3), x2 = 4 * (a2 + l2 * o2 + p3 * s3), v2 = 4 * (a2 + h3 * o2 + u2 * s3), b2 = 4 * (a2 + h3 * o2 + p3 * s3), w2 = 4 * (c2 + l2 * o2 + u2 * s3), _2 = 4 * (c2 + l2 * o2 + p3 * s3), A2 = 4 * (c2 + h3 * o2 + u2 * s3), M2 = 4 * (c2 + h3 * o2 + p3 * s3);
                if (g2 < 0 || M2 >= y2.length) throw new Error("out of range");
                this.r = ur(ur(ur(y2[g2], y2[x2], m2), ur(y2[v2], y2[b2], m2), d2), ur(ur(y2[w2], y2[_2], m2), ur(y2[A2], y2[M2], m2), d2), f2) / 255 * (this.premultiplied ? i2 : 1), this.g = ur(ur(ur(y2[g2 + 1], y2[x2 + 1], m2), ur(y2[v2 + 1], y2[b2 + 1], m2), d2), ur(ur(y2[w2 + 1], y2[_2 + 1], m2), ur(y2[A2 + 1], y2[M2 + 1], m2), d2), f2) / 255 * (this.premultiplied ? i2 : 1), this.b = ur(ur(ur(y2[g2 + 2], y2[x2 + 2], m2), ur(y2[v2 + 2], y2[b2 + 2], m2), d2), ur(ur(y2[w2 + 2], y2[_2 + 2], m2), ur(y2[A2 + 2], y2[M2 + 2], m2), d2), f2) / 255 * (this.premultiplied ? i2 : 1), this.a = i2;
              } else this.r = e2, this.g = r2, this.b = n2, this.a = i2;
            }
            toArray() {
              const { r: t2, g: e2, b: r2, a: n2 } = this;
              return [255 * t2, 255 * e2, 255 * r2, n2];
            }
            toHslaArray() {
              let { r: t2, g: e2, b: r2, a: n2 } = this;
              if (this.premultiplied) {
                if (0 === n2) return [0, 0, 0, 0];
                t2 /= n2, e2 /= n2, r2 /= n2;
              }
              const i2 = Math.min(Math.max(t2, 0), 1), s2 = Math.min(Math.max(e2, 0), 1), o2 = Math.min(Math.max(r2, 0), 1), a2 = Math.min(i2, s2, o2), l2 = Math.max(i2, s2, o2), u2 = (a2 + l2) / 2;
              if (a2 === l2) return [0, 0, 100 * u2, n2];
              const c2 = l2 - a2, h3 = u2 > 0.5 ? c2 / (2 - l2 - a2) : c2 / (l2 + a2);
              let p3 = 0;
              return l2 === i2 ? p3 = (s2 - o2) / c2 + (s2 < o2 ? 6 : 0) : l2 === s2 ? p3 = (o2 - i2) / c2 + 2 : l2 === o2 && (p3 = (i2 - s2) / c2 + 4), p3 *= 60, [Math.min(Math.max(p3, 0), 360), Math.min(Math.max(100 * h3, 0), 100), Math.min(Math.max(100 * u2, 0), 100), n2];
            }
            toArray01() {
              const { r: t2, g: e2, b: r2, a: n2 } = this;
              return [t2, e2, r2, n2];
            }
            toArray01Scaled(t2) {
              const { r: e2, g: r2, b: n2 } = this;
              return [e2 * t2, r2 * t2, n2 * t2];
            }
            toArray01Linear() {
              const { r: t2, g: e2, b: r2, a: n2 } = this;
              return [Math.pow(t2, 2.2), Math.pow(e2, 2.2), Math.pow(r2, 2.2), n2];
            }
          }
          class ar extends or {
            constructor(t2, e2, r2, n2, i2) {
              super(t2, e2, r2, n2, i2, false);
            }
          }
          class lr extends or {
            constructor(t2, e2, r2, n2, i2) {
              super(t2, e2, r2, n2, i2, true);
            }
          }
          function ur(t2, e2, r2) {
            return t2 * (1 - r2) + e2 * r2;
          }
          function cr(t2, e2, r2) {
            return t2.map((t3, n2) => ur(t3, e2[n2], r2));
          }
          sr.black = new sr(0, 0, 0, 1), sr.white = new sr(1, 1, 1, 1), sr.transparent = new sr(0, 0, 0, 0), sr.red = new sr(1, 0, 0, 1), sr.blue = new sr(0, 0, 1, 1);
          var hr = Object.freeze({ __proto__: null, array: cr, color: function(t2, e2, r2) {
            return new sr(ur(t2.r, e2.r, r2), ur(t2.g, e2.g, r2), ur(t2.b, e2.b, r2), ur(t2.a, e2.a, r2));
          }, number: ur });
          function pr(t2, ...e2) {
            for (const r2 of e2) for (const e3 in r2) t2[e3] = r2[e3];
            return t2;
          }
          class fr extends Error {
            constructor(t2, e2) {
              super(e2), this.message = e2, this.key = t2;
            }
          }
          class dr {
            constructor(t2, e2 = []) {
              this.parent = t2, this.bindings = {};
              for (const [t3, r2] of e2) this.bindings[t3] = r2;
            }
            concat(t2) {
              return new dr(this, t2);
            }
            get(t2) {
              if (this.bindings[t2]) return this.bindings[t2];
              if (this.parent) return this.parent.get(t2);
              throw new Error(`${t2} not found in scope.`);
            }
            has(t2) {
              return !!this.bindings[t2] || !!this.parent && this.parent.has(t2);
            }
          }
          const mr = { kind: "null" }, yr = { kind: "number" }, gr = { kind: "string" }, xr = { kind: "boolean" }, vr = { kind: "color" }, br = { kind: "object" }, wr = { kind: "value" }, _r = { kind: "collator" }, Ar = { kind: "formatted" }, Mr = { kind: "resolvedImage" };
          function Ir(t2, e2) {
            return { kind: "array", itemType: t2, N: e2 };
          }
          function Sr(t2) {
            if ("array" === t2.kind) {
              const e2 = Sr(t2.itemType);
              return "number" == typeof t2.N ? `array<${e2}, ${t2.N}>` : "value" === t2.itemType.kind ? "array" : `array<${e2}>`;
            }
            return t2.kind;
          }
          const zr = [mr, yr, gr, xr, vr, Ar, br, Ir(wr), Mr];
          function kr(t2, e2) {
            if ("error" === e2.kind) return null;
            if ("array" === t2.kind) {
              if ("array" === e2.kind && (0 === e2.N && "value" === e2.itemType.kind || !kr(t2.itemType, e2.itemType)) && ("number" != typeof t2.N || t2.N === e2.N)) return null;
            } else {
              if (t2.kind === e2.kind) return null;
              if ("value" === t2.kind) {
                for (const t3 of zr) if (!kr(t3, e2)) return null;
              }
            }
            return `Expected ${Sr(t2)} but found ${Sr(e2)} instead.`;
          }
          function Pr(t2, e2) {
            return e2.some((e3) => e3.kind === t2.kind);
          }
          function Er(t2, e2) {
            return e2.some((e3) => "null" === e3 ? null === t2 : "array" === e3 ? Array.isArray(t2) : "object" === e3 ? t2 && !Array.isArray(t2) && "object" == typeof t2 : e3 === typeof t2);
          }
          function Tr(t2, e2) {
            return "array" === t2.kind && "array" === e2.kind ? t2.N === e2.N && Tr(t2.itemType, e2.itemType) : t2.kind === e2.kind;
          }
          class Br {
            constructor(t2, e2, r2) {
              this.sensitivity = t2 ? e2 ? "variant" : "case" : e2 ? "accent" : "base", this.locale = r2, this.collator = new Intl.Collator(this.locale ? this.locale : [], { sensitivity: this.sensitivity, usage: "search" });
            }
            compare(t2, e2) {
              return this.collator.compare(t2, e2);
            }
            resolvedLocale() {
              return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
          }
          class Vr {
            constructor(t2, e2, r2, n2, i2) {
              this.text = t2.normalize ? t2.normalize() : t2, this.image = e2, this.scale = r2, this.fontStack = n2, this.textColor = i2;
            }
          }
          class Cr {
            constructor(t2) {
              this.sections = t2;
            }
            static fromString(t2) {
              return new Cr([new Vr(t2, null, null, null, null)]);
            }
            isEmpty() {
              return 0 === this.sections.length || !this.sections.some((t2) => 0 !== t2.text.length || !!t2.image && t2.image.hasPrimary());
            }
            static factory(t2) {
              return t2 instanceof Cr ? t2 : Cr.fromString(t2);
            }
            toString() {
              return 0 === this.sections.length ? "" : this.sections.map((t2) => t2.text).join("");
            }
            serialize() {
              const t2 = ["format"];
              for (const e2 of this.sections) {
                if (e2.image) {
                  const r3 = e2.image.getPrimary().id.toString();
                  t2.push(["image", r3]);
                  continue;
                }
                t2.push(e2.text);
                const r2 = {};
                e2.fontStack && (r2["text-font"] = ["literal", e2.fontStack.split(",")]), e2.scale && (r2["font-scale"] = e2.scale), e2.textColor && (r2["text-color"] = ["rgba"].concat(e2.textColor.toNonPremultipliedRenderColor(null).toArray())), t2.push(r2);
              }
              return t2;
            }
          }
          class Fr {
            constructor(t2, e2 = {}) {
              if (this.id = er.from(t2), this.options = Object.assign({}, e2), e2.transform) {
                const { a: t3, b: r2, c: n2, d: i2, e: s2, f: o2 } = e2.transform;
                this.options.transform = new DOMMatrix([t3, r2, n2, i2, s2, o2]);
              } else this.options.transform = new DOMMatrix([1, 0, 0, 1, 0, 0]);
            }
            toString() {
              const { a: t2, b: e2, c: r2, d: n2, e: i2, f: s2 } = this.options.transform;
              return JSON.stringify({ name: this.id.name, iconsetId: this.id.iconsetId, params: this.options.params, transform: { a: t2, b: e2, c: r2, d: n2, e: i2, f: s2 } });
            }
            static parse(t2) {
              let e2, r2, n2, i2;
              try {
                ({ name: e2, iconsetId: r2, params: n2, transform: i2 } = JSON.parse(t2) || {});
              } catch (t3) {
                return null;
              }
              if (!e2) return null;
              const { a: s2, b: o2, c: a2, d: l2, e: u2, f: c2 } = i2 || {};
              return new Fr({ name: e2, iconsetId: r2 }, { params: n2, transform: new DOMMatrix([s2, o2, a2, l2, u2, c2]) });
            }
            scaleSelf(t2, e2) {
              return this.options.transform.scaleSelf(t2, e2), this;
            }
          }
          class Dr {
            constructor(t2, e2, r2, n2, i2 = false) {
              this.primaryId = er.from(t2), this.primaryOptions = e2, r2 && (this.secondaryId = er.from(r2)), this.secondaryOptions = n2, this.available = i2;
            }
            toString() {
              return this.primaryId && this.secondaryId ? `[${this.primaryId.name},${this.secondaryId.name}]` : this.primaryId.name;
            }
            hasPrimary() {
              return !!this.primaryId;
            }
            getPrimary() {
              return new Fr(this.primaryId, this.primaryOptions);
            }
            hasSecondary() {
              return !!this.secondaryId;
            }
            getSecondary() {
              return this.secondaryId ? new Fr(this.secondaryId, this.secondaryOptions) : null;
            }
            static from(t2) {
              return "string" == typeof t2 ? Dr.build({ name: t2 }) : t2;
            }
            static build(t2, e2, r2, n2) {
              return !t2 || "object" == typeof t2 && !("name" in t2) ? null : new Dr(t2, r2, e2, n2);
            }
          }
          function Lr(t2, e2, r2, n2) {
            return "number" == typeof t2 && t2 >= 0 && t2 <= 255 && "number" == typeof e2 && e2 >= 0 && e2 <= 255 && "number" == typeof r2 && r2 >= 0 && r2 <= 255 ? void 0 === n2 || "number" == typeof n2 && n2 >= 0 && n2 <= 1 ? null : `Invalid rgba value [${[t2, e2, r2, n2].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n2 ? [t2, e2, r2, n2] : [t2, e2, r2]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
          }
          function Rr(t2) {
            if (null === t2) return true;
            if ("string" == typeof t2) return true;
            if ("boolean" == typeof t2) return true;
            if ("number" == typeof t2) return true;
            if (t2 instanceof sr) return true;
            if (t2 instanceof Br) return true;
            if (t2 instanceof Cr) return true;
            if (t2 instanceof Dr) return true;
            if (Array.isArray(t2)) {
              for (const e2 of t2) if (!Rr(e2)) return false;
              return true;
            }
            if ("object" == typeof t2) {
              for (const e2 in t2) if (!Rr(t2[e2])) return false;
              return true;
            }
            return false;
          }
          function Or(t2) {
            if (null === t2) return mr;
            if ("string" == typeof t2) return gr;
            if ("boolean" == typeof t2) return xr;
            if ("number" == typeof t2) return yr;
            if (t2 instanceof sr) return vr;
            if (t2 instanceof Br) return _r;
            if (t2 instanceof Cr) return Ar;
            if (t2 instanceof Dr) return Mr;
            if (Array.isArray(t2)) {
              const e2 = t2.length;
              let r2;
              for (const e3 of t2) {
                const t3 = Or(e3);
                if (r2) {
                  if (r2 === t3) continue;
                  r2 = wr;
                  break;
                }
                r2 = t3;
              }
              return Ir(r2 || wr, e2);
            }
            return br;
          }
          function Ur(t2) {
            const e2 = typeof t2;
            return null === t2 ? "" : "string" === e2 || "number" === e2 || "boolean" === e2 ? String(t2) : t2 instanceof Cr || t2 instanceof Dr || t2 instanceof sr ? t2.toString() : JSON.stringify(t2);
          }
          class Nr {
            constructor(t2, e2) {
              this.type = t2, this.value = e2;
            }
            static parse(t2, e2) {
              if (2 !== t2.length) return e2.error(`'literal' expression requires exactly one argument, but found ${t2.length - 1} instead.`);
              if (!Rr(t2[1])) return e2.error("invalid value");
              const r2 = t2[1];
              let n2 = Or(r2);
              const i2 = e2.expectedType;
              return "array" !== n2.kind || 0 !== n2.N || !i2 || "array" !== i2.kind || "number" == typeof i2.N && 0 !== i2.N || (n2 = i2), new Nr(n2, r2);
            }
            evaluate() {
              return this.value;
            }
            eachChild() {
            }
            outputDefined() {
              return true;
            }
            serialize() {
              return "array" === this.type.kind || "object" === this.type.kind ? ["literal", this.value] : this.value instanceof sr ? ["rgba"].concat(this.value.toNonPremultipliedRenderColor(null).toArray()) : this.value instanceof Cr ? this.value.serialize() : this.value;
            }
          }
          class jr {
            constructor(t2) {
              this.name = "ExpressionEvaluationError", this.message = t2;
            }
            toJSON() {
              return this.message;
            }
          }
          const $r = { string: gr, number: yr, boolean: xr, object: br };
          class Gr {
            constructor(t2, e2) {
              this.type = t2, this.args = e2;
            }
            static parse(t2, e2) {
              if (t2.length < 2) return e2.error("Expected at least one argument.");
              let r2, n2 = 1;
              const i2 = t2[0];
              if ("array" === i2) {
                let i3, s3;
                if (t2.length > 2) {
                  const r3 = t2[1];
                  if ("string" != typeof r3 || !(r3 in $r) || "object" === r3) return e2.error('The item type argument of "array" must be one of string, number, boolean', 1);
                  i3 = $r[r3], n2++;
                } else i3 = wr;
                if (t2.length > 3) {
                  if (null !== t2[2] && ("number" != typeof t2[2] || t2[2] < 0 || t2[2] !== Math.floor(t2[2]))) return e2.error('The length argument to "array" must be a positive integer literal', 2);
                  s3 = t2[2], n2++;
                }
                r2 = Ir(i3, s3);
              } else r2 = $r[i2];
              const s2 = [];
              for (; n2 < t2.length; n2++) {
                const r3 = e2.parse(t2[n2], n2, wr);
                if (!r3) return null;
                s2.push(r3);
              }
              return new Gr(r2, s2);
            }
            evaluate(t2) {
              for (let e2 = 0; e2 < this.args.length; e2++) {
                const r2 = this.args[e2].evaluate(t2);
                if (!kr(this.type, Or(r2))) return r2;
                if (e2 === this.args.length - 1) throw new jr(`The expression ${JSON.stringify(this.args[e2].serialize())} evaluated to ${Sr(Or(r2))} but was expected to be of type ${Sr(this.type)}.`);
              }
              return null;
            }
            eachChild(t2) {
              this.args.forEach(t2);
            }
            outputDefined() {
              return this.args.every((t2) => t2.outputDefined());
            }
            serialize() {
              const t2 = this.type, e2 = [t2.kind];
              if ("array" === t2.kind) {
                const r2 = t2.itemType;
                if ("string" === r2.kind || "number" === r2.kind || "boolean" === r2.kind) {
                  e2.push(r2.kind);
                  const n2 = t2.N;
                  ("number" == typeof n2 || this.args.length > 1) && e2.push(n2);
                }
              }
              return e2.concat(this.args.map((t3) => t3.serialize()));
            }
          }
          class qr {
            constructor(t2) {
              this.type = Ar, this.sections = t2;
            }
            static parse(t2, e2) {
              if (t2.length < 2) return e2.error("Expected at least one argument.");
              const r2 = t2[1];
              if (!Array.isArray(r2) && "object" == typeof r2) return e2.error("First argument must be an image or text section.");
              const n2 = [];
              let i2 = false;
              for (let r3 = 1; r3 <= t2.length - 1; ++r3) {
                const s2 = t2[r3];
                if (i2 && "object" == typeof s2 && !Array.isArray(s2)) {
                  i2 = false;
                  let t3 = null;
                  if (s2["font-scale"] && (t3 = e2.parseObjectValue(s2["font-scale"], r3, "font-scale", yr), !t3)) return null;
                  let o2 = null;
                  if (s2["text-font"] && (o2 = e2.parseObjectValue(s2["text-font"], r3, "text-font", Ir(gr)), !o2)) return null;
                  let a2 = null;
                  if (s2["text-color"] && (a2 = e2.parseObjectValue(s2["text-color"], r3, "text-color", vr), !a2)) return null;
                  const l2 = n2[n2.length - 1];
                  l2.scale = t3, l2.font = o2, l2.textColor = a2;
                } else {
                  const s3 = e2.parse(t2[r3], r3, wr);
                  if (!s3) return null;
                  const o2 = s3.type.kind;
                  if ("string" !== o2 && "value" !== o2 && "null" !== o2 && "resolvedImage" !== o2) return e2.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                  i2 = true, n2.push({ content: s3, scale: null, font: null, textColor: null });
                }
              }
              return new qr(n2);
            }
            evaluate(t2) {
              return new Cr(this.sections.map((e2) => {
                const r2 = e2.content.evaluate(t2);
                return Tr(Or(r2), Mr) ? new Vr("", r2, null, null, null) : new Vr(Ur(r2), null, e2.scale ? e2.scale.evaluate(t2) : null, e2.font ? e2.font.evaluate(t2).join(",") : null, e2.textColor ? e2.textColor.evaluate(t2) : null);
              }));
            }
            eachChild(t2) {
              for (const e2 of this.sections) t2(e2.content), e2.scale && t2(e2.scale), e2.font && t2(e2.font), e2.textColor && t2(e2.textColor);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              const t2 = ["format"];
              for (const e2 of this.sections) {
                t2.push(e2.content.serialize());
                const r2 = {};
                e2.scale && (r2["font-scale"] = e2.scale.serialize()), e2.font && (r2["text-font"] = e2.font.serialize()), e2.textColor && (r2["text-color"] = e2.textColor.serialize()), t2.push(r2);
              }
              return t2;
            }
          }
          class Hr {
            constructor(t2, e2, r2, n2) {
              this._imageWarnHistory = {}, this.type = Mr, this.namePrimary = t2, this.nameSecondary = e2, r2 && (this.paramsPrimary = r2.params, this.iconsetIdPrimary = r2.iconset ? r2.iconset.id : void 0), n2 && (this.paramsSecondary = n2.params, this.iconsetIdSecondary = n2.iconset ? n2.iconset.id : void 0);
            }
            static parse(t2, e2) {
              if (t2.length < 2) return e2.error("Expected two or more arguments.");
              let r2 = 1;
              const n2 = [];
              function i2() {
                if (r2 < t2.length) {
                  const i3 = e2.parse(t2[r2], r2++, gr);
                  return i3 ? (n2.push({ image: i3, options: {} }), true) : (e2.error(n2.length ? "Secondary image variant is not a string." : "No image name provided."), false);
                }
                return true;
              }
              function s2() {
                if (r2 < t2.length) {
                  const s3 = t2[r2];
                  if (null === (i3 = s3) || "object" != typeof i3 || Array.isArray(i3)) return true;
                  const o2 = s3.params, a2 = s3.iconset, l2 = e2.concat(r2);
                  if (!o2 && !a2) return r2++, true;
                  if (o2) {
                    if ("object" != typeof o2 || o2.constructor !== Object) return l2.error('Image options "params" should be an object'), false;
                    const t3 = {}, e3 = l2.concat(void 0, "params");
                    for (const r3 in o2) {
                      if (!r3) return e3.error("Image parameter name should be non-empty"), false;
                      const n3 = e3.concat(void 0, r3).parse(o2[r3], void 0, vr, void 0, { typeAnnotation: "coerce" });
                      if (!n3) return false;
                      t3[r3] = n3;
                    }
                    n2[n2.length - 1].options.params = t3;
                  }
                  if (a2) {
                    if ("object" != typeof a2 || a2.constructor !== Object) return l2.error('Image options "iconset" should be an object'), false;
                    if (!a2.id) return l2.error('Image options "iconset" should have an "id" property'), false;
                    n2[n2.length - 1].options.iconset = a2;
                  }
                  return r2++, true;
                }
                var i3;
                return true;
              }
              for (let t3 = 0; t3 < 2; t3++) if (!i2() || !s2()) return;
              return new Hr(n2[0].image, n2[1] ? n2[1].image : void 0, n2[0].options, n2[1] ? n2[1].options : void 0);
            }
            evaluateParams(t2, e2) {
              const r2 = {};
              if (e2) {
                for (const n2 in e2) if (e2[n2]) try {
                  r2[n2] = e2[n2].evaluate(t2);
                } catch (t3) {
                  continue;
                }
                if (0 !== Object.keys(r2).length) return { params: r2 };
              }
            }
            evaluate(t2) {
              const e2 = { name: this.namePrimary.evaluate(t2), iconsetId: this.iconsetIdPrimary }, r2 = this.nameSecondary ? { name: this.nameSecondary.evaluate(t2), iconsetId: this.iconsetIdSecondary } : void 0, n2 = Dr.build(e2, r2, this.paramsPrimary ? this.evaluateParams(t2, this.paramsPrimary) : void 0, this.paramsSecondary ? this.evaluateParams(t2, this.paramsSecondary) : void 0);
              if (n2 && t2.availableImages) {
                const e3 = n2.getPrimary().id;
                if (n2.available = t2.availableImages.some((t3) => er.isEqual(t3, e3)), n2.available) {
                  const e4 = n2.getSecondary() ? n2.getSecondary().id : null;
                  e4 && (n2.available = t2.availableImages.some((t3) => er.isEqual(t3, e4)));
                }
              }
              return n2;
            }
            eachChild(t2) {
              if (t2(this.namePrimary), this.paramsPrimary) for (const e2 in this.paramsPrimary) this.paramsPrimary[e2] && t2(this.paramsPrimary[e2]);
              if (this.nameSecondary && (t2(this.nameSecondary), this.paramsSecondary)) for (const e2 in this.paramsSecondary) this.paramsSecondary[e2] && t2(this.paramsSecondary[e2]);
            }
            outputDefined() {
              return false;
            }
            serializeOptions(t2, e2) {
              const r2 = {};
              if (e2 && (r2.iconset = { id: e2 }), t2) {
                r2.params = {};
                for (const e3 in t2) t2[e3] && (r2.params[e3] = t2[e3].serialize());
              }
              return Object.keys(r2).length > 0 ? r2 : void 0;
            }
            serialize() {
              const t2 = ["image", this.namePrimary.serialize()];
              if (this.paramsPrimary || this.iconsetIdPrimary) {
                const e2 = this.serializeOptions(this.paramsPrimary, this.iconsetIdPrimary);
                e2 && t2.push(e2);
              }
              if (this.nameSecondary && (t2.push(this.nameSecondary.serialize()), this.paramsSecondary || this.iconsetIdSecondary)) {
                const e2 = this.serializeOptions(this.paramsSecondary, this.iconsetIdSecondary);
                e2 && t2.push(e2);
              }
              return t2;
            }
          }
          function Xr(t2) {
            return t2 instanceof Number ? "number" : t2 instanceof String ? "string" : t2 instanceof Boolean ? "boolean" : Array.isArray(t2) ? "array" : null === t2 ? "null" : typeof t2;
          }
          const Zr = { "to-boolean": xr, "to-color": vr, "to-number": yr, "to-string": gr };
          class Wr {
            constructor(t2, e2) {
              this.type = t2, this.args = e2;
            }
            static parse(t2, e2) {
              if (t2.length < 2) return e2.error("Expected at least one argument.");
              const r2 = t2[0], n2 = [];
              let i2 = mr;
              if ("to-array" === r2) {
                if (!Array.isArray(t2[1])) return null;
                const r3 = t2[1].length;
                if (e2.expectedType) {
                  if ("array" !== e2.expectedType.kind) return e2.error(`Expected ${e2.expectedType.kind} but found array.`);
                  i2 = Ir(e2.expectedType.itemType, r3);
                } else {
                  if (!(r3 > 0 && Rr(t2[1][0]))) return null;
                  i2 = Ir(Or(t2[1][0]), r3);
                }
                for (let s2 = 0; s2 < r3; s2++) {
                  const r4 = t2[1][s2];
                  let o2;
                  if ("array" === Xr(r4)) o2 = e2.parse(r4, void 0, i2.itemType);
                  else {
                    const t3 = Xr(r4);
                    if (t3 !== i2.itemType.kind) return e2.error(`Expected ${i2.itemType.kind} but found ${t3}.`);
                    o2 = e2.registry.literal.parse(["literal", void 0 === r4 ? null : r4], e2);
                  }
                  if (!o2) return null;
                  n2.push(o2);
                }
              } else {
                if (("to-boolean" === r2 || "to-string" === r2) && 2 !== t2.length) return e2.error("Expected one argument.");
                i2 = Zr[r2];
                for (let r3 = 1; r3 < t2.length; r3++) {
                  const i3 = e2.parse(t2[r3], r3, wr);
                  if (!i3) return null;
                  n2.push(i3);
                }
              }
              return new Wr(i2, n2);
            }
            evaluate(t2) {
              if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(t2));
              if ("color" === this.type.kind) {
                let e2, r2;
                for (const n2 of this.args) {
                  if (e2 = n2.evaluate(t2), r2 = null, e2 instanceof sr) return e2;
                  if ("string" == typeof e2) {
                    const r3 = t2.parseColor(e2);
                    if (r3) return r3;
                  } else if (Array.isArray(e2) && (r2 = e2.length < 3 || e2.length > 4 ? `Invalid rbga value ${JSON.stringify(e2)}: expected an array containing either three or four numeric values.` : Lr(e2[0], e2[1], e2[2], e2[3]), !r2)) return new sr(e2[0] / 255, e2[1] / 255, e2[2] / 255, e2[3]);
                }
                throw new jr(r2 || `Could not parse color from value '${"string" == typeof e2 ? e2 : String(JSON.stringify(e2))}'`);
              }
              if ("number" === this.type.kind) {
                let e2 = null;
                for (const r2 of this.args) {
                  if (e2 = r2.evaluate(t2), null === e2) return 0;
                  const n2 = Number(e2);
                  if (!isNaN(n2)) return n2;
                }
                throw new jr(`Could not convert ${JSON.stringify(e2)} to number.`);
              }
              return "formatted" === this.type.kind ? Cr.fromString(Ur(this.args[0].evaluate(t2))) : "resolvedImage" === this.type.kind ? Dr.build(Ur(this.args[0].evaluate(t2))) : "array" === this.type.kind ? this.args.map((e2) => e2.evaluate(t2)) : Ur(this.args[0].evaluate(t2));
            }
            eachChild(t2) {
              this.args.forEach(t2);
            }
            outputDefined() {
              return this.args.every((t2) => t2.outputDefined());
            }
            serialize() {
              if ("formatted" === this.type.kind) return new qr([{ content: this.args[0], scale: null, font: null, textColor: null }]).serialize();
              if ("resolvedImage" === this.type.kind) return new Hr(this.args[0]).serialize();
              const t2 = "array" === this.type.kind ? [] : [`to-${this.type.kind}`];
              return this.eachChild((e2) => {
                t2.push(e2.serialize());
              }), t2;
            }
          }
          const Yr = ["Unknown", "Point", "LineString", "Polygon"];
          class Kr {
            constructor(t2, e2) {
              this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = t2, this.options = e2;
            }
            id() {
              return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
              return this.feature ? "number" == typeof this.feature.type ? Yr[this.feature.type] : this.feature.type : null;
            }
            geometry() {
              return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
              return this.canonical;
            }
            properties() {
              return this.feature && this.feature.properties || {};
            }
            measureLight(t2) {
              return this.globals.brightness || 0;
            }
            distanceFromCenter() {
              if (this.featureTileCoord && this.featureDistanceData) {
                const t2 = this.featureDistanceData.center, e2 = this.featureDistanceData.scale, { x: r2, y: n2 } = this.featureTileCoord;
                return this.featureDistanceData.bearing[0] * (r2 * e2 - t2[0]) + this.featureDistanceData.bearing[1] * (n2 * e2 - t2[1]);
              }
              return 0;
            }
            parseColor(t2) {
              let e2 = this._parseColorCache[t2];
              return e2 || (e2 = this._parseColorCache[t2] = sr.parse(t2)), e2;
            }
            getConfig(t2) {
              return this.options ? this.options.get(t2) : null;
            }
          }
          class Jr {
            constructor(t2, e2, r2, n2, i2) {
              this.name = t2, this.type = e2, this._evaluate = r2, this.args = n2, this._overloadIndex = i2;
            }
            evaluate(t2) {
              if (!this._evaluate) {
                const t3 = Jr.definitions[this.name];
                this._evaluate = Array.isArray(t3) ? t3[2] : t3.overloads[this._overloadIndex][1];
              }
              return this._evaluate(t2, this.args);
            }
            eachChild(t2) {
              this.args.forEach(t2);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              return [this.name].concat(this.args.map((t2) => t2.serialize()));
            }
            static parse(t2, e2) {
              const r2 = t2[0], n2 = Jr.definitions[r2];
              if (!n2) return e2.error(`Unknown expression "${r2}". If you wanted a literal array, use ["literal", [...]].`, 0);
              const i2 = Array.isArray(n2) ? n2[0] : n2.type, s2 = Array.isArray(n2) ? [[n2[1], n2[2]]] : n2.overloads, o2 = [];
              let a2 = null, l2 = -1;
              for (const [n3, u2] of s2) {
                if (Array.isArray(n3) && n3.length !== t2.length - 1) continue;
                o2.push(n3), l2++, a2 = new bi(e2.registry, e2.path, null, e2.scope, void 0, e2._scope, e2.options);
                const s3 = [];
                let c2 = false;
                for (let e3 = 1; e3 < t2.length; e3++) {
                  const r3 = t2[e3], i3 = Array.isArray(n3) ? n3[e3 - 1] : n3.type, o3 = a2.parse(r3, 1 + s3.length, i3);
                  if (!o3) {
                    c2 = true;
                    break;
                  }
                  s3.push(o3);
                }
                if (!c2) if (Array.isArray(n3) && n3.length !== s3.length) a2.error(`Expected ${n3.length} arguments, but found ${s3.length} instead.`);
                else {
                  for (let t3 = 0; t3 < s3.length; t3++) {
                    const e3 = Array.isArray(n3) ? n3[t3] : n3.type, r3 = s3[t3];
                    a2.concat(t3 + 1).checkSubtype(e3, r3.type);
                  }
                  if (0 === a2.errors.length) return new Jr(r2, i2, u2, s3, l2);
                }
              }
              if (1 === o2.length) e2.errors.push(...a2.errors);
              else {
                const r3 = (o2.length ? o2 : s2.map(([t3]) => t3)).map(Qr).join(" | "), n3 = [];
                for (let r4 = 1; r4 < t2.length; r4++) {
                  const i3 = e2.parse(t2[r4], 1 + n3.length);
                  if (!i3) return null;
                  n3.push(Sr(i3.type));
                }
                e2.error(`Expected arguments of type ${r3}, but found (${n3.join(", ")}) instead.`);
              }
              return null;
            }
            static register(t2, e2) {
              Jr.definitions = e2;
              for (const r2 in e2) t2[r2] = Jr;
            }
          }
          function Qr(t2) {
            return Array.isArray(t2) ? `(${t2.map(Sr).join(", ")})` : `(${Sr(t2.type)}...)`;
          }
          class tn {
            constructor(t2, e2, r2) {
              this.type = _r, this.locale = r2, this.caseSensitive = t2, this.diacriticSensitive = e2;
            }
            static parse(t2, e2) {
              if (2 !== t2.length) return e2.error("Expected one argument.");
              const r2 = t2[1];
              if ("object" != typeof r2 || Array.isArray(r2)) return e2.error("Collator options argument must be an object.");
              const n2 = void 0 === r2["case-sensitive"] ? e2.parse(false, 1, xr) : e2.parseObjectValue(r2["case-sensitive"], 1, "case-sensitive", xr);
              if (!n2) return null;
              const i2 = void 0 === r2["diacritic-sensitive"] ? e2.parse(false, 1, xr) : e2.parseObjectValue(r2["diacritic-sensitive"], 1, "diacritic-sensitive", xr);
              if (!i2) return null;
              let s2 = null;
              return r2.locale && (s2 = e2.parseObjectValue(r2.locale, 1, "locale", gr), !s2) ? null : new tn(n2, i2, s2);
            }
            evaluate(t2) {
              return new Br(this.caseSensitive.evaluate(t2), this.diacriticSensitive.evaluate(t2), this.locale ? this.locale.evaluate(t2) : null);
            }
            eachChild(t2) {
              t2(this.caseSensitive), t2(this.diacriticSensitive), this.locale && t2(this.locale);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              const t2 = {};
              return t2["case-sensitive"] = this.caseSensitive.serialize(), t2["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (t2.locale = this.locale.serialize()), ["collator", t2];
            }
          }
          function en2(t2, e2, r2 = 0, n2 = t2.length - 1, i2 = nn) {
            for (; n2 > r2; ) {
              if (n2 - r2 > 600) {
                const s3 = n2 - r2 + 1, o3 = e2 - r2 + 1, a3 = Math.log(s3), l2 = 0.5 * Math.exp(2 * a3 / 3), u2 = 0.5 * Math.sqrt(a3 * l2 * (s3 - l2) / s3) * (o3 - s3 / 2 < 0 ? -1 : 1);
                en2(t2, e2, Math.max(r2, Math.floor(e2 - o3 * l2 / s3 + u2)), Math.min(n2, Math.floor(e2 + (s3 - o3) * l2 / s3 + u2)), i2);
              }
              const s2 = t2[e2];
              let o2 = r2, a2 = n2;
              for (rn(t2, r2, e2), i2(t2[n2], s2) > 0 && rn(t2, r2, n2); o2 < a2; ) {
                for (rn(t2, o2, a2), o2++, a2--; i2(t2[o2], s2) < 0; ) o2++;
                for (; i2(t2[a2], s2) > 0; ) a2--;
              }
              0 === i2(t2[r2], s2) ? rn(t2, r2, a2) : (a2++, rn(t2, a2, n2)), a2 <= e2 && (r2 = a2 + 1), e2 <= a2 && (n2 = a2 - 1);
            }
          }
          function rn(t2, e2, r2) {
            const n2 = t2[e2];
            t2[e2] = t2[r2], t2[r2] = n2;
          }
          function nn(t2, e2) {
            return t2 < e2 ? -1 : t2 > e2 ? 1 : 0;
          }
          function sn(t2) {
            let e2 = 0;
            for (let r2, n2, i2 = 0, s2 = t2.length, o2 = s2 - 1; i2 < s2; o2 = i2++) r2 = t2[i2], n2 = t2[o2], e2 += (n2.x - r2.x) * (r2.y + n2.y);
            return e2;
          }
          function on2(t2, e2) {
            t2[0] = Math.min(t2[0], e2[0]), t2[1] = Math.min(t2[1], e2[1]), t2[2] = Math.max(t2[2], e2[0]), t2[3] = Math.max(t2[3], e2[1]);
          }
          function an(t2, e2) {
            return !(t2[0] <= e2[0] || t2[2] >= e2[2] || t2[1] <= e2[1] || t2[3] >= e2[3]);
          }
          function ln(t2, e2, r2) {
            const n2 = t2[0] - e2[0], i2 = t2[1] - e2[1], s2 = t2[0] - r2[0], o2 = t2[1] - r2[1];
            return n2 * o2 - s2 * i2 == 0 && n2 * s2 <= 0 && i2 * o2 <= 0;
          }
          function un(t2, e2, r2 = false) {
            let n2 = false;
            for (let a2 = 0, l2 = e2.length; a2 < l2; a2++) {
              const l3 = e2[a2];
              for (let e3 = 0, a3 = l3.length, u2 = a3 - 1; e3 < a3; u2 = e3++) {
                const a4 = l3[u2], c2 = l3[e3];
                if (ln(t2, a4, c2)) return r2;
                (s2 = a4)[1] > (i2 = t2)[1] != (o2 = c2)[1] > i2[1] && i2[0] < (o2[0] - s2[0]) * (i2[1] - s2[1]) / (o2[1] - s2[1]) + s2[0] && (n2 = !n2);
              }
            }
            var i2, s2, o2;
            return n2;
          }
          function cn(t2, e2, r2, n2) {
            const i2 = n2[0] - r2[0], s2 = n2[1] - r2[1], o2 = (t2[0] - r2[0]) * s2 - i2 * (t2[1] - r2[1]), a2 = (e2[0] - r2[0]) * s2 - i2 * (e2[1] - r2[1]);
            return o2 > 0 && a2 < 0 || o2 < 0 && a2 > 0;
          }
          function hn(t2, e2, r2, n2) {
            return 0 != (i2 = [n2[0] - r2[0], n2[1] - r2[1]])[0] * (s2 = [e2[0] - t2[0], e2[1] - t2[1]])[1] - i2[1] * s2[0] && !(!cn(t2, e2, r2, n2) || !cn(r2, n2, t2, e2));
            var i2, s2;
          }
          function pn(t2) {
            const e2 = new bt(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), r2 = new bt(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
            for (const n2 of t2[0]) e2.x > n2.x && (e2.x = n2.x), e2.y > n2.y && (e2.y = n2.y), r2.x < n2.x && (r2.x = n2.x), r2.y < n2.y && (r2.y = n2.y);
            return { min: e2, max: r2 };
          }
          const fn = 8192;
          function dn(t2, e2) {
            const r2 = (180 + t2[0]) / 360, n2 = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t2[1] * Math.PI / 360))) / 360, i2 = Math.pow(2, e2.z);
            return [Math.round(r2 * i2 * fn), Math.round(n2 * i2 * fn)];
          }
          function mn(t2, e2) {
            for (let r2 = 0; r2 < e2.length; r2++) if (un(t2, e2[r2])) return true;
            return false;
          }
          function yn(t2, e2, r2) {
            for (const n2 of r2) for (let r3 = 0, i2 = n2.length, s2 = i2 - 1; r3 < i2; s2 = r3++) if (hn(t2, e2, n2[s2], n2[r3])) return true;
            return false;
          }
          function gn(t2, e2) {
            for (let r2 = 0; r2 < t2.length; ++r2) if (!un(t2[r2], e2)) return false;
            for (let r2 = 0; r2 < t2.length - 1; ++r2) if (yn(t2[r2], t2[r2 + 1], e2)) return false;
            return true;
          }
          function xn(t2, e2) {
            for (let r2 = 0; r2 < e2.length; r2++) if (gn(t2, e2[r2])) return true;
            return false;
          }
          function vn(t2, e2, r2) {
            const n2 = [];
            for (let i2 = 0; i2 < t2.length; i2++) {
              const s2 = [];
              for (let n3 = 0; n3 < t2[i2].length; n3++) {
                const o2 = dn(t2[i2][n3], r2);
                on2(e2, o2), s2.push(o2);
              }
              n2.push(s2);
            }
            return n2;
          }
          function bn(t2, e2, r2) {
            const n2 = [];
            for (let i2 = 0; i2 < t2.length; i2++) {
              const s2 = vn(t2[i2], e2, r2);
              n2.push(s2);
            }
            return n2;
          }
          function wn(t2, e2, r2, n2) {
            if (t2[0] < r2[0] || t2[0] > r2[2]) {
              const e3 = 0.5 * n2;
              let i2 = t2[0] - r2[0] > e3 ? -n2 : r2[0] - t2[0] > e3 ? n2 : 0;
              0 === i2 && (i2 = t2[0] - r2[2] > e3 ? -n2 : r2[2] - t2[0] > e3 ? n2 : 0), t2[0] += i2;
            }
            on2(e2, t2);
          }
          function _n(t2, e2, r2, n2) {
            const i2 = Math.pow(2, n2.z) * fn, s2 = [n2.x * fn, n2.y * fn], o2 = [];
            if (!t2) return o2;
            for (const n3 of t2) for (const t3 of n3) {
              const n4 = [t3.x + s2[0], t3.y + s2[1]];
              wn(n4, e2, r2, i2), o2.push(n4);
            }
            return o2;
          }
          function An(t2, e2, r2, n2) {
            const i2 = Math.pow(2, n2.z) * fn, s2 = [n2.x * fn, n2.y * fn], o2 = [];
            if (!t2) return o2;
            for (const r3 of t2) {
              const t3 = [];
              for (const n3 of r3) {
                const r4 = [n3.x + s2[0], n3.y + s2[1]];
                on2(e2, r4), t3.push(r4);
              }
              o2.push(t3);
            }
            if (e2[2] - e2[0] <= i2 / 2) {
              (a2 = e2)[0] = a2[1] = 1 / 0, a2[2] = a2[3] = -1 / 0;
              for (const t3 of o2) for (const n3 of t3) wn(n3, e2, r2, i2);
            }
            var a2;
            return o2;
          }
          class Mn {
            constructor(t2, e2) {
              this.type = xr, this.geojson = t2, this.geometries = e2;
            }
            static parse(t2, e2) {
              if (2 !== t2.length) return e2.error(`'within' expression requires exactly one argument, but found ${t2.length - 1} instead.`);
              if (Rr(t2[1])) {
                const e3 = t2[1];
                if ("FeatureCollection" === e3.type) for (let t3 = 0; t3 < e3.features.length; ++t3) {
                  const r2 = e3.features[t3].geometry.type;
                  if ("Polygon" === r2 || "MultiPolygon" === r2) return new Mn(e3, e3.features[t3].geometry);
                }
                else if ("Feature" === e3.type) {
                  const t3 = e3.geometry.type;
                  if ("Polygon" === t3 || "MultiPolygon" === t3) return new Mn(e3, e3.geometry);
                } else if ("Polygon" === e3.type || "MultiPolygon" === e3.type) return new Mn(e3, e3);
              }
              return e2.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(t2) {
              if (null != t2.geometry() && null != t2.canonicalID()) {
                if ("Point" === t2.geometryType()) return function(t3, e2) {
                  const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i2 = t3.canonicalID();
                  if (!i2) return false;
                  if ("Polygon" === e2.type) {
                    const s2 = vn(e2.coordinates, n2, i2), o2 = _n(t3.geometry(), r2, n2, i2);
                    if (!an(r2, n2)) return false;
                    for (const t4 of o2) if (!un(t4, s2)) return false;
                  }
                  if ("MultiPolygon" === e2.type) {
                    const s2 = bn(e2.coordinates, n2, i2), o2 = _n(t3.geometry(), r2, n2, i2);
                    if (!an(r2, n2)) return false;
                    for (const t4 of o2) if (!mn(t4, s2)) return false;
                  }
                  return true;
                }(t2, this.geometries);
                if ("LineString" === t2.geometryType()) return function(t3, e2) {
                  const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], n2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], i2 = t3.canonicalID();
                  if (!i2) return false;
                  if ("Polygon" === e2.type) {
                    const s2 = vn(e2.coordinates, n2, i2), o2 = An(t3.geometry(), r2, n2, i2);
                    if (!an(r2, n2)) return false;
                    for (const t4 of o2) if (!gn(t4, s2)) return false;
                  }
                  if ("MultiPolygon" === e2.type) {
                    const s2 = bn(e2.coordinates, n2, i2), o2 = An(t3.geometry(), r2, n2, i2);
                    if (!an(r2, n2)) return false;
                    for (const t4 of o2) if (!xn(t4, s2)) return false;
                  }
                  return true;
                }(t2, this.geometries);
              }
              return false;
            }
            eachChild() {
            }
            outputDefined() {
              return true;
            }
            serialize() {
              return ["within", this.geojson];
            }
          }
          const In = { kilometers: 1, miles: 1e3 / 1609.344, nauticalmiles: 1e3 / 1852, meters: 1e3, metres: 1e3, yards: 1e3 / 0.9144, feet: 1e3 / 0.3048, inches: 1e3 / 0.0254 }, Sn = 1 / 298.257223563, zn = Sn * (2 - Sn), kn = Math.PI / 180;
          class Pn {
            static fromTile(t2, e2, r2) {
              const n2 = Math.PI * (1 - 2 * (t2 + 0.5) / Math.pow(2, e2)), i2 = Math.atan(0.5 * (Math.exp(n2) - Math.exp(-n2))) / kn;
              return new Pn(i2, r2);
            }
            static get units() {
              return In;
            }
            constructor(t2, e2) {
              if (void 0 === t2) throw new Error("No latitude given.");
              if (e2 && !In[e2]) throw new Error(`Unknown unit ${e2}. Use one of: ${Object.keys(In).join(", ")}`);
              const r2 = 6378.137 * kn * (e2 ? In[e2] : 1), n2 = Math.cos(t2 * kn), i2 = 1 / (1 - zn * (1 - n2 * n2)), s2 = Math.sqrt(i2);
              this.kx = r2 * s2 * n2, this.ky = r2 * s2 * i2 * (1 - zn);
            }
            distance(t2, e2) {
              const r2 = Bn(t2[0] - e2[0]) * this.kx, n2 = (t2[1] - e2[1]) * this.ky;
              return Math.sqrt(r2 * r2 + n2 * n2);
            }
            bearing(t2, e2) {
              const r2 = Bn(e2[0] - t2[0]) * this.kx;
              return Math.atan2(r2, (e2[1] - t2[1]) * this.ky) / kn;
            }
            destination(t2, e2, r2) {
              const n2 = r2 * kn;
              return this.offset(t2, Math.sin(n2) * e2, Math.cos(n2) * e2);
            }
            offset(t2, e2, r2) {
              return [t2[0] + e2 / this.kx, t2[1] + r2 / this.ky];
            }
            lineDistance(t2) {
              let e2 = 0;
              for (let r2 = 0; r2 < t2.length - 1; r2++) e2 += this.distance(t2[r2], t2[r2 + 1]);
              return e2;
            }
            area(t2) {
              let e2 = 0;
              for (let r2 = 0; r2 < t2.length; r2++) {
                const n2 = t2[r2];
                for (let t3 = 0, i2 = n2.length, s2 = i2 - 1; t3 < i2; s2 = t3++) e2 += Bn(n2[t3][0] - n2[s2][0]) * (n2[t3][1] + n2[s2][1]) * (r2 ? -1 : 1);
              }
              return Math.abs(e2) / 2 * this.kx * this.ky;
            }
            along(t2, e2) {
              let r2 = 0;
              if (e2 <= 0) return t2[0];
              for (let n2 = 0; n2 < t2.length - 1; n2++) {
                const i2 = t2[n2], s2 = t2[n2 + 1], o2 = this.distance(i2, s2);
                if (r2 += o2, r2 > e2) return Tn(i2, s2, (e2 - (r2 - o2)) / o2);
              }
              return t2[t2.length - 1];
            }
            pointToSegmentDistance(t2, e2, r2) {
              let [n2, i2] = e2, s2 = Bn(r2[0] - n2) * this.kx, o2 = (r2[1] - i2) * this.ky;
              if (0 !== s2 || 0 !== o2) {
                const e3 = (Bn(t2[0] - n2) * this.kx * s2 + (t2[1] - i2) * this.ky * o2) / (s2 * s2 + o2 * o2);
                e3 > 1 ? (n2 = r2[0], i2 = r2[1]) : e3 > 0 && (n2 += s2 / this.kx * e3, i2 += o2 / this.ky * e3);
              }
              return s2 = Bn(t2[0] - n2) * this.kx, o2 = (t2[1] - i2) * this.ky, Math.sqrt(s2 * s2 + o2 * o2);
            }
            pointOnLine(t2, e2) {
              let r2 = 1 / 0, n2 = t2[0][0], i2 = t2[0][1], s2 = 0, o2 = 0;
              for (let a2 = 0; a2 < t2.length - 1; a2++) {
                let l2 = t2[a2][0], u2 = t2[a2][1], c2 = Bn(t2[a2 + 1][0] - l2) * this.kx, h3 = (t2[a2 + 1][1] - u2) * this.ky, p3 = 0;
                0 === c2 && 0 === h3 || (p3 = (Bn(e2[0] - l2) * this.kx * c2 + (e2[1] - u2) * this.ky * h3) / (c2 * c2 + h3 * h3), p3 > 1 ? (l2 = t2[a2 + 1][0], u2 = t2[a2 + 1][1]) : p3 > 0 && (l2 += c2 / this.kx * p3, u2 += h3 / this.ky * p3)), c2 = Bn(e2[0] - l2) * this.kx, h3 = (e2[1] - u2) * this.ky;
                const f2 = c2 * c2 + h3 * h3;
                f2 < r2 && (r2 = f2, n2 = l2, i2 = u2, s2 = a2, o2 = p3);
              }
              return { point: [n2, i2], index: s2, t: Math.max(0, Math.min(1, o2)) };
            }
            lineSlice(t2, e2, r2) {
              let n2 = this.pointOnLine(r2, t2), i2 = this.pointOnLine(r2, e2);
              if (n2.index > i2.index || n2.index === i2.index && n2.t > i2.t) {
                const t3 = n2;
                n2 = i2, i2 = t3;
              }
              const s2 = [n2.point], o2 = n2.index + 1, a2 = i2.index;
              !En(r2[o2], s2[0]) && o2 <= a2 && s2.push(r2[o2]);
              for (let t3 = o2 + 1; t3 <= a2; t3++) s2.push(r2[t3]);
              return En(r2[a2], i2.point) || s2.push(i2.point), s2;
            }
            lineSliceAlong(t2, e2, r2) {
              let n2 = 0;
              const i2 = [];
              for (let s2 = 0; s2 < r2.length - 1; s2++) {
                const o2 = r2[s2], a2 = r2[s2 + 1], l2 = this.distance(o2, a2);
                if (n2 += l2, n2 > t2 && 0 === i2.length && i2.push(Tn(o2, a2, (t2 - (n2 - l2)) / l2)), n2 >= e2) return i2.push(Tn(o2, a2, (e2 - (n2 - l2)) / l2)), i2;
                n2 > t2 && i2.push(a2);
              }
              return i2;
            }
            bufferPoint(t2, e2) {
              const r2 = e2 / this.ky, n2 = e2 / this.kx;
              return [t2[0] - n2, t2[1] - r2, t2[0] + n2, t2[1] + r2];
            }
            bufferBBox(t2, e2) {
              const r2 = e2 / this.ky, n2 = e2 / this.kx;
              return [t2[0] - n2, t2[1] - r2, t2[2] + n2, t2[3] + r2];
            }
            insideBBox(t2, e2) {
              return Bn(t2[0] - e2[0]) >= 0 && Bn(t2[0] - e2[2]) <= 0 && t2[1] >= e2[1] && t2[1] <= e2[3];
            }
          }
          function En(t2, e2) {
            return t2[0] === e2[0] && t2[1] === e2[1];
          }
          function Tn(t2, e2, r2) {
            const n2 = Bn(e2[0] - t2[0]);
            return [t2[0] + n2 * r2, t2[1] + (e2[1] - t2[1]) * r2];
          }
          function Bn(t2) {
            for (; t2 < -180; ) t2 += 360;
            for (; t2 > 180; ) t2 -= 360;
            return t2;
          }
          class Vn {
            constructor(t2 = [], e2 = (t3, e3) => t3 < e3 ? -1 : t3 > e3 ? 1 : 0) {
              if (this.data = t2, this.length = this.data.length, this.compare = e2, this.length > 0) for (let t3 = (this.length >> 1) - 1; t3 >= 0; t3--) this._down(t3);
            }
            push(t2) {
              this.data.push(t2), this._up(this.length++);
            }
            pop() {
              if (0 === this.length) return;
              const t2 = this.data[0], e2 = this.data.pop();
              return --this.length > 0 && (this.data[0] = e2, this._down(0)), t2;
            }
            peek() {
              return this.data[0];
            }
            _up(t2) {
              const { data: e2, compare: r2 } = this, n2 = e2[t2];
              for (; t2 > 0; ) {
                const i2 = t2 - 1 >> 1, s2 = e2[i2];
                if (r2(n2, s2) >= 0) break;
                e2[t2] = s2, t2 = i2;
              }
              e2[t2] = n2;
            }
            _down(t2) {
              const { data: e2, compare: r2 } = this, n2 = this.length >> 1, i2 = e2[t2];
              for (; t2 < n2; ) {
                let n3 = 1 + (t2 << 1);
                const s2 = n3 + 1;
                if (s2 < this.length && r2(e2[s2], e2[n3]) < 0 && (n3 = s2), r2(e2[n3], i2) >= 0) break;
                e2[t2] = e2[n3], t2 = n3;
              }
              e2[t2] = i2;
            }
          }
          var Cn = 8192;
          function Fn(t2, e2) {
            return e2.dist - t2.dist;
          }
          const Dn = 100, Ln = 50;
          function Rn(t2) {
            const e2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
            if (e2.length !== t2.length) return false;
            for (let r2 = 0; r2 < e2.length; r2++) if (e2[r2] !== t2[r2]) return false;
            return true;
          }
          function On(t2) {
            return t2[1] - t2[0] + 1;
          }
          function Un(t2, e2) {
            const r2 = t2[1] >= t2[0] && t2[1] < e2;
            return r2 || console.warn("Distance Expression: Index is out of range"), r2;
          }
          function Nn(t2, e2) {
            if (t2[0] > t2[1]) return [null, null];
            const r2 = On(t2);
            if (e2) {
              if (2 === r2) return [t2, null];
              const e3 = Math.floor(r2 / 2);
              return [[t2[0], t2[0] + e3], [t2[0] + e3, t2[1]]];
            }
            {
              if (1 === r2) return [t2, null];
              const e3 = Math.floor(r2 / 2) - 1;
              return [[t2[0], t2[0] + e3], [t2[0] + e3 + 1, t2[1]]];
            }
          }
          function jn(t2, e2) {
            const r2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
            if (!Un(e2, t2.length)) return r2;
            for (let n2 = e2[0]; n2 <= e2[1]; ++n2) on2(r2, t2[n2]);
            return r2;
          }
          function $n(t2) {
            const e2 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
            for (let r2 = 0; r2 < t2.length; ++r2) for (let n2 = 0; n2 < t2[r2].length; ++n2) on2(e2, t2[r2][n2]);
            return e2;
          }
          function Gn(t2, e2, r2) {
            if (Rn(t2) || Rn(e2)) return NaN;
            let n2 = 0, i2 = 0;
            return t2[2] < e2[0] && (n2 = e2[0] - t2[2]), t2[0] > e2[2] && (n2 = t2[0] - e2[2]), t2[1] > e2[3] && (i2 = t2[1] - e2[3]), t2[3] < e2[1] && (i2 = e2[1] - t2[3]), r2.distance([0, 0], [n2, i2]);
          }
          function qn(t2) {
            return 360 * t2 - 180;
          }
          function Hn(t2) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t2) * Math.PI / 180)) - 90;
          }
          function Xn(t2, e2) {
            const r2 = Math.pow(2, e2.z), n2 = (t2.y / Cn + e2.y) / r2;
            return [qn((t2.x / Cn + e2.x) / r2), Hn(n2)];
          }
          function Zn(t2, e2) {
            const r2 = [];
            for (let n2 = 0; n2 < t2.length; ++n2) r2.push(Xn(t2[n2], e2));
            return r2;
          }
          function Wn(t2, e2, r2) {
            const n2 = r2.pointOnLine(e2, t2).point;
            return r2.distance(t2, n2);
          }
          function Yn(t2, e2, r2, n2, i2) {
            const s2 = r2.slice(n2[0], n2[1] + 1);
            let o2 = 1 / 0;
            for (let r3 = e2[0]; r3 <= e2[1]; ++r3) if (0 === (o2 = Math.min(o2, Wn(t2[r3], s2, i2)))) return 0;
            return o2;
          }
          function Kn(t2, e2, r2, n2, i2) {
            const s2 = Math.min(i2.pointToSegmentDistance(t2, r2, n2), i2.pointToSegmentDistance(e2, r2, n2)), o2 = Math.min(i2.pointToSegmentDistance(r2, t2, e2), i2.pointToSegmentDistance(n2, t2, e2));
            return Math.min(s2, o2);
          }
          function Jn(t2, e2, r2, n2, i2) {
            if (!Un(e2, t2.length) || !Un(n2, r2.length)) return NaN;
            let s2 = 1 / 0;
            for (let o2 = e2[0]; o2 < e2[1]; ++o2) for (let e3 = n2[0]; e3 < n2[1]; ++e3) {
              if (hn(t2[o2], t2[o2 + 1], r2[e3], r2[e3 + 1])) return 0;
              s2 = Math.min(s2, Kn(t2[o2], t2[o2 + 1], r2[e3], r2[e3 + 1], i2));
            }
            return s2;
          }
          function Qn(t2, e2, r2, n2, i2) {
            if (!Un(e2, t2.length) || !Un(n2, r2.length)) return NaN;
            let s2 = 1 / 0;
            for (let o2 = e2[0]; o2 <= e2[1]; ++o2) for (let e3 = n2[0]; e3 <= n2[1]; ++e3) if (0 === (s2 = Math.min(s2, i2.distance(t2[o2], r2[e3])))) return s2;
            return s2;
          }
          function ti(t2, e2, r2) {
            if (un(t2, e2, true)) return 0;
            let n2 = 1 / 0;
            for (const i2 of e2) {
              const e3 = i2.length;
              if (e3 < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
              if (i2[0] !== i2[e3 - 1] && 0 === (n2 = Math.min(n2, r2.pointToSegmentDistance(t2, i2[e3 - 1], i2[0])))) return n2;
              if (0 === (n2 = Math.min(n2, Wn(t2, i2, r2)))) return n2;
            }
            return n2;
          }
          function ei(t2, e2, r2, n2) {
            if (!Un(e2, t2.length)) return NaN;
            for (let n3 = e2[0]; n3 <= e2[1]; ++n3) if (un(t2[n3], r2, true)) return 0;
            let i2 = 1 / 0;
            for (let s2 = e2[0]; s2 < e2[1]; ++s2) for (const e3 of r2) for (let r3 = 0, o2 = e3.length, a2 = o2 - 1; r3 < o2; a2 = r3++) {
              if (hn(t2[s2], t2[s2 + 1], e3[a2], e3[r3])) return 0;
              i2 = Math.min(i2, Kn(t2[s2], t2[s2 + 1], e3[a2], e3[r3], n2));
            }
            return i2;
          }
          function ri(t2, e2) {
            for (const r2 of t2) for (let t3 = 0; t3 <= r2.length - 1; ++t3) if (un(r2[t3], e2, true)) return true;
            return false;
          }
          function ni(t2, e2, r2, n2 = 1 / 0) {
            const i2 = $n(t2), s2 = $n(e2);
            if (n2 !== 1 / 0 && Gn(i2, s2, r2) >= n2) return n2;
            if (an(i2, s2)) {
              if (ri(t2, e2)) return 0;
            } else if (ri(e2, t2)) return 0;
            let o2 = n2;
            for (const n3 of t2) for (let t3 = 0, i3 = n3.length, s3 = i3 - 1; t3 < i3; s3 = t3++) for (const i4 of e2) for (let e3 = 0, a2 = i4.length, l2 = a2 - 1; e3 < a2; l2 = e3++) {
              if (hn(n3[s3], n3[t3], i4[l2], i4[e3])) return 0;
              o2 = Math.min(o2, Kn(n3[s3], n3[t3], i4[l2], i4[e3], r2));
            }
            return o2;
          }
          function ii(t2, e2, r2, n2, i2, s2, o2) {
            if (null === s2 || null === o2) return;
            const a2 = Gn(jn(n2, s2), jn(i2, o2), r2);
            a2 < e2 && t2.push({ dist: a2, range1: s2, range2: o2 });
          }
          function si(t2, e2, r2, n2, i2 = 1 / 0) {
            let s2 = Math.min(n2.distance(t2[0], r2[0][0]), i2);
            if (0 === s2) return s2;
            const o2 = new Vn([{ dist: 0, range1: [0, t2.length - 1], range2: [0, 0] }], Fn), a2 = e2 ? Ln : Dn, l2 = $n(r2);
            for (; o2.length; ) {
              const i3 = o2.pop();
              if (i3.dist >= s2) continue;
              const u2 = i3.range1;
              if (On(u2) <= a2) {
                if (!Un(u2, t2.length)) return NaN;
                if (e2) {
                  const e3 = ei(t2, u2, r2, n2);
                  if (0 === (s2 = Math.min(s2, e3))) return s2;
                } else for (let e3 = u2[0]; e3 <= u2[1]; ++e3) {
                  const i4 = ti(t2[e3], r2, n2);
                  if (0 === (s2 = Math.min(s2, i4))) return s2;
                }
              } else {
                const r3 = Nn(u2, e2);
                if (null !== r3[0]) {
                  const e3 = Gn(jn(t2, r3[0]), l2, n2);
                  e3 < s2 && o2.push({ dist: e3, range1: r3[0], range2: [0, 0] });
                }
                if (null !== r3[1]) {
                  const e3 = Gn(jn(t2, r3[1]), l2, n2);
                  e3 < s2 && o2.push({ dist: e3, range1: r3[1], range2: [0, 0] });
                }
              }
            }
            return s2;
          }
          function oi(t2, e2, r2, n2, i2, s2 = 1 / 0) {
            let o2 = Math.min(s2, i2.distance(t2[0], r2[0]));
            if (0 === o2) return o2;
            const a2 = new Vn([{ dist: 0, range1: [0, t2.length - 1], range2: [0, r2.length - 1] }], Fn), l2 = e2 ? Ln : Dn, u2 = n2 ? Ln : Dn;
            for (; a2.length; ) {
              const s3 = a2.pop();
              if (s3.dist >= o2) continue;
              const c2 = s3.range1, h3 = s3.range2;
              if (On(c2) <= l2 && On(h3) <= u2) {
                if (!Un(c2, t2.length) || !Un(h3, r2.length)) return NaN;
                if (e2 && n2 ? o2 = Math.min(o2, Jn(t2, c2, r2, h3, i2)) : e2 || n2 ? e2 && !n2 ? o2 = Math.min(o2, Yn(r2, h3, t2, c2, i2)) : !e2 && n2 && (o2 = Math.min(o2, Yn(t2, c2, r2, h3, i2))) : o2 = Math.min(o2, Qn(t2, c2, r2, h3, i2)), 0 === o2) return o2;
              } else {
                const s4 = Nn(c2, e2), l3 = Nn(h3, n2);
                ii(a2, o2, i2, t2, r2, s4[0], l3[0]), ii(a2, o2, i2, t2, r2, s4[0], l3[1]), ii(a2, o2, i2, t2, r2, s4[1], l3[0]), ii(a2, o2, i2, t2, r2, s4[1], l3[1]);
              }
            }
            return o2;
          }
          function ai(t2, e2, r2, n2, i2 = 1 / 0) {
            let s2 = i2;
            const o2 = jn(t2, [0, t2.length - 1]);
            for (const i3 of r2) if (!(s2 !== 1 / 0 && Gn(o2, jn(i3, [0, i3.length - 1]), n2) >= s2) && (s2 = Math.min(s2, oi(t2, e2, i3, true, n2, s2)), 0 === s2)) return s2;
            return s2;
          }
          function li(t2, e2, r2, n2, i2 = 1 / 0) {
            let s2 = i2;
            const o2 = jn(t2, [0, t2.length - 1]);
            for (const i3 of r2) {
              if (s2 !== 1 / 0 && Gn(o2, $n(i3), n2) >= s2) continue;
              const r3 = si(t2, e2, i3, n2, s2);
              if (isNaN(r3)) return r3;
              if (0 === (s2 = Math.min(s2, r3))) return s2;
            }
            return s2;
          }
          function ui(t2) {
            return "Point" === t2 || "MultiPoint" === t2 || "LineString" === t2 || "MultiLineString" === t2 || "Polygon" === t2 || "MultiPolygon" === t2;
          }
          class ci {
            constructor(t2, e2) {
              this.type = yr, this.geojson = t2, this.geometries = e2;
            }
            static parse(t2, e2) {
              if (2 !== t2.length) return e2.error(`'distance' expression requires either one argument, but found ' ${t2.length - 1} instead.`);
              if (Rr(t2[1])) {
                const e3 = t2[1];
                if ("FeatureCollection" === e3.type) {
                  for (let t3 = 0; t3 < e3.features.length; ++t3) if (ui(e3.features[t3].geometry.type)) return new ci(e3, e3.features[t3].geometry);
                } else if ("Feature" === e3.type) {
                  if (ui(e3.geometry.type)) return new ci(e3, e3.geometry);
                } else if (ui(e3.type)) return new ci(e3, e3);
              }
              return e2.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
            }
            evaluate(t2) {
              const e2 = t2.geometry(), r2 = t2.canonicalID();
              if (null != e2 && null != r2) {
                if ("Point" === t2.geometryType()) return function(t3, e3, r3) {
                  const n2 = [];
                  for (const r4 of t3) for (const t4 of r4) n2.push(Xn(t4, e3));
                  const i2 = new Pn(n2[0][1], "meters");
                  return "Point" === r3.type || "MultiPoint" === r3.type || "LineString" === r3.type ? oi(n2, false, "Point" === r3.type ? [r3.coordinates] : r3.coordinates, "LineString" === r3.type, i2) : "MultiLineString" === r3.type ? ai(n2, false, r3.coordinates, i2) : "Polygon" === r3.type || "MultiPolygon" === r3.type ? li(n2, false, "Polygon" === r3.type ? [r3.coordinates] : r3.coordinates, i2) : null;
                }(e2, r2, this.geometries);
                if ("LineString" === t2.geometryType()) return function(t3, e3, r3) {
                  const n2 = [];
                  for (const r4 of t3) {
                    const t4 = [];
                    for (const n3 of r4) t4.push(Xn(n3, e3));
                    n2.push(t4);
                  }
                  const i2 = new Pn(n2[0][0][1], "meters");
                  if ("Point" === r3.type || "MultiPoint" === r3.type || "LineString" === r3.type) return ai("Point" === r3.type ? [r3.coordinates] : r3.coordinates, "LineString" === r3.type, n2, i2);
                  if ("MultiLineString" === r3.type) {
                    let t4 = 1 / 0;
                    for (let e4 = 0; e4 < r3.coordinates.length; e4++) {
                      const s2 = ai(r3.coordinates[e4], true, n2, i2, t4);
                      if (isNaN(s2)) return s2;
                      if (0 === (t4 = Math.min(t4, s2))) return t4;
                    }
                    return t4;
                  }
                  if ("Polygon" === r3.type || "MultiPolygon" === r3.type) {
                    let t4 = 1 / 0;
                    for (let e4 = 0; e4 < n2.length; e4++) {
                      const s2 = li(n2[e4], true, "Polygon" === r3.type ? [r3.coordinates] : r3.coordinates, i2, t4);
                      if (isNaN(s2)) return s2;
                      if (0 === (t4 = Math.min(t4, s2))) return t4;
                    }
                    return t4;
                  }
                  return null;
                }(e2, r2, this.geometries);
                if ("Polygon" === t2.geometryType()) return function(t3, e3, r3) {
                  const n2 = [];
                  for (const r4 of function(t4, e4) {
                    const r5 = t4.length;
                    if (r5 <= 1) return [t4];
                    const n3 = [];
                    let i3, s2;
                    for (let e5 = 0; e5 < r5; e5++) {
                      const r6 = sn(t4[e5]);
                      0 !== r6 && (t4[e5].area = Math.abs(r6), void 0 === s2 && (s2 = r6 < 0), s2 === r6 < 0 ? (i3 && n3.push(i3), i3 = [t4[e5]]) : i3.push(t4[e5]));
                    }
                    return i3 && n3.push(i3), n3;
                  }(t3)) {
                    const t4 = [];
                    for (let n3 = 0; n3 < r4.length; ++n3) t4.push(Zn(r4[n3], e3));
                    n2.push(t4);
                  }
                  const i2 = new Pn(n2[0][0][0][1], "meters");
                  if ("Point" === r3.type || "MultiPoint" === r3.type || "LineString" === r3.type) return li("Point" === r3.type ? [r3.coordinates] : r3.coordinates, "LineString" === r3.type, n2, i2);
                  if ("MultiLineString" === r3.type) {
                    let t4 = 1 / 0;
                    for (let e4 = 0; e4 < r3.coordinates.length; e4++) {
                      const s2 = li(r3.coordinates[e4], true, n2, i2, t4);
                      if (isNaN(s2)) return s2;
                      if (0 === (t4 = Math.min(t4, s2))) return t4;
                    }
                    return t4;
                  }
                  return "Polygon" === r3.type || "MultiPolygon" === r3.type ? function(t4, e4, r4) {
                    let n3 = 1 / 0;
                    for (const i3 of t4) for (const t5 of e4) {
                      const e5 = ni(i3, t5, r4, n3);
                      if (isNaN(e5)) return e5;
                      if (0 === (n3 = Math.min(n3, e5))) return n3;
                    }
                    return n3;
                  }("Polygon" === r3.type ? [r3.coordinates] : r3.coordinates, n2, i2) : null;
                }(e2, r2, this.geometries);
                console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
              } else console.warn("Distance Expression: requirs valid feature and canonical information.");
              return null;
            }
            eachChild() {
            }
            outputDefined() {
              return true;
            }
            serialize() {
              return ["distance", this.geojson];
            }
          }
          function hi(t2) {
            if (t2 instanceof Jr) {
              if ("get" === t2.name && 1 === t2.args.length) return false;
              if ("feature-state" === t2.name) return false;
              if ("has" === t2.name && 1 === t2.args.length) return false;
              if ("properties" === t2.name || "geometry-type" === t2.name || "id" === t2.name) return false;
              if (/^filter-/.test(t2.name)) return false;
            }
            if (t2 instanceof Mn) return false;
            if (t2 instanceof ci) return false;
            if (t2 instanceof xi) return t2.featureConstant;
            let e2 = true;
            return t2.eachChild((t3) => {
              e2 && !hi(t3) && (e2 = false);
            }), e2;
          }
          function pi(t2) {
            if (t2 instanceof Jr && "feature-state" === t2.name) return false;
            let e2 = true;
            return t2.eachChild((t3) => {
              e2 && !pi(t3) && (e2 = false);
            }), e2;
          }
          function fi(t2) {
            if (t2 instanceof xi) return /* @__PURE__ */ new Set([t2.key]);
            let e2 = /* @__PURE__ */ new Set();
            return t2.eachChild((t3) => {
              e2 = /* @__PURE__ */ new Set([...e2, ...fi(t3)]);
            }), e2;
          }
          function di(t2, e2) {
            if (t2 instanceof Jr && e2.indexOf(t2.name) >= 0) return false;
            let r2 = true;
            return t2.eachChild((t3) => {
              r2 && !di(t3, e2) && (r2 = false);
            }), r2;
          }
          function mi(t2, e2, r2) {
            return [t2, e2, r2].filter(Boolean).join("");
          }
          function yi(t2, e2) {
            switch (t2) {
              case "string":
                return Ur(e2);
              case "number":
                return +e2;
              case "boolean":
                return !!e2;
              case "color":
                return sr.parse(e2);
              case "formatted":
                return Cr.fromString(Ur(e2));
              case "resolvedImage":
                return Dr.build(Ur(e2));
            }
            return e2;
          }
          function gi(t2, e2, r2, n2) {
            return void 0 !== n2 && (t2 = n2 * Math.round(t2 / n2)), void 0 !== e2 && t2 < e2 && (t2 = e2), void 0 !== r2 && t2 > r2 && (t2 = r2), t2;
          }
          class xi {
            constructor(t2, e2, r2, n2 = false) {
              this.type = t2, this.key = e2, this.scope = r2, this.featureConstant = n2;
            }
            static parse(t2, e2) {
              let r2 = e2.expectedType;
              if (null == r2 && (r2 = wr), t2.length < 2 || t2.length > 3) return e2.error("Invalid number of arguments for 'config' expression.");
              const n2 = e2.parse(t2[1], 1);
              if (!(n2 instanceof Nr)) return e2.error("Key name of 'config' expression must be a string literal.");
              let i2, s2 = true;
              const o2 = Ur(n2.value);
              if (t2.length >= 3) {
                const r3 = e2.parse(t2[2], 2);
                if (!(r3 instanceof Nr)) return e2.error("Scope of 'config' expression must be a string literal.");
                i2 = Ur(r3.value);
              }
              if (e2.options) {
                const t3 = mi(o2, i2, e2._scope), r3 = e2.options.get(t3);
                r3 && (s2 = hi(r3.value || r3.default));
              }
              return new xi(r2, o2, i2, s2);
            }
            evaluate(t2) {
              const e2 = mi(this.key, this.scope, t2.scope), r2 = t2.getConfig(e2);
              if (!r2) return null;
              const { type: n2, value: i2, values: s2, minValue: o2, maxValue: a2, stepValue: l2 } = r2, u2 = r2.default.evaluate(t2);
              let c2 = u2;
              if (i2) {
                const e3 = t2.scope;
                t2.scope = (e3 || "").split("").slice(1).join(""), c2 = i2.evaluate(t2), t2.scope = e3;
              }
              return n2 && (c2 = yi(n2, c2)), void 0 === c2 || void 0 === o2 && void 0 === a2 && void 0 === l2 || ("number" == typeof c2 ? c2 = gi(c2, o2, a2, l2) : Array.isArray(c2) && (c2 = c2.map((t3) => "number" == typeof t3 ? gi(t3, o2, a2, l2) : t3))), void 0 !== i2 && void 0 !== c2 && s2 && !s2.includes(c2) && (c2 = u2, n2 && (c2 = yi(n2, c2))), (n2 && n2 !== this.type || void 0 !== c2 && !Tr(Or(c2), this.type)) && (c2 = yi(this.type.kind, c2)), c2;
            }
            eachChild() {
            }
            outputDefined() {
              return false;
            }
            serialize() {
              const t2 = ["config", this.key];
              return this.scope && t2.concat(this.scope), t2;
            }
          }
          class vi {
            constructor(t2, e2) {
              this.type = e2.type, this.name = t2, this.boundExpression = e2;
            }
            static parse(t2, e2) {
              if (2 !== t2.length || "string" != typeof t2[1]) return e2.error("'var' expression requires exactly one string literal argument.");
              const r2 = t2[1];
              return e2.scope.has(r2) ? new vi(r2, e2.scope.get(r2)) : e2.error(`Unknown variable "${r2}". Make sure "${r2}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(t2) {
              return this.boundExpression.evaluate(t2);
            }
            eachChild() {
            }
            outputDefined() {
              return false;
            }
            serialize() {
              return ["var", this.name];
            }
          }
          class bi {
            constructor(t2, e2 = [], r2, n2 = new dr(), i2 = [], s2, o2) {
              this.registry = t2, this.path = e2, this.key = e2.map((t3) => "string" == typeof t3 ? `['${t3}']` : `[${t3}]`).join(""), this.scope = n2, this.errors = i2, this.expectedType = r2, this._scope = s2, this.options = o2;
            }
            parse(t2, e2, r2, n2, i2 = {}) {
              return e2 || r2 ? this.concat(e2, null, r2, n2)._parse(t2, i2) : this._parse(t2, i2);
            }
            parseObjectValue(t2, e2, r2, n2, i2, s2 = {}) {
              return this.concat(e2, r2, n2, i2)._parse(t2, s2);
            }
            _parse(t2, e2) {
              function r2(t3, e3, r3) {
                return "assert" === r3 ? new Gr(e3, [t3]) : "coerce" === r3 ? new Wr(e3, [t3]) : t3;
              }
              if (null !== t2 && "string" != typeof t2 && "boolean" != typeof t2 && "number" != typeof t2 || (t2 = ["literal", t2]), Array.isArray(t2)) {
                if (0 === t2.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                const n2 = "string" == typeof t2[0] ? this.registry[t2[0]] : void 0;
                if (n2) {
                  let i2 = n2.parse(t2, this);
                  if (!i2) return null;
                  if (this.expectedType) {
                    const t3 = this.expectedType, n3 = i2.type;
                    if ("string" !== t3.kind && "number" !== t3.kind && "boolean" !== t3.kind && "object" !== t3.kind && "array" !== t3.kind || "value" !== n3.kind) if ("color" !== t3.kind && "formatted" !== t3.kind && "resolvedImage" !== t3.kind || "value" !== n3.kind && "string" !== n3.kind) {
                      if (this.checkSubtype(t3, n3)) return null;
                    } else i2 = r2(i2, t3, e2.typeAnnotation || "coerce");
                    else i2 = r2(i2, t3, e2.typeAnnotation || "assert");
                  }
                  if (!(i2 instanceof Nr) && "resolvedImage" !== i2.type.kind && wi(i2)) {
                    const t3 = new Kr(this._scope, this.options);
                    try {
                      i2 = new Nr(i2.type, i2.evaluate(t3));
                    } catch (t4) {
                      return this.error(t4.message), null;
                    }
                  }
                  return i2;
                }
                return Wr.parse(["to-array", t2], this);
              }
              return this.error(void 0 === t2 ? "'undefined' value invalid. Use null instead." : "object" == typeof t2 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof t2} instead.`);
            }
            concat(t2, e2, r2, n2) {
              let i2 = "number" == typeof t2 ? this.path.concat(t2) : this.path;
              i2 = "string" == typeof e2 ? i2.concat(e2) : i2;
              const s2 = n2 ? this.scope.concat(n2) : this.scope;
              return new bi(this.registry, i2, r2 || null, s2, this.errors, this._scope, this.options);
            }
            error(t2, ...e2) {
              const r2 = `${this.key}${e2.map((t3) => `[${t3}]`).join("")}`;
              this.errors.push(new fr(r2, t2));
            }
            checkSubtype(t2, e2) {
              const r2 = kr(t2, e2);
              return r2 && this.error(r2), r2;
            }
          }
          function wi(t2) {
            if (t2 instanceof vi) return wi(t2.boundExpression);
            if (t2 instanceof Jr && "error" === t2.name) return false;
            if (t2 instanceof tn) return false;
            if (t2 instanceof Mn) return false;
            if (t2 instanceof ci) return false;
            if (t2 instanceof xi) return false;
            const e2 = t2 instanceof Wr || t2 instanceof Gr;
            let r2 = true;
            return t2.eachChild((t3) => {
              r2 = e2 ? r2 && wi(t3) : r2 && t3 instanceof Nr;
            }), !!r2 && hi(t2) && di(t2, ["zoom", "heatmap-density", "worldview", "line-progress", "raster-value", "sky-radial-progress", "accumulated", "is-supported-script", "pitch", "distance-from-center", "measure-light", "raster-particle-speed"]);
          }
          function _i(t2, e2) {
            const r2 = t2.length - 1;
            let n2, i2, s2 = 0, o2 = r2, a2 = 0;
            for (; s2 <= o2; ) if (a2 = Math.floor((s2 + o2) / 2), n2 = t2[a2], i2 = t2[a2 + 1], n2 <= e2) {
              if (a2 === r2 || e2 < i2) return a2;
              s2 = a2 + 1;
            } else {
              if (!(n2 > e2)) throw new jr("Input is not a number.");
              o2 = a2 - 1;
            }
            return 0;
          }
          class Ai {
            constructor(t2, e2, r2) {
              this.type = t2, this.input = e2, this.labels = [], this.outputs = [];
              for (const [t3, e3] of r2) this.labels.push(t3), this.outputs.push(e3);
            }
            static parse(t2, e2) {
              if (t2.length - 1 < 4) return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
              if ((t2.length - 1) % 2 != 0) return e2.error("Expected an even number of arguments.");
              const r2 = e2.parse(t2[1], 1, yr);
              if (!r2) return null;
              const n2 = [];
              let i2 = null;
              e2.expectedType && "value" !== e2.expectedType.kind && (i2 = e2.expectedType);
              for (let r3 = 1; r3 < t2.length; r3 += 2) {
                const s2 = 1 === r3 ? -1 / 0 : t2[r3], o2 = t2[r3 + 1], a2 = r3, l2 = r3 + 1;
                if ("number" != typeof s2) return e2.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a2);
                if (n2.length && n2[n2.length - 1][0] >= s2) return e2.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a2);
                const u2 = e2.parse(o2, l2, i2);
                if (!u2) return null;
                i2 = i2 || u2.type, n2.push([s2, u2]);
              }
              return new Ai(i2, r2, n2);
            }
            evaluate(t2) {
              const e2 = this.labels, r2 = this.outputs;
              if (1 === e2.length) return r2[0].evaluate(t2);
              const n2 = this.input.evaluate(t2);
              if (n2 <= e2[0]) return r2[0].evaluate(t2);
              const i2 = e2.length;
              return n2 >= e2[i2 - 1] ? r2[i2 - 1].evaluate(t2) : r2[_i(e2, n2)].evaluate(t2);
            }
            eachChild(t2) {
              t2(this.input);
              for (const e2 of this.outputs) t2(e2);
            }
            outputDefined() {
              return this.outputs.every((t2) => t2.outputDefined());
            }
            serialize() {
              const t2 = ["step", this.input.serialize()];
              for (let e2 = 0; e2 < this.labels.length; e2++) e2 > 0 && t2.push(this.labels[e2]), t2.push(this.outputs[e2].serialize());
              return t2;
            }
          }
          const Mi = 0.95047, Ii = 1.08883, Si = 4 / 29, zi = 6 / 29, ki = 3 * zi * zi, Pi = zi * zi * zi, Ei = Math.PI / 180, Ti = 180 / Math.PI;
          function Bi(t2) {
            return t2 > Pi ? Math.pow(t2, 1 / 3) : t2 / ki + Si;
          }
          function Vi(t2) {
            return t2 > zi ? t2 * t2 * t2 : ki * (t2 - Si);
          }
          function Ci(t2) {
            return 255 * (t2 <= 31308e-7 ? 12.92 * t2 : 1.055 * Math.pow(t2, 1 / 2.4) - 0.055);
          }
          function Fi(t2) {
            return (t2 /= 255) <= 0.04045 ? t2 / 12.92 : Math.pow((t2 + 0.055) / 1.055, 2.4);
          }
          function Di(t2) {
            const e2 = Fi(t2.r), r2 = Fi(t2.g), n2 = Fi(t2.b), i2 = Bi((0.4124564 * e2 + 0.3575761 * r2 + 0.1804375 * n2) / Mi), s2 = Bi((0.2126729 * e2 + 0.7151522 * r2 + 0.072175 * n2) / 1);
            return { l: 116 * s2 - 16, a: 500 * (i2 - s2), b: 200 * (s2 - Bi((0.0193339 * e2 + 0.119192 * r2 + 0.9503041 * n2) / Ii)), alpha: t2.a };
          }
          function Li(t2) {
            let e2 = (t2.l + 16) / 116, r2 = isNaN(t2.a) ? e2 : e2 + t2.a / 500, n2 = isNaN(t2.b) ? e2 : e2 - t2.b / 200;
            return e2 = 1 * Vi(e2), r2 = Mi * Vi(r2), n2 = Ii * Vi(n2), new sr(Ci(3.2404542 * r2 - 1.5371385 * e2 - 0.4985314 * n2), Ci(-0.969266 * r2 + 1.8760108 * e2 + 0.041556 * n2), Ci(0.0556434 * r2 - 0.2040259 * e2 + 1.0572252 * n2), t2.alpha);
          }
          function Ri(t2, e2, r2) {
            const n2 = e2 - t2;
            return t2 + r2 * (n2 > 180 || n2 < -180 ? n2 - 360 * Math.round(n2 / 360) : n2);
          }
          const Oi = { forward: Di, reverse: Li, interpolate: function(t2, e2, r2) {
            return { l: ur(t2.l, e2.l, r2), a: ur(t2.a, e2.a, r2), b: ur(t2.b, e2.b, r2), alpha: ur(t2.alpha, e2.alpha, r2) };
          } }, Ui = { forward: function(t2) {
            const { l: e2, a: r2, b: n2 } = Di(t2), i2 = Math.atan2(n2, r2) * Ti;
            return { h: i2 < 0 ? i2 + 360 : i2, c: Math.sqrt(r2 * r2 + n2 * n2), l: e2, alpha: t2.a };
          }, reverse: function(t2) {
            const e2 = t2.h * Ei, r2 = t2.c;
            return Li({ l: t2.l, a: Math.cos(e2) * r2, b: Math.sin(e2) * r2, alpha: t2.alpha });
          }, interpolate: function(t2, e2, r2) {
            return { h: Ri(t2.h, e2.h, r2), c: ur(t2.c, e2.c, r2), l: ur(t2.l, e2.l, r2), alpha: ur(t2.alpha, e2.alpha, r2) };
          } };
          var Ni = Object.freeze({ __proto__: null, hcl: Ui, lab: Oi });
          class ji {
            constructor(t2, e2, r2, n2, i2) {
              this.type = t2, this.operator = e2, this.interpolation = r2, this.input = n2, this.labels = [], this.outputs = [];
              for (const [t3, e3] of i2) this.labels.push(t3), this.outputs.push(e3);
            }
            static interpolationFactor(t2, e2, r2, n2) {
              let i2 = 0;
              if ("exponential" === t2.name) i2 = $i(e2, t2.base, r2, n2);
              else if ("linear" === t2.name) i2 = $i(e2, 1, r2, n2);
              else if ("cubic-bezier" === t2.name) {
                const s2 = t2.controlPoints;
                i2 = new xt(s2[0], s2[1], s2[2], s2[3]).solve($i(e2, 1, r2, n2));
              }
              return i2;
            }
            static parse(t2, e2) {
              let [r2, n2, i2, ...s2] = t2;
              if (!Array.isArray(n2) || 0 === n2.length) return e2.error("Expected an interpolation type expression.", 1);
              if ("linear" === n2[0]) n2 = { name: "linear" };
              else if ("exponential" === n2[0]) {
                const t3 = n2[1];
                if ("number" != typeof t3) return e2.error("Exponential interpolation requires a numeric base.", 1, 1);
                n2 = { name: "exponential", base: t3 };
              } else {
                if ("cubic-bezier" !== n2[0]) return e2.error(`Unknown interpolation type ${String(n2[0])}`, 1, 0);
                {
                  const t3 = n2.slice(1);
                  if (4 !== t3.length || t3.some((t4) => "number" != typeof t4 || t4 < 0 || t4 > 1)) return e2.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                  n2 = { name: "cubic-bezier", controlPoints: t3 };
                }
              }
              if (t2.length - 1 < 4) return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
              if (t2.length - 1 > 3 && (t2.length - 1) % 2 != 0) return e2.error("Expected an even number of arguments.");
              if (i2 = e2.parse(i2, 2, yr), !i2) return null;
              const o2 = [];
              let a2 = null;
              "interpolate-hcl" === r2 || "interpolate-lab" === r2 ? a2 = vr : e2.expectedType && "value" !== e2.expectedType.kind && (a2 = e2.expectedType);
              for (let t3 = 0; t3 < s2.length; t3 += 2) {
                const r3 = s2[t3], n3 = s2[t3 + 1], i3 = t3 + 3, l2 = t3 + 4;
                if ("number" != typeof r3) return e2.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i3);
                if (o2.length && o2[o2.length - 1][0] >= r3) return e2.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i3);
                const u2 = e2.parse(n3, l2, a2);
                if (!u2) return null;
                a2 = a2 || u2.type, o2.push([r3, u2]);
              }
              return "number" === a2.kind || "color" === a2.kind || "array" === a2.kind && "number" === a2.itemType.kind && "number" == typeof a2.N ? new ji(a2, r2, n2, i2, o2) : e2.error(`Type ${Sr(a2)} is not interpolatable.`);
            }
            evaluate(t2) {
              const e2 = this.labels, r2 = this.outputs;
              if (1 === e2.length) return r2[0].evaluate(t2);
              const n2 = this.input.evaluate(t2);
              if (n2 <= e2[0]) return r2[0].evaluate(t2);
              const i2 = e2.length;
              if (n2 >= e2[i2 - 1]) return r2[i2 - 1].evaluate(t2);
              const s2 = _i(e2, n2), o2 = ji.interpolationFactor(this.interpolation, n2, e2[s2], e2[s2 + 1]), a2 = r2[s2].evaluate(t2), l2 = r2[s2 + 1].evaluate(t2);
              return "interpolate" === this.operator ? hr[this.type.kind.toLowerCase()](a2, l2, o2) : "interpolate-hcl" === this.operator ? Ui.reverse(Ui.interpolate(Ui.forward(a2), Ui.forward(l2), o2)) : Oi.reverse(Oi.interpolate(Oi.forward(a2), Oi.forward(l2), o2));
            }
            eachChild(t2) {
              t2(this.input);
              for (const e2 of this.outputs) t2(e2);
            }
            outputDefined() {
              return this.outputs.every((t2) => t2.outputDefined());
            }
            serialize() {
              let t2;
              t2 = "linear" === this.interpolation.name ? ["linear"] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? ["linear"] : ["exponential", this.interpolation.base] : ["cubic-bezier", ...this.interpolation.controlPoints];
              const e2 = [this.operator, t2, this.input.serialize()];
              for (let t3 = 0; t3 < this.labels.length; t3++) e2.push(this.labels[t3], this.outputs[t3].serialize());
              return e2;
            }
          }
          function $i(t2, e2, r2, n2) {
            const i2 = n2 - r2, s2 = t2 - r2;
            return 0 === i2 ? 0 : 1 === e2 ? s2 / i2 : (Math.pow(e2, s2) - 1) / (Math.pow(e2, i2) - 1);
          }
          class Gi {
            constructor(t2, e2) {
              this.type = t2, this.args = e2;
            }
            static parse(t2, e2) {
              if (t2.length < 2) return e2.error("Expectected at least one argument.");
              let r2 = null;
              const n2 = e2.expectedType;
              n2 && "value" !== n2.kind && (r2 = n2);
              const i2 = [];
              for (const n3 of t2.slice(1)) {
                const t3 = e2.parse(n3, 1 + i2.length, r2, void 0, { typeAnnotation: "omit" });
                if (!t3) return null;
                r2 = r2 || t3.type, i2.push(t3);
              }
              const s2 = n2 && i2.some((t3) => kr(n2, t3.type));
              return new Gi(s2 ? wr : r2, i2);
            }
            evaluate(t2) {
              let e2, r2 = null, n2 = 0;
              for (const i2 of this.args) {
                if (n2++, r2 = i2.evaluate(t2), r2 && r2 instanceof Dr && !r2.available && (e2 || (e2 = r2), r2 = null, n2 === this.args.length)) return e2;
                if (null !== r2) break;
              }
              return r2;
            }
            eachChild(t2) {
              this.args.forEach(t2);
            }
            outputDefined() {
              return this.args.every((t2) => t2.outputDefined());
            }
            serialize() {
              const t2 = ["coalesce"];
              return this.eachChild((e2) => {
                t2.push(e2.serialize());
              }), t2;
            }
          }
          class qi {
            constructor(t2, e2) {
              this.type = e2.type, this.bindings = [].concat(t2), this.result = e2;
            }
            evaluate(t2) {
              return this.result.evaluate(t2);
            }
            eachChild(t2) {
              for (const e2 of this.bindings) t2(e2[1]);
              t2(this.result);
            }
            static parse(t2, e2) {
              if (t2.length < 4) return e2.error(`Expected at least 3 arguments, but found ${t2.length - 1} instead.`);
              const r2 = [];
              for (let n3 = 1; n3 < t2.length - 1; n3 += 2) {
                const i2 = t2[n3];
                if ("string" != typeof i2) return e2.error(`Expected string, but found ${typeof i2} instead.`, n3);
                if (/[^a-zA-Z0-9_]/.test(i2)) return e2.error("Variable names must contain only alphanumeric characters or '_'.", n3);
                const s2 = e2.parse(t2[n3 + 1], n3 + 1);
                if (!s2) return null;
                r2.push([i2, s2]);
              }
              const n2 = e2.parse(t2[t2.length - 1], t2.length - 1, e2.expectedType, r2);
              return n2 ? new qi(r2, n2) : null;
            }
            outputDefined() {
              return this.result.outputDefined();
            }
            serialize() {
              const t2 = ["let"];
              for (const [e2, r2] of this.bindings) t2.push(e2, r2.serialize());
              return t2.push(this.result.serialize()), t2;
            }
          }
          class Hi {
            constructor(t2, e2, r2) {
              this.type = t2, this.index = e2, this.input = r2;
            }
            static parse(t2, e2) {
              if (3 !== t2.length) return e2.error(`Expected 2 arguments, but found ${t2.length - 1} instead.`);
              const r2 = e2.parse(t2[1], 1, yr), n2 = e2.parse(t2[2], 2, Ir(e2.expectedType || wr));
              return r2 && n2 ? new Hi(n2.type.itemType, r2, n2) : null;
            }
            evaluate(t2) {
              const e2 = this.index.evaluate(t2), r2 = this.input.evaluate(t2);
              if (e2 < 0) throw new jr(`Array index out of bounds: ${e2} < 0.`);
              if (e2 >= r2.length) throw new jr(`Array index out of bounds: ${e2} > ${r2.length - 1}.`);
              if (e2 !== Math.floor(e2)) throw new jr(`Array index must be an integer, but found ${e2} instead. Use at-interpolated to retrieve interpolated result with a fractional index.`);
              return r2[e2];
            }
            eachChild(t2) {
              t2(this.index), t2(this.input);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              return ["at", this.index.serialize(), this.input.serialize()];
            }
          }
          class Xi {
            constructor(t2, e2, r2) {
              this.type = t2, this.index = e2, this.input = r2;
            }
            static parse(t2, e2) {
              if (3 !== t2.length) return e2.error(`Expected 2 arguments, but found ${t2.length - 1} instead.`);
              const r2 = e2.parse(t2[1], 1, yr), n2 = e2.parse(t2[2], 2, Ir(e2.expectedType || wr));
              return r2 && n2 ? new Xi(n2.type.itemType, r2, n2) : null;
            }
            evaluate(t2) {
              const e2 = this.index.evaluate(t2), r2 = this.input.evaluate(t2);
              if (e2 < 0) throw new jr(`Array index out of bounds: ${e2} < 0.`);
              if (e2 > r2.length - 1) throw new jr(`Array index out of bounds: ${e2} > ${r2.length - 1}.`);
              if (e2 === Math.floor(e2)) return r2[e2];
              const n2 = Math.floor(e2), i2 = Math.ceil(e2), s2 = r2[n2], o2 = r2[i2];
              if ("number" != typeof s2 || "number" != typeof o2) throw new jr(`Cannot interpolate between non-number values at index ${e2}.`);
              const a2 = e2 - n2;
              return s2 * (1 - a2) + o2 * a2;
            }
            eachChild(t2) {
              t2(this.index), t2(this.input);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              return ["at-interpolated", this.index.serialize(), this.input.serialize()];
            }
          }
          class Zi {
            constructor(t2, e2) {
              this.type = xr, this.needle = t2, this.haystack = e2;
            }
            static parse(t2, e2) {
              if (3 !== t2.length) return e2.error(`Expected 2 arguments, but found ${t2.length - 1} instead.`);
              const r2 = e2.parse(t2[1], 1, wr), n2 = e2.parse(t2[2], 2, wr);
              return r2 && n2 ? Pr(r2.type, [xr, gr, yr, mr, wr]) ? new Zi(r2, n2) : e2.error(`Expected first argument to be of type boolean, string, number or null, but found ${Sr(r2.type)} instead`) : null;
            }
            evaluate(t2) {
              const e2 = this.needle.evaluate(t2), r2 = this.haystack.evaluate(t2);
              if (null == r2) return false;
              if (!Er(e2, ["boolean", "string", "number", "null"])) throw new jr(`Expected first argument to be of type boolean, string, number or null, but found ${Sr(Or(e2))} instead.`);
              if (!Er(r2, ["string", "array"])) throw new jr(`Expected second argument to be of type array or string, but found ${Sr(Or(r2))} instead.`);
              return r2.indexOf(e2) >= 0;
            }
            eachChild(t2) {
              t2(this.needle), t2(this.haystack);
            }
            outputDefined() {
              return true;
            }
            serialize() {
              return ["in", this.needle.serialize(), this.haystack.serialize()];
            }
          }
          class Wi {
            constructor(t2, e2, r2) {
              this.type = yr, this.needle = t2, this.haystack = e2, this.fromIndex = r2;
            }
            static parse(t2, e2) {
              if (t2.length <= 2 || t2.length >= 5) return e2.error(`Expected 3 or 4 arguments, but found ${t2.length - 1} instead.`);
              const r2 = e2.parse(t2[1], 1, wr), n2 = e2.parse(t2[2], 2, wr);
              if (!r2 || !n2) return null;
              if (!Pr(r2.type, [xr, gr, yr, mr, wr])) return e2.error(`Expected first argument to be of type boolean, string, number or null, but found ${Sr(r2.type)} instead`);
              if (4 === t2.length) {
                const i2 = e2.parse(t2[3], 3, yr);
                return i2 ? new Wi(r2, n2, i2) : null;
              }
              return new Wi(r2, n2);
            }
            evaluate(t2) {
              const e2 = this.needle.evaluate(t2), r2 = this.haystack.evaluate(t2);
              if (!Er(e2, ["boolean", "string", "number", "null"])) throw new jr(`Expected first argument to be of type boolean, string, number or null, but found ${Sr(Or(e2))} instead.`);
              if (!Er(r2, ["string", "array"])) throw new jr(`Expected second argument to be of type array or string, but found ${Sr(Or(r2))} instead.`);
              if (this.fromIndex) {
                const n2 = this.fromIndex.evaluate(t2);
                return r2.indexOf(e2, n2);
              }
              return r2.indexOf(e2);
            }
            eachChild(t2) {
              t2(this.needle), t2(this.haystack), this.fromIndex && t2(this.fromIndex);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              if (null != this.fromIndex && void 0 !== this.fromIndex) {
                const t2 = this.fromIndex.serialize();
                return ["index-of", this.needle.serialize(), this.haystack.serialize(), t2];
              }
              return ["index-of", this.needle.serialize(), this.haystack.serialize()];
            }
          }
          class Yi {
            constructor(t2, e2, r2, n2, i2, s2) {
              this.inputType = t2, this.type = e2, this.input = r2, this.cases = n2, this.outputs = i2, this.otherwise = s2;
            }
            static parse(t2, e2) {
              if (t2.length < 5) return e2.error(`Expected at least 4 arguments, but found only ${t2.length - 1}.`);
              if (t2.length % 2 != 1) return e2.error("Expected an even number of arguments.");
              let r2, n2;
              e2.expectedType && "value" !== e2.expectedType.kind && (n2 = e2.expectedType);
              const i2 = {}, s2 = [];
              for (let o3 = 2; o3 < t2.length - 1; o3 += 2) {
                let a3 = t2[o3];
                const l2 = t2[o3 + 1];
                Array.isArray(a3) || (a3 = [a3]);
                const u2 = e2.concat(o3);
                if (0 === a3.length) return u2.error("Expected at least one branch label.");
                for (const t3 of a3) {
                  if ("number" != typeof t3 && "string" != typeof t3) return u2.error("Branch labels must be numbers or strings.");
                  if ("number" == typeof t3 && Math.abs(t3) > Number.MAX_SAFE_INTEGER) return u2.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                  if ("number" == typeof t3 && Math.floor(t3) !== t3) return u2.error("Numeric branch labels must be integer values.");
                  if (r2) {
                    if (u2.checkSubtype(r2, Or(t3))) return null;
                  } else r2 = Or(t3);
                  if (void 0 !== i2[String(t3)]) return u2.error("Branch labels must be unique.");
                  i2[String(t3)] = s2.length;
                }
                const c2 = e2.parse(l2, o3, n2);
                if (!c2) return null;
                n2 = n2 || c2.type, s2.push(c2);
              }
              const o2 = e2.parse(t2[1], 1, wr);
              if (!o2) return null;
              const a2 = e2.parse(t2[t2.length - 1], t2.length - 1, n2);
              return a2 ? "value" !== o2.type.kind && e2.concat(1).checkSubtype(r2, o2.type) ? null : new Yi(r2, n2, o2, i2, s2, a2) : null;
            }
            evaluate(t2) {
              const e2 = this.input.evaluate(t2);
              return (Tr(Or(e2), this.inputType) && this.outputs[this.cases[e2]] || this.otherwise).evaluate(t2);
            }
            eachChild(t2) {
              t2(this.input), this.outputs.forEach(t2), t2(this.otherwise);
            }
            outputDefined() {
              return this.outputs.every((t2) => t2.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
              const t2 = ["match", this.input.serialize()], e2 = Object.keys(this.cases).sort(), r2 = [], n2 = {};
              for (const t3 of e2) {
                const e3 = n2[this.cases[t3]];
                void 0 === e3 ? (n2[this.cases[t3]] = r2.length, r2.push([this.cases[t3], [t3]])) : r2[e3][1].push(t3);
              }
              const i2 = (t3) => "number" === this.inputType.kind ? Number(t3) : t3;
              for (const [e3, n3] of r2) t2.push(1 === n3.length ? i2(n3[0]) : n3.map(i2)), t2.push(this.outputs[e3].serialize());
              return t2.push(this.otherwise.serialize()), t2;
            }
          }
          class Ki {
            constructor(t2, e2, r2) {
              this.type = t2, this.branches = e2, this.otherwise = r2;
            }
            static parse(t2, e2) {
              if (t2.length < 4) return e2.error(`Expected at least 3 arguments, but found only ${t2.length - 1}.`);
              if (t2.length % 2 != 0) return e2.error("Expected an odd number of arguments.");
              let r2;
              e2.expectedType && "value" !== e2.expectedType.kind && (r2 = e2.expectedType);
              const n2 = [];
              for (let i3 = 1; i3 < t2.length - 1; i3 += 2) {
                const s2 = e2.parse(t2[i3], i3, xr);
                if (!s2) return null;
                const o2 = e2.parse(t2[i3 + 1], i3 + 1, r2);
                if (!o2) return null;
                n2.push([s2, o2]), r2 = r2 || o2.type;
              }
              const i2 = e2.parse(t2[t2.length - 1], t2.length - 1, r2);
              return i2 ? new Ki(r2, n2, i2) : null;
            }
            evaluate(t2) {
              for (const [e2, r2] of this.branches) if (e2.evaluate(t2)) return r2.evaluate(t2);
              return this.otherwise.evaluate(t2);
            }
            eachChild(t2) {
              for (const [e2, r2] of this.branches) t2(e2), t2(r2);
              t2(this.otherwise);
            }
            outputDefined() {
              return this.branches.every(([t2, e2]) => e2.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
              const t2 = ["case"];
              return this.eachChild((e2) => {
                t2.push(e2.serialize());
              }), t2;
            }
          }
          class Ji {
            constructor(t2, e2, r2, n2) {
              this.type = t2, this.input = e2, this.beginIndex = r2, this.endIndex = n2;
            }
            static parse(t2, e2) {
              if (t2.length <= 2 || t2.length >= 5) return e2.error(`Expected 3 or 4 arguments, but found ${t2.length - 1} instead.`);
              const r2 = e2.parse(t2[1], 1, wr), n2 = e2.parse(t2[2], 2, yr);
              if (!r2 || !n2) return null;
              if (!Pr(r2.type, [Ir(wr), gr, wr])) return e2.error(`Expected first argument to be of type array or string, but found ${Sr(r2.type)} instead`);
              if (4 === t2.length) {
                const i2 = e2.parse(t2[3], 3, yr);
                return i2 ? new Ji(r2.type, r2, n2, i2) : null;
              }
              return new Ji(r2.type, r2, n2);
            }
            evaluate(t2) {
              const e2 = this.input.evaluate(t2), r2 = this.beginIndex.evaluate(t2);
              if (!Er(e2, ["string", "array"])) throw new jr(`Expected first argument to be of type array or string, but found ${Sr(Or(e2))} instead.`);
              if (this.endIndex) {
                const n2 = this.endIndex.evaluate(t2);
                return e2.slice(r2, n2);
              }
              return e2.slice(r2);
            }
            eachChild(t2) {
              t2(this.input), t2(this.beginIndex), this.endIndex && t2(this.endIndex);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              if (null != this.endIndex && void 0 !== this.endIndex) {
                const t2 = this.endIndex.serialize();
                return ["slice", this.input.serialize(), this.beginIndex.serialize(), t2];
              }
              return ["slice", this.input.serialize(), this.beginIndex.serialize()];
            }
          }
          function Qi(t2, e2) {
            return "==" === t2 || "!=" === t2 ? "boolean" === e2.kind || "string" === e2.kind || "number" === e2.kind || "null" === e2.kind || "value" === e2.kind : "string" === e2.kind || "number" === e2.kind || "value" === e2.kind;
          }
          function ts(t2, e2, r2, n2) {
            return 0 === n2.compare(e2, r2);
          }
          function es(t2, e2, r2) {
            const n2 = "==" !== t2 && "!=" !== t2;
            return class i2 {
              constructor(t3, e3, r3) {
                this.type = xr, this.lhs = t3, this.rhs = e3, this.collator = r3, this.hasUntypedArgument = "value" === t3.type.kind || "value" === e3.type.kind;
              }
              static parse(t3, e3) {
                if (3 !== t3.length && 4 !== t3.length) return e3.error("Expected two or three arguments.");
                const r3 = t3[0];
                let s2 = e3.parse(t3[1], 1, wr);
                if (!s2) return null;
                if (!Qi(r3, s2.type)) return e3.concat(1).error(`"${r3}" comparisons are not supported for type '${Sr(s2.type)}'.`);
                let o2 = e3.parse(t3[2], 2, wr);
                if (!o2) return null;
                if (!Qi(r3, o2.type)) return e3.concat(2).error(`"${r3}" comparisons are not supported for type '${Sr(o2.type)}'.`);
                if (s2.type.kind !== o2.type.kind && "value" !== s2.type.kind && "value" !== o2.type.kind) return e3.error(`Cannot compare types '${Sr(s2.type)}' and '${Sr(o2.type)}'.`);
                n2 && ("value" === s2.type.kind && "value" !== o2.type.kind ? s2 = new Gr(o2.type, [s2]) : "value" !== s2.type.kind && "value" === o2.type.kind && (o2 = new Gr(s2.type, [o2])));
                let a2 = null;
                if (4 === t3.length) {
                  if ("string" !== s2.type.kind && "string" !== o2.type.kind && "value" !== s2.type.kind && "value" !== o2.type.kind) return e3.error("Cannot use collator to compare non-string types.");
                  if (a2 = e3.parse(t3[3], 3, _r), !a2) return null;
                }
                return new i2(s2, o2, a2);
              }
              evaluate(i3) {
                const s2 = this.lhs.evaluate(i3), o2 = this.rhs.evaluate(i3);
                if (n2 && this.hasUntypedArgument) {
                  const e3 = Or(s2), r3 = Or(o2);
                  if (e3.kind !== r3.kind || "string" !== e3.kind && "number" !== e3.kind) throw new jr(`Expected arguments for "${t2}" to be (string, string) or (number, number), but found (${e3.kind}, ${r3.kind}) instead.`);
                }
                if (this.collator && !n2 && this.hasUntypedArgument) {
                  const t3 = Or(s2), r3 = Or(o2);
                  if ("string" !== t3.kind || "string" !== r3.kind) return e2(i3, s2, o2);
                }
                return this.collator ? r2(i3, s2, o2, this.collator.evaluate(i3)) : e2(i3, s2, o2);
              }
              eachChild(t3) {
                t3(this.lhs), t3(this.rhs), this.collator && t3(this.collator);
              }
              outputDefined() {
                return true;
              }
              serialize() {
                const e3 = [t2];
                return this.eachChild((t3) => {
                  e3.push(t3.serialize());
                }), e3;
              }
            };
          }
          const rs = es("==", function(t2, e2, r2) {
            return e2 === r2;
          }, ts), ns = es("!=", function(t2, e2, r2) {
            return e2 !== r2;
          }, function(t2, e2, r2, n2) {
            return !ts(0, e2, r2, n2);
          }), is3 = es("<", function(t2, e2, r2) {
            return e2 < r2;
          }, function(t2, e2, r2, n2) {
            return n2.compare(e2, r2) < 0;
          }), ss = es(">", function(t2, e2, r2) {
            return e2 > r2;
          }, function(t2, e2, r2, n2) {
            return n2.compare(e2, r2) > 0;
          }), os = es("<=", function(t2, e2, r2) {
            return e2 <= r2;
          }, function(t2, e2, r2, n2) {
            return n2.compare(e2, r2) <= 0;
          }), as = es(">=", function(t2, e2, r2) {
            return e2 >= r2;
          }, function(t2, e2, r2, n2) {
            return n2.compare(e2, r2) >= 0;
          });
          class ls {
            constructor(t2, e2, r2, n2, i2, s2) {
              this.type = gr, this.number = t2, this.locale = e2, this.currency = r2, this.unit = n2, this.minFractionDigits = i2, this.maxFractionDigits = s2;
            }
            static parse(t2, e2) {
              if (3 !== t2.length) return e2.error("Expected two arguments.");
              const r2 = e2.parse(t2[1], 1, yr);
              if (!r2) return null;
              const n2 = t2[2];
              if ("object" != typeof n2 || Array.isArray(n2)) return e2.error("NumberFormat options argument must be an object.");
              let i2 = null;
              if (n2.locale && (i2 = e2.parseObjectValue(n2.locale, 2, "locale", gr), !i2)) return null;
              let s2 = null;
              if (n2.currency && (s2 = e2.parseObjectValue(n2.currency, 2, "currency", gr), !s2)) return null;
              let o2 = null;
              if (n2.unit && (o2 = e2.parseObjectValue(n2.unit, 2, "unit", gr), !o2)) return null;
              let a2 = null;
              if (n2["min-fraction-digits"] && (a2 = e2.parseObjectValue(n2["min-fraction-digits"], 2, "min-fraction-digits", yr), !a2)) return null;
              let l2 = null;
              return n2["max-fraction-digits"] && (l2 = e2.parseObjectValue(n2["max-fraction-digits"], 2, "max-fraction-digits", yr), !l2) ? null : new ls(r2, i2, s2, o2, a2, l2);
            }
            evaluate(t2) {
              return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t2) : [], { style: (this.currency ? "currency" : this.unit && "unit") || "decimal", currency: this.currency ? this.currency.evaluate(t2) : void 0, unit: this.unit ? this.unit.evaluate(t2) : void 0, minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t2) : void 0, maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t2) : void 0 }).format(this.number.evaluate(t2));
            }
            eachChild(t2) {
              t2(this.number), this.locale && t2(this.locale), this.currency && t2(this.currency), this.unit && t2(this.unit), this.minFractionDigits && t2(this.minFractionDigits), this.maxFractionDigits && t2(this.maxFractionDigits);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              const t2 = {};
              return this.locale && (t2.locale = this.locale.serialize()), this.currency && (t2.currency = this.currency.serialize()), this.unit && (t2.unit = this.unit.serialize()), this.minFractionDigits && (t2["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (t2["max-fraction-digits"] = this.maxFractionDigits.serialize()), ["number-format", this.number.serialize(), t2];
            }
          }
          class us {
            constructor(t2) {
              this.type = yr, this.input = t2;
            }
            static parse(t2, e2) {
              if (2 !== t2.length) return e2.error(`Expected 1 argument, but found ${t2.length - 1} instead.`);
              const r2 = e2.parse(t2[1], 1);
              return r2 ? "array" !== r2.type.kind && "string" !== r2.type.kind && "value" !== r2.type.kind ? e2.error(`Expected argument of type string or array, but found ${Sr(r2.type)} instead.`) : new us(r2) : null;
            }
            evaluate(t2) {
              const e2 = this.input.evaluate(t2);
              if ("string" == typeof e2) return e2.length;
              if (Array.isArray(e2)) return e2.length;
              throw new jr(`Expected value to be of type string or array, but found ${Sr(Or(e2))} instead.`);
            }
            eachChild(t2) {
              t2(this.input);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              const t2 = ["length"];
              return this.eachChild((e2) => {
                t2.push(e2.serialize());
              }), t2;
            }
          }
          function cs(t2) {
            return function() {
              t2 = 1831565813 + (t2 |= 0) | 0;
              let e2 = Math.imul(t2 ^ t2 >>> 15, 1 | t2);
              return e2 = e2 + Math.imul(e2 ^ e2 >>> 7, 61 | e2) ^ e2, ((e2 ^ e2 >>> 14) >>> 0) / 4294967296;
            };
          }
          const hs = { "==": rs, "!=": ns, ">": ss, "<": is3, ">=": as, "<=": os, array: Gr, at: Hi, "at-interpolated": Xi, boolean: Gr, case: Ki, coalesce: Gi, collator: tn, format: qr, image: Hr, in: Zi, "index-of": Wi, interpolate: ji, "interpolate-hcl": ji, "interpolate-lab": ji, length: us, let: qi, literal: Nr, match: Yi, number: Gr, "number-format": ls, object: Gr, slice: Ji, step: Ai, string: Gr, "to-boolean": Wr, "to-color": Wr, "to-number": Wr, "to-string": Wr, var: vi, within: Mn, distance: ci, config: xi };
          function ps(t2, [e2, r2, n2, i2]) {
            e2 = e2.evaluate(t2), r2 = r2.evaluate(t2), n2 = n2.evaluate(t2);
            const s2 = i2 ? i2.evaluate(t2) : 1, o2 = Lr(e2, r2, n2, s2);
            if (o2) throw new jr(o2);
            return new sr(e2 / 255, r2 / 255, n2 / 255, s2);
          }
          function fs(t2, [e2, r2, n2, i2]) {
            e2 = e2.evaluate(t2), r2 = r2.evaluate(t2), n2 = n2.evaluate(t2);
            const s2 = i2 ? i2.evaluate(t2) : 1, o2 = function(t3, e3, r3, n3) {
              return "number" == typeof t3 && t3 >= 0 && t3 <= 360 ? "number" == typeof e3 && e3 >= 0 && e3 <= 100 && "number" == typeof r3 && r3 >= 0 && r3 <= 100 ? void 0 === n3 || "number" == typeof n3 && n3 >= 0 && n3 <= 1 ? null : `Invalid hsla value [${[t3, e3, r3, n3].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n3 ? [t3, e3, r3, n3] : [t3, e3, r3]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n3 ? [t3, e3, r3, n3] : [t3, e3, r3]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(e2, r2, n2, s2);
            if (o2) throw new jr(o2);
            const a2 = `hsla(${e2}, ${r2}%, ${n2}%, ${s2})`, l2 = sr.parse(a2);
            if (!l2) throw new jr(`Failed to parse HSLA color: ${a2}`);
            return l2;
          }
          function ds(t2, e2) {
            return t2 in e2;
          }
          function ms(t2, e2) {
            const r2 = e2[t2];
            return void 0 === r2 ? null : r2;
          }
          function ys(t2) {
            return { type: t2 };
          }
          function gs(t2) {
            return { result: "success", value: t2 };
          }
          function xs(t2) {
            return { result: "error", value: t2 };
          }
          function vs(t2, e2) {
            return !!t2 && !!t2.parameters && t2.parameters.indexOf(e2) > -1;
          }
          function bs(t2) {
            return "data-driven" === t2["property-type"];
          }
          function ws(t2) {
            return vs(t2.expression, "measure-light");
          }
          function _s(t2) {
            return vs(t2.expression, "zoom");
          }
          function As(t2) {
            return !!t2.expression && t2.expression.interpolated;
          }
          function Ms(t2) {
            return "object" == typeof t2 && null !== t2 && !Array.isArray(t2);
          }
          function Is(t2) {
            return t2;
          }
          function Ss(t2, e2) {
            const r2 = "color" === e2.type, n2 = t2.stops && "object" == typeof t2.stops[0][0], i2 = n2 || !(n2 || void 0 !== t2.property), s2 = t2.type || (As(e2) ? "exponential" : "interval");
            if (r2 && ((t2 = pr({}, t2)).stops && (t2.stops = t2.stops.map((t3) => [t3[0], sr.parse(t3[1])])), t2.default = sr.parse(t2.default ? t2.default : e2.default)), t2.colorSpace && "rgb" !== t2.colorSpace && !Ni[t2.colorSpace]) throw new Error(`Unknown color space: ${t2.colorSpace}`);
            let o2, a2, l2;
            if ("exponential" === s2) o2 = Es;
            else if ("interval" === s2) o2 = Ps;
            else if ("categorical" === s2) {
              o2 = ks, a2 = /* @__PURE__ */ Object.create(null);
              for (const e3 of t2.stops) a2[e3[0]] = e3[1];
              l2 = typeof t2.stops[0][0];
            } else {
              if ("identity" !== s2) throw new Error(`Unknown function type "${s2}"`);
              o2 = Ts;
            }
            if (n2) {
              const r3 = {}, n3 = [];
              for (let e3 = 0; e3 < t2.stops.length; e3++) {
                const i4 = t2.stops[e3], s4 = i4[0].zoom;
                void 0 === r3[s4] && (r3[s4] = { zoom: s4, type: t2.type, property: t2.property, default: t2.default, stops: [] }, n3.push(s4)), r3[s4].stops.push([i4[0].value, i4[1]]);
              }
              const i3 = [];
              for (const t3 of n3) i3.push([r3[t3].zoom, Ss(r3[t3], e2)]);
              const s3 = { name: "linear" };
              return { kind: "composite", interpolationType: s3, interpolationFactor: ji.interpolationFactor.bind(void 0, s3), zoomStops: i3.map((t3) => t3[0]), evaluate: ({ zoom: r4 }, n4) => Es({ stops: i3, base: t2.base }, e2, r4).evaluate(r4, n4) };
            }
            if (i2) {
              const r3 = "exponential" === s2 ? { name: "exponential", base: void 0 !== t2.base ? t2.base : 1 } : null;
              return { kind: "camera", interpolationType: r3, interpolationFactor: ji.interpolationFactor.bind(void 0, r3), zoomStops: t2.stops.map((t3) => t3[0]), evaluate: ({ zoom: r4 }) => o2(t2, e2, r4, a2, l2) };
            }
            return { kind: "source", evaluate(r3, n3) {
              const i3 = n3 && n3.properties ? n3.properties[t2.property] : void 0;
              return void 0 === i3 ? zs(t2.default, e2.default) : o2(t2, e2, i3, a2, l2);
            } };
          }
          function zs(t2, e2, r2) {
            return void 0 !== t2 ? t2 : void 0 !== e2 ? e2 : void 0 !== r2 ? r2 : void 0;
          }
          function ks(t2, e2, r2, n2, i2) {
            return zs(typeof r2 === i2 ? n2[r2] : void 0, t2.default, e2.default);
          }
          function Ps(t2, e2, r2) {
            if ("number" !== Xr(r2)) return zs(t2.default, e2.default);
            const n2 = t2.stops.length;
            if (1 === n2) return t2.stops[0][1];
            if (r2 <= t2.stops[0][0]) return t2.stops[0][1];
            if (r2 >= t2.stops[n2 - 1][0]) return t2.stops[n2 - 1][1];
            const i2 = _i(t2.stops.map((t3) => t3[0]), r2);
            return t2.stops[i2][1];
          }
          function Es(t2, e2, r2) {
            const n2 = void 0 !== t2.base ? t2.base : 1;
            if ("number" !== Xr(r2)) return zs(t2.default, e2.default);
            const i2 = t2.stops.length;
            if (1 === i2) return t2.stops[0][1];
            if (r2 <= t2.stops[0][0]) return t2.stops[0][1];
            if (r2 >= t2.stops[i2 - 1][0]) return t2.stops[i2 - 1][1];
            const s2 = _i(t2.stops.map((t3) => t3[0]), r2), o2 = function(t3, e3, r3, n3) {
              const i3 = n3 - r3, s3 = t3 - r3;
              return 0 === i3 ? 0 : 1 === e3 ? s3 / i3 : (Math.pow(e3, s3) - 1) / (Math.pow(e3, i3) - 1);
            }(r2, n2, t2.stops[s2][0], t2.stops[s2 + 1][0]), a2 = t2.stops[s2][1], l2 = t2.stops[s2 + 1][1];
            let u2 = hr[e2.type] || Is;
            if (t2.colorSpace && "rgb" !== t2.colorSpace) {
              const e3 = Ni[t2.colorSpace];
              u2 = (t3, r3) => e3.reverse(e3.interpolate(e3.forward(t3), e3.forward(r3), o2));
            }
            return "function" == typeof a2.evaluate ? { evaluate(...t3) {
              const e3 = a2.evaluate.apply(void 0, t3), r3 = l2.evaluate.apply(void 0, t3);
              if (void 0 !== e3 && void 0 !== r3) return u2(e3, r3, o2);
            } } : u2(a2, l2, o2);
          }
          function Ts(t2, e2, r2) {
            return "color" === e2.type ? r2 = sr.parse(r2) : "formatted" === e2.type ? r2 = Cr.fromString(r2.toString()) : "resolvedImage" === e2.type ? r2 = Dr.build(r2.toString()) : Xr(r2) === e2.type || "enum" === e2.type && e2.values[r2] || (r2 = void 0), zs(r2, t2.default, e2.default);
          }
          Jr.register(hs, { error: [{ kind: "error" }, [gr], (t2, [e2]) => {
            throw new jr(e2.evaluate(t2));
          }], typeof: [gr, [wr], (t2, [e2]) => Sr(Or(e2.evaluate(t2)))], "to-rgba": [Ir(yr, 4), [vr], (t2, [e2]) => e2.evaluate(t2).toNonPremultipliedRenderColor(null).toArray()], "to-hsla": [Ir(yr, 4), [vr], (t2, [e2]) => e2.evaluate(t2).toNonPremultipliedRenderColor(null).toHslaArray()], rgb: [vr, [yr, yr, yr], ps], rgba: [vr, [yr, yr, yr, yr], ps], hsl: [vr, [yr, yr, yr], fs], hsla: [vr, [yr, yr, yr, yr], fs], has: { type: xr, overloads: [[[gr], (t2, [e2]) => ds(e2.evaluate(t2), t2.properties())], [[gr, br], (t2, [e2, r2]) => ds(e2.evaluate(t2), r2.evaluate(t2))]] }, get: { type: wr, overloads: [[[gr], (t2, [e2]) => ms(e2.evaluate(t2), t2.properties())], [[gr, br], (t2, [e2, r2]) => ms(e2.evaluate(t2), r2.evaluate(t2))]] }, "feature-state": [wr, [gr], (t2, [e2]) => ms(e2.evaluate(t2), t2.featureState || {})], properties: [br, [], (t2) => t2.properties()], "geometry-type": [gr, [], (t2) => t2.geometryType()], worldview: [gr, [], (t2) => t2.globals.worldview || ""], id: [wr, [], (t2) => t2.id()], zoom: [yr, [], (t2) => t2.globals.zoom], pitch: [yr, [], (t2) => t2.globals.pitch || 0], "distance-from-center": [yr, [], (t2) => t2.distanceFromCenter()], "measure-light": [yr, [gr], (t2, [e2]) => t2.measureLight(e2.evaluate(t2))], "heatmap-density": [yr, [], (t2) => t2.globals.heatmapDensity || 0], "line-progress": [yr, [], (t2) => t2.globals.lineProgress || 0], "raster-value": [yr, [], (t2) => t2.globals.rasterValue || 0], "raster-particle-speed": [yr, [], (t2) => t2.globals.rasterParticleSpeed || 0], "sky-radial-progress": [yr, [], (t2) => t2.globals.skyRadialProgress || 0], accumulated: [wr, [], (t2) => void 0 === t2.globals.accumulated ? null : t2.globals.accumulated], "+": [yr, ys(yr), (t2, e2) => {
            let r2 = 0;
            for (const n2 of e2) r2 += n2.evaluate(t2);
            return r2;
          }], "*": [yr, ys(yr), (t2, e2) => {
            let r2 = 1;
            for (const n2 of e2) r2 *= n2.evaluate(t2);
            return r2;
          }], "-": { type: yr, overloads: [[[yr, yr], (t2, [e2, r2]) => e2.evaluate(t2) - r2.evaluate(t2)], [[yr], (t2, [e2]) => -e2.evaluate(t2)]] }, "/": [yr, [yr, yr], (t2, [e2, r2]) => e2.evaluate(t2) / r2.evaluate(t2)], "%": [yr, [yr, yr], (t2, [e2, r2]) => e2.evaluate(t2) % r2.evaluate(t2)], ln2: [yr, [], () => Math.LN2], pi: [yr, [], () => Math.PI], e: [yr, [], () => Math.E], "^": [yr, [yr, yr], (t2, [e2, r2]) => Math.pow(e2.evaluate(t2), r2.evaluate(t2))], sqrt: [yr, [yr], (t2, [e2]) => Math.sqrt(e2.evaluate(t2))], log10: [yr, [yr], (t2, [e2]) => Math.log(e2.evaluate(t2)) / Math.LN10], ln: [yr, [yr], (t2, [e2]) => Math.log(e2.evaluate(t2))], log2: [yr, [yr], (t2, [e2]) => Math.log(e2.evaluate(t2)) / Math.LN2], sin: [yr, [yr], (t2, [e2]) => Math.sin(e2.evaluate(t2))], cos: [yr, [yr], (t2, [e2]) => Math.cos(e2.evaluate(t2))], tan: [yr, [yr], (t2, [e2]) => Math.tan(e2.evaluate(t2))], asin: [yr, [yr], (t2, [e2]) => Math.asin(e2.evaluate(t2))], acos: [yr, [yr], (t2, [e2]) => Math.acos(e2.evaluate(t2))], atan: [yr, [yr], (t2, [e2]) => Math.atan(e2.evaluate(t2))], min: [yr, ys(yr), (t2, e2) => Math.min(...e2.map((e3) => e3.evaluate(t2)))], max: [yr, ys(yr), (t2, e2) => Math.max(...e2.map((e3) => e3.evaluate(t2)))], abs: [yr, [yr], (t2, [e2]) => Math.abs(e2.evaluate(t2))], round: [yr, [yr], (t2, [e2]) => {
            const r2 = e2.evaluate(t2);
            return r2 < 0 ? -Math.round(-r2) : Math.round(r2);
          }], floor: [yr, [yr], (t2, [e2]) => Math.floor(e2.evaluate(t2))], ceil: [yr, [yr], (t2, [e2]) => Math.ceil(e2.evaluate(t2))], "filter-==": [xr, [gr, wr], (t2, [e2, r2]) => t2.properties()[e2.value] === r2.value], "filter-id-==": [xr, [wr], (t2, [e2]) => t2.id() === e2.value], "filter-type-==": [xr, [gr], (t2, [e2]) => t2.geometryType() === e2.value], "filter-<": [xr, [gr, wr], (t2, [e2, r2]) => {
            const n2 = t2.properties()[e2.value], i2 = r2.value;
            return typeof n2 == typeof i2 && n2 < i2;
          }], "filter-id-<": [xr, [wr], (t2, [e2]) => {
            const r2 = t2.id(), n2 = e2.value;
            return typeof r2 == typeof n2 && r2 < n2;
          }], "filter->": [xr, [gr, wr], (t2, [e2, r2]) => {
            const n2 = t2.properties()[e2.value], i2 = r2.value;
            return typeof n2 == typeof i2 && n2 > i2;
          }], "filter-id->": [xr, [wr], (t2, [e2]) => {
            const r2 = t2.id(), n2 = e2.value;
            return typeof r2 == typeof n2 && r2 > n2;
          }], "filter-<=": [xr, [gr, wr], (t2, [e2, r2]) => {
            const n2 = t2.properties()[e2.value], i2 = r2.value;
            return typeof n2 == typeof i2 && n2 <= i2;
          }], "filter-id-<=": [xr, [wr], (t2, [e2]) => {
            const r2 = t2.id(), n2 = e2.value;
            return typeof r2 == typeof n2 && r2 <= n2;
          }], "filter->=": [xr, [gr, wr], (t2, [e2, r2]) => {
            const n2 = t2.properties()[e2.value], i2 = r2.value;
            return typeof n2 == typeof i2 && n2 >= i2;
          }], "filter-id->=": [xr, [wr], (t2, [e2]) => {
            const r2 = t2.id(), n2 = e2.value;
            return typeof r2 == typeof n2 && r2 >= n2;
          }], "filter-has": [xr, [wr], (t2, [e2]) => e2.value in t2.properties()], "filter-has-id": [xr, [], (t2) => null !== t2.id() && void 0 !== t2.id()], "filter-type-in": [xr, [Ir(gr)], (t2, [e2]) => e2.value.indexOf(t2.geometryType()) >= 0], "filter-id-in": [xr, [Ir(wr)], (t2, [e2]) => e2.value.indexOf(t2.id()) >= 0], "filter-in-small": [xr, [gr, Ir(wr)], (t2, [e2, r2]) => r2.value.indexOf(t2.properties()[e2.value]) >= 0], "filter-in-large": [xr, [gr, Ir(wr)], (t2, [e2, r2]) => function(t3, e3, r3, n2) {
            for (; r3 <= n2; ) {
              const i2 = r3 + n2 >> 1;
              if (e3[i2] === t3) return true;
              e3[i2] > t3 ? n2 = i2 - 1 : r3 = i2 + 1;
            }
            return false;
          }(t2.properties()[e2.value], r2.value, 0, r2.value.length - 1)], all: { type: xr, overloads: [[[xr, xr], (t2, [e2, r2]) => e2.evaluate(t2) && r2.evaluate(t2)], [ys(xr), (t2, e2) => {
            for (const r2 of e2) if (!r2.evaluate(t2)) return false;
            return true;
          }]] }, any: { type: xr, overloads: [[[xr, xr], (t2, [e2, r2]) => e2.evaluate(t2) || r2.evaluate(t2)], [ys(xr), (t2, e2) => {
            for (const r2 of e2) if (r2.evaluate(t2)) return true;
            return false;
          }]] }, "!": [xr, [xr], (t2, [e2]) => !e2.evaluate(t2)], "is-supported-script": [xr, [gr], (t2, [e2]) => {
            const r2 = t2.globals && t2.globals.isSupportedScript;
            return !r2 || r2(e2.evaluate(t2));
          }], upcase: [gr, [gr], (t2, [e2]) => e2.evaluate(t2).toUpperCase()], downcase: [gr, [gr], (t2, [e2]) => e2.evaluate(t2).toLowerCase()], concat: [gr, ys(wr), (t2, e2) => e2.map((e3) => Ur(e3.evaluate(t2))).join("")], "resolved-locale": [gr, [_r], (t2, [e2]) => e2.evaluate(t2).resolvedLocale()], random: [yr, [yr, yr, wr], (t2, e2) => {
            const [r2, n2, i2] = e2.map((e3) => e3.evaluate(t2));
            if (r2 > n2) return r2;
            if (r2 === n2) return r2;
            let s2;
            if ("string" == typeof i2) s2 = function(t3) {
              let e3 = 0;
              if (0 === t3.length) return e3;
              for (let r3 = 0; r3 < t3.length; r3++) e3 = (e3 << 5) - e3 + t3.charCodeAt(r3), e3 |= 0;
              return e3;
            }(i2);
            else {
              if ("number" != typeof i2) throw new jr(`Invalid seed input: ${i2}`);
              s2 = i2;
            }
            return r2 + cs(s2)() * (n2 - r2);
          }] });
          class Bs {
            constructor(t2, e2, r2, n2) {
              this.expression = t2, this._warningHistory = {}, this._evaluator = new Kr(r2, n2), this._defaultValue = e2 ? function(t3) {
                return "color" === t3.type && (Ms(t3.default) || Array.isArray(t3.default)) ? new sr(0, 0, 0, 0) : "color" === t3.type ? sr.parse(t3.default) || null : void 0 === t3.default ? null : t3.default;
              }(e2) : null, this._enumValues = e2 && "enum" === e2.type ? e2.values : null, this.configDependencies = fi(t2);
            }
            evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2, o2, a2) {
              return this._evaluator.globals = t2, this._evaluator.feature = e2, this._evaluator.featureState = r2, this._evaluator.canonical = n2 || null, this._evaluator.availableImages = i2 || null, this._evaluator.formattedSection = s2, this._evaluator.featureTileCoord = o2 || null, this._evaluator.featureDistanceData = a2 || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(t2, e2, r2, n2, i2, s2, o2, a2) {
              this._evaluator.globals = t2, this._evaluator.feature = e2 || null, this._evaluator.featureState = r2 || null, this._evaluator.canonical = n2 || null, this._evaluator.availableImages = i2 || null, this._evaluator.formattedSection = s2 || null, this._evaluator.featureTileCoord = o2 || null, this._evaluator.featureDistanceData = a2 || null;
              try {
                const t3 = this.expression.evaluate(this._evaluator);
                if (null == t3 || "number" == typeof t3 && t3 != t3) return this._defaultValue;
                if (this._enumValues && !(t3 in this._enumValues)) throw new jr(`Expected value to be one of ${Object.keys(this._enumValues).map((t4) => JSON.stringify(t4)).join(", ")}, but found ${JSON.stringify(t3)} instead.`);
                return t3;
              } catch (t3) {
                return this._warningHistory[t3.message] || (this._warningHistory[t3.message] = true, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t3.message}`)), this._defaultValue;
              }
            }
          }
          function Vs(t2) {
            return Array.isArray(t2) && t2.length > 0 && "string" == typeof t2[0] && t2[0] in hs;
          }
          function Cs(t2, e2, r2, n2) {
            const i2 = new bi(hs, [], e2 ? function(t3) {
              const e3 = { color: vr, string: gr, number: yr, enum: gr, boolean: xr, formatted: Ar, resolvedImage: Mr };
              return "array" === t3.type ? Ir(e3[t3.value] || wr, t3.length) : e3[t3.type];
            }(e2) : void 0, void 0, void 0, r2, n2), s2 = i2.parse(t2, void 0, void 0, void 0, e2 && "string" === e2.type ? { typeAnnotation: "coerce" } : void 0);
            return s2 ? gs(new Bs(s2, e2, r2, n2)) : xs(i2.errors);
          }
          class Fs {
            constructor(t2, e2, r2, n2) {
              this.kind = t2, this._styleExpression = e2, this.isLightConstant = r2, this.isLineProgressConstant = n2, this.isStateDependent = "constant" !== t2 && !pi(e2.expression), this.configDependencies = fi(e2.expression);
            }
            evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2) {
              return this._styleExpression.evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2);
            }
            evaluate(t2, e2, r2, n2, i2, s2) {
              return this._styleExpression.evaluate(t2, e2, r2, n2, i2, s2);
            }
          }
          class Ds {
            constructor(t2, e2, r2, n2, i2, s2) {
              this.kind = t2, this.zoomStops = r2, this._styleExpression = e2, this.isStateDependent = "camera" !== t2 && !pi(e2.expression), this.isLightConstant = i2, this.isLineProgressConstant = s2, this.configDependencies = fi(e2.expression), this.interpolationType = n2;
            }
            evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2) {
              return this._styleExpression.evaluateWithoutErrorHandling(t2, e2, r2, n2, i2, s2);
            }
            evaluate(t2, e2, r2, n2, i2, s2) {
              return this._styleExpression.evaluate(t2, e2, r2, n2, i2, s2);
            }
            interpolationFactor(t2, e2, r2) {
              return this.interpolationType ? ji.interpolationFactor(this.interpolationType, t2, e2, r2) : 0;
            }
          }
          function Ls(t2, e2, r2, n2) {
            if ("error" === (t2 = Cs(t2, e2, r2, n2)).result) return t2;
            const i2 = t2.value.expression, s2 = hi(i2);
            if (!s2 && !bs(e2)) return xs([new fr("", "data expressions not supported")]);
            const o2 = di(i2, ["zoom", "pitch", "distance-from-center"]);
            if (!o2 && !_s(e2)) return xs([new fr("", "zoom expressions not supported")]);
            const a2 = di(i2, ["measure-light"]);
            if (!a2 && !ws(e2)) return xs([new fr("", "measure-light expression not supported")]);
            const l2 = di(i2, ["line-progress"]);
            if (!l2 && !function(t3) {
              return vs(t3.expression, "line-progress");
            }(e2)) return xs([new fr("", "line-progress expression not supported")]);
            const u2 = e2.expression && e2.expression.relaxZoomRestriction, c2 = Os(i2);
            return c2 || o2 || u2 ? c2 instanceof fr ? xs([c2]) : c2 instanceof ji && !As(e2) ? xs([new fr("", '"interpolate" expressions cannot be used with this property')]) : gs(c2 ? new Ds(s2 && l2 ? "camera" : "composite", t2.value, c2.labels, c2 instanceof ji ? c2.interpolation : void 0, a2, l2) : new Fs(s2 && l2 ? "constant" : "source", t2.value, a2, l2)) : xs([new fr("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')]);
          }
          class Rs {
            constructor(t2, e2) {
              this._parameters = t2, this._specification = e2, pr(this, Ss(this._parameters, this._specification));
            }
            static deserialize(t2) {
              return new Rs(t2._parameters, t2._specification);
            }
            static serialize(t2) {
              return { _parameters: t2._parameters, _specification: t2._specification };
            }
          }
          function Os(t2) {
            let e2 = null;
            if (t2 instanceof qi) e2 = Os(t2.result);
            else if (t2 instanceof Gi) {
              for (const r2 of t2.args) if (e2 = Os(r2), e2) break;
            } else (t2 instanceof Ai || t2 instanceof ji) && t2.input instanceof Jr && "zoom" === t2.input.name && (e2 = t2);
            return e2 instanceof fr || t2.eachChild((t3) => {
              const r2 = Os(t3);
              r2 instanceof fr ? e2 = r2 : e2 && r2 && e2 !== r2 && (e2 = new fr("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), e2;
          }
          var Us, Ns, js = function() {
            if (Ns) return Us;
            Ns = 1, Us = e2;
            var t2 = 3;
            function e2(e3, r2, n2) {
              var i2 = this.cells = [];
              if (e3 instanceof ArrayBuffer) {
                this.arrayBuffer = e3;
                var s2 = new Int32Array(this.arrayBuffer);
                e3 = s2[0], this.d = (r2 = s2[1]) + 2 * (n2 = s2[2]);
                for (var o2 = 0; o2 < this.d * this.d; o2++) {
                  var a2 = s2[t2 + o2], l2 = s2[t2 + o2 + 1];
                  i2.push(a2 === l2 ? null : s2.subarray(a2, l2));
                }
                var u2 = s2[t2 + i2.length + 1];
                this.keys = s2.subarray(s2[t2 + i2.length], u2), this.bboxes = s2.subarray(u2), this.insert = this._insertReadonly;
              } else {
                this.d = r2 + 2 * n2;
                for (var c2 = 0; c2 < this.d * this.d; c2++) i2.push([]);
                this.keys = [], this.bboxes = [];
              }
              this.n = r2, this.extent = e3, this.padding = n2, this.scale = r2 / e3, this.uid = 0;
              var h3 = n2 / r2 * e3;
              this.min = -h3, this.max = e3 + h3;
            }
            return e2.prototype.insert = function(t3, e3, r2, n2, i2) {
              this._forEachCell(e3, r2, n2, i2, this._insertCell, this.uid++), this.keys.push(t3), this.bboxes.push(e3), this.bboxes.push(r2), this.bboxes.push(n2), this.bboxes.push(i2);
            }, e2.prototype._insertReadonly = function() {
              throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
            }, e2.prototype._insertCell = function(t3, e3, r2, n2, i2, s2) {
              this.cells[i2].push(s2);
            }, e2.prototype.query = function(t3, e3, r2, n2, i2) {
              var s2 = this.min, o2 = this.max;
              if (t3 <= s2 && e3 <= s2 && o2 <= r2 && o2 <= n2 && !i2) return Array.prototype.slice.call(this.keys);
              var a2 = [];
              return this._forEachCell(t3, e3, r2, n2, this._queryCell, a2, {}, i2), a2;
            }, e2.prototype._queryCell = function(t3, e3, r2, n2, i2, s2, o2, a2) {
              var l2 = this.cells[i2];
              if (null !== l2) for (var u2 = this.keys, c2 = this.bboxes, h3 = 0; h3 < l2.length; h3++) {
                var p3 = l2[h3];
                if (void 0 === o2[p3]) {
                  var f2 = 4 * p3;
                  (a2 ? a2(c2[f2 + 0], c2[f2 + 1], c2[f2 + 2], c2[f2 + 3]) : t3 <= c2[f2 + 2] && e3 <= c2[f2 + 3] && r2 >= c2[f2 + 0] && n2 >= c2[f2 + 1]) ? (o2[p3] = true, s2.push(u2[p3])) : o2[p3] = false;
                }
              }
            }, e2.prototype._forEachCell = function(t3, e3, r2, n2, i2, s2, o2, a2) {
              for (var l2 = this._convertToCellCoord(t3), u2 = this._convertToCellCoord(e3), c2 = this._convertToCellCoord(r2), h3 = this._convertToCellCoord(n2), p3 = l2; p3 <= c2; p3++) for (var f2 = u2; f2 <= h3; f2++) {
                var d2 = this.d * f2 + p3;
                if ((!a2 || a2(this._convertFromCellCoord(p3), this._convertFromCellCoord(f2), this._convertFromCellCoord(p3 + 1), this._convertFromCellCoord(f2 + 1))) && i2.call(this, t3, e3, r2, n2, d2, s2, o2, a2)) return;
              }
            }, e2.prototype._convertFromCellCoord = function(t3) {
              return (t3 - this.padding) / this.scale;
            }, e2.prototype._convertToCellCoord = function(t3) {
              return Math.max(0, Math.min(this.d - 1, Math.floor(t3 * this.scale) + this.padding));
            }, e2.prototype.toArrayBuffer = function() {
              if (this.arrayBuffer) return this.arrayBuffer;
              for (var e3 = this.cells, r2 = t2 + this.cells.length + 1 + 1, n2 = 0, i2 = 0; i2 < this.cells.length; i2++) n2 += this.cells[i2].length;
              var s2 = new Int32Array(r2 + n2 + this.keys.length + this.bboxes.length);
              s2[0] = this.extent, s2[1] = this.n, s2[2] = this.padding;
              for (var o2 = r2, a2 = 0; a2 < e3.length; a2++) {
                var l2 = e3[a2];
                s2[t2 + a2] = o2, s2.set(l2, o2), o2 += l2.length;
              }
              return s2[t2 + e3.length] = o2, s2.set(this.keys, o2), s2[t2 + e3.length + 1] = o2 += this.keys.length, s2.set(this.bboxes, o2), o2 += this.bboxes.length, s2.buffer;
            }, Us;
          }(), $s = dt(js);
          const Gs = {};
          function qs(t2, e2, r2 = {}) {
            Object.defineProperty(t2, "_classRegistryKey", { value: e2, writable: false }), Gs[e2] = { klass: t2, omit: r2.omit || [] };
          }
          qs(Object, "Object"), $s.serialize = function(t2, e2) {
            const r2 = t2.toArrayBuffer();
            return e2 && e2.add(r2), { buffer: r2 };
          }, $s.deserialize = function(t2) {
            return new $s(t2.buffer);
          }, Object.defineProperty($s, "name", { value: "Grid" }), qs($s, "Grid"), "undefined" != typeof DOMMatrix && qs(DOMMatrix, "DOMMatrix"), qs(sr, "Color"), qs(Error, "Error"), qs(Cr, "Formatted"), qs(Vr, "FormattedSection"), qs(Ve, "AJAXError"), qs(Dr, "ResolvedImage"), qs(Rs, "StylePropertyFunction"), qs(Bs, "StyleExpression", { omit: ["_evaluator"] }), qs(er, "ImageId"), qs(Fr, "ImageVariant"), qs(Ds, "ZoomDependentExpression"), qs(Fs, "ZoomConstantExpression"), qs(Jr, "CompoundExpression", { omit: ["_evaluate"] });
          for (const t2 in hs) Gs[hs[t2]._classRegistryKey] || qs(hs[t2], `Expression${t2}`);
          function Hs(t2) {
            return t2 && "undefined" != typeof ArrayBuffer && (t2 instanceof ArrayBuffer || t2.constructor && "ArrayBuffer" === t2.constructor.name);
          }
          function Xs(t2) {
            return self.ImageBitmap && t2 instanceof ImageBitmap;
          }
          function Zs(t2, e2) {
            if (null == t2 || "boolean" == typeof t2 || "number" == typeof t2 || "string" == typeof t2 || t2 instanceof Boolean || t2 instanceof Number || t2 instanceof String || t2 instanceof Date || t2 instanceof RegExp) return t2;
            if (Hs(t2) || Xs(t2)) return e2 && e2.add(t2), t2;
            if (ArrayBuffer.isView(t2)) return e2 && e2.add(t2.buffer), t2;
            if (t2 instanceof ImageData) return e2 && e2.add(t2.data.buffer), t2;
            if (Array.isArray(t2)) {
              const r2 = [];
              for (const n2 of t2) r2.push(Zs(n2, e2));
              return r2;
            }
            if (t2 instanceof Map) {
              const r2 = { $name: "Map", entries: [] };
              for (const [n2, i2] of t2.entries()) r2.entries.push(Zs(n2), Zs(i2, e2));
              return r2;
            }
            if (t2 instanceof Set) {
              const e3 = { $name: "Set" };
              let r2 = 0;
              for (const n2 of t2.values()) e3[++r2] = Zs(n2);
              return e3;
            }
            if (t2 instanceof DOMMatrix) {
              const e3 = { $name: "DOMMatrix" }, r2 = ["is2D", "m11", "m12", "m13", "m14", "m21", "m22", "m23", "m24", "m31", "m32", "m33", "m34", "m41", "m42", "m43", "m44", "a", "b", "c", "d", "e", "f"];
              for (const n2 of r2) e3[n2] = t2[n2];
              return e3;
            }
            if ("bigint" == typeof t2) return { $name: "BigInt", value: t2.toString() };
            if ("object" == typeof t2) {
              const r2 = t2.constructor, n2 = r2._classRegistryKey;
              if (!n2) throw new Error(`Can't serialize object of unregistered class "${r2.name}".`);
              const i2 = r2.serialize ? r2.serialize(t2, e2) : {};
              if (!r2.serialize) {
                for (const r3 in t2) t2.hasOwnProperty(r3) && (Gs[n2].omit.indexOf(r3) >= 0 || (i2[r3] = Zs(t2[r3], e2)));
                t2 instanceof Error && (i2.message = t2.message);
              }
              if (i2.$name) throw new Error("$name property is reserved for worker serialization logic.");
              return "Object" !== n2 && (i2.$name = n2), i2;
            }
            throw new Error("can't serialize object of type " + typeof t2);
          }
          function Ws(t2) {
            if (null == t2 || "boolean" == typeof t2 || "number" == typeof t2 || "string" == typeof t2 || t2 instanceof Boolean || t2 instanceof Number || t2 instanceof String || t2 instanceof Date || t2 instanceof RegExp || Hs(t2) || Xs(t2) || ArrayBuffer.isView(t2) || t2 instanceof ImageData) return t2;
            if (Array.isArray(t2)) return t2.map(Ws);
            if ("object" == typeof t2) {
              const e2 = t2.$name || "Object";
              if ("Map" === e2) {
                const e3 = t2.entries || [], r3 = /* @__PURE__ */ new Map();
                for (let t3 = 0; t3 < e3.length; t3 += 2) r3.set(Ws(e3[t3]), Ws(e3[t3 + 1]));
                return r3;
              }
              if ("Set" === e2) {
                const e3 = /* @__PURE__ */ new Set();
                for (const r3 of Object.keys(t2)) "$name" !== r3 && e3.add(Ws(t2[r3]));
                return e3;
              }
              if ("DOMMatrix" === e2) {
                let e3;
                return e3 = t2.is2D ? [t2.a, t2.b, t2.c, t2.d, t2.e, t2.f] : [t2.m11, t2.m12, t2.m13, t2.m14, t2.m21, t2.m22, t2.m23, t2.m24, t2.m31, t2.m32, t2.m33, t2.m34, t2.m41, t2.m42, t2.m43, t2.m44], new DOMMatrix(e3);
              }
              if ("BigInt" === e2) return BigInt(t2.value);
              const { klass: r2 } = Gs[e2];
              if (!r2) throw new Error(`Can't deserialize unregistered class "${e2}".`);
              if (r2.deserialize) return r2.deserialize(t2);
              const n2 = Object.create(r2.prototype);
              for (const e3 of Object.keys(t2)) "$name" !== e3 && (n2[e3] = Ws(t2[e3]));
              return n2;
            }
            throw new Error("can't deserialize object of type " + typeof t2);
          }
          const Ys = { "Latin-1 Supplement": (t2) => t2 >= 128 && t2 <= 255, Arabic: (t2) => t2 >= 1536 && t2 <= 1791, "Arabic Supplement": (t2) => t2 >= 1872 && t2 <= 1919, "Arabic Extended-A": (t2) => t2 >= 2208 && t2 <= 2303, "Hangul Jamo": (t2) => t2 >= 4352 && t2 <= 4607, "Unified Canadian Aboriginal Syllabics": (t2) => t2 >= 5120 && t2 <= 5759, Khmer: (t2) => t2 >= 6016 && t2 <= 6143, "Unified Canadian Aboriginal Syllabics Extended": (t2) => t2 >= 6320 && t2 <= 6399, "General Punctuation": (t2) => t2 >= 8192 && t2 <= 8303, "Letterlike Symbols": (t2) => t2 >= 8448 && t2 <= 8527, "Number Forms": (t2) => t2 >= 8528 && t2 <= 8591, "Miscellaneous Technical": (t2) => t2 >= 8960 && t2 <= 9215, "Control Pictures": (t2) => t2 >= 9216 && t2 <= 9279, "Optical Character Recognition": (t2) => t2 >= 9280 && t2 <= 9311, "Enclosed Alphanumerics": (t2) => t2 >= 9312 && t2 <= 9471, "Geometric Shapes": (t2) => t2 >= 9632 && t2 <= 9727, "Miscellaneous Symbols": (t2) => t2 >= 9728 && t2 <= 9983, "Miscellaneous Symbols and Arrows": (t2) => t2 >= 11008 && t2 <= 11263, "CJK Radicals Supplement": (t2) => t2 >= 11904 && t2 <= 12031, "Kangxi Radicals": (t2) => t2 >= 12032 && t2 <= 12255, "Ideographic Description Characters": (t2) => t2 >= 12272 && t2 <= 12287, "CJK Symbols and Punctuation": (t2) => t2 >= 12288 && t2 <= 12351, Hiragana: (t2) => t2 >= 12352 && t2 <= 12447, Katakana: (t2) => t2 >= 12448 && t2 <= 12543, Bopomofo: (t2) => t2 >= 12544 && t2 <= 12591, "Hangul Compatibility Jamo": (t2) => t2 >= 12592 && t2 <= 12687, Kanbun: (t2) => t2 >= 12688 && t2 <= 12703, "Bopomofo Extended": (t2) => t2 >= 12704 && t2 <= 12735, "CJK Strokes": (t2) => t2 >= 12736 && t2 <= 12783, "Katakana Phonetic Extensions": (t2) => t2 >= 12784 && t2 <= 12799, "Enclosed CJK Letters and Months": (t2) => t2 >= 12800 && t2 <= 13055, "CJK Compatibility": (t2) => t2 >= 13056 && t2 <= 13311, "CJK Unified Ideographs Extension A": (t2) => t2 >= 13312 && t2 <= 19903, "Yijing Hexagram Symbols": (t2) => t2 >= 19904 && t2 <= 19967, "CJK Unified Ideographs": (t2) => t2 >= 19968 && t2 <= 40959, "Yi Syllables": (t2) => t2 >= 40960 && t2 <= 42127, "Yi Radicals": (t2) => t2 >= 42128 && t2 <= 42191, "Hangul Jamo Extended-A": (t2) => t2 >= 43360 && t2 <= 43391, "Hangul Syllables": (t2) => t2 >= 44032 && t2 <= 55215, "Hangul Jamo Extended-B": (t2) => t2 >= 55216 && t2 <= 55295, "Private Use Area": (t2) => t2 >= 57344 && t2 <= 63743, "CJK Compatibility Ideographs": (t2) => t2 >= 63744 && t2 <= 64255, "Arabic Presentation Forms-A": (t2) => t2 >= 64336 && t2 <= 65023, "Vertical Forms": (t2) => t2 >= 65040 && t2 <= 65055, "CJK Compatibility Forms": (t2) => t2 >= 65072 && t2 <= 65103, "Small Form Variants": (t2) => t2 >= 65104 && t2 <= 65135, "Arabic Presentation Forms-B": (t2) => t2 >= 65136 && t2 <= 65279, "Halfwidth and Fullwidth Forms": (t2) => t2 >= 65280 && t2 <= 65519, Osage: (t2) => t2 >= 66736 && t2 <= 66815, "CJK Unified Ideographs Extension B": (t2) => t2 >= 131072 && t2 <= 173791 };
          function Ks(t2) {
            for (const e2 of t2) if (to(e2.charCodeAt(0))) return true;
            return false;
          }
          function Js(t2) {
            for (const e2 of t2) if (!Qs(e2.charCodeAt(0))) return false;
            return true;
          }
          function Qs(t2) {
            return !(Ys.Arabic(t2) || Ys["Arabic Supplement"](t2) || Ys["Arabic Extended-A"](t2) || Ys["Arabic Presentation Forms-A"](t2) || Ys["Arabic Presentation Forms-B"](t2));
          }
          function to(t2) {
            return !(746 !== t2 && 747 !== t2 && (t2 < 4352 || !(Ys["Bopomofo Extended"](t2) || Ys.Bopomofo(t2) || Ys["CJK Compatibility Forms"](t2) && !(t2 >= 65097 && t2 <= 65103) || Ys["CJK Compatibility Ideographs"](t2) || Ys["CJK Compatibility"](t2) || Ys["CJK Radicals Supplement"](t2) || Ys["CJK Strokes"](t2) || !(!Ys["CJK Symbols and Punctuation"](t2) || t2 >= 12296 && t2 <= 12305 || t2 >= 12308 && t2 <= 12319 || 12336 === t2) || Ys["CJK Unified Ideographs Extension A"](t2) || Ys["CJK Unified Ideographs"](t2) || Ys["Enclosed CJK Letters and Months"](t2) || Ys["Hangul Compatibility Jamo"](t2) || Ys["Hangul Jamo Extended-A"](t2) || Ys["Hangul Jamo Extended-B"](t2) || Ys["Hangul Jamo"](t2) || Ys["Hangul Syllables"](t2) || Ys.Hiragana(t2) || Ys["Ideographic Description Characters"](t2) || Ys.Kanbun(t2) || Ys["Kangxi Radicals"](t2) || Ys["Katakana Phonetic Extensions"](t2) || Ys.Katakana(t2) && 12540 !== t2 || !(!Ys["Halfwidth and Fullwidth Forms"](t2) || 65288 === t2 || 65289 === t2 || 65293 === t2 || t2 >= 65306 && t2 <= 65310 || 65339 === t2 || 65341 === t2 || 65343 === t2 || t2 >= 65371 && t2 <= 65503 || 65507 === t2 || t2 >= 65512 && t2 <= 65519) || !(!Ys["Small Form Variants"](t2) || t2 >= 65112 && t2 <= 65118 || t2 >= 65123 && t2 <= 65126) || Ys["Unified Canadian Aboriginal Syllabics"](t2) || Ys["Unified Canadian Aboriginal Syllabics Extended"](t2) || Ys["Vertical Forms"](t2) || Ys["Yijing Hexagram Symbols"](t2) || Ys["Yi Syllables"](t2) || Ys["Yi Radicals"](t2))));
          }
          function eo(t2) {
            return !(to(t2) || function(t3) {
              return !!(Ys["Latin-1 Supplement"](t3) && (167 === t3 || 169 === t3 || 174 === t3 || 177 === t3 || 188 === t3 || 189 === t3 || 190 === t3 || 215 === t3 || 247 === t3) || Ys["General Punctuation"](t3) && (8214 === t3 || 8224 === t3 || 8225 === t3 || 8240 === t3 || 8241 === t3 || 8251 === t3 || 8252 === t3 || 8258 === t3 || 8263 === t3 || 8264 === t3 || 8265 === t3 || 8273 === t3) || Ys["Letterlike Symbols"](t3) || Ys["Number Forms"](t3) || Ys["Miscellaneous Technical"](t3) && (t3 >= 8960 && t3 <= 8967 || t3 >= 8972 && t3 <= 8991 || t3 >= 8996 && t3 <= 9e3 || 9003 === t3 || t3 >= 9085 && t3 <= 9114 || t3 >= 9150 && t3 <= 9165 || 9167 === t3 || t3 >= 9169 && t3 <= 9179 || t3 >= 9186 && t3 <= 9215) || Ys["Control Pictures"](t3) && 9251 !== t3 || Ys["Optical Character Recognition"](t3) || Ys["Enclosed Alphanumerics"](t3) || Ys["Geometric Shapes"](t3) || Ys["Miscellaneous Symbols"](t3) && !(t3 >= 9754 && t3 <= 9759) || Ys["Miscellaneous Symbols and Arrows"](t3) && (t3 >= 11026 && t3 <= 11055 || t3 >= 11088 && t3 <= 11097 || t3 >= 11192 && t3 <= 11243) || Ys["CJK Symbols and Punctuation"](t3) || Ys.Katakana(t3) || Ys["Private Use Area"](t3) || Ys["CJK Compatibility Forms"](t3) || Ys["Small Form Variants"](t3) || Ys["Halfwidth and Fullwidth Forms"](t3) || 8734 === t3 || 8756 === t3 || 8757 === t3 || t3 >= 9984 && t3 <= 10087 || t3 >= 10102 && t3 <= 10131 || 65532 === t3 || 65533 === t3);
            }(t2));
          }
          function ro(t2) {
            return Ys.Arabic(t2) || Ys["Arabic Supplement"](t2) || Ys["Arabic Extended-A"](t2) || Ys["Arabic Presentation Forms-A"](t2) || Ys["Arabic Presentation Forms-B"](t2);
          }
          function no(t2) {
            return t2 >= 1424 && t2 <= 2303 || Ys["Arabic Presentation Forms-A"](t2) || Ys["Arabic Presentation Forms-B"](t2);
          }
          function io(t2, e2) {
            return !(!e2 && no(t2) || t2 >= 2304 && t2 <= 3583 || t2 >= 3840 && t2 <= 4255 || Ys.Khmer(t2));
          }
          function so(t2) {
            for (const e2 of t2) if (no(e2.charCodeAt(0))) return true;
            return false;
          }
          const oo = { unavailable: "unavailable", deferred: "deferred", loading: "loading", parsing: "parsing", parsed: "parsed", loaded: "loaded", error: "error" };
          let ao = null, lo = oo.unavailable, uo = null;
          const co = function(t2) {
            t2 && "string" == typeof t2 && t2.indexOf("NetworkError") > -1 && (lo = oo.error), ao && ao(t2);
          };
          function ho() {
            po.fire(new Ye("pluginStateChange", { pluginStatus: lo, pluginURL: uo }));
          }
          const po = new tr(), fo = function() {
            return lo;
          }, mo = function() {
            if (lo !== oo.deferred || !uo) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            lo = oo.loading, ho(), uo && De({ url: uo }, (t2) => {
              t2 ? co(t2) : (lo = oo.loaded, ho());
            });
          }, yo = { applyArabicShaping: null, processBidirectionalText: null, processStyledBidirectionalText: null, isLoaded: () => lo === oo.loaded || null != yo.applyArabicShaping, isLoading: () => lo === oo.loading, setState(t2) {
            lo = t2.pluginStatus, uo = t2.pluginURL;
          }, isParsing: () => lo === oo.parsing, isParsed: () => lo === oo.parsed, getPluginURL: () => uo };
          class go {
            constructor(t2, e2) {
              this.zoom = t2, e2 ? (this.now = e2.now, this.fadeDuration = e2.fadeDuration, this.transition = e2.transition, this.pitch = e2.pitch, this.brightness = e2.brightness, this.worldview = e2.worldview) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
            isSupportedScript(t2) {
              return function(t3, e2) {
                for (const r2 of t3) if (!io(r2.charCodeAt(0), e2)) return false;
                return true;
              }(t2, yo.isLoaded());
            }
          }
          class xo {
            constructor(t2, e2, r2, n2) {
              this.property = t2, this.value = e2, this.expression = function(t3, e3, r3, n3) {
                if (Ms(t3)) return new Rs(t3, e3);
                if (Vs(t3) || Array.isArray(t3) && t3.length > 0) {
                  const i2 = Ls(t3, e3, r3, n3);
                  if ("error" === i2.result) throw new Error(i2.value.map((t4) => `${t4.key}: ${t4.message}`).join(", "));
                  return i2.value;
                }
                {
                  let r4 = t3;
                  return "string" == typeof t3 && "color" === e3.type && (r4 = sr.parse(t3)), { kind: "constant", configDependencies: /* @__PURE__ */ new Set(), evaluate: () => r4 };
                }
              }(void 0 === e2 ? t2.specification.default : e2, t2.specification, r2, n2);
            }
            isDataDriven() {
              return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(t2, e2, r2) {
              return this.property.possiblyEvaluate(this, t2, e2, r2);
            }
          }
          class vo {
            constructor(t2, e2, r2) {
              this.property = t2, this.value = new xo(t2, void 0, e2, r2);
            }
            transitioned(t2, e2) {
              return new wo(this.property, this.value, e2, Ct({}, t2.transition, this.transition), t2.now);
            }
            untransitioned() {
              return new wo(this.property, this.value, null, {}, 0);
            }
          }
          class bo {
            constructor(t2, e2, r2) {
              this._properties = t2, this._values = Object.create(t2.defaultTransitionablePropertyValues), this._scope = e2, this._options = r2, this.configDependencies = /* @__PURE__ */ new Set();
            }
            getValue(t2) {
              return Nt(this._values[t2].value.value);
            }
            setValue(t2, e2) {
              this._values.hasOwnProperty(t2) || (this._values[t2] = new vo(this._values[t2].property, this._scope, this._options)), this._values[t2].value = new xo(this._values[t2].property, null === e2 ? void 0 : Nt(e2), this._scope, this._options), this._values[t2].value.expression.configDependencies && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._values[t2].value.expression.configDependencies]));
            }
            setTransitionOrValue(t2, e2) {
              e2 && (this._options = e2);
              const r2 = this._properties.properties;
              if (t2) for (const e3 in t2) {
                const n2 = t2[e3];
                if (e3.endsWith("-transition")) {
                  const t3 = e3.slice(0, -11);
                  r2[t3] && this.setTransition(t3, n2);
                } else r2.hasOwnProperty(e3) && this.setValue(e3, n2);
              }
            }
            getTransition(t2) {
              return Nt(this._values[t2].transition);
            }
            setTransition(t2, e2) {
              this._values.hasOwnProperty(t2) || (this._values[t2] = new vo(this._values[t2].property)), this._values[t2].transition = Nt(e2) || void 0;
            }
            serialize() {
              const t2 = {};
              for (const e2 of Object.keys(this._values)) {
                const r2 = this.getValue(e2);
                void 0 !== r2 && (t2[e2] = r2);
                const n2 = this.getTransition(e2);
                void 0 !== n2 && (t2[`${e2}-transition`] = n2);
              }
              return t2;
            }
            transitioned(t2, e2) {
              const r2 = new _o(this._properties);
              for (const n2 of Object.keys(this._values)) r2._values[n2] = this._values[n2].transitioned(t2, e2._values[n2]);
              return r2;
            }
            untransitioned() {
              const t2 = new _o(this._properties);
              for (const e2 of Object.keys(this._values)) t2._values[e2] = this._values[e2].untransitioned();
              return t2;
            }
          }
          class wo {
            constructor(t2, e2, r2, n2, i2) {
              const s2 = n2.delay || 0, o2 = n2.duration || 0;
              i2 = i2 || 0, this.property = t2, this.value = e2, this.begin = i2 + s2, this.end = this.begin + o2, t2.specification.transition && (n2.delay || n2.duration) && (this.prior = r2);
            }
            possiblyEvaluate(t2, e2, r2) {
              const n2 = t2.now || 0, i2 = this.value.possiblyEvaluate(t2, e2, r2), s2 = this.prior;
              if (s2) {
                if (n2 > this.end) return this.prior = null, i2;
                if (this.value.isDataDriven()) return this.prior = null, i2;
                if (n2 < this.begin) return s2.possiblyEvaluate(t2, e2, r2);
                {
                  const o2 = (n2 - this.begin) / (this.end - this.begin);
                  return this.property.interpolate(s2.possiblyEvaluate(t2, e2, r2), i2, zt(o2));
                }
              }
              return i2;
            }
          }
          class _o {
            constructor(t2) {
              this._properties = t2, this._values = Object.create(t2.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(t2, e2, r2) {
              const n2 = new Io(this._properties);
              for (const i2 of Object.keys(this._values)) n2._values[i2] = this._values[i2].possiblyEvaluate(t2, e2, r2);
              return n2;
            }
            hasTransition() {
              for (const t2 of Object.keys(this._values)) if (this._values[t2].prior) return true;
              return false;
            }
          }
          class Ao {
            constructor(t2, e2, r2) {
              this._properties = t2, this._values = Object.create(t2.defaultPropertyValues), this._scope = e2, this._options = r2, this.configDependencies = /* @__PURE__ */ new Set();
            }
            getValue(t2) {
              return Nt(this._values[t2].value);
            }
            setValue(t2, e2) {
              this._values[t2] = new xo(this._values[t2].property, null === e2 ? void 0 : Nt(e2), this._scope, this._options), this._values[t2].expression.configDependencies && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._values[t2].expression.configDependencies]));
            }
            serialize() {
              const t2 = {};
              for (const e2 of Object.keys(this._values)) {
                const r2 = this.getValue(e2);
                void 0 !== r2 && (t2[e2] = r2);
              }
              return t2;
            }
            possiblyEvaluate(t2, e2, r2) {
              const n2 = new Io(this._properties);
              for (const i2 of Object.keys(this._values)) n2._values[i2] = this._values[i2].possiblyEvaluate(t2, e2, r2);
              return n2;
            }
          }
          class Mo {
            constructor(t2, e2, r2) {
              this.property = t2, this.value = e2, this.parameters = r2;
            }
            isConstant() {
              return "constant" === this.value.kind;
            }
            constantOr(t2) {
              return "constant" === this.value.kind ? this.value.value : t2;
            }
            evaluate(t2, e2, r2, n2) {
              return this.property.evaluate(this.value, this.parameters, t2, e2, r2, n2);
            }
          }
          class Io {
            constructor(t2) {
              this._properties = t2, this._values = Object.create(t2.defaultPossiblyEvaluatedValues);
            }
            get(t2) {
              return this._values[t2];
            }
          }
          class So {
            constructor(t2) {
              this.specification = t2;
            }
            possiblyEvaluate(t2, e2) {
              return t2.expression.evaluate(e2);
            }
            interpolate(t2, e2, r2) {
              const n2 = hr[this.specification.type];
              return n2 ? n2(t2, e2, r2) : t2;
            }
          }
          class zo {
            constructor(t2, e2) {
              this.specification = t2, this.overrides = e2;
            }
            possiblyEvaluate(t2, e2, r2, n2) {
              return new Mo(this, "constant" === t2.expression.kind || "camera" === t2.expression.kind ? { kind: "constant", value: t2.expression.evaluate(e2, null, {}, r2, n2) } : t2.expression, e2);
            }
            interpolate(t2, e2, r2) {
              if ("constant" !== t2.value.kind || "constant" !== e2.value.kind) return t2;
              if (void 0 === t2.value.value || void 0 === e2.value.value) return new Mo(this, { kind: "constant", value: void 0 }, t2.parameters);
              const n2 = hr[this.specification.type];
              return n2 ? new Mo(this, { kind: "constant", value: n2(t2.value.value, e2.value.value, r2) }, t2.parameters) : t2;
            }
            evaluate(t2, e2, r2, n2, i2, s2) {
              return "constant" === t2.kind ? t2.value : t2.evaluate(e2, r2, n2, i2, s2);
            }
          }
          class ko {
            constructor(t2) {
              this.specification = t2;
            }
            possiblyEvaluate(t2, e2, r2, n2) {
              return !!t2.expression.evaluate(e2, null, {}, r2, n2);
            }
            interpolate() {
              return false;
            }
          }
          class Po {
            constructor(t2) {
              this.properties = t2, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
              const e2 = new go(0, {});
              for (const r2 in t2) {
                const n2 = t2[r2];
                n2.specification.overridable && this.overridableProperties.push(r2);
                const i2 = this.defaultPropertyValues[r2] = new xo(n2, void 0), s2 = this.defaultTransitionablePropertyValues[r2] = new vo(n2);
                this.defaultTransitioningPropertyValues[r2] = s2.untransitioned(), this.defaultPossiblyEvaluatedValues[r2] = i2.possiblyEvaluate(e2);
              }
            }
          }
          qs(zo, "DataDrivenProperty"), qs(So, "DataConstantProperty"), qs(ko, "ColorRampProperty");
          var Eo = JSON.parse('{"$version":8,"$root":{"version":{"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"snow":{"type":"snow"},"rain":{"type":"rain"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"indoor":{"type":"indoor"},"imports":{"type":"array","value":"import"},"iconsets":{"type":"iconsets"},"schema":{"type":"schema"},"sources":{"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"type":"featuresets"}},"featuresets":{"*":{"type":"featureset"}},"featureset":{"metadata":{"type":"*"},"selectors":{"type":"array","value":"selector"}},"selector":{"layer":{"type":"string"},"properties":{"type":"selectorProperty"},"featureNamespace":{"type":"string"},"_uniqueFeatureID":{"type":"boolean"}},"selectorProperty":{"*":{"type":"*"}},"model":{"type":"string"},"import":{"id":{"type":"string"},"url":{"type":"string"},"config":{"type":"config"},"data":{"type":"$root"},"color-theme":{"type":"colorTheme","optional":true}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","expression":{}},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string"},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false},"shadow-quality":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"parameters":["zoom"]}},"shadow-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"iconsets":{"*":{"type":"iconset"}},"iconset":["iconset_sprite","iconset_source"],"iconset_sprite":{"type":{"type":"enum","values":{"sprite":1}},"url":{"type":"string"}},"iconset_source":{"type":{"type":"enum","values":{"source":1}},"source":{"type":"string"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"type":{"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"type":"enum","values":{"video":1}},"urls":{"type":"array","value":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"type":"enum","values":{"image":1}},"url":{"type":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string"},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"building":{},"raster":{},"raster-particle":{},"hillshade":{},"model":{},"background":{},"sky":{},"slot":{},"clip":{}}},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_building","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{}},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{}}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"fill-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-base":1,"hd-road-markup":1},"default":"none","expression":{}},"fill-construct-bridge-guard-rail":{"type":"boolean","default":"true","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"circle-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-markup":1},"default":"none","expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"fill-extrusion-edge-radius":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}}},"layout_building":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"building-roof-shape":{"type":"enum","values":{"flat":1,"hipped":1,"gabled":1,"parapet":1,"mansard":1,"skillion":1,"pyramidal":1},"default":"flat","expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{},"property-type":"data-driven"},"building-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{},"property-type":"data-driven"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","default":0,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"line-elevation-reference":{"type":"enum","values":{"none":1,"sea":1,"ground":1,"hd-road-markup":1},"default":"none","expression":{}},"line-cross-slope":{"type":"number","expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"line-width-unit":{"type":"enum","values":{"pixels":1,"meters":1},"default":"pixels","expression":{"parameters":["zoom"]}}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]}},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]}},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]}},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1,"hd-road-markup":1},"default":"ground","expression":{"parameters":["zoom"]}},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"expression":{}},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":0.1,"maximum":10,"expression":{}},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]}},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]}},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_hillshade":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster-particle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_clip":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_model":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_building":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*"}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"high-color":{"type":"color","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"space-color":{"type":"color","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"horizon-blend":{"type":"number","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"snow":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.85],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.3],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"center-thinning":{"type":"number","default":0.4,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,50],"minimum":0,"maximum":360,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"flake-size":{"type":"number","default":0.71,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"rain":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.5],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#03113d",0.3,"#a8adbc"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"opacity":{"type":"number","default":["interpolate",["linear"],["measure-light","brightness"],0,0.88,1,0.7],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#001736",0.3,"#464646"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"center-thinning":{"type":"number","default":0.57,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,80],"minimum":0,"maximum":360,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"droplet-size":{"type":"array","default":[2.6,18.2],"minimum":0,"maximum":50,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"distortion-strength":{"type":"number","default":0.7,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective"}},"colorTheme":{"data":{"type":"string","expression":{}}},"indoor":{"floorplanFeaturesetId":{"type":"string","expression":{}},"buildingFeaturesetId":{"type":"string","expression":{}}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator"},"center":{"type":"array","length":2,"value":"number","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string"},"exaggeration":{"type":"number","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_building","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-bridge-guard-rail-color":{"type":"color","default":"rgba(241, 236, 225, 255)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature"]},"property-type":"data-driven"},"fill-tunnel-structure-color":{"type":"color","default":"rgba(241, 236, 225, 255)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-height-alignment":{"type":"enum","values":{"terrain":1,"flat":1},"default":"flat"},"fill-extrusion-base-alignment":{"type":"enum","values":{"terrain":1,"flat":1},"default":"terrain"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"type":"color","default":"#ffffff","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true}},"paint_building":{"building-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-ambient-occlusion-wall-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-vertical-scale":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-cast-shadows":{"type":"boolean","default":true},"building-color":{"type":"color","default":"rgba(193, 154, 127, 1)","use-theme":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]},"property-type":"data-driven"},"building-emissive-strength":{"type":"number","default":0,"minimum":0,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"property-type":"data-driven"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light","line-progress"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-gradient":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["line-progress"]}},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1]},"line-trim-fade-range":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-trim-color":{"type":"color","default":"transparent","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-border-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]}},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"use-theme":true,"expression":{"interpolated":true,"parameters":["heatmap-density"]}},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"icon-image-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{}},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{}},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{}},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["raster-value"]}},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]}},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"raster-array-band":{"type":"string"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string"},"raster-particle-count":{"type":"number","default":512,"minimum":1},"raster-particle-color":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["raster-particle-speed"]}},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]}},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]}},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"hillshade-shadow-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-accent-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_background":{"background-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":[]}},"background-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]}},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]}},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]}},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]}},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]}},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"use-theme":true,"expression":{"interpolated":true,"parameters":["sky-radial-progress"]}},"sky-atmosphere-halo-color":{"type":"color","default":"white","use-theme":true},"sky-atmosphere-color":{"type":"color","default":"white","use-theme":true},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"property-type":"data-driven"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"use-theme":true,"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d"},"model-cast-shadows":{"type":"boolean","default":true},"model-receive-shadows":{"type":"boolean","default":true},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"model-front-cutoff":{"type":"array","value":"number","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"promoteId":{"*":{"type":"*"}}}');
          function To(t2) {
            return t2 instanceof Number || t2 instanceof String || t2 instanceof Boolean ? t2.valueOf() : t2;
          }
          function Bo(t2) {
            if (Array.isArray(t2)) return t2.map(Bo);
            if (t2 instanceof Object && !(t2 instanceof Number || t2 instanceof String || t2 instanceof Boolean)) {
              const e2 = {};
              for (const r2 in t2) e2[r2] = Bo(t2[r2]);
              return e2;
            }
            return To(t2);
          }
          function Vo(t2) {
            if (true === t2 || false === t2) return true;
            if (!Array.isArray(t2) || 0 === t2.length) return false;
            switch (t2[0]) {
              case "has":
                return t2.length >= 2 && "$id" !== t2[1] && "$type" !== t2[1];
              case "in":
                return t2.length >= 3 && ("string" != typeof t2[1] || Array.isArray(t2[2]));
              case "!in":
              case "!has":
              case "none":
                return false;
              case "==":
              case "!=":
              case ">":
              case ">=":
              case "<":
              case "<=":
                return 3 !== t2.length || Array.isArray(t2[1]) || Array.isArray(t2[2]);
              case "any":
              case "all":
                for (const e2 of t2.slice(1)) if (!Vo(e2) && "boolean" != typeof e2) return false;
                return true;
              default:
                return true;
            }
          }
          function Co(t2, e2 = "", r2 = null, n2 = "fill") {
            if (null == t2) return { filter: () => true, needGeometry: false, needFeature: false };
            Vo(t2) || (t2 = No(t2));
            const i2 = t2;
            let s2 = true;
            try {
              s2 = function(t3) {
                if (!Lo(t3)) return t3;
                let e3 = Bo(t3);
                return Do(e3), e3 = Fo(e3), e3;
              }(i2);
            } catch (t3) {
              console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.
This is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md
and paste the contents of this message in the report.
Thank you!
Filter Expression:
${JSON.stringify(i2, null, 2)}
        `);
            }
            let o2 = null, a2 = null;
            if ("background" !== n2 && "sky" !== n2 && "slot" !== n2) {
              a2 = Eo[`filter_${n2}`];
              const t3 = Cs(s2, a2, e2, r2);
              if ("error" === t3.result) throw new Error(t3.value.map((t4) => `${t4.key}: ${t4.message}`).join(", "));
              o2 = (e3, r3, n3) => t3.value.evaluate(e3, r3, {}, n3);
            }
            let l2 = null, u2 = null;
            if (s2 !== i2) {
              const t3 = Cs(i2, a2, e2, r2);
              if ("error" === t3.result) throw new Error(t3.value.map((t4) => `${t4.key}: ${t4.message}`).join(", "));
              l2 = (e3, r3, n3, i3, s3) => t3.value.evaluate(e3, r3, {}, n3, void 0, void 0, i3, s3), u2 = !hi(t3.value.expression);
            }
            return { filter: o2, dynamicFilter: l2 || void 0, needGeometry: Uo(s2), needFeature: !!u2 };
          }
          function Fo(t2) {
            if (!Array.isArray(t2)) return t2;
            const e2 = function(t3) {
              if (Ro.has(t3[0])) {
                for (let e3 = 1; e3 < t3.length; e3++) if (Lo(t3[e3])) return true;
              }
              return t3;
            }(t2);
            return true === e2 ? e2 : e2.map((t3) => Fo(t3));
          }
          function Do(t2) {
            let e2 = false;
            const r2 = [];
            if ("case" === t2[0]) {
              for (let n2 = 1; n2 < t2.length - 1; n2 += 2) e2 = e2 || Lo(t2[n2]), r2.push(t2[n2 + 1]);
              r2.push(t2[t2.length - 1]);
            } else if ("match" === t2[0]) {
              e2 = e2 || Lo(t2[1]);
              for (let e3 = 2; e3 < t2.length - 1; e3 += 2) r2.push(t2[e3 + 1]);
              r2.push(t2[t2.length - 1]);
            } else if ("step" === t2[0]) {
              e2 = e2 || Lo(t2[1]);
              for (let e3 = 1; e3 < t2.length - 1; e3 += 2) r2.push(t2[e3 + 1]);
            }
            e2 && (t2.length = 0, t2.push("any", ...r2));
            for (let e3 = 1; e3 < t2.length; e3++) Do(t2[e3]);
          }
          function Lo(t2) {
            if (!Array.isArray(t2)) return false;
            if ("pitch" === (e2 = t2[0]) || "distance-from-center" === e2) return true;
            var e2;
            for (let e3 = 1; e3 < t2.length; e3++) if (Lo(t2[e3])) return true;
            return false;
          }
          const Ro = /* @__PURE__ */ new Set(["in", "==", "!=", ">", ">=", "<", "<=", "to-boolean"]);
          function Oo(t2, e2) {
            return t2 < e2 ? -1 : t2 > e2 ? 1 : 0;
          }
          function Uo(t2) {
            if (!Array.isArray(t2)) return false;
            if ("within" === t2[0] || "distance" === t2[0]) return true;
            for (let e2 = 1; e2 < t2.length; e2++) if (Uo(t2[e2])) return true;
            return false;
          }
          function No(t2) {
            if (!t2) return true;
            const e2 = t2[0];
            return t2.length <= 1 ? "any" !== e2 : "==" === e2 ? jo(t2[1], t2[2], "==") : "!=" === e2 ? qo(jo(t2[1], t2[2], "==")) : "<" === e2 || ">" === e2 || "<=" === e2 || ">=" === e2 ? jo(t2[1], t2[2], e2) : "any" === e2 ? (r2 = t2.slice(1), ["any"].concat(r2.map(No))) : "all" === e2 ? ["all"].concat(t2.slice(1).map(No)) : "none" === e2 ? ["all"].concat(t2.slice(1).map(No).map(qo)) : "in" === e2 ? $o(t2[1], t2.slice(2)) : "!in" === e2 ? qo($o(t2[1], t2.slice(2))) : "has" === e2 ? Go(t2[1]) : "!has" !== e2 || qo(Go(t2[1]));
            var r2;
          }
          function jo(t2, e2, r2) {
            switch (t2) {
              case "$type":
                return [`filter-type-${r2}`, e2];
              case "$id":
                return [`filter-id-${r2}`, e2];
              default:
                return [`filter-${r2}`, t2, e2];
            }
          }
          function $o(t2, e2) {
            if (0 === e2.length) return false;
            switch (t2) {
              case "$type":
                return ["filter-type-in", ["literal", e2]];
              case "$id":
                return ["filter-id-in", ["literal", e2]];
              default:
                return e2.length > 200 && !e2.some((t3) => typeof t3 != typeof e2[0]) ? ["filter-in-large", t2, ["literal", e2.sort(Oo)]] : ["filter-in-small", t2, ["literal", e2]];
            }
          }
          function Go(t2) {
            switch (t2) {
              case "$type":
                return true;
              case "$id":
                return ["filter-has-id"];
              default:
                return ["filter-has", t2];
            }
          }
          function qo(t2) {
            return ["!", t2];
          }
          const Ho = "";
          function Xo(t2, e2) {
            return e2 ? `${t2}${Ho}${e2}` : t2;
          }
          const Zo = "-transition", Wo = /* @__PURE__ */ new Set(["fill", "line", "background", "hillshade", "raster"]);
          class Yo extends tr {
            constructor(t2, e2, r2, n2, i2) {
              if (super(), this.id = t2.id, this.fqid = Xo(this.id, r2), this.type = t2.type, this.scope = r2, this.lut = n2, this.options = i2, this._featureFilter = { filter: () => true, needGeometry: false, needFeature: false }, this._filterCompiled = false, this.configDependencies = /* @__PURE__ */ new Set(), "custom" !== t2.type) {
                if (this.metadata = t2.metadata, this.minzoom = t2.minzoom, this.maxzoom = t2.maxzoom, t2.type && "background" !== t2.type && "sky" !== t2.type && "slot" !== t2.type) {
                  this.source = t2.source, this.sourceLayer = t2["source-layer"], this.filter = t2.filter;
                  const e3 = Cs(this.filter, Eo[`filter_${t2.type}`]);
                  "error" !== e3.result && (this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...e3.value.configDependencies]));
                }
                if (t2.slot && (this.slot = t2.slot), e2.layout && (this._unevaluatedLayout = new Ao(e2.layout, this.scope, i2), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._unevaluatedLayout.configDependencies])), e2.paint) {
                  this._transitionablePaint = new bo(e2.paint, this.scope, i2);
                  for (const e3 in t2.paint) this.setPaintProperty(e3, t2.paint[e3]);
                  for (const e3 in t2.layout) this.setLayoutProperty(e3, t2.layout[e3]);
                  this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...this._transitionablePaint.configDependencies]), this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Io(e2.paint);
                }
              }
            }
            onAdd(t2) {
            }
            onRemove(t2) {
            }
            isDraped(t2) {
              return !this.is3D(true) && Wo.has(this.type);
            }
            getLayoutProperty(t2) {
              return "visibility" === t2 ? this.visibility : this._unevaluatedLayout.getValue(t2);
            }
            setLayoutProperty(t2, e2) {
              if ("custom" === this.type && "visibility" === t2) return void (this.visibility = e2);
              const r2 = this._unevaluatedLayout;
              r2._properties.properties[t2] && (r2.setValue(t2, e2), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...r2.configDependencies]), "visibility" === t2 && this.possiblyEvaluateVisibility());
            }
            possiblyEvaluateVisibility() {
              this._unevaluatedLayout._values.visibility && (this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({ zoom: 0 }));
            }
            getPaintProperty(t2) {
              return t2.endsWith(Zo) ? this._transitionablePaint.getTransition(t2.slice(0, -11)) : this._transitionablePaint.getValue(t2);
            }
            setPaintProperty(t2, e2) {
              const r2 = this._transitionablePaint, n2 = r2._properties.properties;
              if (t2.endsWith(Zo)) {
                const i3 = t2.slice(0, -11);
                return n2[i3] && r2.setTransition(i3, e2 || void 0), false;
              }
              if (!n2[t2]) return false;
              const i2 = r2._values[t2], s2 = i2.value.isDataDriven(), o2 = i2.value;
              r2.setValue(t2, e2), this.configDependencies = /* @__PURE__ */ new Set([...this.configDependencies, ...r2.configDependencies]), this._handleSpecialPaintPropertyUpdate(t2);
              const a2 = r2._values[t2].value, l2 = a2.isDataDriven(), u2 = t2.endsWith("pattern") || "line-dasharray" === t2;
              return l2 || s2 || u2 || this._handleOverridablePaintPropertyUpdate(t2, o2, a2);
            }
            _handleSpecialPaintPropertyUpdate(t2) {
            }
            getProgramIds() {
              return null;
            }
            getDefaultProgramParams(t2, e2, r2) {
              return null;
            }
            _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
              return false;
            }
            isHidden(t2) {
              return !!(this.minzoom && t2 < this.minzoom) || !!(this.maxzoom && t2 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(t2) {
              this._transitioningPaint = this._transitionablePaint.transitioned(t2, this._transitioningPaint);
            }
            hasTransition() {
              return this._transitioningPaint.hasTransition();
            }
            recalculate(t2, e2) {
              this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t2, void 0, e2)), this.paint = this._transitioningPaint.possiblyEvaluate(t2, void 0, e2);
            }
            serialize() {
              return Ut({ id: this.id, type: this.type, slot: this.slot, source: this.source, "source-layer": this.sourceLayer, metadata: this.metadata, minzoom: this.minzoom, maxzoom: this.maxzoom, filter: this.filter, layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(), paint: this._transitionablePaint && this._transitionablePaint.serialize() }, (t2, e2) => !(void 0 === t2 || "layout" === e2 && !Object.keys(t2).length || "paint" === e2 && !Object.keys(t2).length));
            }
            is3D(t2) {
              return false;
            }
            hasElevation() {
              return false;
            }
            isSky() {
              return false;
            }
            isTileClipped() {
              return false;
            }
            hasOffscreenPass() {
              return false;
            }
            hasShadowPass() {
              return false;
            }
            canCastShadows() {
              return false;
            }
            hasLightBeamPass() {
              return false;
            }
            cutoffRange() {
              return 0;
            }
            tileCoverLift() {
              return 0;
            }
            resize() {
            }
            isStateDependent() {
              for (const t2 in this.paint._values) {
                const e2 = this.paint.get(t2);
                if (e2 instanceof Mo && bs(e2.property.specification) && ("source" === e2.value.kind || "composite" === e2.value.kind) && e2.value.isStateDependent) return true;
              }
              return false;
            }
            compileFilter(t2) {
              this._filterCompiled || (this._featureFilter = Co(this.filter, this.scope, t2), this._filterCompiled = true);
            }
            invalidateCompiledFilter() {
              this._filterCompiled = false;
            }
            dynamicFilter() {
              return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
              return this._featureFilter.needFeature;
            }
            getLayerRenderingStats() {
              return this._stats;
            }
            resetLayerRenderingStats(t2) {
              this._stats && ("shadow" === t2.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
            }
            queryRadius(t2) {
            }
            queryIntersectsFeature(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            }
          }
          const Ko = { Int8: Int8Array, Uint8: Uint8Array, Int16: Int16Array, Uint16: Uint16Array, Int32: Int32Array, Uint32: Uint32Array, Float32: Float32Array };
          class Jo {
            constructor(t2, e2) {
              this._structArray = t2, this._pos1 = e2 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
          }
          class Qo {
            constructor() {
              this.capacity = -1, this.resize(0);
            }
            static serialize(t2, e2) {
              return t2._trim(), e2 && e2.add(t2.arrayBuffer), { length: t2.length, arrayBuffer: t2.arrayBuffer };
            }
            static deserialize(t2) {
              const e2 = Object.create(this.prototype);
              return e2.arrayBuffer = t2.arrayBuffer, e2.length = t2.length, e2.capacity = t2.arrayBuffer.byteLength / e2.bytesPerElement, e2._refreshViews(), e2;
            }
            _trim() {
              this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
              this.length = 0;
            }
            resize(t2) {
              this.reserve(t2), this.length = t2;
            }
            reserve(t2) {
              if (t2 > this.capacity) {
                this.capacity = Math.max(t2, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                const e2 = this.uint8;
                this._refreshViews(), e2 && this.uint8.set(e2);
              }
            }
            _refreshViews() {
              throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
            }
            emplace(...t2) {
              throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
            }
            emplaceBack(...t2) {
              throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
            }
            destroy() {
              this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
          }
          function ta(t2, e2 = 1) {
            let r2 = 0, n2 = 0;
            return { members: t2.map((t3) => {
              const i2 = Ko[t3.type].BYTES_PER_ELEMENT, s2 = r2 = ea(r2, Math.max(e2, i2)), o2 = t3.components || 1;
              return n2 = Math.max(n2, i2), r2 += i2 * o2, { name: t3.name, type: t3.type, components: o2, offset: s2 };
            }), size: ea(r2, Math.max(n2, e2)), alignment: e2 };
          }
          function ea(t2, e2) {
            return Math.ceil(t2 / e2) * e2;
          }
          class ra extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2) {
              const r2 = this.length;
              return this.resize(r2 + 1), this.emplace(r2, t2, e2);
            }
            emplace(t2, e2, r2) {
              const n2 = 2 * t2;
              return this.int16[n2 + 0] = e2, this.int16[n2 + 1] = r2, t2;
            }
          }
          ra.prototype.bytesPerElement = 4, qs(ra, "StructArrayLayout2i4");
          class na extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2) {
              const n2 = this.length;
              return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
            }
            emplace(t2, e2, r2, n2) {
              const i2 = 3 * t2;
              return this.int16[i2 + 0] = e2, this.int16[i2 + 1] = r2, this.int16[i2 + 2] = n2, t2;
            }
          }
          na.prototype.bytesPerElement = 6, qs(na, "StructArrayLayout3i6");
          class ia extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2) {
              const i2 = this.length;
              return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
            }
            emplace(t2, e2, r2, n2, i2) {
              const s2 = 4 * t2;
              return this.int16[s2 + 0] = e2, this.int16[s2 + 1] = r2, this.int16[s2 + 2] = n2, this.int16[s2 + 3] = i2, t2;
            }
          }
          ia.prototype.bytesPerElement = 8, qs(ia, "StructArrayLayout4i8");
          class sa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2) {
              const e2 = this.length;
              return this.resize(e2 + 1), this.emplace(e2, t2);
            }
            emplace(t2, e2) {
              return this.float32[1 * t2 + 0] = e2, t2;
            }
          }
          sa.prototype.bytesPerElement = 4, qs(sa, "StructArrayLayout1f4");
          class oa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2) {
              const n2 = this.length;
              return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
            }
            emplace(t2, e2, r2, n2) {
              const i2 = 4 * t2, s2 = 2 * t2;
              return this.int16[i2 + 0] = e2, this.int16[i2 + 1] = r2, this.float32[s2 + 1] = n2, t2;
            }
          }
          oa.prototype.bytesPerElement = 8, qs(oa, "StructArrayLayout2i1f8");
          class aa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2) {
              const n2 = this.length;
              return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
            }
            emplace(t2, e2, r2, n2) {
              const i2 = 4 * t2;
              return this.int16[i2 + 0] = e2, this.int16[i2 + 1] = r2, this.int16[i2 + 2] = n2, t2;
            }
          }
          aa.prototype.bytesPerElement = 8, qs(aa, "StructArrayLayout3i8");
          class la extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2) {
              const s2 = this.length;
              return this.resize(s2 + 1), this.emplace(s2, t2, e2, r2, n2, i2);
            }
            emplace(t2, e2, r2, n2, i2, s2) {
              const o2 = 5 * t2;
              return this.int16[o2 + 0] = e2, this.int16[o2 + 1] = r2, this.int16[o2 + 2] = n2, this.int16[o2 + 3] = i2, this.int16[o2 + 4] = s2, t2;
            }
          }
          la.prototype.bytesPerElement = 10, qs(la, "StructArrayLayout5i10");
          class ua extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2) {
              const a2 = this.length;
              return this.resize(a2 + 1), this.emplace(a2, t2, e2, r2, n2, i2, s2, o2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = 6 * t2, u2 = 12 * t2, c2 = 3 * t2;
              return this.int16[l2 + 0] = e2, this.int16[l2 + 1] = r2, this.uint8[u2 + 4] = n2, this.uint8[u2 + 5] = i2, this.uint8[u2 + 6] = s2, this.uint8[u2 + 7] = o2, this.float32[c2 + 2] = a2, t2;
            }
          }
          ua.prototype.bytesPerElement = 12, qs(ua, "StructArrayLayout2i4ub1f12");
          class ca extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2) {
              const n2 = this.length;
              return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
            }
            emplace(t2, e2, r2, n2) {
              const i2 = 3 * t2;
              return this.float32[i2 + 0] = e2, this.float32[i2 + 1] = r2, this.float32[i2 + 2] = n2, t2;
            }
          }
          ca.prototype.bytesPerElement = 12, qs(ca, "StructArrayLayout3f12");
          class ha extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2) {
              const s2 = this.length;
              return this.resize(s2 + 1), this.emplace(s2, t2, e2, r2, n2, i2);
            }
            emplace(t2, e2, r2, n2, i2, s2) {
              const o2 = 6 * t2, a2 = 3 * t2;
              return this.uint16[o2 + 0] = e2, this.uint16[o2 + 1] = r2, this.uint16[o2 + 2] = n2, this.uint16[o2 + 3] = i2, this.float32[a2 + 2] = s2, t2;
            }
          }
          ha.prototype.bytesPerElement = 12, qs(ha, "StructArrayLayout4ui1f12");
          class pa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2) {
              const i2 = this.length;
              return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
            }
            emplace(t2, e2, r2, n2, i2) {
              const s2 = 4 * t2;
              return this.uint16[s2 + 0] = e2, this.uint16[s2 + 1] = r2, this.uint16[s2 + 2] = n2, this.uint16[s2 + 3] = i2, t2;
            }
          }
          pa.prototype.bytesPerElement = 8, qs(pa, "StructArrayLayout4ui8");
          class fa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2) {
              const o2 = this.length;
              return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2) {
              const a2 = 6 * t2;
              return this.int16[a2 + 0] = e2, this.int16[a2 + 1] = r2, this.int16[a2 + 2] = n2, this.int16[a2 + 3] = i2, this.int16[a2 + 4] = s2, this.int16[a2 + 5] = o2, t2;
            }
          }
          fa.prototype.bytesPerElement = 12, qs(fa, "StructArrayLayout6i12");
          class da extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3) {
              const p3 = this.length;
              return this.resize(p3 + 1), this.emplace(p3, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3) {
              const f2 = 12 * t2;
              return this.int16[f2 + 0] = e2, this.int16[f2 + 1] = r2, this.int16[f2 + 2] = n2, this.int16[f2 + 3] = i2, this.uint16[f2 + 4] = s2, this.uint16[f2 + 5] = o2, this.uint16[f2 + 6] = a2, this.uint16[f2 + 7] = l2, this.int16[f2 + 8] = u2, this.int16[f2 + 9] = c2, this.int16[f2 + 10] = h3, this.int16[f2 + 11] = p3, t2;
            }
          }
          da.prototype.bytesPerElement = 24, qs(da, "StructArrayLayout4i4ui4i24");
          class ma extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2) {
              const o2 = this.length;
              return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2) {
              const a2 = 10 * t2, l2 = 5 * t2;
              return this.int16[a2 + 0] = e2, this.int16[a2 + 1] = r2, this.int16[a2 + 2] = n2, this.float32[l2 + 2] = i2, this.float32[l2 + 3] = s2, this.float32[l2 + 4] = o2, t2;
            }
          }
          ma.prototype.bytesPerElement = 20, qs(ma, "StructArrayLayout3i3f20");
          class ya extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2) {
              const i2 = this.length;
              return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
            }
            emplace(t2, e2, r2, n2, i2) {
              const s2 = 4 * t2;
              return this.float32[s2 + 0] = e2, this.float32[s2 + 1] = r2, this.float32[s2 + 2] = n2, this.float32[s2 + 3] = i2, t2;
            }
          }
          ya.prototype.bytesPerElement = 16, qs(ya, "StructArrayLayout4f16");
          class ga extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t2) {
              const e2 = this.length;
              return this.resize(e2 + 1), this.emplace(e2, t2);
            }
            emplace(t2, e2) {
              return this.uint32[1 * t2 + 0] = e2, t2;
            }
          }
          ga.prototype.bytesPerElement = 4, qs(ga, "StructArrayLayout1ul4");
          class xa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2) {
              const r2 = this.length;
              return this.resize(r2 + 1), this.emplace(r2, t2, e2);
            }
            emplace(t2, e2, r2) {
              const n2 = 2 * t2;
              return this.uint16[n2 + 0] = e2, this.uint16[n2 + 1] = r2, t2;
            }
          }
          xa.prototype.bytesPerElement = 4, qs(xa, "StructArrayLayout2ui4");
          class va extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3) {
              const f2 = this.length;
              return this.resize(f2 + 1), this.emplace(f2, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2) {
              const d2 = 20 * t2, m2 = 10 * t2;
              return this.int16[d2 + 0] = e2, this.int16[d2 + 1] = r2, this.int16[d2 + 2] = n2, this.int16[d2 + 3] = i2, this.int16[d2 + 4] = s2, this.float32[m2 + 3] = o2, this.float32[m2 + 4] = a2, this.float32[m2 + 5] = l2, this.float32[m2 + 6] = u2, this.int16[d2 + 14] = c2, this.uint32[m2 + 8] = h3, this.uint16[d2 + 18] = p3, this.uint16[d2 + 19] = f2, t2;
            }
          }
          va.prototype.bytesPerElement = 40, qs(va, "StructArrayLayout5i4f1i1ul2ui40");
          class ba extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2) {
              const a2 = this.length;
              return this.resize(a2 + 1), this.emplace(a2, t2, e2, r2, n2, i2, s2, o2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = 8 * t2;
              return this.int16[l2 + 0] = e2, this.int16[l2 + 1] = r2, this.int16[l2 + 2] = n2, this.int16[l2 + 4] = i2, this.int16[l2 + 5] = s2, this.int16[l2 + 6] = o2, this.int16[l2 + 7] = a2, t2;
            }
          }
          ba.prototype.bytesPerElement = 16, qs(ba, "StructArrayLayout3i2i2i16");
          class wa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2) {
              const s2 = this.length;
              return this.resize(s2 + 1), this.emplace(s2, t2, e2, r2, n2, i2);
            }
            emplace(t2, e2, r2, n2, i2, s2) {
              const o2 = 4 * t2, a2 = 8 * t2;
              return this.float32[o2 + 0] = e2, this.float32[o2 + 1] = r2, this.float32[o2 + 2] = n2, this.int16[a2 + 6] = i2, this.int16[a2 + 7] = s2, t2;
            }
          }
          wa.prototype.bytesPerElement = 16, qs(wa, "StructArrayLayout2f1f2i16");
          class _a extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2) {
              const o2 = this.length;
              return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2) {
              const a2 = 20 * t2, l2 = 5 * t2;
              return this.uint8[a2 + 0] = e2, this.uint8[a2 + 1] = r2, this.float32[l2 + 1] = n2, this.float32[l2 + 2] = i2, this.float32[l2 + 3] = s2, this.float32[l2 + 4] = o2, t2;
            }
          }
          _a.prototype.bytesPerElement = 20, qs(_a, "StructArrayLayout2ub4f20");
          class Aa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2) {
              const n2 = this.length;
              return this.resize(n2 + 1), this.emplace(n2, t2, e2, r2);
            }
            emplace(t2, e2, r2, n2) {
              const i2 = 3 * t2;
              return this.uint16[i2 + 0] = e2, this.uint16[i2 + 1] = r2, this.uint16[i2 + 2] = n2, t2;
            }
          }
          Aa.prototype.bytesPerElement = 6, qs(Aa, "StructArrayLayout3ui6");
          class Ma extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2, g2, x2, v2, b2) {
              const w2 = this.length;
              return this.resize(w2 + 1), this.emplace(w2, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2, g2, x2, v2, b2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2, g2, x2, v2, b2, w2) {
              const _2 = 30 * t2, A2 = 15 * t2, M2 = 60 * t2;
              return this.int16[_2 + 0] = e2, this.int16[_2 + 1] = r2, this.int16[_2 + 2] = n2, this.float32[A2 + 2] = i2, this.float32[A2 + 3] = s2, this.uint16[_2 + 8] = o2, this.uint16[_2 + 9] = a2, this.uint32[A2 + 5] = l2, this.uint32[A2 + 6] = u2, this.uint32[A2 + 7] = c2, this.uint16[_2 + 16] = h3, this.uint16[_2 + 17] = p3, this.uint16[_2 + 18] = f2, this.float32[A2 + 10] = d2, this.float32[A2 + 11] = m2, this.uint8[M2 + 48] = y2, this.uint8[M2 + 49] = g2, this.uint8[M2 + 50] = x2, this.uint32[A2 + 13] = v2, this.int16[_2 + 28] = b2, this.uint8[M2 + 58] = w2, t2;
            }
          }
          Ma.prototype.bytesPerElement = 60, qs(Ma, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
          class Ia extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2, g2, x2, v2, b2, w2, _2, A2, M2, I2, S2, z2, k2, P2, E2, T2, B2) {
              const V2 = this.length;
              return this.resize(V2 + 1), this.emplace(V2, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2, g2, x2, v2, b2, w2, _2, A2, M2, I2, S2, z2, k2, P2, E2, T2, B2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2, g2, x2, v2, b2, w2, _2, A2, M2, I2, S2, z2, k2, P2, E2, T2, B2, V2) {
              const C2 = 20 * t2, F2 = 40 * t2, D2 = 80 * t2;
              return this.float32[C2 + 0] = e2, this.float32[C2 + 1] = r2, this.int16[F2 + 4] = n2, this.int16[F2 + 5] = i2, this.int16[F2 + 6] = s2, this.int16[F2 + 7] = o2, this.int16[F2 + 8] = a2, this.int16[F2 + 9] = l2, this.int16[F2 + 10] = u2, this.int16[F2 + 11] = c2, this.int16[F2 + 12] = h3, this.uint16[F2 + 13] = p3, this.uint16[F2 + 14] = f2, this.uint16[F2 + 15] = d2, this.uint16[F2 + 16] = m2, this.uint16[F2 + 17] = y2, this.uint16[F2 + 18] = g2, this.uint16[F2 + 19] = x2, this.uint16[F2 + 20] = v2, this.uint16[F2 + 21] = b2, this.uint16[F2 + 22] = w2, this.uint16[F2 + 23] = _2, this.uint16[F2 + 24] = A2, this.uint16[F2 + 25] = M2, this.uint16[F2 + 26] = I2, this.uint16[F2 + 27] = S2, this.uint32[C2 + 14] = z2, this.float32[C2 + 15] = k2, this.float32[C2 + 16] = P2, this.float32[C2 + 17] = E2, this.float32[C2 + 18] = T2, this.uint8[D2 + 76] = B2, this.uint16[F2 + 39] = V2, t2;
            }
          }
          Ia.prototype.bytesPerElement = 80, qs(Ia, "StructArrayLayout2f9i15ui1ul4f1ub1ui80");
          class Sa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2) {
              const o2 = this.length;
              return this.resize(o2 + 1), this.emplace(o2, t2, e2, r2, n2, i2, s2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2) {
              const a2 = 6 * t2;
              return this.float32[a2 + 0] = e2, this.float32[a2 + 1] = r2, this.float32[a2 + 2] = n2, this.float32[a2 + 3] = i2, this.float32[a2 + 4] = s2, this.float32[a2 + 5] = o2, t2;
            }
          }
          Sa.prototype.bytesPerElement = 24, qs(Sa, "StructArrayLayout6f24");
          class za extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2) {
              const s2 = this.length;
              return this.resize(s2 + 1), this.emplace(s2, t2, e2, r2, n2, i2);
            }
            emplace(t2, e2, r2, n2, i2, s2) {
              const o2 = 5 * t2;
              return this.float32[o2 + 0] = e2, this.float32[o2 + 1] = r2, this.float32[o2 + 2] = n2, this.float32[o2 + 3] = i2, this.float32[o2 + 4] = s2, t2;
            }
          }
          za.prototype.bytesPerElement = 20, qs(za, "StructArrayLayout5f20");
          class ka extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2) {
              const a2 = this.length;
              return this.resize(a2 + 1), this.emplace(a2, t2, e2, r2, n2, i2, s2, o2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = 7 * t2;
              return this.float32[l2 + 0] = e2, this.float32[l2 + 1] = r2, this.float32[l2 + 2] = n2, this.float32[l2 + 3] = i2, this.float32[l2 + 4] = s2, this.float32[l2 + 5] = o2, this.float32[l2 + 6] = a2, t2;
            }
          }
          ka.prototype.bytesPerElement = 28, qs(ka, "StructArrayLayout7f28");
          class Pa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2) {
              const h3 = this.length;
              return this.resize(h3 + 1), this.emplace(h3, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3) {
              const p3 = 11 * t2;
              return this.float32[p3 + 0] = e2, this.float32[p3 + 1] = r2, this.float32[p3 + 2] = n2, this.float32[p3 + 3] = i2, this.float32[p3 + 4] = s2, this.float32[p3 + 5] = o2, this.float32[p3 + 6] = a2, this.float32[p3 + 7] = l2, this.float32[p3 + 8] = u2, this.float32[p3 + 9] = c2, this.float32[p3 + 10] = h3, t2;
            }
          }
          Pa.prototype.bytesPerElement = 44, qs(Pa, "StructArrayLayout11f44");
          class Ea extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
              const u2 = this.length;
              return this.resize(u2 + 1), this.emplace(u2, t2, e2, r2, n2, i2, s2, o2, a2, l2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) {
              const c2 = 9 * t2;
              return this.float32[c2 + 0] = e2, this.float32[c2 + 1] = r2, this.float32[c2 + 2] = n2, this.float32[c2 + 3] = i2, this.float32[c2 + 4] = s2, this.float32[c2 + 5] = o2, this.float32[c2 + 6] = a2, this.float32[c2 + 7] = l2, this.float32[c2 + 8] = u2, t2;
            }
          }
          Ea.prototype.bytesPerElement = 36, qs(Ea, "StructArrayLayout9f36");
          class Ta extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2) {
              const r2 = this.length;
              return this.resize(r2 + 1), this.emplace(r2, t2, e2);
            }
            emplace(t2, e2, r2) {
              const n2 = 2 * t2;
              return this.float32[n2 + 0] = e2, this.float32[n2 + 1] = r2, t2;
            }
          }
          Ta.prototype.bytesPerElement = 8, qs(Ta, "StructArrayLayout2f8");
          class Ba extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2) {
              const i2 = this.length;
              return this.resize(i2 + 1), this.emplace(i2, t2, e2, r2, n2);
            }
            emplace(t2, e2, r2, n2, i2) {
              const s2 = 6 * t2;
              return this.uint32[3 * t2 + 0] = e2, this.uint16[s2 + 2] = r2, this.uint16[s2 + 3] = n2, this.uint16[s2 + 4] = i2, t2;
            }
          }
          Ba.prototype.bytesPerElement = 12, qs(Ba, "StructArrayLayout1ul3ui12");
          class Va extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(t2) {
              const e2 = this.length;
              return this.resize(e2 + 1), this.emplace(e2, t2);
            }
            emplace(t2, e2) {
              return this.uint16[1 * t2 + 0] = e2, t2;
            }
          }
          Va.prototype.bytesPerElement = 2, qs(Va, "StructArrayLayout1ui2");
          class Ca extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2) {
              const y2 = this.length;
              return this.resize(y2 + 1), this.emplace(y2, t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2) {
              const g2 = 16 * t2;
              return this.float32[g2 + 0] = e2, this.float32[g2 + 1] = r2, this.float32[g2 + 2] = n2, this.float32[g2 + 3] = i2, this.float32[g2 + 4] = s2, this.float32[g2 + 5] = o2, this.float32[g2 + 6] = a2, this.float32[g2 + 7] = l2, this.float32[g2 + 8] = u2, this.float32[g2 + 9] = c2, this.float32[g2 + 10] = h3, this.float32[g2 + 11] = p3, this.float32[g2 + 12] = f2, this.float32[g2 + 13] = d2, this.float32[g2 + 14] = m2, this.float32[g2 + 15] = y2, t2;
            }
          }
          Ca.prototype.bytesPerElement = 64, qs(Ca, "StructArrayLayout16f64");
          class Fa extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(t2, e2, r2, n2, i2, s2, o2) {
              const a2 = this.length;
              return this.resize(a2 + 1), this.emplace(a2, t2, e2, r2, n2, i2, s2, o2);
            }
            emplace(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = 10 * t2, u2 = 5 * t2;
              return this.uint16[l2 + 0] = e2, this.uint16[l2 + 1] = r2, this.uint16[l2 + 2] = n2, this.uint16[l2 + 3] = i2, this.float32[u2 + 2] = s2, this.float32[u2 + 3] = o2, this.float32[u2 + 4] = a2, t2;
            }
          }
          Fa.prototype.bytesPerElement = 20, qs(Fa, "StructArrayLayout4ui3f20");
          class Da extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(t2) {
              const e2 = this.length;
              return this.resize(e2 + 1), this.emplace(e2, t2);
            }
            emplace(t2, e2) {
              return this.int16[1 * t2 + 0] = e2, t2;
            }
          }
          Da.prototype.bytesPerElement = 2, qs(Da, "StructArrayLayout1i2");
          class La extends Qo {
            _refreshViews() {
              this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(t2) {
              const e2 = this.length;
              return this.resize(e2 + 1), this.emplace(e2, t2);
            }
            emplace(t2, e2) {
              return this.uint8[1 * t2 + 0] = e2, t2;
            }
          }
          La.prototype.bytesPerElement = 1, qs(La, "StructArrayLayout1ub1");
          class Ra extends Jo {
            get projectedAnchorX() {
              return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
              return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
              return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
              return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
              return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
              return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
              return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
              return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
              return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
              return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
              return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
              return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
              return this._structArray.uint16[this._pos2 + 19];
            }
          }
          Ra.prototype.size = 40;
          class Oa extends va {
            get(t2) {
              return new Ra(this, t2);
            }
          }
          qs(Oa, "CollisionBoxArray");
          class Ua extends Jo {
            get projectedAnchorX() {
              return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
              return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
              return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
              return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
              return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
              return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
              return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
              return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
              return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
              return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
              return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
              return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
              return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
              return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
              return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
              return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
              return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(t2) {
              this._structArray.uint8[this._pos1 + 49] = t2;
            }
            get hidden() {
              return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(t2) {
              this._structArray.uint8[this._pos1 + 50] = t2;
            }
            get crossTileID() {
              return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(t2) {
              this._structArray.uint32[this._pos4 + 13] = t2;
            }
            get associatedIconIndex() {
              return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
              return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(t2) {
              this._structArray.uint8[this._pos1 + 58] = t2;
            }
          }
          Ua.prototype.size = 60;
          class Na extends Ma {
            get(t2) {
              return new Ua(this, t2);
            }
          }
          qs(Na, "PlacedSymbolArray");
          class ja extends Jo {
            get tileAnchorX() {
              return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
              return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
              return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
              return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
              return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
              return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
              return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
              return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
              return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
              return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
              return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
              return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
              return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
              return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
              return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
              return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
              return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
              return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
              return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
              return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
              return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
              return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
              return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
              return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
              return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
              return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
              return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(t2) {
              this._structArray.uint32[this._pos4 + 14] = t2;
            }
            get textOffset0() {
              return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
              return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
              return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
              return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(t2) {
              this._structArray.float32[this._pos4 + 18] = t2;
            }
            get hasIconTextFit() {
              return this._structArray.uint8[this._pos1 + 76];
            }
            get elevationFeatureIndex() {
              return this._structArray.uint16[this._pos2 + 39];
            }
          }
          ja.prototype.size = 80;
          class $a extends Ia {
            get(t2) {
              return new ja(this, t2);
            }
          }
          qs($a, "SymbolInstanceArray");
          class Ga extends sa {
            getoffsetX(t2) {
              return this.float32[1 * t2 + 0];
            }
          }
          qs(Ga, "GlyphOffsetArray");
          class qa extends ra {
            getx(t2) {
              return this.int16[2 * t2 + 0];
            }
            gety(t2) {
              return this.int16[2 * t2 + 1];
            }
          }
          qs(qa, "SymbolLineVertexArray");
          class Ha extends Jo {
            get featureIndex() {
              return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
              return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
              return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
              return this._structArray.uint16[this._pos2 + 4];
            }
          }
          Ha.prototype.size = 12;
          class Xa extends Ba {
            get(t2) {
              return new Ha(this, t2);
            }
          }
          qs(Xa, "FeatureIndexArray");
          class Za extends xa {
            geta_centroid_pos0(t2) {
              return this.uint16[2 * t2 + 0];
            }
            geta_centroid_pos1(t2) {
              return this.uint16[2 * t2 + 1];
            }
          }
          qs(Za, "FillExtrusionCentroidArray");
          class Wa extends Jo {
            get a_join_normal_inside0() {
              return this._structArray.int16[this._pos2 + 0];
            }
            get a_join_normal_inside1() {
              return this._structArray.int16[this._pos2 + 1];
            }
            get a_join_normal_inside2() {
              return this._structArray.int16[this._pos2 + 2];
            }
          }
          Wa.prototype.size = 6;
          class Ya extends na {
            get(t2) {
              return new Wa(this, t2);
            }
          }
          qs(Ya, "FillExtrusionWallArray");
          const Ka = ta([{ name: "a_pos", components: 2, type: "Int16" }], 4), Ja = ta([{ name: "a_circle_z_offset", components: 1, type: "Float32" }], 4), Qa = ta([{ name: "a_pos_3", components: 3, type: "Int16" }, { name: "a_pos_normal_3", components: 3, type: "Int16" }]);
          class tl {
            constructor(t2 = []) {
              this.segments = t2;
            }
            _prepareSegment(t2, e2, r2, n2) {
              let i2 = this.segments[this.segments.length - 1];
              return t2 > tl.MAX_VERTEX_ARRAY_LENGTH && Gt(`Max vertices per segment is ${tl.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t2}`), (!i2 || i2.vertexLength + t2 > tl.MAX_VERTEX_ARRAY_LENGTH || i2.sortKey !== n2) && (i2 = { vertexOffset: e2, primitiveOffset: r2, vertexLength: 0, primitiveLength: 0 }, void 0 !== n2 && (i2.sortKey = n2), this.segments.push(i2)), i2;
            }
            prepareSegment(t2, e2, r2, n2) {
              return this._prepareSegment(t2, e2.length, r2.length, n2);
            }
            get() {
              return this.segments;
            }
            destroy() {
              for (const t2 of this.segments) for (const e2 in t2.vaos) t2.vaos[e2].destroy();
            }
            static simpleSegment(t2, e2, r2, n2) {
              return new tl([{ vertexOffset: t2, primitiveOffset: e2, vertexLength: r2, primitiveLength: n2, vaos: {}, sortKey: 0 }]);
            }
          }
          function el(t2, e2) {
            return 256 * (t2 = Et(Math.floor(t2), 0, 255)) + Et(Math.floor(e2), 0, 255);
          }
          tl.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, qs(tl, "SegmentVector");
          const rl = ta([{ name: "a_pattern", components: 4, type: "Uint16" }, { name: "a_pixel_ratio", components: 1, type: "Float32" }]), nl = ta([{ name: "a_pattern_b", components: 4, type: "Uint16" }]), il = ta([{ name: "a_dash", components: 4, type: "Uint16" }]);
          class sl {
            constructor() {
              this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = false;
            }
            add(t2, e2, r2, n2) {
              this.ids.push(ol(t2)), this.positions.push(e2, r2, n2);
            }
            eachPosition(t2, e2) {
              const r2 = ol(t2);
              let n2 = 0, i2 = this.ids.length - 1;
              for (; n2 < i2; ) {
                const t3 = n2 + i2 >> 1;
                this.ids[t3] >= r2 ? i2 = t3 : n2 = t3 + 1;
              }
              for (; this.ids[n2] === r2; ) e2(this.positions[3 * n2], this.positions[3 * n2 + 1], this.positions[3 * n2 + 2]), n2++;
            }
            static serialize(t2, e2) {
              const r2 = new Float64Array(t2.ids), n2 = new Uint32Array(t2.positions);
              return al(r2, n2, 0, r2.length - 1), e2 && (e2.add(r2.buffer), e2.add(n2.buffer)), { ids: r2, positions: n2 };
            }
            static deserialize(t2) {
              const e2 = new sl();
              let r2;
              e2.ids = t2.ids, e2.positions = t2.positions;
              for (const t3 of e2.ids) t3 !== r2 && e2.uniqueIds.push(t3), r2 = t3;
              return e2.indexed = true, e2;
            }
          }
          function ol(t2) {
            const e2 = +t2;
            return !isNaN(e2) && Number.MIN_SAFE_INTEGER <= e2 && e2 <= Number.MAX_SAFE_INTEGER ? e2 : We(String(t2));
          }
          function al(t2, e2, r2, n2) {
            for (; r2 < n2; ) {
              const i2 = t2[r2 + n2 >> 1];
              let s2 = r2 - 1, o2 = n2 + 1;
              for (; ; ) {
                do {
                  s2++;
                } while (t2[s2] < i2);
                do {
                  o2--;
                } while (t2[o2] > i2);
                if (s2 >= o2) break;
                ll(t2, s2, o2), ll(e2, 3 * s2, 3 * o2), ll(e2, 3 * s2 + 1, 3 * o2 + 1), ll(e2, 3 * s2 + 2, 3 * o2 + 2);
              }
              o2 - r2 < n2 - o2 ? (al(t2, e2, r2, o2), r2 = o2 + 1) : (al(t2, e2, o2 + 1, n2), n2 = o2);
            }
          }
          function ll(t2, e2, r2) {
            const n2 = t2[e2];
            t2[e2] = t2[r2], t2[r2] = n2;
          }
          qs(sl, "FeaturePositionMap");
          class ul {
            constructor(t2) {
              this.gl = t2.gl, this.initialized = false;
            }
            fetchUniformLocation(t2, e2) {
              return this.location || this.initialized || (this.location = this.gl.getUniformLocation(t2, e2), this.initialized = true), !!this.location;
            }
            set(t2, e2, r2) {
              throw new Error("Uniform#set() must be implemented by each concrete Uniform");
            }
          }
          class cl extends ul {
            constructor(t2) {
              super(t2), this.current = 0;
            }
            set(t2, e2, r2) {
              this.fetchUniformLocation(t2, e2) && this.current !== r2 && (this.current = r2, this.gl.uniform1i(this.location, r2));
            }
          }
          class hl extends ul {
            constructor(t2) {
              super(t2), this.current = 0;
            }
            set(t2, e2, r2) {
              this.fetchUniformLocation(t2, e2) && this.current !== r2 && (this.current = r2, this.gl.uniform1f(this.location, r2));
            }
          }
          class pl extends ul {
            constructor(t2) {
              super(t2), this.current = [0, 0];
            }
            set(t2, e2, r2) {
              this.fetchUniformLocation(t2, e2) && (r2[0] === this.current[0] && r2[1] === this.current[1] || (this.current = r2, this.gl.uniform2f(this.location, r2[0], r2[1])));
            }
          }
          class fl extends ul {
            constructor(t2) {
              super(t2), this.current = [0, 0, 0];
            }
            set(t2, e2, r2) {
              this.fetchUniformLocation(t2, e2) && (r2[0] === this.current[0] && r2[1] === this.current[1] && r2[2] === this.current[2] || (this.current = r2, this.gl.uniform3f(this.location, r2[0], r2[1], r2[2])));
            }
          }
          class dl extends ul {
            constructor(t2) {
              super(t2), this.current = [0, 0, 0, 0];
            }
            set(t2, e2, r2) {
              this.fetchUniformLocation(t2, e2) && (r2[0] === this.current[0] && r2[1] === this.current[1] && r2[2] === this.current[2] && r2[3] === this.current[3] || (this.current = r2, this.gl.uniform4f(this.location, r2[0], r2[1], r2[2], r2[3])));
            }
          }
          class ml extends ul {
            constructor(t2) {
              super(t2), this.current = sr.transparent.toPremultipliedRenderColor(null);
            }
            set(t2, e2, r2) {
              this.fetchUniformLocation(t2, e2) && (r2.r === this.current.r && r2.g === this.current.g && r2.b === this.current.b && r2.a === this.current.a || (this.current = r2, this.gl.uniform4f(this.location, r2.r, r2.g, r2.b, r2.a)));
            }
          }
          const yl = new Float32Array(16);
          class gl extends ul {
            constructor(t2) {
              super(t2), this.current = yl;
            }
            set(t2, e2, r2) {
              if (this.fetchUniformLocation(t2, e2)) {
                if (r2[12] !== this.current[12] || r2[0] !== this.current[0]) return this.current = r2, void this.gl.uniformMatrix4fv(this.location, false, r2);
                for (let t3 = 1; t3 < 16; t3++) if (r2[t3] !== this.current[t3]) {
                  this.current = r2, this.gl.uniformMatrix4fv(this.location, false, r2);
                  break;
                }
              }
            }
          }
          const xl = new Float32Array(9), vl = new Float32Array(4);
          class bl extends ul {
            constructor(t2) {
              super(t2), this.current = vl;
            }
            set(t2, e2, r2) {
              if (this.fetchUniformLocation(t2, e2)) {
                for (let t3 = 0; t3 < 4; t3++) if (r2[t3] !== this.current[t3]) {
                  this.current = r2, this.gl.uniformMatrix2fv(this.location, false, r2);
                  break;
                }
              }
            }
          }
          function wl(t2) {
            return [el(255 * t2.r, 255 * t2.g), el(255 * t2.b, 255 * t2.a)];
          }
          class _l {
            constructor(t2, e2, r2, n2) {
              this.value = t2, this.uniformNames = e2.map((t3) => `u_${t3}`), this.type = r2, this.context = n2;
            }
            setUniform(t2, e2, r2, n2, i2) {
              const s2 = n2.constantOr(this.value);
              e2.set(t2, i2, s2 instanceof sr ? s2.toPremultipliedRenderColor(this.lutExpression && "none" === this.lutExpression.value ? null : this.context.lut) : s2);
            }
            getBinding(t2, e2) {
              return "color" === this.type ? new ml(t2) : new hl(t2);
            }
          }
          class Al {
            constructor(t2, e2) {
              this.uniformNames = e2.map((t3) => `u_${t3}`), this.pattern = null, this.patternTransition = null, this.pixelRatio = 1;
            }
            setConstantPatternPositions(t2, e2) {
              this.pixelRatio = t2.pixelRatio || 1, this.pattern = t2.tl.concat(t2.br), this.patternTransition = e2 ? e2.tl.concat(e2.br) : this.pattern;
            }
            setUniform(t2, e2, r2, n2, i2) {
              let s2 = null;
              "u_pattern" !== i2 && "u_dash" !== i2 || (s2 = this.pattern), "u_pattern_b" === i2 && (s2 = this.patternTransition), "u_pixel_ratio" === i2 && (s2 = this.pixelRatio), s2 && e2.set(t2, i2, s2);
            }
            getBinding(t2, e2) {
              return "u_pattern" === e2 || "u_pattern_b" === e2 || "u_dash" === e2 ? new dl(t2) : new hl(t2);
            }
          }
          class Ml {
            constructor(t2, e2, r2, n2) {
              this.expression = t2, this.type = r2, this.maxValue = 0, this.paintVertexAttributes = e2.map((t3) => ({ name: `a_${t3}`, type: "Float32", components: "color" === r2 ? 2 : 1, offset: 0 })), this.paintVertexArray = new n2();
            }
            populatePaintArray(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = this.paintVertexArray.length, u2 = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate(new go(0, { brightness: s2, worldview: a2 }), e2, {}, i2, n2, o2) : "constant" === this.expression.kind && this.expression.value, c2 = !!this.lutExpression && "none" === ("composite" === this.lutExpression.kind || "source" === this.lutExpression.kind ? this.lutExpression.evaluate(new go(0, { brightness: s2, worldview: a2 }), e2, {}, i2, n2, o2) : this.lutExpression.value);
              this.paintVertexArray.resize(t2), this._setPaintValue(l2, t2, u2, c2 ? null : this.context.lut);
            }
            updatePaintArray(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate({ zoom: 0, brightness: o2, worldview: a2 }, r2, n2, void 0, i2) : "constant" === this.expression.kind && this.expression.value, u2 = !!this.lutExpression && "none" === ("composite" === this.lutExpression.kind || "source" === this.lutExpression.kind ? this.lutExpression.evaluate(new go(0, { brightness: o2, worldview: a2 }), r2, n2, void 0, i2) : this.lutExpression.value);
              this._setPaintValue(t2, e2, l2, u2 ? null : this.context.lut);
            }
            _setPaintValue(t2, e2, r2, n2) {
              if ("color" === this.type) {
                const i2 = wl(r2.toPremultipliedRenderColor(n2));
                for (let r3 = t2; r3 < e2; r3++) this.paintVertexArray.emplace(r3, i2[0], i2[1]);
              } else {
                for (let n3 = t2; n3 < e2; n3++) this.paintVertexArray.emplace(n3, r2);
                this.maxValue = Math.max(this.maxValue, Math.abs(r2));
              }
            }
            upload(t2) {
              this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.lutExpression && "constant" !== this.lutExpression.kind && (this.lutExpression.isStateDependent || !this.lutExpression.isLightConstant) || "constant" !== this.expression.kind && (this.expression.isStateDependent || !this.expression.isLightConstant)));
            }
            destroy() {
              this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
          }
          class Il {
            constructor(t2, e2, r2, n2, i2, s2) {
              this.expression = t2, this.uniformNames = e2.map((t3) => `u_${t3}_t`), this.type = r2, this.useIntegerZoom = n2, this.context = i2, this.maxValue = 0, this.paintVertexAttributes = e2.map((t3) => ({ name: `a_${t3}`, type: "Float32", components: "color" === r2 ? 4 : 2, offset: 0 })), this.paintVertexArray = new s2();
            }
            populatePaintArray(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = this.expression.evaluate(new go(this.context.zoom, { brightness: s2, worldview: a2 }), e2, {}, i2, n2, o2), u2 = this.expression.evaluate(new go(this.context.zoom + 1, { brightness: s2, worldview: a2 }), e2, {}, i2, n2, o2), c2 = !!this.lutExpression && "none" === ("composite" === this.lutExpression.kind || "source" === this.lutExpression.kind ? this.lutExpression.evaluate(new go(0, { brightness: s2, worldview: a2 }), e2, {}, i2, n2, o2) : this.lutExpression.value), h3 = this.paintVertexArray.length;
              this.paintVertexArray.resize(t2), this._setPaintValue(h3, t2, l2, u2, c2 ? null : this.context.lut);
            }
            updatePaintArray(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = this.expression.evaluate({ zoom: this.context.zoom, brightness: o2, worldview: a2 }, r2, n2, void 0, i2), u2 = this.expression.evaluate({ zoom: this.context.zoom + 1, brightness: o2, worldview: a2 }, r2, n2, void 0, i2), c2 = !!this.lutExpression && "none" === ("composite" === this.lutExpression.kind || "source" === this.lutExpression.kind ? this.lutExpression.evaluate(new go(0, { brightness: o2, worldview: a2 }), r2, n2, void 0, i2) : this.lutExpression.value);
              this._setPaintValue(t2, e2, l2, u2, c2 ? null : this.context.lut);
            }
            _setPaintValue(t2, e2, r2, n2, i2) {
              if ("color" === this.type) {
                const n3 = wl(r2.toPremultipliedRenderColor(i2)), s2 = wl(r2.toPremultipliedRenderColor(i2));
                for (let r3 = t2; r3 < e2; r3++) this.paintVertexArray.emplace(r3, n3[0], n3[1], s2[0], s2[1]);
              } else {
                for (let i3 = t2; i3 < e2; i3++) this.paintVertexArray.emplace(i3, r2, n2);
                this.maxValue = Math.max(this.maxValue, Math.abs(r2), Math.abs(n2));
              }
            }
            upload(t2) {
              this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
              this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(t2, e2, r2, n2, i2) {
              const s2 = this.useIntegerZoom ? Math.floor(r2.zoom) : r2.zoom, o2 = Et(this.expression.interpolationFactor(s2, this.context.zoom, this.context.zoom + 1), 0, 1);
              e2.set(t2, i2, o2);
            }
            getBinding(t2, e2) {
              return new hl(t2);
            }
          }
          class Sl {
            constructor(t2, e2, r2, n2, i2) {
              this.expression = t2, this.layerId = i2, this.paintVertexAttributes = ("array" === r2 ? il : rl).members;
              for (let t3 = 0; t3 < e2.length; ++t3) ;
              this.paintVertexArray = new n2(), this.paintTransitionVertexArray = new pa();
            }
            populatePaintArray(t2, e2, r2, n2) {
              const i2 = this.paintVertexArray.length;
              this.paintVertexArray.resize(t2), this._setPaintValues(i2, t2, e2.patterns && e2.patterns[this.layerId], r2);
            }
            updatePaintArray(t2, e2, r2, n2, i2, s2, o2) {
              this._setPaintValues(t2, e2, r2.patterns && r2.patterns[this.layerId], s2);
            }
            _setPaintValues(t2, e2, r2, n2) {
              if (!n2 || !r2) return;
              const i2 = n2[r2[0]], s2 = n2[r2[1]];
              if (i2) {
                if (i2) {
                  const { tl: r3, br: n3, pixelRatio: s3 } = i2;
                  for (let i3 = t2; i3 < e2; i3++) this.paintVertexArray.emplace(i3, r3[0], r3[1], n3[0], n3[1], s3);
                }
                if (s2) {
                  this.paintTransitionVertexArray.resize(this.paintVertexArray.length);
                  const { tl: r3, br: n3 } = s2;
                  for (let i3 = t2; i3 < e2; i3++) this.paintTransitionVertexArray.emplace(i3, r3[0], r3[1], n3[0], n3[1]);
                }
              }
            }
            upload(t2) {
              const e2 = this.expression.isStateDependent || !this.expression.isLightConstant;
              this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = t2.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, e2)), this.paintTransitionVertexArray && this.paintTransitionVertexArray.length && (this.paintTransitionVertexBuffer = t2.createVertexBuffer(this.paintTransitionVertexArray, nl.members, e2));
            }
            destroy() {
              this.paintVertexBuffer && this.paintVertexBuffer.destroy(), this.paintTransitionVertexBuffer && this.paintTransitionVertexBuffer.destroy();
            }
          }
          class zl {
            constructor(t2, e2, r2 = () => true) {
              this.binders = {}, this._buffers = [], this.context = e2;
              const n2 = [];
              for (const i2 in t2.paint._values) {
                const s2 = t2.paint.get(i2);
                if (i2.endsWith("-use-theme")) continue;
                if (!r2(i2)) continue;
                if (!(s2 instanceof Mo && bs(s2.property.specification))) continue;
                const o2 = El(i2, t2.type), a2 = s2.value, l2 = s2.property.specification.type, u2 = !!s2.property.useIntegerZoom, c2 = "line-dasharray" === i2 || i2.endsWith("pattern"), h3 = t2.paint.get(`${i2}-use-theme`), p3 = "line-dasharray" === i2 && "constant" !== t2.layout.get("line-cap").value.kind || h3 && "constant" !== h3.value.kind;
                if ("constant" !== a2.kind || p3) if ("source" === a2.kind || p3 || c2) {
                  const e3 = Vl(i2, l2, "source");
                  this.binders[i2] = c2 ? new Sl(a2, o2, l2, e3, t2.id) : new Ml(a2, o2, l2, e3), n2.push(`/a_${i2}`);
                } else {
                  const t3 = Vl(i2, l2, "composite");
                  this.binders[i2] = new Il(a2, o2, l2, u2, e2, t3), n2.push(`/z_${i2}`);
                }
                else this.binders[i2] = c2 ? new Al(a2.value, o2) : new _l(a2.value, o2, l2, e2), n2.push(`/u_${i2}`);
                h3 && (this.binders[i2].lutExpression = h3.value);
              }
              this.cacheKey = n2.sort().join("");
            }
            getMaxValue(t2) {
              const e2 = this.binders[t2];
              return e2 instanceof Ml || e2 instanceof Il ? e2.maxValue : 0;
            }
            populatePaintArrays(t2, e2, r2, n2, i2, s2, o2, a2) {
              for (const l2 in this.binders) {
                const u2 = this.binders[l2];
                u2.context = this.context, (u2 instanceof Ml || u2 instanceof Il || u2 instanceof Sl) && u2.populatePaintArray(t2, e2, r2, n2, i2, s2, o2, a2);
              }
            }
            setConstantPatternPositions(t2, e2) {
              for (const r2 in this.binders) {
                const n2 = this.binders[r2];
                n2 instanceof Al && n2.setConstantPatternPositions(t2, e2);
              }
            }
            getPatternTransitionVertexBuffer(t2) {
              const e2 = this.binders[t2];
              return e2 instanceof Sl ? e2.paintTransitionVertexBuffer : null;
            }
            updatePaintArrays(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) {
              let c2 = false;
              const h3 = Object.keys(t2), p3 = 0 !== h3.length && !a2, f2 = p3 ? h3 : e2.uniqueIds;
              this.context.lut = i2.lut;
              for (const a3 in this.binders) {
                const h4 = this.binders[a3];
                if (h4.context = this.context, (h4 instanceof Ml || h4 instanceof Il || h4 instanceof Sl) && h4.expression && h4.expression.kind && "constant" !== h4.expression.kind && (true === h4.expression.isStateDependent || false === h4.expression.isLightConstant)) {
                  const d2 = i2.paint.get(a3);
                  h4.expression = d2.value;
                  for (const r3 of f2) {
                    const i3 = t2[r3.toString()];
                    e2.eachPosition(r3, (t3, e3, r4) => {
                      const a4 = n2.feature(t3);
                      h4.updatePaintArray(e3, r4, a4, i3, s2, o2, l2, u2);
                    });
                  }
                  if (!p3) for (const e3 of r2.uniqueIds) {
                    const i3 = t2[e3.toString()];
                    r2.eachPosition(e3, (t3, e4, r3) => {
                      const a4 = n2.feature(t3);
                      h4.updatePaintArray(e4, r3, a4, i3, s2, o2, l2, u2);
                    });
                  }
                  c2 = true;
                }
              }
              return c2;
            }
            defines() {
              const t2 = [];
              for (const e2 in this.binders) {
                const r2 = this.binders[e2];
                (r2 instanceof _l || r2 instanceof Al) && t2.push(...r2.uniformNames.map((t3) => `#define HAS_UNIFORM_${t3}`));
              }
              return t2;
            }
            getBinderAttributes() {
              const t2 = [];
              for (const e2 in this.binders) {
                const r2 = this.binders[e2];
                if (r2 instanceof Ml || r2 instanceof Il || r2 instanceof Sl) for (let e3 = 0; e3 < r2.paintVertexAttributes.length; e3++) t2.push(r2.paintVertexAttributes[e3].name);
                if (r2 instanceof Sl) for (let e3 = 0; e3 < nl.members.length; e3++) t2.push(nl.members[e3].name);
              }
              return t2;
            }
            getBinderUniforms() {
              const t2 = [];
              for (const e2 in this.binders) {
                const r2 = this.binders[e2];
                if (r2 instanceof _l || r2 instanceof Al || r2 instanceof Il) for (const e3 of r2.uniformNames) t2.push(e3);
              }
              return t2;
            }
            getPaintVertexBuffers() {
              return this._buffers;
            }
            getUniforms(t2) {
              const e2 = [];
              for (const r2 in this.binders) {
                const n2 = this.binders[r2];
                if (n2 instanceof _l || n2 instanceof Al || n2 instanceof Il) for (const i2 of n2.uniformNames) e2.push({ name: i2, property: r2, binding: n2.getBinding(t2, i2) });
              }
              return e2;
            }
            setUniforms(t2, e2, r2, n2, i2) {
              for (const { name: e3, property: s2, binding: o2 } of r2) this.binders[s2].setUniform(t2, o2, i2, n2.get(s2), e3);
            }
            updatePaintBuffers() {
              this._buffers = [];
              for (const t2 in this.binders) {
                const e2 = this.binders[t2];
                (e2 instanceof Ml || e2 instanceof Il || e2 instanceof Sl) && e2.paintVertexBuffer && this._buffers.push(e2.paintVertexBuffer), e2 instanceof Sl && e2.paintTransitionVertexBuffer && this._buffers.push(e2.paintTransitionVertexBuffer);
              }
            }
            upload(t2) {
              for (const e2 in this.binders) {
                const r2 = this.binders[e2];
                (r2 instanceof Ml || r2 instanceof Il || r2 instanceof Sl) && r2.upload(t2);
              }
              this.updatePaintBuffers();
            }
            destroy() {
              for (const t2 in this.binders) {
                const e2 = this.binders[t2];
                (e2 instanceof Ml || e2 instanceof Il || e2 instanceof Sl) && e2.destroy();
              }
            }
          }
          class kl {
            constructor(t2, e2, r2 = () => true) {
              this.programConfigurations = {};
              for (const n2 of t2) this.programConfigurations[n2.id] = new zl(n2, e2, r2);
              this.needsUpload = false, this._featureMap = new sl(), this._featureMapWithoutIds = new sl(), this._bufferOffset = 0, this._idlessCounter = 0;
            }
            populatePaintArrays(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
              for (const r3 in this.programConfigurations) this.programConfigurations[r3].populatePaintArrays(t2, e2, n2, i2, s2, o2, a2, l2);
              void 0 !== e2.id ? this._featureMap.add(e2.id, r2, this._bufferOffset, t2) : (this._featureMapWithoutIds.add(this._idlessCounter, r2, this._bufferOffset, t2), this._idlessCounter += 1), this._bufferOffset = t2, this.needsUpload = true;
            }
            updatePaintArrays(t2, e2, r2, n2, i2, s2, o2, a2) {
              for (const l2 of r2) this.needsUpload = this.programConfigurations[l2.id].updatePaintArrays(t2, this._featureMap, this._featureMapWithoutIds, e2, l2, n2, i2, s2, o2 || 0, a2) || this.needsUpload;
            }
            get(t2) {
              return this.programConfigurations[t2];
            }
            upload(t2) {
              if (this.needsUpload) {
                for (const e2 in this.programConfigurations) this.programConfigurations[e2].upload(t2);
                this.needsUpload = false;
              }
            }
            destroy() {
              for (const t2 in this.programConfigurations) this.programConfigurations[t2].destroy();
            }
          }
          const Pl = { "text-opacity": ["opacity"], "icon-opacity": ["opacity"], "text-occlusion-opacity": ["occlusion_opacity"], "icon-occlusion-opacity": ["occlusion_opacity"], "text-color": ["fill_color"], "icon-color": ["fill_color"], "text-emissive-strength": ["emissive_strength"], "icon-emissive-strength": ["emissive_strength"], "text-halo-color": ["halo_color"], "icon-halo-color": ["halo_color"], "text-halo-blur": ["halo_blur"], "icon-halo-blur": ["halo_blur"], "text-halo-width": ["halo_width"], "icon-halo-width": ["halo_width"], "symbol-z-offset": ["z_offset"], "line-gap-width": ["gapwidth"], "line-pattern": ["pattern", "pixel_ratio", "pattern_b"], "fill-pattern": ["pattern", "pixel_ratio", "pattern_b"], "fill-extrusion-pattern": ["pattern", "pixel_ratio", "pattern_b"], "line-dasharray": ["dash"], "fill-bridge-guard-rail-color": ["structure_color"], "fill-tunnel-structure-color": ["structure_color"] };
          function El(t2, e2) {
            return Pl[t2] || [t2.replace(`${e2}-`, "").replace(/-/g, "_")];
          }
          const Tl = { "line-pattern": { source: ha, composite: ha }, "fill-pattern": { source: ha, composite: ha }, "fill-extrusion-pattern": { source: ha, composite: ha }, "line-dasharray": { source: pa, composite: pa } }, Bl = { color: { source: Ta, composite: ya }, number: { source: sa, composite: Ta } };
          function Vl(t2, e2, r2) {
            const n2 = Tl[t2];
            return n2 && n2[r2] || Bl[e2][r2];
          }
          qs(_l, "ConstantBinder"), qs(Al, "PatternConstantBinder"), qs(Ml, "SourceExpressionBinder"), qs(Sl, "PatternCompositeBinder"), qs(Il, "CompositeExpressionBinder"), qs(zl, "ProgramConfiguration", { omit: ["_buffers"] }), qs(kl, "ProgramConfigurationSet");
          const Cl = Cn / Math.PI / 2, Fl = 5, Dl = 6, Ll = 16383, Rl = 64, Ol = [Rl, 32, 16], Ul = -Cl, Nl = Cl;
          function jl(t2, e2, r2, n2 = Cl) {
            return r2 = Mt(r2), [t2 * Math.sin(r2) * n2, -e2 * n2, t2 * Math.cos(r2) * n2];
          }
          function $l(t2, e2, r2) {
            return jl(Math.cos(Mt(t2)), Math.sin(Mt(t2)), e2, r2);
          }
          const Gl = 63710088e-1, ql = 2 * Math.PI * Gl;
          class Hl {
            constructor(t2, e2) {
              if (isNaN(t2) || isNaN(e2)) throw new Error(`Invalid LngLat object: (${t2}, ${e2})`);
              if (this.lng = +t2, this.lat = +e2, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
              return new Hl(Bt(this.lng, -180, 180), this.lat);
            }
            toArray() {
              return [this.lng, this.lat];
            }
            toString() {
              return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(t2) {
              const e2 = Math.PI / 180, r2 = this.lat * e2, n2 = t2.lat * e2, i2 = Math.sin(r2) * Math.sin(n2) + Math.cos(r2) * Math.cos(n2) * Math.cos((t2.lng - this.lng) * e2);
              return Gl * Math.acos(Math.min(i2, 1));
            }
            toBounds(t2 = 0) {
              const e2 = 360 * t2 / 40075017, r2 = e2 / Math.cos(Math.PI / 180 * this.lat);
              return new Xl({ lng: this.lng - r2, lat: this.lat - e2 }, { lng: this.lng + r2, lat: this.lat + e2 });
            }
            toEcef(t2) {
              return $l(this.lat, this.lng, Cl + t2 * Cl / Gl);
            }
            static convert(t2) {
              if (t2 instanceof Hl) return t2;
              if (Array.isArray(t2) && (2 === t2.length || 3 === t2.length)) return new Hl(Number(t2[0]), Number(t2[1]));
              if (!Array.isArray(t2) && "object" == typeof t2 && null !== t2) return new Hl(Number("lng" in t2 ? t2.lng : t2.lon), Number(t2.lat));
              throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
          }
          class Xl {
            constructor(t2, e2) {
              if (t2) if (e2) this.setSouthWest(t2).setNorthEast(e2);
              else if (4 === t2.length) {
                const e3 = t2;
                this.setSouthWest([e3[0], e3[1]]).setNorthEast([e3[2], e3[3]]);
              } else {
                const e3 = t2;
                this.setSouthWest(e3[0]).setNorthEast(e3[1]);
              }
            }
            setNorthEast(t2) {
              return this._ne = t2 instanceof Hl ? new Hl(t2.lng, t2.lat) : Hl.convert(t2), this;
            }
            setSouthWest(t2) {
              return this._sw = t2 instanceof Hl ? new Hl(t2.lng, t2.lat) : Hl.convert(t2), this;
            }
            extend(t2) {
              const e2 = this._sw, r2 = this._ne;
              let n2, i2;
              if (t2 instanceof Hl) n2 = t2, i2 = t2;
              else {
                if (!(t2 instanceof Xl)) return Array.isArray(t2) ? 4 === t2.length || t2.every(Array.isArray) ? this.extend(Xl.convert(t2)) : this.extend(Hl.convert(t2)) : "object" == typeof t2 && null !== t2 && t2.hasOwnProperty("lat") && (t2.hasOwnProperty("lon") || t2.hasOwnProperty("lng")) ? this.extend(Hl.convert(t2)) : this;
                if (n2 = t2._sw, i2 = t2._ne, !n2 || !i2) return this;
              }
              return e2 || r2 ? (e2.lng = Math.min(n2.lng, e2.lng), e2.lat = Math.min(n2.lat, e2.lat), r2.lng = Math.max(i2.lng, r2.lng), r2.lat = Math.max(i2.lat, r2.lat)) : (this._sw = new Hl(n2.lng, n2.lat), this._ne = new Hl(i2.lng, i2.lat)), this;
            }
            getCenter() {
              return new Hl((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
              return this._sw;
            }
            getNorthEast() {
              return this._ne;
            }
            getNorthWest() {
              return new Hl(this.getWest(), this.getNorth());
            }
            getSouthEast() {
              return new Hl(this.getEast(), this.getSouth());
            }
            getWest() {
              return this._sw.lng;
            }
            getSouth() {
              return this._sw.lat;
            }
            getEast() {
              return this._ne.lng;
            }
            getNorth() {
              return this._ne.lat;
            }
            toArray() {
              return [this._sw.toArray(), this._ne.toArray()];
            }
            toString() {
              return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
              return !(this._sw && this._ne);
            }
            contains(t2) {
              const { lng: e2, lat: r2 } = Hl.convert(t2);
              let n2 = this._sw.lng <= e2 && e2 <= this._ne.lng;
              return this._sw.lng > this._ne.lng && (n2 = this._sw.lng >= e2 && e2 >= this._ne.lng), this._sw.lat <= r2 && r2 <= this._ne.lat && n2;
            }
            static convert(t2) {
              if (t2) return t2 instanceof Xl ? t2 : new Xl(t2);
            }
          }
          const Zl = 0, Wl = 25.5;
          function Yl(t2) {
            return ql * Math.cos(t2 * Math.PI / 180);
          }
          function Kl(t2) {
            return (180 + t2) / 360;
          }
          function Jl(t2) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t2 * Math.PI / 360))) / 360;
          }
          function Ql(t2, e2) {
            return t2 / Yl(e2);
          }
          function tu(t2) {
            return 360 * t2 - 180;
          }
          function eu(t2) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t2) * Math.PI / 180)) - 90;
          }
          function ru(t2, e2) {
            return t2 * Yl(eu(e2));
          }
          const nu = 85.051129;
          function iu(t2) {
            return Math.cos(Mt(Et(t2, -85.051129, nu)));
          }
          function su(t2, e2) {
            const r2 = Et(e2, Zl, Wl), n2 = Math.pow(2, r2);
            return iu(t2) * ql / (512 * n2);
          }
          function ou(t2) {
            return 1 / Math.cos(t2 * Math.PI / 180);
          }
          function au(t2, e2 = 0) {
            const r2 = Math.exp(Math.PI * (1 - (t2.y + e2 / Cn) / (1 << t2.z) * 2));
            return 80150034 * r2 / (r2 * r2 + 1) / Cn / (1 << t2.z);
          }
          class lu {
            constructor(t2, e2, r2 = 0) {
              this.x = +t2, this.y = +e2, this.z = +r2;
            }
            static fromLngLat(t2, e2 = 0) {
              const r2 = Hl.convert(t2);
              return new lu(Kl(r2.lng), Jl(r2.lat), Ql(e2, r2.lat));
            }
            toLngLat() {
              return new Hl(tu(this.x), eu(this.y));
            }
            toAltitude() {
              return ru(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
              return 1 / ql * ou(eu(this.y));
            }
          }
          function uu(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            const u2 = (e2 + n2) / 2, c2 = (r2 + i2) / 2, h3 = new bt(u2, c2);
            a2(h3), function(t3, e3, r3, n3, i3, s3) {
              const o3 = r3 - i3, a3 = n3 - s3;
              return Math.abs((n3 - e3) * o3 - (r3 - t3) * a3) / Math.hypot(o3, a3);
            }(h3.x, h3.y, s2.x, s2.y, o2.x, o2.y) >= l2 ? (uu(t2, e2, r2, u2, c2, s2, h3, a2, l2), uu(t2, u2, c2, n2, i2, h3, o2, a2, l2)) : t2.push(o2);
          }
          function cu(t2, e2, r2) {
            let n2 = t2[0], i2 = n2.x, s2 = n2.y;
            e2(n2);
            const o2 = [n2];
            for (let a2 = 1; a2 < t2.length; a2++) {
              const l2 = t2[a2], { x: u2, y: c2 } = l2;
              e2(l2), uu(o2, i2, s2, u2, c2, n2, l2, e2, r2), i2 = u2, s2 = c2, n2 = l2;
            }
            return o2;
          }
          function hu(t2, e2, r2, n2) {
            if (n2(e2, r2)) {
              const i2 = e2.add(r2)._mult(0.5);
              hu(t2, e2, i2, n2), hu(t2, i2, r2, n2);
            } else t2.push(r2);
          }
          function pu(t2, e2) {
            let r2 = t2[0];
            const n2 = [r2];
            for (let i2 = 1; i2 < t2.length; i2++) {
              const s2 = t2[i2];
              hu(n2, r2, s2, e2), r2 = s2;
            }
            return n2;
          }
          const fu = Math.pow(2, 14) - 1, du = -fu - 1;
          function mu(t2, e2) {
            const r2 = Math.round(t2.x * e2), n2 = Math.round(t2.y * e2);
            return t2.x = Et(r2, du, fu), t2.y = Et(n2, du, fu), (r2 < t2.x || r2 > t2.x + 1 || n2 < t2.y || n2 > t2.y + 1) && Gt("Geometry exceeds allowed extent, reduce your vector tile buffer size"), t2;
          }
          function yu(t2, e2, r2) {
            const n2 = t2.loadGeometry(), i2 = t2.extent, s2 = Cn / i2;
            if (e2 && r2 && r2.projection.isReprojectedInTileSpace) {
              const s3 = 1 << e2.z, { scale: o2, x: a2, y: l2, projection: u2 } = r2, c2 = (t3) => {
                const r3 = tu((e2.x + t3.x / i2) / s3), n3 = eu((e2.y + t3.y / i2) / s3), c3 = u2.project(r3, n3);
                t3.x = (c3.x * o2 - a2) * i2, t3.y = (c3.y * o2 - l2) * i2;
              };
              for (let e3 = 0; e3 < n2.length; e3++) if (1 !== t2.type) n2[e3] = cu(n2[e3], c2, 1);
              else {
                const t3 = [];
                for (const r3 of n2[e3]) r3.x < 0 || r3.x >= i2 || r3.y < 0 || r3.y >= i2 || (c2(r3), t3.push(r3));
                n2[e3] = t3;
              }
            }
            for (const t3 of n2) for (const e3 of t3) mu(e3, s2);
            return n2;
          }
          function gu(t2, e2) {
            return { type: t2.type, id: t2.id, properties: t2.properties, geometry: e2 ? yu(t2) : [] };
          }
          var xu, vu, bu, wu, _u, Au, Mu, Iu = {};
          function Su() {
            if (vu) return xu;
            vu = 1;
            var t2 = vt();
            function e2(t3, e3, n3, i2, s2) {
              this.properties = {}, this.extent = n3, this.type = 0, this._pbf = t3, this._geometry = -1, this._keys = i2, this._values = s2, t3.readFields(r2, this, e3);
            }
            function r2(t3, e3, r3) {
              1 == t3 ? e3.id = r3.readVarint() : 2 == t3 ? function(t4, e4) {
                for (var r4 = t4.readVarint() + t4.pos; t4.pos < r4; ) {
                  var n3 = e4._keys[t4.readVarint()], i2 = e4._values[t4.readVarint()];
                  e4.properties[n3] = i2;
                }
              }(r3, e3) : 3 == t3 ? e3.type = r3.readVarint() : 4 == t3 && (e3._geometry = r3.pos);
            }
            function n2(t3) {
              for (var e3, r3, n3 = 0, i2 = 0, s2 = t3.length, o2 = s2 - 1; i2 < s2; o2 = i2++) n3 += ((r3 = t3[o2]).x - (e3 = t3[i2]).x) * (e3.y + r3.y);
              return n3;
            }
            return xu = e2, e2.types = ["Unknown", "Point", "LineString", "Polygon"], e2.prototype.loadGeometry = function() {
              var e3 = this._pbf;
              e3.pos = this._geometry;
              for (var r3, n3 = e3.readVarint() + e3.pos, i2 = 1, s2 = 0, o2 = 0, a2 = 0, l2 = []; e3.pos < n3; ) {
                if (s2 <= 0) {
                  var u2 = e3.readVarint();
                  i2 = 7 & u2, s2 = u2 >> 3;
                }
                if (s2--, 1 === i2 || 2 === i2) o2 += e3.readSVarint(), a2 += e3.readSVarint(), 1 === i2 && (r3 && l2.push(r3), r3 = []), r3.push(new t2(o2, a2));
                else {
                  if (7 !== i2) throw new Error("unknown command " + i2);
                  r3 && r3.push(r3[0].clone());
                }
              }
              return r3 && l2.push(r3), l2;
            }, e2.prototype.bbox = function() {
              var t3 = this._pbf;
              t3.pos = this._geometry;
              for (var e3 = t3.readVarint() + t3.pos, r3 = 1, n3 = 0, i2 = 0, s2 = 0, o2 = 1 / 0, a2 = -1 / 0, l2 = 1 / 0, u2 = -1 / 0; t3.pos < e3; ) {
                if (n3 <= 0) {
                  var c2 = t3.readVarint();
                  r3 = 7 & c2, n3 = c2 >> 3;
                }
                if (n3--, 1 === r3 || 2 === r3) (i2 += t3.readSVarint()) < o2 && (o2 = i2), i2 > a2 && (a2 = i2), (s2 += t3.readSVarint()) < l2 && (l2 = s2), s2 > u2 && (u2 = s2);
                else if (7 !== r3) throw new Error("unknown command " + r3);
              }
              return [o2, l2, a2, u2];
            }, e2.prototype.toGeoJSON = function(t3, r3, i2) {
              var s2, o2, a2 = this.extent * Math.pow(2, i2), l2 = this.extent * t3, u2 = this.extent * r3, c2 = this.loadGeometry(), h3 = e2.types[this.type];
              function p3(t4) {
                for (var e3 = 0; e3 < t4.length; e3++) {
                  var r4 = t4[e3];
                  t4[e3] = [360 * (r4.x + l2) / a2 - 180, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * (r4.y + u2) / a2) * Math.PI / 180)) - 90];
                }
              }
              switch (this.type) {
                case 1:
                  var f2 = [];
                  for (s2 = 0; s2 < c2.length; s2++) f2[s2] = c2[s2][0];
                  p3(c2 = f2);
                  break;
                case 2:
                  for (s2 = 0; s2 < c2.length; s2++) p3(c2[s2]);
                  break;
                case 3:
                  for (c2 = function(t4) {
                    var e3 = t4.length;
                    if (e3 <= 1) return [t4];
                    for (var r4, i3, s3 = [], o3 = 0; o3 < e3; o3++) {
                      var a3 = n2(t4[o3]);
                      0 !== a3 && (void 0 === i3 && (i3 = a3 < 0), i3 === a3 < 0 ? (r4 && s3.push(r4), r4 = [t4[o3]]) : r4.push(t4[o3]));
                    }
                    return r4 && s3.push(r4), s3;
                  }(c2), s2 = 0; s2 < c2.length; s2++) for (o2 = 0; o2 < c2[s2].length; o2++) p3(c2[s2][o2]);
              }
              1 === c2.length ? c2 = c2[0] : h3 = "Multi" + h3;
              var d2 = { type: "Feature", geometry: { type: h3, coordinates: c2 }, properties: this.properties };
              return "id" in this && (d2.id = this.id), d2;
            }, xu;
          }
          function zu() {
            if (wu) return bu;
            wu = 1;
            var t2 = Su();
            function e2(t3, e3) {
              this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = t3, this._keys = [], this._values = [], this._features = [], t3.readFields(r2, this, e3), this.length = this._features.length;
            }
            function r2(t3, e3, r3) {
              15 === t3 ? e3.version = r3.readVarint() : 1 === t3 ? e3.name = r3.readString() : 5 === t3 ? e3.extent = r3.readVarint() : 2 === t3 ? e3._features.push(r3.pos) : 3 === t3 ? e3._keys.push(r3.readString()) : 4 === t3 && e3._values.push(function(t4) {
                for (var e4 = null, r4 = t4.readVarint() + t4.pos; t4.pos < r4; ) {
                  var n2 = t4.readVarint() >> 3;
                  e4 = 1 === n2 ? t4.readString() : 2 === n2 ? t4.readFloat() : 3 === n2 ? t4.readDouble() : 4 === n2 ? t4.readVarint64() : 5 === n2 ? t4.readVarint() : 6 === n2 ? t4.readSVarint() : 7 === n2 ? t4.readBoolean() : null;
                }
                return e4;
              }(r3));
            }
            return bu = e2, e2.prototype.feature = function(e3) {
              if (e3 < 0 || e3 >= this._features.length) throw new Error("feature index out of bounds");
              this._pbf.pos = this._features[e3];
              var r3 = this._pbf.readVarint() + this._pbf.pos;
              return new t2(this._pbf, r3, this.extent, this._keys, this._values);
            }, bu;
          }
          function ku() {
            return Mu || (Mu = 1, Iu.VectorTile = function() {
              if (Au) return _u;
              Au = 1;
              var t2 = zu();
              function e2(e3, r2, n2) {
                if (3 === e3) {
                  var i2 = new t2(n2, n2.readVarint() + n2.pos);
                  i2.length && (r2[i2.name] = i2);
                }
              }
              return _u = function(t3, r2) {
                this.layers = t3.readFields(e2, {}, r2);
              }, _u;
            }(), Iu.VectorTileFeature = Su(), Iu.VectorTileLayer = zu()), Iu;
          }
          var Pu = ku();
          const Eu = "3d_elevation_id", Tu = "level";
          class Bu {
            constructor() {
              this._valid = false;
            }
            reset(t2) {
              return this.feature = t2, this._valid = true, this._geometry = t2.loadGeometry(), 0 !== this._geometry.length && 0 !== this._geometry[0].length || (this._valid = false), this;
            }
            geometry(t2, e2) {
              return this._valid && t2(e2(this._geometry)), this;
            }
            require(t2, e2, r2) {
              return this.get(t2, true, e2, r2);
            }
            optional(t2, e2, r2) {
              return this.get(t2, false, e2, r2);
            }
            success() {
              return this._valid;
            }
            get(t2, e2, r2, n2) {
              const i2 = this.feature.properties.hasOwnProperty(t2) ? +this.feature.properties[t2] : void 0;
              return this._valid && void 0 !== i2 && !Number.isNaN(i2) ? r2(n2 ? n2(i2) : i2) : e2 && (this._valid = false), this;
            }
          }
          class Vu {
            constructor(t2, e2) {
              this.featureFunc = t2, this.vertexFunc = e2;
            }
            parseFeature(t2, e2, r2) {
              return this.featureFunc(t2, e2, r2);
            }
            parseVertex(t2, e2, r2) {
              return this.vertexFunc(t2, e2, r2);
            }
          }
          const Cu = new Vu((t2, e2, r2) => t2.reset(e2).require(Eu, (t3) => {
            r2.id = t3;
          }).optional("fixed_height_relative", (t3) => {
            r2.constantHeight = t3;
          }, Du.decodeRelativeHeight).geometry((t3) => {
            r2.bounds = t3;
          }, pn).success(), (t2, e2, r2) => t2.reset(e2).require(Eu, (t3) => {
            r2.id = t3;
          }).require("elevation_idx", (t3) => {
            r2.idx = t3;
          }).require("extent", (t3) => {
            r2.extent = t3;
          }).require("height_relative", (t3) => {
            r2.height = t3;
          }, Du.decodeRelativeHeight).geometry((t3) => {
            r2.position = t3;
          }, Du.getPoint).success()), Fu = new Vu((t2, e2, r2) => t2.reset(e2).require(Eu, (t3) => {
            r2.id = t3;
          }).optional("fixed_height", (t3) => {
            r2.constantHeight = t3;
          }, Du.decodeMetricHeight).geometry((t3) => {
            r2.bounds = t3;
          }, pn).success(), (t2, e2, r2) => t2.reset(e2).require(Eu, (t3) => {
            r2.id = t3;
          }).require("elevation_idx", (t3) => {
            r2.idx = t3;
          }).require("extent", (t3) => {
            r2.extent = t3;
          }).require("height", (t3) => {
            r2.height = t3;
          }, Du.decodeMetricHeight).geometry((t3) => {
            r2.position = t3;
          }, Du.getPoint).success());
          class Du {
            static getPoint(t2) {
              return at(t2[0][0].x, t2[0][0].y);
            }
            static decodeRelativeHeight(t2) {
              return 1e-4 * t2 * 5;
            }
            static decodeMetricHeight(t2) {
              return 1e-4 * t2;
            }
            static parse(t2) {
              const e2 = [], r2 = [], n2 = t2.length, i2 = new Bu();
              for (let o2 = 0; o2 < n2; o2++) {
                const n3 = t2.feature(o2), a2 = n3.properties.hasOwnProperty("version") ? String(n3.properties.version) : void 0, l2 = (s2 = a2) ? "1.0.1" === s2 ? Fu : void 0 : Cu;
                if (void 0 === l2) {
                  Gt(`Unknown elevation feature version number ${a2 || "(unknown)"}`);
                  continue;
                }
                const u2 = n3.properties.hasOwnProperty("type") ? n3.properties.type : void 0;
                if (u2) {
                  if ("Point" === Pu.VectorTileFeature.types[n3.type] && "curve_point" === u2) {
                    const t3 = {};
                    l2.parseVertex(i2, n3, t3) && e2.push(t3);
                  } else if ("Polygon" === Pu.VectorTileFeature.types[n3.type] && "curve_meta" === u2) {
                    const t3 = {};
                    l2.parseFeature(i2, n3, t3) && r2.push(t3);
                  }
                }
              }
              var s2;
              return { vertices: e2, features: r2 };
            }
          }
          class Lu {
            constructor(t2, e2) {
              this.pos = t2, this.dir = e2;
            }
            intersectsPlane(t2, e2, r2) {
              const n2 = ft(e2, this.dir);
              if (Math.abs(n2) < 1e-6) return false;
              const i2 = ((t2[0] - this.pos[0]) * e2[0] + (t2[1] - this.pos[1]) * e2[1]) / n2;
              return r2[0] = this.pos[0] + this.dir[0] * i2, r2[1] = this.pos[1] + this.dir[1] * i2, true;
            }
          }
          class Ru {
            constructor(t2, e2) {
              this.pos = t2, this.dir = e2;
            }
            intersectsPlane(t2, e2, r2) {
              const n2 = F(e2, this.dir);
              if (Math.abs(n2) < 1e-6) return false;
              const i2 = ((t2[0] - this.pos[0]) * e2[0] + (t2[1] - this.pos[1]) * e2[1] + (t2[2] - this.pos[2]) * e2[2]) / n2;
              return r2[0] = this.pos[0] + this.dir[0] * i2, r2[1] = this.pos[1] + this.dir[1] * i2, r2[2] = this.pos[2] + this.dir[2] * i2, true;
            }
            closestPointOnSphere(t2, r2, n2) {
              if (function(t3, r3) {
                var n3 = t3[0], i3 = t3[1], s3 = t3[2], o3 = r3[0], a3 = r3[1], l3 = r3[2];
                return Math.abs(n3 - o3) <= e * Math.max(1, Math.abs(n3), Math.abs(o3)) && Math.abs(i3 - a3) <= e * Math.max(1, Math.abs(i3), Math.abs(a3)) && Math.abs(s3 - l3) <= e * Math.max(1, Math.abs(s3), Math.abs(l3));
              }(this.pos, t2) || 0 === r2) return n2[0] = n2[1] = n2[2] = 0, false;
              const [i2, s2, o2] = this.dir, a2 = this.pos[0] - t2[0], l2 = this.pos[1] - t2[1], u2 = this.pos[2] - t2[2], c2 = i2 * i2 + s2 * s2 + o2 * o2, h3 = 2 * (a2 * i2 + l2 * s2 + u2 * o2), p3 = h3 * h3 - 4 * c2 * (a2 * a2 + l2 * l2 + u2 * u2 - r2 * r2);
              if (p3 < 0) {
                const t3 = Math.max(-h3 / 2, 0), e2 = a2 + i2 * t3, c3 = l2 + s2 * t3, p4 = u2 + o2 * t3, f2 = Math.hypot(e2, c3, p4);
                return n2[0] = e2 * r2 / f2, n2[1] = c3 * r2 / f2, n2[2] = p4 * r2 / f2, false;
              }
              {
                const t3 = (-h3 - Math.sqrt(p3)) / (2 * c2);
                if (t3 < 0) {
                  const t4 = Math.hypot(a2, l2, u2);
                  return n2[0] = a2 * r2 / t4, n2[1] = l2 * r2 / t4, n2[2] = u2 * r2 / t4, false;
                }
                return n2[0] = a2 + i2 * t3, n2[1] = l2 + s2 * t3, n2[2] = u2 + o2 * t3, true;
              }
            }
          }
          class Ou {
            constructor(t2, e2, r2, n2, i2) {
              this.TL = t2, this.TR = e2, this.BR = r2, this.BL = n2, this.horizon = i2;
            }
            static fromInvProjectionMatrix(t2, e2, r2) {
              const n2 = [-1, 1, 1], i2 = [1, 1, 1], s2 = [1, -1, 1], o2 = [-1, -1, 1], a2 = R(n2, n2, t2), l2 = R(i2, i2, t2), u2 = R(s2, s2, t2), c2 = R(o2, o2, t2);
              return new Ou(a2, l2, u2, c2, e2 / r2);
            }
          }
          function Uu(t2, e2, r2) {
            let n2 = 1 / 0, i2 = -1 / 0;
            const s2 = [];
            for (const o2 of t2) {
              j(s2, o2, e2);
              const t3 = F(s2, r2);
              n2 = Math.min(n2, t3), i2 = Math.max(i2, t3);
            }
            return [n2, i2];
          }
          function Nu(t2, e2) {
            let r2 = true;
            for (let n2 = 0; n2 < t2.planes.length; n2++) {
              const i2 = t2.planes[n2];
              let s2 = 0;
              for (let t3 = 0; t3 < e2.length; t3++) s2 += F(i2, e2[t3]) + i2[3] >= 0;
              if (0 === s2) return 0;
              s2 !== e2.length && (r2 = false);
            }
            return r2 ? 2 : 1;
          }
          function ju(t2, e2) {
            for (const r2 of t2.projections) {
              const n2 = Uu(e2, t2.points[0], r2.axis);
              if (r2.projection[1] < n2[0] || r2.projection[0] > n2[1]) return 0;
            }
            return 1;
          }
          function $u(t2, e2) {
            let r2 = 0;
            const n2 = [0, 0, 0, 0];
            for (let o2 = 0; o2 < t2.length; o2++) n2[0] = t2[o2][0], n2[1] = t2[o2][1], n2[2] = t2[o2][2], n2[3] = 1, (i2 = n2)[0] * (s2 = e2)[0] + i2[1] * s2[1] + i2[2] * s2[2] + i2[3] * s2[3] >= 0 && r2++;
            var i2, s2;
            return r2;
          }
          class Gu {
            constructor(t2, e2) {
              this.points = t2 || new Array(8).fill([0, 0, 0]), this.planes = e2 || new Array(6).fill([0, 0, 0, 0]), this.bounds = qu.fromPoints(this.points), this.projections = [], this.frustumEdges = [j([], this.points[2], this.points[3]), j([], this.points[0], this.points[3]), j([], this.points[4], this.points[0]), j([], this.points[5], this.points[1]), j([], this.points[6], this.points[2]), j([], this.points[7], this.points[3])];
              for (const t3 of this.frustumEdges) {
                const e3 = [0, -t3[2], t3[1]], r2 = [t3[2], 0, -t3[0]];
                this.projections.push({ axis: e3, projection: Uu(this.points, this.points[0], e3) }), this.projections.push({ axis: r2, projection: Uu(this.points, this.points[0], r2) });
              }
            }
            static fromInvProjectionMatrix(t2, e2, r2, n2) {
              const i2 = Math.pow(2, r2), s2 = [[-1, 1, -1, 1], [1, 1, -1, 1], [1, -1, -1, 1], [-1, -1, -1, 1], [-1, 1, 1, 1], [1, 1, 1, 1], [1, -1, 1, 1], [-1, -1, 1, 1]].map((r3) => {
                const s3 = Z([], r3, t2), o3 = 1 / s3[3] / e2 * i2;
                return (a3 = s3)[0] = (l2 = s3)[0] * (u2 = [o3, o3, n2 ? 1 / s3[3] : o3, o3])[0], a3[1] = l2[1] * u2[1], a3[2] = l2[2] * u2[2], a3[3] = l2[3] * u2[3], a3;
                var a3, l2, u2;
              }), o2 = [[0, 1, 2], [6, 5, 4], [0, 3, 7], [2, 1, 5], [3, 2, 6], [0, 4, 5]].map((t3) => {
                const e3 = C([], D([], j([], s2[t3[0]], s2[t3[1]]), j([], s2[t3[2]], s2[t3[1]]))), r3 = -F(e3, s2[t3[1]]);
                return e3.concat(r3);
              }), a2 = [];
              for (let t3 = 0; t3 < s2.length; t3++) a2.push([s2[t3][0], s2[t3][1], s2[t3][2]]);
              return new Gu(a2, o2);
            }
            intersectsPrecise(t2, e2, r2) {
              for (let r3 = 0; r3 < e2.length; r3++) if (!$u(t2, e2[r3])) return 0;
              for (let e3 = 0; e3 < this.planes.length; e3++) if (!$u(t2, this.planes[e3])) return 0;
              for (const e3 of r2) for (const r3 of this.frustumEdges) {
                const n2 = D([], e3, r3), i2 = _(n2);
                if (0 === i2) continue;
                P(n2, n2, 1 / i2);
                const s2 = Uu(this.points, this.points[0], n2), o2 = Uu(t2, this.points[0], n2);
                if (s2[0] > o2[1] || o2[0] > s2[1]) return 0;
              }
              return 1;
            }
            containsPoint(t2) {
              for (const e2 of this.planes) {
                const r2 = e2[3];
                if (F([e2[0], e2[1], e2[2]], t2) + r2 < 0) return false;
              }
              return true;
            }
          }
          class qu {
            static fromPoints(t2) {
              const e2 = [1 / 0, 1 / 0, 1 / 0], r2 = [-1 / 0, -1 / 0, -1 / 0];
              for (const n2 of t2) z(e2, e2, n2), k(r2, r2, n2);
              return new qu(e2, r2);
            }
            static fromTileIdAndHeight(t2, e2, r2) {
              const n2 = 1 << t2.canonical.z, i2 = t2.canonical.x, s2 = t2.canonical.y;
              return new qu([i2 / n2, s2 / n2, e2], [(i2 + 1) / n2, (s2 + 1) / n2, r2]);
            }
            static applyTransform(t2, e2) {
              const r2 = t2.getCorners();
              for (let t3 = 0; t3 < r2.length; ++t3) R(r2[t3], r2[t3], e2);
              return qu.fromPoints(r2);
            }
            static applyTransformFast(t2, e2) {
              const r2 = [e2[12], e2[13], e2[14]], n2 = [...r2];
              for (let i2 = 0; i2 < 3; i2++) for (let s2 = 0; s2 < 3; s2++) {
                const o2 = e2[4 * s2 + i2], a2 = o2 * t2.min[s2], l2 = o2 * t2.max[s2];
                r2[i2] += Math.min(a2, l2), n2[i2] += Math.max(a2, l2);
              }
              return new qu(r2, n2);
            }
            static projectAabbCorners(t2, e2) {
              const r2 = t2.getCorners();
              for (let t3 = 0; t3 < r2.length; ++t3) R(r2[t3], r2[t3], e2);
              return r2;
            }
            constructor(t2, e2) {
              this.min = t2, this.max = e2, this.center = P([], M([], this.min, this.max), 0.5);
            }
            quadrant(t2) {
              const e2 = [t2 % 2 == 0, t2 < 2], r2 = w(this.min), n2 = w(this.max);
              for (let t3 = 0; t3 < e2.length; t3++) r2[t3] = e2[t3] ? this.min[t3] : this.center[t3], n2[t3] = e2[t3] ? this.center[t3] : this.max[t3];
              return n2[2] = this.max[2], new qu(r2, n2);
            }
            distanceX(t2) {
              return Math.max(Math.min(this.max[0], t2[0]), this.min[0]) - t2[0];
            }
            distanceY(t2) {
              return Math.max(Math.min(this.max[1], t2[1]), this.min[1]) - t2[1];
            }
            distanceZ(t2) {
              return Math.max(Math.min(this.max[2], t2[2]), this.min[2]) - t2[2];
            }
            getCorners() {
              const t2 = this.min, e2 = this.max;
              return [[t2[0], t2[1], t2[2]], [e2[0], t2[1], t2[2]], [e2[0], e2[1], t2[2]], [t2[0], e2[1], t2[2]], [t2[0], t2[1], e2[2]], [e2[0], t2[1], e2[2]], [e2[0], e2[1], e2[2]], [t2[0], e2[1], e2[2]]];
            }
            intersects(t2) {
              return this.intersectsAabb(t2.bounds) ? Nu(t2, this.getCorners()) : 0;
            }
            intersectsFlat(t2) {
              return this.intersectsAabb(t2.bounds) ? Nu(t2, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
            }
            intersectsPrecise(t2, e2) {
              return e2 || this.intersects(t2) ? ju(t2, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(t2, e2) {
              return e2 || this.intersectsFlat(t2) ? ju(t2, [[this.min[0], this.min[1], 0], [this.max[0], this.min[1], 0], [this.max[0], this.max[1], 0], [this.min[0], this.max[1], 0]]) : 0;
            }
            intersectsAabb(t2) {
              for (let e2 = 0; e2 < 3; ++e2) if (this.min[e2] > t2.max[e2] || t2.min[e2] > this.max[e2]) return false;
              return true;
            }
            intersectsAabbXY(t2) {
              return !(this.min[0] > t2.max[0] || t2.min[0] > this.max[0] || this.min[1] > t2.max[1] || t2.min[1] > this.max[1]);
            }
            encapsulate(t2) {
              for (let e2 = 0; e2 < 3; e2++) this.min[e2] = Math.min(this.min[e2], t2.min[e2]), this.max[e2] = Math.max(this.max[e2], t2.max[e2]);
            }
            encapsulatePoint(t2) {
              for (let e2 = 0; e2 < 3; e2++) this.min[e2] = Math.min(this.min[e2], t2[e2]), this.max[e2] = Math.max(this.max[e2], t2[e2]);
            }
            closestPoint(t2) {
              return [Math.max(Math.min(this.max[0], t2[0]), this.min[0]), Math.max(Math.min(this.max[1], t2[1]), this.min[1]), Math.max(Math.min(this.max[2], t2[2]), this.min[2])];
            }
          }
          qs(qu, "Aabb");
          class Hu {
            constructor(t2, e2) {
              this.feature = t2, this.metersToTile = e2, this.index = 0;
            }
            get() {
              const t2 = this.feature.vertices[this.index], e2 = this.feature.vertexProps[this.index].dir, r2 = e2[1], n2 = -e2[0], i2 = (t2.extent + 1) * this.metersToTile;
              return [new bt(Math.trunc(t2.position[0] + r2 * i2), Math.trunc(t2.position[1] + n2 * i2)), new bt(Math.trunc(t2.position[0] - r2 * i2), Math.trunc(t2.position[1] - n2 * i2))];
            }
            next() {
              this.index++;
            }
            valid() {
              return this.index < this.feature.vertices.length;
            }
          }
          class Xu {
            constructor(t2, e2, r2, n2, i2, s2) {
              if (this.vertices = new Array(), this.vertexProps = new Array(), this.edges = new Array(), this.edgeProps = new Array(), this.id = t2, this.heightRange = { min: r2, max: r2 }, this.safeArea = e2, this.constantHeight = r2, null == this.constantHeight && (null != this.constantHeight || 0 !== n2.length)) {
                this.vertices = n2, this.edges = i2, this.edges = this.edges.filter((t3) => {
                  return t3.a < this.vertices.length && t3.b < this.vertices.length && !((e3 = this.vertices[t3.a].position)[0] === (r3 = this.vertices[t3.b].position)[0] && e3[1] === r3[1]);
                  var e3, r3;
                }), this.heightRange = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
                for (const t3 of this.vertices) this.vertexProps.push({ dir: at(0, 0) }), this.heightRange.min = Math.min(this.heightRange.min, t3.height), this.heightRange.max = Math.max(this.heightRange.max, t3.height);
                for (const t3 of this.edges) {
                  const e3 = this.vertices[t3.a].position, r3 = this.vertices[t3.b].position, n3 = ut(ot(), r3, e3), i3 = ht(n3), s3 = ct(ot(), n3, 1 / i3);
                  this.edgeProps.push({ vec: n3, dir: s3, len: i3 });
                  const o2 = this.vertexProps[t3.a].dir, a2 = this.vertexProps[t3.b].dir;
                  lt(o2, o2, s3), lt(a2, a2, s3);
                }
                for (const t3 of this.vertexProps) 0 === t3.dir[0] && 0 === t3.dir[1] || pt(t3.dir, t3.dir);
                this.tessellate(s2);
              }
            }
            pointElevation(t2) {
              if (null != this.constantHeight) return this.constantHeight;
              const e2 = this.getClosestEdge(t2);
              if (null == e2) return 0;
              const [r2, n2] = e2;
              return ur(this.vertices[this.edges[r2].a].height, this.vertices[this.edges[r2].b].height, n2);
            }
            computeSlopeNormal(t2, e2) {
              const r2 = this.getClosestEdge(t2);
              if (!r2) return A(0, 0, 1);
              const n2 = r2[0], i2 = this.edges[n2], s2 = this.edgeProps[n2].vec, o2 = A(s2[0], s2[1], (this.vertices[i2.b].height - this.vertices[i2.a].height) * e2), a2 = A(o2[1], -o2[0], 0);
              D(a2, a2, o2);
              const l2 = _(a2);
              return l2 > 0 ? P(a2, a2, 1 / l2) : A(0, 0, 1);
            }
            getSafeArea() {
              return this.safeArea;
            }
            isTunnel() {
              return this.heightRange.max <= -5;
            }
            getClosestEdge(t2) {
              if (0 === this.edges.length) return;
              let e2 = 0, r2 = Number.POSITIVE_INFINITY, n2 = 0;
              const i2 = at(t2.x, t2.y);
              for (let t3 = 0; t3 < this.edges.length; t3++) {
                const s2 = this.edges[t3], o2 = this.edgeProps[t3].dir, a2 = new Lu(i2, this.edgeProps[t3].dir), l2 = this.vertices[s2.a].position, u2 = this.vertices[s2.b].position, c2 = ot(), h3 = ot(), p3 = a2.intersectsPlane(l2, this.vertexProps[s2.a].dir, c2), f2 = a2.intersectsPlane(u2, this.vertexProps[s2.b].dir, h3);
                if (!p3 || !f2) continue;
                const d2 = ut(ot(), h3, c2), m2 = ut(ot(), i2, c2), y2 = ft(d2, d2), g2 = y2 > 0 ? ft(m2, d2) / y2 : 0, x2 = Et(g2, 0, 1), v2 = Math.abs((g2 - x2) * this.edgeProps[t3].len), b2 = ut(ot(), i2, l2), w2 = v2 + Math.abs(ft(b2, at(o2[1], -o2[0])));
                w2 < r2 && (e2 = t3, r2 = w2, n2 = x2);
              }
              return [e2, n2];
            }
            tessellate(t2) {
              for (let e2 = this.edges.length - 1; e2 >= 0; --e2) {
                const r2 = this.edges[e2].a, n2 = this.edges[e2].b, { position: i2, height: s2, extent: o2 } = this.vertices[r2], { position: a2, height: l2, extent: u2 } = this.vertices[n2], c2 = this.vertexProps[r2].dir, h3 = this.vertexProps[n2].dir, p3 = A(i2[0] / t2, i2[1] / t2, s2), f2 = A(a2[0] / t2, a2[1] / t2, l2), d2 = A(c2[1], -c2[0], 0);
                P(d2, d2, o2);
                const m2 = A(h3[1], -h3[0], 0);
                if (P(m2, m2, u2), this.distSqLines(A(p3[0] + 0.5 * d2[0], p3[1] + 0.5 * d2[1], p3[2] + 0.5 * d2[2]), A(f2[0] - 0.5 * m2[0], f2[1] - 0.5 * m2[1], f2[2] - 0.5 * m2[2]), A(p3[0] - 0.5 * d2[0], p3[1] - 0.5 * d2[1], p3[2] - 0.5 * d2[2]), A(f2[0] + 0.5 * m2[0], f2[1] + 0.5 * m2[1], f2[2] + 0.5 * m2[2])) <= 0.0025000000000000005) continue;
                const y2 = this.vertices.length, g2 = lt(ot(), i2, a2);
                this.vertices.push({ position: ct(g2, g2, 0.5), height: 0.5 * (s2 + l2), extent: 0.5 * (o2 + u2) });
                const x2 = lt(ot(), c2, h3);
                this.vertexProps.push({ dir: pt(x2, x2) }), this.edges.splice(e2, 1), this.edgeProps.splice(e2, 1), this.edges.push({ a: r2, b: y2 }), this.edges.push({ a: y2, b: n2 });
                const v2 = ut(ot(), this.vertices[y2].position, i2), b2 = ht(v2), w2 = { vec: v2, dir: ct(ot(), v2, 1 / b2), len: b2 };
                this.edgeProps.push(w2), this.edgeProps.push(w2);
              }
            }
            distSqLines(t2, e2, r2, n2) {
              const i2 = I(b(), e2, t2), s2 = I(b(), n2, r2), o2 = I(b(), t2, r2), a2 = F(i2, i2), l2 = F(i2, s2), u2 = F(i2, o2), c2 = F(s2, s2), h3 = F(s2, o2), p3 = a2 * c2 - l2 * l2;
              if (0 === p3) {
                const e3 = F(o2, s2) / F(s2, s2);
                return T(L(b(), r2, n2, e3), t2);
              }
              const f2 = (l2 * h3 - u2 * c2) / p3, d2 = (a2 * h3 - l2 * u2) / p3;
              return T(L(b(), t2, e2, f2), L(b(), r2, n2, d2));
            }
          }
          class Zu {
            static parseFrom(t2, e2) {
              const r2 = Du.parse(t2);
              if (!r2) return [];
              let { vertices: n2, features: i2 } = r2;
              const s2 = 1 / au(e2);
              i2.sort((t3, e3) => t3.id - e3.id), n2.sort((t3, e3) => t3.id - e3.id || t3.idx - e3.idx), n2 = n2.filter((t3, e3, r3) => e3 === r3.findIndex((e4) => e4.id === t3.id && e4.idx === t3.idx));
              const o2 = new Array();
              let a2 = 0;
              const l2 = n2.length;
              for (const t3 of i2) {
                if (t3.constantHeight) {
                  o2.push(new Xu(t3.id, t3.bounds, t3.constantHeight));
                  continue;
                }
                for (; a2 !== l2 && n2[a2].id < t3.id; ) a2++;
                if (a2 === l2 || n2[a2].id !== t3.id) continue;
                const e3 = new Array(), r3 = new Array(), i3 = a2;
                for (; a2 !== l2 && n2[a2].id === t3.id; ) {
                  const t4 = n2[a2];
                  if (e3.push({ position: t4.position, height: t4.height, extent: t4.extent }), a2 !== i3 && n2[a2 - 1].idx === t4.idx - 1) {
                    const t5 = a2 - i3;
                    r3.push({ a: t5 - 1, b: t5 });
                  }
                  a2++;
                }
                o2.push(new Xu(t3.id, t3.bounds, void 0, e3, r3, s2));
              }
              return o2;
            }
            static getElevationFeature(t2, e2) {
              if (!e2) return;
              const r2 = +t2.properties[Eu];
              return Number.isNaN(r2) ? void 0 : e2.find((t3) => t3.id === r2);
            }
          }
          class Wu {
            constructor(t2, e2) {
              this.zScale = 1, this.xOffset = 0, this.yOffset = 0, t2.equals(e2) || (this.zScale = Math.pow(2, e2.z - t2.z), this.xOffset = (t2.x * this.zScale - e2.x) * Cn, this.yOffset = (t2.y * this.zScale - e2.y) * Cn);
            }
            constantElevation(t2, e2) {
              if (null != t2.constantHeight) return this.computeBiasedHeight(t2.constantHeight, e2);
            }
            pointElevation(t2, e2, r2) {
              const n2 = this.constantElevation(e2, r2);
              return null != n2 ? n2 : (t2.x = t2.x * this.zScale + this.xOffset, t2.y = t2.y * this.zScale + this.yOffset, this.computeBiasedHeight(e2.pointElevation(t2), r2));
            }
            computeBiasedHeight(t2, e2) {
              return e2 <= 0 ? t2 : t2 + e2 * Tt(0, e2, t2 >= 0 ? t2 : Math.abs(0.5 * t2));
            }
          }
          qs(Xu, "ElevationFeature");
          class Yu {
            constructor(t2) {
              this.zoom = t2.zoom, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.hasPattern = false, this.projection = t2.projection, this.layoutVertexArray = new ra(), this.indexArray = new Aa(), this.segments = new tl(), this.programConfigurations = new kl(t2.layers, { zoom: t2.zoom, lut: t2.lut }), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.elevationMode = this.layers[0].layout.get("circle-elevation-reference"), this.hasElevation = false, "none" !== this.elevationMode && (this.elevatedLayoutVertexArray = new sa()), this.worldview = t2.worldview;
            }
            updateFootprints(t2, e2) {
            }
            populate(t2, e2, r2, n2) {
              const i2 = this.layers[0], s2 = [];
              let o2 = null;
              "circle" === i2.type && (o2 = i2.layout.get("circle-sort-key"));
              for (const { feature: e3, id: i3, index: a3, sourceLayerIndex: l2 } of t2) {
                const t3 = this.layers[0]._featureFilter.needGeometry, u2 = gu(e3, t3);
                if (!this.layers[0]._featureFilter.filter(new go(this.zoom, { worldview: this.worldview }), u2, r2)) continue;
                const c2 = o2 ? o2.evaluate(u2, {}, r2) : void 0, h3 = { id: i3, properties: e3.properties, type: e3.type, sourceLayerIndex: l2, index: a3, geometry: t3 ? u2.geometry : yu(e3, r2, n2), patterns: {}, sortKey: c2 };
                s2.push(h3);
              }
              o2 && s2.sort((t3, e3) => t3.sortKey - e3.sortKey);
              let a2 = null;
              "globe" === n2.projection.name && (this.globeExtVertexArray = new fa(), a2 = n2.projection);
              for (const n3 of s2) {
                const { geometry: i3, index: s3, sourceLayerIndex: o3 } = n3, l2 = t2[s3].feature;
                this.addFeature(n3, i3, s3, e2.availableImages, r2, a2, e2.brightness, e2.elevationFeatures), e2.featureIndex.insert(l2, i3, s3, o3, this.index);
              }
              this.hasElevation || (this.elevatedLayoutVertexArray = void 0);
            }
            update(t2, e2, r2, n2, i2, s2, o2) {
              this.programConfigurations.updatePaintArrays(t2, e2, i2, r2, n2, s2, o2, this.worldview);
            }
            isEmpty() {
              return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
              return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t2) {
              this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, Ka.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = t2.createVertexBuffer(this.globeExtVertexArray, Qa.members)), this.elevatedLayoutVertexArray && (this.elevatedLayoutVertexBuffer = t2.createVertexBuffer(this.elevatedLayoutVertexArray, Ja.members))), this.programConfigurations.upload(t2), this.uploaded = true;
            }
            destroy() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy());
            }
            addFeature(t2, e2, r2, n2, i2, s2, o2, a2) {
              let l2;
              "none" !== this.elevationMode && (l2 = Zu.getElevationFeature(t2, a2));
              for (const r3 of e2) for (const e3 of r3) {
                const r4 = e3.x, n3 = e3.y;
                if (r4 < 0 || r4 >= Cn || n3 < 0 || n3 >= Cn) continue;
                if (s2) {
                  const t3 = s2.projectTilePoint(r4, n3, i2), e4 = s2.upVector(i2, r4, n3);
                  this.addGlobeExtVertex(t3, e4), this.addGlobeExtVertex(t3, e4), this.addGlobeExtVertex(t3, e4), this.addGlobeExtVertex(t3, e4);
                }
                const o3 = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, t2.sortKey), a3 = o3.vertexLength;
                if (this.addCircleVertex(r4, n3, -1, -1), this.addCircleVertex(r4, n3, 1, -1), this.addCircleVertex(r4, n3, 1, 1), this.addCircleVertex(r4, n3, -1, 1), "none" !== this.elevationMode) {
                  const t3 = l2 ? l2.pointElevation(new bt(r4, n3)) : 0;
                  this.hasElevation = this.hasElevation || 0 !== t3;
                  for (let e4 = 0; e4 < 4; e4++) this.elevatedLayoutVertexArray.emplaceBack(t3);
                }
                this.indexArray.emplaceBack(a3, a3 + 1, a3 + 2), this.indexArray.emplaceBack(a3, a3 + 2, a3 + 3), o3.vertexLength += 4, o3.primitiveLength += 2;
              }
              this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, {}, n2, i2, o2, void 0, this.worldview);
            }
            addCircleVertex(t2, e2, r2, n2) {
              this.layoutVertexArray.emplaceBack(2 * t2 + (r2 + 1) / 2, 2 * e2 + (n2 + 1) / 2);
            }
            addGlobeExtVertex(t2, e2) {
              const r2 = 16384;
              this.globeExtVertexArray.emplaceBack(t2.x, t2.y, t2.z, e2[0] * r2, e2[1] * r2, e2[2] * r2);
            }
          }
          function Ku(t2, e2) {
            for (let r2 = 0; r2 < t2.length; r2++) if (lc(e2, t2[r2])) return true;
            for (let r2 = 0; r2 < e2.length; r2++) if (lc(t2, e2[r2])) return true;
            return !!ec(t2, e2);
          }
          function Ju(t2, e2, r2) {
            return !!lc(t2, e2) || !!sc(e2, t2, r2);
          }
          function Qu(t2, e2) {
            if (1 === t2.length) return ac(e2, t2[0]);
            for (let r2 = 0; r2 < e2.length; r2++) {
              const n2 = e2[r2];
              for (let e3 = 0; e3 < n2.length; e3++) if (lc(t2, n2[e3])) return true;
            }
            for (let r2 = 0; r2 < t2.length; r2++) if (ac(e2, t2[r2])) return true;
            for (let r2 = 0; r2 < e2.length; r2++) if (ec(t2, e2[r2])) return true;
            return false;
          }
          function tc(t2, e2, r2) {
            if (t2.length > 1) {
              if (ec(t2, e2)) return true;
              for (let n2 = 0; n2 < e2.length; n2++) if (sc(e2[n2], t2, r2)) return true;
            }
            for (let n2 = 0; n2 < t2.length; n2++) if (sc(t2[n2], e2, r2)) return true;
            return false;
          }
          function ec(t2, e2) {
            if (0 === t2.length || 0 === e2.length) return false;
            for (let r2 = 0; r2 < t2.length - 1; r2++) {
              const n2 = t2[r2], i2 = t2[r2 + 1];
              for (let t3 = 0; t3 < e2.length - 1; t3++) if (rc(n2, i2, e2[t3], e2[t3 + 1])) return true;
            }
            return false;
          }
          function rc(t2, e2, r2, n2) {
            return qt(t2, r2, n2) !== qt(e2, r2, n2) && qt(t2, e2, r2) !== qt(t2, e2, n2);
          }
          function nc(t2, e2, r2) {
            return (t2.x - r2.x) * (e2.y - r2.y) - (t2.y - r2.y) * (e2.x - r2.x);
          }
          function ic(t2, e2, r2, n2) {
            const i2 = nc(t2, e2, n2), s2 = nc(t2, e2, r2);
            if (Math.sign(i2) === Math.sign(s2)) return;
            const o2 = nc(r2, n2, t2), a2 = o2 + s2 - i2;
            return Math.sign(o2) !== Math.sign(a2) ? [o2 / (o2 - a2), s2 / (s2 - i2)] : void 0;
          }
          function sc(t2, e2, r2) {
            const n2 = r2 * r2;
            if (1 === e2.length) return t2.distSqr(e2[0]) < n2;
            for (let r3 = 1; r3 < e2.length; r3++) if (oc(t2, e2[r3 - 1], e2[r3]) < n2) return true;
            return false;
          }
          function oc(t2, e2, r2) {
            const n2 = e2.distSqr(r2);
            if (0 === n2) return t2.distSqr(e2);
            const i2 = ((t2.x - e2.x) * (r2.x - e2.x) + (t2.y - e2.y) * (r2.y - e2.y)) / n2;
            return t2.distSqr(i2 < 0 ? e2 : i2 > 1 ? r2 : r2.sub(e2)._mult(i2)._add(e2));
          }
          function ac(t2, e2) {
            let r2, n2, i2, s2 = false;
            for (let o2 = 0; o2 < t2.length; o2++) {
              r2 = t2[o2];
              for (let t3 = 0, o3 = r2.length - 1; t3 < r2.length; o3 = t3++) n2 = r2[t3], i2 = r2[o3], n2.y > e2.y != i2.y > e2.y && e2.x < (i2.x - n2.x) * (e2.y - n2.y) / (i2.y - n2.y) + n2.x && (s2 = !s2);
            }
            return s2;
          }
          function lc(t2, e2) {
            let r2 = false;
            for (let n2 = 0, i2 = t2.length - 1; n2 < t2.length; i2 = n2++) {
              const s2 = t2[n2], o2 = t2[i2];
              s2.y > e2.y != o2.y > e2.y && e2.x < (o2.x - s2.x) * (e2.y - s2.y) / (o2.y - s2.y) + s2.x && (r2 = !r2);
            }
            return r2;
          }
          function uc(t2, e2, r2, n2, i2) {
            for (const s3 of t2) if (e2 <= s3.x && r2 <= s3.y && n2 >= s3.x && i2 >= s3.y) return true;
            const s2 = [new bt(e2, r2), new bt(e2, i2), new bt(n2, i2), new bt(n2, r2)];
            if (t2.length > 2) {
              for (const e3 of s2) if (lc(t2, e3)) return true;
            }
            for (let e3 = 0; e3 < t2.length - 1; e3++) if (cc(t2[e3], t2[e3 + 1], s2)) return true;
            return false;
          }
          function cc(t2, e2, r2) {
            const n2 = r2[0], i2 = r2[2];
            if (t2.x < n2.x && e2.x < n2.x || t2.x > i2.x && e2.x > i2.x || t2.y < n2.y && e2.y < n2.y || t2.y > i2.y && e2.y > i2.y) return false;
            const s2 = qt(t2, e2, r2[0]);
            return s2 !== qt(t2, e2, r2[1]) || s2 !== qt(t2, e2, r2[2]) || s2 !== qt(t2, e2, r2[3]);
          }
          function hc(t2, e2, r2, n2, i2, s2) {
            let o2 = e2.y - t2.y, a2 = t2.x - e2.x;
            if (s2 = s2 || 0) {
              const t3 = o2 * o2 + a2 * a2;
              if (0 === t3) return true;
              const e3 = Math.sqrt(t3);
              o2 /= e3, a2 /= e3;
            }
            return !((r2.x - t2.x) * o2 + (r2.y - t2.y) * a2 - s2 < 0 || (n2.x - t2.x) * o2 + (n2.y - t2.y) * a2 - s2 < 0 || (i2.x - t2.x) * o2 + (i2.y - t2.y) * a2 - s2 < 0);
          }
          function pc(t2, e2, r2, n2, i2, s2, o2) {
            return !(hc(t2, e2, n2, i2, s2, o2) || hc(e2, r2, n2, i2, s2, o2) || hc(r2, t2, n2, i2, s2, o2) || hc(n2, i2, t2, e2, r2, o2) || hc(i2, s2, t2, e2, r2, o2) || hc(s2, n2, t2, e2, r2, o2));
          }
          function fc(t2, e2, r2) {
            const n2 = e2.paint.get(t2).value;
            return "constant" === n2.kind ? n2.value : r2.programConfigurations.get(e2.id).getMaxValue(t2);
          }
          function dc(t2) {
            return Math.sqrt(t2[0] * t2[0] + t2[1] * t2[1]);
          }
          function mc(t2, e2, r2, n2, i2) {
            if (!e2[0] && !e2[1]) return t2;
            const s2 = bt.convert(e2)._mult(i2);
            "viewport" === r2 && s2._rotate(-n2);
            const o2 = [];
            for (let e3 = 0; e3 < t2.length; e3++) o2.push(t2[e3].sub(s2));
            return o2;
          }
          function yc(t2, e2, r2, n2) {
            const i2 = bt.convert(t2)._mult(n2);
            return "viewport" === e2 && i2._rotate(-r2), i2;
          }
          let gc, xc;
          function vc(t2, e2, r2) {
            var n2 = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r2);
            return [t2 * n2 - 2 * Math.PI * 6378137 / 2, e2 * n2 - 2 * Math.PI * 6378137 / 2];
          }
          qs(Yu, "CircleBucket", { omit: ["layers"] });
          class bc {
            constructor(t2, e2, r2) {
              this.z = t2, this.x = e2, this.y = r2, this.key = Ac(0, t2, t2, e2, r2);
            }
            equals(t2) {
              return this.z === t2.z && this.x === t2.x && this.y === t2.y;
            }
            url(t2, e2) {
              const r2 = function(t3, e3, r3) {
                var n3 = vc(256 * t3, 256 * (e3 = Math.pow(2, r3) - e3 - 1), r3), i2 = vc(256 * (t3 + 1), 256 * (e3 + 1), r3);
                return n3[0] + "," + n3[1] + "," + i2[0] + "," + i2[1];
              }(this.x, this.y, this.z), n2 = function(t3, e3, r3) {
                let n3, i2 = "";
                for (let s2 = t3; s2 > 0; s2--) n3 = 1 << s2 - 1, i2 += (e3 & n3 ? 1 : 0) + (r3 & n3 ? 2 : 0);
                return i2;
              }(this.z, this.x, this.y);
              return t2[(this.x + this.y) % t2.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === e2 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n2).replace("{bbox-epsg-3857}", r2);
            }
            toString() {
              return `${this.z}/${this.x}/${this.y}`;
            }
          }
          class wc {
            constructor(t2, e2) {
              this.wrap = t2, this.canonical = e2, this.key = Ac(t2, e2.z, e2.z, e2.x, e2.y);
            }
          }
          class _c {
            constructor(t2, e2, r2, n2, i2) {
              this.overscaledZ = t2, this.wrap = e2, this.canonical = new bc(r2, +n2, +i2), this.key = 0 === e2 && t2 === r2 ? this.canonical.key : Ac(e2, t2, r2, n2, i2);
            }
            equals(t2) {
              return this.overscaledZ === t2.overscaledZ && this.wrap === t2.wrap && this.canonical.equals(t2.canonical);
            }
            scaledTo(t2) {
              const e2 = this.canonical.z - t2;
              return t2 > this.canonical.z ? new _c(t2, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new _c(t2, this.wrap, t2, this.canonical.x >> e2, this.canonical.y >> e2);
            }
            calculateScaledKey(t2, e2 = true) {
              if (this.overscaledZ === t2 && e2) return this.key;
              if (t2 > this.canonical.z) return Ac(this.wrap * +e2, t2, this.canonical.z, this.canonical.x, this.canonical.y);
              {
                const r2 = this.canonical.z - t2;
                return Ac(this.wrap * +e2, t2, t2, this.canonical.x >> r2, this.canonical.y >> r2);
              }
            }
            isChildOf(t2) {
              if (t2.wrap !== this.wrap) return false;
              const e2 = this.canonical.z - t2.canonical.z;
              return 0 === t2.overscaledZ || t2.overscaledZ < this.overscaledZ && t2.canonical.z < this.canonical.z && t2.canonical.x === this.canonical.x >> e2 && t2.canonical.y === this.canonical.y >> e2;
            }
            children(t2) {
              if (this.overscaledZ >= t2) return [new _c(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)];
              const e2 = this.canonical.z + 1, r2 = 2 * this.canonical.x, n2 = 2 * this.canonical.y;
              return [new _c(e2, this.wrap, e2, r2, n2), new _c(e2, this.wrap, e2, r2 + 1, n2), new _c(e2, this.wrap, e2, r2, n2 + 1), new _c(e2, this.wrap, e2, r2 + 1, n2 + 1)];
            }
            isLessThan(t2) {
              return this.wrap < t2.wrap || !(this.wrap > t2.wrap) && (this.overscaledZ < t2.overscaledZ || !(this.overscaledZ > t2.overscaledZ) && (this.canonical.x < t2.canonical.x || !(this.canonical.x > t2.canonical.x) && this.canonical.y < t2.canonical.y));
            }
            wrapped() {
              return new _c(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(t2) {
              return new _c(this.overscaledZ, t2, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
              return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
              return new wc(this.wrap, this.canonical);
            }
            toString() {
              return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
          }
          function Ac(t2, e2, r2, n2, i2) {
            const s2 = 1 << Math.min(r2, 22);
            let o2 = s2 * (i2 % s2) + n2 % s2;
            return t2 && r2 < 22 && (o2 += s2 * s2 * ((t2 < 0 ? -2 * t2 - 1 : 2 * t2) % (1 << 2 * (22 - r2)))), 16 * (32 * o2 + r2) + (e2 - r2);
          }
          const Mc = [(t2) => {
            let e2 = t2.canonical.x - 1, r2 = t2.wrap;
            return e2 < 0 && (e2 = (1 << t2.canonical.z) - 1, r2--), new _c(t2.overscaledZ, r2, t2.canonical.z, e2, t2.canonical.y);
          }, (t2) => {
            let e2 = t2.canonical.x + 1, r2 = t2.wrap;
            return e2 === 1 << t2.canonical.z && (e2 = 0, r2++), new _c(t2.overscaledZ, r2, t2.canonical.z, e2, t2.canonical.y);
          }, (t2) => new _c(t2.overscaledZ, t2.wrap, t2.canonical.z, t2.canonical.x, (0 === t2.canonical.y ? 1 << t2.canonical.z : t2.canonical.y) - 1), (t2) => new _c(t2.overscaledZ, t2.wrap, t2.canonical.z, t2.canonical.x, t2.canonical.y === (1 << t2.canonical.z) - 1 ? 0 : t2.canonical.y + 1)];
          qs(bc, "CanonicalTileID"), qs(_c, "OverscaledTileID", { omit: ["projMatrix", "expandedProjMatrix"] });
          const Ic = ta([{ type: "Float32", name: "a_globe_pos", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }]), { members: Sc } = Ic, zc = ta([{ name: "a_pos_3", components: 3, type: "Int16" }]);
          var kc = ta([{ name: "a_pos", type: "Int16", components: 2 }]);
          function Pc(t2) {
            return t2 * Cl / Gl;
          }
          const Ec = [new qu([Ul, Ul, Ul], [Nl, Nl, Nl]), new qu([Ul, Ul, Ul], [0, 0, Nl]), new qu([0, Ul, Ul], [Nl, 0, Nl]), new qu([Ul, 0, Ul], [0, Nl, Nl]), new qu([0, 0, Ul], [Nl, Nl, Nl])];
          function Tc(t2, e2, r2, n2 = true) {
            const i2 = P([], t2._camera.position, t2.worldSize), s2 = [e2, r2, 1, 1];
            Z(s2, s2, t2.pixelMatrixInverse), H(s2, s2, 1 / s2[3]);
            const o2 = C([], j([], s2, i2)), a2 = t2.globeMatrix, l2 = [a2[12], a2[13], a2[14]], u2 = j([], l2, i2), c2 = _(u2), h3 = C([], u2), p3 = t2.worldSize / (2 * Math.PI), f2 = F(h3, o2), d2 = Math.asin(p3 / c2);
            if (d2 < Math.acos(f2)) {
              if (!n2) return null;
              const t3 = [], e3 = [];
              P(t3, o2, c2 / f2), C(e3, j(e3, t3, u2)), C(o2, M(o2, u2, P(o2, e3, Math.tan(d2) * c2)));
            }
            const m2 = [];
            new Ru(i2, o2).closestPointOnSphere(l2, p3, m2);
            const y2 = C([], Kt(a2, 0)), g2 = C([], Kt(a2, 1)), x2 = C([], Kt(a2, 2)), v2 = F(y2, m2), b2 = F(g2, m2), w2 = F(x2, m2), A2 = It(Math.asin(-b2 / p3));
            let I2 = It(Math.atan2(v2, w2));
            I2 = t2.center.lng + function(t3, e3) {
              const r3 = (e3 - t3 + 180) % 360 - 180;
              return r3 < -180 ? r3 + 360 : r3;
            }(t2.center.lng, I2);
            const S2 = Kl(I2), z2 = Et(Jl(A2), 0, 1);
            return new lu(S2, z2);
          }
          class Bc {
            constructor(t2, e2, r2) {
              this.a = j([], t2, r2), this.b = j([], e2, r2), this.center = r2;
              const n2 = C([], this.a), i2 = C([], this.b);
              this.angle = Math.acos(F(n2, i2));
            }
          }
          function Vc(t2, e2) {
            if (0 === t2.angle) return null;
            let r2;
            return r2 = 0 === t2.a[e2] ? 1 / t2.angle * 0.5 * Math.PI : 1 / t2.angle * Math.atan(t2.b[e2] / t2.a[e2] / Math.sin(t2.angle) - 1 / Math.tan(t2.angle)), r2 < 0 || r2 > 1 ? null : function(t3, e3, r3, n2) {
              const i2 = Math.sin(r3);
              return t3 * (Math.sin((1 - n2) * r3) / i2) + e3 * (Math.sin(n2 * r3) / i2);
            }(t2.a[e2], t2.b[e2], t2.angle, Et(r2, 0, 1)) + t2.center[e2];
          }
          function Cc(t2) {
            if (t2.z <= 1) return Ec[t2.z + 2 * t2.y + t2.x];
            const e2 = Oc(Rc(t2));
            return qu.fromPoints(e2);
          }
          function Fc(t2, e2, r2) {
            return P(t2, t2, 1 - r2), E(t2, t2, e2, r2);
          }
          function Dc(t2, e2, r2) {
            for (const n2 of t2) R(n2, n2, e2), P(n2, n2, r2);
          }
          function Lc(t2, e2, r2, n2) {
            const i2 = e2 / t2.worldSize, s2 = t2.globeMatrix;
            if (r2.z <= 1) {
              const t3 = Cc(r2).getCorners();
              return Dc(t3, s2, i2), qu.fromPoints(t3);
            }
            const o2 = Rc(r2, n2), a2 = Oc(o2, Cl + Pc(t2._tileCoverLift));
            Dc(a2, s2, i2);
            const l2 = Number.MAX_VALUE, u2 = [-l2, -l2, -l2], c2 = [l2, l2, l2];
            if (o2.contains(t2.center)) {
              for (const t3 of a2) z(c2, c2, t3), k(u2, u2, t3);
              u2[2] = 0;
              const e3 = t2.point, r3 = [e3.x * i2, e3.y * i2, 0];
              return z(c2, c2, r3), k(u2, u2, r3), new qu(c2, u2);
            }
            if (t2._tileCoverLift > 0) {
              for (const t3 of a2) z(c2, c2, t3), k(u2, u2, t3);
              return new qu(c2, u2);
            }
            const h3 = [s2[12] * i2, s2[13] * i2, s2[14] * i2], p3 = o2.getCenter(), f2 = Et(t2.center.lat, -85.051129, nu), d2 = Et(p3.lat, -85.051129, nu), m2 = Kl(t2.center.lng), y2 = Jl(f2);
            let g2 = m2 - Kl(p3.lng);
            const x2 = y2 - Jl(d2);
            g2 > 0.5 ? g2 -= 1 : g2 < -0.5 && (g2 += 1);
            let v2 = 0;
            Math.abs(g2) > Math.abs(x2) ? v2 = g2 >= 0 ? 1 : 3 : (v2 = x2 >= 0 ? 0 : 2, E(h3, h3, [s2[4] * i2, s2[5] * i2, s2[6] * i2], -Math.sin(Mt(x2 >= 0 ? o2.getSouth() : o2.getNorth())) * Cl));
            const b2 = a2[v2], w2 = a2[(v2 + 1) % 4], _2 = new Bc(b2, w2, h3), A2 = [Vc(_2, 0) || b2[0], Vc(_2, 1) || b2[1], Vc(_2, 2) || b2[2]], I2 = Zc(t2.zoom);
            if (I2 > 0) {
              const n3 = function({ x: t3, y: e3, z: r3 }, n4, i4, s3, o3) {
                const a3 = 1 / (1 << r3);
                let l3 = t3 * a3, u3 = l3 + a3, c3 = e3 * a3, h4 = c3 + a3, p4 = 0;
                const f3 = (l3 + u3) / 2 - s3;
                return f3 > 0.5 ? p4 = -1 : f3 < -0.5 && (p4 = 1), l3 = ((l3 + p4) * n4 - (s3 *= n4)) * i4 + s3, u3 = ((u3 + p4) * n4 - s3) * i4 + s3, c3 = (c3 * n4 - (o3 *= n4)) * i4 + o3, h4 = (h4 * n4 - o3) * i4 + o3, [[l3, h4, 0], [u3, h4, 0], [u3, c3, 0], [l3, c3, 0]];
              }(r2, e2, t2._pixelsPerMercatorPixel, m2, y2);
              for (let t3 = 0; t3 < a2.length; t3++) Fc(a2[t3], n3[t3], I2);
              const i3 = M([], n3[v2], n3[(v2 + 1) % 4]);
              P(i3, i3, 0.5), Fc(A2, i3, I2);
            }
            for (const t3 of a2) z(c2, c2, t3), k(u2, u2, t3);
            return c2[2] = Math.min(b2[2], w2[2]), z(c2, c2, A2), k(u2, u2, A2), new qu(c2, u2);
          }
          function Rc({ x: t2, y: e2, z: r2 }, n2 = false) {
            const i2 = 1 / (1 << r2), s2 = new Hl(tu(t2 * i2), e2 === (1 << r2) - 1 && n2 ? -90 : eu((e2 + 1) * i2)), o2 = new Hl(tu((t2 + 1) * i2), 0 === e2 && n2 ? 90 : eu(e2 * i2));
            return new Xl(s2, o2);
          }
          function Oc(t2, e2 = Cl) {
            const r2 = Mt(t2.getNorth()), n2 = Mt(t2.getSouth()), i2 = Math.cos(r2), s2 = Math.cos(n2), o2 = Math.sin(r2), a2 = Math.sin(n2), l2 = t2.getWest(), u2 = t2.getEast();
            return [jl(s2, a2, l2, e2), jl(s2, a2, u2, e2), jl(i2, o2, u2, e2), jl(i2, o2, l2, e2)];
          }
          function Uc(t2, e2, r2, n2) {
            const i2 = 1 << r2.z, s2 = (t2 / Cn + r2.x) / i2;
            return $l(eu((e2 / Cn + r2.y) / i2), tu(s2), n2);
          }
          function Nc({ min: t2, max: e2 }) {
            return Ll / Math.max(e2[0] - t2[0], e2[1] - t2[1], e2[2] - t2[2]);
          }
          const jc = new Float64Array(16);
          function $c(t2) {
            const e2 = Nc(t2), r2 = y(jc, [e2, e2, e2]);
            return h2(r2, r2, V([], t2.min));
          }
          function Gc(t2) {
            const e2 = (n2 = t2.min, (r2 = jc)[0] = 1, r2[1] = 0, r2[2] = 0, r2[3] = 0, r2[4] = 0, r2[5] = 1, r2[6] = 0, r2[7] = 0, r2[8] = 0, r2[9] = 0, r2[10] = 1, r2[11] = 0, r2[12] = n2[0], r2[13] = n2[1], r2[14] = n2[2], r2[15] = 1, r2);
            var r2, n2;
            const i2 = 1 / Nc(t2);
            return p2(e2, e2, [i2, i2, i2]);
          }
          function qc(t2) {
            const e2 = Cn / (2 * Math.PI);
            return t2 / (2 * Math.PI) / e2;
          }
          function Hc(t2, e2) {
            return Cn / (512 * Math.pow(2, t2)) * Nc(Cc(e2));
          }
          function Xc(t2, e2, r2, n2, i2) {
            const s2 = qc(r2), o2 = [t2, e2, -r2 / (2 * Math.PI)], a2 = l(new Float64Array(16));
            return h2(a2, a2, o2), p2(a2, a2, [s2, s2, s2]), f(a2, a2, Mt(-i2)), d(a2, a2, Mt(-n2)), a2;
          }
          function Zc(t2) {
            return Tt(Fl, Dl, t2);
          }
          function Wc(t2, e2) {
            const r2 = $l(e2.lat, e2.lng), n2 = function(t3) {
              const e3 = $l(t3._center.lat, t3._center.lng);
              let r3 = D([], A(0, 1, 0), e3);
              const n3 = g([], -t3.angle, e3);
              r3 = R(r3, r3, n3), g(n3, -t3._pitch, r3);
              const i3 = C([], e3);
              return P(i3, i3, Pc(t3.cameraToCenterDistance / t3.pixelsPerMeter)), R(i3, i3, n3), M([], e3, i3);
            }(t2);
            return o2 = (i2 = I([], n2, r2))[0], a2 = i2[1], l2 = i2[2], u2 = (s2 = r2)[0], c2 = s2[1], h3 = s2[2], f2 = (p3 = Math.sqrt(o2 * o2 + a2 * a2 + l2 * l2) * Math.sqrt(u2 * u2 + c2 * c2 + h3 * h3)) && F(i2, s2) / p3, Math.acos(Math.min(Math.max(f2, -1), 1));
            var i2, s2, o2, a2, l2, u2, c2, h3, p3, f2;
          }
          function Yc(t2, e2) {
            return Wc(t2, e2) > Math.PI / 2 * 1.01;
          }
          const Kc = Mt(85), Jc = Math.cos(Kc), Qc = Math.sin(Kc), th = a(), eh = (t2) => {
            const e2 = [];
            return "map" === t2.paint.get("circle-pitch-alignment") && e2.push("PITCH_WITH_MAP"), "map" === t2.paint.get("circle-pitch-scale") && e2.push("SCALE_WITH_MAP"), e2;
          };
          function rh(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            if (s2 && t2.queryGeometry.isAboveHorizon) return false;
            s2 && (l2 *= t2.pixelToTileUnitsFactor);
            const u2 = t2.tileID.canonical, c2 = r2.projection.upVectorScale(u2, r2.center.lat, r2.worldSize).metersToTile;
            for (const h3 of e2) for (const e3 of h3) {
              const h4 = e3.add(a2), p3 = i2 && r2.elevation ? r2.elevation.exaggeration() * i2.getElevationAt(h4.x, h4.y, true) : 0, f2 = r2.projection.projectTilePoint(h4.x, h4.y, u2);
              if (p3 > 0) {
                const t3 = r2.projection.upVector(u2, h4.x, h4.y);
                f2.x += t3[0] * c2 * p3, f2.y += t3[1] * c2 * p3, f2.z += t3[2] * c2 * p3;
              }
              const d2 = s2 ? h4 : nh(f2.x, f2.y, f2.z, n2), m2 = s2 ? t2.tilespaceRays.map((t3) => oh(t3, p3)) : t2.queryGeometry.screenGeometry, y2 = Z([], [f2.x, f2.y, f2.z, 1], n2);
              if (!o2 && s2 ? l2 *= y2[3] / r2.cameraToCenterDistance : o2 && !s2 && (l2 *= r2.cameraToCenterDistance / y2[3]), s2) {
                const t3 = eu((e3.y / Cn + u2.y) / (1 << u2.z));
                l2 /= r2.projection.pixelsPerMeter(t3, 1) / Ql(1, t3);
              }
              if (Ju(m2, d2, l2)) return true;
            }
            return false;
          }
          function nh(t2, e2, r2, n2) {
            const i2 = Z([], [t2, e2, r2, 1], n2);
            return new bt(i2[0] / i2[3], i2[1] / i2[3]);
          }
          const ih = A(0, 0, 0), sh = A(0, 0, 1);
          function oh(t2, e2) {
            const r2 = b();
            return ih[2] = e2, t2.intersectsPlane(ih, sh, r2), new bt(r2[0], r2[1]);
          }
          class ah extends Yu {
          }
          let lh, uh, ch, hh;
          function ph(t2, { width: e2, height: r2 }, n2, i2) {
            if (i2) {
              if (i2 instanceof Uint8ClampedArray) i2 = new Uint8Array(i2.buffer);
              else if (i2.length !== e2 * r2 * n2) throw new RangeError("mismatched image size");
            } else i2 = new Uint8Array(e2 * r2 * n2);
            return t2.width = e2, t2.height = r2, t2.data = i2, t2;
          }
          function fh(t2, e2, r2) {
            const { width: n2, height: i2 } = e2;
            n2 === t2.width && i2 === t2.height || (dh(t2, e2, { x: 0, y: 0 }, { x: 0, y: 0 }, { width: Math.min(t2.width, n2), height: Math.min(t2.height, i2) }, r2, null), t2.width = n2, t2.height = i2, t2.data = e2.data);
          }
          function dh(t2, e2, r2, n2, i2, s2, o2, a2) {
            if (0 === i2.width || 0 === i2.height) return e2;
            if (i2.width > t2.width || i2.height > t2.height || r2.x > t2.width - i2.width || r2.y > t2.height - i2.height) throw new RangeError("out of range source coordinates for image copy");
            if (i2.width > e2.width || i2.height > e2.height || n2.x > e2.width - i2.width || n2.y > e2.height - i2.height) throw new RangeError("out of range destination coordinates for image copy");
            const l2 = t2.data, u2 = e2.data, c2 = 4 === s2 && a2;
            for (let a3 = 0; a3 < i2.height; a3++) {
              const h3 = ((r2.y + a3) * t2.width + r2.x) * s2, p3 = ((n2.y + a3) * e2.width + n2.x) * s2;
              if (c2) for (let t3 = 0; t3 < i2.width; t3++) {
                const e3 = h3 + t3 * s2 + 3, r3 = p3 + t3 * s2;
                u2[r3 + 0] = 255, u2[r3 + 1] = 255, u2[r3 + 2] = 255, u2[r3 + 3] = l2[e3];
              }
              else if (o2) for (let t3 = 0; t3 < i2.width; t3++) {
                const e3 = h3 + t3 * s2, r3 = p3 + t3 * s2, n3 = new sr(l2[e3 + 0] / 255, l2[e3 + 1] / 255, l2[e3 + 2] / 255, l2[e3 + 3]).toNonPremultipliedRenderColor(o2).toArray();
                u2[r3 + 0] = n3[0], u2[r3 + 1] = n3[1], u2[r3 + 2] = n3[2], u2[r3 + 3] = n3[3];
              }
              else for (let t3 = 0; t3 < i2.width * s2; t3++) u2[p3 + t3] = l2[h3 + t3];
            }
            return e2;
          }
          qs(ah, "HeatmapBucket", { omit: ["layers"] });
          class mh {
            constructor(t2, e2) {
              ph(this, t2, 1, e2);
            }
            resize(t2) {
              fh(this, new mh(t2), 1);
            }
            clone() {
              return new mh({ width: this.width, height: this.height }, new Uint8Array(this.data));
            }
            static copy(t2, e2, r2, n2, i2) {
              dh(t2, e2, r2, n2, i2, 1, null);
            }
          }
          class yh {
            constructor(t2, e2) {
              ph(this, t2, 4, e2);
            }
            resize(t2) {
              fh(this, new yh(t2), 4);
            }
            replace(t2, e2) {
              e2 ? this.data.set(t2) : this.data = t2 instanceof Uint8ClampedArray ? new Uint8Array(t2.buffer) : t2;
            }
            clone() {
              return new yh({ width: this.width, height: this.height }, new Uint8Array(this.data));
            }
            static copy(t2, e2, r2, n2, i2, s2, o2) {
              dh(t2, e2, r2, n2, i2, 4, s2, o2);
            }
          }
          class gh {
            constructor(t2, e2) {
              this.width = t2.width, this.height = t2.height, this.data = e2 instanceof Uint8Array ? new Float32Array(e2.buffer) : e2;
            }
          }
          function xh(t2) {
            const e2 = {}, r2 = t2.resolution || 256, n2 = t2.clips ? t2.clips.length : 1, i2 = t2.image || new yh({ width: r2, height: n2 }), s2 = (r3, n3, s3) => {
              e2[t2.evaluationKey] = s3;
              const o2 = t2.expression.evaluate(e2), a2 = o2 ? o2.toNonPremultipliedRenderColor(null) : null;
              a2 && (i2.data[r3 + n3 + 0] = Math.floor(255 * a2.r), i2.data[r3 + n3 + 1] = Math.floor(255 * a2.g), i2.data[r3 + n3 + 2] = Math.floor(255 * a2.b), i2.data[r3 + n3 + 3] = Math.floor(255 * a2.a));
            };
            if (t2.clips) for (let e3 = 0, i3 = 0; e3 < n2; ++e3, i3 += 4 * r2) for (let n3 = 0, o2 = 0; n3 < r2; n3++, o2 += 4) {
              const a2 = n3 / (r2 - 1), { start: l2, end: u2 } = t2.clips[e3];
              s2(i3, o2, l2 * (1 - a2) + u2 * a2);
            }
            else for (let t3 = 0, e3 = 0; t3 < r2; t3++, e3 += 4) s2(0, e3, t3 / (r2 - 1));
            return i2;
          }
          qs(mh, "AlphaImage"), qs(yh, "RGBAImage");
          const vh = ta([{ name: "a_pos", components: 2, type: "Int16" }], 4), bh = ta([{ name: "a_road_z_offset", components: 1, type: "Float32" }], 4), wh = ta([{ name: "a_pos", components: 2, type: "Int16" }, { name: "a_height", components: 1, type: "Float32" }], 4), _h = ta([{ name: "a_pos_normal_3", components: 3, type: "Int16" }], 4);
          function Ah(t2, e2, r2 = 2) {
            const n2 = e2 && e2.length, i2 = n2 ? e2[0] * r2 : t2.length;
            let s2 = Mh(t2, 0, i2, r2, true);
            const o2 = [];
            if (!s2 || s2.next === s2.prev) return o2;
            let a2, l2, u2;
            if (n2 && (s2 = function(t3, e3, r3, n3) {
              const i3 = [];
              for (let r4 = 0, s3 = e3.length; r4 < s3; r4++) {
                const o3 = Mh(t3, e3[r4] * n3, r4 < s3 - 1 ? e3[r4 + 1] * n3 : t3.length, n3, false);
                o3 === o3.next && (o3.steiner = true), i3.push(Fh(o3));
              }
              i3.sort(Th);
              for (let t4 = 0; t4 < i3.length; t4++) r3 = Bh(i3[t4], r3);
              return r3;
            }(t2, e2, s2, r2)), t2.length > 80 * r2) {
              a2 = 1 / 0, l2 = 1 / 0;
              let e3 = -1 / 0, n3 = -1 / 0;
              for (let s3 = r2; s3 < i2; s3 += r2) {
                const r3 = t2[s3], i3 = t2[s3 + 1];
                r3 < a2 && (a2 = r3), i3 < l2 && (l2 = i3), r3 > e3 && (e3 = r3), i3 > n3 && (n3 = i3);
              }
              u2 = Math.max(e3 - a2, n3 - l2), u2 = 0 !== u2 ? 32767 / u2 : 0;
            }
            return Sh(s2, o2, r2, a2, l2, u2, 0), o2;
          }
          function Mh(t2, e2, r2, n2, i2) {
            let s2;
            if (i2 === function(t3, e3, r3, n3) {
              let i3 = 0;
              for (let s3 = e3, o2 = r3 - n3; s3 < r3; s3 += n3) i3 += (t3[o2] - t3[s3]) * (t3[s3 + 1] + t3[o2 + 1]), o2 = s3;
              return i3;
            }(t2, e2, r2, n2) > 0) for (let i3 = e2; i3 < r2; i3 += n2) s2 = Hh(i3 / n2 | 0, t2[i3], t2[i3 + 1], s2);
            else for (let i3 = r2 - n2; i3 >= e2; i3 -= n2) s2 = Hh(i3 / n2 | 0, t2[i3], t2[i3 + 1], s2);
            return s2 && Uh(s2, s2.next) && (Xh(s2), s2 = s2.next), s2;
          }
          function Ih(t2, e2) {
            if (!t2) return t2;
            e2 || (e2 = t2);
            let r2, n2 = t2;
            do {
              if (r2 = false, n2.steiner || !Uh(n2, n2.next) && 0 !== Oh(n2.prev, n2, n2.next)) n2 = n2.next;
              else {
                if (Xh(n2), n2 = e2 = n2.prev, n2 === n2.next) break;
                r2 = true;
              }
            } while (r2 || n2 !== e2);
            return e2;
          }
          function Sh(t2, e2, r2, n2, i2, s2, o2) {
            if (!t2) return;
            !o2 && s2 && function(t3, e3, r3, n3) {
              let i3 = t3;
              do {
                0 === i3.z && (i3.z = Ch(i3.x, i3.y, e3, r3, n3)), i3.prevZ = i3.prev, i3.nextZ = i3.next, i3 = i3.next;
              } while (i3 !== t3);
              i3.prevZ.nextZ = null, i3.prevZ = null, function(t4) {
                let e4, r4 = 1;
                do {
                  let n4, i4 = t4;
                  t4 = null;
                  let s3 = null;
                  for (e4 = 0; i4; ) {
                    e4++;
                    let o3 = i4, a3 = 0;
                    for (let t5 = 0; t5 < r4 && (a3++, o3 = o3.nextZ, o3); t5++) ;
                    let l2 = r4;
                    for (; a3 > 0 || l2 > 0 && o3; ) 0 !== a3 && (0 === l2 || !o3 || i4.z <= o3.z) ? (n4 = i4, i4 = i4.nextZ, a3--) : (n4 = o3, o3 = o3.nextZ, l2--), s3 ? s3.nextZ = n4 : t4 = n4, n4.prevZ = s3, s3 = n4;
                    i4 = o3;
                  }
                  s3.nextZ = null, r4 *= 2;
                } while (e4 > 1);
              }(i3);
            }(t2, n2, i2, s2);
            let a2 = t2;
            for (; t2.prev !== t2.next; ) {
              const l2 = t2.prev, u2 = t2.next;
              if (s2 ? kh(t2, n2, i2, s2) : zh(t2)) e2.push(l2.i, t2.i, u2.i), Xh(t2), t2 = u2.next, a2 = u2.next;
              else if ((t2 = u2) === a2) {
                o2 ? 1 === o2 ? Sh(t2 = Ph(Ih(t2), e2), e2, r2, n2, i2, s2, 2) : 2 === o2 && Eh(t2, e2, r2, n2, i2, s2) : Sh(Ih(t2), e2, r2, n2, i2, s2, 1);
                break;
              }
            }
          }
          function zh(t2) {
            const e2 = t2.prev, r2 = t2, n2 = t2.next;
            if (Oh(e2, r2, n2) >= 0) return false;
            const i2 = e2.x, s2 = r2.x, o2 = n2.x, a2 = e2.y, l2 = r2.y, u2 = n2.y, c2 = Math.min(i2, s2, o2), h3 = Math.min(a2, l2, u2), p3 = Math.max(i2, s2, o2), f2 = Math.max(a2, l2, u2);
            let d2 = n2.next;
            for (; d2 !== e2; ) {
              if (d2.x >= c2 && d2.x <= p3 && d2.y >= h3 && d2.y <= f2 && Lh(i2, a2, s2, l2, o2, u2, d2.x, d2.y) && Oh(d2.prev, d2, d2.next) >= 0) return false;
              d2 = d2.next;
            }
            return true;
          }
          function kh(t2, e2, r2, n2) {
            const i2 = t2.prev, s2 = t2, o2 = t2.next;
            if (Oh(i2, s2, o2) >= 0) return false;
            const a2 = i2.x, l2 = s2.x, u2 = o2.x, c2 = i2.y, h3 = s2.y, p3 = o2.y, f2 = Math.min(a2, l2, u2), d2 = Math.min(c2, h3, p3), m2 = Math.max(a2, l2, u2), y2 = Math.max(c2, h3, p3), g2 = Ch(f2, d2, e2, r2, n2), x2 = Ch(m2, y2, e2, r2, n2);
            let v2 = t2.prevZ, b2 = t2.nextZ;
            for (; v2 && v2.z >= g2 && b2 && b2.z <= x2; ) {
              if (v2.x >= f2 && v2.x <= m2 && v2.y >= d2 && v2.y <= y2 && v2 !== i2 && v2 !== o2 && Lh(a2, c2, l2, h3, u2, p3, v2.x, v2.y) && Oh(v2.prev, v2, v2.next) >= 0) return false;
              if (v2 = v2.prevZ, b2.x >= f2 && b2.x <= m2 && b2.y >= d2 && b2.y <= y2 && b2 !== i2 && b2 !== o2 && Lh(a2, c2, l2, h3, u2, p3, b2.x, b2.y) && Oh(b2.prev, b2, b2.next) >= 0) return false;
              b2 = b2.nextZ;
            }
            for (; v2 && v2.z >= g2; ) {
              if (v2.x >= f2 && v2.x <= m2 && v2.y >= d2 && v2.y <= y2 && v2 !== i2 && v2 !== o2 && Lh(a2, c2, l2, h3, u2, p3, v2.x, v2.y) && Oh(v2.prev, v2, v2.next) >= 0) return false;
              v2 = v2.prevZ;
            }
            for (; b2 && b2.z <= x2; ) {
              if (b2.x >= f2 && b2.x <= m2 && b2.y >= d2 && b2.y <= y2 && b2 !== i2 && b2 !== o2 && Lh(a2, c2, l2, h3, u2, p3, b2.x, b2.y) && Oh(b2.prev, b2, b2.next) >= 0) return false;
              b2 = b2.nextZ;
            }
            return true;
          }
          function Ph(t2, e2) {
            let r2 = t2;
            do {
              const n2 = r2.prev, i2 = r2.next.next;
              !Uh(n2, i2) && Nh(n2, r2, r2.next, i2) && Gh(n2, i2) && Gh(i2, n2) && (e2.push(n2.i, r2.i, i2.i), Xh(r2), Xh(r2.next), r2 = t2 = i2), r2 = r2.next;
            } while (r2 !== t2);
            return Ih(r2);
          }
          function Eh(t2, e2, r2, n2, i2, s2) {
            let o2 = t2;
            do {
              let t3 = o2.next.next;
              for (; t3 !== o2.prev; ) {
                if (o2.i !== t3.i && Rh(o2, t3)) {
                  let a2 = qh(o2, t3);
                  return o2 = Ih(o2, o2.next), a2 = Ih(a2, a2.next), Sh(o2, e2, r2, n2, i2, s2, 0), void Sh(a2, e2, r2, n2, i2, s2, 0);
                }
                t3 = t3.next;
              }
              o2 = o2.next;
            } while (o2 !== t2);
          }
          function Th(t2, e2) {
            let r2 = t2.x - e2.x;
            return 0 === r2 && (r2 = t2.y - e2.y, 0 === r2) && (r2 = (t2.next.y - t2.y) / (t2.next.x - t2.x) - (e2.next.y - e2.y) / (e2.next.x - e2.x)), r2;
          }
          function Bh(t2, e2) {
            const r2 = function(t3, e3) {
              let r3 = e3;
              const n3 = t3.x, i2 = t3.y;
              let s2, o2 = -1 / 0;
              if (Uh(t3, r3)) return r3;
              do {
                if (Uh(t3, r3.next)) return r3.next;
                if (i2 <= r3.y && i2 >= r3.next.y && r3.next.y !== r3.y) {
                  const t4 = r3.x + (i2 - r3.y) * (r3.next.x - r3.x) / (r3.next.y - r3.y);
                  if (t4 <= n3 && t4 > o2 && (o2 = t4, s2 = r3.x < r3.next.x ? r3 : r3.next, t4 === n3)) return s2;
                }
                r3 = r3.next;
              } while (r3 !== e3);
              if (!s2) return null;
              const a2 = s2, l2 = s2.x, u2 = s2.y;
              let c2 = 1 / 0;
              r3 = s2;
              do {
                if (n3 >= r3.x && r3.x >= l2 && n3 !== r3.x && Dh(i2 < u2 ? n3 : o2, i2, l2, u2, i2 < u2 ? o2 : n3, i2, r3.x, r3.y)) {
                  const e4 = Math.abs(i2 - r3.y) / (n3 - r3.x);
                  Gh(r3, t3) && (e4 < c2 || e4 === c2 && (r3.x > s2.x || r3.x === s2.x && Vh(s2, r3))) && (s2 = r3, c2 = e4);
                }
                r3 = r3.next;
              } while (r3 !== a2);
              return s2;
            }(t2, e2);
            if (!r2) return e2;
            const n2 = qh(r2, t2);
            return Ih(n2, n2.next), Ih(r2, r2.next);
          }
          function Vh(t2, e2) {
            return Oh(t2.prev, t2, e2.prev) < 0 && Oh(e2.next, t2, t2.next) < 0;
          }
          function Ch(t2, e2, r2, n2, i2) {
            return (t2 = 1431655765 & ((t2 = 858993459 & ((t2 = 252645135 & ((t2 = 16711935 & ((t2 = (t2 - r2) * i2 | 0) | t2 << 8)) | t2 << 4)) | t2 << 2)) | t2 << 1)) | (e2 = 1431655765 & ((e2 = 858993459 & ((e2 = 252645135 & ((e2 = 16711935 & ((e2 = (e2 - n2) * i2 | 0) | e2 << 8)) | e2 << 4)) | e2 << 2)) | e2 << 1)) << 1;
          }
          function Fh(t2) {
            let e2 = t2, r2 = t2;
            do {
              (e2.x < r2.x || e2.x === r2.x && e2.y < r2.y) && (r2 = e2), e2 = e2.next;
            } while (e2 !== t2);
            return r2;
          }
          function Dh(t2, e2, r2, n2, i2, s2, o2, a2) {
            return (i2 - o2) * (e2 - a2) >= (t2 - o2) * (s2 - a2) && (t2 - o2) * (n2 - a2) >= (r2 - o2) * (e2 - a2) && (r2 - o2) * (s2 - a2) >= (i2 - o2) * (n2 - a2);
          }
          function Lh(t2, e2, r2, n2, i2, s2, o2, a2) {
            return !(t2 === o2 && e2 === a2) && Dh(t2, e2, r2, n2, i2, s2, o2, a2);
          }
          function Rh(t2, e2) {
            return t2.next.i !== e2.i && t2.prev.i !== e2.i && !function(t3, e3) {
              let r2 = t3;
              do {
                if (r2.i !== t3.i && r2.next.i !== t3.i && r2.i !== e3.i && r2.next.i !== e3.i && Nh(r2, r2.next, t3, e3)) return true;
                r2 = r2.next;
              } while (r2 !== t3);
              return false;
            }(t2, e2) && (Gh(t2, e2) && Gh(e2, t2) && function(t3, e3) {
              let r2 = t3, n2 = false;
              const i2 = (t3.x + e3.x) / 2, s2 = (t3.y + e3.y) / 2;
              do {
                r2.y > s2 != r2.next.y > s2 && r2.next.y !== r2.y && i2 < (r2.next.x - r2.x) * (s2 - r2.y) / (r2.next.y - r2.y) + r2.x && (n2 = !n2), r2 = r2.next;
              } while (r2 !== t3);
              return n2;
            }(t2, e2) && (Oh(t2.prev, t2, e2.prev) || Oh(t2, e2.prev, e2)) || Uh(t2, e2) && Oh(t2.prev, t2, t2.next) > 0 && Oh(e2.prev, e2, e2.next) > 0);
          }
          function Oh(t2, e2, r2) {
            return (e2.y - t2.y) * (r2.x - e2.x) - (e2.x - t2.x) * (r2.y - e2.y);
          }
          function Uh(t2, e2) {
            return t2.x === e2.x && t2.y === e2.y;
          }
          function Nh(t2, e2, r2, n2) {
            const i2 = $h(Oh(t2, e2, r2)), s2 = $h(Oh(t2, e2, n2)), o2 = $h(Oh(r2, n2, t2)), a2 = $h(Oh(r2, n2, e2));
            return i2 !== s2 && o2 !== a2 || !(0 !== i2 || !jh(t2, r2, e2)) || !(0 !== s2 || !jh(t2, n2, e2)) || !(0 !== o2 || !jh(r2, t2, n2)) || !(0 !== a2 || !jh(r2, e2, n2));
          }
          function jh(t2, e2, r2) {
            return e2.x <= Math.max(t2.x, r2.x) && e2.x >= Math.min(t2.x, r2.x) && e2.y <= Math.max(t2.y, r2.y) && e2.y >= Math.min(t2.y, r2.y);
          }
          function $h(t2) {
            return t2 > 0 ? 1 : t2 < 0 ? -1 : 0;
          }
          function Gh(t2, e2) {
            return Oh(t2.prev, t2, t2.next) < 0 ? Oh(t2, e2, t2.next) >= 0 && Oh(t2, t2.prev, e2) >= 0 : Oh(t2, e2, t2.prev) < 0 || Oh(t2, t2.next, e2) < 0;
          }
          function qh(t2, e2) {
            const r2 = Zh(t2.i, t2.x, t2.y), n2 = Zh(e2.i, e2.x, e2.y), i2 = t2.next, s2 = e2.prev;
            return t2.next = e2, e2.prev = t2, r2.next = i2, i2.prev = r2, n2.next = r2, r2.prev = n2, s2.next = n2, n2.prev = s2, n2;
          }
          function Hh(t2, e2, r2, n2) {
            const i2 = Zh(t2, e2, r2);
            return n2 ? (i2.next = n2.next, i2.prev = n2, n2.next.prev = i2, n2.next = i2) : (i2.prev = i2, i2.next = i2), i2;
          }
          function Xh(t2) {
            t2.next.prev = t2.prev, t2.prev.next = t2.next, t2.prevZ && (t2.prevZ.nextZ = t2.nextZ), t2.nextZ && (t2.nextZ.prevZ = t2.prevZ);
          }
          function Zh(t2, e2, r2) {
            return { i: t2, x: e2, y: r2, prev: null, next: null, z: 0, prevZ: null, nextZ: null, steiner: false };
          }
          function Wh(t2, e2) {
            const r2 = t2.length;
            if (r2 <= 1) return [t2];
            const n2 = [];
            let i2, s2;
            for (let e3 = 0; e3 < r2; e3++) {
              const r3 = Ht(t2[e3]);
              0 !== r3 && (t2[e3].area = Math.abs(r3), void 0 === s2 && (s2 = r3 < 0), s2 === r3 < 0 ? (i2 && n2.push(i2), i2 = [t2[e3]]) : i2.push(t2[e3]));
            }
            if (i2 && n2.push(i2), e2 > 1) for (let t3 = 0; t3 < n2.length; t3++) n2[t3].length <= e2 || (en2(n2[t3], e2, 1, n2[t3].length - 1, Yh), n2[t3] = n2[t3].slice(0, e2));
            return n2;
          }
          function Yh(t2, e2) {
            return e2.area - t2.area;
          }
          function Kh(t2, e2, r2 = 1) {
            if (!t2) return null;
            const n2 = "string" == typeof t2 ? Dr.from(t2).getPrimary() : t2.getPrimary(), i2 = "string" == typeof t2 ? null : t2.getSecondary();
            for (const t3 of [n2, i2]) {
              if (!t3) continue;
              const n3 = t3.id.toString();
              e2.has(n3) || e2.set(n3, []), t3.scaleSelf(r2), e2.get(n3).push(t3);
            }
            return { primary: n2.toString(), secondary: i2 ? i2.toString() : null };
          }
          function Jh(t2, e2, r2, n2) {
            const i2 = n2.patternDependencies;
            let s2 = false;
            for (const n3 of e2) {
              const e3 = n3.paint.get(`${t2}-pattern`);
              e3.isConstant() || (s2 = true), Kh(e3.constantOr(null), i2, r2) && (s2 = true);
            }
            return s2;
          }
          function Qh(t2, e2, r2, n2, i2, s2) {
            const o2 = s2.patternDependencies;
            for (const a2 of e2) {
              const e3 = a2.paint.get(`${t2}-pattern`).value;
              if ("constant" !== e3.kind) {
                let t3 = e3.evaluate({ zoom: n2 }, r2, {}, s2.availableImages);
                t3 = t3 && t3.name ? t3.name : t3;
                const l2 = Kh(t3, o2, i2);
                if (!l2) continue;
                const { primary: u2, secondary: c2 } = l2;
                u2 && (r2.patterns[a2.id] = [u2, c2].filter(Boolean));
              }
            }
            return r2;
          }
          class tp {
            constructor() {
              this.polygons = /* @__PURE__ */ new Map();
            }
            add(t2, ...e2) {
              this.polygons.has(t2) ? this.polygons.get(t2).push(...e2) : this.polygons.set(t2, e2);
            }
            merge(t2) {
              for (const [e2, r2] of t2.polygons) this.add(e2, ...r2);
            }
          }
          class ep {
            constructor() {
              this.portals = [];
            }
            static evaluate(t2) {
              if (0 === t2.length) return new ep();
              let e2 = [];
              for (const r3 of t2) e2.push(...r3.portals);
              if (0 === e2.length) return new ep();
              const r2 = (t3, e3) => t3 <= 0 && e3 <= 0 || t3 >= Cn && e3 >= Cn;
              for (const t3 of e2) {
                const e3 = t3.va, n3 = t3.vb;
                (r2(e3.x, n3.x) || r2(e3.y, n3.y)) && (t3.type = "border");
              }
              const n2 = e2.filter((t3) => "unevaluated" !== t3.type), i2 = e2.filter((t3) => "unevaluated" === t3.type);
              if (0 === i2.length) return new ep();
              i2.sort((t3, e3) => t3.hash === e3.hash ? t3.isTunnel === e3.isTunnel ? 0 : t3.isTunnel ? -1 : 1 : t3.hash < e3.hash ? 1 : -1), e2 = n2.concat(i2);
              let s2 = n2.length, o2 = s2, a2 = s2;
              do {
                if (o2++, o2 === e2.length || e2[s2].hash !== e2[o2].hash) {
                  if (o2 - s2 == 2) {
                    a2 < s2 && (e2[a2] = e2[s2], e2[s2] = null);
                    const t3 = e2[a2], r3 = e2[o2 - 1];
                    t3.type = t3.isTunnel !== r3.isTunnel ? "tunnel" : "polygon", t3.connection = { a: t3.connection.a, b: r3.connection.a }, a2++;
                  }
                  s2 = o2;
                }
              } while (s2 !== e2.length);
              return e2.splice(a2), e2.sort((t3, e3) => t3.hash < e3.hash ? 1 : -1), { portals: e2 };
            }
          }
          qs(ep, "ElevationPortalGraph"), qs(tp, "ElevationPolygons");
          class rp {
            constructor(t2, e2, r2) {
              this.outPositions = t2, this.outNormals = e2, this.outIndices = r2, this.vertexLookup = /* @__PURE__ */ new Map(), this.buffer = new ArrayBuffer(4), this.view = new DataView(this.buffer);
            }
            addVertex(t2, e2, r2) {
              let n2 = t2[2];
              null != r2 && (n2 *= r2);
              const i2 = this.getVec3Bits(t2) << 96n | this.getVec3Bits(e2), s2 = this.vertexLookup.get(i2);
              if (null != s2) return s2;
              const o2 = this.outPositions.length;
              this.vertexLookup.set(i2, o2);
              const a2 = Math.trunc(16384 * e2[0]), l2 = Math.trunc(16384 * e2[1]), u2 = Math.trunc(16384 * e2[2]);
              return this.outPositions.emplaceBack(t2[0], t2[1], n2), this.outNormals.emplaceBack(a2, l2, u2), o2;
            }
            addVertices(t2, e2, ...r2) {
              const n2 = [];
              for (const i2 of r2) {
                const r3 = this.addVertex(i2, t2, e2);
                n2.push(r3);
              }
              return n2;
            }
            addTriangles(t2, e2, r2) {
              if (e2 && r2) {
                const n2 = 1 === r2.length, i2 = A(0, 0, 0);
                for (let s2 = 0; s2 < t2.length; s2 += 3) {
                  const o2 = e2[t2[s2 + 0]], a2 = e2[t2[s2 + 1]], l2 = e2[t2[s2 + 2]], u2 = n2 ? r2[0] : r2[t2[s2 + 1]], c2 = n2 ? r2[0] : r2[t2[s2 + 2]], h3 = this.addVertex(A(o2.x, o2.y, n2 ? r2[0] : r2[t2[s2 + 0]]), i2), p3 = this.addVertex(A(a2.x, a2.y, u2), i2), f2 = this.addVertex(A(l2.x, l2.y, c2), i2);
                  this.outIndices.emplaceBack(h3, p3, f2);
                }
              } else for (let e3 = 0; e3 < t2.length; e3 += 3) this.outIndices.emplaceBack(t2[e3 + 0], t2[e3 + 1], t2[e3 + 2]);
            }
            addQuad(t2, e2) {
              const r2 = this.addVertices(e2, void 0, ...t2.map((t3) => A(t3.coord.x, t3.coord.y, t3.height))), [n2, i2, s2, o2] = r2;
              this.addTriangles([n2, i2, s2, s2, o2, n2]);
            }
            getVertexCount() {
              return this.outPositions.length;
            }
            clearVertexLookup() {
              this.vertexLookup.clear();
            }
            getBits(t2) {
              return this.view.setFloat32(0, t2), BigInt(this.view.getUint32(0));
            }
            getVec3Bits(t2) {
              return this.getBits(t2[0]) << 64n | this.getBits(t2[1]) << 32n | this.getBits(t2[2]);
            }
          }
          class np {
            constructor(t2, e2, r2, n2) {
              this.unevaluatedPortals = new ep(), this.portalPolygons = new tp(), this.bridgeFeatureSections = [], this.tunnelFeatureSections = [], this.vertexHashLookup = /* @__PURE__ */ new Map(), this.unevalVertices = [], this.unevalHeights = [], this.unevalTriangles = [], this.unevalTunnelTriangles = [], this.unevalEdges = [], this.vertexPositions = new oa(), this.vertexNormals = new aa(), this.indexArray = new Aa(), this.tileToMeters = au(t2), this.bridgeProgramConfigurations = new kl(e2, { zoom: r2, lut: n2 }, (t3) => "fill-tunnel-structure-color" !== t3), this.tunnelProgramConfigurations = new kl(e2, { zoom: r2, lut: n2 }, (t3) => "fill-bridge-guard-rail-color" !== t3);
            }
            addVertices(t2, e2) {
              const r2 = this.unevalVertices.length;
              for (let r3 = 0; r3 < t2.length; r3++) this.unevalVertices.push(t2[r3]), this.unevalHeights.push(e2[r3]);
              return r2;
            }
            addTriangles(t2, e2, r2) {
              const n2 = r2 ? this.unevalTunnelTriangles : this.unevalTriangles;
              for (const r3 of t2) n2.push(r3 + e2);
            }
            addRenderableRing(t2, e2, r2, n2, i2, s2) {
              const o2 = [new bt(i2.min.x, i2.min.y), new bt(i2.max.x, i2.min.y), new bt(i2.max.x, i2.max.y), new bt(i2.min.x, i2.max.y)];
              for (let a2 = 0; a2 < r2 - 1; a2++) {
                const r3 = e2 + a2, l2 = r3 + 1, u2 = this.unevalVertices[r3], c2 = this.unevalVertices[l2];
                if (!(u2.x >= i2.min.x && u2.x <= i2.max.x && u2.y >= i2.min.y && u2.y <= i2.max.y || c2.x >= i2.min.x && c2.x <= i2.max.x && c2.y >= i2.min.y && c2.y <= i2.max.y || cc(u2, c2, o2))) continue;
                if (this.isOnBorder(u2.x, c2.x) || this.isOnBorder(u2.y, c2.y)) continue;
                const h3 = np.computeEdgeHash(this.unevalVertices[r3], this.unevalVertices[l2]);
                let p3, f2 = this.vertexHashLookup.get(np.computePosHash(u2));
                null != f2 ? p3 = f2.next : (f2 = this.vertexHashLookup.get(np.computePosHash(c2)), p3 = null != f2 ? f2.prev : h3), this.unevalEdges.push({ polygonIdx: t2, a: r3, b: l2, hash: h3, portalHash: p3, isTunnel: n2, type: "unevaluated", featureInfo: s2 });
              }
            }
            addPortalCandidates(t2, e2, r2, n2, i2) {
              if (0 === e2.length) return;
              this.portalPolygons.add(t2, { geometry: e2, zLevel: i2 });
              const s2 = e2[0];
              this.vertexHashLookup.clear();
              let o2 = np.computeEdgeHash(s2[s2.length - 2], s2[s2.length - 1]);
              for (let e3 = 0; e3 < s2.length - 1; e3++) {
                const i3 = s2[e3 + 0], a2 = s2[e3 + 1], l2 = at(a2.x - i3.x, a2.y - i3.y), u2 = ht(l2);
                if (0 === u2) continue;
                let c2 = "unevaluated";
                const h3 = n2.pointElevation(i3), p3 = n2.pointElevation(a2);
                Math.abs(h3) < 0.01 && Math.abs(p3) < 0.01 ? c2 = "entrance" : (this.isOnBorder(i3.x, a2.x) || this.isOnBorder(i3.y, a2.y)) && (c2 = "border");
                const f2 = np.computeEdgeHash(i3, a2);
                this.unevaluatedPortals.portals.push({ connection: { a: t2, b: void 0 }, va: i3, vb: a2, vab: l2, length: u2, hash: f2, isTunnel: r2, type: c2 });
                const d2 = np.computePosHash(i3);
                this.vertexHashLookup.set(d2, { prev: o2, next: f2 }), o2 = f2;
              }
            }
            construct(t2) {
              if (0 === this.unevalVertices.length) return;
              const e2 = () => ({ vertexOffset: 0, primitiveOffset: this.indexArray.length }), r2 = (t3) => {
                t3.primitiveLength = this.indexArray.length - t3.primitiveOffset;
              }, n2 = new rp(this.vertexPositions, this.vertexNormals, this.indexArray);
              this.prepareEdges(t2.portals, this.unevalEdges);
              const i2 = e2(), s2 = e2(), o2 = e2(), a2 = (t3, e3) => {
                t3.sort((t4, r4) => t4.type === e3 && r4.type !== e3 ? -1 : t4.type !== e3 && r4.type === e3 ? 1 : 0);
                const r3 = t3.findIndex((t4) => t4.type !== e3);
                return r3 >= 0 ? r3 : t3.length;
              };
              let l2 = 0;
              this.unevalEdges.length > 0 && (l2 = a2(this.unevalEdges, "none"), this.constructBridgeStructures(n2, this.unevalVertices, this.unevalHeights, this.unevalEdges, { min: 0, max: l2 }, this.tileToMeters)), r2(o2);
              const u2 = e2(), c2 = e2();
              if (this.unevalEdges.length > 0) {
                const t3 = this.unevalEdges.splice(l2), e3 = a2(t3, "tunnel") + l2;
                this.unevalEdges.push(...t3), this.constructTunnelStructures(n2, this.unevalVertices, this.unevalHeights, this.unevalEdges, { min: 0, max: l2 }, { min: l2, max: e3 });
              }
              r2(u2), n2.addTriangles(this.unevalTriangles, this.unevalVertices, this.unevalHeights), r2(c2), n2.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, this.unevalHeights), r2(s2), n2.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, [-0.1]), r2(i2), this.maskSegments = tl.simpleSegment(0, c2.primitiveOffset, 0, c2.primitiveLength), this.depthSegments = tl.simpleSegment(0, s2.primitiveOffset, 0, s2.primitiveLength), this.renderableBridgeSegments = tl.simpleSegment(0, o2.primitiveOffset, 0, o2.primitiveLength), this.renderableTunnelSegments = tl.simpleSegment(0, u2.primitiveOffset, 0, u2.primitiveLength), this.shadowCasterSegments = tl.simpleSegment(0, i2.primitiveOffset, 0, i2.primitiveLength);
            }
            update(t2, e2, r2, n2, i2, s2, o2, a2) {
              this.bridgeProgramConfigurations.updatePaintArrays(t2, e2, i2, r2, n2, s2, o2, a2), this.tunnelProgramConfigurations.updatePaintArrays(t2, e2, i2, r2, n2, s2, o2, a2);
            }
            upload(t2) {
              this.vertexBuffer || 0 === this.vertexPositions.length || 0 === this.vertexNormals.length || 0 === this.indexArray.length || (this.vertexBuffer = t2.createVertexBuffer(this.vertexPositions, wh.members), this.vertexBufferNormal = t2.createVertexBuffer(this.vertexNormals, _h.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.bridgeProgramConfigurations.upload(t2), this.tunnelProgramConfigurations.upload(t2));
            }
            destroy() {
              this.vertexBuffer && (this.vertexBuffer.destroy(), this.vertexBufferNormal.destroy(), this.indexBuffer.destroy()), this.maskSegments && (this.maskSegments.destroy(), this.depthSegments.destroy(), this.renderableBridgeSegments.destroy(), this.renderableTunnelSegments.destroy(), this.shadowCasterSegments.destroy()), this.bridgeProgramConfigurations.destroy(), this.tunnelProgramConfigurations.destroy();
            }
            populatePaintArrays(t2, e2, r2, n2, i2) {
              const s2 = (s3, o2) => {
                for (let a2 = 0; a2 < o2.length - 1; a2++) {
                  const l2 = o2[a2].featureIndex, u2 = o2[a2 + 1].vertexStart, c2 = t2.feature(l2);
                  s3.populatePaintArrays(u2, c2, l2, {}, r2, e2, n2, void 0, i2);
                }
              };
              s2(this.bridgeProgramConfigurations, this.bridgeFeatureSections), s2(this.tunnelProgramConfigurations, this.tunnelFeatureSections);
            }
            computeVertexConnections(t2, e2, r2, n2, i2) {
              const s2 = /* @__PURE__ */ new Map();
              for (let o2 = n2; o2 < i2; o2++) {
                const n3 = r2[o2], i3 = n3.a, a2 = n3.b, l2 = np.computePosHash(t2[i3]), u2 = np.computePosHash(t2[a2]);
                s2.has(l2) || s2.set(l2, {}), s2.has(u2) || s2.set(u2, {});
                const c2 = s2.get(l2), h3 = s2.get(u2);
                e2[i3] <= 0 && e2[a2] <= 0 || (c2.to = a2, h3.from = i3);
              }
              return s2;
            }
            constructBridgeStructures(t2, e2, r2, n2, i2, s2) {
              t2.clearVertexLookup();
              const o2 = this.computeVertexConnections(e2, r2, n2, i2.min, i2.max), a2 = 1 / s2, l2 = 0.5 * a2, u2 = (t3) => A(e2[t3].x, e2[t3].y, r2[t3] * a2), c2 = (t3) => {
                const r3 = o2.get(np.computePosHash(e2[t3])), n3 = r3.from, i3 = r3.to;
                if (!n3 || !i3) return;
                const s3 = u2(n3), a3 = u2(t3), l3 = u2(i3), c3 = A(0, 0, 0);
                if (!N(s3, a3)) {
                  const t4 = j(b(), a3, s3);
                  M(c3, c3, C(t4, t4));
                }
                if (!N(l3, a3)) {
                  const t4 = j(b(), l3, a3);
                  M(c3, c3, C(t4, t4));
                }
                const h4 = G(c3);
                return h4 > 0 ? P(c3, c3, 1 / h4) : void 0;
              };
              let h3 = Number.POSITIVE_INFINITY;
              this.sortSubarray(n2, i2.min, i2.max, (t3, e3) => t3.featureInfo.featureIndex - e3.featureInfo.featureIndex);
              for (let o3 = i2.min; o3 < i2.max; o3++) {
                const i3 = n2[o3];
                if (!i3.featureInfo.guardRailEnabled) continue;
                const u3 = this.prepareEdgePoints(e2, r2, i3, (t3, e3) => t3 > e3);
                if (null == u3) continue;
                const p3 = u3[0], f2 = u3[1], d2 = A(p3.coord.x, p3.coord.y, a2 * p3.height), m2 = A(f2.coord.x, f2.coord.y, a2 * f2.height);
                if (N(d2, m2)) continue;
                const y2 = j(b(), m2, d2);
                C(y2, y2);
                const g2 = (t3) => C(t3, t3), x2 = c2(i3.a) || y2, v2 = c2(i3.b) || y2, w2 = g2(A(x2[1], -x2[0], 0)), _2 = g2(A(v2[1], -v2[0], 0)), I2 = g2(D(b(), w2, x2)), S2 = g2(D(b(), _2, v2)), z2 = b(), k2 = [M(b(), d2, P(z2, j(z2, w2, I2), l2)), M(b(), d2, P(z2, M(z2, w2, I2), l2)), M(b(), d2, P(z2, I2, l2)), d2], E2 = [M(b(), m2, P(z2, j(z2, _2, S2), l2)), M(b(), m2, P(z2, M(z2, _2, S2), l2)), M(b(), m2, P(z2, S2, l2)), m2];
                h3 = this.addFeatureSection(i3.featureInfo.featureIndex, h3, this.bridgeFeatureSections, t2);
                const [T2, B2] = t2.addVertices(w2, s2, k2[0], k2[1]), [F2, L2] = t2.addVertices(_2, s2, E2[0], E2[1]);
                t2.addTriangles([T2, B2, F2, B2, L2, F2]);
                const [R2, O2] = t2.addVertices(I2, s2, k2[1], k2[2]), [U2, $2] = t2.addVertices(S2, s2, E2[1], E2[2]);
                t2.addTriangles([R2, O2, U2, O2, $2, U2]);
                const [G2, q2] = t2.addVertices(V(w2, w2), s2, k2[2], k2[3]), [H2, X2] = t2.addVertices(V(_2, _2), s2, E2[2], E2[3]);
                t2.addTriangles([G2, q2, H2, q2, X2, H2]);
              }
              this.bridgeFeatureSections.push({ featureIndex: Number.POSITIVE_INFINITY, vertexStart: t2.getVertexCount() });
            }
            constructTunnelStructures(t2, e2, r2, n2, i2, s2) {
              t2.clearVertexLookup();
              let o2 = Number.POSITIVE_INFINITY;
              const a2 = (t3, e3) => t3.featureInfo.featureIndex - e3.featureInfo.featureIndex;
              this.sortSubarray(n2, i2.min, i2.max, a2), this.sortSubarray(n2, s2.min, s2.max, a2);
              const l2 = (t3) => C(t3, t3);
              for (let s3 = i2.min; s3 < i2.max; s3++) {
                const i3 = this.prepareEdgePoints(e2, r2, n2[s3], (t3, e3) => t3 < e3);
                if (null == i3) continue;
                const [a3, u2] = i3, c2 = l2(A(-(u2.coord.y - a3.coord.y), u2.coord.x - a3.coord.x, 0));
                o2 = this.addFeatureSection(n2[s3].featureInfo.featureIndex, o2, this.tunnelFeatureSections, t2), t2.addQuad([a3, u2, { coord: u2.coord, height: n2[s3].isTunnel ? -0.1 : 0 }, { coord: a3.coord, height: n2[s3].isTunnel ? -0.1 : 0 }], c2);
              }
              for (let i3 = s2.min; i3 < s2.max; i3++) {
                const s3 = n2[i3];
                s3.isTunnel && ([s3.a, s3.b] = [s3.b, s3.a]);
                const a3 = e2[s3.a], u2 = e2[s3.b], c2 = l2(A(-(u2.y - a3.y), u2.x - a3.x, 0));
                o2 = this.addFeatureSection(s3.featureInfo.featureIndex, o2, this.tunnelFeatureSections, t2), t2.addQuad([{ coord: u2, height: 0 }, { coord: a3, height: 0 }, { coord: a3, height: r2[s3.a] + 4 }, { coord: u2, height: r2[s3.b] + 4 }], c2), t2.addQuad([{ coord: a3, height: 0 }, { coord: u2, height: 0 }, { coord: u2, height: r2[s3.b] + 4 }, { coord: a3, height: r2[s3.a] + 4 }], c2);
              }
              this.tunnelFeatureSections.push({ featureIndex: Number.POSITIVE_INFINITY, vertexStart: t2.getVertexCount() });
            }
            prepareEdgePoints(t2, e2, r2, n2) {
              let i2 = e2[r2.a], s2 = e2[r2.b];
              const o2 = n2(i2, 0), a2 = n2(s2, 0);
              if (o2 && a2) return [{ coord: t2[r2.a], height: i2 }, { coord: t2[r2.b], height: s2 }];
              if (!o2 && !a2) return;
              const l2 = t2[r2.a].clone(), u2 = t2[r2.b].clone();
              if (o2) {
                if (!a2) {
                  const t3 = s2 / (s2 - i2);
                  u2.x = ur(u2.x, l2.x, t3), u2.y = ur(u2.y, l2.y, t3), s2 = ur(s2, i2, t3);
                }
              } else {
                const t3 = i2 / (i2 - s2);
                l2.x = ur(l2.x, u2.x, t3), l2.y = ur(l2.y, u2.y, t3), i2 = ur(i2, s2, t3);
              }
              return [{ coord: l2, height: i2 }, { coord: u2, height: s2 }];
            }
            prepareEdges(t2, e2) {
              if (0 === e2.length) return;
              e2.sort((t3, e3) => t3.hash === e3.hash ? e3.polygonIdx - t3.polygonIdx : e3.hash > t3.hash ? 1 : -1);
              let r2 = 0, n2 = 0, i2 = 0, s2 = e2[r2].polygonIdx;
              do {
                n2++, (n2 === e2.length || e2[r2].hash !== e2[n2].hash) && ((1 == n2 - r2 || e2[n2 - 1].polygonIdx !== s2) && (i2 < r2 && (e2[i2] = e2[r2], e2[r2] = null), e2[i2].type = "none", i2++), r2 = n2, r2 !== e2.length && (s2 = e2[r2].polygonIdx));
              } while (r2 !== e2.length);
              if (e2.splice(i2), 0 !== e2.length && 0 !== t2.length) {
                e2.sort((t3, e3) => t3.portalHash < e3.portalHash ? 1 : -1);
                let r3 = 0, n3 = 0;
                for (; r3 !== e2.length && n3 !== t2.length; ) {
                  const i3 = e2[r3], s3 = t2[n3];
                  i3.portalHash > s3.hash ? r3++ : s3.hash > i3.portalHash ? n3++ : (i3.type = s3.type, r3++);
                }
              }
            }
            isOnBorder(t2, e2) {
              return t2 <= 0 && e2 <= 0 || t2 >= Cn && e2 >= Cn;
            }
            addFeatureSection(t2, e2, r2, n2) {
              return t2 !== e2 && (e2 = t2, r2.push({ featureIndex: t2, vertexStart: n2.getVertexCount() }), n2.clearVertexLookup()), e2;
            }
            sortSubarray(t2, e2, r2, n2) {
              const i2 = t2.slice(e2, r2);
              i2.sort(n2), t2.splice(e2, i2.length, ...i2);
            }
            static computeEdgeHash(t2, e2) {
              return (t2.y === e2.y && t2.x > e2.x || t2.y > e2.y) && ([t2, e2] = [e2, t2]), BigInt(np.computePosHash(t2)) << 32n | BigInt(np.computePosHash(e2));
            }
            static computePosHash(t2) {
              return ((65535 & t2.x) << 16 | 65535 & t2.y) >>> 0;
            }
          }
          var ip, sp = { exports: {} }, op = (ip || (ip = 1, function(t2, e2) {
            !function(t3) {
              function e3(t4, e4) {
                return t4 > e4 ? 1 : t4 < e4 ? -1 : 0;
              }
              var r2 = function(t4, r3) {
                void 0 === t4 && (t4 = e3), void 0 === r3 && (r3 = false), this._compare = t4, this._root = null, this._size = 0, this._noDuplicates = !!r3;
              }, n2 = { size: { configurable: true } };
              function i2(t4, e4, r3, n3, s3) {
                var o3 = s3 - n3;
                if (o3 > 0) {
                  var a3 = n3 + Math.floor(o3 / 2), l3 = { key: e4[a3], data: r3[a3], parent: t4 };
                  return l3.left = i2(l3, e4, r3, n3, a3), l3.right = i2(l3, e4, r3, a3 + 1, s3), l3;
                }
                return null;
              }
              function s2(t4, e4, r3, n3, i3) {
                if (!(r3 >= n3)) {
                  for (var o3 = t4[r3 + n3 >> 1], a3 = r3 - 1, l3 = n3 + 1; ; ) {
                    do {
                      a3++;
                    } while (i3(t4[a3], o3) < 0);
                    do {
                      l3--;
                    } while (i3(t4[l3], o3) > 0);
                    if (a3 >= l3) break;
                    var u3 = t4[a3];
                    t4[a3] = t4[l3], t4[l3] = u3, u3 = e4[a3], e4[a3] = e4[l3], e4[l3] = u3;
                  }
                  s2(t4, e4, r3, l3, i3), s2(t4, e4, l3 + 1, n3, i3);
                }
              }
              r2.prototype.rotateLeft = function(t4) {
                var e4 = t4.right;
                e4 && (t4.right = e4.left, e4.left && (e4.left.parent = t4), e4.parent = t4.parent), t4.parent ? t4 === t4.parent.left ? t4.parent.left = e4 : t4.parent.right = e4 : this._root = e4, e4 && (e4.left = t4), t4.parent = e4;
              }, r2.prototype.rotateRight = function(t4) {
                var e4 = t4.left;
                e4 && (t4.left = e4.right, e4.right && (e4.right.parent = t4), e4.parent = t4.parent), t4.parent ? t4 === t4.parent.left ? t4.parent.left = e4 : t4.parent.right = e4 : this._root = e4, e4 && (e4.right = t4), t4.parent = e4;
              }, r2.prototype._splay = function(t4) {
                for (; t4.parent; ) {
                  var e4 = t4.parent;
                  e4.parent ? e4.left === t4 && e4.parent.left === e4 ? (this.rotateRight(e4.parent), this.rotateRight(e4)) : e4.right === t4 && e4.parent.right === e4 ? (this.rotateLeft(e4.parent), this.rotateLeft(e4)) : e4.left === t4 && e4.parent.right === e4 ? (this.rotateRight(e4), this.rotateLeft(e4)) : (this.rotateLeft(e4), this.rotateRight(e4)) : e4.left === t4 ? this.rotateRight(e4) : this.rotateLeft(e4);
                }
              }, r2.prototype.splay = function(t4) {
                for (var e4, r3, n3, i3, s3; t4.parent; ) (r3 = (e4 = t4.parent).parent) && r3.parent ? ((n3 = r3.parent).left === r3 ? n3.left = t4 : n3.right = t4, t4.parent = n3) : (t4.parent = null, this._root = t4), i3 = t4.left, s3 = t4.right, t4 === e4.left ? (r3 && (r3.left === e4 ? (e4.right ? (r3.left = e4.right, r3.left.parent = r3) : r3.left = null, e4.right = r3, r3.parent = e4) : (i3 ? (r3.right = i3, i3.parent = r3) : r3.right = null, t4.left = r3, r3.parent = t4)), s3 ? (e4.left = s3, s3.parent = e4) : e4.left = null, t4.right = e4, e4.parent = t4) : (r3 && (r3.right === e4 ? (e4.left ? (r3.right = e4.left, r3.right.parent = r3) : r3.right = null, e4.left = r3, r3.parent = e4) : (s3 ? (r3.left = s3, s3.parent = r3) : r3.left = null, t4.right = r3, r3.parent = t4)), i3 ? (e4.right = i3, i3.parent = e4) : e4.right = null, t4.left = e4, e4.parent = t4);
              }, r2.prototype.replace = function(t4, e4) {
                t4.parent ? t4 === t4.parent.left ? t4.parent.left = e4 : t4.parent.right = e4 : this._root = e4, e4 && (e4.parent = t4.parent);
              }, r2.prototype.minNode = function(t4) {
                if (void 0 === t4 && (t4 = this._root), t4) for (; t4.left; ) t4 = t4.left;
                return t4;
              }, r2.prototype.maxNode = function(t4) {
                if (void 0 === t4 && (t4 = this._root), t4) for (; t4.right; ) t4 = t4.right;
                return t4;
              }, r2.prototype.insert = function(t4, e4) {
                var r3 = this._root, n3 = null, i3 = this._compare;
                if (this._noDuplicates) for (; r3; ) {
                  if (n3 = r3, 0 === i3(r3.key, t4)) return;
                  r3 = i3(r3.key, t4) < 0 ? r3.right : r3.left;
                }
                else for (; r3; ) n3 = r3, r3 = i3(r3.key, t4) < 0 ? r3.right : r3.left;
                return r3 = { key: t4, data: e4, left: null, right: null, parent: n3 }, n3 ? i3(n3.key, r3.key) < 0 ? n3.right = r3 : n3.left = r3 : this._root = r3, this.splay(r3), this._size++, r3;
              }, r2.prototype.find = function(t4) {
                for (var e4 = this._root, r3 = this._compare; e4; ) {
                  var n3 = r3(e4.key, t4);
                  if (n3 < 0) e4 = e4.right;
                  else {
                    if (!(n3 > 0)) return e4;
                    e4 = e4.left;
                  }
                }
                return null;
              }, r2.prototype.contains = function(t4) {
                for (var e4 = this._root, r3 = this._compare; e4; ) {
                  var n3 = r3(t4, e4.key);
                  if (0 === n3) return true;
                  e4 = n3 < 0 ? e4.left : e4.right;
                }
                return false;
              }, r2.prototype.remove = function(t4) {
                var e4 = this.find(t4);
                if (!e4) return false;
                if (this.splay(e4), e4.left) if (e4.right) {
                  var r3 = this.minNode(e4.right);
                  r3.parent !== e4 && (this.replace(r3, r3.right), r3.right = e4.right, r3.right.parent = r3), this.replace(e4, r3), r3.left = e4.left, r3.left.parent = r3;
                } else this.replace(e4, e4.left);
                else this.replace(e4, e4.right);
                return this._size--, true;
              }, r2.prototype.removeNode = function(t4) {
                if (!t4) return false;
                if (this.splay(t4), t4.left) if (t4.right) {
                  var e4 = this.minNode(t4.right);
                  e4.parent !== t4 && (this.replace(e4, e4.right), e4.right = t4.right, e4.right.parent = e4), this.replace(t4, e4), e4.left = t4.left, e4.left.parent = e4;
                } else this.replace(t4, t4.left);
                else this.replace(t4, t4.right);
                return this._size--, true;
              }, r2.prototype.erase = function(t4) {
                var e4 = this.find(t4);
                if (e4) {
                  this.splay(e4);
                  var r3 = e4.left, n3 = e4.right, i3 = null;
                  r3 && (r3.parent = null, i3 = this.maxNode(r3), this.splay(i3), this._root = i3), n3 && (r3 ? i3.right = n3 : this._root = n3, n3.parent = i3), this._size--;
                }
              }, r2.prototype.pop = function() {
                var t4 = this._root, e4 = null;
                if (t4) {
                  for (; t4.left; ) t4 = t4.left;
                  e4 = { key: t4.key, data: t4.data }, this.remove(t4.key);
                }
                return e4;
              }, r2.prototype.next = function(t4) {
                var e4 = t4;
                if (e4) if (e4.right) for (e4 = e4.right; e4 && e4.left; ) e4 = e4.left;
                else for (e4 = t4.parent; e4 && e4.right === t4; ) t4 = e4, e4 = e4.parent;
                return e4;
              }, r2.prototype.prev = function(t4) {
                var e4 = t4;
                if (e4) if (e4.left) for (e4 = e4.left; e4 && e4.right; ) e4 = e4.right;
                else for (e4 = t4.parent; e4 && e4.left === t4; ) t4 = e4, e4 = e4.parent;
                return e4;
              }, r2.prototype.forEach = function(t4) {
                for (var e4 = this._root, r3 = [], n3 = false, i3 = 0; !n3; ) e4 ? (r3.push(e4), e4 = e4.left) : r3.length > 0 ? (t4(e4 = r3.pop(), i3++), e4 = e4.right) : n3 = true;
                return this;
              }, r2.prototype.range = function(t4, e4, r3, n3) {
                for (var i3 = [], s3 = this._compare, o3 = this._root; 0 !== i3.length || o3; ) if (o3) i3.push(o3), o3 = o3.left;
                else {
                  if (s3((o3 = i3.pop()).key, e4) > 0) break;
                  if (s3(o3.key, t4) >= 0 && r3.call(n3, o3)) return this;
                  o3 = o3.right;
                }
                return this;
              }, r2.prototype.keys = function() {
                for (var t4 = this._root, e4 = [], r3 = [], n3 = false; !n3; ) t4 ? (e4.push(t4), t4 = t4.left) : e4.length > 0 ? (t4 = e4.pop(), r3.push(t4.key), t4 = t4.right) : n3 = true;
                return r3;
              }, r2.prototype.values = function() {
                for (var t4 = this._root, e4 = [], r3 = [], n3 = false; !n3; ) t4 ? (e4.push(t4), t4 = t4.left) : e4.length > 0 ? (t4 = e4.pop(), r3.push(t4.data), t4 = t4.right) : n3 = true;
                return r3;
              }, r2.prototype.at = function(t4) {
                for (var e4 = this._root, r3 = [], n3 = false, i3 = 0; !n3; ) if (e4) r3.push(e4), e4 = e4.left;
                else if (r3.length > 0) {
                  if (e4 = r3.pop(), i3 === t4) return e4;
                  i3++, e4 = e4.right;
                } else n3 = true;
                return null;
              }, r2.prototype.load = function(t4, e4, r3) {
                if (void 0 === t4 && (t4 = []), void 0 === e4 && (e4 = []), void 0 === r3 && (r3 = false), 0 !== this._size) throw new Error("bulk-load: tree is not empty");
                var n3 = t4.length;
                return r3 && s2(t4, e4, 0, n3 - 1, this._compare), this._root = i2(null, t4, e4, 0, n3), this._size = n3, this;
              }, r2.prototype.min = function() {
                var t4 = this.minNode(this._root);
                return t4 ? t4.key : null;
              }, r2.prototype.max = function() {
                var t4 = this.maxNode(this._root);
                return t4 ? t4.key : null;
              }, r2.prototype.isEmpty = function() {
                return null === this._root;
              }, n2.size.get = function() {
                return this._size;
              }, r2.createTree = function(t4, e4, n3, i3, s3) {
                return new r2(n3, s3).load(t4, e4, i3);
              }, Object.defineProperties(r2.prototype, n2);
              var o2 = 0, a2 = 1, l2 = 2, u2 = 3, c2 = 0, h3 = 1, p3 = 2, f2 = 3;
              function d2(t4, e4, r3) {
                null === e4 ? (t4.inOut = false, t4.otherInOut = true) : (t4.isSubject === e4.isSubject ? (t4.inOut = !e4.inOut, t4.otherInOut = e4.otherInOut) : (t4.inOut = !e4.otherInOut, t4.otherInOut = e4.isVertical() ? !e4.inOut : e4.inOut), e4 && (t4.prevInResult = !m2(e4, r3) || e4.isVertical() ? e4.prevInResult : e4));
                var n3 = m2(t4, r3);
                t4.resultTransition = n3 ? function(t5, e5) {
                  var r4, n4 = !t5.inOut, i3 = !t5.otherInOut;
                  switch (e5) {
                    case c2:
                      r4 = n4 && i3;
                      break;
                    case h3:
                      r4 = n4 || i3;
                      break;
                    case f2:
                      r4 = n4 ^ i3;
                      break;
                    case p3:
                      r4 = t5.isSubject ? n4 && !i3 : i3 && !n4;
                  }
                  return r4 ? 1 : -1;
                }(t4, r3) : 0;
              }
              function m2(t4, e4) {
                switch (t4.type) {
                  case o2:
                    switch (e4) {
                      case c2:
                        return !t4.otherInOut;
                      case h3:
                        return t4.otherInOut;
                      case p3:
                        return t4.isSubject && t4.otherInOut || !t4.isSubject && !t4.otherInOut;
                      case f2:
                        return true;
                    }
                    break;
                  case l2:
                    return e4 === c2 || e4 === h3;
                  case u2:
                    return e4 === p3;
                  case a2:
                    return false;
                }
                return false;
              }
              var y2 = function(t4, e4, r3, n3, i3) {
                this.left = e4, this.point = t4, this.otherEvent = r3, this.isSubject = n3, this.type = i3 || o2, this.inOut = false, this.otherInOut = false, this.prevInResult = null, this.resultTransition = 0, this.otherPos = -1, this.outputContourId = -1, this.isExteriorRing = true;
              }, g2 = { inResult: { configurable: true } };
              function x2(t4, e4) {
                return t4[0] === e4[0] && t4[1] === e4[1];
              }
              y2.prototype.isBelow = function(t4) {
                var e4 = this.point, r3 = this.otherEvent.point;
                return this.left ? (e4[0] - t4[0]) * (r3[1] - t4[1]) - (r3[0] - t4[0]) * (e4[1] - t4[1]) > 0 : (r3[0] - t4[0]) * (e4[1] - t4[1]) - (e4[0] - t4[0]) * (r3[1] - t4[1]) > 0;
              }, y2.prototype.isAbove = function(t4) {
                return !this.isBelow(t4);
              }, y2.prototype.isVertical = function() {
                return this.point[0] === this.otherEvent.point[0];
              }, g2.inResult.get = function() {
                return 0 !== this.resultTransition;
              }, y2.prototype.clone = function() {
                var t4 = new y2(this.point, this.left, this.otherEvent, this.isSubject, this.type);
                return t4.contourId = this.contourId, t4.resultTransition = this.resultTransition, t4.prevInResult = this.prevInResult, t4.isExteriorRing = this.isExteriorRing, t4.inOut = this.inOut, t4.otherInOut = this.otherInOut, t4;
              }, Object.defineProperties(y2.prototype, g2);
              var v2 = 11102230246251565e-32, b2 = 134217729, w2 = (3 + 8 * v2) * v2;
              function _2(t4, e4, r3, n3, i3) {
                var s3, o3, a3, l3, u3 = e4[0], c3 = n3[0], h4 = 0, p4 = 0;
                c3 > u3 == c3 > -u3 ? (s3 = u3, u3 = e4[++h4]) : (s3 = c3, c3 = n3[++p4]);
                var f3 = 0;
                if (h4 < t4 && p4 < r3) for (c3 > u3 == c3 > -u3 ? (a3 = s3 - ((o3 = u3 + s3) - u3), u3 = e4[++h4]) : (a3 = s3 - ((o3 = c3 + s3) - c3), c3 = n3[++p4]), s3 = o3, 0 !== a3 && (i3[f3++] = a3); h4 < t4 && p4 < r3; ) c3 > u3 == c3 > -u3 ? (a3 = s3 - ((o3 = s3 + u3) - (l3 = o3 - s3)) + (u3 - l3), u3 = e4[++h4]) : (a3 = s3 - ((o3 = s3 + c3) - (l3 = o3 - s3)) + (c3 - l3), c3 = n3[++p4]), s3 = o3, 0 !== a3 && (i3[f3++] = a3);
                for (; h4 < t4; ) a3 = s3 - ((o3 = s3 + u3) - (l3 = o3 - s3)) + (u3 - l3), u3 = e4[++h4], s3 = o3, 0 !== a3 && (i3[f3++] = a3);
                for (; p4 < r3; ) a3 = s3 - ((o3 = s3 + c3) - (l3 = o3 - s3)) + (c3 - l3), c3 = n3[++p4], s3 = o3, 0 !== a3 && (i3[f3++] = a3);
                return 0 === s3 && 0 !== f3 || (i3[f3++] = s3), f3;
              }
              function A2(t4) {
                return new Float64Array(t4);
              }
              var M2 = 33306690738754716e-32, I2 = 22204460492503146e-32, S2 = 11093356479670487e-47, z2 = A2(4), k2 = A2(8), P2 = A2(12), E2 = A2(16), T2 = A2(4);
              function B2(t4, e4, r3) {
                var n3 = function(t5, e5, r4, n4, i3, s3) {
                  var o3 = (e5 - s3) * (r4 - i3), a3 = (t5 - i3) * (n4 - s3), l3 = o3 - a3;
                  if (0 === o3 || 0 === a3 || o3 > 0 != a3 > 0) return l3;
                  var u3 = Math.abs(o3 + a3);
                  return Math.abs(l3) >= M2 * u3 ? l3 : -function(t6, e6, r5, n5, i4, s4, o4) {
                    var a4, l4, u4, c3, h4, p4, f3, d3, m3, y3, g3, x3, v3, A3, M3, B3, V3, C3, F3 = t6 - i4, D3 = r5 - i4, L3 = e6 - s4, R3 = n5 - s4;
                    z2[0] = (M3 = (d3 = F3 - (f3 = (p4 = b2 * F3) - (p4 - F3))) * (y3 = R3 - (m3 = (p4 = b2 * R3) - (p4 - R3))) - ((A3 = F3 * R3) - f3 * m3 - d3 * m3 - f3 * y3)) - ((g3 = M3 - (V3 = (d3 = L3 - (f3 = (p4 = b2 * L3) - (p4 - L3))) * (y3 = D3 - (m3 = (p4 = b2 * D3) - (p4 - D3))) - ((B3 = L3 * D3) - f3 * m3 - d3 * m3 - f3 * y3))) + (h4 = M3 - g3)) + (h4 - V3), z2[1] = (v3 = A3 - ((x3 = A3 + g3) - (h4 = x3 - A3)) + (g3 - h4)) - ((g3 = v3 - B3) + (h4 = v3 - g3)) + (h4 - B3), z2[2] = x3 - ((C3 = x3 + g3) - (h4 = C3 - x3)) + (g3 - h4), z2[3] = C3;
                    var O3 = function(t7, e7) {
                      for (var r6 = e7[0], n6 = 1; n6 < 4; n6++) r6 += e7[n6];
                      return r6;
                    }(0, z2), U3 = I2 * o4;
                    if (O3 >= U3 || -O3 >= U3) return O3;
                    if (a4 = t6 - (F3 + (h4 = t6 - F3)) + (h4 - i4), u4 = r5 - (D3 + (h4 = r5 - D3)) + (h4 - i4), l4 = e6 - (L3 + (h4 = e6 - L3)) + (h4 - s4), c3 = n5 - (R3 + (h4 = n5 - R3)) + (h4 - s4), 0 === a4 && 0 === l4 && 0 === u4 && 0 === c3) return O3;
                    if (U3 = S2 * o4 + w2 * Math.abs(O3), (O3 += F3 * c3 + R3 * a4 - (L3 * u4 + D3 * l4)) >= U3 || -O3 >= U3) return O3;
                    T2[0] = (M3 = (d3 = a4 - (f3 = (p4 = b2 * a4) - (p4 - a4))) * (y3 = R3 - (m3 = (p4 = b2 * R3) - (p4 - R3))) - ((A3 = a4 * R3) - f3 * m3 - d3 * m3 - f3 * y3)) - ((g3 = M3 - (V3 = (d3 = l4 - (f3 = (p4 = b2 * l4) - (p4 - l4))) * (y3 = D3 - (m3 = (p4 = b2 * D3) - (p4 - D3))) - ((B3 = l4 * D3) - f3 * m3 - d3 * m3 - f3 * y3))) + (h4 = M3 - g3)) + (h4 - V3), T2[1] = (v3 = A3 - ((x3 = A3 + g3) - (h4 = x3 - A3)) + (g3 - h4)) - ((g3 = v3 - B3) + (h4 = v3 - g3)) + (h4 - B3), T2[2] = x3 - ((C3 = x3 + g3) - (h4 = C3 - x3)) + (g3 - h4), T2[3] = C3;
                    var N3 = _2(4, z2, 4, T2, k2);
                    T2[0] = (M3 = (d3 = F3 - (f3 = (p4 = b2 * F3) - (p4 - F3))) * (y3 = c3 - (m3 = (p4 = b2 * c3) - (p4 - c3))) - ((A3 = F3 * c3) - f3 * m3 - d3 * m3 - f3 * y3)) - ((g3 = M3 - (V3 = (d3 = L3 - (f3 = (p4 = b2 * L3) - (p4 - L3))) * (y3 = u4 - (m3 = (p4 = b2 * u4) - (p4 - u4))) - ((B3 = L3 * u4) - f3 * m3 - d3 * m3 - f3 * y3))) + (h4 = M3 - g3)) + (h4 - V3), T2[1] = (v3 = A3 - ((x3 = A3 + g3) - (h4 = x3 - A3)) + (g3 - h4)) - ((g3 = v3 - B3) + (h4 = v3 - g3)) + (h4 - B3), T2[2] = x3 - ((C3 = x3 + g3) - (h4 = C3 - x3)) + (g3 - h4), T2[3] = C3;
                    var j3 = _2(N3, k2, 4, T2, P2);
                    T2[0] = (M3 = (d3 = a4 - (f3 = (p4 = b2 * a4) - (p4 - a4))) * (y3 = c3 - (m3 = (p4 = b2 * c3) - (p4 - c3))) - ((A3 = a4 * c3) - f3 * m3 - d3 * m3 - f3 * y3)) - ((g3 = M3 - (V3 = (d3 = l4 - (f3 = (p4 = b2 * l4) - (p4 - l4))) * (y3 = u4 - (m3 = (p4 = b2 * u4) - (p4 - u4))) - ((B3 = l4 * u4) - f3 * m3 - d3 * m3 - f3 * y3))) + (h4 = M3 - g3)) + (h4 - V3), T2[1] = (v3 = A3 - ((x3 = A3 + g3) - (h4 = x3 - A3)) + (g3 - h4)) - ((g3 = v3 - B3) + (h4 = v3 - g3)) + (h4 - B3), T2[2] = x3 - ((C3 = x3 + g3) - (h4 = C3 - x3)) + (g3 - h4), T2[3] = C3;
                    var $3 = _2(j3, P2, 4, T2, E2);
                    return E2[$3 - 1];
                  }(t5, e5, r4, n4, i3, s3, u3);
                }(t4[0], t4[1], e4[0], e4[1], r3[0], r3[1]);
                return n3 > 0 ? -1 : n3 < 0 ? 1 : 0;
              }
              function V2(t4, e4) {
                var r3 = t4.point, n3 = e4.point;
                return r3[0] > n3[0] ? 1 : r3[0] < n3[0] ? -1 : r3[1] !== n3[1] ? r3[1] > n3[1] ? 1 : -1 : function(t5, e5, r4, n4) {
                  return t5.left !== e5.left ? t5.left ? 1 : -1 : 0 !== B2(r4, t5.otherEvent.point, e5.otherEvent.point) ? t5.isBelow(e5.otherEvent.point) ? -1 : 1 : !t5.isSubject && e5.isSubject ? 1 : -1;
                }(t4, e4, r3);
              }
              function C2(t4, e4, r3) {
                var n3 = new y2(e4, false, t4, t4.isSubject), i3 = new y2(e4, true, t4.otherEvent, t4.isSubject);
                return x2(t4.point, t4.otherEvent.point) && console.warn("what is that, a collapsed segment?", t4), n3.contourId = i3.contourId = t4.contourId, V2(i3, t4.otherEvent) > 0 && (t4.otherEvent.left = true, i3.left = false), t4.otherEvent.otherEvent = i3, t4.otherEvent = n3, r3.push(i3), r3.push(n3), r3;
              }
              function F2(t4, e4) {
                return t4[0] * e4[1] - t4[1] * e4[0];
              }
              function D2(t4, e4) {
                return t4[0] * e4[0] + t4[1] * e4[1];
              }
              function L2(t4, e4, r3) {
                var n3 = function(t5, e5, r4, n4, i4) {
                  var s4 = [e5[0] - t5[0], e5[1] - t5[1]], o4 = [n4[0] - r4[0], n4[1] - r4[1]];
                  function a3(t6, e6, r5) {
                    return [t6[0] + e6 * r5[0], t6[1] + e6 * r5[1]];
                  }
                  var l3 = [r4[0] - t5[0], r4[1] - t5[1]], u3 = F2(s4, o4), c4 = u3 * u3, h4 = D2(s4, s4);
                  if (c4 > 0) {
                    var p4 = F2(l3, o4) / u3;
                    if (p4 < 0 || p4 > 1) return null;
                    var f3 = F2(l3, s4) / u3;
                    return f3 < 0 || f3 > 1 ? null : 0 === p4 || 1 === p4 ? [a3(t5, p4, s4)] : 0 === f3 || 1 === f3 ? [a3(r4, f3, o4)] : [a3(t5, p4, s4)];
                  }
                  if ((c4 = (u3 = F2(l3, s4)) * u3) > 0) return null;
                  var d3 = D2(s4, l3) / h4, m3 = d3 + D2(s4, o4) / h4, y3 = Math.min(d3, m3), g3 = Math.max(d3, m3);
                  return y3 <= 1 && g3 >= 0 ? 1 === y3 ? [a3(t5, y3 > 0 ? y3 : 0, s4)] : 0 === g3 ? [a3(t5, g3 < 1 ? g3 : 1, s4)] : [a3(t5, y3 > 0 ? y3 : 0, s4), a3(t5, g3 < 1 ? g3 : 1, s4)] : null;
                }(t4.point, t4.otherEvent.point, e4.point, e4.otherEvent.point), i3 = n3 ? n3.length : 0;
                if (0 === i3) return 0;
                if (1 === i3 && (x2(t4.point, e4.point) || x2(t4.otherEvent.point, e4.otherEvent.point))) return 0;
                if (2 === i3 && t4.isSubject === e4.isSubject) return 0;
                if (1 === i3) return x2(t4.point, n3[0]) || x2(t4.otherEvent.point, n3[0]) || C2(t4, n3[0], r3), x2(e4.point, n3[0]) || x2(e4.otherEvent.point, n3[0]) || C2(e4, n3[0], r3), 1;
                var s3 = [], o3 = false, c3 = false;
                return x2(t4.point, e4.point) ? o3 = true : 1 === V2(t4, e4) ? s3.push(e4, t4) : s3.push(t4, e4), x2(t4.otherEvent.point, e4.otherEvent.point) ? c3 = true : 1 === V2(t4.otherEvent, e4.otherEvent) ? s3.push(e4.otherEvent, t4.otherEvent) : s3.push(t4.otherEvent, e4.otherEvent), o3 && c3 || o3 ? (e4.type = a2, t4.type = e4.inOut === t4.inOut ? l2 : u2, o3 && !c3 && C2(s3[1].otherEvent, s3[0].point, r3), 2) : c3 ? (C2(s3[0], s3[1].point, r3), 3) : s3[0] !== s3[3].otherEvent ? (C2(s3[0], s3[1].point, r3), C2(s3[1], s3[2].point, r3), 3) : (C2(s3[0], s3[1].point, r3), C2(s3[3].otherEvent, s3[2].point, r3), 3);
              }
              function R2(t4, e4) {
                if (t4 === e4) return 0;
                if (0 !== B2(t4.point, t4.otherEvent.point, e4.point) || 0 !== B2(t4.point, t4.otherEvent.point, e4.otherEvent.point)) return x2(t4.point, e4.point) ? t4.isBelow(e4.otherEvent.point) ? -1 : 1 : t4.point[0] === e4.point[0] ? t4.point[1] < e4.point[1] ? -1 : 1 : 1 === V2(t4, e4) ? e4.isAbove(t4.point) ? -1 : 1 : t4.isBelow(e4.point) ? -1 : 1;
                if (t4.isSubject !== e4.isSubject) return t4.isSubject ? -1 : 1;
                var r3 = t4.point, n3 = e4.point;
                return r3[0] === n3[0] && r3[1] === n3[1] ? (r3 = t4.otherEvent.point)[0] === (n3 = e4.otherEvent.point)[0] && r3[1] === n3[1] ? 0 : t4.contourId > e4.contourId ? 1 : -1 : 1 === V2(t4, e4) ? 1 : -1;
              }
              var O2 = function() {
                this.points = [], this.holeIds = [], this.holeOf = null, this.depth = null;
              };
              function U2(t4, e4, r3, n3) {
                var i3, s3 = t4 + 1, o3 = e4[t4].point, a3 = e4.length;
                for (s3 < a3 && (i3 = e4[s3].point); s3 < a3 && i3[0] === o3[0] && i3[1] === o3[1]; ) {
                  if (!r3[s3]) return s3;
                  ++s3 < a3 && (i3 = e4[s3].point);
                }
                for (s3 = t4 - 1; r3[s3] && s3 > n3; ) s3--;
                return s3;
              }
              O2.prototype.isExterior = function() {
                return null == this.holeOf;
              };
              var N2 = $2, j2 = $2;
              function $2(t4, e4) {
                if (!(this instanceof $2)) return new $2(t4, e4);
                if (this.data = t4 || [], this.length = this.data.length, this.compare = e4 || G2, this.length > 0) for (var r3 = (this.length >> 1) - 1; r3 >= 0; r3--) this._down(r3);
              }
              function G2(t4, e4) {
                return t4 < e4 ? -1 : t4 > e4 ? 1 : 0;
              }
              $2.prototype = { push: function(t4) {
                this.data.push(t4), this.length++, this._up(this.length - 1);
              }, pop: function() {
                if (0 !== this.length) {
                  var t4 = this.data[0];
                  return this.length--, this.length > 0 && (this.data[0] = this.data[this.length], this._down(0)), this.data.pop(), t4;
                }
              }, peek: function() {
                return this.data[0];
              }, _up: function(t4) {
                for (var e4 = this.data, r3 = this.compare, n3 = e4[t4]; t4 > 0; ) {
                  var i3 = t4 - 1 >> 1, s3 = e4[i3];
                  if (r3(n3, s3) >= 0) break;
                  e4[t4] = s3, t4 = i3;
                }
                e4[t4] = n3;
              }, _down: function(t4) {
                for (var e4 = this.data, r3 = this.compare, n3 = this.length >> 1, i3 = e4[t4]; t4 < n3; ) {
                  var s3 = 1 + (t4 << 1), o3 = s3 + 1, a3 = e4[s3];
                  if (o3 < this.length && r3(e4[o3], a3) < 0 && (s3 = o3, a3 = e4[o3]), r3(a3, i3) >= 0) break;
                  e4[t4] = a3, t4 = s3;
                }
                e4[t4] = i3;
              } }, N2.default = j2;
              var q2 = Math.max, H2 = Math.min, X2 = 0;
              function Z2(t4, e4, r3, n3, i3, s3) {
                var o3, a3, l3, u3, c3, h4;
                for (o3 = 0, a3 = t4.length - 1; o3 < a3; o3++) if (u3 = t4[o3 + 1], c3 = new y2(l3 = t4[o3], false, void 0, e4), h4 = new y2(u3, false, c3, e4), c3.otherEvent = h4, l3[0] !== u3[0] || l3[1] !== u3[1]) {
                  c3.contourId = h4.contourId = r3, s3 || (c3.isExteriorRing = false, h4.isExteriorRing = false), V2(c3, h4) > 0 ? h4.left = true : c3.left = true;
                  var p4 = l3[0], f3 = l3[1];
                  i3[0] = H2(i3[0], p4), i3[1] = H2(i3[1], f3), i3[2] = q2(i3[2], p4), i3[3] = q2(i3[3], f3), n3.push(c3), n3.push(h4);
                }
              }
              var W2 = [];
              function Y2(t4, e4, n3) {
                "number" == typeof t4[0][0][0] && (t4 = [t4]), "number" == typeof e4[0][0][0] && (e4 = [e4]);
                var i3 = function(t5, e5, r3) {
                  var n4 = null;
                  return t5.length * e5.length == 0 && (r3 === c2 ? n4 = W2 : r3 === p3 ? n4 = t5 : r3 !== h3 && r3 !== f2 || (n4 = 0 === t5.length ? e5 : t5)), n4;
                }(t4, e4, n3);
                if (i3) return i3 === W2 ? null : i3;
                var s3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], o3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0], a3 = function(t5, e5, r3, n4, i4) {
                  var s4, o4, a4, l4, u4, c3, h4 = new N2(null, V2);
                  for (a4 = 0, l4 = t5.length; a4 < l4; a4++) for (u4 = 0, c3 = (s4 = t5[a4]).length; u4 < c3; u4++) (o4 = 0 === u4) && X2++, Z2(s4[u4], true, X2, h4, r3, o4);
                  for (a4 = 0, l4 = e5.length; a4 < l4; a4++) for (u4 = 0, c3 = (s4 = e5[a4]).length; u4 < c3; u4++) o4 = 0 === u4, i4 === p3 && (o4 = false), o4 && X2++, Z2(s4[u4], false, X2, h4, n4, o4);
                  return h4;
                }(t4, e4, s3, o3, n3);
                if (i3 = function(t5, e5, r3, n4, i4) {
                  var s4 = null;
                  return (r3[0] > n4[2] || n4[0] > r3[2] || r3[1] > n4[3] || n4[1] > r3[3]) && (i4 === c2 ? s4 = W2 : i4 === p3 ? s4 = t5 : i4 !== h3 && i4 !== f2 || (s4 = t5.concat(e5))), s4;
                }(t4, e4, s3, o3, n3)) return i3 === W2 ? null : i3;
                for (var l3 = function(t5) {
                  var e5, r3, n4 = function(t6) {
                    var e6, r4, n5, i5, s5 = [];
                    for (r4 = 0, n5 = t6.length; r4 < n5; r4++) ((e6 = t6[r4]).left && e6.inResult || !e6.left && e6.otherEvent.inResult) && s5.push(e6);
                    for (var o5 = false; !o5; ) for (o5 = true, r4 = 0, n5 = s5.length; r4 < n5; r4++) r4 + 1 < n5 && 1 === V2(s5[r4], s5[r4 + 1]) && (i5 = s5[r4], s5[r4] = s5[r4 + 1], s5[r4 + 1] = i5, o5 = false);
                    for (r4 = 0, n5 = s5.length; r4 < n5; r4++) (e6 = s5[r4]).otherPos = r4;
                    for (r4 = 0, n5 = s5.length; r4 < n5; r4++) (e6 = s5[r4]).left || (i5 = e6.otherPos, e6.otherPos = e6.otherEvent.otherPos, e6.otherEvent.otherPos = i5);
                    return s5;
                  }(t5), i4 = {}, s4 = [], o4 = function() {
                    if (!i4[e5]) {
                      var t6 = s4.length, r4 = function(t7, e6, r5) {
                        var n5 = new O2();
                        if (null != t7.prevInResult) {
                          var i5 = t7.prevInResult, s5 = i5.outputContourId;
                          if (i5.resultTransition > 0) {
                            var o6 = e6[s5];
                            if (null != o6.holeOf) {
                              var a5 = o6.holeOf;
                              e6[a5].holeIds.push(r5), n5.holeOf = a5, n5.depth = e6[s5].depth;
                            } else e6[s5].holeIds.push(r5), n5.holeOf = s5, n5.depth = e6[s5].depth + 1;
                          } else n5.holeOf = null, n5.depth = e6[s5].depth;
                        } else n5.holeOf = null, n5.depth = 0;
                        return n5;
                      }(n4[e5], s4, t6), o5 = function(e6) {
                        i4[e6] = true, e6 < n4.length && n4[e6] && (n4[e6].outputContourId = t6);
                      }, a4 = e5, l4 = e5;
                      for (r4.points.push(n4[e5].point); o5(a4), o5(a4 = n4[a4].otherPos), r4.points.push(n4[a4].point), !((a4 = U2(a4, n4, i4, l4)) == l4 || a4 >= n4.length) && n4[a4]; ) ;
                      s4.push(r4);
                    }
                  };
                  for (e5 = 0, r3 = n4.length; e5 < r3; e5++) o4();
                  return s4;
                }(function(t5, e5, n4, i4, s4, o4) {
                  for (var a4, l4, u4, h4 = new r2(R2), f3 = [], m4 = Math.min(i4[2], s4[2]); 0 !== t5.length; ) {
                    var y4 = t5.pop();
                    if (f3.push(y4), o4 === c2 && y4.point[0] > m4 || o4 === p3 && y4.point[0] > i4[2]) break;
                    if (y4.left) {
                      l4 = a4 = h4.insert(y4), a4 = a4 !== (u4 = h4.minNode()) ? h4.prev(a4) : null, l4 = h4.next(l4);
                      var g4 = a4 ? a4.key : null;
                      if (d2(y4, g4, o4), l4 && 2 === L2(y4, l4.key, t5) && (d2(y4, g4, o4), d2(l4.key, y4, o4)), a4 && 2 === L2(a4.key, y4, t5)) {
                        var x4 = a4;
                        d2(g4, (x4 = x4 !== u4 ? h4.prev(x4) : null) ? x4.key : null, o4), d2(y4, g4, o4);
                      }
                    } else l4 = a4 = h4.find(y4 = y4.otherEvent), a4 && l4 && (a4 = a4 !== u4 ? h4.prev(a4) : null, l4 = h4.next(l4), h4.remove(y4), l4 && a4 && L2(a4.key, l4.key, t5));
                  }
                  return f3;
                }(a3, 0, 0, s3, o3, n3)), u3 = [], m3 = 0; m3 < l3.length; m3++) {
                  var y3 = l3[m3];
                  if (y3.isExterior()) {
                    for (var g3 = [y3.points], x3 = 0; x3 < y3.holeIds.length; x3++) g3.push(l3[y3.holeIds[x3]].points);
                    u3.push(g3);
                  }
                }
                return u3;
              }
              var K2 = { UNION: h3, DIFFERENCE: p3, INTERSECTION: c2, XOR: f2 };
              t3.diff = function(t4, e4) {
                return Y2(t4, e4, p3);
              }, t3.intersection = function(t4, e4) {
                return Y2(t4, e4, c2);
              }, t3.operations = K2, t3.union = function(t4, e4) {
                return Y2(t4, e4, h3);
              }, t3.xor = function(t4, e4) {
                return Y2(t4, e4, f2);
              }, Object.defineProperty(t3, "__esModule", { value: true });
            }(e2);
          }(0, sp.exports)), sp.exports);
          function ap(t2, e2, r2, n2) {
            const i2 = [], s2 = 0 === n2 ? (t3, e3, r3, n3, i3, s3) => {
              t3.push(new bt(s3, r3 + (s3 - e3) / (n3 - e3) * (i3 - r3)));
            } : (t3, e3, r3, n3, i3, s3) => {
              t3.push(new bt(e3 + (s3 - r3) / (i3 - r3) * (n3 - e3), s3));
            };
            for (const o2 of t2) {
              const t3 = [];
              for (const i3 of o2) {
                if (i3.length <= 2) continue;
                const o3 = [];
                for (let t4 = 0; t4 < i3.length - 1; t4++) {
                  const a3 = i3[t4].x, l3 = i3[t4].y, u2 = i3[t4 + 1].x, c2 = i3[t4 + 1].y, h3 = 0 === n2 ? a3 : l3, p3 = 0 === n2 ? u2 : c2;
                  h3 < e2 ? p3 > e2 && s2(o3, a3, l3, u2, c2, e2) : h3 > r2 ? p3 < r2 && s2(o3, a3, l3, u2, c2, r2) : o3.push(i3[t4]), p3 < e2 && h3 >= e2 && s2(o3, a3, l3, u2, c2, e2), p3 > r2 && h3 <= r2 && s2(o3, a3, l3, u2, c2, r2);
                }
                let a2 = i3[i3.length - 1];
                const l2 = 0 === n2 ? a2.x : a2.y;
                l2 >= e2 && l2 <= r2 && o3.push(a2), o3.length && (a2 = o3[o3.length - 1], o3[0].x === a2.x && o3[0].y === a2.y || o3.push(o3[0]), t3.push(o3));
              }
              t3.length && i2.push(t3);
            }
            return i2;
          }
          function lp(t2, e2) {
            const r2 = cp(t2), n2 = cp([e2]), i2 = op.intersection(r2, n2);
            return null == i2 ? [] : hp(i2);
          }
          function up(t2, e2) {
            const r2 = 65536;
            let n2 = cp(t2, r2);
            for (; e2.valid(); e2.next()) {
              const [t3, i2] = e2.get(), s2 = t3.x * r2, o2 = t3.y * r2, a2 = i2.x * r2, l2 = i2.y * r2, u2 = a2 - s2, c2 = l2 - o2, h3 = Math.hypot(u2, c2), p3 = Math.trunc(c2 / h3 * 3), f2 = -Math.trunc(u2 / h3 * 3);
              n2 = op.diff(n2, [[[s2, o2], [a2, l2], [a2 + p3, l2 + f2], [s2 + p3, o2 + f2], [s2, o2]]]);
            }
            return hp(n2, 1 / r2);
          }
          function cp(t2, e2 = 1) {
            return [t2.map((t3) => t3.map((t4) => [t4.x * e2, t4.y * e2]))];
          }
          function hp(t2, e2 = 1) {
            return t2.map((t3) => t3.map((t4, r2) => {
              const n2 = t4.map((t5) => new bt(t5[0] * e2, t5[1] * e2).round());
              return r2 > 0 && n2.reverse(), n2;
            }));
          }
          class pp {
            constructor(t2, e2) {
              this.layoutVertexArray = new ra(), this.indexArray = new Aa(), this.lineIndexArray = new xa(), this.triangleSegments = new tl(), this.lineSegments = new tl(), this.programConfigurations = new kl(t2.layers, { zoom: t2.zoom, lut: t2.lut }), this.uploaded = false, e2 && (this.elevatedLayoutVertexArray = new sa());
            }
            update(t2, e2, r2, n2, i2, s2, o2, a2) {
              this.programConfigurations.updatePaintArrays(t2, e2, i2, r2, n2, s2, o2, a2);
            }
            isEmpty() {
              return 0 === this.layoutVertexArray.length;
            }
            needsUpload() {
              return this.programConfigurations.needsUpload;
            }
            upload(t2) {
              this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, vh.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.lineIndexBuffer = t2.createIndexBuffer(this.lineIndexArray), this.elevatedLayoutVertexArray && this.elevatedLayoutVertexArray.length > 0 && (this.elevatedLayoutVertexBuffer = t2.createVertexBuffer(this.elevatedLayoutVertexArray, bh.members))), this.programConfigurations.upload(t2), this.uploaded = true;
            }
            destroy() {
              this.layoutVertexBuffer && (this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.lineIndexBuffer.destroy(), this.programConfigurations.destroy(), this.triangleSegments.destroy(), this.lineSegments.destroy());
            }
            populatePaintArrays(t2, e2, r2, n2, i2, s2, o2) {
              this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, e2, r2, n2, i2, s2, void 0, o2);
            }
          }
          class fp {
            constructor(t2) {
              this.zoom = t2.zoom, this.pixelRatio = t2.pixelRatio, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.hasPattern = false, this.patternFeatures = [], this.lut = t2.lut, this.bufferData = new pp(t2, false), this.elevationBufferData = new pp(t2, true), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.projection = t2.projection, this.elevationMode = this.layers[0].layout.get("fill-elevation-reference"), this.sourceLayerIndex = t2.sourceLayerIndex, this.worldview = t2.worldview;
            }
            updateFootprints(t2, e2) {
            }
            populate(t2, e2, r2, n2) {
              this.hasPattern = Jh("fill", this.layers, this.pixelRatio, e2);
              const i2 = this.layers[0].layout.get("fill-sort-key"), s2 = [];
              for (const { feature: o2, id: a2, index: l2, sourceLayerIndex: u2 } of t2) {
                const t3 = this.layers[0]._featureFilter.needGeometry, c2 = gu(o2, t3);
                if (!this.layers[0]._featureFilter.filter(new go(this.zoom, { worldview: this.worldview }), c2, r2)) continue;
                const h3 = i2 ? i2.evaluate(c2, {}, r2, e2.availableImages) : void 0, p3 = { id: a2, properties: o2.properties, type: o2.type, sourceLayerIndex: u2, index: l2, geometry: t3 ? c2.geometry : yu(o2, r2, n2), patterns: {}, sortKey: h3 };
                s2.push(p3);
              }
              i2 && s2.sort((t3, e3) => t3.sortKey - e3.sortKey);
              for (const n3 of s2) {
                const { geometry: i3, index: s3, sourceLayerIndex: o2 } = n3;
                if (this.hasPattern) {
                  const t3 = Qh("fill", this.layers, n3, this.zoom, this.pixelRatio, e2);
                  this.patternFeatures.push(t3);
                } else this.addFeature(n3, i3, s3, r2, {}, e2.availableImages, e2.brightness, e2.elevationFeatures);
                e2.featureIndex.insert(t2[s3].feature, i3, s3, o2, this.index);
              }
            }
            update(t2, e2, r2, n2, i2, s2, o2) {
              this.bufferData.update(t2, e2, r2, n2, i2, s2, o2, this.worldview), this.elevationBufferData.update(t2, e2, r2, n2, i2, s2, o2, this.worldview), this.elevatedStructures && this.elevatedStructures.update(t2, e2, r2, n2, i2, s2, o2, this.worldview);
            }
            addFeatures(t2, e2, r2, n2, i2, s2) {
              for (const i3 of this.patternFeatures) this.addFeature(i3, i3.geometry, i3.index, e2, r2, n2, s2, t2.elevationFeatures);
            }
            isEmpty() {
              return this.bufferData.isEmpty() && this.elevationBufferData.isEmpty();
            }
            uploadPending() {
              return !this.uploaded || this.bufferData.needsUpload() || this.elevationBufferData.needsUpload();
            }
            upload(t2) {
              this.bufferData.upload(t2), this.elevationBufferData.upload(t2), this.elevatedStructures && this.elevatedStructures.upload(t2);
            }
            destroy() {
              this.bufferData.destroy(), this.elevationBufferData.destroy(), this.elevatedStructures && this.elevatedStructures.destroy();
            }
            addFeature(t2, e2, r2, n2, i2, s2 = [], o2, a2) {
              const l2 = Wh(e2, 500);
              "none" !== this.elevationMode ? this.addElevatedRoadFeature(t2, l2, n2, r2, a2) : this.addGeometry(l2, this.bufferData), this.bufferData.populatePaintArrays(t2, r2, i2, s2, n2, o2, this.worldview), this.elevationBufferData.populatePaintArrays(t2, r2, i2, s2, n2, o2, this.worldview);
            }
            getUnevaluatedPortalGraph() {
              return this.elevatedStructures ? this.elevatedStructures.unevaluatedPortals : void 0;
            }
            getElevationPolygons() {
              return this.elevatedStructures ? this.elevatedStructures.portalPolygons : void 0;
            }
            setEvaluatedPortalGraph(t2, e2, r2, n2, i2) {
              this.elevatedStructures && (this.elevatedStructures.construct(t2), this.elevatedStructures.populatePaintArrays(e2, r2, n2, i2, this.worldview));
            }
            addElevatedRoadFeature(t2, e2, r2, n2, i2) {
              const s2 = new Array(), o2 = Zu.getElevationFeature(t2, i2);
              if (!o2) return void this.addGeometry(e2, this.bufferData);
              {
                const t3 = this.clipPolygonsToTile(e2, 1);
                t3.length > 0 && s2.push({ polygons: t3, elevationFeature: o2, elevationTileID: r2 });
              }
              const a2 = { guardRailEnabled: this.layers[0].layout.get("fill-construct-bridge-guard-rail").evaluate(t2, {}, r2), featureIndex: n2 };
              for (const e3 of s2) if (e3.elevationFeature) {
                if ("hd-road-base" === this.elevationMode) {
                  this.elevatedStructures || (this.elevatedStructures = new np(e3.elevationTileID, this.layers, this.zoom, this.lut));
                  const r3 = e3.elevationFeature.isTunnel();
                  let n3 = 0;
                  t2.properties.hasOwnProperty(Tu) && (n3 = +t2.properties[Tu]);
                  for (const t3 of e3.polygons) this.elevatedStructures.addPortalCandidates(e3.elevationFeature.id, t3, r3, e3.elevationFeature, n3);
                }
                null == e3.elevationFeature.constantHeight && (e3.polygons = this.prepareElevatedPolygons(e3.polygons, e3.elevationFeature, e3.elevationTileID));
                const i3 = new Wu(r2, e3.elevationTileID);
                this.addElevatedGeometry(e3.polygons, i3, e3.elevationFeature, "hd-road-base" === this.elevationMode ? 0 : 0.05, n2, a2);
              }
            }
            addElevatedGeometry(t2, e2, r2, n2, i2, s2) {
              const o2 = { elevation: r2, elevationSampler: e2, bias: n2, index: i2, featureInfo: s2 }, [a2, l2] = this.addGeometry(t2, this.elevationBufferData, o2);
              null == this.elevationBufferData.heightRange ? this.elevationBufferData.heightRange = { min: a2, max: l2 } : (this.elevationBufferData.heightRange.min = Math.min(this.elevationBufferData.heightRange.min, a2), this.elevationBufferData.heightRange.max = Math.max(this.elevationBufferData.heightRange.max, l2));
            }
            addGeometry(t2, e2, r2) {
              let n2 = Number.POSITIVE_INFINITY, i2 = Number.NEGATIVE_INFINITY, s2 = null;
              r2 && (s2 = r2.elevationSampler.constantElevation(r2.elevation, r2.bias), null != s2 && (n2 = s2, i2 = s2));
              const o2 = (t3, o3, a2) => {
                if (null != r2) if (o3.push(t3), null != s2) e2.elevatedLayoutVertexArray.emplaceBack(s2), a2.push(s2);
                else {
                  const s3 = r2.elevationSampler.pointElevation(t3, r2.elevation, r2.bias);
                  e2.elevatedLayoutVertexArray.emplaceBack(s3), a2.push(s3), n2 = Math.min(n2, s3), i2 = Math.max(i2, s3);
                }
              };
              for (const n3 of t2) {
                let t3 = 0;
                for (const e3 of n3) t3 += e3.length;
                const i3 = e2.triangleSegments.prepareSegment(t3, e2.layoutVertexArray, e2.indexArray), s3 = i3.vertexLength, a2 = [], l2 = [], u2 = [], c2 = [], h3 = [], p3 = e2.layoutVertexArray.length;
                for (const t4 of n3) {
                  if (0 === t4.length) continue;
                  t4 !== n3[0] && l2.push(a2.length / 2);
                  const i4 = e2.lineSegments.prepareSegment(t4.length, e2.layoutVertexArray, e2.lineIndexArray), s4 = i4.vertexLength;
                  r2 && h3.push(e2.layoutVertexArray.length - p3), o2(t4[0], u2, c2), e2.layoutVertexArray.emplaceBack(t4[0].x, t4[0].y), e2.lineIndexArray.emplaceBack(s4 + t4.length - 1, s4), a2.push(t4[0].x), a2.push(t4[0].y);
                  for (let r3 = 1; r3 < t4.length; r3++) o2(t4[r3], u2, c2), e2.layoutVertexArray.emplaceBack(t4[r3].x, t4[r3].y), e2.lineIndexArray.emplaceBack(s4 + r3 - 1, s4 + r3), a2.push(t4[r3].x), a2.push(t4[r3].y);
                  i4.vertexLength += t4.length, i4.primitiveLength += t4.length;
                }
                const f2 = Ah(a2, l2);
                for (let t4 = 0; t4 < f2.length; t4 += 3) e2.indexArray.emplaceBack(s3 + f2[t4], s3 + f2[t4 + 1], s3 + f2[t4 + 2]);
                if (f2.length > 0 && r2 && "hd-road-base" === this.elevationMode) {
                  const t4 = r2.elevation.isTunnel(), e3 = r2.elevation.safeArea, n4 = this.elevatedStructures.addVertices(u2, c2);
                  this.elevatedStructures.addTriangles(f2, n4, t4);
                  const i4 = h3.length;
                  if (i4 > 0) {
                    for (let s4 = 0; s4 < i4 - 1; s4++) this.elevatedStructures.addRenderableRing(r2.index, h3[s4] + n4, h3[s4 + 1] - h3[s4], t4, e3, r2.featureInfo);
                    this.elevatedStructures.addRenderableRing(r2.index, h3[i4 - 1] + n4, u2.length - h3[i4 - 1], t4, e3, r2.featureInfo);
                  }
                }
                i3.vertexLength += t3, i3.primitiveLength += f2.length / 3;
              }
              return [n2, i2];
            }
            prepareElevatedPolygons(t2, e2, r2) {
              const n2 = 1 / au(r2), i2 = [];
              for (const r3 of t2) {
                const t3 = up(r3, new Hu(e2, n2));
                i2.push(...t3);
              }
              return i2;
            }
            clipPolygonsToTile(t2, e2) {
              const r2 = -e2, n2 = -e2, i2 = Cn + e2, s2 = Cn + e2;
              let o2 = 0;
              const a2 = [], l2 = [];
              for (; o2 < t2.length; o2++) {
                const e3 = t2[o2], u3 = pn(e3);
                (u3.min.x >= r2 && u3.max.x <= i2 && u3.min.y >= n2 && u3.max.y <= s2 ? a2 : l2).push(e3);
              }
              if (a2.length === t2.length) return t2;
              const u2 = [new bt(r2, n2), new bt(i2, n2), new bt(i2, s2), new bt(r2, s2), new bt(r2, n2)], c2 = a2;
              for (const t3 of l2) c2.push(...lp(t3, u2));
              return c2;
            }
          }
          let dp, mp, yp, gp;
          qs(fp, "FillBucket", { omit: ["layers", "patternFeatures"] }), qs(pp, "FillBufferData"), qs(np, "ElevatedStructures");
          class xp {
            constructor(t2, e2, r2, n2) {
              if (this.triangleCount = e2.length / 3, this.min = new bt(0, 0), this.max = new bt(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === t2.length) return;
              const [i2, s2] = [t2[0].clone(), t2[0].clone()];
              for (let e3 = 1; e3 < t2.length; ++e3) {
                const r3 = t2[e3];
                i2.x = Math.min(i2.x, r3.x), i2.y = Math.min(i2.y, r3.y), s2.x = Math.max(s2.x, r3.x), s2.y = Math.max(s2.y, r3.y);
              }
              if (n2) {
                const t3 = Math.ceil(Math.max(s2.x - i2.x, s2.y - i2.y) / n2);
                r2 = Math.max(r2, t3);
              }
              if (0 === r2) return;
              this.min = i2, this.max = s2;
              const o2 = this.max.sub(this.min);
              o2.x = Math.max(o2.x, 1), o2.y = Math.max(o2.y, 1);
              const a2 = Math.max(o2.x, o2.y) / r2;
              this.cellsX = Math.max(1, Math.ceil(o2.x / a2)), this.cellsY = Math.max(1, Math.ceil(o2.y / a2)), this.xScale = 1 / a2, this.yScale = 1 / a2;
              const l2 = [];
              for (let r3 = 0; r3 < this.triangleCount; r3++) {
                const n3 = t2[e2[3 * r3 + 0]].sub(this.min), i3 = t2[e2[3 * r3 + 1]].sub(this.min), s3 = t2[e2[3 * r3 + 2]].sub(this.min), o3 = vp(Math.floor(Math.min(n3.x, i3.x, s3.x)), this.xScale, this.cellsX), u3 = vp(Math.floor(Math.max(n3.x, i3.x, s3.x)), this.xScale, this.cellsX), c2 = vp(Math.floor(Math.min(n3.y, i3.y, s3.y)), this.yScale, this.cellsY), h3 = vp(Math.floor(Math.max(n3.y, i3.y, s3.y)), this.yScale, this.cellsY), p3 = new bt(0, 0), f2 = new bt(0, 0), d2 = new bt(0, 0), m2 = new bt(0, 0);
                for (let t3 = c2; t3 <= h3; ++t3) {
                  p3.y = f2.y = t3 * a2, d2.y = m2.y = (t3 + 1) * a2;
                  for (let e3 = o3; e3 <= u3; ++e3) p3.x = d2.x = e3 * a2, f2.x = m2.x = (e3 + 1) * a2, (pc(n3, i3, s3, p3, f2, m2) || pc(n3, i3, s3, p3, m2, d2)) && l2.push({ cellIdx: t3 * this.cellsX + e3, triIdx: r3 });
                }
              }
              if (0 === l2.length) return;
              l2.sort((t3, e3) => t3.cellIdx - e3.cellIdx || t3.triIdx - e3.triIdx);
              let u2 = 0;
              for (; u2 < l2.length; ) {
                const t3 = l2[u2].cellIdx, e3 = { start: this.payload.length, len: 0 };
                for (; u2 < l2.length && l2[u2].cellIdx === t3; ) ++e3.len, this.payload.push(l2[u2++].triIdx);
                this.cells[t3] = e3;
              }
            }
            _lazyInitLookup() {
              this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
            }
            queryPoint(t2, e2) {
              if (0 === this.triangleCount || 0 === this.cells.length) return;
              if (t2.x > this.max.x || this.min.x > t2.x || t2.y > this.max.y || this.min.y > t2.y) return;
              const r2 = vp(t2.x - this.min.x, this.xScale, this.cellsX), n2 = vp(t2.y - this.min.y, this.yScale, this.cellsY), i2 = this.cells[n2 * this.cellsX + r2];
              if (i2) {
                this._lazyInitLookup();
                for (let t3 = 0; t3 < i2.len; t3++) {
                  const r3 = this.payload[i2.start + t3], n3 = Math.floor(r3 / 8), s2 = 1 << r3 % 8;
                  if (!(this.lookup[n3] & s2) && (this.lookup[n3] |= s2, e2.push(r3), e2.length === this.triangleCount)) return;
                }
              }
            }
            query(t2, e2, r2) {
              if (0 === this.triangleCount || 0 === this.cells.length) return;
              if (t2.x > this.max.x || this.min.x > e2.x) return;
              if (t2.y > this.max.y || this.min.y > e2.y) return;
              this._lazyInitLookup();
              const n2 = vp(t2.x - this.min.x, this.xScale, this.cellsX), i2 = vp(e2.x - this.min.x, this.xScale, this.cellsX), s2 = vp(t2.y - this.min.y, this.yScale, this.cellsY), o2 = vp(e2.y - this.min.y, this.yScale, this.cellsY);
              for (let t3 = s2; t3 <= o2; t3++) for (let e3 = n2; e3 <= i2; e3++) {
                const n3 = this.cells[t3 * this.cellsX + e3];
                if (n3) for (let t4 = 0; t4 < n3.len; t4++) {
                  const e4 = this.payload[n3.start + t4], i3 = Math.floor(e4 / 8), s3 = 1 << e4 % 8;
                  if (!(this.lookup[i3] & s3) && (this.lookup[i3] |= s3, r2.push(e4), r2.length === this.triangleCount)) return;
                }
              }
            }
          }
          function vp(t2, e2, r2) {
            return Math.max(0, Math.min(r2 - 1, Math.floor(t2 * e2)));
          }
          qs(xp, "TriangleGridIndex");
          class bp {
            constructor(t2) {
              this.zoom = t2.zoom, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.hasPattern = false, this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.footprints = [], this.worldview = t2.worldview;
            }
            updateFootprints(t2, e2) {
              for (const r2 of this.footprints) e2.push({ footprint: r2, id: t2 });
            }
            populate(t2, e2, r2, n2) {
              const i2 = [];
              for (const { feature: e3, id: s2, index: o2, sourceLayerIndex: a2 } of t2) {
                const t3 = this.layers[0]._featureFilter.needGeometry, l2 = gu(e3, t3);
                if (!this.layers[0]._featureFilter.filter(new go(this.zoom, { worldview: this.worldview }), l2, r2)) continue;
                const u2 = { id: s2, properties: e3.properties, type: e3.type, sourceLayerIndex: a2, index: o2, geometry: t3 ? l2.geometry : yu(e3, r2, n2), patterns: {} };
                i2.push(u2);
              }
              for (const n3 of i2) {
                const { geometry: i3, index: s2, sourceLayerIndex: o2 } = n3;
                this.addFeature(n3, i3, s2, r2, {}, e2.availableImages, e2.brightness), e2.featureIndex.insert(t2[s2].feature, i3, s2, o2, this.index);
              }
            }
            isEmpty() {
              return 0 === this.footprints.length;
            }
            uploadPending() {
              return false;
            }
            upload(t2) {
            }
            update(t2, e2, r2, n2, i2, s2, o2) {
            }
            destroy() {
            }
            addFeature(t2, e2, r2, n2, i2, s2 = [], o2) {
              for (const t3 of Wh(e2, 2)) {
                const e3 = [], r3 = [], n3 = [], i3 = new bt(1 / 0, 1 / 0), s3 = new bt(-1 / 0, -1 / 0);
                for (const o4 of t3) if (0 !== o4.length) {
                  o4 !== t3[0] && n3.push(r3.length / 2);
                  for (let t4 = 0; t4 < o4.length; t4++) r3.push(o4[t4].x), r3.push(o4[t4].y), e3.push(o4[t4]), i3.x = Math.min(i3.x, o4[t4].x), i3.y = Math.min(i3.y, o4[t4].y), s3.x = Math.max(s3.x, o4[t4].x), s3.y = Math.max(s3.y, o4[t4].y);
                }
                const o3 = Ah(r3, n3), a2 = new xp(e3, o3, 8, 256);
                this.footprints.push({ vertices: e3, indices: o3, grid: a2, min: i3, max: s3 });
              }
            }
          }
          qs(bp, "ClipBucket", { omit: ["layers"] });
          const wp = ta([{ name: "a_pos_normal_ed", components: 4, type: "Int16" }]), _p = ta([{ name: "a_pos_end", components: 4, type: "Int16" }, { name: "a_angular_offset_factor", components: 1, type: "Int16" }]), Ap = ta([{ name: "a_centroid_pos", components: 2, type: "Uint16" }]), Mp = ta([{ name: "a_join_normal_inside", components: 3, type: "Int16" }]), Ip = ta([{ name: "a_hidden_by_landmark", components: 1, type: "Uint8" }]), Sp = ta([{ name: "a_pos_3", components: 3, type: "Int16" }, { name: "a_pos_normal_3", components: 3, type: "Int16" }]), { members: zp } = wp, kp = Number.MAX_SAFE_INTEGER;
          function Pp(t2, e2, r2, n2) {
            return t2.order < e2 || t2.order === kp || !(t2.clipMask & r2) || function(t3, e3) {
              return 0 !== e3.length && void 0 === e3.find((e4) => e4 === t3);
            }(n2, t2.clipScope);
          }
          function Ep(t2, e2) {
            return t2.x - e2.x || t2.y - e2.y;
          }
          function Tp(t2, e2) {
            return 0 === Ep(t2.min, e2.min) && 0 === Ep(t2.max, e2.max);
          }
          function Bp(t2, e2) {
            return !(t2.min.x > e2.max.x || t2.max.x < e2.min.x || t2.min.y > e2.max.y || t2.max.y < e2.min.y);
          }
          function Vp(t2, e2) {
            if (t2.length !== e2.length) return false;
            for (let r2 = 0; r2 < t2.length; r2++) if (t2[r2].sourceId !== e2[r2].sourceId || !Tp(t2[r2], e2[r2]) || t2[r2].order !== e2[r2].order || t2[r2].clipMask !== e2[r2].clipMask || !wt(t2[r2].clipScope, e2[r2].clipScope)) return false;
            return true;
          }
          function Cp(t2, e2, r2) {
            const n2 = 1 / Cn, i2 = 1 / (1 << r2.canonical.z), s2 = (e2.x * n2 + r2.canonical.x) * i2 + r2.wrap, o2 = (e2.y * n2 + r2.canonical.y) * i2;
            return { min: new bt((t2.x * n2 + r2.canonical.x) * i2 + r2.wrap, (t2.y * n2 + r2.canonical.y) * i2), max: new bt(s2, o2) };
          }
          function Fp(t2, e2, r2) {
            const n2 = 1 << r2.canonical.z, i2 = ((e2.x - r2.wrap) * n2 - r2.canonical.x) * Cn, s2 = (e2.y * n2 - r2.canonical.y) * Cn;
            return { min: new bt(((t2.x - r2.wrap) * n2 - r2.canonical.x) * Cn, (t2.y * n2 - r2.canonical.y) * Cn), max: new bt(i2, s2) };
          }
          function Dp(t2, e2, r2, n2, i2, s2, o2) {
            const a2 = t2.indices, l2 = t2.vertices, u2 = [];
            for (let c2 = n2; c2 < n2 + i2; c2 += 3) {
              const n3 = e2[r2[c2 + 0] + s2], i3 = e2[r2[c2 + 1] + s2], h3 = e2[r2[c2 + 2] + s2], p3 = Math.min(n3.x, i3.x, h3.x), f2 = Math.max(n3.x, i3.x, h3.x), d2 = Math.min(n3.y, i3.y, h3.y), m2 = Math.max(n3.y, i3.y, h3.y);
              u2.length = 0, t2.grid.query(new bt(p3, d2), new bt(f2, m2), u2);
              for (let t3 = 0; t3 < u2.length; t3++) {
                const e3 = u2[t3];
                if (pc(l2[a2[3 * e3 + 0]], l2[a2[3 * e3 + 1]], l2[a2[3 * e3 + 2]], n3, i3, h3, o2)) return true;
              }
            }
            return false;
          }
          function Lp(t2, e2, r2, n2) {
            if (!t2 || !r2) return false;
            let i2 = t2.vertices;
            if (!e2.canonical.equals(n2.canonical) || e2.wrap !== n2.wrap) {
              if (r2.vertices.length < t2.vertices.length) return Lp(r2, n2, t2, e2);
              const s2 = e2.canonical, o2 = n2.canonical, a2 = Math.pow(2, o2.z - s2.z);
              i2 = t2.vertices.map((t3) => new bt((t3.x + s2.x * Cn) * a2 - o2.x * Cn, (t3.y + s2.y * Cn) * a2 - o2.y * Cn));
            }
            return Dp(r2, i2, t2.indices, 0, t2.indices.length, 0, 0);
          }
          function Rp(t2, e2, r2, n2) {
            const i2 = Math.pow(2, n2.z - r2.z);
            return new bt((t2 + r2.x * Cn) * i2 - n2.x * Cn, (e2 + r2.y * Cn) * i2 - n2.y * Cn);
          }
          function Op(t2, e2) {
            const r2 = [];
            e2.grid.queryPoint(t2, r2);
            const n2 = e2.indices, i2 = e2.vertices;
            for (let e3 = 0; e3 < r2.length; e3++) {
              const s2 = r2[e3];
              if (lc([i2[n2[3 * s2 + 0]], i2[n2[3 * s2 + 1]], i2[n2[3 * s2 + 2]]], t2)) return true;
            }
            return false;
          }
          const Up = [new bt(0, 0), new bt(Cn, 0), new bt(Cn, Cn), new bt(0, Cn)];
          function Np(t2, e2) {
            const r2 = [];
            let n2 = [];
            if (!e2 || t2.length < 2) return [t2];
            if (2 === t2.length) return cc(t2[0], t2[1], Up) ? [t2] : [];
            for (let e3 = 0; e3 < t2.length + 2; e3++) {
              const i2 = t2[e3 % t2.length], s2 = t2[(e3 + 1) % t2.length], o2 = cc(0 === e3 ? t2[t2.length - 1] : t2[(e3 - 1) % t2.length], i2, Up), a2 = cc(i2, s2, Up), l2 = o2 || a2;
              l2 && n2.push(i2), l2 && a2 || n2.length > 0 && (n2.length > 1 && r2.push(n2), n2 = []);
            }
            return n2.length > 1 && r2.push(n2), r2;
          }
          const jp = Pu.VectorTileFeature.types, $p = ["fill-extrusion-base", "fill-extrusion-height", "fill-extrusion-color", "fill-extrusion-pattern", "fill-extrusion-flood-light-wall-radius", "fill-extrusion-line-width", "fill-extrusion-emissive-strength"], Gp = ["fill-extrusion-flood-light-ground-radius"], qp = Math.pow(2, 13), Hp = Math.pow(2, 15) - 1, Xp = new bt(0, 1), Zp = 2147483648;
          function Wp(t2, e2, r2, n2, i2, s2, o2, a2) {
            t2.emplaceBack((e2 << 1) + o2, (r2 << 1) + s2, (Math.floor(n2 * qp) << 1) + i2, Math.round(a2));
          }
          function Yp(t2, e2, r2) {
            t2.emplaceBack(e2.x * Cn, e2.y * Cn, r2 ? 1 : 0);
          }
          function Kp(t2, e2, r2, n2, i2, s2) {
            t2.emplaceBack(e2.x, e2.y, (r2.x << 1) + n2, (r2.y << 1) + i2, s2);
          }
          function Jp(t2, e2, r2) {
            const n2 = 16384;
            t2.emplaceBack(e2.x, e2.y, e2.z, r2[0] * n2, r2[1] * n2, r2[2] * n2);
          }
          class Qp {
            constructor() {
              this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
          }
          class tf {
            constructor() {
              this.centroidXY = new bt(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new bt(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new bt(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
            }
            span() {
              return new bt(this.max.x - this.min.x, this.max.y - this.min.y);
            }
          }
          class ef {
            constructor() {
              this.acc = new bt(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
            startRing(t2, e2) {
              t2.min.x === Number.MAX_VALUE && (t2.min.x = t2.max.x = e2.x, t2.min.y = t2.max.y = e2.y);
            }
            appendEdge(t2, e2, r2) {
              this.accCount++, this.acc._add(e2);
              let n2 = !!this.borders;
              e2.x < t2.min.x ? (t2.min.x = e2.x, n2 = true) : e2.x > t2.max.x && (t2.max.x = e2.x, n2 = true), e2.y < t2.min.y ? (t2.min.y = e2.y, n2 = true) : e2.y > t2.max.y && (t2.max.y = e2.y, n2 = true), ((0 === e2.x || e2.x === Cn) && e2.x === r2.x) != ((0 === e2.y || e2.y === Cn) && e2.y === r2.y) && this.processBorderOverlap(e2, r2), n2 && this.checkBorderIntersection(e2, r2);
            }
            checkBorderIntersection(t2, e2) {
              e2.x < 0 != t2.x < 0 && this.addBorderIntersection(0, ur(e2.y, t2.y, (0 - e2.x) / (t2.x - e2.x))), e2.x > Cn != t2.x > Cn && this.addBorderIntersection(1, ur(e2.y, t2.y, (Cn - e2.x) / (t2.x - e2.x))), e2.y < 0 != t2.y < 0 && this.addBorderIntersection(2, ur(e2.x, t2.x, (0 - e2.y) / (t2.y - e2.y))), e2.y > Cn != t2.y > Cn && this.addBorderIntersection(3, ur(e2.x, t2.x, (Cn - e2.y) / (t2.y - e2.y)));
            }
            addBorderIntersection(t2, e2) {
              this.borders || (this.borders = [[Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE], [Number.MAX_VALUE, -Number.MAX_VALUE]]);
              const r2 = this.borders[t2];
              e2 < r2[0] && (r2[0] = e2), e2 > r2[1] && (r2[1] = e2);
            }
            processBorderOverlap(t2, e2) {
              if (t2.x === e2.x) {
                if (t2.y === e2.y) return;
                const r2 = 0 === t2.x ? 0 : 1;
                this.addBorderIntersection(r2, e2.y), this.addBorderIntersection(r2, t2.y);
              } else {
                const r2 = 0 === t2.y ? 2 : 3;
                this.addBorderIntersection(r2, e2.x), this.addBorderIntersection(r2, t2.x);
              }
            }
            centroid() {
              return 0 === this.accCount ? new bt(0, 0) : new bt(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
              return this.borders ? this.borders.reduce((t2, e2) => t2 + +(e2[0] !== Number.MAX_VALUE), 0) : 0;
            }
          }
          function rf(t2, e2) {
            const r2 = t2.add(e2)._unit(), n2 = Et(t2.x * r2.x + t2.y * r2.y, -1, 1);
            var i2, s2, o2;
            return i2 = Math.acos(n2), Math.min(4, Math.max(-4, Math.tan(i2))) / 4 * Hp * ((s2 = t2).x * (o2 = e2).y - s2.y * o2.x < 0 ? -1 : 1);
          }
          const nf = [(t2) => t2.x < 0, (t2) => t2.x > Cn, (t2) => t2.y < 0, (t2) => t2.y > Cn];
          function sf(t2, e2, r2, n2) {
            const i2 = [4];
            if (0 === n2) return i2;
            r2._mult(n2);
            const s2 = t2.sub(r2), o2 = e2.sub(r2), a2 = [t2, e2, s2, o2];
            for (let t3 = 0; t3 < 4; t3++) for (const e3 of a2) if (nf[t3](e3)) {
              i2.push(t3);
              break;
            }
            return i2;
          }
          class of {
            constructor(t2) {
              this.vertexArray = new la(), this.indexArray = new Aa(), this.programConfigurations = new kl(t2.layers, { zoom: t2.zoom, lut: t2.lut }, (t3) => Gp.includes(t3)), this._segments = new tl(), this.hiddenByLandmarkVertexArray = new La(), this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [0, 0, 0, 0, 0], this.regionSegments = {}, this.regionSegments[4] = new tl();
            }
            getDefaultSegment() {
              return this.regionSegments[4];
            }
            hasData() {
              return 0 !== this.vertexArray.length;
            }
            addData(t2, e2, r2, n2 = false) {
              const i2 = t2.length;
              if (i2 > 2) {
                let s2 = Math.max(0, this._segments.get().length - 1);
                const o2 = this._segments._prepareSegment(4 * i2, this.vertexArray.length, 2 * this._segmentToGroundQuads[s2].length);
                let a2;
                s2 !== this._segments.get().length - 1 && (s2++, this._segmentToGroundQuads[s2] = [], this._segmentToRegionTriCounts[s2] = [0, 0, 0, 0, 0]);
                {
                  const e3 = t2[0], r3 = t2[1];
                  a2 = rf(e3.sub(t2[i2 - 1])._perp()._unit(), r3.sub(e3)._perp()._unit());
                }
                for (let l2 = 0; l2 < i2; l2++) {
                  const u2 = l2 === i2 - 1 ? 0 : l2 + 1, c2 = t2[l2], h3 = t2[u2], p3 = t2[u2 === i2 - 1 ? 0 : u2 + 1], f2 = h3.sub(c2)._perp()._unit(), d2 = rf(f2, p3.sub(h3)._perp()._unit()), m2 = a2, y2 = d2;
                  if (hf(c2, h3, e2) || n2 && pf(c2, e2) && pf(h3, e2)) {
                    a2 = d2;
                    continue;
                  }
                  const g2 = o2.vertexLength;
                  Kp(this.vertexArray, c2, h3, 1, 1, m2), Kp(this.vertexArray, c2, h3, 1, 0, m2), Kp(this.vertexArray, c2, h3, 0, 1, y2), Kp(this.vertexArray, c2, h3, 0, 0, y2), o2.vertexLength += 4;
                  const x2 = sf(c2, h3, f2, r2);
                  for (const t3 of x2) this._segmentToGroundQuads[s2].push({ id: g2, region: t3 }), this._segmentToRegionTriCounts[s2][t3] += 2, o2.primitiveLength += 2;
                  a2 = d2;
                }
              }
            }
            prepareBorderSegments() {
              if (!this.hasData()) return;
              const t2 = this._segments.get(), e2 = t2.length;
              for (let t3 = 0; t3 < e2; t3++) this._segmentToGroundQuads[t3].sort((t4, e3) => t4.region - e3.region);
              for (let r2 = 0; r2 < e2; r2++) {
                const e3 = this._segmentToGroundQuads[r2], n2 = t2[r2], i2 = this._segmentToRegionTriCounts[r2];
                i2.reduce((t3, e4) => t3 + e4, 0);
                let s2 = 0;
                for (let t3 = 0; t3 <= 4; t3++) {
                  const e4 = i2[t3];
                  if (0 !== e4) {
                    let r3 = this.regionSegments[t3];
                    r3 || (r3 = this.regionSegments[t3] = new tl());
                    const i3 = { vertexOffset: n2.vertexOffset, primitiveOffset: n2.primitiveOffset + s2, vertexLength: n2.vertexLength, primitiveLength: e4 };
                    r3.get().push(i3);
                  }
                  s2 += e4;
                }
                for (let t3 = 0; t3 < e3.length; t3++) {
                  const r3 = e3[t3].id;
                  this.indexArray.emplaceBack(r3, r3 + 1, r3 + 3), this.indexArray.emplaceBack(r3, r3 + 3, r3 + 2);
                }
              }
              this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(t2, e2, r2, n2, i2, s2, o2) {
              this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, t2, e2, r2, n2, i2, s2, void 0, o2);
            }
            upload(t2) {
              this.hasData() && (this.vertexBuffer = t2.createVertexBuffer(this.vertexArray, _p.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray));
            }
            uploadPaintProperties(t2) {
              this.hasData() && this.programConfigurations.upload(t2);
            }
            update(t2, e2, r2, n2, i2, s2, o2, a2) {
              this.hasData() && this.programConfigurations.updatePaintArrays(t2, e2, r2, n2, i2, s2, o2, a2);
            }
            updateHiddenByLandmark(t2) {
              if (!this.hasData()) return;
              const e2 = t2.groundVertexCount + t2.groundVertexArrayOffset;
              if (0 === t2.groundVertexCount) return;
              const r2 = t2.flags & Zp ? 1 : 0;
              for (let n2 = t2.groundVertexArrayOffset; n2 < e2; ++n2) this.hiddenByLandmarkVertexArray.emplace(n2, r2);
              this._needsHiddenByLandmarkUpdate = true;
            }
            uploadHiddenByLandmark(t2) {
              this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = t2.createVertexBuffer(this.hiddenByLandmarkVertexArray, Ip.members, true) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = false);
            }
            destroy() {
              if (this.vertexBuffer) {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                for (let t2 = 0; t2 <= 4; t2++) {
                  const e2 = this.regionSegments[t2];
                  e2 && e2.destroy();
                }
              }
            }
          }
          class af {
            constructor(t2) {
              this.zoom = t2.zoom, this.canonical = t2.canonical, this.overscaling = t2.overscaling, this.layers = t2.layers, this.pixelRatio = t2.pixelRatio, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.hasPattern = false, this.edgeRadius = 0, this.projection = t2.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new Aa(), this.footprintVertices = new ra(), this.footprintSegments = [], this.layoutVertexArray = new ia(), this.centroidVertexArray = new Za(), this.wallVertexArray = new Ya(), this.indexArray = new Aa(), this.programConfigurations = new kl(t2.layers, { zoom: t2.zoom, lut: t2.lut }, (t3) => $p.includes(t3)), this.segments = new tl(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.groundEffect = new of(t2), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [], this.worldview = t2.worldview;
            }
            updateFootprints(t2, e2) {
            }
            populate(t2, e2, r2, n2) {
              this.features = [], this.hasPattern = Jh("fill-extrusion", this.layers, this.pixelRatio, e2), this.featuresOnBorder = [], this.borderFeatureIndices = [[], [], [], []], this.borderDoneWithNeighborZ = [-1, -1, -1, -1], this.selfDEMTileTimestamp = Number.MAX_VALUE, this.borderDEMTileTimestamp = [Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE], this.tileToMeter = au(r2), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
              for (const { feature: i2, id: s2, index: o2, sourceLayerIndex: a2 } of t2) {
                const t3 = this.layers[0]._featureFilter.needGeometry, l2 = gu(i2, t3);
                if (!this.layers[0]._featureFilter.filter(new go(this.zoom, { worldview: this.worldview }), l2, r2)) continue;
                const u2 = { id: s2, sourceLayerIndex: a2, index: o2, geometry: t3 ? l2.geometry : yu(i2, r2, n2), properties: i2.properties, type: i2.type, patterns: {} }, c2 = this.layoutVertexArray.length, h3 = "Polygon" === jp[u2.type];
                if (this.hasPattern) this.features.push(Qh("fill-extrusion", this.layers, u2, this.zoom, this.pixelRatio, e2));
                else if (this.wallMode) for (const t4 of u2.geometry) for (const i3 of Np(t4, h3)) this.addFeature(u2, [i3], o2, r2, {}, e2.availableImages, n2, e2.brightness);
                else this.addFeature(u2, u2.geometry, o2, r2, {}, e2.availableImages, n2, e2.brightness);
                e2.featureIndex.insert(i2, u2.geometry, o2, a2, this.index, c2);
              }
              this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(t2, e2, r2, n2, i2, s2) {
              for (const t3 of this.features) {
                const o2 = "Polygon" === jp[t3.type], { geometry: a2 } = t3;
                if (this.wallMode) for (const l2 of a2) for (const a3 of Np(l2, o2)) this.addFeature(t3, [a3], t3.index, e2, r2, n2, i2, s2);
                else this.addFeature(t3, a2, t3.index, e2, r2, n2, i2, s2);
              }
              this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(t2, e2, r2, n2, i2, s2, o2) {
              this.programConfigurations.updatePaintArrays(t2, e2, i2, r2, n2, s2, o2, this.worldview), this.groundEffect.update(t2, e2, i2, r2, n2, s2, o2, this.worldview);
            }
            isEmpty() {
              return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
              return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(t2) {
              this.uploaded || (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, zp), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.wallVertexBuffer = t2.createVertexBuffer(this.wallVertexArray, Mp.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = t2.createVertexBuffer(this.layoutVertexExtArray, Sp.members, true)), this.groundEffect.upload(t2)), this.groundEffect.uploadPaintProperties(t2), this.programConfigurations.upload(t2), this.uploaded = true;
            }
            uploadCentroid(t2) {
              this.groundEffect.uploadHiddenByLandmark(t2), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = t2.createVertexBuffer(this.centroidVertexArray, Ap.members, true) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = false);
            }
            destroy() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t2, {}) / this.tileToMeter, u2 = [new bt(0, 0), new bt(Cn, Cn)], c2 = o2.projection, h3 = "globe" === c2.name, p3 = this.wallMode || "Polygon" === jp[t2.type], f2 = new ef();
              f2.centroidDataIndex = this.centroidData.length;
              const d2 = new tf(), m2 = this.layers[0].paint.get("fill-extrusion-base").evaluate(t2, {}, n2) <= 0, y2 = this.layers[0].paint.get("fill-extrusion-height").evaluate(t2, {}, n2);
              let g2;
              if (d2.height = y2, d2.vertexArrayOffset = this.layoutVertexArray.length, d2.groundVertexArrayOffset = this.groundEffect.vertexArray.length, h3 && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new fa()), this.wallMode) {
                if (h3) return void Gt("Non zero fill-extrusion-line-width is not yet supported on globe.");
                if (1 !== e2.length) return;
                g2 = function(t3) {
                  const e3 = t3[0].x === t3[t3.length - 1].x && t3[0].y === t3[t3.length - 1].y, r3 = function(t4) {
                    let e4 = 0;
                    const r4 = t4.length;
                    for (let n4 = 0; n4 < r4; n4++) e4 += (t4[(n4 + 1) % r4].x - t4[n4].x) * (t4[(n4 + 1) % r4].y + t4[n4].y);
                    return e4 >= 0;
                  }(t3);
                  r3 || (t3 = t3.reverse());
                  const n3 = { geometry: [], joinNormals: [], indices: [] }, i3 = [], s3 = [], o3 = [];
                  let a3 = t3.length;
                  for (; a3 >= 2 && t3[a3 - 1].equals(t3[a3 - 2]); ) a3--;
                  if (a3 < (e3 ? 3 : 2)) return n3;
                  let l3, u3, c3, h4, p4, f3 = 0;
                  for (; f3 < a3 - 1 && t3[f3].equals(t3[f3 + 1]); ) f3++;
                  e3 && (l3 = t3[a3 - 2], p4 = t3[f3].sub(l3)._unit()._perp());
                  for (let r4 = f3; r4 < a3; r4++) {
                    if (c3 = r4 === a3 - 1 ? e3 ? t3[f3 + 1] : void 0 : t3[r4 + 1], c3 && t3[r4].equals(c3)) continue;
                    p4 && (h4 = p4), l3 && (u3 = l3), l3 = t3[r4], p4 = c3 ? c3.sub(l3)._unit()._perp() : h4, h4 = h4 || p4;
                    let n4 = h4.add(p4);
                    0 === n4.x && 0 === n4.y || n4._unit();
                    const d4 = n4.x * p4.x + n4.y * p4.y, m3 = 0 !== d4 ? 1 / d4 : 1 / 0, y3 = h4.x * p4.y - h4.y * p4.x > 0;
                    let g3 = "miter";
                    const x3 = 2;
                    "miter" === g3 && m3 > x3 && (g3 = "bevel"), "bevel" === g3 && (m3 > 100 && (g3 = "flipbevel"), m3 < x3 && (g3 = "miter"));
                    const v3 = (t4, e4, r5, n5) => {
                      const a4 = new bt(t4.x, t4.y), l4 = new bt(t4.x, t4.y);
                      a4.x += e4.x * n5, a4.y += e4.y * n5, l4.x -= e4.x * Math.max(r5, 1), l4.y -= e4.y * Math.max(r5, 1), o3.push(e4), i3.push(a4), s3.push(l4);
                    };
                    if ("miter" === g3) n4._mult(m3), v3(l3, n4, 0, 0);
                    else if ("flipbevel" === g3) n4 = p4.mult(-1), v3(l3, n4, 0, 0), v3(l3, n4.mult(-1), 0, 0);
                    else {
                      const t4 = -Math.sqrt(m3 * m3 - 1), e4 = y3 ? t4 : 0, r5 = y3 ? 0 : t4;
                      u3 && v3(l3, h4, e4, r5), c3 && v3(l3, p4, e4, r5);
                    }
                  }
                  n3.geometry = [...i3, ...s3.reverse(), i3[0]], n3.joinNormals = [...o3, ...o3.reverse(), o3[o3.length - 1]];
                  const d3 = n3.geometry.length - 1;
                  for (let t4 = 0; t4 < d3 / 2; t4++) if (t4 + 1 < d3 / 2) {
                    let e4 = t4, r4 = t4 + 1, i4 = d3 - 1 - t4, s4 = d3 - 2 - t4;
                    e4 = 0 === e4 ? d3 - 1 : e4 - 1, r4 = 0 === r4 ? d3 - 1 : r4 - 1, i4 = 0 === i4 ? d3 - 1 : i4 - 1, s4 = 0 === s4 ? d3 - 1 : s4 - 1, n3.indices.push(i4), n3.indices.push(r4), n3.indices.push(e4), n3.indices.push(i4), n3.indices.push(s4), n3.indices.push(r4);
                  }
                  return n3;
                }(e2[0]), e2 = [g2.geometry];
              }
              const x2 = (t3, e3) => t3 < (e3.length - 1) / 2 || t3 === e3.length - 1, v2 = this.wallMode ? [e2] : Wh(e2, 500);
              for (let t3 = v2.length - 1; t3 >= 0; t3--) {
                const e3 = v2[t3];
                (0 === e3.length || (b2 = e3[0]).every((t4) => t4.x <= 0) || b2.every((t4) => t4.x >= Cn) || b2.every((t4) => t4.y <= 0) || b2.every((t4) => t4.y >= Cn)) && v2.splice(t3, 1);
              }
              var b2;
              let w2;
              if (h3) w2 = yf(v2, u2, n2);
              else {
                w2 = [];
                for (const t3 of v2) w2.push({ polygon: t3, bounds: u2 });
              }
              const _2 = p3 ? this.edgeRadius : 0, A2 = _2 > 0 && this.zoom < 17, M2 = (t3, e3) => {
                if (0 === t3.length) return false;
                const r3 = t3[t3.length - 1];
                return e3.x === r3.x && e3.y === r3.y;
              };
              for (const { polygon: t3, bounds: e3 } of w2) {
                let r3 = 0, i3 = 0;
                for (const e4 of t3) p3 && !e4[0].equals(e4[e4.length - 1]) && e4.push(e4[0]), i3 += p3 ? e4.length - 1 : e4.length;
                const s3 = this.segments.prepareSegment((p3 ? 5 : 4) * i3, this.layoutVertexArray, this.indexArray);
                d2.footprintSegIdx < 0 && (d2.footprintSegIdx = this.footprintSegments.length), d2.polygonSegIdx < 0 && (d2.polygonSegIdx = this.polygonSegments.length);
                const o3 = { triangleArrayOffset: this.indexArray.length, triangleCount: 0, triangleSegIdx: this.segments.segments.length - 1 }, a3 = new Qp();
                if (a3.vertexOffset = this.footprintVertices.length, a3.indexOffset = 3 * this.footprintIndices.length, a3.ringIndices = [], p3) {
                  const i4 = [], o4 = [];
                  r3 = s3.vertexLength;
                  for (let r4 = 0; r4 < t3.length; r4++) {
                    const u4 = t3[r4];
                    u4.length && 0 !== r4 && o4.push(i4.length / 2);
                    const p4 = [];
                    let f3, d3;
                    f3 = u4[1].sub(u4[0])._perp()._unit(), a3.ringIndices.push(u4.length - 1);
                    for (let t4 = 1; t4 < u4.length; t4++) {
                      const e4 = u4[t4], r5 = u4[t4 === u4.length - 1 ? 1 : t4 + 1], o5 = e4.clone();
                      if (_2) {
                        d3 = r5.sub(e4)._perp()._unit();
                        const t5 = f3.add(d3)._unit(), n3 = _2 * Math.min(4, 1 / (f3.x * t5.x + f3.y * t5.y));
                        o5.x += n3 * t5.x, o5.y += n3 * t5.y, o5.x = Math.round(o5.x), o5.y = Math.round(o5.y), f3 = d3;
                      }
                      if (!m2 || 0 !== _2 && !A2 || M2(p4, o5) || p4.push(o5), Wp(this.layoutVertexArray, o5.x, o5.y, 0, 0, 1, 1, 0), this.wallMode) {
                        const e5 = x2(t4, u4);
                        Yp(this.wallVertexArray, g2.joinNormals[t4], !e5);
                      }
                      s3.vertexLength++, this.footprintVertices.emplaceBack(e4.x, e4.y), i4.push(e4.x, e4.y), h3 && Jp(this.layoutVertexExtArray, c2.projectTilePoint(o5.x, o5.y, n2), c2.upVector(n2, o5.x, o5.y));
                    }
                    m2 && (0 === _2 || A2) && (0 !== p4.length && M2(p4, p4[0]) && p4.pop(), this.groundEffect.addData(p4, e3, l2));
                  }
                  const u3 = this.wallMode ? g2.indices : Ah(i4, o4);
                  for (let t4 = 0; t4 < u3.length; t4 += 3) this.footprintIndices.emplaceBack(a3.vertexOffset + u3[t4 + 0], a3.vertexOffset + u3[t4 + 1], a3.vertexOffset + u3[t4 + 2]), this.indexArray.emplaceBack(r3 + u3[t4], r3 + u3[t4 + 2], r3 + u3[t4 + 1]), s3.primitiveLength++;
                  a3.indexCount += u3.length, a3.vertexCount += this.footprintVertices.length - a3.vertexOffset;
                }
                for (let i4 = 0; i4 < t3.length; i4++) {
                  const o4 = t3[i4];
                  f2.startRing(d2, o4[0]);
                  let a4 = o4.length > 4 && ff(o4[o4.length - 2], o4[0], o4[1]), u3 = _2 ? uf(o4[o4.length - 2], o4[0], o4[1], _2) : 0;
                  const y3 = [];
                  let v3, b3, w3;
                  b3 = o4[1].sub(o4[0])._perp()._unit();
                  let A3 = true;
                  for (let t4 = 1, i5 = 0; t4 < o4.length; t4++) {
                    let l3 = o4[t4 - 1], p4 = o4[t4];
                    const I2 = o4[t4 === o4.length - 1 ? 1 : t4 + 1];
                    if (f2.appendEdge(d2, p4, l3), hf(p4, l3, e3)) {
                      _2 && (b3 = I2.sub(p4)._perp()._unit(), A3 = !A3);
                      continue;
                    }
                    const S2 = p4.sub(l3)._perp(), z2 = S2.x / (Math.abs(S2.x) + Math.abs(S2.y)), k2 = S2.y > 0 ? 1 : 0, P2 = l3.dist(p4);
                    if (i5 + P2 > 32768 && (i5 = 0), _2) {
                      w3 = I2.sub(p4)._perp()._unit();
                      let t5 = cf(l3, p4, I2, lf(b3, w3), _2);
                      isNaN(t5) && (t5 = 0);
                      const e4 = p4.sub(l3)._unit();
                      l3 = l3.add(e4.mult(u3))._round(), p4 = p4.add(e4.mult(-t5))._round(), u3 = t5, b3 = w3, m2 && this.zoom >= 17 && (M2(y3, l3) || y3.push(l3), M2(y3, p4) || y3.push(p4));
                    }
                    const E2 = s3.vertexLength, T2 = o4.length > 4 && ff(l3, p4, I2);
                    let B2 = df(i5, a4, A3);
                    if (Wp(this.layoutVertexArray, l3.x, l3.y, z2, k2, 0, 0, B2), Wp(this.layoutVertexArray, l3.x, l3.y, z2, k2, 0, 1, B2), this.wallMode) {
                      const e4 = x2(t4 - 1, o4), r4 = g2.joinNormals[t4 - 1];
                      Yp(this.wallVertexArray, r4, e4), Yp(this.wallVertexArray, r4, e4);
                    }
                    if (i5 += P2, B2 = df(i5, T2, !A3), a4 = T2, Wp(this.layoutVertexArray, p4.x, p4.y, z2, k2, 0, 0, B2), Wp(this.layoutVertexArray, p4.x, p4.y, z2, k2, 0, 1, B2), this.wallMode) {
                      const e4 = x2(t4, o4), r4 = g2.joinNormals[t4];
                      Yp(this.wallVertexArray, r4, e4), Yp(this.wallVertexArray, r4, e4);
                    }
                    if (s3.vertexLength += 4, this.indexArray.emplaceBack(E2 + 0, E2 + 1, E2 + 2), this.indexArray.emplaceBack(E2 + 1, E2 + 3, E2 + 2), s3.primitiveLength += 2, _2) {
                      const n3 = r3 + (1 === t4 ? o4.length - 2 : t4 - 2), i6 = 1 === t4 ? r3 : n3 + 1;
                      if (this.indexArray.emplaceBack(E2 + 1, n3, E2 + 3), this.indexArray.emplaceBack(n3, i6, E2 + 3), s3.primitiveLength += 2, void 0 === v3 && (v3 = E2), !hf(I2, o4[t4], e3)) {
                        const e4 = t4 === o4.length - 1 ? v3 : s3.vertexLength;
                        this.indexArray.emplaceBack(E2 + 2, E2 + 3, e4), this.indexArray.emplaceBack(E2 + 3, e4 + 1, e4), this.indexArray.emplaceBack(E2 + 3, i6, e4 + 1), s3.primitiveLength += 3;
                      }
                      A3 = !A3;
                    }
                    if (h3) {
                      const t5 = this.layoutVertexExtArray, e4 = c2.projectTilePoint(l3.x, l3.y, n2), r4 = c2.projectTilePoint(p4.x, p4.y, n2), i6 = c2.upVector(n2, l3.x, l3.y), s4 = c2.upVector(n2, p4.x, p4.y);
                      Jp(t5, e4, i6), Jp(t5, e4, i6), Jp(t5, r4, s4), Jp(t5, r4, s4);
                    }
                  }
                  p3 && (r3 += o4.length - 1), m2 && _2 && this.zoom >= 17 && (0 !== y3.length && M2(y3, y3[0]) && y3.pop(), this.groundEffect.addData(y3, e3, l2, _2 > 0));
                }
                this.footprintSegments.push(a3), o3.triangleCount = this.indexArray.length - o3.triangleArrayOffset, this.polygonSegments.push(o3), ++d2.footprintSegLen, ++d2.polygonSegLen;
              }
              if (d2.vertexCount = this.layoutVertexArray.length - d2.vertexArrayOffset, d2.groundVertexCount = this.groundEffect.vertexArray.length - d2.groundVertexArrayOffset, 0 !== d2.vertexCount) {
                if (d2.centroidXY = f2.borders ? Xp : this.encodeCentroid(f2, d2), this.centroidData.push(d2), f2.borders) {
                  this.featuresOnBorder.push(f2);
                  const t3 = this.featuresOnBorder.length - 1;
                  for (let e3 = 0; e3 < f2.borders.length; e3++) f2.borders[e3][0] !== Number.MAX_VALUE && this.borderFeatureIndices[e3].push(t3);
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, i2, s2, n2, a2, void 0, this.worldview), this.groundEffect.addPaintPropertiesData(t2, r2, i2, s2, n2, a2, this.worldview), this.maxHeight = Math.max(this.maxHeight, y2);
              }
            }
            sortBorders() {
              for (let t2 = 0; t2 < this.borderFeatureIndices.length; t2++) this.borderFeatureIndices[t2].sort((e2, r2) => this.featuresOnBorder[e2].borders[t2][0] - this.featuresOnBorder[r2].borders[t2][0]);
            }
            splitToSubtiles() {
              const t2 = [];
              for (let e3 = 0; e3 < this.centroidData.length; e3++) {
                const r3 = this.centroidData[e3], n3 = +(r3.min.y + r3.max.y > Cn), i3 = 2 * n3 + (+(r3.min.x + r3.max.x > Cn) ^ n3);
                for (let n4 = 0; n4 < r3.polygonSegLen; n4++) {
                  const s3 = r3.polygonSegIdx + n4;
                  t2.push({ centroidIdx: e3, subtile: i3, polygonSegmentIdx: s3, triangleSegmentIdx: this.polygonSegments[s3].triangleSegIdx });
                }
              }
              const e2 = new Aa();
              t2.sort((t3, e3) => t3.triangleSegmentIdx === e3.triangleSegmentIdx ? t3.subtile - e3.subtile : t3.triangleSegmentIdx - e3.triangleSegmentIdx);
              let r2 = 0, n2 = 0, i2 = 0;
              for (const e3 of t2) {
                if (e3.triangleSegmentIdx !== r2) break;
                i2++;
              }
              const s2 = t2.length;
              for (; n2 !== t2.length; ) {
                r2 = t2[n2].triangleSegmentIdx;
                let o2 = 0, a2 = n2, l2 = n2;
                for (let e3 = a2; e3 < i2 && t2[e3].subtile === o2; e3++) l2++;
                for (; a2 !== i2; ) {
                  const n3 = t2[a2];
                  o2 = n3.subtile;
                  const s3 = this.centroidData[n3.centroidIdx].min.clone(), u2 = this.centroidData[n3.centroidIdx].max.clone(), c2 = { vertexOffset: this.segments.segments[r2].vertexOffset, primitiveOffset: e2.length, vertexLength: this.segments.segments[r2].vertexLength, primitiveLength: 0, sortKey: void 0, vaos: {} };
                  for (let r3 = a2; r3 < l2; r3++) {
                    const n4 = t2[r3], i3 = this.polygonSegments[n4.polygonSegmentIdx], o3 = this.centroidData[n4.centroidIdx].min, a3 = this.centroidData[n4.centroidIdx].max, l3 = this.indexArray.uint16;
                    for (let t3 = i3.triangleArrayOffset; t3 < i3.triangleArrayOffset + i3.triangleCount; t3++) e2.emplaceBack(l3[3 * t3], l3[3 * t3 + 1], l3[3 * t3 + 2]);
                    c2.primitiveLength += i3.triangleCount, s3.x = Math.min(s3.x, o3.x), s3.y = Math.min(s3.y, o3.y), u2.x = Math.max(u2.x, a3.x), u2.y = Math.max(u2.y, a3.y);
                  }
                  c2.primitiveLength > 0 && this.triangleSubSegments.push({ segment: c2, min: s3, max: u2 }), a2 = l2;
                  for (let e3 = a2; e3 < i2 && t2[e3].subtile === t2[a2].subtile; e3++) l2++;
                }
                n2 = i2;
                for (let e3 = n2; e3 < s2 && t2[e3].triangleSegmentIdx === t2[n2].triangleSegmentIdx; e3++) i2++;
              }
              e2._trim(), this.indexArray = e2;
            }
            getVisibleSegments(t2, e2, r2) {
              const n2 = new tl();
              if (this.wallMode) {
                for (const t3 of this.triangleSubSegments) n2.segments.push(t3.segment);
                return n2;
              }
              let i2 = 0, s2 = 0;
              const o2 = 1 << t2.canonical.z;
              if (e2) {
                const r3 = e2.getMinMaxForTile(t2);
                r3 && (i2 = r3.min, s2 = r3.max);
              }
              s2 += this.maxHeight;
              const a2 = t2.toUnwrapped();
              let l2;
              const u2 = [a2.canonical.x / o2 + a2.wrap, a2.canonical.y / o2], c2 = [(a2.canonical.x + 1) / o2 + a2.wrap, (a2.canonical.y + 1) / o2], h3 = (t3, e3, r3) => [t3[0] * (1 - r3[0]) + e3[0] * r3[0], t3[1] * (1 - r3[1]) + e3[1] * r3[1]], p3 = [], f2 = [];
              for (const t3 of this.triangleSubSegments) {
                p3[0] = t3.min.x / Cn, p3[1] = t3.min.y / Cn, f2[0] = t3.max.x / Cn, f2[1] = t3.max.y / Cn;
                const e3 = h3(u2, c2, p3), o3 = h3(u2, c2, f2);
                if (0 === new qu([e3[0], e3[1], i2], [o3[0], o3[1], s2]).intersectsPrecise(r2)) {
                  l2 && (n2.segments.push(l2), l2 = void 0);
                  continue;
                }
                const a3 = t3.segment;
                l2 && l2.vertexOffset !== a3.vertexOffset && (n2.segments.push(l2), l2 = void 0), l2 ? (l2.vertexLength += a3.vertexLength, l2.primitiveLength += a3.primitiveLength) : l2 = { vertexOffset: a3.vertexOffset, primitiveLength: a3.primitiveLength, vertexLength: a3.vertexLength, primitiveOffset: a3.primitiveOffset, sortKey: void 0, vaos: {} };
              }
              return l2 && n2.segments.push(l2), n2;
            }
            encodeCentroid(t2, e2) {
              const r2 = t2.centroid(), n2 = e2.span(), i2 = Math.min(7, Math.round(n2.x * this.tileToMeter / 10)), s2 = Math.min(7, Math.round(n2.y * this.tileToMeter / 10));
              return new bt(Et(r2.x, 1, Cn - 1) << 3 | i2, Et(r2.y, 1, Cn - 1) << 3 | s2);
            }
            encodeBorderCentroid(t2) {
              if (!t2.borders) return new bt(0, 0);
              const e2 = t2.borders, r2 = Number.MAX_VALUE;
              if (e2[0][0] !== r2 || e2[1][0] !== r2) {
                const t3 = e2[0][0] !== r2 ? 0 : 1;
                return new bt(6 | (e2[0][0] !== r2 ? 0 : 65528), (e2[t3][0] + e2[t3][1]) / 2 << 3 | 6);
              }
              {
                const t3 = e2[2][0] !== r2 ? 2 : 3;
                return new bt((e2[t3][0] + e2[t3][1]) / 2 << 3 | 6, 6 | (e2[2][0] !== r2 ? 0 : 65528));
              }
            }
            showCentroid(t2) {
              const e2 = this.centroidData[t2.centroidDataIndex];
              e2.flags &= Zp, e2.centroidXY.x = 0, e2.centroidXY.y = 0, this.writeCentroidToBuffer(e2);
            }
            writeCentroidToBuffer(t2) {
              this.groundEffect.updateHiddenByLandmark(t2);
              const e2 = t2.vertexArrayOffset, r2 = t2.vertexCount + t2.vertexArrayOffset, n2 = t2.flags & Zp ? Xp : t2.centroidXY, i2 = this.centroidVertexArray.geta_centroid_pos0(e2);
              if (this.centroidVertexArray.geta_centroid_pos1(e2) !== n2.y || i2 !== n2.x) {
                for (let t3 = e2; t3 < r2; ++t3) this.centroidVertexArray.emplace(t3, n2.x, n2.y);
                this.needsCentroidUpdate = true;
              }
            }
            createCentroidsBuffer() {
              this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
              for (const t2 of this.centroidData) this.writeCentroidToBuffer(t2);
            }
            updateReplacement(t2, e2, r2) {
              if (e2.updateTime === this.replacementUpdateTime) return;
              this.replacementUpdateTime = e2.updateTime;
              const n2 = e2.getReplacementRegionsForTile(t2.toUnwrapped());
              if (Vp(this.activeReplacements, n2)) return;
              if (this.activeReplacements = n2, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
              else for (const t3 of this.centroidData) t3.flags &= 2147483647;
              const i2 = [];
              for (const e3 of this.activeReplacements) {
                if (e3.order < r2) continue;
                const n3 = Math.max(1, Math.pow(2, e3.footprintTileId.canonical.z - t2.canonical.z));
                for (const r3 of this.centroidData) if (!(r3.flags & Zp || e3.min.x > r3.max.x || r3.min.x > e3.max.x || e3.min.y > r3.max.y || r3.min.y > e3.max.y)) for (let s2 = 0; s2 < r3.footprintSegLen; s2++) {
                  const o2 = this.footprintSegments[r3.footprintSegIdx + s2];
                  if (i2.length = 0, gf(this.footprintVertices, o2.vertexOffset, o2.vertexCount, e3.footprintTileId.canonical, t2.canonical, i2), Dp(e3.footprint, i2, this.footprintIndices.uint16, o2.indexOffset, o2.indexCount, -o2.vertexOffset, -n3)) {
                    r3.flags |= Zp;
                    break;
                  }
                }
              }
              for (const t3 of this.centroidData) this.writeCentroidToBuffer(t3);
              this.borderDoneWithNeighborZ = [-1, -1, -1, -1];
            }
            footprintContainsPoint(t2, e2, r2) {
              let n2 = false;
              for (let i2 = 0; i2 < r2.footprintSegLen; i2++) {
                const s2 = this.footprintSegments[r2.footprintSegIdx + i2];
                let o2 = 0;
                for (const r3 of s2.ringIndices) {
                  for (let i3 = o2, a2 = r3 + o2 - 1; i3 < r3 + o2; a2 = i3++) {
                    const r4 = this.footprintVertices.int16[2 * (i3 + s2.vertexOffset) + 0], o3 = this.footprintVertices.int16[2 * (i3 + s2.vertexOffset) + 1], l2 = this.footprintVertices.int16[2 * (a2 + s2.vertexOffset) + 1];
                    o3 > e2 != l2 > e2 && t2 < (this.footprintVertices.int16[2 * (a2 + s2.vertexOffset) + 0] - r4) * (e2 - o3) / (l2 - o3) + r4 && (n2 = !n2);
                  }
                  o2 = r3;
                }
              }
              return n2;
            }
            getHeightAtTileCoord(t2, e2) {
              let r2 = Number.NEGATIVE_INFINITY, n2 = true;
              const i2 = 4 * (t2 + Cn) * Cn + (e2 + Cn);
              if (this.partLookup.hasOwnProperty(i2)) {
                const t3 = this.partLookup[i2];
                return t3 ? { height: t3.height, hidden: !!(t3.flags & Zp) } : void 0;
              }
              for (const s2 of this.centroidData) t2 > s2.max.x || s2.min.x > t2 || e2 > s2.max.y || s2.min.y > e2 || this.footprintContainsPoint(t2, e2, s2) && s2 && s2.height > r2 && (r2 = s2.height, this.partLookup[i2] = s2, n2 = !!(s2.flags & Zp));
              if (r2 !== Number.NEGATIVE_INFINITY) return { height: r2, hidden: n2 };
              this.partLookup[i2] = void 0;
            }
          }
          function lf(t2, e2) {
            const r2 = t2.add(e2)._unit();
            return t2.x * r2.x + t2.y * r2.y;
          }
          function uf(t2, e2, r2, n2) {
            const i2 = e2.sub(t2)._perp()._unit(), s2 = r2.sub(e2)._perp()._unit();
            return cf(t2, e2, r2, lf(i2, s2), n2);
          }
          function cf(t2, e2, r2, n2, i2) {
            const s2 = Math.sqrt(1 - n2 * n2);
            return Math.min(t2.dist(e2) / 3, e2.dist(r2) / 3, i2 * s2 / n2);
          }
          function hf(t2, e2, r2) {
            return t2.x < r2[0].x && e2.x < r2[0].x || t2.x > r2[1].x && e2.x > r2[1].x || t2.y < r2[0].y && e2.y < r2[0].y || t2.y > r2[1].y && e2.y > r2[1].y;
          }
          function pf(t2, e2) {
            return t2.x < e2[0].x || t2.x > e2[1].x || t2.y < e2[0].y || t2.y > e2[1].y;
          }
          function ff(t2, e2, r2) {
            if (t2.x < 0 || t2.x >= Cn || e2.x < 0 || e2.x >= Cn || r2.x < 0 || r2.x >= Cn) return false;
            const n2 = r2.sub(e2), i2 = n2.perp(), s2 = t2.sub(e2);
            return (n2.x * s2.x + n2.y * s2.y) / Math.sqrt((n2.x * n2.x + n2.y * n2.y) * (s2.x * s2.x + s2.y * s2.y)) > -0.866 && i2.x * s2.x + i2.y * s2.y < 0;
          }
          function df(t2, e2, r2) {
            const n2 = e2 ? 2 | t2 : -3 & t2;
            return r2 ? 1 | n2 : -2 & n2;
          }
          function mf() {
            const t2 = Math.PI / 32, e2 = Math.tan(t2), r2 = Gl;
            return r2 * Math.sqrt(1 + 2 * e2 * e2) - r2;
          }
          function yf(t2, e2, r2) {
            const n2 = 1 << r2.z, i2 = tu(r2.x / n2), s2 = tu((r2.x + 1) / n2), o2 = eu(r2.y / n2), a2 = eu((r2.y + 1) / n2);
            return function(t3, e3, r3, n3, i3 = 0, s3) {
              const o3 = [];
              if (!t3.length || !r3 || !n3) return o3;
              const a3 = (t4, e4) => {
                for (const r4 of t4) o3.push({ polygon: r4, bounds: e4 });
              }, l2 = Math.ceil(Math.log2(r3)), u2 = Math.ceil(Math.log2(n3)), c2 = l2 - u2, h3 = [];
              for (let t4 = 0; t4 < Math.abs(c2); t4++) h3.push(c2 > 0 ? 0 : 1);
              for (let t4 = 0; t4 < Math.min(l2, u2); t4++) h3.push(0), h3.push(1);
              let p3 = t3;
              if (p3 = ap(p3, e3[0].y - i3, e3[1].y + i3, 1), p3 = ap(p3, e3[0].x - i3, e3[1].x + i3, 0), !p3.length) return o3;
              const f2 = [];
              for (h3.length ? f2.push({ polygons: p3, bounds: e3, depth: 0 }) : a3(p3, e3); f2.length; ) {
                const t4 = f2.pop(), e4 = t4.depth, r4 = h3[e4], n4 = t4.bounds[0], o4 = t4.bounds[1], l3 = 0 === r4 ? n4.x : n4.y, u3 = 0 === r4 ? o4.x : o4.y, c3 = s3 ? s3(r4, l3, u3) : 0.5 * (l3 + u3), p4 = ap(t4.polygons, l3 - i3, c3 + i3, r4), d2 = ap(t4.polygons, c3 - i3, u3 + i3, r4);
                if (p4.length) {
                  const t5 = [n4, new bt(0 === r4 ? c3 : o4.x, 1 === r4 ? c3 : o4.y)];
                  h3.length > e4 + 1 ? f2.push({ polygons: p4, bounds: t5, depth: e4 + 1 }) : a3(p4, t5);
                }
                if (d2.length) {
                  const t5 = [new bt(0 === r4 ? c3 : n4.x, 1 === r4 ? c3 : n4.y), o4];
                  h3.length > e4 + 1 ? f2.push({ polygons: d2, bounds: t5, depth: e4 + 1 }) : a3(d2, t5);
                }
              }
              return o3;
            }(t2, e2, Math.ceil((s2 - i2) / 11.25), Math.ceil((o2 - a2) / 11.25), 1, (t3, e3, i3) => {
              if (0 === t3) return 0.5 * (e3 + i3);
              {
                const t4 = eu((r2.y + e3 / Cn) / n2);
                return (Jl(0.5 * (eu((r2.y + i3 / Cn) / n2) + t4)) * n2 - r2.y) * Cn;
              }
            });
          }
          function gf(t2, e2, r2, n2, i2, s2) {
            const o2 = Math.pow(2, n2.z - i2.z);
            for (let a2 = 0; a2 < r2; a2++) {
              let r3 = t2.int16[2 * (a2 + e2) + 0], l2 = t2.int16[2 * (a2 + e2) + 1];
              r3 = (r3 + i2.x * Cn) * o2 - n2.x * Cn, l2 = (l2 + i2.y * Cn) * o2 - n2.y * Cn, s2.push(new bt(r3, l2));
            }
          }
          let xf, vf;
          qs(af, "FillExtrusionBucket", { omit: ["layers", "features"] }), qs(tf, "PartData"), qs(Qp, "FootprintSegment"), qs(ef, "BorderCentroidData"), qs(of, "GroundEffect");
          class bf extends bt {
            constructor(t2, e2, r2) {
              super(t2, e2), this.z = r2;
            }
          }
          class wf extends bf {
            constructor(t2, e2, r2, n2) {
              super(t2, e2, r2), this.w = n2;
            }
          }
          function _f(t2, e2, r2, n2) {
            const i2 = "x" === r2 ? "y" : "x", s2 = (n2 - t2[r2]) / (e2[r2] - t2[r2]);
            t2[i2] = Math.round(t2[i2] + (e2[i2] - t2[i2]) * s2), t2[r2] = n2, t2.hasOwnProperty("z") && (t2.z = ur(t2.z, e2.z, s2)), t2.hasOwnProperty("w") && (t2.w = ur(t2.w, e2.w, s2));
          }
          function Af(t2, e2, r2, n2) {
            const i2 = r2, s2 = n2;
            for (const r3 of ["x", "y"]) {
              let n3 = t2, o2 = e2;
              n3[r3] >= o2[r3] && (n3 = e2, o2 = t2), n3[r3] < i2 && o2[r3] > i2 && _f(n3, o2, r3, i2), n3[r3] < s2 && o2[r3] > s2 && _f(o2, n3, r3, s2);
            }
          }
          function Mf(t2, e2, r2, n2, i2, s2) {
            const o2 = [];
            for (let a2 = 0; a2 < t2.length; a2++) {
              const l2 = t2[a2];
              let u2;
              const c2 = o2.length;
              let h3 = 0;
              for (let t3 = 0; t3 < l2.length - 1; t3++) {
                let c3 = l2[t3], p3 = l2[t3 + 1], f2 = 0;
                const d2 = h3;
                let m2, y2;
                s2 && (f2 = Math.hypot(p3.x - c3.x, p3.y - c3.y), h3 += f2, m2 = c3, y2 = p3), c3.x < e2 && p3.x < e2 || (c3.x < e2 ? c3 = new bt(e2, c3.y + (e2 - c3.x) / (p3.x - c3.x) * (p3.y - c3.y))._round() : p3.x < e2 && (p3 = new bt(e2, c3.y + (e2 - c3.x) / (p3.x - c3.x) * (p3.y - c3.y))._round()), c3.y < r2 && p3.y < r2 || (c3.y < r2 ? c3 = new bt(c3.x + (r2 - c3.y) / (p3.y - c3.y) * (p3.x - c3.x), r2)._round() : p3.y < r2 && (p3 = new bt(c3.x + (r2 - c3.y) / (p3.y - c3.y) * (p3.x - c3.x), r2)._round()), c3.x >= n2 && p3.x >= n2 || (c3.x >= n2 ? c3 = new bt(n2, c3.y + (n2 - c3.x) / (p3.x - c3.x) * (p3.y - c3.y))._round() : p3.x >= n2 && (p3 = new bt(n2, c3.y + (n2 - c3.x) / (p3.x - c3.x) * (p3.y - c3.y))._round()), c3.y >= i2 && p3.y >= i2 || (c3.y >= i2 ? c3 = new bt(c3.x + (i2 - c3.y) / (p3.y - c3.y) * (p3.x - c3.x), i2)._round() : p3.y >= i2 && (p3 = new bt(c3.x + (i2 - c3.y) / (p3.y - c3.y) * (p3.x - c3.x), i2)._round()), u2 && c3.equals(u2[u2.length - 1]) || (u2 = [c3], o2.push(u2), s2 && s2.push({ progress: { min: d2 + Sf(m2, y2, c3) * f2, max: 1 }, parentIndex: a2, prevPoint: m2, nextPoint: y2 })), u2.push(p3), s2 && (s2[s2.length - 1].progress.max = d2 + Sf(m2, y2, p3) * f2, s2[s2.length - 1].nextPoint = y2)))));
              }
              if (s2 && h3 > 0) for (let t3 = c2; t3 < o2.length; t3++) s2[t3].progress.min /= h3, s2[t3].progress.max /= h3;
            }
            return o2;
          }
          function If(t2, e2, r2, n2, i2) {
            if (t2.length < 2) return void n2.push(t2);
            const s2 = [];
            for (; e2.valid(); ) {
              const [r3, n3] = e2.get();
              for (let e3 = 0; e3 < t2.length - 1; e3++) {
                const i3 = t2[e3], o3 = t2[e3 + 1], a3 = ic(i3, o3, r3, n3);
                if (a3) {
                  const [t3] = a3, r4 = new bt(ur(i3.x, o3.x, t3), ur(i3.y, o3.y, t3));
                  s2.push({ t: e3 + t3, distance: 0, point: r4 });
                }
              }
              e2.next();
            }
            if (0 === s2.length) return void n2.push(t2);
            s2.sort((t3, e3) => t3.t - e3.t);
            let o2 = 0, a2 = 0, l2 = [];
            for (n2.push(l2); o2 !== t2.length; ) {
              if (a2 === s2.length) {
                for (; o2 !== t2.length; ) 0 !== l2.length && l2[l2.length - 1].equals(t2[o2]) || l2.push(t2[o2]), o2++;
                break;
              }
              s2[a2].t <= o2 ? (0 !== l2.length && l2[l2.length - 1].equals(s2[a2].point) || l2.push(s2[a2].point), Math.trunc(s2[a2].t), a2++) : (0 !== l2.length && l2[l2.length - 1].equals(t2[o2]) || l2.push(t2[o2]), o2++);
            }
          }
          function Sf(t2, e2, r2) {
            return t2.x !== e2.x ? (r2.x - t2.x) / (e2.x - t2.x) : t2.y !== e2.y ? (r2.y - t2.y) / (e2.y - t2.y) : 0;
          }
          function zf(t2, e2) {
            return t2.x * e2.x + t2.y * e2.y;
          }
          function kf(t2, e2) {
            if (1 === t2.length) {
              let r2 = 0;
              const n2 = e2[r2++];
              let i2;
              for (; !i2 || n2.equals(i2); ) if (i2 = e2[r2++], !i2) return 1 / 0;
              for (; r2 < e2.length; r2++) {
                const s2 = e2[r2], o2 = t2[0], a2 = i2.sub(n2), l2 = s2.sub(n2), u2 = o2.sub(n2), c2 = zf(a2, a2), h3 = zf(a2, l2), p3 = zf(l2, l2), f2 = zf(u2, a2), d2 = zf(u2, l2), m2 = c2 * p3 - h3 * h3, y2 = (p3 * f2 - h3 * d2) / m2, g2 = (c2 * d2 - h3 * f2) / m2, x2 = n2.z * (1 - y2 - g2) + i2.z * y2 + s2.z * g2;
                if (isFinite(x2)) return x2;
              }
              return 1 / 0;
            }
            {
              let t3 = 1 / 0;
              for (const r2 of e2) t3 = Math.min(t3, r2.z);
              return t3;
            }
          }
          function Pf(t2, e2, r2, n2, i2, s2, o2, a2) {
            const l2 = o2 * i2.getElevationAt(t2, e2, true, true), u2 = 0 !== s2[0], c2 = u2 ? 0 === s2[1] ? o2 * (s2[0] / 7 - 450) : o2 * function(t3, e3, r3) {
              const n3 = Math.floor(e3[0] / 8), i3 = Math.floor(e3[1] / 8), s3 = 10 * (e3[0] - 8 * n3), o3 = 10 * (e3[1] - 8 * i3), a3 = t3.getElevationAt(n3, i3, true, true), l3 = t3.getMeterToDEM(r3), u3 = Math.floor(0.5 * (s3 * l3 - 1)), c3 = Math.floor(0.5 * (o3 * l3 - 1)), h3 = t3.tileCoordToPixel(n3, i3), p3 = 2 * u3 + 1, f2 = 2 * c3 + 1, d2 = function(t4, e4, r4, n4, i4) {
                return [t4.getElevationAtPixel(e4, r4, true), t4.getElevationAtPixel(e4 + i4, r4, true), t4.getElevationAtPixel(e4, r4 + i4, true), t4.getElevationAtPixel(e4 + n4, r4 + i4, true)];
              }(t3, h3.x - u3, h3.y - c3, p3, f2), m2 = Math.abs(d2[0] - d2[1]), y2 = Math.abs(d2[2] - d2[3]), g2 = Math.abs(d2[0] - d2[2]) + Math.abs(d2[1] - d2[3]), x2 = Math.min(0.25, 0.5 * l3 * (m2 + y2) / p3), v2 = Math.min(0.25, 0.5 * l3 * g2 / f2);
              return a3 + Math.max(x2 * s3, v2 * o3);
            }(i2, s2, a2) : l2;
            return { base: l2 + (0 === r2 ? -1 : r2), top: u2 ? Math.max(c2 + n2, l2 + r2 + 2) : l2 + n2 };
          }
          class Ef {
            constructor(t2) {
              this._callback = t2, this._triggered = false, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel(), this._channel.port2.onmessage = () => {
                this._triggered = false, this._callback();
              });
            }
            trigger() {
              this._triggered || (this._triggered = true, this._channel ? this._channel.port1.postMessage(true) : setTimeout(() => {
                this._triggered = false, this._callback();
              }, 0));
            }
            remove() {
              this._channel = void 0, this._callback = () => {
              };
            }
          }
          class Tf {
            constructor() {
              this.tasks = {}, this.taskQueue = [], Rt(["process"], this), this.invoker = new Ef(this.process), this.nextId = 0;
            }
            add(t2, e2) {
              const r2 = this.nextId++, n2 = function({ type: t3, isSymbolTile: e3, zoom: r3 }) {
                return r3 = r3 || 0, "message" === t3 ? 0 : "maybePrepare" !== t3 || e3 ? "parseTile" !== t3 || e3 ? "parseTile" === t3 && e3 ? 300 - r3 : "maybePrepare" === t3 && e3 ? 400 - r3 : 500 : 200 - r3 : 100 - r3;
              }(e2);
              if (0 === n2) {
                try {
                  t2();
                } finally {
                }
                return null;
              }
              return this.tasks[r2] = { fn: t2, metadata: e2, priority: n2, id: r2 }, this.taskQueue.push(r2), this.invoker.trigger(), { cancel: () => {
                delete this.tasks[r2];
              } };
            }
            process() {
              try {
                if (this.taskQueue = this.taskQueue.filter((t3) => !!this.tasks[t3]), !this.taskQueue.length) return;
                const t2 = this.pick();
                if (null === t2) return;
                const e2 = this.tasks[t2];
                if (delete this.tasks[t2], this.taskQueue.length && this.invoker.trigger(), !e2) return;
                e2.fn();
              } finally {
              }
            }
            pick() {
              let t2 = null, e2 = 1 / 0;
              for (let r3 = 0; r3 < this.taskQueue.length; r3++) {
                const n2 = this.tasks[this.taskQueue[r3]];
                n2.priority < e2 && (e2 = n2.priority, t2 = r3);
              }
              if (null === t2) return null;
              const r2 = this.taskQueue[t2];
              return this.taskQueue.splice(t2, 1), r2;
            }
            remove() {
              this.invoker.remove();
            }
          }
          class Bf {
            constructor(t2, e2, r2) {
              this.target = t2, this.parent = e2, this.mapId = r2, this.callbacks = {}, this.cancelCallbacks = {}, Rt(["receive"], this), this.target.addEventListener("message", this.receive, false), this.scheduler = new Tf();
            }
            send(t2, e2, r2, n2, i2 = false, s2) {
              const o2 = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
              r2 && (r2.metadata = s2, this.callbacks[o2] = r2);
              const a2 = /* @__PURE__ */ new Set();
              return this.target.postMessage({ id: o2, type: t2, hasCallback: !!r2, targetMapId: n2, mustQueue: i2, sourceMapId: this.mapId, data: Zs(e2, a2) }, a2), { cancel: () => {
                r2 && delete this.callbacks[o2], this.target.postMessage({ id: o2, type: "<cancel>", targetMapId: n2, sourceMapId: this.mapId });
              } };
            }
            receive(t2) {
              const e2 = t2.data;
              if (!e2) return;
              const r2 = e2.id;
              if (r2 && (!e2.targetMapId || this.mapId === e2.targetMapId)) if ("<cancel>" === e2.type) {
                const t3 = this.cancelCallbacks[r2];
                delete this.cancelCallbacks[r2], t3 && t3.cancel();
              } else if (e2.mustQueue || Zt(self)) {
                const t3 = this.callbacks[r2], n2 = this.scheduler.add(() => this.processTask(r2, e2), t3 && t3.metadata || { type: "message" });
                n2 && (this.cancelCallbacks[r2] = n2);
              } else this.processTask(r2, e2);
            }
            processTask(t2, e2) {
              if (delete this.cancelCallbacks[t2], "<response>" === e2.type) {
                const r2 = this.callbacks[t2];
                delete this.callbacks[t2], r2 && (e2.error ? r2(Ws(e2.error)) : r2(null, Ws(e2.data)));
              } else {
                const r2 = /* @__PURE__ */ new Set(), n2 = e2.hasCallback ? (e3, n3) => {
                  this.target.postMessage({ id: t2, type: "<response>", sourceMapId: this.mapId, error: e3 ? Zs(e3) : null, data: Zs(n3, r2) }, r2);
                } : () => {
                }, i2 = Ws(e2.data);
                if (this.parent[e2.type]) this.parent[e2.type](e2.sourceMapId, i2, n2);
                else if (this.parent.getWorkerSource) {
                  const t3 = e2.type.split("."), { source: r3, scope: s2 } = i2;
                  this.parent.getWorkerSource(e2.sourceMapId, t3[0], r3, s2)[t3[1]](i2, n2);
                } else n2(new Error(`Could not find function ${e2.type}`));
              }
            }
            remove() {
              this.scheduler.remove(), this.target.removeEventListener("message", this.receive, false);
            }
          }
          var Vf = { workerUrl: "", workerClass: null, workerParams: void 0 };
          const Cf = "mapboxgl_preloaded_worker_pool";
          class Ff {
            constructor() {
              this.active = {};
            }
            acquire(t2, e2 = Ff.workerCount) {
              if (!this.workers) for (this.workers = []; this.workers.length < e2; ) this.workers.push(null != Vf.workerClass ? new Vf.workerClass() : new self.Worker(Vf.workerUrl, Vf.workerParams));
              return this.active[t2] = true, this.workers.slice();
            }
            release(t2) {
              delete this.active[t2], this.workers && 0 === this.numActive() && (this.workers.forEach((t3) => {
                t3.terminate();
              }), this.workers = null);
            }
            isPreloaded() {
              return !!this.active[Cf];
            }
            numActive() {
              return Object.keys(this.active).length;
            }
          }
          Ff.workerCount = 2;
          class Df {
            constructor(t2, e2, r2 = "Worker", n2 = Ff.workerCount) {
              this.workerPool = t2, this.actors = [], this.currentActor = 0, this.id = Dt();
              const i2 = this.workerPool.acquire(this.id, n2);
              for (let t3 = 0; t3 < i2.length; t3++) {
                const n3 = new Df.Actor(i2[t3], e2, this.id);
                n3.name = `${r2} ${t3}`, this.actors.push(n3);
              }
              this.ready = false, this.broadcast("checkIfReady", null, () => {
                this.ready = true;
              });
            }
            broadcast(t2, e2, r2) {
              Vt(this.actors, (r3, n2) => {
                r3.send(t2, e2, n2);
              }, r2 = r2 || function() {
              });
            }
            getActor() {
              return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
              this.actors.forEach((t2) => {
                t2.remove();
              }), this.actors = [], this.workerPool.release(this.id);
            }
          }
          let Lf, Rf;
          function Of() {
            return Lf || (Lf = new Ff()), Lf;
          }
          Df.Actor = Bf;
          class Uf {
            constructor(t2) {
              this.module = t2;
            }
            createIntArray(t2) {
              const e2 = new Int32Array(t2), r2 = this.module.malloc(e2.length * e2.BYTES_PER_ELEMENT);
              return this.module.heap32.set(e2, r2 / e2.BYTES_PER_ELEMENT), r2;
            }
            createFloatArray(t2) {
              const e2 = new Float32Array(t2), r2 = this.module.malloc(e2.length * e2.BYTES_PER_ELEMENT);
              return this.module.heapF32.set(e2, r2 / e2.BYTES_PER_ELEMENT), r2;
            }
            createStringBuffer(t2) {
              const e2 = this.module.malloc(t2.length + 1);
              for (let r2 = 0; r2 < t2.length; ++r2) this.module.heapU8[e2 + r2] = t2.charCodeAt(r2);
              return this.module.heapU8[e2 + t2.length] = 0, e2;
            }
            readStringBuffer(t2) {
              let e2 = "";
              for (; 0 !== this.module.heapU8[t2]; ) e2 += String.fromCharCode(this.module.heapU8[t2]), ++t2;
              return e2;
            }
            setStyle(t2) {
              const e2 = t2.entranceColorRgb, r2 = t2.facadeGlazingColorRgb, n2 = t2.roofColorRgb, i2 = t2.wallColorRgb, s2 = t2.normalScale;
              this.module.setStyle(e2[0], e2[1], e2[2], r2[0], r2[1], r2[2], n2[0], n2[1], n2[2], i2[0], i2[1], i2[2], s2[0], s2[1], s2[2], t2.tileToMeters);
            }
            setAOOptions(t2, e2) {
              this.module.setAOOptions(t2 ? 1 : 0, e2);
            }
            setMetricOptions(t2, e2) {
              this.module.setMetricOptions(t2 ? 1 : 0, e2);
            }
            setFacadeOptions(t2, e2, r2) {
              this.module.setFacadeOptions(t2, e2, r2);
            }
            generateMesh(t2, e2) {
              for (const e3 of t2) {
                const t3 = this.createStringBuffer(e3.roofType), r3 = [0], n3 = [];
                for (const t4 of e3.coordinates) if (Array.isArray(t4)) {
                  for (const e4 of t4) n3.push(e4.x), n3.push(e4.y);
                  r3.push(n3.length);
                }
                const i3 = this.createIntArray(r3), s3 = this.createFloatArray(n3);
                this.module.addFeature(e3.id, e3.sourceId, e3.minHeight, e3.height, t3, e3.roofType.length, s3, i3, r3.length - 1), this.module.free(t3), this.module.free(i3), this.module.free(s3);
              }
              for (const t3 of e2) {
                let e3;
                e3 = t3.entrances ? JSON.parse(t3.entrances) : [];
                const r3 = this.createFloatArray(e3), n3 = [];
                for (const e4 of t3.coordinates) n3.push(e4.x), n3.push(e4.y);
                const i3 = this.createFloatArray(n3);
                this.module.addFacade(t3.sourceId, t3.crossPerc, t3.distanceToRoad, r3, e3.length, i3, n3.length), this.module.free(r3), this.module.free(i3);
              }
              if (!this.module.generateMesh()) {
                const t3 = this.module.getLastError();
                return this.readStringBuffer(t3);
              }
              const r2 = this.module.getMeshCount(), n2 = new Array(r2);
              for (let t3 = 0; t3 < r2; t3++) {
                const e3 = this.module.getPositionsPtr(t3), r3 = this.module.getPositionsLength(t3), i3 = new Float32Array(this.module.heapF32.buffer, e3, r3), s3 = this.module.getNormalsPtr(t3), o2 = this.module.getNormalsLength(t3), a2 = new Float32Array(this.module.heapF32.buffer, s3, o2), l2 = this.module.getColorsPtr(t3), u2 = this.module.getColorsLength(t3), c2 = new Uint8Array(this.module.heapU8.buffer, l2, u2), h3 = this.module.getAOPtr(t3), p3 = this.module.getAOLength(t3), f2 = new Float32Array(this.module.heapF32.buffer, h3, p3), d2 = this.module.getIndicesPtr(t3), m2 = this.module.getIndicesLength(t3), y2 = new Int32Array(this.module.heap32.buffer, d2, m2), g2 = this.module.getBuildingPart(t3), x2 = this.readStringBuffer(g2);
                n2[t3] = { positions: i3, normals: a2, colors: c2, ao: f2, indices: y2, buildingPart: x2 };
              }
              const i2 = this.module.getRingCount(), s2 = [];
              for (let t3 = 0; t3 < i2; t3++) {
                const e3 = this.module.getRingPtr(t3), r3 = this.module.getRingLength(t3), n3 = new Float32Array(this.module.heapF32.buffer, e3, r3);
                s2.push(n3);
              }
              return { meshes: n2, modifiedPolygonRings: s2 };
            }
          }
          let Nf, jf, $f, Gf, qf, Hf = null, Xf = null, Zf = null, Wf = null;
          function Yf() {
            return Zt(self) && self.worker.dracoUrl ? self.worker.dracoUrl : jf || ne.DRACO_URL;
          }
          function Kf() {
            if (Zt(self) && self.worker.meshoptUrl) return self.worker.meshoptUrl;
            if (Gf) return Gf;
            const t2 = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 3, 2, 0, 0, 5, 3, 1, 0, 1, 12, 1, 0, 10, 22, 2, 12, 0, 65, 0, 65, 0, 65, 0, 252, 10, 0, 0, 11, 7, 0, 65, 0, 253, 15, 26, 11]);
            if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
            return Gf = WebAssembly.validate(t2) ? ne.MESHOPT_SIMD_URL : ne.MESHOPT_URL, Gf;
          }
          const Jf = { 5120: Int8Array, 5121: Uint8Array, 5122: Int16Array, 5123: Uint16Array, 5125: Uint32Array, 5126: Float32Array }, Qf = { 5120: "DT_INT8", 5121: "DT_UINT8", 5122: "DT_INT16", 5123: "DT_UINT16", 5125: "DT_UINT32", 5126: "DT_FLOAT32" }, td = { SCALAR: 1, VEC2: 2, VEC3: 3, VEC4: 4, MAT2: 4, MAT3: 9, MAT4: 16 };
          function ed(t2, e2, r2) {
            const n2 = r2.json.bufferViews.length, i2 = r2.buffers.length;
            e2.bufferView = n2, r2.json.bufferViews[n2] = { buffer: i2, byteLength: t2.byteLength }, r2.buffers[i2] = t2;
          }
          const rd = "KHR_draco_mesh_compression";
          function nd(t2, e2) {
            const r2 = t2.extensions && t2.extensions[rd];
            if (!r2) return;
            const n2 = new $f.Decoder(), i2 = cd(e2, r2.bufferView), s2 = new $f.Mesh();
            if (!n2.DecodeArrayToMesh(i2, i2.byteLength, s2)) throw new Error("Failed to decode Draco mesh");
            const o2 = e2.json.accessors[t2.indices], a2 = Jf[o2.componentType], l2 = o2.count * a2.BYTES_PER_ELEMENT, u2 = $f._malloc(l2);
            a2 === Uint16Array ? n2.GetTrianglesUInt16Array(s2, l2, u2) : n2.GetTrianglesUInt32Array(s2, l2, u2), ed($f.memory.buffer.slice(u2, u2 + l2), o2, e2), $f._free(u2);
            for (const i3 of Object.keys(r2.attributes)) {
              const o3 = n2.GetAttributeByUniqueId(s2, r2.attributes[i3]), a3 = e2.json.accessors[t2.attributes[i3]], l3 = Qf[a3.componentType], u3 = a3.count * td[a3.type] * Jf[a3.componentType].BYTES_PER_ELEMENT, c2 = $f._malloc(u3);
              n2.GetAttributeDataArrayForAllPoints(s2, o3, $f[l3], u3, c2), ed($f.memory.buffer.slice(c2, c2 + u3), a3, e2), $f._free(c2);
            }
            n2.destroy(), s2.destroy(), delete t2.extensions[rd];
          }
          const id = "EXT_meshopt_compression";
          function sd(t2, e2) {
            if (!t2.extensions || !t2.extensions[id]) return;
            const r2 = t2.extensions[id], n2 = new Uint8Array(e2.buffers[r2.buffer], r2.byteOffset || 0, r2.byteLength || 0), i2 = new Uint8Array(r2.count * r2.byteStride);
            qf.decodeGltfBuffer(i2, r2.count, r2.byteStride, n2, r2.mode, r2.filter), t2.buffer = e2.buffers.length, t2.byteOffset = 0, e2.buffers[t2.buffer] = i2.buffer, delete t2.extensions[id];
          }
          const od = 1179937895, ad = new TextDecoder("utf8");
          function ld(t2, e2) {
            return new URL(t2, e2).href;
          }
          function ud(t2, e2, r2, n2) {
            return fetch(ld(t2.uri, n2)).then((t3) => t3.arrayBuffer()).then((t3) => {
              e2.buffers[r2] = t3;
            });
          }
          function cd(t2, e2) {
            const r2 = t2.json.bufferViews[e2];
            return new Uint8Array(t2.buffers[r2.buffer], r2.byteOffset || 0, r2.byteLength);
          }
          function hd(t2, e2, r2, n2) {
            if (t2.uri) {
              const i2 = ld(t2.uri, n2);
              return fetch(i2).then((t3) => t3.blob()).then((t3) => createImageBitmap(t3)).then((t3) => {
                e2.images[r2] = t3;
              });
            }
            if (void 0 !== t2.bufferView) {
              const n3 = cd(e2, t2.bufferView), i2 = new Blob([n3], { type: t2.mimeType });
              return createImageBitmap(i2).then((t3) => {
                e2.images[r2] = t3;
              });
            }
          }
          function pd(t2, e2 = 0, r2) {
            const n2 = { json: null, images: [], buffers: [] };
            if (new Uint32Array(t2, e2, 1)[0] === od) {
              const r3 = new Uint32Array(t2, e2);
              let i3 = 2;
              const s3 = (r3[i3++] >> 2) - 3, o3 = r3[i3++] >> 2;
              if (i3++, n2.json = JSON.parse(ad.decode(r3.subarray(i3, i3 + o3))), i3 += o3, i3 < s3) {
                const s4 = r3[i3++];
                i3++;
                const o4 = e2 + (i3 << 2);
                n2.buffers[0] = t2.slice(o4, o4 + s4);
              }
            } else n2.json = JSON.parse(ad.decode(new Uint8Array(t2, e2)));
            const { buffers: i2, images: s2, meshes: o2, extensionsUsed: a2, bufferViews: l2 } = n2.json;
            let u2 = Promise.resolve();
            if (i2) {
              const t3 = [];
              for (let e3 = 0; e3 < i2.length; e3++) {
                const s3 = i2[e3];
                s3.uri ? t3.push(ud(s3, n2, e3, r2)) : n2.buffers[e3] || (n2.buffers[e3] = null);
              }
              u2 = Promise.all(t3);
            }
            return u2.then(() => {
              const t3 = [], e3 = a2 && a2.includes(rd), i3 = a2 && a2.includes(id);
              if (e3 && t3.push(function() {
                if (!$f) return null != Nf ? Nf : (Nf = function(t4) {
                  let e4, r3 = null;
                  function n3() {
                    e4 = new Uint8Array(r3.buffer);
                  }
                  function i4() {
                    throw new Error("Unexpected Draco error.");
                  }
                  const s3 = { a: { a: i4, d: function(t5, r4, n4) {
                    return e4.copyWithin(t5, r4, r4 + n4);
                  }, c: function(t5) {
                    const i5 = e4.length, s4 = Math.max(t5 >>> 0, Math.ceil(1.2 * i5)), o3 = Math.ceil((s4 - i5) / 65536);
                    try {
                      return r3.grow(o3), n3(), true;
                    } catch (t6) {
                      return false;
                    }
                  }, b: i4 } };
                  return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(t4, s3) : t4.then((t5) => t5.arrayBuffer()).then((t5) => WebAssembly.instantiate(t5, s3))).then((t5) => {
                    const { Rb: i5, Qb: s4, P: o3, T: a3, X: l3, Ja: u3, La: c2, Qa: h3, Va: p3, Wa: f2, eb: d2, jb: m2, f: y2, e: g2, yb: x2, zb: v2, Ab: b2, Bb: w2, Db: _2, Gb: A2 } = t5.instance.exports;
                    r3 = g2;
                    const M2 = /* @__PURE__ */ (() => {
                      let t6 = 0, r4 = 0, n4 = 0, o4 = 0;
                      return (a4) => {
                        n4 && (i5(o4), i5(t6), r4 += n4, n4 = t6 = 0), t6 || (r4 += 128, t6 = s4(r4));
                        const l4 = a4.length + 7 & -8;
                        let u4 = t6;
                        l4 >= r4 && (n4 = l4, u4 = o4 = s4(l4));
                        for (let t7 = 0; t7 < a4.length; t7++) e4[u4 + t7] = a4[t7];
                        return u4;
                      };
                    })();
                    return n3(), y2(), { memory: g2, _free: i5, _malloc: s4, Mesh: class {
                      constructor() {
                        this.ptr = o3();
                      }
                      destroy() {
                        a3(this.ptr);
                      }
                    }, Decoder: class {
                      constructor() {
                        this.ptr = u3();
                      }
                      destroy() {
                        m2(this.ptr);
                      }
                      DecodeArrayToMesh(t6, e5, r4) {
                        const n4 = M2(t6), i6 = c2(this.ptr, n4, e5, r4.ptr);
                        return !!l3(i6);
                      }
                      GetAttributeByUniqueId(t6, e5) {
                        return { ptr: h3(this.ptr, t6.ptr, e5) };
                      }
                      GetTrianglesUInt16Array(t6, e5, r4) {
                        p3(this.ptr, t6.ptr, e5, r4);
                      }
                      GetTrianglesUInt32Array(t6, e5, r4) {
                        f2(this.ptr, t6.ptr, e5, r4);
                      }
                      GetAttributeDataArrayForAllPoints(t6, e5, r4, n4, i6) {
                        d2(this.ptr, t6.ptr, e5.ptr, r4, n4, i6);
                      }
                    }, DT_INT8: x2(), DT_UINT8: v2(), DT_INT16: b2(), DT_UINT16: w2(), DT_UINT32: _2(), DT_FLOAT32: A2() };
                  });
                }(fetch(Yf())), Nf.then((t4) => {
                  $f = t4, Nf = void 0;
                }));
              }()), i3 && t3.push(function() {
                if (qf) return;
                const t4 = function(t5) {
                  let e4;
                  const r3 = WebAssembly.instantiateStreaming(t5, {}).then((t6) => {
                    e4 = t6.instance, e4.exports.__wasm_call_ctors();
                  }), n3 = { NONE: "", OCTAHEDRAL: "meshopt_decodeFilterOct", QUATERNION: "meshopt_decodeFilterQuat", EXPONENTIAL: "meshopt_decodeFilterExp" }, i4 = { ATTRIBUTES: "meshopt_decodeVertexBuffer", TRIANGLES: "meshopt_decodeIndexBuffer", INDICES: "meshopt_decodeIndexSequence" };
                  return { ready: r3, supported: true, decodeGltfBuffer(t6, r4, s3, o3, a3, l3) {
                    !function(t7, e5, r5, n4, i5, s4, o4) {
                      const a4 = t7.exports.sbrk, l4 = n4 + 3 & -4, u3 = a4(l4 * i5), c2 = a4(s4.length), h3 = new Uint8Array(t7.exports.memory.buffer);
                      h3.set(s4, c2);
                      const p3 = e5(u3, n4, i5, c2, s4.length);
                      if (0 === p3 && o4 && o4(u3, l4, i5), r5.set(h3.subarray(u3, u3 + n4 * i5)), a4(u3 - a4(0)), 0 !== p3) throw new Error(`Malformed buffer data: ${p3}`);
                    }(e4, e4.exports[i4[a3]], t6, r4, s3, o3, e4.exports[n3[l3]]);
                  } };
                }(fetch(Kf()));
                return t4.ready.then(() => {
                  qf = t4;
                });
              }()), s2) for (let e4 = 0; e4 < s2.length; e4++) t3.push(hd(s2[e4], n2, e4, r2));
              return (t3.length ? Promise.all(t3) : Promise.resolve()).then(() => {
                if (e3 && o2) for (const { primitives: t4 } of o2) for (const e4 of t4) nd(e4, n2);
                if (i3 && o2 && l2) for (const t4 of l2) sd(t4, n2);
                return n2;
              });
            });
          }
          class fd {
            constructor(t2) {
              this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.hasPattern = false, this.worldview = t2.worldview;
            }
            updateFootprints(t2, e2) {
            }
            prepare() {
              return function() {
                if (null != Wf || null != Zf) return null;
                if (null != Xf) return Xf;
                const t2 = fetch(ne.BUILDING_GEN_URL);
                return Xf = function(t3) {
                  let e2, r2, n2, i2;
                  function s2() {
                    e2 = new Uint8Array(i2.buffer), r2 = new Int32Array(i2.buffer), n2 = new Float32Array(i2.buffer);
                  }
                  function o2() {
                    throw new Error("Unexpected BuildingGen error.");
                  }
                  const a2 = () => {
                  }, l2 = { a: { a: o2, f: function(t4) {
                    const r3 = e2.length, n3 = Math.max(t4 >>> 0, Math.ceil(1.2 * r3)), o3 = Math.ceil((n3 - r3) / 65536);
                    try {
                      return i2.grow(o3), s2(), true;
                    } catch (t5) {
                      return false;
                    }
                  }, g: o2, b: a2, c: a2, d: a2, e: a2 } };
                  return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(t3, l2) : t3.then((t4) => t4.arrayBuffer()).then((t4) => WebAssembly.instantiate(t4, l2))).then((t4) => {
                    const o3 = t4.instance.exports;
                    return (0, o3.g)(), i2 = o3.f, s2(), new Uf({ setStyle: o3.h, setAOOptions: o3.i, setMetricOptions: o3.j, setFacadeOptions: o3.k, addFeature: o3.l, addFacade: o3.m, generateMesh: o3.n, getLastError: o3.o, getMeshCount: o3.p, getPositionsPtr: o3.q, getPositionsLength: o3.r, getNormalsPtr: o3.s, getNormalsLength: o3.t, getColorsPtr: o3.u, getColorsLength: o3.v, getAOPtr: o3.w, getAOLength: o3.x, getIndicesPtr: o3.y, getIndicesLength: o3.z, getBuildingPart: o3.A, getRingCount: o3.B, getRingPtr: o3.C, getRingLength: o3.D, free: o3.E, malloc: o3.F, heapU8: e2, heap32: r2, heapF32: n2 });
                  });
                }(t2).then((t3) => (Xf = null, Wf = t3, Wf)).catch((t3) => {
                  Gt("Could not load building-gen"), Xf = null, Zf = t3;
                }), Xf;
              }();
            }
            populate(t2, e2, r2, n2) {
            }
            update(t2, e2, r2, n2, i2, s2, o2) {
            }
            isEmpty() {
              return false;
            }
            uploadPending() {
              return false;
            }
            upload(t2) {
            }
            destroy() {
            }
            getHeightAtTileCoord(t2, e2) {
              return { height: Number.NEGATIVE_INFINITY, hidden: true };
            }
          }
          let dd, md;
          qs(fd, "BuildingBucket", { omit: ["layers"] });
          const yd = ta([{ name: "a_pos_normal", components: 2, type: "Int16" }, { name: "a_data", components: 4, type: "Uint8" }, { name: "a_linesofar", components: 1, type: "Float32" }], 4), gd = ta([{ name: "a_z_offset_width", components: 3, type: "Float32" }], 4), { members: xd } = yd, vd = ta([{ name: "a_packed", components: 3, type: "Float32" }]), { members: bd } = vd, wd = ta([{ name: "a_pattern_data", components: 3, type: "Float32" }]), { members: _d } = wd;
          class Ad {
            constructor(t2, e2) {
              this.width = t2, this.height = e2, this.nextRow = 0, this.image = new mh({ width: t2, height: e2 }), this.positions = {}, this.uploaded = false;
            }
            getDash(t2, e2) {
              const r2 = this.getKey(t2, e2);
              return this.positions[r2];
            }
            trim() {
              const t2 = this.width, e2 = this.height = Lt(this.nextRow);
              this.image.resize({ width: t2, height: e2 });
            }
            getKey(t2, e2) {
              return t2.join(",") + e2;
            }
            getDashRanges(t2, e2, r2) {
              const n2 = [];
              let i2 = t2.length % 2 == 1 ? -t2[t2.length - 1] * r2 : 0, s2 = t2[0] * r2, o2 = true;
              n2.push({ left: i2, right: s2, isDash: o2, zeroLength: 0 === t2[0] });
              let a2 = t2[0];
              for (let e3 = 1; e3 < t2.length; e3++) {
                o2 = !o2;
                const l2 = t2[e3];
                i2 = a2 * r2, a2 += l2, s2 = a2 * r2, n2.push({ left: i2, right: s2, isDash: o2, zeroLength: 0 === l2 });
              }
              return n2;
            }
            addRoundDash(t2, e2, r2) {
              const n2 = e2 / 2;
              for (let e3 = -r2; e3 <= r2; e3++) {
                const i2 = this.width * (this.nextRow + r2 + e3);
                let s2 = 0, o2 = t2[s2];
                for (let a2 = 0; a2 < this.width; a2++) {
                  a2 / o2.right > 1 && (o2 = t2[++s2]);
                  const l2 = Math.abs(a2 - o2.left), u2 = Math.abs(a2 - o2.right), c2 = Math.min(l2, u2);
                  let h3;
                  const p3 = e3 / r2 * (n2 + 1);
                  if (o2.isDash) {
                    const t3 = n2 - Math.abs(p3);
                    h3 = Math.sqrt(c2 * c2 + t3 * t3);
                  } else h3 = n2 - Math.sqrt(c2 * c2 + p3 * p3);
                  this.image.data[i2 + a2] = Math.max(0, Math.min(255, h3 + 128));
                }
              }
            }
            addRegularDash(t2, e2) {
              for (let e3 = t2.length - 1; e3 >= 0; --e3) {
                const r3 = t2[e3], n3 = t2[e3 + 1];
                r3.zeroLength ? t2.splice(e3, 1) : n3 && n3.isDash === r3.isDash && (n3.left = r3.left, t2.splice(e3, 1));
              }
              const r2 = t2[0], n2 = t2[t2.length - 1];
              r2.isDash === n2.isDash && (r2.left = n2.left - this.width, n2.right = r2.right + this.width);
              const i2 = this.width * this.nextRow;
              let s2 = 0, o2 = t2[s2];
              for (let r3 = 0; r3 < this.width; r3++) {
                r3 / o2.right > 1 && (o2 = t2[++s2]);
                const n3 = Math.abs(r3 - o2.left), a2 = Math.abs(r3 - o2.right), l2 = Math.min(n3, a2);
                this.image.data[i2 + r3] = Math.max(0, Math.min(255, (o2.isDash ? l2 : -l2) + e2 + 128));
              }
            }
            addDash(t2, e2) {
              const r2 = this.getKey(t2, e2);
              if (this.positions[r2]) return this.positions[r2];
              const n2 = "round" === e2, i2 = n2 ? 7 : 0, s2 = 2 * i2 + 1;
              if (this.nextRow + s2 > this.height) return Gt("LineAtlas out of space"), null;
              0 === t2.length && t2.push(1);
              let o2 = 0;
              for (let e3 = 0; e3 < t2.length; e3++) t2[e3] < 0 && (Gt("Negative value is found in line dasharray, replacing values with 0"), t2[e3] = 0), o2 += t2[e3];
              if (0 !== o2) {
                const r3 = this.width / o2, s3 = this.getDashRanges(t2, this.width, r3);
                n2 ? this.addRoundDash(s3, r3, i2) : this.addRegularDash(s3, "square" === e2 ? 0.5 * r3 : 0);
              }
              const a2 = this.nextRow + i2;
              this.nextRow += s2;
              const l2 = { tl: [a2, i2], br: [o2, 0] };
              return this.positions[r2] = l2, l2;
            }
          }
          qs(Ad, "LineAtlas");
          const Md = Pu.VectorTileFeature.types, Id = Math.cos(Math.PI / 180 * 37.5), Sd = Math.cos(Math.PI / 180 * 5);
          class zd {
            constructor(t2) {
              this.evaluationGlobals = { zoom: 0, lineProgress: void 0 }, this.elevationType = "none", this.zoom = t2.zoom, this.evaluationGlobals.zoom = this.zoom, this.overscaling = t2.overscaling, this.pixelRatio = t2.pixelRatio, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.projection = t2.projection, this.hasPattern = false, this.hasCrossSlope = false, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((t3) => {
                this.gradients[t3.id] = {};
              }), this.layoutVertexArray = new ua(), this.layoutVertexArray2 = new ca(), this.patternVertexArray = new ca(), this.indexArray = new Aa(), this.programConfigurations = new kl(t2.layers, { zoom: t2.zoom, lut: t2.lut }), this.segments = new tl(), this.maxLineLength = 0, this.zOffsetVertexArray = new ca(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.tessellationStep = t2.tessellationStep ? t2.tessellationStep : Cn / 64, this.worldview = t2.worldview;
            }
            updateFootprints(t2, e2) {
            }
            populate(t2, e2, r2, n2) {
              this.hasPattern = Jh("line", this.layers, this.pixelRatio, e2);
              const i2 = this.layers[0].layout.get("line-sort-key");
              this.tileToMeter = au(r2);
              const s2 = this.layers[0].layout.get("line-elevation-reference");
              if ("hd-road-markup" === s2) this.elevationType = "road";
              else {
                const t3 = this.layers[0].layout.get("line-z-offset"), e3 = t3.isConstant() && !t3.constantOr(0);
                this.elevationType = "sea" !== s2 && "ground" !== s2 && e3 ? "none" : "offset", "offset" === this.elevationType && "none" === s2 && Gt(`line-elevation-reference: ground is used for the layer ${this.layerIds[0]} because non-zero line-z-offset value was found.`);
              }
              const o2 = this.layers[0].layout.get("line-cross-slope");
              this.hasCrossSlope = "offset" === this.elevationType && void 0 !== o2;
              const a2 = [];
              for (const { feature: e3, id: s3, index: o3, sourceLayerIndex: l3 } of t2) {
                const t3 = this.layers[0]._featureFilter.needGeometry, u3 = gu(e3, t3);
                if (!this.layers[0]._featureFilter.filter(new go(this.zoom, { worldview: this.worldview }), u3, r2)) continue;
                const c3 = i2 ? i2.evaluate(u3, {}, r2) : void 0, h3 = { id: s3, properties: e3.properties, type: e3.type, sourceLayerIndex: l3, index: o3, geometry: t3 ? u3.geometry : yu(e3, r2, n2), patterns: {}, sortKey: c3 };
                a2.push(h3);
              }
              i2 && a2.sort((t3, e3) => t3.sortKey - e3.sortKey);
              const { lineAtlas: l2, featureIndex: u2 } = e2, c2 = this.addConstantDashes(l2);
              for (const n3 of a2) {
                const { geometry: i3, index: s3, sourceLayerIndex: o3 } = n3;
                if (c2 && this.addFeatureDashes(n3, l2), this.hasPattern) {
                  const t3 = Qh("line", this.layers, n3, this.zoom, this.pixelRatio, e2);
                  this.patternFeatures.push(t3);
                } else this.addFeature(n3, i3, s3, r2, l2.positions, e2.availableImages, e2.brightness, e2.elevationFeatures);
                u2.insert(t2[s3].feature, i3, s3, o3, this.index);
              }
            }
            addConstantDashes(t2) {
              let e2 = false;
              for (const r2 of this.layers) {
                const n2 = r2.paint.get("line-dasharray").value, i2 = r2.layout.get("line-cap").value;
                if ("constant" !== n2.kind || "constant" !== i2.kind) e2 = true;
                else {
                  const e3 = i2.value, r3 = n2.value;
                  if (!r3) continue;
                  t2.addDash(r3, e3);
                }
              }
              return e2;
            }
            addFeatureDashes(t2, e2) {
              const r2 = this.zoom;
              for (const n2 of this.layers) {
                const i2 = n2.paint.get("line-dasharray").value, s2 = n2.layout.get("line-cap").value;
                if ("constant" === i2.kind && "constant" === s2.kind) continue;
                let o2, a2;
                if ("constant" === i2.kind) {
                  if (o2 = i2.value, !o2) continue;
                } else o2 = i2.evaluate({ zoom: r2 }, t2);
                a2 = "constant" === s2.kind ? s2.value : s2.evaluate({ zoom: r2 }, t2), e2.addDash(o2, a2), t2.patterns[n2.id] = [e2.getKey(o2, a2)];
              }
            }
            update(t2, e2, r2, n2, i2, s2, o2, a2) {
              this.programConfigurations.updatePaintArrays(t2, e2, i2, r2, n2, s2, o2, a2);
            }
            addFeatures(t2, e2, r2, n2, i2, s2) {
              for (const t3 of this.patternFeatures) this.addFeature(t3, t3.geometry, t3.index, e2, r2, n2, s2);
            }
            isEmpty() {
              return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
              return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(t2) {
              this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t2.createVertexBuffer(this.layoutVertexArray2, bd)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = t2.createVertexBuffer(this.patternVertexArray, _d)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = t2.createVertexBuffer(this.zOffsetVertexArray, gd.members, true)), this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, xd), this.indexBuffer = t2.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t2), this.uploaded = true;
            }
            destroy() {
              this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(t2) {
              if (t2.properties && t2.properties.hasOwnProperty("mapbox_clip_start") && t2.properties.hasOwnProperty("mapbox_clip_end")) return { start: +t2.properties.mapbox_clip_start, end: +t2.properties.mapbox_clip_end };
            }
            addFeature(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = this.layers[0].layout, u2 = l2.get("line-join").evaluate(t2, {}), c2 = l2.get("line-cap").evaluate(t2, {}), h3 = l2.get("line-miter-limit"), p3 = l2.get("line-round-limit");
              this.lineClips = this.lineFeatureClips(t2), this.lineFeature = t2, this.zOffsetValue = l2.get("line-z-offset").value;
              const f2 = this.layers[0].paint.get("line-width").value;
              if ("constant" !== f2.kind && false === f2.isLineProgressConstant && (this.variableWidthValue = f2), "road" === this.elevationType) {
                const r3 = this.layoutVertexArray.length;
                if (!this.addElevatedRoadFeature(t2, e2, n2, a2, u2, c2, h3, p3)) {
                  const [i3, s3] = this.clipRuntimeLinesToTile(e2, 1);
                  for (let e3 = 0; e3 < i3.length; e3++) {
                    const r4 = i3[e3], o3 = s3[e3], a3 = { progress: { min: o3.progress.min, max: o3.progress.max }, nextDir: this.computeSegNextDir(o3, r4), prevDir: this.computeSegPrevDir(o3, r4) };
                    this.addLine(r4, t2, n2, u2, c2, h3, p3, a3);
                  }
                  this.fillNonElevatedRoadSegment(r3);
                }
              } else for (const r3 of e2) this.addLine(r3, t2, n2, u2, c2, h3, p3);
              this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t2, r2, i2, s2, n2, o2, void 0, this.worldview);
            }
            computeSegNextDir(t2, e2) {
              return t2.nextPoint.sub(e2.at(-2)).unit();
            }
            computeSegPrevDir(t2, e2) {
              return e2[1].sub(t2.prevPoint).unit();
            }
            clipLinesToTile(t2, e2) {
              return Mf(t2, -e2, -e2, Cn + e2, Cn + e2);
            }
            clipRuntimeLinesToTile(t2, e2) {
              const r2 = [];
              return [Mf(t2, -e2, -e2, Cn + e2, Cn + e2, r2), r2];
            }
            addElevatedRoadFeature(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = [], u2 = Zu.getElevationFeature(t2, n2);
              if (u2) {
                const t3 = this.clipLinesToTile(e2, 1), n3 = this.prepareElevatedLines(t3, u2, r2);
                for (const t4 of n3) l2.push({ geometry: t4, elevation: u2, elevationTileID: r2, segment: { progress: { min: 0, max: 1 }, nextDir: void 0, prevDir: void 0 } });
              }
              if (0 === l2.length) return false;
              for (const e3 of l2) {
                const n3 = this.layoutVertexArray.length;
                this.addLine(e3.geometry, t2, r2, i2, s2, o2, a2);
                const l3 = new Wu(r2, e3.elevationTileID);
                if (e3.elevation) for (let t3 = n3; t3 < this.layoutVertexArray.length; t3++) {
                  const r3 = new bt(this.layoutVertexArray.int16[6 * t3] >> 1, this.layoutVertexArray.int16[6 * t3 + 1] >> 1), n4 = l3.pointElevation(r3, e3.elevation, 0.05);
                  this.updateHeightRange(n4), this.zOffsetVertexArray.emplaceBack(n4, 0, 0);
                }
                else this.fillNonElevatedRoadSegment(n3);
              }
              return true;
            }
            prepareElevatedLines(t2, e2, r2) {
              if (null != e2.constantHeight) return t2;
              const n2 = [], i2 = 1 / au(r2);
              for (const r3 of t2) If(r3, new Hu(e2, i2), 0, n2);
              return n2;
            }
            fillNonElevatedRoadSegment(t2) {
              for (let e2 = t2; e2 < this.layoutVertexArray.length; e2++) this.zOffsetVertexArray.emplaceBack(0, 0, 0);
            }
            updateHeightRange(t2) {
              this.heightRange ? (this.heightRange.min = Math.min(this.heightRange.min, t2), this.heightRange.max = Math.max(this.heightRange.max, t2)) : this.heightRange = { min: t2, max: t2 };
            }
            addLine(t2, e2, r2, n2, i2, s2, o2, a2) {
              this.distance = 0, this.prevDistance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.totalFeatureLength = 0, this.lineSoFar = 0, this.currentVertex = void 0;
              const l2 = "none" === n2;
              this.patternJoinNone = this.hasPattern && l2, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [];
              const u2 = a2 && a2.progress.min > 0, c2 = a2 && a2.progress.max < 1;
              if (this.lineClips) {
                let r3 = { min: this.lineClips.start, max: this.lineClips.end }, n3 = 1;
                if (a2) {
                  const t3 = this.lineClips.end - this.lineClips.start;
                  r3 = function(t4, e3, r4) {
                    return { min: re(t4.min, e3, r4), max: re(t4.max, e3, r4) };
                  }(a2.progress, { min: 0, max: 1 }, r3), t3 > 0 && (n3 = (r3.max - r3.min) / t3);
                }
                const i3 = +e2.properties.mapbox_clip_feature_len, s3 = +e2.properties.mapbox_clip_seg_len;
                if (Number.isNaN(i3) || Number.isNaN(s3)) {
                  for (let e4 = 0; e4 < t2.length - 1; e4++) this.totalDistance += t2[e4].dist(t2[e4 + 1]);
                  const e3 = this.totalDistance / (r3.max - r3.min);
                  this.totalFeatureLength = Number.isFinite(e3) ? e3 : 0, this.lineClips.start = r3.min, this.lineClips.end = r3.max, this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                } else this.totalFeatureLength = i3, this.distance = s3 * n3, this.lineClips.start = r3.min, this.lineClips.end = r3.max, this.maxLineLength = Math.max(this.maxLineLength, this.distance);
                this.lineClipsArray.push(this.lineClips), this.updateScaledDistance();
              }
              const h3 = "Polygon" === Md[e2.type];
              let p3 = t2.length;
              for (; p3 >= 2 && t2[p3 - 1].equals(t2[p3 - 2]); ) p3--;
              let f2 = 0;
              for (; f2 < p3 - 1 && t2[f2].equals(t2[f2 + 1]); ) f2++;
              if (p3 < (h3 ? 3 : 2)) return;
              "bevel" === n2 && (s2 = 1.05);
              const d2 = this.segments.prepareSegment(10 * p3, this.layoutVertexArray, this.indexArray);
              let m2, y2, g2, x2, v2, b2, w2, _2;
              a2 && a2.prevDir && (b2 = a2.prevDir.perp()), a2 && a2.nextDir && (w2 = a2.nextDir.perp()), this.e1 = this.e2 = -1, h3 && (m2 = t2[p3 - 2], v2 = t2[f2].sub(m2)._unit()._perp());
              for (let e3 = f2; e3 < p3; e3++) {
                if (g2 = e3 === p3 - 1 ? h3 ? t2[f2 + 1] : void 0 : t2[e3 + 1], g2 && t2[e3].equals(g2)) continue;
                v2 && (x2 = v2), m2 && (y2 = m2), m2 = t2[e3], _2 = this.evaluateLineProgressFeatures(y2 ? y2.dist(m2) : 0), v2 = g2 ? g2.sub(m2)._unit()._perp() : x2, x2 = x2 || v2;
                const r3 = y2 && g2;
                let a3 = r3 ? n2 : h3 || l2 ? "butt" : i2;
                const A2 = x2.x * v2.x + x2.y * v2.y;
                if (l2) {
                  const t3 = function(t4) {
                    if (t4.patternJoinNone) {
                      const e4 = t4.segmentPoints.length / 2, r4 = t4.lineSoFar - t4.segmentStart;
                      for (let n3 = 0; n3 < e4; ++n3) {
                        const e5 = t4.segmentPoints[2 * n3 + 1], i3 = Math.round(t4.segmentPoints[2 * n3]) + 0.5 + 0.25 * e5;
                        t4.patternVertexArray.emplaceBack(i3, r4, t4.segmentStart), t4.patternVertexArray.emplaceBack(i3, r4, t4.segmentStart);
                      }
                      t4.segmentPoints.length = 0;
                    }
                    t4.e1 = t4.e2 = -1;
                  };
                  if (r3 && A2 < Sd) {
                    this.updateDistance(y2, m2), this.addCurrentVertex(m2, x2, 1, 1, d2, _2), t3(this), this.addCurrentVertex(m2, v2, -1, -1, d2, _2);
                    continue;
                  }
                  if (y2) {
                    if (!g2) {
                      this.updateDistance(y2, m2), this.addCurrentVertex(m2, x2, 1, 1, d2, _2), t3(this);
                      continue;
                    }
                    a3 = "miter";
                  }
                }
                let M2 = x2.add(v2);
                0 === M2.x && 0 === M2.y || M2._unit();
                const I2 = M2.x * v2.x + M2.y * v2.y, S2 = 0 !== I2 ? 1 / I2 : 1 / 0, z2 = 2 * Math.sqrt(2 - 2 * I2), k2 = I2 < Id && y2 && g2, P2 = x2.x * v2.y - x2.y * v2.x > 0, E2 = this.overscaling <= 16 ? 15 * Cn / (512 * this.overscaling) : 0;
                if (r3 && "round" === a3) {
                  if (S2 < o2) a3 = "miter";
                  else if (S2 <= 2) {
                    const t3 = kd(m2, -10, Cn + 10);
                    a3 = "offset" === this.elevationType && (t3 || this.hasCrossSlope) ? "miter" : "fakeround";
                  }
                }
                if ("miter" === a3 && S2 > s2 && (a3 = "bevel"), "bevel" === a3 && (S2 > 2 && (a3 = "flipbevel"), S2 < s2 && (a3 = "miter")), y2 && !("miter" === a3 && k2) && this.updateDistance(y2, m2), "miter" === a3) if (k2) {
                  const t3 = m2.dist(y2);
                  if (t3 > 2 * E2) {
                    const e5 = m2.sub(m2.sub(y2)._mult(E2 / t3)._round());
                    this.updateDistance(y2, e5), this.addCurrentVertex(e5, x2, 0, 0, d2, _2), y2 = e5;
                  }
                  this.updateDistance(y2, m2), M2._mult(S2), this.addCurrentVertex(m2, M2, 0, 0, d2, _2);
                  const e4 = m2.dist(g2);
                  if (e4 > 2 * E2) {
                    const t4 = m2.add(g2.sub(m2)._mult(E2 / e4)._round());
                    this.updateDistance(m2, t4), this.addCurrentVertex(t4, v2, 0, 0, d2, _2), m2 = t4;
                  }
                } else M2._mult(S2), this.addCurrentVertex(m2, M2, 0, 0, d2, _2);
                else if ("flipbevel" === a3) {
                  if (S2 > 100) M2 = v2.mult(-1);
                  else {
                    const t3 = S2 * x2.add(v2).mag() / x2.sub(v2).mag();
                    M2._perp()._mult(t3 * (P2 ? -1 : 1));
                  }
                  this.addCurrentVertex(m2, M2, 0, 0, d2, _2), this.addCurrentVertex(m2, M2.mult(-1), 0, 0, d2, _2);
                } else if ("bevel" === a3 || "fakeround" === a3) {
                  null != _2 && y2 && this.addCurrentVertex(m2, w2 || x2, -1, -1, d2, _2);
                  const t3 = m2.dist(y2) <= 2 * E2 && "bevel" !== a3, e4 = M2.mult(P2 ? 1 : -1);
                  e4._mult(S2);
                  const r4 = v2.mult(P2 ? -1 : 1), n3 = x2.mult(P2 ? -1 : 1), i3 = this.evaluateLineProgressFeatures(this.distance);
                  if (null == _2 && (this.addHalfVertex(m2, e4.x, e4.y, false, !P2, 0, d2, i3), t3 || this.addHalfVertex(m2, e4.x + 2 * n3.x, e4.y + 2 * n3.y, false, P2, 0, d2, i3)), "fakeround" === a3) {
                    const t4 = Math.round(180 * z2 / Math.PI / 20);
                    this.addHalfVertex(m2, n3.x, n3.y, false, P2, 0, d2, i3);
                    for (let e5 = 0; e5 < t4; e5++) {
                      let s3 = e5 / t4;
                      if (0.5 !== s3) {
                        const t5 = s3 - 0.5;
                        s3 += s3 * t5 * (s3 - 1) * ((1.0904 + A2 * (A2 * (3.55645 - 1.43519 * A2) - 3.2452)) * t5 * t5 + (0.848013 + A2 * (0.215638 * A2 - 1.06021)));
                      }
                      const o3 = r4.sub(n3)._mult(s3)._add(n3)._unit();
                      this.addHalfVertex(m2, o3.x, o3.y, false, P2, 0, d2, i3);
                    }
                    this.addHalfVertex(m2, r4.x, r4.y, false, P2, 0, d2, i3);
                  }
                  t3 || null != _2 || this.addHalfVertex(m2, e4.x + 2 * r4.x, e4.y + 2 * r4.y, false, P2, 0, d2, i3), null != _2 && g2 && this.addCurrentVertex(m2, b2 || v2, 1, 1, d2, _2);
                } else if ("butt" === a3) this.addCurrentVertex(m2, M2, 0, 0, d2, _2);
                else if ("square" === a3) {
                  if (!y2) {
                    const t3 = u2 ? 0 : -1;
                    this.addCurrentVertex(m2, M2, t3, t3, d2, _2);
                  }
                  if (this.addCurrentVertex(m2, M2, 0, 0, d2, _2), y2) {
                    const t3 = c2 ? 0 : 1;
                    this.addCurrentVertex(m2, M2, t3, t3, d2, _2);
                  }
                } else if ("round" === a3) {
                  if (y2) {
                    const t3 = !r3 && w2 ? w2 : x2;
                    this.addCurrentVertex(m2, t3, 0, 0, d2, _2), !r3 && c2 || this.addCurrentVertex(m2, t3, 1, 1, d2, _2, true);
                  }
                  if (g2) {
                    const t3 = !r3 && b2 ? b2 : v2;
                    !r3 && u2 || this.addCurrentVertex(m2, t3, -1, -1, d2, _2, true), this.addCurrentVertex(m2, t3, 0, 0, d2, _2);
                  }
                }
              }
            }
            addVerticesTo(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) {
              const c2 = (e2.w - t2.w) / this.tessellationStep | 0;
              let h3 = 0;
              const p3 = this.scaledDistance;
              if (c2 > 1) {
                this.lineSoFar = t2.w;
                const p4 = (e2.x - t2.x) / c2, f3 = (e2.y - t2.y) / c2, d2 = (e2.z - t2.z) / c2, m2 = (e2.w - t2.w) / c2;
                for (let e3 = 1; e3 < c2; ++e3) {
                  t2.x += p4, t2.y += f3, t2.z += d2, this.lineSoFar += m2, h3 += m2;
                  const e4 = this.evaluateLineProgressFeatures(this.prevDistance + h3);
                  this.scaledDistance = (this.prevDistance + h3) / this.totalDistance, this.addHalfVertex(t2, r2, n2, u2, false, o2, l2, e4), this.addHalfVertex(t2, i2, s2, u2, true, -a2, l2, e4);
                }
              }
              this.lineSoFar = e2.w, this.scaledDistance = p3;
              const f2 = this.evaluateLineProgressFeatures(this.distance);
              this.addHalfVertex(e2, r2, n2, u2, false, o2, l2, f2), this.addHalfVertex(e2, i2, s2, u2, true, -a2, l2, f2);
            }
            evaluateLineProgressFeatures(t2) {
              if (!this.variableWidthValue && "offset" !== this.elevationType) return null;
              this.evaluationGlobals.lineProgress = 0, this.lineClips ? this.evaluationGlobals.lineProgress = Math.min(1, (this.totalFeatureLength * this.lineClips.start + t2) / this.totalFeatureLength) : Gt(`line-progress evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`);
              let e2 = 0;
              return this.variableWidthValue && "constant" !== this.variableWidthValue.kind && (e2 = this.variableWidthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0), "offset" !== this.elevationType ? { zOffset: 0, variableWidth: e2 } : "constant" === this.zOffsetValue.kind ? { zOffset: this.zOffsetValue.value, variableWidth: e2 } : { zOffset: this.zOffsetValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0, variableWidth: e2 };
            }
            addCurrentVertex(t2, e2, r2, n2, i2, s2, o2 = false) {
              const a2 = e2.x + e2.y * r2, l2 = e2.y - e2.x * r2, u2 = e2.y * n2 - e2.x, c2 = -e2.y - e2.x * n2;
              if (null != s2) {
                const e3 = "offset" === this.elevationType, h3 = -10, p3 = Cn + 10, f2 = s2.zOffset, d2 = new wf(t2.x, t2.y, f2, this.lineSoFar), m2 = !!e3 && kd(t2, h3, p3), y2 = this.lineSoFar, g2 = this.distance;
                if (this.currentVertex) if (m2) {
                  const e4 = this.currentVertexIsOutside, s3 = this.currentVertex, m3 = new wf(t2.x, t2.y, f2, this.lineSoFar);
                  if (Af(s3, m3, h3, p3), !kd(m3, h3, p3)) {
                    if (e4) {
                      this.e1 = this.e2 = -1, this.distance -= s3.dist(d2), this.lineSoFar = s3.w;
                      const t3 = this.evaluateLineProgressFeatures(s3.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                      this.addHalfVertex(s3, a2, l2, o2, false, r2, i2, t3), this.addHalfVertex(s3, u2, c2, o2, true, -n2, i2, t3), this.prevDistance = this.distance;
                    }
                    this.distance = this.prevDistance + s3.dist(m3), this.scaledDistance = this.distance / this.totalDistance, this.addVerticesTo(s3, m3, a2, l2, u2, c2, r2, n2, i2, o2), this.distance = g2, this.scaledDistance = this.distance / this.totalDistance;
                  }
                } else {
                  const t3 = this.currentVertex;
                  if (this.currentVertexIsOutside) {
                    Af(t3, d2, h3, p3), this.e1 = this.e2 = -1, this.distance -= t3.dist(d2), this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = t3.w;
                    const e4 = this.evaluateLineProgressFeatures(t3.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                    this.addHalfVertex(t3, a2, l2, o2, false, r2, i2, e4), this.addHalfVertex(t3, u2, c2, o2, true, -n2, i2, e4), this.prevDistance = this.distance, this.distance = g2, this.scaledDistance = this.distance / this.totalDistance;
                  }
                  this.addVerticesTo(t3, d2, a2, l2, u2, c2, r2, n2, i2, o2);
                }
                else m2 || (this.addHalfVertex(t2, a2, l2, o2, false, r2, i2, s2), this.addHalfVertex(t2, u2, c2, o2, true, -n2, i2, s2));
                this.currentVertex = d2, this.currentVertexIsOutside = m2, this.lineSoFar = y2;
              } else this.addHalfVertex(t2, a2, l2, o2, false, r2, i2, s2), this.addHalfVertex(t2, u2, c2, o2, true, -n2, i2, s2);
            }
            addHalfVertex({ x: t2, y: e2 }, r2, n2, i2, s2, o2, a2, l2) {
              if (this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), s2 || this.segmentPoints.push(this.lineSoFar - this.segmentStart, o2)), this.layoutVertexArray.emplaceBack((t2 << 1) + (i2 ? 1 : 0), (e2 << 1) + (s2 ? 1 : 0), Math.round(63 * r2) + 128, Math.round(63 * n2) + 128, 1 + (0 === o2 ? 0 : o2 < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips) {
                const t3 = ur(this.lineClips.start, this.lineClips.end, this.scaledDistance);
                this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, t3);
              }
              const u2 = a2.vertexLength++;
              this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u2), a2.primitiveLength++), s2 ? this.e2 = u2 : this.e1 = u2, null != l2 && this.zOffsetVertexArray.emplaceBack(l2.zOffset, l2.variableWidth, l2.variableWidth);
            }
            updateScaledDistance() {
              this.lineClips ? (this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = this.totalFeatureLength * this.lineClips.start + this.distance) : this.lineSoFar = this.distance;
            }
            updateDistance(t2, e2) {
              this.prevDistance = this.distance, this.distance += t2.dist(e2), this.updateScaledDistance();
            }
          }
          function kd(t2, e2, r2) {
            return t2.x < e2 || t2.x > r2 || t2.y < e2 || t2.y > r2;
          }
          let Pd, Ed;
          function Td(t2, e2, r2) {
            return e2 * (Cn / (t2.tileSize * Math.pow(2, r2 - t2.tileID.overscaledZ)));
          }
          qs(zd, "LineBucket", { omit: ["layers", "patternFeatures", "currentVertex", "currentVertexIsOutside"] });
          const Bd = (t2, e2, r2) => (1 - r2) * t2 + r2 * e2;
          function Vd(t2, e2) {
            return 1 / Td(t2, 1, e2.tileZoom);
          }
          function Cd(t2, e2, r2, n2) {
            return t2.translatePosMatrix(n2 || e2.tileID.projMatrix, e2, r2.paint.get("line-translate"), r2.paint.get("line-translate-anchor"));
          }
          const Fd = (t2) => {
            const e2 = [];
            Dd(t2) && e2.push("RENDER_LINE_DASH"), t2.paint.get("line-gradient") && e2.push("RENDER_LINE_GRADIENT");
            const r2 = t2.paint.get("line-trim-offset");
            0 === r2[0] && 0 === r2[1] || e2.push("RENDER_LINE_TRIM_OFFSET"), 0 !== t2.paint.get("line-border-width").constantOr(1) && e2.push("RENDER_LINE_BORDER");
            const n2 = "none" === t2.layout.get("line-join").constantOr("miter"), i2 = !!t2.paint.get("line-pattern").constantOr(1);
            return n2 && i2 && e2.push("LINE_JOIN_NONE"), e2;
          };
          function Dd(t2) {
            const e2 = t2.paint.get("line-dasharray").value;
            return e2.value || "constant" !== e2.kind;
          }
          let Ld;
          const Rd = () => Ld || (Ld = { layout: Pd || (Pd = new Po({ "line-cap": new zo(Eo.layout_line["line-cap"]), "line-join": new zo(Eo.layout_line["line-join"]), "line-miter-limit": new So(Eo.layout_line["line-miter-limit"]), "line-round-limit": new So(Eo.layout_line["line-round-limit"]), "line-sort-key": new zo(Eo.layout_line["line-sort-key"]), "line-z-offset": new zo(Eo.layout_line["line-z-offset"]), "line-elevation-reference": new So(Eo.layout_line["line-elevation-reference"]), "line-cross-slope": new So(Eo.layout_line["line-cross-slope"]), visibility: new So(Eo.layout_line.visibility), "line-width-unit": new So(Eo.layout_line["line-width-unit"]) })), paint: Ed || (Ed = new Po({ "line-opacity": new zo(Eo.paint_line["line-opacity"]), "line-color": new zo(Eo.paint_line["line-color"]), "line-translate": new So(Eo.paint_line["line-translate"]), "line-translate-anchor": new So(Eo.paint_line["line-translate-anchor"]), "line-width": new zo(Eo.paint_line["line-width"]), "line-gap-width": new zo(Eo.paint_line["line-gap-width"]), "line-offset": new zo(Eo.paint_line["line-offset"]), "line-blur": new zo(Eo.paint_line["line-blur"]), "line-dasharray": new zo(Eo.paint_line["line-dasharray"]), "line-pattern": new zo(Eo.paint_line["line-pattern"]), "line-pattern-cross-fade": new So(Eo.paint_line["line-pattern-cross-fade"]), "line-gradient": new ko(Eo.paint_line["line-gradient"]), "line-trim-offset": new So(Eo.paint_line["line-trim-offset"]), "line-trim-fade-range": new So(Eo.paint_line["line-trim-fade-range"]), "line-trim-color": new So(Eo.paint_line["line-trim-color"]), "line-emissive-strength": new So(Eo.paint_line["line-emissive-strength"]), "line-border-width": new zo(Eo.paint_line["line-border-width"]), "line-border-color": new zo(Eo.paint_line["line-border-color"]), "line-occlusion-opacity": new So(Eo.paint_line["line-occlusion-opacity"]), "line-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "line-gradient-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "line-trim-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "line-border-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, Ld);
          class Od extends zo {
            possiblyEvaluate(t2, e2) {
              return e2 = new go(Math.floor(e2.zoom), { now: e2.now, fadeDuration: e2.fadeDuration, transition: e2.transition, worldview: e2.worldview }), super.possiblyEvaluate(t2, e2);
            }
            evaluate(t2, e2, r2, n2) {
              return e2 = Ct({}, e2, { zoom: Math.floor(e2.zoom) }), super.evaluate(t2, e2, r2, n2);
            }
          }
          let Ud;
          function Nd(t2, e2) {
            return e2 > 0 ? e2 + 2 * t2 : t2;
          }
          const jd = ta([{ name: "a_pos_offset", components: 4, type: "Int16" }, { name: "a_tex_size", components: 4, type: "Uint16" }, { name: "a_pixeloffset", components: 4, type: "Int16" }], 4), $d = ta([{ name: "a_globe_anchor", components: 3, type: "Int16" }, { name: "a_globe_normal", components: 3, type: "Float32" }], 4), Gd = ta([{ name: "a_projected_pos", components: 4, type: "Float32" }], 4);
          ta([{ name: "a_fade_opacity", components: 1, type: "Uint32" }], 4);
          const qd = ta([{ name: "a_auto_z_offset", components: 1, type: "Float32" }], 4), Hd = ta([{ name: "a_x_axis", components: 3, type: "Float32" }, { name: "a_y_axis", components: 3, type: "Float32" }]), Xd = ta([{ name: "a_texb", components: 2, type: "Uint16" }]), Zd = ta([{ name: "a_placed", components: 2, type: "Uint8" }, { name: "a_shift", components: 2, type: "Float32" }, { name: "a_elevation_from_sea", components: 2, type: "Float32" }]), Wd = ta([{ name: "a_size_scale", components: 1, type: "Float32" }, { name: "a_padding", components: 2, type: "Float32" }, { name: "a_auto_z_offset", components: 1, type: "Float32" }]);
          ta([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Int16", name: "tileAnchorX" }, { type: "Int16", name: "tileAnchorY" }, { type: "Float32", name: "x1" }, { type: "Float32", name: "y1" }, { type: "Float32", name: "x2" }, { type: "Float32", name: "y2" }, { type: "Int16", name: "padding" }, { type: "Uint32", name: "featureIndex" }, { type: "Uint16", name: "sourceLayerIndex" }, { type: "Uint16", name: "bucketIndex" }]);
          const Yd = ta([{ name: "a_pos", components: 3, type: "Int16" }, { name: "a_anchor_pos", components: 2, type: "Int16" }, { name: "a_extrude", components: 2, type: "Int16" }], 4), Kd = ta([{ name: "a_pos_2f", components: 2, type: "Float32" }, { name: "a_radius", components: 1, type: "Float32" }, { name: "a_flags", components: 2, type: "Int16" }], 4);
          ta([{ name: "triangle", components: 3, type: "Uint16" }]), ta([{ type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Uint16", name: "glyphStartIndex" }, { type: "Uint16", name: "numGlyphs" }, { type: "Uint32", name: "vertexStartIndex" }, { type: "Uint32", name: "lineStartIndex" }, { type: "Uint32", name: "lineLength" }, { type: "Uint16", name: "segment" }, { type: "Uint16", name: "lowerSize" }, { type: "Uint16", name: "upperSize" }, { type: "Float32", name: "lineOffsetX" }, { type: "Float32", name: "lineOffsetY" }, { type: "Uint8", name: "writingMode" }, { type: "Uint8", name: "placedOrientation" }, { type: "Uint8", name: "hidden" }, { type: "Uint32", name: "crossTileID" }, { type: "Int16", name: "associatedIconIndex" }, { type: "Uint8", name: "flipState" }]), ta([{ type: "Float32", name: "tileAnchorX" }, { type: "Float32", name: "tileAnchorY" }, { type: "Int16", name: "projectedAnchorX" }, { type: "Int16", name: "projectedAnchorY" }, { type: "Int16", name: "projectedAnchorZ" }, { type: "Int16", name: "rightJustifiedTextSymbolIndex" }, { type: "Int16", name: "centerJustifiedTextSymbolIndex" }, { type: "Int16", name: "leftJustifiedTextSymbolIndex" }, { type: "Int16", name: "verticalPlacedTextSymbolIndex" }, { type: "Int16", name: "placedIconSymbolIndex" }, { type: "Int16", name: "verticalPlacedIconSymbolIndex" }, { type: "Uint16", name: "key" }, { type: "Uint16", name: "textBoxStartIndex" }, { type: "Uint16", name: "textBoxEndIndex" }, { type: "Uint16", name: "verticalTextBoxStartIndex" }, { type: "Uint16", name: "verticalTextBoxEndIndex" }, { type: "Uint16", name: "iconBoxStartIndex" }, { type: "Uint16", name: "iconBoxEndIndex" }, { type: "Uint16", name: "verticalIconBoxStartIndex" }, { type: "Uint16", name: "verticalIconBoxEndIndex" }, { type: "Uint16", name: "featureIndex" }, { type: "Uint16", name: "numHorizontalGlyphVertices" }, { type: "Uint16", name: "numVerticalGlyphVertices" }, { type: "Uint16", name: "numIconVertices" }, { type: "Uint16", name: "numVerticalIconVertices" }, { type: "Uint16", name: "useRuntimeCollisionCircles" }, { type: "Uint32", name: "crossTileID" }, { type: "Float32", components: 2, name: "textOffset" }, { type: "Float32", name: "collisionCircleDiameter" }, { type: "Float32", name: "zOffset" }, { type: "Uint8", name: "hasIconTextFit" }, { type: "Uint16", name: "elevationFeatureIndex" }]), ta([{ type: "Float32", name: "offsetX" }]), ta([{ type: "Int16", name: "x" }, { type: "Int16", name: "y" }]);
          var Jd = 24;
          function Qd(t2, e2, r2) {
            return t2.sections.forEach((t3) => {
              t3.text = function(t4, e3, r3) {
                const n2 = e3.layout.get("text-transform").evaluate(r3, {});
                return "uppercase" === n2 ? t4 = t4.toLocaleUpperCase() : "lowercase" === n2 && (t4 = t4.toLocaleLowerCase()), yo.applyArabicShaping && (t4 = yo.applyArabicShaping(t4)), t4;
              }(t3.text, e2, r2);
            }), t2;
          }
          const tm = { "!": "\uFE15", "#": "\uFF03", $: "\uFF04", "%": "\uFF05", "&": "\uFF06", "(": "\uFE35", ")": "\uFE36", "*": "\uFF0A", "+": "\uFF0B", ",": "\uFE10", "-": "\uFE32", ".": "\u30FB", "/": "\uFF0F", ":": "\uFE13", ";": "\uFE14", "<": "\uFE3F", "=": "\uFF1D", ">": "\uFE40", "?": "\uFE16", "@": "\uFF20", "[": "\uFE47", "\\": "\uFF3C", "]": "\uFE48", "^": "\uFF3E", _: "\uFE33", "`": "\uFF40", "{": "\uFE37", "|": "\u2015", "}": "\uFE38", "~": "\uFF5E", "\xA2": "\uFFE0", "\xA3": "\uFFE1", "\xA5": "\uFFE5", "\xA6": "\uFFE4", "\xAC": "\uFFE2", "\xAF": "\uFFE3", "\u2013": "\uFE32", "\u2014": "\uFE31", "\u2018": "\uFE43", "\u2019": "\uFE44", "\u201C": "\uFE41", "\u201D": "\uFE42", "\u2026": "\uFE19", "\u2027": "\u30FB", "\u20A9": "\uFFE6", "\u3001": "\uFE11", "\u3002": "\uFE12", "\u3008": "\uFE3F", "\u3009": "\uFE40", "\u300A": "\uFE3D", "\u300B": "\uFE3E", "\u300C": "\uFE41", "\u300D": "\uFE42", "\u300E": "\uFE43", "\u300F": "\uFE44", "\u3010": "\uFE3B", "\u3011": "\uFE3C", "\u3014": "\uFE39", "\u3015": "\uFE3A", "\u3016": "\uFE17", "\u3017": "\uFE18", "\uFF01": "\uFE15", "\uFF08": "\uFE35", "\uFF09": "\uFE36", "\uFF0C": "\uFE10", "\uFF0D": "\uFE32", "\uFF0E": "\u30FB", "\uFF1A": "\uFE13", "\uFF1B": "\uFE14", "\uFF1C": "\uFE3F", "\uFF1E": "\uFE40", "\uFF1F": "\uFE16", "\uFF3B": "\uFE47", "\uFF3D": "\uFE48", "\uFF3F": "\uFE33", "\uFF5B": "\uFE37", "\uFF5C": "\u2015", "\uFF5D": "\uFE38", "\uFF5F": "\uFE35", "\uFF60": "\uFE36", "\uFF61": "\uFE12", "\uFF62": "\uFE41", "\uFF63": "\uFE42", "\u2190": "\u2191", "\u2192": "\u2193" };
          function em(t2) {
            return "\uFE36" === t2 || "\uFE48" === t2 || "\uFE38" === t2 || "\uFE44" === t2 || "\uFE42" === t2 || "\uFE3E" === t2 || "\uFE3C" === t2 || "\uFE3A" === t2 || "\uFE18" === t2 || "\uFE40" === t2 || "\uFE10" === t2 || "\uFE13" === t2 || "\uFE14" === t2 || "\uFF40" === t2 || "\uFFE3" === t2 || "\uFE11" === t2 || "\uFE12" === t2;
          }
          function rm(t2) {
            return "\uFE35" === t2 || "\uFE47" === t2 || "\uFE37" === t2 || "\uFE43" === t2 || "\uFE41" === t2 || "\uFE3D" === t2 || "\uFE3B" === t2 || "\uFE39" === t2 || "\uFE17" === t2 || "\uFE3F" === t2;
          }
          var nm, im, sm, om = {};
          function am() {
            return nm || (nm = 1, om.read = function(t2, e2, r2, n2, i2) {
              var s2, o2, a2 = 8 * i2 - n2 - 1, l2 = (1 << a2) - 1, u2 = l2 >> 1, c2 = -7, h3 = r2 ? i2 - 1 : 0, p3 = r2 ? -1 : 1, f2 = t2[e2 + h3];
              for (h3 += p3, s2 = f2 & (1 << -c2) - 1, f2 >>= -c2, c2 += a2; c2 > 0; s2 = 256 * s2 + t2[e2 + h3], h3 += p3, c2 -= 8) ;
              for (o2 = s2 & (1 << -c2) - 1, s2 >>= -c2, c2 += n2; c2 > 0; o2 = 256 * o2 + t2[e2 + h3], h3 += p3, c2 -= 8) ;
              if (0 === s2) s2 = 1 - u2;
              else {
                if (s2 === l2) return o2 ? NaN : 1 / 0 * (f2 ? -1 : 1);
                o2 += Math.pow(2, n2), s2 -= u2;
              }
              return (f2 ? -1 : 1) * o2 * Math.pow(2, s2 - n2);
            }, om.write = function(t2, e2, r2, n2, i2, s2) {
              var o2, a2, l2, u2 = 8 * s2 - i2 - 1, c2 = (1 << u2) - 1, h3 = c2 >> 1, p3 = 23 === i2 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f2 = n2 ? 0 : s2 - 1, d2 = n2 ? 1 : -1, m2 = e2 < 0 || 0 === e2 && 1 / e2 < 0 ? 1 : 0;
              for (e2 = Math.abs(e2), isNaN(e2) || e2 === 1 / 0 ? (a2 = isNaN(e2) ? 1 : 0, o2 = c2) : (o2 = Math.floor(Math.log(e2) / Math.LN2), e2 * (l2 = Math.pow(2, -o2)) < 1 && (o2--, l2 *= 2), (e2 += o2 + h3 >= 1 ? p3 / l2 : p3 * Math.pow(2, 1 - h3)) * l2 >= 2 && (o2++, l2 /= 2), o2 + h3 >= c2 ? (a2 = 0, o2 = c2) : o2 + h3 >= 1 ? (a2 = (e2 * l2 - 1) * Math.pow(2, i2), o2 += h3) : (a2 = e2 * Math.pow(2, h3 - 1) * Math.pow(2, i2), o2 = 0)); i2 >= 8; t2[r2 + f2] = 255 & a2, f2 += d2, a2 /= 256, i2 -= 8) ;
              for (o2 = o2 << i2 | a2, u2 += i2; u2 > 0; t2[r2 + f2] = 255 & o2, f2 += d2, o2 /= 256, u2 -= 8) ;
              t2[r2 + f2 - d2] |= 128 * m2;
            }), om;
          }
          function lm() {
            if (sm) return im;
            sm = 1, im = e2;
            var t2 = am();
            function e2(t3) {
              this.buf = ArrayBuffer.isView && ArrayBuffer.isView(t3) ? t3 : new Uint8Array(t3 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            e2.Varint = 0, e2.Fixed64 = 1, e2.Bytes = 2, e2.Fixed32 = 5;
            var r2 = 4294967296, n2 = 1 / r2, i2 = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
            function s2(t3) {
              return t3.type === e2.Bytes ? t3.readVarint() + t3.pos : t3.pos + 1;
            }
            function o2(t3, e3, r3) {
              return r3 ? 4294967296 * e3 + (t3 >>> 0) : 4294967296 * (e3 >>> 0) + (t3 >>> 0);
            }
            function a2(t3, e3, r3) {
              var n3 = e3 <= 16383 ? 1 : e3 <= 2097151 ? 2 : e3 <= 268435455 ? 3 : Math.floor(Math.log(e3) / (7 * Math.LN2));
              r3.realloc(n3);
              for (var i3 = r3.pos - 1; i3 >= t3; i3--) r3.buf[i3 + n3] = r3.buf[i3];
            }
            function l2(t3, e3) {
              for (var r3 = 0; r3 < t3.length; r3++) e3.writeVarint(t3[r3]);
            }
            function u2(t3, e3) {
              for (var r3 = 0; r3 < t3.length; r3++) e3.writeSVarint(t3[r3]);
            }
            function c2(t3, e3) {
              for (var r3 = 0; r3 < t3.length; r3++) e3.writeFloat(t3[r3]);
            }
            function h3(t3, e3) {
              for (var r3 = 0; r3 < t3.length; r3++) e3.writeDouble(t3[r3]);
            }
            function p3(t3, e3) {
              for (var r3 = 0; r3 < t3.length; r3++) e3.writeBoolean(t3[r3]);
            }
            function f2(t3, e3) {
              for (var r3 = 0; r3 < t3.length; r3++) e3.writeFixed32(t3[r3]);
            }
            function d2(t3, e3) {
              for (var r3 = 0; r3 < t3.length; r3++) e3.writeSFixed32(t3[r3]);
            }
            function m2(t3, e3) {
              for (var r3 = 0; r3 < t3.length; r3++) e3.writeFixed64(t3[r3]);
            }
            function y2(t3, e3) {
              for (var r3 = 0; r3 < t3.length; r3++) e3.writeSFixed64(t3[r3]);
            }
            function g2(t3, e3) {
              return (t3[e3] | t3[e3 + 1] << 8 | t3[e3 + 2] << 16) + 16777216 * t3[e3 + 3];
            }
            function x2(t3, e3, r3) {
              t3[r3] = e3, t3[r3 + 1] = e3 >>> 8, t3[r3 + 2] = e3 >>> 16, t3[r3 + 3] = e3 >>> 24;
            }
            function v2(t3, e3) {
              return (t3[e3] | t3[e3 + 1] << 8 | t3[e3 + 2] << 16) + (t3[e3 + 3] << 24);
            }
            return e2.prototype = { destroy: function() {
              this.buf = null;
            }, readFields: function(t3, e3, r3) {
              for (r3 = r3 || this.length; this.pos < r3; ) {
                var n3 = this.readVarint(), i3 = n3 >> 3, s3 = this.pos;
                this.type = 7 & n3, t3(i3, e3, this), this.pos === s3 && this.skip(n3);
              }
              return e3;
            }, readMessage: function(t3, e3) {
              return this.readFields(t3, e3, this.readVarint() + this.pos);
            }, readFixed32: function() {
              var t3 = g2(this.buf, this.pos);
              return this.pos += 4, t3;
            }, readSFixed32: function() {
              var t3 = v2(this.buf, this.pos);
              return this.pos += 4, t3;
            }, readFixed64: function() {
              var t3 = g2(this.buf, this.pos) + g2(this.buf, this.pos + 4) * r2;
              return this.pos += 8, t3;
            }, readSFixed64: function() {
              var t3 = g2(this.buf, this.pos) + v2(this.buf, this.pos + 4) * r2;
              return this.pos += 8, t3;
            }, readFloat: function() {
              var e3 = t2.read(this.buf, this.pos, true, 23, 4);
              return this.pos += 4, e3;
            }, readDouble: function() {
              var e3 = t2.read(this.buf, this.pos, true, 52, 8);
              return this.pos += 8, e3;
            }, readVarint: function(t3) {
              var e3, r3, n3 = this.buf;
              return e3 = 127 & (r3 = n3[this.pos++]), r3 < 128 ? e3 : (e3 |= (127 & (r3 = n3[this.pos++])) << 7, r3 < 128 ? e3 : (e3 |= (127 & (r3 = n3[this.pos++])) << 14, r3 < 128 ? e3 : (e3 |= (127 & (r3 = n3[this.pos++])) << 21, r3 < 128 ? e3 : function(t4, e4, r4) {
                var n4, i3, s3 = r4.buf;
                if (n4 = (112 & (i3 = s3[r4.pos++])) >> 4, i3 < 128) return o2(t4, n4, e4);
                if (n4 |= (127 & (i3 = s3[r4.pos++])) << 3, i3 < 128) return o2(t4, n4, e4);
                if (n4 |= (127 & (i3 = s3[r4.pos++])) << 10, i3 < 128) return o2(t4, n4, e4);
                if (n4 |= (127 & (i3 = s3[r4.pos++])) << 17, i3 < 128) return o2(t4, n4, e4);
                if (n4 |= (127 & (i3 = s3[r4.pos++])) << 24, i3 < 128) return o2(t4, n4, e4);
                if (n4 |= (1 & (i3 = s3[r4.pos++])) << 31, i3 < 128) return o2(t4, n4, e4);
                throw new Error("Expected varint not more than 10 bytes");
              }(e3 |= (15 & (r3 = n3[this.pos])) << 28, t3, this))));
            }, readVarint64: function() {
              return this.readVarint(true);
            }, readSVarint: function() {
              var t3 = this.readVarint();
              return t3 % 2 == 1 ? (t3 + 1) / -2 : t3 / 2;
            }, readBoolean: function() {
              return Boolean(this.readVarint());
            }, readString: function() {
              var t3 = this.readVarint() + this.pos, e3 = this.pos;
              return this.pos = t3, t3 - e3 >= 12 && i2 ? function(t4, e4, r3) {
                return i2.decode(t4.subarray(e4, r3));
              }(this.buf, e3, t3) : function(t4, e4, r3) {
                for (var n3 = "", i3 = e4; i3 < r3; ) {
                  var s3, o3, a3, l3 = t4[i3], u3 = null, c3 = l3 > 239 ? 4 : l3 > 223 ? 3 : l3 > 191 ? 2 : 1;
                  if (i3 + c3 > r3) break;
                  1 === c3 ? l3 < 128 && (u3 = l3) : 2 === c3 ? 128 == (192 & (s3 = t4[i3 + 1])) && (u3 = (31 & l3) << 6 | 63 & s3) <= 127 && (u3 = null) : 3 === c3 ? (o3 = t4[i3 + 2], 128 == (192 & (s3 = t4[i3 + 1])) && 128 == (192 & o3) && ((u3 = (15 & l3) << 12 | (63 & s3) << 6 | 63 & o3) <= 2047 || u3 >= 55296 && u3 <= 57343) && (u3 = null)) : 4 === c3 && (o3 = t4[i3 + 2], a3 = t4[i3 + 3], 128 == (192 & (s3 = t4[i3 + 1])) && 128 == (192 & o3) && 128 == (192 & a3) && ((u3 = (15 & l3) << 18 | (63 & s3) << 12 | (63 & o3) << 6 | 63 & a3) <= 65535 || u3 >= 1114112) && (u3 = null)), null === u3 ? (u3 = 65533, c3 = 1) : u3 > 65535 && (u3 -= 65536, n3 += String.fromCharCode(u3 >>> 10 & 1023 | 55296), u3 = 56320 | 1023 & u3), n3 += String.fromCharCode(u3), i3 += c3;
                }
                return n3;
              }(this.buf, e3, t3);
            }, readBytes: function() {
              var t3 = this.readVarint() + this.pos, e3 = this.buf.subarray(this.pos, t3);
              return this.pos = t3, e3;
            }, readPackedVarint: function(t3, r3) {
              if (this.type !== e2.Bytes) return t3.push(this.readVarint(r3));
              var n3 = s2(this);
              for (t3 = t3 || []; this.pos < n3; ) t3.push(this.readVarint(r3));
              return t3;
            }, readPackedSVarint: function(t3) {
              if (this.type !== e2.Bytes) return t3.push(this.readSVarint());
              var r3 = s2(this);
              for (t3 = t3 || []; this.pos < r3; ) t3.push(this.readSVarint());
              return t3;
            }, readPackedBoolean: function(t3) {
              if (this.type !== e2.Bytes) return t3.push(this.readBoolean());
              var r3 = s2(this);
              for (t3 = t3 || []; this.pos < r3; ) t3.push(this.readBoolean());
              return t3;
            }, readPackedFloat: function(t3) {
              if (this.type !== e2.Bytes) return t3.push(this.readFloat());
              var r3 = s2(this);
              for (t3 = t3 || []; this.pos < r3; ) t3.push(this.readFloat());
              return t3;
            }, readPackedDouble: function(t3) {
              if (this.type !== e2.Bytes) return t3.push(this.readDouble());
              var r3 = s2(this);
              for (t3 = t3 || []; this.pos < r3; ) t3.push(this.readDouble());
              return t3;
            }, readPackedFixed32: function(t3) {
              if (this.type !== e2.Bytes) return t3.push(this.readFixed32());
              var r3 = s2(this);
              for (t3 = t3 || []; this.pos < r3; ) t3.push(this.readFixed32());
              return t3;
            }, readPackedSFixed32: function(t3) {
              if (this.type !== e2.Bytes) return t3.push(this.readSFixed32());
              var r3 = s2(this);
              for (t3 = t3 || []; this.pos < r3; ) t3.push(this.readSFixed32());
              return t3;
            }, readPackedFixed64: function(t3) {
              if (this.type !== e2.Bytes) return t3.push(this.readFixed64());
              var r3 = s2(this);
              for (t3 = t3 || []; this.pos < r3; ) t3.push(this.readFixed64());
              return t3;
            }, readPackedSFixed64: function(t3) {
              if (this.type !== e2.Bytes) return t3.push(this.readSFixed64());
              var r3 = s2(this);
              for (t3 = t3 || []; this.pos < r3; ) t3.push(this.readSFixed64());
              return t3;
            }, skip: function(t3) {
              var r3 = 7 & t3;
              if (r3 === e2.Varint) for (; this.buf[this.pos++] > 127; ) ;
              else if (r3 === e2.Bytes) this.pos = this.readVarint() + this.pos;
              else if (r3 === e2.Fixed32) this.pos += 4;
              else {
                if (r3 !== e2.Fixed64) throw new Error("Unimplemented type: " + r3);
                this.pos += 8;
              }
            }, writeTag: function(t3, e3) {
              this.writeVarint(t3 << 3 | e3);
            }, realloc: function(t3) {
              for (var e3 = this.length || 16; e3 < this.pos + t3; ) e3 *= 2;
              if (e3 !== this.length) {
                var r3 = new Uint8Array(e3);
                r3.set(this.buf), this.buf = r3, this.length = e3;
              }
            }, finish: function() {
              return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            }, writeFixed32: function(t3) {
              this.realloc(4), x2(this.buf, t3, this.pos), this.pos += 4;
            }, writeSFixed32: function(t3) {
              this.realloc(4), x2(this.buf, t3, this.pos), this.pos += 4;
            }, writeFixed64: function(t3) {
              this.realloc(8), x2(this.buf, -1 & t3, this.pos), x2(this.buf, Math.floor(t3 * n2), this.pos + 4), this.pos += 8;
            }, writeSFixed64: function(t3) {
              this.realloc(8), x2(this.buf, -1 & t3, this.pos), x2(this.buf, Math.floor(t3 * n2), this.pos + 4), this.pos += 8;
            }, writeVarint: function(t3) {
              (t3 = +t3 || 0) > 268435455 || t3 < 0 ? function(t4, e3) {
                var r3, n3;
                if (t4 >= 0 ? (r3 = t4 % 4294967296 | 0, n3 = t4 / 4294967296 | 0) : (n3 = ~(-t4 / 4294967296), 4294967295 ^ (r3 = ~(-t4 % 4294967296)) ? r3 = r3 + 1 | 0 : (r3 = 0, n3 = n3 + 1 | 0)), t4 >= 18446744073709552e3 || t4 < -18446744073709552e3) throw new Error("Given varint doesn't fit into 10 bytes");
                e3.realloc(10), function(t5, e4, r4) {
                  r4.buf[r4.pos++] = 127 & t5 | 128, t5 >>>= 7, r4.buf[r4.pos++] = 127 & t5 | 128, t5 >>>= 7, r4.buf[r4.pos++] = 127 & t5 | 128, t5 >>>= 7, r4.buf[r4.pos++] = 127 & t5 | 128, r4.buf[r4.pos] = 127 & (t5 >>>= 7);
                }(r3, 0, e3), function(t5, e4) {
                  var r4 = (7 & t5) << 4;
                  e4.buf[e4.pos++] |= r4 | ((t5 >>>= 3) ? 128 : 0), t5 && (e4.buf[e4.pos++] = 127 & t5 | ((t5 >>>= 7) ? 128 : 0), t5 && (e4.buf[e4.pos++] = 127 & t5 | ((t5 >>>= 7) ? 128 : 0), t5 && (e4.buf[e4.pos++] = 127 & t5 | ((t5 >>>= 7) ? 128 : 0), t5 && (e4.buf[e4.pos++] = 127 & t5 | ((t5 >>>= 7) ? 128 : 0), t5 && (e4.buf[e4.pos++] = 127 & t5)))));
                }(n3, e3);
              }(t3, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t3 | (t3 > 127 ? 128 : 0), t3 <= 127 || (this.buf[this.pos++] = 127 & (t3 >>>= 7) | (t3 > 127 ? 128 : 0), t3 <= 127 || (this.buf[this.pos++] = 127 & (t3 >>>= 7) | (t3 > 127 ? 128 : 0), t3 <= 127 || (this.buf[this.pos++] = t3 >>> 7 & 127))));
            }, writeSVarint: function(t3) {
              this.writeVarint(t3 < 0 ? 2 * -t3 - 1 : 2 * t3);
            }, writeBoolean: function(t3) {
              this.writeVarint(Boolean(t3));
            }, writeString: function(t3) {
              t3 = String(t3), this.realloc(4 * t3.length), this.pos++;
              var e3 = this.pos;
              this.pos = function(t4, e4, r4) {
                for (var n3, i3, s3 = 0; s3 < e4.length; s3++) {
                  if ((n3 = e4.charCodeAt(s3)) > 55295 && n3 < 57344) {
                    if (!i3) {
                      n3 > 56319 || s3 + 1 === e4.length ? (t4[r4++] = 239, t4[r4++] = 191, t4[r4++] = 189) : i3 = n3;
                      continue;
                    }
                    if (n3 < 56320) {
                      t4[r4++] = 239, t4[r4++] = 191, t4[r4++] = 189, i3 = n3;
                      continue;
                    }
                    n3 = i3 - 55296 << 10 | n3 - 56320 | 65536, i3 = null;
                  } else i3 && (t4[r4++] = 239, t4[r4++] = 191, t4[r4++] = 189, i3 = null);
                  n3 < 128 ? t4[r4++] = n3 : (n3 < 2048 ? t4[r4++] = n3 >> 6 | 192 : (n3 < 65536 ? t4[r4++] = n3 >> 12 | 224 : (t4[r4++] = n3 >> 18 | 240, t4[r4++] = n3 >> 12 & 63 | 128), t4[r4++] = n3 >> 6 & 63 | 128), t4[r4++] = 63 & n3 | 128);
                }
                return r4;
              }(this.buf, t3, this.pos);
              var r3 = this.pos - e3;
              r3 >= 128 && a2(e3, r3, this), this.pos = e3 - 1, this.writeVarint(r3), this.pos += r3;
            }, writeFloat: function(e3) {
              this.realloc(4), t2.write(this.buf, e3, this.pos, true, 23, 4), this.pos += 4;
            }, writeDouble: function(e3) {
              this.realloc(8), t2.write(this.buf, e3, this.pos, true, 52, 8), this.pos += 8;
            }, writeBytes: function(t3) {
              var e3 = t3.length;
              this.writeVarint(e3), this.realloc(e3);
              for (var r3 = 0; r3 < e3; r3++) this.buf[this.pos++] = t3[r3];
            }, writeRawMessage: function(t3, e3) {
              this.pos++;
              var r3 = this.pos;
              t3(e3, this);
              var n3 = this.pos - r3;
              n3 >= 128 && a2(r3, n3, this), this.pos = r3 - 1, this.writeVarint(n3), this.pos += n3;
            }, writeMessage: function(t3, r3, n3) {
              this.writeTag(t3, e2.Bytes), this.writeRawMessage(r3, n3);
            }, writePackedVarint: function(t3, e3) {
              e3.length && this.writeMessage(t3, l2, e3);
            }, writePackedSVarint: function(t3, e3) {
              e3.length && this.writeMessage(t3, u2, e3);
            }, writePackedBoolean: function(t3, e3) {
              e3.length && this.writeMessage(t3, p3, e3);
            }, writePackedFloat: function(t3, e3) {
              e3.length && this.writeMessage(t3, c2, e3);
            }, writePackedDouble: function(t3, e3) {
              e3.length && this.writeMessage(t3, h3, e3);
            }, writePackedFixed32: function(t3, e3) {
              e3.length && this.writeMessage(t3, f2, e3);
            }, writePackedSFixed32: function(t3, e3) {
              e3.length && this.writeMessage(t3, d2, e3);
            }, writePackedFixed64: function(t3, e3) {
              e3.length && this.writeMessage(t3, m2, e3);
            }, writePackedSFixed64: function(t3, e3) {
              e3.length && this.writeMessage(t3, y2, e3);
            }, writeBytesField: function(t3, r3) {
              this.writeTag(t3, e2.Bytes), this.writeBytes(r3);
            }, writeFixed32Field: function(t3, r3) {
              this.writeTag(t3, e2.Fixed32), this.writeFixed32(r3);
            }, writeSFixed32Field: function(t3, r3) {
              this.writeTag(t3, e2.Fixed32), this.writeSFixed32(r3);
            }, writeFixed64Field: function(t3, r3) {
              this.writeTag(t3, e2.Fixed64), this.writeFixed64(r3);
            }, writeSFixed64Field: function(t3, r3) {
              this.writeTag(t3, e2.Fixed64), this.writeSFixed64(r3);
            }, writeVarintField: function(t3, r3) {
              this.writeTag(t3, e2.Varint), this.writeVarint(r3);
            }, writeSVarintField: function(t3, r3) {
              this.writeTag(t3, e2.Varint), this.writeSVarint(r3);
            }, writeStringField: function(t3, r3) {
              this.writeTag(t3, e2.Bytes), this.writeString(r3);
            }, writeFloatField: function(t3, r3) {
              this.writeTag(t3, e2.Fixed32), this.writeFloat(r3);
            }, writeDoubleField: function(t3, r3) {
              this.writeTag(t3, e2.Fixed64), this.writeDouble(r3);
            }, writeBooleanField: function(t3, e3) {
              this.writeVarintField(t3, Boolean(e3));
            } }, im;
          }
          var um = dt(lm());
          const cm = 3;
          function hm(t2, e2, r2) {
            e2.glyphs = [], 1 === t2 && r2.readMessage(pm, e2);
          }
          function pm(t2, e2, r2) {
            if (3 === t2) {
              const { id: t3, bitmap: n2, width: i2, height: s2, left: o2, top: a2, advance: l2 } = r2.readMessage(fm, {});
              e2.glyphs.push({ id: t3, bitmap: new mh({ width: i2 + 2 * cm, height: s2 + 2 * cm }, n2), metrics: { width: i2, height: s2, left: o2, top: a2, advance: l2 } });
            } else 4 === t2 ? e2.ascender = r2.readSVarint() : 5 === t2 && (e2.descender = r2.readSVarint());
          }
          function fm(t2, e2, r2) {
            1 === t2 ? e2.id = r2.readVarint() : 2 === t2 ? e2.bitmap = r2.readBytes() : 3 === t2 ? e2.width = r2.readVarint() : 4 === t2 ? e2.height = r2.readVarint() : 5 === t2 ? e2.left = r2.readSVarint() : 6 === t2 ? e2.top = r2.readSVarint() : 7 === t2 && (e2.advance = r2.readVarint());
          }
          const dm = cm, mm = { horizontal: 1, vertical: 2, horizontalOnly: 3 };
          class ym {
            constructor() {
              this.scale = 1, this.fontStack = "", this.image = null;
            }
            static forText(t2, e2) {
              const r2 = new ym();
              return r2.scale = t2 || 1, r2.fontStack = e2, r2;
            }
            static forImage(t2) {
              const e2 = new ym();
              return e2.image = t2, e2;
            }
          }
          class gm {
            constructor() {
              this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(t2, e2, r2) {
              const n2 = new gm();
              for (let i2 = 0; i2 < t2.sections.length; i2++) {
                const s2 = t2.sections[i2];
                s2.image ? n2.addImageSection(s2, r2) : n2.addTextSection(s2, e2);
              }
              return n2;
            }
            length() {
              return this.text.length;
            }
            getSection(t2) {
              return this.sections[this.sectionIndex[t2]];
            }
            getSections() {
              return this.sections;
            }
            getSectionIndex(t2) {
              return this.sectionIndex[t2];
            }
            getCodePoint(t2) {
              return this.text.codePointAt(t2);
            }
            verticalizePunctuation(t2) {
              this.text = function(t3, e2) {
                let r2 = "";
                for (let n2 = 0; n2 < t3.length; n2++) {
                  const i2 = t3.charCodeAt(n2 + 1) || null, s2 = t3.charCodeAt(n2 - 1) || null;
                  r2 += !e2 && (i2 && eo(i2) && !tm[t3[n2 + 1]] || s2 && eo(s2) && !tm[t3[n2 - 1]]) || !tm[t3[n2]] ? t3[n2] : tm[t3[n2]];
                }
                return r2;
              }(this.text, t2);
            }
            trim() {
              let t2 = 0;
              for (let e3 = 0; e3 < this.text.length && vm[this.text.charCodeAt(e3)]; e3++) t2++;
              let e2 = this.text.length;
              for (let r2 = this.text.length - 1; r2 >= 0 && r2 >= t2 && vm[this.text.charCodeAt(r2)]; r2--) e2--;
              this.text = this.text.substring(t2, e2), this.sectionIndex = this.sectionIndex.slice(t2, e2);
            }
            substring(t2, e2) {
              const r2 = new gm();
              return r2.text = this.text.substring(t2, e2), r2.sectionIndex = this.sectionIndex.slice(t2, e2), r2.sections = this.sections, r2;
            }
            toString() {
              return this.text;
            }
            getMaxScale() {
              return this.sectionIndex.reduce((t2, e2) => Math.max(t2, this.sections[e2].scale), 0);
            }
            addTextSection(t2, e2) {
              this.text += t2.text, this.sections.push(ym.forText(t2.scale, t2.fontStack || e2));
              const r2 = this.sections.length - 1;
              for (let e3 = 0; e3 < t2.text.length; ++e3) this.sectionIndex.push(r2);
            }
            addImageSection(t2, e2) {
              const r2 = t2.image ? t2.image.getPrimary() : null;
              if (!r2) return void Gt("Can't add FormattedSection with an empty image.");
              r2.scaleSelf(e2);
              const n2 = this.getNextImageSectionCharCode();
              n2 ? (this.text += String.fromCodePoint(n2), this.sections.push(ym.forImage(r2)), this.sectionIndex.push(this.sections.length - 1)) : Gt("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
              return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
          }
          function xm(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2 = 1) {
            const y2 = gm.fromFeature(t2, i2, m2);
            h3 === mm.vertical && y2.verticalizePunctuation(p3);
            let g2 = [];
            const x2 = function(t3, e3, r3, n3, i3, s3) {
              if (!t3) return [];
              const o3 = [], a3 = function(t4, e4, r4, n4, i4, s4) {
                let o4 = 0;
                for (let r5 = 0; r5 < t4.length(); r5++) {
                  const a4 = t4.getSection(r5);
                  o4 += wm(t4.getCodePoint(r5), a4, n4, i4, e4, s4);
                }
                return o4 / Math.max(1, Math.ceil(o4 / r4));
              }(t3, e3, r3, n3, i3, s3), l3 = t3.text.indexOf("\u200B") >= 0;
              let u3 = 0;
              for (let r4 = 0; r4 < t3.length(); r4++) {
                const h4 = t3.getSection(r4), p4 = t3.getCodePoint(r4);
                if (vm[p4] || (u3 += wm(p4, h4, n3, i3, e3, s3)), r4 < t3.length() - 1) {
                  const e4 = !((c3 = p4) < 11904 || !(Ys["Bopomofo Extended"](c3) || Ys.Bopomofo(c3) || Ys["CJK Compatibility Forms"](c3) || Ys["CJK Compatibility Ideographs"](c3) || Ys["CJK Compatibility"](c3) || Ys["CJK Radicals Supplement"](c3) || Ys["CJK Strokes"](c3) || Ys["CJK Symbols and Punctuation"](c3) || Ys["CJK Unified Ideographs Extension A"](c3) || Ys["CJK Unified Ideographs"](c3) || Ys["Enclosed CJK Letters and Months"](c3) || Ys["Halfwidth and Fullwidth Forms"](c3) || Ys.Hiragana(c3) || Ys["Ideographic Description Characters"](c3) || Ys["Kangxi Radicals"](c3) || Ys["Katakana Phonetic Extensions"](c3) || Ys.Katakana(c3) || Ys["Vertical Forms"](c3) || Ys["Yi Radicals"](c3) || Ys["Yi Syllables"](c3)));
                  (bm[p4] || e4 || h4.image) && o3.push(Mm(r4 + 1, u3, a3, o3, Am(p4, t3.getCodePoint(r4 + 1), e4 && l3), false));
                }
              }
              var c3;
              return Im(Mm(t3.length(), u3, a3, o3, 0, true));
            }(y2, u2, s2, e2, n2, f2), { processBidirectionalText: v2, processStyledBidirectionalText: b2 } = yo;
            if (v2 && 1 === y2.sections.length) {
              const t3 = v2(y2.toString(), x2);
              for (const e3 of t3) {
                const t4 = new gm();
                t4.text = e3, t4.sections = y2.sections;
                for (let r3 = 0; r3 < e3.length; r3++) t4.sectionIndex.push(0);
                g2.push(t4);
              }
            } else if (b2) {
              const t3 = b2(y2.text, y2.sectionIndex, x2);
              for (const e3 of t3) {
                const t4 = new gm();
                t4.text = e3[0], t4.sectionIndex = e3[1], t4.sections = y2.sections, g2.push(t4);
              }
            } else g2 = function(t3, e3) {
              const r3 = [], n3 = t3.text;
              let i3 = 0;
              for (const n4 of e3) r3.push(t3.substring(i3, n4)), i3 = n4;
              return i3 < n3.length && r3.push(t3.substring(i3, n3.length)), r3;
            }(y2, x2);
            const w2 = [], _2 = { positionedLines: w2, text: y2.toString(), top: c2[1], bottom: c2[1], left: c2[0], right: c2[0], writingMode: h3, iconsInText: false, verticalizable: false, hasBaseline: false };
            if (function(t3, e3, r3, n3, i3, s3, o3, a3, l3, u3, c3, h4) {
              let p4 = 0, f3 = 0, d3 = 0;
              const m3 = "right" === a3 ? 1 : "left" === a3 ? 0 : 0.5;
              let y3 = false;
              for (const t4 of i3) {
                const r4 = t4.getSections();
                for (const t5 of r4) {
                  if (t5.image) continue;
                  const r5 = e3[t5.fontStack];
                  if (r5 && (y3 = void 0 !== r5.ascender && void 0 !== r5.descender, !y3)) break;
                }
                if (!y3) break;
              }
              let g3 = 0;
              for (const o4 of i3) {
                o4.trim();
                const i4 = o4.getMaxScale(), a4 = (i4 - 1) * Jd, v4 = { positionedGlyphs: [], lineOffset: 0 };
                t3.positionedLines[g3] = v4;
                const b4 = v4.positionedGlyphs;
                let w4 = 0;
                if (!o4.length()) {
                  f3 += s3, ++g3;
                  continue;
                }
                let _3 = 0, A2 = 0;
                for (let s4 = 0; s4 < o4.length(); s4++) {
                  const a5 = o4.getSection(s4), d4 = o4.getSectionIndex(s4), m4 = o4.getCodePoint(s4);
                  let g4 = a5.scale, v5 = null, M3 = null, I2 = null, S2 = Jd, z2 = 0;
                  l3 === mm.vertical && (12312 === (x3 = m4) || 12313 === x3 || 12316 === x3 || 12540 === x3 || 12448 === x3) && (l3 = mm.horizontal);
                  const k2 = !(l3 === mm.horizontal || !c3 && !to(m4) || c3 && (vm[m4] || ro(m4)));
                  if (a5.image) {
                    const e4 = n3.get(a5.image.toString());
                    if (!e4) continue;
                    I2 = a5.image, t3.iconsInText = t3.iconsInText || true, M3 = e4.paddedRect;
                    const r4 = e4.displaySize;
                    g4 = g4 * Jd / h4, v5 = { width: r4[0], height: r4[1], left: 0, top: -3, advance: k2 ? r4[1] : r4[0], localGlyph: false }, z2 = y3 ? -v5.height * g4 : i4 * Jd - 17 - r4[1] * g4, S2 = v5.advance;
                    const s5 = (k2 ? r4[0] : r4[1]) * g4 - Jd * i4;
                    s5 > 0 && s5 > w4 && (w4 = s5);
                  } else {
                    const t4 = r3[a5.fontStack];
                    if (!t4) continue;
                    t4[m4] && (M3 = t4[m4]);
                    const n4 = e3[a5.fontStack];
                    if (!n4) continue;
                    const s5 = n4.glyphs[m4];
                    if (!s5) continue;
                    if (v5 = s5.metrics, S2 = 8203 !== m4 ? Jd : 0, y3) {
                      const t5 = void 0 !== n4.ascender ? Math.abs(n4.ascender) : 0, e4 = void 0 !== n4.descender ? Math.abs(n4.descender) : 0, r4 = (t5 + e4) * g4;
                      _3 < r4 && (_3 = r4, A2 = (t5 - e4) / 2 * g4), z2 = -t5 * g4;
                    } else z2 = (i4 - g4) * Jd - 17;
                  }
                  k2 ? (t3.verticalizable = true, b4.push({ glyph: m4, image: I2, x: p4, y: f3 + z2, vertical: k2, scale: g4, localGlyph: v5.localGlyph, fontStack: a5.fontStack, sectionIndex: d4, metrics: v5, rect: M3 }), p4 += S2 * g4 + u3) : (b4.push({ glyph: m4, image: I2, x: p4, y: f3 + z2, vertical: k2, scale: g4, localGlyph: v5.localGlyph, fontStack: a5.fontStack, sectionIndex: d4, metrics: v5, rect: M3 }), p4 += v5.advance * g4 + u3);
                }
                0 !== b4.length && (d3 = Math.max(p4 - u3, d3), y3 ? zm(b4, m3, w4, A2, s3 * i4 / 2) : zm(b4, m3, w4, 0, s3 / 2)), p4 = 0;
                const M2 = s3 * i4 + w4;
                v4.lineOffset = Math.max(w4, a4), f3 += M2, ++g3;
              }
              var x3;
              const v3 = f3, { horizontalAlign: b3, verticalAlign: w3 } = Sm(o3);
              (function(t4, e4, r4, n4, i4, s4) {
                const o4 = (e4 - r4) * i4, a4 = -s4 * n4;
                for (const e5 of t4) for (const t5 of e5.positionedGlyphs) t5.x += o4, t5.y += a4;
              })(t3.positionedLines, m3, b3, w3, d3, v3), t3.top += -w3 * v3, t3.bottom = t3.top + v3, t3.left += -b3 * d3, t3.right = t3.left + d3, t3.hasBaseline = y3;
            }(_2, e2, r2, n2, g2, o2, a2, l2, h3, u2, p3, d2), !function(t3) {
              for (const e3 of t3) if (0 !== e3.positionedGlyphs.length) return false;
              return true;
            }(w2)) return _2;
          }
          const vm = { 9: true, 10: true, 11: true, 12: true, 13: true, 32: true }, bm = { 10: true, 32: true, 38: true, 40: true, 41: true, 43: true, 45: true, 47: true, 173: true, 183: true, 8203: true, 8208: true, 8211: true, 8231: true };
          function wm(t2, e2, r2, n2, i2, s2) {
            if (e2.image) {
              const t3 = n2.get(e2.image.toString());
              return t3 ? t3.displaySize[0] * e2.scale * Jd / s2 + i2 : 0;
            }
            {
              const n3 = r2[e2.fontStack], s3 = n3 && n3.glyphs[t2];
              return s3 ? s3.metrics.advance * e2.scale + i2 : 0;
            }
          }
          function _m(t2, e2, r2, n2) {
            const i2 = Math.pow(t2 - e2, 2);
            return n2 ? t2 < e2 ? i2 / 2 : 2 * i2 : i2 + Math.abs(r2) * r2;
          }
          function Am(t2, e2, r2) {
            let n2 = 0;
            return 10 === t2 && (n2 -= 1e4), r2 && (n2 += 150), 40 !== t2 && 65288 !== t2 || (n2 += 50), 41 !== e2 && 65289 !== e2 || (n2 += 50), n2;
          }
          function Mm(t2, e2, r2, n2, i2, s2) {
            let o2 = null, a2 = _m(e2, r2, i2, s2);
            for (const t3 of n2) {
              const n3 = _m(e2 - t3.x, r2, i2, s2) + t3.badness;
              n3 <= a2 && (o2 = t3, a2 = n3);
            }
            return { index: t2, x: e2, priorBreak: o2, badness: a2 };
          }
          function Im(t2) {
            return t2 ? Im(t2.priorBreak).concat(t2.index) : [];
          }
          function Sm(t2) {
            let e2 = 0.5, r2 = 0.5;
            switch (t2) {
              case "right":
              case "top-right":
              case "bottom-right":
                e2 = 1;
                break;
              case "left":
              case "top-left":
              case "bottom-left":
                e2 = 0;
            }
            switch (t2) {
              case "bottom":
              case "bottom-right":
              case "bottom-left":
                r2 = 1;
                break;
              case "top":
              case "top-right":
              case "top-left":
                r2 = 0;
            }
            return { horizontalAlign: e2, verticalAlign: r2 };
          }
          function zm(t2, e2, r2, n2, i2) {
            if (!(e2 || r2 || n2 || i2)) return;
            const s2 = t2.length - 1, o2 = t2[s2], a2 = (o2.x + o2.metrics.advance * o2.scale) * e2;
            for (let e3 = 0; e3 <= s2; e3++) t2[e3].x -= a2, t2[e3].y += r2 + n2 + i2;
          }
          function km(t2) {
            return void 0 !== t2.imagePrimary && void 0 !== t2.top && void 0 !== t2.bottom && void 0 !== t2.left && void 0 !== t2.right;
          }
          function Pm(t2, e2, r2, n2) {
            const { horizontalAlign: i2, verticalAlign: s2 } = Sm(n2), o2 = r2[0] - t2.displaySize[0] * i2, a2 = r2[1] - t2.displaySize[1] * s2;
            return { imagePrimary: t2, imageSecondary: e2, top: a2, bottom: a2 + t2.displaySize[1], left: o2, right: o2 + t2.displaySize[0] };
          }
          function Em(t2, e2, r2, n2, i2, s2) {
            const o2 = t2.imagePrimary;
            let a2;
            if (o2.content) {
              const t3 = o2.content, e3 = o2.pixelRatio || 1;
              a2 = [t3[0] / e3, t3[1] / e3, o2.displaySize[0] - t3[2] / e3, o2.displaySize[1] - t3[3] / e3];
            }
            const l2 = e2.left * s2, u2 = e2.right * s2;
            let c2, h3, p3, f2;
            "width" === r2 || "both" === r2 ? (f2 = i2[0] + l2 - n2[3], h3 = i2[0] + u2 + n2[1]) : (f2 = i2[0] + (l2 + u2 - o2.displaySize[0]) / 2, h3 = f2 + o2.displaySize[0]);
            const d2 = e2.top * s2, m2 = e2.bottom * s2;
            return "height" === r2 || "both" === r2 ? (c2 = i2[1] + d2 - n2[0], p3 = i2[1] + m2 + n2[2]) : (c2 = i2[1] + (d2 + m2 - o2.displaySize[1]) / 2, p3 = c2 + o2.displaySize[1]), { imagePrimary: o2, imageSecondary: void 0, top: c2, right: h3, bottom: p3, left: f2, collisionPadding: a2 };
          }
          function Tm(t2) {
            return !t2.imagePrimary.stretchX;
          }
          function Bm(t2) {
            return !t2.imagePrimary.stretchY;
          }
          function Vm(t2) {
            return { width: t2.right - t2.left, height: t2.bottom - t2.top };
          }
          const Cm = 128;
          function Fm(t2, e2, r2) {
            const { expression: n2 } = e2;
            if ("constant" === n2.kind) return { kind: "constant", layoutSize: n2.evaluate(new go(t2 + 1, { worldview: r2 })) };
            if ("source" === n2.kind) return { kind: "source" };
            {
              const { zoomStops: e3, interpolationType: i2 } = n2;
              let s2 = 0;
              for (; s2 < e3.length && e3[s2] <= t2; ) s2++;
              s2 = Math.max(0, s2 - 1);
              let o2 = s2;
              for (; o2 < e3.length && e3[o2] < t2 + 1; ) o2++;
              o2 = Math.min(e3.length - 1, o2);
              const a2 = e3[s2], l2 = e3[o2];
              return "composite" === n2.kind ? { kind: "composite", minZoom: a2, maxZoom: l2, interpolationType: i2 } : { kind: "camera", minZoom: a2, maxZoom: l2, minSize: n2.evaluate(new go(a2, { worldview: r2 })), maxSize: n2.evaluate(new go(l2, { worldview: r2 })), interpolationType: i2 };
            }
          }
          function Dm(t2, { uSize: e2, uSizeT: r2 }, { lowerSize: n2, upperSize: i2 }) {
            return "source" === t2.kind ? n2 / Cm : "composite" === t2.kind ? ur(n2 / Cm, i2 / Cm, r2) : e2;
          }
          function Lm(t2, e2, r2 = 1) {
            let n2 = 0, i2 = 0;
            if ("constant" === t2.kind) i2 = t2.layoutSize * r2;
            else if ("source" !== t2.kind) {
              const { interpolationType: s2, minZoom: o2, maxZoom: a2 } = t2, l2 = s2 ? Et(ji.interpolationFactor(s2, e2, o2, a2), 0, 1) : 0;
              "camera" === t2.kind ? i2 = ur(t2.minSize, t2.maxSize, l2) * r2 : n2 = l2 * r2;
            }
            return { uSizeT: n2, uSize: i2 };
          }
          class Rm extends bt {
            constructor(t2, e2, r2, n2, i2) {
              super(t2, e2), this.angle = n2, this.z = r2, void 0 !== i2 && (this.segment = i2);
            }
            clone() {
              return new Rm(this.x, this.y, this.z, this.angle, this.segment);
            }
          }
          function Om(t2, e2, r2, n2, i2) {
            if (void 0 === e2.segment) return true;
            let s2 = e2, o2 = e2.segment + 1, a2 = 0;
            for (; a2 > -r2 / 2; ) {
              if (o2--, o2 < 0) return false;
              a2 -= t2[o2].dist(s2), s2 = t2[o2];
            }
            a2 += t2[o2].dist(t2[o2 + 1]), o2++;
            const l2 = [];
            let u2 = 0;
            for (; a2 < r2 / 2; ) {
              const e3 = t2[o2], r3 = t2[o2 + 1];
              if (!r3) return false;
              let s3 = t2[o2 - 1].angleTo(e3) - e3.angleTo(r3);
              for (s3 = Math.abs((s3 + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l2.push({ distance: a2, angleDelta: s3 }), u2 += s3; a2 - l2[0].distance > n2; ) u2 -= l2.shift().angleDelta;
              if (u2 > i2) return false;
              o2++, a2 += e3.dist(r3);
            }
            return true;
          }
          function Um(t2) {
            let e2 = 0;
            for (let r2 = 0; r2 < t2.length - 1; r2++) e2 += t2[r2].dist(t2[r2 + 1]);
            return e2;
          }
          function Nm(t2, e2, r2) {
            return t2 ? 0.6 * e2 * r2 : 0;
          }
          function jm(t2, e2) {
            return Math.max(t2 ? t2.right - t2.left : 0, e2 ? e2.right - e2.left : 0);
          }
          function $m(t2, e2, r2, n2, i2, s2) {
            const o2 = Nm(r2, i2, s2), a2 = jm(r2, n2) * s2;
            let l2 = 0;
            const u2 = Um(t2) / 2;
            for (let r3 = 0; r3 < t2.length - 1; r3++) {
              const n3 = t2[r3], i3 = t2[r3 + 1], s3 = n3.dist(i3);
              if (l2 + s3 > u2) {
                const c2 = (u2 - l2) / s3, h3 = ur(n3.x, i3.x, c2), p3 = ur(n3.y, i3.y, c2), f2 = new Rm(h3, p3, 0, i3.angleTo(n3), r3);
                return !o2 || Om(t2, f2, a2, o2, e2) ? f2 : void 0;
              }
              l2 += s3;
            }
          }
          function Gm(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            const u2 = Nm(n2, s2, o2), c2 = jm(n2, i2), h3 = c2 * o2, p3 = 0 === t2[0].x || t2[0].x === l2 || 0 === t2[0].y || t2[0].y === l2;
            return e2 - h3 < e2 / 4 && (e2 = h3 + e2 / 4), qm(t2, p3 ? e2 / 2 * a2 % e2 : (c2 / 2 + 2 * s2) * o2 * a2 % e2, e2, u2, r2, h3, p3, false, l2);
          }
          function qm(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            const u2 = s2 / 2, c2 = Um(t2);
            let h3 = 0, p3 = e2 - r2, f2 = [];
            for (let e3 = 0; e3 < t2.length - 1; e3++) {
              const o3 = t2[e3], a3 = t2[e3 + 1], d2 = o3.dist(a3), m2 = a3.angleTo(o3);
              for (; p3 + r2 < h3 + d2; ) {
                p3 += r2;
                const y2 = (p3 - h3) / d2, g2 = ur(o3.x, a3.x, y2), x2 = ur(o3.y, a3.y, y2);
                if (g2 >= 0 && g2 < l2 && x2 >= 0 && x2 < l2 && p3 - u2 >= 0 && p3 + u2 <= c2) {
                  const r3 = new Rm(g2, x2, 0, m2, e3);
                  n2 && !Om(t2, r3, s2, n2, i2) || f2.push(r3);
                }
              }
              h3 += d2;
            }
            return a2 || f2.length || o2 || (f2 = qm(t2, h3 / 2, r2, n2, i2, s2, o2, true, l2)), f2;
          }
          function Hm(t2) {
            let e2 = 0, r2 = 0;
            for (const n3 of t2) e2 += n3.w * n3.h, r2 = Math.max(r2, n3.w);
            t2.sort((t3, e3) => e3.h - t3.h);
            const n2 = [{ x: 0, y: 0, w: Math.max(Math.ceil(Math.sqrt(e2 / 0.95)), r2), h: 1 / 0 }];
            let i2 = 0, s2 = 0;
            for (const e3 of t2) for (let t3 = n2.length - 1; t3 >= 0; t3--) {
              const r3 = n2[t3];
              if (!(e3.w > r3.w || e3.h > r3.h)) {
                if (e3.x = r3.x, e3.y = r3.y, s2 = Math.max(s2, e3.y + e3.h), i2 = Math.max(i2, e3.x + e3.w), e3.w === r3.w && e3.h === r3.h) {
                  const e4 = n2.pop();
                  t3 < n2.length && (n2[t3] = e4);
                } else e3.h === r3.h ? (r3.x += e3.w, r3.w -= e3.w) : e3.w === r3.w ? (r3.y += e3.h, r3.h -= e3.h) : (n2.push({ x: r3.x + e3.w, y: r3.y, w: r3.w - e3.w, h: e3.h }), r3.y += e3.h, r3.h -= e3.h);
                break;
              }
            }
            return { w: i2, h: s2, fill: e2 / (i2 * s2) || 0 };
          }
          qs(Rm, "Anchor");
          const Xm = 1;
          class Zm {
            static getImagePositionScale(t2, e2, r2) {
              if (e2 && t2 && t2.options && t2.options.transform) {
                const e3 = t2.options.transform;
                return { x: e3.a, y: e3.d };
              }
              return { x: r2, y: r2 };
            }
            constructor(t2, e2, r2, n2) {
              this.paddedRect = t2;
              const { pixelRatio: i2, version: s2, stretchX: o2, stretchY: a2, content: l2, sdf: u2, usvg: c2 } = e2;
              this.pixelRatio = i2, this.stretchX = o2, this.stretchY = a2, this.content = l2, this.version = s2, this.padding = r2, this.sdf = u2, this.usvg = c2, this.scale = Zm.getImagePositionScale(n2, c2, i2);
            }
            get tl() {
              return [this.paddedRect.x + this.padding, this.paddedRect.y + this.padding];
            }
            get br() {
              return [this.paddedRect.x + this.paddedRect.w - this.padding, this.paddedRect.y + this.paddedRect.h - this.padding];
            }
            get displaySize() {
              return [(this.paddedRect.w - 2 * this.padding) / this.scale.x, (this.paddedRect.h - 2 * this.padding) / this.scale.y];
            }
          }
          function Wm(t2, e2, r2) {
            const n2 = Fr.parse(t2), i2 = function(t3, e3, r3 = [1, 1]) {
              return { x: 0, y: 0, w: (t3.data ? t3.data.width : t3.width * r3[0]) + 2 * e3, h: (t3.data ? t3.data.height : t3.height * r3[1]) + 2 * e3 };
            }(e2, r2, [n2.options.transform.a, n2.options.transform.d]);
            return { bin: i2, imagePosition: new Zm(i2, e2, r2, n2), imageVariant: n2 };
          }
          class Ym {
            constructor(t2, e2, r2) {
              const n2 = /* @__PURE__ */ new Map(), i2 = /* @__PURE__ */ new Map();
              this.haveRenderCallbacks = [];
              const s2 = [];
              this.addImages(t2, n2, Xm, s2), this.addImages(e2, i2, 2, s2);
              const { w: o2, h: a2 } = Hm(s2), l2 = new yh({ width: o2 || 1, height: a2 || 1 });
              for (const [e3, i3] of t2.entries()) {
                const t3 = n2.get(e3).paddedRect;
                yh.copy(i3.data, l2, { x: 0, y: 0 }, { x: t3.x + Xm, y: t3.y + Xm }, i3.data, r2, i3.sdf);
              }
              for (const [t3, n3] of e2.entries()) {
                const e3 = i2.get(t3), s3 = e3.paddedRect;
                let o3 = e3.padding;
                const a3 = s3.x + o3, u2 = s3.y + o3, c2 = n3.data.width, h3 = n3.data.height;
                o3 = o3 > 1 ? o3 - 1 : o3, yh.copy(n3.data, l2, { x: 0, y: 0 }, { x: a3, y: u2 }, n3.data, r2), yh.copy(n3.data, l2, { x: 0, y: h3 - o3 }, { x: a3, y: u2 - o3 }, { width: c2, height: o3 }, r2), yh.copy(n3.data, l2, { x: 0, y: 0 }, { x: a3, y: u2 + h3 }, { width: c2, height: o3 }, r2), yh.copy(n3.data, l2, { x: c2 - o3, y: 0 }, { x: a3 - o3, y: u2 }, { width: o3, height: h3 }, r2), yh.copy(n3.data, l2, { x: 0, y: 0 }, { x: a3 + c2, y: u2 }, { width: o3, height: h3 }, r2), yh.copy(n3.data, l2, { x: c2 - o3, y: h3 - o3 }, { x: a3 - o3, y: u2 - o3 }, { width: o3, height: o3 }, r2), yh.copy(n3.data, l2, { x: 0, y: h3 - o3 }, { x: a3 + c2, y: u2 - o3 }, { width: o3, height: o3 }, r2), yh.copy(n3.data, l2, { x: 0, y: 0 }, { x: a3 + c2, y: u2 + h3 }, { width: o3, height: o3 }, r2), yh.copy(n3.data, l2, { x: c2 - o3, y: 0 }, { x: a3 - o3, y: u2 + h3 }, { width: o3, height: o3 }, r2);
              }
              this.lut = r2, this.image = l2, this.iconPositions = n2, this.patternPositions = i2;
            }
            addImages(t2, e2, r2, n2) {
              for (const [i2, s2] of t2.entries()) {
                const { bin: t3, imagePosition: o2, imageVariant: a2 } = Wm(i2, s2, r2);
                e2.set(i2, o2), n2.push(t3), s2.hasRenderCallback && this.haveRenderCallbacks.push(a2.id);
              }
            }
            patchUpdatedImages(t2, e2, r2) {
              this.haveRenderCallbacks = this.haveRenderCallbacks.filter((e3) => t2.hasImage(e3, r2)), t2.dispatchRenderCallbacks(this.haveRenderCallbacks, r2);
              for (const n2 of t2.getUpdatedImages(r2)) {
                for (const i2 of this.iconPositions.keys()) {
                  const s2 = Fr.parse(i2);
                  if (er.isEqual(s2.id, n2)) {
                    const s3 = t2.getImage(n2, r2);
                    this.patchUpdatedImage(this.iconPositions.get(i2), s3, e2);
                  }
                }
                for (const i2 of this.patternPositions.keys()) {
                  const s2 = Fr.parse(i2);
                  if (er.isEqual(s2.id, n2)) {
                    const s3 = t2.getImage(n2, r2);
                    this.patchUpdatedImage(this.patternPositions.get(i2), s3, e2);
                  }
                }
              }
            }
            patchUpdatedImage(t2, e2, r2) {
              if (!t2 || !e2) return;
              if (t2.version === e2.version) return;
              t2.version = e2.version;
              const [n2, i2] = t2.tl, s2 = t2.sdf;
              if (this.lut || s2) {
                const t3 = { width: e2.data.width, height: e2.data.height }, o2 = new yh(t3);
                yh.copy(e2.data, o2, { x: 0, y: 0 }, { x: 0, y: 0 }, t3, this.lut, s2), r2.update(o2, { position: { x: n2, y: i2 } });
              } else r2.update(e2.data, { position: { x: n2, y: i2 } });
            }
          }
          qs(Zm, "ImagePosition"), qs(Ym, "ImageAtlas");
          const Km = 1e20;
          function Jm(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            for (let u2 = e2; u2 < e2 + n2; u2++) Qm(t2, r2 * s2 + u2, s2, i2, o2, a2, l2);
            for (let u2 = r2; u2 < r2 + i2; u2++) Qm(t2, u2 * s2 + e2, 1, n2, o2, a2, l2);
          }
          function Qm(t2, e2, r2, n2, i2, s2, o2) {
            s2[0] = 0, o2[0] = -1e20, o2[1] = Km, i2[0] = t2[e2];
            for (let a2 = 1, l2 = 0, u2 = 0; a2 < n2; a2++) {
              i2[a2] = t2[e2 + a2 * r2];
              const n3 = a2 * a2;
              do {
                const t3 = s2[l2];
                u2 = (i2[a2] - i2[t3] + n3 - t3 * t3) / (a2 - t3) / 2;
              } while (u2 <= o2[l2] && --l2 > -1);
              l2++, s2[l2] = a2, o2[l2] = u2, o2[l2 + 1] = Km;
            }
            for (let a2 = 0, l2 = 0; a2 < n2; a2++) {
              for (; o2[l2 + 1] < a2; ) l2++;
              const n3 = s2[l2], u2 = a2 - n3;
              t2[e2 + a2 * r2] = i2[n3] + u2 * u2;
            }
          }
          const ty = 2, ey = { none: 0, ideographs: 1, all: 2 };
          class ry {
            constructor(t2, e2, r2) {
              this.requestManager = t2, this.localGlyphMode = e2, this.localFontFamily = r2, this.urls = {}, this.entries = {}, this.localGlyphs = { 200: {}, 400: {}, 500: {}, 900: {} };
            }
            setURL(t2, e2) {
              this.urls[e2] = t2;
            }
            getGlyphs(t2, e2, r2) {
              const n2 = [], i2 = this.urls[e2] || ne.GLYPHS_URL;
              for (const e3 in t2) for (const r3 of t2[e3]) n2.push({ stack: e3, id: r3 });
              Vt(n2, ({ stack: t3, id: e3 }, r3) => {
                let n3 = this.entries[t3];
                n3 || (n3 = this.entries[t3] = { glyphs: {}, requests: {}, ranges: {}, ascender: void 0, descender: void 0 });
                let s2 = n3.glyphs[e3];
                if (void 0 !== s2) return void r3(null, { stack: t3, id: e3, glyph: s2 });
                if (s2 = this._tinySDF(n3, t3, e3), s2) return n3.glyphs[e3] = s2, void r3(null, { stack: t3, id: e3, glyph: s2 });
                const o2 = Math.floor(e3 / 256);
                if (256 * o2 > 65535) return Gt("glyphs > 65535 not supported"), void r3(null, { stack: t3, id: e3, glyph: s2 });
                if (n3.ranges[o2]) return void r3(null, { stack: t3, id: e3, glyph: s2 });
                let a2 = n3.requests[o2];
                a2 || (a2 = n3.requests[o2] = [], ry.loadGlyphRange(t3, o2, i2, this.requestManager, (t4, e4) => {
                  if (e4) {
                    n3.ascender = e4.ascender, n3.descender = e4.descender;
                    for (const t5 in e4.glyphs) this._doesCharSupportLocalGlyph(+t5) || (n3.glyphs[+t5] = e4.glyphs[+t5]);
                    n3.ranges[o2] = true;
                  }
                  for (const r4 of a2) r4(t4, e4);
                  delete n3.requests[o2];
                })), a2.push((n4, i3) => {
                  n4 ? r3(n4) : i3 && r3(null, { stack: t3, id: e3, glyph: i3.glyphs[e3] || null });
                });
              }, (t3, e3) => {
                if (t3) r2(t3);
                else if (e3) {
                  const t4 = {};
                  for (const { stack: r3, id: n3, glyph: i3 } of e3) void 0 === t4[r3] && (t4[r3] = {}), void 0 === t4[r3].glyphs && (t4[r3].glyphs = {}), t4[r3].glyphs[n3] = i3 && { id: i3.id, bitmap: i3.bitmap.clone(), metrics: i3.metrics }, t4[r3].ascender = this.entries[r3].ascender, t4[r3].descender = this.entries[r3].descender;
                  r2(null, t4);
                }
              });
            }
            _doesCharSupportLocalGlyph(t2) {
              return this.localGlyphMode !== ey.none && (this.localGlyphMode === ey.all ? !!this.localFontFamily : !!this.localFontFamily && (Ys["CJK Unified Ideographs"](t2) || Ys["Hangul Syllables"](t2) || Ys.Hiragana(t2) || Ys.Katakana(t2) || Ys["CJK Symbols and Punctuation"](t2) || Ys["CJK Unified Ideographs Extension A"](t2) || Ys["CJK Unified Ideographs Extension B"](t2) || Ys.Osage(t2)));
            }
            _tinySDF(t2, e2, r2) {
              const n2 = this.localFontFamily;
              if (!n2 || !this._doesCharSupportLocalGlyph(r2)) return;
              let i2 = t2.tinySDF;
              if (!i2) {
                let r3 = "400";
                /bold/i.test(e2) ? r3 = "900" : /medium/i.test(e2) ? r3 = "500" : /light/i.test(e2) && (r3 = "200"), i2 = t2.tinySDF = new ry.TinySDF({ fontFamily: n2, fontWeight: r3, fontSize: 24 * ty, buffer: 3 * ty, radius: 8 * ty }), i2.fontWeight = r3;
              }
              if (this.localGlyphs[i2.fontWeight][r2]) return this.localGlyphs[i2.fontWeight][r2];
              const s2 = String.fromCodePoint(r2), { data: o2, width: a2, height: l2, glyphWidth: u2, glyphHeight: c2, glyphLeft: h3, glyphTop: p3, glyphAdvance: f2 } = i2.draw(s2);
              return this.localGlyphs[i2.fontWeight][r2] = { id: r2, bitmap: new mh({ width: a2, height: l2 }, o2), metrics: { width: u2 / ty, height: c2 / ty, left: h3 / ty, top: p3 / ty - 27, advance: f2 / ty, localGlyph: true } };
            }
          }
          ry.loadGlyphRange = function(t2, e2, r2, n2, i2) {
            const s2 = 256 * e2, o2 = s2 + 255, a2 = n2.transformRequest(n2.normalizeGlyphsURL(r2).replace("{fontstack}", t2).replace("{range}", `${s2}-${o2}`), Be.Glyphs);
            De(a2, (t3, e3) => {
              if (t3) i2(t3);
              else if (e3) {
                const t4 = {}, r3 = function(t5) {
                  return new um(t5).readFields(hm, {});
                }(e3);
                for (const e4 of r3.glyphs) t4[e4.id] = e4;
                i2(null, { glyphs: t4, ascender: r3.ascender, descender: r3.descender });
              }
            });
          }, ry.TinySDF = class {
            constructor({ fontSize: t2 = 24, buffer: e2 = 3, radius: r2 = 8, cutoff: n2 = 0.25, fontFamily: i2 = "sans-serif", fontWeight: s2 = "normal", fontStyle: o2 = "normal" } = {}) {
              this.buffer = e2, this.cutoff = n2, this.radius = r2;
              const a2 = this.size = t2 + 4 * e2, l2 = this._createCanvas(a2), u2 = this.ctx = l2.getContext("2d", { willReadFrequently: true });
              u2.font = `${o2} ${s2} ${t2}px ${i2}`, u2.textBaseline = "alphabetic", u2.textAlign = "left", u2.fillStyle = "black", this.gridOuter = new Float64Array(a2 * a2), this.gridInner = new Float64Array(a2 * a2), this.f = new Float64Array(a2), this.z = new Float64Array(a2 + 1), this.v = new Uint16Array(a2);
            }
            _createCanvas(t2) {
              const e2 = document.createElement("canvas");
              return e2.width = e2.height = t2, e2;
            }
            draw(t2) {
              const { width: e2, actualBoundingBoxAscent: r2, actualBoundingBoxDescent: n2, actualBoundingBoxLeft: i2, actualBoundingBoxRight: s2 } = this.ctx.measureText(t2), o2 = Math.ceil(r2), a2 = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(s2 - i2))), l2 = Math.min(this.size - this.buffer, o2 + Math.ceil(n2)), u2 = a2 + 2 * this.buffer, c2 = l2 + 2 * this.buffer, h3 = Math.max(u2 * c2, 0), p3 = new Uint8ClampedArray(h3), f2 = { data: p3, width: u2, height: c2, glyphWidth: a2, glyphHeight: l2, glyphTop: o2, glyphLeft: 0, glyphAdvance: e2 };
              if (0 === a2 || 0 === l2) return f2;
              const { ctx: d2, buffer: m2, gridInner: y2, gridOuter: g2 } = this;
              d2.clearRect(m2, m2, a2, l2), d2.fillText(t2, m2, m2 + o2);
              const x2 = d2.getImageData(m2, m2, a2, l2);
              g2.fill(Km, 0, h3), y2.fill(0, 0, h3);
              for (let t3 = 0; t3 < l2; t3++) for (let e3 = 0; e3 < a2; e3++) {
                const r3 = x2.data[4 * (t3 * a2 + e3) + 3] / 255;
                if (0 === r3) continue;
                const n3 = (t3 + m2) * u2 + e3 + m2;
                if (1 === r3) g2[n3] = 0, y2[n3] = Km;
                else {
                  const t4 = 0.5 - r3;
                  g2[n3] = t4 > 0 ? t4 * t4 : 0, y2[n3] = t4 < 0 ? t4 * t4 : 0;
                }
              }
              Jm(g2, 0, 0, u2, c2, u2, this.f, this.v, this.z), Jm(y2, m2, m2, a2, l2, u2, this.f, this.v, this.z);
              for (let t3 = 0; t3 < h3; t3++) {
                const e3 = Math.sqrt(g2[t3]) - Math.sqrt(y2[t3]);
                p3[t3] = Math.round(255 - 255 * (e3 / this.radius + this.cutoff));
              }
              return f2;
            }
          };
          const ny = Xm;
          function iy(t2, e2) {
            return t2 + e2[1] - e2[0];
          }
          function sy(t2, e2, r2, n2, i2 = 1) {
            const s2 = [], o2 = t2.imagePrimary, a2 = o2.pixelRatio, l2 = o2.paddedRect.w - 2 * ny, u2 = o2.paddedRect.h - 2 * ny, c2 = (t2.right - t2.left) * i2, h3 = (t2.bottom - t2.top) * i2, p3 = o2.stretchX || [[0, l2]], f2 = o2.stretchY || [[0, u2]], d2 = p3.reduce(iy, 0), m2 = f2.reduce(iy, 0), y2 = l2 - d2, g2 = u2 - m2;
            let x2 = 0, v2 = d2, b2 = 0, w2 = m2, _2 = 0, A2 = y2, M2 = 0, I2 = g2;
            if (o2.content && n2) {
              const t3 = o2.content;
              x2 = oy(p3, 0, t3[0]), b2 = oy(f2, 0, t3[1]), v2 = oy(p3, t3[0], t3[2]), w2 = oy(f2, t3[1], t3[3]), _2 = t3[0] - x2, M2 = t3[1] - b2, A2 = t3[2] - t3[0] - v2, I2 = t3[3] - t3[1] - w2;
            }
            const S2 = (n3, s3, l3, u3) => {
              const p4 = ly(n3.stretch - x2, v2, c2, t2.left * i2), f3 = uy(n3.fixed - _2, A2, n3.stretch, d2), y3 = ly(s3.stretch - b2, w2, h3, t2.top * i2), g3 = uy(s3.fixed - M2, I2, s3.stretch, m2), S3 = ly(l3.stretch - x2, v2, c2, t2.left * i2), z2 = uy(l3.fixed - _2, A2, l3.stretch, d2), k2 = ly(u3.stretch - b2, w2, h3, t2.top * i2), P2 = uy(u3.fixed - M2, I2, u3.stretch, m2), E2 = new bt(p4, y3), T2 = new bt(S3, y3), B2 = new bt(S3, k2), V2 = new bt(p4, k2), C2 = new bt(f3 / a2, g3 / a2), F2 = new bt(z2 / a2, P2 / a2), D2 = e2 * Math.PI / 180;
              if (D2) {
                const t3 = Math.sin(D2), e3 = Math.cos(D2), r3 = [e3, -t3, t3, e3];
                E2._matMult(r3), T2._matMult(r3), V2._matMult(r3), B2._matMult(r3);
              }
              const L2 = n3.stretch + n3.fixed, R2 = l3.stretch + l3.fixed, O2 = s3.stretch + s3.fixed, U2 = u3.stretch + u3.fixed, N2 = t2.imageSecondary;
              return { tl: E2, tr: T2, bl: V2, br: B2, texPrimary: { x: o2.paddedRect.x + ny + L2, y: o2.paddedRect.y + ny + O2, w: R2 - L2, h: U2 - O2 }, texSecondary: N2 ? { x: N2.paddedRect.x + ny + L2, y: N2.paddedRect.y + ny + O2, w: R2 - L2, h: U2 - O2 } : void 0, writingMode: void 0, glyphOffset: [0, 0], sectionIndex: 0, pixelOffsetTL: C2, pixelOffsetBR: F2, minFontScaleX: A2 / a2 / c2, minFontScaleY: I2 / a2 / h3, isSDF: r2 };
            };
            if (n2 && (o2.stretchX || o2.stretchY)) {
              const t3 = ay(p3, y2, d2), e3 = ay(f2, g2, m2);
              for (let r3 = 0; r3 < t3.length - 1; r3++) {
                const n3 = t3[r3], i3 = t3[r3 + 1];
                for (let t4 = 0; t4 < e3.length - 1; t4++) s2.push(S2(n3, e3[t4], i3, e3[t4 + 1]));
              }
            } else s2.push(S2({ fixed: 0, stretch: -1 }, { fixed: 0, stretch: -1 }, { fixed: 0, stretch: l2 + 1 }, { fixed: 0, stretch: u2 + 1 }));
            return s2;
          }
          function oy(t2, e2, r2) {
            let n2 = 0;
            for (const i2 of t2) n2 += Math.max(e2, Math.min(r2, i2[1])) - Math.max(e2, Math.min(r2, i2[0]));
            return n2;
          }
          function ay(t2, e2, r2) {
            const n2 = [{ fixed: -1, stretch: 0 }];
            for (const [e3, r3] of t2) {
              const t3 = n2[n2.length - 1];
              n2.push({ fixed: e3 - t3.stretch, stretch: t3.stretch }), n2.push({ fixed: e3 - t3.stretch, stretch: t3.stretch + (r3 - e3) });
            }
            return n2.push({ fixed: e2 + ny, stretch: r2 }), n2;
          }
          function ly(t2, e2, r2, n2) {
            return t2 / e2 * r2 + n2;
          }
          function uy(t2, e2, r2, n2) {
            return t2 - e2 * r2 / n2;
          }
          function cy(t2, e2, r2, n2) {
            const i2 = e2 + t2.positionedLines[n2].lineOffset;
            return 0 === n2 ? r2 + i2 / 2 : r2 + (i2 + (e2 + t2.positionedLines[n2 - 1].lineOffset)) / 2;
          }
          function hy(t2, e2 = 1, r2 = false) {
            let n2 = 1 / 0, i2 = 1 / 0, s2 = -1 / 0, o2 = -1 / 0;
            const a2 = t2[0];
            for (let t3 = 0; t3 < a2.length; t3++) {
              const e3 = a2[t3];
              (!t3 || e3.x < n2) && (n2 = e3.x), (!t3 || e3.y < i2) && (i2 = e3.y), (!t3 || e3.x > s2) && (s2 = e3.x), (!t3 || e3.y > o2) && (o2 = e3.y);
            }
            const l2 = Math.min(s2 - n2, o2 - i2);
            let u2 = l2 / 2;
            const c2 = new Vn([], py);
            if (0 === l2) return new bt(n2, i2);
            for (let e3 = n2; e3 < s2; e3 += l2) for (let r3 = i2; r3 < o2; r3 += l2) c2.push(new fy(e3 + u2, r3 + u2, u2, t2));
            let h3 = function(t3) {
              let e3 = 0, r3 = 0, n3 = 0;
              const i3 = t3[0];
              for (let t4 = 0, s3 = i3.length, o3 = s3 - 1; t4 < s3; o3 = t4++) {
                const s4 = i3[t4], a3 = i3[o3], l3 = s4.x * a3.y - a3.x * s4.y;
                r3 += (s4.x + a3.x) * l3, n3 += (s4.y + a3.y) * l3, e3 += 3 * l3;
              }
              return new fy(r3 / e3, n3 / e3, 0, t3);
            }(t2), p3 = c2.length;
            for (; c2.length; ) {
              const n3 = c2.pop();
              (n3.d > h3.d || !h3.d) && (h3 = n3, r2 && console.log("found best %d after %d probes", Math.round(1e4 * n3.d) / 1e4, p3)), n3.max - h3.d <= e2 || (u2 = n3.h / 2, c2.push(new fy(n3.p.x - u2, n3.p.y - u2, u2, t2)), c2.push(new fy(n3.p.x + u2, n3.p.y - u2, u2, t2)), c2.push(new fy(n3.p.x - u2, n3.p.y + u2, u2, t2)), c2.push(new fy(n3.p.x + u2, n3.p.y + u2, u2, t2)), p3 += 4);
            }
            return r2 && (console.log(`num probes: ${p3}`), console.log(`best distance: ${h3.d}`)), h3.p;
          }
          function py(t2, e2) {
            return e2.max - t2.max;
          }
          class fy {
            constructor(t2, e2, r2, n2) {
              this.p = new bt(t2, e2), this.h = r2, this.d = function(t3, e3) {
                let r3 = false, n3 = 1 / 0;
                for (let i2 = 0; i2 < e3.length; i2++) {
                  const s2 = e3[i2];
                  for (let e4 = 0, i3 = s2.length, o2 = i3 - 1; e4 < i3; o2 = e4++) {
                    const i4 = s2[e4], a2 = s2[o2];
                    i4.y > t3.y != a2.y > t3.y && t3.x < (a2.x - i4.x) * (t3.y - i4.y) / (a2.y - i4.y) + i4.x && (r3 = !r3), n3 = Math.min(n3, oc(t3, i4, a2));
                  }
                }
                return (r3 ? 1 : -1) * Math.sqrt(n3);
              }(this.p, n2), this.max = this.d + this.h * Math.SQRT2;
            }
          }
          const dy = Object.keys, my = Number.POSITIVE_INFINITY, yy = Math.sqrt(2);
          function gy(t2, [e2, r2]) {
            let n2 = 0, i2 = 0;
            if (r2 === my) {
              e2 < 0 && (e2 = 0);
              const r3 = e2 / yy;
              switch (t2) {
                case "top-right":
                case "top-left":
                  i2 = r3 - 7;
                  break;
                case "bottom-right":
                case "bottom-left":
                  i2 = 7 - r3;
                  break;
                case "bottom":
                  i2 = 7 - e2;
                  break;
                case "top":
                  i2 = e2 - 7;
              }
              switch (t2) {
                case "top-right":
                case "bottom-right":
                  n2 = -r3;
                  break;
                case "top-left":
                case "bottom-left":
                  n2 = r3;
                  break;
                case "left":
                  n2 = e2;
                  break;
                case "right":
                  n2 = -e2;
              }
            } else {
              switch (e2 = Math.abs(e2), r2 = Math.abs(r2), t2) {
                case "top-right":
                case "top-left":
                case "top":
                  i2 = r2 - 7;
                  break;
                case "bottom-right":
                case "bottom-left":
                case "bottom":
                  i2 = 7 - r2;
              }
              switch (t2) {
                case "top-right":
                case "bottom-right":
                case "right":
                  n2 = -e2;
                  break;
                case "top-left":
                case "bottom-left":
                case "left":
                  n2 = e2;
              }
            }
            return [n2, i2];
          }
          function xy(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            if (!e2 || !e2.usvg) return;
            const u2 = Vm(n2), c2 = Vm(i2), h3 = "both" !== s2 && "width" !== s2 || !Tm(n2) ? 1 : c2.width / u2.width, p3 = "both" !== s2 && "height" !== s2 || !Bm(n2) ? 1 : c2.height / u2.height;
            r2.scaleSelf(h3, p3);
            const f2 = r2.toString();
            o2.set(f2, r2), a2.set(f2, e2);
            const { imagePosition: d2 } = Wm(f2, e2, Xm);
            l2.set(f2, d2);
          }
          function vy(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            if (!t2) return;
            const u2 = function(t3, e3, r3, n3, i3, s3) {
              if ("camera" === t3.kind) return t3.maxSize;
              if ("composite" === t3.kind) {
                const n4 = e3.possiblyEvaluate(new go(t3.maxZoom, { worldview: s3 }), r3).evaluate(i3, {}, r3), o3 = e3.possiblyEvaluate(new go(t3.minZoom, { worldview: s3 }), r3).evaluate(i3, {}, r3);
                return Math.max(n4, o3);
              }
              return e3.possiblyEvaluate(new go(n3, { worldview: s3 })).evaluate(i3, {}, r3);
            }(e2, r2, n2, i2, s2, l2);
            return t2.scaleSelf(u2 * a2 * o2);
          }
          function by(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            return { iconPrimary: vy(t2.getPrimary(), e2, r2, n2, i2, s2, o2, a2, l2), iconSecondary: vy(t2.getSecondary(), e2, r2, n2, i2, s2, o2, a2, l2) };
          }
          function wy(t2, e2, r2) {
            if (!e2) return;
            const n2 = r2.get(t2.toString()), i2 = r2.get(e2.toString());
            i2 && (n2.paddedRect.w === i2.paddedRect.w && n2.paddedRect.h === i2.paddedRect.h || Gt(`Mismatch in icon variant sizes: ${t2.toString()} and ${e2.toString()}`), n2.usvg !== i2.usvg && Gt(`Mismatch in icon variant image types: ${t2.id} and ${e2.id}`));
          }
          function _y(t2, e2, r2, n2) {
            if (!t2) return;
            const i2 = e2.get(r2.toString());
            if (t2.imagePrimary = i2, n2) {
              const r3 = e2.get(n2.toString());
              t2.imageSecondary = r3;
            }
          }
          function Ay(t2, e2) {
            for (const r2 in t2.horizontal) My(t2.horizontal[r2], e2);
            My(t2.vertical, e2);
          }
          function My(t2, e2) {
            if (t2) {
              for (const r2 of t2.positionedLines) for (const t3 of r2.positionedGlyphs) if (null !== t3.image) {
                const r3 = t3.image.toString();
                t3.rect = e2.get(r3).paddedRect;
              }
            }
          }
          function Iy(t2) {
            switch (t2) {
              case "right":
              case "top-right":
              case "bottom-right":
                return "right";
              case "left":
              case "top-left":
              case "bottom-left":
                return "left";
            }
            return "center";
          }
          function Sy(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            const u2 = Ty(s2.horizontal) || s2.vertical, c2 = r2.get("icon-text-fit-padding").evaluate(n2, {}, i2);
            let h3, p3 = e2;
            return e2 && "none" !== l2 && (t2.allowVerticalPlacement && s2.vertical && (h3 = Em(e2, s2.vertical, l2, c2, a2, o2)), u2 && (p3 = Em(e2, u2, l2, c2, a2, o2))), { defaultShapedIcon: p3, verticallyShapedIcon: h3 };
          }
          function zy(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2, g2, x2, v2) {
            let b2 = o2.textMaxSize.evaluate(e2, {}, p3);
            void 0 === b2 ? b2 = a2 * o2.textScaleFactor : b2 *= o2.textScaleFactor;
            const w2 = t2.layers[0].layout, _2 = Ty(r2.horizontal) || r2.vertical, A2 = "globe" === f2.name, M2 = Jd, I2 = t2.tilePixelRatio * b2 / M2, S2 = (B2 = t2.overscaling, t2.zoom > 18 && B2 > 2 && (B2 >>= 1), Math.max(Cn / (512 * B2), 1) * w2.get("symbol-spacing")), z2 = w2.get("text-padding") * t2.tilePixelRatio, k2 = w2.get("icon-padding") * t2.tilePixelRatio, P2 = Mt(w2.get("text-max-angle")), E2 = "map" === w2.get("icon-rotation-alignment") && "point" !== v2, T2 = S2 / 2;
            var B2;
            false === t2.hasAnyIconTextFit && "none" !== y2 && (t2.hasAnyIconTextFit = true);
            const V2 = e2.properties ? +e2.properties[Eu] : null, C2 = V2 && t2.elevationFeatureIdToIndex ? t2.elevationFeatureIdToIndex.get(V2) : 65535, F2 = (a3, l3, v3) => {
              if (l3.x < 0 || l3.x >= Cn || l3.y < 0 || l3.y >= Cn) return;
              let b3 = null;
              if (A2) {
                const { x: t3, y: e3, z: r3 } = f2.projectTilePoint(l3.x, l3.y, v3);
                b3 = { anchor: new Rm(t3, e3, r3, 0, void 0), up: f2.upVector(v3, l3.x, l3.y) };
              }
              !function(t3, e3, r3, n3, i3, s3, o3, a4, l4, u3, c3, h4, p4, f3, d3, m3, y3, g3, x3, v4, b4, w3, _3, A3, M3, I3, S3, z3, k3) {
                const P3 = t3.addToLineVertexArray(e3, n3);
                let E3, T3, B3, V3, C3, F3, D2, L2 = 0, R2 = 0, O2 = 0, U2 = 0, N2 = -1, j2 = -1;
                const $2 = {};
                let G2 = We("");
                const q2 = r3 ? r3.anchor : e3, H2 = "none" !== z3;
                let X2 = 0, Z2 = 0;
                if (void 0 === l4._unevaluatedLayout.getValue("text-radial-offset")) {
                  const t4 = l4.layout.get("text-offset").evaluate(b4, {}, M3);
                  X2 = t4[0] * Jd, Z2 = t4[1] * Jd;
                } else X2 = l4.layout.get("text-radial-offset").evaluate(b4, {}, M3) * Jd, Z2 = my;
                if (t3.allowVerticalPlacement && i3.vertical) {
                  const t4 = i3.vertical;
                  if (d3) F3 = Vy(t4), a4 && (D2 = Vy(a4));
                  else {
                    const r4 = l4.layout.get("text-rotate").evaluate(b4, {}, M3) + 90;
                    B3 = By(u3, q2, e3, c3, h4, p4, t4, f3, r4, m3), a4 && (V3 = By(u3, q2, e3, c3, h4, p4, a4, g3, r4));
                  }
                }
                if (s3) {
                  const n4 = t3.iconSizeData, i4 = l4.layout.get("icon-rotate").evaluate(b4, {}, M3), o4 = sy(s3, i4, _3, H2, w3.iconScaleFactor), f4 = a4 ? sy(a4, i4, _3, H2, w3.iconScaleFactor) : void 0;
                  T3 = By(u3, q2, e3, c3, h4, p4, s3, g3, i4, null), L2 = 4 * o4.length;
                  let d4 = null;
                  "source" === n4.kind ? (d4 = [Cm * l4.layout.get("icon-size").evaluate(b4, {}, M3) * w3.iconScaleFactor], d4[0] > Py && Gt(`${t3.layerIds[0]}: Value for "icon-size" is >= ${ky}. Reduce your "icon-size".`)) : "composite" === n4.kind && (d4 = [Cm * w3.compositeIconSizes[0].evaluate(b4, {}, M3) * w3.iconScaleFactor, Cm * w3.compositeIconSizes[1].evaluate(b4, {}, M3) * w3.iconScaleFactor], (d4[0] > Py || d4[1] > Py) && Gt(`${t3.layerIds[0]}: Value for "icon-size" is >= ${ky}. Reduce your "icon-size".`)), t3.addSymbols(t3.icon, o4, d4, v4, x3, b4, void 0, r3, e3, P3.lineStartIndex, P3.lineLength, -1, A3, M3, I3, S3), N2 = t3.icon.placedSymbolArray.length - 1, f4 && (R2 = 4 * f4.length, t3.addSymbols(t3.icon, f4, d4, v4, x3, b4, mm.vertical, r3, e3, P3.lineStartIndex, P3.lineLength, -1, A3, M3, I3, S3), j2 = t3.icon.placedSymbolArray.length - 1);
                }
                for (const n4 in i3.horizontal) {
                  const s4 = n4, a5 = i3.horizontal[s4];
                  E3 || (G2 = We(a5.text), d3 ? C3 = Vy(a5) : E3 = By(u3, q2, e3, c3, h4, p4, a5, f3, l4.layout.get("text-rotate").evaluate(b4, {}, M3), m3));
                  const y4 = 1 === a5.positionedLines.length;
                  if (O2 += Ey(t3, r3, e3, a5, o3, l4, d3, b4, m3, P3, i3.vertical ? mm.horizontal : mm.horizontalOnly, y4 ? dy(i3.horizontal) : [s4], $2, N2, w3, A3, M3, I3), y4) break;
                }
                i3.vertical && (U2 += Ey(t3, r3, e3, i3.vertical, o3, l4, d3, b4, m3, P3, mm.vertical, ["vertical"], $2, j2, w3, A3, M3, I3));
                let W2 = -1;
                const Y2 = (t4, e4) => t4 ? Math.max(t4, e4) : e4;
                W2 = Y2(C3, W2), W2 = Y2(F3, W2), W2 = Y2(D2, W2);
                const K2 = W2 > -1 ? 1 : 0;
                t3.glyphOffsetArray.length >= 65535 && Gt("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b4.sortKey && t3.addToSortKeyRanges(t3.symbolInstances.length, b4.sortKey), t3.symbolInstances.emplaceBack(e3.x, e3.y, q2.x, q2.y, q2.z, $2.right >= 0 ? $2.right : -1, $2.center >= 0 ? $2.center : -1, $2.left >= 0 ? $2.left : -1, $2.vertical >= 0 ? $2.vertical : -1, N2, j2, G2, void 0 !== E3 ? E3 : t3.collisionBoxArray.length, void 0 !== E3 ? E3 + 1 : t3.collisionBoxArray.length, void 0 !== B3 ? B3 : t3.collisionBoxArray.length, void 0 !== B3 ? B3 + 1 : t3.collisionBoxArray.length, void 0 !== T3 ? T3 : t3.collisionBoxArray.length, void 0 !== T3 ? T3 + 1 : t3.collisionBoxArray.length, V3 || t3.collisionBoxArray.length, V3 ? V3 + 1 : t3.collisionBoxArray.length, c3, O2, U2, L2, R2, K2, 0, X2, Z2, W2, 0, H2 ? 1 : 0, k3);
              }(t2, l3, b3, a3, r2, n2, s2, i2, t2.layers[0], t2.collisionBoxArray, e2.index, e2.sourceLayerIndex, t2.index, z2, x2, u2, 0, k2, E2, g2, e2, o2, c2, h3, p3, d2, m2, y2, C2);
            };
            if ("line" === v2) for (const i3 of Mf(e2.geometry, 0, 0, Cn, Cn)) {
              const e3 = Gm(i3, S2, P2, r2.vertical || _2, n2, M2, I2, t2.overscaling, Cn);
              for (const r3 of e3) _2 && Cy(t2, _2.text, T2, r3) || F2(i3, r3, p3);
            }
            else if ("line-center" === v2) {
              for (const t3 of e2.geometry) if (t3.length > 1) {
                const e3 = $m(t3, P2, r2.vertical || _2, n2, M2, I2);
                e3 && F2(t3, e3, p3);
              }
            } else if ("Polygon" === e2.type) for (const t3 of Wh(e2.geometry, 0)) {
              const e3 = hy(t3, 16);
              F2(t3[0], new Rm(e3.x, e3.y, 0, 0, void 0), p3);
            }
            else if ("LineString" === e2.type) for (const t3 of e2.geometry) F2(t3, new Rm(t3[0].x, t3[0].y, 0, 0, void 0), p3);
            else if ("Point" === e2.type) for (const t3 of e2.geometry) for (const e3 of t3) F2([e3], new Rm(e3.x, e3.y, 0, 0, void 0), p3);
          }
          const ky = 255, Py = ky * Cm;
          function Ey(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2, g2) {
            const x2 = function(t3, e3, r3, n3, i3, s3, o3, a3) {
              const l3 = [];
              if (0 === e3.positionedLines.length) return l3;
              const u3 = n3.layout.get("text-rotate").evaluate(s3, {}) * Math.PI / 180, c3 = function(t4) {
                const e4 = t4[0], r4 = t4[1], n4 = e4 * r4;
                return n4 > 0 ? [e4, -r4] : n4 < 0 ? [-e4, r4] : 0 === e4 ? [r4, e4] : [r4, -e4];
              }(r3);
              let h4 = Math.abs(e3.top - e3.bottom);
              for (const t4 of e3.positionedLines) h4 -= t4.lineOffset;
              const p4 = e3.positionedLines.length, f3 = h4 / p4;
              let d3 = e3.top - r3[1];
              for (let t4 = 0; t4 < p4; ++t4) {
                const n4 = e3.positionedLines[t4];
                d3 = cy(e3, f3, d3, t4);
                for (const t5 of n4.positionedGlyphs) {
                  if (!t5.rect) continue;
                  const n5 = t5.rect || {};
                  let s4 = dm + 1, h5 = true, p5 = 1, f4 = 0;
                  if (t5.image) {
                    const e4 = o3.get(t5.image.toString());
                    if (!e4) continue;
                    if (e4.sdf) {
                      Gt("SDF images are not supported in formatted text and will be ignored.");
                      continue;
                    }
                    h5 = false, p5 = e4.pixelRatio, s4 = Xm / p5;
                  }
                  const m3 = (i3 || a3) && t5.vertical, y3 = t5.metrics.advance * t5.scale / 2, g3 = t5.metrics, x3 = t5.rect;
                  if (null === x3) continue;
                  a3 && e3.verticalizable && (f4 = t5.image ? y3 - t5.metrics.width * t5.scale / 2 : 0);
                  const v3 = i3 ? [t5.x + y3, t5.y] : [0, 0];
                  let b3 = [0, 0], w2 = [0, 0], _2 = false;
                  i3 || (m3 ? (w2 = [t5.x + y3 + c3[0], t5.y + c3[1] - f4], _2 = true) : b3 = [t5.x + y3 + r3[0], t5.y + r3[1] - f4]);
                  const A2 = x3.w * t5.scale / (p5 * (t5.localGlyph ? ty : 1)), M2 = x3.h * t5.scale / (p5 * (t5.localGlyph ? ty : 1));
                  let I2, S2, z2, k2;
                  if (m3) {
                    const e4 = t5.y - d3, r4 = new bt(-y3, y3 - e4), n6 = -Math.PI / 2, i4 = new bt(...w2);
                    I2 = new bt(-y3 + b3[0], b3[1]), I2._rotateAround(n6, r4)._add(i4), I2.x += -e4 + y3, I2.y -= (g3.left - s4) * t5.scale;
                    const o4 = t5.image ? g3.advance * t5.scale : Jd * t5.scale, a4 = String.fromCodePoint(t5.glyph);
                    em(a4) ? I2.x += (1 - s4) * t5.scale : rm(a4) ? I2.x += o4 - g3.height * t5.scale + (-s4 - 1) * t5.scale : I2.x += t5.image || g3.width + 2 * s4 === x3.w && g3.height + 2 * s4 === x3.h ? (o4 - M2) / 2 : (o4 - (g3.height + 2 * s4) * t5.scale) / 2, S2 = new bt(I2.x, I2.y - A2), z2 = new bt(I2.x + M2, I2.y), k2 = new bt(I2.x + M2, I2.y - A2);
                  } else {
                    const e4 = (g3.left - s4) * t5.scale - y3 + b3[0], r4 = (-g3.top - s4) * t5.scale + b3[1], n6 = e4 + A2, i4 = r4 + M2;
                    I2 = new bt(e4, r4), S2 = new bt(n6, r4), z2 = new bt(e4, i4), k2 = new bt(n6, i4);
                  }
                  if (u3) {
                    let t6;
                    t6 = i3 ? new bt(0, 0) : _2 ? new bt(c3[0], c3[1]) : new bt(r3[0], r3[1]), I2._rotateAround(u3, t6), S2._rotateAround(u3, t6), z2._rotateAround(u3, t6), k2._rotateAround(u3, t6);
                  }
                  const P2 = new bt(0, 0), E2 = new bt(0, 0);
                  l3.push({ tl: I2, tr: S2, bl: z2, br: k2, texPrimary: n5, texSecondary: void 0, writingMode: e3.writingMode, glyphOffset: v3, sectionIndex: t5.sectionIndex, isSDF: h5, pixelOffsetTL: P2, pixelOffsetBR: E2, minFontScaleX: 0, minFontScaleY: 0 });
                }
              }
              return l3;
            }(0, n2, l2, s2, o2, a2, i2, t2.allowVerticalPlacement), v2 = t2.textSizeData;
            let b2 = null;
            "source" === v2.kind ? (b2 = [Cm * s2.layout.get("text-size").evaluate(a2, {}, y2) * d2.textScaleFactor], b2[0] > Py && Gt(`${t2.layerIds[0]}: Value for "text-size" is >= ${ky}. Reduce your "text-size".`)) : "composite" === v2.kind && (b2 = [Cm * d2.compositeTextSizes[0].evaluate(a2, {}, y2) * d2.textScaleFactor, Cm * d2.compositeTextSizes[1].evaluate(a2, {}, y2) * d2.textScaleFactor], (b2[0] > Py || b2[1] > Py) && Gt(`${t2.layerIds[0]}: Value for "text-size" is >= ${ky}. Reduce your "text-size".`)), t2.addSymbols(t2.text, x2, b2, l2, o2, a2, c2, e2, r2, u2.lineStartIndex, u2.lineLength, f2, m2, y2, g2, false);
            for (const e3 of h3) p3[e3] = t2.text.placedSymbolArray.length - 1;
            return 4 * x2.length;
          }
          function Ty(t2) {
            for (const e2 in t2) return t2[e2];
            return null;
          }
          function By(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) {
            let c2 = o2.top, h3 = o2.bottom, p3 = o2.left, f2 = o2.right;
            if (km(o2) && o2.collisionPadding) {
              const t3 = o2.collisionPadding;
              p3 -= t3[0], c2 -= t3[1], f2 += t3[2], h3 += t3[3];
            }
            if (l2) {
              const t3 = new bt(p3, c2), e3 = new bt(f2, c2), r3 = new bt(p3, h3), n3 = new bt(f2, h3), i3 = Mt(l2);
              let s3 = new bt(0, 0);
              u2 && (s3 = new bt(u2[0], u2[1])), t3._rotateAround(i3, s3), e3._rotateAround(i3, s3), r3._rotateAround(i3, s3), n3._rotateAround(i3, s3), p3 = Math.min(t3.x, e3.x, r3.x, n3.x), f2 = Math.max(t3.x, e3.x, r3.x, n3.x), c2 = Math.min(t3.y, e3.y, r3.y, n3.y), h3 = Math.max(t3.y, e3.y, r3.y, n3.y);
            }
            return t2.emplaceBack(e2.x, e2.y, e2.z, r2.x, r2.y, p3, c2, f2, h3, a2, n2, i2, s2), t2.length - 1;
          }
          function Vy(t2) {
            km(t2) && t2.collisionPadding && (t2.top -= t2.collisionPadding[1], t2.bottom += t2.collisionPadding[3]);
            const e2 = t2.bottom - t2.top;
            return e2 > 0 ? Math.max(10, e2) : null;
          }
          function Cy(t2, e2, r2, n2) {
            const i2 = t2.compareText;
            if (e2 in i2) {
              const t3 = i2[e2];
              for (let e3 = t3.length - 1; e3 >= 0; e3--) if (n2.dist(t3[e3]) < r2) return true;
            } else i2[e2] = [];
            return i2[e2].push(n2), false;
          }
          function Fy(t2, e2) {
            const r2 = t2.fovAboveCenter, n2 = t2.elevation ? t2.elevation.getMinElevationBelowMSL() * e2 : 0, i2 = (t2._camera.position[2] * t2.worldSize - n2) / Math.cos(t2._pitch), s2 = Math.sin(r2) * i2 / Math.sin(Math.max(Math.PI / 2 - t2._pitch - r2, 0.01));
            let o2 = Math.sin(t2._pitch) * s2 + i2;
            const a2 = i2 * (1 / t2._horizonShift);
            if (!t2.elevation || 0 === t2.elevation.exaggeration()) {
              let e3 = Math.max(t2.zoom - 17, 0);
              t2.isOrthographic && (e3 /= 10), o2 *= 1 + e3;
            }
            return Math.min(1.01 * o2, a2);
          }
          function Dy(t2, e2) {
            if (!e2.isReprojectedInTileSpace) return { scale: 1 << t2.z, x: t2.x, y: t2.y, x2: t2.x + 1, y2: t2.y + 1, projection: e2 };
            const r2 = Math.pow(2, -t2.z), n2 = t2.x * r2, i2 = (t2.x + 1) * r2, s2 = t2.y * r2, o2 = (t2.y + 1) * r2, a2 = tu(n2), l2 = tu(i2), u2 = eu(s2), c2 = eu(o2), h3 = e2.project(a2, u2), p3 = e2.project(l2, u2), f2 = e2.project(l2, c2), d2 = e2.project(a2, c2);
            let m2 = Math.min(h3.x, p3.x, f2.x, d2.x), y2 = Math.min(h3.y, p3.y, f2.y, d2.y), g2 = Math.max(h3.x, p3.x, f2.x, d2.x), x2 = Math.max(h3.y, p3.y, f2.y, d2.y);
            const v2 = r2 / 16;
            function b2(t3, r3, n3, i3, s3, o3) {
              const a3 = (n3 + s3) / 2, l3 = (i3 + o3) / 2, u3 = e2.project(tu(a3), eu(l3)), c3 = Math.max(0, m2 - u3.x, y2 - u3.y, u3.x - g2, u3.y - x2);
              m2 = Math.min(m2, u3.x), g2 = Math.max(g2, u3.x), y2 = Math.min(y2, u3.y), x2 = Math.max(x2, u3.y), c3 > v2 && (b2(t3, u3, n3, i3, a3, l3), b2(u3, r3, a3, l3, s3, o3));
            }
            b2(h3, p3, n2, s2, i2, s2), b2(p3, f2, i2, s2, i2, o2), b2(f2, d2, i2, o2, n2, o2), b2(d2, h3, n2, o2, n2, s2), m2 -= v2, y2 -= v2, g2 += v2, x2 += v2;
            const w2 = 1 / Math.max(g2 - m2, x2 - y2);
            return { scale: w2, x: m2 * w2, y: y2 * w2, x2: g2 * w2, y2: x2 * w2, projection: e2 };
          }
          function Ly(t2, { x: e2, y: r2 }, n2 = 0) {
            return new bt(((e2 - n2) * t2.scale - t2.x) * Cn, (r2 * t2.scale - t2.y) * Cn);
          }
          const Ry = l(new Float32Array(16));
          class Oy {
            constructor(t2) {
              this.spec = t2, this.name = t2.name, this.wrap = false, this.requiresDraping = false, this.supportsWorldCopies = false, this.supportsTerrain = false, this.supportsFog = false, this.supportsFreeCamera = false, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = true, this.unsupportedLayers = ["custom"], this.center = [0, 0], this.range = [3.5, 7];
            }
            project(t2, e2) {
              return { x: 0, y: 0, z: 0 };
            }
            unproject(t2, e2) {
              return new Hl(0, 0);
            }
            projectTilePoint(t2, e2, r2) {
              return { x: t2, y: e2, z: 0 };
            }
            locationPoint(t2, e2, r2, n2 = true) {
              return t2._coordinatePoint(t2.locationCoordinate(e2, r2), n2);
            }
            pixelsPerMeter(t2, e2) {
              return Ql(1, t2) * e2;
            }
            pixelSpaceConversion(t2, e2, r2) {
              return 1;
            }
            farthestPixelDistance(t2) {
              return Fy(t2, t2.pixelsPerMeter);
            }
            pointCoordinate(t2, e2, r2, n2) {
              const i2 = t2.horizonLineFromTop(false), s2 = new bt(e2, Math.max(i2, r2));
              return t2.rayIntersectionCoordinate(t2.pointRayIntersection(s2, n2));
            }
            pointCoordinate3D(t2, e2, r2) {
              const n2 = new bt(e2, r2);
              if (t2.elevation) return t2.elevation.pointCoordinate(n2);
              {
                const e3 = this.pointCoordinate(t2, n2.x, n2.y, 0);
                return [e3.x, e3.y, e3.z];
              }
            }
            isPointAboveHorizon(t2, e2) {
              if (t2.elevation && t2.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(t2, e2.x, e2.y);
              const r2 = t2.horizonLineFromTop();
              return e2.y < r2;
            }
            createInversionMatrix(t2, e2) {
              return Ry;
            }
            createTileMatrix(t2, e2, r2) {
              let n2, i2, s2;
              const o2 = r2.canonical, a2 = l(new Float64Array(16));
              if (this.isReprojectedInTileSpace) {
                const l2 = Dy(o2, this);
                n2 = 1, i2 = l2.x + r2.wrap * l2.scale, s2 = l2.y, p2(a2, a2, [n2 / l2.scale, n2 / l2.scale, t2.pixelsPerMeter / e2]);
              } else n2 = e2 / t2.zoomScale(o2.z), i2 = (o2.x + Math.pow(2, o2.z) * r2.wrap) * n2, s2 = o2.y * n2;
              return h2(a2, a2, [i2, s2, 0]), p2(a2, a2, [n2 / Cn, n2 / Cn, 1]), a2;
            }
            upVector(t2, e2, r2) {
              return [0, 0, 1];
            }
            upVectorScale(t2, e2, r2) {
              return { metersToTile: 1 };
            }
          }
          class Uy extends Oy {
            constructor(t2) {
              super(t2), this.range = [4, 7], this.center = t2.center || [-96, 37.5];
              const [e2, r2] = this.parallels = t2.parallels || [29.5, 45.5], n2 = Math.sin(Mt(e2));
              this.n = (n2 + Math.sin(Mt(r2))) / 2, this.c = 1 + n2 * (2 * this.n - n2), this.r0 = Math.sqrt(this.c) / this.n;
            }
            project(t2, e2) {
              const { n: r2, c: n2, r0: i2 } = this, s2 = Mt(t2 - this.center[0]), o2 = Mt(e2), a2 = Math.sqrt(n2 - 2 * r2 * Math.sin(o2)) / r2;
              return { x: a2 * Math.sin(s2 * r2), y: a2 * Math.cos(s2 * r2) - i2, z: 0 };
            }
            unproject(t2, e2) {
              const { n: r2, c: n2, r0: i2 } = this, s2 = i2 + e2;
              let o2 = Math.atan2(t2, Math.abs(s2)) * Math.sign(s2);
              s2 * r2 < 0 && (o2 -= Math.PI * Math.sign(t2) * Math.sign(s2));
              const a2 = Mt(this.center[0]) * r2;
              o2 = Bt(o2, -Math.PI - a2, Math.PI - a2);
              const l2 = Et(It(o2 / r2) + this.center[0], -180, 180), u2 = Math.asin(Et((n2 - (t2 * t2 + s2 * s2) * r2 * r2) / (2 * r2), -1, 1)), c2 = Et(It(u2), -85.051129, nu);
              return new Hl(l2, c2);
            }
          }
          const Ny = 1.340264, jy = -0.081106, $y = 893e-6, Gy = 3796e-6, qy = Math.sqrt(3) / 2;
          class Hy extends Oy {
            project(t2, e2) {
              e2 = e2 / 180 * Math.PI, t2 = t2 / 180 * Math.PI;
              const r2 = Math.asin(qy * Math.sin(e2)), n2 = r2 * r2, i2 = n2 * n2 * n2;
              return { x: 0.5 * (t2 * Math.cos(r2) / (qy * (Ny + 3 * jy * n2 + i2 * (7 * $y + 9 * Gy * n2))) / Math.PI + 0.5), y: 1 - 0.5 * (r2 * (Ny + jy * n2 + i2 * ($y + Gy * n2)) / Math.PI + 1), z: 0 };
            }
            unproject(t2, e2) {
              t2 = (2 * t2 - 0.5) * Math.PI;
              let r2 = e2 = (2 * (1 - e2) - 1) * Math.PI, n2 = r2 * r2, i2 = n2 * n2 * n2;
              for (let t3, s3, o3, a3 = 0; a3 < 12 && (s3 = r2 * (Ny + jy * n2 + i2 * ($y + Gy * n2)) - e2, o3 = Ny + 3 * jy * n2 + i2 * (7 * $y + 9 * Gy * n2), t3 = s3 / o3, r2 = Et(r2 - t3, -Math.PI / 3, Math.PI / 3), n2 = r2 * r2, i2 = n2 * n2 * n2, !(Math.abs(t3) < 1e-12)); ++a3) ;
              const s2 = qy * t2 * (Ny + 3 * jy * n2 + i2 * (7 * $y + 9 * Gy * n2)) / Math.cos(r2), o2 = Math.asin(Math.sin(r2) / qy), a2 = Et(180 * s2 / Math.PI, -180, 180), l2 = Et(180 * o2 / Math.PI, -85.051129, nu);
              return new Hl(a2, l2);
            }
          }
          class Xy extends Oy {
            constructor(t2) {
              super(t2), this.wrap = true, this.supportsWorldCopies = true;
            }
            project(t2, e2) {
              return { x: 0.5 + t2 / 360, y: 0.5 - e2 / 360, z: 0 };
            }
            unproject(t2, e2) {
              const r2 = 360 * (t2 - 0.5), n2 = Et(360 * (0.5 - e2), -85.051129, nu);
              return new Hl(r2, n2);
            }
          }
          const Zy = Math.PI / 2;
          function Wy(t2) {
            return Math.tan((Zy + t2) / 2);
          }
          class Yy extends Oy {
            constructor(t2) {
              super(t2), this.center = t2.center || [0, 30];
              const [e2, r2] = this.parallels = t2.parallels || [30, 30];
              let n2 = Mt(e2), i2 = Mt(r2);
              this.southernCenter = n2 + i2 < 0, this.southernCenter && (n2 = -n2, i2 = -i2);
              const s2 = Math.cos(n2), o2 = Wy(n2);
              this.n = n2 === i2 ? Math.sin(n2) : Math.log(s2 / Math.cos(i2)) / Math.log(Wy(i2) / o2), this.f = s2 * Math.pow(Wy(n2), this.n) / this.n;
            }
            project(t2, e2) {
              e2 = Mt(e2), this.southernCenter && (e2 = -e2), t2 = Mt(t2 - this.center[0]);
              const r2 = 1e-6, { n: n2, f: i2 } = this;
              i2 > 0 ? e2 < -Zy + r2 && (e2 = -Zy + r2) : e2 > Zy - r2 && (e2 = Zy - r2);
              const s2 = i2 / Math.pow(Wy(e2), n2);
              let o2 = s2 * Math.sin(n2 * t2), a2 = i2 - s2 * Math.cos(n2 * t2);
              return o2 = 0.5 * (o2 / Math.PI + 0.5), a2 = 0.5 * (a2 / Math.PI + 0.5), { x: o2, y: this.southernCenter ? a2 : 1 - a2, z: 0 };
            }
            unproject(t2, e2) {
              t2 = (2 * t2 - 0.5) * Math.PI, this.southernCenter && (e2 = 1 - e2), e2 = (2 * (1 - e2) - 0.5) * Math.PI;
              const { n: r2, f: n2 } = this, i2 = n2 - e2, s2 = Math.sign(i2), o2 = Math.sign(r2) * Math.sqrt(t2 * t2 + i2 * i2);
              let a2 = Math.atan2(t2, Math.abs(i2)) * s2;
              i2 * r2 < 0 && (a2 -= Math.PI * Math.sign(t2) * s2);
              const l2 = Et(It(a2 / r2) + this.center[0], -180, 180), u2 = Et(It(2 * Math.atan(Math.pow(n2 / o2, 1 / r2)) - Zy), -85.051129, nu);
              return new Hl(l2, this.southernCenter ? -u2 : u2);
            }
          }
          class Ky extends Oy {
            constructor(t2) {
              super(t2), this.wrap = true, this.supportsWorldCopies = true, this.supportsTerrain = true, this.supportsFog = true, this.supportsFreeCamera = true, this.isReprojectedInTileSpace = false, this.unsupportedLayers = [], this.range = null;
            }
            project(t2, e2) {
              return { x: Kl(t2), y: Jl(e2), z: 0 };
            }
            unproject(t2, e2) {
              const r2 = tu(t2), n2 = eu(e2);
              return new Hl(r2, n2);
            }
          }
          const Jy = Mt(nu);
          class Qy extends Oy {
            project(t2, e2) {
              const r2 = (e2 = Mt(e2)) * e2, n2 = r2 * r2;
              return { x: 0.5 * ((t2 = Mt(t2)) * (0.8707 - 0.131979 * r2 + n2 * (n2 * (3971e-6 * r2 - 1529e-6 * n2) - 0.013791)) / Math.PI + 0.5), y: 1 - 0.5 * (e2 * (1.007226 + r2 * (0.015085 + n2 * (0.028874 * r2 - 0.044475 - 5916e-6 * n2))) / Math.PI + 1), z: 0 };
            }
            unproject(t2, e2) {
              t2 = (2 * t2 - 0.5) * Math.PI;
              let r2 = e2 = (2 * (1 - e2) - 1) * Math.PI, n2 = 25, i2 = 0, s2 = r2 * r2;
              do {
                s2 = r2 * r2;
                const t3 = s2 * s2;
                i2 = (r2 * (1.007226 + s2 * (0.015085 + t3 * (0.028874 * s2 - 0.044475 - 5916e-6 * t3))) - e2) / (1.007226 + s2 * (0.045255 + t3 * (0.259866 * s2 - 0.311325 - 5916e-6 * 11 * t3))), r2 = Et(r2 - i2, -Jy, Jy);
              } while (Math.abs(i2) > 1e-6 && --n2 > 0);
              s2 = r2 * r2;
              const o2 = Et(It(t2 / (0.8707 + s2 * (s2 * (s2 * s2 * s2 * (3971e-6 - 1529e-6 * s2) - 0.013791) - 0.131979))), -180, 180), a2 = It(r2);
              return new Hl(o2, a2);
            }
          }
          const tg = Mt(nu);
          class eg extends Oy {
            project(t2, e2) {
              e2 = Mt(e2), t2 = Mt(t2);
              const r2 = Math.cos(e2), n2 = 2 / Math.PI, i2 = Math.acos(r2 * Math.cos(t2 / 2)), s2 = Math.sin(i2) / i2, o2 = 0.5 * (t2 * n2 + 2 * r2 * Math.sin(t2 / 2) / s2) || 0, a2 = 0.5 * (e2 + Math.sin(e2) / s2) || 0;
              return { x: 0.5 * (o2 / Math.PI + 0.5), y: 1 - 0.5 * (a2 / Math.PI + 1), z: 0 };
            }
            unproject(t2, e2) {
              let r2 = t2 = (2 * t2 - 0.5) * Math.PI, n2 = e2 = (2 * (1 - e2) - 1) * Math.PI, i2 = 25;
              const s2 = 1e-6;
              let o2 = 0, a2 = 0;
              do {
                const i3 = Math.cos(n2), s3 = Math.sin(n2), l2 = 2 * s3 * i3, u2 = s3 * s3, c2 = i3 * i3, h3 = Math.cos(r2 / 2), p3 = Math.sin(r2 / 2), f2 = 2 * h3 * p3, d2 = p3 * p3, m2 = 1 - c2 * h3 * h3, y2 = m2 ? 1 / m2 : 0, g2 = m2 ? Math.acos(i3 * h3) * Math.sqrt(1 / m2) : 0, x2 = 0.5 * (2 * g2 * i3 * p3 + 2 * r2 / Math.PI) - t2, v2 = 0.5 * (g2 * s3 + n2) - e2, b2 = 0.5 * y2 * (c2 * d2 + g2 * i3 * h3 * u2) + 1 / Math.PI, w2 = y2 * (f2 * l2 / 4 - g2 * s3 * p3), _2 = 0.125 * y2 * (l2 * p3 - g2 * s3 * c2 * f2), A2 = 0.5 * y2 * (u2 * h3 + g2 * d2 * i3) + 0.5, M2 = w2 * _2 - A2 * b2;
                o2 = (v2 * w2 - x2 * A2) / M2, a2 = (x2 * _2 - v2 * b2) / M2, r2 = Et(r2 - o2, -Math.PI, Math.PI), n2 = Et(n2 - a2, -tg, tg);
              } while ((Math.abs(o2) > s2 || Math.abs(a2) > s2) && --i2 > 0);
              return new Hl(It(r2), It(n2));
            }
          }
          class rg extends Oy {
            constructor(t2) {
              super(t2), this.center = t2.center || [0, 0], this.parallels = t2.parallels || [0, 0], this.cosPhi = Math.max(0.01, Math.cos(Mt(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = true, this.supportsWorldCopies = true;
            }
            project(t2, e2) {
              const { scale: r2, cosPhi: n2 } = this;
              return { x: Mt(t2) * n2 * r2 + 0.5, y: -Math.sin(Mt(e2)) / n2 * r2 + 0.5, z: 0 };
            }
            unproject(t2, e2) {
              const { scale: r2, cosPhi: n2 } = this, i2 = -(e2 - 0.5) / r2, s2 = Et(It((t2 - 0.5) / r2) / n2, -180, 180), o2 = Math.asin(Et(i2 * n2, -1, 1)), a2 = Et(It(o2), -85.051129, nu);
              return new Hl(s2, a2);
            }
          }
          class ng extends Ky {
            constructor(t2) {
              super(t2), this.requiresDraping = true, this.supportsWorldCopies = false, this.supportsFog = true, this.zAxisUnit = "pixels", this.unsupportedLayers = ["debug"], this.range = [3, 5];
            }
            projectTilePoint(t2, e2, r2) {
              const n2 = Uc(t2, e2, r2);
              return R(n2, n2, $c(Cc(r2))), { x: n2[0], y: n2[1], z: n2[2] };
            }
            locationPoint(t2, e2, r2) {
              const n2 = $l(e2.lat, e2.lng), i2 = C([], n2), s2 = r2 ? t2._centerAltitude + r2 : t2.elevation ? t2.elevation.getAtPointOrZero(t2.locationCoordinate(e2), t2._centerAltitude) : t2._centerAltitude;
              E(n2, n2, i2, Ql(1, 0) * Cn * s2);
              const o2 = l(new Float64Array(16));
              return c(o2, t2.pixelMatrix, t2.globeMatrix), R(n2, n2, o2), new bt(n2[0], n2[1]);
            }
            pixelsPerMeter(t2, e2) {
              return Ql(1, 0) * e2;
            }
            pixelSpaceConversion(t2, e2, r2) {
              const n2 = Ql(1, t2) * e2, i2 = ur(Ql(1, 45) * e2, n2, r2);
              return this.pixelsPerMeter(t2, e2) / i2;
            }
            createTileMatrix(t2, e2, r2) {
              const n2 = Gc(Cc(r2.canonical));
              return c(new Float64Array(16), t2.globeMatrix, n2);
            }
            createInversionMatrix(t2, e2) {
              const { center: r2 } = t2, n2 = $c(Cc(e2));
              return d(n2, n2, Mt(r2.lng)), f(n2, n2, Mt(r2.lat)), p2(n2, n2, [t2._pixelsPerMercatorPixel, t2._pixelsPerMercatorPixel, 1]), Float32Array.from(n2);
            }
            pointCoordinate(t2, e2, r2, n2) {
              return Tc(t2, e2, r2, true) || new lu(0, 0);
            }
            pointCoordinate3D(t2, e2, r2) {
              const n2 = this.pointCoordinate(t2, e2, r2, 0);
              return [n2.x, n2.y, n2.z];
            }
            isPointAboveHorizon(t2, e2) {
              return !Tc(t2, e2.x, e2.y, false);
            }
            farthestPixelDistance(t2) {
              const e2 = function(t3, e3) {
                const r3 = t3.cameraToCenterDistance, n2 = t3._centerAltitude * e3, i2 = t3._camera, s2 = t3._camera.forward(), o2 = M([], P([], s2, -r3), [0, 0, n2]), a2 = t3.worldSize / (2 * Math.PI), l2 = [0, 0, -a2], u2 = t3.width / t3.height, c2 = Math.tan(t3.fovAboveCenter), h3 = P([], i2.up(), c2), p3 = P([], i2.right(), c2 * u2), f2 = C([], M([], M([], s2, h3), p3)), d2 = [];
                let m2;
                if (new Ru(o2, f2).closestPointOnSphere(l2, a2, d2)) {
                  const e4 = M([], d2, l2), r4 = j([], e4, o2);
                  m2 = Math.cos(t3.fovAboveCenter) * _(r4);
                } else {
                  const t4 = j([], o2, l2), e4 = j([], l2, o2);
                  C(e4, e4);
                  const r4 = _(t4) - a2;
                  m2 = Math.sqrt(r4 * (r4 + 2 * a2));
                  const n3 = Math.acos(m2 / (a2 + r4)) - Math.acos(F(s2, e4));
                  m2 *= Math.cos(n3);
                }
                return 1.01 * m2;
              }(t2, this.pixelsPerMeter(t2.center.lat, t2.worldSize)), r2 = Zc(t2.zoom);
              if (r2 > 0) {
                const n2 = Fy(t2, Ql(1, t2.center.lat) * t2.worldSize), i2 = t2.worldSize / (2 * Math.PI), s2 = Math.max(t2.width, t2.height) / t2.worldSize * Math.PI;
                return ur(e2, n2 + i2 * (1 - Math.cos(s2)), Math.pow(r2, 10));
              }
              return e2;
            }
            upVector(t2, e2, r2) {
              return Uc(e2, r2, t2, 1);
            }
            upVectorScale(t2) {
              return { metersToTile: Pc(Nc(Cc(t2))) };
            }
          }
          function ig(t2) {
            const e2 = t2.parallels, r2 = !!e2 && Math.abs(e2[0] + e2[1]) < 0.01;
            switch (t2.name) {
              case "mercator":
                return new Ky(t2);
              case "equirectangular":
                return new Xy(t2);
              case "naturalEarth":
                return new Qy(t2);
              case "equalEarth":
                return new Hy(t2);
              case "winkelTripel":
                return new eg(t2);
              case "albers":
                return r2 ? new rg(t2) : new Uy(t2);
              case "lambertConformalConic":
                return r2 ? new rg(t2) : new Yy(t2);
              case "globe":
                return new ng(t2);
            }
            throw new Error(`Invalid projection name: ${t2.name}`);
          }
          const sg = Pu.VectorTileFeature.types, og = [{ name: "a_fade_opacity", components: 1, type: "Uint8", offset: 0 }];
          function ag(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3) {
            const f2 = a2 ? Math.min(Py, Math.round(a2[0])) : 0, d2 = a2 ? Math.min(Py, Math.round(a2[1])) : 0;
            t2.emplaceBack(e2, r2, Math.round(32 * n2), Math.round(32 * i2), s2, o2, (f2 << 1) + (l2 ? 1 : 0), d2, 16 * u2, 16 * c2, 256 * h3, 256 * p3);
          }
          function lg(t2, e2, r2) {
            t2.emplaceBack(e2, r2);
          }
          function ug(t2, e2, r2, n2, i2, s2, o2) {
            t2.emplaceBack(e2, r2, n2, i2, s2, o2);
          }
          const cg = (t2, e2, r2, n2) => {
            for (let i2 = 0; i2 < e2; i2++) t2.emplaceBack(r2[0], r2[1], r2[2], n2[0], n2[1], n2[2]);
          };
          function hg(t2, e2, r2, n2, i2) {
            t2.emplaceBack(e2, r2, n2, i2), t2.emplaceBack(e2, r2, n2, i2), t2.emplaceBack(e2, r2, n2, i2), t2.emplaceBack(e2, r2, n2, i2);
          }
          function pg(t2) {
            for (const e2 of t2.sections) if (so(e2.text)) return true;
            return false;
          }
          class fg {
            constructor(t2) {
              this.layoutVertexArray = new da(), this.indexArray = new Aa(), this.programConfigurations = t2, this.segments = new tl(), this.dynamicLayoutVertexArray = new ya(), this.opacityVertexArray = new ga(), this.placedSymbolArray = new Na(), this.iconTransitioningVertexArray = new xa(), this.globeExtVertexArray = new ma(), this.zOffsetVertexArray = new sa(), this.orientationVertexArray = new Sa();
            }
            isEmpty() {
              return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            upload(t2, e2, r2, n2, i2) {
              this.isEmpty() || (r2 && (this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, jd.members), this.indexBuffer = t2.createIndexBuffer(this.indexArray, e2), this.dynamicLayoutVertexBuffer = t2.createVertexBuffer(this.dynamicLayoutVertexArray, Gd.members, true), this.opacityVertexBuffer = t2.createVertexBuffer(this.opacityVertexArray, og, true), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = t2.createVertexBuffer(this.iconTransitioningVertexArray, Xd.members, true)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = t2.createVertexBuffer(this.globeExtVertexArray, $d.members, true)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || i2) && (this.zOffsetVertexBuffer = t2.createVertexBuffer(this.zOffsetVertexArray, qd.members, true)), !this.orientationVertexBuffer && this.orientationVertexArray && this.orientationVertexArray.length > 0 && (this.orientationVertexBuffer = t2.createVertexBuffer(this.orientationVertexArray, Hd.members, true)), this.opacityVertexBuffer.itemSize = 1), (r2 || n2) && this.programConfigurations.upload(t2));
            }
            destroy() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.orientationVertexBuffer && this.orientationVertexBuffer.destroy());
            }
          }
          qs(fg, "SymbolBuffers");
          class dg {
            constructor(t2, e2, r2) {
              this.layoutVertexArray = new t2(), this.layoutAttributes = e2, this.indexArray = new r2(), this.segments = new tl(), this.collisionVertexArray = new _a(), this.collisionVertexArrayExt = new ya();
            }
            upload(t2) {
              this.layoutVertexBuffer = t2.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t2.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t2.createVertexBuffer(this.collisionVertexArray, Zd.members, true), this.collisionVertexBufferExt = t2.createVertexBuffer(this.collisionVertexArrayExt, Wd.members, true);
            }
            destroy() {
              this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
          }
          qs(dg, "CollisionBuffers");
          class mg {
            constructor(t2) {
              this.collisionBoxArray = t2.collisionBoxArray, this.zoom = t2.zoom, this.lut = t2.lut, this.overscaling = t2.overscaling, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.index = t2.index, this.pixelRatio = t2.pixelRatio, this.sourceLayerIndex = t2.sourceLayerIndex, this.hasPattern = false, this.hasRTLText = false, this.fullyClipped = false, this.hasAnyIconTextFit = false, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = l([]), this.placementViewportMatrix = l([]);
              const e2 = this.layers[0]._unevaluatedLayout._values;
              this.worldview = t2.worldview, this.textSizeData = Fm(this.zoom, e2["text-size"], this.worldview), this.iconSizeData = Fm(this.zoom, e2["icon-size"], this.worldview);
              const r2 = this.layers[0].layout, n2 = r2.get("symbol-sort-key"), i2 = r2.get("symbol-z-order");
              this.canOverlap = r2.get("text-allow-overlap") || r2.get("icon-allow-overlap") || r2.get("text-ignore-placement") || r2.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i2 && void 0 !== n2.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i2 || "auto" === i2 && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r2.get("text-writing-mode").map((t3) => mm[t3]), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.sourceID = t2.sourceID, this.projection = t2.projection, this.hasAnyZOffset = false, this.zOffsetSortDirty = false, this.zOffsetBuffersNeedUpload = false, this.elevationType = "none", this.elevationStateComplete = false, this.activeReplacements = [], this.replacementUpdateTime = 0;
            }
            createArrays() {
              this.text = new fg(new kl(this.layers, { zoom: this.zoom, lut: this.lut }, (t2) => t2.startsWith("text") || t2.startsWith("symbol"))), this.icon = new fg(new kl(this.layers, { zoom: this.zoom, lut: this.lut }, (t2) => t2.startsWith("icon") || t2.startsWith("symbol"))), this.glyphOffsetArray = new Ga(), this.lineVertexArray = new qa(), this.symbolInstances = new $a();
            }
            calculateGlyphDependencies(t2, e2, r2, n2, i2) {
              for (const r3 of t2) {
                const t3 = r3.codePointAt(0);
                if (void 0 === t3) break;
                if (e2[t3] = true, n2 && i2 && t3 <= 65535) {
                  const t4 = tm[r3];
                  t4 && (e2[t4.charCodeAt(0)] = true);
                }
              }
            }
            updateFootprints(t2, e2) {
            }
            updateReplacement(t2, e2) {
              if (e2.updateTime === this.replacementUpdateTime) return false;
              this.replacementUpdateTime = e2.updateTime;
              const r2 = e2.getReplacementRegionsForTile(t2.toUnwrapped(), true);
              return !Vp(this.activeReplacements, r2) && (this.activeReplacements = r2, true);
            }
            populate(t2, e2, r2, n2) {
              const i2 = this.layers[0], s2 = i2.layout, o2 = "globe" === this.projection.name, a2 = s2.get("text-font"), l2 = s2.get("text-field"), u2 = s2.get("icon-image"), [c2, h3] = s2.get("icon-size-scale-range"), p3 = Et(e2.scaleFactor || 1, c2, h3), f2 = ("constant" !== l2.value.kind || l2.value.value instanceof Cr && !l2.value.value.isEmpty() || l2.value.value.toString().length > 0) && ("constant" !== a2.value.kind || a2.value.value.length > 0), d2 = "constant" !== u2.value.kind || !!u2.value.value || Object.keys(u2.parameters).length > 0, m2 = s2.get("symbol-sort-key");
              if (this.features = [], !f2 && !d2) return;
              const y2 = e2.iconDependencies, g2 = e2.glyphDependencies, x2 = e2.availableImages, v2 = new go(this.zoom, { worldview: this.worldview });
              for (const { feature: e3, id: l3, index: u3, sourceLayerIndex: c3 } of t2) {
                const t3 = i2._featureFilter.needGeometry, h4 = gu(e3, t3);
                if (!i2._featureFilter.filter(v2, h4, r2)) continue;
                if (t3 || (h4.geometry = yu(e3, r2, n2)), o2 && 1 !== e3.type && r2.z <= 5) {
                  const t4 = h4.geometry, e4 = 0.98078528056, n3 = (t5, n4) => F(Uc(t5.x, t5.y, r2, 1), Uc(n4.x, n4.y, r2, 1)) < e4;
                  for (let e5 = 0; e5 < t4.length; e5++) t4[e5] = pu(t4[e5], n3);
                }
                let b2, w2;
                if (f2) {
                  const t4 = i2.getValueAndResolveTokens("text-field", h4, r2, x2), e4 = Cr.factory(t4);
                  pg(e4) && (this.hasRTLText = true), (!this.hasRTLText || "unavailable" === fo() || this.hasRTLText && yo.isParsed()) && (b2 = Qd(e4, i2, h4));
                }
                if (d2) {
                  const t4 = i2.getValueAndResolveTokens("icon-image", h4, r2, x2);
                  w2 = "string" == typeof t4 ? Dr.build(t4) : t4;
                }
                if (!b2 && !w2) continue;
                const _2 = this.sortFeaturesByKey ? m2.evaluate(h4, {}, r2) : void 0, A2 = { id: l3, text: b2, icon: w2, index: u3, sourceLayerIndex: c3, geometry: h4.geometry, properties: e3.properties, type: sg[e3.type], sortKey: _2 };
                if (this.features.push(A2), w2) {
                  const t4 = this.layers[0]._unevaluatedLayout._values, { iconPrimary: e4, iconSecondary: n3 } = by(w2, this.iconSizeData, t4["icon-size"], r2, this.zoom, A2, this.pixelRatio, p3, this.worldview), i3 = e4.id.toString();
                  if (y2.has(i3) ? y2.get(i3).push(e4) : y2.set(i3, [e4]), n3) {
                    const t5 = n3.id.toString();
                    y2.has(t5) ? y2.get(t5).push(n3) : y2.set(t5, [n3]);
                  }
                }
                if (b2) {
                  const t4 = a2.evaluate(h4, {}, r2).join(","), e4 = "map" === s2.get("text-rotation-alignment") && "point" !== s2.get("symbol-placement");
                  this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(mm.vertical) >= 0;
                  for (const r3 of b2.sections) if (r3.image) {
                    const t5 = r3.image.getPrimary().scaleSelf(this.pixelRatio), e5 = t5.id.toString(), n3 = y2.get(e5) || [];
                    n3.push(t5), y2.set(e5, n3);
                  } else {
                    const n3 = Ks(b2.toString()), i3 = r3.fontStack || t4, s3 = g2[i3] = g2[i3] || {};
                    this.calculateGlyphDependencies(r3.text, s3, e4, this.allowVerticalPlacement, n3);
                  }
                }
              }
              if ("line" === s2.get("symbol-placement") && (this.features = function(t3) {
                const e3 = {}, r3 = {}, n3 = [];
                let i3 = 0;
                function s3(e4) {
                  n3.push(t3[e4]), i3++;
                }
                function o3(t4, e4, i4) {
                  const s4 = r3[t4];
                  return delete r3[t4], r3[e4] = s4, n3[s4].geometry[0].pop(), n3[s4].geometry[0] = n3[s4].geometry[0].concat(i4[0]), s4;
                }
                function a3(t4, r4, i4) {
                  const s4 = e3[r4];
                  return delete e3[r4], e3[t4] = s4, n3[s4].geometry[0].shift(), n3[s4].geometry[0] = i4[0].concat(n3[s4].geometry[0]), s4;
                }
                function l3(t4, e4, r4) {
                  const n4 = r4 ? e4[0][e4[0].length - 1] : e4[0][0];
                  return `${t4}:${n4.x}:${n4.y}`;
                }
                for (let u3 = 0; u3 < t3.length; u3++) {
                  const c3 = t3[u3], h4 = c3.geometry, p4 = c3.text ? c3.text.toString() : null;
                  if (!p4) {
                    s3(u3);
                    continue;
                  }
                  const f3 = l3(p4, h4), d3 = l3(p4, h4, true);
                  if (f3 in r3 && d3 in e3 && r3[f3] !== e3[d3]) {
                    const t4 = a3(f3, d3, h4), i4 = o3(f3, d3, n3[t4].geometry);
                    delete e3[f3], delete r3[d3], r3[l3(p4, n3[i4].geometry, true)] = i4, n3[t4].geometry = null;
                  } else f3 in r3 ? o3(f3, d3, h4) : d3 in e3 ? a3(f3, d3, h4) : (s3(u3), e3[f3] = i3 - 1, r3[d3] = i3 - 1);
                }
                return n3.filter((t4) => t4.geometry);
              }(this.features)), "hd-road-markup" === s2.get("symbol-elevation-reference")) {
                if (this.elevationType = "road", e2.elevationFeatures) {
                  !this.elevationFeatures && e2.elevationFeatures.length > 0 && (this.elevationFeatures = [], this.elevationFeatureIdToIndex = /* @__PURE__ */ new Map());
                  for (const t3 of e2.elevationFeatures) this.elevationFeatureIdToIndex.set(t3.id, this.elevationFeatures.length), this.elevationFeatures.push(t3);
                }
              } else s2.get("symbol-z-elevate") && (this.elevationType = "offset");
              "none" !== this.elevationType && (this.zOffsetBuffersNeedUpload = true), this.sortFeaturesByKey && this.features.sort((t3, e3) => t3.sortKey - e3.sortKey);
            }
            update(t2, e2, r2, n2, i2, s2, o2) {
              this.text.programConfigurations.updatePaintArrays(t2, e2, i2, r2, n2, s2, o2, this.worldview), this.icon.programConfigurations.updatePaintArrays(t2, e2, i2, r2, n2, s2, o2, this.worldview);
            }
            updateRoadElevation(t2) {
              if ("road" !== this.elevationType || !this.elevationFeatures) return;
              if (this.elevationStateComplete) return;
              this.elevationStateComplete = true, this.hasAnyZOffset = false;
              let e2 = false;
              const r2 = au(t2), n2 = 1 / r2;
              let i2 = false, s2 = false;
              for (let t3 = 0; t3 < this.symbolInstances.length; t3++) {
                const o2 = this.symbolInstances.get(t3), a2 = A(1, 0, 0), l2 = A(0, 1, 0), { numHorizontalGlyphVertices: u2, numVerticalGlyphVertices: c2, numIconVertices: h3, numVerticalIconVertices: p3 } = o2, f2 = u2 > 0 || c2 > 0, d2 = h3 > 0, m2 = this.elevationFeatures[o2.elevationFeatureIndex];
                if (m2) {
                  const t4 = new bt(o2.tileAnchorX, o2.tileAnchorY), u3 = 0.075 + m2.pointElevation(t4);
                  o2.zOffset !== u3 && (e2 = true, o2.zOffset = u3);
                  const c3 = m2.computeSlopeNormal(t4, n2), h4 = st(W(), A(0, 0, 1), c3);
                  U(a2, a2, h4), U(l2, l2, h4), a2[2] *= r2, l2[2] *= r2, 1 === a2[0] && 0 === a2[1] && 0 === a2[2] && 0 === l2[0] && 1 === l2[1] && 0 === l2[2] || (i2 = i2 || f2, s2 = s2 || d2);
                }
                if (f2 && (cg(this.text.orientationVertexArray, u2, a2, l2), cg(this.text.orientationVertexArray, c2, a2, l2)), d2) {
                  const { placedIconSymbolIndex: t4, verticalPlacedIconSymbolIndex: e3 } = o2;
                  t4 >= 0 && cg(this.icon.orientationVertexArray, h3, a2, l2), e3 >= 0 && cg(this.icon.orientationVertexArray, p3, a2, l2);
                }
              }
              i2 || (this.text.orientationVertexArray = void 0), s2 || (this.icon.orientationVertexArray = void 0), e2 && (this.zOffsetBuffersNeedUpload = true, this.zOffsetSortDirty = true);
            }
            updateZOffset() {
              const t2 = (t3, e3, n3) => {
                r2 += e3, r2 > t3.length && t3.resize(r2);
                for (let i2 = -e3; i2 < 0; i2++) t3.emplace(i2 + r2, n3);
              }, e2 = (t3, e3, r3) => {
                n2 += e3, n2 > t3.length && t3.resize(n2);
                for (let i2 = -e3; i2 < 0; i2++) t3.emplace(i2 + n2, r3);
              };
              if (!this.zOffsetBuffersNeedUpload) return;
              this.zOffsetBuffersNeedUpload = false;
              let r2 = 0, n2 = 0;
              for (let r3 = 0; r3 < this.symbolInstances.length; r3++) {
                const n3 = this.symbolInstances.get(r3), { numHorizontalGlyphVertices: i2, numVerticalGlyphVertices: s2, numIconVertices: o2 } = n3, a2 = n3.zOffset, l2 = o2 > 0;
                if ((i2 > 0 || s2 > 0) && (t2(this.text.zOffsetVertexArray, i2, a2), t2(this.text.zOffsetVertexArray, s2, a2)), l2) {
                  const { placedIconSymbolIndex: t3, verticalPlacedIconSymbolIndex: r4 } = n3;
                  t3 >= 0 && e2(this.icon.zOffsetVertexArray, o2, a2), r4 >= 0 && e2(this.icon.zOffsetVertexArray, n3.numVerticalIconVertices, a2);
                }
              }
              this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
            }
            isEmpty() {
              return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
              return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(t2) {
              !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t2), this.iconCollisionBox.upload(t2)), this.text.upload(t2, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(t2, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = true;
            }
            destroyDebugData() {
              this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
              return this.projectionInstance || (this.projectionInstance = ig(this.projection)), this.projectionInstance;
            }
            destroy() {
              this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(t2, e2) {
              const r2 = this.lineVertexArray.length;
              if (void 0 !== t2.segment) for (const { x: t3, y: r3 } of e2) this.lineVertexArray.emplaceBack(t3, r3);
              return { lineStartIndex: r2, lineLength: this.lineVertexArray.length - r2 };
            }
            addSymbols(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2) {
              const y2 = t2.indexArray, g2 = t2.layoutVertexArray, x2 = t2.globeExtVertexArray, v2 = t2.segments.prepareSegment(4 * e2.length, g2, y2, this.canOverlap ? s2.sortKey : void 0), b2 = this.glyphOffsetArray.length, w2 = v2.vertexLength, _2 = this.allowVerticalPlacement && o2 === mm.vertical ? Math.PI / 2 : 0, A2 = s2.text && s2.text.sections;
              for (let n3 = 0; n3 < e2.length; n3++) {
                const { tl: i3, tr: o3, bl: u3, br: c3, texPrimary: h4, texSecondary: b3, pixelOffsetTL: w3, pixelOffsetBR: M3, minFontScaleX: I2, minFontScaleY: S2, glyphOffset: z2, isSDF: k2, sectionIndex: P2 } = e2[n3], E2 = v2.vertexLength, T2 = z2[1];
                if (ag(g2, l2.x, l2.y, i3.x, T2 + i3.y, h4.x, h4.y, r2, k2, w3.x, w3.y, I2, S2), ag(g2, l2.x, l2.y, o3.x, T2 + o3.y, h4.x + h4.w, h4.y, r2, k2, M3.x, w3.y, I2, S2), ag(g2, l2.x, l2.y, u3.x, T2 + u3.y, h4.x, h4.y + h4.h, r2, k2, w3.x, M3.y, I2, S2), ag(g2, l2.x, l2.y, c3.x, T2 + c3.y, h4.x + h4.w, h4.y + h4.h, r2, k2, M3.x, M3.y, I2, S2), a2) {
                  const { x: e3, y: r3, z: n4 } = a2.anchor, [i4, s3, o4] = a2.up;
                  ug(x2, e3, r3, n4, i4, s3, o4), ug(x2, e3, r3, n4, i4, s3, o4), ug(x2, e3, r3, n4, i4, s3, o4), ug(x2, e3, r3, n4, i4, s3, o4), hg(t2.dynamicLayoutVertexArray, e3, r3, n4, _2);
                } else hg(t2.dynamicLayoutVertexArray, l2.x, l2.y, l2.z, _2);
                if (m2) {
                  const e3 = b3 || h4;
                  lg(t2.iconTransitioningVertexArray, e3.x, e3.y), lg(t2.iconTransitioningVertexArray, e3.x + e3.w, e3.y), lg(t2.iconTransitioningVertexArray, e3.x, e3.y + e3.h), lg(t2.iconTransitioningVertexArray, e3.x + e3.w, e3.y + e3.h);
                }
                y2.emplaceBack(E2, E2 + 1, E2 + 2), y2.emplaceBack(E2 + 1, E2 + 2, E2 + 3), v2.vertexLength += 4, v2.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(z2[0]), n3 !== e2.length - 1 && P2 === e2[n3 + 1].sectionIndex || t2.programConfigurations.populatePaintArrays(g2.length, s2, s2.index, {}, p3, f2, d2, A2 && A2[P2], this.worldview);
              }
              const M2 = a2 ? a2.anchor : l2;
              t2.placedSymbolArray.emplaceBack(M2.x, M2.y, M2.z, l2.x, l2.y, b2, this.glyphOffsetArray.length - b2, w2, u2, c2, l2.segment, r2 ? r2[0] : 0, r2 ? r2[1] : 0, n2[0], n2[1], o2, 0, 0, 0, h3, 0);
            }
            _commitLayoutVertex(t2, e2, r2, n2, i2, s2, o2) {
              t2.emplaceBack(e2, r2, n2, i2, s2, Math.round(o2.x), Math.round(o2.y));
            }
            _addCollisionDebugVertices(t2, e2, r2, n2, i2, s2, o2) {
              const a2 = r2.segments.prepareSegment(4, r2.layoutVertexArray, r2.indexArray), l2 = a2.vertexLength, u2 = o2.tileAnchorX, c2 = o2.tileAnchorY;
              for (let t3 = 0; t3 < 4; t3++) r2.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
              this._commitDebugCollisionVertexUpdate(r2.collisionVertexArrayExt, e2, t2.padding, o2.zOffset), this._commitLayoutVertex(r2.layoutVertexArray, n2, i2, s2, u2, c2, new bt(t2.x1, t2.y1)), this._commitLayoutVertex(r2.layoutVertexArray, n2, i2, s2, u2, c2, new bt(t2.x2, t2.y1)), this._commitLayoutVertex(r2.layoutVertexArray, n2, i2, s2, u2, c2, new bt(t2.x2, t2.y2)), this._commitLayoutVertex(r2.layoutVertexArray, n2, i2, s2, u2, c2, new bt(t2.x1, t2.y2)), a2.vertexLength += 4;
              const h3 = r2.indexArray;
              h3.emplaceBack(l2, l2 + 1), h3.emplaceBack(l2 + 1, l2 + 2), h3.emplaceBack(l2 + 2, l2 + 3), h3.emplaceBack(l2 + 3, l2), a2.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(t2, e2, r2, n2, i2, s2) {
              for (let o2 = n2; o2 < i2; o2++) {
                const n3 = r2.get(o2), i3 = this.getSymbolInstanceTextSize(t2, s2, e2, o2);
                this._addCollisionDebugVertices(n3, i3, this.textCollisionBox, n3.projectedAnchorX, n3.projectedAnchorY, n3.projectedAnchorZ, s2);
              }
            }
            _addIconDebugCollisionBoxes(t2, e2, r2, n2, i2, s2) {
              for (let o2 = n2; o2 < i2; o2++) {
                const n3 = r2.get(o2), i3 = this.getSymbolInstanceIconSize(t2, e2, s2.placedIconSymbolIndex);
                this._addCollisionDebugVertices(n3, i3, this.iconCollisionBox, n3.projectedAnchorX, n3.projectedAnchorY, n3.projectedAnchorZ, s2);
              }
            }
            generateCollisionDebugBuffers(t2, e2, r2) {
              this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new dg(ba, Yd.members, xa), this.iconCollisionBox = new dg(ba, Yd.members, xa);
              const n2 = Lm(this.iconSizeData, t2), i2 = Lm(this.textSizeData, t2, r2);
              for (let r3 = 0; r3 < this.symbolInstances.length; r3++) {
                const s2 = this.symbolInstances.get(r3);
                this._addTextDebugCollisionBoxes(i2, t2, e2, s2.textBoxStartIndex, s2.textBoxEndIndex, s2), this._addTextDebugCollisionBoxes(i2, t2, e2, s2.verticalTextBoxStartIndex, s2.verticalTextBoxEndIndex, s2), this._addIconDebugCollisionBoxes(n2, t2, e2, s2.iconBoxStartIndex, s2.iconBoxEndIndex, s2), this._addIconDebugCollisionBoxes(n2, t2, e2, s2.verticalIconBoxStartIndex, s2.verticalIconBoxEndIndex, s2);
              }
            }
            getSymbolInstanceTextSize(t2, e2, r2, n2) {
              const i2 = this.text.placedSymbolArray.get(e2.rightJustifiedTextSymbolIndex >= 0 ? e2.rightJustifiedTextSymbolIndex : e2.centerJustifiedTextSymbolIndex >= 0 ? e2.centerJustifiedTextSymbolIndex : e2.leftJustifiedTextSymbolIndex >= 0 ? e2.leftJustifiedTextSymbolIndex : e2.verticalPlacedTextSymbolIndex >= 0 ? e2.verticalPlacedTextSymbolIndex : n2), s2 = Dm(this.textSizeData, t2, i2) / Jd;
              return this.tilePixelRatio * s2;
            }
            getSymbolInstanceIconSize(t2, e2, r2) {
              const n2 = this.icon.placedSymbolArray.get(r2), i2 = Dm(this.iconSizeData, t2, n2);
              return this.tilePixelRatio * i2;
            }
            _commitDebugCollisionVertexUpdate(t2, e2, r2, n2) {
              t2.emplaceBack(e2, -r2, -r2, n2), t2.emplaceBack(e2, r2, -r2, n2), t2.emplaceBack(e2, r2, r2, n2), t2.emplaceBack(e2, -r2, r2, n2);
            }
            _updateTextDebugCollisionBoxes(t2, e2, r2, n2, i2, s2, o2) {
              for (let o3 = n2; o3 < i2; o3++) {
                const n3 = r2.get(o3), i3 = this.getSymbolInstanceTextSize(t2, s2, e2, o3);
                this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i3, n3.padding, s2.zOffset);
              }
            }
            _updateIconDebugCollisionBoxes(t2, e2, r2, n2, i2, s2, o2) {
              for (let o3 = n2; o3 < i2; o3++) {
                const n3 = r2.get(o3), i3 = this.getSymbolInstanceIconSize(t2, e2, s2.placedIconSymbolIndex);
                this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i3, n3.padding, s2.zOffset);
              }
            }
            updateCollisionDebugBuffers(t2, e2, r2, n2) {
              if (!this.hasDebugData()) return;
              this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
              const i2 = Lm(this.iconSizeData, t2, n2), s2 = Lm(this.textSizeData, t2, r2);
              for (let o2 = 0; o2 < this.symbolInstances.length; o2++) {
                const a2 = this.symbolInstances.get(o2);
                this._updateTextDebugCollisionBoxes(s2, t2, e2, a2.textBoxStartIndex, a2.textBoxEndIndex, a2, r2), this._updateTextDebugCollisionBoxes(s2, t2, e2, a2.verticalTextBoxStartIndex, a2.verticalTextBoxEndIndex, a2, r2), this._updateIconDebugCollisionBoxes(i2, t2, e2, a2.iconBoxStartIndex, a2.iconBoxEndIndex, a2, n2), this._updateIconDebugCollisionBoxes(i2, t2, e2, a2.verticalIconBoxStartIndex, a2.verticalIconBoxEndIndex, a2, n2);
              }
              this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
              const u2 = {};
              if (e2 < r2) {
                const { x1: r3, y1: n3, x2: i3, y2: s3, padding: o3, projectedAnchorX: a3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h3, tileAnchorY: p3, featureIndex: f2 } = t2.get(e2);
                u2.textBox = { x1: r3, y1: n3, x2: i3, y2: s3, padding: o3, projectedAnchorX: a3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h3, tileAnchorY: p3 }, u2.textFeatureIndex = f2;
              }
              if (n2 < i2) {
                const { x1: e3, y1: r3, x2: i3, y2: s3, padding: o3, projectedAnchorX: a3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h3, tileAnchorY: p3, featureIndex: f2 } = t2.get(n2);
                u2.verticalTextBox = { x1: e3, y1: r3, x2: i3, y2: s3, padding: o3, projectedAnchorX: a3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h3, tileAnchorY: p3 }, u2.verticalTextFeatureIndex = f2;
              }
              if (s2 < o2) {
                const { x1: e3, y1: r3, x2: n3, y2: i3, padding: o3, projectedAnchorX: a3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h3, tileAnchorY: p3, featureIndex: f2 } = t2.get(s2);
                u2.iconBox = { x1: e3, y1: r3, x2: n3, y2: i3, padding: o3, projectedAnchorX: a3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h3, tileAnchorY: p3 }, u2.iconFeatureIndex = f2;
              }
              if (a2 < l2) {
                const { x1: e3, y1: r3, x2: n3, y2: i3, padding: s3, projectedAnchorX: o3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h3, tileAnchorY: p3, featureIndex: f2 } = t2.get(a2);
                u2.verticalIconBox = { x1: e3, y1: r3, x2: n3, y2: i3, padding: s3, projectedAnchorX: o3, projectedAnchorY: l3, projectedAnchorZ: c2, tileAnchorX: h3, tileAnchorY: p3 }, u2.verticalIconFeatureIndex = f2;
              }
              return u2;
            }
            deserializeCollisionBoxes(t2) {
              this.collisionArrays = [];
              for (let e2 = 0; e2 < this.symbolInstances.length; e2++) {
                const r2 = this.symbolInstances.get(e2);
                this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t2, r2.textBoxStartIndex, r2.textBoxEndIndex, r2.verticalTextBoxStartIndex, r2.verticalTextBoxEndIndex, r2.iconBoxStartIndex, r2.iconBoxEndIndex, r2.verticalIconBoxStartIndex, r2.verticalIconBoxEndIndex));
              }
            }
            hasTextData() {
              return this.text.segments.get().length > 0;
            }
            hasIconData() {
              return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
              return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
              return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
              return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
              return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(t2, e2) {
              const r2 = t2.placedSymbolArray.get(e2), n2 = r2.vertexStartIndex + 4 * r2.numGlyphs;
              for (let e3 = r2.vertexStartIndex; e3 < n2; e3 += 4) t2.indexArray.emplaceBack(e3, e3 + 1, e3 + 2), t2.indexArray.emplaceBack(e3 + 1, e3 + 2, e3 + 3);
            }
            getSortedSymbolIndexes(t2) {
              if (this.sortedAngle === t2 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
              const e2 = Math.sin(t2), r2 = Math.cos(t2), n2 = [], i2 = [], s2 = [];
              for (let t3 = 0; t3 < this.symbolInstances.length; ++t3) {
                s2.push(t3);
                const o2 = this.symbolInstances.get(t3);
                n2.push(0 | Math.round(e2 * o2.tileAnchorX + r2 * o2.tileAnchorY)), i2.push(o2.featureIndex);
              }
              return s2.sort((t3, e3) => n2[t3] - n2[e3] || i2[e3] - i2[t3]), s2;
            }
            getSortedIndexesByZOffset() {
              if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
              if (!this.symbolInstanceIndexesSortedZOffset) {
                this.symbolInstanceIndexesSortedZOffset = [];
                for (let t2 = 0; t2 < this.symbolInstances.length; ++t2) this.symbolInstanceIndexesSortedZOffset.push(t2);
              }
              return this.zOffsetSortDirty = false, this.symbolInstanceIndexesSortedZOffset.sort((t2, e2) => this.symbolInstances.get(e2).zOffset - this.symbolInstances.get(t2).zOffset);
            }
            addToSortKeyRanges(t2, e2) {
              const r2 = this.sortKeyRanges[this.sortKeyRanges.length - 1];
              r2 && r2.sortKey === e2 ? r2.symbolInstanceEnd = t2 + 1 : this.sortKeyRanges.push({ sortKey: e2, symbolInstanceStart: t2, symbolInstanceEnd: t2 + 1 });
            }
            sortFeatures(t2) {
              if (this.sortFeaturesByY && this.sortedAngle !== t2 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t2), this.sortedAngle = t2, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                for (const t3 of this.symbolInstanceIndexes) {
                  const e2 = this.symbolInstances.get(t3);
                  this.featureSortOrder.push(e2.featureIndex);
                  const { rightJustifiedTextSymbolIndex: r2, centerJustifiedTextSymbolIndex: n2, leftJustifiedTextSymbolIndex: i2, verticalPlacedTextSymbolIndex: s2, placedIconSymbolIndex: o2, verticalPlacedIconSymbolIndex: a2 } = e2;
                  r2 >= 0 && this.addIndicesForPlacedSymbol(this.text, r2), n2 >= 0 && n2 !== r2 && this.addIndicesForPlacedSymbol(this.text, n2), i2 >= 0 && i2 !== n2 && i2 !== r2 && this.addIndicesForPlacedSymbol(this.text, i2), s2 >= 0 && this.addIndicesForPlacedSymbol(this.text, s2), o2 >= 0 && this.addIndicesForPlacedSymbol(this.icon, o2), a2 >= 0 && this.addIndicesForPlacedSymbol(this.icon, a2);
                }
                this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
              }
            }
          }
          let yg, gg, xg;
          qs(mg, "SymbolBucket", { omit: ["layers", "collisionBoxArray", "features", "compareText"] }), mg.addDynamicAttributes = hg;
          class vg {
            constructor(t2) {
              this.type = t2.property.overrides ? t2.property.overrides.runtimeType : mr, this.defaultValue = t2;
            }
            evaluate(t2) {
              if (t2.formattedSection) {
                const e2 = this.defaultValue.property.overrides;
                if (e2 && e2.hasOverride(t2.formattedSection)) return e2.getOverride(t2.formattedSection);
              }
              return t2.feature && t2.featureState ? this.defaultValue.evaluate(t2.feature, t2.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(t2) {
              this.defaultValue.isConstant() || t2(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
              return false;
            }
            serialize() {
              return null;
            }
          }
          qs(vg, "FormatSectionOverride", { omit: ["defaultValue"] });
          const bg = () => xg || (xg = { layout: yg || (yg = new Po({ "symbol-placement": new So(Eo.layout_symbol["symbol-placement"]), "symbol-spacing": new So(Eo.layout_symbol["symbol-spacing"]), "symbol-avoid-edges": new So(Eo.layout_symbol["symbol-avoid-edges"]), "symbol-sort-key": new zo(Eo.layout_symbol["symbol-sort-key"]), "symbol-z-order": new So(Eo.layout_symbol["symbol-z-order"]), "symbol-z-elevate": new So(Eo.layout_symbol["symbol-z-elevate"]), "symbol-elevation-reference": new So(Eo.layout_symbol["symbol-elevation-reference"]), "icon-allow-overlap": new So(Eo.layout_symbol["icon-allow-overlap"]), "icon-ignore-placement": new So(Eo.layout_symbol["icon-ignore-placement"]), "icon-optional": new So(Eo.layout_symbol["icon-optional"]), "icon-rotation-alignment": new So(Eo.layout_symbol["icon-rotation-alignment"]), "icon-size": new zo(Eo.layout_symbol["icon-size"]), "icon-size-scale-range": new So(Eo.layout_symbol["icon-size-scale-range"]), "icon-text-fit": new zo(Eo.layout_symbol["icon-text-fit"]), "icon-text-fit-padding": new zo(Eo.layout_symbol["icon-text-fit-padding"]), "icon-image": new zo(Eo.layout_symbol["icon-image"]), "icon-rotate": new zo(Eo.layout_symbol["icon-rotate"]), "icon-padding": new So(Eo.layout_symbol["icon-padding"]), "icon-keep-upright": new So(Eo.layout_symbol["icon-keep-upright"]), "icon-offset": new zo(Eo.layout_symbol["icon-offset"]), "icon-anchor": new zo(Eo.layout_symbol["icon-anchor"]), "icon-pitch-alignment": new So(Eo.layout_symbol["icon-pitch-alignment"]), "text-pitch-alignment": new So(Eo.layout_symbol["text-pitch-alignment"]), "text-rotation-alignment": new So(Eo.layout_symbol["text-rotation-alignment"]), "text-field": new zo(Eo.layout_symbol["text-field"]), "text-font": new zo(Eo.layout_symbol["text-font"]), "text-size": new zo(Eo.layout_symbol["text-size"]), "text-size-scale-range": new So(Eo.layout_symbol["text-size-scale-range"]), "text-max-width": new zo(Eo.layout_symbol["text-max-width"]), "text-line-height": new zo(Eo.layout_symbol["text-line-height"]), "text-letter-spacing": new zo(Eo.layout_symbol["text-letter-spacing"]), "text-justify": new zo(Eo.layout_symbol["text-justify"]), "text-radial-offset": new zo(Eo.layout_symbol["text-radial-offset"]), "text-variable-anchor": new So(Eo.layout_symbol["text-variable-anchor"]), "text-anchor": new zo(Eo.layout_symbol["text-anchor"]), "text-max-angle": new So(Eo.layout_symbol["text-max-angle"]), "text-writing-mode": new So(Eo.layout_symbol["text-writing-mode"]), "text-rotate": new zo(Eo.layout_symbol["text-rotate"]), "text-padding": new So(Eo.layout_symbol["text-padding"]), "text-keep-upright": new So(Eo.layout_symbol["text-keep-upright"]), "text-transform": new zo(Eo.layout_symbol["text-transform"]), "text-offset": new zo(Eo.layout_symbol["text-offset"]), "text-allow-overlap": new So(Eo.layout_symbol["text-allow-overlap"]), "text-ignore-placement": new So(Eo.layout_symbol["text-ignore-placement"]), "text-optional": new So(Eo.layout_symbol["text-optional"]), visibility: new So(Eo.layout_symbol.visibility) })), paint: gg || (gg = new Po({ "icon-opacity": new zo(Eo.paint_symbol["icon-opacity"]), "icon-occlusion-opacity": new zo(Eo.paint_symbol["icon-occlusion-opacity"]), "icon-emissive-strength": new zo(Eo.paint_symbol["icon-emissive-strength"]), "text-emissive-strength": new zo(Eo.paint_symbol["text-emissive-strength"]), "icon-color": new zo(Eo.paint_symbol["icon-color"]), "icon-halo-color": new zo(Eo.paint_symbol["icon-halo-color"]), "icon-halo-width": new zo(Eo.paint_symbol["icon-halo-width"]), "icon-halo-blur": new zo(Eo.paint_symbol["icon-halo-blur"]), "icon-translate": new So(Eo.paint_symbol["icon-translate"]), "icon-translate-anchor": new So(Eo.paint_symbol["icon-translate-anchor"]), "icon-image-cross-fade": new So(Eo.paint_symbol["icon-image-cross-fade"]), "text-opacity": new zo(Eo.paint_symbol["text-opacity"]), "text-occlusion-opacity": new zo(Eo.paint_symbol["text-occlusion-opacity"]), "text-color": new zo(Eo.paint_symbol["text-color"], { runtimeType: vr, getOverride: (t2) => t2.textColor, hasOverride: (t2) => !!t2.textColor }), "text-halo-color": new zo(Eo.paint_symbol["text-halo-color"]), "text-halo-width": new zo(Eo.paint_symbol["text-halo-width"]), "text-halo-blur": new zo(Eo.paint_symbol["text-halo-blur"]), "text-translate": new So(Eo.paint_symbol["text-translate"]), "text-translate-anchor": new So(Eo.paint_symbol["text-translate-anchor"]), "icon-color-saturation": new So(Eo.paint_symbol["icon-color-saturation"]), "icon-color-contrast": new So(Eo.paint_symbol["icon-color-contrast"]), "icon-color-brightness-min": new So(Eo.paint_symbol["icon-color-brightness-min"]), "icon-color-brightness-max": new So(Eo.paint_symbol["icon-color-brightness-max"]), "symbol-z-offset": new zo(Eo.paint_symbol["symbol-z-offset"]), "icon-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "icon-halo-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "text-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "text-halo-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, xg);
          class wg extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, bg(), e2, r2, n2), this._colorAdjustmentMatrix = l([]), this.hasInitialOcclusionOpacityProperties = void 0 !== t2.paint && ("icon-occlusion-opacity" in t2.paint || "text-occlusion-opacity" in t2.paint);
            }
            recalculate(t2, e2) {
              super.recalculate(t2, e2), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
              const r2 = this.layout.get("text-writing-mode");
              if (r2) {
                const t3 = [];
                for (const e3 of r2) t3.indexOf(e3) < 0 && t3.push(e3);
                this.layout._values["text-writing-mode"] = t3;
              } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? ["horizontal"] : ["horizontal", "vertical"];
              this._setPaintOverrides();
            }
            getColorAdjustmentMatrix(t2, e2, r2, n2) {
              return this._saturation === t2 && this._contrast === e2 && this._brightnessMin === r2 && this._brightnessMax === n2 || (this._colorAdjustmentMatrix = function(t3, e3, r3, n3) {
                t3 = ee(t3), e3 = te(e3);
                const i2 = a(), s2 = t3 / 3, o2 = 1 - 2 * s2, l2 = [o2, s2, s2, 0, s2, o2, s2, 0, s2, s2, o2, 0, 0, 0, 0, 1], u2 = 0.5 - 0.5 * e3, h3 = n3 - r3;
                return c(i2, [h3, 0, 0, 0, 0, h3, 0, 0, 0, 0, h3, 0, r3, r3, r3, 1], [e3, 0, 0, 0, 0, e3, 0, 0, 0, 0, e3, 0, u2, u2, u2, 1]), c(i2, i2, l2), i2;
              }(t2, e2, r2, n2), this._saturation = t2, this._contrast = e2, this._brightnessMin = r2, this._brightnessMax = n2), this._colorAdjustmentMatrix;
            }
            getValueAndResolveTokens(t2, e2, r2, n2) {
              const i2 = this.layout.get(t2).evaluate(e2, {}, r2, n2), s2 = this._unevaluatedLayout._values[t2];
              return s2.isDataDriven() || Vs(s2.value) || !i2 ? i2 : function(t3, e3) {
                return e3.replace(/{([^{}]+)}/g, (e4, r3) => r3 in t3 ? String(t3[r3]) : "");
              }(e2.properties, i2);
            }
            createBucket(t2) {
              return new mg(t2);
            }
            queryRadius() {
              return 0;
            }
            queryIntersectsFeature() {
              return false;
            }
            _setPaintOverrides() {
              for (const t2 of bg().paint.overridableProperties) {
                if (!wg.hasPaintOverride(this.layout, t2)) continue;
                const e2 = this.paint.get(t2), r2 = new vg(e2), n2 = new Bs(r2, e2.property.specification, this.scope, this.options);
                let i2 = null;
                i2 = "constant" === e2.value.kind || "source" === e2.value.kind ? new Fs("source", n2) : new Ds("composite", n2, e2.value.zoomStops, e2.value.interpolationType), this.paint._values[t2] = new Mo(e2.property, i2, e2.parameters);
              }
            }
            _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
              return !(!this.layout || e2.isDataDriven() || r2.isDataDriven()) && wg.hasPaintOverride(this.layout, t2);
            }
            static hasPaintOverride(t2, e2) {
              const r2 = t2.get("text-field"), n2 = bg().paint.properties[e2];
              let i2 = false;
              const s2 = (t3) => {
                for (const e3 of t3) if (n2.overrides && n2.overrides.hasOverride(e3)) return void (i2 = true);
              };
              if ("constant" === r2.value.kind && r2.value.value instanceof Cr) s2(r2.value.value.sections);
              else if ("source" === r2.value.kind) {
                const t3 = (e4) => {
                  i2 || (e4 instanceof Nr && Or(e4.value) === Ar ? s2(e4.value.sections) : e4 instanceof qr ? s2(e4.sections) : e4.eachChild(t3));
                }, e3 = r2.value;
                e3._styleExpression && t3(e3._styleExpression.expression);
              }
              return i2;
            }
            getProgramIds() {
              return ["symbol"];
            }
            getDefaultProgramParams(t2, e2, r2) {
              return { config: new zl(this, { zoom: e2, lut: r2 }), overrideFog: false };
            }
            hasElevation() {
              return this.layout && "hd-road-markup" === this.layout.get("symbol-elevation-reference");
            }
          }
          let _g, Ag, Mg, Ig;
          var Sg = ta([{ name: "a_pos", type: "Int16", components: 2 }, { name: "a_texture_pos", type: "Int16", components: 2 }]);
          function zg(t2) {
            switch (t2) {
              case WebGL2RenderingContext.RGBA8:
                return WebGL2RenderingContext.RGBA;
              case WebGL2RenderingContext.DEPTH_COMPONENT16:
                return WebGL2RenderingContext.DEPTH_COMPONENT;
              case WebGL2RenderingContext.DEPTH24_STENCIL8:
                return WebGL2RenderingContext.DEPTH_STENCIL;
              case WebGL2RenderingContext.R8:
              case WebGL2RenderingContext.R32F:
                return WebGL2RenderingContext.RED;
            }
          }
          function kg(t2) {
            switch (t2) {
              case WebGL2RenderingContext.RGBA8:
                return WebGL2RenderingContext.UNSIGNED_BYTE;
              case WebGL2RenderingContext.DEPTH_COMPONENT16:
                return WebGL2RenderingContext.UNSIGNED_SHORT;
              case WebGL2RenderingContext.DEPTH24_STENCIL8:
                return WebGL2RenderingContext.UNSIGNED_INT_24_8;
              case WebGL2RenderingContext.R8:
                return WebGL2RenderingContext.UNSIGNED_BYTE;
              case WebGL2RenderingContext.R32F:
                return WebGL2RenderingContext.FLOAT;
            }
          }
          class Pg {
            constructor(t2, e2, r2, n2) {
              this.context = t2, this.format = r2, this.useMipmap = n2 && n2.useMipmap, this.texture = t2.gl.createTexture(), this.update(e2, { premultiply: n2 && n2.premultiply });
            }
            update(t2, e2) {
              const r2 = t2 && t2 instanceof HTMLVideoElement && 0 === t2.width ? t2.videoWidth : t2.width, n2 = t2 && t2 instanceof HTMLVideoElement && 0 === t2.height ? t2.videoHeight : t2.height, { context: i2 } = this, { gl: s2 } = i2, { x: o2, y: a2 } = e2 && e2.position ? e2.position : { x: 0, y: 0 }, l2 = o2 + r2, u2 = a2 + n2;
              !this.size || this.size[0] === l2 && this.size[1] === u2 || (s2.bindTexture(s2.TEXTURE_2D, null), s2.deleteTexture(this.texture), this.texture = s2.createTexture(), this.size = null), s2.bindTexture(s2.TEXTURE_2D, this.texture), i2.pixelStoreUnpackFlipY.set(false), i2.pixelStoreUnpack.set(1), i2.pixelStoreUnpackPremultiplyAlpha.set(this.format === s2.RGBA8 && (!e2 || false !== e2.premultiply));
              const c2 = t2 instanceof HTMLImageElement || t2 instanceof HTMLCanvasElement || t2 instanceof HTMLVideoElement || t2 instanceof ImageData || ImageBitmap && t2 instanceof ImageBitmap;
              if (!this.size && l2 > 0 && u2 > 0) {
                const t3 = this.useMipmap ? Math.floor(Math.log2(Math.max(l2, u2))) + 1 : 1;
                s2.texStorage2D(s2.TEXTURE_2D, t3, this.format, l2, u2), this.size = [l2, u2];
              }
              if (this.size) if (c2) s2.texSubImage2D(s2.TEXTURE_2D, 0, o2, a2, zg(this.format), kg(this.format), t2);
              else {
                const e3 = t2.data;
                e3 && s2.texSubImage2D(s2.TEXTURE_2D, 0, o2, a2, r2, n2, zg(this.format), kg(this.format), e3);
              }
              this.useMipmap && s2.generateMipmap(s2.TEXTURE_2D);
            }
            bind(t2, e2, r2 = false) {
              const { context: n2 } = this, { gl: i2 } = n2;
              i2.bindTexture(i2.TEXTURE_2D, this.texture), t2 !== this.minFilter && (i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_MAG_FILTER, t2), i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_MIN_FILTER, this.useMipmap && !r2 ? t2 === i2.NEAREST ? i2.NEAREST_MIPMAP_NEAREST : i2.LINEAR_MIPMAP_LINEAR : t2), this.minFilter = t2), e2 !== this.wrapS && (i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_WRAP_S, e2), i2.texParameteri(i2.TEXTURE_2D, i2.TEXTURE_WRAP_T, e2), this.wrapS = e2);
            }
            bindExtraParam(t2, e2, r2, n2, i2) {
              const { context: s2 } = this, { gl: o2 } = s2;
              o2.bindTexture(o2.TEXTURE_2D, this.texture), e2 !== this.magFilter && (o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_MAG_FILTER, e2), this.magFilter = e2), t2 !== this.minFilter && (o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_MIN_FILTER, this.useMipmap ? t2 === o2.NEAREST ? o2.NEAREST_MIPMAP_NEAREST : o2.LINEAR_MIPMAP_LINEAR : t2), this.minFilter = t2), r2 !== this.wrapS && (o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_WRAP_S, r2), this.wrapS = r2), n2 !== this.wrapT && (o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_WRAP_T, n2), this.wrapT = n2), i2 !== this.compareMode && (i2 ? (o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_COMPARE_MODE, o2.COMPARE_REF_TO_TEXTURE), o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_COMPARE_FUNC, i2)) : o2.texParameteri(o2.TEXTURE_2D, o2.TEXTURE_COMPARE_MODE, o2.NONE), this.compareMode = i2);
            }
            destroy() {
              const { gl: t2 } = this.context;
              t2.deleteTexture(this.texture), this.texture = null;
            }
          }
          class Eg {
            constructor(t2, e2) {
              this.context = t2, this.texture = e2;
            }
            bind(t2, e2) {
              const { context: r2 } = this, { gl: n2 } = r2;
              n2.bindTexture(n2.TEXTURE_2D, this.texture), t2 !== this.minFilter && (n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_MAG_FILTER, t2), n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_MIN_FILTER, t2), this.minFilter = t2), e2 !== this.wrapS && (n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_WRAP_S, e2), n2.texParameteri(n2.TEXTURE_2D, n2.TEXTURE_WRAP_T, e2), this.wrapS = e2);
            }
          }
          function Tg(t2, e2, r2, n2, i2, a2, l2, u2) {
            const c2 = [t2, e2, 1, r2, n2, 1, i2, a2, 1], h3 = [l2, u2, 1], p3 = s([], c2), [f2, d2, m2] = O(h3, h3, p3);
            return o(c2, c2, [f2, 0, 0, 0, d2, 0, 0, 0, m2]);
          }
          function Bg(t2, e2, r2, n2, i2, a2, l2, u2) {
            const c2 = function(t3, e3, r3, n3, i3, a3, l3, u3) {
              const c3 = Tg(0, 0, 1, 0, 1, 1, 0, 1), h3 = Tg(t3, e3, r3, n3, i3, a3, l3, u3);
              return o(h3, h3, s([], c3));
            }(t2, e2, r2, n2, i2, a2, l2, u2);
            return [c2[2] / c2[8] / Cn, c2[5] / c2[8] / Cn];
          }
          function Vg(t2) {
            return [t2[0], Math.min(Math.max(t2[1], -85.051129), nu)];
          }
          class Cg extends tr {
            constructor(t2, e2, r2, n2) {
              super(), this.id = t2, this.dispatcher = r2, this.coordinates = e2.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = false, this.onNorthPole = false, this.onSouthPole = false, this.setEventedParent(n2), this.options = e2, this._dirty = false;
            }
            load(t2, e2) {
              if (this._loaded = e2 || false, this.fire(new Ye("dataloading", { dataType: "source" })), this.url = this.options.url, !this.url) return t2 && (this.coordinates = t2), this._loaded = true, void this._finishLoading();
              this._imageRequest = Ne(this.map._requestManager.transformRequest(this.url, Be.Image), (e3, r2) => {
                this._imageRequest = null, this._loaded = true, e3 ? this.fire(new Ke(e3)) : r2 && (this.image = r2 instanceof HTMLImageElement ? fe.getImageData(r2) : r2, this._dirty = true, this.width = this.image.width, this.height = this.image.height, t2 && (this.coordinates = t2), this._finishLoading());
              });
            }
            loaded() {
              return this._loaded;
            }
            updateImage(t2) {
              return t2.url ? (this._imageRequest && t2.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = t2.url, this.load(t2.coordinates, this._loaded), this) : this;
            }
            setTexture(t2) {
              if (!(t2.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
              return this.texture = new Eg(this.map.painter.context, t2.handle), this.width = t2.dimensions[0], this.height = t2.dimensions[1], this._dirty = false, this._loaded = true, this._finishLoading(), this;
            }
            _finishLoading() {
              this.map && (this.setCoordinates(this.coordinates), this.fire(new Ye("data", { dataType: "source", sourceDataType: "metadata" })));
            }
            onAdd(t2) {
              this.map = t2, this.load();
            }
            onRemove(t2) {
              this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof Eg || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
            }
            setCoordinates(t2) {
              if (this.coordinates = t2, this._boundsArray = void 0, this._unsupportedCoords = false, !t2.length) return this;
              this.onNorthPole = false, this.onSouthPole = false;
              let e2 = t2[0][1], r2 = t2[0][1];
              for (const n3 of t2) n3[1] > r2 && (r2 = n3[1]), n3[1] < e2 && (e2 = n3[1]);
              const n2 = (r2 + e2) / 2;
              if (n2 > nu ? this.onNorthPole = true : n2 < -85.051129 && (this.onSouthPole = true), !this.onNorthPole && !this.onSouthPole) {
                const e3 = t2.map(lu.fromLngLat);
                this.tileID = function(t3) {
                  let e4 = 1 / 0, r3 = 1 / 0, n3 = -1 / 0, i2 = -1 / 0;
                  for (const s3 of t3) e4 = Math.min(e4, s3.x), r3 = Math.min(r3, s3.y), n3 = Math.max(n3, s3.x), i2 = Math.max(i2, s3.y);
                  const s2 = Math.max(n3 - e4, i2 - r3), o2 = Math.max(0, Math.floor(-Math.log(s2) / Math.LN2)), a2 = Math.pow(2, o2);
                  let l2 = Math.floor((e4 + n3) / 2 * a2);
                  return l2 > 1 && (l2 -= 1), new bc(o2, l2, Math.floor((r3 + i2) / 2 * a2));
                }(e3), this.minzoom = this.maxzoom = this.tileID.z;
              }
              return this.fire(new Ye("data", { dataType: "source", sourceDataType: "content" })), this;
            }
            _clear() {
              this._boundsArray = void 0, this._unsupportedCoords = false;
            }
            _prepareData(t2) {
              for (const t3 in this.tiles) {
                const e3 = this.tiles[t3];
                "loaded" !== e3.state && (e3.state = "loaded", e3.texture = this.texture);
              }
              if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
              const e2 = Dy(new bc(0, 0, 0), this.map.transform.projection), r2 = [e2.projection.project(this.coordinates[0][0], this.coordinates[0][1]), e2.projection.project(this.coordinates[1][0], this.coordinates[1][1]), e2.projection.project(this.coordinates[2][0], this.coordinates[2][1]), e2.projection.project(this.coordinates[3][0], this.coordinates[3][1])];
              if (!function(t3) {
                const e3 = t3[1].x - t3[0].x, r3 = t3[1].y - t3[0].y, n3 = t3[2].x - t3[1].x, i3 = t3[2].y - t3[1].y, s2 = t3[3].x - t3[2].x, o2 = t3[3].y - t3[2].y, a3 = t3[0].x - t3[3].x, l3 = t3[0].y - t3[3].y, u3 = e3 * i3 - n3 * r3, c3 = n3 * o2 - s2 * i3, h4 = s2 * l3 - a3 * o2, p4 = a3 * r3 - e3 * l3;
                return u3 > 0 && c3 > 0 && h4 > 0 && p4 > 0 || u3 < 0 && c3 < 0 && h4 < 0 && p4 < 0;
              }(r2)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = true);
              const n2 = Dy(this.tileID, this.map.transform.projection), [i2, a2, l2, u2] = this.coordinates.map((t3) => {
                const e3 = n2.projection.project(t3[0], t3[1]);
                return Ly(n2, e3)._round();
              });
              this.perspectiveTransform = Bg(i2.x, i2.y, a2.x, a2.y, l2.x, l2.y, u2.x, u2.y);
              const c2 = this._boundsArray = new ia();
              c2.emplaceBack(i2.x, i2.y, 0, 0), c2.emplaceBack(a2.x, a2.y, Cn, 0), c2.emplaceBack(u2.x, u2.y, 0, Cn), c2.emplaceBack(l2.x, l2.y, Cn, Cn), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = t2.createVertexBuffer(c2, Sg.members), this.boundsSegments = tl.simpleSegment(0, 0, 4, 2);
              const h3 = [], p3 = [Vg((f2 = this.coordinates)[0]), Vg(f2[1]), Vg(f2[2]), Vg(f2[3])];
              var f2;
              const [d2, m2, y2, g2] = function(t3) {
                let e3 = t3[0][0], r3 = e3, n3 = t3[0][1], i3 = n3;
                for (let s2 = 1; s2 < t3.length; s2++) t3[s2][0] < e3 ? e3 = t3[s2][0] : t3[s2][0] > r3 && (r3 = t3[s2][0]), t3[s2][1] < n3 ? n3 = t3[s2][1] : t3[s2][1] > i3 && (i3 = t3[s2][1]);
                return [e3, n3, r3 - e3, i3 - n3];
              }(p3);
              {
                const n3 = new ia(), [i3, a3, l3, u3] = function(t3) {
                  let e3 = t3[0].x, r3 = e3, n4 = t3[0].y, i4 = n4;
                  for (let s2 = 1; s2 < t3.length; s2++) t3[s2].x < e3 ? e3 = t3[s2].x : t3[s2].x > r3 && (r3 = t3[s2].x), t3[s2].y < n4 ? n4 = t3[s2].y : t3[s2].y > i4 && (i4 = t3[s2].y);
                  return [e3, n4, r3 - e3, i4 - n4];
                }(r2), c3 = (t3) => [(t3.x - i3) / l3, (t3.y - a3) / u3], [p4, f3, x2, v2] = r2.map(c3), b2 = function(t3, e3, r3, n4, i4, a4, l4, u4) {
                  const c4 = Tg(0, 0, 1, 0, 1, 1, 0, 1);
                  return o(c4, c4, s([], Tg(t3, e3, r3, n4, i4, a4, l4, u4)));
                }(p4[0], p4[1], f3[0], f3[1], x2[0], x2[1], v2[0], v2[1]);
                this.elevatedGlobePerspectiveTransform = Bg(p4[0], p4[1], f3[0], f3[1], x2[0], x2[1], v2[0], v2[1]);
                const w2 = (t3, e3) => {
                  h3.push(t3.lng);
                  const r3 = Math.round((t3.lng - d2) / y2 * Cn), i4 = Math.round((t3.lat - m2) / g2 * Cn), s2 = c3(e3), o2 = O([], [s2[0], s2[1], 1], b2), a4 = Math.round(o2[0] / o2[2] * Cn), l4 = Math.round(o2[1] / o2[2] * Cn);
                  n3.emplaceBack(r3, i4, a4, l4);
                }, _2 = r2[3].x - r2[0].x, A2 = r2[3].y - r2[0].y, M2 = r2[2].x - r2[1].x, I2 = r2[2].y - r2[1].y;
                for (let t3 = 0; t3 < 65; t3++) {
                  const n4 = t3 / 64, i4 = [r2[0].x + n4 * _2, r2[0].y + n4 * A2], s2 = [r2[1].x + n4 * M2, r2[1].y + n4 * I2], o2 = s2[0] - i4[0], a4 = s2[1] - i4[1];
                  for (let t4 = 0; t4 < 65; t4++) {
                    const r3 = t4 / 64, n5 = { x: i4[0] + o2 * r3, y: i4[1] + a4 * r3 };
                    w2(e2.projection.unproject(n5.x, n5.y), n5);
                  }
                }
                this.elevatedGlobeVertexBuffer = t2.createVertexBuffer(n3, Sg.members);
              }
              {
                this.maxLongitudeTriangleSize = 0;
                let e3 = [], r3 = new Aa();
                const n3 = (t3, n4, i3) => {
                  r3.emplaceBack(t3, n4, i3);
                  const s2 = h3[t3], o2 = h3[n4], a3 = h3[i3], l3 = Math.min(Math.min(s2, o2), a3), u3 = Math.max(Math.max(s2, o2), a3) - l3;
                  u3 > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = u3), e3.push(l3 + u3 / 2);
                };
                for (let t3 = 0; t3 < 64; t3++) for (let e4 = 0; e4 < 64; e4++) {
                  const r4 = 65 * t3 + e4, i3 = r4 + 1, s2 = r4 + 65, o2 = s2 + 1;
                  n3(r4, s2, i3), n3(i3, s2, o2);
                }
                [e3, r3] = function(t3, e4) {
                  const r4 = Array.from({ length: t3.length }, (t4, e5) => e5);
                  r4.sort((e5, r5) => t3[e5] - t3[r5]);
                  const n4 = [], i3 = new Aa();
                  for (let s2 = 0; s2 < r4.length; s2++) {
                    const o2 = r4[s2];
                    n4.push(t3[o2]);
                    const a3 = 3 * o2, l3 = a3 + 1;
                    i3.emplaceBack(e4.uint16[a3], e4.uint16[l3], e4.uint16[l3 + 1]);
                  }
                  return [n4, i3];
                }(e3, r3), this.elevatedGlobeTrianglesCenterLongitudes = e3, this.elevatedGlobeIndexBuffer = t2.createIndexBuffer(r3);
              }
              this.elevatedGlobeSegments = tl.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([0, y2 / Cn, 0, g2 / Cn, 0, 0, m2, d2, 0]);
            }
            prepare() {
              const t2 = 0 !== Object.keys(this.tiles).length;
              if (this.tileID && !t2) return;
              const e2 = this.map.painter.context, r2 = e2.gl;
              !this._dirty || this.texture instanceof Eg || (this.texture ? this.texture.update(this.image) : (this.texture = new Pg(e2, this.image, r2.RGBA8), this.texture.bind(r2.LINEAR, r2.CLAMP_TO_EDGE)), this._dirty = false), t2 && this._prepareData(e2);
            }
            loadTile(t2, e2) {
              this.tileID && this.tileID.equals(t2.tileID.canonical) ? (this.tiles[String(t2.tileID.wrap)] = t2, t2.buckets = {}, e2(null)) : (t2.state = "errored", e2(null));
            }
            serialize() {
              return { type: "image", url: this.options.url, coordinates: this.coordinates };
            }
            hasTransition() {
              return false;
            }
            getSegmentsForLongitude(t2) {
              const e2 = this.elevatedGlobeSegments;
              if (!this.elevatedGlobeTrianglesCenterLongitudes || !e2) return null;
              const r2 = this.elevatedGlobeTrianglesCenterLongitudes;
              let n2 = (i2 = t2 + 180) + 360 * Math.round((r2[0] - i2) / 360);
              var i2;
              const s2 = new tl(), o2 = (t3, r3) => {
                s2.segments.push({ vertexOffset: 0, primitiveOffset: t3, vertexLength: e2.segments[0].vertexLength, primitiveLength: r3, sortKey: void 0, vaos: {} });
              }, a2 = 0.51 * this.maxLongitudeTriangleSize;
              if (Math.abs(r2[0] - n2) <= a2) {
                const t3 = Qt(r2, 0, r2.length, n2 + a2);
                return t3 === r2.length || o2(t3, Jt(r2, t3 + 1, r2.length, n2 + 360 - a2) - t3), s2;
              }
              n2 < r2[0] && (n2 += 360);
              const l2 = Jt(r2, 0, r2.length, n2 - a2);
              if (l2 === r2.length) return o2(0, r2.length), s2;
              o2(0, l2 - 0);
              const u2 = Qt(r2, l2 + 1, r2.length, n2 + a2);
              return u2 !== r2.length && o2(u2, r2.length - u2), s2;
            }
          }
          const Fg = (Math.pow(256, 2) - 1) / 16907520;
          class Dg extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: Mg || (Mg = new Po({ visibility: new So(Eo.layout_raster.visibility) })), paint: Ig || (Ig = new Po({ "raster-opacity": new So(Eo.paint_raster["raster-opacity"]), "raster-color": new ko(Eo.paint_raster["raster-color"]), "raster-color-mix": new So(Eo.paint_raster["raster-color-mix"]), "raster-color-range": new So(Eo.paint_raster["raster-color-range"]), "raster-hue-rotate": new So(Eo.paint_raster["raster-hue-rotate"]), "raster-brightness-min": new So(Eo.paint_raster["raster-brightness-min"]), "raster-brightness-max": new So(Eo.paint_raster["raster-brightness-max"]), "raster-saturation": new So(Eo.paint_raster["raster-saturation"]), "raster-contrast": new So(Eo.paint_raster["raster-contrast"]), "raster-resampling": new So(Eo.paint_raster["raster-resampling"]), "raster-fade-duration": new So(Eo.paint_raster["raster-fade-duration"]), "raster-emissive-strength": new So(Eo.paint_raster["raster-emissive-strength"]), "raster-array-band": new So(Eo.paint_raster["raster-array-band"]), "raster-elevation": new So(Eo.paint_raster["raster-elevation"]), "raster-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2), this.updateColorRamp(), this._curRampRange = [NaN, NaN];
            }
            getProgramIds() {
              return ["raster"];
            }
            hasColorMap() {
              return !!this._transitionablePaint._values["raster-color"].value.value;
            }
            tileCoverLift() {
              return this.paint.get("raster-elevation");
            }
            isDraped(t2) {
              return !(t2 && t2._source instanceof Cg && (t2._source.onNorthPole || t2._source.onSouthPole)) && 0 === this.paint.get("raster-elevation");
            }
            _handleSpecialPaintPropertyUpdate(t2) {
              "raster-color" !== t2 && "raster-color-range" !== t2 || (this._curRampRange = [NaN, NaN], this.updateColorRamp());
            }
            updateColorRamp(t2) {
              if (!this.hasColorMap()) return;
              if (!this._curRampRange) return;
              const e2 = this._transitionablePaint._values["raster-color"].value.expression, [r2, n2] = t2 || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({ zoom: 0 }) || [NaN, NaN];
              isNaN(r2) && isNaN(n2) || r2 === this._curRampRange[0] && n2 === this._curRampRange[1] || (this.colorRamp = xh({ expression: e2, evaluationKey: "rasterValue", image: this.colorRamp, clips: [{ start: r2, end: n2 }], resolution: 256 }), this.colorRampTexture = null, this._curRampRange = [r2, n2]);
            }
          }
          let Lg, Rg, Og, Ug, Ng;
          class jg extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: Lg || (Lg = new Po({ visibility: new So(Eo["layout_raster-particle"].visibility) })), paint: Rg || (Rg = new Po({ "raster-particle-array-band": new So(Eo["paint_raster-particle"]["raster-particle-array-band"]), "raster-particle-count": new So(Eo["paint_raster-particle"]["raster-particle-count"]), "raster-particle-color": new ko(Eo["paint_raster-particle"]["raster-particle-color"]), "raster-particle-max-speed": new So(Eo["paint_raster-particle"]["raster-particle-max-speed"]), "raster-particle-speed-factor": new So(Eo["paint_raster-particle"]["raster-particle-speed-factor"]), "raster-particle-fade-opacity-factor": new So(Eo["paint_raster-particle"]["raster-particle-fade-opacity-factor"]), "raster-particle-reset-rate-factor": new So(Eo["paint_raster-particle"]["raster-particle-reset-rate-factor"]), "raster-particle-elevation": new So(Eo["paint_raster-particle"]["raster-particle-elevation"]), "raster-particle-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2), this._updateColorRamp(), this.lastInvalidatedAt = fe.now();
            }
            onRemove(t2) {
              this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
            }
            hasColorMap() {
              return !!this._transitionablePaint._values["raster-particle-color"].value.value;
            }
            getProgramIds() {
              return ["rasterParticle"];
            }
            hasOffscreenPass() {
              return "none" !== this.visibility;
            }
            isDraped(t2) {
              return false;
            }
            _handleSpecialPaintPropertyUpdate(t2) {
              "raster-particle-color" !== t2 && "raster-particle-max-speed" !== t2 || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === t2 && this._invalidateAnimationState();
            }
            _updateColorRamp() {
              if (!this.hasColorMap()) return;
              const t2 = this._transitionablePaint._values["raster-particle-color"].value.expression, e2 = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({ zoom: 0 });
              this.colorRamp = xh({ expression: t2, evaluationKey: "rasterParticleSpeed", image: this.colorRamp, clips: [{ start: 0, end: e2 }], resolution: 256 }), this.colorRampTexture = null;
            }
            _invalidateAnimationState() {
              this.lastInvalidatedAt = fe.now();
            }
            tileCoverLift() {
              return this.paint.get("raster-particle-elevation");
            }
          }
          class $g extends Yo {
            constructor(t2, e2) {
              super(t2, {}, e2, null), this.implementation = t2, t2.slot && (this.slot = t2.slot);
            }
            is3D(t2) {
              return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
              return void 0 !== this.implementation.prerender;
            }
            isDraped(t2) {
              return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
              return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {
            }
            updateTransitions() {
            }
            hasTransition() {
              return false;
            }
            serialize() {
            }
            onAdd(t2) {
              this.implementation.onAdd && this.implementation.onAdd(t2, t2.painter.context.gl);
            }
            onRemove(t2) {
              this.implementation.onRemove && this.implementation.onRemove(t2, t2.painter.context.gl);
            }
          }
          function Gg(t2, e2, r2) {
            const n2 = [0, 0, 1], i2 = Y([]);
            return J(i2, i2, r2 ? -Mt(t2) + Math.PI : Mt(t2)), K(i2, i2, -Mt(e2)), U(n2, n2, i2), C(n2, n2);
          }
          function qg(t2, e2) {
            const r2 = Xg(t2.projection, t2.zoom, t2.width, t2.height), n2 = function(t3, e3, r3, n3, i3) {
              const s2 = new Hl(r3.lng - 180 * Zg, r3.lat), o2 = new Hl(r3.lng + 180 * Zg, r3.lat), a2 = t3.project(s2.lng, s2.lat), u2 = t3.project(o2.lng, o2.lat), h3 = -Math.atan2(u2.y - a2.y, u2.x - a2.x), f2 = lu.fromLngLat(r3);
              f2.y = Et(f2.y, -1 + Zg, 1 - Zg);
              const d2 = f2.toLngLat(), y2 = t3.project(d2.lng, d2.lat), g2 = lu.fromLngLat(d2);
              g2.x += Zg;
              const x2 = g2.toLngLat(), v2 = t3.project(x2.lng, x2.lat), b2 = Yg(v2.x - y2.x, v2.y - y2.y, h3), w2 = lu.fromLngLat(d2);
              w2.y += Zg;
              const _2 = w2.toLngLat(), A2 = t3.project(_2.lng, _2.lat), M2 = Yg(A2.x - y2.x, A2.y - y2.y, h3), I2 = Math.abs(b2.x) / Math.abs(M2.y), S2 = l([]);
              m(S2, S2, -h3 * (1 - (i3 ? 0 : n3)));
              const z2 = l([]);
              return p2(z2, z2, [1, 1 - (1 - I2) * n3, 1]), z2[4] = -M2.x / M2.y * n3, m(z2, z2, h3), c(z2, S2, z2), z2;
            }(t2.projection, 0, t2.center, r2, e2), i2 = Hg(t2);
            return p2(n2, n2, [i2, i2, 1]), n2;
          }
          function Hg(t2) {
            const e2 = t2.projection, r2 = Xg(t2.projection, t2.zoom, t2.width, t2.height), n2 = Wg(e2, t2.center), i2 = Wg(e2, Hl.convert(e2.center));
            return Math.pow(2, n2 * r2 + (1 - r2) * i2);
          }
          function Xg(t2, e2, r2, n2, i2 = 1 / 0) {
            const s2 = t2.range;
            if (!s2) return 0;
            const o2 = Math.min(i2, Math.max(r2, n2)), a2 = Math.log(o2 / 1024) / Math.LN2;
            return Tt(s2[0] + a2, s2[1] + a2, e2);
          }
          const Zg = 1 / 4e4;
          function Wg(t2, e2) {
            const r2 = Et(e2.lat, -85.051129, nu), n2 = new Hl(e2.lng - 180 * Zg, r2), i2 = new Hl(e2.lng + 180 * Zg, r2), s2 = t2.project(n2.lng, r2), o2 = t2.project(i2.lng, r2), a2 = lu.fromLngLat(n2), l2 = lu.fromLngLat(i2), u2 = o2.x - s2.x, c2 = o2.y - s2.y, h3 = l2.x - a2.x, p3 = l2.y - a2.y, f2 = Math.sqrt((h3 * h3 + p3 * p3) / (u2 * u2 + c2 * c2));
            return Math.log(f2) / Math.LN2;
          }
          function Yg(t2, e2, r2) {
            const n2 = Math.cos(r2), i2 = Math.sin(r2);
            return { x: t2 * n2 - e2 * i2, y: t2 * i2 + e2 * n2 };
          }
          function Kg(t2, e2, r2) {
            l(t2), m(t2, t2, Mt(e2[2])), f(t2, t2, Mt(e2[0])), d(t2, t2, Mt(e2[1])), p2(t2, t2, r2), c(t2, t2, [1, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 1]);
          }
          function Jg(t2, e2, r2, n2, i2, s2, o2, a2) {
            const l2 = [r2[0] - e2[0], r2[1] - e2[1], 0], u2 = [n2[0] - e2[0], n2[1] - e2[1], 0];
            if (_(l2) < 1e-12 || _(u2) < 1e-12) return Y(t2);
            const c2 = D([], l2, u2);
            C(c2, c2), I(u2, n2, e2), l2[2] = (s2 - i2) * a2, u2[2] = (o2 - i2) * a2;
            const h3 = l2;
            return D(h3, l2, u2), C(h3, h3), st(t2, c2, h3);
          }
          function Qg(t2, e2, r2 = false) {
            const n2 = Zc(e2.zoom), i2 = function(t3, e3, r3) {
              const n3 = e3.worldSize, i3 = [t3[12], t3[13], t3[14]], s2 = eu(i3[1] / n3), o2 = tu(i3[0] / n3), a2 = l([]), u2 = Ql(1, s2) * n3, f2 = Ql(1, 0) * n3 * su(s2, e3.zoom), d2 = 1 / qc(n3);
              let m2 = f2 * d2;
              if (r3) {
                const t4 = Xg(e3.projection, e3.zoom, e3.width, e3.height, 1024);
                m2 = d2 * e3.projection.pixelSpaceConversion(e3.center.lat, n3, t4);
              }
              const y2 = $l(s2, o2);
              M(y2, y2, P([], C([], y2), u2 * m2 * i3[2]));
              const g2 = function(t4) {
                const e4 = [t4[0], t4[1], t4[2]];
                let r4 = [0, 1, 0];
                const n4 = D([], r4, e4);
                return D(r4, e4, n4), 0 === B(r4) && (r4 = [0, 1, 0], D(n4, e4, r4)), C(n4, n4), C(r4, r4), C(e4, e4), [n4[0], n4[1], n4[2], 0, r4[0], r4[1], r4[2], 0, e4[0], e4[1], e4[2], 0, t4[0], t4[1], t4[2], 1];
              }(y2);
              p2(a2, a2, [m2, m2, m2 * u2]), h2(a2, a2, [-i3[0], -i3[1], -i3[2]]);
              const x2 = c([], e3.globeMatrix, g2);
              return c(x2, x2, a2), c(x2, x2, t3), x2;
            }(t2, e2, r2);
            if (n2 > 0) {
              const r3 = function(t3, e3) {
                const r4 = e3.worldSize, n3 = Ql(1, 0) * r4 * su(e3.center.lat, e3.zoom) / qc(r4), i3 = Ql(1, e3.center.lat) * r4, s2 = l([]);
                return d(s2, s2, Mt(e3.center.lng)), f(s2, s2, Mt(e3.center.lat)), h2(s2, s2, [0, 0, Cl]), p2(s2, s2, [n3, n3, n3 * i3]), h2(s2, s2, [e3.point.x - 0.5 * r4, e3.point.y - 0.5 * r4, 0]), c(s2, s2, t3), c(s2, e3.globeMatrix, s2);
              }(t2, e2);
              return function(t3, e3, r4) {
                const n3 = (t4, e4, r5) => {
                  const n4 = _(t4), i4 = _(e4), s3 = Fc(t4, e4, r5);
                  return P(s3, s3, 1 / _(s3) * ur(n4, i4, r5));
                }, i3 = n3([t3[0], t3[1], t3[2]], [e3[0], e3[1], e3[2]], r4), s2 = n3([t3[4], t3[5], t3[6]], [e3[4], e3[5], e3[6]], r4), o2 = n3([t3[8], t3[9], t3[10]], [e3[8], e3[9], e3[10]], r4), a2 = Fc([t3[12], t3[13], t3[14]], [e3[12], e3[13], e3[14]], r4);
                return [i3[0], i3[1], i3[2], 0, s2[0], s2[1], s2[2], 0, o2[0], o2[1], o2[2], 0, a2[0], a2[1], a2[2], 1];
              }(i2, r3, n2);
            }
            return i2;
          }
          function tx(t2, e2, r2, n2) {
            const i2 = qu.projectAabbCorners(n2, r2);
            let s2 = Number.MAX_VALUE, o2 = -1;
            for (let t3 = 0; t3 < i2.length; ++t3) {
              const r3 = i2[t3];
              r3[0] = (0.5 * r3[0] + 0.5) * e2.width, r3[1] = (0.5 - 0.5 * r3[1]) * e2.height, r3[2] < s2 && (o2 = t3, s2 = r3[2]);
            }
            const a2 = (t3) => new bt(i2[t3][0], i2[t3][1]);
            let l2;
            switch (o2) {
              case 0:
              case 6:
                l2 = [a2(1), a2(5), a2(4), a2(7), a2(3), a2(2), a2(1)];
                break;
              case 1:
              case 7:
                l2 = [a2(0), a2(4), a2(5), a2(6), a2(2), a2(3), a2(0)];
                break;
              case 3:
              case 5:
                l2 = [a2(1), a2(0), a2(4), a2(7), a2(6), a2(2), a2(1)];
                break;
              default:
                l2 = [a2(1), a2(5), a2(6), a2(7), a2(3), a2(0), a2(1)];
            }
            if (Ku(t2, l2)) return s2;
          }
          const ex = ta([{ name: "a_pos_3f", components: 3, type: "Float32" }]), rx = ta([{ name: "a_color_3f", components: 3, type: "Float32" }]), nx = ta([{ name: "a_color_4f", components: 4, type: "Float32" }]), ix = ta([{ name: "a_uv_2f", components: 2, type: "Float32" }]), sx = ta([{ name: "a_normal_3f", components: 3, type: "Float32" }]), ox = ta([{ name: "a_normal_matrix0", components: 4, type: "Float32" }, { name: "a_normal_matrix1", components: 4, type: "Float32" }, { name: "a_normal_matrix2", components: 4, type: "Float32" }, { name: "a_normal_matrix3", components: 4, type: "Float32" }]), ax = ta([{ name: "a_pbr", components: 4, type: "Uint16" }, { name: "a_heightBasedEmissiveStrength", components: 3, type: "Float32" }]), lx = { None: 0, Model: 1, Symbol: 2, FillExtrusion: 4 };
          class ux {
            constructor(t2, e2, r2, n2) {
              this.message = (t2 ? `${t2}: ` : "") + r2, n2 && (this.identifier = n2), null != e2 && e2.__line__ && (this.line = e2.__line__);
            }
          }
          function cx(t2, e2) {
            const r2 = -1 === t2.indexOf("://");
            try {
              return new URL(t2, r2 && e2 ? "http://example.com" : void 0), true;
            } catch (t3) {
              return false;
            }
          }
          class hx {
            constructor(t2, e2) {
              this.feature = t2, this.instancedDataOffset = e2, this.instancedDataCount = 0, this.rotation = [0, 0, 0], this.scale = [1, 1, 1], this.translation = [0, 0, 0];
            }
          }
          class px {
            constructor() {
              this.instancedDataArray = new Ca(), this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
          }
          class fx {
            constructor(t2) {
              this.zoom = t2.zoom, this.canonical = t2.canonical, this.layers = t2.layers, this.layerIds = this.layers.map((t3) => t3.fqid), this.projection = t2.projection, this.index = t2.index, this.worldview = t2.worldview, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.hasPattern = false, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = { id: null, timestamp: 0 }, this.modelUris = [], this.modelsRequested = false, this.activeReplacements = [], this.replacementUpdateTime = 0, this.styleDefinedModelURLs = t2.styleDefinedModelURLs;
            }
            updateFootprints(t2, e2) {
            }
            populate(t2, e2, r2, n2) {
              this.tileToMeter = au(r2);
              const i2 = this.layers[0]._featureFilter.needGeometry;
              this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
              for (const { feature: s2, id: o2, index: a2, sourceLayerIndex: l2 } of t2) {
                const t3 = null != o2 ? o2 : s2.properties && s2.properties.hasOwnProperty("id") ? s2.properties.id : void 0, u2 = gu(s2, i2);
                if (!this.layers[0]._featureFilter.filter(new go(this.zoom, { worldview: this.worldview }), u2, r2)) continue;
                const c2 = { id: t3, sourceLayerIndex: l2, index: a2, geometry: i2 ? u2.geometry : yu(s2, r2, n2), properties: s2.properties, type: s2.type, patterns: {} }, h3 = this.addFeature(c2, c2.geometry, u2);
                h3 && e2.featureIndex.insert(s2, c2.geometry, a2, l2, this.index, this.instancesPerModel[h3].instancedDataArray.length, Cn / 32);
              }
              this.lookup = null;
            }
            update(t2, e2, r2, n2) {
              for (const e3 in this.instancesPerModel) {
                const r3 = this.instancesPerModel[e3];
                for (const e4 in t2) r3.idToFeaturesIndex.hasOwnProperty(e4) && (this.evaluate(r3.features[r3.idToFeaturesIndex[e4]], t2[e4], r3, true), this.uploaded = false);
              }
              this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
              if (!this.hasZoomDependentProperties) return false;
              let t2 = false;
              for (const e2 in this.instancesPerModel) {
                const r2 = this.instancesPerModel[e2];
                for (const e3 of r2.features) {
                  const n2 = this.layers[0], i2 = e3.feature, s2 = this.canonical, o2 = n2.paint.get("model-rotation").evaluate(i2, {}, s2), a2 = n2.paint.get("model-scale").evaluate(i2, {}, s2), l2 = n2.paint.get("model-translation").evaluate(i2, {}, s2);
                  N(e3.rotation, o2) && N(e3.scale, a2) && N(e3.translation, l2) || (this.evaluate(e3, e3.featureStates, r2, true), t2 = true);
                }
              }
              return t2;
            }
            updateReplacement(t2, e2, r2, n2) {
              if (e2.updateTime === this.replacementUpdateTime) return false;
              this.replacementUpdateTime = e2.updateTime;
              const i2 = e2.getReplacementRegionsForTile(t2.toUnwrapped(), true);
              if (Vp(this.activeReplacements, i2)) return false;
              this.activeReplacements = i2;
              let s2 = false;
              for (const e3 in this.instancesPerModel) {
                const i3 = this.instancesPerModel[e3], o2 = i3.instancedDataArray;
                for (const e4 of i3.features) {
                  const i4 = e4.instancedDataOffset, a2 = e4.instancedDataCount;
                  for (let e5 = 0; e5 < a2; e5++) {
                    const a3 = 16 * (e5 + i4);
                    let l2 = o2.float32[a3 + 0];
                    const u2 = l2 > Cn;
                    l2 = u2 ? l2 - Cn : l2;
                    const c2 = Math.floor(l2), h3 = o2.float32[a3 + 1];
                    let p3 = false;
                    for (const e6 of this.activeReplacements) if (!Pp(e6, r2, lx.Model, n2) && !(e6.min.x > c2 || c2 > e6.max.x || e6.min.y > h3 || h3 > e6.max.y) && (p3 = Op(Rp(c2, h3, t2.canonical, e6.footprintTileId.canonical), e6.footprint), p3)) break;
                    o2.float32[a3] = p3 ? l2 + Cn : l2, s2 = s2 || p3 !== u2;
                  }
                }
              }
              return s2;
            }
            isEmpty() {
              for (const t2 in this.instancesPerModel) if (0 !== this.instancesPerModel[t2].instancedDataArray.length) return false;
              return true;
            }
            uploadPending() {
              return !this.uploaded;
            }
            upload(t2) {
              if (!this.uploaded) for (const e2 in this.instancesPerModel) {
                const r2 = this.instancesPerModel[e2];
                r2.instancedDataArray.length < 0 || 0 === r2.instancedDataArray.length || (r2.instancedDataBuffer ? r2.instancedDataBuffer.updateData(r2.instancedDataArray) : r2.instancedDataBuffer = t2.createVertexBuffer(r2.instancedDataArray, ox.members, true, void 0, this.instanceCount));
              }
              this.uploaded = true;
            }
            destroy() {
              for (const t3 in this.instancesPerModel) {
                const e2 = this.instancesPerModel[t3];
                0 !== e2.instancedDataArray.length && e2.instancedDataBuffer && e2.instancedDataBuffer.destroy();
              }
              const t2 = this.layers[0].modelManager;
              if (t2 && this.modelUris && this.modelsRequested) for (const e2 of this.modelUris) t2.removeModel(e2, "", true);
            }
            addFeature(t2, e2, r2) {
              const n2 = this.layers[0], i2 = n2.layout.get("model-id").evaluate(r2, {}, this.canonical);
              if (!i2) return Gt(`modelId is not evaluated for layer ${n2.id} and it is not going to get rendered.`), i2;
              (cx(i2, false) || void 0 !== this.styleDefinedModelURLs[i2]) && (this.modelUris.includes(i2) || this.modelUris.push(i2)), this.instancesPerModel[i2] || (this.instancesPerModel[i2] = new px());
              const s2 = this.instancesPerModel[i2], o2 = s2.instancedDataArray, a2 = new hx(r2, o2.length);
              for (const t3 of e2) for (const e3 of t3) {
                if (e3.x < 0 || e3.x >= Cn || e3.y < 0 || e3.y >= Cn) continue;
                const t4 = (this.lookupDim - 1) / Cn, r3 = this.lookupDim * (e3.y * t4 | 0) + e3.x * t4 | 0;
                if (this.lookup) {
                  if (0 !== this.lookup[r3]) continue;
                  this.lookup[r3] = 1;
                }
                this.instanceCount++;
                const n3 = o2.length;
                o2.resize(n3 + 1), s2.instancesEvaluatedElevation.push(0), o2.float32[16 * n3] = e3.x, o2.float32[16 * n3 + 1] = e3.y;
              }
              return a2.instancedDataCount = s2.instancedDataArray.length - a2.instancedDataOffset, a2.instancedDataCount > 0 && (t2.id && (s2.idToFeaturesIndex[t2.id] = s2.features.length), s2.features.push(a2), this.evaluate(a2, {}, s2, false)), i2;
            }
            getModelUris() {
              return this.modelUris;
            }
            evaluate(t2, e2, r2, n2) {
              const i2 = this.layers[0], s2 = t2.feature, o2 = this.canonical, a2 = t2.rotation = i2.paint.get("model-rotation").evaluate(s2, e2, o2), l2 = t2.scale = i2.paint.get("model-scale").evaluate(s2, e2, o2), u2 = t2.translation = i2.paint.get("model-translation").evaluate(s2, e2, o2), c2 = i2.paint.get("model-color").evaluate(s2, e2, o2);
              c2.a = i2.paint.get("model-color-mix-intensity").evaluate(s2, e2, o2);
              const h3 = [];
              this.maxVerticalOffset < u2[2] && (this.maxVerticalOffset = u2[2]), this.maxScale = Math.max(Math.max(this.maxScale, l2[0]), Math.max(l2[1], l2[2])), Kg(h3, a2, l2);
              const p3 = Math.round(100 * c2.a) + c2.b / 1.05;
              for (let e3 = 0; e3 < t2.instancedDataCount; ++e3) {
                const i3 = t2.instancedDataOffset + e3, s3 = 16 * i3, a3 = r2.instancedDataArray.float32;
                let l3 = 0;
                n2 && (l3 = a3[s3 + 6] - r2.instancesEvaluatedElevation[i3]);
                const f2 = 0 | a3[s3 + 1];
                a3[s3] = (0 | a3[s3]) + c2.r / 1.05, a3[s3 + 1] = f2 + c2.g / 1.05, a3[s3 + 2] = p3, a3[s3 + 3] = 1 / (o2.z > 10 ? this.tileToMeter : au(o2, f2)), a3[s3 + 4] = u2[0], a3[s3 + 5] = u2[1], a3[s3 + 6] = u2[2] + l3, a3[s3 + 7] = h3[0], a3[s3 + 8] = h3[1], a3[s3 + 9] = h3[2], a3[s3 + 10] = h3[4], a3[s3 + 11] = h3[5], a3[s3 + 12] = h3[6], a3[s3 + 13] = h3[8], a3[s3 + 14] = h3[9], a3[s3 + 15] = h3[10], r2.instancesEvaluatedElevation[i3] = u2[2];
              }
            }
          }
          let dx, mx;
          qs(fx, "ModelBucket", { omit: ["layers"] }), qs(px, "PerModelAttributes"), qs(hx, "ModelFeature");
          const yx = 64, gx = { CoordinateSpaceTile: 1, HasMapboxMeshFeatures: 4, HasMeshoptCompression: 8 };
          function xx(t2, e2, r2, n2, i2, s2, o2, a2, u2, f2 = false) {
            const d2 = r2.zoom, m2 = r2.project(n2), y2 = su(n2.lat, d2), g2 = 1 / y2;
            l(t2), h2(t2, t2, [m2.x + o2[0] * g2, m2.y + o2[1] * g2, o2[2]]);
            let v2 = 1, b2 = 1;
            const w2 = r2.worldSize;
            if (f2) {
              if ("mercator" === r2.projection.name) {
                let t3 = 0;
                r2.elevation && (t3 = r2.elevation.getAtPointOrZero(new lu(m2.x / w2, m2.y / w2), 0));
                const e3 = Z([], [m2.x, m2.y, t3, 1], r2.projMatrix)[3] / r2.cameraToCenterDistance;
                v2 = e3, b2 = e3 * su(r2.center.lat, d2);
              } else if ("globe" === r2.projection.name) {
                const e3 = Qg(t2, r2), i3 = [0, 0, 0, 1];
                Z(i3, i3, c([], r2.projMatrix, e3));
                const s3 = i3[3] / r2.cameraToCenterDistance, o3 = Zc(d2), a3 = r2.projection.pixelsPerMeter(n2.lat, w2) * su(n2.lat, d2), l2 = r2.projection.pixelsPerMeter(r2.center.lat, w2) * su(r2.center.lat, d2);
                v2 = s3 / ur(a3, iu(r2.center.lat), o3), b2 = s3 * y2 / a3, v2 *= l2, b2 *= l2;
              }
            } else v2 = g2;
            p2(t2, t2, [v2, v2, b2]);
            const _2 = [...t2], A2 = e2.orientation, M2 = [];
            if (Kg(M2, [A2[0] + i2[0], A2[1] + i2[1], A2[2] + i2[2]], s2), c(t2, _2, M2), a2 && r2.elevation) {
              let i3 = 0;
              const s3 = [];
              if (u2 && r2.elevation) {
                i3 = function(t3, e3, r3, n3, i4) {
                  const s4 = e3.elevation;
                  if (!s4) return 0;
                  const o4 = qu.projectAabbCorners(r3, n3), a3 = Ql(1, i4.lat) * e3.worldSize, l2 = function(t4, e4) {
                    const r4 = [0, 0, 1], n4 = [{ corners: [0, 1, 3, 2], dotProductWithUp: 0 }, { corners: [1, 5, 2, 6], dotProductWithUp: 0 }, { corners: [0, 4, 1, 5], dotProductWithUp: 0 }, { corners: [2, 6, 3, 7], dotProductWithUp: 0 }, { corners: [4, 7, 5, 6], dotProductWithUp: 0 }, { corners: [0, 3, 4, 7], dotProductWithUp: 0 }];
                    for (const i5 of n4) {
                      const n5 = t4[i5.corners[0]], s5 = t4[i5.corners[1]], o5 = t4[i5.corners[2]], a4 = [s5[0] - n5[0], s5[1] - n5[1], e4 * (s5[2] - n5[2])], l3 = D(a4, a4, [o5[0] - n5[0], o5[1] - n5[1], e4 * (o5[2] - n5[2])]);
                      C(l3, l3), i5.dotProductWithUp = F(l3, r4);
                    }
                    return n4.sort((t5, e5) => t5.dotProductWithUp - e5.dotProductWithUp), n4[0].corners;
                  }(o4, a3), u3 = o4[l2[0]], c2 = o4[l2[1]], h3 = o4[l2[2]], p3 = o4[l2[3]], f3 = s4.getAtPointOrZero(new lu(u3[0] / e3.worldSize, u3[1] / e3.worldSize), 0), d3 = s4.getAtPointOrZero(new lu(c2[0] / e3.worldSize, c2[1] / e3.worldSize), 0), m3 = s4.getAtPointOrZero(new lu(h3[0] / e3.worldSize, h3[1] / e3.worldSize), 0), y3 = s4.getAtPointOrZero(new lu(p3[0] / e3.worldSize, p3[1] / e3.worldSize), 0), g3 = (f3 + y3) / 2, x2 = (d3 + m3) / 2;
                  return g3 > x2 ? d3 < m3 ? Jg(t3, c2, p3, u3, d3, y3, f3, a3) : Jg(t3, h3, u3, p3, m3, f3, y3, a3) : f3 < y3 ? Jg(t3, u3, c2, h3, f3, d3, m3, a3) : Jg(t3, p3, h3, c2, y3, m3, d3, a3), Math.max(g3, x2);
                }(s3, r2, e2.aabb, t2, n2);
                const o3 = c([], x([], s3), M2);
                c(t2, _2, o3);
              } else i3 = r2.elevation.getAtPointOrZero(new lu(m2.x / w2, m2.y / w2), 0);
              0 !== i3 && (t2[14] += i3);
            }
          }
          function vx(t2, e2, r2 = false) {
            t2.uploaded || (t2.gfxTexture = new Pg(e2, t2.image, r2 ? e2.gl.R8 : e2.gl.RGBA8, { useMipmap: t2.sampler.minFilter >= e2.gl.NEAREST_MIPMAP_NEAREST }), t2.uploaded = true, t2.image = null);
          }
          function bx(t2, e2, r2) {
            t2.indexBuffer = e2.createIndexBuffer(t2.indexArray, false, true), t2.vertexBuffer = e2.createVertexBuffer(t2.vertexArray, ex.members, false, true), t2.normalArray && (t2.normalBuffer = e2.createVertexBuffer(t2.normalArray, sx.members, false, true)), t2.texcoordArray && (t2.texcoordBuffer = e2.createVertexBuffer(t2.texcoordArray, ix.members, false, true)), t2.colorArray && (t2.colorBuffer = e2.createVertexBuffer(t2.colorArray, (12 === t2.colorArray.bytesPerElement ? rx : nx).members, false, true)), t2.featureArray && (t2.pbrBuffer = e2.createVertexBuffer(t2.featureArray, ax.members, true)), t2.segments = tl.simpleSegment(0, 0, t2.vertexArray.length, t2.indexArray.length);
            const n2 = t2.material;
            n2.pbrMetallicRoughness.baseColorTexture && vx(n2.pbrMetallicRoughness.baseColorTexture, e2), n2.pbrMetallicRoughness.metallicRoughnessTexture && vx(n2.pbrMetallicRoughness.metallicRoughnessTexture, e2), n2.normalTexture && vx(n2.normalTexture, e2), n2.occlusionTexture && vx(n2.occlusionTexture, e2, r2), n2.emissionTexture && vx(n2.emissionTexture, e2);
          }
          function wx(t2, e2, r2) {
            if (t2.meshes) for (const n2 of t2.meshes) bx(n2, e2, r2);
            if (t2.children) for (const n2 of t2.children) wx(n2, e2, r2);
          }
          function _x(t2) {
            if (t2.meshes) for (const e2 of t2.meshes) e2.indexArray.destroy(), e2.vertexArray.destroy(), e2.colorArray && e2.colorArray.destroy(), e2.normalArray && e2.normalArray.destroy(), e2.texcoordArray && e2.texcoordArray.destroy(), e2.featureArray && e2.featureArray.destroy();
            if (t2.children) for (const e2 of t2.children) _x(e2);
          }
          function Ax(t2) {
            if (t2.meshes) for (const r2 of t2.meshes) r2.vertexBuffer && (r2.vertexBuffer.destroy(), r2.indexBuffer.destroy(), r2.normalBuffer && r2.normalBuffer.destroy(), r2.texcoordBuffer && r2.texcoordBuffer.destroy(), r2.colorBuffer && r2.colorBuffer.destroy(), r2.pbrBuffer && r2.pbrBuffer.destroy(), r2.segments.destroy(), r2.material && ((e2 = r2.material).pbrMetallicRoughness.baseColorTexture && e2.pbrMetallicRoughness.baseColorTexture.gfxTexture && e2.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), e2.pbrMetallicRoughness.metallicRoughnessTexture && e2.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && e2.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), e2.normalTexture && e2.normalTexture.gfxTexture && e2.normalTexture.gfxTexture.destroy(), e2.emissionTexture && e2.emissionTexture.gfxTexture && e2.emissionTexture.gfxTexture.destroy(), e2.occlusionTexture && e2.occlusionTexture.gfxTexture && e2.occlusionTexture.gfxTexture.destroy()));
            var e2;
            if (t2.children) for (const e3 of t2.children) Ax(e3);
          }
          class Mx {
            constructor(t2, e2, r2) {
              this._demTile = t2, this._dem = this._demTile.dem, this._scale = e2, this._offset = r2;
            }
            static create(t2, e2, r2) {
              const n2 = r2 || t2.findDEMTileFor(e2);
              if (!n2 || !n2.dem) return;
              const i2 = n2.dem, s2 = n2.tileID, o2 = 1 << e2.canonical.z - s2.canonical.z;
              return new Mx(n2, i2.dim / Cn / o2, [(e2.canonical.x / o2 - s2.canonical.x) * i2.dim, (e2.canonical.y / o2 - s2.canonical.y) * i2.dim]);
            }
            tileCoordToPixel(t2, e2) {
              const r2 = e2 * this._scale + this._offset[1], n2 = Math.floor(t2 * this._scale + this._offset[0]), i2 = Math.floor(r2);
              return new bt(n2, i2);
            }
            getElevationAt(t2, e2, r2, n2) {
              const i2 = t2 * this._scale + this._offset[0], s2 = e2 * this._scale + this._offset[1], o2 = Math.floor(i2), a2 = Math.floor(s2), l2 = this._dem;
              return n2 = !!n2, r2 ? ur(ur(l2.get(o2, a2, n2), l2.get(o2, a2 + 1, n2), s2 - a2), ur(l2.get(o2 + 1, a2, n2), l2.get(o2 + 1, a2 + 1, n2), s2 - a2), i2 - o2) : l2.get(o2, a2, n2);
            }
            getElevationAtPixel(t2, e2, r2) {
              return this._dem.get(t2, e2, !!r2);
            }
            getMeterToDEM(t2) {
              return (1 << this._demTile.tileID.canonical.z) * Ql(1, t2) * this._dem.stride;
            }
          }
          const Ix = new Float32Array(262144), Sx = new Uint8Array(262144);
          function zx(t2) {
            let e2 = 0;
            if (t2.meshes) for (const r2 of t2.meshes) e2 = Math.max(e2, r2.aabb.max[2]);
            if (t2.children) for (const r2 of t2.children) e2 = Math.max(e2, zx(r2));
            return e2;
          }
          function kx(t2, e2, r2) {
            if (t2.meshes) for (const n2 of t2.meshes) {
              if (n2.aabb.min[0] === 1 / 0) continue;
              const i2 = qu.applyTransform(n2.aabb, t2.matrix);
              r2.insert(e2, i2.min[0], i2.min[1], i2.max[0], i2.max[1]);
            }
            if (t2.children) for (const n2 of t2.children) kx(n2, e2, r2);
          }
          const Px = ["", "wall", "door", "roof", "window", "lamp", "logo"];
          class Ex {
            constructor(t2) {
              this.node = t2, this.evaluatedRMEA = [[1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1], [0.4, 1, 0, 1], [1, 0, 0, 1], [1, 0, 0, 1]], this.hiddenByReplacement = false, this.evaluatedTranslation = [0, 0, 0], this.evaluatedScale = [1, 1, 1], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.cameraCollisionOpacity = 1, this.feature = { type: "Point", id: t2.id, geometry: [], properties: { height: zx(t2) } }, this.aabb = this._getLocalBounds(), this.state = null;
            }
            _getLocalBounds() {
              if (!this.node.meshes) return new qu([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
              if (!this.aabb) {
                let t2 = 0;
                const e2 = new qu([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]);
                for (const r2 of this.node.meshes) this.node.lightMeshIndex !== t2 && (r2.transformedAabb = qu.applyTransformFast(r2.aabb, this.node.matrix), e2.encapsulate(r2.transformedAabb)), t2++;
                this.aabb = e2;
              }
              return this.aabb;
            }
          }
          class Tx {
            constructor(t2, e2, r2, n2, i2, s2, o2, a2) {
              this.id = r2, this.layers = t2, this.layerIds = this.layers.map((t3) => t3.fqid), this.stateDependentLayerIds = this.layers.filter((t3) => t3.isStateDependent()).map((t3) => t3.id), this.modelTraits |= gx.CoordinateSpaceTile, this.uploaded = false, this.hasPattern = false, n2 && (this.modelTraits |= gx.HasMapboxMeshFeatures), i2 && (this.modelTraits |= gx.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = { name: "mercator" }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = s2, this.worldview = a2, this.dirty = true, this.needsUpload = false, this.filter = null, this.nodesInfo = [];
              for (const t3 of e2) this.nodesInfo.push(new Ex(t3)), kx(t3, o2.featureIndexArray.length, o2.grid), o2.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, o2.bucketLayerIDs.length - 1, 0);
              this.states = {};
            }
            updateFootprints(t2, e2) {
              for (const r2 of this.getNodesInfo()) {
                const n2 = r2.node;
                n2.footprint && e2.push({ footprint: n2.footprint, id: t2 });
              }
            }
            update(t2) {
              const e2 = 0 !== Object.keys(t2).length;
              if (e2 && !this.stateDependentLayers.length) return;
              const r2 = e2 ? this.stateDependentLayers : this.layers;
              if (!wt(t2, this.states)) for (const e3 of r2) this.evaluate(e3, t2);
              this.states = structuredClone(t2);
            }
            populate() {
              console.log("populate 3D model bucket");
            }
            uploadPending() {
              return !this.uploaded || this.needsUpload;
            }
            upload(t2) {
              if (!this.needsUpload) return;
              const e2 = this.getNodesInfo();
              for (const r2 of e2) {
                const e3 = r2.node;
                this.uploaded ? this.updatePbrBuffer(e3) : wx(e3, t2, true);
              }
              for (const t3 of e2) _x(t3.node);
              this.uploaded = true, this.needsUpload = false;
            }
            updatePbrBuffer(t2) {
              let e2 = false;
              if (!t2.meshes) return e2;
              for (const r2 of t2.meshes) r2.pbrBuffer && (r2.pbrBuffer.updateData(r2.featureArray), e2 = true);
              return e2;
            }
            needsReEvaluation(t2, e2, r2) {
              const n2 = t2.transform.projectionOptions, i2 = t2.style.getBrightness(), s2 = this.brightness !== i2;
              if (!this.uploaded || this.dirty || n2.name !== this.projection.name || Bx(r2.paint.get("model-color").value, s2) || Bx(r2.paint.get("model-color-mix-intensity").value, s2) || Bx(r2.paint.get("model-roughness").value, s2) || Bx(r2.paint.get("model-emissive-strength").value, s2) || Bx(r2.paint.get("model-height-based-emissive-strength-multiplier").value, s2)) {
                this.projection = n2, this.brightness = i2;
                const t3 = this.getNodesInfo();
                for (const e3 of t3) e3.state = null;
                return true;
              }
              return false;
            }
            evaluateTransform(t2, e2) {
              if (t2.transform.zoom === this.zoom) return;
              this.zoom = t2.transform.zoom;
              const r2 = this.getNodesInfo(), n2 = this.id.canonical;
              for (const t3 of r2) {
                const r3 = t3.feature;
                t3.evaluatedTranslation = e2.paint.get("model-translation").evaluate(r3, {}, n2), t3.evaluatedScale = e2.paint.get("model-scale").evaluate(r3, {}, n2);
              }
            }
            evaluate(t2, e2) {
              const r2 = this.getNodesInfo();
              for (const n2 of r2) {
                if (!n2.node.meshes) continue;
                const r3 = n2.feature, i2 = e2 && e2[r3.id];
                if (wt(i2, n2.state)) continue;
                n2.state = structuredClone(i2);
                const s2 = n2.node.meshes && n2.node.meshes[0].featureData, o2 = n2.evaluatedColor[2], a2 = n2.evaluatedRMEA[2], l2 = this.id.canonical;
                if (n2.hasTranslucentParts = false, s2) {
                  for (let e3 = 0; e3 < Px.length; e3++) {
                    const s3 = Px[e3];
                    s3.length && (r3.properties.part = s3);
                    const o3 = t2.paint.get("model-color").evaluate(r3, i2, l2).toPremultipliedRenderColor(null), a3 = t2.paint.get("model-color-mix-intensity").evaluate(r3, i2, l2);
                    n2.evaluatedColor[e3] = [o3.r, o3.g, o3.b, a3], n2.evaluatedRMEA[e3][0] = t2.paint.get("model-roughness").evaluate(r3, i2, l2), n2.evaluatedRMEA[e3][2] = t2.paint.get("model-emissive-strength").evaluate(r3, i2, l2), n2.evaluatedRMEA[e3][3] = o3.a, n2.emissionHeightBasedParams[e3] = t2.paint.get("model-height-based-emissive-strength-multiplier").evaluate(r3, i2, l2), !n2.hasTranslucentParts && o3.a < 1 && (n2.hasTranslucentParts = true);
                  }
                  delete r3.properties.part, Cx(n2, o2 !== n2.evaluatedColor[2] || a2 !== n2.evaluatedRMEA[2], this.modelTraits);
                } else n2.evaluatedRMEA[0][2] = t2.paint.get("model-emissive-strength").evaluate(r3, i2, l2);
                n2.evaluatedTranslation = t2.paint.get("model-translation").evaluate(r3, i2, l2), n2.evaluatedScale = t2.paint.get("model-scale").evaluate(r3, i2, l2), this.updatePbrBuffer(n2.node) || (this.needsUpload = true);
              }
              this.dirty = false;
            }
            elevationUpdate(t2, e2, r2, n2) {
              const i2 = t2.findDEMTileFor(r2);
              if (i2 && (i2.tileID.canonical !== this.terrainTile || e2 !== this.terrainExaggeration)) {
                if (i2.dem && i2.tileID.overscaledZ !== this.elevationReadFromZ) {
                  this.elevationReadFromZ = i2.tileID.overscaledZ;
                  const e3 = Mx.create(t2, r2, i2);
                  if (!e3) return;
                  this.modelTraits & gx.HasMapboxMeshFeatures && this.updateDEM(t2, e3, r2, n2);
                  for (const t3 of this.getNodesInfo()) {
                    const r3 = t3.node;
                    if (!r3.footprint || !r3.footprint.vertices || !r3.footprint.vertices.length) continue;
                    const n3 = r3.footprint.vertices;
                    let i3 = e3.getElevationAt(n3[0].x, n3[0].y, true, true);
                    for (let t4 = 1; t4 < n3.length; t4++) i3 = Math.min(i3, e3.getElevationAt(n3[t4].x, n3[t4].y, true, true));
                    r3.elevation = i3;
                  }
                }
                this.terrainTile = i2.tileID.canonical, this.terrainExaggeration = e2;
              }
            }
            updateDEM(t2, e2, r2, n2) {
              let i2 = e2._dem._modifiedForSources[n2];
              if (void 0 === i2 && (e2._dem._modifiedForSources[n2] = [], i2 = e2._dem._modifiedForSources[n2]), i2.includes(r2.canonical)) return;
              const s2 = e2._dem.dim;
              i2.push(r2.canonical);
              let o2 = false;
              for (const t3 of this.getNodesInfo()) {
                const r3 = t3.node;
                if (!r3.footprint || !r3.footprint.grid) continue;
                const n3 = r3.footprint.grid, i3 = e2.tileCoordToPixel(n3.min.x, n3.min.y), a2 = e2.tileCoordToPixel(n3.max.x, n3.max.y), l2 = Math.min(Math.min(s2 - a2.y, i3.x), Math.min(i3.y, s2 - a2.x));
                if (l2 < 0) continue;
                const u2 = Et(l2, 2, 5);
                let c2 = Math.max(0, i3.x - u2), h3 = Math.max(0, i3.y - u2), p3 = Math.min(a2.x + u2, s2 - 1), f2 = Math.min(a2.y + u2, s2 - 1);
                for (let t4 = h3; t4 <= f2; ++t4) for (let e3 = c2; e3 <= p3; ++e3) Sx[t4 * s2 + e3] = 255;
                let d2 = 0, m2 = 0;
                for (let t4 = 0; t4 < n3.cellsY; ++t4) for (let r4 = 0; r4 < n3.cellsX; ++r4) {
                  if (!n3.cells[t4 * n3.cellsX + r4]) continue;
                  const i4 = e2.tileCoordToPixel(n3.min.x + r4 / n3.xScale, n3.min.y + t4 / n3.yScale), o3 = e2.tileCoordToPixel(n3.min.x + (r4 + 1) / n3.xScale, n3.min.y + (t4 + 1) / n3.yScale);
                  for (let t5 = i4.y; t5 <= Math.min(o3.y + 1, s2 - 1); ++t5) for (let r5 = i4.x; r5 <= Math.min(o3.x + 1, s2 - 1); ++r5) 255 === Sx[t5 * s2 + r5] && (Sx[t5 * s2 + r5] = 0, d2 += e2.getElevationAtPixel(r5, t5), m2++);
                }
                const y2 = d2 / m2;
                c2 = Math.max(1, i3.x - u2), h3 = Math.max(1, i3.y - u2), p3 = Math.min(a2.x + u2, s2 - 2), f2 = Math.min(a2.y + u2, s2 - 2), o2 = true;
                for (let t4 = h3; t4 <= f2; ++t4) for (let r4 = c2; r4 <= p3; ++r4) 0 === Sx[t4 * s2 + r4] && (Ix[t4 * s2 + r4] = e2._dem.set(r4, t4, y2));
                for (let t4 = 1; t4 < u2; ++t4) {
                  c2 = Math.max(1, i3.x - t4), h3 = Math.max(1, i3.y - t4), p3 = Math.min(a2.x + t4, s2 - 2), f2 = Math.min(a2.y + t4, s2 - 2);
                  for (let r4 = h3; r4 <= f2; ++r4) for (let n4 = c2; n4 <= p3; ++n4) {
                    const i4 = r4 * s2 + n4;
                    if (255 === Sx[i4]) {
                      let o3 = 0, a3 = 0, l3 = -1, c3 = -1;
                      for (let e3 = -1; e3 <= 1; ++e3) for (let i5 = -1; i5 <= 1; ++i5) {
                        const u3 = (r4 + e3) * s2 + n4 + i5;
                        if (Sx[u3] >= t4) continue;
                        const h4 = Ix[u3], p4 = Math.abs(h4);
                        p4 > a3 && (o3 = h4, a3 = p4, l3 = i5, c3 = e3);
                      }
                      if (a3 > 0.1) {
                        const s3 = 1 - (t4 + 0.5 * Math.abs(l3 * c3)) / u2;
                        let a4 = e2._dem.get(n4, r4) + o3 * s3;
                        const h4 = e2._dem.get(n4 + l3, r4 + c3), p4 = e2._dem.get(n4 - l3, r4 - c3, true);
                        (a4 - h4) * (a4 - p4) > 0 && (a4 = (h4 + p4) / 2), Ix[i4] = e2._dem.set(n4, r4, a4), Sx[i4] = t4;
                      }
                    }
                  }
                }
              }
              o2 && (e2._demTile.needsDEMTextureUpload = true, e2._dem._timestamp = fe.now());
            }
            setFilter(t2) {
              this.filter = t2 ? Co(t2) : null;
            }
            getNodesInfo() {
              return this.filter ? this.nodesInfo.filter((t2) => this.filter.filter(new go(this.id.overscaledZ, { worldview: this.worldview }), t2.feature, this.id.canonical)) : this.nodesInfo;
            }
            destroy() {
              const t2 = this.getNodesInfo();
              for (const e2 of t2) _x(e2.node), Ax(e2.node);
            }
            isEmpty() {
              return !this.nodesInfo.length;
            }
            updateReplacement(t2, e2) {
              if (e2.updateTime === this.replacementUpdateTime) return;
              this.replacementUpdateTime = e2.updateTime;
              const r2 = e2.getReplacementRegionsForTile(t2.toUnwrapped());
              for (const t3 of this.getNodesInfo()) {
                const e3 = t3.node.footprint;
                t3.hiddenByReplacement = !!e3 && !r2.find((t4) => t4.footprint === e3);
              }
            }
            getHeightAtTileCoord(t2, e2) {
              const r2 = [], n2 = [0, 0, 0], i2 = l([]);
              for (const s2 of this.getNodesInfo()) {
                const o2 = s2.node.meshes[0], a2 = o2.transformedAabb;
                if (t2 < a2.min[0] || e2 < a2.min[1] || t2 > a2.max[0] || e2 > a2.max[1]) continue;
                if (true === s2.node.hidden) return { height: 1 / 0, maxHeight: s2.feature.properties.height, hidden: false, verticalScale: s2.evaluatedScale[2] };
                u(i2, s2.node.matrix), n2[0] = t2, n2[1] = e2, R(n2, n2, i2);
                const l2 = (n2[0] - o2.aabb.min[0]) / (o2.aabb.max[0] - o2.aabb.min[0]) * yx | 0, c2 = Math.min(63, (n2[1] - o2.aabb.min[1]) / (o2.aabb.max[1] - o2.aabb.min[1]) * yx | 0) * yx + Math.min(63, l2), h3 = o2.heightmap[c2];
                if (!(h3 < 0 && s2.node.footprint)) {
                  if (s2.hiddenByReplacement) return;
                  return { height: h3, maxHeight: s2.feature.properties.height, hidden: false, verticalScale: s2.evaluatedScale[2] };
                }
                if (s2.node.footprint.grid.query(new bt(t2, e2), new bt(t2, e2), r2), r2.length > 0) return { height: void 0, maxHeight: s2.feature.properties.height, hidden: s2.hiddenByReplacement, verticalScale: s2.evaluatedScale[2] };
              }
            }
          }
          function Bx(t2, e2) {
            return t2 instanceof Fs && !t2.isLightConstant && e2;
          }
          function Vx(t2, e2, r2, n2, i2, s2, o2, a2) {
            let l2 = (61440 & e2 | (61440 & e2) >> 4) >> 8, u2 = (3840 & e2 | (3840 & e2) >> 4) >> 4, c2 = 240 & e2 | (240 & e2) >> 4;
            r2[3] > 0 && (l2 = ur(l2, 255 * r2[0], r2[3]), u2 = ur(u2, 255 * r2[1], r2[3]), c2 = ur(c2, 255 * r2[2], r2[3]));
            const h3 = l2 << 8 | u2, p3 = c2 << 8 | Math.floor(255 * n2[3]), f2 = function(t3) {
              const e3 = Et(t3, 0, 2);
              return Math.min(Math.round(0.5 * e3 * 255), 255);
            }(n2[2]) << 8 | 15 * n2[0] << 4 | 15 * n2[1], d2 = Et(i2[0], 0, 1), m2 = Et(i2[1], 0, 1), y2 = Et(i2[2], 0, 1), g2 = Et(i2[3], 0, 1);
            let x2, v2, b2, w2;
            if (d2 !== m2 && o2 !== s2 && m2 !== d2) {
              const t3 = o2 - s2;
              v2 = 1 / (t3 * (m2 - d2)), b2 = -(s2 + t3 * d2) / (t3 * (m2 - d2));
              const e3 = Et(i2[4], -1, 1);
              w2 = Math.pow(10, e3), x2 = 255 * y2 << 8 | 255 * g2;
            } else x2 = 65535, v2 = 0, b2 = 1, w2 = 1;
            if (t2.emplaceBack(h3, p3, f2, x2, v2, b2, w2), a2) {
              const t3 = a2.length;
              a2.clear();
              for (let e3 = 0; e3 < t3; e3++) a2.emplaceBack(h3, p3, f2, x2, v2, b2, w2);
            }
          }
          function Cx(t2, e2, r2) {
            const n2 = t2.node;
            let i2 = 0;
            const s2 = r2 & gx.HasMeshoptCompression;
            for (const r3 of n2.meshes) {
              if (n2.lights && n2.lightMeshIndex === i2) continue;
              if (!r3.featureData) continue;
              r3.featureArray = new Fa(), r3.featureArray.reserve(r3.featureData.length);
              let o2 = e2;
              for (const e3 of r3.featureData) {
                const i3 = s2 ? 65535 & e3 : e3 >> 16 & 65535, a2 = s2 ? e3 >> 16 & 65535 : 65535 & e3, l2 = (15 & a2) < 8 ? 15 & a2 : 0, u2 = t2.evaluatedRMEA[l2], c2 = t2.evaluatedColor[l2], h3 = t2.emissionHeightBasedParams[l2];
                let p3;
                if (o2 && 2 === l2 && n2.lights && (p3 = new Fa(), p3.resize(10 * n2.lights.length)), Vx(r3.featureArray, i3, c2, u2, h3, r3.aabb.min[2], r3.aabb.max[2], p3), p3 && o2) {
                  o2 = false;
                  const t3 = n2.meshes[n2.lightMeshIndex];
                  t3.featureArray = p3, t3.featureArray._trim();
                }
              }
              r3.featureArray._trim(), i2++;
            }
          }
          function Fx(t2, e2, r2, n2) {
            const i2 = 1 << t2.z;
            e2.lat = eu((n2 / Cn + t2.y) / i2), e2.lng = tu((r2 / Cn + t2.x) / i2);
          }
          function Dx(t2, e2, r2, n2) {
            const i2 = t2.getNodesInfo()[e2];
            if (!i2 || i2.hiddenByReplacement || !i2.node.meshes) return;
            let s2 = Number.MAX_VALUE;
            const o2 = i2.node, a2 = r2.tile, l2 = n2.calculatePosMatrix(a2.tileID.toUnwrapped(), n2.worldSize), u2 = i2.evaluatedScale;
            let f2 = 0;
            n2.elevation && o2.elevation && (f2 = o2.elevation * n2.elevation.exaggeration()), h2(l2, l2, [(o2.anchor ? o2.anchor[0] : 0) * (u2[0] - 1), (o2.anchor ? o2.anchor[1] : 0) * (u2[1] - 1), f2]), p2(l2, l2, u2);
            const d2 = r2.queryGeometry, m2 = d2.isPointQuery() ? d2.screenBounds : d2.screenGeometry, y2 = function(t3) {
              const e3 = c([], l2, t3.matrix);
              c(e3, n2.expandedFarZProjMatrix, e3);
              for (let r3 = 0; r3 < t3.meshes.length; ++r3) {
                const i3 = t3.meshes[r3];
                if (r3 === t3.lightMeshIndex) continue;
                const o3 = tx(m2, n2, e3, i3.aabb);
                null != o3 && (s2 = Math.min(o3, s2));
              }
              if (t3.children) for (const e4 of t3.children) y2(e4);
            };
            if (y2(o2), s2 === Number.MAX_VALUE) return;
            const g2 = new Hl(0, 0);
            return Fx(a2.tileID.canonical, g2, i2.node.anchor[0], i2.node.anchor[1]), { intersectionZ: s2, position: g2, feature: i2.feature };
          }
          qs(Tx, "Tiled3dModelBucket", { omit: ["layers"] }), qs(Ex, "Tiled3dModelFeature");
          const Lx = { circle: class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: gc || (gc = new Po({ "circle-sort-key": new zo(Eo.layout_circle["circle-sort-key"]), "circle-elevation-reference": new So(Eo.layout_circle["circle-elevation-reference"]), visibility: new So(Eo.layout_circle.visibility) })), paint: xc || (xc = new Po({ "circle-radius": new zo(Eo.paint_circle["circle-radius"]), "circle-color": new zo(Eo.paint_circle["circle-color"]), "circle-blur": new zo(Eo.paint_circle["circle-blur"]), "circle-opacity": new zo(Eo.paint_circle["circle-opacity"]), "circle-translate": new So(Eo.paint_circle["circle-translate"]), "circle-translate-anchor": new So(Eo.paint_circle["circle-translate-anchor"]), "circle-pitch-scale": new So(Eo.paint_circle["circle-pitch-scale"]), "circle-pitch-alignment": new So(Eo.paint_circle["circle-pitch-alignment"]), "circle-stroke-width": new zo(Eo.paint_circle["circle-stroke-width"]), "circle-stroke-color": new zo(Eo.paint_circle["circle-stroke-color"]), "circle-stroke-opacity": new zo(Eo.paint_circle["circle-stroke-opacity"]), "circle-emissive-strength": new So(Eo.paint_circle["circle-emissive-strength"]), "circle-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "circle-stroke-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2);
            }
            createBucket(t2) {
              return new Yu(t2);
            }
            queryRadius(t2) {
              const e2 = t2;
              return fc("circle-radius", this, e2) + fc("circle-stroke-width", this, e2) + dc(this.paint.get("circle-translate"));
            }
            queryIntersectsFeature(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = yc(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s2.angle, t2.pixelToTileUnitsFactor), u2 = this.paint.get("circle-radius").evaluate(e2, r2) + this.paint.get("circle-stroke-width").evaluate(e2, r2);
              return rh(t2, n2, s2, o2, a2, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l2, u2);
            }
            getProgramIds() {
              return ["circle"];
            }
            getDefaultProgramParams(t2, e2, r2) {
              const n2 = eh(this);
              return { config: new zl(this, { zoom: e2, lut: r2 }), defines: n2, overrideFog: false };
            }
            is3D(t2) {
              return !t2 && !!this.layout && "none" !== this.layout.get("circle-elevation-reference");
            }
            hasElevation() {
              return this.layout && "none" !== this.layout.get("circle-elevation-reference");
            }
          }, heatmap: class extends Yo {
            createBucket(t2) {
              return new ah(t2);
            }
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: lh || (lh = new Po({ visibility: new So(Eo.layout_heatmap.visibility) })), paint: uh || (uh = new Po({ "heatmap-radius": new zo(Eo.paint_heatmap["heatmap-radius"]), "heatmap-weight": new zo(Eo.paint_heatmap["heatmap-weight"]), "heatmap-intensity": new So(Eo.paint_heatmap["heatmap-intensity"]), "heatmap-color": new ko(Eo.paint_heatmap["heatmap-color"]), "heatmap-opacity": new So(Eo.paint_heatmap["heatmap-opacity"]), "heatmap-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2), this._updateColorRamp();
            }
            _handleSpecialPaintPropertyUpdate(t2) {
              "heatmap-color" === t2 && this._updateColorRamp();
            }
            _updateColorRamp() {
              this.colorRamp = xh({ expression: this._transitionablePaint._values["heatmap-color"].value.expression, evaluationKey: "heatmapDensity", image: this.colorRamp }), this.colorRampTexture = null;
            }
            resize() {
              this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
            }
            queryRadius(t2) {
              return fc("heatmap-radius", this, t2);
            }
            queryIntersectsFeature(t2, e2, r2, n2, i2, s2, o2, a2) {
              const l2 = this.paint.get("heatmap-radius").evaluate(e2, r2);
              return rh(t2, n2, s2, o2, a2, true, true, new bt(0, 0), l2);
            }
            hasOffscreenPass() {
              return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
            }
            getProgramIds() {
              return ["heatmap", "heatmapTexture"];
            }
            getDefaultProgramParams(t2, e2, r2) {
              return "heatmap" === t2 ? { config: new zl(this, { zoom: e2, lut: r2 }), overrideFog: false } : {};
            }
          }, hillshade: class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: ch || (ch = new Po({ visibility: new So(Eo.layout_hillshade.visibility) })), paint: hh || (hh = new Po({ "hillshade-illumination-direction": new So(Eo.paint_hillshade["hillshade-illumination-direction"]), "hillshade-illumination-anchor": new So(Eo.paint_hillshade["hillshade-illumination-anchor"]), "hillshade-exaggeration": new So(Eo.paint_hillshade["hillshade-exaggeration"]), "hillshade-shadow-color": new So(Eo.paint_hillshade["hillshade-shadow-color"]), "hillshade-highlight-color": new So(Eo.paint_hillshade["hillshade-highlight-color"]), "hillshade-accent-color": new So(Eo.paint_hillshade["hillshade-accent-color"]), "hillshade-emissive-strength": new So(Eo.paint_hillshade["hillshade-emissive-strength"]), "hillshade-shadow-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "hillshade-highlight-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "hillshade-accent-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2);
            }
            shouldRedrape() {
              return this.hasOffscreenPass() && "viewport" === this.paint.get("hillshade-illumination-anchor");
            }
            hasOffscreenPass() {
              return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
            }
            getProgramIds() {
              return ["hillshade", "hillshadePrepare"];
            }
            getDefaultProgramParams(t2, e2, r2) {
              return { overrideFog: false };
            }
          }, fill: class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: dp || (dp = new Po({ "fill-sort-key": new zo(Eo.layout_fill["fill-sort-key"]), visibility: new So(Eo.layout_fill.visibility), "fill-elevation-reference": new So(Eo.layout_fill["fill-elevation-reference"]), "fill-construct-bridge-guard-rail": new zo(Eo.layout_fill["fill-construct-bridge-guard-rail"]) })), paint: mp || (mp = new Po({ "fill-antialias": new So(Eo.paint_fill["fill-antialias"]), "fill-opacity": new zo(Eo.paint_fill["fill-opacity"]), "fill-color": new zo(Eo.paint_fill["fill-color"]), "fill-outline-color": new zo(Eo.paint_fill["fill-outline-color"]), "fill-translate": new So(Eo.paint_fill["fill-translate"]), "fill-translate-anchor": new So(Eo.paint_fill["fill-translate-anchor"]), "fill-pattern": new zo(Eo.paint_fill["fill-pattern"]), "fill-pattern-cross-fade": new So(Eo.paint_fill["fill-pattern-cross-fade"]), "fill-emissive-strength": new So(Eo.paint_fill["fill-emissive-strength"]), "fill-z-offset": new zo(Eo.paint_fill["fill-z-offset"]), "fill-bridge-guard-rail-color": new zo(Eo.paint_fill["fill-bridge-guard-rail-color"]), "fill-tunnel-structure-color": new zo(Eo.paint_fill["fill-tunnel-structure-color"]), "fill-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "fill-outline-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "fill-bridge-guard-rail-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "fill-tunnel-structure-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2);
            }
            getProgramIds() {
              const t2 = this.paint.get("fill-pattern"), e2 = t2 && t2.constantOr(1), r2 = [e2 ? "fillPattern" : "fill"];
              return this.paint.get("fill-antialias") && r2.push(e2 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r2;
            }
            getDefaultProgramParams(t2, e2, r2) {
              return { config: new zl(this, { zoom: e2, lut: r2 }), overrideFog: false };
            }
            recalculate(t2, e2) {
              super.recalculate(t2, e2);
              const r2 = this.paint._values["fill-outline-color"];
              "constant" === r2.value.kind && void 0 === r2.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
            }
            createBucket(t2) {
              return new fp(t2);
            }
            queryRadius() {
              return dc(this.paint.get("fill-translate"));
            }
            queryIntersectsFeature(t2, e2, r2, n2, i2, s2) {
              return !t2.queryGeometry.isAboveHorizon && Qu(mc(t2.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s2.angle, t2.pixelToTileUnitsFactor), n2);
            }
            isTileClipped() {
              return 0 === this.paint.get("fill-z-offset").constantOr(1);
            }
            is3D(t2) {
              if (0 !== this.paint.get("fill-z-offset").constantOr(1)) return true;
              const e2 = this.layout && "none" !== this.layout.get("fill-elevation-reference");
              return null != t2 ? e2 && !t2 : e2;
            }
            hasElevation() {
              return this.layout && "none" !== this.layout.get("fill-elevation-reference");
            }
            hasShadowPass() {
              return this.layout && "none" !== this.layout.get("fill-elevation-reference");
            }
          }, "fill-extrusion": class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: xf || (xf = new Po({ visibility: new So(Eo["layout_fill-extrusion"].visibility), "fill-extrusion-edge-radius": new So(Eo["layout_fill-extrusion"]["fill-extrusion-edge-radius"]) })), paint: vf || (vf = new Po({ "fill-extrusion-opacity": new So(Eo["paint_fill-extrusion"]["fill-extrusion-opacity"]), "fill-extrusion-color": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-color"]), "fill-extrusion-translate": new So(Eo["paint_fill-extrusion"]["fill-extrusion-translate"]), "fill-extrusion-translate-anchor": new So(Eo["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]), "fill-extrusion-pattern": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-pattern"]), "fill-extrusion-pattern-cross-fade": new So(Eo["paint_fill-extrusion"]["fill-extrusion-pattern-cross-fade"]), "fill-extrusion-height": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-height"]), "fill-extrusion-base": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-base"]), "fill-extrusion-height-alignment": new So(Eo["paint_fill-extrusion"]["fill-extrusion-height-alignment"]), "fill-extrusion-base-alignment": new So(Eo["paint_fill-extrusion"]["fill-extrusion-base-alignment"]), "fill-extrusion-vertical-gradient": new So(Eo["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]), "fill-extrusion-ambient-occlusion-intensity": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]), "fill-extrusion-ambient-occlusion-radius": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]), "fill-extrusion-ambient-occlusion-wall-radius": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]), "fill-extrusion-ambient-occlusion-ground-radius": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]), "fill-extrusion-ambient-occlusion-ground-attenuation": new So(Eo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]), "fill-extrusion-flood-light-color": new So(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]), "fill-extrusion-flood-light-intensity": new So(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]), "fill-extrusion-flood-light-wall-radius": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]), "fill-extrusion-flood-light-ground-radius": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]), "fill-extrusion-flood-light-ground-attenuation": new So(Eo["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]), "fill-extrusion-vertical-scale": new So(Eo["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]), "fill-extrusion-rounded-roof": new So(Eo["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]), "fill-extrusion-cutoff-fade-range": new So(Eo["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]), "fill-extrusion-emissive-strength": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]), "fill-extrusion-line-width": new zo(Eo["paint_fill-extrusion"]["fill-extrusion-line-width"]), "fill-extrusion-cast-shadows": new So(Eo["paint_fill-extrusion"]["fill-extrusion-cast-shadows"]), "fill-extrusion-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "fill-extrusion-flood-light-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2), this._stats = { numRenderedVerticesInShadowPass: 0, numRenderedVerticesInTransparentPass: 0 };
            }
            createBucket(t2) {
              return new af(t2);
            }
            queryRadius() {
              return dc(this.paint.get("fill-extrusion-translate"));
            }
            is3D(t2) {
              return true;
            }
            hasShadowPass() {
              return this.paint.get("fill-extrusion-cast-shadows");
            }
            cutoffRange() {
              return this.paint.get("fill-extrusion-cutoff-fade-range");
            }
            canCastShadows() {
              return true;
            }
            getProgramIds() {
              return [this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"];
            }
            queryIntersectsFeature(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
              const u2 = yc(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s2.angle, t2.pixelToTileUnitsFactor), c2 = this.paint.get("fill-extrusion-height").evaluate(e2, r2), h3 = this.paint.get("fill-extrusion-base").evaluate(e2, r2), p3 = [0, 0], f2 = a2 && s2.elevation, d2 = s2.elevation ? s2.elevation.exaggeration() : 1, m2 = t2.tile.getBucket(this);
              if (f2 && m2 instanceof af) {
                const t3 = m2.centroidVertexArray, e3 = l2 + 1;
                e3 < t3.length && (p3[0] = t3.geta_centroid_pos0(e3), p3[1] = t3.geta_centroid_pos1(e3));
              }
              if (0 === p3[0] && 1 === p3[1]) return false;
              "globe" === s2.projection.name && (n2 = yf([n2], [new bt(0, 0), new bt(Cn, Cn)], t2.tileID.canonical).map((t3) => t3.polygon).flat());
              const y2 = f2 ? a2 : null, [g2, x2] = function(t3, e3, r3, n3, i3, s3, o3, a3, l3, u3, c3) {
                return "globe" === t3.projection.name ? function(t4, e4, r4, n4, i4, s4, o4, a4, l4, u4, c4) {
                  const h4 = [], p4 = [], f3 = t4.projection.upVectorScale(c4, t4.center.lat, t4.worldSize).metersToTile, d3 = [0, 0, 0, 1], m3 = [0, 0, 0, 1], y3 = (t5, e5, r5, n5) => {
                    t5[0] = e5, t5[1] = r5, t5[2] = n5, t5[3] = 1;
                  }, g3 = mf();
                  r4 > 0 && (r4 += g3), n4 += g3;
                  for (const g4 of e4) {
                    const e5 = [], x3 = [];
                    for (const h5 of g4) {
                      const p5 = h5.x + i4.x, g5 = h5.y + i4.y, v3 = t4.projection.projectTilePoint(p5, g5, c4), b2 = t4.projection.upVector(c4, h5.x, h5.y);
                      let w2 = r4, _2 = n4;
                      if (o4) {
                        const t5 = Pf(p5, g5, r4, n4, o4, a4, l4, u4);
                        w2 += t5.base, _2 += t5.top;
                      }
                      0 !== r4 ? y3(d3, v3.x + b2[0] * f3 * w2, v3.y + b2[1] * f3 * w2, v3.z + b2[2] * f3 * w2) : y3(d3, v3.x, v3.y, v3.z), y3(m3, v3.x + b2[0] * f3 * _2, v3.y + b2[1] * f3 * _2, v3.z + b2[2] * f3 * _2), R(d3, d3, s4), R(m3, m3, s4), e5.push(new bf(d3[0], d3[1], d3[2])), x3.push(new bf(m3[0], m3[1], m3[2]));
                    }
                    h4.push(e5), p4.push(x3);
                  }
                  return [h4, p4];
                }(t3, e3, r3, n3, i3, s3, o3, a3, l3, u3, c3) : o3 ? function(t4, e4, r4, n4, i4, s4, o4, a4, l4) {
                  const u4 = [], c4 = [], h4 = [0, 0, 0, 1];
                  for (const p4 of t4) {
                    const t5 = [], f3 = [];
                    for (const u5 of p4) {
                      const c5 = u5.x + n4.x, p5 = u5.y + n4.y, d3 = Pf(c5, p5, e4, r4, s4, o4, a4, l4);
                      h4[0] = c5, h4[1] = p5, h4[2] = d3.base, h4[3] = 1, Z(h4, h4, i4), h4[3] = Math.max(h4[3], 1e-5);
                      const m3 = new bf(h4[0] / h4[3], h4[1] / h4[3], h4[2] / h4[3]);
                      h4[0] = c5, h4[1] = p5, h4[2] = d3.top, h4[3] = 1, Z(h4, h4, i4), h4[3] = Math.max(h4[3], 1e-5);
                      const y3 = new bf(h4[0] / h4[3], h4[1] / h4[3], h4[2] / h4[3]);
                      t5.push(m3), f3.push(y3);
                    }
                    u4.push(t5), c4.push(f3);
                  }
                  return [u4, c4];
                }(e3, r3, n3, i3, s3, o3, a3, l3, u3) : function(t4, e4, r4, n4, i4) {
                  const s4 = [], o4 = [], a4 = i4[8] * e4, l4 = i4[9] * e4, u4 = i4[10] * e4, c4 = i4[11] * e4, h4 = i4[8] * r4, p4 = i4[9] * r4, f3 = i4[10] * r4, d3 = i4[11] * r4;
                  for (const e5 of t4) {
                    const t5 = [], r5 = [];
                    for (const s5 of e5) {
                      const e6 = s5.x + n4.x, o5 = s5.y + n4.y, m3 = i4[0] * e6 + i4[4] * o5 + i4[12], y3 = i4[1] * e6 + i4[5] * o5 + i4[13], g3 = i4[2] * e6 + i4[6] * o5 + i4[14], x3 = i4[3] * e6 + i4[7] * o5 + i4[15], v3 = m3 + a4, b2 = y3 + l4, w2 = g3 + u4, _2 = Math.max(x3 + c4, 1e-5), A2 = m3 + h4, M2 = y3 + p4, I2 = g3 + f3, S2 = Math.max(x3 + d3, 1e-5);
                      t5.push(new bf(v3 / _2, b2 / _2, w2 / _2)), r5.push(new bf(A2 / S2, M2 / S2, I2 / S2));
                    }
                    s4.push(t5), o4.push(r5);
                  }
                  return [s4, o4];
                }(e3, r3, n3, i3, s3);
              }(s2, n2, h3, c2, u2, o2, y2, p3, d2, s2.center.lat, t2.tileID.canonical), v2 = t2.queryGeometry;
              return function(t3, e3, r3) {
                let n3 = 1 / 0;
                Qu(r3, e3) && (n3 = kf(r3, e3[0]));
                for (let i3 = 0; i3 < e3.length; i3++) {
                  const s3 = e3[i3], o3 = t3[i3];
                  for (let t4 = 0; t4 < s3.length - 1; t4++) {
                    const e4 = s3[t4], i4 = [e4, s3[t4 + 1], o3[t4 + 1], o3[t4], e4];
                    Ku(r3, i4) && (n3 = Math.min(n3, kf(r3, i4)));
                  }
                }
                return n3 !== 1 / 0 && n3;
              }(g2, x2, v2.isPointQuery() ? v2.screenBounds : v2.screenGeometry);
            }
          }, building: class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: dd || (dd = new Po({ visibility: new So(Eo.layout_building.visibility), "building-roof-shape": new zo(Eo.layout_building["building-roof-shape"]), "building-height": new zo(Eo.layout_building["building-height"]), "building-base": new zo(Eo.layout_building["building-base"]) })), paint: md || (md = new Po({ "building-opacity": new So(Eo.paint_building["building-opacity"]), "building-ambient-occlusion-wall-intensity": new So(Eo.paint_building["building-ambient-occlusion-wall-intensity"]), "building-ambient-occlusion-ground-intensity": new So(Eo.paint_building["building-ambient-occlusion-ground-intensity"]), "building-ambient-occlusion-ground-radius": new So(Eo.paint_building["building-ambient-occlusion-ground-radius"]), "building-ambient-occlusion-ground-attenuation": new So(Eo.paint_building["building-ambient-occlusion-ground-attenuation"]), "building-vertical-scale": new So(Eo.paint_building["building-vertical-scale"]), "building-cast-shadows": new So(Eo.paint_building["building-cast-shadows"]), "building-color": new zo(Eo.paint_building["building-color"]), "building-emissive-strength": new zo(Eo.paint_building["building-emissive-strength"]), "building-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2), this._stats = { numRenderedVerticesInShadowPass: 0, numRenderedVerticesInTransparentPass: 0 };
            }
            createBucket(t2) {
              return new fd(t2);
            }
          }, line: class extends Yo {
            constructor(t2, e2, r2, n2) {
              const i2 = Rd();
              super(t2, i2, e2, r2, n2), i2.layout && (this.layout = new Io(i2.layout)), this.gradientVersion = 0, this.hasElevatedBuckets = false, this.hasNonElevatedBuckets = false;
            }
            _handleSpecialPaintPropertyUpdate(t2) {
              if ("line-gradient" === t2) {
                const t3 = this._transitionablePaint._values["line-gradient"].value.expression;
                this.stepInterpolant = t3._styleExpression && t3._styleExpression.expression instanceof Ai, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
              }
            }
            gradientExpression() {
              return this._transitionablePaint._values["line-gradient"].value.expression;
            }
            widthExpression() {
              return this._transitionablePaint._values["line-width"].value.expression;
            }
            recalculate(t2, e2) {
              super.recalculate(t2, e2), this.paint._values["line-floorwidth"] = (() => {
                if (Ud) return Ud;
                const t3 = Rd();
                return Ud = new Od(t3.paint.properties["line-width"].specification), Ud.useIntegerZoom = true, Ud;
              })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t2);
            }
            createBucket(t2) {
              return new zd(t2);
            }
            getProgramIds() {
              return [this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"];
            }
            getDefaultProgramParams(t2, e2, r2) {
              const n2 = Fd(this);
              return { config: new zl(this, { zoom: e2, lut: r2 }), defines: n2, overrideFog: false };
            }
            queryRadius(t2) {
              const e2 = t2, r2 = Nd(fc("line-width", this, e2), fc("line-gap-width", this, e2)), n2 = fc("line-offset", this, e2);
              return r2 / 2 + Math.abs(n2) + dc(this.paint.get("line-translate"));
            }
            queryIntersectsFeature(t2, e2, r2, n2, i2, s2) {
              if (t2.queryGeometry.isAboveHorizon) return false;
              const o2 = mc(t2.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s2.angle, t2.pixelToTileUnitsFactor), a2 = t2.pixelToTileUnitsFactor / 2 * Nd(this.paint.get("line-width").evaluate(e2, r2), this.paint.get("line-gap-width").evaluate(e2, r2)), l2 = this.paint.get("line-offset").evaluate(e2, r2);
              return l2 && (n2 = function(t3, e3) {
                const r3 = [], n3 = new bt(0, 0);
                for (let i3 = 0; i3 < t3.length; i3++) {
                  const s3 = t3[i3], o3 = [];
                  for (let t4 = 0; t4 < s3.length; t4++) {
                    const r4 = s3[t4], i4 = s3[t4 + 1], a3 = 0 === t4 ? n3 : r4.sub(s3[t4 - 1])._unit()._perp(), l3 = t4 === s3.length - 1 ? n3 : i4.sub(r4)._unit()._perp(), u2 = a3._add(l3)._unit();
                    u2._mult(1 / (u2.x * l3.x + u2.y * l3.y)), o3.push(u2._mult(e3)._add(r4));
                  }
                  r3.push(o3);
                }
                return r3;
              }(n2, l2 * t2.pixelToTileUnitsFactor)), function(t3, e3, r3) {
                for (let n3 = 0; n3 < e3.length; n3++) {
                  const i3 = e3[n3];
                  if (t3.length >= 3) {
                    for (let e4 = 0; e4 < i3.length; e4++) if (lc(t3, i3[e4])) return true;
                  }
                  if (tc(t3, i3, r3)) return true;
                }
                return false;
              }(o2, n2, a2);
            }
            isTileClipped() {
              return this.hasNonElevatedBuckets;
            }
            isDraped(t2) {
              return !this.hasElevatedBuckets;
            }
            hasElevation() {
              return this.layout && "none" !== this.layout.get("line-elevation-reference");
            }
          }, symbol: wg, background: class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: _g || (_g = new Po({ visibility: new So(Eo.layout_background.visibility) })), paint: Ag || (Ag = new Po({ "background-pitch-alignment": new So(Eo.paint_background["background-pitch-alignment"]), "background-color": new So(Eo.paint_background["background-color"]), "background-pattern": new So(Eo.paint_background["background-pattern"]), "background-opacity": new So(Eo.paint_background["background-opacity"]), "background-emissive-strength": new So(Eo.paint_background["background-emissive-strength"]), "background-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2);
            }
            getProgramIds() {
              return [this.paint.get("background-pattern") ? "backgroundPattern" : "background"];
            }
            getDefaultProgramParams(t2, e2, r2) {
              return { overrideFog: false };
            }
            is3D(t2) {
              return "viewport" === this.paint.get("background-pitch-alignment");
            }
          }, raster: Dg, "raster-particle": jg, sky: class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: Og || (Og = new Po({ visibility: new So(Eo.layout_sky.visibility) })), paint: Ug || (Ug = new Po({ "sky-type": new So(Eo.paint_sky["sky-type"]), "sky-atmosphere-sun": new So(Eo.paint_sky["sky-atmosphere-sun"]), "sky-atmosphere-sun-intensity": new So(Eo.paint_sky["sky-atmosphere-sun-intensity"]), "sky-gradient-center": new So(Eo.paint_sky["sky-gradient-center"]), "sky-gradient-radius": new So(Eo.paint_sky["sky-gradient-radius"]), "sky-gradient": new ko(Eo.paint_sky["sky-gradient"]), "sky-atmosphere-halo-color": new So(Eo.paint_sky["sky-atmosphere-halo-color"]), "sky-atmosphere-color": new So(Eo.paint_sky["sky-atmosphere-color"]), "sky-opacity": new So(Eo.paint_sky["sky-opacity"]), "sky-gradient-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "sky-atmosphere-halo-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }), "sky-atmosphere-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2), this._updateColorRamp();
            }
            _handleSpecialPaintPropertyUpdate(t2) {
              "sky-gradient" === t2 ? this._updateColorRamp() : "sky-atmosphere-sun" !== t2 && "sky-atmosphere-halo-color" !== t2 && "sky-atmosphere-color" !== t2 && "sky-atmosphere-sun-intensity" !== t2 || (this._skyboxInvalidated = true);
            }
            _updateColorRamp() {
              this.colorRamp = xh({ expression: this._transitionablePaint._values["sky-gradient"].value.expression, evaluationKey: "skyRadialProgress" }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
            }
            needsSkyboxCapture(t2) {
              if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return true;
              if (!this.paint.get("sky-atmosphere-sun")) {
                const e2 = t2.style.light.properties.get("position");
                return this._lightPosition.azimuthal !== e2.azimuthal || this._lightPosition.polar !== e2.polar;
              }
              return false;
            }
            getCenter(t2, e2) {
              if ("atmosphere" === this.paint.get("sky-type")) {
                const r3 = this.paint.get("sky-atmosphere-sun"), n2 = !r3, i2 = t2.style.light, s2 = i2.properties.get("position");
                return n2 && "viewport" === i2.properties.get("anchor") && Gt("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n2 ? Gg(s2.azimuthal, 90 - s2.polar, e2) : Gg(r3[0], 90 - r3[1], e2);
              }
              const r2 = this.paint.get("sky-gradient-center");
              return Gg(r2[0], 90 - r2[1], e2);
            }
            isSky() {
              return true;
            }
            markSkyboxValid(t2) {
              this._skyboxInvalidated = false, this._lightPosition = t2.style.light.properties.get("position");
            }
            hasOffscreenPass() {
              return true;
            }
            getProgramIds() {
              const t2 = this.paint.get("sky-type");
              return "atmosphere" === t2 ? ["skyboxCapture", "skybox"] : "gradient" === t2 ? ["skyboxGradient"] : null;
            }
          }, slot: class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { paint: Ng || (Ng = new Po({})) }, e2, null);
            }
          }, model: class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: dx || (dx = new Po({ visibility: new So(Eo.layout_model.visibility), "model-id": new zo(Eo.layout_model["model-id"]) })), paint: mx || (mx = new Po({ "model-opacity": new zo(Eo.paint_model["model-opacity"]), "model-rotation": new zo(Eo.paint_model["model-rotation"]), "model-scale": new zo(Eo.paint_model["model-scale"]), "model-translation": new zo(Eo.paint_model["model-translation"]), "model-color": new zo(Eo.paint_model["model-color"]), "model-color-mix-intensity": new zo(Eo.paint_model["model-color-mix-intensity"]), "model-type": new So(Eo.paint_model["model-type"]), "model-cast-shadows": new So(Eo.paint_model["model-cast-shadows"]), "model-receive-shadows": new So(Eo.paint_model["model-receive-shadows"]), "model-ambient-occlusion-intensity": new So(Eo.paint_model["model-ambient-occlusion-intensity"]), "model-emissive-strength": new zo(Eo.paint_model["model-emissive-strength"]), "model-roughness": new zo(Eo.paint_model["model-roughness"]), "model-height-based-emissive-strength-multiplier": new zo(Eo.paint_model["model-height-based-emissive-strength-multiplier"]), "model-cutoff-fade-range": new So(Eo.paint_model["model-cutoff-fade-range"]), "model-front-cutoff": new So(Eo.paint_model["model-front-cutoff"]), "model-color-use-theme": new zo({ type: "string", default: "default", "property-type": "data-driven" }) })) }, e2, r2, n2), this._stats = { numRenderedVerticesInShadowPass: 0, numRenderedVerticesInTransparentPass: 0 };
            }
            createBucket(t2) {
              return new fx(t2);
            }
            getProgramIds() {
              return ["model"];
            }
            is3D(t2) {
              return true;
            }
            hasShadowPass() {
              return true;
            }
            canCastShadows() {
              return true;
            }
            hasLightBeamPass() {
              return true;
            }
            cutoffRange() {
              return this.paint.get("model-cutoff-fade-range");
            }
            queryRadius(t2) {
              return t2 instanceof Tx ? Cn - 1 : 0;
            }
            queryIntersectsFeature(t2, e2, r2, n2, i2, s2) {
              if (!this.modelManager) return false;
              const o2 = this.modelManager, l2 = t2.tile.getBucket(this);
              if (!(l2 && l2 instanceof fx)) return false;
              for (const r3 in l2.instancesPerModel) {
                const n3 = l2.instancesPerModel[r3], i3 = void 0 !== e2.id ? e2.id : e2.properties && e2.properties.hasOwnProperty("id") ? e2.properties.id : void 0;
                if (n3.idToFeaturesIndex.hasOwnProperty(i3)) {
                  const e3 = n3.features[n3.idToFeaturesIndex[i3]], u2 = o2.getModel(r3, this.scope);
                  if (!u2) return false;
                  let h3 = a();
                  const p3 = new Hl(0, 0), f2 = l2.canonical;
                  let d2 = Number.MAX_VALUE;
                  for (let r4 = 0; r4 < e3.instancedDataCount; ++r4) {
                    const i4 = 16 * (e3.instancedDataOffset + r4), o3 = n3.instancedDataArray.float32, a2 = [o3[i4 + 4], o3[i4 + 5], o3[i4 + 6]];
                    Fx(f2, p3, o3[i4], 0 | o3[i4 + 1]), xx(h3, u2, s2, p3, e3.rotation, e3.scale, a2, false, false, false), "globe" === s2.projection.name && (h3 = Qg(h3, s2));
                    const l3 = c([], s2.projMatrix, h3), m2 = t2.queryGeometry, y2 = tx(m2.isPointQuery() ? m2.screenBounds : m2.screenGeometry, s2, l3, u2.aabb);
                    null != y2 && (d2 = Math.min(y2, d2));
                  }
                  return d2 !== Number.MAX_VALUE && d2;
                }
              }
              return false;
            }
            _handleOverridablePaintPropertyUpdate(t2, e2, r2) {
              return !(!this.layout || e2.isDataDriven() || r2.isDataDriven() || "model-color" !== t2 && "model-color-mix-intensity" !== t2 && "model-rotation" !== t2 && "model-scale" !== t2 && "model-translation" !== t2 && "model-emissive-strength" !== t2);
            }
            _isPropertyZoomDependent(t2) {
              const e2 = this._transitionablePaint._values[t2];
              return null != e2 && null != e2.value && null != e2.value.expression && e2.value.expression instanceof Ds;
            }
            isZoomDependent() {
              return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
            }
          }, clip: class extends Yo {
            constructor(t2, e2, r2, n2) {
              super(t2, { layout: yp || (yp = new Po({ "clip-layer-types": new So(Eo.layout_clip["clip-layer-types"]), "clip-layer-scope": new So(Eo.layout_clip["clip-layer-scope"]) })), paint: gp || (gp = new Po({})) }, e2, r2, n2);
            }
            recalculate(t2, e2) {
              super.recalculate(t2, e2);
            }
            createBucket(t2) {
              return new bp(t2);
            }
            is3D(t2) {
              return true;
            }
          } }, Rx = new sr(0, 0, 0), Ox = { PATH_RULE_NON_ZERO: 1, PATH_RULE_EVEN_ODD: 2 }, Ux = { LINE_CAP_BUTT: 1, LINE_CAP_ROUND: 2, LINE_CAP_SQUARE: 3 }, Nx = { LINE_JOIN_MITER: 1, LINE_JOIN_MITER_CLIP: 2, LINE_JOIN_ROUND: 3, LINE_JOIN_BEVEL: 4 }, jx = { PAINT_ORDER_FILL_AND_STROKE: 1 }, $x = { PATH_COMMAND_MOVE: 1, PATH_COMMAND_LINE: 2, PATH_COMMAND_QUAD: 3, PATH_COMMAND_CUBIC: 4, PATH_COMMAND_CLOSE: 5 }, Gx = { MASK_TYPE_LUMINANCE: 1 };
          function qx(t2, e2, r2) {
            1 === t2 && e2.icons.push(function(t3, e3) {
              return function(t4) {
                if (t4.usvg_tree.height || (t4.usvg_tree.height = t4.usvg_tree.width), !t4.metadata) return t4;
                const { metadata: e4 } = t4;
                if (e4.content_area) {
                  const { content_area: r3 } = e4;
                  null == r3.top && (r3.top = r3.left), null == r3.width && (r3.width = t4.usvg_tree.width), null == r3.height && (r3.height = r3.width);
                }
                return e4.stretch_x && e4.stretch_x.length && Hx(e4, "x"), e4.stretch_y && e4.stretch_y.length && Hx(e4, "y"), t4;
              }(t3.readFields(Xx, { name: void 0 }, e3));
            }(r2, r2.readVarint() + r2.pos));
          }
          function Hx(t2, e2) {
            const r2 = [], n2 = t2[`stretch_${e2}`];
            let i2 = null;
            for (let t3 = 0; t3 < n2.length; t3++) null === i2 ? i2 = 0 === r2.length ? n2[0] : r2[r2.length - 1][1] + n2[t3] : (r2.push([i2, i2 + n2[t3]]), i2 = null);
            t2[`stretch_${e2}_areas`] = r2;
          }
          function Xx(t2, e2, r2) {
            1 === t2 ? e2.name = r2.readString() : 2 === t2 ? e2.metadata = function(t3, e3) {
              return t3.readFields(Zx, { stretch_x: null, stretch_y: null, stretch_x_areas: null, stretch_y_areas: null, variables: [] }, e3);
            }(r2, r2.readVarint() + r2.pos) : 3 === t2 && (e2.usvg_tree = function(t3, e3) {
              return t3.readFields(Kx, { width: 20, children: [], linear_gradients: [], radial_gradients: [], clip_paths: [], masks: [] }, e3);
            }(r2, r2.readVarint() + r2.pos), e2.data = "usvg_tree");
          }
          function Zx(t2, e2, r2) {
            1 === t2 ? e2.stretch_x = r2.readPackedVarint() : 2 === t2 ? e2.stretch_y = r2.readPackedVarint() : 3 === t2 ? e2.content_area = function(t3, e3) {
              return t3.readFields(Wx, { left: 0 }, e3);
            }(r2, r2.readVarint() + r2.pos) : 4 === t2 && e2.variables.push(function(t3, e3) {
              return t3.readFields(Yx, { name: void 0 }, e3);
            }(r2, r2.readVarint() + r2.pos));
          }
          function Wx(t2, e2, r2) {
            1 === t2 ? e2.left = r2.readVarint() : 2 === t2 ? e2.width = r2.readVarint() : 3 === t2 ? e2.top = r2.readVarint() : 4 === t2 && (e2.height = r2.readVarint());
          }
          function Yx(t2, e2, r2) {
            1 === t2 ? e2.name = r2.readString() : 2 === t2 && (e2.rgb_color = sv(r2.readVarint()), e2.value = "rgb_color");
          }
          function Kx(t2, e2, r2) {
            1 === t2 ? e2.width = e2.height = r2.readVarint() : 2 === t2 ? e2.height = r2.readVarint() : 3 === t2 ? e2.children.push(Jx(r2, r2.readVarint() + r2.pos)) : 4 === t2 ? e2.linear_gradients.push(function(t3, e3) {
              return t3.readFields(av, { spread_method: 1, stops: [], x1: 0, y1: 0, x2: 1, y2: 0 }, e3);
            }(r2, r2.readVarint() + r2.pos)) : 5 === t2 ? e2.radial_gradients.push(function(t3, e3) {
              return t3.readFields(cv, { spread_method: 1, stops: [], cx: 0.5, cy: 0.5, r: 0.5, fx: 0.5, fy: 0.5, fr: 0 }, e3);
            }(r2, r2.readVarint() + r2.pos)) : 7 === t2 ? e2.clip_paths.push(function(t3, e3) {
              return t3.readFields(hv, { children: [] }, e3);
            }(r2, r2.readVarint() + r2.pos)) : 8 === t2 && e2.masks.push(function(t3, e3) {
              const r3 = t3.readFields(pv, { left: 0, width: 20, mask_type: Gx.MASK_TYPE_LUMINANCE, children: [] }, e3);
              return null == r3.height && (r3.height = r3.width), null == r3.top && (r3.top = r3.left), r3;
            }(r2, r2.readVarint() + r2.pos));
          }
          function Jx(t2, e2) {
            return t2.readFields(Qx, {}, e2);
          }
          function Qx(t2, e2, r2) {
            1 === t2 ? (e2.group = function(t3, e3) {
              return t3.readFields(tv, { opacity: 255, children: [] }, e3);
            }(r2, r2.readVarint() + r2.pos), e2.node = "group") : 2 === t2 && (e2.path = function(t3, e3) {
              return t3.readFields(nv, { paint_order: 1, commands: [], step: 1, diffs: [], rule: Ox.PATH_RULE_NON_ZERO }, e3);
            }(r2, r2.readVarint() + r2.pos), e2.node = "path");
          }
          function tv(t2, e2, r2) {
            1 === t2 ? e2.transform = ev(r2, r2.readVarint() + r2.pos) : 2 === t2 ? e2.opacity = r2.readVarint() : 5 === t2 ? e2.clip_path_idx = r2.readVarint() : 6 === t2 ? e2.mask_idx = r2.readVarint() : 7 === t2 && e2.children.push(Jx(r2, r2.readVarint() + r2.pos));
          }
          function ev(t2, e2) {
            return t2.readFields(rv, { sx: 1, ky: 0, kx: 0, sy: 1, tx: 0, ty: 0 }, e2);
          }
          function rv(t2, e2, r2) {
            1 === t2 ? e2.sx = r2.readFloat() : 2 === t2 ? e2.ky = r2.readFloat() : 3 === t2 ? e2.kx = r2.readFloat() : 4 === t2 ? e2.sy = r2.readFloat() : 5 === t2 ? e2.tx = r2.readFloat() : 6 === t2 && (e2.ty = r2.readFloat());
          }
          function nv(t2, e2, r2) {
            1 === t2 ? e2.fill = function(t3, e3) {
              return t3.readFields(iv, { rgb_color: Rx, paint: "rgb_color", opacity: 255 }, e3);
            }(r2, r2.readVarint() + r2.pos) : 2 === t2 ? e2.stroke = function(t3, e3) {
              return t3.readFields(ov, { rgb_color: Rx, paint: "rgb_color", dasharray: [], dashoffset: 0, miterlimit: 4, opacity: 255, width: 1, linecap: 1, linejoin: 1 }, e3);
            }(r2, r2.readVarint() + r2.pos) : 3 === t2 ? e2.paint_order = r2.readVarint() : 5 === t2 ? r2.readPackedVarint(e2.commands) : 6 === t2 ? e2.step = r2.readFloat() : 7 === t2 ? r2.readPackedSVarint(e2.diffs) : 8 === t2 && (e2.rule = r2.readVarint());
          }
          function iv(t2, e2, r2) {
            1 === t2 ? (e2.rgb_color = sv(r2.readVarint()), e2.paint = "rgb_color") : 2 === t2 ? (e2.linear_gradient_idx = r2.readVarint(), e2.paint = "linear_gradient_idx") : 3 === t2 ? (e2.radial_gradient_idx = r2.readVarint(), e2.paint = "radial_gradient_idx") : 5 === t2 && (e2.opacity = r2.readVarint());
          }
          function sv(t2) {
            return new sr((t2 >> 16 & 255) / 255, (t2 >> 8 & 255) / 255, (255 & t2) / 255, 1);
          }
          function ov(t2, e2, r2) {
            1 === t2 ? (e2.rgb_color = sv(r2.readVarint()), e2.paint = "rgb_color") : 2 === t2 ? (e2.linear_gradient_idx = r2.readVarint(), e2.paint = "linear_gradient_idx") : 3 === t2 ? (e2.radial_gradient_idx = r2.readVarint(), e2.paint = "radial_gradient_idx") : 5 === t2 ? r2.readPackedFloat(e2.dasharray) : 6 === t2 ? e2.dashoffset = r2.readFloat() : 7 === t2 ? e2.miterlimit = r2.readFloat() : 8 === t2 ? e2.opacity = r2.readVarint() : 9 === t2 ? e2.width = r2.readFloat() : 10 === t2 ? e2.linecap = r2.readVarint() : 11 === t2 && (e2.linejoin = r2.readVarint());
          }
          function av(t2, e2, r2) {
            1 === t2 ? e2.transform = ev(r2, r2.readVarint() + r2.pos) : 2 === t2 ? e2.spread_method = r2.readVarint() : 3 === t2 ? e2.stops.push(lv(r2, r2.readVarint() + r2.pos)) : 4 === t2 ? e2.x1 = r2.readFloat() : 5 === t2 ? e2.y1 = r2.readFloat() : 6 === t2 ? e2.x2 = r2.readFloat() : 7 === t2 && (e2.y2 = r2.readFloat());
          }
          function lv(t2, e2) {
            return t2.readFields(uv, { offset: 0, opacity: 255, rgb_color: Rx }, e2);
          }
          function uv(t2, e2, r2) {
            1 === t2 ? e2.offset = r2.readFloat() : 2 === t2 ? e2.opacity = r2.readVarint() : 3 === t2 && (e2.rgb_color = sv(r2.readVarint()));
          }
          function cv(t2, e2, r2) {
            1 === t2 ? e2.transform = ev(r2, r2.readVarint() + r2.pos) : 2 === t2 ? e2.spread_method = r2.readVarint() : 3 === t2 ? e2.stops.push(lv(r2, r2.readVarint() + r2.pos)) : 4 === t2 ? e2.cx = r2.readFloat() : 5 === t2 ? e2.cy = r2.readFloat() : 6 === t2 ? e2.r = r2.readFloat() : 7 === t2 ? e2.fx = r2.readFloat() : 8 === t2 ? e2.fy = r2.readFloat() : 9 === t2 && (e2.fr = r2.readFloat());
          }
          function hv(t2, e2, r2) {
            1 === t2 ? e2.transform = ev(r2, r2.readVarint() + r2.pos) : 2 === t2 ? e2.clip_path_idx = r2.readVarint() : 3 === t2 && e2.children.push(Jx(r2, r2.readVarint() + r2.pos));
          }
          function pv(t2, e2, r2) {
            1 === t2 ? e2.left = e2.top = r2.readFloat() : 2 === t2 ? e2.width = e2.height = r2.readFloat() : 3 === t2 ? e2.top = r2.readFloat() : 4 === t2 ? e2.height = r2.readFloat() : 5 === t2 ? e2.mask_type = r2.readVarint() : 6 === t2 ? e2.mask_idx = r2.readVarint() : 7 === t2 && e2.children.push(Jx(r2, r2.readVarint() + r2.pos));
          }
          class fv {
            static calculate(t2 = {}, e2 = []) {
              const r2 = /* @__PURE__ */ new Map(), n2 = /* @__PURE__ */ new Map();
              if (0 === Object.keys(t2).length) return r2;
              e2.forEach((t3) => {
                n2.set(t3.name, t3.rgb_color || new sr(0, 0, 0));
              });
              for (const [e3, i2] of Object.entries(t2)) n2.has(e3) ? r2.set(n2.get(e3).toString(), i2) : console.warn(`Ignoring unknown image variable "${e3}"`);
              return r2;
            }
          }
          function dv(t2, e2 = 255, r2) {
            const n2 = e2 / 255, i2 = t2.toString(), s2 = r2.has(i2) ? r2.get(i2).clone() : t2.clone();
            return s2.a *= n2, s2.toString();
          }
          function mv(t2, e2) {
            if (!pe()) {
              const r2 = document.createElement("canvas");
              return r2.width = t2, r2.height = e2, r2;
            }
            return new OffscreenCanvas(t2, e2);
          }
          function yv(t2, e2) {
            const r2 = fv.calculate(e2.params, t2.metadata ? t2.metadata.variables : []), n2 = t2.usvg_tree, i2 = n2.width, s2 = n2.height, o2 = e2.transform ? e2.transform : new DOMMatrix(), a2 = Math.max(1, Math.round(i2 * o2.a)), l2 = Math.max(1, Math.round(s2 * o2.d)), u2 = new DOMMatrix([a2 / i2, 0, 0, l2 / s2, 0, 0]), c2 = mv(a2, l2).getContext("2d");
            return gv(c2, u2, n2, n2, r2), c2.getImageData(0, 0, a2, l2);
          }
          function gv(t2, e2, r2, n2, i2) {
            for (const s2 of n2.children) xv(t2, e2, r2, s2, i2);
          }
          function xv(t2, e2, r2, n2, i2) {
            n2.group ? (t2.save(), function(t3, e3, r3, n3, i3) {
              const s2 = null != n3.mask_idx ? r3.masks[n3.mask_idx] : null, o2 = null != n3.clip_path_idx ? r3.clip_paths[n3.clip_path_idx] : null;
              if (n3.transform && (e3 = zv(n3.transform).preMultiplySelf(e3)), !function(t4, e4, r4) {
                return 255 !== t4.opacity || e4 || r4;
              }(n3, null != o2, null != s2)) return void gv(t3, e3, r3, n3, i3);
              const a2 = mv(t3.canvas.width, t3.canvas.height), l2 = a2.getContext("2d");
              gv(l2, e3, r3, n3, i3), o2 && Iv(l2, e3, r3, o2), s2 && Sv(l2, e3, r3, s2, i3), t3.globalAlpha = n3.opacity / 255, t3.drawImage(a2, 0, 0);
            }(t2, e2, r2, n2.group, i2), t2.restore()) : n2.path && (t2.save(), function(t3, e3, r3, n3, i3) {
              t3.setTransform(e3), n3.paint_order === jx.PAINT_ORDER_FILL_AND_STROKE ? (vv(t3, r3, n3, i3), wv(t3, r3, n3, i3)) : (wv(t3, r3, n3, i3), vv(t3, r3, n3, i3));
            }(t2, e2, r2, n2.path, i2), t2.restore());
          }
          function vv(t2, e2, r2, n2) {
            const i2 = r2.fill;
            if (!i2) return;
            const s2 = i2.opacity / 255;
            switch (t2.save(), t2.beginPath(), kv(r2, t2), i2.paint) {
              case "rgb_color":
                t2.fillStyle = dv(i2.rgb_color, i2.opacity, n2);
                break;
              case "linear_gradient_idx": {
                const r3 = e2.linear_gradients[i2.linear_gradient_idx];
                r3.transform && t2.setTransform(zv(r3.transform).preMultiplySelf(t2.getTransform())), t2.fillStyle = _v(t2, r3, s2, n2);
                break;
              }
              case "radial_gradient_idx": {
                const r3 = e2.radial_gradients[i2.radial_gradient_idx];
                r3.transform && t2.setTransform(zv(r3.transform).preMultiplySelf(t2.getTransform())), t2.fillStyle = Av(t2, r3, s2, n2);
              }
            }
            t2.fill(bv(r2)), t2.restore();
          }
          function bv(t2) {
            return t2.rule === Ox.PATH_RULE_NON_ZERO ? "nonzero" : t2.rule === Ox.PATH_RULE_EVEN_ODD ? "evenodd" : void 0;
          }
          function wv(t2, e2, r2, n2) {
            const i2 = r2.stroke;
            if (!i2) return;
            const s2 = Pv(r2);
            t2.lineWidth = i2.width, t2.miterLimit = i2.miterlimit, t2.setLineDash(i2.dasharray), t2.lineDashOffset = i2.dashoffset;
            const o2 = i2.opacity / 255;
            switch (i2.paint) {
              case "rgb_color":
                t2.strokeStyle = dv(i2.rgb_color, i2.opacity, n2);
                break;
              case "linear_gradient_idx":
                t2.strokeStyle = _v(t2, e2.linear_gradients[i2.linear_gradient_idx], o2, n2, true);
                break;
              case "radial_gradient_idx":
                t2.strokeStyle = Av(t2, e2.radial_gradients[i2.radial_gradient_idx], o2, n2, true);
            }
            switch (i2.linejoin) {
              case Nx.LINE_JOIN_MITER_CLIP:
              case Nx.LINE_JOIN_MITER:
                t2.lineJoin = "miter";
                break;
              case Nx.LINE_JOIN_ROUND:
                t2.lineJoin = "round";
                break;
              case Nx.LINE_JOIN_BEVEL:
                t2.lineJoin = "bevel";
            }
            switch (i2.linecap) {
              case Ux.LINE_CAP_BUTT:
                t2.lineCap = "butt";
                break;
              case Ux.LINE_CAP_ROUND:
                t2.lineCap = "round";
                break;
              case Ux.LINE_CAP_SQUARE:
                t2.lineCap = "square";
            }
            t2.stroke(s2);
          }
          function _v(t2, e2, r2, n2, i2 = false) {
            if (1 === e2.stops.length) {
              const t3 = e2.stops[0];
              return dv(t3.rgb_color, t3.opacity * r2, n2);
            }
            const { x1: s2, y1: o2, x2: a2, y2: l2 } = e2;
            let u2 = new DOMPoint(s2, o2), c2 = new DOMPoint(a2, l2);
            if (i2) {
              const t3 = zv(e2.transform);
              u2 = t3.transformPoint(u2), c2 = t3.transformPoint(c2);
            }
            const h3 = t2.createLinearGradient(u2.x, u2.y, c2.x, c2.y);
            for (const t3 of e2.stops) h3.addColorStop(t3.offset, dv(t3.rgb_color, t3.opacity * r2, n2));
            return h3;
          }
          function Av(t2, e2, r2, n2, i2 = false) {
            if (1 === e2.stops.length) {
              const t3 = e2.stops[0];
              return dv(t3.rgb_color, t3.opacity * r2, n2);
            }
            const s2 = zv(e2.transform), { fx: o2, fy: a2, fr: l2, cx: u2, cy: c2, r: h3 } = e2;
            let p3 = new DOMPoint(o2, a2), f2 = new DOMPoint(u2, c2), d2 = l2, m2 = h3;
            if (i2) {
              p3 = s2.transformPoint(p3), f2 = s2.transformPoint(f2);
              const t3 = (s2.a + s2.d) / 2;
              d2 = l2 * t3, m2 = e2.r * t3;
            }
            const y2 = t2.createRadialGradient(p3.x, p3.y, d2, f2.x, f2.y, m2);
            for (const t3 of e2.stops) y2.addColorStop(t3.offset, dv(t3.rgb_color, t3.opacity * r2, n2));
            return y2;
          }
          function Mv(t2, e2, r2, n2) {
            const i2 = n2.transform ? zv(n2.transform).preMultiplySelf(e2) : e2, s2 = mv(t2.canvas.width, t2.canvas.height), o2 = s2.getContext("2d");
            for (const t3 of n2.children) if (t3.group) Mv(o2, i2, r2, t3.group);
            else if (t3.path) {
              const e3 = t3.path, r3 = new Path2D();
              r3.addPath(Pv(e3), i2), o2.fill(r3, bv(e3));
            }
            const a2 = null != n2.clip_path_idx ? r2.clip_paths[n2.clip_path_idx] : null;
            a2 && Iv(o2, i2, r2, a2), t2.globalCompositeOperation = "source-over", t2.drawImage(s2, 0, 0);
          }
          function Iv(t2, e2, r2, n2) {
            const i2 = mv(t2.canvas.width, t2.canvas.height);
            Mv(i2.getContext("2d"), e2, r2, n2), t2.globalCompositeOperation = "destination-in", t2.drawImage(i2, 0, 0);
          }
          function Sv(t2, e2, r2, n2, i2) {
            if (0 === n2.children.length) return;
            const s2 = null != n2.mask_idx ? r2.masks[n2.mask_idx] : null;
            s2 && Sv(t2, e2, r2, s2, i2);
            const o2 = t2.canvas.width, a2 = t2.canvas.height, l2 = mv(o2, a2), u2 = l2.getContext("2d"), c2 = n2.width, h3 = n2.height, p3 = n2.left, f2 = n2.top, d2 = new Path2D(), m2 = new Path2D();
            m2.rect(p3, f2, c2, h3), d2.addPath(m2, e2), u2.clip(d2);
            for (const t3 of n2.children) xv(u2, e2, r2, t3, i2);
            const y2 = u2.getImageData(0, 0, o2, a2), g2 = y2.data;
            if (n2.mask_type === Gx.MASK_TYPE_LUMINANCE) for (let t3 = 0; t3 < g2.length; t3 += 4) g2[t3 + 3] = g2[t3 + 3] / 255 * (0.2126 * g2[t3] + 0.7152 * g2[t3 + 1] + 0.0722 * g2[t3 + 2]);
            u2.putImageData(y2, 0, 0), t2.globalCompositeOperation = "destination-in", t2.drawImage(l2, 0, 0);
          }
          function zv(t2) {
            return t2 ? new DOMMatrix([t2.sx, t2.ky, t2.kx, t2.sy, t2.tx, t2.ty]) : new DOMMatrix();
          }
          function kv(t2, e2) {
            const r2 = t2.step;
            let n2 = t2.diffs[0] * r2, i2 = t2.diffs[1] * r2;
            e2.moveTo(n2, i2);
            for (let s2 = 0, o2 = 2; s2 < t2.commands.length; s2++) switch (t2.commands[s2]) {
              case $x.PATH_COMMAND_MOVE:
                n2 += t2.diffs[o2++] * r2, i2 += t2.diffs[o2++] * r2, e2.moveTo(n2, i2);
                break;
              case $x.PATH_COMMAND_LINE:
                n2 += t2.diffs[o2++] * r2, i2 += t2.diffs[o2++] * r2, e2.lineTo(n2, i2);
                break;
              case $x.PATH_COMMAND_QUAD: {
                const s3 = n2 + t2.diffs[o2++] * r2, a2 = i2 + t2.diffs[o2++] * r2;
                n2 = s3 + t2.diffs[o2++] * r2, i2 = a2 + t2.diffs[o2++] * r2, e2.quadraticCurveTo(s3, a2, n2, i2);
                break;
              }
              case $x.PATH_COMMAND_CUBIC: {
                const s3 = n2 + t2.diffs[o2++] * r2, a2 = i2 + t2.diffs[o2++] * r2, l2 = s3 + t2.diffs[o2++] * r2, u2 = a2 + t2.diffs[o2++] * r2;
                n2 = l2 + t2.diffs[o2++] * r2, i2 = u2 + t2.diffs[o2++] * r2, e2.bezierCurveTo(s3, a2, l2, u2, n2, i2);
                break;
              }
              case $x.PATH_COMMAND_CLOSE:
                e2.closePath();
            }
            return e2;
          }
          function Pv(t2) {
            return kv(t2, new Path2D());
          }
          class Ev {
            constructor(t2) {
              this.capacity = t2, this.cache = /* @__PURE__ */ new Map();
            }
            get(t2) {
              if (!this.cache.has(t2)) return;
              const e2 = this.cache.get(t2);
              return this.cache.delete(t2), this.cache.set(t2, e2), e2;
            }
            put(t2, e2) {
              this.cache.has(t2) ? this.cache.delete(t2) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(t2, e2);
            }
            delete(t2) {
              this.cache.delete(t2);
            }
          }
          qs(Ev, "LRUCache");
          class Tv {
            constructor() {
              this.cacheMap = /* @__PURE__ */ new Map(), this.cacheDependenciesMap = /* @__PURE__ */ new Map();
            }
            static _getImage(t2) {
              return new yh(t2, t2.data);
            }
            getFromCache(t2, e2, r2) {
              return this.cacheMap.has(r2) || this.cacheMap.set(r2, new Ev(150)), this.cacheMap.get(r2).get(Xo(t2.toString(), e2));
            }
            setInCache(t2, e2, r2, n2) {
              this.cacheDependenciesMap.has(n2) || this.cacheDependenciesMap.set(n2, /* @__PURE__ */ new Map()), this.cacheMap.has(n2) || this.cacheMap.set(n2, new Ev(150));
              const i2 = this.cacheDependenciesMap.get(n2), s2 = Xo(t2.id.toString(), r2);
              i2.get(s2) || i2.set(s2, /* @__PURE__ */ new Set());
              const o2 = this.cacheMap.get(n2), a2 = t2.toString();
              i2.get(s2).add(a2), o2.put(Xo(t2.toString(), r2), e2);
            }
            removeImagesFromCacheByIds(t2, e2, r2 = 0) {
              if (!this.cacheMap.has(r2) || !this.cacheDependenciesMap.has(r2)) return;
              const n2 = this.cacheMap.get(r2), i2 = this.cacheDependenciesMap.get(r2);
              for (const r3 of t2) {
                const t3 = Xo(r3.toString(), e2);
                if (i2.has(t3)) {
                  for (const e3 of i2.get(t3)) n2.delete(e3);
                  i2.delete(t3);
                }
              }
            }
            rasterize(t2, e2, r2, n2, i2 = yv) {
              const s2 = this.getFromCache(t2, r2, n2);
              if (s2) return s2.clone();
              const o2 = i2(e2.icon, t2.options), a2 = Tv._getImage(o2);
              return this.setInCache(t2, a2, r2, n2), a2.clone();
            }
          }
          class Bv {
            constructor(t2) {
              this.size = t2, this.minimums = [], this.maximums = [], this.leaves = [];
            }
            getElevation(t2, e2) {
              const r2 = this.toIdx(t2, e2);
              return { min: this.minimums[r2], max: this.maximums[r2] };
            }
            isLeaf(t2, e2) {
              return this.leaves[this.toIdx(t2, e2)];
            }
            toIdx(t2, e2) {
              return e2 * this.size + t2;
            }
          }
          function Vv(t2, e2, r2, n2) {
            let i2 = 0, s2 = Number.MAX_VALUE;
            for (let o2 = 0; o2 < 3; o2++) if (Math.abs(n2[o2]) < 1e-15) {
              if (r2[o2] < t2[o2] || r2[o2] > e2[o2]) return null;
            } else {
              const a2 = 1 / n2[o2];
              let l2 = (t2[o2] - r2[o2]) * a2, u2 = (e2[o2] - r2[o2]) * a2;
              if (l2 > u2) {
                const t3 = l2;
                l2 = u2, u2 = t3;
              }
              if (l2 > i2 && (i2 = l2), u2 < s2 && (s2 = u2), i2 > s2) return null;
            }
            return i2;
          }
          function Cv(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2, c2) {
            const h3 = n2 - t2, p3 = i2 - e2, f2 = s2 - r2, d2 = o2 - t2, m2 = a2 - e2, y2 = l2 - r2, g2 = c2[1] * y2 - c2[2] * m2, x2 = c2[2] * d2 - c2[0] * y2, v2 = c2[0] * m2 - c2[1] * d2, b2 = h3 * g2 + p3 * x2 + f2 * v2;
            if (Math.abs(b2) < 1e-15) return null;
            const w2 = 1 / b2, _2 = u2[0] - t2, A2 = u2[1] - e2, M2 = u2[2] - r2, I2 = (_2 * g2 + A2 * x2 + M2 * v2) * w2;
            if (I2 < 0 || I2 > 1) return null;
            const S2 = A2 * f2 - M2 * p3, z2 = M2 * h3 - _2 * f2, k2 = _2 * p3 - A2 * h3, P2 = (c2[0] * S2 + c2[1] * z2 + c2[2] * k2) * w2;
            return P2 < 0 || I2 + P2 > 1 ? null : (d2 * S2 + m2 * z2 + y2 * k2) * w2;
          }
          function Fv(t2, e2, r2) {
            return (t2 - e2) / (r2 - e2);
          }
          function Dv(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            const u2 = 1 << r2, c2 = s2 - n2, h3 = o2 - i2, p3 = (t2 + 1) / u2 * c2 + n2, f2 = (e2 + 0) / u2 * h3 + i2, d2 = (e2 + 1) / u2 * h3 + i2;
            a2[0] = (t2 + 0) / u2 * c2 + n2, a2[1] = f2, l2[0] = p3, l2[1] = d2;
          }
          class Lv {
            constructor(t2) {
              if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = t2, this._siblingOffset = [[0, 0], [1, 0], [0, 1], [1, 1]], !this.dem) return;
              const e2 = function(t3) {
                const e3 = Math.ceil(Math.log2(t3.dim / 8)), r3 = [];
                let n3 = Math.ceil(Math.pow(2, e3));
                const i2 = 1 / n3, s2 = (t4, e4, r4, n4, i3) => {
                  const s3 = n4 ? 1 : 0, o3 = (t4 + 1) * r4 - s3, a3 = e4 * r4, l2 = (e4 + 1) * r4 - s3;
                  i3[0] = t4 * r4, i3[1] = a3, i3[2] = o3, i3[3] = l2;
                };
                let o2 = new Bv(n3);
                const a2 = [];
                for (let e4 = 0; e4 < n3 * n3; e4++) {
                  s2(e4 % n3, Math.floor(e4 / n3), i2, false, a2);
                  const r4 = Ov(a2[0], a2[1], t3), l2 = Ov(a2[2], a2[1], t3), u2 = Ov(a2[2], a2[3], t3), c2 = Ov(a2[0], a2[3], t3);
                  o2.minimums.push(Math.min(r4, l2, u2, c2)), o2.maximums.push(Math.max(r4, l2, u2, c2)), o2.leaves.push(1);
                }
                for (r3.push(o2), n3 /= 2; n3 >= 1; n3 /= 2) {
                  const t4 = r3[r3.length - 1];
                  o2 = new Bv(n3);
                  for (let e4 = 0; e4 < n3 * n3; e4++) {
                    s2(e4 % n3, Math.floor(e4 / n3), 2, true, a2);
                    const r4 = t4.getElevation(a2[0], a2[1]), i3 = t4.getElevation(a2[2], a2[1]), l2 = t4.getElevation(a2[2], a2[3]), u2 = t4.getElevation(a2[0], a2[3]), c2 = t4.isLeaf(a2[0], a2[1]), h3 = t4.isLeaf(a2[2], a2[1]), p3 = t4.isLeaf(a2[2], a2[3]), f2 = t4.isLeaf(a2[0], a2[3]), d2 = Math.min(r4.min, i3.min, l2.min, u2.min), m2 = Math.max(r4.max, i3.max, l2.max, u2.max), y2 = c2 && h3 && p3 && f2;
                    o2.maximums.push(m2), o2.minimums.push(d2), o2.leaves.push(m2 - d2 <= 5 && y2 ? 1 : 0);
                  }
                  r3.push(o2);
                }
                return r3;
              }(this.dem), r2 = e2.length - 1, n2 = e2[r2];
              this._addNode(n2.minimums[0], n2.maximums[0], n2.leaves[0]), this._construct(e2, 0, 0, r2, 0);
            }
            raycastRoot(t2, e2, r2, n2, i2, s2, o2 = 1) {
              return Vv([t2, e2, -100], [r2, n2, this.maximums[0] * o2], i2, s2);
            }
            raycast(t2, e2, r2, n2, i2, s2, o2 = 1) {
              if (!this.nodeCount) return null;
              const a2 = this.raycastRoot(t2, e2, r2, n2, i2, s2, o2);
              if (null == a2) return null;
              const l2 = [], u2 = [], c2 = [], h3 = [], p3 = [{ idx: 0, t: a2, nodex: 0, nodey: 0, depth: 0 }];
              for (; p3.length > 0; ) {
                const { idx: a3, t: f2, nodex: d2, nodey: m2, depth: y2 } = p3.pop();
                if (this.leaves[a3]) {
                  Dv(d2, m2, y2, t2, e2, r2, n2, c2, h3);
                  const a4 = 1 << y2, l3 = (d2 + 0) / a4, u3 = (d2 + 1) / a4, p4 = (m2 + 0) / a4, g3 = (m2 + 1) / a4, x2 = Ov(l3, p4, this.dem) * o2, v2 = Ov(u3, p4, this.dem) * o2, b2 = Ov(u3, g3, this.dem) * o2, w2 = Ov(l3, g3, this.dem) * o2, _2 = Cv(c2[0], c2[1], x2, h3[0], c2[1], v2, h3[0], h3[1], b2, i2, s2), A2 = Cv(h3[0], h3[1], b2, c2[0], h3[1], w2, c2[0], c2[1], x2, i2, s2), M2 = Math.min(null !== _2 ? _2 : Number.MAX_VALUE, null !== A2 ? A2 : Number.MAX_VALUE);
                  if (M2 !== Number.MAX_VALUE) return M2;
                  {
                    const t3 = E([], i2, s2, f2);
                    if (Rv(x2, v2, w2, b2, Fv(t3[0], c2[0], h3[0]), Fv(t3[1], c2[1], h3[1])) >= t3[2]) return f2;
                  }
                  continue;
                }
                let g2 = 0;
                for (let p4 = 0; p4 < this._siblingOffset.length; p4++) {
                  Dv((d2 << 1) + this._siblingOffset[p4][0], (m2 << 1) + this._siblingOffset[p4][1], y2 + 1, t2, e2, r2, n2, c2, h3), c2[2] = -100, h3[2] = this.maximums[this.childOffsets[a3] + p4] * o2;
                  const f3 = Vv(c2, h3, i2, s2);
                  if (null != f3) {
                    const t3 = f3;
                    l2[p4] = t3;
                    let e3 = false;
                    for (let r3 = 0; r3 < g2 && !e3; r3++) t3 >= l2[u2[r3]] && (u2.splice(r3, 0, p4), e3 = true);
                    e3 || (u2[g2] = p4), g2++;
                  }
                }
                for (let t3 = 0; t3 < g2; t3++) {
                  const e3 = u2[t3];
                  p3.push({ idx: this.childOffsets[a3] + e3, t: l2[e3], nodex: (d2 << 1) + this._siblingOffset[e3][0], nodey: (m2 << 1) + this._siblingOffset[e3][1], depth: y2 + 1 });
                }
              }
              return null;
            }
            _addNode(t2, e2, r2) {
              return this.minimums.push(t2), this.maximums.push(e2), this.leaves.push(r2), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(t2, e2, r2, n2, i2) {
              if (1 === t2[n2].isLeaf(e2, r2)) return;
              this.childOffsets[i2] || (this.childOffsets[i2] = this.nodeCount);
              const s2 = n2 - 1, o2 = t2[s2];
              let a2 = 0, l2 = 0;
              for (let t3 = 0; t3 < this._siblingOffset.length; t3++) {
                const n3 = 2 * e2 + this._siblingOffset[t3][0], i3 = 2 * r2 + this._siblingOffset[t3][1], s3 = o2.getElevation(n3, i3), u2 = o2.isLeaf(n3, i3), c2 = this._addNode(s3.min, s3.max, u2);
                u2 && (a2 |= 1 << t3), l2 || (l2 = c2);
              }
              for (let n3 = 0; n3 < this._siblingOffset.length; n3++) a2 & 1 << n3 || this._construct(t2, 2 * e2 + this._siblingOffset[n3][0], 2 * r2 + this._siblingOffset[n3][1], s2, l2 + n3);
            }
          }
          function Rv(t2, e2, r2, n2, i2, s2) {
            return ur(ur(t2, r2, s2), ur(e2, n2, s2), i2);
          }
          function Ov(t2, e2, r2) {
            const n2 = r2.dim, i2 = Et(t2 * n2 - 0.5, 0, n2 - 1), s2 = Et(e2 * n2 - 0.5, 0, n2 - 1), o2 = Math.floor(i2), a2 = Math.floor(s2), l2 = Math.min(o2 + 1, n2 - 1), u2 = Math.min(a2 + 1, n2 - 1);
            return Rv(r2.get(o2, a2), r2.get(l2, a2), r2.get(o2, u2), r2.get(l2, u2), i2 - o2, s2 - a2);
          }
          const Uv = { mapbox: [6553.6, 25.6, 0.1, 1e4], terrarium: [256, 1, 1 / 256, 32768] };
          function Nv(t2, e2, r2) {
            return (256 * t2 * 256 + 256 * e2 + r2) / 10 - 1e4;
          }
          function jv(t2, e2, r2) {
            return 256 * t2 + e2 + r2 / 256 - 32768;
          }
          class $v {
            get tree() {
              return this._tree || this._buildQuadTree(), this._tree;
            }
            constructor(t2, e2, r2, n2 = false) {
              if (this.uid = t2, e2.height !== e2.width) throw new RangeError("DEM tiles must be square");
              if (r2 && "mapbox" !== r2 && "terrarium" !== r2) return void Gt(`"${r2}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
              this.stride = e2.height;
              const i2 = this.dim = e2.height - 2, s2 = new Uint32Array(e2.data.buffer);
              if (this.pixels = new Uint8Array(e2.data.buffer), this.floatView = new Float32Array(e2.data.buffer), this.borderReady = n2, this._modifiedForSources = {}, !n2) {
                for (let t3 = 0; t3 < i2; t3++) s2[this._idx(-1, t3)] = s2[this._idx(0, t3)], s2[this._idx(i2, t3)] = s2[this._idx(i2 - 1, t3)], s2[this._idx(t3, -1)] = s2[this._idx(t3, 0)], s2[this._idx(t3, i2)] = s2[this._idx(t3, i2 - 1)];
                s2[this._idx(-1, -1)] = s2[this._idx(0, 0)], s2[this._idx(i2, -1)] = s2[this._idx(i2 - 1, 0)], s2[this._idx(-1, i2)] = s2[this._idx(0, i2 - 1)], s2[this._idx(i2, i2)] = s2[this._idx(i2 - 1, i2 - 1)];
              }
              const o2 = "terrarium" === r2 ? jv : Nv;
              for (let t3 = 0; t3 < s2.length; ++t3) {
                const e3 = 4 * t3;
                this.floatView[t3] = o2(this.pixels[e3], this.pixels[e3 + 1], this.pixels[e3 + 2]);
              }
              this._timestamp = fe.now();
            }
            _buildQuadTree() {
              this._tree = new Lv(this);
            }
            get(t2, e2, r2 = false) {
              r2 && (t2 = Et(t2, -1, this.dim), e2 = Et(e2, -1, this.dim));
              const n2 = this._idx(t2, e2);
              return this.floatView[n2];
            }
            set(t2, e2, r2) {
              const n2 = this._idx(t2, e2), i2 = this.floatView[n2];
              return this.floatView[n2] = r2, r2 - i2;
            }
            static getUnpackVector(t2) {
              return Uv[t2];
            }
            _idx(t2, e2) {
              if (t2 < -1 || t2 >= this.dim + 1 || e2 < -1 || e2 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
              return (e2 + 1) * this.stride + (t2 + 1);
            }
            static pack(t2, e2) {
              const r2 = [0, 0, 0, 0], n2 = $v.getUnpackVector(e2);
              let i2 = Math.floor((t2 + n2[3]) / n2[2]);
              return r2[2] = i2 % 256, i2 = Math.floor(i2 / 256), r2[1] = i2 % 256, i2 = Math.floor(i2 / 256), r2[0] = i2, r2;
            }
            getPixels() {
              return new gh({ width: this.stride, height: this.stride }, this.pixels);
            }
            backfillBorder(t2, e2, r2) {
              if (this.dim !== t2.dim) throw new Error("dem dimension mismatch");
              let n2 = e2 * this.dim, i2 = e2 * this.dim + this.dim, s2 = r2 * this.dim, o2 = r2 * this.dim + this.dim;
              switch (e2) {
                case -1:
                  n2 = i2 - 1;
                  break;
                case 1:
                  i2 = n2 + 1;
              }
              switch (r2) {
                case -1:
                  s2 = o2 - 1;
                  break;
                case 1:
                  o2 = s2 + 1;
              }
              const a2 = -e2 * this.dim, l2 = -r2 * this.dim;
              for (let e3 = s2; e3 < o2; e3++) for (let r3 = n2; r3 < i2; r3++) {
                const n3 = 4 * this._idx(r3, e3), i3 = 4 * this._idx(r3 + a2, e3 + l2);
                this.pixels[n3 + 0] = t2.pixels[i3 + 0], this.pixels[n3 + 1] = t2.pixels[i3 + 1], this.pixels[n3 + 2] = t2.pixels[i3 + 2], this.pixels[n3 + 3] = t2.pixels[i3 + 3];
              }
            }
            onDeserialize() {
              this._tree && (this._tree.dem = this);
            }
          }
          function Gv(t2, e2, r2) {
            1 === t2 ? e2.headerLength = r2.readFixed32() : 2 === t2 ? e2.x = r2.readVarint() : 3 === t2 ? e2.y = r2.readVarint() : 4 === t2 ? e2.z = r2.readVarint() : 5 === t2 && e2.layers.push(function(t3, e3) {
              return t3.readFields(Wv, { version: 0, name: "", units: "", tileSize: 0, buffer: 0, pixelFormat: 0, dataIndex: [] }, e3);
            }(r2, r2.readVarint() + r2.pos));
          }
          function qv(t2, e2, r2) {
            1 === t2 ? (e2.delta_filter = function(t3, e3) {
              return t3.readFields(Hv, { blockSize: 0 }, e3);
            }(r2, r2.readVarint() + r2.pos), e2.filter = "delta_filter") : 2 === t2 ? (r2.readVarint(), e2.filter = "zigzag_filter") : 3 === t2 ? (r2.readVarint(), e2.filter = "bitshuffle_filter") : 4 === t2 && (r2.readVarint(), e2.filter = "byteshuffle_filter");
          }
          function Hv(t2, e2, r2) {
            1 === t2 && (e2.blockSize = r2.readVarint());
          }
          function Xv(t2, e2, r2) {
            1 === t2 ? (r2.readVarint(), e2.codec = "gzip_data") : 2 === t2 ? (r2.readVarint(), e2.codec = "jpeg_image") : 3 === t2 ? (r2.readVarint(), e2.codec = "webp_image") : 4 === t2 && (r2.readVarint(), e2.codec = "png_image");
          }
          function Zv(t2, e2, r2) {
            let n2 = 0, i2 = 0;
            1 === t2 ? e2.firstByte = r2.readFixed64() : 2 === t2 ? e2.lastByte = r2.readFixed64() : 3 === t2 ? e2.filters.push(function(t3, e3) {
              return t3.readFields(qv, {}, e3);
            }(r2, r2.readVarint() + r2.pos)) : 4 === t2 ? e2.codec = function(t3, e3) {
              return t3.readFields(Xv, {}, e3);
            }(r2, r2.readVarint() + r2.pos) : 5 === t2 ? i2 = r2.readFloat() : 6 === t2 ? n2 = r2.readFloat() : 7 === t2 ? e2.bands.push(r2.readString()) : 8 === t2 ? e2.offset = r2.readDouble() : 9 === t2 && (e2.scale = r2.readDouble()), 0 === e2.offset && (e2.offset = i2), 0 === e2.scale && (e2.scale = n2);
          }
          function Wv(t2, e2, r2) {
            1 === t2 ? e2.version = r2.readVarint() : 2 === t2 ? e2.name = r2.readString() : 3 === t2 ? e2.units = r2.readString() : 4 === t2 ? e2.tileSize = r2.readVarint() : 5 === t2 ? e2.buffer = r2.readVarint() : 6 === t2 ? e2.pixelFormat = r2.readVarint() : 7 === t2 && e2.dataIndex.push(function(t3, e3) {
              return t3.readFields(Zv, { firstByte: 0, lastByte: 0, filters: [], codec: null, offset: 0, scale: 0, bands: [] }, e3);
            }(r2, r2.readVarint() + r2.pos));
          }
          function Yv(t2, e2, r2) {
            if (2 === t2) !function(t3, e3, r3) {
              t3.readFields(Kv, r3, e3);
            }(r2, r2.readVarint() + r2.pos, e2);
            else if (3 === t2) throw new Error("Not implemented");
          }
          function Kv(t2, e2, r2) {
            if (1 === t2) {
              let t3 = 0;
              const n2 = r2.readVarint() + r2.pos;
              for (; r2.pos < n2; ) e2[t3++] = r2.readVarint();
            }
          }
          function Jv(t2, e2) {
            if (4 !== e2.length) throw new Error(`Expected data of dimension 4 but got ${e2.length}.`);
            let r2 = e2[3];
            for (let n2 = 2; n2 >= 1; n2--) {
              const i2 = 1 === n2 ? 1 : 0, s2 = 2 === n2 ? 1 : 0;
              for (let n3 = 0; n3 < e2[0]; n3++) {
                const o2 = e2[1] * n3;
                for (let n4 = i2; n4 < e2[1]; n4++) {
                  const i3 = e2[2] * (n4 + o2);
                  for (let n5 = s2; n5 < e2[2]; n5++) {
                    const s3 = e2[3] * (n5 + i3);
                    for (let n6 = 0; n6 < e2[3]; n6++) {
                      const e3 = s3 + n6;
                      t2[e3] += t2[e3 - r2];
                    }
                  }
                }
              }
              r2 *= e2[n2];
            }
            return t2;
          }
          function Qv(t2) {
            for (let e2 = 0, r2 = t2.length; e2 < r2; e2++) t2[e2] = t2[e2] >>> 1 ^ -(1 & t2[e2]);
            return t2;
          }
          function tb(t2, e2) {
            switch (e2) {
              case "uint32":
                return t2;
              case "uint16":
                for (let e3 = 0; e3 < t2.length; e3 += 2) {
                  const r2 = t2[e3], n2 = t2[e3 + 1];
                  t2[e3] = (240 & r2) >> 4 | (61440 & r2) >> 8 | (240 & n2) << 4 | 61440 & n2, t2[e3 + 1] = 15 & r2 | (3840 & r2) >> 4 | (15 & n2) << 8 | (3840 & n2) << 4;
                }
                return t2;
              case "uint8":
                for (let e3 = 0; e3 < t2.length; e3 += 4) {
                  const r2 = t2[e3], n2 = t2[e3 + 1], i2 = t2[e3 + 2], s2 = t2[e3 + 3];
                  t2[e3 + 0] = (192 & r2) >> 6 | (192 & n2) >> 4 | (192 & i2) >> 2 | 192 & s2, t2[e3 + 1] = (48 & r2) >> 4 | (48 & n2) >> 2 | 48 & i2 | (48 & s2) << 2, t2[e3 + 2] = (12 & r2) >> 2 | 12 & n2 | (12 & i2) << 2 | (12 & s2) << 4, t2[e3 + 3] = 3 & r2 | (3 & n2) << 2 | (3 & i2) << 4 | (3 & s2) << 6;
                }
                return t2;
              default:
                throw new Error(`Invalid pixel format, "${e2}"`);
            }
          }
          qs($v, "DEMData"), qs(Lv, "DemMinMaxQuadTree", { omit: ["dem"] });
          var eb = Uint8Array, rb = Uint16Array, nb = Int32Array, ib = new eb([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), sb = new eb([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), ob = new eb([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), ab = function(t2, e2) {
            for (var r2 = new rb(31), n2 = 0; n2 < 31; ++n2) r2[n2] = e2 += 1 << t2[n2 - 1];
            var i2 = new nb(r2[30]);
            for (n2 = 1; n2 < 30; ++n2) for (var s2 = r2[n2]; s2 < r2[n2 + 1]; ++s2) i2[s2] = s2 - r2[n2] << 5 | n2;
            return { b: r2, r: i2 };
          }, lb = ab(ib, 2), ub = lb.b, cb = lb.r;
          ub[28] = 258, cb[258] = 28;
          for (var hb = ab(sb, 0).b, pb = new rb(32768), fb = 0; fb < 32768; ++fb) {
            var db = (43690 & fb) >> 1 | (21845 & fb) << 1;
            pb[fb] = ((65280 & (db = (61680 & (db = (52428 & db) >> 2 | (13107 & db) << 2)) >> 4 | (3855 & db) << 4)) >> 8 | (255 & db) << 8) >> 1;
          }
          var mb = function(t2, e2, r2) {
            for (var n2 = t2.length, i2 = 0, s2 = new rb(e2); i2 < n2; ++i2) t2[i2] && ++s2[t2[i2] - 1];
            var o2, a2 = new rb(e2);
            for (i2 = 1; i2 < e2; ++i2) a2[i2] = a2[i2 - 1] + s2[i2 - 1] << 1;
            o2 = new rb(1 << e2);
            var l2 = 15 - e2;
            for (i2 = 0; i2 < n2; ++i2) if (t2[i2]) for (var u2 = i2 << 4 | t2[i2], c2 = e2 - t2[i2], h3 = a2[t2[i2] - 1]++ << c2, p3 = h3 | (1 << c2) - 1; h3 <= p3; ++h3) o2[pb[h3] >> l2] = u2;
            return o2;
          }, yb = new eb(288);
          for (fb = 0; fb < 144; ++fb) yb[fb] = 8;
          for (fb = 144; fb < 256; ++fb) yb[fb] = 9;
          for (fb = 256; fb < 280; ++fb) yb[fb] = 7;
          for (fb = 280; fb < 288; ++fb) yb[fb] = 8;
          var gb = new eb(32);
          for (fb = 0; fb < 32; ++fb) gb[fb] = 5;
          var xb = mb(yb, 9), vb = mb(gb, 5), bb = function(t2) {
            for (var e2 = t2[0], r2 = 1; r2 < t2.length; ++r2) t2[r2] > e2 && (e2 = t2[r2]);
            return e2;
          }, wb = function(t2, e2, r2) {
            var n2 = e2 / 8 | 0;
            return (t2[n2] | t2[n2 + 1] << 8) >> (7 & e2) & r2;
          }, _b = function(t2, e2) {
            var r2 = e2 / 8 | 0;
            return (t2[r2] | t2[r2 + 1] << 8 | t2[r2 + 2] << 16) >> (7 & e2);
          }, Ab = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler", , "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"], Mb = function(t2, e2, r2) {
            var n2 = new Error(e2 || Ab[t2]);
            if (n2.code = t2, Error.captureStackTrace && Error.captureStackTrace(n2, Mb), !r2) throw n2;
            return n2;
          }, Ib = new eb(0), Sb = "undefined" != typeof TextDecoder && new TextDecoder();
          try {
            Sb.decode(Ib, { stream: true });
          } catch (t2) {
          }
          const zb = { gzip_data: "gzip" };
          class kb extends Error {
            constructor(t2) {
              super(t2), this.name = "MRTError";
            }
          }
          const Pb = { 0: "uint32", 1: "uint32", 2: "uint16", 3: "uint8" }, Eb = { uint32: 1, uint16: 2, uint8: 4 }, Tb = { uint32: Uint32Array, uint16: Uint16Array, uint8: Uint8Array };
          let Bb;
          class Vb {
            constructor(t2 = 5) {
              this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = t2;
            }
            getLayer(t2) {
              const e2 = this.layers[t2];
              if (!e2) throw new kb(`Layer '${t2}' not found`);
              return e2;
            }
            getHeaderLength(t2) {
              const e2 = new Uint8Array(t2), r2 = new DataView(t2);
              if (13 !== e2[0]) throw new kb("File is not a valid MRT.");
              return r2.getUint32(1, true);
            }
            parseHeader(t2) {
              const e2 = new Uint8Array(t2), r2 = this.getHeaderLength(t2);
              if (e2.length < r2) throw new kb(`Expected header with length >= ${r2} but got buffer of length ${e2.length}`);
              const n2 = function(t3, e3) {
                return t3.readFields(Gv, { headerLength: 0, x: 0, y: 0, z: 0, layers: [] }, void 0);
              }(new Bb(e2.subarray(0, r2)));
              if (!isNaN(this.x) && (this.x !== n2.x || this.y !== n2.y || this.z !== n2.z)) throw new kb(`Invalid attempt to parse header ${n2.z}/${n2.x}/${n2.y} for tile ${this.z}/${this.x}/${this.y}`);
              this.x = n2.x, this.y = n2.y, this.z = n2.z;
              for (const t3 of n2.layers) this.layers[t3.name] = new Cb(t3, { cacheSize: this._cacheSize });
              return this;
            }
            createDecodingTask(t2) {
              const e2 = [], r2 = this.getLayer(t2.layerName);
              for (let n2 of t2.blockIndices) {
                const i2 = r2.dataIndex[n2], s2 = i2.firstByte - t2.firstByte, o2 = i2.lastByte - t2.firstByte;
                if (r2._blocksInProgress.has(n2)) continue;
                const a2 = { layerName: r2.name, firstByte: s2, lastByte: o2, pixelFormat: r2.pixelFormat, blockIndex: n2, blockShape: [i2.bands.length].concat(r2.bandShape), buffer: r2.buffer, codec: i2.codec.codec, filters: i2.filters.map((t3) => t3.filter) };
                r2._blocksInProgress.add(n2), e2.push(a2);
              }
              return new Fb(e2, () => {
                e2.forEach((t3) => r2._blocksInProgress.delete(t3.blockIndex));
              }, (t3, n2) => {
                if (e2.forEach((t4) => r2._blocksInProgress.delete(t4.blockIndex)), t3) throw t3;
                n2.forEach((t4) => {
                  this.getLayer(t4.layerName).processDecodedData(t4);
                });
              });
            }
          }
          class Cb {
            constructor({ version: t2, name: e2, units: r2, tileSize: n2, pixelFormat: i2, buffer: s2, dataIndex: o2 }, a2) {
              if (this.version = t2, 1 !== this.version) throw new kb(`Cannot parse raster layer encoded with MRT version ${t2}`);
              this.name = e2, this.units = r2, this.tileSize = n2, this.buffer = s2, this.pixelFormat = Pb[i2], this.dataIndex = o2, this.bandShape = [n2 + 2 * s2, n2 + 2 * s2, Eb[this.pixelFormat]], this._decodedBlocks = new Ev(a2 ? a2.cacheSize : 5), this._blocksInProgress = /* @__PURE__ */ new Set();
            }
            get dimension() {
              return Eb[this.pixelFormat];
            }
            get cacheSize() {
              return this._decodedBlocks.capacity;
            }
            getBandList() {
              return this.dataIndex.map(({ bands: t2 }) => t2).flat();
            }
            processDecodedData(t2) {
              const e2 = t2.blockIndex.toString();
              this._decodedBlocks.get(e2) || this._decodedBlocks.put(e2, t2.data);
            }
            getBlockForBand(t2) {
              let e2 = 0;
              switch (typeof t2) {
                case "string":
                  for (const [r2, n2] of this.dataIndex.entries()) {
                    for (const [i2, s2] of n2.bands.entries()) if (s2 === t2) return { bandIndex: e2 + i2, blockIndex: r2, blockBandIndex: i2 };
                    e2 += n2.bands.length;
                  }
                  break;
                case "number":
                  for (const [r2, n2] of this.dataIndex.entries()) {
                    if (t2 >= e2 && t2 < e2 + n2.bands.length) return { bandIndex: t2, blockIndex: r2, blockBandIndex: t2 - e2 };
                    e2 += n2.bands.length;
                  }
                  break;
                default:
                  throw new kb(`Invalid band \`${JSON.stringify(t2)}\`. Expected string or integer.`);
              }
              return { blockIndex: -1, blockBandIndex: -1 };
            }
            getDataRange(t2) {
              let e2 = 1 / 0, r2 = -1 / 0;
              const n2 = [], i2 = /* @__PURE__ */ new Set();
              for (const s2 of t2) {
                const { blockIndex: t3 } = this.getBlockForBand(s2);
                if (t3 < 0) throw new kb(`Invalid band: ${JSON.stringify(s2)}`);
                const o2 = this.dataIndex[t3];
                n2.includes(t3) || n2.push(t3), i2.add(t3), e2 = Math.min(e2, o2.firstByte), r2 = Math.max(r2, o2.lastByte);
              }
              if (i2.size > this.cacheSize) throw new kb(`Number of blocks to decode (${i2.size}) exceeds cache size (${this.cacheSize}).`);
              return { layerName: this.name, firstByte: e2, lastByte: r2, blockIndices: n2 };
            }
            hasBand(t2) {
              const { blockIndex: e2 } = this.getBlockForBand(t2);
              return e2 >= 0;
            }
            hasDataForBand(t2) {
              const { blockIndex: e2 } = this.getBlockForBand(t2);
              return e2 >= 0 && !!this._decodedBlocks.get(e2.toString());
            }
            getBandView(t2) {
              const { blockIndex: e2, blockBandIndex: r2 } = this.getBlockForBand(t2);
              if (e2 < 0) throw new kb(`Band not found: ${JSON.stringify(t2)}`);
              const n2 = this._decodedBlocks.get(e2.toString());
              if (!n2) throw new kb(`Data for band ${JSON.stringify(t2)} of layer "${this.name}" not decoded.`);
              const i2 = this.dataIndex[e2], s2 = this.bandShape.reduce((t3, e3) => t3 * e3, 1), o2 = r2 * s2, a2 = n2.subarray(o2, o2 + s2);
              return { data: a2, bytes: new Uint8Array(a2.buffer).subarray(a2.byteOffset, a2.byteOffset + a2.byteLength), tileSize: this.tileSize, buffer: this.buffer, pixelFormat: this.pixelFormat, dimension: this.dimension, offset: i2.offset, scale: i2.scale };
            }
          }
          Vb.setPbf = function(t2) {
            Bb = t2;
          };
          class Fb {
            constructor(t2, e2, r2) {
              this.tasks = t2, this._onCancel = e2, this._onComplete = r2, this._finalized = false;
            }
            cancel() {
              this._finalized || (this._onCancel(), this._finalized = true);
            }
            complete(t2, e2) {
              this._finalized || (this._onComplete(t2, e2), this._finalized = true);
            }
          }
          function Db(t2, e2) {
            const r2 = t2.json.bufferViews[e2.bufferView], n2 = Jf[e2.componentType];
            return new n2(t2.buffers[r2.buffer], (e2.byteOffset || 0) + (r2.byteOffset || 0), e2.count * (r2.byteStride && r2.byteStride !== td[e2.type] * n2.BYTES_PER_ELEMENT ? r2.byteStride / n2.BYTES_PER_ELEMENT : td[e2.type]));
          }
          function Lb(t2, e2, r2, n2) {
            const i2 = Jf[e2.componentType], s2 = function(t3) {
              switch (t3) {
                case Int8Array:
                  return 1 / 127;
                case Uint8Array:
                  return 1 / 255;
                case Int16Array:
                  return 1 / 32767;
                case Uint16Array:
                  return 1 / 65535;
                default:
                  return 1;
              }
            }(i2), o2 = t2.json.bufferViews[e2.bufferView], a2 = o2.byteStride ? o2.byteStride / i2.BYTES_PER_ELEMENT : td[e2.type], l2 = r2.float32, u2 = l2.length / r2.capacity;
            for (let t3 = 0, r3 = 0; t3 < e2.count * a2; t3 += a2, r3 += u2) for (let e3 = 0; e3 < u2; e3++) l2[r3 + e3] = n2[t3 + e3] * s2;
            r2._trim();
          }
          function Rb(t2, e2, r2) {
            const n2 = t2.indices, i2 = t2.attributes, s2 = {};
            s2.indexArray = new Aa();
            const o2 = e2.json.accessors[n2], a2 = o2.count / 3;
            s2.indexArray.reserve(a2);
            const l2 = Db(e2, o2);
            for (let t3 = 0; t3 < a2; t3++) s2.indexArray.emplaceBack(l2[3 * t3], l2[3 * t3 + 1], l2[3 * t3 + 2]);
            s2.indexArray._trim(), s2.vertexArray = new ca();
            const u2 = e2.json.accessors[i2.POSITION];
            s2.vertexArray.reserve(u2.count);
            const c2 = Db(e2, u2);
            for (let t3 = 0; t3 < u2.count; t3++) s2.vertexArray.emplaceBack(c2[3 * t3], c2[3 * t3 + 1], c2[3 * t3 + 2]);
            if (s2.vertexArray._trim(), s2.aabb = new qu(u2.min, u2.max), s2.centroid = function(t3, e3) {
              const r3 = [0, 0, 0], n3 = t3.length;
              if (n3 > 0) {
                for (let i3 = 0; i3 < n3; i3++) {
                  const n4 = 3 * t3[i3];
                  r3[0] += e3[n4], r3[1] += e3[n4 + 1], r3[2] += e3[n4 + 2];
                }
                r3[0] /= n3, r3[1] /= n3, r3[2] /= n3;
              }
              return r3;
            }(l2, c2), void 0 !== i2.COLOR_0) {
              const t3 = e2.json.accessors[i2.COLOR_0], r3 = td[t3.type], n3 = Db(e2, t3);
              s2.colorArray = 3 === r3 ? new ca() : new ya(), s2.colorArray.resize(t3.count), Lb(e2, t3, s2.colorArray, n3);
            }
            if (void 0 !== i2.NORMAL) {
              s2.normalArray = new ca();
              const t3 = e2.json.accessors[i2.NORMAL];
              s2.normalArray.resize(t3.count);
              const r3 = Db(e2, t3);
              Lb(e2, t3, s2.normalArray, r3);
            }
            if (void 0 !== i2.TEXCOORD_0 && r2.length > 0) {
              s2.texcoordArray = new Ta();
              const t3 = e2.json.accessors[i2.TEXCOORD_0];
              s2.texcoordArray.resize(t3.count);
              const r3 = Db(e2, t3);
              Lb(e2, t3, s2.texcoordArray, r3);
            }
            if (void 0 !== i2._FEATURE_ID_RGBA4444) {
              const t3 = e2.json.accessors[i2._FEATURE_ID_RGBA4444];
              e2.json.extensionsUsed && e2.json.extensionsUsed.includes("EXT_meshopt_compression") && (s2.featureData = Db(e2, t3));
            }
            void 0 !== i2._FEATURE_RGBA4444 && (s2.featureData = new Uint32Array(Db(e2, e2.json.accessors[i2._FEATURE_RGBA4444]).buffer));
            const h3 = t2.material;
            return s2.material = function(t3, e3) {
              const { emissiveFactor: r3 = [0, 0, 0], alphaMode: n3 = "OPAQUE", alphaCutoff: i3 = 0.5, normalTexture: s3, occlusionTexture: o3, emissiveTexture: a3, doubleSided: l3 } = t3, { baseColorFactor: u3 = [1, 1, 1, 1], metallicFactor: c3 = 1, roughnessFactor: h4 = 1, baseColorTexture: p3, metallicRoughnessTexture: f2 } = t3.pbrMetallicRoughness || {}, d2 = o3 ? e3[o3.index] : void 0;
              if (o3 && o3.extensions && o3.extensions.KHR_texture_transform && d2) {
                const t4 = o3.extensions.KHR_texture_transform;
                d2.offsetScale = [t4.offset[0], t4.offset[1], t4.scale[0], t4.scale[1]];
              }
              return { pbrMetallicRoughness: { baseColorFactor: new sr(...u3), metallicFactor: c3, roughnessFactor: h4, baseColorTexture: p3 ? e3[p3.index] : void 0, metallicRoughnessTexture: f2 ? e3[f2.index] : void 0 }, doubleSided: l3, emissiveFactor: new sr(...r3), alphaMode: n3, alphaCutoff: i3, normalTexture: s3 ? e3[s3.index] : void 0, occlusionTexture: d2, emissionTexture: a3 ? e3[a3.index] : void 0, defined: void 0 === t3.defined };
            }(void 0 !== h3 ? e2.json.materials[h3] : { defined: false }, r2), s2;
          }
          function Ob(t2, e2, r2) {
            const { matrix: n2, rotation: i2, translation: s2, scale: o2, mesh: a2, extras: l2, children: u2 } = t2, c2 = {};
            if (c2.matrix = n2 || function(t3, e3, r3, n3) {
              var i3 = e3[0], s3 = e3[1], o3 = e3[2], a3 = e3[3], l3 = i3 + i3, u3 = s3 + s3, c3 = o3 + o3, h3 = i3 * l3, p3 = i3 * u3, f2 = i3 * c3, d2 = s3 * u3, m2 = s3 * c3, y2 = o3 * c3, g2 = a3 * l3, x2 = a3 * u3, v2 = a3 * c3, b2 = n3[0], w2 = n3[1], _2 = n3[2];
              return t3[0] = (1 - (d2 + y2)) * b2, t3[1] = (p3 + v2) * b2, t3[2] = (f2 - x2) * b2, t3[3] = 0, t3[4] = (p3 - v2) * w2, t3[5] = (1 - (h3 + y2)) * w2, t3[6] = (m2 + g2) * w2, t3[7] = 0, t3[8] = (f2 + x2) * _2, t3[9] = (m2 - g2) * _2, t3[10] = (1 - (h3 + d2)) * _2, t3[11] = 0, t3[12] = r3[0], t3[13] = r3[1], t3[14] = r3[2], t3[15] = 1, t3;
            }([], i2 || [0, 0, 0, 1], s2 || [0, 0, 0], o2 || [1, 1, 1]), void 0 !== a2) {
              c2.meshes = r2[a2];
              const t3 = c2.anchor = [0, 0];
              for (const e3 of c2.meshes) {
                const { min: r3, max: n3 } = e3.aabb;
                t3[0] += r3[0] + n3[0], t3[1] += r3[1] + n3[1];
              }
              t3[0] = Math.floor(t3[0] / c2.meshes.length / 2), t3[1] = Math.floor(t3[1] / c2.meshes.length / 2);
            }
            if (l2 && (l2.id && (c2.id = l2.id), l2.lights && (c2.lights = function(t3) {
              if (!t3.length) return [];
              const e3 = function(t4) {
                const e4 = atob(t4), r4 = new Uint8Array(e4.length);
                for (let t5 = 0; t5 < e4.length; t5++) r4[t5] = e4.codePointAt(t5);
                return r4;
              }(t3), r3 = [], n3 = e3.length / 24, i3 = new Uint16Array(e3.buffer), s3 = new Float32Array(e3.buffer);
              for (let t4 = 0; t4 < n3; t4++) {
                const e4 = i3[2 * t4 * 6] / 30, n4 = i3[2 * t4 * 6 + 1] / 30, o3 = i3[2 * t4 * 6 + 10] / 100, a3 = s3[6 * t4 + 1], l3 = s3[6 * t4 + 2], u3 = s3[6 * t4 + 3], c3 = s3[6 * t4 + 4], h3 = u3 - a3, p3 = c3 - l3, f2 = Math.hypot(h3, p3);
                r3.push({ pos: [a3 + 0.5 * h3, l3 + 0.5 * p3, n4], normal: [p3 / f2, -h3 / f2, 0], width: f2, height: e4, depth: o3, points: [a3, l3, u3, c3] });
              }
              return r3;
            }(l2.lights))), u2) {
              const t3 = [];
              for (const n3 of u2) t3.push(Ob(e2.json.nodes[n3], e2, r2));
              c2.children = t3;
            }
            return c2;
          }
          function Ub(t2) {
            if (0 === t2.vertices.length || 0 === t2.indices.length) return null;
            const e2 = new xp(t2.vertices, t2.indices, 8, 256), [r2, n2] = [e2.min.clone(), e2.max.clone()];
            return { vertices: t2.vertices, indices: t2.indices, grid: e2, min: r2, max: n2 };
          }
          function Nb(t2) {
            if (!t2.extras || !t2.extras.ground) return null;
            const e2 = t2.extras.ground;
            if (!e2 || !Array.isArray(e2) || 0 === e2.length) return null;
            const r2 = e2[0];
            if (!r2 || !Array.isArray(r2) || 0 === r2.length) return null;
            const n2 = [];
            for (const t3 of r2) {
              if (!Array.isArray(t3) || 2 !== t3.length) continue;
              const e3 = t3[0], r3 = t3[1];
              "number" == typeof e3 && "number" == typeof r3 && n2.push(new bt(e3, r3));
            }
            if (n2.length < 3) return null;
            n2.length > 1 && n2[n2.length - 1].equals(n2[0]) && n2.pop();
            let i2 = 0;
            for (let t3 = 0; t3 < n2.length; t3++) {
              const e3 = n2[t3], r3 = n2[(t3 + 1) % n2.length], s3 = n2[(t3 + 2) % n2.length];
              i2 += (e3.x - r3.x) * (s3.y - r3.y) - (s3.x - r3.x) * (e3.y - r3.y);
            }
            i2 > 0 && n2.reverse();
            const s2 = Ah(n2.flatMap((t3) => [t3.x, t3.y]), []);
            return 0 === s2.length ? null : { vertices: n2, indices: s2 };
          }
          function jb(t2, e2) {
            const r2 = [], n2 = [];
            let i2 = 0;
            const s2 = [];
            for (const o2 of t2) {
              i2 = r2.length;
              const t3 = o2.vertexArray.float32, a2 = o2.indexArray.uint16;
              for (let n3 = 0; n3 < o2.vertexArray.length; n3++) s2[0] = t3[3 * n3 + 0], s2[1] = t3[3 * n3 + 1], s2[2] = t3[3 * n3 + 2], R(s2, s2, e2), r2.push(new bt(s2[0], s2[1]));
              for (let t4 = 0; t4 < 3 * o2.indexArray.length; t4++) n2.push(a2[t4] + i2);
            }
            if (n2.length % 3 != 0) return null;
            for (let t3 = 0; t3 < n2.length; t3 += 3) {
              const e3 = r2[n2[t3 + 0]], i3 = r2[n2[t3 + 1]], s3 = r2[n2[t3 + 2]];
              (e3.x - i3.x) * (s3.y - i3.y) - (s3.x - i3.x) * (e3.y - i3.y) > 0 && ([n2[t3 + 1], n2[t3 + 2]] = [n2[t3 + 2], n2[t3 + 1]]);
            }
            return { vertices: r2, indices: n2 };
          }
          function $b(t2) {
            const e2 = function(t3, e3) {
              const r3 = [], n3 = WebGL2RenderingContext;
              if (t3.json.textures) for (const i3 of t3.json.textures) {
                const s3 = { magFilter: n3.LINEAR, minFilter: n3.NEAREST, wrapS: n3.REPEAT, wrapT: n3.REPEAT };
                void 0 !== i3.sampler && Object.assign(s3, t3.json.samplers[i3.sampler]), r3.push({ image: e3[i3.source], sampler: s3, uploaded: false });
              }
              return r3;
            }(t2, t2.images), r2 = function(t3, e3) {
              const r3 = [];
              for (const n3 of t3.json.meshes) {
                const i3 = [];
                for (const r4 of n3.primitives) i3.push(Rb(r4, t3, e3));
                r3.push(i3);
              }
              return r3;
            }(t2, e2), { scenes: n2, scene: i2, nodes: s2 } = t2.json, o2 = n2 ? n2[i2 || 0].nodes : s2, a2 = [];
            for (const e3 of o2) a2.push(Ob(s2[e3], t2, r2));
            return function(t3, e3, r3) {
              const n3 = {}, i3 = /* @__PURE__ */ new Set();
              for (let s3 = 0; s3 < t3.length; s3++) {
                const t4 = r3[e3[s3]];
                if (!t4.extras) continue;
                const o3 = t4.extras["mapbox:footprint:version"], a3 = t4.extras["mapbox:footprint:id"];
                (o3 || a3) && i3.add(s3), "1.0.0" === o3 && a3 && (n3[a3] = s3);
              }
              for (let s3 = 0; s3 < t3.length; s3++) {
                if (i3.has(s3)) continue;
                const o3 = t3[s3], a3 = r3[e3[s3]];
                if (!a3.extras) continue;
                let l2 = null;
                o3.id in n3 && (l2 = jb(t3[n3[o3.id]].meshes, o3.matrix)), l2 || (l2 = Nb(a3)), l2 && (o3.footprint = Ub(l2));
              }
              if (i3.size > 0) {
                const e4 = Array.from(i3.values()).sort((t4, e5) => t4 - e5);
                for (let r4 = e4.length - 1; r4 >= 0; r4--) t3.splice(e4[r4], 1);
              }
            }(a2, o2, t2.json.nodes), a2;
          }
          function Gb(t2) {
            t2.heightmap = new Float32Array(4096), t2.heightmap.fill(-1);
            const e2 = t2.vertexArray.float32, r2 = t2.aabb.min[0] - 1, n2 = t2.aabb.min[1] - 1, i2 = yx / (t2.aabb.max[0] - r2 + 2), s2 = yx / (t2.aabb.max[1] - n2 + 2);
            for (let o2 = 0; o2 < e2.length; o2 += 3) {
              const a2 = e2[o2 + 2], l2 = (e2[o2 + 0] - r2) * i2 | 0, u2 = (e2[o2 + 1] - n2) * s2 | 0;
              a2 > t2.heightmap[u2 * yx + l2] && (t2.heightmap[u2 * yx + l2] = a2);
            }
          }
          function qb(t2, e2) {
            const r2 = {};
            r2.indexArray = new Aa(), r2.indexArray.reserve(4 * t2.length), r2.vertexArray = new ca(), r2.vertexArray.reserve(10 * t2.length), r2.colorArray = new ya(), r2.vertexArray.reserve(10 * t2.length);
            let n2 = 0;
            for (const i3 of t2) {
              const t3 = Math.min(10, Math.max(4, 1.3 * i3.height)) * e2, s3 = [-i3.normal[1], i3.normal[0], 0], o2 = Math.min(0.29, 0.1 * i3.width / i3.depth), a2 = i3.width - 2 * i3.depth * e2 * (o2 + 0.01), l2 = E([], i3.pos, s3, a2 / 2), u2 = E([], i3.pos, s3, -a2 / 2), c2 = [l2[0], l2[1], l2[2] + i3.height], h3 = [u2[0], u2[1], u2[2] + i3.height], p3 = E([], i3.normal, s3, o2);
              P(p3, p3, t3);
              const f2 = E([], i3.normal, s3, -o2);
              P(f2, f2, t3), M(p3, l2, p3), M(f2, u2, f2), l2[2] += 0.1, u2[2] += 0.1, r2.vertexArray.emplaceBack(p3[0], p3[1], p3[2]), r2.vertexArray.emplaceBack(f2[0], f2[1], f2[2]), r2.vertexArray.emplaceBack(l2[0], l2[1], l2[2]), r2.vertexArray.emplaceBack(u2[0], u2[1], u2[2]), r2.vertexArray.emplaceBack(c2[0], c2[1], c2[2]), r2.vertexArray.emplaceBack(h3[0], h3[1], h3[2]), r2.vertexArray.emplaceBack(l2[0], l2[1], l2[2]), r2.vertexArray.emplaceBack(u2[0], u2[1], u2[2]), r2.vertexArray.emplaceBack(p3[0], p3[1], p3[2]), r2.vertexArray.emplaceBack(f2[0], f2[1], f2[2]);
              const d2 = a2 / t3 / 2;
              r2.colorArray.emplaceBack(-d2 - o2, -1, d2, 0.8), r2.colorArray.emplaceBack(d2 + o2, -1, d2, 0.8), r2.colorArray.emplaceBack(-d2, 0, d2, 1.3), r2.colorArray.emplaceBack(d2, 0, d2, 1.3), r2.colorArray.emplaceBack(d2 + o2, -0.8, d2, 0.7), r2.colorArray.emplaceBack(d2 + o2, -0.8, d2, 0.7), r2.colorArray.emplaceBack(0, 0, d2, 1.3), r2.colorArray.emplaceBack(0, 0, d2, 1.3), r2.colorArray.emplaceBack(d2 + o2, -1.2, d2, 0.8), r2.colorArray.emplaceBack(d2 + o2, -1.2, d2, 0.8), r2.indexArray.emplaceBack(6 + n2, 4 + n2, 8 + n2), r2.indexArray.emplaceBack(7 + n2, 9 + n2, 5 + n2), r2.indexArray.emplaceBack(0 + n2, 1 + n2, 2 + n2), r2.indexArray.emplaceBack(1 + n2, 3 + n2, 2 + n2), n2 += 10;
            }
            const i2 = { defined: true };
            i2.emissiveFactor = sr.black;
            const s2 = {};
            return s2.baseColorFactor = sr.white, i2.pbrMetallicRoughness = s2, r2.material = i2, r2.aabb = new qu([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), r2;
          }
          Vb.performDecoding = function(t2, e2) {
            const r2 = new Uint8Array(t2);
            return Promise.all(e2.tasks.map((t3) => {
              const { layerName: e3, firstByte: n2, lastByte: i2, pixelFormat: s2, blockShape: o2, blockIndex: a2, filters: l2, codec: u2 } = t3, c2 = r2.subarray(n2, i2 + 1), h3 = new Uint32Array(o2[0] * o2[1] * o2[2]);
              let p3;
              if ("gzip_data" !== u2) throw new kb(`Unhandled codec: ${u2}`);
              return p3 = function(t4, e4) {
                if (!globalThis.DecompressionStream && "gzip_data" === e4) return Promise.resolve(((s3 = function(t5) {
                  31 == t5[0] && 139 == t5[1] && 8 == t5[2] || Mb(6, "invalid gzip data");
                  var e5 = t5[3], r4 = 10;
                  4 & e5 && (r4 += 2 + (t5[10] | t5[11] << 8));
                  for (var n4 = (e5 >> 3 & 1) + (e5 >> 4 & 1); n4 > 0; n4 -= !t5[r4++]) ;
                  return r4 + (2 & e5);
                }(i3 = t4)) + 8 > i3.length && Mb(6, "invalid gzip data"), function(t5, e5, r4, n4) {
                  var i4 = t5.length;
                  if (!i4 || e5.f && !e5.l) return r4 || new eb(0);
                  var s4 = !r4, o4 = s4 || 2 != e5.i, a4 = e5.i;
                  s4 && (r4 = new eb(3 * i4));
                  var l3, u3, c3 = function(t6) {
                    var e6 = r4.length;
                    if (t6 > e6) {
                      var n5 = new eb(Math.max(2 * e6, t6));
                      n5.set(r4), r4 = n5;
                    }
                  }, h4 = e5.f || 0, p4 = e5.p || 0, f2 = e5.b || 0, d2 = e5.l, m2 = e5.d, y2 = e5.m, g2 = e5.n, x2 = 8 * i4;
                  do {
                    if (!d2) {
                      h4 = wb(t5, p4, 1);
                      var v2 = wb(t5, p4 + 1, 3);
                      if (p4 += 3, !v2) {
                        var b2 = t5[(T2 = 4 + ((p4 + 7) / 8 | 0)) - 4] | t5[T2 - 3] << 8, w2 = T2 + b2;
                        if (w2 > i4) {
                          a4 && Mb(0);
                          break;
                        }
                        o4 && c3(f2 + b2), r4.set(t5.subarray(T2, w2), f2), e5.b = f2 += b2, e5.p = p4 = 8 * w2, e5.f = h4;
                        continue;
                      }
                      if (1 == v2) d2 = xb, m2 = vb, y2 = 9, g2 = 5;
                      else if (2 == v2) {
                        var _2 = wb(t5, p4, 31) + 257, A2 = wb(t5, p4 + 10, 15) + 4, M2 = _2 + wb(t5, p4 + 5, 31) + 1;
                        p4 += 14;
                        for (var I2 = new eb(M2), S2 = new eb(19), z2 = 0; z2 < A2; ++z2) S2[ob[z2]] = wb(t5, p4 + 3 * z2, 7);
                        p4 += 3 * A2;
                        var k2 = bb(S2), P2 = (1 << k2) - 1, E2 = mb(S2, k2);
                        for (z2 = 0; z2 < M2; ) {
                          var T2, B2 = E2[wb(t5, p4, P2)];
                          if (p4 += 15 & B2, (T2 = B2 >> 4) < 16) I2[z2++] = T2;
                          else {
                            var V2 = 0, C2 = 0;
                            for (16 == T2 ? (C2 = 3 + wb(t5, p4, 3), p4 += 2, V2 = I2[z2 - 1]) : 17 == T2 ? (C2 = 3 + wb(t5, p4, 7), p4 += 3) : 18 == T2 && (C2 = 11 + wb(t5, p4, 127), p4 += 7); C2--; ) I2[z2++] = V2;
                          }
                        }
                        var F2 = I2.subarray(0, _2), D2 = I2.subarray(_2);
                        y2 = bb(F2), g2 = bb(D2), d2 = mb(F2, y2), m2 = mb(D2, g2);
                      } else Mb(1);
                      if (p4 > x2) {
                        a4 && Mb(0);
                        break;
                      }
                    }
                    o4 && c3(f2 + 131072);
                    for (var L2 = (1 << y2) - 1, R2 = (1 << g2) - 1, O2 = p4; ; O2 = p4) {
                      var U2 = (V2 = d2[_b(t5, p4) & L2]) >> 4;
                      if ((p4 += 15 & V2) > x2) {
                        a4 && Mb(0);
                        break;
                      }
                      if (V2 || Mb(2), U2 < 256) r4[f2++] = U2;
                      else {
                        if (256 == U2) {
                          O2 = p4, d2 = null;
                          break;
                        }
                        var N2 = U2 - 254;
                        U2 > 264 && (N2 = wb(t5, p4, (1 << (G2 = ib[z2 = U2 - 257])) - 1) + ub[z2], p4 += G2);
                        var j2 = m2[_b(t5, p4) & R2], $2 = j2 >> 4;
                        if (j2 || Mb(3), p4 += 15 & j2, D2 = hb[$2], $2 > 3) {
                          var G2 = sb[$2];
                          D2 += _b(t5, p4) & (1 << G2) - 1, p4 += G2;
                        }
                        if (p4 > x2) {
                          a4 && Mb(0);
                          break;
                        }
                        o4 && c3(f2 + 131072);
                        var q2 = f2 + N2;
                        if (f2 < D2) {
                          var H2 = 0 - D2, X2 = Math.min(D2, q2);
                          for (H2 + f2 < 0 && Mb(3); f2 < X2; ++f2) r4[f2] = (void 0)[H2 + f2];
                        }
                        for (; f2 < q2; ++f2) r4[f2] = r4[f2 - D2];
                      }
                    }
                    e5.l = d2, e5.p = O2, e5.b = f2, e5.f = h4, d2 && (h4 = 1, e5.m = y2, e5.d = m2, e5.n = g2);
                  } while (!h4);
                  return f2 != r4.length && s4 ? (l3 = r4, (null == (u3 = f2) || u3 > l3.length) && (u3 = l3.length), new eb(l3.subarray(0, u3))) : r4.subarray(0, f2);
                }(i3.subarray(s3, -8), { i: 2 }, new eb(((r3 = i3)[(n3 = r3.length) - 4] | r3[n3 - 3] << 8 | r3[n3 - 2] << 16 | r3[n3 - 1] << 24) >>> 0))));
                var r3, n3, i3, s3;
                const o3 = zb[e4];
                if (!o3) throw new Error(`Unhandled codec: ${e4}`);
                const a3 = new globalThis.DecompressionStream(o3);
                return new Response(new Blob([t4]).stream().pipeThrough(a3)).arrayBuffer().then((t5) => new Uint8Array(t5));
              }(c2, u2).then((t4) => (function(t5, e4) {
                t5.readFields(Yv, e4);
              }(new Bb(t4), h3), new (0, Tb[s2])(h3.buffer))), p3.then((t4) => {
                for (let e4 = l2.length - 1; e4 >= 0; e4--) switch (l2[e4]) {
                  case "delta_filter":
                    Jv(t4, o2);
                    break;
                  case "zigzag_filter":
                    Qv(t4);
                    break;
                  case "bitshuffle_filter":
                    tb(t4, s2);
                    break;
                  default:
                    throw new kb(`Unhandled filter "${l2[e4]}"`);
                }
                return { layerName: e3, blockIndex: a2, data: t4 };
              }).catch((t4) => {
                throw t4;
              });
            }));
          }, qs(Fb, "MRTDecodingBatch", { omit: ["_onCancel", "_onComplete"] }), qs(Vb, "MapboxRasterTile"), qs(Cb, "MapboxRasterLayer", { omit: ["_blocksInProgress"] });
          class Hb {
            constructor(t2) {
              this._stringToNumber = {}, this._numberToString = [];
              for (let e2 = 0; e2 < t2.length; e2++) {
                const r2 = t2[e2];
                this._stringToNumber[r2] = e2, this._numberToString[e2] = r2;
              }
            }
            encode(t2) {
              return this._stringToNumber[t2];
            }
            decode(t2) {
              return this._numberToString[t2];
            }
          }
          const Xb = ["id", "tile", "layer", "source", "sourceLayer", "state"];
          class Zb {
            constructor(t2, e2, r2, n2, i2) {
              this.type = "Feature", this._vectorTileFeature = t2, this._z = e2, this._x = r2, this._y = n2, this.properties = t2.properties, this.id = i2;
            }
            clone() {
              const t2 = new Zb(this._vectorTileFeature, this._z, this._x, this._y, this.id);
              return this.state && (t2.state = Object.assign({}, this.state)), this.layer && (t2.layer = Object.assign({}, this.layer)), this.source && (t2.source = this.source), this.sourceLayer && (t2.sourceLayer = this.sourceLayer), t2;
            }
            get geometry() {
              return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(t2) {
              this._geometry = t2;
            }
            toJSON() {
              const t2 = { type: "Feature", state: void 0, geometry: this.geometry, properties: this.properties };
              for (const e2 of Xb) void 0 !== this[e2] && (t2[e2] = this[e2]);
              return t2;
            }
          }
          class Wb {
            constructor(t2, e2) {
              this.tileID = t2, this.x = t2.canonical.x, this.y = t2.canonical.y, this.z = t2.canonical.z, this.grid = new $s(Cn, 16, 0), this.featureIndexArray = new Xa(), this.promoteId = e2, this.is3DTile = false, this.serializedLayersCache = /* @__PURE__ */ new Map();
            }
            insert(t2, e2, r2, n2, i2, s2 = 0, o2 = 0) {
              const a2 = this.featureIndexArray.length;
              this.featureIndexArray.emplaceBack(r2, n2, i2, s2);
              const l2 = this.grid;
              for (let t3 = 0; t3 < e2.length; t3++) {
                const r3 = e2[t3], n3 = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                for (let t4 = 0; t4 < r3.length; t4++) {
                  const e3 = r3[t4];
                  n3[0] = Math.min(n3[0], e3.x), n3[1] = Math.min(n3[1], e3.y), n3[2] = Math.max(n3[2], e3.x), n3[3] = Math.max(n3[3], e3.y);
                }
                0 !== o2 && (n3[0] -= o2, n3[1] -= o2, n3[2] += o2, n3[3] += o2), n3[0] < Cn && n3[1] < Cn && n3[2] >= 0 && n3[3] >= 0 && l2.insert(a2, n3[0], n3[1], n3[2], n3[3]);
              }
            }
            loadVTLayers() {
              if (!this.vtLayers) {
                this.vtLayers = new Pu.VectorTile(new um(this.rawTileData)).layers, this.sourceLayerCoder = new Hb(this.vtLayers ? Object.keys(this.vtLayers).sort() : ["_geojsonTileLayer"]), this.vtFeatures = {};
                for (const t2 in this.vtLayers) this.vtFeatures[t2] = [];
              }
              return this.vtLayers;
            }
            query(t2, e2) {
              const { tilespaceGeometry: r2, transform: n2, tileTransform: i2, pixelPosMatrix: s2, availableImages: o2, worldview: a2 } = e2;
              this.loadVTLayers(), this.serializedLayersCache.clear();
              const l2 = r2.bufferedTilespaceBounds, u2 = this.grid.query(l2.min.x, l2.min.y, l2.max.x, l2.max.y, (t3, e3, n3, i3) => uc(r2.bufferedTilespaceGeometry, t3, e3, n3, i3));
              u2.sort(Kb);
              let c2 = null;
              n2.elevation && u2.length > 0 && (c2 = Mx.create(n2.elevation, this.tileID));
              const h3 = {};
              let p3;
              for (let e3 = 0; e3 < u2.length; e3++) {
                const l3 = u2[e3];
                if (l3 === p3) continue;
                p3 = l3;
                const f2 = this.featureIndexArray.get(l3);
                let d2 = null;
                this.is3DTile ? this.loadMatchingModelFeature(h3, f2, t2, r2, n2, a2) : this.loadMatchingFeature(h3, f2, t2, o2, a2, (t3, e4, o3, a3 = 0) => (d2 || (d2 = yu(t3, this.tileID.canonical, i2)), e4.queryIntersectsFeature(r2, t3, o3, d2, this.z, n2, s2, c2, a3)));
              }
              return h3;
            }
            loadMatchingFeature(t2, e2, r2, n2, i2, s2) {
              const { featureIndex: o2, bucketIndex: a2, sourceLayerIndex: l2, layoutVertexArrayOffset: u2 } = e2, c2 = this.bucketLayerIDs[a2], h3 = r2.layers, p3 = Object.keys(h3);
              if (p3.length && !jt(p3, c2)) return;
              const f2 = r2.sourceCache, d2 = this.sourceLayerCoder.decode(l2), m2 = this.vtLayers[d2].feature(o2), y2 = this.getId(m2, d2);
              for (let e3 = 0; e3 < c2.length; e3++) {
                const r3 = c2[e3];
                if (!h3[r3]) continue;
                const { styleLayer: a3, targets: l3 } = h3[r3];
                let p4 = {};
                void 0 !== y2 && (p4 = f2.getFeatureState(a3.sourceLayer, y2));
                const d3 = !s2 || s2(m2, a3, p4, u2);
                if (!d3) continue;
                const g2 = new Zb(m2, this.z, this.x, this.y, y2);
                g2.tile = this.tileID.canonical, g2.state = p4;
                let x2 = this.serializedLayersCache.get(r3);
                x2 || (x2 = a3.serialize(), x2.id = r3, this.serializedLayersCache.set(r3, x2)), g2.source = x2.source, g2.sourceLayer = x2["source-layer"], g2.layer = Ct({}, x2), g2.layer.paint = Yb(x2.paint, a3.paint, m2, p4, n2), g2.layer.layout = Yb(x2.layout, a3.layout, m2, p4, n2);
                let v2 = false;
                for (const t3 of l3) {
                  this.updateFeatureProperties(g2, t3);
                  const { filter: e4 } = t3;
                  if (e4) {
                    if (m2.properties = g2.properties, e4.needGeometry) {
                      const t4 = gu(m2, true);
                      if (!e4.filter(new go(this.tileID.overscaledZ, { worldview: i2 }), t4, this.tileID.canonical)) continue;
                    } else if (!e4.filter(new go(this.tileID.overscaledZ, { worldview: i2 }), m2)) continue;
                  }
                  v2 = true, t3.targetId && this.addFeatureVariant(g2, t3);
                }
                v2 && this.appendToResult(t2, r3, o2, g2, d3);
              }
            }
            loadMatchingModelFeature(t2, e2, r2, n2, i2, s2) {
              const { featureIndex: o2, bucketIndex: a2 } = e2, l2 = this.bucketLayerIDs[a2], u2 = r2.layers, c2 = Object.keys(u2);
              if (!c2.length || jt(c2, l2)) for (let e3 = 0; e3 < l2.length; e3++) {
                const a3 = l2[e3], { styleLayer: c3, targets: h3 } = u2[a3];
                if ("model" !== c3.type) continue;
                const p3 = n2.tile, f2 = p3.getBucket(c3);
                if (!(f2 && f2 instanceof Tx)) continue;
                const d2 = Dx(f2, o2, n2, i2);
                if (!d2) continue;
                const { z: m2, x: y2, y: g2 } = p3.tileID.canonical, { feature: x2, intersectionZ: v2, position: b2 } = d2;
                let w2 = {};
                void 0 !== x2.id && (w2 = r2.sourceCache.getFeatureState(c3.sourceLayer, x2.id));
                const _2 = new Zb({}, m2, y2, g2, x2.id);
                _2.tile = this.tileID.canonical, _2.state = w2, _2.properties = x2.properties, _2.geometry = { type: "Point", coordinates: [b2.lng, b2.lat] };
                let A2 = this.serializedLayersCache.get(a3);
                A2 || (A2 = c3.serialize(), A2.id = a3, this.serializedLayersCache.set(a3, A2)), _2.source = A2.source, _2.sourceLayer = A2["source-layer"], _2.layer = Ct({}, A2);
                let M2 = false;
                for (const t3 of h3) {
                  this.updateFeatureProperties(_2, t3);
                  const { filter: e4 } = t3;
                  if (e4) {
                    if (x2.properties = _2.properties, e4.needGeometry) {
                      if (!e4.filter(new go(this.tileID.overscaledZ, { worldview: s2 }), x2, this.tileID.canonical)) continue;
                    } else if (!e4.filter(new go(this.tileID.overscaledZ, { worldview: s2 }), x2)) continue;
                  }
                  M2 = true, t3.targetId && this.addFeatureVariant(_2, t3);
                }
                M2 && this.appendToResult(t2, a3, o2, _2, v2);
              }
            }
            updateFeatureProperties(t2, e2, r2) {
              if (e2.properties) {
                const n2 = {};
                for (const i2 in e2.properties) {
                  const s2 = e2.properties[i2].evaluate({ zoom: this.z }, t2._vectorTileFeature, t2.state, t2.tile, r2);
                  null != s2 && (n2[i2] = s2);
                }
                t2.properties = n2;
              }
            }
            addFeatureVariant(t2, e2, r2) {
              const n2 = { target: e2.target, namespace: e2.namespace, uniqueFeatureID: e2.uniqueFeatureID };
              e2.properties && (n2.properties = t2.properties), t2.variants = t2.variants || {}, t2.variants[e2.targetId] = t2.variants[e2.targetId] || [], t2.variants[e2.targetId].push(n2);
            }
            appendToResult(t2, e2, r2, n2, i2) {
              let s2 = t2[e2];
              void 0 === s2 && (s2 = t2[e2] = []), s2.push({ featureIndex: r2, feature: n2, intersectionZ: i2 });
            }
            lookupSymbolFeatures(t2, e2, r2, n2, i2, s2) {
              const o2 = {};
              this.loadVTLayers();
              for (const a2 of t2) this.loadMatchingFeature(o2, { bucketIndex: e2, sourceLayerIndex: r2, featureIndex: a2, layoutVertexArrayOffset: 0 }, n2, i2, s2);
              return o2;
            }
            loadFeature(t2) {
              const { featureIndex: e2, sourceLayerIndex: r2 } = t2;
              this.loadVTLayers();
              const n2 = this.sourceLayerCoder.decode(r2), i2 = this.vtFeatures[n2];
              if (i2[e2]) return i2[e2];
              const s2 = this.vtLayers[n2].feature(e2);
              return i2[e2] = s2, s2;
            }
            hasLayer(t2) {
              for (const e2 of this.bucketLayerIDs) for (const r2 of e2) if (t2 === r2) return true;
              return false;
            }
            getId(t2, e2) {
              let r2 = t2.id;
              if (this.promoteId) {
                const n2 = Array.isArray(this.promoteId) || "object" != typeof this.promoteId ? this.promoteId : this.promoteId[e2];
                if (null != n2) if (Array.isArray(n2)) {
                  if (!this.promoteIdExpression) {
                    const t3 = Cs(n2);
                    if ("success" !== t3.result) {
                      const e3 = t3.value.map((t4) => `${t4.key}: ${t4.message}`).join(", ");
                      return void Gt(`Failed to create expression for promoteId: ${e3}`);
                    }
                    this.promoteIdExpression = t3.value;
                  }
                  this.promoteIdExpression._evaluator || (this.promoteIdExpression._evaluator = new Kr()), r2 = this.promoteIdExpression.evaluate({ zoom: 0 }, t2);
                } else r2 = t2.properties[n2];
                "boolean" == typeof r2 && (r2 = Number(r2));
              }
              return r2;
            }
          }
          function Yb(t2, e2, r2, n2, i2) {
            return Ot(t2, (t3, s2) => {
              const o2 = e2 instanceof Io ? e2.get(s2) : null;
              return o2 && o2.evaluate ? o2.evaluate(r2, n2, void 0, i2) : o2;
            });
          }
          function Kb(t2, e2) {
            return e2 - t2;
          }
          qs(Wb, "FeatureIndex", { omit: ["rawTileData", "sourceLayerCoder"] });
          const Jb = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
          class Qb {
            static from(t2) {
              if (!(t2 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
              const [e2, r2] = new Uint8Array(t2, 0, 2);
              if (219 !== e2) throw new Error("Data does not appear to be in a KDBush format.");
              const n2 = r2 >> 4;
              if (1 !== n2) throw new Error(`Got v${n2} data when expected v1.`);
              const i2 = Jb[15 & r2];
              if (!i2) throw new Error("Unrecognized array type.");
              const [s2] = new Uint16Array(t2, 2, 1), [o2] = new Uint32Array(t2, 4, 1);
              return new Qb(o2, s2, i2, t2);
            }
            constructor(t2, e2 = 64, r2 = Float64Array, n2) {
              if (isNaN(t2) || t2 < 0) throw new Error(`Unpexpected numItems value: ${t2}.`);
              this.numItems = +t2, this.nodeSize = Math.min(Math.max(+e2, 2), 65535), this.ArrayType = r2, this.IndexArrayType = t2 < 65536 ? Uint16Array : Uint32Array;
              const i2 = Jb.indexOf(this.ArrayType), s2 = 2 * t2 * this.ArrayType.BYTES_PER_ELEMENT, o2 = t2 * this.IndexArrayType.BYTES_PER_ELEMENT, a2 = (8 - o2 % 8) % 8;
              if (i2 < 0) throw new Error(`Unexpected typed array class: ${r2}.`);
              n2 && n2 instanceof ArrayBuffer ? (this.data = n2, this.ids = new this.IndexArrayType(this.data, 8, t2), this.coords = new this.ArrayType(this.data, 8 + o2 + a2, 2 * t2), this._pos = 2 * t2, this._finished = true) : (this.data = new ArrayBuffer(8 + s2 + o2 + a2), this.ids = new this.IndexArrayType(this.data, 8, t2), this.coords = new this.ArrayType(this.data, 8 + o2 + a2, 2 * t2), this._pos = 0, this._finished = false, new Uint8Array(this.data, 0, 2).set([219, 16 + i2]), new Uint16Array(this.data, 2, 1)[0] = e2, new Uint32Array(this.data, 4, 1)[0] = t2);
            }
            add(t2, e2) {
              const r2 = this._pos >> 1;
              return this.ids[r2] = r2, this.coords[this._pos++] = t2, this.coords[this._pos++] = e2, r2;
            }
            finish() {
              const t2 = this._pos >> 1;
              if (t2 !== this.numItems) throw new Error(`Added ${t2} items when expected ${this.numItems}.`);
              return tw(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = true, this;
            }
            range(t2, e2, r2, n2) {
              if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
              const { ids: i2, coords: s2, nodeSize: o2 } = this, a2 = [0, i2.length - 1, 0], l2 = [];
              for (; a2.length; ) {
                const u2 = a2.pop() || 0, c2 = a2.pop() || 0, h3 = a2.pop() || 0;
                if (c2 - h3 <= o2) {
                  for (let o3 = h3; o3 <= c2; o3++) {
                    const a3 = s2[2 * o3], u3 = s2[2 * o3 + 1];
                    a3 >= t2 && a3 <= r2 && u3 >= e2 && u3 <= n2 && l2.push(i2[o3]);
                  }
                  continue;
                }
                const p3 = h3 + c2 >> 1, f2 = s2[2 * p3], d2 = s2[2 * p3 + 1];
                f2 >= t2 && f2 <= r2 && d2 >= e2 && d2 <= n2 && l2.push(i2[p3]), (0 === u2 ? t2 <= f2 : e2 <= d2) && (a2.push(h3), a2.push(p3 - 1), a2.push(1 - u2)), (0 === u2 ? r2 >= f2 : n2 >= d2) && (a2.push(p3 + 1), a2.push(c2), a2.push(1 - u2));
              }
              return l2;
            }
            within(t2, e2, r2) {
              if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
              const { ids: n2, coords: i2, nodeSize: s2 } = this, o2 = [0, n2.length - 1, 0], a2 = [], l2 = r2 * r2;
              for (; o2.length; ) {
                const u2 = o2.pop() || 0, c2 = o2.pop() || 0, h3 = o2.pop() || 0;
                if (c2 - h3 <= s2) {
                  for (let r3 = h3; r3 <= c2; r3++) iw(i2[2 * r3], i2[2 * r3 + 1], t2, e2) <= l2 && a2.push(n2[r3]);
                  continue;
                }
                const p3 = h3 + c2 >> 1, f2 = i2[2 * p3], d2 = i2[2 * p3 + 1];
                iw(f2, d2, t2, e2) <= l2 && a2.push(n2[p3]), (0 === u2 ? t2 - r2 <= f2 : e2 - r2 <= d2) && (o2.push(h3), o2.push(p3 - 1), o2.push(1 - u2)), (0 === u2 ? t2 + r2 >= f2 : e2 + r2 >= d2) && (o2.push(p3 + 1), o2.push(c2), o2.push(1 - u2));
              }
              return a2;
            }
          }
          function tw(t2, e2, r2, n2, i2, s2) {
            if (i2 - n2 <= r2) return;
            const o2 = n2 + i2 >> 1;
            ew(t2, e2, o2, n2, i2, s2), tw(t2, e2, r2, n2, o2 - 1, 1 - s2), tw(t2, e2, r2, o2 + 1, i2, 1 - s2);
          }
          function ew(t2, e2, r2, n2, i2, s2) {
            for (; i2 > n2; ) {
              if (i2 - n2 > 600) {
                const o3 = i2 - n2 + 1, a3 = r2 - n2 + 1, l3 = Math.log(o3), u2 = 0.5 * Math.exp(2 * l3 / 3), c2 = 0.5 * Math.sqrt(l3 * u2 * (o3 - u2) / o3) * (a3 - o3 / 2 < 0 ? -1 : 1);
                ew(t2, e2, r2, Math.max(n2, Math.floor(r2 - a3 * u2 / o3 + c2)), Math.min(i2, Math.floor(r2 + (o3 - a3) * u2 / o3 + c2)), s2);
              }
              const o2 = e2[2 * r2 + s2];
              let a2 = n2, l2 = i2;
              for (rw(t2, e2, n2, r2), e2[2 * i2 + s2] > o2 && rw(t2, e2, n2, i2); a2 < l2; ) {
                for (rw(t2, e2, a2, l2), a2++, l2--; e2[2 * a2 + s2] < o2; ) a2++;
                for (; e2[2 * l2 + s2] > o2; ) l2--;
              }
              e2[2 * n2 + s2] === o2 ? rw(t2, e2, n2, l2) : (l2++, rw(t2, e2, l2, i2)), l2 <= r2 && (n2 = l2 + 1), r2 <= l2 && (i2 = l2 - 1);
            }
          }
          function rw(t2, e2, r2, n2) {
            nw(t2, r2, n2), nw(e2, 2 * r2, 2 * n2), nw(e2, 2 * r2 + 1, 2 * n2 + 1);
          }
          function nw(t2, e2, r2) {
            const n2 = t2[e2];
            t2[e2] = t2[r2], t2[r2] = n2;
          }
          function iw(t2, e2, r2, n2) {
            const i2 = t2 - r2, s2 = e2 - n2;
            return i2 * i2 + s2 * s2;
          }
          t.$ = Jr, t.A = Ye, t.B = Fr, t.C = Xo, t.D = Df, t.E = tr, t.F = 2, t.G = Zm, t.H = Hm, t.I = er, t.J = Xr, t.K = class extends ux {
          }, t.L = pr, t.M = To, t.N = As, t.O = bs, t.P = bt, t.Q = _s, t.R = Be, t.S = Vs, t.T = Pg, t.U = Bo, t.V = ux, t.W = Ls, t.X = Cs, t.Y = pi, t.Z = di, t._ = hi, t.a = function(t2) {
            return ne.API_CDN_URL_REGEX.test(t2);
          }, t.a$ = Dt, t.a0 = ir, t.a1 = Vo, t.a2 = Ms, t.a3 = ws, t.a4 = function(t2) {
            const e2 = t2.value;
            let r2 = [];
            if (!e2) return r2;
            const n2 = Xr(e2);
            return "string" !== n2 ? (r2 = r2.concat([new ux(t2.key, e2, `string expected, "${n2}" found`)]), r2) : (cx(e2, true) || (r2 = r2.concat([new ux(t2.key, e2, `invalid url "${e2}"`)])), r2);
          }, t.a5 = Eo, t.a6 = bo, t.a7 = Po, t.a8 = So, t.a9 = class {
            constructor(t2) {
              this.specification = t2;
            }
            possiblyEvaluate(t2, e2) {
              return Xt(t2.expression.evaluate(e2));
            }
            interpolate(t2, e2, r2) {
              return { x: ur(t2.x, e2.x, r2), y: ur(t2.y, e2.y, r2), z: ur(t2.z, e2.z, r2), azimuthal: ur(t2.azimuthal, e2.azimuthal, r2), polar: ur(t2.polar, e2.polar, r2) };
            }
          }, t.aA = Z, t.aB = Cl, t.aC = lc, t.aD = Kl, t.aE = cu, t.aF = function(t2, e2) {
            const r2 = {};
            for (let n2 = 0; n2 < e2.length; n2++) {
              const i2 = e2[n2];
              i2 in t2 && (r2[i2] = t2[i2]);
            }
            return r2;
          }, t.aG = Xl, t.aH = Jl, t.aI = class {
            constructor(t2) {
              this.entries = {}, this.scheduler = t2;
            }
            request(t2, e2, r2, n2) {
              const i2 = this.entries[t2] = this.entries[t2] || { callbacks: [] };
              if (i2.result) {
                const [t3, r3] = i2.result;
                return this.scheduler ? this.scheduler.add(() => {
                  n2(t3, r3);
                }, e2) : n2(t3, r3), () => {
                };
              }
              return i2.callbacks.push(n2), i2.cancel || (i2.cancel = r2((r3, n3) => {
                i2.result = [r3, n3];
                for (const t3 of i2.callbacks) this.scheduler ? this.scheduler.add(() => {
                  t3(r3, n3);
                }, e2) : t3(r3, n3);
                setTimeout(() => delete this.entries[t2], 3e3);
              })), () => {
                i2.result || (i2.callbacks = i2.callbacks.filter((t3) => t3 !== n2), i2.callbacks.length || (i2.cancel(), delete this.entries[t2]));
              };
            }
          }, t.aJ = function(t2, e2, r2) {
            const n2 = JSON.stringify(t2.request);
            return t2.data && (this.deduped.entries[n2] = { result: [null, t2.data] }), this.deduped.request(n2, { type: "parseTile", isSymbolTile: t2.isSymbolTile, zoom: t2.tileZoom }, (e3) => {
              const n3 = De(t2.request, (t3, n4, i2, s2) => {
                t3 ? e3(t3) : n4 && e3(null, { vectorTile: r2 ? void 0 : new Pu.VectorTile(new um(n4)), rawData: n4, cacheControl: i2, expires: s2 });
              });
              return () => {
                n3.cancel(), e3();
              };
            }, e2);
          }, t.aK = function(t2) {
            Me++, Me > xe && (t2.getActor().send("enforceCacheSizeLimit", ge), Me = 0);
          }, t.aL = function(t2) {
            return t2 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(t2) / Math.LN2));
          }, t.aM = _c, t.aN = Dg, t.aO = jg, t.aP = Cg, t.aQ = function(t2, e2) {
            const r2 = document.createElement("video");
            r2.muted = true, r2.onloadstart = function() {
              e2(null, r2);
            };
            for (let e3 = 0; e3 < t2.length; e3++) {
              const n2 = document.createElement("source");
              Le(t2[e3]) || (r2.crossOrigin = "Anonymous"), n2.src = t2[e3], r2.appendChild(n2);
            }
            return { cancel: () => {
            } };
          }, t.aR = Eg, t.aS = function(t2) {
            return fetch(t2).then((t3) => t3.arrayBuffer()).then((e2) => pd(e2, 0, t2));
          }, t.aT = $b, t.aU = class {
            constructor(t2, e2, r2, n2) {
              this.id = t2, this.position = null != e2 ? new Hl(e2[0], e2[1]) : new Hl(0, 0), this.orientation = null != r2 ? r2 : [0, 0, 0], this.nodes = n2, this.uploaded = false, this.aabb = new qu([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), this.matrix = [];
            }
            _applyTransformations(t2, e2) {
              if (c(t2.matrix, e2, t2.matrix), t2.meshes) for (const e3 of t2.meshes) {
                const r2 = qu.applyTransformFast(e3.aabb, t2.matrix);
                this.aabb.encapsulate(r2);
              }
              if (t2.children) for (const e3 of t2.children) this._applyTransformations(e3, t2.matrix);
            }
            computeBoundsAndApplyParent() {
              const t2 = l([]);
              for (const e2 of this.nodes) this._applyTransformations(e2, t2);
            }
            computeModelMatrix(t2, e2, r2, n2, i2, s2, o2 = false) {
              xx(this.matrix, this, t2.transform, this.position, e2, r2, n2, i2, s2, o2);
            }
            upload(t2) {
              if (!this.uploaded) {
                for (const e2 of this.nodes) wx(e2, t2);
                for (const t3 of this.nodes) _x(t3);
                this.uploaded = true;
              }
            }
            destroy() {
              for (const t2 of this.nodes) Ax(t2);
            }
          }, t.aV = Rt, t.aW = Dy, t.aX = tu, t.aY = eu, t.aZ = ia, t.a_ = Aa, t.aa = go, t.ab = Ds, t.ac = lu, t.ad = R, t.ae = _, t.af = Tt, t.ag = Io, t.ah = Zc, t.ai = ur, t.aj = Cn, t.ak = cr, t.al = Mt, t.am = sr, t.an = class {
            constructor(t2) {
              this.specification = t2;
            }
            possiblyEvaluate(t2, e2) {
              return function([t3, e3]) {
                const r2 = Xt([1, t3, e3]);
                return { x: r2.x, y: r2.y, z: r2.z };
              }(t2.expression.evaluate(e2));
            }
            interpolate(t2, e2, r2) {
              return { x: ur(t2.x, e2.x, r2), y: ur(t2.y, e2.y, r2), z: ur(t2.z, e2.z, r2) };
            }
          }, t.ao = function(t2, e2, r2 = 0, n2 = true) {
            const i2 = new bt(r2, r2), s2 = t2.sub(i2), o2 = e2.add(i2), a2 = [s2, new bt(o2.x, s2.y), o2, new bt(s2.x, o2.y)];
            return n2 && a2.push(s2.clone()), a2;
          }, t.ap = function(t2, e2) {
            const r2 = [];
            for (let n2 = 0; n2 < t2.length; n2++) {
              const i2 = Bt(n2 - 1, -1, t2.length - 1), s2 = Bt(n2 + 1, -1, t2.length - 1), o2 = t2[n2], a2 = t2[s2], l2 = t2[i2].sub(o2).unit(), u2 = a2.sub(o2).unit(), c2 = u2.angleWithSep(l2.x, l2.y), h3 = l2.add(u2).unit().mult(-1 * e2 / Math.sin(c2 / 2));
              r2.push(o2.add(h3));
            }
            return r2;
          }, t.aq = Ly, t.ar = uc, t.as = function(t2, e2, r2 = 0) {
            return A(((e2.x - r2) * t2.scale - t2.x) * Cn, (e2.y * t2.scale - t2.y) * Cn, ru(e2.z, e2.y));
          }, t.at = j, t.au = C, t.av = Ru, t.aw = Td, t.ax = function(t2) {
            let e2 = 1 / 0, r2 = 1 / 0, n2 = -1 / 0, i2 = -1 / 0;
            for (const s2 of t2) e2 = Math.min(e2, s2.x), r2 = Math.min(r2, s2.y), n2 = Math.max(n2, s2.x), i2 = Math.max(i2, s2.y);
            return { min: new bt(e2, r2), max: new bt(n2, i2) };
          }, t.ay = Et, t.az = c, t.b = function(t2) {
            return ne.API_FONTS_REGEX.test(t2);
          }, t.b$ = function(t2, e2, r2) {
            r2 *= 0.5;
            var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = e2[3], a2 = Math.sin(r2), l2 = Math.cos(r2);
            return t2[0] = n2 * l2 + i2 * a2, t2[1] = i2 * l2 - n2 * a2, t2[2] = s2 * l2 + o2 * a2, t2[3] = o2 * l2 - s2 * a2, t2;
          }, t.b0 = Oa, t.b1 = mg, t.b2 = function() {
            yo.isLoading() || yo.isLoaded() || "deferred" !== fo() || mo();
          }, t.b3 = Co, t.b4 = gu, t.b5 = Zb, t.b6 = Wt, t.b7 = zd, t.b8 = fp, t.b9 = yu, t.bA = function(t2, e2) {
            const { x: r2, y: n2 } = t2.point, i2 = Xc(r2, n2, t2.worldSize / t2._pixelsPerMercatorPixel, 0, 0);
            return c(i2, i2, Gc(Cc(e2)));
          }, t.bB = n, t.bC = function(t2) {
            return t2[0] = 0, t2[1] = 0, t2[2] = 0, t2;
          }, t.bD = function(t2, e2) {
            return Math.hypot(e2[0] - t2[0], e2[1] - t2[1], e2[2] - t2[2]);
          }, t.bE = E, t.bF = D, t.bG = F, t.bH = Lm, t.bI = mm, t.bJ = Dm, t.bK = function(t2, e2, r2, n2, i2) {
            const s2 = 5 * e2 + 2;
            t2.float32[s2 + 0] = r2, t2.float32[s2 + 1] = n2, t2.float32[s2 + 2] = i2;
          }, t.bL = hg, t.bM = Mf, t.bN = Ku, t.bO = Jd, t.bP = Pp, t.bQ = lx, t.bR = Rp, t.bS = Op, t.bT = Sm, t.bU = gy, t.bV = Iy, t.bW = Qb, t.bX = Bt, t.bY = P, t.bZ = G, t.b_ = Y, t.ba = ra, t.bb = Va, t.bc = kc, t.bd = tl, t.be = Ah, t.bf = Sg, t.bg = function(t2, e2) {
            const r2 = Zc(e2.zoom);
            if (0 === r2) return Cc(t2);
            const n2 = Rc(t2), i2 = Oc(n2), s2 = Kl(n2.getWest()) * e2.worldSize, o2 = Kl(n2.getEast()) * e2.worldSize, a2 = Jl(n2.getNorth()) * e2.worldSize, l2 = Jl(n2.getSouth()) * e2.worldSize, c2 = [s2, a2, 0], h3 = [o2, a2, 0], p3 = [s2, l2, 0], f2 = [o2, l2, 0], d2 = u([], e2.globeMatrix);
            return R(c2, c2, d2), R(h3, h3, d2), R(p3, p3, d2), R(f2, f2, d2), i2[0] = Fc(i2[0], p3, r2), i2[1] = Fc(i2[1], f2, r2), i2[2] = Fc(i2[2], h3, r2), i2[3] = Fc(i2[3], c2, r2), qu.fromPoints(i2);
          }, t.bh = $c, t.bi = u, t.bj = Uc, t.bk = Fc, t.bl = na, t.bm = zc, t.bn = y, t.bo = h2, t.bp = Vb, t.bq = um, t.br = De, t.bs = function(t2, e2) {
            const r2 = [];
            for (const n2 in t2) n2 in e2 || r2.push(n2);
            return r2;
          }, t.bt = Vt, t.bu = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"], t.bv = wt, t.bw = function(t2) {
            var e2 = new r(16);
            return e2[0] = t2[0], e2[1] = t2[1], e2[2] = t2[2], e2[3] = t2[3], e2[4] = t2[4], e2[5] = t2[5], e2[6] = t2[6], e2[7] = t2[7], e2[8] = t2[8], e2[9] = t2[9], e2[10] = t2[10], e2[11] = t2[11], e2[12] = t2[12], e2[13] = t2[13], e2[14] = t2[14], e2[15] = t2[15], e2;
          }, t.bx = l, t.by = m, t.bz = a, t.c = se, t.c$ = Of, t.c0 = K, t.c1 = Kt, t.c2 = function(t2, e2) {
            return t2[0] = -e2[0], t2[1] = -e2[1], t2[2] = -e2[2], t2[3] = e2[3], t2;
          }, t.c3 = x, t.c4 = function(t2, e2, r2, n2, i2) {
            var s2, o2 = 1 / Math.tan(e2 / 2);
            return t2[0] = o2 / r2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = o2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[11] = -1, t2[12] = 0, t2[13] = 0, t2[15] = 0, null != i2 && i2 !== 1 / 0 ? (t2[10] = (i2 + n2) * (s2 = 1 / (n2 - i2)), t2[14] = 2 * i2 * n2 * s2) : (t2[10] = -1, t2[14] = -2 * n2), t2;
          }, t.c5 = function(t2, e2, r2, n2, i2, s2, o2) {
            var a2 = 1 / (e2 - r2), l2 = 1 / (n2 - i2), u2 = 1 / (s2 - o2);
            return t2[0] = -2 * a2, t2[1] = 0, t2[2] = 0, t2[3] = 0, t2[4] = 0, t2[5] = -2 * l2, t2[6] = 0, t2[7] = 0, t2[8] = 0, t2[9] = 0, t2[10] = 2 * u2, t2[11] = 0, t2[12] = (e2 + r2) * a2, t2[13] = (i2 + n2) * l2, t2[14] = (o2 + s2) * u2, t2[15] = 1, t2;
          }, t.c6 = Ql, t.c7 = function(t2, e2, r2) {
            t2[4 * e2 + 0] = r2[0], t2[4 * e2 + 1] = r2[1], t2[4 * e2 + 2] = r2[2], t2[4 * e2 + 3] = r2[3];
          }, t.c8 = cl, t.c9 = fl, t.cA = Xg, t.cB = v, t.cC = qg, t.cD = function(t2) {
            const e2 = qg(t2, true);
            return n([], [e2[0], e2[1], e2[4], e2[5]]);
          }, t.cE = p2, t.cF = Ou, t.cG = f, t.cH = function(t2) {
            const { x: e2, y: r2 } = t2.point, { lng: n2, lat: i2 } = t2._center;
            return Xc(e2, r2, t2.worldSize, n2, i2);
          }, t.cI = S, t.cJ = It, t.cK = Ac, t.cL = Fl, t.cM = function(t2, e2, r2) {
            let n2 = 0;
            for (let r3 = 0; r3 < 2; ++r3) {
              const i2 = 0;
              t2[r3] > i2 && (n2 += (t2[r3] - i2) * (t2[r3] - i2)), e2[r3] < i2 && (n2 += (i2 - e2[r3]) * (i2 - e2[r3]));
            }
            return n2;
          }, t.cN = function(t2) {
            return t2 * t2 * t2 * t2 * t2;
          }, t.cO = Yl, t.cP = 45, t.cQ = dl, t.cR = function(t2, e2, r2) {
            const n2 = Math.sqrt(t2 * t2 + e2 * e2 + r2 * r2), i2 = n2 > 0 ? Math.acos(r2 / n2) * At : 0;
            let s2 = 0 !== t2 || 0 !== e2 ? Math.atan2(-e2, -t2) * At + 90 : 0;
            return s2 < 0 && (s2 += 360), [n2, s2, i2];
          }, t.cS = A, t.cT = Xt, t.cU = au, t.cV = M, t.cW = qu, t.cX = I, t.cY = function(t2) {
            return [Math.pow(t2[0], 1 / 2.2), Math.pow(t2[1], 1 / 2.2), Math.pow(t2[2], 1 / 2.2)];
          }, t.cZ = cx, t.c_ = function(t2, e2) {
            return t2.readFields(qx, { icons: [] }, e2);
          }, t.ca = hl, t.cb = pl, t.cc = gl, t.cd = Hl, t.ce = ig, t.cf = function() {
            var t2 = new r(4);
            return r != Float32Array && (t2[1] = 0, t2[2] = 0), t2[0] = 1, t2[3] = 1, t2;
          }, t.cg = function(t2, e2, r2) {
            var n2 = e2[0], i2 = e2[1], s2 = e2[2], o2 = e2[3], a2 = Math.sin(r2), l2 = Math.cos(r2);
            return t2[0] = n2 * l2 + s2 * a2, t2[1] = i2 * l2 + o2 * a2, t2[2] = n2 * -a2 + s2 * l2, t2[3] = i2 * -a2 + o2 * l2, t2;
          }, t.ch = function(t2, e2) {
            return t2[0] === e2[0] && t2[1] === e2[1] && t2[2] === e2[2] && t2[3] === e2[3];
          }, t.ci = N, t.cj = function(t2) {
            return Math.hypot(t2[0], t2[1], t2[2], t2[3]);
          }, t.ck = it, t.cl = U, t.cm = wc, t.cn = Gu, t.co = Hg, t.cp = bc, t.cq = Lc, t.cr = function(t2, e2, r2, n2, i2, s2, o2, a2, l2) {
            if ("globe" === l2.name) return Lc(t2, e2, new bc(r2, n2, i2), false);
            const u2 = Dy({ z: r2, x: n2, y: i2 }, l2);
            return new qu([(s2 + u2.x / u2.scale) * e2, e2 * (u2.y / u2.scale), o2], [(s2 + u2.x2 / u2.scale) * e2, e2 * (u2.y2 / u2.scale), a2]);
          }, t.cs = function(t2, e2, r2) {
            return t2[0] = Math.min(e2[0], r2[0]), t2[1] = Math.min(e2[1], r2[1]), t2[2] = Math.min(e2[2], r2[2]), t2[3] = Math.min(e2[3], r2[3]), t2;
          }, t.ct = function(t2, e2, r2) {
            return t2[0] = Math.max(e2[0], r2[0]), t2[1] = Math.max(e2[1], r2[1]), t2[2] = Math.max(e2[2], r2[2]), t2[3] = Math.max(e2[3], r2[3]), t2;
          }, t.cu = function(t2) {
            const e2 = Math.round((t2 + 45 + 360) % 360 / 90) % 4;
            return St[e2];
          }, t.cv = nu, t.cw = H, t.cx = Dl, t.cy = function(t2) {
            const e2 = l(new Float64Array(16));
            c(e2, t2.pixelMatrix, t2.globeMatrix);
            const r2 = [0, Ul, 0], n2 = [0, Nl, 0];
            return R(r2, r2, e2), R(n2, n2, e2), [r2[0] > 0 && r2[0] <= t2.width && r2[1] > 0 && r2[1] <= t2.height && !Yc(t2, new Hl(t2.center.lat, 90)), n2[0] > 0 && n2[0] <= t2.width && n2[1] > 0 && n2[1] <= t2.height && !Yc(t2, new Hl(t2.center.lat, -90))];
          }, t.cz = function(t2, e2) {
            const { scale: r2 } = t2.tileTransform, n2 = r2 * Cn / (t2.tileSize * Math.pow(2, e2.zoom - t2.tileID.overscaledZ + t2.tileID.canonical.z));
            return function(t3, e3, r3) {
              var n3 = e3[1], i2 = e3[2], s2 = e3[3], o2 = r3[0], a2 = r3[1];
              return t3[0] = e3[0] * o2, t3[1] = n3 * o2, t3[2] = i2 * a2, t3[3] = s2 * a2, t3;
            }(new Float32Array(4), e2.inverseAdjustmentMatrix, [n2, n2]);
          }, t.d = function(t2) {
            return ne.API_TILEJSON_REGEX.test(t2);
          }, t.d$ = Da, t.d0 = ry, t.d1 = ey, t.d2 = Ce, t.d3 = co, t.d4 = me, t.d5 = We, t.d6 = Nt, t.d7 = function(t2) {
            const e2 = t2.indexOf(Ho);
            return e2 >= 0 ? t2.slice(0, e2) : t2;
          }, t.d8 = function(t2) {
            return t2.indexOf(Ho) >= 0;
          }, t.d9 = function(t2) {
            const e2 = t2.lastIndexOf(Ho);
            return e2 >= 0 ? t2.slice(e2 + 1) : "";
          }, t.dA = Hc, t.dB = te, t.dC = ee, t.dD = 256, t.dE = function(t2, e2) {
            const r2 = [0, 0, 0];
            return R(r2, r2, $c(Cc(e2.canonical))), R(r2, r2, t2), r2;
          }, t.dF = (t2) => ({ u_matrix: new gl(t2), u_texsize: new pl(t2), u_pixels_to_tile_units: new bl(t2), u_device_pixel_ratio: new hl(t2), u_width_scale: new hl(t2), u_floor_width_scale: new hl(t2), u_image: new cl(t2), u_units_to_pixels: new pl(t2), u_tile_units_to_pixels: new hl(t2), u_alpha_discard_threshold: new hl(t2), u_trim_offset: new pl(t2), u_trim_fade_range: new pl(t2), u_trim_color: new dl(t2), u_emissive_strength: new hl(t2), u_zbias_factor: new hl(t2), u_tile_to_meter: new hl(t2), u_ground_shadow_factor: new fl(t2), u_pattern_transition: new hl(t2) }), t.dG = (t2) => ({ u_matrix: new gl(t2), u_pixels_to_tile_units: new bl(t2), u_device_pixel_ratio: new hl(t2), u_width_scale: new hl(t2), u_floor_width_scale: new hl(t2), u_units_to_pixels: new pl(t2), u_dash_image: new cl(t2), u_gradient_image: new cl(t2), u_image_height: new hl(t2), u_texsize: new pl(t2), u_tile_units_to_pixels: new hl(t2), u_alpha_discard_threshold: new hl(t2), u_trim_offset: new pl(t2), u_trim_fade_range: new pl(t2), u_trim_color: new dl(t2), u_emissive_strength: new hl(t2), u_zbias_factor: new hl(t2), u_tile_to_meter: new hl(t2), u_ground_shadow_factor: new fl(t2) }), t.dH = (t2) => ({ u_camera_to_center_distance: new hl(t2), u_extrude_scale: new bl(t2), u_device_pixel_ratio: new hl(t2), u_matrix: new gl(t2), u_inv_rot_matrix: new gl(t2), u_merc_center: new pl(t2), u_tile_id: new fl(t2), u_zoom_transition: new hl(t2), u_up_dir: new fl(t2), u_emissive_strength: new hl(t2) }), t.dI = wa, t.dJ = Kd, t.dK = eh, t.dL = (t2, e2, r2, n2, i2, s2) => {
            const o2 = t2.transform, a2 = "globe" === o2.projection.name;
            let l2;
            if ("map" === s2.paint.get("circle-pitch-alignment")) if (a2) {
              const t3 = Hc(o2.zoom, e2.canonical) * o2._pixelsPerMercatorPixel;
              l2 = Float32Array.from([t3, 0, 0, t3]);
            } else l2 = o2.calculatePixelsToTileUnitsMatrix(r2);
            else l2 = new Float32Array([o2.pixelsToGLUnits[0], 0, 0, o2.pixelsToGLUnits[1]]);
            const u2 = { u_camera_to_center_distance: t2.transform.getCameraToCenterDistance(o2.projection), u_matrix: t2.translatePosMatrix(e2.projMatrix, r2, s2.paint.get("circle-translate"), s2.paint.get("circle-translate-anchor")), u_device_pixel_ratio: fe.devicePixelRatio, u_extrude_scale: l2, u_inv_rot_matrix: th, u_merc_center: [0, 0], u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_up_dir: [0, 0, 0], u_emissive_strength: s2.paint.get("circle-emissive-strength") };
            if (a2) {
              u2.u_inv_rot_matrix = n2, u2.u_merc_center = i2, u2.u_tile_id = [e2.canonical.x, e2.canonical.y, 1 << e2.canonical.z], u2.u_zoom_transition = Zc(o2.zoom);
              const t3 = i2[0] * Cn, r3 = i2[1] * Cn;
              u2.u_up_dir = o2.projection.upVector(new bc(0, 0, 0), t3, r3);
            }
            return u2;
          }, t.dM = Fd, t.dN = Dr, t.dO = (t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) => {
            const c2 = t2.transform, h3 = c2.pitch < 15 ? Bd(0.07, 0.7, Et((14 - c2.zoom) / 5, 0, 1)) : 0.07, p3 = "none" === r2.paint.get("line-trim-color-use-theme").constantOr("default");
            return { u_matrix: Cd(t2, e2, r2, n2), u_texsize: e2.imageAtlasTexture ? e2.imageAtlasTexture.size : [0, 0], u_pixels_to_tile_units: c2.calculatePixelsToTileUnitsMatrix(e2), u_device_pixel_ratio: i2, u_width_scale: s2, u_floor_width_scale: o2, u_image: 0, u_tile_units_to_pixels: Vd(e2, c2), u_units_to_pixels: [1 / c2.pixelsToGLUnits[0], 1 / c2.pixelsToGLUnits[1]], u_alpha_discard_threshold: 0, u_trim_offset: a2, u_trim_fade_range: r2.paint.get("line-trim-fade-range"), u_trim_color: r2.paint.get("line-trim-color").toPremultipliedRenderColor(p3 ? null : r2.lut).toArray01(), u_emissive_strength: r2.paint.get("line-emissive-strength"), u_zbias_factor: h3, u_tile_to_meter: au(e2.tileID.canonical, 0), u_ground_shadow_factor: l2, u_pattern_transition: u2 };
          }, t.dP = (t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) => {
            const c2 = t2.transform, h3 = c2.calculatePixelsToTileUnitsMatrix(e2), p3 = "none" === r2.paint.get("line-trim-color-use-theme").constantOr("default"), f2 = c2.pitch < 15 ? Bd(0.07, 0.7, Et((14 - c2.zoom) / 5, 0, 1)) : 0.07;
            return { u_matrix: Cd(t2, e2, r2, n2), u_pixels_to_tile_units: h3, u_device_pixel_ratio: s2, u_width_scale: o2, u_floor_width_scale: a2, u_units_to_pixels: [1 / c2.pixelsToGLUnits[0], 1 / c2.pixelsToGLUnits[1]], u_dash_image: 0, u_gradient_image: 1, u_image_height: i2, u_texsize: Dd(r2) && e2.lineAtlasTexture ? e2.lineAtlasTexture.size : [0, 0], u_tile_units_to_pixels: Vd(e2, t2.transform), u_alpha_discard_threshold: 0, u_trim_offset: l2, u_trim_fade_range: r2.paint.get("line-trim-fade-range"), u_trim_color: r2.paint.get("line-trim-color").toPremultipliedRenderColor(p3 ? null : r2.lut).toArray01(), u_emissive_strength: r2.paint.get("line-emissive-strength"), u_zbias_factor: f2, u_tile_to_meter: au(e2.tileID.canonical, 0), u_ground_shadow_factor: u2 };
          }, t.dQ = Lt, t.dR = xh, t.dS = ru, t.dT = Mc, t.dU = af, t.dV = mf, t.dW = Zp, t.dX = 450, t.dY = 7, t.dZ = Fg, t.d_ = ta, t.da = function(t2) {
            const e2 = [], r2 = t2.id;
            return void 0 === r2 && e2.push({ message: `layers.${r2}: missing required property "id"` }), void 0 === t2.render && e2.push({ message: `layers.${r2}: missing required method "render"` }), t2.renderingMode && "2d" !== t2.renderingMode && "3d" !== t2.renderingMode && e2.push({ message: `layers.${r2}: property "renderingMode" must be either "2d" or "3d"` }), e2;
          }, t.db = function(t2, e2, r2, n2) {
            return "custom" === t2.type ? new $g(t2, e2) : new Lx[t2.type](t2, e2, r2, n2);
          }, t.dc = Ut, t.dd = function(t2) {
            const e2 = t2.indexOf(Ho);
            return e2 >= 0 ? t2.slice(e2 + 1) : "";
          }, t.de = class extends Zb {
            constructor(t2, e2) {
              super(t2._vectorTileFeature, t2._z, t2._x, t2._y, t2.id), t2.state && (this.state = Object.assign({}, t2.state)), this.target = e2.target, this.namespace = e2.namespace, e2.properties && (this.properties = e2.properties), this.target && ("featuresetId" in this.target && !this.target.importId || "layerId" in this.target) && (this.source = t2.source, this.sourceLayer = t2.sourceLayer, this.layer = t2.layer);
            }
            toJSON() {
              const t2 = super.toJSON();
              return t2.target = this.target, t2.namespace = this.namespace, t2;
            }
          }, t.df = po, t.dg = Fe, t.dh = function(t2) {
            return t2({ pluginStatus: lo, pluginURL: uo }), po.on("pluginStateChange", t2), t2;
          }, t.di = ml, t.dj = class extends ul {
            constructor(t2) {
              super(t2), this.current = xl;
            }
            set(t2, e2, r2) {
              if (this.fetchUniformLocation(t2, e2)) {
                for (let t3 = 0; t3 < 9; t3++) if (r2[t3] !== this.current[t3]) {
                  this.current = r2, this.gl.uniformMatrix3fv(this.location, false, r2);
                  break;
                }
              }
            }
          }, t.dk = zt, t.dl = function(t2, e2, r2) {
            const n2 = Zc(r2.zoom), i2 = t2.style.map._antialias, s2 = t2.terrain && t2.terrain.exaggeration() > 0;
            return 0 === n2 && !i2 && !s2;
          }, t.dm = function(t2) {
            const e2 = t2.pixelsPerMeter, r2 = e2 / Ql(1, t2.center.lat), n2 = l(new Float64Array(16));
            return h2(n2, n2, [t2.point.x, t2.point.y, 0]), p2(n2, n2, [r2, r2, e2]), Float32Array.from(n2);
          }, t.dn = Rc, t.dp = function(t2) {
            const e2 = nu - 5;
            t2 = Et(t2, -80.051129, e2) / e2 * 90;
            const r2 = Math.pow(Math.abs(Math.sin(Mt(t2))), 3);
            return Math.round(r2 * (Ol.length - 1));
          }, t.dq = function(t2, e2, r2, n2) {
            const i2 = e2.getNorth(), s2 = e2.getSouth(), a2 = e2.getWest(), l2 = e2.getEast(), u2 = 1 << t2.z, c2 = l2 - a2, h3 = i2 - s2, p3 = c2 / Rl, f2 = -h3 / Ol[r2], d2 = [0, p3, 0, f2, 0, 0, i2, a2, 0];
            if (t2.z > 0) {
              const t3 = 180 / n2;
              o(d2, d2, [t3 / c2 + 1, 0, 0, 0, t3 / h3 + 1, 0, -0.5 * t3 / p3, 0.5 * t3 / f2, 1]);
            }
            return d2[2] = u2, d2[5] = t2.x, d2[8] = t2.y, d2;
          }, t.dr = Cc, t.ds = function(t2, e2, r2) {
            const n2 = l(new Float64Array(16)), i2 = (e2 / (1 << t2) - 0.5) * Math.PI * 2;
            return d(n2, r2.globeMatrix, i2), Float32Array.from(n2);
          }, t.dt = class {
            isDataAvailableAtPoint(t2) {
              const e2 = this._source();
              if (this.isUsingMockSource() || !e2 || t2.y < 0 || t2.y > 1) return false;
              const r2 = e2.getSource().maxzoom, n2 = 1 << r2, i2 = Math.floor(t2.x), s2 = Math.floor((t2.x - i2) * n2), o2 = Math.floor(t2.y * n2), a2 = this.findDEMTileFor(new _c(r2, i2, r2, s2, o2));
              return !(!a2 || !a2.dem);
            }
            getAtPointOrZero(t2, e2 = 0) {
              return this.getAtPoint(t2, e2) || 0;
            }
            getAtPoint(t2, e2, r2 = true) {
              if (this.isUsingMockSource()) return null;
              null == e2 && (e2 = null);
              const n2 = this._source();
              if (!n2) return e2;
              if (t2.y < 0 || t2.y > 1) return e2;
              const i2 = n2.getSource().maxzoom, s2 = 1 << i2, o2 = Math.floor(t2.x), a2 = t2.x - o2, l2 = new _c(i2, o2, i2, Math.floor(a2 * s2), Math.floor(t2.y * s2)), u2 = this.findDEMTileFor(l2);
              if (!u2 || !u2.dem) return e2;
              const c2 = u2.dem, h3 = 1 << u2.tileID.canonical.z, p3 = (a2 * h3 - u2.tileID.canonical.x) * c2.dim, f2 = (t2.y * h3 - u2.tileID.canonical.y) * c2.dim, d2 = Math.floor(p3), m2 = Math.floor(f2);
              return (r2 ? this.exaggeration() : 1) * ur(ur(c2.get(d2, m2), c2.get(d2, m2 + 1), f2 - m2), ur(c2.get(d2 + 1, m2), c2.get(d2 + 1, m2 + 1), f2 - m2), p3 - d2);
            }
            getAtTileOffset(t2, e2, r2) {
              const n2 = 1 << t2.canonical.z;
              return this.getAtPointOrZero(new lu(t2.wrap + (t2.canonical.x + e2 / Cn) / n2, (t2.canonical.y + r2 / Cn) / n2));
            }
            getAtTileOffsetFunc(t2, e2, r2, n2) {
              return (i2) => {
                const s2 = this.getAtTileOffset(t2, i2.x, i2.y), o2 = n2.upVector(t2.canonical, i2.x, i2.y);
                return P(o2, o2, s2 * n2.upVectorScale(t2.canonical, e2, r2).metersToTile), o2;
              };
            }
            getForTilePoints(t2, e2, r2, n2) {
              if (this.isUsingMockSource()) return false;
              const i2 = Mx.create(this, t2, n2);
              return !!i2 && (e2.forEach((t3) => {
                t3[2] = this.exaggeration() * i2.getElevationAt(t3[0], t3[1], r2);
              }), true);
            }
            getMinMaxForTile(t2) {
              if (this.isUsingMockSource()) return null;
              const e2 = this.findDEMTileFor(t2);
              if (!e2 || !e2.dem) return null;
              const r2 = e2.dem.tree, n2 = e2.tileID, i2 = 1 << t2.canonical.z - n2.canonical.z;
              let s2 = t2.canonical.x / i2 - n2.canonical.x, o2 = t2.canonical.y / i2 - n2.canonical.y, a2 = 0;
              for (let e3 = 0; e3 < t2.canonical.z - n2.canonical.z && !r2.leaves[a2]; e3++) {
                s2 *= 2, o2 *= 2;
                const t3 = 2 * Math.floor(o2) + Math.floor(s2);
                a2 = r2.childOffsets[a2] + t3, s2 %= 1, o2 %= 1;
              }
              return { min: this.exaggeration() * r2.minimums[a2], max: this.exaggeration() * r2.maximums[a2] };
            }
            getMinElevationBelowMSL() {
              throw new Error("Pure virtual method called.");
            }
            raycast(t2, e2, r2) {
              throw new Error("Pure virtual method called.");
            }
            pointCoordinate(t2) {
              throw new Error("Pure virtual method called.");
            }
            _source() {
              throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
              throw new Error("Pure virtual method called.");
            }
            exaggeration() {
              throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(t2) {
              throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
              throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
              const t2 = this.visibleDemTiles;
              if (0 === t2.length) return null;
              let e2 = false, r2 = Number.MAX_VALUE, n2 = Number.MIN_VALUE;
              for (const i2 of t2) {
                const t3 = this.getMinMaxForTile(i2.tileID);
                t3 && (r2 = Math.min(r2, t3.min), n2 = Math.max(n2, t3.max), e2 = true);
              }
              return e2 ? { min: r2, max: n2 } : null;
            }
          }, t.du = gh, t.dv = Pc, t.dw = function(t2, e2) {
            return [Math.pow(t2[0], 2.2) * e2, Math.pow(t2[1], 2.2) * e2, Math.pow(t2[2], 2.2) * e2];
          }, t.dx = i, t.dy = function(t2, e2) {
            var r2 = Math.sin(e2), n2 = Math.cos(e2);
            return t2[0] = n2, t2[1] = r2, t2[2] = 0, t2[3] = -r2, t2[4] = n2, t2[5] = 0, t2[6] = 0, t2[7] = 0, t2[8] = 1, t2;
          }, t.dz = O, t.e = ne, t.e$ = Hb, t.e0 = 256, t.e1 = Gc, t.e2 = ca, t.e3 = d, t.e4 = function(t2, e2) {
            return t2[0] = e2[0], t2[1] = e2[1], t2[2] = e2[2], t2[3] = e2[4], t2[4] = e2[5], t2[5] = e2[6], t2[6] = e2[8], t2[7] = e2[9], t2[8] = e2[10], t2;
          }, t.e5 = za, t.e6 = ka, t.e7 = cs, t.e8 = function(t2, e2, r2, n2, i2) {
            return Et((t2 - e2) / (r2 - e2) * (i2 - n2) + n2, n2, i2);
          }, t.e9 = J, t.eA = function(t2, e2, r2) {
            return t2[0] = e2[0] / r2[0], t2[1] = e2[1] / r2[1], t2[2] = e2[2] / r2[2], t2;
          }, t.eB = $, t.eC = $l, t.eD = B, t.eE = function(t2, e2, r2, n2) {
            return t2[0] = e2, t2[1] = r2, t2[2] = n2, t2;
          }, t.eF = function([t2, e2, r2]) {
            const n2 = Math.hypot(t2, e2, r2), i2 = Math.atan2(t2, r2), s2 = 0.5 * Math.PI - Math.acos(-e2 / n2);
            return new Hl(It(i2), It(s2));
          }, t.eG = X, t.eH = Wg, t.eI = function(t2) {
            const e2 = t2.navigator ? t2.navigator.userAgent : null;
            return !!function(t3) {
              if (null == Yt) {
                const e3 = t3.navigator ? t3.navigator.userAgent : null;
                Yt = !!t3.safari || !(!e3 || !(/\b(iPad|iPhone|iPod)\b/.test(e3) || e3.match("Safari") && !e3.match("Chrome")));
              }
              return Yt;
            }(t2) && !(!e2 || !(e2.match("Version/15.4") || e2.match("Version/15.5") || e2.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/)));
          }, t.eJ = function(t2, e2) {
            ge = t2, xe = e2;
          }, t.eK = Yc, t.eL = Wc, t.eM = function(t2) {
            const e2 = [0, 0, 0], r2 = l(new Float64Array(16));
            return c(r2, t2.pixelMatrix, t2.globeMatrix), R(e2, e2, r2), new bt(e2[0], e2[1]);
          }, t.eN = function() {
            const t2 = Lf;
            t2 && (t2.isPreloaded() && 1 === t2.numActive() ? (t2.release(Cf), Lf = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
          }, t.eO = function() {
            Of().acquire(Cf);
          }, t.eP = fo, t.eQ = function(t2, e2, r2 = false) {
            if (lo === oo.deferred || lo === oo.loading || lo === oo.loaded) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            uo = fe.resolveURL(t2), lo = oo.deferred, ao = e2, ho(), r2 || mo();
          }, t.eR = function(t2) {
            Gf = fe.resolveURL(t2), Hf || (Hf = new Df(Of(), new tr())), Hf.broadcast("setMeshoptUrl", Gf);
          }, t.eS = Kf, t.eT = function(t2) {
            jf = fe.resolveURL(t2), Hf || (Hf = new Df(Of(), new tr())), Hf.broadcast("setDracoUrl", jf);
          }, t.eU = Yf, t.eV = Vf, t.eW = function(t2) {
            const e2 = _e();
            if (!e2) return;
            const r2 = e2.delete(ye);
            t2 && r2.then(() => t2()).catch(t2);
          }, t.eX = Ff, t.eY = qs, t.eZ = mh, t.e_ = ty, t.ea = function(t2, e2) {
            var r2 = e2[0], n2 = e2[1], i2 = e2[2], s2 = e2[3], o2 = e2[4], a2 = e2[5], l2 = e2[6], u2 = e2[7], c2 = e2[8], h3 = c2 * o2 - a2 * u2, p3 = -c2 * s2 + a2 * l2, f2 = u2 * s2 - o2 * l2, d2 = r2 * h3 + n2 * p3 + i2 * f2;
            return d2 ? (t2[0] = h3 * (d2 = 1 / d2), t2[1] = (-c2 * n2 + i2 * u2) * d2, t2[2] = (a2 * n2 - i2 * o2) * d2, t2[3] = p3 * d2, t2[4] = (c2 * r2 - i2 * l2) * d2, t2[5] = (-a2 * r2 + i2 * s2) * d2, t2[6] = f2 * d2, t2[7] = (-u2 * r2 + n2 * l2) * d2, t2[8] = (o2 * r2 - n2 * s2) * d2, t2) : null;
          }, t.eb = V, t.ec = su, t.ed = Qg, t.ee = function(t2, e2) {
            if (t2 === e2) {
              var r2 = e2[1], n2 = e2[2], i2 = e2[3], s2 = e2[6], o2 = e2[7], a2 = e2[11];
              t2[1] = e2[4], t2[2] = e2[8], t2[3] = e2[12], t2[4] = r2, t2[6] = e2[9], t2[7] = e2[13], t2[8] = n2, t2[9] = s2, t2[11] = e2[14], t2[12] = i2, t2[13] = o2, t2[14] = a2;
            } else t2[0] = e2[0], t2[1] = e2[4], t2[2] = e2[8], t2[3] = e2[12], t2[4] = e2[1], t2[5] = e2[5], t2[6] = e2[9], t2[7] = e2[13], t2[8] = e2[2], t2[9] = e2[6], t2[10] = e2[10], t2[11] = e2[14], t2[12] = e2[3], t2[13] = e2[7], t2[14] = e2[11], t2[15] = e2[15];
            return t2;
          }, t.ef = b, t.eg = [1, 1, 1], t.eh = class {
            constructor(t2, e2, r2, n2) {
              this.context = t2, this.format = n2, this.size = r2, this.texture = t2.gl.createTexture();
              const [i2, s2, o2] = this.size, { gl: a2 } = t2;
              a2.bindTexture(a2.TEXTURE_3D, this.texture), t2.pixelStoreUnpackFlipY.set(false), t2.pixelStoreUnpack.set(1), t2.pixelStoreUnpackPremultiplyAlpha.set(false), a2.texImage3D(a2.TEXTURE_3D, 0, this.format, i2, s2, o2, 0, zg(this.format), kg(this.format), e2.data);
            }
            bind(t2, e2) {
              const { context: r2 } = this, { gl: n2 } = r2;
              n2.bindTexture(n2.TEXTURE_3D, this.texture), t2 !== this.minFilter && (n2.texParameteri(n2.TEXTURE_3D, n2.TEXTURE_MAG_FILTER, t2), n2.texParameteri(n2.TEXTURE_3D, n2.TEXTURE_MIN_FILTER, t2), this.minFilter = t2), e2 !== this.wrapS && (n2.texParameteri(n2.TEXTURE_3D, n2.TEXTURE_WRAP_S, e2), n2.texParameteri(n2.TEXTURE_3D, n2.TEXTURE_WRAP_T, e2), this.wrapS = e2);
            }
            destroy() {
              const { gl: t2 } = this.context;
              t2.deleteTexture(this.texture), this.texture = null;
            }
          }, t.ei = Mx, t.ej = function(t2, e2, n2, i2) {
            var s2 = new r(4);
            return s2[0] = t2, s2[1] = e2, s2[2] = n2, s2[3] = i2, s2;
          }, t.ek = q, t.el = function(t2, e2, r2, n2) {
            var i2 = e2[0], s2 = e2[1], o2 = e2[2], a2 = e2[3];
            return t2[0] = i2 + n2 * (r2[0] - i2), t2[1] = s2 + n2 * (r2[1] - s2), t2[2] = o2 + n2 * (r2[2] - o2), t2[3] = a2 + n2 * (r2[3] - a2), t2;
          }, t.em = gx, t.en = xa, t.eo = Ta, t.ep = function(t2, e2, n2, i2, s2, o2, a2, l2, u2, c2, h3, p3, f2, d2, m2, y2) {
            var g2 = new r(16);
            return g2[0] = t2, g2[1] = e2, g2[2] = n2, g2[3] = i2, g2[4] = s2, g2[5] = o2, g2[6] = a2, g2[7] = l2, g2[8] = u2, g2[9] = c2, g2[10] = h3, g2[11] = p3, g2[12] = f2, g2[13] = d2, g2[14] = m2, g2[15] = y2, g2;
          }, t.eq = Gl, t.er = Ea, t.es = Pa, t.et = class {
            constructor() {
              this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = { min: new bt(1 / 0, 1 / 0), max: new bt(-1 / 0, -1 / 0) };
            }
            clear() {
              this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
              return this._updateTime;
            }
            getReplacementRegionsForTile(t2, e2 = false) {
              const r2 = Cp(new bt(0, 0), new bt(Cn, Cn), t2), n2 = [];
              if (e2 && !Bp(r2, this._globalClipBounds)) return n2;
              for (const e3 of this._activeRegions) {
                if (e3.hiddenByOverlap) continue;
                if (!Bp(r2, e3)) continue;
                const i2 = Fp(e3.min, e3.max, t2);
                n2.push({ min: i2.min, max: i2.max, sourceId: this._sourceIds[e3.priority], footprint: e3.footprint, footprintTileId: e3.tileId, order: e3.order, clipMask: e3.clipMask, clipScope: e3.clipScope });
              }
              return n2;
            }
            setSources(t2) {
              this._setSources(t2.map((t3) => ({ getSourceId: () => t3.cache.id, getFootprints: () => {
                const e2 = [];
                for (const r2 of t3.cache.getVisibleCoordinates()) {
                  const n2 = t3.cache.getTile(r2).buckets[t3.layer];
                  n2 && n2.updateFootprints(r2.toUnwrapped(), e2);
                }
                return e2;
              }, getOrder: () => t3.order, getClipMask: () => t3.clipMask, getClipScope: () => t3.clipScope })));
            }
            _addSource(t2) {
              const e2 = t2.getFootprints();
              if (0 === e2.length) return;
              const r2 = t2.getOrder(), n2 = t2.getClipMask(), i2 = t2.getClipScope();
              for (const t3 of e2) {
                if (!t3.footprint) continue;
                const e3 = Cp(t3.footprint.min, t3.footprint.max, t3.id);
                this._activeRegions.push({ min: e3.min, max: e3.max, hiddenByOverlap: false, priority: this._sourceIds.length, tileId: t3.id, footprint: t3.footprint, order: r2, clipMask: n2, clipScope: i2 });
              }
              this._sourceIds.push(t2.getSourceId());
            }
            _computeReplacement() {
              this._activeRegions.sort((t3, e2) => t3.priority - e2.priority || Ep(t3.min, e2.min) || Ep(t3.max, e2.max) || t3.order - e2.order || t3.clipMask - e2.clipMask || function(t4, e3) {
                const r2 = (t5, e4) => t5 + e4;
                return t4.length - e3.length || t4.reduce(r2, "").localeCompare(e3.reduce(r2, ""));
              }(t3.clipScope, e2.clipScope));
              let t2 = this._activeRegions.length !== this._prevRegions.length;
              if (!t2) {
                let e2 = 0;
                for (; !t2 && e2 !== this._activeRegions.length; ) {
                  const r2 = this._activeRegions[e2], n2 = this._prevRegions[e2];
                  t2 = r2.priority !== n2.priority || !Tp(r2, n2) || r2.order !== n2.order || r2.clipMask !== n2.clipMask || !wt(r2.clipScope, n2.clipScope), ++e2;
                }
              }
              if (t2) {
                ++this._updateTime;
                for (const t4 of this._activeRegions) t4.order !== kp && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, t4.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, t4.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, t4.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, t4.max.y));
                const t3 = (t4) => {
                  const e2 = this._activeRegions;
                  if (t4 >= e2.length) return t4;
                  const r2 = e2[t4].priority;
                  for (; t4 < e2.length && e2[t4].priority === r2; ) ++t4;
                  return t4;
                };
                if (this._sourceIds.length > 1) {
                  let e2 = 0, r2 = t3(e2);
                  for (; e2 !== r2; ) {
                    let n2 = e2;
                    const i2 = e2;
                    for (; n2 !== r2; ) {
                      const t4 = this._activeRegions[n2];
                      t4.hiddenByOverlap = false;
                      for (let e3 = 0; e3 < i2; e3++) {
                        const r3 = this._activeRegions[e3];
                        if (!r3.hiddenByOverlap && t4.order === kp && Bp(t4, r3) && (t4.hiddenByOverlap = Lp(t4.footprint, t4.tileId, r3.footprint, r3.tileId), t4.hiddenByOverlap)) break;
                      }
                      ++n2;
                    }
                    e2 = r2, r2 = t3(e2);
                  }
                }
              }
            }
            _setSources(t2) {
              [this._prevRegions, this._activeRegions] = [this._activeRegions, []], this._sourceIds = [];
              for (let e2 = t2.length - 1; e2 >= 0; e2--) this._addSource(t2[e2]);
              this._computeReplacement();
            }
          }, t.eu = kp, t.ev = class {
            constructor(t2) {
              this._createGrid(t2), this._createPoles(t2);
            }
            destroy() {
              this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
              for (const t2 of this._poleSegments) t2.destroy();
              for (const t2 of this._gridSegments) t2.withSkirts.destroy(), t2.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(t2, e2) {
              const r2 = new ra(), n2 = new Aa(), i2 = [], s2 = t2 + 1 + 2, o2 = e2[0] + 1, a2 = e2[0] + 1 + (1 + e2.length), l2 = (t3, e3, r3) => {
                let n3 = t3 === s2 - 1 ? t3 - 2 : 0 === t3 ? t3 : t3 - 1;
                return n3 += r3 ? 24575 : 0, [n3, e3];
              };
              for (let t3 = 0; t3 < s2; ++t3) r2.emplaceBack(...l2(t3, 0, true));
              for (let t3 = 0; t3 < o2; ++t3) for (let e3 = 0; e3 < s2; ++e3) r2.emplaceBack(...l2(e3, t3, (0 === e3 || e3 === s2 - 1) && true));
              for (let t3 = 0; t3 < e2.length; ++t3) {
                const n3 = e2[t3];
                for (let t4 = 0; t4 < s2; ++t4) r2.emplaceBack(...l2(t4, n3, true));
              }
              for (let t3 = 0; t3 < e2.length; ++t3) {
                const o3 = n2.length, l3 = e2[t3] + 1 + 2, u2 = new Aa();
                for (let r3 = 0; r3 < l3 - 1; r3++) {
                  const i3 = r3 === l3 - 2, o4 = i3 ? s2 * (a2 - e2.length + t3 - r3) : s2;
                  for (let t4 = 0; t4 < s2 - 1; t4++) {
                    const e3 = r3 * s2 + t4;
                    0 === r3 || i3 || 0 === t4 || t4 === s2 - 2 ? (u2.emplaceBack(e3 + 1, e3, e3 + o4), u2.emplaceBack(e3 + o4, e3 + o4 + 1, e3 + 1)) : (n2.emplaceBack(e3 + 1, e3, e3 + o4), n2.emplaceBack(e3 + o4, e3 + o4 + 1, e3 + 1));
                  }
                }
                const c2 = tl.simpleSegment(0, o3, r2.length, n2.length - o3);
                for (let t4 = 0; t4 < u2.uint16.length; t4 += 3) n2.emplaceBack(u2.uint16[t4], u2.uint16[t4 + 1], u2.uint16[t4 + 2]);
                const h3 = tl.simpleSegment(0, o3, r2.length, n2.length - o3);
                i2.push({ withoutSkirts: c2, withSkirts: h3 });
              }
              return { vertices: r2, indices: n2, segments: i2 };
            }
            _createGrid(t2) {
              const e2 = this._fillGridMeshWithLods(Rl, Ol);
              this._gridSegments = e2.segments, this._gridBuffer = t2.createVertexBuffer(e2.vertices, kc.members), this._gridIndexBuffer = t2.createIndexBuffer(e2.indices, true);
            }
            _createPoles(t2) {
              const e2 = new Aa();
              for (let t3 = 0; t3 <= Rl; t3++) e2.emplaceBack(0, t3 + 1, t3 + 2);
              this._poleIndexBuffer = t2.createIndexBuffer(e2, true);
              const r2 = new za(), n2 = new za(), i2 = new za(), s2 = new za();
              this._poleSegments = [];
              for (let t3 = 0, e3 = 0; t3 < Fl; t3++) {
                const o2 = 360 / (1 << t3);
                r2.emplaceBack(0, -Cl, 0, 0.5, 0), n2.emplaceBack(0, -Cl, 0, 0.5, 1), i2.emplaceBack(0, -Cl, 0, 0.5, 0.5), s2.emplaceBack(0, -Cl, 0, 0.5, 0.5);
                for (let t4 = 0; t4 <= Rl; t4++) {
                  let e4 = t4 / Rl, a2 = 0;
                  const l2 = ur(0, o2, e4), [u2, c2, h3] = jl(Jc, Qc, l2, Cl);
                  r2.emplaceBack(u2, c2, h3, e4, a2), n2.emplaceBack(u2, c2, h3, e4, 1 - a2);
                  const p3 = Mt(l2);
                  e4 = 0.5 + 0.5 * Math.sin(p3), a2 = 0.5 + 0.5 * Math.cos(p3), i2.emplaceBack(u2, c2, h3, e4, a2), s2.emplaceBack(u2, c2, h3, e4, 1 - a2);
                }
                this._poleSegments.push(tl.simpleSegment(e3, 0, 66, 64)), e3 += 66;
              }
              this._poleNorthVertexBuffer = t2.createVertexBuffer(r2, Sc, false), this._poleSouthVertexBuffer = t2.createVertexBuffer(n2, Sc, false), this._texturedPoleNorthVertexBuffer = t2.createVertexBuffer(i2, Sc, false), this._texturedPoleSouthVertexBuffer = t2.createVertexBuffer(s2, Sc, false);
            }
            getGridBuffers(t2, e2) {
              return [this._gridBuffer, this._gridIndexBuffer, e2 ? this._gridSegments[t2].withSkirts : this._gridSegments[t2].withoutSkirts];
            }
            getPoleBuffers(t2, e2) {
              return [e2 ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer, e2 ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer, this._poleIndexBuffer, this._poleSegments[t2]];
            }
          }, t.ew = kt, t.ex = function() {
            return !!document.fullscreenElement || !!document.webkitFullscreenElement;
          }, t.ey = Pt, t.ez = ou, t.f = function(t2) {
            return btoa(encodeURIComponent(t2).replace(/%([0-9A-F]{2})/g, (t3, e2) => String.fromCharCode(Number("0x" + e2))));
          }, t.f0 = Wb, t.f1 = Ad, t.f2 = Eu, t.f3 = "hd_road_elevation", t.f4 = Zu, t.f5 = Ot, t.f6 = ep, t.f7 = Wm, t.f8 = Xm, t.f9 = function(t2, e2, r2, n2, i2, s2, o2, a2 = 1, l2, u2, c2) {
            t2.createArrays(), t2.tilePixelRatio = Cn / (512 * t2.overscaling), t2.compareText = {}, t2.iconsNeedLinear = false;
            const h3 = t2.layers[0].layout, p3 = t2.layers[0]._unevaluatedLayout._values, f2 = {};
            f2.scaleFactor = a2, f2.textSizeScaleRange = h3.get("text-size-scale-range"), f2.iconSizeScaleRange = h3.get("icon-size-scale-range");
            const [d2, m2] = f2.textSizeScaleRange, [y2, g2] = f2.iconSizeScaleRange;
            f2.textScaleFactor = Et(f2.scaleFactor, d2, m2), f2.iconScaleFactor = Et(f2.scaleFactor, y2, g2);
            const x2 = p3["text-size"], v2 = p3["icon-size"];
            if ("composite" === t2.textSizeData.kind) {
              const { minZoom: e3, maxZoom: r3 } = t2.textSizeData;
              f2.compositeTextSizes = [x2.possiblyEvaluate(new go(e3, { worldview: c2 }), s2), x2.possiblyEvaluate(new go(r3, { worldview: c2 }), s2)];
            }
            if ("composite" === t2.iconSizeData.kind) {
              const { minZoom: e3, maxZoom: r3 } = t2.iconSizeData;
              f2.compositeIconSizes = [v2.possiblyEvaluate(new go(e3, { worldview: c2 }), s2), v2.possiblyEvaluate(new go(r3, { worldview: c2 }), s2)];
            }
            f2.layoutTextSize = x2.possiblyEvaluate(new go(o2 + 1, { worldview: c2 }), s2), f2.layoutIconSize = v2.possiblyEvaluate(new go(o2 + 1, { worldview: c2 }), s2), f2.textMaxSize = x2.possiblyEvaluate(new go(18, { worldview: c2 }), s2);
            const b2 = h3.get("symbol-placement"), w2 = "map" === h3.get("text-rotation-alignment") && "point" !== b2, _2 = h3.get("text-size");
            let A2 = false;
            const M2 = [];
            for (const o3 of t2.features) {
              const a3 = h3.get("text-font").evaluate(o3, {}, s2).join(","), d3 = _2.evaluate(o3, {}, s2) * f2.textScaleFactor, m3 = f2.layoutTextSize.evaluate(o3, {}, s2) * f2.textScaleFactor, y3 = f2.layoutIconSize.evaluate(o3, {}, s2) * f2.iconScaleFactor, g3 = { horizontal: {}, vertical: void 0 }, x3 = o3.text;
              let v3, I2 = [0, 0];
              if (x3) {
                const n3 = x3.toString(), u3 = h3.get("text-letter-spacing").evaluate(o3, {}, s2) * Jd, c3 = h3.get("text-line-height").evaluate(o3, {}, s2) * Jd, p4 = Js(n3) ? u3 : 0, f3 = h3.get("text-anchor").evaluate(o3, {}, s2), y4 = h3.get("text-variable-anchor");
                if (!y4) {
                  const t3 = h3.get("text-radial-offset").evaluate(o3, {}, s2);
                  if (t3) I2 = gy(f3, [t3 * Jd, my]);
                  else {
                    const t4 = h3.get("text-offset").evaluate(o3, {}, s2);
                    I2 = [t4[0] * Jd, t4[1] * Jd];
                  }
                }
                let v4 = w2 ? "center" : h3.get("text-justify").evaluate(o3, {}, s2);
                const _3 = "point" === b2, A3 = _3 ? h3.get("text-max-width").evaluate(o3, {}, s2) * Jd : 1 / 0, M3 = (s3) => {
                  t2.allowVerticalPlacement && Ks(n3) && (g3.vertical = xm(x3, e2, r2, i2, a3, A3, c3, f3, s3, p4, I2, mm.vertical, true, m3, d3, l2));
                };
                if (!w2 && y4) {
                  const t3 = "auto" === v4 ? y4.map((t4) => Iy(t4)) : [v4];
                  let n4 = false;
                  for (let s3 = 0; s3 < t3.length; s3++) {
                    const o4 = t3[s3];
                    if (!g3.horizontal[o4]) if (n4) g3.horizontal[o4] = g3.horizontal[0];
                    else {
                      const t4 = xm(x3, e2, r2, i2, a3, A3, c3, "center", o4, p4, I2, mm.horizontal, false, m3, d3, l2);
                      t4 && (g3.horizontal[o4] = t4, n4 = 1 === t4.positionedLines.length);
                    }
                  }
                  M3("left");
                } else {
                  if ("auto" === v4 && (v4 = Iy(f3)), _3 || h3.get("text-writing-mode").indexOf("horizontal") >= 0 || !Ks(n3)) {
                    const t3 = xm(x3, e2, r2, i2, a3, A3, c3, f3, v4, p4, I2, mm.horizontal, false, m3, d3, l2);
                    t3 && (g3.horizontal[v4] = t3);
                  }
                  M3(_3 ? "left" : v4);
                }
              }
              let S2, z2, k2, P2, E2, T2, B2 = false;
              const V2 = h3.get("icon-text-fit").evaluate(o3, {}, s2);
              if (o3.icon && o3.icon.hasPrimary()) {
                const e3 = by(o3.icon, t2.iconSizeData, p3["icon-size"], s2, t2.zoom, o3, l2, f2.iconScaleFactor, c2);
                S2 = e3.iconPrimary, k2 = e3.iconSecondary;
                const r3 = S2.toString();
                if (z2 = n2.get(r3), z2 && (E2 = h3.get("icon-offset").evaluate(o3, {}, s2), T2 = h3.get("icon-anchor").evaluate(o3, {}, s2), v3 = Pm(i2.get(r3), k2 ? i2.get(k2.toString()) : void 0, E2, T2), B2 = z2.sdf, void 0 === t2.sdfIcons ? t2.sdfIcons = z2.sdf : t2.sdfIcons !== z2.sdf && Gt("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (z2.pixelRatio !== t2.pixelRatio || 0 !== h3.get("icon-rotate").constantOr(1)) && (t2.iconsNeedLinear = true)), k2) {
                  const t3 = k2.toString();
                  P2 = n2.get(t3);
                }
              }
              A2 = A2 || !(!o3.icon || !o3.icon.hasSecondary());
              const C2 = Ty(g3.horizontal) || g3.vertical;
              t2.iconsInText || (t2.iconsInText = !!C2 && C2.iconsInText);
              const F2 = m3 * f2.textScaleFactor / Jd, { defaultShapedIcon: D2, verticallyShapedIcon: L2 } = Sy(t2, v3, h3, o3, s2, g3, F2, E2, V2);
              "none" !== V2 && v3 && (Tm(v3) || Bm(v3)) && (xy(0, z2, S2, v3, D2, V2, u2, n2, i2), xy(0, P2, k2, v3, D2, V2, u2, n2, i2), L2 && (xy(0, z2, S2, v3, L2, V2, u2, n2, i2), xy(0, P2, k2, v3, L2, V2, u2, n2, i2))), v3 = D2, M2.push({ feature: o3, shapedTextOrientations: g3, shapedText: C2, shapedIcon: v3, iconPrimary: S2, iconSecondary: k2, iconOffset: E2, iconAnchor: T2, verticallyShapedIcon: L2, layoutTextSize: m3, layoutIconSize: y3, textOffset: I2, isSDFIcon: B2, iconTextFit: V2 });
            }
            return { featureData: M2, sizes: f2, hasAnySecondaryIcon: A2, textAlongLine: w2, symbolPlacement: b2 };
          }, t.fa = Ym, t.fb = function(t2, e2, r2, n2, i2, s2, o2, a2, l2, u2) {
            const { featureData: c2, hasAnySecondaryIcon: h3, sizes: p3, textAlongLine: f2, symbolPlacement: d2 } = e2;
            for (const e3 of c2) {
              const { shapedIcon: r3, verticallyShapedIcon: s3, feature: c3, shapedTextOrientations: m2, shapedText: y2, layoutTextSize: g2, textOffset: x2, isSDFIcon: v2, iconPrimary: b2, iconSecondary: w2, iconTextFit: _2, iconOffset: A2 } = e3;
              _y(r3, u2.iconPositions, b2, w2), _y(s3, u2.iconPositions, b2, w2), Ay(m2, u2.iconPositions), wy(b2, w2, u2.iconPositions), (y2 || r3) && zy(t2, c3, m2, r3, s3, l2, p3, g2, 0, x2, v2, n2, i2, o2, a2, h3, _2, A2, f2, d2);
            }
            r2 && t2.generateCollisionDebugBuffers(s2, t2.collisionBoxArray, p3.textScaleFactor);
          }, t.fc = Pu, t.fd = $v, t.fe = vt, t.ff = ku, t.fg = lm, t.fh = dt, t.fi = function(t2) {
            let e2 = 0;
            if (new Uint32Array(t2, 0, 1)[0] !== od) {
              const r2 = new Uint32Array(t2, 0, 7), [, , n2, i2, s2, o2] = r2;
              e2 = r2.byteLength + i2 + s2 + o2 + s2, (n2 !== t2.byteLength || e2 >= t2.byteLength) && Gt("Invalid b3dm header information.");
            }
            return pd(t2, e2);
          }, t.fj = function(t2, e2) {
            const r2 = $b(t2);
            for (const t3 of r2) {
              for (const e3 of t3.meshes) Gb(e3);
              t3.lights && (t3.lightMeshIndex = t3.meshes.length, t3.meshes.push(qb(t3.lights, e2)));
            }
            return r2;
          }, t.fk = Tx, t.fl = Zt, t.fm = Bf, t.fn = yo, t.fo = oo, t.fp = function(t2) {
            Ae(), null != be && be.then((e2) => {
              e2.keys().then((r2) => {
                for (let n2 = 0; n2 < r2.length - t2; n2++) e2.delete(r2[n2]).catch((t3) => Gt(t3.message));
              }).catch((t3) => Gt(t3.message));
            }).catch((t3) => Gt(t3.message));
          }, t.g = function(t2, e2) {
            return Fe(Ct(t2, { method: "GET" }), e2);
          }, t.h = Ct, t.i = function(t2) {
            return ne.API_STYLE_REGEX.test(t2) && !se(t2);
          }, t.j = function(t2) {
            return 0 === t2.indexOf("mapbox:");
          }, t.k = ie, t.l = Ie, t.m = function(t2) {
            return decodeURIComponent(atob(t2).split("").map((t3) => "%" + ("00" + t3.charCodeAt(0).toString(16)).slice(-2)).join(""));
          }, t.n = function(t2, e2) {
            return Fe(Ct(t2, { type: "json" }), e2);
          }, t.o = Ne, t.p = function(t2, e2) {
            return Fe(Ct(t2, { method: "POST" }), e2);
          }, t.q = fe, t.r = yh, t.s = function(t2) {
            try {
              const e2 = self[t2];
              return e2.setItem("_mapbox_test_", 1), e2.removeItem("_mapbox_test_"), true;
            } catch (t3) {
              return false;
            }
          }, t.t = pe, t.u = function() {
            return function t2(e2) {
              return e2 ? (e2 ^ Math.random() * (16 >> e2 / 4)).toString(16) : ([1e7] + -[1e3] + -4e3 + -8e3 + -1e11).replace(/[018]/g, t2);
            }();
          }, t.v = function(t2) {
            return !!t2 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t2);
          }, t.w = Gt, t.x = function() {
            return Rf || (Rf = new Ff()), Rf;
          }, t.y = Tv, t.z = Ke;
        });
        define3(["./shared"], function(e) {
          function t(e2) {
            const t2 = e2 ? e2.url.toString() : void 0;
            return t2 ? performance.getEntriesByName(t2) : [];
          }
          function s(e2) {
            if ("number" == typeof e2 || "boolean" == typeof e2 || "string" == typeof e2 || null == e2) return JSON.stringify(e2);
            if (Array.isArray(e2)) {
              let t3 = "[";
              for (const i2 of e2) t3 += `${s(i2)},`;
              return `${t3}]`;
            }
            let t2 = "{";
            for (const i2 of Object.keys(e2).sort()) t2 += `${i2}:${s(e2[i2])},`;
            return `${t2}}`;
          }
          function i(t2) {
            let i2 = "";
            for (const o2 of e.bu) i2 += `/${s(t2[o2])}`;
            return i2;
          }
          class o {
            constructor(e2) {
              this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, e2 && this.replace(e2);
            }
            replace(e2, t2) {
              this._layerConfigs = {}, this._layers = {}, this.update(e2, [], t2);
            }
            update(t2, o2, n2) {
              this._options = n2;
              for (const s2 of t2) this._layerConfigs[s2.id] = s2, (this._layers[s2.id] = e.db(s2, this.scope, null, this._options)).compileFilter(n2), this.keyCache[s2.id] && delete this.keyCache[s2.id];
              for (const e2 of o2) delete this.keyCache[e2], delete this._layerConfigs[e2], delete this._layers[e2];
              this.familiesBySource = {};
              const r2 = function(e2, t3) {
                const o3 = {};
                for (let n4 = 0; n4 < e2.length; n4++) {
                  const r3 = e2[n4];
                  let a2 = t3 && t3[r3.id];
                  a2 || ("symbol" === r3.type ? a2 = r3.id : (a2 = i(r3), "line" === r3.type && r3.paint && function e3(t4) {
                    return "string" == typeof t4 && "line-progress" === t4 || (Array.isArray(t4) ? t4.some(e3) : !(!t4 || "object" != typeof t4) && Object.values(t4).some(e3));
                  }(r3.paint["line-width"]) && (a2 += `/${s(r3.paint["line-width"])}`))), t3 && (t3[r3.id] = a2);
                  let l2 = o3[a2];
                  l2 || (l2 = o3[a2] = []), l2.push(r3);
                }
                const n3 = [];
                for (const e3 in o3) n3.push(o3[e3]);
                return n3;
              }(Object.values(this._layerConfigs), this.keyCache);
              for (const e2 of r2) {
                const t3 = e2.map((e3) => this._layers[e3.id]), s2 = t3[0];
                if ("none" === s2.visibility) continue;
                const i2 = s2.source || "";
                let o3 = this.familiesBySource[i2];
                o3 || (o3 = this.familiesBySource[i2] = {});
                const n3 = s2.sourceLayer || "_geojsonTileLayer";
                let r3 = o3[n3];
                r3 || (r3 = o3[n3] = []), r3.push(t3);
              }
            }
          }
          const n = 1 * e.e_;
          class r {
            constructor(t2) {
              const s2 = {}, i2 = [];
              for (const e2 in t2) {
                const o3 = t2[e2], r3 = s2[e2] = {};
                for (const e3 in o3.glyphs) {
                  const t3 = o3.glyphs[+e3];
                  if (!t3 || 0 === t3.bitmap.width || 0 === t3.bitmap.height) continue;
                  const s3 = t3.metrics.localGlyph ? n : 1, a3 = { x: 0, y: 0, w: t3.bitmap.width + 2 * s3, h: t3.bitmap.height + 2 * s3 };
                  i2.push(a3), r3[e3] = a3;
                }
              }
              const { w: o2, h: r2 } = e.H(i2), a2 = new e.eZ({ width: o2 || 1, height: r2 || 1 });
              for (const i3 in t2) {
                const o3 = t2[i3];
                for (const t3 in o3.glyphs) {
                  const r3 = o3.glyphs[+t3];
                  if (!r3 || 0 === r3.bitmap.width || 0 === r3.bitmap.height) continue;
                  const l2 = s2[i3][t3], c2 = r3.metrics.localGlyph ? n : 1;
                  e.eZ.copy(r3.bitmap, a2, { x: 0, y: 0 }, { x: l2.x + c2, y: l2.y + c2 }, r3.bitmap);
                }
              }
              this.image = a2, this.positions = s2;
            }
          }
          e.eY(r, "GlyphAtlas");
          class a {
            constructor(t2) {
              this.tileID = new e.aM(t2.tileID.overscaledZ, t2.tileID.wrap, t2.tileID.canonical.z, t2.tileID.canonical.x, t2.tileID.canonical.y), this.tileZoom = t2.tileZoom, this.uid = t2.uid, this.zoom = t2.zoom, this.lut = t2.lut, this.canonical = t2.tileID.canonical, this.pixelRatio = t2.pixelRatio, this.tileSize = t2.tileSize, this.source = t2.source, this.scope = t2.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t2.showCollisionBoxes, this.collectResourceTiming = !!t2.request && t2.request.collectResourceTiming, this.promoteId = t2.promoteId, this.isSymbolTile = t2.isSymbolTile, this.tileTransform = e.aW(t2.tileID.canonical, t2.projection), this.projection = t2.projection, this.worldview = t2.worldview, this.localizableLayerIds = t2.localizableLayerIds, this.brightness = t2.brightness, this.extraShadowCaster = !!t2.extraShadowCaster, this.tessellationStep = t2.tessellationStep, this.scaleFactor = t2.scaleFactor, this.worldview = t2.worldview;
            }
            parse(t2, s2, i2, o2, n2, a2) {
              this.status = "parsing", this.data = t2, this.collisionBoxArray = new e.b0();
              const c2 = new e.e$(Object.keys(t2.layers).sort()), h3 = new e.f0(this.tileID, this.promoteId);
              h3.bucketLayerIDs = [];
              const u2 = {}, d2 = new e.f1(256, 256), f2 = { featureIndex: h3, iconDependencies: /* @__PURE__ */ new Map(), patternDependencies: /* @__PURE__ */ new Map(), glyphDependencies: {}, lineAtlas: d2, availableImages: i2, brightness: this.brightness, scaleFactor: this.scaleFactor, elevationFeatures: void 0 }, p3 = [], g2 = s2.familiesBySource[this.source];
              for (const s3 in g2) {
                const n3 = t2.layers[s3];
                if (!n3) continue;
                let r2 = false, a3 = false, d3 = false;
                for (const e2 of g2[s3]) "symbol" === e2[0].type ? r2 = true : a3 = true, e2[0].is3D() && "model" !== e2[0].type && (d3 = true);
                if (this.extraShadowCaster && !d3) continue;
                if (true === this.isSymbolTile && !r2) continue;
                if (false === this.isSymbolTile && !a3) continue;
                1 === n3.version && e.w(`Vector tile source "${this.source}" layer "${s3}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                const m3 = c2.encode(s3), y2 = [];
                let w2 = false;
                for (let t3 = 0, i3 = 0; t3 < n3.length; t3++) {
                  const o3 = n3.feature(t3), r3 = h3.getId(o3, s3);
                  if (this.localizableLayerIds && this.localizableLayerIds.has(s3)) {
                    const e2 = o3.properties ? o3.properties.worldview : null;
                    if (this.worldview && "string" == typeof e2) if ("all" === e2) o3.properties.$localized = true;
                    else {
                      if (!e2.split(",").includes(this.worldview)) continue;
                      o3.properties.$localized = true, o3.properties.worldview = this.worldview;
                    }
                  }
                  !w2 && o3.properties && o3.properties.hasOwnProperty(e.f2) && (w2 = true), y2.push({ feature: o3, id: r3, index: i3, sourceLayerIndex: m3 }), i3++;
                }
                w2 && !f2.elevationFeatures && t2.layers.hasOwnProperty(e.f3) && (f2.elevationFeatures = e.f4.parseFrom(t2.layers[e.f3], this.canonical));
                for (const t3 of g2[s3]) {
                  const s4 = t3[0];
                  if (this.extraShadowCaster && (!s4.is3D() || "model" === s4.type)) continue;
                  if (void 0 !== this.isSymbolTile && "symbol" === s4.type !== this.isSymbolTile) continue;
                  if (s4.minzoom && this.zoom < Math.floor(s4.minzoom)) continue;
                  if (s4.maxzoom && this.zoom >= s4.maxzoom) continue;
                  if ("none" === s4.visibility) continue;
                  l(t3, this.zoom, f2.brightness, i2, this.worldview);
                  const n4 = u2[s4.id] = s4.createBucket({ index: h3.bucketLayerIDs.length, layers: t3, zoom: this.zoom, lut: this.lut, canonical: this.canonical, pixelRatio: this.pixelRatio, overscaling: this.overscaling, collisionBoxArray: this.collisionBoxArray, sourceLayerIndex: m3, sourceID: this.source, projection: this.projection.spec, tessellationStep: this.tessellationStep, styleDefinedModelURLs: o2, worldview: this.worldview });
                  h3.bucketLayerIDs.push(t3.map((t4) => e.C(t4.id, t4.scope)));
                  let r3 = n4.prepare ? n4.prepare() : null;
                  null != r3 ? (r3 = r3.then(() => n4.populate(y2, f2, this.tileID.canonical, this.tileTransform)), p3.push(r3)) : n4.populate(y2, f2, this.tileID.canonical, this.tileTransform);
                }
              }
              const m2 = () => {
                let s3, o3, p4, g3, m3, y2;
                d2.trim();
                const w2 = { type: "maybePrepare", isSymbolTile: this.isSymbolTile, zoom: this.zoom }, v2 = () => {
                  if (s3) return this.status = "done", a2(s3);
                  if (this.extraShadowCaster) this.status = "done", a2(null, { buckets: Object.values(u2).filter((e2) => !e2.isEmpty()), featureIndex: h3, collisionBoxArray: null, glyphAtlasImage: null, lineAtlas: null, imageAtlas: null, brightness: f2.brightness, glyphMap: null, iconMap: null, glyphPositions: null });
                  else if (o3 && p4 && g3) {
                    const t3 = new r(o3), s4 = /* @__PURE__ */ new Map();
                    for (const [t4, i3] of p4.entries()) {
                      const { imagePosition: o4 } = e.f7(t4, i3, e.f8);
                      s4.set(t4, o4);
                    }
                    const a3 = {};
                    for (const n3 in u2) {
                      const r2 = u2[n3];
                      r2 instanceof e.b1 && (l(r2.layers, this.zoom, f2.brightness, i2, this.worldview), a3[n3] = e.f9(r2, o3, t3.positions, p4, s4, this.tileID.canonical, this.tileZoom, this.scaleFactor, this.pixelRatio, m3, this.worldview));
                    }
                    const c3 = { iconsPending: true, patternsPending: true };
                    this.rasterizeIfNeeded(n2, p4, m3, () => {
                      c3.iconsPending = false, x2(a3, t3, c3);
                    }), this.rasterizeIfNeeded(n2, g3, y2, () => {
                      c3.patternsPending = false, x2(a3, t3, c3);
                    });
                  }
                }, x2 = (t3, s4, o4, n3) => {
                  if (o4.iconsPending || o4.patternsPending) return;
                  const r2 = new e.fa(p4, g3, this.lut);
                  for (const s5 in u2) {
                    const o5 = u2[s5];
                    if (s5 in t3) e.fb(o5, t3[s5], this.showCollisionBoxes, i2, this.tileID.canonical, this.tileZoom, this.projection, this.brightness, p4, r2);
                    else if (o5.hasPattern && (o5 instanceof e.b7 || o5 instanceof e.b8 || o5 instanceof e.dU)) {
                      l(o5.layers, this.zoom, f2.brightness, i2, this.worldview);
                      const e2 = Object.fromEntries(r2.patternPositions);
                      o5.addFeatures(f2, this.tileID.canonical, e2, i2, this.tileTransform, this.brightness);
                    }
                  }
                  this.status = "done", a2(null, { buckets: Object.values(u2).filter((e2) => !e2.isEmpty()), featureIndex: h3, collisionBoxArray: this.collisionBoxArray, glyphAtlasImage: s4.image, lineAtlas: d2, imageAtlas: r2, brightness: f2.brightness });
                };
                if (!this.extraShadowCaster) {
                  const t3 = e.f5(f2.glyphDependencies, (e2) => Object.keys(e2).map(Number));
                  Object.keys(t3).length ? n2.send("getGlyphs", { uid: this.uid, stacks: t3, scope: this.scope }, (e2, t4) => {
                    s3 || (s3 = e2, o3 = t4, v2());
                  }, void 0, false, w2) : o3 = {};
                  const i3 = Array.from(f2.iconDependencies.keys()).map((t4) => e.I.parse(t4));
                  i3.length ? n2.send("getImages", { images: i3, source: this.source, scope: this.scope, tileID: this.tileID, type: "icons" }, (e2, t4) => {
                    s3 || (s3 = e2, p4 = /* @__PURE__ */ new Map(), m3 = this.updateImageMapAndGetImageTaskQueue(p4, t4, f2.iconDependencies), v2());
                  }, void 0, false, w2) : (p4 = /* @__PURE__ */ new Map(), m3 = /* @__PURE__ */ new Map());
                  const r2 = Array.from(f2.patternDependencies.keys()).map((t4) => e.I.parse(t4));
                  r2.length ? n2.send("getImages", { images: r2, source: this.source, scope: this.scope, tileID: this.tileID, type: "patterns" }, (e2, t4) => {
                    s3 || (s3 = e2, g3 = /* @__PURE__ */ new Map(), y2 = this.updateImageMapAndGetImageTaskQueue(g3, t4, f2.patternDependencies), v2());
                  }, void 0, false, w2) : (g3 = /* @__PURE__ */ new Map(), y2 = /* @__PURE__ */ new Map());
                }
                if (f2.elevationFeatures && f2.elevationFeatures.length > 0) {
                  const s4 = [];
                  for (const t3 of Object.values(u2)) if (t3 instanceof e.b8) {
                    const e2 = t3.getUnevaluatedPortalGraph();
                    e2 && s4.push(e2);
                  }
                  const i3 = e.f6.evaluate(s4);
                  for (const s5 of Object.values(u2)) if (s5 instanceof e.b8) {
                    const e2 = t2.layers[c2.decode(s5.sourceLayerIndex)];
                    s5.setEvaluatedPortalGraph(i3, e2, this.tileID.canonical, f2.availableImages, f2.brightness);
                  }
                }
                v2();
              };
              p3.length > 0 ? Promise.allSettled(p3).then(m2).catch(a2) : m2();
            }
            rasterizeIfNeeded(e2, t2, s2, i2) {
              Array.from(t2.values()).some((e3) => e3.usvg) ? this.rasterize(e2, t2, s2, i2) : i2();
            }
            updateImageMapAndGetImageTaskQueue(e2, t2, s2) {
              const i2 = /* @__PURE__ */ new Map();
              for (const o2 of t2.keys()) {
                const n2 = s2.get(o2) || [];
                for (const s3 of n2) {
                  const o3 = s3.toString(), n3 = t2.get(s3.id.toString());
                  n3.usvg ? i2.has(o3) || (i2.set(o3, s3), e2.set(o3, Object.assign({}, n3))) : e2.set(o3, n3);
                }
              }
              return i2;
            }
            rasterize(e2, t2, s2, i2) {
              this.rasterizeTask = e2.send("rasterizeImages", { scope: this.scope, tasks: s2 }, (e3, s3) => {
                if (!e3) for (const [e4, i3] of s3.entries()) {
                  const s4 = Object.assign(t2.get(e4), { data: i3 });
                  t2.set(e4, s4);
                }
                i2();
              });
            }
            cancelRasterize() {
              this.rasterizeTask && this.rasterizeTask.cancel();
            }
          }
          function l(t2, s2, i2, o2, n2) {
            const r2 = new e.aa(s2, { brightness: i2, worldview: n2 });
            for (const e2 of t2) e2.recalculate(r2, o2);
          }
          class c extends e.E {
            constructor(t2, s2, i2, o2, n2, r2, a2) {
              super(), this.actor = t2, this.layerIndex = s2, this.availableImages = i2, this.availableModels = o2, this.loadVectorData = r2 || e.aJ, this.loading = {}, this.loaded = {}, this.deduped = new e.aI(t2.scheduler), this.isSpriteLoaded = n2, this.scheduler = t2.scheduler, this.brightness = a2;
            }
            loadTile(s2, i2) {
              const o2 = s2.uid, n2 = s2 && s2.request, r2 = n2 && n2.collectResourceTiming, l2 = this.loading[o2] = new a(s2);
              l2.abort = this.loadVectorData(s2, (a2, c2) => {
                const h3 = !this.loading[o2];
                if (delete this.loading[o2], l2.cancelRasterize(), h3 || a2 || !c2) return l2.status = "done", h3 || (this.loaded[o2] = l2), i2(a2);
                const u2 = c2.rawData, d2 = {};
                c2.expires && (d2.expires = c2.expires), c2.cacheControl && (d2.cacheControl = c2.cacheControl), l2.vectorTile = c2.vectorTile || new e.fc.VectorTile(new e.bq(u2));
                const f2 = () => {
                  l2.parse(l2.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, (s3, o3) => {
                    if (s3 || !o3) return i2(s3);
                    const a3 = {};
                    if (r2) {
                      const e2 = t(n2);
                      e2.length > 0 && (a3.resourceTiming = JSON.parse(JSON.stringify(e2)));
                    }
                    i2(null, e.h({ rawTileData: u2.slice(0) }, o3, d2, a3));
                  });
                };
                this.isSpriteLoaded ? f2() : this.once("isSpriteLoaded", () => {
                  this.scheduler ? this.scheduler.add(f2, { type: "parseTile", isSymbolTile: s2.isSymbolTile, zoom: s2.tileZoom }) : f2();
                }), this.loaded = this.loaded || {}, this.loaded[o2] = l2;
              });
            }
            reloadTile(t2, s2) {
              const i2 = this.loaded, o2 = t2.uid;
              if (i2 && i2[o2]) {
                const n2 = i2[o2];
                n2.scaleFactor = t2.scaleFactor, n2.showCollisionBoxes = t2.showCollisionBoxes, n2.projection = t2.projection, n2.brightness = t2.brightness, n2.tileTransform = e.aW(t2.tileID.canonical, t2.projection), n2.extraShadowCaster = t2.extraShadowCaster, n2.lut = t2.lut, n2.worldview = t2.worldview;
                const r2 = (e2, t3) => {
                  const i3 = n2.reloadCallback;
                  i3 && (delete n2.reloadCallback, n2.parse(n2.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, i3)), s2(e2, t3);
                };
                "parsing" === n2.status ? n2.reloadCallback = r2 : "done" === n2.status && (n2.vectorTile ? n2.parse(n2.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, r2) : r2());
              } else s2(null, void 0);
            }
            abortTile(e2, t2) {
              const s2 = e2.uid, i2 = this.loading[s2];
              i2 && (i2.abort && i2.abort(), delete this.loading[s2]), t2();
            }
            removeTile(e2, t2) {
              const s2 = this.loaded, i2 = e2.uid;
              s2 && s2[i2] && delete s2[i2], t2();
            }
          }
          class h2 {
            loadTile(t2, s2) {
              const { uid: i2, encoding: o2, rawImageData: n2, padding: r2 } = t2, a2 = ImageBitmap && n2 instanceof ImageBitmap ? this.getImageData(n2, r2) : n2;
              s2(null, new e.fd(i2, a2, o2, r2 < 1));
            }
            reloadTile(e2, t2) {
              t2(null, null);
            }
            abortTile(e2, t2) {
              t2();
            }
            removeTile(e2, t2) {
              t2();
            }
            getImageData(e2, t2) {
              this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e2.width, e2.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", { willReadFrequently: true })), this.offscreenCanvas.width = e2.width, this.offscreenCanvas.height = e2.height, this.offscreenCanvasContext.drawImage(e2, 0, 0, e2.width, e2.height);
              const s2 = this.offscreenCanvasContext.getImageData(-t2, -t2, e2.width + 2 * t2, e2.height + 2 * t2);
              return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), s2;
            }
          }
          e.bp.setPbf(e.bq);
          class u {
            constructor(t2) {
              this._mrt = new e.bp(t2.partial ? 30 : 1 / 0), this._isHeaderLoaded = false, this.uid = t2.uid, this.tileID = t2.tileID, this.source = t2.source;
            }
            parse(t2, s2) {
              const i2 = this._mrt;
              this.status = "parsing", this._entireBuffer = t2;
              try {
                i2.parseHeader(t2), this._isHeaderLoaded = true;
                const o2 = [];
                for (const s3 in i2.layers) {
                  const n2 = i2.getLayer(s3), r2 = n2.getDataRange(n2.getBandList()), a2 = i2.createDecodingTask(r2), l2 = t2.slice(r2.firstByte, r2.lastByte + 1), c2 = e.bp.performDecoding(l2, a2).then((e2) => a2.complete(null, e2)).catch((e2) => a2.complete(e2, null));
                  o2.push(c2);
                }
                Promise.allSettled(o2).then(() => s2(null, i2)).catch((e2) => s2(e2));
              } catch (e2) {
                s2(e2);
              }
            }
          }
          class d {
            constructor(e2) {
              this.actor = e2, this.loading = {}, this.loaded = {};
            }
            loadTile(t2, s2) {
              const i2 = t2.uid, o2 = t2.request, n2 = this.loading[i2] = new u(t2), { cancel: r2 } = e.br(o2, (e2, t3, o3, r3) => {
                const a2 = !this.loading[i2];
                if (delete this.loading[i2], a2 || e2 || !t3) return n2.status = "done", a2 || (this.loaded[i2] = n2), s2(e2);
                n2.parse(t3, (e3, t4) => {
                  if (e3 || !t4) return s2(e3);
                  s2(null, t4, o3, r3);
                }), this.loaded[i2] = n2;
              });
              n2.abort = r2;
            }
            reloadTile(e2, t2) {
              t2(null, void 0);
            }
            abortTile(e2, t2) {
              const s2 = e2.uid, i2 = this.loading[s2];
              i2 && (i2.abort && i2.abort(), delete this.loading[s2]), t2();
            }
            removeTile(e2, t2) {
              const s2 = e2.uid;
              this.loaded[s2] && delete this.loaded[s2], t2();
            }
            decodeRasterArray(t2, s2) {
              e.bp.performDecoding(t2.buffer, t2.task).then((e2) => s2(null, e2)).catch((e2) => s2(e2));
            }
          }
          const f = e.fc.VectorTileFeature.prototype.toGeoJSON;
          class p2 {
            constructor(t2) {
              this._feature = t2, this.extent = e.aj, this.type = t2.type, this.properties = t2.tags, "id" in t2 && !isNaN(t2.id) && (this.id = parseInt(t2.id, 10));
            }
            loadGeometry() {
              if (1 === this._feature.type) {
                const t2 = [];
                for (const s2 of this._feature.geometry) t2.push([new e.P(s2[0], s2[1])]);
                return t2;
              }
              {
                const t2 = [];
                for (const s2 of this._feature.geometry) {
                  const i2 = [];
                  for (const t3 of s2) i2.push(new e.P(t3[0], t3[1]));
                  t2.push(i2);
                }
                return t2;
              }
            }
            toGeoJSON(e2, t2, s2) {
              return f.call(this, e2, t2, s2);
            }
          }
          class g {
            constructor(t2) {
              this.layers = { _geojsonTileLayer: this }, this.name = "_geojsonTileLayer", this.extent = e.aj, this.length = t2.length, this._features = t2;
            }
            feature(e2) {
              return new p2(this._features[e2]);
            }
          }
          class m {
            constructor(t2, s2) {
              this.name = t2, this.extent = e.aj, this.length = s2.length, this._features = s2;
            }
            feature(e2) {
              return new p2(this._features[e2]);
            }
          }
          class y extends g {
            constructor(e2) {
              super([]), this.layers = {};
              for (const t2 in e2) this.layers[t2] = new m(t2, e2[t2]);
            }
          }
          const w = 64 / 4096, v = 128;
          class x {
            constructor() {
              this.features = /* @__PURE__ */ new Map();
            }
            clear() {
              this.features.clear();
            }
            load(e2 = [], t2) {
              for (const s2 of e2) {
                const e3 = s2.id;
                if (null == e3) continue;
                let i2 = this.features.get(e3);
                i2 && this.updateCache(i2, t2), s2.geometry ? (i2 = I(s2), this.updateCache(i2, t2), this.features.set(e3, i2)) : this.features.delete(e3), this.updateCache(i2, t2);
              }
            }
            updateCache(e2, t2) {
              for (const { canonical: s2, uid: i2 } of Object.values(t2)) {
                const { z: o2, x: n2, y: r2 } = s2;
                b(e2, Math.pow(2, o2), n2, r2) && delete t2[i2];
              }
            }
            getTile(e2, t2, s2) {
              const i2 = Math.pow(2, e2), o2 = [];
              for (const e3 of this.features.values()) b(e3, i2, t2, s2) && o2.push(T(e3, i2, t2, s2));
              return { features: o2 };
            }
            getFeatures() {
              return [...this.features.values()];
            }
          }
          function b({ minX: e2, minY: t2, maxX: s2, maxY: i2 }, o2, n2, r2) {
            return e2 < (n2 + 1 + w) / o2 && t2 < (r2 + 1 + w) / o2 && s2 > (n2 - w) / o2 && i2 > (r2 - w) / o2;
          }
          function I(e2) {
            const { id: t2, geometry: s2, properties: i2 } = e2;
            if (!s2) return;
            if ("GeometryCollection" === s2.type) throw new Error("GeometryCollection not supported in dynamic mode.");
            const { type: o2, coordinates: n2 } = s2, r2 = { id: t2, type: 1, geometry: [], tags: i2, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 }, a2 = r2.geometry;
            if ("Point" === o2) S(n2, a2, r2);
            else if ("MultiPoint" === o2) for (const e3 of n2) S(e3, a2, r2);
            else if ("LineString" === o2) r2.type = 2, M(n2, a2, r2);
            else if ("MultiLineString" === o2) r2.type = 2, P(n2, a2, r2);
            else if ("Polygon" === o2) r2.type = 3, P(n2, a2, r2, true);
            else {
              if ("MultiPolygon" !== o2) throw new Error("Input data is not a valid GeoJSON object.");
              r2.type = 3;
              for (const e3 of n2) P(e3, a2, r2, true);
            }
            return r2;
          }
          function S([t2, s2], i2, o2) {
            const n2 = e.aD(t2);
            let r2 = e.aH(s2);
            r2 = r2 < 0 ? 0 : r2 > 1 ? 1 : r2, i2.push(n2, r2), o2.minX = Math.min(o2.minX, n2), o2.minY = Math.min(o2.minY, r2), o2.maxX = Math.max(o2.maxX, n2), o2.maxY = Math.max(o2.maxY, r2);
          }
          function M(e2, t2, s2, i2 = false, o2 = false) {
            const n2 = [];
            for (const t3 of e2) S(t3, n2, s2);
            t2.push(n2), i2 && function(e3, t3) {
              let s3 = 0;
              for (let t4 = 0, i3 = e3.length, o3 = i3 - 2; t4 < i3; o3 = t4, t4 += 2) s3 += (e3[t4] - e3[o3]) * (e3[t4 + 1] + e3[o3 + 1]);
              if (s3 > 0 === t3) for (let t4 = 0, s4 = e3.length; t4 < s4 / 2; t4 += 2) {
                const i3 = e3[t4], o3 = e3[t4 + 1];
                e3[t4] = e3[s4 - 2 - t4], e3[t4 + 1] = e3[s4 - 1 - t4], e3[s4 - 2 - t4] = i3, e3[s4 - 1 - t4] = o3;
              }
            }(n2, o2);
          }
          function P(e2, t2, s2, i2 = false) {
            for (let o2 = 0; o2 < e2.length; o2++) M(e2[o2], t2, s2, i2, 0 === o2);
          }
          function T(t2, s2, i2, o2) {
            const { id: n2, type: r2, geometry: a2, tags: l2 } = t2, c2 = [];
            if (1 === r2) !function(t3, s3, i3, o3, n3) {
              for (let r3 = 0; r3 < t3.length; r3 += 2) {
                const a3 = Math.round(e.aj * (t3[r3 + 0] * s3 - i3)), l3 = Math.round(e.aj * (t3[r3 + 1] * s3 - o3));
                n3.push([a3, l3]);
              }
            }(a2, s2, i2, o2, c2);
            else for (const e2 of a2) k(e2, s2, i2, o2, c2);
            return { id: n2, type: r2, geometry: c2, tags: l2 };
          }
          function k(t2, s2, i2, o2, n2) {
            const r2 = -128, a2 = e.aj + v;
            let l2;
            for (let c2 = 0; c2 < t2.length - 2; c2 += 2) {
              let h3 = Math.round(e.aj * (t2[c2 + 0] * s2 - i2)), u2 = Math.round(e.aj * (t2[c2 + 1] * s2 - o2)), d2 = Math.round(e.aj * (t2[c2 + 2] * s2 - i2)), f2 = Math.round(e.aj * (t2[c2 + 3] * s2 - o2));
              const p3 = d2 - h3, g2 = f2 - u2;
              h3 < r2 && d2 < r2 || (h3 < r2 ? (u2 += Math.round(g2 * ((r2 - h3) / p3)), h3 = r2) : d2 < r2 && (f2 = u2 + Math.round(g2 * ((r2 - h3) / p3)), d2 = r2), u2 < r2 && f2 < r2 || (u2 < r2 ? (h3 += Math.round(p3 * ((r2 - u2) / g2)), u2 = r2) : f2 < r2 && (d2 = h3 + Math.round(p3 * ((r2 - u2) / g2)), f2 = r2), h3 >= a2 && d2 >= a2 || (h3 >= a2 ? (u2 += Math.round(g2 * ((a2 - h3) / p3)), h3 = a2) : d2 >= a2 && (f2 = u2 + Math.round(g2 * ((a2 - h3) / p3)), d2 = a2), u2 >= a2 && f2 >= a2 || (u2 >= a2 ? (h3 += Math.round(p3 * ((a2 - u2) / g2)), u2 = a2) : f2 >= a2 && (d2 = h3 + Math.round(p3 * ((a2 - u2) / g2)), f2 = a2), l2 && h3 === l2[l2.length - 1][0] && u2 === l2[l2.length - 1][1] || (l2 = [[h3, u2]], n2.push(l2)), l2.push([d2, f2])))));
            }
          }
          var L, _, C, j = { exports: {} }, D = function() {
            if (C) return j.exports;
            C = 1;
            var t2 = e.fg(), s2 = function() {
              if (_) return L;
              _ = 1;
              var t3 = e.fe(), s3 = e.ff().VectorTileFeature;
              function i3(e2, t4) {
                this.options = t4 || {}, this.features = e2, this.length = e2.length;
              }
              function o3(e2, t4) {
                this.id = "number" == typeof e2.id ? e2.id : void 0, this.type = e2.type, this.rawGeometry = 1 === e2.type ? [e2.geometry] : e2.geometry, this.properties = e2.tags, this.extent = t4 || 4096;
              }
              return L = i3, i3.prototype.feature = function(e2) {
                return new o3(this.features[e2], this.options.extent);
              }, o3.prototype.loadGeometry = function() {
                var e2 = this.rawGeometry;
                this.geometry = [];
                for (var s4 = 0; s4 < e2.length; s4++) {
                  for (var i4 = e2[s4], o4 = [], n3 = 0; n3 < i4.length; n3++) o4.push(new t3(i4[n3][0], i4[n3][1]));
                  this.geometry.push(o4);
                }
                return this.geometry;
              }, o3.prototype.bbox = function() {
                this.geometry || this.loadGeometry();
                for (var e2 = this.geometry, t4 = 1 / 0, s4 = -1 / 0, i4 = 1 / 0, o4 = -1 / 0, n3 = 0; n3 < e2.length; n3++) for (var r3 = e2[n3], a3 = 0; a3 < r3.length; a3++) {
                  var l3 = r3[a3];
                  t4 = Math.min(t4, l3.x), s4 = Math.max(s4, l3.x), i4 = Math.min(i4, l3.y), o4 = Math.max(o4, l3.y);
                }
                return [t4, i4, s4, o4];
              }, o3.prototype.toGeoJSON = s3.prototype.toGeoJSON, L;
            }();
            function i2(e2) {
              var s3 = new t2();
              return function(e3, t3) {
                for (var s4 in e3.layers) t3.writeMessage(3, o2, e3.layers[s4]);
              }(e2, s3), s3.finish();
            }
            function o2(e2, t3) {
              var s3;
              t3.writeVarintField(15, e2.version || 1), t3.writeStringField(1, e2.name || ""), t3.writeVarintField(5, e2.extent || 4096);
              var i3 = { keys: [], values: [], keycache: {}, valuecache: {} };
              for (s3 = 0; s3 < e2.length; s3++) i3.feature = e2.feature(s3), t3.writeMessage(2, n2, i3);
              var o3 = i3.keys;
              for (s3 = 0; s3 < o3.length; s3++) t3.writeStringField(3, o3[s3]);
              var r3 = i3.values;
              for (s3 = 0; s3 < r3.length; s3++) t3.writeMessage(4, h3, r3[s3]);
            }
            function n2(e2, t3) {
              var s3 = e2.feature;
              void 0 !== s3.id && t3.writeVarintField(1, s3.id), t3.writeMessage(2, r2, e2), t3.writeVarintField(3, s3.type), t3.writeMessage(4, c2, s3);
            }
            function r2(e2, t3) {
              var s3 = e2.feature, i3 = e2.keys, o3 = e2.values, n3 = e2.keycache, r3 = e2.valuecache;
              for (var a3 in s3.properties) {
                var l3 = s3.properties[a3], c3 = n3[a3];
                if (null !== l3) {
                  void 0 === c3 && (i3.push(a3), n3[a3] = c3 = i3.length - 1), t3.writeVarint(c3);
                  var h4 = typeof l3;
                  "string" !== h4 && "boolean" !== h4 && "number" !== h4 && (l3 = JSON.stringify(l3));
                  var u2 = h4 + ":" + l3, d2 = r3[u2];
                  void 0 === d2 && (o3.push(l3), r3[u2] = d2 = o3.length - 1), t3.writeVarint(d2);
                }
              }
            }
            function a2(e2, t3) {
              return (t3 << 3) + (7 & e2);
            }
            function l2(e2) {
              return e2 << 1 ^ e2 >> 31;
            }
            function c2(e2, t3) {
              for (var s3 = e2.loadGeometry(), i3 = e2.type, o3 = 0, n3 = 0, r3 = s3.length, c3 = 0; c3 < r3; c3++) {
                var h4 = s3[c3], u2 = 1;
                1 === i3 && (u2 = h4.length), t3.writeVarint(a2(1, u2));
                for (var d2 = 3 === i3 ? h4.length - 1 : h4.length, f2 = 0; f2 < d2; f2++) {
                  1 === f2 && 1 !== i3 && t3.writeVarint(a2(2, d2 - 1));
                  var p3 = h4[f2].x - o3, g2 = h4[f2].y - n3;
                  t3.writeVarint(l2(p3)), t3.writeVarint(l2(g2)), o3 += p3, n3 += g2;
                }
                3 === i3 && t3.writeVarint(a2(7, 1));
              }
            }
            function h3(e2, t3) {
              var s3 = typeof e2;
              "string" === s3 ? t3.writeStringField(1, e2) : "boolean" === s3 ? t3.writeBooleanField(7, e2) : "number" === s3 && (e2 % 1 != 0 ? t3.writeDoubleField(3, e2) : e2 < 0 ? t3.writeSVarintField(6, e2) : t3.writeVarintField(5, e2));
            }
            return j.exports = i2, j.exports.fromVectorTileJs = i2, j.exports.fromGeojsonVt = function(e2, t3) {
              t3 = t3 || {};
              var o3 = {};
              for (var n3 in e2) o3[n3] = new s2(e2[n3].features, t3), o3[n3].name = n3, o3[n3].version = t3.version, o3[n3].extent = t3.extent;
              return i2({ layers: o3 });
            }, j.exports.GeoJSONWrapper = s2, j.exports;
          }(), z = e.fh(D);
          const O = { minZoom: 0, maxZoom: 16, minPoints: 2, radius: 40, extent: 512, nodeSize: 64, log: false, generateId: false, reduce: null, map: (e2) => e2 }, F = Math.fround || (A = new Float32Array(1), (e2) => (A[0] = +e2, A[0]));
          var A;
          const Z = 3, N = 5, B = 6;
          class R {
            constructor(e2) {
              this.options = Object.assign(Object.create(O), e2), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e2) {
              const { log: t2, minZoom: s2, maxZoom: i2 } = this.options;
              t2 && console.time("total time");
              const o2 = `prepare ${e2.length} points`;
              t2 && console.time(o2), this.points = e2;
              const n2 = [];
              for (let t3 = 0; t3 < e2.length; t3++) {
                const s3 = e2[t3];
                if (!s3.geometry) continue;
                const [i3, o3] = s3.geometry.coordinates, r3 = F(Y(i3)), a2 = F(G(o3));
                n2.push(r3, a2, 1 / 0, t3, -1, 1), this.options.reduce && n2.push(0);
              }
              let r2 = this.trees[i2 + 1] = this._createTree(n2);
              t2 && console.timeEnd(o2);
              for (let e3 = i2; e3 >= s2; e3--) {
                const s3 = +Date.now();
                r2 = this.trees[e3] = this._createTree(this._cluster(r2, e3)), t2 && console.log("z%d: %d clusters in %dms", e3, r2.numItems, +Date.now() - s3);
              }
              return t2 && console.timeEnd("total time"), this;
            }
            getClusters(e2, t2) {
              let s2 = ((e2[0] + 180) % 360 + 360) % 360 - 180;
              const i2 = Math.max(-90, Math.min(90, e2[1]));
              let o2 = 180 === e2[2] ? 180 : ((e2[2] + 180) % 360 + 360) % 360 - 180;
              const n2 = Math.max(-90, Math.min(90, e2[3]));
              if (e2[2] - e2[0] >= 360) s2 = -180, o2 = 180;
              else if (s2 > o2) {
                const e3 = this.getClusters([s2, i2, 180, n2], t2), r3 = this.getClusters([-180, i2, o2, n2], t2);
                return e3.concat(r3);
              }
              const r2 = this.trees[this._limitZoom(t2)], a2 = r2.range(Y(s2), G(n2), Y(o2), G(i2)), l2 = r2.data, c2 = [];
              for (const e3 of a2) {
                const t3 = this.stride * e3;
                c2.push(l2[t3 + N] > 1 ? X(l2, t3, this.clusterProps) : this.points[l2[t3 + Z]]);
              }
              return c2;
            }
            getChildren(e2) {
              const t2 = this._getOriginId(e2), s2 = this._getOriginZoom(e2), i2 = "No cluster with the specified id.", o2 = this.trees[s2];
              if (!o2) throw new Error(i2);
              const n2 = o2.data;
              if (t2 * this.stride >= n2.length) throw new Error(i2);
              const r2 = this.options.radius / (this.options.extent * Math.pow(2, s2 - 1)), a2 = o2.within(n2[t2 * this.stride], n2[t2 * this.stride + 1], r2), l2 = [];
              for (const t3 of a2) {
                const s3 = t3 * this.stride;
                n2[s3 + 4] === e2 && l2.push(n2[s3 + N] > 1 ? X(n2, s3, this.clusterProps) : this.points[n2[s3 + Z]]);
              }
              if (0 === l2.length) throw new Error(i2);
              return l2;
            }
            getLeaves(e2, t2, s2) {
              const i2 = [];
              return this._appendLeaves(i2, e2, t2 = t2 || 10, s2 = s2 || 0, 0), i2;
            }
            getTile(e2, t2, s2) {
              const i2 = this.trees[this._limitZoom(e2)], o2 = Math.pow(2, e2), { extent: n2, radius: r2 } = this.options, a2 = r2 / n2, l2 = (s2 - a2) / o2, c2 = (s2 + 1 + a2) / o2, h3 = { features: [] };
              return this._addTileFeatures(i2.range((t2 - a2) / o2, l2, (t2 + 1 + a2) / o2, c2), i2.data, t2, s2, o2, h3), 0 === t2 && this._addTileFeatures(i2.range(1 - a2 / o2, l2, 1, c2), i2.data, o2, s2, o2, h3), t2 === o2 - 1 && this._addTileFeatures(i2.range(0, l2, a2 / o2, c2), i2.data, -1, s2, o2, h3), h3.features.length ? h3 : null;
            }
            getClusterExpansionZoom(e2) {
              let t2 = this._getOriginZoom(e2) - 1;
              for (; t2 <= this.options.maxZoom; ) {
                const s2 = this.getChildren(e2);
                if (t2++, 1 !== s2.length) break;
                e2 = s2[0].properties.cluster_id;
              }
              return t2;
            }
            _appendLeaves(e2, t2, s2, i2, o2) {
              const n2 = this.getChildren(t2);
              for (const t3 of n2) {
                const n3 = t3.properties;
                if (n3 && n3.cluster ? o2 + n3.point_count <= i2 ? o2 += n3.point_count : o2 = this._appendLeaves(e2, n3.cluster_id, s2, i2, o2) : o2 < i2 ? o2++ : e2.push(t3), e2.length === s2) break;
              }
              return o2;
            }
            _createTree(t2) {
              const s2 = new e.bW(t2.length / this.stride | 0, this.options.nodeSize, Float32Array);
              for (let e2 = 0; e2 < t2.length; e2 += this.stride) s2.add(t2[e2], t2[e2 + 1]);
              return s2.finish(), s2.data = t2, s2;
            }
            _addTileFeatures(e2, t2, s2, i2, o2, n2) {
              for (const r2 of e2) {
                const e3 = r2 * this.stride, a2 = t2[e3 + N] > 1;
                let l2, c2, h3;
                if (a2) l2 = E(t2, e3, this.clusterProps), c2 = t2[e3], h3 = t2[e3 + 1];
                else {
                  const s3 = this.points[t2[e3 + Z]];
                  l2 = s3.properties;
                  const [i3, o3] = s3.geometry.coordinates;
                  c2 = Y(i3), h3 = G(o3);
                }
                const u2 = { type: 1, geometry: [[Math.round(this.options.extent * (c2 * o2 - s2)), Math.round(this.options.extent * (h3 * o2 - i2))]], tags: l2 };
                let d2;
                d2 = a2 || this.options.generateId ? t2[e3 + Z] : this.points[t2[e3 + Z]].id, void 0 !== d2 && (u2.id = d2), n2.features.push(u2);
              }
            }
            _limitZoom(e2) {
              return Math.max(this.options.minZoom, Math.min(Math.floor(+e2), this.options.maxZoom + 1));
            }
            _cluster(e2, t2) {
              const { radius: s2, extent: i2, reduce: o2, minPoints: n2 } = this.options, r2 = s2 / (i2 * Math.pow(2, t2)), a2 = e2.data, l2 = [], c2 = this.stride;
              for (let s3 = 0; s3 < a2.length; s3 += c2) {
                if (a2[s3 + 2] <= t2) continue;
                a2[s3 + 2] = t2;
                const i3 = a2[s3], h3 = a2[s3 + 1], u2 = e2.within(a2[s3], a2[s3 + 1], r2), d2 = a2[s3 + N];
                let f2 = d2;
                for (const e3 of u2) {
                  const s4 = e3 * c2;
                  a2[s4 + 2] > t2 && (f2 += a2[s4 + N]);
                }
                if (f2 > d2 && f2 >= n2) {
                  let e3, n3 = i3 * d2, r3 = h3 * d2, p3 = -1;
                  const g2 = (s3 / c2 << 5) + (t2 + 1) + this.points.length;
                  for (const i4 of u2) {
                    const l3 = i4 * c2;
                    if (a2[l3 + 2] <= t2) continue;
                    a2[l3 + 2] = t2;
                    const h4 = a2[l3 + N];
                    n3 += a2[l3] * h4, r3 += a2[l3 + 1] * h4, a2[l3 + 4] = g2, o2 && (e3 || (e3 = this._map(a2, s3, true), p3 = this.clusterProps.length, this.clusterProps.push(e3)), o2(e3, this._map(a2, l3)));
                  }
                  a2[s3 + 4] = g2, l2.push(n3 / f2, r3 / f2, 1 / 0, g2, -1, f2), o2 && l2.push(p3);
                } else {
                  for (let e3 = 0; e3 < c2; e3++) l2.push(a2[s3 + e3]);
                  if (f2 > 1) for (const e3 of u2) {
                    const s4 = e3 * c2;
                    if (!(a2[s4 + 2] <= t2)) {
                      a2[s4 + 2] = t2;
                      for (let e4 = 0; e4 < c2; e4++) l2.push(a2[s4 + e4]);
                    }
                  }
                }
              }
              return l2;
            }
            _getOriginId(e2) {
              return e2 - this.points.length >> 5;
            }
            _getOriginZoom(e2) {
              return (e2 - this.points.length) % 32;
            }
            _map(e2, t2, s2) {
              if (e2[t2 + N] > 1) {
                const i3 = this.clusterProps[e2[t2 + B]];
                return s2 ? Object.assign({}, i3) : i3;
              }
              const i2 = this.points[e2[t2 + Z]].properties, o2 = this.options.map(i2);
              return s2 && o2 === i2 ? Object.assign({}, o2) : o2;
            }
          }
          function X(e2, t2, s2) {
            return { type: "Feature", id: e2[t2 + Z], properties: E(e2, t2, s2), geometry: { type: "Point", coordinates: [(i2 = e2[t2], 360 * (i2 - 0.5)), J(e2[t2 + 1])] } };
            var i2;
          }
          function E(e2, t2, s2) {
            const i2 = e2[t2 + N], o2 = i2 >= 1e4 ? `${Math.round(i2 / 1e3)}k` : i2 >= 1e3 ? Math.round(i2 / 100) / 10 + "k" : i2, n2 = e2[t2 + B], r2 = -1 === n2 ? {} : Object.assign({}, s2[n2]);
            return Object.assign(r2, { cluster: true, cluster_id: e2[t2 + Z], point_count: i2, point_count_abbreviated: o2 });
          }
          function Y(e2) {
            return e2 / 360 + 0.5;
          }
          function G(e2) {
            const t2 = Math.sin(e2 * Math.PI / 180), s2 = 0.5 - 0.25 * Math.log((1 + t2) / (1 - t2)) / Math.PI;
            return s2 < 0 ? 0 : s2 > 1 ? 1 : s2;
          }
          function J(e2) {
            const t2 = (180 - 360 * e2) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t2)) / Math.PI - 90;
          }
          function V(e2, t2, s2, i2) {
            let o2 = i2;
            const n2 = t2 + (s2 - t2 >> 1);
            let r2, a2 = s2 - t2;
            const l2 = e2[t2], c2 = e2[t2 + 1], h3 = e2[s2], u2 = e2[s2 + 1];
            for (let i3 = t2 + 3; i3 < s2; i3 += 3) {
              const t3 = $(e2[i3], e2[i3 + 1], l2, c2, h3, u2);
              if (t3 > o2) r2 = i3, o2 = t3;
              else if (t3 === o2) {
                const e3 = Math.abs(i3 - n2);
                e3 < a2 && (r2 = i3, a2 = e3);
              }
            }
            o2 > i2 && (r2 - t2 > 3 && V(e2, t2, r2, i2), e2[r2 + 2] = o2, s2 - r2 > 3 && V(e2, r2, s2, i2));
          }
          function $(e2, t2, s2, i2, o2, n2) {
            let r2 = o2 - s2, a2 = n2 - i2;
            if (0 !== r2 || 0 !== a2) {
              const l2 = ((e2 - s2) * r2 + (t2 - i2) * a2) / (r2 * r2 + a2 * a2);
              l2 > 1 ? (s2 = o2, i2 = n2) : l2 > 0 && (s2 += r2 * l2, i2 += a2 * l2);
            }
            return r2 = e2 - s2, a2 = t2 - i2, r2 * r2 + a2 * a2;
          }
          function U(e2, t2, s2, i2) {
            const o2 = { id: e2 ?? null, type: t2, geometry: s2, tags: i2, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
            if ("Point" === t2 || "MultiPoint" === t2 || "LineString" === t2) W(o2, s2);
            else if ("Polygon" === t2) W(o2, s2[0]);
            else if ("MultiLineString" === t2) for (const e3 of s2) W(o2, e3);
            else if ("MultiPolygon" === t2) for (const e3 of s2) W(o2, e3[0]);
            return o2;
          }
          function W(e2, t2) {
            for (let s2 = 0; s2 < t2.length; s2 += 3) e2.minX = Math.min(e2.minX, t2[s2]), e2.minY = Math.min(e2.minY, t2[s2 + 1]), e2.maxX = Math.max(e2.maxX, t2[s2]), e2.maxY = Math.max(e2.maxY, t2[s2 + 1]);
          }
          function q(e2, t2, s2, i2) {
            if (!t2.geometry) return;
            const o2 = t2.geometry.coordinates;
            if (o2 && 0 === o2.length) return;
            const n2 = t2.geometry.type, r2 = Math.pow(s2.tolerance / ((1 << s2.maxZoom) * s2.extent), 2);
            let a2 = [], l2 = t2.id;
            if (s2.promoteId ? l2 = t2.properties[s2.promoteId] : s2.generateId && (l2 = i2 || 0), "Point" === n2) H(o2, a2);
            else if ("MultiPoint" === n2) for (const e3 of o2) H(e3, a2);
            else if ("LineString" === n2) Q(o2, a2, r2, false);
            else if ("MultiLineString" === n2) {
              if (s2.lineMetrics) {
                for (const s3 of o2) a2 = [], Q(s3, a2, r2, false), e2.push(U(l2, "LineString", a2, t2.properties));
                return;
              }
              K(o2, a2, r2, false);
            } else if ("Polygon" === n2) K(o2, a2, r2, true);
            else {
              if ("MultiPolygon" !== n2) {
                if ("GeometryCollection" === n2) {
                  for (const o3 of t2.geometry.geometries) q(e2, { id: l2, geometry: o3, properties: t2.properties }, s2, i2);
                  return;
                }
                throw new Error("Input data is not a valid GeoJSON object.");
              }
              for (const e3 of o2) {
                const t3 = [];
                K(e3, t3, r2, true), a2.push(t3);
              }
            }
            e2.push(U(l2, n2, a2, t2.properties));
          }
          function H(e2, t2) {
            t2.push(ee(e2[0]), te(e2[1]), 0);
          }
          function Q(e2, t2, s2, i2) {
            let o2, n2, r2 = 0;
            for (let s3 = 0; s3 < e2.length; s3++) {
              const a3 = ee(e2[s3][0]), l2 = te(e2[s3][1]);
              t2.push(a3, l2, 0), s3 > 0 && (r2 += i2 ? (o2 * l2 - a3 * n2) / 2 : Math.sqrt(Math.pow(a3 - o2, 2) + Math.pow(l2 - n2, 2))), o2 = a3, n2 = l2;
            }
            const a2 = t2.length - 3;
            t2[2] = 1, V(t2, 0, a2, s2), t2[a2 + 2] = 1, t2.size = Math.abs(r2), t2.start = 0, t2.end = t2.size;
          }
          function K(e2, t2, s2, i2) {
            for (let o2 = 0; o2 < e2.length; o2++) {
              const n2 = [];
              Q(e2[o2], n2, s2, i2), t2.push(n2);
            }
          }
          function ee(e2) {
            return e2 / 360 + 0.5;
          }
          function te(e2) {
            const t2 = Math.sin(e2 * Math.PI / 180), s2 = 0.5 - 0.25 * Math.log((1 + t2) / (1 - t2)) / Math.PI;
            return s2 < 0 ? 0 : s2 > 1 ? 1 : s2;
          }
          function se(e2, t2, s2, i2, o2, n2, r2, a2) {
            if (i2 /= t2, n2 >= (s2 /= t2) && r2 < i2) return e2;
            if (r2 < s2 || n2 >= i2) return null;
            const l2 = [];
            for (const t3 of e2) {
              const e3 = t3.geometry;
              let n3 = t3.type;
              const r3 = 0 === o2 ? t3.minX : t3.minY, c2 = 0 === o2 ? t3.maxX : t3.maxY;
              if (r3 >= s2 && c2 < i2) {
                l2.push(t3);
                continue;
              }
              if (c2 < s2 || r3 >= i2) continue;
              let h3 = [];
              if ("Point" === n3 || "MultiPoint" === n3) ie(e3, h3, s2, i2, o2);
              else if ("LineString" === n3) oe(e3, h3, s2, i2, o2, false, a2.lineMetrics);
              else if ("MultiLineString" === n3) re(e3, h3, s2, i2, o2, false);
              else if ("Polygon" === n3) re(e3, h3, s2, i2, o2, true);
              else if ("MultiPolygon" === n3) for (const t4 of e3) {
                const e4 = [];
                re(t4, e4, s2, i2, o2, true), e4.length && h3.push(e4);
              }
              if (h3.length) {
                if (a2.lineMetrics && "LineString" === n3) {
                  for (const e4 of h3) l2.push(U(t3.id, n3, e4, t3.tags));
                  continue;
                }
                "LineString" !== n3 && "MultiLineString" !== n3 || (1 === h3.length ? (n3 = "LineString", h3 = h3[0]) : n3 = "MultiLineString"), "Point" !== n3 && "MultiPoint" !== n3 || (n3 = 3 === h3.length ? "Point" : "MultiPoint"), l2.push(U(t3.id, n3, h3, t3.tags));
              }
            }
            return l2.length ? l2 : null;
          }
          function ie(e2, t2, s2, i2, o2) {
            for (let n2 = 0; n2 < e2.length; n2 += 3) {
              const r2 = e2[n2 + o2];
              r2 >= s2 && r2 <= i2 && ae(t2, e2[n2], e2[n2 + 1], e2[n2 + 2]);
            }
          }
          function oe(e2, t2, s2, i2, o2, n2, r2) {
            let a2 = ne(e2);
            const l2 = 0 === o2 ? le : ce;
            let c2, h3, u2 = e2.start;
            for (let d3 = 0; d3 < e2.length - 3; d3 += 3) {
              const f3 = e2[d3], p4 = e2[d3 + 1], g3 = e2[d3 + 2], m2 = e2[d3 + 3], y2 = e2[d3 + 4], w2 = 0 === o2 ? f3 : p4, v2 = 0 === o2 ? m2 : y2;
              let x2 = false;
              r2 && (c2 = Math.sqrt(Math.pow(f3 - m2, 2) + Math.pow(p4 - y2, 2))), w2 < s2 ? v2 > s2 && (h3 = l2(a2, f3, p4, m2, y2, s2), r2 && (a2.start = u2 + c2 * h3)) : w2 > i2 ? v2 < i2 && (h3 = l2(a2, f3, p4, m2, y2, i2), r2 && (a2.start = u2 + c2 * h3)) : ae(a2, f3, p4, g3), v2 < s2 && w2 >= s2 && (h3 = l2(a2, f3, p4, m2, y2, s2), x2 = true), v2 > i2 && w2 <= i2 && (h3 = l2(a2, f3, p4, m2, y2, i2), x2 = true), !n2 && x2 && (r2 && (a2.end = u2 + c2 * h3), t2.push(a2), a2 = ne(e2)), r2 && (u2 += c2);
            }
            let d2 = e2.length - 3;
            const f2 = e2[d2], p3 = e2[d2 + 1], g2 = 0 === o2 ? f2 : p3;
            g2 >= s2 && g2 <= i2 && ae(a2, f2, p3, e2[d2 + 2]), d2 = a2.length - 3, n2 && d2 >= 3 && (a2[d2] !== a2[0] || a2[d2 + 1] !== a2[1]) && ae(a2, a2[0], a2[1], a2[2]), a2.length && t2.push(a2);
          }
          function ne(e2) {
            const t2 = [];
            return t2.size = e2.size, t2.start = e2.start, t2.end = e2.end, t2;
          }
          function re(e2, t2, s2, i2, o2, n2) {
            for (const r2 of e2) oe(r2, t2, s2, i2, o2, n2, false);
          }
          function ae(e2, t2, s2, i2) {
            e2.push(t2, s2, i2);
          }
          function le(e2, t2, s2, i2, o2, n2) {
            const r2 = (n2 - t2) / (i2 - t2);
            return ae(e2, n2, s2 + (o2 - s2) * r2, 1), r2;
          }
          function ce(e2, t2, s2, i2, o2, n2) {
            const r2 = (n2 - s2) / (o2 - s2);
            return ae(e2, t2 + (i2 - t2) * r2, n2, 1), r2;
          }
          function he(e2, t2) {
            const s2 = [];
            for (let i2 = 0; i2 < e2.length; i2++) {
              const o2 = e2[i2], n2 = o2.type;
              let r2;
              if ("Point" === n2 || "MultiPoint" === n2 || "LineString" === n2) r2 = ue(o2.geometry, t2);
              else if ("MultiLineString" === n2 || "Polygon" === n2) {
                r2 = [];
                for (const e3 of o2.geometry) r2.push(ue(e3, t2));
              } else if ("MultiPolygon" === n2) {
                r2 = [];
                for (const e3 of o2.geometry) {
                  const s3 = [];
                  for (const i3 of e3) s3.push(ue(i3, t2));
                  r2.push(s3);
                }
              }
              s2.push(U(o2.id, n2, r2, o2.tags));
            }
            return s2;
          }
          function ue(e2, t2) {
            const s2 = [];
            s2.size = e2.size, void 0 !== e2.start && (s2.start = e2.start, s2.end = e2.end);
            for (let i2 = 0; i2 < e2.length; i2 += 3) s2.push(e2[i2] + t2, e2[i2 + 1], e2[i2 + 2]);
            return s2;
          }
          function de2(e2, t2) {
            if (e2.transformed) return e2;
            const s2 = 1 << e2.z, i2 = e2.x, o2 = e2.y;
            for (const n2 of e2.features) {
              const e3 = n2.geometry, r2 = n2.type;
              if (n2.geometry = [], 1 === r2) for (let r3 = 0; r3 < e3.length; r3 += 2) n2.geometry.push(fe(e3[r3], e3[r3 + 1], t2, s2, i2, o2));
              else for (let r3 = 0; r3 < e3.length; r3++) {
                const a2 = [];
                for (let n3 = 0; n3 < e3[r3].length; n3 += 2) a2.push(fe(e3[r3][n3], e3[r3][n3 + 1], t2, s2, i2, o2));
                n2.geometry.push(a2);
              }
            }
            return e2.transformed = true, e2;
          }
          function fe(e2, t2, s2, i2, o2, n2) {
            return [Math.round(s2 * (e2 * i2 - o2)), Math.round(s2 * (t2 * i2 - n2))];
          }
          function pe(e2, t2, s2, i2, o2) {
            const n2 = t2 === o2.maxZoom ? 0 : o2.tolerance / ((1 << t2) * o2.extent), r2 = { features: [], numPoints: 0, numSimplified: 0, numFeatures: e2.length, source: null, x: s2, y: i2, z: t2, transformed: false, minX: 2, minY: 1, maxX: -1, maxY: 0 };
            for (const t3 of e2) ge(r2, t3, n2, o2);
            return r2;
          }
          function ge(e2, t2, s2, i2) {
            const o2 = t2.geometry, n2 = t2.type, r2 = [];
            if (e2.minX = Math.min(e2.minX, t2.minX), e2.minY = Math.min(e2.minY, t2.minY), e2.maxX = Math.max(e2.maxX, t2.maxX), e2.maxY = Math.max(e2.maxY, t2.maxY), "Point" === n2 || "MultiPoint" === n2) for (let t3 = 0; t3 < o2.length; t3 += 3) r2.push(o2[t3], o2[t3 + 1]), e2.numPoints++, e2.numSimplified++;
            else if ("LineString" === n2) me(r2, o2, e2, s2, false, false);
            else if ("MultiLineString" === n2 || "Polygon" === n2) for (let t3 = 0; t3 < o2.length; t3++) me(r2, o2[t3], e2, s2, "Polygon" === n2, 0 === t3);
            else if ("MultiPolygon" === n2) for (let t3 = 0; t3 < o2.length; t3++) {
              const i3 = o2[t3];
              for (let t4 = 0; t4 < i3.length; t4++) me(r2, i3[t4], e2, s2, true, 0 === t4);
            }
            if (r2.length) {
              let s3 = t2.tags || null;
              if ("LineString" === n2 && i2.lineMetrics) {
                s3 = {};
                for (const e3 in t2.tags) s3[e3] = t2.tags[e3];
                s3.mapbox_clip_start = o2.start / o2.size, s3.mapbox_clip_end = o2.end / o2.size;
              }
              const a2 = { geometry: r2, type: "Polygon" === n2 || "MultiPolygon" === n2 ? 3 : "LineString" === n2 || "MultiLineString" === n2 ? 2 : 1, tags: s3 };
              null !== t2.id && (a2.id = t2.id), e2.features.push(a2);
            }
          }
          function me(e2, t2, s2, i2, o2, n2) {
            const r2 = i2 * i2;
            if (i2 > 0 && t2.size < (o2 ? r2 : i2)) return void (s2.numPoints += t2.length / 3);
            const a2 = [];
            for (let e3 = 0; e3 < t2.length; e3 += 3) (0 === i2 || t2[e3 + 2] > r2) && (s2.numSimplified++, a2.push(t2[e3], t2[e3 + 1])), s2.numPoints++;
            o2 && function(e3, t3) {
              let s3 = 0;
              for (let t4 = 0, i3 = e3.length, o3 = i3 - 2; t4 < i3; o3 = t4, t4 += 2) s3 += (e3[t4] - e3[o3]) * (e3[t4 + 1] + e3[o3 + 1]);
              if (s3 > 0 === t3) for (let t4 = 0, s4 = e3.length; t4 < s4 / 2; t4 += 2) {
                const i3 = e3[t4], o3 = e3[t4 + 1];
                e3[t4] = e3[s4 - 2 - t4], e3[t4 + 1] = e3[s4 - 1 - t4], e3[s4 - 2 - t4] = i3, e3[s4 - 1 - t4] = o3;
              }
            }(a2, n2), e2.push(a2);
          }
          const ye = { maxZoom: 14, indexMaxZoom: 5, indexMaxPoints: 1e5, tolerance: 3, extent: 4096, buffer: 64, lineMetrics: false, promoteId: null, generateId: false, debug: 0 };
          class we {
            constructor(e2, t2) {
              const s2 = (t2 = this.options = function(e3, t3) {
                for (const s3 in t3) e3[s3] = t3[s3];
                return e3;
              }(Object.create(ye), t2)).debug;
              if (s2 && console.time("preprocess data"), t2.maxZoom < 0 || t2.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
              if (t2.promoteId && t2.generateId) throw new Error("promoteId and generateId cannot be used together.");
              let i2 = function(e3, t3) {
                const s3 = [];
                if ("FeatureCollection" === e3.type) for (let i3 = 0; i3 < e3.features.length; i3++) q(s3, e3.features[i3], t3, i3);
                else q(s3, "Feature" === e3.type ? e3 : { geometry: e3 }, t3);
                return s3;
              }(e2, t2);
              this.tiles = {}, this.tileCoords = [], s2 && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t2.indexMaxZoom, t2.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i2 = function(e3, t3) {
                const s3 = t3.buffer / t3.extent;
                let i3 = e3;
                const o2 = se(e3, 1, -1 - s3, s3, 0, -1, 2, t3), n2 = se(e3, 1, 1 - s3, 2 + s3, 0, -1, 2, t3);
                return (o2 || n2) && (i3 = se(e3, 1, -s3, 1 + s3, 0, -1, 2, t3) || [], o2 && (i3 = he(o2, 1).concat(i3)), n2 && (i3 = i3.concat(he(n2, -1)))), i3;
              }(i2, t2), i2.length && this.splitTile(i2, 0, 0, 0), s2 && (i2.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            splitTile(e2, t2, s2, i2, o2, n2, r2) {
              const a2 = [e2, t2, s2, i2], l2 = this.options, c2 = l2.debug;
              for (; a2.length; ) {
                i2 = a2.pop(), s2 = a2.pop(), t2 = a2.pop(), e2 = a2.pop();
                const h3 = 1 << t2, u2 = ve(t2, s2, i2);
                let d2 = this.tiles[u2];
                if (!d2 && (c2 > 1 && console.time("creation"), d2 = this.tiles[u2] = pe(e2, t2, s2, i2, l2), this.tileCoords.push({ z: t2, x: s2, y: i2 }), c2)) {
                  c2 > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t2, s2, i2, d2.numFeatures, d2.numPoints, d2.numSimplified), console.timeEnd("creation"));
                  const e3 = `z${t2}`;
                  this.stats[e3] = (this.stats[e3] || 0) + 1, this.total++;
                }
                if (d2.source = e2, null == o2) {
                  if (t2 === l2.indexMaxZoom || d2.numPoints <= l2.indexMaxPoints) continue;
                } else {
                  if (t2 === l2.maxZoom || t2 === o2) continue;
                  if (null != o2) {
                    const e3 = o2 - t2;
                    if (s2 !== n2 >> e3 || i2 !== r2 >> e3) continue;
                  }
                }
                if (d2.source = null, 0 === e2.length) continue;
                c2 > 1 && console.time("clipping");
                const f2 = 0.5 * l2.buffer / l2.extent, p3 = 0.5 - f2, g2 = 0.5 + f2, m2 = 1 + f2;
                let y2 = null, w2 = null, v2 = null, x2 = null, b2 = se(e2, h3, s2 - f2, s2 + g2, 0, d2.minX, d2.maxX, l2), I2 = se(e2, h3, s2 + p3, s2 + m2, 0, d2.minX, d2.maxX, l2);
                e2 = null, b2 && (y2 = se(b2, h3, i2 - f2, i2 + g2, 1, d2.minY, d2.maxY, l2), w2 = se(b2, h3, i2 + p3, i2 + m2, 1, d2.minY, d2.maxY, l2), b2 = null), I2 && (v2 = se(I2, h3, i2 - f2, i2 + g2, 1, d2.minY, d2.maxY, l2), x2 = se(I2, h3, i2 + p3, i2 + m2, 1, d2.minY, d2.maxY, l2), I2 = null), c2 > 1 && console.timeEnd("clipping"), a2.push(y2 || [], t2 + 1, 2 * s2, 2 * i2), a2.push(w2 || [], t2 + 1, 2 * s2, 2 * i2 + 1), a2.push(v2 || [], t2 + 1, 2 * s2 + 1, 2 * i2), a2.push(x2 || [], t2 + 1, 2 * s2 + 1, 2 * i2 + 1);
              }
            }
            getTile(e2, t2, s2) {
              e2 = +e2, t2 = +t2, s2 = +s2;
              const i2 = this.options, { extent: o2, debug: n2 } = i2;
              if (e2 < 0 || e2 > 24) return null;
              const r2 = 1 << e2, a2 = ve(e2, t2 = t2 + r2 & r2 - 1, s2);
              if (this.tiles[a2]) return de2(this.tiles[a2], o2);
              n2 > 1 && console.log("drilling down to z%d-%d-%d", e2, t2, s2);
              let l2, c2 = e2, h3 = t2, u2 = s2;
              for (; !l2 && c2 > 0; ) c2--, h3 >>= 1, u2 >>= 1, l2 = this.tiles[ve(c2, h3, u2)];
              return l2 && l2.source ? (n2 > 1 && (console.log("found parent tile z%d-%d-%d", c2, h3, u2), console.time("drilling down")), this.splitTile(l2.source, c2, h3, u2, e2, t2, s2), n2 > 1 && console.timeEnd("drilling down"), this.tiles[a2] ? de2(this.tiles[a2], o2) : null) : null;
            }
          }
          function ve(e2, t2, s2) {
            return 32 * ((1 << e2) * s2 + t2) + e2;
          }
          function xe(e2, t2) {
            const s2 = e2.tileID.canonical;
            if (!this._geoJSONIndex) return void t2(null, null);
            const i2 = this._geoJSONIndex.getTile(s2.z, s2.x, s2.y);
            if (!i2) return void t2(null, null);
            const o2 = (e3) => e3.tags && "3d_elevation_id" in e3.tags && "source" in e3.tags && "elevation" === e3.tags.source, n2 = i2.features.filter((e3) => o2(e3));
            let r2;
            if (n2.length > 0) {
              const e3 = i2.features.filter((e4) => !o2(e4));
              r2 = new y({ _geojsonTileLayer: e3, hd_road_elevation: n2 });
            } else r2 = new g(i2.features);
            let a2 = z(r2);
            0 === a2.byteOffset && a2.byteLength === a2.buffer.byteLength || (a2 = new Uint8Array(a2)), t2(null, { vectorTile: r2, rawData: a2.buffer });
          }
          class be extends c {
            constructor(e2, t2, s2, i2, o2, n2, r2) {
              super(e2, t2, s2, i2, o2, xe, r2), n2 && (this.loadGeoJSON = n2), this._dynamicIndex = new x();
            }
            loadData(s2, i2) {
              const o2 = s2 && s2.request, n2 = o2 && o2.collectResourceTiming;
              this.loadGeoJSON(s2, (r2, a2) => {
                if (r2 || !a2) return i2(r2);
                if ("object" != typeof a2) return i2(new Error(`Input data given to '${s2.source}' is not a valid GeoJSON object.`));
                {
                  try {
                    if (s2.filter) {
                      const t2 = e.X(s2.filter, { type: "boolean", "property-type": "data-driven", overridable: false, transition: false });
                      if ("error" === t2.result) throw new Error(t2.value.map((e2) => `${e2.key}: ${e2.message}`).join(", "));
                      a2.features = a2.features.filter((e2) => t2.value.evaluate({ zoom: 0 }, e2));
                    }
                    s2.dynamic ? ("Feature" === a2.type && (a2 = { type: "FeatureCollection", features: [a2] }), s2.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(a2.features, this.loaded), s2.cluster && (a2.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = s2.cluster ? new R(function({ superclusterOptions: t2, clusterProperties: s3 }) {
                      if (!s3 || !t2) return t2;
                      const i3 = {}, o3 = {}, n3 = { accumulated: null, zoom: 0 }, r4 = { properties: null }, a3 = Object.keys(s3);
                      for (const t3 of a3) {
                        const [n4, r5] = s3[t3], a4 = e.X(r5), l2 = e.X("string" == typeof n4 ? [n4, ["accumulated"], ["get", t3]] : n4);
                        i3[t3] = a4.value, o3[t3] = l2.value;
                      }
                      return t2.map = (e2) => {
                        r4.properties = e2;
                        const t3 = {};
                        for (const e3 of a3) t3[e3] = i3[e3].evaluate(n3, r4);
                        return t3;
                      }, t2.reduce = (e2, t3) => {
                        r4.properties = t3;
                        for (const t4 of a3) n3.accumulated = e2[t4], e2[t4] = o3[t4].evaluate(n3, r4);
                      }, t2;
                    }(s2)).load(a2.features) : s2.dynamic ? this._dynamicIndex : function(e2, t2) {
                      return new we(e2, t2);
                    }(a2, s2.geojsonVtOptions);
                  } catch (e2) {
                    return i2(e2);
                  }
                  const r3 = {};
                  if (n2) {
                    const e2 = t(o2);
                    e2 && (r3.resourceTiming = {}, r3.resourceTiming[s2.source] = JSON.parse(JSON.stringify(e2)));
                  }
                  i2(null, r3);
                }
              });
            }
            reloadTile(e2, t2) {
              const s2 = this.loaded;
              return s2 && s2[e2.uid] ? e2.partial ? t2(null, void 0) : super.reloadTile(e2, t2) : this.loadTile(e2, t2);
            }
            loadGeoJSON(t2, s2) {
              if (t2.request) e.n(t2.request, s2);
              else {
                if ("string" != typeof t2.data) return s2(new Error(`Input data given to '${t2.source}' is not a valid GeoJSON object.`));
                try {
                  return s2(null, JSON.parse(t2.data));
                } catch (e2) {
                  return s2(new Error(`Input data given to '${t2.source}' is not a valid GeoJSON object.`));
                }
              }
            }
            getClusterExpansionZoom(e2, t2) {
              try {
                t2(null, this._geoJSONIndex.getClusterExpansionZoom(e2.clusterId));
              } catch (e3) {
                t2(e3);
              }
            }
            getClusterChildren(e2, t2) {
              try {
                t2(null, this._geoJSONIndex.getChildren(e2.clusterId));
              } catch (e3) {
                t2(e3);
              }
            }
            getClusterLeaves(e2, t2) {
              try {
                t2(null, this._geoJSONIndex.getLeaves(e2.clusterId, e2.limit, e2.offset));
              } catch (e3) {
                t2(e3);
              }
            }
          }
          class Ie {
            constructor(t2, s2, i2) {
              this.tileID = new e.aM(t2.tileID.overscaledZ, t2.tileID.wrap, t2.tileID.canonical.z, t2.tileID.canonical.x, t2.tileID.canonical.y), this.tileZoom = t2.tileZoom, this.uid = t2.uid, this.zoom = t2.zoom, this.canonical = t2.tileID.canonical, this.pixelRatio = t2.pixelRatio, this.tileSize = t2.tileSize, this.source = t2.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t2.projection, this.brightness = s2, this.worldview = i2;
            }
            parse(t2, s2, i2, o2) {
              this.status = "parsing";
              const n2 = new e.aM(i2.tileID.overscaledZ, i2.tileID.wrap, i2.tileID.canonical.z, i2.tileID.canonical.x, i2.tileID.canonical.y), r2 = [], a2 = s2.familiesBySource[i2.source], l2 = new e.f0(n2, i2.promoteId);
              l2.bucketLayerIDs = [], l2.is3DTile = true, e.fi(t2).then((t3) => {
                if (!t3) return o2(new Error("Could not parse tile"));
                const s3 = t3.json.extensionsUsed && t3.json.extensionsUsed.includes("MAPBOX_mesh_features") || t3.json.asset.extras && t3.json.asset.extras.MAPBOX_mesh_features, c2 = t3.json.extensionsUsed && t3.json.extensionsUsed.includes("EXT_meshopt_compression"), h3 = new e.aa(this.zoom, { brightness: this.brightness, worldview: this.worldview });
                for (const o3 in a2) for (const u2 of a2[o3]) {
                  const o4 = u2[0];
                  l2.bucketLayerIDs.push(u2.map((t4) => e.C(t4.id, t4.scope))), o4.recalculate(h3, []);
                  const a3 = e.fj(t3, 1 / e.cU(i2.tileID.canonical)), d2 = new e.fk(u2, a3, n2, s3, c2, this.brightness, l2, this.worldview);
                  s3 || (d2.needsUpload = true), r2.push(d2), d2.evaluate(o4);
                }
                this.status = "done", o2(null, { buckets: r2, featureIndex: l2, collisionBoxArray: null, glyphAtlasImage: null, lineAtlas: null, imageAtlas: null, brightness: null });
              }).catch((e2) => o2(new Error(e2.message)));
            }
          }
          class Se {
            constructor(e2, t2, s2, i2, o2, n2, r2, a2) {
              this.actor = e2, this.layerIndex = t2, this.availableImages = s2, this.availableModels = i2, this.brightness = r2, this.loading = {}, this.loaded = {}, this.worldview = a2;
            }
            loadTile(t2, s2) {
              const i2 = t2.uid, o2 = this.loading[i2] = new Ie(t2, this.brightness, this.worldview);
              e.br(t2.request, (e2, n2) => {
                const r2 = !this.loading[i2];
                return delete this.loading[i2], r2 || e2 ? (o2.status = "done", r2 || (this.loaded[i2] = o2), s2(e2)) : n2 && 0 !== n2.byteLength ? void o2.parse(n2, this.layerIndex, t2, (e3, t3) => {
                  o2.status = "done", this.loaded = this.loaded || {}, this.loaded[i2] = o2, e3 || !t3 ? s2(e3) : s2(null, t3);
                }) : (o2.status = "done", this.loaded[i2] = o2, s2());
              });
            }
            reloadTile(e2, t2) {
              const s2 = this.loaded, i2 = e2.uid;
              if (s2 && s2[i2]) {
                const o2 = s2[i2];
                o2.projection = e2.projection, o2.brightness = e2.brightness;
                const n2 = (s3, i3) => {
                  o2.reloadCallback && (delete o2.reloadCallback, this.loadTile(e2, t2)), t2(s3, i3);
                };
                "parsing" === o2.status ? o2.reloadCallback = n2 : "done" === o2.status && this.loadTile(e2, t2);
              }
            }
            abortTile(e2, t2) {
              const s2 = e2.uid;
              this.loading[s2] && delete this.loading[s2], t2();
            }
            removeTile(e2, t2) {
              const s2 = this.loaded, i2 = e2.uid;
              s2 && s2[i2] && delete s2[i2], t2();
            }
          }
          class Me {
            constructor(t2) {
              this.self = t2, this.actor = new e.fm(t2, this), this.layerIndexes = {}, this.availableImages = {}, this.availableModels = {}, this.isSpriteLoaded = {}, this.imageRasterizer = new e.y(), this.rtlPluginParsingListeners = [], this.projections = {}, this.defaultProjection = e.ce({ name: "mercator" }), this.workerSourceTypes = { vector: c, geojson: be, "raster-dem": h2, "raster-array": d, "batched-model": Se }, this.workerSources = {}, this.self.registerWorkerSource = (e2, t3) => {
                if (this.workerSourceTypes[e2]) throw new Error(`Worker source with name "${e2}" already registered.`);
                this.workerSourceTypes[e2] = t3;
              }, this.self.registerRTLTextPlugin = (t3) => {
                if (e.fn.isParsed()) throw new Error("RTL text plugin already registered.");
                e.fn.setState({ pluginStatus: e.fo.parsed, pluginURL: e.fn.getPluginURL() }), e.fn.applyArabicShaping = t3.applyArabicShaping, e.fn.processBidirectionalText = t3.processBidirectionalText, e.fn.processStyledBidirectionalText = t3.processStyledBidirectionalText;
                for (const e2 of this.rtlPluginParsingListeners) e2(null, true);
                this.rtlPluginParsingListeners = [];
              };
            }
            clearCaches(e2, t2, s2) {
              delete this.layerIndexes[e2], delete this.availableImages[e2], delete this.availableModels[e2], delete this.workerSources[e2], s2();
            }
            checkIfReady(e2, t2, s2) {
              s2();
            }
            setReferrer(e2, t2) {
              this.referrer = t2;
            }
            spriteLoaded(t2, s2) {
              this.isSpriteLoaded[t2] || (this.isSpriteLoaded[t2] = {});
              const { scope: i2, isLoaded: o2 } = s2;
              if (this.isSpriteLoaded[t2][i2] = o2, this.workerSources[t2] && this.workerSources[t2][i2]) for (const s3 in this.workerSources[t2][i2]) {
                const n2 = this.workerSources[t2][i2][s3];
                for (const t3 in n2) {
                  const s4 = n2[t3];
                  s4 instanceof c && (s4.isSpriteLoaded = o2, s4.fire(new e.A("isSpriteLoaded")));
                }
              }
            }
            setImages(e2, t2, s2) {
              this.availableImages[e2] || (this.availableImages[e2] = {});
              const { scope: i2, images: o2 } = t2;
              if (this.availableImages[e2][i2] = o2, this.workerSources[e2] && this.workerSources[e2][i2]) {
                for (const t3 in this.workerSources[e2][i2]) {
                  const s3 = this.workerSources[e2][i2][t3];
                  for (const e3 in s3) s3[e3].availableImages = o2;
                }
                s2();
              } else s2();
            }
            setModels(e2, { scope: t2, models: s2 }, i2) {
              if (this.availableModels[e2] || (this.availableModels[e2] = {}), this.availableModels[e2][t2] = s2, this.workerSources[e2] && this.workerSources[e2][t2]) {
                for (const i3 in this.workerSources[e2][t2]) {
                  const o2 = this.workerSources[e2][t2][i3];
                  for (const e3 in o2) o2[e3].availableModels = s2;
                }
                i2();
              } else i2();
            }
            setProjection(t2, s2) {
              this.projections[t2] = e.ce(s2);
            }
            setBrightness(e2, t2, s2) {
              this.brightness = t2, s2();
            }
            setWorldview(e2, t2, s2) {
              this.worldview = t2, s2();
            }
            setLayers(e2, t2, s2) {
              this.getLayerIndex(e2, t2.scope).replace(t2.layers, t2.options), s2();
            }
            updateLayers(e2, t2, s2) {
              this.getLayerIndex(e2, t2.scope).update(t2.layers, t2.removedIds, t2.options), s2();
            }
            loadTile(e2, t2, s2) {
              t2.projection = this.projections[e2] || this.defaultProjection, this.getWorkerSource(e2, t2.type, t2.source, t2.scope).loadTile(t2, s2);
            }
            decodeRasterArray(e2, t2, s2) {
              this.getWorkerSource(e2, t2.type, t2.source, t2.scope).decodeRasterArray(t2, s2);
            }
            reloadTile(e2, t2, s2) {
              t2.projection = this.projections[e2] || this.defaultProjection, this.getWorkerSource(e2, t2.type, t2.source, t2.scope).reloadTile(t2, s2);
            }
            abortTile(e2, t2, s2) {
              this.getWorkerSource(e2, t2.type, t2.source, t2.scope).abortTile(t2, s2);
            }
            removeTile(e2, t2, s2) {
              this.getWorkerSource(e2, t2.type, t2.source, t2.scope).removeTile(t2, s2);
            }
            removeSource(e2, t2, s2) {
              if (!(this.workerSources[e2] && this.workerSources[e2][t2.scope] && this.workerSources[e2][t2.scope][t2.type] && this.workerSources[e2][t2.scope][t2.type][t2.source])) return;
              const i2 = this.workerSources[e2][t2.scope][t2.type][t2.source];
              delete this.workerSources[e2][t2.scope][t2.type][t2.source], void 0 !== i2.removeSource ? i2.removeSource(t2, s2) : s2();
            }
            loadWorkerSource(e2, t2, s2) {
              try {
                this.self.importScripts(t2.url), s2();
              } catch (e3) {
                s2(e3.toString());
              }
            }
            syncRTLPluginState(t2, s2, i2) {
              if (e.fn.isParsed()) i2(null, true);
              else if (e.fn.isParsing()) this.rtlPluginParsingListeners.push(i2);
              else try {
                e.fn.setState(s2);
                const t3 = e.fn.getPluginURL();
                !e.fn.isLoaded() || e.fn.isParsed() || e.fn.isParsing() || null == t3 || (e.fn.setState({ pluginStatus: e.fo.parsing, pluginURL: e.fn.getPluginURL() }), this.self.importScripts(t3), e.fn.isParsed() ? i2(null, true) : this.rtlPluginParsingListeners.push(i2));
              } catch (e2) {
                i2(e2.toString());
              }
            }
            setDracoUrl(e2, t2) {
              this.dracoUrl = t2;
            }
            getAvailableImages(e2, t2) {
              this.availableImages[e2] || (this.availableImages[e2] = {});
              let s2 = this.availableImages[e2][t2];
              return s2 || (s2 = []), s2;
            }
            getAvailableModels(e2, t2) {
              this.availableModels[e2] || (this.availableModels[e2] = {});
              let s2 = this.availableModels[e2][t2];
              return s2 || (s2 = {}), s2;
            }
            getLayerIndex(e2, t2) {
              this.layerIndexes[e2] || (this.layerIndexes[e2] = {});
              let s2 = this.layerIndexes[e2][t2];
              return s2 || (s2 = this.layerIndexes[e2][t2] = new o(), s2.scope = t2), s2;
            }
            getWorkerSource(e2, t2, s2, i2) {
              const o2 = this.workerSources;
              return o2[e2] || (o2[e2] = {}), o2[e2][i2] || (o2[e2][i2] = {}), o2[e2][i2][t2] || (o2[e2][i2][t2] = {}), this.isSpriteLoaded[e2] || (this.isSpriteLoaded[e2] = {}), o2[e2][i2][t2][s2] || (o2[e2][i2][t2][s2] = new this.workerSourceTypes[t2]({ send: (t3, s3, i3, o3, n2, r2) => this.actor.send(t3, s3, i3, e2, n2, r2), scheduler: this.actor.scheduler }, this.getLayerIndex(e2, i2), this.getAvailableImages(e2, i2), this.getAvailableModels(e2, i2), this.isSpriteLoaded[e2][i2], void 0, this.brightness, this.worldview)), o2[e2][i2][t2][s2];
            }
            rasterizeImagesWorker(e2, t2, s2) {
              const i2 = /* @__PURE__ */ new Map();
              for (const [s3, { image: o2, imageVariant: n2 }] of t2.tasks.entries()) {
                const r2 = this.imageRasterizer.rasterize(n2, o2, t2.scope, e2);
                i2.set(s3, r2);
              }
              s2(void 0, i2);
            }
            removeRasterizedImages(e2, t2, s2) {
              this.imageRasterizer.removeImagesFromCacheByIds(t2.imageIds, t2.scope, e2), s2();
            }
            enforceCacheSizeLimit(t2, s2) {
              e.fp(s2);
            }
            getWorkerPerformanceMetrics(e2, t2, s2) {
              s2(void 0, void 0);
            }
          }
          return e.fl(self) && (self.worker = new Me(self)), Me;
        });
        define3(["./shared"], function(e) {
          var t = "3.13.0";
          const i = { create: "create", load: "load", fullLoad: "fullLoad" }, o = { mark(e2) {
            performance.mark(e2);
          }, measure(e2, t2, i2) {
            performance.measure(e2, t2, i2);
          } };
          function s(t2) {
            const i2 = t2.name.split("?")[0];
            return e.a(i2) && i2.includes("mapbox-gl.js") ? "javascript" : e.a(i2) && i2.includes("mapbox-gl.css") ? "css" : e.b(i2) ? "fontRange" : e.c(i2) ? "sprite" : e.i(i2) ? "style" : e.d(i2) ? "tilejson" : "other";
          }
          var r, n = {}, a = function() {
            if (r) return n;
            function e2(e3) {
              return !t2(e3);
            }
            function t2(t3) {
              return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : function() {
                if (!("Worker" in window && "Blob" in window && "URL" in window)) return false;
                var e3, t4, i3 = new Blob([""], { type: "text/javascript" }), o3 = URL.createObjectURL(i3);
                try {
                  t4 = new Worker(o3), e3 = true;
                } catch (t5) {
                  e3 = false;
                }
                return t4 && t4.terminate(), URL.revokeObjectURL(o3), e3;
              }() ? function() {
                var e3 = document.createElement("canvas");
                e3.width = e3.height = 1;
                var t4 = e3.getContext("2d");
                if (!t4) return false;
                var i3 = t4.getImageData(0, 0, 1, 1);
                return i3 && i3.width === e3.width;
              }() ? (void 0 === i2[o2 = t3 && t3.failIfMajorPerformanceCaveat] && (i2[o2] = function(t4) {
                var i3, o3 = function(t5) {
                  var i4 = document.createElement("canvas"), o4 = Object.create(e2.webGLContextAttributes);
                  return o4.failIfMajorPerformanceCaveat = t5, i4.getContext("webgl2", o4);
                }(t4);
                if (!o3) return false;
                try {
                  i3 = o3.createShader(o3.VERTEX_SHADER);
                } catch (e3) {
                  return false;
                }
                return !(!i3 || o3.isContextLost()) && (o3.shaderSource(i3, "void main() {}"), o3.compileShader(i3), true === o3.getShaderParameter(i3, o3.COMPILE_STATUS));
              }(o2)), i2[o2] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
              var o2;
            }
            r = 1, n.supported = e2, n.notSupportedReason = t2;
            var i2 = {};
            return e2.webGLContextAttributes = { antialias: false, alpha: true, stencil: true, depth: true }, n;
          }();
          function l(e2, t2, i2) {
            const o2 = document.createElement(e2);
            return null != t2 && (o2.className = t2), i2 && i2.appendChild(o2), o2;
          }
          function c(e2, t2, i2) {
            const o2 = document.createElementNS("http://www.w3.org/2000/svg", e2);
            for (const e3 of Object.keys(t2)) o2.setAttributeNS(null, e3, String(t2[e3]));
            return i2 && i2.appendChild(o2), o2;
          }
          const h2 = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, d = h2 && void 0 !== h2.userSelect ? "userSelect" : "WebkitUserSelect";
          let u;
          function _() {
            h2 && d && (u = h2[d], h2[d] = "none");
          }
          function p2() {
            h2 && d && (h2[d] = u);
          }
          function f(e2) {
            e2.preventDefault(), e2.stopPropagation(), window.removeEventListener("click", f, true);
          }
          function m() {
            window.addEventListener("click", f, true), window.setTimeout(() => {
              window.removeEventListener("click", f, true);
            }, 0);
          }
          function g(e2, t2) {
            const i2 = e2.getBoundingClientRect();
            return x(e2, i2, t2);
          }
          function v(e2, t2) {
            const i2 = e2.getBoundingClientRect(), o2 = [];
            for (let s2 = 0; s2 < t2.length; s2++) o2.push(x(e2, i2, t2[s2]));
            return o2;
          }
          function y(e2) {
            return /firefox/i.test(navigator.userAgent) && /macintosh/i.test(navigator.userAgent) && 2 === e2.button && e2.ctrlKey ? 0 : e2.button;
          }
          function x(t2, i2, o2) {
            const s2 = t2.offsetWidth === i2.width ? 1 : t2.offsetWidth / i2.width;
            return new e.P((o2.clientX - i2.left) * s2, (o2.clientY - i2.top) * s2);
          }
          const b = "01", w = "NO_ACCESS_TOKEN";
          class T {
            constructor(e2, t2, i2) {
              this._transformRequestFn = e2, this._customAccessToken = t2, this._silenceAuthErrors = !!i2, this._createSkuToken();
            }
            _createSkuToken() {
              const e2 = function() {
                let e3 = "";
                for (let t2 = 0; t2 < 10; t2++) e3 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                return { token: ["1", b, e3].join(""), tokenExpiresAt: Date.now() + 432e5 };
              }();
              this._skuToken = e2.token, this._skuTokenExpiresAt = e2.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
              return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(e2, t2) {
              return this._transformRequestFn && this._transformRequestFn(e2, t2) || { url: e2 };
            }
            normalizeStyleURL(i2, o2) {
              if (!e.j(i2)) return i2;
              const s2 = S(i2);
              return s2.params.push(`sdk=js-${t}`), s2.path = `/styles/v1${s2.path}`, this._makeAPIURL(s2, this._customAccessToken || o2);
            }
            normalizeGlyphsURL(t2, i2) {
              if (!e.j(t2)) return t2;
              const o2 = S(t2);
              return o2.path = `/fonts/v1${o2.path}`, this._makeAPIURL(o2, this._customAccessToken || i2);
            }
            normalizeModelURL(t2, i2) {
              if (!e.j(t2)) return t2;
              const o2 = S(t2);
              return o2.path = `/models/v1${o2.path}`, this._makeAPIURL(o2, this._customAccessToken || i2);
            }
            normalizeSourceURL(t2, i2, o2, s2) {
              if (!e.j(t2)) return t2;
              const r2 = S(t2);
              return r2.path = `/v4/${r2.authority}.json`, r2.params.push("secure"), o2 && r2.params.push(`language=${o2}`), s2 && r2.params.push(`worldview=${s2}`), this._makeAPIURL(r2, this._customAccessToken || i2);
            }
            normalizeIconsetURL(t2, i2) {
              const o2 = S(t2);
              return e.j(t2) ? (o2.path = `/styles/v1${o2.path}/iconset.pbf`, this._makeAPIURL(o2, this._customAccessToken || i2)) : I(o2);
            }
            normalizeSpriteURL(t2, i2, o2, s2) {
              const r2 = S(t2);
              return e.j(t2) ? (r2.path = `/styles/v1${r2.path}/sprite${i2}${o2}`, this._makeAPIURL(r2, this._customAccessToken || s2)) : (r2.path += `${i2}${o2}`, I(r2));
            }
            normalizeTileURL(t2, i2, o2) {
              if (this._isSkuTokenExpired() && this._createSkuToken(), t2 && !e.j(t2)) return t2;
              const s2 = S(t2);
              s2.path = s2.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${i2 || o2 && "raster" !== s2.authority && 512 === o2 ? "@2x" : ""}${e.l.supported ? ".webp" : "$1"}`), "raster" === s2.authority ? s2.path = `/${e.e.RASTER_URL_PREFIX}${s2.path}` : "rasterarrays" === s2.authority ? s2.path = `/${e.e.RASTERARRAYS_URL_PREFIX}${s2.path}` : "3dtiles" === s2.authority ? s2.path = `/${e.e.TILES3D_URL_PREFIX}${s2.path}` : (s2.path = s2.path.replace(/^.+\/v4\//, "/"), s2.path = `/${e.e.TILE_URL_VERSION}${s2.path}`);
              const r2 = this._customAccessToken || function(e2) {
                for (const t3 of e2) {
                  const e3 = t3.match(/^access_token=(.*)$/);
                  if (e3) return e3[1];
                }
                return null;
              }(s2.params) || e.e.ACCESS_TOKEN;
              return e.e.REQUIRE_ACCESS_TOKEN && r2 && this._skuToken && s2.params.push(`sku=${this._skuToken}`), this._makeAPIURL(s2, r2);
            }
            canonicalizeTileURL(t2, i2) {
              const o2 = S(t2);
              if (!o2.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !o2.path.match(/\.[\w]+$/)) return t2;
              let s2 = "mapbox://";
              o2.path.match(/^\/raster\/v1\//) ? s2 += `raster/${o2.path.replace(`/${e.e.RASTER_URL_PREFIX}/`, "")}` : o2.path.match(/^\/rasterarrays\/v1\//) ? s2 += `rasterarrays/${o2.path.replace(`/${e.e.RASTERARRAYS_URL_PREFIX}/`, "")}` : s2 += `tiles/${o2.path.replace(`/${e.e.TILE_URL_VERSION}/`, "")}`;
              let r2 = o2.params;
              return i2 && (r2 = r2.filter((e2) => !e2.match(/^access_token=/))), r2.length && (s2 += `?${r2.join("&")}`), s2;
            }
            canonicalizeTileset(t2, i2) {
              const o2 = !!i2 && e.j(i2), s2 = [];
              for (const i3 of t2.tiles || []) e.k(i3) ? s2.push(this.canonicalizeTileURL(i3, o2)) : s2.push(i3);
              return s2;
            }
            _makeAPIURL(t2, i2) {
              const o2 = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", s2 = S(e.e.API_URL);
              if (t2.protocol = s2.protocol, t2.authority = s2.authority, "http" === t2.protocol) {
                const e2 = t2.params.indexOf("secure");
                e2 >= 0 && t2.params.splice(e2, 1);
              }
              if ("/" !== s2.path && (t2.path = `${s2.path}${t2.path}`), !e.e.REQUIRE_ACCESS_TOKEN) return I(t2);
              if (i2 = i2 || e.e.ACCESS_TOKEN, !this._silenceAuthErrors) {
                if (!i2) throw new Error(`An API access token is required to use Mapbox GL. ${o2}`);
                if ("s" === i2[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${o2}`);
              }
              return t2.params = t2.params.filter((e2) => -1 === e2.indexOf("access_token")), t2.params.push(`access_token=${i2 || ""}`), I(t2);
            }
          }
          const E = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
          function S(e2) {
            const t2 = e2.match(E);
            if (!t2) throw new Error("Unable to parse URL object");
            return { protocol: t2[1], authority: t2[2], path: t2[3] || "/", params: t2[4] ? t2[4].split("&") : [] };
          }
          function I(e2) {
            const t2 = e2.params.length ? `?${e2.params.join("&")}` : "";
            return `${e2.protocol}://${e2.authority}${e2.path}${t2}`;
          }
          const C = "mapbox.eventData";
          function R(t2) {
            if (!t2) return null;
            const i2 = t2.split(".");
            if (!i2 || 3 !== i2.length) return null;
            try {
              return JSON.parse(e.m(i2[1]));
            } catch (e2) {
              return null;
            }
          }
          class D {
            constructor(e2) {
              this.type = e2, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
            getStorageKey(t2) {
              const i2 = R(e.e.ACCESS_TOKEN);
              let o2 = "";
              return o2 = i2 && i2.u ? e.f(i2.u) : e.e.ACCESS_TOKEN || "", t2 ? `${C}.${t2}:${o2}` : `${C}:${o2}`;
            }
            fetchEventData() {
              const t2 = e.s("localStorage"), i2 = this.getStorageKey(), o2 = this.getStorageKey("uuid");
              if (t2) try {
                const e2 = localStorage.getItem(i2);
                e2 && (this.eventData = JSON.parse(e2));
                const t3 = localStorage.getItem(o2);
                t3 && (this.anonId = t3);
              } catch (t3) {
                e.w("Unable to read from LocalStorage");
              }
            }
            saveEventData() {
              const t2 = e.s("localStorage"), i2 = this.getStorageKey(), o2 = this.getStorageKey("uuid"), s2 = this.anonId;
              if (t2 && s2) try {
                localStorage.setItem(o2, s2), Object.keys(this.eventData).length >= 1 && localStorage.setItem(i2, JSON.stringify(this.eventData));
              } catch (t3) {
                e.w("Unable to write to LocalStorage");
              }
            }
            processRequests(e2) {
            }
            postEvent(t2, i2, o2, s2) {
              if (!e.e.EVENTS_URL) return;
              const r2 = S(e.e.EVENTS_URL);
              r2.params.push(`access_token=${s2 || e.e.ACCESS_TOKEN || ""}`);
              const n2 = { event: this.type, created: new Date(t2).toISOString() }, a2 = i2 ? e.h(n2, i2) : n2, l2 = { url: I(r2), headers: { "Content-Type": "text/plain" }, body: JSON.stringify([a2]) };
              this.pendingRequest = e.p(l2, (e2) => {
                this.pendingRequest = null, o2(e2), this.saveEventData(), this.processRequests(s2);
              });
            }
            queueRequest(e2, t2) {
              this.queue.push(e2), this.processRequests(t2);
            }
          }
          const A = new class extends D {
            constructor(e2) {
              super("appUserTurnstile"), this._customAccessToken = e2;
            }
            postTurnstileEvent(t2, i2) {
              e.e.EVENTS_URL && e.e.ACCESS_TOKEN && Array.isArray(t2) && t2.some((t3) => e.j(t3) || e.k(t3)) && this.queueRequest(Date.now(), i2);
            }
            processRequests(i2) {
              if (this.pendingRequest || 0 === this.queue.length) return;
              this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
              const o2 = R(e.e.ACCESS_TOKEN), s2 = o2 ? o2.u : e.e.ACCESS_TOKEN;
              let r2 = s2 !== this.eventData.tokenU;
              e.v(this.anonId) || (this.anonId = e.u(), r2 = true);
              const n2 = this.queue.shift();
              if (this.eventData.lastSuccess) {
                const e2 = new Date(this.eventData.lastSuccess), t2 = new Date(n2), i3 = (n2 - this.eventData.lastSuccess) / 864e5;
                r2 = r2 || i3 >= 1 || i3 < -1 || e2.getDate() !== t2.getDate();
              } else r2 = true;
              r2 ? this.postEvent(n2, { sdkIdentifier: "mapbox-gl-js", sdkVersion: t, skuId: b, "enabled.telemetry": false, userId: this.anonId }, (e2) => {
                e2 || (this.eventData.lastSuccess = n2, this.eventData.tokenU = s2);
              }, i2) : this.processRequests();
            }
          }(), L = A.postTurnstileEvent.bind(A), P = new class extends D {
            constructor() {
              super("map.load"), this.success = {}, this.skuToken = "";
            }
            postMapLoadEvent(t2, i2, o2, s2) {
              this.skuToken = i2, this.errorCb = s2, e.e.EVENTS_URL && (o2 || e.e.ACCESS_TOKEN ? this.queueRequest({ id: t2, timestamp: Date.now() }, o2) : this.errorCb(new Error(w)));
            }
            processRequests(i2) {
              if (this.pendingRequest || 0 === this.queue.length) return;
              const { id: o2, timestamp: s2 } = this.queue.shift();
              o2 && this.success[o2] || (this.anonId || this.fetchEventData(), e.v(this.anonId) || (this.anonId = e.u()), this.postEvent(s2, { sdkIdentifier: "mapbox-gl-js", sdkVersion: t, skuId: b, skuToken: this.skuToken, userId: this.anonId }, (e2) => {
                e2 ? this.errorCb(e2) : o2 && (this.success[o2] = true);
              }, i2));
            }
            remove() {
              this.errorCb = null;
            }
          }(), z = P.postMapLoadEvent.bind(P), M = new class extends D {
            constructor() {
              super("style.load"), this.eventIdPerMapInstanceMap = /* @__PURE__ */ new Map(), this.mapInstanceIdMap = /* @__PURE__ */ new WeakMap();
            }
            getMapInstanceId(t2) {
              let i2 = this.mapInstanceIdMap.get(t2);
              return i2 || (i2 = e.u(), this.mapInstanceIdMap.set(t2, i2)), i2;
            }
            getEventId(e2) {
              const t2 = this.eventIdPerMapInstanceMap.get(e2) || 0;
              return this.eventIdPerMapInstanceMap.set(e2, t2 + 1), t2;
            }
            postStyleLoadEvent(t2, i2) {
              const { map: o2, style: s2, importedStyles: r2 } = i2;
              if (!e.e.EVENTS_URL || !t2 && !e.e.ACCESS_TOKEN) return;
              const n2 = this.getMapInstanceId(o2), a2 = { mapInstanceId: n2, eventId: this.getEventId(n2), style: s2 };
              r2.length && (a2.importedStyles = r2), this.queueRequest({ timestamp: Date.now(), payload: a2 }, t2);
            }
            processRequests(e2) {
              if (this.pendingRequest || 0 === this.queue.length) return;
              const { timestamp: t2, payload: i2 } = this.queue.shift();
              this.postEvent(t2, i2, () => {
              }, e2);
            }
          }(), O = M.postStyleLoadEvent.bind(M), F = new class extends D {
            constructor() {
              super("gljs.performance");
            }
            postPerformanceEvent(t2, i2) {
              e.e.EVENTS_URL && (t2 || e.e.ACCESS_TOKEN) && this.queueRequest({ timestamp: Date.now(), performanceData: i2 }, t2);
            }
            processRequests(o2) {
              if (this.pendingRequest || 0 === this.queue.length) return;
              const { timestamp: r2, performanceData: n2 } = this.queue.shift(), a2 = function(o3) {
                const r3 = performance.getEntriesByType("resource"), n3 = performance.getEntriesByType("mark"), a3 = function(e2) {
                  const t2 = {};
                  if (e2) {
                    for (const i2 in e2) if ("other" !== i2) for (const o4 of e2[i2]) {
                      const e3 = `${i2}ResolveRangeMin`, s2 = `${i2}ResolveRangeMax`, r4 = `${i2}RequestCount`, n4 = `${i2}RequestCachedCount`;
                      t2[e3] = Math.min(t2[e3] || 1 / 0, o4.startTime), t2[s2] = Math.max(t2[s2] || -1 / 0, o4.responseEnd);
                      const a4 = (e4) => {
                        void 0 === t2[e4] && (t2[e4] = 0), ++t2[e4];
                      };
                      void 0 !== o4.transferSize && 0 === o4.transferSize && a4(n4), a4(r4);
                    }
                  }
                  return t2;
                }(function(e2, t2) {
                  const i2 = {};
                  if (e2) for (const o4 of e2) {
                    const e3 = t2(o4);
                    void 0 === i2[e3] && (i2[e3] = []), i2[e3].push(o4);
                  }
                  return i2;
                }(r3, s)), l2 = window.devicePixelRatio, c2 = navigator.connection || navigator.mozConnection || navigator.webkitConnection, h3 = c2 ? c2.effectiveType : void 0, d2 = { counters: [], metadata: [], attributes: [] }, u2 = (e2, t2, i2) => {
                  null != i2 && e2.push({ name: t2, value: i2.toString() });
                };
                for (const e2 in a3) u2(d2.counters, e2, a3[e2]);
                if (o3.interactionRange[0] !== 1 / 0 && o3.interactionRange[1] !== -1 / 0 && (u2(d2.counters, "interactionRangeMin", o3.interactionRange[0]), u2(d2.counters, "interactionRangeMax", o3.interactionRange[1])), n3) for (const e2 of Object.keys(i)) {
                  const t2 = i[e2], o4 = n3.find((e3) => e3.name === t2);
                  o4 && u2(d2.counters, t2, o4.startTime);
                }
                return u2(d2.counters, "visibilityHidden", o3.visibilityHidden), u2(d2.attributes, "style", function(t2) {
                  if (t2) for (const i2 of t2) {
                    const t3 = i2.name.split("?")[0];
                    if (e.i(t3)) {
                      const e2 = t3.split("/").slice(-2);
                      if (2 === e2.length) return `mapbox://styles/${e2[0]}/${e2[1]}`;
                    }
                  }
                }(r3)), u2(d2.attributes, "terrainEnabled", o3.terrainEnabled ? "true" : "false"), u2(d2.attributes, "fogEnabled", o3.fogEnabled ? "true" : "false"), u2(d2.attributes, "projection", o3.projection), u2(d2.attributes, "zoom", o3.zoom), u2(d2.metadata, "devicePixelRatio", l2), u2(d2.metadata, "connectionEffectiveType", h3), u2(d2.metadata, "navigatorUserAgent", navigator.userAgent), u2(d2.metadata, "screenWidth", window.screen.width), u2(d2.metadata, "screenHeight", window.screen.height), u2(d2.metadata, "windowWidth", window.innerWidth), u2(d2.metadata, "windowHeight", window.innerHeight), u2(d2.metadata, "mapWidth", o3.width / l2), u2(d2.metadata, "mapHeight", o3.height / l2), u2(d2.metadata, "webglRenderer", o3.renderer), u2(d2.metadata, "webglVendor", o3.vendor), u2(d2.metadata, "sdkVersion", t), u2(d2.metadata, "sdkIdentifier", "mapbox-gl-js"), d2;
              }(n2);
              for (const e2 of a2.metadata) ;
              for (const e2 of a2.counters) ;
              for (const e2 of a2.attributes) ;
              this.postEvent(r2, a2, () => {
              }, o2);
            }
          }(), B = F.postPerformanceEvent.bind(F), k = new class extends D {
            constructor() {
              super("map.auth"), this.success = {}, this.skuToken = "";
            }
            getSession(t2, i2, o2, s2) {
              if (!e.e.API_URL || !e.e.SESSION_PATH) return;
              const r2 = S(e.e.API_URL + e.e.SESSION_PATH);
              r2.params.push(`sku=${i2 || ""}`), r2.params.push(`access_token=${s2 || e.e.ACCESS_TOKEN || ""}`);
              const n2 = { url: I(r2), headers: { "Content-Type": "text/plain" } };
              this.pendingRequest = e.g(n2, (e2) => {
                this.pendingRequest = null, o2(e2), this.saveEventData(), this.processRequests(s2);
              });
            }
            getSessionAPI(t2, i2, o2, s2) {
              this.skuToken = i2, this.errorCb = s2, e.e.SESSION_PATH && e.e.API_URL && (o2 || e.e.ACCESS_TOKEN ? this.queueRequest({ id: t2, timestamp: Date.now() }, o2) : this.errorCb(new Error(w)));
            }
            processRequests(e2) {
              if (this.pendingRequest || 0 === this.queue.length) return;
              const { id: t2, timestamp: i2 } = this.queue.shift();
              t2 && this.success[t2] || this.getSession(i2, this.skuToken, (e3) => {
                e3 ? this.errorCb(e3) : t2 && (this.success[t2] = true);
              }, e2);
            }
            remove() {
              this.errorCb = null;
            }
          }(), N = k.getSessionAPI.bind(k), U = /* @__PURE__ */ new Set();
          function j(e2, t2) {
            t2 ? U.add(e2) : U.delete(e2);
          }
          class V {
            constructor() {
              this._changed = false, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = /* @__PURE__ */ new Set(), this._updatedImages = {};
            }
            isDirty() {
              return this._changed;
            }
            setDirty() {
              this._changed = true;
            }
            getUpdatedSourceCaches() {
              return this._updatedSourceCaches;
            }
            updateSourceCache(e2, t2) {
              this._updatedSourceCaches[e2] = t2, this.setDirty();
            }
            discardSourceCacheUpdate(e2) {
              delete this._updatedSourceCaches[e2];
            }
            updateLayer(e2) {
              const t2 = e2.scope;
              this._updatedLayers[t2] = this._updatedLayers[t2] || /* @__PURE__ */ new Set(), this._updatedLayers[t2].add(e2.id), this.setDirty();
            }
            removeLayer(e2) {
              const t2 = e2.scope;
              this._removedLayers[t2] = this._removedLayers[t2] || {}, this._updatedLayers[t2] = this._updatedLayers[t2] || /* @__PURE__ */ new Set(), this._removedLayers[t2][e2.id] = e2, this._updatedLayers[t2].delete(e2.id), this._updatedPaintProps.delete(e2.fqid), this.setDirty();
            }
            getRemovedLayer(e2) {
              return this._removedLayers[e2.scope] ? this._removedLayers[e2.scope][e2.id] : null;
            }
            discardLayerRemoval(e2) {
              this._removedLayers[e2.scope] && delete this._removedLayers[e2.scope][e2.id];
            }
            getLayerUpdatesByScope() {
              const e2 = {};
              for (const t2 in this._updatedLayers) e2[t2] = e2[t2] || {}, e2[t2].updatedIds = Array.from(this._updatedLayers[t2].values());
              for (const t2 in this._removedLayers) e2[t2] = e2[t2] || {}, e2[t2].removedIds = Object.keys(this._removedLayers[t2]);
              return e2;
            }
            getUpdatedPaintProperties() {
              return this._updatedPaintProps;
            }
            updatePaintProperties(e2) {
              this._updatedPaintProps.add(e2.fqid), this.setDirty();
            }
            getUpdatedImages(e2) {
              return this._updatedImages[e2] ? Array.from(this._updatedImages[e2].values()) : [];
            }
            updateImage(t2, i2) {
              this._updatedImages[i2] = this._updatedImages[i2] || /* @__PURE__ */ new Set(), this._updatedImages[i2].add(e.I.toString(t2)), this.setDirty();
            }
            resetUpdatedImages(e2) {
              this._updatedImages[e2] && this._updatedImages[e2].clear();
            }
            reset() {
              this._changed = false, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages = {};
            }
          }
          function G(e2) {
            const { userImage: t2 } = e2;
            return !!(t2 && t2.render && t2.render()) && (e2.data.replace(new Uint8Array(t2.data.buffer)), true);
          }
          class q extends e.E {
            constructor(t2) {
              super(), this.imageProviders = /* @__PURE__ */ new Map(), this.images = /* @__PURE__ */ new Map(), this.updatedImages = /* @__PURE__ */ new Map(), this.callbackDispatchedThisFrame = /* @__PURE__ */ new Map(), this.loaded = /* @__PURE__ */ new Map(), this.requestors = [], this.patterns = /* @__PURE__ */ new Map(), this.patternsInFlight = /* @__PURE__ */ new Set(), this.atlasImage = /* @__PURE__ */ new Map(), this.atlasTexture = /* @__PURE__ */ new Map(), this.dirty = true, this.spriteFormat = t2, "raster" !== t2 && e.t() && (this.imageRasterizerDispatcher = new e.D(e.x(), this, "Image Rasterizer Worker", 1));
            }
            addScope(t2) {
              this.loaded.set(t2, false), this.imageProviders.set(t2, /* @__PURE__ */ new Map()), this.images.set(t2, /* @__PURE__ */ new Map()), this.updatedImages.set(t2, /* @__PURE__ */ new Set()), this.callbackDispatchedThisFrame.set(t2, /* @__PURE__ */ new Set()), this.patterns.set(t2, /* @__PURE__ */ new Map()), this.atlasImage.set(t2, new e.r({ width: 1, height: 1 }));
            }
            removeScope(e2) {
              this.loaded.delete(e2), this.imageProviders.delete(e2), this.images.delete(e2), this.updatedImages.delete(e2), this.callbackDispatchedThisFrame.delete(e2), this.patterns.delete(e2), this.atlasImage.delete(e2);
              const t2 = this.atlasTexture.get(e2);
              t2 && (t2.destroy(), this.atlasTexture.delete(e2));
            }
            addImageProvider(e2, t2) {
              this.imageProviders.has(t2) || this.imageProviders.set(t2, /* @__PURE__ */ new Map()), this.imageProviders.get(t2).set(e2.id, e2);
            }
            removeImageProvider(e2, t2) {
              this.imageProviders.has(t2) && this.imageProviders.get(t2).delete(e2);
            }
            getPendingImageProviders() {
              const e2 = [];
              for (const t2 of this.imageProviders.values()) for (const i2 of t2.values()) i2.hasPendingRequests() && e2.push(i2);
              return e2;
            }
            get imageRasterizer() {
              return this._imageRasterizer || (this._imageRasterizer = new e.y()), this._imageRasterizer;
            }
            isLoaded() {
              for (const e2 of this.loaded.keys()) if (!this.loaded.get(e2)) return false;
              return true;
            }
            setLoaded(e2, t2) {
              if (this.loaded.get(t2) !== e2 && (this.loaded.set(t2, e2), e2)) {
                for (const { ids: e3, callback: i2 } of this.requestors) this._notify(e3, t2, i2);
                this.requestors = [];
              }
            }
            hasImage(e2, t2) {
              return !!this.getImage(e2, t2);
            }
            getImage(e2, t2) {
              return this.images.get(t2).get(e2.toString());
            }
            addImage(e2, t2, i2) {
              this._validate(e2, i2) && this.images.get(t2).set(e2.toString(), i2);
            }
            _validate(t2, i2) {
              let o2 = true;
              return this._validateStretch(i2.stretchX, i2.data && i2.data.width) || (this.fire(new e.z(new Error(`Image "${t2.name}" has invalid "stretchX" value`))), o2 = false), this._validateStretch(i2.stretchY, i2.data && i2.data.height) || (this.fire(new e.z(new Error(`Image "${t2.name}" has invalid "stretchY" value`))), o2 = false), this._validateContent(i2.content, i2) || (this.fire(new e.z(new Error(`Image "${t2.name}" has invalid "content" value`))), o2 = false), o2;
            }
            _validateStretch(e2, t2) {
              if (!e2) return true;
              let i2 = 0;
              for (const o2 of e2) {
                if (o2[0] < i2 || o2[1] < o2[0] || t2 < o2[1]) return false;
                i2 = o2[1];
              }
              return true;
            }
            _validateContent(e2, t2) {
              if (!e2) return true;
              if (4 !== e2.length) return false;
              if (!t2.usvg) {
                if (e2[0] < 0 || t2.data.width < e2[0]) return false;
                if (e2[1] < 0 || t2.data.height < e2[1]) return false;
                if (e2[2] < 0 || t2.data.width < e2[2]) return false;
                if (e2[3] < 0 || t2.data.height < e2[3]) return false;
              }
              return !(e2[2] < e2[0] || e2[3] < e2[1]);
            }
            updateImage(e2, t2, i2) {
              const o2 = this.images.get(t2).get(e2.toString());
              i2.version = o2.version + 1, this.images.get(t2).set(e2.toString(), i2), this.updatedImages.get(t2).add(e2), this.removeFromImageRasterizerCache(e2, t2);
            }
            clearUpdatedImages(e2) {
              this.updatedImages.get(e2).clear();
            }
            removeFromImageRasterizerCache(t2, i2) {
              "raster" !== this.spriteFormat && (e.t() ? this.imageRasterizerDispatcher.getActor().send("removeRasterizedImages", { imageIds: [t2], scope: i2 }) : this.imageRasterizer.removeImagesFromCacheByIds([t2], i2));
            }
            removeImage(e2, t2) {
              const i2 = this.images.get(t2), o2 = i2.get(e2.toString());
              i2.delete(e2.toString()), this.patterns.get(t2).delete(e2.toString()), this.removeFromImageRasterizerCache(e2, t2), o2.userImage && o2.userImage.onRemove && o2.userImage.onRemove();
            }
            listImages(t2) {
              return Array.from(this.images.get(t2).keys()).map((t3) => e.I.from(t3));
            }
            getImages(e2, t2, i2) {
              const o2 = [], s2 = [], r2 = this.imageProviders.get(t2);
              for (const i3 of e2) {
                if (!i3.iconsetId) {
                  o2.push(i3);
                  continue;
                }
                const e3 = r2.get(i3.iconsetId);
                e3 && (this.getImage(i3, t2) ? s2.push(i3) : e3.addPendingRequest(i3));
              }
              if (0 === o2.length) return void this._notify(s2, t2, i2);
              let n2 = true;
              const a2 = !!this.loaded.get(t2), l2 = this.images.get(t2);
              if (!a2) for (const e3 of o2) l2.has(e3.toString()) || (n2 = false);
              a2 || n2 ? this._notify(o2, t2, i2) : this.requestors.push({ ids: o2, scope: t2, callback: i2 });
            }
            rasterizeImages(e2, t2) {
              const i2 = /* @__PURE__ */ new Map(), { tasks: o2, scope: s2 } = e2;
              for (const [e3, t3] of o2.entries()) {
                const o3 = this.getImage(t3.id, s2);
                o3 && i2.set(e3, { image: o3, imageVariant: t3 });
              }
              this._rasterizeImages(s2, i2, t2);
            }
            _rasterizeImages(t2, i2, o2) {
              if (e.t()) this.imageRasterizerDispatcher.getActor().send("rasterizeImagesWorker", { tasks: i2, scope: t2 }, o2);
              else {
                const e2 = /* @__PURE__ */ new Map();
                for (const [o3, { image: s2, imageVariant: r2 }] of i2.entries()) e2.set(o3, this.imageRasterizer.rasterize(r2, s2, t2, 0));
                o2(void 0, e2);
              }
            }
            getUpdatedImages(e2) {
              return this.updatedImages.get(e2) || /* @__PURE__ */ new Set();
            }
            _notify(t2, i2, o2) {
              const s2 = this.images.get(i2), r2 = /* @__PURE__ */ new Map();
              for (const i3 of t2) {
                if (!s2.get(i3.toString())) {
                  if (i3.iconsetId) continue;
                  this.fire(new e.A("styleimagemissing", { id: i3.name }));
                }
                const t3 = s2.get(i3.toString());
                if (!t3) {
                  e.w(`Image "${i3.name}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                  continue;
                }
                const o3 = { data: t3.usvg ? null : t3.data.clone(), pixelRatio: t3.pixelRatio, sdf: t3.sdf, usvg: t3.usvg, version: t3.version, stretchX: t3.stretchX, stretchY: t3.stretchY, content: t3.content, hasRenderCallback: Boolean(t3.userImage && t3.userImage.render) };
                t3.usvg && Object.assign(o3, { width: t3.icon.usvg_tree.width, height: t3.icon.usvg_tree.height }), r2.set(e.I.toString(i3), o3);
              }
              o2(null, r2);
            }
            getPixelSize(e2) {
              const { width: t2, height: i2 } = this.atlasImage.get(e2);
              return { width: t2, height: i2 };
            }
            getPattern(t2, i2, o2) {
              const s2 = t2.toString(), r2 = this.patterns.get(i2), n2 = r2.get(s2), a2 = this.getImage(t2, i2);
              if (!a2) return null;
              if (n2) {
                if (n2.position.version === a2.version) return n2.position;
                n2.position.version = a2.version;
              } else {
                if (a2.usvg && !a2.data) {
                  const r3 = this.getPatternInFlightId(s2, i2);
                  if (this.patternsInFlight.has(r3)) return null;
                  this.patternsInFlight.add(r3);
                  const n3 = new e.B(t2).scaleSelf(e.q.devicePixelRatio), l2 = /* @__PURE__ */ new Map([[n3.toString(), { image: a2, imageVariant: n3 }]]);
                  return this._rasterizeImages(i2, l2, (e2, t3) => this.storePatternImage(n3, i2, a2, o2, t3)), null;
                }
                this.storePattern(t2, i2, a2);
              }
              return this._updatePatternAtlas(i2, o2), r2.get(s2).position;
            }
            getPatternInFlightId(t2, i2) {
              return e.C(t2, i2);
            }
            hasPatternsInFlight() {
              return 0 !== this.patternsInFlight.size;
            }
            storePatternImage(e2, t2, i2, o2, s2) {
              const r2 = e2.toString(), n2 = s2 ? s2.get(r2) : void 0;
              n2 && (i2.data = n2, this.storePattern(e2.id, t2, i2), this._updatePatternAtlas(t2, o2), this.patternsInFlight.delete(this.getPatternInFlightId(e2.id.toString(), t2)));
            }
            storePattern(t2, i2, o2) {
              const s2 = { w: o2.data.width + 2 * e.F, h: o2.data.height + 2 * e.F, x: 0, y: 0 }, r2 = new e.G(s2, o2, e.F);
              this.patterns.get(i2).set(t2.toString(), { bin: s2, position: r2 });
            }
            bind(t2, i2) {
              const o2 = t2.gl;
              let s2 = this.atlasTexture.get(i2);
              s2 ? this.dirty && (s2.update(this.atlasImage.get(i2)), this.dirty = false) : (s2 = new e.T(t2, this.atlasImage.get(i2), o2.RGBA8), this.atlasTexture.set(i2, s2)), s2.bind(o2.LINEAR, o2.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(t2, i2) {
              const o2 = this.patterns.get(t2), s2 = Array.from(o2.values()).map(({ bin: e2 }) => e2), { w: r2, h: n2 } = e.H(s2), a2 = this.atlasImage.get(t2);
              a2.resize({ width: r2 || 1, height: n2 || 1 });
              const l2 = this.images.get(t2);
              for (const [t3, { bin: s3, position: r3 }] of o2.entries()) {
                let o3 = r3.padding;
                const n3 = s3.x + o3, c2 = s3.y + o3, h3 = l2.get(t3).data, d2 = h3.width, u2 = h3.height;
                o3 = o3 > 1 ? o3 - 1 : o3, e.r.copy(h3, a2, { x: 0, y: 0 }, { x: n3, y: c2 }, { width: d2, height: u2 }, i2), e.r.copy(h3, a2, { x: 0, y: u2 - o3 }, { x: n3, y: c2 - o3 }, { width: d2, height: o3 }, i2), e.r.copy(h3, a2, { x: 0, y: 0 }, { x: n3, y: c2 + u2 }, { width: d2, height: o3 }, i2), e.r.copy(h3, a2, { x: d2 - o3, y: 0 }, { x: n3 - o3, y: c2 }, { width: o3, height: u2 }, i2), e.r.copy(h3, a2, { x: 0, y: 0 }, { x: n3 + d2, y: c2 }, { width: o3, height: u2 }, i2), e.r.copy(h3, a2, { x: d2 - o3, y: u2 - o3 }, { x: n3 - o3, y: c2 - o3 }, { width: o3, height: o3 }, i2), e.r.copy(h3, a2, { x: 0, y: u2 - o3 }, { x: n3 + d2, y: c2 - o3 }, { width: o3, height: o3 }, i2), e.r.copy(h3, a2, { x: 0, y: 0 }, { x: n3 + d2, y: c2 + u2 }, { width: o3, height: o3 }, i2), e.r.copy(h3, a2, { x: d2 - o3, y: 0 }, { x: n3 - o3, y: c2 + u2 }, { width: o3, height: o3 }, i2);
              }
              this.dirty = true;
            }
            beginFrame() {
              for (const e2 of this.images.keys()) this.callbackDispatchedThisFrame.set(e2, /* @__PURE__ */ new Set());
            }
            dispatchRenderCallbacks(e2, t2) {
              const i2 = this.images.get(t2);
              for (const o2 of e2) {
                if (this.callbackDispatchedThisFrame.get(t2).has(o2.toString())) continue;
                this.callbackDispatchedThisFrame.get(t2).add(o2.toString());
                const e3 = i2.get(o2.toString());
                G(e3) && this.updateImage(o2, t2, e3);
              }
            }
          }
          function Z(t2) {
            const i2 = t2.key, o2 = t2.value, s2 = t2.valueSpec || {}, r2 = t2.objectElementValidators || {}, n2 = t2.style, a2 = t2.styleSpec;
            let l2 = [];
            const c2 = e.J(o2);
            if ("object" !== c2) return [new e.V(i2, o2, `object expected, ${c2} found`)];
            for (const t3 in o2) {
              const c3 = t3.split(".")[0];
              let h3;
              r2[c3] ? h3 = r2[c3] : s2[c3] ? h3 = _e : r2["*"] ? h3 = r2["*"] : s2["*"] && (h3 = _e), h3 ? l2 = l2.concat(h3({ key: (i2 ? `${i2}.` : i2) + t3, value: o2[t3], valueSpec: s2[c3] || s2["*"], style: n2, styleSpec: a2, object: o2, objectKey: t3 }, o2)) : l2.push(new e.K(i2, o2[t3], `unknown property "${t3}"`));
            }
            for (const t3 in s2) r2[t3] || s2[t3].required && void 0 === s2[t3].default && void 0 === o2[t3] && l2.push(new e.V(i2, o2, `missing required property "${t3}"`));
            return l2;
          }
          function H(t2) {
            const i2 = t2.value, o2 = t2.valueSpec, s2 = t2.style, r2 = t2.styleSpec, n2 = t2.key, a2 = t2.arrayElementValidator || _e;
            if ("array" !== e.J(i2)) return [new e.V(n2, i2, `array expected, ${e.J(i2)} found`)];
            if (o2.length && i2.length !== o2.length) return [new e.V(n2, i2, `array length ${o2.length} expected, length ${i2.length} found`)];
            if (o2["min-length"] && i2.length < o2["min-length"]) return [new e.V(n2, i2, `array length at least ${o2["min-length"]} expected, length ${i2.length} found`)];
            let l2 = { type: o2.value, values: o2.values, minimum: o2.minimum, maximum: o2.maximum, function: void 0 };
            r2.$version < 7 && (l2.function = o2.function), "object" === e.J(o2.value) && (l2 = o2.value);
            let c2 = [];
            for (let e2 = 0; e2 < i2.length; e2++) c2 = c2.concat(a2({ array: i2, arrayIndex: e2, value: i2[e2], valueSpec: l2, style: s2, styleSpec: r2, key: `${n2}[${e2}]` }, true));
            return c2;
          }
          function W(t2) {
            const i2 = t2.key, o2 = t2.value, s2 = t2.valueSpec;
            let r2 = e.J(o2);
            if ("number" === r2 && o2 != o2 && (r2 = "NaN"), "number" !== r2) return [new e.V(i2, o2, `number expected, ${r2} found`)];
            if ("minimum" in s2) {
              let r3 = s2.minimum;
              if ("array" === e.J(s2.minimum) && (r3 = s2.minimum[t2.arrayIndex]), o2 < r3) return [new e.V(i2, o2, `${o2} is less than the minimum value ${r3}`)];
            }
            if ("maximum" in s2) {
              let r3 = s2.maximum;
              if ("array" === e.J(s2.maximum) && (r3 = s2.maximum[t2.arrayIndex]), o2 > r3) return [new e.V(i2, o2, `${o2} is greater than the maximum value ${r3}`)];
            }
            return [];
          }
          function $(t2) {
            const i2 = t2.valueSpec, o2 = e.M(t2.value.type);
            let s2, r2, n2, a2 = {};
            const l2 = "categorical" !== o2 && void 0 === t2.value.property, c2 = !l2, h3 = "array" === e.J(t2.value.stops) && "array" === e.J(t2.value.stops[0]) && "object" === e.J(t2.value.stops[0][0]), d2 = Z({ key: t2.key, value: t2.value, valueSpec: t2.styleSpec.function, style: t2.style, styleSpec: t2.styleSpec, objectElementValidators: { stops: function(t3) {
              if ("identity" === o2) return [new e.V(t3.key, t3.value, 'identity function may not have a "stops" property')];
              let i3 = [];
              const s3 = t3.value;
              return i3 = i3.concat(H({ key: t3.key, value: s3, valueSpec: t3.valueSpec, style: t3.style, styleSpec: t3.styleSpec, arrayElementValidator: u2 })), "array" === e.J(s3) && 0 === s3.length && i3.push(new e.V(t3.key, s3, "array must have at least one stop")), i3;
            }, default: function(e2) {
              return _e({ key: e2.key, value: e2.value, valueSpec: i2, style: e2.style, styleSpec: e2.styleSpec });
            } } });
            return "identity" === o2 && l2 && d2.push(new e.V(t2.key, t2.value, 'missing required property "property"')), "identity" === o2 || t2.value.stops || d2.push(new e.V(t2.key, t2.value, 'missing required property "stops"')), "exponential" === o2 && t2.valueSpec.expression && !e.N(t2.valueSpec) && d2.push(new e.V(t2.key, t2.value, "exponential functions not supported")), t2.styleSpec.$version >= 8 && (c2 && !e.O(t2.valueSpec) ? d2.push(new e.V(t2.key, t2.value, "property functions not supported")) : l2 && !e.Q(t2.valueSpec) && d2.push(new e.V(t2.key, t2.value, "zoom functions not supported"))), "categorical" !== o2 && !h3 || void 0 !== t2.value.property || d2.push(new e.V(t2.key, t2.value, '"property" property is required')), d2;
            function u2(t3) {
              let o3 = [];
              const s3 = t3.value, l3 = t3.key;
              if ("array" !== e.J(s3)) return [new e.V(l3, s3, `array expected, ${e.J(s3)} found`)];
              if (2 !== s3.length) return [new e.V(l3, s3, `array length 2 expected, length ${s3.length} found`)];
              if (h3) {
                if ("object" !== e.J(s3[0])) return [new e.V(l3, s3, `object expected, ${e.J(s3[0])} found`)];
                if (void 0 === s3[0].zoom) return [new e.V(l3, s3, "object stop key must have zoom")];
                if (void 0 === s3[0].value) return [new e.V(l3, s3, "object stop key must have value")];
                const i3 = e.M(s3[0].zoom);
                if ("number" != typeof i3) return [new e.V(l3, s3[0].zoom, "stop zoom values must be numbers")];
                if (n2 && n2 > i3) return [new e.V(l3, s3[0].zoom, "stop zoom values must appear in ascending order")];
                i3 !== n2 && (n2 = i3, r2 = void 0, a2 = {}), o3 = o3.concat(Z({ key: `${l3}[0]`, value: s3[0], valueSpec: { zoom: {} }, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { zoom: W, value: _2 } }));
              } else o3 = o3.concat(_2({ key: `${l3}[0]`, value: s3[0], style: t3.style, styleSpec: t3.styleSpec }, s3));
              return e.S(e.U(s3[1])) ? o3.concat([new e.V(`${l3}[1]`, s3[1], "expressions are not allowed in function stops.")]) : o3.concat(_e({ key: `${l3}[1]`, value: s3[1], valueSpec: i2, style: t3.style, styleSpec: t3.styleSpec }));
            }
            function _2(t3, n3) {
              const l3 = e.J(t3.value), c3 = e.M(t3.value), h4 = null !== t3.value ? t3.value : n3;
              if (s2) {
                if (l3 !== s2) return [new e.V(t3.key, h4, `${l3} stop domain type must match previous stop domain type ${s2}`)];
              } else s2 = l3;
              if ("number" !== l3 && "string" !== l3 && "boolean" !== l3 && "number" != typeof c3 && "string" != typeof c3 && "boolean" != typeof c3) return [new e.V(t3.key, h4, "stop domain value must be a number, string, or boolean")];
              if ("number" !== l3 && "categorical" !== o2) {
                let s3 = `number expected, ${l3} found`;
                return e.O(i2) && void 0 === o2 && (s3 += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [new e.V(t3.key, h4, s3)];
              }
              return "categorical" !== o2 || "number" !== l3 || "number" == typeof c3 && isFinite(c3) && Math.floor(c3) === c3 ? "categorical" !== o2 && "number" === l3 && "number" == typeof c3 && "number" == typeof r2 && void 0 !== r2 && c3 < r2 ? [new e.V(t3.key, h4, "stop domain values must appear in ascending order")] : (r2 = c3, "categorical" === o2 && c3 in a2 ? [new e.V(t3.key, h4, "stop domain values must be unique")] : (a2[c3] = true, [])) : [new e.V(t3.key, h4, `integer expected, found ${String(c3)}`)];
            }
          }
          function X(t2) {
            const i2 = ("property" === t2.expressionContext ? e.W : e.X)(e.U(t2.value), t2.valueSpec);
            if ("error" === i2.result) return i2.value.map((i3) => new e.V(`${t2.key}${i3.key}`, t2.value, i3.message));
            const o2 = i2.value.expression || i2.value._styleExpression.expression;
            if ("property" === t2.expressionContext && "text-font" === t2.propertyKey && !o2.outputDefined()) return [new e.V(t2.key, t2.value, `Invalid data expression for "${t2.propertyKey}". Output values must be contained as literals within the expression.`)];
            if ("property" === t2.expressionContext && "layout" === t2.propertyType && !e.Y(o2)) return [new e.V(t2.key, t2.value, '"feature-state" data expressions are not supported with layout properties.')];
            if ("filter" === t2.expressionContext) return Y(o2, t2);
            if (t2.expressionContext && 0 === t2.expressionContext.indexOf("cluster")) {
              if (!e.Z(o2, ["zoom", "feature-state"])) return [new e.V(t2.key, t2.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
              if ("cluster-initial" === t2.expressionContext && !e._(o2)) return [new e.V(t2.key, t2.value, "Feature data expressions are not supported with initial expression part of cluster properties.")];
            }
            return [];
          }
          function Y(t2, i2) {
            const o2 = /* @__PURE__ */ new Set(["zoom", "feature-state", "pitch", "distance-from-center"]);
            if (i2.valueSpec && i2.valueSpec.expression) for (const e2 of i2.valueSpec.expression.parameters) o2.delete(e2);
            if (0 === o2.size) return [];
            const s2 = [];
            return t2 instanceof e.$ && o2.has(t2.name) ? [new e.V(i2.key, i2.value, `["${t2.name}"] expression is not supported in a filter for a ${i2.object.type} layer with id: ${i2.object.id}`)] : (t2.eachChild((e2) => {
              s2.push(...Y(e2, i2));
            }), s2);
          }
          function K(t2) {
            const i2 = t2.key, o2 = t2.value, s2 = t2.valueSpec, r2 = [];
            return Array.isArray(s2.values) ? -1 === s2.values.indexOf(e.M(o2)) && r2.push(new e.V(i2, o2, `expected one of [${s2.values.join(", ")}], ${JSON.stringify(o2)} found`)) : -1 === Object.keys(s2.values).indexOf(e.M(o2)) && r2.push(new e.V(i2, o2, `expected one of [${Object.keys(s2.values).join(", ")}], ${JSON.stringify(o2)} found`)), r2;
          }
          function J(t2) {
            return e.a1(e.U(t2.value)) ? X(e.L({}, t2, { expressionContext: "filter", valueSpec: t2.styleSpec[`filter_${t2.layerType || "fill"}`] })) : Q(t2);
          }
          function Q(t2) {
            const i2 = t2.value, o2 = t2.key;
            if ("array" !== e.J(i2)) return [new e.V(o2, i2, `array expected, ${e.J(i2)} found`)];
            const s2 = t2.styleSpec;
            let r2, n2 = [];
            if (i2.length < 1) return [new e.V(o2, i2, "filter array must have at least 1 element")];
            switch (n2 = n2.concat(K({ key: `${o2}[0]`, value: i2[0], valueSpec: s2.filter_operator, style: t2.style, styleSpec: t2.styleSpec })), e.M(i2[0])) {
              case "<":
              case "<=":
              case ">":
              case ">=":
                i2.length >= 2 && "$type" === e.M(i2[1]) && n2.push(new e.V(o2, i2, `"$type" cannot be use with operator "${i2[0]}"`));
              case "==":
              case "!=":
                3 !== i2.length && n2.push(new e.V(o2, i2, `filter array for operator "${i2[0]}" must have 3 elements`));
              case "in":
              case "!in":
                i2.length >= 2 && (r2 = e.J(i2[1]), "string" !== r2 && n2.push(new e.V(`${o2}[1]`, i2[1], `string expected, ${r2} found`)));
                for (let a2 = 2; a2 < i2.length; a2++) r2 = e.J(i2[a2]), "$type" === e.M(i2[1]) ? n2 = n2.concat(K({ key: `${o2}[${a2}]`, value: i2[a2], valueSpec: s2.geometry_type, style: t2.style, styleSpec: t2.styleSpec })) : "string" !== r2 && "number" !== r2 && "boolean" !== r2 && n2.push(new e.V(`${o2}[${a2}]`, i2[a2], `string, number, or boolean expected, ${r2} found`));
                break;
              case "any":
              case "all":
              case "none":
                for (let e2 = 1; e2 < i2.length; e2++) n2 = n2.concat(Q({ key: `${o2}[${e2}]`, value: i2[e2], style: t2.style, styleSpec: t2.styleSpec }));
                break;
              case "has":
              case "!has":
                r2 = e.J(i2[1]), 2 !== i2.length ? n2.push(new e.V(o2, i2, `filter array for "${i2[0]}" operator must have 2 elements`)) : "string" !== r2 && n2.push(new e.V(`${o2}[1]`, i2[1], `string expected, ${r2} found`));
            }
            return n2;
          }
          function ee(t2, i2) {
            const o2 = t2.key, s2 = t2.style, r2 = t2.layer, n2 = t2.styleSpec, a2 = t2.value, l2 = t2.objectKey, c2 = n2[`${i2}_${t2.layerType}`];
            if (!c2) return [];
            const h3 = l2.match(/^(.*)-use-theme$/);
            if ("paint" === i2 && h3 && c2[h3[1]]) return e.S(a2) ? [].concat(_e({ key: t2.key, value: a2, valueSpec: { type: "string", expression: { interpolated: false, parameters: ["zoom", "feature"] }, "property-type": "data-driven" }, style: s2, styleSpec: n2, expressionContext: "property", propertyType: i2, propertyKey: l2 })) : _e({ key: o2, value: a2, valueSpec: { type: "string" }, style: s2, styleSpec: n2 });
            const d2 = l2.match(/^(.*)-transition$/);
            if ("paint" === i2 && d2 && c2[d2[1]] && c2[d2[1]].transition) return _e({ key: o2, value: a2, valueSpec: n2.transition, style: s2, styleSpec: n2 });
            const u2 = t2.valueSpec || c2[l2];
            if (!u2) return [new e.K(o2, a2, `unknown property "${l2}"`)];
            let _2;
            if ("string" === e.J(a2) && e.O(u2) && !u2.tokens && (_2 = /^{([^}]+)}$/.exec(a2))) {
              const t3 = `\`{ "type": "identity", "property": ${_2 ? JSON.stringify(_2[1]) : '"_"'} }\``;
              return [new e.V(o2, a2, `"${l2}" does not support interpolation syntax
Use an identity property function instead: ${t3}.`)];
            }
            const p3 = [];
            if ("symbol" === t2.layerType) "text-field" !== l2 || !s2 || s2.glyphs || s2.imports || p3.push(new e.V(o2, a2, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l2 && e.a2(e.U(a2)) && "identity" === e.M(a2.type) && p3.push(new e.V(o2, a2, '"text-font" does not support identity functions'));
            else if ("model" === t2.layerType && "paint" === i2 && r2 && r2.layout && r2.layout.hasOwnProperty("model-id") && e.O(u2) && (e.a3(u2) || e.Q(u2))) {
              const t3 = e.W(e.U(a2), u2), i3 = t3.value.expression || t3.value._styleExpression.expression;
              i3 && !e.Z(i3, ["measure-light"]) && ("model-emissive-strength" === l2 && e._(i3) && e.Y(i3) || p3.push(new e.V(o2, a2, `${l2} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return p3.concat(_e({ key: t2.key, value: a2, valueSpec: u2, style: s2, styleSpec: n2, expressionContext: "property", propertyType: i2, propertyKey: l2 }));
          }
          function te(e2) {
            return ee(e2, "paint");
          }
          function ie(e2) {
            return ee(e2, "layout");
          }
          function oe(t2) {
            let i2 = [];
            const o2 = t2.value, s2 = t2.key, r2 = t2.style, n2 = t2.styleSpec;
            o2.type || o2.ref || i2.push(new e.V(s2, o2, 'either "type" or "ref" is required'));
            let a2 = e.M(o2.type);
            const l2 = e.M(o2.ref);
            if (o2.id) {
              const n3 = e.M(o2.id);
              for (let a3 = 0; a3 < t2.arrayIndex; a3++) {
                const t3 = r2.layers[a3];
                e.M(t3.id) === n3 && i2.push(new e.V(s2, o2.id, `duplicate layer id "${o2.id}", previously used at line ${t3.id.__line__}`));
              }
            }
            if ("ref" in o2) {
              let t3;
              ["type", "source", "source-layer", "filter", "layout"].forEach((t4) => {
                t4 in o2 && i2.push(new e.V(s2, o2[t4], `"${t4}" is prohibited for ref layers`));
              }), r2.layers.forEach((i3) => {
                e.M(i3.id) === l2 && (t3 = i3);
              }), t3 ? t3.ref ? i2.push(new e.V(s2, o2.ref, "ref cannot reference another ref layer")) : a2 = e.M(t3.type) : "string" == typeof l2 && i2.push(new e.V(s2, o2.ref, `ref layer "${l2}" not found`));
            } else if ("background" !== a2 && "sky" !== a2 && "slot" !== a2) if (o2.source) {
              const t3 = r2.sources && r2.sources[o2.source], n3 = t3 && e.M(t3.type);
              t3 ? "vector" === n3 && "raster" === a2 ? i2.push(new e.V(s2, o2.source, `layer "${o2.id}" requires a raster source`)) : "raster" === n3 && "raster" !== a2 ? i2.push(new e.V(s2, o2.source, `layer "${o2.id}" requires a vector source`)) : "vector" !== n3 || o2["source-layer"] ? "raster-dem" === n3 && "hillshade" !== a2 ? i2.push(new e.V(s2, o2.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== n3 || ["raster", "raster-particle"].includes(a2) ? "line" === a2 && o2.paint && (o2.paint["line-gradient"] || o2.paint["line-trim-offset"]) && "geojson" === n3 && !t3.lineMetrics ? i2.push(new e.V(s2, o2, `layer "${o2.id}" specifies a line-gradient, which requires the GeoJSON source to have \`lineMetrics\` enabled.`)) : "raster-particle" === a2 && "raster-array" !== n3 && i2.push(new e.V(s2, o2.source, `layer "${o2.id}" requires a 'raster-array' source.`)) : i2.push(new e.V(s2, o2.source, "raster-array source can only be used with layer type 'raster'.")) : i2.push(new e.V(s2, o2, `layer "${o2.id}" must specify a "source-layer"`)) : i2.push(new e.V(s2, o2.source, `source "${o2.source}" not found`));
            } else i2.push(new e.V(s2, o2, 'missing required property "source"'));
            return i2 = i2.concat(Z({ key: s2, value: o2, valueSpec: n2.layer, style: t2.style, styleSpec: t2.styleSpec, objectElementValidators: { "*": () => [], type: () => _e({ key: `${s2}.type`, value: o2.type, valueSpec: n2.layer.type, style: t2.style, styleSpec: t2.styleSpec, object: o2, objectKey: "type" }), filter: (t3) => J(e.L({ layerType: a2 }, t3)), layout: (t3) => Z({ layer: o2, key: t3.key, value: t3.value, valueSpec: {}, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { "*": (t4) => ie(e.L({ layerType: a2 }, t4)) } }), paint: (t3) => Z({ layer: o2, key: t3.key, value: t3.value, valueSpec: {}, style: t3.style, styleSpec: t3.styleSpec, objectElementValidators: { "*": (t4) => te(e.L({ layerType: a2, layer: o2 }, t4)) } }) } })), i2;
          }
          function se(t2) {
            const i2 = t2.value, o2 = t2.key, s2 = e.J(i2);
            return "string" !== s2 ? [new e.V(o2, i2, `string expected, ${s2} found`)] : [];
          }
          const re = { promoteId: function t2({ key: i2, value: o2 }) {
            if ("string" === e.J(o2)) return se({ key: i2, value: o2 });
            if (Array.isArray(o2)) {
              const t3 = [], s2 = e.U(o2), r2 = e.X(s2);
              return "error" === r2.result && r2.value.forEach((o3) => {
                t3.push(new e.V(`${i2}${o3.key}`, null, `${o3.message}`));
              }), e.Z(r2.value.expression, ["zoom", "heatmap-density", "line-progress", "raster-value", "sky-radial-progress", "accumulated", "is-supported-script", "pitch", "distance-from-center", "measure-light", "raster-particle-speed"]) || t3.push(new e.V(`${i2}`, null, "promoteId expression should be only feature dependent")), t3;
            }
            {
              const e2 = [];
              for (const s2 in o2) e2.push(...t2({ key: `${i2}.${s2}`, value: o2[s2] }));
              return e2;
            }
          } };
          function ne(t2) {
            const i2 = t2.value, o2 = t2.key, s2 = t2.styleSpec, r2 = t2.style;
            if (!i2.type) return [new e.V(o2, i2, '"type" is required')];
            const n2 = e.M(i2.type);
            let a2 = [];
            switch (["vector", "raster", "raster-dem", "raster-array"].includes(n2) && (i2.url || i2.tiles || a2.push(new e.K(o2, i2, 'Either "url" or "tiles" is required.'))), n2) {
              case "vector":
              case "raster":
              case "raster-dem":
              case "raster-array":
                return a2 = a2.concat(Z({ key: o2, value: i2, valueSpec: s2[`source_${n2.replace("-", "_")}`], style: t2.style, styleSpec: s2, objectElementValidators: re })), a2;
              case "geojson":
                if (a2 = Z({ key: o2, value: i2, valueSpec: s2.source_geojson, style: r2, styleSpec: s2, objectElementValidators: re }), i2.cluster) for (const e2 in i2.clusterProperties) {
                  const [t3, s3] = i2.clusterProperties[e2], r3 = "string" == typeof t3 ? [t3, ["accumulated"], ["get", e2]] : t3;
                  a2.push(...X({ key: `${o2}.${e2}.map`, value: s3, expressionContext: "cluster-map" })), a2.push(...X({ key: `${o2}.${e2}.reduce`, value: r3, expressionContext: "cluster-reduce" }));
                }
                return a2;
              case "video":
                return Z({ key: o2, value: i2, valueSpec: s2.source_video, style: r2, styleSpec: s2 });
              case "image":
                return Z({ key: o2, value: i2, valueSpec: s2.source_image, style: r2, styleSpec: s2 });
              case "canvas":
                return [new e.V(o2, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")];
              default:
                return K({ key: `${o2}.type`, value: i2.type, valueSpec: { values: ae(s2) } });
            }
          }
          function ae(e2) {
            return e2.source.reduce((t2, i2) => {
              const o2 = e2[i2];
              return "enum" === o2.type.type && (t2 = t2.concat(Object.keys(o2.type.values))), t2;
            }, []);
          }
          function le(t2) {
            const i2 = t2.value, o2 = t2.styleSpec, s2 = o2.light, r2 = t2.style;
            let n2 = [];
            const a2 = e.J(i2);
            if (void 0 === i2) return n2;
            if ("object" !== a2) return n2 = n2.concat([new e.V("light", i2, `object expected, ${a2} found`)]), n2;
            for (const t3 in i2) {
              const a3 = t3.match(/^(.*)-transition$/), l2 = t3.match(/^(.*)-use-theme$/);
              n2 = n2.concat(l2 && s2[l2[1]] ? _e({ key: t3, value: i2[t3], valueSpec: { type: "string" }, style: r2, styleSpec: o2 }) : a3 && s2[a3[1]] && s2[a3[1]].transition ? _e({ key: t3, value: i2[t3], valueSpec: o2.transition, style: r2, styleSpec: o2 }) : s2[t3] ? _e({ key: t3, value: i2[t3], valueSpec: s2[t3], style: r2, styleSpec: o2 }) : [new e.V(t3, i2[t3], `unknown property "${t3}"`)]);
            }
            return n2;
          }
          function ce(t2) {
            const i2 = t2.value;
            let o2 = [];
            if (!i2) return o2;
            const s2 = e.J(i2);
            if ("object" !== s2) return o2 = o2.concat([new e.V("light-3d", i2, `object expected, ${s2} found`)]), o2;
            const r2 = t2.styleSpec, n2 = r2["light-3d"], a2 = t2.key, l2 = t2.style, c2 = t2.style.lights;
            for (const t3 of ["type", "id"]) if (!(t3 in i2)) return o2 = o2.concat([new e.V("light-3d", i2, `missing property ${t3} on light`)]), o2;
            if (i2.type && c2) for (let s3 = 0; s3 < t2.arrayIndex; s3++) {
              const t3 = e.M(i2.type), r3 = c2[s3];
              e.M(r3.type) === t3 && o2.push(new e.V(a2, i2.id, `duplicate light type "${i2.type}", previously defined at line ${r3.id.__line__}`));
            }
            const h3 = `properties_light_${i2.type}`;
            if (!(h3 in r2)) return o2 = o2.concat([new e.V("light-3d", i2, `Invalid light type ${i2.type}`)]), o2;
            const d2 = r2[h3];
            for (const s3 in i2) if ("properties" === s3) {
              const n3 = i2[s3], a3 = e.J(n3);
              if ("object" !== a3) return o2 = o2.concat([new e.V("properties", n3, `object expected, ${a3} found`)]), o2;
              for (const a4 in n3) {
                const c3 = a4.match(/^(.*)-transition$/), h4 = a4.match(/^(.*)-use-theme$/);
                o2 = o2.concat(h4 && d2[h4[1]] ? _e({ key: s3, value: n3[a4], valueSpec: { type: "string" }, style: l2, styleSpec: r2 }) : c3 && d2[c3[1]] && d2[c3[1]].transition ? _e({ key: s3, value: i2[s3], valueSpec: r2.transition, style: l2, styleSpec: r2 }) : d2[a4] ? _e({ key: a4, value: n3[a4], valueSpec: d2[a4], style: l2, styleSpec: r2 }) : [new e.K(t2.key, n3[a4], `unknown property "${a4}"`)]);
              }
            } else o2 = o2.concat(n2[s3] ? _e({ key: s3, value: i2[s3], valueSpec: n2[s3], style: l2, styleSpec: r2 }) : [new e.K(s3, i2[s3], `unknown property "${s3}"`)]);
            return o2;
          }
          function he(t2) {
            const i2 = t2.value, o2 = t2.key, s2 = t2.style, r2 = t2.styleSpec, n2 = r2.terrain;
            let a2 = [];
            const l2 = e.J(i2);
            if (void 0 === i2) return a2;
            if ("null" === l2) return a2;
            if ("object" !== l2) return a2 = a2.concat([new e.V("terrain", i2, `object expected, ${l2} found`)]), a2;
            for (const t3 in i2) {
              const o3 = t3.match(/^(.*)-transition$/), l3 = t3.match(/^(.*)-use-theme$/);
              a2 = a2.concat(l3 && n2[l3[1]] ? _e({ key: t3, value: i2[t3], valueSpec: { type: "string" }, style: s2, styleSpec: r2 }) : o3 && n2[o3[1]] && n2[o3[1]].transition ? _e({ key: t3, value: i2[t3], valueSpec: r2.transition, style: s2, styleSpec: r2 }) : n2[t3] ? _e({ key: t3, value: i2[t3], valueSpec: n2[t3], style: s2, styleSpec: r2 }) : [new e.K(t3, i2[t3], `unknown property "${t3}"`)]);
            }
            if (i2.source) {
              const t3 = s2.sources && s2.sources[i2.source], r3 = t3 && e.M(t3.type);
              t3 ? "raster-dem" !== r3 && a2.push(new e.V(o2, i2.source, `terrain cannot be used with a source of type ${String(r3)}, it only be used with a "raster-dem" source type`)) : a2.push(new e.V(o2, i2.source, `source "${i2.source}" not found`));
            } else a2.push(new e.V(o2, i2, 'terrain is missing required property "source"'));
            return a2;
          }
          function de2(t2) {
            const i2 = t2.value, o2 = t2.style, s2 = t2.styleSpec, r2 = s2.fog;
            let n2 = [];
            const a2 = e.J(i2);
            if (void 0 === i2) return n2;
            if ("object" !== a2) return n2 = n2.concat([new e.V("fog", i2, `object expected, ${a2} found`)]), n2;
            for (const t3 in i2) {
              const a3 = t3.match(/^(.*)-transition$/), l2 = t3.match(/^(.*)-use-theme$/);
              n2 = n2.concat(l2 && r2[l2[1]] ? _e({ key: t3, value: i2[t3], valueSpec: { type: "string" }, style: o2, styleSpec: s2 }) : a3 && r2[a3[1]] && r2[a3[1]].transition ? _e({ key: t3, value: i2[t3], valueSpec: s2.transition, style: o2, styleSpec: s2 }) : r2[t3] ? _e({ key: t3, value: i2[t3], valueSpec: r2[t3], style: o2, styleSpec: s2 }) : [new e.K(t3, i2[t3], `unknown property "${t3}"`)]);
            }
            return n2;
          }
          const ue = { "*": () => [], array: H, boolean: function(t2) {
            const i2 = t2.value, o2 = t2.key, s2 = e.J(i2);
            return "boolean" !== s2 ? [new e.V(o2, i2, `boolean expected, ${s2} found`)] : [];
          }, number: W, color: function(t2) {
            const i2 = t2.key, o2 = t2.value, s2 = e.J(o2);
            return "string" !== s2 ? [new e.V(i2, o2, `color expected, ${s2} found`)] : null === e.a0.parseCSSColor(o2) ? [new e.V(i2, o2, `color expected, "${o2}" found`)] : [];
          }, enum: K, filter: J, function: $, layer: oe, object: Z, source: ne, model: e.a4, light: le, "light-3d": ce, terrain: he, fog: de2, string: se, formatted: function(e2) {
            return 0 === se(e2).length ? [] : X(e2);
          }, resolvedImage: function(e2) {
            return 0 === se(e2).length ? [] : X(e2);
          }, projection: function(t2) {
            const i2 = t2.value, o2 = t2.styleSpec, s2 = o2.projection, r2 = t2.style;
            let n2 = [];
            const a2 = e.J(i2);
            if ("object" === a2) for (const e2 in i2) n2 = n2.concat(_e({ key: e2, value: i2[e2], valueSpec: s2[e2], style: r2, styleSpec: o2 }));
            else "string" !== a2 && (n2 = n2.concat([new e.V("projection", i2, `object or string expected, ${a2} found`)]));
            return n2;
          }, import: function(t2) {
            const { value: i2, styleSpec: o2 } = t2, { data: s2, ...r2 } = i2;
            Object.defineProperty(r2, "__line__", { value: i2.__line__, enumerable: false });
            let n2 = Z(e.L({}, t2, { value: r2, valueSpec: o2.import }));
            return "" === e.M(r2.id) && n2.push(new e.V(`${t2.key}.id`, r2, "import id can't be an empty string")), s2 && (n2 = n2.concat(fe(s2, o2, { key: `${t2.key}.data` }))), n2;
          }, iconset: function(t2) {
            const i2 = t2.value, o2 = t2.key, s2 = t2.styleSpec, r2 = t2.style;
            if (!i2.type) return [new e.V(o2, i2, '"type" is required')];
            const n2 = e.M(i2.type);
            let a2 = [];
            if (a2 = a2.concat(Z({ key: o2, value: i2, valueSpec: s2[`iconset_${n2}`], style: r2, styleSpec: s2 })), "source" === n2 && i2.source) {
              const t3 = r2.sources && r2.sources[i2.source], s3 = t3 && e.M(t3.type);
              t3 ? "raster-array" !== s3 && a2.push(new e.V(o2, i2.source, `iconset cannot be used with a source of type ${String(s3)}, it only be used with a "raster-array" source type`)) : a2.push(new e.V(o2, i2.source, `source "${i2.source}" not found`));
            }
            return a2;
          } };
          function _e(t2, i2 = false) {
            const o2 = t2.value, s2 = t2.valueSpec, r2 = t2.styleSpec;
            if (s2.expression && e.a2(e.M(o2))) return $(t2);
            if (s2.expression && e.S(e.U(o2))) return X(t2);
            if (s2.type && ue[s2.type]) {
              const o3 = ue[s2.type](t2);
              return true === i2 && o3.length > 0 && "array" === e.J(t2.value) ? X(t2) : o3;
            }
            return Z(e.L({}, t2, { valueSpec: s2.type ? r2[s2.type] : s2 }));
          }
          function pe(t2) {
            const i2 = t2.value, o2 = t2.key, s2 = se(t2);
            return s2.length || (-1 === i2.indexOf("{fontstack}") && s2.push(new e.V(o2, i2, '"glyphs" url must include a "{fontstack}" token')), -1 === i2.indexOf("{range}") && s2.push(new e.V(o2, i2, '"glyphs" url must include a "{range}" token'))), s2;
          }
          function fe(t2, i2 = e.a5, o2 = {}) {
            return _e({ key: o2.key || "", value: t2, valueSpec: i2.$root, styleSpec: i2, style: t2, objectElementValidators: { glyphs: pe, "*": () => [] } });
          }
          function me(t2, i2 = e.a5) {
            return De(fe(t2, i2));
          }
          const ge = (e2) => De(ne(e2)), ve = (e2) => De(le(e2)), ye = (e2) => De(ce(e2)), xe = (e2) => De(he(e2)), be = (e2) => De(de2(e2)), we = (t2) => De(function(t3) {
            const i2 = t3.value, o2 = t3.style, s2 = t3.styleSpec, r2 = s2.snow;
            let n2 = [];
            const a2 = e.J(i2);
            if (void 0 === i2) return n2;
            if ("object" !== a2) return n2 = n2.concat([new e.V("snow", i2, `object expected, ${a2} found`)]), n2;
            for (const t4 in i2) {
              const a3 = t4.match(/^(.*)-transition$/);
              n2 = n2.concat(a3 && r2[a3[1]] && r2[a3[1]].transition ? _e({ key: t4, value: i2[t4], valueSpec: s2.transition, style: o2, styleSpec: s2 }) : r2[t4] ? _e({ key: t4, value: i2[t4], valueSpec: r2[t4], style: o2, styleSpec: s2 }) : [new e.K(t4, i2[t4], `unknown property "${t4}"`)]);
            }
            return n2;
          }(t2)), Te = (t2) => De(function(t3) {
            const i2 = t3.value, o2 = t3.style, s2 = t3.styleSpec, r2 = s2.rain;
            let n2 = [];
            const a2 = e.J(i2);
            if (void 0 === i2) return n2;
            if ("object" !== a2) return n2 = n2.concat([new e.V("rain", i2, `object expected, ${a2} found`)]), n2;
            for (const t4 in i2) {
              const a3 = t4.match(/^(.*)-transition$/);
              n2 = n2.concat(a3 && r2[a3[1]] && r2[a3[1]].transition ? _e({ key: t4, value: i2[t4], valueSpec: s2.transition, style: o2, styleSpec: s2 }) : r2[t4] ? _e({ key: t4, value: i2[t4], valueSpec: r2[t4], style: o2, styleSpec: s2 }) : [new e.K(t4, i2[t4], `unknown property "${t4}"`)]);
            }
            return n2;
          }(t2)), Ee = (e2) => De(oe(e2)), Se = (e2) => De(J(e2)), Ie = (e2) => De(te(e2)), Ce = (e2) => De(ie(e2)), Re = (t2) => De(e.a4(t2));
          function De(e2) {
            return e2.slice().sort((e3, t2) => e3.line && t2.line ? e3.line - t2.line : 0);
          }
          function Ae(t2, i2) {
            let o2 = false;
            if (i2 && i2.length) for (const s2 of i2) s2 instanceof e.K ? e.w(s2.message) : (t2.fire(new e.z(new Error(s2.message))), o2 = true);
            return o2;
          }
          let Le;
          class Pe extends e.E {
            constructor(t2, i2 = "flat") {
              super(), this._transitionable = new e.a6(Le || (Le = new e.a7({ anchor: new e.a8(e.a5.light.anchor), position: new e.a9(e.a5.light.position), color: new e.a8(e.a5.light.color), intensity: new e.a8(e.a5.light.intensity) }))), this.setLight(t2, i2), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
              return this._transitionable.serialize();
            }
            setLight(e2, t2, i2 = {}) {
              this._validate(ve, e2, i2) || (this._transitionable.setTransitionOrValue(e2), this.id = t2);
            }
            updateTransitions(e2) {
              this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
            }
            hasTransition() {
              return this._transitioning.hasTransition();
            }
            recalculate(e2) {
              this.properties = this._transitioning.possiblyEvaluate(e2);
            }
            _validate(t2, i2, o2) {
              return (!o2 || false !== o2.validate) && Ae(this, t2.call(me, e.h({ value: i2, style: { glyphs: true, sprite: true }, styleSpec: e.a5 })));
            }
          }
          let ze = class extends e.E {
            constructor(t2, i2, o2, s2, r2) {
              super(), this.scope = o2, this._transitionable = new e.a6(new e.a7({ source: new e.a8(e.a5.terrain.source), exaggeration: new e.a8(e.a5.terrain.exaggeration) }), o2, s2), this._transitionable.setTransitionOrValue(t2, s2), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i2, this.worldview = r2;
            }
            get() {
              return this._transitionable.serialize();
            }
            set(e2, t2) {
              this._transitionable.setTransitionOrValue(e2, t2);
            }
            updateTransitions(e2) {
              this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
            }
            hasTransition() {
              return this._transitioning.hasTransition();
            }
            recalculate(e2) {
              this.properties = this._transitioning.possiblyEvaluate(e2);
            }
            getExaggeration(t2) {
              return this._transitioning.possiblyEvaluate(new e.aa(t2, { worldview: this.worldview })).get("exaggeration");
            }
            getAttenuationRange() {
              if (!this.isZoomDependent()) return null;
              const t2 = this._transitionable._values.exaggeration;
              if (!t2) return null;
              const i2 = t2.value.expression;
              if (!i2) return null;
              let o2 = -1, s2 = -1, r2 = 1;
              for (const t3 of i2.zoomStops) r2 = i2.evaluate(new e.aa(t3, { worldview: this.worldview })), r2 > 0.01 ? (o2 = t3, s2 = -1) : s2 = t3;
              return r2 < 0.01 && o2 > 0 && s2 > o2 ? [o2, s2] : null;
            }
            isZoomDependent() {
              const t2 = this._transitionable._values.exaggeration;
              return null != t2 && null != t2.value && null != t2.value.expression && t2.value.expression instanceof e.ab;
            }
          };
          const Me = 45, Oe = 65, Fe = 0.05;
          function Be(t2, i2, o2, s2) {
            const r2 = e.af(Me, Oe, o2), [n2, a2] = ke(t2, s2);
            let l2 = 1 - Math.min(1, Math.exp((i2 - n2) / (a2 - n2) * -6));
            return l2 *= l2 * l2, l2 = Math.min(1, 1.00747 * l2), l2 * r2 * t2.alpha;
          }
          function ke(e2, t2) {
            const i2 = 0.5 / Math.tan(0.5 * t2);
            return [e2.range[0] + i2, e2.range[1] + i2];
          }
          function Ne(t2, i2, o2, s2, r2) {
            const n2 = e.ad([], [i2, o2, s2], r2.mercatorFogMatrix);
            return Be(t2, e.ae(n2), r2.pitch, r2._fov);
          }
          function Ue(t2, i2, o2, s2, r2, n2, a2) {
            const l2 = [[o2, s2, 0], [r2, s2, 0], [r2, n2, 0], [o2, n2, 0]];
            let c2 = Number.MAX_VALUE, h3 = -Number.MAX_VALUE;
            for (const t3 of l2) {
              const o3 = e.ad([], t3, i2), s3 = e.ae(o3);
              c2 = Math.min(c2, s3), h3 = Math.max(h3, s3);
            }
            return [Be(t2, c2, a2.pitch, a2._fov), Be(t2, h3, a2.pitch, a2._fov)];
          }
          class je extends e.E {
            constructor(t2, i2, o2, s2) {
              super();
              const r2 = new e.a7({ range: new e.a8(e.a5.fog.range), color: new e.a8(e.a5.fog.color), "color-use-theme": new e.a8({ type: "string", "property-type": "data-constant", default: "default" }), "high-color": new e.a8(e.a5.fog["high-color"]), "high-color-use-theme": new e.a8({ type: "string", "property-type": "data-constant", default: "default" }), "space-color": new e.a8(e.a5.fog["space-color"]), "space-color-use-theme": new e.a8({ type: "string", "property-type": "data-constant", default: "default" }), "horizon-blend": new e.a8(e.a5.fog["horizon-blend"]), "star-intensity": new e.a8(e.a5.fog["star-intensity"]), "vertical-range": new e.a8(e.a5.fog["vertical-range"]) });
              this._transitionable = new e.a6(r2, o2, new Map(s2)), this.set(t2, s2), this._transitioning = this._transitionable.untransitioned(), this._transform = i2, this.properties = new e.ag(r2), this.scope = o2;
            }
            get state() {
              const t2 = this._transform, i2 = "globe" === t2.projection.name, o2 = e.ah(t2.zoom), s2 = this.properties.get("range"), r2 = [0.5, 3];
              return { range: i2 ? [e.ai(r2[0], s2[0], o2), e.ai(r2[1], s2[1], o2)] : s2, horizonBlend: this.properties.get("horizon-blend"), alpha: this.properties.get("color").a };
            }
            get() {
              return this._transitionable.serialize();
            }
            set(t2, i2, o2 = {}) {
              if (this._validate(be, t2, o2)) return;
              const s2 = e.h({}, t2);
              for (const t3 of Object.keys(e.a5.fog)) void 0 === s2[t3] && (s2[t3] = e.a5.fog[t3].default);
              this._options = s2, this._transitionable.setTransitionOrValue(this._options, i2);
            }
            getOpacity(t2) {
              if (!this._transform.projection.supportsFog) return 0;
              const i2 = this.properties && this.properties.get("color") || 1;
              return ("globe" === this._transform.projection.name ? 1 : e.af(Me, Oe, t2)) * i2.a;
            }
            getOpacityAtLatLng(t2, i2) {
              return this._transform.projection.supportsFog ? function(t3, i3, o2) {
                const s2 = e.ac.fromLngLat(i3), r2 = o2.elevation ? o2.elevation.getAtPointOrZero(s2) : 0;
                return Ne(t3, s2.x, s2.y, r2, o2);
              }(this.state, t2, i2) : 0;
            }
            getOpacityForTile(t2) {
              if (!this._transform.projection.supportsFog) return [1, 1];
              const i2 = this._transform.calculateFogTileMatrix(t2.toUnwrapped());
              return Ue(this.state, i2, 0, 0, e.aj, e.aj, this._transform);
            }
            getOpacityForBounds(e2, t2, i2, o2, s2) {
              return this._transform.projection.supportsFog ? Ue(this.state, e2, t2, i2, o2, s2, this._transform) : [1, 1];
            }
            getFovAdjustedRange(e2) {
              return this._transform.projection.supportsFog ? ke(this.state, e2) : [0, 1];
            }
            isVisibleOnFrustum(t2) {
              if (!this._transform.projection.supportsFog) return false;
              const i2 = [4, 5, 6, 7];
              for (const o2 of i2) {
                const i3 = t2.points[o2];
                let s2;
                if (i3[2] >= 0) s2 = i3;
                else {
                  const r2 = t2.points[o2 - 4];
                  s2 = e.ak(r2, i3, r2[2] / (r2[2] - i3[2]));
                }
                if (Ne(this.state, s2[0], s2[1], 0, this._transform) >= Fe) return true;
              }
              return false;
            }
            updateConfig(e2) {
              this._transitionable.setTransitionOrValue(this._options, new Map(e2));
            }
            updateTransitions(e2) {
              this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
            }
            hasTransition() {
              return this._transitioning.hasTransition();
            }
            recalculate(e2) {
              this.properties = this._transitioning.possiblyEvaluate(e2);
            }
            _validate(t2, i2, o2) {
              return (!o2 || false !== o2.validate) && Ae(this, t2.call(me, e.h({ value: i2, style: { glyphs: true, sprite: true }, styleSpec: e.a5 })));
            }
          }
          let Ve, Ge, qe, Ze, He = class extends e.E {
            constructor(t2, i2, o2, s2) {
              super();
              const r2 = Ve || (Ve = new e.a7({ density: new e.a8(e.a5.snow.density), intensity: new e.a8(e.a5.snow.intensity), color: new e.a8(e.a5.snow.color), opacity: new e.a8(e.a5.snow.opacity), vignette: new e.a8(e.a5.snow.vignette), "vignette-color": new e.a8(e.a5.snow["vignette-color"]), "center-thinning": new e.a8(e.a5.snow["center-thinning"]), direction: new e.a8(e.a5.snow.direction), "flake-size": new e.a8(e.a5.snow["flake-size"]) }));
              this._transitionable = new e.a6(r2, o2, new Map(s2)), this.set(t2, s2), this._transitioning = this._transitionable.untransitioned(), this.properties = new e.ag(r2), this.scope = o2;
            }
            get state() {
              const t2 = this.properties.get("opacity"), i2 = this.properties.get("color"), o2 = this.properties.get("direction"), s2 = e.al(o2[0]), r2 = -Math.max(e.al(o2[1]), 0.01), n2 = [Math.cos(s2) * Math.cos(r2), Math.sin(s2) * Math.cos(r2), Math.sin(r2)], a2 = this.properties.get("vignette"), l2 = this.properties.get("vignette-color");
              return l2.a = a2, { density: this.properties.get("density"), intensity: this.properties.get("intensity"), color: new e.am(i2.r, i2.g, i2.b, i2.a * t2), direction: n2, centerThinning: this.properties.get("center-thinning"), flakeSize: this.properties.get("flake-size"), vignetteColor: l2 };
            }
            get() {
              return this._transitionable.serialize();
            }
            set(t2, i2, o2 = {}) {
              if (this._validate(we, t2, o2)) return;
              const s2 = e.h({}, t2);
              for (const t3 of Object.keys(e.a5.snow)) void 0 === s2[t3] && (s2[t3] = e.a5.snow[t3].default);
              this._options = s2, this._transitionable.setTransitionOrValue(this._options, i2);
            }
            updateConfig(e2) {
              this._transitionable.setTransitionOrValue(this._options, new Map(e2));
            }
            updateTransitions(e2) {
              this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
            }
            hasTransition() {
              return this._transitioning.hasTransition();
            }
            recalculate(e2) {
              this.properties = this._transitioning.possiblyEvaluate(e2);
            }
            _validate(t2, i2, o2) {
              return (!o2 || false !== o2.validate) && Ae(this, t2.call(me, e.h({ value: i2, style: { glyphs: true, sprite: true }, styleSpec: e.a5 })));
            }
          }, We = class extends e.E {
            constructor(t2, i2, o2, s2) {
              super();
              const r2 = Ge || (Ge = new e.a7({ density: new e.a8(e.a5.rain.density), intensity: new e.a8(e.a5.rain.intensity), color: new e.a8(e.a5.rain.color), opacity: new e.a8(e.a5.rain.opacity), vignette: new e.a8(e.a5.rain.vignette), "vignette-color": new e.a8(e.a5.rain["vignette-color"]), "center-thinning": new e.a8(e.a5.rain["center-thinning"]), direction: new e.a8(e.a5.rain.direction), "droplet-size": new e.a8(e.a5.rain["droplet-size"]), "distortion-strength": new e.a8(e.a5.rain["distortion-strength"]) }));
              this._transitionable = new e.a6(r2, o2, new Map(s2)), this.set(t2, s2), this._transitioning = this._transitionable.untransitioned(), this.properties = new e.ag(r2), this.scope = o2;
            }
            get state() {
              const t2 = this.properties.get("opacity"), i2 = this.properties.get("color"), o2 = this.properties.get("direction"), s2 = e.al(o2[0]), r2 = -Math.max(e.al(o2[1]), 0.01), n2 = [Math.cos(s2) * Math.cos(r2), Math.sin(s2) * Math.cos(r2), Math.sin(r2)], a2 = this.properties.get("vignette-color");
              return a2.a = this.properties.get("vignette"), { density: this.properties.get("density"), intensity: this.properties.get("intensity"), color: new e.am(i2.r, i2.g, i2.b, i2.a * t2), direction: n2, centerThinning: this.properties.get("center-thinning"), dropletSize: this.properties.get("droplet-size"), distortionStrength: this.properties.get("distortion-strength"), vignetteColor: a2 };
            }
            get() {
              return this._transitionable.serialize();
            }
            set(t2, i2, o2 = {}) {
              if (this._validate(Te, t2, o2)) return;
              const s2 = e.h({}, t2);
              for (const t3 of Object.keys(e.a5.rain)) void 0 === s2[t3] && (s2[t3] = e.a5.rain[t3].default);
              this._options = s2, this._transitionable.setTransitionOrValue(this._options, i2);
            }
            updateConfig(e2) {
              this._transitionable.setTransitionOrValue(this._options, new Map(e2));
            }
            updateTransitions(e2) {
              this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
            }
            hasTransition() {
              return this._transitioning.hasTransition();
            }
            recalculate(e2) {
              this.properties = this._transitioning.possiblyEvaluate(e2);
            }
            _validate(t2, i2, o2) {
              return (!o2 || false !== o2.validate) && Ae(this, t2.call(me, e.h({ value: i2, style: { glyphs: true, sprite: true }, styleSpec: e.a5 })));
            }
          };
          class $e extends e.E {
            constructor(t2, i2, o2, s2) {
              super(), this.scope = o2, this._options = t2, this.properties = new e.ag(i2), this._transitionable = new e.a6(i2, o2, new Map(s2)), this._transitionable.setTransitionOrValue(t2.properties), this._transitioning = this._transitionable.untransitioned();
            }
            updateConfig(e2) {
              this._transitionable.setTransitionOrValue(this._options.properties, new Map(e2));
            }
            updateTransitions(e2) {
              this._transitioning = this._transitionable.transitioned(e2, this._transitioning);
            }
            hasTransition() {
              return this._transitioning.hasTransition();
            }
            recalculate(e2) {
              this.properties = this._transitioning.possiblyEvaluate(e2);
            }
            get() {
              return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e2, t2) {
              this._options = e2, this._transitionable.setTransitionOrValue(e2.properties, t2);
            }
            shadowsEnabled() {
              return !!this.properties && true === this.properties.get("cast-shadows");
            }
          }
          class Xe {
            constructor(e2, t2, i2, o2) {
              this.screenBounds = e2, this.cameraPoint = t2, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i2, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, o2);
            }
            static createFromScreenPoints(t2, i2) {
              let o2, s2;
              if (t2 instanceof e.P || "number" == typeof t2[0]) {
                const r2 = e.P.convert(t2);
                o2 = [r2], s2 = i2.isPointAboveHorizon(r2);
              } else {
                const r2 = e.P.convert(t2[0]), n2 = e.P.convert(t2[1]), a2 = r2.add(n2)._div(2);
                o2 = [r2, n2], s2 = e.ao(r2, n2).every((e2) => i2.isPointAboveHorizon(e2)) && i2.isPointAboveHorizon(a2);
              }
              return new Xe(o2, i2.getCameraPoint(), s2, i2);
            }
            isPointQuery() {
              return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t2) {
              return e.ao(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t2);
            }
            bufferedCameraGeometry(t2) {
              const i2 = this.screenBounds[0], o2 = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], s2 = e.ao(i2, o2, 0, false);
              return this.cameraPoint.y > o2.y && (this.cameraPoint.x > i2.x && this.cameraPoint.x < o2.x ? s2.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o2.x ? s2[2] = this.cameraPoint : this.cameraPoint.x <= i2.x && (s2[3] = this.cameraPoint)), e.ap(s2, t2);
            }
            bufferedCameraGeometryGlobe(t2) {
              const i2 = this.screenBounds[0], o2 = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e.P(1, 1)) : this.screenBounds[1], s2 = e.ao(i2, o2, t2), r2 = this.cameraPoint.clone();
              switch (3 * ((r2.y > i2.y) + (r2.y > o2.y)) + ((r2.x > i2.x) + (r2.x > o2.x))) {
                case 0:
                  s2[0] = r2, s2[4] = r2.clone();
                  break;
                case 1:
                  s2.splice(1, 0, r2);
                  break;
                case 2:
                  s2[1] = r2;
                  break;
                case 3:
                  s2.splice(4, 0, r2);
                  break;
                case 5:
                  s2.splice(2, 0, r2);
                  break;
                case 6:
                  s2[3] = r2;
                  break;
                case 7:
                  s2.splice(3, 0, r2);
                  break;
                case 8:
                  s2[2] = r2;
              }
              return s2;
            }
            containsTile(t2, i2, o2, s2 = 0) {
              const r2 = t2.queryPadding / i2._pixelsPerMercatorPixel + 1, n2 = o2 ? this._bufferedCameraMercator(r2, i2) : this._bufferedScreenMercator(r2, i2);
              let a2 = t2.tileID.wrap + (n2.unwrapped ? s2 : 0);
              const l2 = n2.polygon.map((i3) => e.aq(t2.tileTransform, i3, a2));
              if (!e.ar(l2, 0, 0, e.aj, e.aj)) return;
              a2 = t2.tileID.wrap + (this.screenGeometryMercator.unwrapped ? s2 : 0);
              const c2 = this.screenGeometryMercator.polygon.map((i3) => e.as(t2.tileTransform, i3, a2)), h3 = c2.map((t3) => new e.P(t3[0], t3[1])), d2 = i2.getFreeCameraOptions().position || new e.ac(0, 0, 0), u2 = e.as(t2.tileTransform, d2, a2), _2 = c2.map((t3) => {
                const i3 = e.at(t3, t3, u2);
                return e.au(i3, i3), new e.av(u2, i3);
              }), p3 = e.aw(t2, 1, i2.zoom) * i2._pixelsPerMercatorPixel;
              return { queryGeometry: this, tilespaceGeometry: h3, tilespaceRays: _2, bufferedTilespaceGeometry: l2, bufferedTilespaceBounds: (f2 = e.ax(l2), f2.min.x = e.ay(f2.min.x, 0, e.aj), f2.min.y = e.ay(f2.min.y, 0, e.aj), f2.max.x = e.ay(f2.max.x, 0, e.aj), f2.max.y = e.ay(f2.max.y, 0, e.aj), f2), tile: t2, tileID: t2.tileID, pixelToTileUnitsFactor: p3 };
              var f2;
            }
            _bufferedScreenMercator(e2, t2) {
              const i2 = Je(e2);
              if (this._screenRaycastCache[i2]) return this._screenRaycastCache[i2];
              {
                let o2;
                return o2 = "globe" === t2.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e2), t2) : { polygon: this.bufferedScreenGeometry(e2).map((e3) => t2.pointCoordinate3D(e3)), unwrapped: true }, this._screenRaycastCache[i2] = o2, o2;
              }
            }
            _bufferedCameraMercator(e2, t2) {
              const i2 = Je(e2);
              if (this._cameraRaycastCache[i2]) return this._cameraRaycastCache[i2];
              {
                let o2;
                return o2 = "globe" === t2.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e2), t2) : { polygon: this.bufferedCameraGeometry(e2).map((e3) => t2.pointCoordinate3D(e3)), unwrapped: true }, this._cameraRaycastCache[i2] = o2, o2;
              }
            }
            _projectAndResample(t2, i2) {
              const o2 = function(t3, i3) {
                const o3 = e.az([], i3.pixelMatrix, i3.globeMatrix), s3 = [0, -e.aB, 0, 1], r2 = [0, e.aB, 0, 1], n2 = [0, 0, 0, 1];
                e.aA(s3, s3, o3), e.aA(r2, r2, o3), e.aA(n2, n2, o3);
                const a2 = new e.P(s3[0] / s3[3], s3[1] / s3[3]), l2 = new e.P(r2[0] / r2[3], r2[1] / r2[3]), c2 = e.aC(t3, a2) && s3[3] < n2[3], h3 = e.aC(t3, l2) && r2[3] < n2[3];
                if (!c2 && !h3) return null;
                const d2 = function(e2, t4, i4) {
                  for (let o4 = 1; o4 < e2.length; o4++) {
                    const s4 = Ke(t4.pointCoordinate3D(e2[o4 - 1]).x), r3 = Ke(t4.pointCoordinate3D(e2[o4]).x);
                    if (i4 < 0) {
                      if (s4 < r3) return { idx: o4, t: -s4 / (r3 - 1 - s4) };
                    } else if (r3 < s4) return { idx: o4, t: (1 - s4) / (r3 + 1 - s4) };
                  }
                  return null;
                }(t3, i3, c2 ? -1 : 1);
                if (!d2) return null;
                const { idx: u2, t: _2 } = d2;
                let p3 = u2 > 1 ? Ye(t3.slice(0, u2), i3) : [], f2 = u2 < t3.length ? Ye(t3.slice(u2), i3) : [];
                p3 = p3.map((t4) => new e.P(Ke(t4.x), t4.y)), f2 = f2.map((t4) => new e.P(Ke(t4.x), t4.y));
                const m2 = [...p3];
                0 === m2.length && m2.push(f2[f2.length - 1]);
                const g2 = e.ai(m2[m2.length - 1].y, (0 === f2.length ? p3[0] : f2[0]).y, _2);
                let v2;
                return v2 = c2 ? [new e.P(0, g2), new e.P(0, 0), new e.P(1, 0), new e.P(1, g2)] : [new e.P(1, g2), new e.P(1, 1), new e.P(0, 1), new e.P(0, g2)], m2.push(...v2), 0 === f2.length ? m2.push(p3[0]) : m2.push(...f2), { polygon: m2.map((t4) => new e.ac(t4.x, t4.y)), unwrapped: false };
              }(t2, i2);
              if (o2) return o2;
              const s2 = function(t3, i3) {
                let o3 = false, s3 = -1 / 0, r2 = 0;
                for (let e2 = 0; e2 < t3.length - 1; e2++) t3[e2].x > s3 && (s3 = t3[e2].x, r2 = e2);
                for (let e2 = 0; e2 < t3.length - 1; e2++) {
                  const i4 = (r2 + e2) % (t3.length - 1), s4 = t3[i4], n3 = t3[i4 + 1];
                  Math.abs(s4.x - n3.x) > 0.5 && (s4.x < n3.x ? (s4.x += 1, 0 === i4 && (t3[t3.length - 1].x += 1)) : (n3.x += 1, i4 + 1 === t3.length - 1 && (t3[0].x += 1)), o3 = true);
                }
                const n2 = e.aD(i3.center.lng);
                return o3 && n2 < Math.abs(n2 - 1) && t3.forEach((e2) => {
                  e2.x -= 1;
                }), { polygon: t3, unwrapped: o3 };
              }(Ye(t2, i2).map((t3) => new e.P(Ke(t3.x), t3.y)), i2);
              return { polygon: s2.polygon.map((t3) => new e.ac(t3.x, t3.y)), unwrapped: s2.unwrapped };
            }
          }
          function Ye(t2, i2) {
            return e.aE(t2, (e2) => {
              const t3 = i2.pointCoordinate3D(e2);
              e2.x = t3.x, e2.y = t3.y;
            }, 1 / 256);
          }
          function Ke(e2) {
            return e2 < 0 ? 1 + e2 % 1 : e2 % 1;
          }
          function Je(e2) {
            return 100 * e2 | 0;
          }
          function Qe(t2, i2, o2, s2, r2) {
            const n2 = function(o3, s3) {
              if (o3) return r2(o3);
              if (s3) {
                if (t2.url && s3.tiles && t2.tiles && delete t2.tiles, s3.variants) {
                  if (!Array.isArray(s3.variants)) return r2(new Error("variants must be an array"));
                  for (const t3 of s3.variants) {
                    if (null == t3 || "object" != typeof t3 || t3.constructor !== Object) return r2(new Error("variant must be an object"));
                    if (!Array.isArray(t3.capabilities)) return r2(new Error("capabilities must be an array"));
                    if (1 === t3.capabilities.length && "meshopt" === t3.capabilities[0]) {
                      s3 = e.h(s3, t3);
                      break;
                    }
                  }
                }
                const o4 = e.aF(e.h({}, s3, t2), ["tilejson", "tiles", "minzoom", "maxzoom", "attribution", "mapbox_logo", "bounds", "extra_bounds", "scheme", "tileSize", "encoding", "vector_layers", "raster_layers", "worldview_options", "worldview_default", "worldview"]);
                o4.tiles = i2.canonicalizeTileset(o4, t2.url), r2(null, o4);
              }
            }, a2 = function(e2, t3, i3) {
              if (!e2) return null;
              if (!t3 && !i3) return e2;
              i3 = i3 || e2.worldview_default;
              const o3 = Object.values(e2.language || {});
              if (0 === o3.length) return null;
              const s3 = Object.values(e2.worldview || {});
              if (0 === s3.length) return null;
              const r3 = o3.every((e3) => e3 === t3), n3 = s3.every((e3) => e3 === i3);
              return r3 && n3 ? e2 : t3 in (e2.language_options || {}) || i3 in (e2.worldview_options || {}) ? null : e2.language_options && e2.worldview_options ? e2 : null;
            }(t2.data, o2, s2);
            return a2 ? e.q.frame(() => n2(null, a2)) : t2.url ? e.n(i2.transformRequest(i2.normalizeSourceURL(t2.url, null, o2, s2), e.R.Source), n2) : e.q.frame(() => {
              const { data: e2, ...i3 } = t2;
              n2(null, i3);
            });
          }
          function et(t2, i2) {
            const o2 = Math.pow(2, i2.z), s2 = Math.floor(e.aD(t2.getWest()) * o2), r2 = Math.floor(e.aH(t2.getNorth()) * o2), n2 = Math.ceil(e.aD(t2.getEast()) * o2), a2 = Math.ceil(e.aH(t2.getSouth()) * o2);
            return i2.x >= s2 && i2.x < n2 && i2.y >= r2 && i2.y < a2;
          }
          class tt2 {
            constructor(t2, i2, o2) {
              this.bounds = t2 ? e.aG.convert(this.validateBounds(t2)) : null, this.minzoom = i2 || 0, this.maxzoom = o2 || 24;
            }
            validateBounds(e2) {
              return Array.isArray(e2) && 4 === e2.length ? [Math.max(-180, e2[0]), Math.max(-90, e2[1]), Math.min(180, e2[2]), Math.min(90, e2[3])] : [-180, -90, 180, 90];
            }
            addExtraBounds(t2) {
              if (t2) {
                this.extraBounds || (this.extraBounds = []);
                for (const i2 of t2) this.extraBounds.push(e.aG.convert(this.validateBounds(i2)));
              }
            }
            contains(e2) {
              if (e2.z > this.maxzoom || e2.z < this.minzoom) return false;
              if (this.bounds && !et(this.bounds, e2)) return false;
              if (!this.extraBounds) return true;
              for (const t2 of this.extraBounds) if (et(t2, e2)) return true;
              return false;
            }
            static fromTileJSON(e2) {
              if (!e2.bounds && !e2.extra_bounds) return null;
              const t2 = new tt2(e2.bounds, e2.minzoom, e2.maxzoom);
              return t2.addExtraBounds(e2.extra_bounds), t2;
            }
          }
          class it extends e.E {
            constructor(t2, i2, o2, s2) {
              if (super(), this.id = t2, this.dispatcher = o2, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = true, this.isTileClipped = true, this._loaded = false, e.h(this, e.aF(i2, ["url", "scheme", "tileSize", "promoteId"])), this._options = e.h({ type: "vector" }, i2), this._collectResourceTiming = !!i2.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
              this.setEventedParent(s2), this._tileWorkers = {}, this._deduped = new e.aI();
            }
            load(t2) {
              this._loaded = false, this.fire(new e.A("dataloading", { dataType: "source" }));
              const i2 = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o2 = this.map.getWorldview();
              this._tileJSONRequest = Qe(this._options, this.map._requestManager, i2, o2, (s2, r2) => {
                if (this._tileJSONRequest = null, this._loaded = true, s2) i2 && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i2}`), o2 && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o2}`), this.fire(new e.z(s2));
                else if (r2) {
                  if (e.h(this, r2), this.hasWorldviews = !!r2.worldview_options, r2.worldview_default && (this.worldviewDefault = r2.worldview_default), r2.vector_layers) {
                    this.vectorLayers = r2.vector_layers, this.vectorLayerIds = [], this.localizableLayerIds = /* @__PURE__ */ new Set();
                    for (const e2 of r2.vector_layers) this.vectorLayerIds.push(e2.id), r2.worldview && r2.worldview[e2.source] && this.localizableLayerIds.add(e2.id);
                  }
                  this.tileBounds = tt2.fromTileJSON(r2), L(r2.tiles, this.map._requestManager._customAccessToken), this.fire(new e.A("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.A("data", { dataType: "source", sourceDataType: "content" }));
                }
                t2 && t2(s2);
              });
            }
            loaded() {
              return this._loaded;
            }
            hasTile(e2) {
              return !this.tileBounds || this.tileBounds.contains(e2.canonical);
            }
            onAdd(e2) {
              this.map = e2, this.load();
            }
            reload() {
              this.cancelTileJSONRequest();
              const t2 = e.C(this.id, this.scope);
              this.load(() => this.map.style.clearSource(t2));
            }
            setTiles(e2) {
              return this._options.tiles = e2, this.reload(), this;
            }
            setUrl(e2) {
              return this.url = e2, this._options.url = e2, this.reload(), this;
            }
            onRemove(e2) {
              this.cancelTileJSONRequest();
            }
            serialize() {
              return e.h({}, this._options);
            }
            loadTile(t2, i2) {
              const o2 = t2.tileID.canonical.url(this.tiles, this.scheme), s2 = this.map._requestManager.normalizeTileURL(o2), r2 = this.map._requestManager.transformRequest(s2, e.R.Tile), n2 = this.map.style ? this.map.style.getLut(this.scope) : null, a2 = n2 ? { image: n2.image.clone() } : null, l2 = { request: r2, data: void 0, uid: t2.uid, tileID: t2.tileID, tileZoom: t2.tileZoom, zoom: t2.tileID.overscaledZ, maxZoom: this.maxzoom, lut: a2, tileSize: this.tileSize * t2.tileID.overscaleFactor(), type: this.type, source: this.id, scope: this.scope, pixelRatio: e.q.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, isSymbolTile: t2.isSymbolTile, brightness: this.map.style && this.map.style.getBrightness() || 0, extraShadowCaster: t2.isExtraShadowCaster, tessellationStep: this.map._tessellationStep, scaleFactor: this.map.getScaleFactor(), worldview: this.map.getWorldview() || this.worldviewDefault };
              if (this.hasWorldviews && e.j(o2) && (l2.localizableLayerIds = this.localizableLayerIds), l2.request.collectResourceTiming = this._collectResourceTiming, t2.actor && "expired" !== t2.state) "loading" === t2.state ? t2.reloadCallback = i2 : t2.request = t2.actor.send("reloadTile", l2, c2.bind(this));
              else if (t2.actor = this._tileWorkers[s2] = this._tileWorkers[s2] || this.dispatcher.getActor(), this.dispatcher.ready) t2.request = t2.actor.send("loadTile", l2, c2.bind(this), void 0, true);
              else {
                const i3 = e.aJ.call({ deduped: this._deduped }, l2, (e2, i4) => {
                  e2 || !i4 ? c2.call(this, e2) : (l2.data = { cacheControl: i4.cacheControl, expires: i4.expires, rawData: i4.rawData.slice(0) }, t2.actor && t2.actor.send("loadTile", l2, c2.bind(this), void 0, true));
                }, true);
                t2.request = { cancel: i3 };
              }
              function c2(o3, s3) {
                return delete t2.request, t2.aborted ? i2(null) : o3 && 404 !== o3.status ? i2(o3) : (s3 && s3.resourceTiming && (t2.resourceTiming = s3.resourceTiming), this.map._refreshExpiredTiles && s3 && t2.setExpiryData(s3), t2.loadVectorData(s3, this.map.painter), e.aK(this.dispatcher), i2(null), void (t2.reloadCallback && (this.loadTile(t2, t2.reloadCallback), t2.reloadCallback = null)));
              }
            }
            abortTile(e2) {
              e2.request && (e2.request.cancel(), delete e2.request), e2.actor && e2.actor.send("abortTile", { uid: e2.uid, type: this.type, source: this.id, scope: this.scope });
            }
            unloadTile(e2, t2) {
              e2.actor && e2.actor.send("removeTile", { uid: e2.uid, type: this.type, source: this.id, scope: this.scope }), e2.destroy();
            }
            hasTransition() {
              return false;
            }
            afterUpdate() {
              this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
              this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
          }
          class ot extends e.E {
            constructor(t2, i2, o2, s2) {
              super(), this.id = t2, this.dispatcher = o2, this.setEventedParent(s2), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = true, this.scheme = "xyz", this.tileSize = 512, this._loaded = false, this._options = e.h({ type: "raster" }, i2), e.h(this, e.aF(i2, ["url", "scheme", "tileSize"]));
            }
            load(t2) {
              this._loaded = false, this.fire(new e.A("dataloading", { dataType: "source" }));
              const i2 = this.map.getWorldview();
              this._tileJSONRequest = Qe(this._options, this.map._requestManager, null, i2, (i3, o2) => {
                this._tileJSONRequest = null, this._loaded = true, i3 ? this.fire(new e.z(i3)) : o2 && (e.h(this, o2), o2.raster_layers && (this.rasterLayers = o2.raster_layers, this.rasterLayerIds = this.rasterLayers.map((e2) => e2.id)), this.tileBounds = tt2.fromTileJSON(o2), L(o2.tiles), this.fire(new e.A("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.A("data", { dataType: "source", sourceDataType: "content" }))), t2 && t2(i3);
              });
            }
            loaded() {
              return this._loaded;
            }
            onAdd(e2) {
              this.map = e2, this.load();
            }
            reload() {
              this.cancelTileJSONRequest();
              const t2 = e.C(this.id, this.scope);
              this.load(() => this.map.style.clearSource(t2));
            }
            setTiles(e2) {
              return this._options.tiles = e2, this.reload(), this;
            }
            setUrl(e2) {
              return this.url = e2, this._options.url = e2, this.reload(), this;
            }
            onRemove(e2) {
              this.cancelTileJSONRequest();
            }
            serialize() {
              return e.h({}, this._options);
            }
            hasTile(e2) {
              return !this.tileBounds || this.tileBounds.contains(e2.canonical);
            }
            loadTile(t2, i2) {
              const o2 = e.q.devicePixelRatio >= 2, s2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme), o2, this.tileSize);
              t2.request = e.o(this.map._requestManager.transformRequest(s2, e.R.Tile), (o3, s3, r2, n2) => (delete t2.request, t2.aborted ? (t2.state = "unloaded", i2(null)) : o3 ? (t2.state = "errored", i2(o3)) : s3 ? (this.map._refreshExpiredTiles && t2.setExpiryData({ cacheControl: r2, expires: n2 }), t2.setTexture(s3, this.map.painter), t2.state = "loaded", e.aK(this.dispatcher), void i2(null)) : i2(null)));
            }
            abortTile(e2, t2) {
              e2.request && (e2.request.cancel(), delete e2.request), t2 && t2();
            }
            unloadTile(t2, i2) {
              t2.texture && t2.texture instanceof e.T ? (t2.destroy(true), t2.texture && t2.texture instanceof e.T && this.map.painter.saveTileTexture(t2.texture)) : t2.destroy(), i2 && i2();
            }
            hasTransition() {
              return false;
            }
            cancelTileJSONRequest() {
              this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
          }
          class st extends ot {
            constructor(t2, i2, o2, s2) {
              super(t2, i2, o2, s2), this.type = "raster-array", this.maxzoom = 22, this.partial = true, this._options = e.h({ type: "raster-array" }, i2);
            }
            triggerRepaint(e2) {
              const t2 = this.map.painter._terrain, i2 = this.map.style.getSourceCache(this.id);
              t2 && t2.enabled && i2 && t2._clearRenderCacheForTile(i2.id, e2.tileID), this.map.triggerRepaint();
            }
            loadTile(t2, i2) {
              const o2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme), false, this.tileSize), s2 = this.map._requestManager.transformRequest(o2, e.R.Tile), r2 = { request: s2, uid: t2.uid, tileID: t2.tileID, type: this.type, source: this.id, scope: this.scope, partial: this.partial };
              t2.source = this.id, t2.scope = this.scope, t2.requestParams = s2, t2.actor || (t2.actor = this.dispatcher.getActor());
              const n2 = (e2, o3, s3, r3) => {
                if (delete t2.request, t2.aborted) return t2.state = "unloaded", i2(null);
                if (e2) {
                  if ("AbortError" === e2.name) return;
                  return t2.state = "errored", i2(e2);
                }
                if (this.map._refreshExpiredTiles && o3 && t2.setExpiryData({ cacheControl: s3, expires: r3 }), this.partial) t2.state = "empty";
                else {
                  if (!o3) return i2(null);
                  t2.state = "loaded", t2._isHeaderLoaded = true, t2._mrt = o3;
                }
                i2(null);
              };
              t2.request = this.partial ? t2.fetchHeader(void 0, n2.bind(this)) : t2.actor.send("loadTile", r2, n2.bind(this), void 0, true);
            }
            abortTile(e2) {
              e2.request && (e2.request.cancel(), delete e2.request), e2.actor && e2.actor.send("abortTile", { uid: e2.uid, type: this.type, source: this.id, scope: this.scope });
            }
            unloadTile(t2, i2) {
              const o2 = t2.texture;
              o2 && o2 instanceof e.T ? (t2.destroy(true), this.map.painter.saveTileTexture(o2)) : (t2.destroy(), t2.flushQueues(), t2._isHeaderLoaded = false, delete t2._mrt, delete t2.textureDescriptor), t2.fbo && (t2.fbo.destroy(), delete t2.fbo), delete t2.request, delete t2.requestParams, delete t2.neighboringTiles, t2.state = "unloaded";
            }
            prepareTile(t2, i2, o2) {
              t2._isHeaderLoaded && ("empty" !== t2.state && (t2.state = "reloading"), t2.fetchBand(i2, o2, (i3, o3) => {
                if (i3) return t2.state = "errored", this.fire(new e.z(i3)), void this.triggerRepaint(t2);
                o3 && (t2._isHeaderLoaded = true, t2.setTexture(o3, this.map.painter), t2.state = "loaded", this.triggerRepaint(t2));
              }));
            }
            getInitialBand(e2) {
              if (!this.rasterLayers) return 0;
              const t2 = this.rasterLayers.find(({ id: t3 }) => t3 === e2), i2 = t2 && t2.fields, o2 = i2 && i2.bands && i2.bands;
              return o2 ? o2[0] : 0;
            }
            getTextureDescriptor(t2, i2, o2) {
              if (!t2) return;
              const s2 = i2.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
              if (!s2) return;
              let r2 = null;
              i2 instanceof e.aN ? r2 = i2.paint.get("raster-array-band") : i2 instanceof e.aO && (r2 = i2.paint.get("raster-particle-array-band"));
              const n2 = r2 || this.getInitialBand(s2);
              if (null != n2) if (t2.textureDescriptor) {
                if (!t2.updateNeeded(s2, n2) || o2) return Object.assign({}, t2.textureDescriptor, { texture: t2.texture });
              } else this.prepareTile(t2, s2, n2);
            }
            getImages(t2, i2) {
              const o2 = /* @__PURE__ */ new Map();
              for (const s2 of t2) for (const t3 of i2) {
                const [i3, r2] = t3.split("/"), n2 = s2.getLayer(i3);
                if (!n2) continue;
                if (!n2.hasBand(r2) || !n2.hasDataForBand(r2)) continue;
                const { bytes: a2, tileSize: l2, buffer: c2 } = n2.getBandView(r2), h3 = l2 + 2 * c2, d2 = { data: new e.r({ width: h3, height: h3 }, a2), pixelRatio: 2, sdf: false, usvg: false, version: 0 };
                o2.set(t3, d2);
              }
              return o2;
            }
          }
          const rt = { vector: it, raster: ot, "raster-dem": class extends ot {
            constructor(t2, i2, o2, s2) {
              super(t2, i2, o2, s2), this.type = "raster-dem", this.maxzoom = 22, this._options = e.h({ type: "raster-dem" }, i2), this.encoding = i2.encoding || "mapbox";
            }
            loadTile(t2, i2) {
              const o2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme), false, this.tileSize);
              function s2(e2, o3) {
                e2 && (t2.state = "errored", i2(e2)), o3 && (t2.dem = o3, t2.dem.onDeserialize(), t2.needsHillshadePrepare = true, t2.needsDEMTextureUpload = true, t2.state = "loaded", i2(null));
              }
              t2.request = e.o(this.map._requestManager.transformRequest(o2, e.R.Tile), function(o3, r2, n2, a2) {
                if (delete t2.request, t2.aborted) t2.state = "unloaded", i2(null);
                else if (o3) t2.state = "errored", i2(o3);
                else if (r2) {
                  this.map._refreshExpiredTiles && t2.setExpiryData({ cacheControl: n2, expires: a2 });
                  const i3 = ImageBitmap && r2 instanceof ImageBitmap && e.t(), o4 = 1 - (r2.width - e.aL(r2.width)) / 2;
                  o4 < 1 || t2.neighboringTiles || (t2.neighboringTiles = this._getNeighboringTiles(t2.tileID));
                  const l2 = i3 ? r2 : e.q.getImageData(r2, o4), c2 = { uid: t2.uid, tileID: t2.tileID, source: this.id, type: this.type, scope: this.scope, rawImageData: l2, encoding: this.encoding, padding: o4 };
                  t2.actor && "expired" !== t2.state || (t2.actor = this.dispatcher.getActor(), t2.actor.send("loadTile", c2, s2.bind(this), void 0, true));
                }
              }.bind(this));
            }
            _getNeighboringTiles(t2) {
              const i2 = t2.canonical, o2 = Math.pow(2, i2.z), s2 = (i2.x - 1 + o2) % o2, r2 = 0 === i2.x ? t2.wrap - 1 : t2.wrap, n2 = (i2.x + 1 + o2) % o2, a2 = i2.x + 1 === o2 ? t2.wrap + 1 : t2.wrap, l2 = {};
              return l2[new e.aM(t2.overscaledZ, r2, i2.z, s2, i2.y).key] = { backfilled: false }, l2[new e.aM(t2.overscaledZ, a2, i2.z, n2, i2.y).key] = { backfilled: false }, i2.y > 0 && (l2[new e.aM(t2.overscaledZ, r2, i2.z, s2, i2.y - 1).key] = { backfilled: false }, l2[new e.aM(t2.overscaledZ, t2.wrap, i2.z, i2.x, i2.y - 1).key] = { backfilled: false }, l2[new e.aM(t2.overscaledZ, a2, i2.z, n2, i2.y - 1).key] = { backfilled: false }), i2.y + 1 < o2 && (l2[new e.aM(t2.overscaledZ, r2, i2.z, s2, i2.y + 1).key] = { backfilled: false }, l2[new e.aM(t2.overscaledZ, t2.wrap, i2.z, i2.x, i2.y + 1).key] = { backfilled: false }, l2[new e.aM(t2.overscaledZ, a2, i2.z, n2, i2.y + 1).key] = { backfilled: false }), l2;
            }
          }, "raster-array": st, geojson: class extends e.E {
            constructor(t2, i2, o2, s2) {
              super(), this.id = t2, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = true, this.reparseOverscaled = true, this._loaded = false, this.actor = o2.getActor(), this.setEventedParent(s2), this._data = i2.data, this._options = e.h({}, i2), this._collectResourceTiming = i2.collectResourceTiming, void 0 !== i2.maxzoom && (this.maxzoom = i2.maxzoom), void 0 !== i2.minzoom && (this.minzoom = i2.minzoom), i2.type && (this.type = i2.type), i2.attribution && (this.attribution = i2.attribution), this.promoteId = i2.promoteId;
              const r2 = e.aj / this.tileSize;
              this.workerOptions = e.h({ source: this.id, scope: this.scope, cluster: i2.cluster || false, geojsonVtOptions: { buffer: (void 0 !== i2.buffer ? i2.buffer : 128) * r2, tolerance: (void 0 !== i2.tolerance ? i2.tolerance : 0.375) * r2, extent: e.aj, maxZoom: this.maxzoom, lineMetrics: i2.lineMetrics || false, generateId: i2.generateId || false }, superclusterOptions: { maxZoom: void 0 !== i2.clusterMaxZoom ? i2.clusterMaxZoom : this.maxzoom - 1, minPoints: Math.max(2, i2.clusterMinPoints || 2), extent: e.aj, radius: (void 0 !== i2.clusterRadius ? i2.clusterRadius : 50) * r2, log: false, generateId: i2.generateId || false }, clusterProperties: i2.clusterProperties, filter: i2.filter, dynamic: i2.dynamic }, i2.workerOptions);
            }
            onAdd(e2) {
              this.map = e2, this.setData(this._data);
            }
            setData(e2) {
              return this._data = e2, this._updateWorkerData(), this;
            }
            updateData(t2) {
              if (!this._options.dynamic) return this.fire(new e.z(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
              if ("string" != typeof t2 && ("Feature" === t2.type && (t2 = { type: "FeatureCollection", features: [t2] }), "FeatureCollection" !== t2.type)) return this.fire(new e.z(new Error("Data to update should be a feature or a feature collection.")));
              if (this._coalesce && "string" != typeof t2 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
                const e2 = /* @__PURE__ */ new Map();
                for (const t3 of this._data.features) e2.set(t3.id, t3);
                for (const i2 of t2.features) e2.set(i2.id, i2);
                this._data.features = [...e2.values()];
              } else this._data = t2;
              return this._updateWorkerData(true), this;
            }
            getClusterExpansionZoom(e2, t2) {
              return this.actor.send("geojson.getClusterExpansionZoom", { clusterId: e2, source: this.id, scope: this.scope }, t2), this;
            }
            getClusterChildren(e2, t2) {
              return this.actor.send("geojson.getClusterChildren", { clusterId: e2, source: this.id, scope: this.scope }, t2), this;
            }
            getClusterLeaves(e2, t2, i2, o2) {
              return this.actor.send("geojson.getClusterLeaves", { source: this.id, scope: this.scope, clusterId: e2, limit: t2, offset: i2 }, o2), this;
            }
            _updateWorkerData(t2 = false) {
              if (this._pendingLoad) return void (this._coalesce = true);
              this.fire(new e.A("dataloading", { dataType: "source" })), this._loaded = false;
              const i2 = e.h({ append: t2 }, this.workerOptions);
              i2.scope = this.scope;
              const o2 = this._data;
              "string" == typeof o2 ? (i2.request = this.map._requestManager.transformRequest(e.q.resolveURL(o2), e.R.Source), i2.request.collectResourceTiming = this._collectResourceTiming) : i2.data = JSON.stringify(o2), this._pendingLoad = this.actor.send(`${this.type}.loadData`, i2, (i3, o3) => {
                if (this._loaded = true, this._pendingLoad = null, i3) this.fire(new e.z(i3));
                else {
                  const i4 = { dataType: "source", sourceDataType: this._metadataFired ? "content" : "metadata" };
                  this._collectResourceTiming && o3 && o3.resourceTiming && o3.resourceTiming[this.id] && (i4.resourceTiming = o3.resourceTiming[this.id]), t2 && (this._partialReload = true), this.fire(new e.A("data", i4)), this._partialReload = false, this._metadataFired = true;
                }
                this._coalesce && (this._updateWorkerData(t2), this._coalesce = false);
              });
            }
            loaded() {
              return this._loaded;
            }
            reload() {
              const t2 = e.C(this.id, this.scope);
              this.map.style.clearSource(t2), this._updateWorkerData();
            }
            loadTile(t2, i2) {
              const o2 = t2.actor ? "reloadTile" : "loadTile";
              t2.actor = this.actor;
              const s2 = this.map.style ? this.map.style.getLut(this.scope) : null, r2 = s2 ? { image: s2.image.clone() } : null, n2 = this._partialReload, a2 = { type: this.type, uid: t2.uid, tileID: t2.tileID, tileZoom: t2.tileZoom, zoom: t2.tileID.overscaledZ, maxZoom: this.maxzoom, tileSize: this.tileSize, source: this.id, lut: r2, scope: this.scope, pixelRatio: e.q.devicePixelRatio, showCollisionBoxes: this.map.showCollisionBoxes, promoteId: this.promoteId, brightness: this.map.style && this.map.style.getBrightness() || 0, extraShadowCaster: t2.isExtraShadowCaster, scaleFactor: this.map.getScaleFactor(), partial: n2, worldview: this.map.getWorldview() };
              t2.request = this.actor.send(o2, a2, (e2, s3) => n2 && !s3 ? (t2.state = "loaded", i2(null)) : (delete t2.request, t2.destroy(), t2.aborted ? i2(null) : e2 ? i2(e2) : (t2.loadVectorData(s3, this.map.painter, "reloadTile" === o2), i2(null))), void 0, "loadTile" === o2);
            }
            abortTile(e2) {
              e2.request && (e2.request.cancel(), delete e2.request), e2.aborted = true;
            }
            unloadTile(e2, t2) {
              this.actor.send("removeTile", { uid: e2.uid, type: this.type, source: this.id, scope: this.scope }), e2.destroy();
            }
            onRemove(e2) {
              this._pendingLoad && this._pendingLoad.cancel();
            }
            serialize() {
              return e.h({}, this._options, { type: this.type, data: this._data });
            }
            hasTransition() {
              return false;
            }
          }, video: class extends e.aP {
            constructor(e2, t2, i2, o2) {
              super(e2, t2, i2, o2), this.roundZoom = true, this.type = "video", this.options = t2;
            }
            load() {
              this._loaded = false;
              const t2 = this.options;
              this.urls = [];
              for (const i2 of t2.urls) this.urls.push(this.map._requestManager.transformRequest(i2, e.R.Source).url);
              e.aQ(this.urls, (t3, i2) => {
                this._loaded = true, t3 ? this.fire(new e.z(t3)) : i2 && (this.video = i2, this.video.loop = true, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", () => {
                  this.map.triggerRepaint();
                }), this.map && this.video.play(), this._finishLoading());
              });
            }
            pause() {
              this.video && this.video.pause();
            }
            play() {
              this.video && this.video.play();
            }
            seek(t2) {
              if (this.video) {
                const i2 = this.video.seekable;
                t2 < i2.start(0) || t2 > i2.end(0) ? this.fire(new e.z(new e.V(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i2.start(0)} and ${i2.end(0)}-second mark.`))) : this.video.currentTime = t2;
              }
            }
            getVideo() {
              return this.video;
            }
            onAdd(e2) {
              this.map || (this.map = e2, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
            }
            prepare() {
              if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
              const t2 = this.map.painter.context, i2 = t2.gl;
              this.texture ? this.video.paused || (this.texture.bind(i2.LINEAR, i2.CLAMP_TO_EDGE), i2.texSubImage2D(i2.TEXTURE_2D, 0, 0, 0, i2.RGBA, i2.UNSIGNED_BYTE, this.video)) : (this.texture = new e.T(t2, this.video, i2.RGBA8), this.texture.bind(i2.LINEAR, i2.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t2);
            }
            serialize() {
              return { type: "video", urls: this.urls, coordinates: this.coordinates };
            }
            hasTransition() {
              return this.video && !this.video.paused;
            }
          }, image: e.aP, model: class extends e.E {
            constructor(e2, t2, i2, o2) {
              super(), this.id = e2, this.type = "model", this.models = [], this._loaded = false, this._options = t2;
            }
            load() {
              const t2 = [];
              for (const i2 in this._options.models) {
                const o2 = this._options.models[i2], s2 = e.aS(this.map._requestManager.transformRequest(o2.uri, e.R.Model).url).then((t3) => {
                  if (!t3) return;
                  const s3 = e.aT(t3), r2 = new e.aU(i2, o2.position, o2.orientation, s3);
                  r2.computeBoundsAndApplyParent(), this.models.push(r2);
                }).catch((t3) => {
                  this.fire(new e.z(new Error(`Could not load model ${i2} from ${o2.uri}: ${t3.message}`)));
                });
                t2.push(s2);
              }
              Promise.allSettled(t2).then(() => {
                this._loaded = true, this.fire(new e.A("data", { dataType: "source", sourceDataType: "metadata" }));
              }).catch((t3) => {
                this._loaded = true, this.fire(new e.z(new Error(`Could not load models: ${t3.message}`)));
              });
            }
            onAdd(e2) {
              this.map = e2, this.load();
            }
            hasTransition() {
              return false;
            }
            loaded() {
              return this._loaded;
            }
            getModels() {
              return this.models;
            }
            loadTile(e2, t2) {
            }
            serialize() {
              return this._options;
            }
          }, "batched-model": class extends e.E {
            constructor(e2, t2, i2, o2) {
              super(), this.type = "batched-model", this.id = e2, this.tileSize = 512, this._options = t2, this.tiles = this._options.tiles, this.maxzoom = t2.maxzoom || 19, this.minzoom = t2.minzoom || 0, this.roundZoom = true, this.usedInConflation = true, this.dispatcher = i2, this.reparseOverscaled = false, this.scheme = "xyz", this._loaded = false, this.setEventedParent(o2);
            }
            onAdd(e2) {
              this.map = e2, this.load();
            }
            reload() {
              this.cancelTileJSONRequest();
              const t2 = e.C(this.id, this.scope);
              this.load(() => this.map.style.clearSource(t2));
            }
            cancelTileJSONRequest() {
              this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            load(t2) {
              this._loaded = false, this.fire(new e.A("dataloading", { dataType: "source" }));
              const i2 = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o2 = this.map.getWorldview();
              this._tileJSONRequest = Qe(this._options, this.map._requestManager, i2, o2, (s2, r2) => {
                this._tileJSONRequest = null, this._loaded = true, s2 ? (i2 && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i2}`), o2 && 2 !== o2.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o2}`), this.fire(new e.z(s2))) : r2 && (e.h(this, r2), r2.bounds && (this.tileBounds = new tt2(r2.bounds, this.minzoom, this.maxzoom)), L(r2.tiles, this.map._requestManager._customAccessToken), this.fire(new e.A("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.A("data", { dataType: "source", sourceDataType: "content" }))), t2 && t2(s2);
              });
            }
            hasTransition() {
              return false;
            }
            hasTile(e2) {
              return !this.tileBounds || this.tileBounds.contains(e2.canonical);
            }
            loaded() {
              return this._loaded;
            }
            loadTile(t2, i2) {
              const o2 = this.map._requestManager.normalizeTileURL(t2.tileID.canonical.url(this.tiles, this.scheme)), s2 = { request: this.map._requestManager.transformRequest(o2, e.R.Tile), data: void 0, uid: t2.uid, tileID: t2.tileID, tileZoom: t2.tileZoom, zoom: t2.tileID.overscaledZ, tileSize: this.tileSize * t2.tileID.overscaleFactor(), type: this.type, source: this.id, scope: this.scope, showCollisionBoxes: this.map.showCollisionBoxes, isSymbolTile: t2.isSymbolTile, brightness: this.map.style && this.map.style.getBrightness() || 0, pixelRatio: e.q.devicePixelRatio, promoteId: this.promoteId };
              if (t2.actor && "expired" !== t2.state) if ("loading" === t2.state) t2.reloadCallback = i2;
              else {
                if (t2.buckets) {
                  const e2 = Object.values(t2.buckets);
                  for (const t3 of e2) t3.dirty = true;
                  return void (t2.state = "loaded");
                }
                t2.request = t2.actor.send("reloadTile", s2, r2.bind(this));
              }
              else t2.actor = this.dispatcher.getActor(), t2.request = t2.actor.send("loadTile", s2, r2.bind(this), void 0, true);
              function r2(e2, o3) {
                return t2.aborted ? i2(null) : e2 && 404 !== e2.status ? i2(e2) : (this.map._refreshExpiredTiles && o3 && t2.setExpiryData(o3), t2.loadModelData(o3, this.map.painter), t2.state = "loaded", void i2(null));
              }
            }
            serialize() {
              return e.h({}, this._options);
            }
          }, canvas: class extends e.aP {
            constructor(t2, i2, o2, s2) {
              super(t2, i2, o2, s2), i2.coordinates ? Array.isArray(i2.coordinates) && 4 === i2.coordinates.length && !i2.coordinates.some((e2) => !Array.isArray(e2) || 2 !== e2.length || e2.some((e3) => "number" != typeof e3)) || this.fire(new e.z(new e.V(`sources.${t2}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e.z(new e.V(`sources.${t2}`, null, 'missing required property "coordinates"'))), i2.animate && "boolean" != typeof i2.animate && this.fire(new e.z(new e.V(`sources.${t2}`, null, 'optional "animate" property must be a boolean value'))), i2.canvas ? "string" == typeof i2.canvas || i2.canvas instanceof HTMLCanvasElement || this.fire(new e.z(new e.V(`sources.${t2}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e.z(new e.V(`sources.${t2}`, null, 'missing required property "canvas"'))), this.options = i2, this.animate = void 0 === i2.animate || i2.animate;
            }
            load() {
              this._loaded = true, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e.z(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                this._playing = true, this.map.triggerRepaint();
              }, this.pause = function() {
                this._playing && (this.prepare(), this._playing = false);
              }, this._finishLoading());
            }
            getCanvas() {
              return this.canvas;
            }
            onAdd(e2) {
              this.map = e2, this.load(), this.canvas && this.animate && this.play();
            }
            onRemove(e2) {
              this.pause();
            }
            prepare() {
              let t2 = false;
              if (this.canvas.width !== this.width && (this.width = this.canvas.width, t2 = true), this.canvas.height !== this.height && (this.height = this.canvas.height, t2 = true), this._hasInvalidDimensions()) return;
              if (0 === Object.keys(this.tiles).length) return;
              const i2 = this.map.painter.context;
              this.texture ? !t2 && !this._playing || this.texture instanceof e.aR || this.texture.update(this.canvas, { premultiply: true }) : this.texture = new e.T(i2, this.canvas, i2.gl.RGBA8, { premultiply: true }), this._prepareData(i2);
            }
            serialize() {
              return { type: "canvas", coordinates: this.coordinates };
            }
            hasTransition() {
              return this._playing;
            }
            _hasInvalidDimensions() {
              for (const e2 of [this.canvas.width, this.canvas.height]) if (isNaN(e2) || e2 <= 0) return true;
              return false;
            }
          }, custom: class extends e.E {
            constructor(t2, i2, o2, s2) {
              super(), this.id = t2, this.type = "custom", this._dataType = "raster", this._dispatcher = o2, this._implementation = i2, this.setEventedParent(s2), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = false, this.roundZoom = true, this._implementation || this.fire(new e.z(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e.z(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new tt2(this._implementation.bounds, this.minzoom, this.maxzoom)), i2.update = this._update.bind(this), i2.clearTiles = this._clearTiles.bind(this), i2.coveringTiles = this._coveringTiles.bind(this), e.h(this, e.aF(i2, ["dataType", "scheme", "minzoom", "maxzoom", "tileSize", "attribution", "minTileCacheSize", "maxTileCacheSize"]));
            }
            serialize() {
              return e.aF(this, ["type", "scheme", "minzoom", "maxzoom", "tileSize", "attribution"]);
            }
            load() {
              this._loaded = true, this.fire(new e.A("data", { dataType: "source", sourceDataType: "metadata" })), this.fire(new e.A("data", { dataType: "source", sourceDataType: "content" }));
            }
            loaded() {
              return this._loaded;
            }
            onAdd(t2) {
              this.map = t2, this._loaded = false, this.fire(new e.A("dataloading", { dataType: "source" })), this._implementation.onAdd && this._implementation.onAdd(t2), this.load();
            }
            onRemove(e2) {
              this._implementation.onRemove && this._implementation.onRemove(e2);
            }
            hasTile(e2) {
              if (this._implementation.hasTile) {
                const { x: t2, y: i2, z: o2 } = e2.canonical;
                return this._implementation.hasTile({ x: t2, y: i2, z: o2 });
              }
              return !this.tileBounds || this.tileBounds.contains(e2.canonical);
            }
            loadTile(e2, t2) {
              const { x: i2, y: o2, z: s2 } = e2.tileID.canonical, r2 = new AbortController();
              e2.request = Promise.resolve(this._implementation.loadTile({ x: i2, y: o2, z: s2 }, { signal: r2.signal })).then(function(i3) {
                return delete e2.request, e2.aborted ? (e2.state = "unloaded", t2(null)) : void 0 === i3 ? (e2.state = "errored", t2(null)) : null === i3 ? (this.loadTileData(e2, { width: this.tileSize, height: this.tileSize, data: null }), e2.state = "loaded", t2(null)) : function(e3) {
                  return e3 instanceof ImageData || e3 instanceof HTMLCanvasElement || e3 instanceof ImageBitmap || e3 instanceof HTMLImageElement;
                }(i3) ? (this.loadTileData(e2, i3), e2.state = "loaded", void t2(null)) : (e2.state = "errored", t2(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
              }.bind(this)).catch((i3) => {
                "AbortError" !== i3.name && (e2.state = "errored", t2(i3));
              }), e2.request.cancel = () => r2.abort();
            }
            loadTileData(e2, t2) {
              e2.setTexture(t2, this.map.painter);
            }
            unloadTile(t2, i2) {
              if (t2.texture && t2.texture instanceof e.T ? (t2.destroy(true), t2.texture && t2.texture instanceof e.T && this.map.painter.saveTileTexture(t2.texture)) : t2.destroy(), this._implementation.unloadTile) {
                const { x: e2, y: i3, z: o2 } = t2.tileID.canonical;
                this._implementation.unloadTile({ x: e2, y: i3, z: o2 });
              }
              i2 && i2();
            }
            abortTile(e2, t2) {
              e2.request && e2.request.cancel && (e2.request.cancel(), delete e2.request), t2 && t2();
            }
            hasTransition() {
              return false;
            }
            _coveringTiles() {
              return this.map.transform.coveringTiles({ tileSize: this.tileSize, minzoom: this.minzoom, maxzoom: this.maxzoom, roundZoom: this.roundZoom }).map((e2) => ({ x: e2.canonical.x, y: e2.canonical.y, z: e2.canonical.z }));
            }
            _clearTiles() {
              const t2 = e.C(this.id, this.scope);
              this.map.style.clearSource(t2);
            }
            _update() {
              this.fire(new e.A("data", { dataType: "source", sourceDataType: "content" }));
            }
          } }, nt = function(t2, i2, o2, s2) {
            const r2 = new rt[i2.type](t2, i2, o2, s2);
            if (r2.id !== t2) throw new Error(`Expected Source id to be ${t2} instead of ${r2.id}`);
            return e.aV(["load", "abort", "unload", "serialize", "prepare"], r2), r2;
          };
          function at(e2, t2, i2 = "") {
            return `${i2}:${t2.id || ""}:${t2.layer.id}:${function(e3) {
              if ("layerId" in e3) return `layer:${e3.layerId}`;
              {
                const { featuresetId: t3, importId: i3 } = e3;
                return `featureset:${t3}${i3 ? `:import:${i3}` : ""}`;
              }
            }(e2.target)}`;
          }
          function lt(e2, t2, i2, o2 = "") {
            if (e2.uniqueFeatureID) {
              const s2 = at(e2, t2, o2);
              if (i2.has(s2)) return true;
              i2.add(s2);
            }
            return false;
          }
          function ct(e2, t2, i2, o2, s2 = false) {
            const r2 = t2.sourceCache.transform, n2 = t2.sourceCache.tilesIn(e2, t2.has3DLayers, s2);
            n2.sort(ut);
            const a2 = [];
            for (const e3 of n2) {
              const n3 = e3.tile.queryRenderedFeatures(t2, e3, i2, o2, r2, s2);
              Object.keys(n3).length && a2.push({ wrappedTileID: e3.tile.tileID.wrapped().key, queryResults: n3 });
            }
            return 0 === a2.length ? {} : function(e3) {
              const t3 = {}, i3 = {};
              for (const o3 of e3) {
                const e4 = o3.queryResults, s3 = o3.wrappedTileID, r3 = i3[s3] = i3[s3] || {};
                for (const i4 in e4) {
                  const o4 = e4[i4], s4 = r3[i4] = r3[i4] || {}, n3 = t3[i4] = t3[i4] || [];
                  for (const e5 of o4) s4[e5.featureIndex] || (s4[e5.featureIndex] = true, n3.push(e5));
                }
              }
              return t3;
            }(a2);
          }
          function ht(e2, t2, i2, o2, s2, r2) {
            const n2 = {}, a2 = o2.queryRenderedSymbols(e2), l2 = [];
            for (const e3 of Object.keys(a2).map(Number)) l2.push(s2[e3]);
            l2.sort(ut);
            for (const e3 of l2) {
              const o3 = e3.featureIndex.lookupSymbolFeatures(a2[e3.bucketInstanceId], e3.bucketIndex, e3.sourceLayerIndex, t2, i2, r2);
              for (const t3 in o3) {
                const i3 = n2[t3] = n2[t3] || [], s3 = o3[t3];
                s3.sort((t4, i4) => {
                  const o4 = e3.featureSortOrder;
                  if (o4) {
                    const e4 = o4.indexOf(t4.featureIndex);
                    return o4.indexOf(i4.featureIndex) - e4;
                  }
                  return i4.featureIndex - t4.featureIndex;
                });
                for (const e4 of s3) i3.push(e4);
              }
            }
            return n2;
          }
          function dt(e2, t2) {
            const i2 = e2.getRenderableIds().map((t3) => e2.getTileByID(t3)), o2 = [], s2 = {};
            for (let e3 = 0; e3 < i2.length; e3++) {
              const r2 = i2[e3], n2 = r2.tileID.canonical.key;
              s2[n2] || (s2[n2] = true, r2.querySourceFeatures(o2, t2));
            }
            return o2;
          }
          function ut(e2, t2) {
            const i2 = e2.tileID, o2 = t2.tileID;
            return i2.overscaledZ - o2.overscaledZ || i2.canonical.y - o2.canonical.y || i2.wrap - o2.wrap || i2.canonical.x - o2.canonical.x;
          }
          function _t(e2, t2) {
            const i2 = {};
            if (!t2) return i2;
            for (const o2 of e2) {
              const e3 = o2.layerIds.map((e4) => t2.getLayer(e4)).filter(Boolean);
              if (0 !== e3.length) {
                o2.layers = e3, o2.stateDependentLayerIds && (o2.stateDependentLayers = o2.stateDependentLayerIds.map((t3) => e3.filter((e4) => e4.id === t3)[0]));
                for (const t3 of e3) i2[t3.fqid] = o2;
              }
            }
            return i2;
          }
          const pt = 32, ft = 33, mt = new Uint16Array(8184);
          for (let e2 = 0; e2 < 2046; e2++) {
            let t2 = e2 + 2, i2 = 0, o2 = 0, s2 = 0, r2 = 0, n2 = 0, a2 = 0;
            for (1 & t2 ? s2 = r2 = n2 = pt : i2 = o2 = a2 = pt; (t2 >>= 1) > 1; ) {
              const e3 = i2 + s2 >> 1, l3 = o2 + r2 >> 1;
              1 & t2 ? (s2 = i2, r2 = o2, i2 = n2, o2 = a2) : (i2 = s2, o2 = r2, s2 = n2, r2 = a2), n2 = e3, a2 = l3;
            }
            const l2 = 4 * e2;
            mt[l2 + 0] = i2, mt[l2 + 1] = o2, mt[l2 + 2] = s2, mt[l2 + 3] = r2;
          }
          const gt = new Uint16Array(2178), vt = new Uint8Array(1089), yt = new Uint16Array(1089);
          function xt(e2) {
            return 0 === e2 ? -0.03125 : 32 === e2 ? 0.03125 : 0;
          }
          const bt = (() => ({ type: 2, extent: e.aj, loadGeometry: () => [[new e.P(0, 0), new e.P(e.aj + 1, 0), new e.P(e.aj + 1, e.aj + 1), new e.P(0, e.aj + 1), new e.P(0, 0)]] }))();
          class wt {
            constructor(t2, i2, o2, s2, r2, n2) {
              this.tileID = t2, this.uid = e.a$(), this.uses = 0, this.tileSize = i2, this.tileZoom = o2, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = false, this.hasRTLText = false, this.dependencies = {}, this.isRaster = r2, s2 && s2.style && (this._lastUpdatedBrightness = s2.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", s2 && s2.transform && (this.projection = s2.transform.projection), this.worldview = n2;
            }
            registerFadeDuration(t2) {
              const i2 = t2 + this.timeAdded;
              i2 < e.q.now() || this.fadeEndTime && i2 < this.fadeEndTime || (this.fadeEndTime = i2);
            }
            wasRequested() {
              return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
              return this._tileTransform || (this._tileTransform = e.aW(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(t2, i2, o2) {
              if (this.unloadVectorData(), this.state = "loaded", t2) {
                t2.featureIndex && (this.latestFeatureIndex = t2.featureIndex, t2.rawTileData ? (this.latestRawTileData = t2.rawTileData, this.latestFeatureIndex.rawTileData = t2.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = t2.collisionBoxArray, this.buckets = _t(t2.buckets, i2.style), this.hasSymbolBuckets = false;
                for (const t3 in this.buckets) {
                  const i3 = this.buckets[t3];
                  if (i3 instanceof e.b1) {
                    if (this.hasSymbolBuckets = true, !o2) break;
                    i3.justReloaded = true;
                  }
                }
                if (this.hasRTLText = false, this.hasSymbolBuckets) for (const t3 in this.buckets) {
                  const i3 = this.buckets[t3];
                  if (i3 instanceof e.b1 && i3.hasRTLText) {
                    this.hasRTLText = true, e.b2();
                    break;
                  }
                }
                this.queryPadding = 0;
                for (const e2 in this.buckets) {
                  const t3 = this.buckets[e2], o3 = i2.style.getOwnLayer(e2);
                  if (!o3) continue;
                  const s2 = o3.queryRadius(t3);
                  this.queryPadding = Math.max(this.queryPadding, s2);
                }
                t2.imageAtlas && (this.imageAtlas = t2.imageAtlas), t2.glyphAtlasImage && (this.glyphAtlasImage = t2.glyphAtlasImage), t2.lineAtlas && (this.lineAtlas = t2.lineAtlas), this._lastUpdatedBrightness = t2.brightness;
              } else this.collisionBoxArray = new e.b0();
            }
            unloadVectorData() {
              if (this.hasData()) {
                for (const e2 in this.buckets) this.buckets[e2].destroy();
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
              }
            }
            loadModelData(e2, t2, i2) {
              e2 && (e2.resourceTiming && (this.resourceTiming = e2.resourceTiming), this.buckets = Object.assign({}, this.buckets, _t(e2.buckets, t2.style)), e2.featureIndex && (this.latestFeatureIndex = e2.featureIndex));
            }
            getBucket(e2) {
              return this.buckets[e2.fqid];
            }
            upload(t2) {
              for (const e2 in this.buckets) {
                const i3 = this.buckets[e2];
                i3.uploadPending() && i3.upload(t2);
              }
              const i2 = t2.gl, o2 = this.imageAtlas;
              o2 && !o2.uploaded && (this.imageAtlasTexture = new e.T(t2, o2.image, i2.RGBA8, { useMipmap: !!o2.patternPositions.size }), this.imageAtlas.uploaded = true), this.glyphAtlasImage && (this.glyphAtlasTexture = new e.T(t2, this.glyphAtlasImage, i2.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new e.T(t2, this.lineAtlas.image, i2.R8), this.lineAtlas.uploaded = true);
            }
            prepare(e2, t2, i2) {
              if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(e2, this.imageAtlasTexture, i2), !t2 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
              const o2 = t2.style.getBrightness();
              (this._lastUpdatedBrightness || o2) && (this._lastUpdatedBrightness && o2 && Math.abs(this._lastUpdatedBrightness - o2) < 1e-3 || (this.updateBuckets(t2, this._lastUpdatedBrightness !== o2), this._lastUpdatedBrightness = o2));
            }
            queryRenderedFeatures(t2, i2, o2, s2, r2, n2) {
              if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile) return {};
              const a2 = function(t3, i3) {
                const o3 = e.bn([], [0.5 * t3.width, 0.5 * -t3.height, 1]);
                return e.bo(o3, o3, [1, -1, 0]), e.az(o3, o3, t3.calculateProjMatrix(i3.toUnwrapped())), Float32Array.from(o3);
              }(r2, this.tileID);
              return this.latestFeatureIndex.query(t2, { tilespaceGeometry: i2, pixelPosMatrix: a2, transform: s2, availableImages: o2, tileTransform: this.tileTransform, worldview: this.worldview });
            }
            querySourceFeatures(t2, i2) {
              const o2 = this.latestFeatureIndex;
              if (!o2 || !o2.rawTileData) return;
              const s2 = o2.loadVTLayers(), r2 = i2 ? i2.sourceLayer : "", n2 = s2._geojsonTileLayer || s2[r2];
              if (!n2) return;
              const a2 = e.b3(i2 && i2.filter), { z: l2, x: c2, y: h3 } = this.tileID.canonical, d2 = { z: l2, x: c2, y: h3 };
              for (let i3 = 0; i3 < n2.length; i3++) {
                const s3 = n2.feature(i3);
                if (a2.needGeometry) {
                  const t3 = e.b4(s3, true);
                  if (!a2.filter(new e.aa(this.tileID.overscaledZ, { worldview: this.worldview }), t3, this.tileID.canonical)) continue;
                } else if (!a2.filter(new e.aa(this.tileID.overscaledZ, { worldview: this.worldview }), s3)) continue;
                const u2 = o2.getId(s3, r2), _2 = new e.b5(s3, l2, c2, h3, u2);
                _2.tile = d2, t2.push(_2);
              }
            }
            loaded() {
              return "loaded" === this.state || "errored" === this.state;
            }
            hasData() {
              return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
              return !!this.imageAtlas && !!this.imageAtlas.patternPositions.size;
            }
            setExpiryData(t2) {
              const i2 = this.expirationTime;
              if (t2.cacheControl) {
                const i3 = e.b6(t2.cacheControl);
                i3["max-age"] && (this.expirationTime = Date.now() + 1e3 * i3["max-age"]);
              } else t2.expires && (this.expirationTime = new Date(t2.expires).getTime());
              if (this.expirationTime) {
                const e2 = Date.now();
                let t3 = false;
                if (this.expirationTime > e2) t3 = false;
                else if (i2) if (this.expirationTime < i2) t3 = true;
                else {
                  const o2 = this.expirationTime - i2;
                  o2 ? this.expirationTime = e2 + Math.max(o2, 3e4) : t3 = true;
                }
                else t3 = true;
                t3 ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
              }
            }
            getExpiryTimeout() {
              if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (/* @__PURE__ */ new Date()).getTime(), Math.pow(2, 31) - 1);
            }
            refreshFeatureState(e2) {
              this.latestFeatureIndex && (this.latestFeatureIndex.rawTileData || this.latestFeatureIndex.is3DTile) && e2 && this.updateBuckets(e2);
            }
            updateBuckets(t2, i2) {
              if (!this.latestFeatureIndex) return;
              if (!t2.style) return;
              const o2 = this.latestFeatureIndex.loadVTLayers(), s2 = t2.style.listImages(), r2 = t2.style.getBrightness();
              for (const n2 in this.buckets) {
                if (!t2.style.hasLayer(n2)) continue;
                const a2 = this.buckets[n2], l2 = a2.layers[0], c2 = l2.sourceLayer || "_geojsonTileLayer", h3 = o2[c2], d2 = t2.style.getLayerSourceCache(l2);
                let u2 = {};
                d2 && (u2 = d2._state.getState(c2, void 0));
                const _2 = this.imageAtlas ? Object.fromEntries(this.imageAtlas.patternPositions) : {}, p3 = Object.keys(u2).length > 0 && !i2;
                p3 && !a2.stateDependentLayers.length && !i2 || a2.update(u2, h3, s2, _2, p3 ? a2.stateDependentLayers : a2.layers, i2, r2), (a2 instanceof e.b7 || a2 instanceof e.b8) && t2._terrain && t2._terrain.enabled && d2 && a2.uploadPending() && t2._terrain._clearRenderCacheForTile(d2.id, this.tileID);
                const f2 = t2 && t2.style && t2.style.getOwnLayer(n2);
                f2 && (this.queryPadding = Math.max(this.queryPadding, f2.queryRadius(a2)));
              }
            }
            holdingForFade() {
              return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
              return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < e.q.now();
            }
            clearFadeHold() {
              this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(t2) {
              this.symbolFadeHoldUntil = e.q.now() + t2;
            }
            setTexture(t2, i2) {
              const o2 = i2.context, s2 = o2.gl;
              this.texture = this.texture || i2.getTileTexture(t2.width), this.texture && this.texture instanceof e.T ? this.texture.update(t2) : (this.texture = new e.T(o2, t2, s2.RGBA8, { useMipmap: true }), this.texture.bind(s2.LINEAR, s2.CLAMP_TO_EDGE));
            }
            setDependencies(e2, t2) {
              const i2 = {};
              for (const e3 of t2) i2[e3] = true;
              this.dependencies[e2] = i2;
            }
            hasDependency(e2, t2) {
              for (const i2 of e2) {
                const e3 = this.dependencies[i2];
                if (e3) {
                  for (const i3 of t2) if (e3[i3]) return true;
                }
              }
              return false;
            }
            clearQueryDebugViz() {
            }
            _makeDebugTileBoundsBuffers(t2, i2) {
              if (!i2 || "mercator" === i2.name || this._tileDebugBuffer) return;
              const o2 = e.b9(bt, this.tileID.canonical, this.tileTransform)[0], s2 = new e.ba(), r2 = new e.bb();
              for (let e2 = 0; e2 < o2.length; e2++) {
                const { x: t3, y: i3 } = o2[e2];
                s2.emplaceBack(t3, i3), r2.emplaceBack(e2);
              }
              r2.emplaceBack(0), this._tileDebugIndexBuffer = t2.createIndexBuffer(r2), this._tileDebugBuffer = t2.createVertexBuffer(s2, e.bc.members), this._tileDebugSegments = e.bd.simpleSegment(0, 0, s2.length, r2.length);
            }
            _makeTileBoundsBuffers(t2, i2) {
              if (this._tileBoundsBuffer || !i2 || "mercator" === i2.name) return;
              const o2 = e.b9(bt, this.tileID.canonical, this.tileTransform)[0];
              let s2, r2;
              if (this.isRaster) {
                const t3 = function(t4, i3) {
                  const o3 = e.aW(t4, i3), s3 = Math.pow(2, t4.z);
                  for (let r4 = 0; r4 < ft; r4++) for (let n3 = 0; n3 < ft; n3++) {
                    const a3 = e.aX((t4.x + (n3 + xt(n3)) / pt) / s3), l3 = e.aY((t4.y + (r4 + xt(r4)) / pt) / s3), c3 = i3.project(a3, l3), h3 = r4 * ft + n3;
                    gt[2 * h3 + 0] = Math.round((c3.x * o3.scale - o3.x) * e.aj), gt[2 * h3 + 1] = Math.round((c3.y * o3.scale - o3.y) * e.aj);
                  }
                  vt.fill(0), yt.fill(0);
                  for (let e2 = 2045; e2 >= 0; e2--) {
                    const t5 = 4 * e2, i4 = mt[t5 + 0], o4 = mt[t5 + 1], s4 = mt[t5 + 2], r4 = mt[t5 + 3], n3 = i4 + s4 >> 1, a3 = o4 + r4 >> 1, l3 = n3 + a3 - o4, c3 = a3 + i4 - n3, h3 = o4 * ft + i4, d2 = r4 * ft + s4, u2 = a3 * ft + n3, _2 = Math.hypot((gt[2 * h3 + 0] + gt[2 * d2 + 0]) / 2 - gt[2 * u2 + 0], (gt[2 * h3 + 1] + gt[2 * d2 + 1]) / 2 - gt[2 * u2 + 1]) >= 16;
                    vt[u2] = vt[u2] || (_2 ? 1 : 0), e2 < 1022 && (vt[u2] = vt[u2] || vt[(o4 + c3 >> 1) * ft + (i4 + l3 >> 1)] || vt[(r4 + c3 >> 1) * ft + (s4 + l3 >> 1)]);
                  }
                  const r3 = new e.aZ(), n2 = new e.a_();
                  let a2 = 0;
                  function l2(t5, i4) {
                    const o4 = i4 * ft + t5;
                    return 0 === yt[o4] && (r3.emplaceBack(gt[2 * o4 + 0], gt[2 * o4 + 1], t5 * e.aj / pt, i4 * e.aj / pt), yt[o4] = ++a2), yt[o4] - 1;
                  }
                  function c2(e2, t5, i4, o4, s4, r4) {
                    const a3 = e2 + i4 >> 1, h3 = t5 + o4 >> 1;
                    if (Math.abs(e2 - s4) + Math.abs(t5 - r4) > 1 && vt[h3 * ft + a3]) c2(s4, r4, e2, t5, a3, h3), c2(i4, o4, s4, r4, a3, h3);
                    else {
                      const a4 = l2(e2, t5), c3 = l2(i4, o4), h4 = l2(s4, r4);
                      n2.emplaceBack(a4, c3, h4);
                    }
                  }
                  return c2(0, 0, pt, pt, pt, 0), c2(pt, pt, 0, 0, 0, pt), { vertices: r3, indices: n2 };
                }(this.tileID.canonical, i2);
                s2 = t3.vertices, r2 = t3.indices;
              } else {
                s2 = new e.aZ(), r2 = new e.a_();
                for (const { x: e2, y: t4 } of o2) s2.emplaceBack(e2, t4, 0, 0);
                const t3 = e.be(s2.int16.subarray(0, 4 * s2.length), void 0, 4);
                for (let e2 = 0; e2 < t3.length; e2 += 3) r2.emplaceBack(t3[e2], t3[e2 + 1], t3[e2 + 2]);
              }
              this._tileBoundsBuffer = t2.createVertexBuffer(s2, e.bf.members), this._tileBoundsIndexBuffer = t2.createIndexBuffer(r2), this._tileBoundsSegments = e.bd.simpleSegment(0, 0, s2.length, r2.length);
            }
            _makeGlobeTileDebugBuffers(t2, i2) {
              const o2 = i2.projection;
              if (!o2 || "globe" !== o2.name || i2.freezeTileCoverage) return;
              const s2 = this.tileID.canonical, r2 = e.bg(s2, i2), n2 = e.bh(r2), a2 = e.ah(i2.zoom);
              let l2;
              a2 > 0 && (l2 = e.bi(new Float64Array(16), i2.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(t2, s2, i2, n2, l2, a2), this._makeGlobeTileDebugTextBuffer(t2, s2, i2, n2, l2, a2);
            }
            _globePoint(t2, i2, o2, s2, r2, n2, a2) {
              let l2 = e.bj(t2, i2, o2);
              if (n2) {
                const r3 = 1 << o2.z, c2 = e.aD(s2.center.lng), h3 = e.aH(s2.center.lat), d2 = (o2.x + 0.5) / r3 - c2;
                let u2 = 0;
                d2 > 0.5 ? u2 = -1 : d2 < -0.5 && (u2 = 1);
                let _2 = (t2 / e.aj + o2.x) / r3 + u2, p3 = (i2 / e.aj + o2.y) / r3;
                _2 = (_2 - c2) * s2._pixelsPerMercatorPixel + c2, p3 = (p3 - h3) * s2._pixelsPerMercatorPixel + h3;
                const f2 = [_2 * s2.worldSize, p3 * s2.worldSize, 0];
                e.ad(f2, f2, n2), l2 = e.bk(l2, f2, a2);
              }
              return e.ad(l2, l2, r2);
            }
            _makeGlobeTileDebugBorderBuffer(t2, i2, o2, s2, r2, n2) {
              const a2 = new e.ba(), l2 = new e.bb(), c2 = new e.bl(), h3 = (e2, t3, h4, d3, u2) => {
                const _2 = (h4 - e2) / (u2 - 1), p3 = (d3 - t3) / (u2 - 1), f2 = a2.length;
                for (let h5 = 0; h5 < u2; h5++) {
                  const d4 = e2 + h5 * _2, u3 = t3 + h5 * p3;
                  a2.emplaceBack(d4, u3);
                  const m2 = this._globePoint(d4, u3, i2, o2, s2, r2, n2);
                  c2.emplaceBack(m2[0], m2[1], m2[2]), l2.emplaceBack(f2 + h5);
                }
              }, d2 = e.aj;
              h3(0, 0, d2, 0, 16), h3(d2, 0, d2, d2, 16), h3(d2, d2, 0, d2, 16), h3(0, d2, 0, 0, 16), this._tileDebugIndexBuffer = t2.createIndexBuffer(l2), this._tileDebugBuffer = t2.createVertexBuffer(a2, e.bc.members), this._globeTileDebugBorderBuffer = t2.createVertexBuffer(c2, e.bm.members), this._tileDebugSegments = e.bd.simpleSegment(0, 0, a2.length, l2.length);
            }
            _makeGlobeTileDebugTextBuffer(t2, i2, o2, s2, r2, n2) {
              const a2 = e.aj / 4, l2 = new e.ba(), c2 = new e.a_(), h3 = new e.bl(), d2 = 25;
              c2.reserve(32), l2.reserve(d2), h3.reserve(d2);
              const u2 = (e2, t3) => d2 * e2 + t3;
              for (let e2 = 0; e2 < d2; e2++) {
                const t3 = e2 * a2;
                for (let e3 = 0; e3 < d2; e3++) {
                  const c3 = e3 * a2;
                  l2.emplaceBack(c3, t3);
                  const d3 = this._globePoint(c3, t3, i2, o2, s2, r2, n2);
                  h3.emplaceBack(d3[0], d3[1], d3[2]);
                }
              }
              for (let e2 = 0; e2 < 4; e2++) for (let t3 = 0; t3 < 4; t3++) {
                const i3 = u2(e2, t3), o3 = u2(e2, t3 + 1), s3 = u2(e2 + 1, t3), r3 = u2(e2 + 1, t3 + 1);
                c2.emplaceBack(i3, o3, s3), c2.emplaceBack(s3, o3, r3);
              }
              this._tileDebugTextIndexBuffer = t2.createIndexBuffer(c2), this._tileDebugTextBuffer = t2.createVertexBuffer(l2, e.bc.members), this._globeTileDebugTextBuffer = t2.createVertexBuffer(h3, e.bm.members), this._tileDebugTextSegments = e.bd.simpleSegment(0, 0, d2, 32);
            }
            destroy(t2 = false) {
              for (const e2 in this.buckets) this.buckets[e2].destroy();
              this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !t2 && this.texture && this.texture instanceof e.T && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
            }
          }
          e.bp.setPbf(e.bq);
          class Tt extends wt {
            constructor(e2, t2, i2, o2, s2) {
              super(e2, t2, i2, o2, s2), this._workQueue = [], this._fetchQueue = [], this._isHeaderLoaded = false;
            }
            getLayers() {
              return this._mrt ? Object.values(this._mrt.layers) : [];
            }
            getLayer(e2) {
              return this._mrt && this._mrt.getLayer(e2);
            }
            setTexture(t2, i2) {
              const o2 = i2.context, s2 = o2.gl;
              this.texture = this.texture || i2.getTileTexture(t2.width), this.texture && this.texture instanceof e.T ? this.texture.update(t2, { premultiply: false }) : this.texture = new e.T(o2, t2, s2.RGBA8, { premultiply: false });
            }
            flushQueues() {
              for (; this._workQueue.length; ) this._workQueue.pop()();
              for (; this._fetchQueue.length; ) this._fetchQueue.pop()();
            }
            fetchHeader(t2 = 16384, i2) {
              const o2 = this._mrt = new e.bp(30), s2 = Object.assign({}, this.requestParams, { headers: { Range: "bytes=0-" + (t2 - 1) } });
              return this.entireBuffer = null, this.request = e.br(s2, (e2, s3, r2, n2) => {
                if (e2) i2(e2);
                else try {
                  const e3 = o2.getHeaderLength(s3);
                  if (e3 > t2) return void (this.request = this.fetchHeader(e3, i2));
                  o2.parseHeader(s3), this._isHeaderLoaded = true;
                  let a2 = 0;
                  for (const e4 of Object.values(o2.layers)) a2 = Math.max(a2, e4.dataIndex[e4.dataIndex.length - 1].lastByte);
                  s3.byteLength >= a2 && (this.entireBuffer = s3), i2(null, this.entireBuffer || s3, r2, n2);
                } catch (e3) {
                  i2(e3);
                }
              }), this.request;
            }
            fetchBand(t2, i2, o2) {
              const s2 = this._mrt;
              if (!this._isHeaderLoaded || !s2) return void o2(new Error("Tile header is not ready"));
              const r2 = this.actor;
              if (!r2) return void o2(new Error("Can't fetch tile band without an actor"));
              let n2;
              const a2 = (e2, s3) => {
                n2.complete(e2, s3), e2 ? o2(e2) : (this.updateTextureDescriptor(t2, i2), o2(null, this.textureDescriptor && this.textureDescriptor.img));
              }, l2 = (e2, t3) => {
                if (e2) return o2(e2);
                const i3 = r2.send("decodeRasterArray", { type: "raster-array", source: this.source, scope: this.scope, tileID: this.tileID, uid: this.uid, buffer: t3, task: n2 }, a2, void 0, true);
                this._workQueue.push(() => {
                  i3 && i3.cancel(), n2.cancel();
                });
              }, c2 = s2.getLayer(t2);
              if (!c2) return void o2(new Error(`Unknown sourceLayer "${t2}"`));
              if (c2.hasDataForBand(i2)) return this.updateTextureDescriptor(t2, i2), void o2(null, this.textureDescriptor ? this.textureDescriptor.img : null);
              const h3 = c2.getDataRange([i2]);
              if (n2 = s2.createDecodingTask(h3), !n2 || n2.tasks.length) if (this.flushQueues(), this.entireBuffer) l2(null, this.entireBuffer.slice(h3.firstByte, h3.lastByte + 1));
              else {
                const t3 = Object.assign({}, this.requestParams, { headers: { Range: `bytes=${h3.firstByte}-${h3.lastByte}` } }), i3 = e.br(t3, l2);
                this._fetchQueue.push(() => {
                  i3.cancel(), n2.cancel();
                });
              }
              else o2(null);
            }
            updateNeeded(e2, t2) {
              return (!this.textureDescriptor || this.textureDescriptor.band !== t2 || this.textureDescriptor.layer !== e2) && "errored" !== this.state;
            }
            updateTextureDescriptor(t2, i2) {
              if (!this._mrt) return;
              const o2 = this._mrt.getLayer(t2);
              if (!o2 || !o2.hasBand(i2) || !o2.hasDataForBand(i2)) return;
              const { bytes: s2, tileSize: r2, buffer: n2, offset: a2, scale: l2 } = o2.getBandView(i2), c2 = r2 + 2 * n2, h3 = new e.r({ width: c2, height: c2 }, s2), d2 = this.texture;
              d2 && d2 instanceof e.T && d2.update(h3, { premultiply: false }), this.textureDescriptor = { layer: t2, band: i2, img: h3, buffer: n2, offset: a2, tileSize: r2, format: o2.pixelFormat, mix: [l2, 256 * l2, 65536 * l2, 16777216 * l2] };
            }
          }
          class Et {
            constructor(e2, t2) {
              this.max = e2, this.onRemove = t2, this.reset();
            }
            reset() {
              for (const e2 in this.data) for (const t2 of this.data[e2]) t2.timeout && clearTimeout(t2.timeout), this.onRemove(t2.value);
              return this.data = {}, this.order = [], this;
            }
            add(e2, t2, i2) {
              const o2 = e2.wrapped().key;
              void 0 === this.data[o2] && (this.data[o2] = []);
              const s2 = { value: t2, timeout: void 0 };
              if (void 0 !== i2 && (s2.timeout = setTimeout(() => {
                this.remove(e2, s2);
              }, i2)), this.data[o2].push(s2), this.order.push(o2), this.order.length > this.max) {
                const e3 = this._getAndRemoveByKey(this.order[0]);
                e3 && this.onRemove(e3);
              }
              return this;
            }
            has(e2) {
              return e2.wrapped().key in this.data;
            }
            getAndRemove(e2) {
              return this.has(e2) ? this._getAndRemoveByKey(e2.wrapped().key) : null;
            }
            _getAndRemoveByKey(e2) {
              const t2 = this.data[e2].shift();
              return t2.timeout && clearTimeout(t2.timeout), 0 === this.data[e2].length && delete this.data[e2], this.order.splice(this.order.indexOf(e2), 1), t2.value;
            }
            getByKey(e2) {
              const t2 = this.data[e2];
              return t2 ? t2[0].value : null;
            }
            get(e2) {
              return this.has(e2) ? this.data[e2.wrapped().key][0].value : null;
            }
            remove(e2, t2) {
              if (!this.has(e2)) return this;
              const i2 = e2.wrapped().key, o2 = void 0 === t2 ? 0 : this.data[i2].indexOf(t2), s2 = this.data[i2][o2];
              return this.data[i2].splice(o2, 1), s2.timeout && clearTimeout(s2.timeout), 0 === this.data[i2].length && delete this.data[i2], this.onRemove(s2.value), this.order.splice(this.order.indexOf(i2), 1), this;
            }
            setMaxSize(e2) {
              for (this.max = e2; this.order.length > this.max; ) {
                const e3 = this._getAndRemoveByKey(this.order[0]);
                e3 && this.onRemove(e3);
              }
              return this;
            }
            filter(e2) {
              const t2 = [];
              for (const i2 in this.data) for (const o2 of this.data[i2]) e2(o2.value) || t2.push(o2);
              for (const e3 of t2) this.remove(e3.value.tileID, e3);
            }
          }
          class St {
            constructor() {
              this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(t2, i2, o2) {
              const s2 = String(i2);
              if (this.stateChanges[t2] = this.stateChanges[t2] || {}, this.stateChanges[t2][s2] = this.stateChanges[t2][s2] || {}, e.h(this.stateChanges[t2][s2], o2), null === this.deletedStates[t2]) {
                this.deletedStates[t2] = {};
                for (const e2 in this.state[t2]) e2 !== s2 && (this.deletedStates[t2][e2] = null);
              } else if (this.deletedStates[t2] && null === this.deletedStates[t2][s2]) {
                this.deletedStates[t2][s2] = {};
                for (const e2 in this.state[t2][s2]) o2[e2] || (this.deletedStates[t2][s2][e2] = null);
              } else for (const e2 in o2) this.deletedStates[t2] && this.deletedStates[t2][s2] && null === this.deletedStates[t2][s2][e2] && delete this.deletedStates[t2][s2][e2];
            }
            removeFeatureState(e2, t2, i2) {
              if (null === this.deletedStates[e2]) return;
              const o2 = String(t2);
              if (this.deletedStates[e2] = this.deletedStates[e2] || {}, i2 && void 0 !== t2) null !== this.deletedStates[e2][o2] && (this.deletedStates[e2][o2] = this.deletedStates[e2][o2] || {}, this.deletedStates[e2][o2][i2] = null);
              else if (void 0 !== t2) if (this.stateChanges[e2] && this.stateChanges[e2][o2]) for (i2 in this.deletedStates[e2][o2] = {}, this.stateChanges[e2][o2]) this.deletedStates[e2][o2][i2] = null;
              else this.deletedStates[e2][o2] = null;
              else this.deletedStates[e2] = null;
            }
            getState(t2, i2) {
              const o2 = this.state[t2] || {}, s2 = this.stateChanges[t2] || {}, r2 = this.deletedStates[t2];
              if (null === r2) return {};
              if (void 0 !== i2) {
                const t3 = String(i2), n3 = e.h({}, o2[t3], s2[t3]);
                if (r2) {
                  const e2 = r2[i2];
                  if (null === e2) return {};
                  for (const t4 in e2) delete n3[t4];
                }
                return n3;
              }
              const n2 = e.h({}, o2, s2);
              if (r2) for (const e2 in r2) delete n2[e2];
              return n2;
            }
            initializeTileState(e2, t2) {
              e2.refreshFeatureState(t2);
            }
            coalesceChanges(t2, i2) {
              const o2 = {};
              for (const t3 in this.stateChanges) {
                this.state[t3] = this.state[t3] || {};
                const i3 = {};
                for (const o3 in this.stateChanges[t3]) this.state[t3][o3] || (this.state[t3][o3] = {}), e.h(this.state[t3][o3], this.stateChanges[t3][o3]), i3[o3] = this.state[t3][o3];
                o2[t3] = i3;
              }
              for (const t3 in this.deletedStates) {
                this.state[t3] = this.state[t3] || {};
                const i3 = {};
                if (null === this.deletedStates[t3]) for (const e2 in this.state[t3]) i3[e2] = {}, this.state[t3][e2] = {};
                else for (const e2 in this.deletedStates[t3]) {
                  if (null === this.deletedStates[t3][e2]) this.state[t3][e2] = {};
                  else if (this.state[t3][e2]) for (const i4 of Object.keys(this.deletedStates[t3][e2])) delete this.state[t3][e2][i4];
                  i3[e2] = this.state[t3][e2];
                }
                o2[t3] = o2[t3] || {}, e.h(o2[t3], i3);
              }
              if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(o2).length) for (const e2 in t2) t2[e2].refreshFeatureState(i2);
            }
          }
          class It extends e.E {
            constructor(e2, t2, i2) {
              super(), this.id = e2, this._onlySymbols = i2, t2.on("data", (e3) => {
                "source" === e3.dataType && "metadata" === e3.sourceDataType && (this._sourceLoaded = true), this._sourceLoaded && !this._paused && "source" === e3.dataType && "content" === e3.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
              }), t2.on("error", () => {
                this._sourceErrored = true;
              }), this._source = t2, this._tiles = {}, this._cache = new Et(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t2.minTileCacheSize, this._maxTileCacheSize = t2.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = false, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new St(), this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
            }
            onAdd(e2) {
              this.map = e2, this._minTileCacheSize = void 0 === this._minTileCacheSize && e2 ? e2._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e2 ? e2._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
              if (this._sourceErrored) return true;
              if (!this._sourceLoaded) return false;
              if (!this._source.loaded()) return false;
              for (const e2 in this._tiles) if (!this._tiles[e2].loaded()) return false;
              return true;
            }
            getSource() {
              return this._source;
            }
            pause() {
              this._paused = true;
            }
            resume() {
              if (!this._paused) return;
              const e2 = this._shouldReloadOnResume;
              this._paused = false, this._shouldReloadOnResume = false, e2 && this.reload(), this.transform && this.update(this.transform);
            }
            _loadTile(e2, t2) {
              return e2.isSymbolTile = this._onlySymbols, e2.isExtraShadowCaster = this._shadowCasterTiles[e2.tileID.key], this._source.loadTile(e2, t2);
            }
            _unloadTile(e2) {
              if (this._source.unloadTile) return this._source.unloadTile(e2);
            }
            _abortTile(e2) {
              if (this._source.abortTile) return this._source.abortTile(e2);
            }
            serialize() {
              return this._source.serialize();
            }
            prepare(e2) {
              this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
              for (const t2 in this._tiles) {
                const i2 = this._tiles[t2];
                i2.upload(e2), i2.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
              }
            }
            getIds() {
              return Object.values(this._tiles).map((e2) => e2.tileID).sort(Ct).map((e2) => e2.key);
            }
            getRenderableIds(t2, i2) {
              const o2 = [];
              for (const e2 in this._tiles) this._isIdRenderable(+e2, t2, i2) && o2.push(this._tiles[e2]);
              return t2 ? o2.sort((t3, i3) => {
                const o3 = t3.tileID, s2 = i3.tileID, r2 = new e.P(o3.canonical.x, o3.canonical.y)._rotate(this.transform.angle), n2 = new e.P(s2.canonical.x, s2.canonical.y)._rotate(this.transform.angle);
                return o3.overscaledZ - s2.overscaledZ || n2.y - r2.y || n2.x - r2.x;
              }).map((e2) => e2.tileID.key) : o2.map((e2) => e2.tileID).sort(Ct).map((e2) => e2.key);
            }
            hasRenderableParent(e2) {
              const t2 = this.findLoadedParent(e2, 0);
              return !!t2 && this._isIdRenderable(t2.tileID.key);
            }
            _isIdRenderable(e2, t2, i2) {
              return this._tiles[e2] && this._tiles[e2].hasData() && !this._coveredTiles[e2] && (t2 || !this._tiles[e2].holdingForFade()) && (i2 || !this._shadowCasterTiles[e2]);
            }
            reload() {
              if (this._paused) this._shouldReloadOnResume = true;
              else {
                this._cache.reset();
                for (const e2 in this._tiles) "errored" !== this._tiles[e2].state && this._reloadTile(+e2, "reloading");
              }
            }
            _reloadTile(e2, t2) {
              const i2 = this._tiles[e2];
              i2 && ("loading" !== i2.state && (i2.state = t2), this._loadTile(i2, this._tileLoaded.bind(this, i2, e2, t2)));
            }
            _tileLoaded(t2, i2, o2, s2) {
              if (s2) if (t2.state = "errored", 404 !== s2.status) this._source.fire(new e.z(s2, { tile: t2 }));
              else {
                if (this._source.fire(new e.A("data", { dataType: "source", sourceDataType: "error", sourceId: this._source.id, tile: t2 })), !(t2.tileID.key in this._loadedParentTiles)) return;
                if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                  const e2 = this.map.painter.terrain;
                  this.update(this.transform, e2.getScaledDemTileSize(), true), e2.resetTileLookupCache(this.id);
                } else this.update(this.transform);
              }
              else t2.timeAdded = e.q.now(), "expired" === o2 && (t2.refreshedUponExpiration = true), this._setTileReloadTimer(i2, t2), "raster-dem" === this._source.type && t2.dem && this._backfillDEM(t2), this._state.initializeTileState(t2, this.map ? this.map.painter : null), this._source.fire(new e.A("data", { dataType: "source", tile: t2, coord: t2.tileID, sourceCacheId: this.id }));
            }
            _backfillDEM(e2) {
              const t2 = this.getRenderableIds();
              for (let o2 = 0; o2 < t2.length; o2++) {
                const s2 = t2[o2];
                if (e2.neighboringTiles && e2.neighboringTiles[s2]) {
                  const t3 = this.getTileByID(s2);
                  i2(e2, t3), i2(t3, e2);
                }
              }
              function i2(e3, t3) {
                if (!e3.dem || e3.dem.borderReady) return;
                e3.needsHillshadePrepare = true, e3.needsDEMTextureUpload = true;
                let i3 = t3.tileID.canonical.x - e3.tileID.canonical.x;
                const o2 = t3.tileID.canonical.y - e3.tileID.canonical.y, s2 = Math.pow(2, e3.tileID.canonical.z), r2 = t3.tileID.key;
                0 === i3 && 0 === o2 || Math.abs(o2) > 1 || (Math.abs(i3) > 1 && (1 === Math.abs(i3 + s2) ? i3 += s2 : 1 === Math.abs(i3 - s2) && (i3 -= s2)), t3.dem && e3.dem && (e3.dem.backfillBorder(t3.dem, i3, o2), e3.neighboringTiles && e3.neighboringTiles[r2] && (e3.neighboringTiles[r2].backfilled = true)));
              }
            }
            getTile(e2) {
              return this.getTileByID(e2.key);
            }
            getTileByID(e2) {
              return this._tiles[e2];
            }
            _retainLoadedChildren(e2, t2, i2, o2) {
              for (const s2 in this._tiles) {
                let r2 = this._tiles[s2];
                if (o2[s2] || !r2.hasData() || r2.tileID.overscaledZ <= t2 || r2.tileID.overscaledZ > i2) continue;
                let n2 = r2.tileID;
                for (; r2 && r2.tileID.overscaledZ > t2 + 1; ) {
                  const e3 = r2.tileID.scaledTo(r2.tileID.overscaledZ - 1);
                  r2 = this._tiles[e3.key], r2 && r2.hasData() && (n2 = e3);
                }
                let a2 = n2;
                for (; a2.overscaledZ > t2; ) if (a2 = a2.scaledTo(a2.overscaledZ - 1), e2[a2.key]) {
                  o2[n2.key] = n2;
                  break;
                }
              }
            }
            findLoadedParent(e2, t2) {
              if (e2.key in this._loadedParentTiles) {
                const i2 = this._loadedParentTiles[e2.key];
                return i2 && i2.tileID.overscaledZ >= t2 ? i2 : null;
              }
              for (let i2 = e2.overscaledZ - 1; i2 >= t2; i2--) {
                const t3 = e2.scaledTo(i2), o2 = this._getLoadedTile(t3);
                if (o2) return o2;
              }
            }
            _getLoadedTile(e2) {
              const t2 = this._tiles[e2.key];
              return t2 && t2.hasData() ? t2 : this._cache.getByKey(this._source.reparseOverscaled ? e2.wrapped().key : e2.canonical.key);
            }
            updateCacheSize(e2, t2) {
              t2 = t2 || this._source.tileSize;
              const i2 = Math.ceil(e2.width / t2) + 1, o2 = Math.ceil(e2.height / t2) + 1, s2 = Math.floor(i2 * o2 * 5), r2 = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, s2) : s2, n2 = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r2) : r2;
              this._cache.setMaxSize(n2);
            }
            handleWrapJump(e2) {
              const t2 = Math.round((e2 - (void 0 === this._prevLng ? e2 : this._prevLng)) / 360);
              if (this._prevLng = e2, t2) {
                const e3 = {};
                for (const i2 in this._tiles) {
                  const o2 = this._tiles[i2];
                  o2.tileID = o2.tileID.unwrapTo(o2.tileID.wrap + t2), e3[o2.tileID.key] = o2;
                }
                this._tiles = e3;
                for (const e4 in this._timers) clearTimeout(this._timers[e4]), delete this._timers[e4];
                for (const e4 in this._tiles) this._setTileReloadTimer(+e4, this._tiles[e4]);
              }
            }
            update(t2, i2, o2, s2, r2) {
              if (this.transform = t2, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
              if (this.usedForTerrain && !o2) return;
              this.updateCacheSize(t2, i2), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
              const n2 = "batched-model" === this._source.type;
              let a2, l2 = this._source.maxzoom;
              const c2 = this.map && this.map.painter ? this.map.painter._terrain : null;
              if (c2 && c2.sourceCache === this && c2.attenuationRange()) {
                const e2 = c2.attenuationRange()[0], t3 = Math.floor(e2) - Math.log2(c2.getDemUpscale());
                l2 > t3 && (l2 = t3);
              }
              if (this.used || this.usedForTerrain) {
                if (this._source.tileID) a2 = t2.getVisibleUnwrappedCoordinates(this._source.tileID).map((t3) => new e.aM(t3.canonical.z, t3.wrap, t3.canonical.z, t3.canonical.x, t3.canonical.y));
                else if (0 !== this.tileCoverLift) {
                  const s3 = t2.clone();
                  s3.tileCoverLift = this.tileCoverLift, a2 = s3.coveringTiles({ tileSize: i2 || this._source.tileSize, minzoom: this._source.minzoom, maxzoom: l2, roundZoom: this._source.roundZoom && !o2, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain, calculateQuadrantVisibility: n2 }), this._source.minzoom <= 1 && "globe" === t2.projection.name && (a2.push(new e.aM(1, 0, 1, 0, 0)), a2.push(new e.aM(1, 0, 1, 1, 0)), a2.push(new e.aM(1, 0, 1, 0, 1)), a2.push(new e.aM(1, 0, 1, 1, 1)));
                } else if (a2 = t2.coveringTiles({ tileSize: i2 || this._source.tileSize, minzoom: this._source.minzoom, maxzoom: l2, roundZoom: this._source.roundZoom && !o2, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain, calculateQuadrantVisibility: n2 }), this._source.hasTile) {
                  const e2 = this._source.hasTile.bind(this._source);
                  a2 = a2.filter((t3) => e2(t3));
                }
              } else a2 = [];
              if (a2.length > 0 && "globe" !== this.transform.projection.name && !this.usedForTerrain && !Rt(this._source.type)) {
                const e2 = t2.coveringZoomLevel({ tileSize: i2 || this._source.tileSize, roundZoom: this._source.roundZoom && !o2 }), l3 = Math.min(e2, this._source.maxzoom);
                if (n2) {
                  const e3 = t2.extendTileCover(a2, l3);
                  for (const t3 of e3) a2.push(t3);
                } else if (r2) {
                  const e3 = t2.extendTileCover(a2, l3, this.transform._camera.forward());
                  for (const t3 of e3) a2.push(t3);
                } else if (this.castsShadows && s2) {
                  const e3 = t2.extendTileCover(a2, l3, s2);
                  for (const t3 of e3) this._shadowCasterTiles[t3.key] = true, a2.push(t3);
                }
              }
              const h3 = this._updateRetainedTiles(a2);
              if (Rt(this._source.type) && 0 !== a2.length) {
                const t3 = {}, i3 = {}, o3 = Object.keys(h3);
                for (const s4 of o3) {
                  const o4 = h3[s4], r3 = this._tiles[s4];
                  if (!r3 || r3.fadeEndTime && r3.fadeEndTime <= e.q.now()) continue;
                  const n3 = this.findLoadedParent(o4, Math.max(o4.overscaledZ - It.maxOverzooming, this._source.minzoom));
                  n3 && (this._addTile(n3.tileID), t3[n3.tileID.key] = n3.tileID), i3[s4] = o4;
                }
                const s3 = a2[a2.length - 1].overscaledZ;
                for (const e2 in this._tiles) {
                  const t4 = this._tiles[e2];
                  if (h3[e2] || !t4.hasData()) continue;
                  let o4 = t4.tileID;
                  for (; o4.overscaledZ > s3; ) {
                    o4 = o4.scaledTo(o4.overscaledZ - 1);
                    const s4 = this._tiles[o4.key];
                    if (s4 && s4.hasData() && i3[o4.key]) {
                      h3[e2] = t4.tileID;
                      break;
                    }
                  }
                }
                for (const e2 in t3) h3[e2] || (this._coveredTiles[e2] = true, h3[e2] = t3[e2]);
              }
              for (const e2 in h3) this._tiles[e2].clearFadeHold();
              const d2 = e.bs(this._tiles, h3);
              for (const e2 of d2) {
                const t3 = this._tiles[e2];
                t3.hasSymbolBuckets && !t3.holdingForFade() ? t3.setHoldDuration(this.map._fadeDuration) : t3.hasSymbolBuckets && !t3.symbolFadeFinished() || this._removeTile(+e2);
              }
              this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
              for (const e2 in this._tiles) this._tiles[e2].holdingForFade() && this._removeTile(+e2);
            }
            _updateRetainedTiles(e2) {
              const t2 = {};
              if (0 === e2.length) return t2;
              const i2 = {}, o2 = e2.reduce((e3, t3) => Math.min(e3, t3.overscaledZ), 1 / 0), s2 = e2[0].overscaledZ, r2 = Math.max(s2 - It.maxOverzooming, this._source.minzoom), n2 = Math.max(s2 + It.maxUnderzooming, this._source.minzoom), a2 = {};
              for (const i3 of e2) {
                const e3 = this._addTile(i3);
                t2[i3.key] = i3, e3.hasData() || o2 < this._source.maxzoom && (a2[i3.key] = i3);
              }
              this._retainLoadedChildren(a2, o2, n2, t2);
              for (const o3 of e2) {
                let e3 = this._tiles[o3.key];
                if (e3.hasData()) continue;
                if (o3.canonical.z >= this._source.maxzoom) {
                  const e4 = o3.children(this._source.maxzoom)[0], i3 = this.getTile(e4);
                  if (i3 && i3.hasData()) {
                    t2[e4.key] = e4;
                    continue;
                  }
                } else {
                  const e4 = o3.children(this._source.maxzoom);
                  if (t2[e4[0].key] && t2[e4[1].key] && t2[e4[2].key] && t2[e4[3].key]) continue;
                }
                let s3 = e3.wasRequested();
                for (let n3 = o3.overscaledZ - 1; n3 >= r2; --n3) {
                  const r3 = o3.scaledTo(n3);
                  if (i2[r3.key]) break;
                  if (i2[r3.key] = true, e3 = this.getTile(r3), !e3 && s3 && (e3 = this._addTile(r3)), e3 && (t2[r3.key] = r3, s3 = e3.wasRequested(), e3.hasData())) break;
                }
              }
              return t2;
            }
            _updateLoadedParentTileCache() {
              this._loadedParentTiles = {};
              for (const e2 in this._tiles) {
                const t2 = [];
                let i2, o2 = this._tiles[e2].tileID;
                for (; o2.overscaledZ > 0; ) {
                  if (o2.key in this._loadedParentTiles) {
                    i2 = this._loadedParentTiles[o2.key];
                    break;
                  }
                  t2.push(o2.key);
                  const e3 = o2.scaledTo(o2.overscaledZ - 1);
                  if (i2 = this._getLoadedTile(e3), i2) break;
                  o2 = e3;
                }
                for (const e3 of t2) this._loadedParentTiles[e3] = i2;
              }
            }
            _addTile(t2) {
              let i2 = this._tiles[t2.key];
              if (i2) return true !== i2.isExtraShadowCaster || !!this._shadowCasterTiles[t2.key] || this._reloadTile(t2.key, "reloading"), i2;
              i2 = this._cache.getAndRemove(t2), i2 && (this._setTileReloadTimer(t2.key, i2), i2.tileID = t2, this._state.initializeTileState(i2, this.map ? this.map.painter : null), this._cacheTimers[t2.key] && (clearTimeout(this._cacheTimers[t2.key]), delete this._cacheTimers[t2.key], this._setTileReloadTimer(t2.key, i2)));
              const o2 = Boolean(i2);
              if (!o2) {
                const e2 = this.map ? this.map.painter : null, o3 = this._source.tileSize * t2.overscaleFactor();
                i2 = "raster-array" === this._source.type ? new Tt(t2, o3, this.transform.tileZoom, e2, this._isRaster) : new wt(t2, o3, this.transform.tileZoom, e2, this._isRaster, this._source.worldview), this._loadTile(i2, this._tileLoaded.bind(this, i2, t2.key, i2.state));
              }
              return i2.uses++, this._tiles[t2.key] = i2, o2 || this._source.fire(new e.A("dataloading", { tile: i2, coord: i2.tileID, dataType: "source" })), i2;
            }
            _setTileReloadTimer(e2, t2) {
              e2 in this._timers && (clearTimeout(this._timers[e2]), delete this._timers[e2]);
              const i2 = t2.getExpiryTimeout();
              i2 && (this._timers[e2] = setTimeout(() => {
                this._reloadTile(e2, "expired"), delete this._timers[e2];
              }, i2));
            }
            _removeTile(e2) {
              const t2 = this._tiles[e2];
              t2 && (t2.uses--, delete this._tiles[e2], this._timers[e2] && (clearTimeout(this._timers[e2]), delete this._timers[e2]), t2.uses > 0 || (t2.hasData() && "reloading" !== t2.state || "empty" === t2.state ? this._cache.add(t2.tileID, t2, t2.getExpiryTimeout()) : (t2.aborted = true, this._abortTile(t2), this._unloadTile(t2))));
            }
            clearTiles() {
              this._shouldReloadOnResume = false, this._paused = false;
              for (const e2 in this._tiles) this._removeTile(+e2);
              this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t2, i2, o2) {
              const s2 = [], r2 = this.transform;
              if (!r2) return s2;
              const n2 = "globe" === r2.projection.name, a2 = e.aD(r2.center.lng);
              for (const l2 in this._tiles) {
                const c2 = this._tiles[l2];
                if (o2 && c2.clearQueryDebugViz(), c2.holdingForFade()) continue;
                let h3;
                if (n2) {
                  const t3 = c2.tileID.canonical;
                  if (0 === t3.z) {
                    const i3 = [Math.abs(e.ay(a2, ...Dt(t3, -1)) - a2), Math.abs(e.ay(a2, ...Dt(t3, 1)) - a2)];
                    h3 = [0, 2 * i3.indexOf(Math.min(...i3)) - 1];
                  } else {
                    const i3 = [Math.abs(e.ay(a2, ...Dt(t3, -1)) - a2), Math.abs(e.ay(a2, ...Dt(t3, 0)) - a2), Math.abs(e.ay(a2, ...Dt(t3, 1)) - a2)];
                    h3 = [i3.indexOf(Math.min(...i3)) - 1];
                  }
                } else h3 = [0];
                for (const e2 of h3) {
                  const o3 = t2.containsTile(c2, r2, i2, e2);
                  o3 && s2.push(o3);
                }
              }
              return s2;
            }
            getShadowCasterCoordinates() {
              return this._getRenderableCoordinates(false, true);
            }
            getVisibleCoordinates(e2) {
              return this._getRenderableCoordinates(e2);
            }
            _getRenderableCoordinates(e2, t2) {
              const i2 = this.getRenderableIds(e2, t2).map((e3) => this._tiles[e3].tileID), o2 = "globe" === this.transform.projection.name;
              for (const e3 of i2) e3.projMatrix = this.transform.calculateProjMatrix(e3.toUnwrapped()), e3.expandedProjMatrix = o2 ? this.transform.calculateProjMatrix(e3.toUnwrapped(), false, true) : e3.projMatrix;
              return i2;
            }
            sortCoordinatesByDistance(e2) {
              const t2 = e2.slice(), i2 = this.transform._camera.position, o2 = this.transform._camera.forward(), s2 = {};
              for (const e3 of t2) {
                const t3 = 1 / (1 << e3.canonical.z);
                s2[e3.key] = ((e3.canonical.x + 0.5) * t3 + e3.wrap - i2[0]) * o2[0] + ((e3.canonical.y + 0.5) * t3 - i2[1]) * o2[1] - i2[2] * o2[2];
              }
              return t2.sort((e3, t3) => s2[e3.key] - s2[t3.key]), t2;
            }
            hasTransition() {
              if (this._source.hasTransition()) return true;
              if (Rt(this._source.type)) for (const t2 in this._tiles) {
                const i2 = this._tiles[t2];
                if (void 0 !== i2.fadeEndTime && i2.fadeEndTime >= e.q.now()) return true;
              }
              return false;
            }
            setFeatureState(e2, t2, i2) {
              this._state.updateState(e2 = e2 || "_geojsonTileLayer", t2, i2);
            }
            removeFeatureState(e2, t2, i2) {
              this._state.removeFeatureState(e2 = e2 || "_geojsonTileLayer", t2, i2);
            }
            getFeatureState(e2, t2) {
              return this._state.getState(e2 = e2 || "_geojsonTileLayer", t2);
            }
            setDependencies(e2, t2, i2) {
              const o2 = this._tiles[e2];
              o2 && o2.setDependencies(t2, i2);
            }
            reloadTilesForDependencies(e2, t2) {
              for (const i2 in this._tiles) this._tiles[i2].hasDependency(e2, t2) && this._reloadTile(+i2, "reloading");
              this._cache.filter((i2) => !i2.hasDependency(e2, t2));
            }
            _preloadTiles(t2, i2) {
              if (!this._sourceLoaded) {
                const e2 = () => {
                  this._sourceLoaded && (this._source.off("data", e2), this._preloadTiles(t2, i2));
                };
                return void this._source.on("data", e2);
              }
              const o2 = /* @__PURE__ */ new Map(), s2 = Array.isArray(t2) ? t2 : [t2], r2 = this.map.painter.terrain, n2 = this.usedForTerrain && r2 ? r2.getScaledDemTileSize() : this._source.tileSize;
              for (const e2 of s2) {
                const t3 = e2.coveringTiles({ tileSize: n2, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom && !this.usedForTerrain, reparseOverscaled: this._source.reparseOverscaled, isTerrainDEM: this.usedForTerrain });
                for (const e3 of t3) o2.set(e3.key, e3);
                this.usedForTerrain && e2.updateElevation(false);
              }
              const a2 = Array.from(o2.values());
              e.bt(a2, (e2, t3) => {
                const i3 = new wt(e2, this._source.tileSize * e2.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster, this._source.worldview);
                this._loadTile(i3, (e3) => {
                  "raster-dem" === this._source.type && i3.dem && this._backfillDEM(i3), t3(e3, i3);
                });
              }, i2);
            }
          }
          function Ct(e2, t2) {
            const i2 = Math.abs(2 * e2.wrap) - +(e2.wrap < 0), o2 = Math.abs(2 * t2.wrap) - +(t2.wrap < 0);
            return e2.overscaledZ - t2.overscaledZ || o2 - i2 || t2.canonical.y - e2.canonical.y || t2.canonical.x - e2.canonical.x;
          }
          function Rt(e2) {
            return "raster" === e2 || "image" === e2 || "video" === e2 || "custom" === e2;
          }
          function Dt(e2, t2) {
            const i2 = 1 << e2.z;
            return [e2.x / i2 + t2, (e2.x + 1) / i2 + t2];
          }
          It.maxOverzooming = 10, It.maxUnderzooming = 3;
          class At {
            constructor(e2) {
              this.style = e2, this.layersGotHidden = false, this.layers = [];
            }
            processLayersChanged() {
              this.layers = [];
              const e2 = false, t2 = false;
              for (const i2 in this.style._mergedLayers) {
                const o2 = this.style._mergedLayers[i2];
                if ("fill-extrusion" === o2.type || "building" === o2.type) this.layers.push({ layer: o2, visible: e2, visibilityChanged: t2 });
                else if ("model" === o2.type) {
                  const i3 = this.style.getLayerSource(o2);
                  i3 && "batched-model" === i3.type && this.layers.push({ layer: o2, visible: e2, visibilityChanged: t2 });
                }
              }
            }
            onNewFrame(e2) {
              this.layersGotHidden = false;
              for (const t2 of this.layers) {
                const i2 = t2.layer;
                let o2 = false;
                "fill-extrusion" === i2.type ? o2 = !i2.isHidden(e2) && i2.paint.get("fill-extrusion-opacity") > 0 : "building" === i2.type ? o2 = !i2.isHidden(e2) && i2.paint.get("building-opacity") > 0 : "model" === i2.type && (o2 = !i2.isHidden(e2) && i2.paint.get("model-opacity").constantOr(1) > 0), this.layersGotHidden = this.layersGotHidden || !o2 && t2.visible, t2.visible = o2;
              }
            }
            updateZOffset(e2, t2) {
              this.currentBuildingBuckets = [];
              for (const e3 of this.layers) {
                const i3 = e3.layer, o2 = this.style.getLayerSourceCache(i3);
                let s2 = 1;
                "fill-extrusion" === i3.type ? s2 = e3.visible ? i3.paint.get("fill-extrusion-vertical-scale") : 0 : "building" === i3.type && (s2 = e3.visible ? i3.paint.get("building-vertical-scale") : 0);
                let r2 = o2 ? o2.getTile(t2) : null;
                if (!r2 && o2 && t2.canonical.z > o2.getSource().minzoom) {
                  let e4 = t2.scaledTo(Math.min(o2.getSource().maxzoom, t2.overscaledZ - 1));
                  for (; e4.overscaledZ >= o2.getSource().minzoom && (r2 = o2.getTile(e4), !r2 && 0 !== e4.overscaledZ); ) e4 = e4.scaledTo(e4.overscaledZ - 1);
                }
                this.currentBuildingBuckets.push({ bucket: r2 ? r2.getBucket(i3) : null, tileID: r2 ? r2.tileID : t2, verticalScale: s2 });
              }
              e2.hasAnyZOffset = false;
              let i2 = false;
              for (let o2 = 0; o2 < e2.symbolInstances.length; o2++) {
                const s2 = e2.symbolInstances.get(o2), r2 = s2.zOffset, n2 = this._getHeightAtTileOffset(t2, s2.tileAnchorX, s2.tileAnchorY);
                s2.zOffset = n2 !== Number.NEGATIVE_INFINITY ? n2 : r2, i2 || r2 === s2.zOffset || (i2 = true), e2.hasAnyZOffset || 0 === s2.zOffset || (e2.hasAnyZOffset = true);
              }
              i2 && (e2.zOffsetBuffersNeedUpload = true, e2.zOffsetSortDirty = true);
            }
            _mapCoordToOverlappingTile(t2, i2, o2, s2) {
              let r2 = i2, n2 = o2;
              if (t2.canonical.z !== s2.canonical.z) {
                const a2 = s2.canonical, l2 = 1 / (1 << t2.canonical.z - a2.z);
                r2 = (i2 + t2.canonical.x * e.aj) * l2 - a2.x * e.aj | 0, n2 = (o2 + t2.canonical.y * e.aj) * l2 - a2.y * e.aj | 0;
              }
              return { tileX: r2, tileY: n2 };
            }
            _getHeightAtTileOffset(e2, t2, i2) {
              let o2, s2;
              for (let r2 = 0; r2 < this.layers.length; ++r2) {
                const n2 = this.layers[r2].layer;
                if ("fill-extrusion" !== n2.type && "building" !== n2.type) continue;
                const { bucket: a2, tileID: l2, verticalScale: c2 } = this.currentBuildingBuckets[r2];
                if (!a2) continue;
                const { tileX: h3, tileY: d2 } = this._mapCoordToOverlappingTile(e2, t2, i2, l2), u2 = a2.getHeightAtTileCoord(h3, d2);
                u2 && void 0 !== u2.height && (u2.hidden ? o2 = u2.height : s2 = Math.max(u2.height * c2, s2 || 0));
              }
              if (void 0 !== s2) return s2;
              for (let s3 = 0; s3 < this.layers.length; ++s3) {
                const r2 = this.layers[s3];
                if ("model" !== r2.layer.type || !r2.visible) continue;
                const { bucket: n2, tileID: a2 } = this.currentBuildingBuckets[s3];
                if (!n2) continue;
                const { tileX: l2, tileY: c2 } = this._mapCoordToOverlappingTile(e2, t2, i2, a2), h3 = n2.getHeightAtTileCoord(l2, c2);
                if (h3 && !h3.hidden) return void 0 === h3.height && void 0 !== o2 ? Math.min(h3.maxHeight, o2) * h3.verticalScale : h3.height ? h3.height * h3.verticalScale : Number.NEGATIVE_INFINITY;
              }
              return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
            }
          }
          function Lt(t2, i2) {
            const o2 = {};
            for (const e2 in t2) "ref" !== e2 && (o2[e2] = t2[e2]);
            return e.bu.forEach((e2) => {
              e2 in i2 && (o2[e2] = i2[e2]);
            }), o2;
          }
          function Pt(e2) {
            e2 = e2.slice();
            const t2 = /* @__PURE__ */ Object.create(null);
            for (let i2 = 0; i2 < e2.length; i2++) t2[e2[i2].id] = e2[i2];
            for (let i2 = 0; i2 < e2.length; i2++) "ref" in e2[i2] && (e2[i2] = Lt(e2[i2], t2[e2[i2].ref]));
            return e2;
          }
          const zt = { setStyle: "setStyle", addLayer: "addLayer", removeLayer: "removeLayer", setPaintProperty: "setPaintProperty", setLayoutProperty: "setLayoutProperty", setSlot: "setSlot", setFilter: "setFilter", addSource: "addSource", removeSource: "removeSource", setGeoJSONSourceData: "setGeoJSONSourceData", setLayerZoomRange: "setLayerZoomRange", setLayerProperty: "setLayerProperty", setCenter: "setCenter", setZoom: "setZoom", setBearing: "setBearing", setPitch: "setPitch", setSprite: "setSprite", setGlyphs: "setGlyphs", setTransition: "setTransition", setLight: "setLight", setTerrain: "setTerrain", setFog: "setFog", setSnow: "setSnow", setRain: "setRain", setCamera: "setCamera", setLights: "setLights", setProjection: "setProjection", addImport: "addImport", removeImport: "removeImport", updateImport: "updateImport", addIconset: "addIconset", removeIconset: "removeIconset" };
          function Mt(e2, t2, i2) {
            i2.push({ command: zt.addSource, args: [e2, t2[e2]] });
          }
          function Ot(e2, t2, i2) {
            t2.push({ command: zt.removeSource, args: [e2] }), i2[e2] = true;
          }
          function Ft(e2, t2, i2, o2) {
            Ot(e2, i2, o2), Mt(e2, t2, i2);
          }
          function Bt(t2, i2, o2) {
            let s2;
            for (s2 in t2[o2]) if (t2[o2].hasOwnProperty(s2) && "data" !== s2 && !e.bv(t2[o2][s2], i2[o2][s2])) return false;
            for (s2 in i2[o2]) if (i2[o2].hasOwnProperty(s2) && "data" !== s2 && !e.bv(t2[o2][s2], i2[o2][s2])) return false;
            return true;
          }
          function kt(t2, i2, o2, s2, r2, n2) {
            let a2;
            for (a2 in i2 = i2 || {}, t2 = t2 || {}) t2.hasOwnProperty(a2) && (e.bv(t2[a2], i2[a2]) || o2.push({ command: n2, args: [s2, a2, i2[a2], r2] }));
            for (a2 in i2) i2.hasOwnProperty(a2) && !t2.hasOwnProperty(a2) && (e.bv(t2[a2], i2[a2]) || o2.push({ command: n2, args: [s2, a2, i2[a2], r2] }));
          }
          function Nt(e2) {
            return e2.id;
          }
          function Ut(e2, t2) {
            return e2[t2.id] = t2, e2;
          }
          class jt {
            constructor(e2, t2) {
              this.reset(e2, t2);
            }
            reset(e2, t2) {
              this.points = e2 || [], this._distances = [0];
              for (let e3 = 1; e3 < this.points.length; e3++) this._distances[e3] = this._distances[e3 - 1] + this.points[e3].dist(this.points[e3 - 1]);
              this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t2 || 0, 0.5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t2) {
              if (1 === this.points.length) return this.points[0];
              t2 = e.ay(t2, 0, 1);
              let i2 = 1, o2 = this._distances[i2];
              const s2 = t2 * this.paddedLength + this.padding;
              for (; o2 < s2 && i2 < this._distances.length; ) o2 = this._distances[++i2];
              const r2 = i2 - 1, n2 = this._distances[r2], a2 = o2 - n2, l2 = a2 > 0 ? (s2 - n2) / a2 : 0;
              return this.points[r2].mult(1 - l2).add(this.points[i2].mult(l2));
            }
          }
          class Vt {
            constructor(e2, t2, i2) {
              const o2 = this.boxCells = [], s2 = this.circleCells = [];
              this.xCellCount = Math.ceil(e2 / i2), this.yCellCount = Math.ceil(t2 / i2);
              for (let e3 = 0; e3 < this.xCellCount * this.yCellCount; e3++) o2.push([]), s2.push([]);
              this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e2, this.height = t2, this.xScale = this.xCellCount / e2, this.yScale = this.yCellCount / t2, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
              return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e2, t2, i2, o2, s2) {
              this._forEachCell(t2, i2, o2, s2, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e2), this.bboxes.push(t2), this.bboxes.push(i2), this.bboxes.push(o2), this.bboxes.push(s2);
            }
            insertCircle(e2, t2, i2, o2) {
              this._forEachCell(t2 - o2, i2 - o2, t2 + o2, i2 + o2, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e2), this.circles.push(t2), this.circles.push(i2), this.circles.push(o2);
            }
            _insertBoxCell(e2, t2, i2, o2, s2, r2) {
              this.boxCells[s2].push(r2);
            }
            _insertCircleCell(e2, t2, i2, o2, s2, r2) {
              this.circleCells[s2].push(r2);
            }
            _query(e2, t2, i2, o2, s2, r2) {
              if (i2 < 0 || e2 > this.width || o2 < 0 || t2 > this.height) return !s2 && [];
              const n2 = [];
              if (e2 <= 0 && t2 <= 0 && this.width <= i2 && this.height <= o2) {
                if (s2) return true;
                for (let e3 = 0; e3 < this.boxKeys.length; e3++) n2.push({ key: this.boxKeys[e3], x1: this.bboxes[4 * e3], y1: this.bboxes[4 * e3 + 1], x2: this.bboxes[4 * e3 + 2], y2: this.bboxes[4 * e3 + 3] });
                for (let e3 = 0; e3 < this.circleKeys.length; e3++) {
                  const t3 = this.circles[3 * e3], i3 = this.circles[3 * e3 + 1], o3 = this.circles[3 * e3 + 2];
                  n2.push({ key: this.circleKeys[e3], x1: t3 - o3, y1: i3 - o3, x2: t3 + o3, y2: i3 + o3 });
                }
                return r2 ? n2.filter(r2) : n2;
              }
              return this._forEachCell(e2, t2, i2, o2, this._queryCell, n2, { hitTest: s2, seenUids: { box: {}, circle: {} } }, r2), s2 ? n2.length > 0 : n2;
            }
            _queryCircle(e2, t2, i2, o2, s2) {
              const r2 = e2 - i2, n2 = e2 + i2, a2 = t2 - i2, l2 = t2 + i2;
              if (n2 < 0 || r2 > this.width || l2 < 0 || a2 > this.height) return !o2 && [];
              const c2 = [];
              return this._forEachCell(r2, a2, n2, l2, this._queryCellCircle, c2, { hitTest: o2, circle: { x: e2, y: t2, radius: i2 }, seenUids: { box: {}, circle: {} } }, s2), o2 ? c2.length > 0 : c2;
            }
            query(e2, t2, i2, o2, s2) {
              return this._query(e2, t2, i2, o2, false, s2);
            }
            hitTest(e2, t2, i2, o2, s2) {
              return this._query(e2, t2, i2, o2, true, s2);
            }
            hitTestCircle(e2, t2, i2, o2) {
              return this._queryCircle(e2, t2, i2, true, o2);
            }
            _queryCell(e2, t2, i2, o2, s2, r2, n2, a2) {
              const l2 = n2.seenUids, c2 = this.boxCells[s2];
              if (null !== c2) {
                const s3 = this.bboxes;
                for (const h4 of c2) if (!l2.box[h4]) {
                  l2.box[h4] = true;
                  const c3 = 4 * h4;
                  if (e2 <= s3[c3 + 2] && t2 <= s3[c3 + 3] && i2 >= s3[c3 + 0] && o2 >= s3[c3 + 1] && (!a2 || a2(this.boxKeys[h4]))) {
                    if (n2.hitTest) return r2.push(true), true;
                    r2.push({ key: this.boxKeys[h4], x1: s3[c3], y1: s3[c3 + 1], x2: s3[c3 + 2], y2: s3[c3 + 3] });
                  }
                }
              }
              const h3 = this.circleCells[s2];
              if (null !== h3) {
                const s3 = this.circles;
                for (const c3 of h3) if (!l2.circle[c3]) {
                  l2.circle[c3] = true;
                  const h4 = 3 * c3;
                  if (this._circleAndRectCollide(s3[h4], s3[h4 + 1], s3[h4 + 2], e2, t2, i2, o2) && (!a2 || a2(this.circleKeys[c3]))) {
                    if (n2.hitTest) return r2.push(true), true;
                    {
                      const e3 = s3[h4], t3 = s3[h4 + 1], i3 = s3[h4 + 2];
                      r2.push({ key: this.circleKeys[c3], x1: e3 - i3, y1: t3 - i3, x2: e3 + i3, y2: t3 + i3 });
                    }
                  }
                }
              }
            }
            _queryCellCircle(e2, t2, i2, o2, s2, r2, n2, a2) {
              const l2 = n2.circle, c2 = n2.seenUids, h3 = this.boxCells[s2];
              if (null !== h3) {
                const e3 = this.bboxes;
                for (const t3 of h3) if (!c2.box[t3]) {
                  c2.box[t3] = true;
                  const i3 = 4 * t3;
                  if (this._circleAndRectCollide(l2.x, l2.y, l2.radius, e3[i3 + 0], e3[i3 + 1], e3[i3 + 2], e3[i3 + 3]) && (!a2 || a2(this.boxKeys[t3]))) return r2.push(true), true;
                }
              }
              const d2 = this.circleCells[s2];
              if (null !== d2) {
                const e3 = this.circles;
                for (const t3 of d2) if (!c2.circle[t3]) {
                  c2.circle[t3] = true;
                  const i3 = 3 * t3;
                  if (this._circlesCollide(e3[i3], e3[i3 + 1], e3[i3 + 2], l2.x, l2.y, l2.radius) && (!a2 || a2(this.circleKeys[t3]))) return r2.push(true), true;
                }
              }
            }
            _forEachCell(e2, t2, i2, o2, s2, r2, n2, a2) {
              const l2 = this._convertToXCellCoord(e2), c2 = this._convertToYCellCoord(t2), h3 = this._convertToXCellCoord(i2), d2 = this._convertToYCellCoord(o2);
              for (let u2 = l2; u2 <= h3; u2++) for (let l3 = c2; l3 <= d2; l3++) if (s2.call(this, e2, t2, i2, o2, this.xCellCount * l3 + u2, r2, n2, a2)) return;
            }
            _convertToXCellCoord(e2) {
              return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e2 * this.xScale)));
            }
            _convertToYCellCoord(e2) {
              return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e2 * this.yScale)));
            }
            _circlesCollide(e2, t2, i2, o2, s2, r2) {
              const n2 = o2 - e2, a2 = s2 - t2, l2 = i2 + r2;
              return l2 * l2 > n2 * n2 + a2 * a2;
            }
            _circleAndRectCollide(e2, t2, i2, o2, s2, r2, n2) {
              const a2 = (r2 - o2) / 2, l2 = Math.abs(e2 - (o2 + a2));
              if (l2 > a2 + i2) return false;
              const c2 = (n2 - s2) / 2, h3 = Math.abs(t2 - (s2 + c2));
              if (h3 > c2 + i2) return false;
              if (l2 <= a2 || h3 <= c2) return true;
              const d2 = l2 - a2, u2 = h3 - c2;
              return d2 * d2 + u2 * u2 <= i2 * i2;
            }
          }
          const Gt = { unknown: 0, flipRequired: 1, flipNotRequired: 2 }, qt = Math.tan(85 * Math.PI / 180);
          function Zt(t2, i2, o2, s2, r2, n2, a2) {
            const l2 = e.bz();
            if (o2) if ("globe" === n2.name) {
              const t3 = e.bA(r2, i2);
              e.az(l2, l2, t3);
            } else {
              const t3 = e.bB([], a2);
              l2[0] = t3[0], l2[1] = t3[1], l2[4] = t3[2], l2[5] = t3[3], s2 || e.by(l2, l2, r2.angle);
            }
            else e.az(l2, r2.labelPlaneMatrix, t2);
            return l2;
          }
          function Ht(e2, t2, i2, o2, s2, r2, n2) {
            const a2 = Zt(e2, t2, i2, o2, s2, r2, n2);
            return "globe" === r2.name && i2 || (a2[2] = a2[6] = a2[10] = a2[14] = 0), a2;
          }
          function Wt(t2, i2, o2, s2, r2, n2, a2) {
            if (o2) {
              if ("globe" === n2.name) {
                const l2 = Zt(t2, i2, o2, s2, r2, n2, a2);
                return e.bi(l2, l2), e.az(l2, t2, l2), l2;
              }
              {
                const i3 = e.bw(t2), o3 = e.bx([]);
                return o3[0] = a2[0], o3[1] = a2[1], o3[4] = a2[2], o3[5] = a2[3], e.az(i3, i3, o3), s2 || e.by(i3, i3, -r2.angle), i3;
              }
            }
            return r2.glCoordMatrix;
          }
          function $t(t2, i2, o2, s2) {
            const r2 = [t2, i2, o2, 1];
            o2 ? e.aA(r2, r2, s2) : ri(r2, r2, s2);
            const n2 = r2[3];
            return r2[0] /= n2, r2[1] /= n2, r2[2] /= n2, r2;
          }
          function Xt(e2, t2) {
            return Math.min(0.5 + e2 / t2 * 0.5, 1.5);
          }
          function Yt(e2, t2) {
            const i2 = e2[0] / e2[3], o2 = e2[1] / e2[3];
            return i2 >= -t2[0] && i2 <= t2[0] && o2 >= -t2[1] && o2 <= t2[1];
          }
          function Kt(t2, i2, o2, s2, r2, n2, a2, l2, c2, h3) {
            const d2 = o2.transform, u2 = s2 ? t2.textSizeData : t2.iconSizeData, _2 = e.bH(u2, o2.transform.zoom), p3 = "globe" === d2.projection.name, f2 = [256 / o2.width * 2 + 1, 256 / o2.height * 2 + 1], m2 = s2 ? t2.text.dynamicLayoutVertexArray : t2.icon.dynamicLayoutVertexArray;
            m2.clear();
            let g2 = null;
            p3 && (g2 = s2 ? t2.text.globeExtVertexArray : t2.icon.globeExtVertexArray);
            const v2 = t2.lineVertexArray, y2 = s2 ? t2.text.placedSymbolArray : t2.icon.placedSymbolArray, x2 = o2.transform.width / o2.transform.height;
            let b2, w2 = false;
            for (let s3 = 0; s3 < y2.length; s3++) {
              const p4 = y2.get(s3), { numGlyphs: T2, writingMode: E2 } = p4;
              if (E2 !== e.bI.vertical || w2 || b2 === e.bI.horizontal || (w2 = true), b2 = E2, (p4.hidden || E2 === e.bI.vertical) && !w2) {
                si(T2, m2);
                continue;
              }
              w2 = false;
              const S2 = new e.P(p4.tileAnchorX, p4.tileAnchorY);
              let { x: I2, y: C2, z: R2 } = d2.projection.projectTilePoint(S2.x, S2.y, h3.canonical);
              if (c2) {
                const [e2, t3, i3] = c2(S2);
                I2 += e2, C2 += t3, R2 += i3;
              }
              const D2 = [I2, C2, R2, 1];
              if (e.aA(D2, D2, i2), !Yt(D2, f2)) {
                si(T2, m2);
                continue;
              }
              const A2 = D2[3], L2 = Xt(o2.transform.getCameraToCenterDistance(d2.projection), A2), P2 = e.bJ(u2, _2, p4), z2 = a2 ? P2 / L2 : P2 * L2, M2 = $t(I2, C2, R2, r2);
              if (M2[3] <= 0) {
                si(T2, m2);
                continue;
              }
              let O2 = {};
              const F2 = e.al(t2.layers[0].layout.get("text-max-angle")), B2 = Math.cos(F2), k2 = a2 ? null : c2, N2 = ei(p4, z2, false, l2, i2, r2, n2, t2.glyphOffsetArray, v2, m2, g2, M2, S2, O2, x2, k2, d2.projection, h3, a2, B2);
              w2 = N2.useVertical, k2 && N2.needsFlipping && (O2 = {}), (N2.notEnoughRoom || w2 || N2.needsFlipping && ei(p4, z2, true, l2, i2, r2, n2, t2.glyphOffsetArray, v2, m2, g2, M2, S2, O2, x2, k2, d2.projection, h3, a2, B2).notEnoughRoom) && si(T2, m2);
            }
            s2 ? (t2.text.dynamicLayoutVertexBuffer.updateData(m2), g2 && t2.text.globeExtVertexBuffer && t2.text.globeExtVertexBuffer.updateData(g2)) : (t2.icon.dynamicLayoutVertexBuffer.updateData(m2), g2 && t2.icon.globeExtVertexBuffer && t2.icon.globeExtVertexBuffer.updateData(g2));
          }
          function Jt(e2, t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2, m2) {
            const { lineStartIndex: g2, glyphStartIndex: v2, segment: y2 } = a2, x2 = v2 + a2.numGlyphs, b2 = g2 + a2.lineLength, w2 = t2.getoffsetX(v2), T2 = t2.getoffsetX(x2 - 1), E2 = oi(e2 * w2, i2, o2, s2, r2, n2, y2, g2, b2, l2, c2, h3, d2, u2, true, _2, p3, f2, m2);
            if (!E2) return null;
            const S2 = oi(e2 * T2, i2, o2, s2, r2, n2, y2, g2, b2, l2, c2, h3, d2, u2, true, _2, p3, f2, m2);
            return S2 ? { first: E2, last: S2 } : null;
          }
          function Qt(t2, i2, o2, s2) {
            return t2 === e.bI.horizontal && Math.abs(s2) > Math.abs(o2) ? { useVertical: true } : t2 === e.bI.vertical ? s2 > 0 ? { needsFlipping: true } : null : i2 !== Gt.unknown && function(e2, t3) {
              return 0 === e2 || Math.abs(t3 / e2) > qt;
            }(o2, s2) ? i2 === Gt.flipRequired ? { needsFlipping: true } : null : o2 < 0 ? { needsFlipping: true } : null;
          }
          function ei(t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2, m2, g2, v2, y2, x2) {
            const b2 = i2 / 24, w2 = t2.lineOffsetX * b2, T2 = t2.lineOffsetY * b2, { lineStartIndex: E2, glyphStartIndex: S2, numGlyphs: I2, segment: C2, writingMode: R2, flipState: D2 } = t2, A2 = E2 + t2.lineLength, L2 = (t3) => {
              if (d2) {
                const [i4, o4, s4] = t3.up, r3 = h3.length;
                e.bK(d2, r3 + 0, i4, o4, s4), e.bK(d2, r3 + 1, i4, o4, s4), e.bK(d2, r3 + 2, i4, o4, s4), e.bK(d2, r3 + 3, i4, o4, s4);
              }
              const [i3, o3, s3] = t3.point;
              e.bL(h3, i3, o3, s3, t3.angle);
            };
            if (I2 > 1) {
              const e2 = Jt(b2, l2, w2, T2, o2, u2, _2, t2, c2, n2, p3, m2, false, g2, v2, y2, x2);
              if (!e2) return { notEnoughRoom: true };
              if (s2 && !o2) {
                let [i3, o3, s3] = e2.first.point, [r3, n3, l3] = e2.last.point;
                [i3, o3] = $t(i3, o3, s3, a2), [r3, n3] = $t(r3, n3, l3, a2);
                const c3 = Qt(R2, D2, (r3 - i3) * f2, n3 - o3);
                if (t2.flipState = c3 && c3.needsFlipping ? Gt.flipRequired : Gt.flipNotRequired, c3) return c3;
              }
              L2(e2.first);
              for (let e3 = S2 + 1; e3 < S2 + I2 - 1; e3++) {
                const t3 = oi(b2 * l2.getoffsetX(e3), w2, T2, o2, u2, _2, C2, E2, A2, c2, n2, p3, m2, false, false, g2, v2, y2, x2);
                if (!t3) return h3.length -= 4 * (e3 - S2), { notEnoughRoom: true };
                L2(t3);
              }
              L2(e2.last);
            } else {
              if (s2 && !o2) {
                const i4 = $t(_2.x, _2.y, 0, r2), o3 = E2 + C2 + 1, s3 = new e.P(c2.getx(o3), c2.gety(o3)), n3 = $t(s3.x, s3.y, 0, r2), a3 = n3[3] > 0 ? n3 : ii(_2, s3, i4, 1, r2, void 0, g2, v2.canonical), l3 = Qt(R2, D2, (a3[0] - i4[0]) * f2, a3[1] - i4[1]);
                if (t2.flipState = l3 && l3.needsFlipping ? Gt.flipRequired : Gt.flipNotRequired, l3) return l3;
              }
              const i3 = oi(b2 * l2.getoffsetX(S2), w2, T2, o2, u2, _2, C2, E2, A2, c2, n2, p3, m2, false, false, g2, v2, y2, x2);
              if (!i3) return { notEnoughRoom: true };
              L2(i3);
            }
            return {};
          }
          function ti(e2, t2, i2, o2, s2) {
            const { x: r2, y: n2, z: a2 } = o2.projectTilePoint(e2.x, e2.y, t2);
            if (!s2) return $t(r2, n2, a2, i2);
            const [l2, c2, h3] = s2(e2);
            return $t(r2 + l2, n2 + c2, a2 + h3, i2);
          }
          function ii(t2, i2, o2, s2, r2, n2, a2, l2) {
            const c2 = ti(t2.sub(i2)._unit()._add(t2), l2, r2, a2, n2);
            return e.at(c2, o2, c2), e.au(c2, c2), e.bE(c2, o2, c2, s2);
          }
          function oi(t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2, m2, g2, v2, y2) {
            const x2 = s2 ? t2 - i2 : t2 + i2;
            let b2 = x2 > 0 ? 1 : -1, w2 = 0;
            s2 && (b2 *= -1, w2 = Math.PI), b2 < 0 && (w2 += Math.PI);
            let T2 = l2 + a2 + (b2 > 0 ? 0 : 1) | 0, E2 = r2, S2 = r2, I2 = 0, C2 = 0;
            const R2 = Math.abs(x2), D2 = [], A2 = [];
            let L2 = n2, P2 = L2, z2 = e.bC([]);
            const M2 = () => ii(P2, L2, S2, R2 - I2 + 1, d2, _2, m2, g2.canonical);
            for (; I2 + C2 <= R2; ) {
              if (T2 += b2, T2 < l2 || T2 >= c2) return null;
              if (S2 = E2, P2 = L2, D2.push(S2), p3 && A2.push(P2), L2 = new e.P(h3.getx(T2), h3.gety(T2)), E2 = u2[T2], !E2) {
                const e2 = ti(L2, g2.canonical, d2, m2, _2);
                E2 = e2[3] > 0 ? u2[T2] = e2 : M2();
              }
              I2 += C2;
              const t3 = e.at([], E2, S2), i3 = e.bD(S2, E2);
              if (o2 && i3 > 0 && C2 > 0 && e.bG(z2, t3) / (C2 * i3) < y2) return null;
              C2 = i3, z2 = t3;
            }
            f2 && _2 && (u2[T2] && (E2 = M2(), C2 = e.bD(S2, E2), z2 = e.at([], E2, S2)), u2[T2] = E2);
            const O2 = (R2 - I2) / C2, F2 = L2.sub(P2)._mult(O2)._add(P2), B2 = e.bE([], S2, z2, O2);
            let k2 = [0, 0, 1], N2 = z2[0], U2 = z2[1];
            if (v2 && (k2 = m2.upVector(g2.canonical, F2.x, F2.y), 0 !== k2[0] || 0 !== k2[1] || 1 !== k2[2])) {
              const t3 = [k2[2], 0, -k2[0]], i3 = e.bF([], k2, t3);
              e.au(t3, t3), e.au(i3, i3), N2 = e.bG(z2, t3), U2 = e.bG(z2, i3);
            }
            if (o2) {
              const t3 = e.bF([], k2, z2);
              e.au(t3, t3), e.bE(B2, B2, t3, o2 * b2);
            }
            const j2 = w2 + Math.atan2(U2, N2);
            return D2.push(B2), p3 && A2.push(F2), { point: B2, angle: j2, path: D2, tilePath: A2, up: k2 };
          }
          function si(e2, t2) {
            const i2 = t2.length, o2 = i2 + 4 * e2;
            t2.resize(o2), t2.float32.fill(-1 / 0, 4 * i2, 4 * o2);
          }
          function ri(e2, t2, i2) {
            const o2 = t2[0], s2 = t2[1];
            return e2[0] = i2[0] * o2 + i2[4] * s2 + i2[12], e2[1] = i2[1] * o2 + i2[5] * s2 + i2[13], e2[3] = i2[3] * o2 + i2[7] * s2 + i2[15], e2;
          }
          const ni = 100;
          class ai {
            constructor(e2, t2, i2 = new Vt(e2.width + 200, e2.height + 200, 25), o2 = new Vt(e2.width + 200, e2.height + 200, 25)) {
              this.transform = e2, this.grid = i2, this.ignoredGrid = o2, this.pitchfactor = Math.cos(e2._pitch) * e2.cameraToCenterDistance, this.screenRightBoundary = e2.width + ni, this.screenBottomBoundary = e2.height + ni, this.gridRightBoundary = e2.width + 200, this.gridBottomBoundary = e2.height + 200, this.fogState = t2;
            }
            placeCollisionBox(e2, t2, i2, o2, s2, r2, n2, a2) {
              let l2 = i2.projectedAnchorX, c2 = i2.projectedAnchorY, h3 = i2.projectedAnchorZ;
              const d2 = i2.elevation, u2 = i2.tileID, _2 = e2.getProjection();
              if (d2 && u2) {
                const [e3, t3, o3] = _2.upVector(u2.canonical, i2.tileAnchorX, i2.tileAnchorY), s3 = _2.upVectorScale(u2.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                l2 += e3 * d2 * s3, c2 += t3 * d2 * s3, h3 += o3 * d2 * s3;
              }
              const p3 = this.projectAndGetPerspectiveRatio(n2, l2, c2, h3, i2.tileID, "globe" === _2.name || !!d2 || this.transform.pitch > 0, _2), f2 = r2 * p3.perspectiveRatio, m2 = (i2.x1 * t2 + o2.x - i2.padding) * f2 + p3.point.x, g2 = (i2.y1 * t2 + o2.y - i2.padding) * f2 + p3.point.y, v2 = (i2.x2 * t2 + o2.x + i2.padding) * f2 + p3.point.x, y2 = (i2.y2 * t2 + o2.y + i2.padding) * f2 + p3.point.y, x2 = p3.perspectiveRatio <= 0.55 || p3.occluded;
              return !this.isInsideGrid(m2, g2, v2, y2) || !s2 && this.grid.hitTest(m2, g2, v2, y2, a2) || x2 ? { box: [], offscreen: false, occluded: p3.occluded } : { box: [m2, g2, v2, y2], offscreen: this.isOffscreen(m2, g2, v2, y2), occluded: false };
            }
            placeCollisionCircles(t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2) {
              const m2 = [], g2 = this.transform.elevation, v2 = t2.getProjection(), y2 = g2 ? g2.getAtTileOffsetFunc(f2, this.transform.center.lat, this.transform.worldSize, v2) : null, x2 = new e.P(o2.tileAnchorX, o2.tileAnchorY);
              let { x: b2, y: w2, z: T2 } = v2.projectTilePoint(x2.x, x2.y, f2.canonical);
              if (y2) {
                const [e2, t3, i3] = y2(x2);
                b2 += e2, w2 += t3, T2 += i3;
              }
              const E2 = "globe" === v2.name, S2 = this.projectAndGetPerspectiveRatio(a2, b2, w2, T2, f2, E2 || !!g2 || this.transform.pitch > 0, v2), { perspectiveRatio: I2 } = S2, C2 = (d2 ? n2 / I2 : n2 * I2) / e.bO, R2 = $t(b2, w2, T2, l2), D2 = o2.lineOffsetX * C2, A2 = o2.lineOffsetY * C2, L2 = e.al(t2.layers[0].layout.get("text-max-angle")), P2 = Math.cos(L2), z2 = S2.signedDistanceFromCamera > 0 ? Jt(C2, r2, D2, A2, false, R2, x2, o2, s2, l2, {}, g2 && !d2 ? y2 : null, d2 && !!g2, v2, f2, d2, P2) : null;
              let M2 = false, O2 = false, F2 = true;
              if (z2 && !S2.occluded) {
                const t3 = 0.5 * _2 * I2 + p3, o3 = new e.P(-100, -100), s3 = new e.P(this.screenRightBoundary, this.screenBottomBoundary), r3 = new jt(), { first: n3, last: a3 } = z2, l3 = n3.path.length;
                let d3 = [];
                for (let e2 = l3 - 1; e2 >= 1; e2--) d3.push(n3.path[e2]);
                for (let e2 = 1; e2 < a3.path.length; e2++) d3.push(a3.path[e2]);
                const f3 = 2.5 * t3;
                c2 && (d3 = d3.map(([e2, t4, i3], o4) => (y2 && !E2 && (i3 = y2(o4 < l3 - 1 ? n3.tilePath[l3 - 1 - o4] : a3.tilePath[o4 - l3 + 2])[2]), $t(e2, t4, i3, c2))), d3.some((e2) => e2[3] <= 0) && (d3 = []));
                let g3 = [];
                if (d3.length > 0) {
                  let t4 = 1 / 0, i3 = -1 / 0, r4 = 1 / 0, n4 = -1 / 0;
                  for (const e2 of d3) t4 = Math.min(t4, e2[0]), r4 = Math.min(r4, e2[1]), i3 = Math.max(i3, e2[0]), n4 = Math.max(n4, e2[1]);
                  i3 >= o3.x && t4 <= s3.x && n4 >= o3.y && r4 <= s3.y && (g3 = [d3.map((t5) => new e.P(t5[0], t5[1]))], (t4 < o3.x || i3 > s3.x || r4 < o3.y || n4 > s3.y) && (g3 = e.bM(g3, o3.x, o3.y, s3.x, s3.y)));
                }
                for (const e2 of g3) {
                  r3.reset(e2, 0.25 * t3);
                  let o4 = 0;
                  o4 = r3.length <= 0.5 * t3 ? 1 : Math.ceil(r3.paddedLength / f3) + 1;
                  for (let e3 = 0; e3 < o4; e3++) {
                    const s4 = e3 / Math.max(o4 - 1, 1), n4 = r3.lerp(s4), a4 = n4.x + ni, l4 = n4.y + ni;
                    m2.push(a4, l4, t3, 0);
                    const c3 = a4 - t3, d4 = l4 - t3, _3 = a4 + t3, p4 = l4 + t3;
                    if (F2 = F2 && this.isOffscreen(c3, d4, _3, p4), O2 = O2 || this.isInsideGrid(c3, d4, _3, p4), !i2 && this.grid.hitTestCircle(a4, l4, t3, u2) && (M2 = true, !h3)) return { circles: [], offscreen: false, collisionDetected: M2, occluded: false };
                  }
                }
              }
              return { circles: !h3 && M2 || !O2 ? [] : m2, offscreen: F2, collisionDetected: M2, occluded: S2.occluded };
            }
            queryRenderedSymbols(t2) {
              if (0 === t2.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
              const i2 = [];
              let o2 = 1 / 0, s2 = 1 / 0, r2 = -1 / 0, n2 = -1 / 0;
              for (const a3 of t2) {
                const t3 = new e.P(a3.x + ni, a3.y + ni);
                o2 = Math.min(o2, t3.x), s2 = Math.min(s2, t3.y), r2 = Math.max(r2, t3.x), n2 = Math.max(n2, t3.y), i2.push(t3);
              }
              const a2 = this.grid.query(o2, s2, r2, n2).concat(this.ignoredGrid.query(o2, s2, r2, n2)), l2 = {}, c2 = {};
              for (const t3 of a2) {
                const o3 = t3.key;
                if (void 0 === l2[o3.bucketInstanceId] && (l2[o3.bucketInstanceId] = {}), l2[o3.bucketInstanceId][o3.featureIndex]) continue;
                const s3 = [new e.P(t3.x1, t3.y1), new e.P(t3.x2, t3.y1), new e.P(t3.x2, t3.y2), new e.P(t3.x1, t3.y2)];
                e.bN(i2, s3) && (l2[o3.bucketInstanceId][o3.featureIndex] = true, void 0 === c2[o3.bucketInstanceId] && (c2[o3.bucketInstanceId] = []), c2[o3.bucketInstanceId].push(o3.featureIndex));
              }
              return c2;
            }
            insertCollisionBox(e2, t2, i2, o2, s2) {
              (t2 ? this.ignoredGrid : this.grid).insert({ bucketInstanceId: i2, featureIndex: o2, collisionGroupID: s2 }, e2[0], e2[1], e2[2], e2[3]);
            }
            insertCollisionCircles(e2, t2, i2, o2, s2) {
              const r2 = t2 ? this.ignoredGrid : this.grid, n2 = { bucketInstanceId: i2, featureIndex: o2, collisionGroupID: s2 };
              for (let t3 = 0; t3 < e2.length; t3 += 4) r2.insertCircle(n2, e2[t3], e2[t3 + 1], e2[t3 + 2]);
            }
            projectAndGetPerspectiveRatio(t2, i2, o2, s2, r2, n2, a2) {
              const l2 = [i2, o2, s2, 1];
              let c2 = false;
              if (s2 || this.transform.pitch > 0) {
                if (e.aA(l2, l2, t2), this.fogState && r2 && "globe" !== a2.name) {
                  const t3 = function(t4, i3, o3, s3, r3, n3) {
                    const a3 = n3.calculateFogTileMatrix(r3), l3 = [i3, o3, s3];
                    return e.ad(l3, l3, a3), Be(t4, e.ae(l3), n3.pitch, n3._fov);
                  }(this.fogState, i2, o2, s2, r2.toUnwrapped(), this.transform);
                  c2 = t3 > 0.9;
                }
              } else ri(l2, l2, t2);
              const h3 = l2[3];
              return { point: new e.P((l2[0] / h3 + 1) / 2 * this.transform.width + ni, (-l2[1] / h3 + 1) / 2 * this.transform.height + ni), perspectiveRatio: Math.min(0.5 + this.transform.getCameraToCenterDistance(a2) / h3 * 0.5, 1.5), signedDistanceFromCamera: h3, occluded: n2 && l2[2] > h3 || c2 };
            }
            isOffscreen(e2, t2, i2, o2) {
              return i2 < ni || e2 >= this.screenRightBoundary || o2 < ni || t2 > this.screenBottomBoundary;
            }
            isInsideGrid(e2, t2, i2, o2) {
              return i2 >= 0 && e2 < this.gridRightBoundary && o2 >= 0 && t2 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
              const t2 = e.bx([]);
              return e.bo(t2, t2, [-100, -100, 0]), t2;
            }
          }
          function li(t2, i2, o2) {
            const s2 = i2.createTileMatrix(t2, t2.worldSize, o2.toUnwrapped());
            return e.az(new Float32Array(16), t2.projMatrix, s2);
          }
          function ci(e2, t2, i2) {
            if (t2.projection.name === i2.projection.name) return e2.projMatrix;
            const o2 = i2.clone();
            return o2.setProjection(t2.projection), li(o2, t2.getProjection(), e2);
          }
          function hi(e2, t2, i2) {
            return t2.name === i2.projection.name ? e2.projMatrix : li(i2, t2, e2);
          }
          class di {
            constructor(e2, t2, i2, o2) {
              this.opacity = e2 ? Math.max(0, Math.min(1, e2.opacity + (e2.placed ? t2 : -t2))) : o2 && i2 ? 1 : 0, this.placed = i2;
            }
            isHidden() {
              return 0 === this.opacity && !this.placed;
            }
          }
          class ui {
            constructor(e2, t2, i2, o2, s2, r2 = false) {
              this.text = new di(e2 ? e2.text : null, t2, i2, s2), this.icon = new di(e2 ? e2.icon : null, t2, o2, s2), this.clipped = r2;
            }
            isHidden() {
              return this.text.isHidden() && this.icon.isHidden();
            }
          }
          class _i {
            constructor(e2, t2, i2, o2 = false) {
              this.text = e2, this.icon = t2, this.skipFade = i2, this.clipped = o2;
            }
          }
          class pi {
            constructor() {
              this.invProjMatrix = e.bz(), this.viewportMatrix = e.bz(), this.circles = [];
            }
          }
          class fi {
            constructor(e2, t2, i2, o2, s2) {
              this.bucketInstanceId = e2, this.featureIndex = t2, this.sourceLayerIndex = i2, this.bucketIndex = o2, this.tileID = s2;
            }
          }
          class mi {
            constructor(e2) {
              this.crossSourceCollisions = e2, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e2) {
              if (this.crossSourceCollisions) return { ID: 0, predicate: null };
              if (!this.collisionGroups[e2]) {
                const t2 = ++this.maxGroupID;
                this.collisionGroups[e2] = { ID: t2, predicate: (e3) => e3.collisionGroupID === t2 };
              }
              return this.collisionGroups[e2];
            }
          }
          function gi(t2, i2, o2, s2, r2) {
            const { horizontalAlign: n2, verticalAlign: a2 } = e.bT(t2), l2 = -(n2 - 0.5) * i2, c2 = -(a2 - 0.5) * o2, h3 = e.bU(t2, s2);
            return new e.P(l2 + h3[0] * r2, c2 + h3[1] * r2);
          }
          function vi(t2, i2, o2, s2, r2) {
            const n2 = new e.P(t2, i2);
            return o2 && n2._rotate(s2 ? r2 : -r2), n2;
          }
          class yi {
            constructor(e2, t2, i2, o2, s2, r2) {
              this.transform = e2.clone(), this.projection = e2.projection.name, this.collisionIndex = new ai(this.transform, s2), this.buildingIndex = r2, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = false, this.commitTime = 0, this.fadeDuration = t2, this.retainedQueryData = {}, this.collisionGroups = new mi(i2), this.collisionCircleArrays = {}, this.prevPlacement = o2, o2 && (o2.prevPlacement = void 0), this.placedOrientations = {};
            }
            getBucketParts(t2, i2, o2, s2, r2 = 1) {
              const n2 = o2.getBucket(i2), a2 = o2.latestFeatureIndex;
              if (!n2 || !a2 || i2.fqid !== n2.layerIds[0]) return;
              const l2 = n2.layers[0].layout, c2 = n2.layers[0].paint, h3 = o2.collisionBoxArray, d2 = Math.pow(2, this.transform.zoom - o2.tileID.overscaledZ), u2 = o2.tileSize / e.aj, _2 = o2.tileID.toUnwrapped();
              this.transform.setProjection(n2.projection);
              const p3 = (f2 = o2.tileID, m2 = n2.getProjection(), g2 = this.transform, m2.name === this.projection ? g2.calculateProjMatrix(f2.toUnwrapped()) : li(g2, m2, f2));
              var f2, m2, g2;
              const v2 = "map" === l2.get("text-pitch-alignment"), y2 = "map" === l2.get("text-rotation-alignment");
              i2.compileFilter(i2.options);
              const x2 = i2.dynamicFilter(), b2 = i2.dynamicFilterNeedsFeature(), w2 = this.transform.calculatePixelsToTileUnitsMatrix(o2), T2 = Ht(p3, o2.tileID.canonical, v2, y2, this.transform, n2.getProjection(), w2);
              let E2 = null;
              if (v2) {
                const t3 = Wt(p3, o2.tileID.canonical, v2, y2, this.transform, n2.getProjection(), w2);
                E2 = e.az([], this.transform.labelPlaneMatrix, t3);
              }
              let S2 = null;
              x2 && o2.latestFeatureIndex && (S2 = { unwrappedTileID: _2, dynamicFilter: x2, dynamicFilterNeedsFeature: b2 }), this.retainedQueryData[n2.bucketInstanceId] = new fi(n2.bucketInstanceId, a2, n2.sourceLayerIndex, n2.index, o2.tileID);
              const [I2, C2] = n2.layers[0].layout.get("text-size-scale-range"), R2 = e.ay(r2, I2, C2), [D2, A2] = l2.get("icon-size-scale-range"), L2 = e.ay(r2, D2, A2), P2 = { bucket: n2, layout: l2, paint: c2, posMatrix: p3, textLabelPlaneMatrix: T2, labelToScreenMatrix: E2, clippingData: S2, scale: d2, textPixelRatio: u2, holdingForFade: o2.holdingForFade(), collisionBoxArray: h3, partiallyEvaluatedTextSize: e.bH(n2.textSizeData, this.transform.zoom, R2), partiallyEvaluatedIconSize: e.bH(n2.iconSizeData, this.transform.zoom, L2), collisionGroup: this.collisionGroups.get(n2.sourceID), latestFeatureIndex: o2.latestFeatureIndex };
              if (s2) for (const e2 of n2.sortKeyRanges) {
                const { sortKey: i3, symbolInstanceStart: o3, symbolInstanceEnd: s3 } = e2;
                t2.push({ sortKey: i3, symbolInstanceStart: o3, symbolInstanceEnd: s3, parameters: P2 });
              }
              else t2.push({ symbolInstanceStart: 0, symbolInstanceEnd: n2.symbolInstances.length, parameters: P2 });
            }
            attemptAnchorPlacement(e2, t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2, m2, g2) {
              const { textOffset0: v2, textOffset1: y2, crossTileID: x2 } = d2, b2 = [v2, y2], w2 = gi(e2, i2, o2, b2, s2), T2 = this.collisionIndex.placeCollisionBox(_2, s2, t2, vi(w2.x, w2.y, r2, n2, this.transform.angle), h3, a2, l2, c2.predicate);
              if (f2) {
                const e3 = _2.getSymbolInstanceIconSize(g2, this.transform.zoom, d2.placedIconSymbolIndex);
                if (0 === this.collisionIndex.placeCollisionBox(_2, e3, f2, vi(w2.x, w2.y, r2, n2, this.transform.angle), h3, a2, l2, c2.predicate).box.length) return;
              }
              if (T2.box.length > 0) {
                let t3;
                return this.prevPlacement && this.prevPlacement.variableOffsets[x2] && this.prevPlacement.placements[x2] && this.prevPlacement.placements[x2].text && (t3 = this.prevPlacement.variableOffsets[x2].anchor), this.variableOffsets[x2] = { textOffset: b2, width: i2, height: o2, anchor: e2, textScale: s2, prevAnchor: t3 }, this.markUsedJustification(_2, e2, d2, p3), _2.allowVerticalPlacement && (this.markUsedOrientation(_2, p3, d2), this.placedOrientations[x2] = p3), { shift: w2, placedGlyphBoxes: T2 };
              }
            }
            placeLayerBucketPart(t2, i2, o2, s2, r2 = 1) {
              const { bucket: n2, layout: a2, paint: l2, posMatrix: c2, textLabelPlaneMatrix: h3, labelToScreenMatrix: d2, clippingData: u2, textPixelRatio: _2, holdingForFade: p3, collisionBoxArray: f2, partiallyEvaluatedTextSize: m2, partiallyEvaluatedIconSize: g2, collisionGroup: v2, latestFeatureIndex: y2 } = t2.parameters, x2 = a2.get("text-optional"), b2 = a2.get("icon-optional"), w2 = a2.get("text-allow-overlap"), T2 = a2.get("icon-allow-overlap"), E2 = "map" === a2.get("text-rotation-alignment"), S2 = "map" === a2.get("text-pitch-alignment"), I2 = l2.get("symbol-z-offset"), C2 = "sea" === a2.get("symbol-elevation-reference"), [R2, D2] = a2.get("text-size-scale-range"), [A2, L2] = a2.get("icon-size-scale-range"), P2 = e.ay(r2, R2, D2), z2 = e.ay(r2, A2, L2);
              this.transform.setProjection(n2.projection);
              let M2 = w2 && (T2 || !n2.hasIconData() || b2), O2 = T2 && (w2 || !n2.hasTextData() || x2);
              const F2 = !I2.isConstant();
              !n2.collisionArrays && f2 && n2.deserializeCollisionBoxes(f2), o2 && s2 && n2.updateCollisionDebugBuffers(this.transform.zoom, f2, P2, z2);
              const B2 = (t3, s3, l3) => {
                const { crossTileID: f3, numVerticalGlyphVertices: R3 } = t3;
                let D3 = null;
                if (u2 && u2.dynamicFilterNeedsFeature || F2) {
                  const e2 = this.retainedQueryData[n2.bucketInstanceId];
                  D3 = y2.loadFeature({ featureIndex: t3.featureIndex, bucketIndex: e2.bucketIndex, sourceLayerIndex: e2.sourceLayerIndex, layoutVertexArrayOffset: 0 });
                }
                if (u2 && !(0, u2.dynamicFilter)({ zoom: this.transform.zoom, pitch: this.transform.pitch }, D3, this.retainedQueryData[n2.bucketInstanceId].tileID.canonical, new e.P(t3.tileAnchorX, t3.tileAnchorY), this.transform.calculateDistanceTileData(u2.unwrappedTileID))) return this.placements[f3] = new _i(false, false, false, true), void i2.add(f3);
                const A3 = I2.evaluate(D3, {});
                if (i2.has(f3)) return;
                if (p3) return void (this.placements[f3] = new _i(false, false, false));
                let L3 = false, P3 = false, z3 = true, B3 = false, k3 = false, N2 = null, U2 = { box: null, offscreen: null, occluded: null }, j2 = { box: null }, V2 = null, G2 = null, q2 = null, Z2 = 0, H2 = 0, W2 = 0;
                l3.textFeatureIndex ? Z2 = l3.textFeatureIndex : t3.useRuntimeCollisionCircles && (Z2 = t3.featureIndex), l3.verticalTextFeatureIndex && (H2 = l3.verticalTextFeatureIndex);
                const $2 = (e2) => {
                  e2.tileID = this.retainedQueryData[n2.bucketInstanceId].tileID;
                  const i3 = this.transform.elevation;
                  e2.elevation = C2 ? A3 : A3 + (i3 ? i3.getAtTileOffset(e2.tileID, e2.tileAnchorX, e2.tileAnchorY) : 0), e2.elevation += t3.zOffset;
                }, X2 = l3.textBox;
                if (X2) {
                  $2(X2);
                  const i3 = (i4) => {
                    let o4 = e.bI.horizontal;
                    if (n2.allowVerticalPlacement && !i4 && this.prevPlacement) {
                      const e2 = this.prevPlacement.placedOrientations[f3];
                      e2 && (this.placedOrientations[f3] = e2, o4 = e2, this.markUsedOrientation(n2, o4, t3));
                    }
                    return o4;
                  }, o3 = (t4, i4) => {
                    if (n2.allowVerticalPlacement && R3 > 0 && l3.verticalTextBox) {
                      for (const o4 of n2.writingModes) if (o4 === e.bI.vertical ? (U2 = i4(), j2 = U2) : U2 = t4(), U2 && U2.box && U2.box.length) break;
                    } else U2 = t4();
                  };
                  if (a2.get("text-variable-anchor")) {
                    let r3 = a2.get("text-variable-anchor");
                    if (this.prevPlacement && this.prevPlacement.variableOffsets[f3]) {
                      const e2 = this.prevPlacement.variableOffsets[f3];
                      r3.indexOf(e2.anchor) > 0 && (r3 = r3.filter((t4) => t4 !== e2.anchor), r3.unshift(e2.anchor));
                    }
                    const h4 = (e2, i4, o4) => {
                      const a3 = n2.getSymbolInstanceTextSize(m2, t3, this.transform.zoom, s3), l4 = (e2.x2 - e2.x1) * a3 + 2 * e2.padding, h5 = (e2.y2 - e2.y1) * a3 + 2 * e2.padding, d4 = t3.hasIconTextFit && !T2 ? i4 : null;
                      d4 && $2(d4);
                      let u3 = { box: [], offscreen: false, occluded: false };
                      const p4 = w2 ? 2 * r3.length : r3.length;
                      for (let i5 = 0; i5 < p4; ++i5) {
                        const p5 = this.attemptAnchorPlacement(r3[i5 % r3.length], e2, l4, h5, a3, E2, S2, _2, c2, v2, i5 >= r3.length, t3, s3, n2, o4, d4, m2, g2);
                        if (p5 && (u3 = p5.placedGlyphBoxes, u3 && u3.box && u3.box.length)) {
                          L3 = true, N2 = p5.shift;
                          break;
                        }
                      }
                      return u3;
                    };
                    o3(() => h4(X2, l3.iconBox, e.bI.horizontal), () => {
                      const t4 = l3.verticalTextBox;
                      return t4 && $2(t4), n2.allowVerticalPlacement && !(U2 && U2.box && U2.box.length) && R3 > 0 && t4 ? h4(t4, l3.verticalIconBox, e.bI.vertical) : { box: null, offscreen: null, occluded: null };
                    }), U2 && (L3 = U2.box, z3 = U2.offscreen, B3 = U2.occluded);
                    const d3 = i3(!(!U2 || !U2.box));
                    if (!L3 && this.prevPlacement) {
                      const e2 = this.prevPlacement.variableOffsets[f3];
                      e2 && (this.variableOffsets[f3] = e2, this.markUsedJustification(n2, e2.anchor, t3, d3));
                    }
                  } else {
                    const a3 = (i4, o4) => {
                      const a4 = n2.getSymbolInstanceTextSize(m2, t3, this.transform.zoom, s3, r2), l4 = this.collisionIndex.placeCollisionBox(n2, a4, i4, new e.P(0, 0), w2, _2, c2, v2.predicate);
                      return l4 && l4.box && l4.box.length && (this.markUsedOrientation(n2, o4, t3), this.placedOrientations[f3] = o4), l4;
                    };
                    o3(() => a3(X2, e.bI.horizontal), () => {
                      const t4 = l3.verticalTextBox;
                      return n2.allowVerticalPlacement && R3 > 0 && t4 ? ($2(t4), a3(t4, e.bI.vertical)) : { box: null, offscreen: null, occluded: null };
                    }), i3(!!(U2 && U2.box && U2.box.length));
                  }
                }
                if (V2 = U2, L3 = V2 && V2.box && V2.box.length > 0, z3 = V2 && V2.offscreen, B3 = V2 && V2.occluded, t3.useRuntimeCollisionCircles) {
                  const i3 = n2.text.placedSymbolArray.get(t3.centerJustifiedTextSymbolIndex >= 0 ? t3.centerJustifiedTextSymbolIndex : t3.verticalPlacedTextSymbolIndex), s4 = e.bJ(n2.textSizeData, m2, i3), r3 = a2.get("text-padding");
                  G2 = this.collisionIndex.placeCollisionCircles(n2, w2, i3, n2.lineVertexArray, n2.glyphOffsetArray, s4, c2, h3, d2, o2, S2, v2.predicate, t3.collisionCircleDiameter * s4 / e.bO, r3, this.retainedQueryData[n2.bucketInstanceId].tileID), L3 = w2 || G2.circles.length > 0 && !G2.collisionDetected, z3 = z3 && G2.offscreen, B3 = G2.occluded;
                }
                if (l3.iconFeatureIndex && (W2 = l3.iconFeatureIndex), l3.iconBox) {
                  const i3 = (i4) => {
                    $2(i4);
                    const o3 = t3.hasIconTextFit && N2 ? vi(N2.x, N2.y, E2, S2, this.transform.angle) : new e.P(0, 0), s4 = n2.getSymbolInstanceIconSize(g2, this.transform.zoom, t3.placedIconSymbolIndex);
                    return this.collisionIndex.placeCollisionBox(n2, s4, i4, o3, T2, _2, c2, v2.predicate);
                  };
                  j2 && j2.box && j2.box.length && l3.verticalIconBox ? (q2 = i3(l3.verticalIconBox), P3 = q2.box.length > 0) : (q2 = i3(l3.iconBox), P3 = q2.box.length > 0), z3 = z3 && q2.offscreen, k3 = q2.occluded;
                }
                const Y2 = x2 || 0 === t3.numHorizontalGlyphVertices && 0 === R3, K2 = b2 || 0 === t3.numIconVertices;
                if (Y2 || K2 ? K2 ? Y2 || (P3 = P3 && L3) : L3 = P3 && L3 : P3 = L3 = P3 && L3, L3 && V2 && V2.box && this.collisionIndex.insertCollisionBox(V2.box, a2.get("text-ignore-placement"), n2.bucketInstanceId, j2 && j2.box && H2 ? H2 : Z2, v2.ID), P3 && q2 && this.collisionIndex.insertCollisionBox(q2.box, a2.get("icon-ignore-placement"), n2.bucketInstanceId, W2, v2.ID), G2 && (L3 && this.collisionIndex.insertCollisionCircles(G2.circles, a2.get("text-ignore-placement"), n2.bucketInstanceId, Z2, v2.ID), o2)) {
                  const e2 = n2.bucketInstanceId;
                  let t4 = this.collisionCircleArrays[e2];
                  void 0 === t4 && (t4 = this.collisionCircleArrays[e2] = new pi());
                  for (let e3 = 0; e3 < G2.circles.length; e3 += 4) t4.circles.push(G2.circles[e3 + 0]), t4.circles.push(G2.circles[e3 + 1]), t4.circles.push(G2.circles[e3 + 2]), t4.circles.push(G2.collisionDetected ? 1 : 0);
                }
                const J2 = "globe" !== n2.projection.name;
                M2 = M2 && (J2 || !B3), O2 = O2 && (J2 || !k3), this.placements[f3] = new _i(L3 || M2, P3 || O2, z3 || n2.justReloaded), i2.add(f3);
              }, k2 = this.retainedQueryData[n2.bucketInstanceId].tileID;
              if ("offset" === n2.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(n2, k2), "road" === n2.elevationType && n2.updateRoadElevation(k2.canonical), n2.updateZOffset(), n2.sortFeaturesByY) {
                const t3 = n2.getSortedSymbolIndexes(this.transform.angle);
                for (let e2 = t3.length - 1; e2 >= 0; --e2) {
                  const i3 = t3[e2];
                  B2(n2.symbolInstances.get(i3), i3, n2.collisionArrays[i3]);
                }
                n2.hasAnyZOffset && e.w(`${n2.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
              } else if (n2.hasAnyZOffset) {
                const e2 = n2.getSortedIndexesByZOffset();
                for (let t3 = 0; t3 < e2.length; ++t3) {
                  const i3 = e2[t3];
                  B2(n2.symbolInstances.get(i3), i3, n2.collisionArrays[i3]);
                }
              } else for (let e2 = t2.symbolInstanceStart; e2 < t2.symbolInstanceEnd; e2++) B2(n2.symbolInstances.get(e2), e2, n2.collisionArrays[e2]);
              if (o2 && n2.bucketInstanceId in this.collisionCircleArrays) {
                const t3 = this.collisionCircleArrays[n2.bucketInstanceId];
                e.bi(t3.invProjMatrix, c2), t3.viewportMatrix = this.collisionIndex.getViewportMatrix();
              }
              n2.justReloaded = false;
            }
            markUsedJustification(t2, i2, o2, s2) {
              const { leftJustifiedTextSymbolIndex: r2, centerJustifiedTextSymbolIndex: n2, rightJustifiedTextSymbolIndex: a2, verticalPlacedTextSymbolIndex: l2, crossTileID: c2 } = o2, h3 = e.bV(i2), d2 = s2 === e.bI.vertical ? l2 : "left" === h3 ? r2 : "center" === h3 ? n2 : "right" === h3 ? a2 : -1;
              r2 >= 0 && (t2.text.placedSymbolArray.get(r2).crossTileID = d2 >= 0 && r2 !== d2 ? 0 : c2), n2 >= 0 && (t2.text.placedSymbolArray.get(n2).crossTileID = d2 >= 0 && n2 !== d2 ? 0 : c2), a2 >= 0 && (t2.text.placedSymbolArray.get(a2).crossTileID = d2 >= 0 && a2 !== d2 ? 0 : c2), l2 >= 0 && (t2.text.placedSymbolArray.get(l2).crossTileID = d2 >= 0 && l2 !== d2 ? 0 : c2);
            }
            markUsedOrientation(t2, i2, o2) {
              const s2 = i2 === e.bI.horizontal || i2 === e.bI.horizontalOnly ? i2 : 0, r2 = i2 === e.bI.vertical ? i2 : 0, { leftJustifiedTextSymbolIndex: n2, centerJustifiedTextSymbolIndex: a2, rightJustifiedTextSymbolIndex: l2, verticalPlacedTextSymbolIndex: c2 } = o2, h3 = t2.text.placedSymbolArray;
              n2 >= 0 && (h3.get(n2).placedOrientation = s2), a2 >= 0 && (h3.get(a2).placedOrientation = s2), l2 >= 0 && (h3.get(l2).placedOrientation = s2), c2 >= 0 && (h3.get(c2).placedOrientation = r2);
            }
            commit(e2) {
              this.commitTime = e2, this.zoomAtLastRecencyCheck = this.transform.zoom;
              const t2 = this.prevPlacement;
              let i2 = false;
              this.prevZoomAdjustment = t2 ? t2.zoomAdjustment(this.transform.zoom) : 0;
              const o2 = t2 ? t2.symbolFadeChange(e2) : 1, s2 = t2 ? t2.opacities : {}, r2 = t2 ? t2.variableOffsets : {}, n2 = t2 ? t2.placedOrientations : {};
              for (const e3 in this.placements) {
                const t3 = this.placements[e3], r3 = s2[e3];
                r3 ? (this.opacities[e3] = new ui(r3, o2, t3.text, t3.icon, null, t3.clipped), i2 = i2 || t3.text !== r3.text.placed || t3.icon !== r3.icon.placed) : (this.opacities[e3] = new ui(null, o2, t3.text, t3.icon, t3.skipFade, t3.clipped), i2 = i2 || t3.text || t3.icon);
              }
              for (const e3 in s2) {
                const t3 = s2[e3];
                if (!this.opacities[e3]) {
                  const s3 = new ui(t3, o2, false, false);
                  s3.isHidden() || (this.opacities[e3] = s3, i2 = i2 || t3.text.placed || t3.icon.placed);
                }
              }
              for (const e3 in r2) this.variableOffsets[e3] || !this.opacities[e3] || this.opacities[e3].isHidden() || (this.variableOffsets[e3] = r2[e3]);
              for (const e3 in n2) this.placedOrientations[e3] || !this.opacities[e3] || this.opacities[e3].isHidden() || (this.placedOrientations[e3] = n2[e3]);
              i2 ? this.lastPlacementChangeTime = e2 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t2 ? t2.lastPlacementChangeTime : e2);
            }
            updateLayerOpacities(e2, t2, i2, o2) {
              const s2 = /* @__PURE__ */ new Set();
              for (const r2 of t2) {
                const t3 = r2.getBucket(e2);
                t3 && r2.latestFeatureIndex && e2.fqid === t3.layerIds[0] && (this.updateBucketOpacities(t3, s2, r2, r2.collisionBoxArray, i2, o2, r2.tileID, e2.scope), "offset" === t3.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(t3, r2.tileID), "road" === t3.elevationType && t3.updateRoadElevation(r2.tileID.canonical), t3.updateZOffset());
              }
            }
            updateBucketOpacities(t2, i2, o2, s2, r2, n2, a2, l2) {
              t2.hasTextData() && t2.text.opacityVertexArray.clear(), t2.hasIconData() && t2.icon.opacityVertexArray.clear(), t2.hasIconCollisionBoxData() && t2.iconCollisionBox.collisionVertexArray.clear(), t2.hasTextCollisionBoxData() && t2.textCollisionBox.collisionVertexArray.clear();
              const c2 = t2.layers[0].layout, h3 = t2.layers[0].paint, d2 = !!t2.layers[0].dynamicFilter(), u2 = new ui(null, 0, false, false, true), _2 = c2.get("text-allow-overlap"), p3 = c2.get("icon-allow-overlap"), f2 = c2.get("text-variable-anchor"), m2 = "map" === c2.get("text-rotation-alignment"), g2 = "map" === c2.get("text-pitch-alignment"), v2 = h3.get("symbol-z-offset"), y2 = "sea" === c2.get("symbol-elevation-reference"), x2 = !v2.isConstant(), b2 = new ui(null, 0, _2 && (p3 || !t2.hasIconData() || c2.get("icon-optional")), p3 && (_2 || !t2.hasTextData() || c2.get("text-optional")), true);
              !t2.collisionArrays && s2 && (t2.hasIconCollisionBoxData() || t2.hasTextCollisionBoxData()) && t2.deserializeCollisionBoxes(s2);
              const w2 = (e2, t3, i3) => {
                for (let o3 = 0; o3 < t3 / 4; o3++) e2.opacityVertexArray.emplaceBack(i3);
              };
              let T2 = 0;
              n2 && t2.updateReplacement(a2, n2);
              for (let s3 = 0; s3 < t2.symbolInstances.length; s3++) {
                const c3 = t2.symbolInstances.get(s3), { numHorizontalGlyphVertices: h4, numVerticalGlyphVertices: _3, crossTileID: p4, numIconVertices: E2, tileAnchorX: S2, tileAnchorY: I2 } = c3;
                let C2 = null;
                const R2 = this.retainedQueryData[t2.bucketInstanceId];
                x2 && c3 && R2 && (C2 = o2.latestFeatureIndex.loadFeature({ featureIndex: c3.featureIndex, bucketIndex: R2.bucketIndex, sourceLayerIndex: R2.sourceLayerIndex, layoutVertexArrayOffset: 0 }));
                const D2 = v2.evaluate(C2, {}), A2 = i2.has(p4);
                let L2 = this.opacities[p4];
                A2 ? L2 = u2 : L2 || (L2 = b2, this.opacities[p4] = L2), i2.add(p4);
                const P2 = h4 > 0 || _3 > 0, z2 = E2 > 0, M2 = this.placedOrientations[p4], O2 = M2 === e.bI.vertical, F2 = M2 === e.bI.horizontal || M2 === e.bI.horizontalOnly;
                !P2 && !z2 || L2.isHidden() || T2++;
                let B2 = false;
                if ((P2 || z2) && n2) for (const i3 of t2.activeReplacements) {
                  if (e.bP(i3, r2, e.bQ.Symbol, l2)) continue;
                  if (i3.min.x > S2 || S2 > i3.max.x || i3.min.y > I2 || I2 > i3.max.y) continue;
                  const t3 = e.bR(S2, I2, a2.canonical, i3.footprintTileId.canonical);
                  if (B2 = e.bS(t3, i3.footprint), B2) break;
                }
                if (P2) {
                  const e2 = B2 ? Di : Ri(L2.text);
                  w2(t2.text, h4, O2 ? Di : e2), w2(t2.text, _3, F2 ? Di : e2);
                  const i3 = L2.text.isHidden(), { leftJustifiedTextSymbolIndex: o3, centerJustifiedTextSymbolIndex: s4, rightJustifiedTextSymbolIndex: r3, verticalPlacedTextSymbolIndex: n3 } = c3, a3 = t2.text.placedSymbolArray, l3 = i3 || O2 ? 1 : 0;
                  o3 >= 0 && (a3.get(o3).hidden = l3), s4 >= 0 && (a3.get(s4).hidden = l3), r3 >= 0 && (a3.get(r3).hidden = l3), n3 >= 0 && (a3.get(n3).hidden = i3 || F2 ? 1 : 0);
                  const d3 = this.variableOffsets[p4];
                  d3 && this.markUsedJustification(t2, d3.anchor, c3, M2);
                  const u3 = this.placedOrientations[p4];
                  u3 && (this.markUsedJustification(t2, "left", c3, u3), this.markUsedOrientation(t2, u3, c3));
                }
                if (z2) {
                  const e2 = B2 ? Di : Ri(L2.icon), { placedIconSymbolIndex: i3, verticalPlacedIconSymbolIndex: o3 } = c3, s4 = t2.icon.placedSymbolArray, r3 = L2.icon.isHidden() ? 1 : 0;
                  i3 >= 0 && (w2(t2.icon, E2, O2 ? Di : e2), s4.get(i3).hidden = r3), o3 >= 0 && (w2(t2.icon, c3.numVerticalIconVertices, F2 ? Di : e2), s4.get(o3).hidden = r3);
                }
                if (t2.hasIconCollisionBoxData() || t2.hasTextCollisionBoxData()) {
                  const i3 = t2.collisionArrays[s3];
                  if (i3) {
                    let o3 = new e.P(0, 0), s4 = true;
                    if (i3.textBox || i3.verticalTextBox) {
                      if (f2) {
                        const e2 = this.variableOffsets[p4];
                        e2 ? (o3 = gi(e2.anchor, e2.width, e2.height, e2.textOffset, e2.textScale), m2 && o3._rotate(g2 ? this.transform.angle : -this.transform.angle)) : s4 = false;
                      }
                      d2 && (s4 = !L2.clipped), i3.textBox && xi(t2.textCollisionBox.collisionVertexArray, L2.text.placed, !s4 || O2, D2, y2, o3.x, o3.y), i3.verticalTextBox && xi(t2.textCollisionBox.collisionVertexArray, L2.text.placed, !s4 || F2, D2, y2, o3.x, o3.y);
                    }
                    const r3 = s4 && Boolean(!F2 && i3.verticalIconBox);
                    i3.iconBox && xi(t2.iconCollisionBox.collisionVertexArray, L2.icon.placed, r3, D2, y2, c3.hasIconTextFit ? o3.x : 0, c3.hasIconTextFit ? o3.y : 0), i3.verticalIconBox && xi(t2.iconCollisionBox.collisionVertexArray, L2.icon.placed, !r3, D2, y2, c3.hasIconTextFit ? o3.x : 0, c3.hasIconTextFit ? o3.y : 0);
                  }
                }
              }
              if (t2.fullyClipped = 0 === T2, t2.sortFeatures(this.transform.angle), this.retainedQueryData[t2.bucketInstanceId] && (this.retainedQueryData[t2.bucketInstanceId].featureSortOrder = t2.featureSortOrder), t2.hasTextData() && t2.text.opacityVertexBuffer && t2.text.opacityVertexBuffer.updateData(t2.text.opacityVertexArray), t2.hasIconData() && t2.icon.opacityVertexBuffer && t2.icon.opacityVertexBuffer.updateData(t2.icon.opacityVertexArray), t2.hasIconCollisionBoxData() && t2.iconCollisionBox.collisionVertexBuffer && t2.iconCollisionBox.collisionVertexBuffer.updateData(t2.iconCollisionBox.collisionVertexArray), t2.hasTextCollisionBoxData() && t2.textCollisionBox.collisionVertexBuffer && t2.textCollisionBox.collisionVertexBuffer.updateData(t2.textCollisionBox.collisionVertexArray), t2.bucketInstanceId in this.collisionCircleArrays) {
                const e2 = this.collisionCircleArrays[t2.bucketInstanceId];
                t2.placementInvProjMatrix = e2.invProjMatrix, t2.placementViewportMatrix = e2.viewportMatrix, t2.collisionCircleArray = e2.circles, delete this.collisionCircleArrays[t2.bucketInstanceId];
              }
            }
            symbolFadeChange(e2) {
              return 0 === this.fadeDuration ? 1 : (e2 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e2) {
              return Math.max(0, (this.transform.zoom - e2) / 1.5);
            }
            hasTransitions(e2) {
              return this.stale || e2 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e2, t2) {
              const i2 = this.zoomAtLastRecencyCheck === t2 ? 1 - this.zoomAdjustment(t2) : 1;
              return this.zoomAtLastRecencyCheck = t2, this.commitTime + this.fadeDuration * i2 > e2;
            }
            setStale() {
              this.stale = true;
            }
          }
          function xi(e2, t2, i2, o2, s2, r2, n2) {
            e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, r2 || 0, n2 || 0, o2, s2 ? 1 : 0), e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, r2 || 0, n2 || 0, o2, s2 ? 1 : 0), e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, r2 || 0, n2 || 0, o2, s2 ? 1 : 0), e2.emplaceBack(t2 ? 1 : 0, i2 ? 1 : 0, r2 || 0, n2 || 0, o2, s2 ? 1 : 0);
          }
          const bi = Math.pow(2, 25), wi = Math.pow(2, 24), Ti = Math.pow(2, 17), Ei = Math.pow(2, 16), Si = Math.pow(2, 9), Ii = Math.pow(2, 8), Ci = Math.pow(2, 1);
          function Ri(e2) {
            if (0 === e2.opacity && !e2.placed) return 0;
            if (1 === e2.opacity && e2.placed) return 4294967295;
            const t2 = e2.placed ? 1 : 0, i2 = Math.floor(127 * e2.opacity);
            return i2 * bi + t2 * wi + i2 * Ti + t2 * Ei + i2 * Si + t2 * Ii + i2 * Ci + t2;
          }
          const Di = 0;
          class Ai {
            constructor(e2) {
              this._sortAcrossTiles = "viewport-y" !== e2.layout.get("symbol-z-order") && void 0 !== e2.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = /* @__PURE__ */ new Set(), this._bucketParts = [];
            }
            continuePlacement(e2, t2, i2, o2, s2, r2) {
              const n2 = this._bucketParts;
              for (; this._currentTileIndex < e2.length; ) if (t2.getBucketParts(n2, o2, e2[this._currentTileIndex], this._sortAcrossTiles, r2), this._currentTileIndex++, s2()) return true;
              for (this._sortAcrossTiles && (this._sortAcrossTiles = false, n2.sort((e3, t3) => e3.sortKey - t3.sortKey)); this._currentPartIndex < n2.length; ) {
                const e3 = n2[this._currentPartIndex];
                if (t2.placeLayerBucketPart(e3, this._seenCrossTileIDs, i2, 0 === e3.symbolInstanceStart, r2), this._currentPartIndex++, s2()) return true;
              }
              return false;
            }
          }
          class Li {
            constructor(e2, t2, i2, o2, s2, r2, n2, a2, l2) {
              this.placement = new yi(e2, s2, r2, n2, a2, l2), this._currentPlacementIndex = t2.length - 1, this._forceFullPlacement = i2, this._showCollisionBoxes = o2, this._done = false;
            }
            isDone() {
              return this._done;
            }
            continuePlacement(t2, i2, o2, s2, r2) {
              const n2 = e.q.now(), a2 = () => {
                const t3 = e.q.now() - n2;
                return !this._forceFullPlacement && t3 > 2;
              };
              for (; this._currentPlacementIndex >= 0; ) {
                const n3 = i2[t2[this._currentPlacementIndex]], l2 = this.placement.collisionIndex.transform.zoom;
                if ("symbol" === n3.type && (!n3.minzoom || n3.minzoom <= l2) && (!n3.maxzoom || n3.maxzoom > l2)) {
                  const t3 = n3, i3 = t3.layout.get("symbol-z-elevate"), l3 = void 0 !== t3.layout.get("symbol-sort-key").constantOr(1), c2 = t3.layout.get("symbol-z-order"), h3 = "viewport-y" === c2 || "auto" === c2 && !("viewport-y" !== c2 && l3), d2 = t3.layout.get("text-allow-overlap") || t3.layout.get("icon-allow-overlap") || t3.layout.get("text-ignore-placement") || t3.layout.get("icon-ignore-placement"), u2 = h3 && d2, _2 = this._inProgressLayer = this._inProgressLayer || new Ai(t3), p3 = e.C(n3.source, n3.scope);
                  if (_2.continuePlacement(i3 || u2 ? s2[p3] : o2[p3], this.placement, this._showCollisionBoxes, n3, a2, r2)) return;
                  delete this._inProgressLayer;
                }
                this._currentPlacementIndex--;
              }
              this._done = true;
            }
            commit(e2) {
              return this.placement.commit(e2), this.placement;
            }
          }
          const Pi = 512 / e.aj / 2;
          class zi {
            constructor(t2, i2, o2) {
              this.tileID = t2, this.bucketInstanceId = o2, this.index = new e.bW(i2.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
              const s2 = t2.canonical.x * e.aj, r2 = t2.canonical.y * e.aj;
              for (let e2 = 0; e2 < i2.length; e2++) {
                const { key: t3, crossTileID: o3, tileAnchorX: n2, tileAnchorY: a2 } = i2.get(e2), l2 = Math.floor((s2 + n2) * Pi), c2 = Math.floor((r2 + a2) * Pi);
                this.index.add(l2, c2), this.keys.push(t3), this.crossTileIDs.push(o3);
              }
              this.index.finish();
            }
            findMatches(t2, i2, o2) {
              const s2 = this.tileID.canonical.z < i2.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i2.canonical.z), r2 = Pi / Math.pow(2, i2.canonical.z - this.tileID.canonical.z), n2 = i2.canonical.x * e.aj, a2 = i2.canonical.y * e.aj;
              for (let e2 = 0; e2 < t2.length; e2++) {
                const i3 = t2.get(e2);
                if (i3.crossTileID) continue;
                const { key: l2, tileAnchorX: c2, tileAnchorY: h3 } = i3, d2 = Math.floor((n2 + c2) * r2), u2 = Math.floor((a2 + h3) * r2), _2 = this.index.range(d2 - s2, u2 - s2, d2 + s2, u2 + s2).sort((e3, t3) => e3 - t3);
                for (const e3 of _2) {
                  const t3 = this.crossTileIDs[e3];
                  if (this.keys[e3] === l2 && !o2.has(t3)) {
                    o2.add(t3), i3.crossTileID = t3;
                    break;
                  }
                }
              }
            }
          }
          class Mi {
            constructor() {
              this.maxCrossTileID = 0;
            }
            generate() {
              return ++this.maxCrossTileID;
            }
          }
          class Oi {
            constructor() {
              this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e2) {
              const t2 = Math.round((e2 - this.lng) / 360);
              if (0 !== t2) for (const e3 in this.indexes) {
                const i2 = this.indexes[e3], o2 = {};
                for (const e4 in i2) {
                  const s2 = i2[e4];
                  s2.tileID = s2.tileID.unwrapTo(s2.tileID.wrap + t2), o2[s2.tileID.key] = s2;
                }
                this.indexes[e3] = o2;
              }
              this.lng = e2;
            }
            addBucket(e2, t2, i2) {
              if (this.indexes[e2.overscaledZ] && this.indexes[e2.overscaledZ][e2.key]) {
                if (this.indexes[e2.overscaledZ][e2.key].bucketInstanceId === t2.bucketInstanceId) return false;
                this.removeBucketCrossTileIDs(e2.overscaledZ, this.indexes[e2.overscaledZ][e2.key]);
              }
              for (let e3 = 0; e3 < t2.symbolInstances.length; e3++) t2.symbolInstances.get(e3).crossTileID = 0;
              this.usedCrossTileIDs[e2.overscaledZ] || (this.usedCrossTileIDs[e2.overscaledZ] = /* @__PURE__ */ new Set());
              const o2 = this.usedCrossTileIDs[e2.overscaledZ];
              for (const i3 in this.indexes) {
                const s2 = this.indexes[i3];
                if (Number(i3) > e2.overscaledZ) for (const i4 in s2) {
                  const r2 = s2[i4];
                  r2.tileID.isChildOf(e2) && r2.findMatches(t2.symbolInstances, e2, o2);
                }
                else {
                  const r2 = s2[e2.scaledTo(Number(i3)).key];
                  r2 && r2.findMatches(t2.symbolInstances, e2, o2);
                }
              }
              for (let e3 = 0; e3 < t2.symbolInstances.length; e3++) {
                const s2 = t2.symbolInstances.get(e3);
                s2.crossTileID || (s2.crossTileID = i2.generate(), o2.add(s2.crossTileID));
              }
              return void 0 === this.indexes[e2.overscaledZ] && (this.indexes[e2.overscaledZ] = {}), this.indexes[e2.overscaledZ][e2.key] = new zi(e2, t2.symbolInstances, t2.bucketInstanceId), true;
            }
            removeBucketCrossTileIDs(e2, t2) {
              for (const i2 of t2.crossTileIDs) this.usedCrossTileIDs[e2].delete(i2);
            }
            removeStaleBuckets(e2) {
              let t2 = false;
              for (const i2 in this.indexes) {
                const o2 = this.indexes[i2];
                for (const s2 in o2) e2[o2[s2].bucketInstanceId] || (this.removeBucketCrossTileIDs(i2, o2[s2]), delete o2[s2], t2 = true);
              }
              return t2;
            }
          }
          class Fi {
            constructor() {
              this.layerIndexes = {}, this.crossTileIDs = new Mi(), this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e2, t2, i2, o2) {
              let s2 = this.layerIndexes[e2.fqid];
              void 0 === s2 && (s2 = this.layerIndexes[e2.fqid] = new Oi());
              let r2 = false;
              const n2 = {};
              "globe" !== o2.name && s2.handleWrapJump(i2);
              for (const i3 of t2) {
                const t3 = i3.getBucket(e2);
                t3 && e2.fqid === t3.layerIds[0] && (t3.bucketInstanceId || (t3.bucketInstanceId = ++this.maxBucketInstanceId), s2.addBucket(i3.tileID, t3, this.crossTileIDs) && (r2 = true), n2[t3.bucketInstanceId] = true);
              }
              return s2.removeStaleBuckets(n2) && (r2 = true), r2;
            }
            pruneUnusedLayers(e2) {
              const t2 = {};
              e2.forEach((e3) => {
                t2[e3] = true;
              });
              for (const e3 in this.layerIndexes) t2[e3] || delete this.layerIndexes[e3];
            }
          }
          const Bi = 771;
          class ki {
            constructor(e2, t2, i2, o2) {
              this.blendFunction = e2, this.blendColor = t2.toNonPremultipliedRenderColor(null), this.mask = i2, this.blendEquation = o2;
            }
          }
          ki.Replace = [1, 0, 1, 0], ki.disabled = new ki(ki.Replace, e.am.transparent, [false, false, false, false]), ki.unblended = new ki(ki.Replace, e.am.transparent, [true, true, true, true]), ki.alphaBlended = new ki([1, Bi, 1, Bi], e.am.transparent, [true, true, true, true]), ki.alphaBlendedNonPremultiplied = new ki([770, Bi, 770, Bi], e.am.transparent, [true, true, true, true]), ki.multiply = new ki([774, 0, 774, 0], e.am.transparent, [true, true, true, true]);
          class Ni {
            constructor(e2, t2, i2) {
              this.func = e2, this.mask = t2, this.range = i2;
            }
          }
          Ni.ReadOnly = false, Ni.ReadWrite = true, Ni.disabled = new Ni(519, Ni.ReadOnly, [0, 1]);
          const Ui = 7680;
          class ji {
            constructor(e2, t2, i2, o2, s2, r2) {
              this.test = e2, this.ref = t2, this.mask = i2, this.fail = o2, this.depthFail = s2, this.pass = r2;
            }
          }
          ji.disabled = new ji({ func: 519, mask: 0 }, 0, 0, Ui, Ui, Ui);
          const Vi = 1029, Gi = 2305;
          class qi {
            constructor(e2, t2, i2) {
              this.enable = e2, this.mode = t2, this.frontFace = i2;
            }
          }
          function Zi(t2, i2) {
            const o2 = e.c1(t2, 3);
            e.c3(t2, i2), e.c7(t2, 3, o2);
          }
          function Hi(t2, i2) {
            const o2 = e.b_([]);
            return e.b$(o2, o2, -i2), e.c0(o2, o2, -t2), o2;
          }
          function Wi(t2, i2) {
            const o2 = [t2[0], t2[1], 0], s2 = [i2[0], i2[1], 0];
            if (e.ae(o2) >= 1e-15) {
              const t3 = e.au([], o2);
              e.bY(s2, t3, e.bG(s2, t3)), i2[0] = s2[0], i2[1] = s2[1];
            }
            const r2 = e.bF([], i2, t2);
            if (e.bZ(r2) < 1e-15) return null;
            const n2 = Math.atan2(-r2[1], r2[0]);
            return Hi(Math.atan2(Math.sqrt(t2[0] * t2[0] + t2[1] * t2[1]), -t2[2]), n2);
          }
          qi.disabled = new qi(false, Vi, Gi), qi.backCCW = new qi(true, Vi, Gi), qi.backCW = new qi(true, Vi, 2304), qi.frontCW = new qi(true, 1028, 2304), qi.frontCCW = new qi(true, 1028, Gi);
          class $i {
            constructor(e2, t2) {
              this.position = e2, this.orientation = t2;
            }
            get position() {
              return this._position;
            }
            set position(t2) {
              if (t2) {
                const i2 = t2 instanceof e.ac ? t2 : new e.ac(t2[0], t2[1], t2[2]);
                this._renderWorldCopies && (i2.x = e.bX(i2.x, 0, 1)), this._position = i2;
              } else this._position = null;
            }
            lookAtPoint(t2, i2) {
              if (this.orientation = null, !this.position) return;
              const o2 = this.position, s2 = this._elevation ? this._elevation.getAtPointOrZero(e.ac.fromLngLat(t2)) : 0, r2 = e.ac.fromLngLat(t2, s2), n2 = [r2.x - o2.x, r2.y - o2.y, r2.z - o2.z];
              i2 || (i2 = [0, 0, 1]), i2[2] = Math.abs(i2[2]), this.orientation = Wi(n2, i2);
            }
            setPitchBearing(t2, i2) {
              this.orientation = Hi(e.al(t2), e.al(-i2));
            }
          }
          class Xi {
            constructor(t2, i2) {
              this._transform = e.bx([]), this.orientation = i2, this.position = t2;
            }
            get mercatorPosition() {
              const t2 = this.position;
              return new e.ac(t2[0], t2[1], t2[2]);
            }
            get position() {
              const t2 = e.c1(this._transform, 3);
              return [t2[0], t2[1], t2[2]];
            }
            set position(t2) {
              var i2;
              t2 && e.c7(this._transform, 3, [(i2 = t2)[0], i2[1], i2[2], 1]);
            }
            get orientation() {
              return this._orientation;
            }
            set orientation(t2) {
              this._orientation = t2 || e.b_([]), t2 && Zi(this._transform, this._orientation);
            }
            getPitchBearing() {
              const e2 = this.forward(), t2 = this.right();
              return { bearing: Math.atan2(-t2[1], t2[0]), pitch: Math.atan2(Math.sqrt(e2[0] * e2[0] + e2[1] * e2[1]), -e2[2]) };
            }
            setPitchBearing(e2, t2) {
              this._orientation = Hi(e2, t2), Zi(this._transform, this._orientation);
            }
            forward() {
              const t2 = e.c1(this._transform, 2);
              return [-t2[0], -t2[1], -t2[2]];
            }
            up() {
              const t2 = e.c1(this._transform, 1);
              return [-t2[0], -t2[1], -t2[2]];
            }
            right() {
              const t2 = e.c1(this._transform, 0);
              return [t2[0], t2[1], t2[2]];
            }
            getCameraToWorld(t2, i2) {
              const o2 = new Float64Array(16);
              return e.bi(o2, this.getWorldToCamera(t2, i2)), o2;
            }
            getCameraToWorldMercator() {
              return this._transform;
            }
            getWorldToCameraPosition(t2, i2, o2) {
              const s2 = this.position;
              e.bY(s2, s2, -t2);
              const r2 = new Float64Array(16);
              return e.bn(r2, [o2, o2, o2]), e.bo(r2, r2, s2), r2[10] *= i2, r2;
            }
            getWorldToCamera(t2, i2) {
              const o2 = new Float64Array(16), s2 = new Float64Array(4), r2 = this.position;
              return e.c2(s2, this._orientation), e.bY(r2, r2, -t2), e.c3(o2, s2), e.bo(o2, o2, r2), o2[1] *= -1, o2[5] *= -1, o2[9] *= -1, o2[13] *= -1, o2[8] *= i2, o2[9] *= i2, o2[10] *= i2, o2[11] *= i2, o2;
            }
            getCameraToClipPerspective(t2, i2, o2, s2) {
              const r2 = new Float64Array(16);
              return e.c4(r2, t2, i2, o2, s2), r2;
            }
            getCameraToClipOrthographic(t2, i2, o2, s2, r2, n2) {
              const a2 = new Float64Array(16);
              return e.c5(a2, t2, i2, o2, s2, r2, n2), a2;
            }
            getDistanceToElevation(t2, i2 = false) {
              const o2 = 0 === t2 ? 0 : e.c6(t2, i2 ? e.aY(this.position[1]) : this.position[1]), s2 = this.forward();
              return (o2 - this.position[2]) / s2[2];
            }
            clone() {
              return new Xi([...this.position], [...this.orientation]);
            }
          }
          const Yi = { BaseColor: 5, MetallicRoughness: 6, Normal: 7, Occlusion: 8, Emission: 9, LUT: 10, ShadowMap0: 11 };
          class Ki {
            constructor(e2 = 0, t2 = 0, i2 = 0, o2 = 0) {
              if (isNaN(e2) || e2 < 0 || isNaN(t2) || t2 < 0 || isNaN(i2) || i2 < 0 || isNaN(o2) || o2 < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
              this.top = e2, this.bottom = t2, this.left = i2, this.right = o2;
            }
            interpolate(t2, i2, o2) {
              return null != i2.top && null != t2.top && (this.top = e.ai(t2.top, i2.top, o2)), null != i2.bottom && null != t2.bottom && (this.bottom = e.ai(t2.bottom, i2.bottom, o2)), null != i2.left && null != t2.left && (this.left = e.ai(t2.left, i2.left, o2)), null != i2.right && null != t2.right && (this.right = e.ai(t2.right, i2.right, o2)), this;
            }
            getCenter(t2, i2) {
              const o2 = e.ay((this.left + t2 - this.right) / 2, 0, t2), s2 = e.ay((this.top + i2 - this.bottom) / 2, 0, i2);
              return new e.P(o2, s2);
            }
            equals(e2) {
              return this.top === e2.top && this.bottom === e2.bottom && this.left === e2.left && this.right === e2.right;
            }
            clone() {
              return new Ki(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
              return { top: this.top, bottom: this.bottom, left: this.left, right: this.right };
            }
          }
          const Ji = 15;
          class Qi {
            constructor(t2, i2, o2, s2, r2, n2, a2) {
              this.tileSize = 512, this._renderWorldCopies = void 0 === r2 || r2, this._minZoom = t2 || 0, this._maxZoom = i2 || 22, this._minPitch = o2 ?? 0, this._maxPitch = s2 ?? 60, this.setProjection(n2), this.setMaxBounds(a2), this.width = 0, this.height = 0, this._center = new e.cd(0, 0), this.zoom = 0, this.angle = 0, this._fov = 0.6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = true, this._edgeInsets = new Ki(), this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Xi(), this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [0, 0, 0], this._tileCoverLift = 0, this.freezeTileCoverage = false, this._horizonShift = 0.1, this._orthographicProjectionAtLowPitch = false, this._allowWorldUnderZoom = false;
            }
            clone() {
              const e2 = new Qi(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection(), this.maxBounds);
              return e2._elevation = this._elevation, e2._centerAltitude = this._centerAltitude, e2._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e2.tileSize = this.tileSize, e2.mercatorFromTransition = this.mercatorFromTransition, e2.width = this.width, e2.height = this.height, e2.cameraElevationReference = this.cameraElevationReference, e2._center = this._center, e2._setZoom(this.zoom), e2._seaLevelZoom = this._seaLevelZoom, e2.angle = this.angle, e2._fov = this._fov, e2._pitch = this._pitch, e2._nearZ = this._nearZ, e2._farZ = this._farZ, e2._averageElevation = this._averageElevation, e2._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e2._unmodified = this._unmodified, e2._edgeInsets = this._edgeInsets.clone(), e2._camera = this._camera.clone(), e2._calcMatrices(), e2.freezeTileCoverage = this.freezeTileCoverage, e2.frustumCorners = this.frustumCorners, e2._allowWorldUnderZoom = this._allowWorldUnderZoom, e2;
            }
            get isOrthographic() {
              return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < Ji;
            }
            get elevation() {
              return this._elevation;
            }
            set elevation(e2) {
              this._elevation !== e2 && (this._elevation = e2, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get depthOcclusionForSymbolsAndCircles() {
              return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e2, t2 = false) {
              const i2 = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
              (null == this._seaLevelZoom || i2) && this._updateCameraOnTerrain(), (e2 || i2) && this._constrainCamera(t2), this._calcMatrices();
            }
            getProjection() {
              return e.aF(this.projection, ["name", "center", "parallels"]);
            }
            setProjection(t2) {
              this.projectionOptions = t2 || { name: "mercator" };
              const i2 = this.projection ? this.getProjection() : void 0;
              this.projection = e.ce(this.projectionOptions);
              const o2 = this.getProjection(), s2 = !e.bv(i2, o2);
              return s2 && this._calcMatrices(), this.mercatorFromTransition = false, s2;
            }
            setOrthographicProjectionAtLowPitch(e2) {
              return this._orthographicProjectionAtLowPitch !== e2 && (this._orthographicProjectionAtLowPitch = e2, this._calcMatrices(), true);
            }
            setMercatorFromTransition() {
              const t2 = this.projection.name;
              this.mercatorFromTransition = true, this.projectionOptions = { name: "mercator" }, this.projection = e.ce({ name: "mercator" });
              const i2 = t2 !== this.projection.name;
              return i2 && this._calcMatrices(), i2;
            }
            get minZoom() {
              return this._minZoom;
            }
            set minZoom(e2) {
              this._minZoom !== e2 && (this._minZoom = e2, this.zoom = Math.max(this.zoom, e2));
            }
            get maxZoom() {
              return this._maxZoom;
            }
            set maxZoom(e2) {
              this._maxZoom !== e2 && (this._maxZoom = e2, this.zoom = Math.min(this.zoom, e2));
            }
            get minPitch() {
              return this._minPitch;
            }
            set minPitch(e2) {
              this._minPitch !== e2 && (this._minPitch = e2, this.pitch = Math.max(this.pitch, e2));
            }
            get maxPitch() {
              return this._maxPitch;
            }
            set maxPitch(e2) {
              this._maxPitch !== e2 && (this._maxPitch = e2, this.pitch = Math.min(this.pitch, e2));
            }
            get renderWorldCopies() {
              return this._renderWorldCopies && true === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e2) {
              void 0 === e2 ? e2 = true : null === e2 && (e2 = false), this._renderWorldCopies = e2;
            }
            get worldSize() {
              return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
              const e2 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
              return this._worldSizeFromZoom(this._zoomFromMercatorZ(e2));
            }
            get cameraWorldSize() {
              const e2 = Math.max(this._camera.getDistanceToElevation(this._averageElevation, true), Number.EPSILON);
              return this._worldSizeFromZoom(this._zoomFromMercatorZ(e2));
            }
            get pixelsPerMeter() {
              return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
              return e.c6(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
              return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
              return new e.P(this.width, this.height);
            }
            get bearing() {
              return e.bX(this.rotation, -180, 180);
            }
            set bearing(e2) {
              this.rotation = e2;
            }
            get rotation() {
              return -this.angle / Math.PI * 180;
            }
            set rotation(t2) {
              const i2 = -t2 * Math.PI / 180;
              this.angle !== i2 && (this._unmodified = false, this.angle = i2, this._calcMatrices(), this.rotationMatrix = e.cf(), e.cg(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
              return this._pitch / Math.PI * 180;
            }
            set pitch(t2) {
              const i2 = e.ay(t2, this.minPitch, this.maxPitch) / 180 * Math.PI;
              this._pitch !== i2 && (this._unmodified = false, this._pitch = i2, this._calcMatrices());
            }
            get aspect() {
              return this.width / this.height;
            }
            get fov() {
              return this._fov / Math.PI * 180;
            }
            set fov(t2) {
              t2 = Math.max(0.01, Math.min(60, t2)), this._fov !== t2 && (this._unmodified = false, this._fov = e.al(t2), this._calcMatrices());
            }
            get fovX() {
              return this._fov;
            }
            get fovY() {
              const e2 = 1 / Math.tan(0.5 * this.fovX);
              return 2 * Math.atan(1 / this.aspect / e2);
            }
            get averageElevation() {
              return this._averageElevation;
            }
            set averageElevation(e2) {
              this._averageElevation = e2, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
              return this._zoom;
            }
            set zoom(e2) {
              const t2 = Math.min(Math.max(e2, this.minZoom), this.maxZoom);
              this._zoom !== t2 && (this._unmodified = false, this._setZoom(t2), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e2) {
              this._zoom = e2, this.scale = this.zoomScale(e2), this.tileZoom = Math.floor(e2), this.zoomFraction = e2 - this.tileZoom;
            }
            get tileCoverLift() {
              return this._tileCoverLift;
            }
            set tileCoverLift(e2) {
              this._tileCoverLift !== e2 && (this._tileCoverLift = e2);
            }
            _updateCameraOnTerrain() {
              const e2 = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t2 = this.elevation && e2 === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
              if (!this._elevation || e2 === Number.NEGATIVE_INFINITY && (!t2 || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
              const i2 = this._elevation;
              t2 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i2.exaggeration() && this._centerAltitudeValidForExaggeration !== i2.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i2.exaggeration(), this._centerAltitudeValidForExaggeration = i2.exaggeration()) : (this._centerAltitude = e2 || 0, this._centerAltitudeValidForExaggeration = i2.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
              if (void 0 === this._centerAltitudeValidForExaggeration) return;
              const e2 = Math.max(0, (this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize);
              this._seaLevelZoom = this._zoomFromMercatorZ(e2);
            }
            sampleAverageElevation() {
              if (!this._elevation) return 0;
              const t2 = this._elevation, i2 = [[0.5, 0.2], [0.3, 0.5], [0.5, 0.5], [0.7, 0.5], [0.5, 0.8]], o2 = this.horizonLineFromTop();
              let s2 = 0, r2 = 0;
              for (let n2 = 0; n2 < i2.length; n2++) {
                const a2 = new e.P(i2[n2][0] * this.width, o2 + i2[n2][1] * (this.height - o2)), l2 = t2.pointCoordinate(a2);
                if (!l2) continue;
                const c2 = 1 / Math.hypot(l2[0] - this._camera.position[0], l2[1] - this._camera.position[1]);
                s2 += l2[3] * c2, r2 += c2;
              }
              return 0 === r2 ? NaN : s2 / r2;
            }
            get center() {
              return this._center;
            }
            set center(e2) {
              e2.lat === this._center.lat && e2.lng === this._center.lng || (this._unmodified = false, this._center = e2, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
              if (null == this._seaLevelZoom || !this._elevation) return;
              const e2 = this._seaLevelZoom, t2 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i2 = this.pixelsPerMeter / this.worldSize * t2, o2 = this._mercatorZfromZoom(e2), s2 = this._mercatorZfromZoom(this._maxZoom), r2 = Math.max(o2 - i2, s2);
              this._setZoom(this._zoomFromMercatorZ(r2));
            }
            get padding() {
              return this._edgeInsets.toJSON();
            }
            set padding(e2) {
              this._edgeInsets.equals(e2) || (this._unmodified = false, this._edgeInsets.interpolate(this._edgeInsets, e2, 1), this._calcMatrices());
            }
            computeZoomRelativeTo(t2) {
              const i2 = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t2.toAltitude()));
              let o2;
              o2 = t2.z < this._camera.position[2] ? [i2.x, i2.y, i2.z] : [t2.x, t2.y, t2.z];
              const s2 = e.ae(e.at([], this._camera.position, o2));
              return e.ay(this._zoomFromMercatorZ(s2), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(t2) {
              if (!this.height) return;
              if (!t2.position && !t2.orientation) return;
              this._updateCameraState();
              let i2 = false;
              if (t2.orientation && !e.ch(t2.orientation, this._camera.orientation) && (i2 = this._setCameraOrientation(t2.orientation)), t2.position) {
                const o2 = [t2.position.x, t2.position.y, t2.position.z];
                e.ci(o2, this._camera.position) || (this._setCameraPosition(o2), i2 = true);
              }
              i2 && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
              this._updateCameraState();
              const t2 = this._camera.position, i2 = new $i();
              return i2.position = new e.ac(t2[0], t2[1], t2[2]), i2.orientation = this._camera.orientation, i2._elevation = this.elevation, i2._renderWorldCopies = this.renderWorldCopies, i2;
            }
            _setCameraOrientation(t2) {
              if (!e.cj(t2)) return false;
              e.ck(t2, t2);
              const i2 = e.cl([], [0, 0, -1], t2), o2 = e.cl([], [0, -1, 0], t2);
              if (o2[2] < 0) return false;
              const s2 = Wi(i2, o2);
              return !!s2 && (this._camera.orientation = s2, true);
            }
            _setCameraPosition(t2) {
              const i2 = this.zoomScale(this.minZoom) * this.tileSize, o2 = this.zoomScale(this.maxZoom) * this.tileSize, s2 = this.cameraToCenterDistance;
              t2[2] = e.ay(t2[2], s2 / o2, s2 / i2), this._camera.position = t2;
            }
            get centerPoint() {
              return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
              return this._fov * (0.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e2) {
              return this._edgeInsets.equals(e2);
            }
            interpolatePadding(e2, t2, i2) {
              this._unmodified = false, this._edgeInsets.interpolate(e2, t2, i2), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e2) {
              const t2 = (e2.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e2.tileSize));
              return Math.max(0, t2);
            }
            getVisibleUnwrappedCoordinates(t2) {
              const i2 = [new e.cm(0, t2)];
              if (this.renderWorldCopies) {
                const o2 = this.pointCoordinate(new e.P(0, 0)), s2 = this.pointCoordinate(new e.P(this.width, 0)), r2 = this.pointCoordinate(new e.P(this.width, this.height)), n2 = this.pointCoordinate(new e.P(0, this.height)), a2 = Math.floor(Math.min(o2.x, s2.x, r2.x, n2.x)), l2 = Math.floor(Math.max(o2.x, s2.x, r2.x, n2.x)), c2 = 1;
                for (let o3 = a2 - c2; o3 <= l2 + c2; o3++) 0 !== o3 && i2.push(new e.cm(o3, t2));
              }
              return i2;
            }
            isLODDisabled(e2) {
              return (!e2 || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCover(t2, i2, o2) {
              let s2 = [];
              const r2 = null != o2, n2 = !r2;
              if (n2 && this.zoom < i2) return s2;
              if (r2 && 0 === o2[0] && 0 === o2[1]) return s2;
              const a2 = /* @__PURE__ */ new Set(), l2 = (t3, i3, o3, r3, n3) => {
                const l3 = e.cK(i3, t3, o3, r3, n3);
                a2.has(l3) || (s2.push(new e.aM(t3, i3, o3, r3, n3)), a2.add(l3));
              };
              for (let e2 = 0; e2 < t2.length; e2++) {
                const s3 = t2[e2];
                if (n2 && s3.canonical.z !== i2) continue;
                const a3 = s3.canonical, c3 = s3.overscaledZ, h3 = s3.wrap, d2 = 1 << a3.z, u2 = a3.x + 1 < d2, _2 = a3.x > 0, p3 = a3.y + 1 < d2, f2 = a3.y > 0, m2 = s3.wrap - (_2 ? 0 : 1), g2 = s3.wrap + (u2 ? 0 : 1), v2 = _2 ? a3.x - 1 : d2 - 1, y2 = u2 ? a3.x + 1 : 0;
                if (r2) o2[0] < 0 ? (l2(c3, g2, a3.z, y2, a3.y), o2[1] < 0 && p3 && (l2(c3, h3, a3.z, a3.x, a3.y + 1), l2(c3, g2, a3.z, y2, a3.y + 1)), o2[1] > 0 && f2 && (l2(c3, h3, a3.z, a3.x, a3.y - 1), l2(c3, g2, a3.z, y2, a3.y - 1))) : o2[0] > 0 ? (l2(c3, m2, a3.z, v2, a3.y), o2[1] < 0 && p3 && (l2(c3, h3, a3.z, a3.x, a3.y + 1), l2(c3, m2, a3.z, v2, a3.y + 1)), o2[1] > 0 && f2 && (l2(c3, h3, a3.z, a3.x, a3.y - 1), l2(c3, m2, a3.z, v2, a3.y - 1))) : o2[1] < 0 && p3 ? l2(c3, h3, a3.z, a3.x, a3.y + 1) : f2 && l2(c3, h3, a3.z, a3.x, a3.y - 1);
                else {
                  const e3 = s3.visibleQuadrants;
                  1 & e3 && (l2(c3, m2, a3.z, v2, a3.y), f2 && (l2(c3, h3, a3.z, a3.x, a3.y - 1), l2(c3, m2, a3.z, v2, a3.y - 1))), 2 & e3 && (l2(c3, g2, a3.z, y2, a3.y), f2 && (l2(c3, h3, a3.z, a3.x, a3.y - 1), l2(c3, g2, a3.z, y2, a3.y - 1))), 4 & e3 && (l2(c3, m2, a3.z, v2, a3.y), p3 && (l2(c3, h3, a3.z, a3.x, a3.y + 1), l2(c3, m2, a3.z, v2, a3.y + 1))), 8 & e3 && (l2(c3, g2, a3.z, y2, a3.y), p3 && (l2(c3, h3, a3.z, a3.x, a3.y + 1), l2(c3, g2, a3.z, y2, a3.y + 1)));
                }
              }
              const c2 = [];
              for (const e2 of s2) s2.some((t3) => e2.isChildOf(t3)) || c2.push(e2);
              if (s2 = c2.filter((e2) => !t2.some((t3) => !!(e2.overscaledZ < i2 && t3.isChildOf(e2)) || e2.equals(t3) || e2.isChildOf(t3))), n2) {
                const e2 = 1 << i2, t3 = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), o3 = [e2 * t3.x, e2 * t3.y], r3 = 4, n3 = r3 * r3;
                s2 = s2.filter((e3) => {
                  const t4 = e3.canonical.x + 0.5 - o3[0], i3 = e3.canonical.y + 0.5 - o3[1];
                  return t4 * t4 + i3 * i3 < n3;
                });
              }
              return s2;
            }
            coveringTiles(t2) {
              let i2 = this.coveringZoomLevel(t2);
              const o2 = i2, s2 = this.elevation && this.elevation.exaggeration(), r2 = s2 && !t2.isTerrainDEM, n2 = "mercator" === this.projection.name;
              if (void 0 !== t2.minzoom && i2 < t2.minzoom) return [];
              void 0 !== t2.maxzoom && i2 > t2.maxzoom && (i2 = t2.maxzoom);
              const a2 = this.locationCoordinate(this.center), l2 = this.center.lat, c2 = 1 << i2, h3 = [c2 * a2.x, c2 * a2.y, 0], d2 = "globe" === this.projection.name, u2 = !d2, _2 = e.cn.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i2, u2), p3 = d2 ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), f2 = c2 * e.c6(1, this.center.lat), m2 = this._camera.position[2] / e.c6(1, this.center.lat), g2 = [c2 * p3.x, c2 * p3.y, m2 * (u2 ? 1 : f2)], v2 = d2 || s2, y2 = this.cameraToCenterDistance / t2.tileSize * (t2.roundZoom ? 1 : 0.502), x2 = this.isLODDisabled(true) ? i2 : 0;
              let b2;
              if (this._elevation && t2.isTerrainDEM) b2 = 1e4 * this._elevation.exaggeration();
              else if (this._elevation) {
                const e2 = this._elevation.getMinMaxForVisibleTiles();
                b2 = e2 ? e2.max : this._centerAltitude;
              } else b2 = this._centerAltitude;
              const w2 = t2.isTerrainDEM ? -b2 : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, T2 = this.projection.isReprojectedInTileSpace ? e.co(this) : 1, E2 = (t3) => {
                const i3 = 1 / 4e4, o3 = new e.ac(t3.x + i3, t3.y, t3.z), s3 = new e.ac(t3.x, t3.y + i3, t3.z), r3 = t3.toLngLat(), n3 = o3.toLngLat(), a3 = s3.toLngLat(), l3 = this.locationCoordinate(r3), c3 = this.locationCoordinate(n3), h4 = this.locationCoordinate(a3), d3 = Math.hypot(c3.x - l3.x, c3.y - l3.y), u3 = Math.hypot(h4.x - l3.x, h4.y - l3.y);
                return Math.sqrt(d3 * u3) * T2 / i3;
              }, S2 = (t3) => {
                const i3 = b2, o3 = w2;
                return { aabb: e.cr(this, c2, 0, 0, 0, t3, o3, i3, this.projection), zoom: 0, x: 0, y: 0, minZ: o3, maxZ: i3, wrap: t3, fullyVisible: false };
              }, I2 = [];
              let C2 = [];
              const R2 = i2, D2 = t2.reparseOverscaled ? o2 : i2, A2 = (m2 - this._centerAltitude) * f2, L2 = (e2) => {
                if (!this._elevation || !e2.tileID || !n2) return;
                const t3 = this._elevation.getMinMaxForTile(e2.tileID), i3 = e2.aabb;
                t3 ? (i3.min[2] = t3.min, i3.max[2] = t3.max, i3.center[2] = (i3.min[2] + i3.max[2]) / 2) : (e2.shouldSplit = z2(e2), e2.shouldSplit || (i3.min[2] = i3.max[2] = i3.center[2] = this._centerAltitude));
              }, P2 = (e2, t3) => {
                if (0.707 * t3 < e2) return 1;
                const i3 = t3 / e2;
                return i3 / (1.4144271570014144 + (Math.pow(1.1, i3 - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
              }, z2 = (t3) => {
                if (t3.zoom < x2) return true;
                if (t3.zoom === R2) return false;
                if (null != t3.shouldSplit) return t3.shouldSplit;
                const i3 = t3.aabb.distanceX(g2), s3 = t3.aabb.distanceY(g2);
                let a3 = A2, c3 = 1;
                if (d2) {
                  a3 = t3.aabb.distanceZ(g2);
                  const i4 = Math.pow(2, t3.zoom), o3 = e.aY((t3.y + 1) / i4), s4 = e.aY(t3.y / i4), r3 = Math.min(Math.max(l2, o3), s4), n3 = e.cO(r3) / e.cO(l2);
                  if (c3 = r3 === l2 ? 1 / Math.max(1, this._mercatorScaleRatio - 0.3) : Math.min(1, n3 / this._mercatorScaleRatio), this.zoom <= e.cL && t3.zoom === R2 - 1 && n3 >= 0.9) return true;
                } else if (r2 && (a3 = t3.aabb.distanceZ(g2) * f2), this.projection.isReprojectedInTileSpace && o2 <= 5) {
                  const i4 = Math.pow(2, t3.zoom), o3 = E2(new e.ac((t3.x + 0.5) / i4, (t3.y + 0.5) / i4));
                  c3 = o3 > 0.85 ? 1 : o3;
                }
                if (!n2) {
                  const e2 = Math.sqrt(i3 * i3 + s3 * s3 + a3 * a3);
                  let o3 = (1 << R2 - t3.zoom) * y2 * c3;
                  return o3 *= P2(Math.max(a3, A2), e2), e2 < o3;
                }
                let u3 = Number.MAX_VALUE, _3 = 0;
                const p4 = t3.aabb.getCorners(), m3 = [];
                for (const t4 of p4) {
                  e.at(m3, t4, g2), d2 || (r2 ? m3[2] *= f2 : m3[2] = A2);
                  const i4 = e.bG(m3, this._camera.forward());
                  i4 < u3 && (u3 = i4, _3 = Math.abs(m3[2]));
                }
                let v3 = (1 << R2 - t3.zoom) * y2 * c3;
                if (v3 *= P2(Math.max(_3, A2), u3), u3 < v3) return true;
                const b3 = t3.aabb.closestPoint(h3);
                return b3[0] === h3[0] && b3[1] === h3[1];
              };
              if (this.renderWorldCopies) for (let e2 = 1; e2 <= 3; e2++) I2.push(S2(-e2)), I2.push(S2(e2));
              for (I2.push(S2(0)); I2.length > 0; ) {
                const o3 = I2.pop(), s3 = o3.x, a3 = o3.y;
                let l3 = o3.fullyVisible;
                const u3 = () => "globe" === this.projection.name && (0 === o3.y || o3.y === (1 << o3.zoom) - 1);
                if (!l3) {
                  let t3 = v2 ? o3.aabb.intersects(_2) : o3.aabb.intersectsFlat(_2);
                  if (0 === t3 && u3()) {
                    const i3 = new e.cp(o3.zoom, s3, a3);
                    t3 = e.cq(this, c2, i3, true).intersects(_2);
                  }
                  if (0 === t3) continue;
                  l3 = 2 === t3;
                }
                if (o3.zoom !== R2 && z2(o3)) for (let t3 = 0; t3 < 4; t3++) {
                  const i3 = (s3 << 1) + t3 % 2, h4 = (a3 << 1) + (t3 >> 1), u4 = { aabb: n2 ? o3.aabb.quadrant(t3) : e.cr(this, c2, o3.zoom + 1, i3, h4, o3.wrap, o3.minZ, o3.maxZ, this.projection), zoom: o3.zoom + 1, x: i3, y: h4, wrap: o3.wrap, fullyVisible: l3, tileID: void 0, shouldSplit: void 0, minZ: o3.minZ, maxZ: o3.maxZ };
                  r2 && !d2 && (u4.tileID = new e.aM(o3.zoom + 1 === R2 ? D2 : o3.zoom + 1, o3.wrap, o3.zoom + 1, i3, h4), L2(u4)), I2.push(u4);
                }
                else {
                  const r3 = o3.zoom === R2 ? D2 : o3.zoom;
                  if (t2.minzoom && t2.minzoom > r3) continue;
                  let n3 = 0;
                  if (!l3) {
                    let i3 = v2 ? o3.aabb.intersectsPrecise(_2) : o3.aabb.intersectsPreciseFlat(_2);
                    if (0 === i3 && u3()) {
                      const t3 = new e.cp(o3.zoom, s3, a3);
                      i3 = e.cq(this, c2, t3, true).intersectsPrecise(_2);
                    }
                    if (0 === i3) continue;
                    if (t2.calculateQuadrantVisibility) if (_2.containsPoint(o3.aabb.center)) n3 = 15;
                    else for (let e2 = 0; e2 < 4; e2++) 0 !== o3.aabb.quadrant(e2).intersects(_2) && (n3 |= 1 << e2);
                  }
                  const d3 = h3[0] - (0.5 + s3 + (o3.wrap << o3.zoom)) * (1 << i2 - o3.zoom), p4 = h3[1] - 0.5 - a3, f3 = o3.tileID ? o3.tileID : new e.aM(r3, o3.wrap, o3.zoom, s3, a3);
                  t2.calculateQuadrantVisibility && (f3.visibleQuadrants = n3), C2.push({ tileID: f3, distanceSq: d3 * d3 + p4 * p4 });
                }
              }
              if (this.fogCullDistSq) {
                const i3 = this.fogCullDistSq, o3 = this.horizonLineFromTop();
                C2 = C2.filter((s3) => {
                  const r3 = [0, 0, 0, 1], n3 = [e.aj, e.aj, 0, 1], a3 = this.calculateFogTileMatrix(s3.tileID.toUnwrapped());
                  e.aA(r3, r3, a3), e.aA(n3, n3, a3);
                  const l3 = e.cs([], r3, n3), c3 = e.ct([], r3, n3), h4 = e.cM(l3, c3);
                  if (0 === h4) return true;
                  let d3 = false;
                  const u3 = this._elevation;
                  if (u3 && h4 > i3 && 0 !== o3) {
                    const i4 = this.calculateProjMatrix(s3.tileID.toUnwrapped());
                    let r4;
                    t2.isTerrainDEM || (r4 = u3.getMinMaxForTile(s3.tileID)), r4 || (r4 = { min: w2, max: b2 });
                    const n4 = e.cu(this.rotation), a4 = [n4[0] * e.aj, n4[1] * e.aj, r4.max];
                    e.ad(a4, a4, i4), d3 = (1 - a4[1]) * this.height * 0.5 < o3;
                  }
                  return h4 < i3 || d3;
                });
              }
              return C2.sort((e2, t3) => e2.distanceSq - t3.distanceSq).map((e2) => e2.tileID);
            }
            resize(e2, t2) {
              this.width = e2, this.height = t2, this.pixelsToGLUnits = [2 / e2, -2 / t2], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
              return this._unmodified;
            }
            zoomScale(e2) {
              return Math.pow(2, e2);
            }
            scaleZoom(e2) {
              return Math.log(e2) / Math.LN2;
            }
            project(t2) {
              const i2 = e.ay(t2.lat, -85.051129, e.cv), o2 = this.projection.project(t2.lng, i2);
              return new e.P(o2.x * this.worldSize, o2.y * this.worldSize);
            }
            unproject(e2) {
              return this.projection.unproject(e2.x / this.worldSize, e2.y / this.worldSize);
            }
            get point() {
              return this.project(this.center);
            }
            get pointMerc() {
              return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
              return this.pixelsPerMeter / e.c6(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(t2, i2) {
              let o2, s2;
              const r2 = this.centerPoint;
              if ("globe" === this.projection.name) {
                const e2 = this.worldSize;
                o2 = (i2.x - r2.x) / e2, s2 = (i2.y - r2.y) / e2;
              } else {
                const e2 = this.pointCoordinate(i2), t3 = this.pointCoordinate(r2);
                o2 = e2.x - t3.x, s2 = e2.y - t3.y;
              }
              const n2 = this.locationCoordinate(t2);
              this.setLocation(new e.ac(n2.x - o2, n2.y - s2));
            }
            setLocation(e2) {
              this.center = this.coordinateLocation(e2), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e2, t2) {
              return this.projection.locationPoint(this, e2, t2);
            }
            locationPoint3D(e2, t2) {
              return this.projection.locationPoint(this, e2, t2, true);
            }
            pointLocation(e2) {
              return this.coordinateLocation(this.pointCoordinate(e2));
            }
            pointLocation3D(e2, t2) {
              return this.coordinateLocation(this.pointCoordinate3D(e2, t2));
            }
            locationCoordinate(t2, i2) {
              const o2 = i2 ? e.c6(i2, t2.lat) : void 0, s2 = this.projection.project(t2.lng, t2.lat);
              return new e.ac(s2.x, s2.y, o2);
            }
            coordinateLocation(e2) {
              return this.projection.unproject(e2.x, e2.y);
            }
            pointRayIntersection(t2, i2) {
              const o2 = null != i2 ? i2 : this._centerAltitude, s2 = [t2.x, t2.y, 0, 1], r2 = [t2.x, t2.y, 1, 1];
              e.aA(s2, s2, this.pixelMatrixInverse), e.aA(r2, r2, this.pixelMatrixInverse);
              const n2 = r2[3];
              e.cw(s2, s2, 1 / s2[3]), e.cw(r2, r2, 1 / n2);
              const a2 = s2[2], l2 = r2[2];
              return { p0: s2, p1: r2, t: a2 === l2 ? 0 : (o2 - a2) / (l2 - a2) };
            }
            screenPointToMercatorRay(t2) {
              const i2 = [t2.x, t2.y, 0, 1], o2 = [t2.x, t2.y, 1, 1];
              return e.aA(i2, i2, this.pixelMatrixInverse), e.aA(o2, o2, this.pixelMatrixInverse), e.cw(i2, i2, 1 / i2[3]), e.cw(o2, o2, 1 / o2[3]), i2[2] = e.c6(i2[2], this._center.lat) * this.worldSize, o2[2] = e.c6(o2[2], this._center.lat) * this.worldSize, e.cw(i2, i2, 1 / this.worldSize), e.cw(o2, o2, 1 / this.worldSize), new e.av([i2[0], i2[1], i2[2]], e.au([], e.at([], o2, i2)));
            }
            rayIntersectionCoordinate(t2) {
              const { p0: i2, p1: o2, t: s2 } = t2, r2 = e.c6(i2[2], this._center.lat), n2 = e.c6(o2[2], this._center.lat);
              return new e.ac(e.ai(i2[0], o2[0], s2) / this.worldSize, e.ai(i2[1], o2[1], s2) / this.worldSize, e.ai(r2, n2, s2));
            }
            pointCoordinate(e2, t2 = this._centerAltitude) {
              return this.projection.pointCoordinate(this, e2.x, e2.y, t2);
            }
            pointCoordinate3D(t2, i2) {
              if (!this.elevation) return this.pointCoordinate(t2, i2);
              let o2 = this.projection.pointCoordinate3D(this, t2.x, t2.y);
              if (o2) return new e.ac(o2[0], o2[1], o2[2]);
              let s2 = 0, r2 = this.horizonLineFromTop();
              if (t2.y > r2) return this.pointCoordinate(t2, i2);
              const n2 = 0.02 * r2, a2 = t2.clone();
              for (let t3 = 0; t3 < 10 && r2 - s2 > n2; t3++) {
                a2.y = e.ai(s2, r2, 0.66);
                const t4 = this.projection.pointCoordinate3D(this, a2.x, a2.y);
                t4 ? (r2 = a2.y, o2 = t4) : s2 = a2.y;
              }
              return o2 ? new e.ac(o2[0], o2[1], o2[2]) : this.pointCoordinate(t2);
            }
            isPointAboveHorizon(e2) {
              return this.projection.isPointAboveHorizon(this, e2);
            }
            isPointOnSurface(t2) {
              if (t2.y < 0 || t2.y > this.height || t2.x < 0 || t2.x > this.width) return false;
              if (this.elevation || this.zoom >= e.cx) return !this.isPointAboveHorizon(t2);
              const i2 = this.pointCoordinate(t2);
              return i2.y >= 0 && i2.y <= 1;
            }
            _coordinatePoint(t2, i2) {
              const o2 = i2 && this.elevation ? this.elevation.getAtPointOrZero(t2, this._centerAltitude) : this._centerAltitude, s2 = [t2.x * this.worldSize, t2.y * this.worldSize, o2 + t2.toAltitude(), 1];
              return e.aA(s2, s2, this.pixelMatrix), s2[3] > 0 ? new e.P(s2[0] / s2[3], s2[1] / s2[3]) : new e.P(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
              const { top: t2, left: i2 } = this._edgeInsets, o2 = this.height - this._edgeInsets.bottom, s2 = this.width - this._edgeInsets.right, r2 = this.pointLocation3D(new e.P(i2, t2)), n2 = this.pointLocation3D(new e.P(s2, t2)), a2 = this.pointLocation3D(new e.P(s2, o2)), l2 = this.pointLocation3D(new e.P(i2, o2));
              let c2 = Math.min(r2.lng, n2.lng, a2.lng, l2.lng), h3 = Math.max(r2.lng, n2.lng, a2.lng, l2.lng), d2 = Math.min(r2.lat, n2.lat, a2.lat, l2.lat), u2 = Math.max(r2.lat, n2.lat, a2.lat, l2.lat);
              const _2 = Math.pow(2, -this.zoom) / 16 * 270, p3 = "globe" === this.projection.name ? 1 : 4, f2 = (t3, i3, o3, s3, r3) => {
                const n3 = (t3 + o3) / 2, a3 = (i3 + s3) / 2, l3 = new e.P(n3, a3), { lng: m2, lat: g2 } = this.pointLocation3D(l3), v2 = Math.max(0, c2 - m2, d2 - g2, m2 - h3, g2 - u2);
                c2 = Math.min(c2, m2), h3 = Math.max(h3, m2), d2 = Math.min(d2, g2), u2 = Math.max(u2, g2), (r3 < p3 || v2 > _2) && (f2(t3, i3, n3, a3, r3 + 1), f2(n3, a3, o3, s3, r3 + 1));
              };
              if (f2(i2, t2, s2, t2, 1), f2(s2, t2, s2, o2, 1), f2(s2, o2, i2, o2, 1), f2(i2, o2, i2, t2, 1), "globe" === this.projection.name) {
                const [t3, i3] = e.cy(this);
                t3 ? (u2 = 90, h3 = 180, c2 = -180) : i3 && (d2 = -90, h3 = 180, c2 = -180);
              }
              return new e.aG(new e.cd(c2, d2), new e.cd(h3, u2));
            }
            _getBoundsRectangular(t2, i2) {
              const { top: o2, left: s2 } = this._edgeInsets, r2 = this.height - this._edgeInsets.bottom, n2 = this.width - this._edgeInsets.right, a2 = new e.P(s2, o2), l2 = new e.P(n2, o2), c2 = new e.P(n2, r2), h3 = new e.P(s2, r2);
              let d2 = this.pointCoordinate(a2, t2), u2 = this.pointCoordinate(l2, t2);
              const _2 = this.pointCoordinate(c2, i2), p3 = this.pointCoordinate(h3, i2), f2 = (e2, t3) => (t3.y - e2.y) / (t3.x - e2.x);
              return d2.y > 1 && u2.y >= 0 ? d2 = new e.ac((1 - p3.y) / f2(p3, d2) + p3.x, 1) : d2.y < 0 && u2.y <= 1 && (d2 = new e.ac(-p3.y / f2(p3, d2) + p3.x, 0)), u2.y > 1 && d2.y >= 0 ? u2 = new e.ac((1 - _2.y) / f2(_2, u2) + _2.x, 1) : u2.y < 0 && d2.y <= 1 && (u2 = new e.ac(-_2.y / f2(_2, u2) + _2.x, 0)), new e.aG().extend(this.coordinateLocation(d2)).extend(this.coordinateLocation(u2)).extend(this.coordinateLocation(p3)).extend(this.coordinateLocation(_2));
            }
            _getBoundsRectangularTerrain() {
              const e2 = this.elevation;
              if (!e2.visibleDemTiles.length || e2.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
              const t2 = e2.visibleDemTiles.reduce((e3, t3) => {
                if (t3.dem) {
                  const i2 = t3.dem.tree;
                  e3.min = Math.min(e3.min, i2.minimums[0]), e3.max = Math.max(e3.max, i2.maximums[0]);
                }
                return e3;
              }, { min: Number.MAX_VALUE, max: 0 });
              return this._getBoundsRectangular(t2.min * e2.exaggeration(), t2.max * e2.exaggeration());
            }
            getBounds() {
              return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e2 = true) {
              const t2 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, 0.1)) - this.centerOffset.y, i2 = this.height / 2 - t2 * (1 - this._horizonShift);
              return e2 ? Math.max(0, i2) : i2;
            }
            getMaxBounds() {
              return this.maxBounds;
            }
            setMaxBounds(t2) {
              this.maxBounds = t2, this.minLat = -85.051129, this.maxLat = e.cv, this.minLng = -180, this.maxLng = 180, t2 && (this.minLat = t2.getSouth(), this.maxLat = t2.getNorth(), this.minLng = t2.getWest(), this.maxLng = t2.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e.aD(this.minLng) * this.tileSize, this.worldMaxX = e.aD(this.maxLng) * this.tileSize, this.worldMinY = e.aH(this.maxLat) * this.tileSize, this.worldMaxY = e.aH(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e2, t2) {
              return this.projection.createTileMatrix(this, t2, e2);
            }
            calculateDistanceTileData(t2) {
              const i2 = t2.key, o2 = this._distanceTileDataCache;
              if (o2[i2]) return o2[i2];
              const s2 = t2.canonical, r2 = 1 / this.height, n2 = this.cameraWorldSize, a2 = n2 / this.zoomScale(s2.z), l2 = (s2.x + Math.pow(2, s2.z) * t2.wrap) * a2, c2 = s2.y * a2, h3 = this.point;
              h3.x *= n2 / this.worldSize, h3.y *= n2 / this.worldSize;
              const d2 = this.angle, u2 = Math.sin(-d2), _2 = -Math.cos(-d2);
              return o2[i2] = { bearing: [u2, _2], center: [(h3.x - l2) * r2, (h3.y - c2) * r2], scale: a2 / e.aj * r2 }, o2[i2];
            }
            calculateFogTileMatrix(t2) {
              const i2 = t2.key, o2 = this._fogTileMatrixCache;
              if (o2[i2]) return o2[i2];
              const s2 = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t2);
              return e.az(s2, this.worldToFogMatrix, s2), o2[i2] = new Float32Array(s2), o2[i2];
            }
            calculateProjMatrix(t2, i2 = false, o2 = false) {
              const s2 = t2.key;
              let r2;
              if (r2 = o2 ? this._expandedProjMatrixCache : i2 ? this._alignedProjMatrixCache : this._projMatrixCache, r2[s2]) return r2[s2];
              const n2 = this.calculatePosMatrix(t2, this.worldSize);
              let a2;
              return a2 = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : o2 ? this.expandedFarZProjMatrix : i2 ? this.alignedProjMatrix : this.projMatrix, e.az(n2, a2, n2), r2[s2] = new Float32Array(n2), r2[s2];
            }
            calculatePixelsToTileUnitsMatrix(t2) {
              const i2 = t2.tileID.key, o2 = this._pixelsToTileUnitsCache;
              if (o2[i2]) return o2[i2];
              const s2 = e.cz(t2, this);
              return o2[i2] = s2, o2[i2];
            }
            customLayerMatrix() {
              return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
              if ("globe" === this.projection.name) {
                const t2 = 1 / this.worldSize, i2 = e.bn([], [t2, t2, t2]);
                return e.az(i2, i2, this.globeMatrix), i2;
              }
            }
            recenterOnTerrain() {
              if (!this._elevation || "globe" === this.projection.name) return;
              const t2 = this._elevation;
              this._updateCameraState();
              const i2 = e.c6(1, this._center.lat) * this.worldSize, o2 = this._computeCameraPosition(i2), s2 = this._camera.forward(), r2 = e.c6(1, this._center.lat);
              o2[2] /= r2, s2[2] /= r2, e.au(s2, s2);
              const n2 = t2.raycast(o2, s2, t2.exaggeration());
              if (n2) {
                const t3 = e.bE([], o2, s2, n2), i3 = new e.ac(t3[0], t3[1], e.c6(t3[2], e.aY(t3[1]))), a2 = (i3.z + e.ae([i3.x - o2[0], i3.y - o2[1], i3.z - o2[2] * r2])) * this._pixelsPerMercatorPixel;
                this._seaLevelZoom = this._zoomFromMercatorZ(a2), this._centerAltitude = i3.toAltitude(), this._center = this.coordinateLocation(i3), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
              }
            }
            _constrainCamera(t2 = false) {
              if (!this._elevation) return;
              const i2 = this._elevation, o2 = e.c6(1, this._center.lat) * this.worldSize, s2 = this._computeCameraPosition(o2), r2 = i2.getAtPointOrZero(new e.ac(...s2)), n2 = this.pixelsPerMeter / this.worldSize * r2, a2 = this._minimumHeightOverTerrain(), l2 = s2[2] - n2;
              if (l2 <= a2) if (l2 < 0 || t2) {
                const t3 = this.locationCoordinate(this._center, this._centerAltitude), i3 = [s2[0], s2[1], t3.z - s2[2]], o3 = e.ae(i3);
                i3[2] -= (a2 - l2) / this._pixelsPerMercatorPixel;
                const r3 = e.ae(i3);
                if (0 === r3) return;
                e.bY(i3, i3, o3 / r3 * this._pixelsPerMercatorPixel), this._camera.position = [s2[0], s2[1], t3.z * this._pixelsPerMercatorPixel - i3[2]], this._updateStateFromCamera();
              } else this._isCameraConstrained = true;
            }
            _constrain() {
              if (!this.center || !this.width || !this.height || this._constraining) return;
              this._constraining = true;
              const t2 = "globe" === this.projection.name || this.mercatorFromTransition;
              if (this.projection.isReprojectedInTileSpace || t2) {
                const i3 = this.center;
                return i3.lat = e.ay(i3.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t2) && (i3.lng = e.ay(i3.lng, this.minLng, this.maxLng)), this.center = i3, void (this._constraining = false);
              }
              const i2 = this._unmodified, { x: o2, y: s2 } = this.point;
              let r2 = 0, n2 = o2, a2 = s2;
              const l2 = this.width / 2, c2 = this.height / 2, h3 = this.worldMinY * this.scale, d2 = this.worldMaxY * this.scale;
              if (s2 - c2 < h3 && (a2 = h3 + c2), s2 + c2 > d2 && (a2 = d2 - c2), d2 - h3 < this.height && (r2 = Math.max(r2, this.height / (d2 - h3)), a2 = (d2 + h3) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                const e2 = this.worldMinX * this.scale, t3 = this.worldMaxX * this.scale, i3 = this.worldSize / 2 - (e2 + t3) / 2;
                n2 = (o2 + i3 + this.worldSize) % this.worldSize - i3, n2 - l2 < e2 && (n2 = e2 + l2), n2 + l2 > t3 && (n2 = t3 - l2), t3 - e2 < this.width && (r2 = Math.max(r2, this.width / (t3 - e2)), n2 = (t3 + e2) / 2);
              }
              n2 === o2 && a2 === s2 || this._allowWorldUnderZoom || (this.center = this.unproject(new e.P(n2, a2))), r2 && !this._allowWorldUnderZoom && (this.zoom += this.scaleZoom(r2)), this._constrainCamera(), this._unmodified = i2, this._constraining = false;
            }
            _minZoomForBounds() {
              let e2 = Math.max(0, this.scaleZoom(Math.max(0, this.height) / (this.worldMaxY - this.worldMinY)));
              return this.maxBounds && (e2 = Math.max(e2, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e2;
            }
            _maxCameraBoundsDistance() {
              return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
              if (!this.height) return;
              const t2 = this.centerOffset, i2 = "globe" === this.projection.name, o2 = this.pixelsPerMeter;
              "globe" === this.projection.name && (this._mercatorScaleRatio = e.c6(1, this.center.lat) / e.c6(1, e.cP));
              const s2 = e.cA(this.projection, this.zoom, this.width, this.height, 1024);
              this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, s2), this.cameraToCenterDistance = 0.5 / Math.tan(0.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
              const r2 = "meters" === this.projection.zAxisUnit ? o2 : 1, n2 = this._camera.getWorldToCamera(this.worldSize, r2);
              let a2;
              const l2 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
              if (l2[8] = 2 * -t2.x / this.width, l2[9] = 2 * t2.y / this.height, this.isOrthographic) {
                let i3 = 0.5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(0.5 * this._fov), o3 = i3 * this.aspect, s3 = -o3, r3 = -i3;
                o3 -= t2.x, s3 -= t2.x, i3 += t2.y, r3 += t2.y, a2 = this._camera.getCameraToClipOrthographic(s3, o3, r3, i3, this._nearZ, this._farZ), ((t3, i4, o4, s4) => {
                  for (let r4 = 0; r4 < 16; r4++) t3[r4] = e.ai(i4[r4], o4[r4], s4);
                })(a2, a2, l2, e.cN(this.pitch >= Ji ? 1 : this.pitch / Ji));
              } else a2 = l2;
              const c2 = e.cB([], l2, n2);
              let h3 = e.cB([], a2, n2);
              if (this.projection.isReprojectedInTileSpace) {
                const t3 = this.locationCoordinate(this.center), i3 = e.bx([]);
                e.bo(i3, i3, [t3.x * this.worldSize, t3.y * this.worldSize, 0]), e.az(i3, i3, e.cC(this)), e.bo(i3, i3, [-t3.x * this.worldSize, -t3.y * this.worldSize, 0]), e.az(h3, h3, i3), e.az(c2, c2, i3), this.inverseAdjustmentMatrix = e.cD(this);
              } else this.inverseAdjustmentMatrix = [1, 0, 0, 1];
              if (this.mercatorMatrix = e.cE([], h3, [this.worldSize, this.worldSize, this.worldSize / r2, 1]), this.projMatrix = h3, this.invProjMatrix = e.bi(new Float64Array(16), this.projMatrix), i2) {
                const i3 = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                i3[8] = 2 * -t2.x / this.width, i3[9] = 2 * t2.y / this.height, this.expandedFarZProjMatrix = e.cB([], i3, n2);
              } else this.expandedFarZProjMatrix = this.projMatrix;
              const d2 = e.bi([], a2);
              this.frustumCorners = e.cF.fromInvProjectionMatrix(d2, this.horizonLineFromTop(), this.height), this.cameraFrustum = e.cn.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !i2);
              const u2 = new Float32Array(16);
              e.bx(u2), e.cE(u2, u2, [1, -1, 1]), e.cG(u2, u2, this._pitch), e.by(u2, u2, this.angle);
              const _2 = e.c4(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
              this.starsProjMatrix = e.bw(_2);
              const p3 = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
              _2[8] = 2 * -t2.x / this.width, _2[9] = 2 * (t2.y + p3) / this.height, this.skyboxMatrix = e.az(u2, _2, u2);
              const f2 = this.point, m2 = f2.x, g2 = f2.y, v2 = this.width % 2 / 2, y2 = this.height % 2 / 2, x2 = Math.cos(this.angle), b2 = Math.sin(this.angle), w2 = m2 - Math.round(m2) + x2 * v2 + b2 * y2, T2 = g2 - Math.round(g2) + x2 * y2 + b2 * v2, E2 = new Float64Array(h3);
              if (e.bo(E2, E2, [w2 > 0.5 ? w2 - 1 : w2, T2 > 0.5 ? T2 - 1 : T2, 0]), this.alignedProjMatrix = E2, h3 = e.bz(), e.cE(h3, h3, [this.width / 2, -this.height / 2, 1]), e.bo(h3, h3, [1, -1, 0]), this.labelPlaneMatrix = h3, h3 = e.bz(), e.cE(h3, h3, [1, -1, 1]), e.bo(h3, h3, [-1, -1, 0]), e.cE(h3, h3, [2 / this.width, 2 / this.height, 1]), this.glCoordMatrix = h3, this.pixelMatrix = e.az(new Float64Array(16), this.labelPlaneMatrix, c2), this._calcFogMatrices(), this._distanceTileDataCache = {}, h3 = e.bi(new Float64Array(16), this.pixelMatrix), !h3) throw new Error("failed to invert matrix");
              if (this.pixelMatrixInverse = h3, "globe" === this.projection.name || this.mercatorFromTransition) {
                this.globeMatrix = e.cH(this);
                const t3 = [this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]];
                this.globeCenterInViewSpace = e.ad(t3, t3, n2), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
              } else this.globeMatrix = h3;
              this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
            }
            _calcFogMatrices() {
              this._fogTileMatrixCache = {};
              const t2 = this.cameraWorldSizeForFog, i2 = this.cameraPixelsPerMeter, o2 = this._camera.position, s2 = 1 / this.height / this._pixelsPerMercatorPixel, r2 = [t2, t2, i2];
              e.bY(r2, r2, s2), e.bY(o2, o2, -1), e.cI(o2, o2, r2);
              const n2 = e.bz();
              e.bo(n2, n2, o2), e.cE(n2, n2, r2), this.mercatorFogMatrix = n2, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t2, i2, s2);
            }
            _computeCameraPosition(e2) {
              const t2 = (e2 = e2 || this.pixelsPerMeter) / this.pixelsPerMeter, i2 = this._camera.forward(), o2 = this.point, s2 = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t2 - e2 / this.worldSize * this._centerAltitude;
              return [o2.x / this.worldSize - i2[0] * s2, o2.y / this.worldSize - i2[1] * s2, e2 / this.worldSize * this._centerAltitude - i2[2] * s2];
            }
            _updateCameraState() {
              this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(t2) {
              const i2 = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o2 = this._camera.position[2], s2 = t2[2];
              let r2 = 1;
              this.projection.wrap && (this.center = this.center.wrap()), s2 > 0 && (r2 = Math.min((i2 - o2) / s2, 1)), this._camera.position = e.bE([], this._camera.position, t2, r2), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
              const t2 = this._camera.position, i2 = this._camera.forward(), { pitch: o2, bearing: s2 } = this._camera.getPitchBearing(), r2 = e.c6(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, n2 = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e.al(this._maxPitch)), a2 = Math.max((t2[2] - r2) / Math.cos(o2), n2), l2 = this._zoomFromMercatorZ(a2);
              e.bE(t2, t2, i2, a2), this._pitch = e.ay(o2, e.al(this.minPitch), e.al(this.maxPitch)), this.angle = e.bX(s2, -Math.PI, Math.PI), this._setZoom(e.ay(l2, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e.ac(t2[0], t2[1], t2[2])), this._unmodified = false, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e2) {
              return Math.pow(2, e2) * this.tileSize;
            }
            _mercatorZfromZoom(e2) {
              return this.cameraToCenterDistance / this._worldSizeFromZoom(e2);
            }
            _minimumHeightOverTerrain() {
              const e2 = Math.min(null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
              return this._mercatorZfromZoom(e2);
            }
            _zoomFromMercatorZ(e2) {
              return this.scaleZoom(this.cameraToCenterDistance / (Math.max(0, e2) * this.tileSize));
            }
            zoomFromMercatorZAdjusted(t2) {
              let i2 = 0, o2 = e.cx, s2 = 0, r2 = 1 / 0;
              for (; o2 - i2 > 1e-6 && o2 > i2; ) {
                const e2 = i2 + 0.5 * (o2 - i2), n2 = this.tileSize * Math.pow(2, e2), a2 = this.getCameraToCenterDistance(this.projection, e2, n2), l2 = this.scaleZoom(a2 / (Math.max(0, t2) * this.tileSize)), c2 = Math.abs(e2 - l2);
                c2 < r2 && (r2 = c2, s2 = e2), e2 < l2 ? i2 = e2 : o2 = e2;
              }
              return s2;
            }
            _terrainEnabled() {
              return !(!this._elevation || !this.projection.supportsTerrain && (e.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(t2, i2) {
              const o2 = Math.min(t2.x, i2.x), s2 = Math.max(t2.x, i2.x), r2 = Math.min(t2.y, i2.y), n2 = Math.max(t2.y, i2.y);
              if (r2 < this.horizonLineFromTop(false)) return true;
              if ("mercator" !== this.projection.name) return false;
              const a2 = [new e.P(o2, r2), new e.P(s2, n2), new e.P(o2, n2), new e.P(s2, r2)], l2 = this.renderWorldCopies ? -3 : 0, c2 = this.renderWorldCopies ? 4 : 1;
              for (const e2 of a2) {
                const t3 = this.pointRayIntersection(e2);
                if (t3.t < 0) return true;
                const i3 = this.rayIntersectionCoordinate(t3);
                if (i3.x < l2 || i3.y < 0 || i3.x > c2 || i3.y > 1) return true;
              }
              return false;
            }
            isHorizonVisible() {
              return this.pitch + e.cJ(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e.P(0, 0), new e.P(this.width, this.height));
            }
            zoomDeltaToMovement(t2, i2) {
              const o2 = e.ae(e.at([], this._camera.position, t2)), s2 = this._zoomFromMercatorZ(o2) + i2;
              return o2 - this._mercatorZfromZoom(s2);
            }
            getCameraPoint() {
              if ("globe" === this.projection.name) {
                const t2 = function([t3, i2, o2], s2) {
                  const r2 = [t3, i2, o2, 1];
                  e.aA(r2, r2, s2);
                  const n2 = r2[3] = Math.max(r2[3], 1e-6);
                  return r2[0] /= n2, r2[1] /= n2, r2[2] /= n2, r2;
                }([this.globeMatrix[12], this.globeMatrix[13], this.globeMatrix[14]], this.pixelMatrix);
                return new e.P(t2[0], t2[1]);
              }
              {
                const t2 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                return this.centerPoint.add(new e.P(0, t2));
              }
            }
            getCameraToCenterDistance(t2, i2 = this.zoom, o2 = this.worldSize) {
              const s2 = e.cA(t2, i2, this.width, this.height, 1024), r2 = t2.pixelSpaceConversion(this.center.lat, o2, s2);
              let n2 = 0.5 / Math.tan(0.5 * this._fov) * this.height * r2;
              return this.isOrthographic && (n2 = e.ai(1, n2, e.cN(this.pitch >= Ji ? 1 : this.pitch / Ji))), n2;
            }
            getWorldToCameraMatrix() {
              const t2 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
              return "globe" === this.projection.name && e.az(t2, t2, this.globeMatrix), t2;
            }
            getFrustum(t2) {
              return e.cn.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t2, "meters" === this.projection.zAxisUnit);
            }
          }
          const eo = (t2, i2) => {
            if (i2 > 0 && t2.terrain && e.w("Cutoff is currently disabled on terrain"), i2 <= 0 || t2.terrain) return { shouldRenderCutoff: false, uniformValues: { u_cutoff_params: [0, 0, 0, 1] } };
            const o2 = t2.transform, s2 = Math.max(Math.abs(o2._zoom - (t2.minCutoffZoom - 1)), 1), r2 = o2.isLODDisabled(false) ? e.af(60, 45, o2.pitch) : e.af(30, 15, o2.pitch), n2 = o2._farZ - o2._nearZ, a2 = i2 * o2.height, l2 = ((1 - (c2 = r2)) * o2.cameraToCenterDistance + c2 * (o2._farZ + a2)) * s2;
            var c2;
            return { shouldRenderCutoff: r2 < 1, uniformValues: { u_cutoff_params: [o2._nearZ, o2._farZ, (l2 - o2._nearZ) / n2, (l2 - a2 - o2._nearZ) / n2] } };
          }, to = { cascadeCount: 2, normalOffset: 3, shadowMapResolution: 2048 };
          class io {
            constructor(e2, t2) {
              this.aabb = e2, this.lastCascade = t2;
            }
          }
          class oo {
            add(e2, t2) {
              const i2 = this.receivers[e2.key];
              void 0 !== i2 ? (i2.aabb.min[0] = Math.min(i2.aabb.min[0], t2.min[0]), i2.aabb.min[1] = Math.min(i2.aabb.min[1], t2.min[1]), i2.aabb.min[2] = Math.min(i2.aabb.min[2], t2.min[2]), i2.aabb.max[0] = Math.max(i2.aabb.max[0], t2.max[0]), i2.aabb.max[1] = Math.max(i2.aabb.max[1], t2.max[1]), i2.aabb.max[2] = Math.max(i2.aabb.max[2], t2.max[2])) : this.receivers[e2.key] = new io(t2, null);
            }
            clear() {
              this.receivers = {};
            }
            get(e2) {
              return this.receivers[e2.key];
            }
            computeRequiredCascades(t2, i2, o2) {
              const s2 = e.cW.fromPoints(t2.points);
              let r2 = 0;
              for (const t3 in this.receivers) {
                const n2 = this.receivers[t3];
                if (!n2) continue;
                if (!s2.intersectsAabb(n2.aabb)) continue;
                n2.aabb.min = s2.closestPoint(n2.aabb.min), n2.aabb.max = s2.closestPoint(n2.aabb.max);
                const a2 = n2.aabb.getCorners();
                for (let t4 = 0; t4 < o2.length; t4++) {
                  let s3 = true;
                  for (const r3 of a2) {
                    const n3 = [r3[0] * i2, r3[1] * i2, r3[2]];
                    if (e.ad(n3, n3, o2[t4].matrix), n3[0] < -1 || n3[0] > 1 || n3[1] < -1 || n3[1] > 1) {
                      s3 = false;
                      break;
                    }
                  }
                  if (n2.lastCascade = t4, r2 = Math.max(r2, t4), s3) break;
                }
              }
              return r2 + 1;
            }
          }
          class so {
            constructor(e2) {
              this.painter = e2, this._enabled = false, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new oo(), this._depthMode = new Ni(e2.context.gl.LEQUAL, Ni.ReadWrite, [0, 1]), this._uniformValues = { u_light_matrix_0: new Float32Array(16), u_light_matrix_1: new Float32Array(16), u_shadow_intensity: 0, u_fade_range: [0, 0], u_shadow_normal_offset: [1, 1, 1], u_shadow_texel_size: 1, u_shadow_map_resolution: 1, u_shadow_direction: [0, 0, 1], u_shadow_bias: [36e-5, 12e-4, 0.012], u_shadowmap_0: 0, u_shadowmap_1: 0 }, this._forceDisable = false, this.useNormalOffset = false, e2.tp.registerParameter(this, ["Shadows"], "_forceDisable", { label: "forceDisable" }, () => {
                this.painter.style.map.triggerRepaint();
              }), e2.tp.registerParameter(to, ["Shadows"], "cascadeCount", { min: 1, max: 2, step: 1 }), e2.tp.registerParameter(to, ["Shadows"], "normalOffset", { min: 0, max: 10, step: 0.05 }), e2.tp.registerParameter(to, ["Shadows"], "shadowMapResolution", { min: 32, max: 2048, step: 32 }), e2.tp.registerBinding(this, ["Shadows"], "_numCascadesToRender", { readonly: true, label: "numCascadesToRender" });
            }
            destroy() {
              for (const e2 of this._cascades) e2.texture.destroy(), e2.framebuffer.destroy();
              this._cascades = [];
            }
            updateShadowParameters(t2, i2) {
              const o2 = this.painter;
              if (this._enabled = false, this._shadowLayerCount = 0, this._receivers.clear(), !i2 || !i2.properties) return;
              const s2 = i2.properties.get("shadow-intensity");
              if (!i2.shadowsEnabled() || s2 <= 0) return;
              if (this._shadowLayerCount = o2.style.order.reduce((e2, i3) => {
                const s3 = o2.style._mergedLayers[i3];
                return e2 + (s3.hasShadowPass() && !s3.isHidden(t2.zoom) ? 1 : 0);
              }, 0), this._enabled = this._shadowLayerCount > 0, !this.enabled) return;
              const r2 = o2.context, n2 = to.shadowMapResolution, a2 = to.shadowMapResolution;
              if (0 === this._cascades.length || to.shadowMapResolution !== this._cascades[0].texture.size[0]) {
                this._cascades = [];
                for (let t3 = 0; t3 < to.cascadeCount; ++t3) {
                  const t4 = o2._shadowMapDebug, i3 = r2.gl, s3 = r2.createFramebuffer(n2, a2, t4, "texture"), l3 = new e.T(r2, { width: n2, height: a2, data: null }, i3.DEPTH_COMPONENT16);
                  if (s3.depthAttachment.set(l3.texture), t4) {
                    const t5 = new e.T(r2, { width: n2, height: a2, data: null }, i3.RGBA8);
                    s3.colorAttachment.set(t5.texture);
                  }
                  this._cascades.push({ framebuffer: s3, texture: l3, matrix: [], far: 0, boundingSphereRadius: 0, frustum: new e.cn(), scale: 0 });
                }
              }
              this.shadowDirection = no(i2);
              let l2 = 0;
              if (t2.elevation) {
                const e2 = t2.elevation, i3 = [1e4, -1e4];
                e2.visibleDemTiles.filter((e3) => e3.dem).forEach((e3) => {
                  const t3 = e3.dem.tree;
                  i3[0] = Math.min(i3[0], t3.minimums[0]), i3[1] = Math.max(i3[1], t3.maximums[0]);
                }), 1e4 !== i3[0] && (l2 = (i3[1] - i3[0]) * e2.exaggeration());
              }
              const c2 = 1.5 * t2.cameraToCenterDistance, h3 = 3 * c2, d2 = new Float64Array(16);
              for (let i3 = 0; i3 < this._cascades.length; ++i3) {
                const o3 = this._cascades[i3];
                let s3 = t2.height / 50, r3 = 1;
                1 === to.cascadeCount ? r3 = h3 : 0 === i3 ? r3 = c2 : (s3 = c2, r3 = h3);
                const [n3, a3] = lo(t2, this.shadowDirection, s3, r3, to.shadowMapResolution, l2);
                o3.scale = t2.scale, o3.matrix = n3, o3.boundingSphereRadius = a3, e.bi(d2, o3.matrix), o3.frustum = e.cn.fromInvProjectionMatrix(d2, 1, 0, true), o3.far = r3;
              }
              const u2 = this._cascades.length - 1;
              this._uniformValues.u_fade_range = [0.75 * this._cascades[u2].far, this._cascades[u2].far], this._uniformValues.u_shadow_intensity = s2, this._uniformValues.u_shadow_direction = [this.shadowDirection[0], this.shadowDirection[1], this.shadowDirection[2]], this._uniformValues.u_shadow_texel_size = 1 / to.shadowMapResolution, this._uniformValues.u_shadow_map_resolution = to.shadowMapResolution, this._uniformValues.u_shadowmap_0 = Yi.ShadowMap0, this._uniformValues.u_shadowmap_1 = Yi.ShadowMap0 + 1, this._groundShadowTiles = o2.transform.coveringTiles({ tileSize: 512, renderWorldCopies: true });
              const _2 = o2.transform.elevation;
              for (const e2 of this._groundShadowTiles) {
                let t3 = { min: 0, max: 0 };
                if (_2) {
                  const i3 = _2.getMinMaxForTile(e2);
                  i3 && (t3 = i3);
                }
                this.addShadowReceiver(e2.toUnwrapped(), t3.min, t3.max);
              }
            }
            get enabled() {
              return this._enabled && !this._forceDisable;
            }
            set enabled(e2) {
              this._enabled = e2;
            }
            drawShadowPass(t2, i2) {
              if (!this.enabled) return;
              const o2 = this.painter, s2 = o2.context;
              this._numCascadesToRender = this._receivers.computeRequiredCascades(o2.transform.getFrustum(0), o2.transform.worldSize, this._cascades), s2.viewport.set([0, 0, to.shadowMapResolution, to.shadowMapResolution]);
              for (let r2 = 0; r2 < this._numCascadesToRender; ++r2) {
                o2.currentShadowCascade = r2, s2.bindFramebuffer.set(this._cascades[r2].framebuffer.framebuffer), s2.clear({ color: e.am.white, depth: 1 });
                for (const e2 of t2.order) {
                  const s3 = t2._mergedLayers[e2];
                  if (!s3.hasShadowPass() || s3.isHidden(o2.transform.zoom)) continue;
                  const r3 = t2.getLayerSourceCache(s3), n2 = r3 ? i2[r3.id] : void 0;
                  ("model" === s3.type || n2 && n2.length) && o2.renderLayer(o2, r3, s3, n2);
                }
              }
              o2.currentShadowCascade = 0;
            }
            drawGroundShadows() {
              if (!this.enabled) return;
              const e2 = this.painter, t2 = e2.style, i2 = e2.context, o2 = i2.gl, s2 = t2.directionalLight, r2 = t2.ambientLight;
              if (!s2 || !r2) return;
              const n2 = [], a2 = eo(e2, e2.longestCutoffRange);
              a2.shouldRenderCutoff && n2.push("RENDER_CUTOFF"), n2.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), this.useNormalOffset && n2.push("NORMAL_OFFSET");
              const l2 = ao(t2, s2, r2), c2 = new Ni(o2.LEQUAL, Ni.ReadOnly, e2.depthRangeFor3D), h3 = new ji({ func: o2.EQUAL, mask: 255 }, 0, 255, o2.KEEP, o2.KEEP, o2.KEEP);
              for (const t3 of this._groundShadowTiles) {
                const s3 = t3.toUnwrapped(), r3 = e2.isTileAffectedByFog(t3), d2 = e2.getOrCreateProgram("groundShadow", { defines: n2, overrideFog: r3 });
                this.setupShadows(s3, d2), e2.uploadCommonUniforms(i2, d2, s3, null, a2);
                const u2 = { u_matrix: e2.transform.calculateProjMatrix(s3), u_ground_shadow_factor: l2 };
                d2.draw(e2, o2.TRIANGLES, c2, h3, ki.multiply, qi.disabled, u2, "ground_shadow", e2.tileExtentBuffer, e2.quadTriangleIndexBuffer, e2.tileExtentSegments, null, e2.transform.zoom, null, null);
              }
            }
            getShadowPassColorMode() {
              return this.painter._shadowMapDebug ? ki.unblended : ki.disabled;
            }
            getShadowPassDepthMode() {
              return this._depthMode;
            }
            getShadowCastingLayerCount() {
              return this._shadowLayerCount;
            }
            calculateShadowPassMatrixFromTile(t2) {
              const i2 = this.painter.transform, o2 = i2.calculatePosMatrix(t2, i2.worldSize);
              return e.az(o2, this._cascades[this.painter.currentShadowCascade].matrix, o2), Float32Array.from(o2);
            }
            calculateShadowPassMatrixFromMatrix(t2) {
              return e.az(t2, this._cascades[this.painter.currentShadowCascade].matrix, t2), Float32Array.from(t2);
            }
            setupShadows(t2, i2, o2, s2 = 0) {
              if (!this.enabled) return;
              const r2 = this.painter.transform, n2 = this.painter.context, a2 = n2.gl, l2 = this._uniformValues, c2 = new Float64Array(16), h3 = r2.calculatePosMatrix(t2, r2.worldSize);
              for (let t3 = 0; t3 < this._cascades.length; t3++) e.az(c2, this._cascades[t3].matrix, h3), l2[0 === t3 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(c2), n2.activeTexture.set(a2.TEXTURE0 + Yi.ShadowMap0 + t3), this._cascades[t3].texture.bindExtraParam(a2.LINEAR, a2.LINEAR, a2.CLAMP_TO_EDGE, a2.CLAMP_TO_EDGE, a2.GREATER);
              if (this.useNormalOffset = !!o2, this.useNormalOffset) {
                const i3 = e.cU(t2.canonical), n3 = 2 / r2.tileSize * e.aj / to.shadowMapResolution, a3 = n3 * this._cascades[0].boundingSphereRadius, c3 = n3 * this._cascades[this._cascades.length - 1].boundingSphereRadius, h4 = ("vector-tile" === o2 ? 1 : 3) / Math.pow(2, s2 - t2.canonical.z - (1 - r2.zoom + Math.floor(r2.zoom)));
                l2.u_shadow_normal_offset = [i3, a3 * h4, c3 * h4], l2.u_shadow_bias = [6e-5, 12e-4, 0.012];
              } else l2.u_shadow_bias = [36e-5, 12e-4, 0.012];
              i2.setShadowUniformValues(n2, l2);
            }
            setupShadowsFromMatrix(t2, i2, o2 = false) {
              if (!this.enabled) return;
              const s2 = this.painter.context, r2 = s2.gl, n2 = this._uniformValues, a2 = new Float64Array(16);
              for (let i3 = 0; i3 < to.cascadeCount; i3++) e.az(a2, this._cascades[i3].matrix, t2), n2[0 === i3 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(a2), s2.activeTexture.set(r2.TEXTURE0 + Yi.ShadowMap0 + i3), this._cascades[i3].texture.bindExtraParam(r2.LINEAR, r2.LINEAR, r2.CLAMP_TO_EDGE, r2.CLAMP_TO_EDGE, r2.GREATER);
              if (this.useNormalOffset = o2, o2) {
                const e2 = to.normalOffset;
                n2.u_shadow_normal_offset = [1, e2, e2], n2.u_shadow_bias = [6e-5, 12e-4, 0.012];
              } else n2.u_shadow_bias = [36e-5, 12e-4, 0.012];
              i2.setShadowUniformValues(s2, n2);
            }
            getShadowUniformValues() {
              return this._uniformValues;
            }
            getCurrentCascadeFrustum() {
              return this._cascades[this.painter.currentShadowCascade].frustum;
            }
            computeSimplifiedTileShadowVolume(t2, i2, o2, s2) {
              if (s2[2] >= 0) return {};
              const r2 = function(t3, i3, o3) {
                const s3 = o3 / (1 << t3.canonical.z);
                return new e.cW([t3.canonical.x * s3 + t3.wrap * o3, t3.canonical.y * s3 + t3.wrap * o3, 0], [(t3.canonical.x + 1) * s3 + t3.wrap * o3, (t3.canonical.y + 1) * s3 + t3.wrap * o3, i3]);
              }(t2, i2, o2).getCorners(), n2 = i2 / -s2[2];
              s2[0] < 0 ? (e.cV(r2[0], r2[0], [s2[0] * n2, 0, 0]), e.cV(r2[3], r2[3], [s2[0] * n2, 0, 0])) : s2[0] > 0 && (e.cV(r2[1], r2[1], [s2[0] * n2, 0, 0]), e.cV(r2[2], r2[2], [s2[0] * n2, 0, 0])), s2[1] < 0 ? (e.cV(r2[0], r2[0], [0, s2[1] * n2, 0]), e.cV(r2[1], r2[1], [0, s2[1] * n2, 0])) : s2[1] > 0 && (e.cV(r2[2], r2[2], [0, s2[1] * n2, 0]), e.cV(r2[3], r2[3], [0, s2[1] * n2, 0]));
              const a2 = {};
              return a2.vertices = r2, a2.planes = [ro(r2[1], r2[0], r2[4]), ro(r2[2], r2[1], r2[5]), ro(r2[3], r2[2], r2[6]), ro(r2[0], r2[3], r2[7])], a2;
            }
            addShadowReceiver(t2, i2, o2) {
              this._receivers.add(t2, e.cW.fromTileIdAndHeight(t2, i2, o2));
            }
            getMaxCascadeForTile(e2) {
              const t2 = this._receivers.get(e2);
              return t2 && t2.lastCascade ? t2.lastCascade : 0;
            }
          }
          function ro(t2, i2, o2) {
            const s2 = e.at([], o2, i2), r2 = e.at([], t2, i2), n2 = e.bF([], s2, r2), a2 = e.ae(n2);
            return 0 === a2 ? [0, 0, 1, 0] : (e.bY(n2, n2, 1 / a2), [n2[0], n2[1], n2[2], -e.bG(n2, i2)]);
          }
          function no(t2) {
            const i2 = t2.properties.get("direction"), o2 = e.cR(i2.x, i2.y, i2.z);
            o2[2] = e.ay(o2[2], 0, 75);
            const s2 = e.cT([o2[0], o2[1], o2[2]]);
            return e.cS(s2.x, s2.y, s2.z);
          }
          function ao(t2, i2, o2) {
            const s2 = "none" === i2.properties.get("color-use-theme"), r2 = i2.properties.get("color"), n2 = i2.properties.get("intensity"), a2 = i2.properties.get("direction"), l2 = [a2.x, a2.y, a2.z], c2 = "none" === o2.properties.get("color-use-theme"), h3 = o2.properties.get("color"), d2 = o2.properties.get("intensity"), u2 = Math.max(e.bG([0, 0, 1], l2), 0), _2 = [0, 0, 0];
            e.bY(_2, h3.toPremultipliedRenderColor(c2 ? null : t2.getLut(i2.scope)).toArray01Linear().slice(0, 3), d2);
            const p3 = [0, 0, 0];
            return e.bY(p3, r2.toPremultipliedRenderColor(s2 ? null : t2.getLut(o2.scope)).toArray01Linear().slice(0, 3), u2 * n2), e.cY([_2[0] > 0 ? _2[0] / (_2[0] + p3[0]) : 0, _2[1] > 0 ? _2[1] / (_2[1] + p3[1]) : 0, _2[2] > 0 ? _2[2] / (_2[2] + p3[2]) : 0]);
          }
          function lo(t2, i2, o2, s2, r2, n2) {
            const a2 = t2.zoom, l2 = t2.scale, c2 = t2.worldSize, h3 = 1 / c2, d2 = t2.aspect, u2 = Math.sqrt(1 + d2 * d2) * Math.tan(0.5 * t2.fovX), _2 = u2 * u2, p3 = s2 - o2, f2 = s2 + o2;
            let m2, g2;
            _2 > p3 / f2 ? (m2 = s2, g2 = s2 * u2) : (m2 = 0.5 * f2 * (1 + _2), g2 = 0.5 * Math.sqrt(p3 * p3 + 2 * (s2 * s2 + o2 * o2) * _2 + f2 * f2 * _2 * _2));
            const v2 = t2.projection.pixelsPerMeter(t2.center.lat, c2), y2 = t2._camera.getCameraToWorldMercator(), x2 = [0, 0, -m2 * h3];
            e.ad(x2, x2, y2);
            let b2 = g2 * h3;
            const w2 = t2._edgeInsets;
            if (!(0 === w2.left && 0 === w2.top && 0 === w2.right && 0 === w2.bottom || w2.left === w2.right && w2.top === w2.bottom)) {
              const i3 = t2._camera.getWorldToCamera(t2.worldSize, "meters" === t2.projection.zAxisUnit ? v2 : 1), r3 = t2._camera.getCameraToClipPerspective(t2._fov, t2.width / t2.height, o2, s2);
              r3[8] = 2 * -t2.centerOffset.x / t2.width, r3[9] = 2 * t2.centerOffset.y / t2.height;
              const n3 = new Float64Array(16);
              e.cB(n3, r3, i3);
              const h4 = new Float64Array(16);
              e.bi(h4, n3);
              const d3 = e.cn.fromInvProjectionMatrix(h4, c2, a2, true);
              for (const i4 of d3.points) {
                const o3 = ((T2 = i4)[0] /= l2, T2[1] /= l2, T2[2] = e.c6(T2[2], t2._center.lat), T2);
                b2 = Math.max(b2, e.bZ(e.cX([], x2, o3)));
              }
            }
            var T2;
            b2 *= r2 / (r2 - 1);
            const E2 = Math.acos(i2[2]), S2 = Math.atan2(-i2[0], -i2[1]), I2 = new Xi();
            I2.position = x2, I2.setPitchBearing(E2, S2);
            const C2 = I2.getWorldToCamera(c2, v2), R2 = b2 * c2, D2 = Math.min(t2._mercatorZfromZoom(17) * c2 * -2, -2 * R2), A2 = I2.getCameraToClipOrthographic(-R2, R2, -R2, R2, D2, (R2 + n2 * v2) / i2[2]), L2 = new Float64Array(16);
            e.az(L2, A2, C2);
            const P2 = e.cS(Math.floor(1e6 * x2[0]) / 1e6 * c2, Math.floor(1e6 * x2[1]) / 1e6 * c2, 0), z2 = 0.5 * r2, M2 = [0, 0, 0];
            e.ad(M2, P2, L2), e.bY(M2, M2, z2);
            const O2 = [Math.floor(M2[0]), Math.floor(M2[1]), Math.floor(M2[2])], F2 = [0, 0, 0];
            e.at(F2, M2, O2), e.bY(F2, F2, -1 / z2);
            const B2 = new Float64Array(16);
            return e.bx(B2), e.bo(B2, B2, F2), e.az(L2, B2, L2), [L2, R2];
          }
          class co extends e.E {
            constructor(e2) {
              super(), this.requestManager = e2, this.models = { "": {} }, this.modelUris = { "": {} }, this.modelByURL = {}, this.numModelsLoading = {};
            }
            loadModel(t2, i2) {
              return e.aS(this.requestManager.transformRequest(i2, e.R.Model).url).then((i3) => {
                if (!i3) return;
                const o2 = e.aT(i3), s2 = new e.aU(t2, void 0, void 0, o2);
                return s2.computeBoundsAndApplyParent(), s2;
              }).catch((o2) => {
                if (o2 && 404 === o2.status) return null;
                this.fire(new e.z(new Error(`Could not load model ${t2} from ${i2}: ${o2.message}`)));
              });
            }
            load(t2, i2, o2 = { forceReload: false }) {
              this.models[i2] || (this.models[i2] = {});
              const s2 = Object.keys(t2), r2 = [], n2 = [];
              for (const e2 of s2) {
                const s3 = t2[e2];
                this.hasURLBeenRequested(s3) && !o2.forceReload || (this.modelByURL[s3] = { modelId: e2, scope: i2 }, r2.push(this.loadModel(e2, s3)), n2.push(e2)), this.models[i2][e2] || (this.models[i2][e2] = { model: null, numReferences: 1 });
              }
              this.numModelsLoading[i2] = (this.numModelsLoading[i2] || 0) + n2.length, Promise.allSettled(r2).then((t3) => {
                for (let e2 = 0; e2 < t3.length; e2++) {
                  const { status: o3 } = t3[e2];
                  if ("rejected" === o3) continue;
                  const { value: s3 } = t3[e2];
                  this.models[i2][n2[e2]] || (this.models[i2][n2[e2]] = { model: null, numReferences: 1 }), this.models[i2][n2[e2]].model = s3;
                }
                this.numModelsLoading[i2] -= n2.length, this.fire(new e.A("data", { dataType: "style" }));
              }).catch((t3) => {
                this.fire(new e.z(new Error(`Could not load models: ${t3.message}`)));
              });
            }
            isLoaded() {
              for (const e2 in this.numModelsLoading) if (this.numModelsLoading[e2] > 0) return false;
              return true;
            }
            hasModel(e2, t2, i2 = { exactIdMatch: false }) {
              return !!(i2.exactIdMatch ? this.getModel(e2, t2) : this.getModelByURL(this.modelUris[t2][e2]));
            }
            getModel(e2, t2) {
              return this.models[t2] || (this.models[t2] = {}), this.models[t2][e2] ? this.models[t2][e2].model : void 0;
            }
            getModelByURL(e2) {
              if (!e2) return null;
              const t2 = this.modelByURL[e2];
              return t2 ? this.models[t2.scope][t2.modelId].model : null;
            }
            hasModelBeenAdded(e2, t2) {
              return this.models[t2] && void 0 !== this.models[t2][e2];
            }
            getModelURIs(e2) {
              return this.modelUris[e2] || {};
            }
            addModel(e2, t2, i2) {
              this.models[i2] || (this.models[i2] = {}), this.modelUris[i2] || (this.modelUris[i2] = {});
              const o2 = this.requestManager.normalizeModelURL(t2);
              if ((this.hasModel(e2, i2, { exactIdMatch: true }) || this.hasModelBeenAdded(e2, i2)) && this.modelUris[i2][e2] === o2) this.models[i2][e2].numReferences++;
              else if (this.hasURLBeenRequested(o2)) {
                const { scope: e3, modelId: t3 } = this.modelByURL[o2];
                this.models[e3][t3].numReferences++;
              } else this.modelUris[i2][e2] = o2, this.load({ [e2]: this.modelUris[i2][e2] }, i2);
            }
            addModelURLs(e2, t2) {
              this.models[t2] || (this.models[t2] = {}), this.modelUris[t2] || (this.modelUris[t2] = {});
              const i2 = this.modelUris[t2];
              for (const t3 in e2) i2[t3] = this.requestManager.normalizeModelURL(e2[t3]);
            }
            reloadModels(e2) {
              this.load(this.modelUris[e2], e2, { forceReload: true });
            }
            addModelsFromBucket(t2, i2) {
              this.models[i2] || (this.models[i2] = {}), this.modelUris[i2] || (this.modelUris[i2] = {});
              const o2 = {};
              for (const s2 of t2) this.hasModel(s2, i2, { exactIdMatch: true }) || this.hasURLBeenRequested(s2) ? this.models[i2][s2].numReferences++ : this.modelUris[i2][s2] && !this.hasURLBeenRequested(s2) ? o2[s2] = this.modelUris[i2][s2] : !this.hasURLBeenRequested(s2) && e.cZ(s2, false) && (this.modelUris[i2][s2] = this.requestManager.normalizeModelURL(s2), o2[s2] = this.modelUris[i2][s2]);
              this.load(o2, i2);
            }
            hasURLBeenRequested(e2) {
              return void 0 !== this.modelByURL[e2];
            }
            removeModel(e2, t2, i2 = false) {
              if (this.models[t2] && this.models[t2][e2] && (this.models[t2][e2].numReferences--, 0 === this.models[t2][e2].numReferences)) {
                const o2 = this.modelUris[t2][e2];
                i2 || delete this.modelUris[t2][e2], delete this.modelByURL[o2];
                const s2 = this.models[t2][e2].model;
                if (!s2) return;
                delete this.models[t2][e2], s2.destroy();
              }
            }
            destroy() {
              for (const e2 of Object.keys(this.models)) for (const t2 of Object.keys(this.models[e2])) {
                const i2 = this.models[e2][t2].model;
                delete this.models[e2][t2], i2 && i2.destroy();
              }
              this.models = { "": {} }, this.modelUris = { "": {} }, this.modelByURL = {}, this.numModelsLoading = {};
            }
            listModels(e2) {
              return this.models[e2] || (this.models[e2] = {}), Object.keys(this.models[e2]);
            }
            upload(e2, t2) {
              this.models[t2] || (this.models[t2] = {});
              for (const i2 in this.models[t2]) this.models[t2][i2].model && this.models[t2][i2].model.upload(e2.context);
            }
          }
          const ho = new e.a7({ data: new e.a8(e.a5.colorTheme.data) }), uo = { "mbx-indoor-active-floorplans": { default: ["literal", []] }, "mbx-indoor-underground": { default: ["literal", false] }, "mbx-indoor-loaded-levels": { default: ["literal", []] }, "mbx-indoor-level-height": { default: ["literal", {}] }, "mbx-indoor-level-base": { default: ["literal", {}] }, "mbx-indoor-level-selected": { default: ["literal", {}] }, "mbx-indoor-level-overlapped": { default: ["literal", {}] } };
          function _o(e2) {
            return e2 = e2 || {}, Object.assign(e2, uo);
          }
          class po extends e.E {
            constructor(t2) {
              super(), this.mergeFloors = true, this._scope = void 0, this._queryFeatureSetId = void 0, this._buildingEntryFeatureSetId = void 0, this._selectedFloorplan = void 0, this._indoorData = void 0, this._floorplanStates = {}, e.aV(["_onLoad", "_onMove", "_checkFloorplanVisible"], this), this._map = t2, this._checkFloorplanVisible(), this._map.on("load", this._onLoad), this._map.on("move", this._onMove);
            }
            destroy() {
              this._map.indoor.off("load", this._onLoad), this._map.indoor.off("move", this._onMove), this._map = void 0;
            }
            _onLoad() {
              this._map.style.forEachFragmentStyle((t2) => {
                t2.stylesheet.indoor && (this._queryFeatureSetId ? this.fire(new e.z(new Error("Multiple indoor map styles detected, simultaneous usage is not allowed currently."))) : (this._queryFeatureSetId = t2.stylesheet.indoor.floorplanFeaturesetId, this._buildingEntryFeatureSetId = t2.stylesheet.indoor.buildingFeaturesetId, this._scope = t2.scope));
              }), this._queryFeatureSetId && this._buildingEntryFeatureSetId && this._map.addInteraction("mbx-indoor-buildingclick", { type: "click", target: { featuresetId: this._buildingEntryFeatureSetId, importId: this._scope }, handler: (e2) => (e2.feature && e2.feature.properties.floorplan && this.selectFloorplan(e2.feature.properties.floorplan), true) }), this._checkFloorplanVisible();
            }
            _onMove() {
              this._checkFloorplanVisible();
            }
            _checkFloorplanVisible() {
              if (!this._queryFeatureSetId) return;
              if (!this._map.isStyleLoaded()) return;
              const t2 = () => {
                this._indoorData = void 0, this._selectedFloorplan = void 0, this._map.setConfigProperty(this._scope, "mbx-indoor-underground", false), this._map.setConfigProperty(this._scope, "mbx-indoor-active-floorplans", ["literal", []]), this.fire(new e.A("floorplangone"));
              };
              if (this._map.transform.zoom < 13) return void t2();
              const i2 = { target: { featuresetId: this._queryFeatureSetId, importId: this._scope } }, o2 = this._map.transform.width, s2 = this._map.transform.height, r2 = o2 * (2 / 3), n2 = s2 * (2 / 3), a2 = 0.5 * (o2 - r2), l2 = 0.5 * (s2 - n2), c2 = [new e.P(a2, l2), new e.P(a2 + r2, l2 + n2)], h3 = this._map.queryRenderedFeatures(c2, i2);
              h3.length > 0 ? this._selectedFloorplan && h3[0].properties.id === this._selectedFloorplan.properties.id || (this._selectedFloorplan = h3[0], this._floorplanSelected()) : t2();
            }
            _floorplanSelected() {
              this._indoorData = JSON.parse(this._selectedFloorplan.properties["indoor-data"]), this._indoorData.id = this._selectedFloorplan.properties.id, this._floorplanStates[this._indoorData.id] = this._floorplanStates[this._indoorData.id] || {}, this._map.setConfigProperty(this._scope, "mbx-indoor-active-floorplans", ["literal", [this._indoorData.id]]);
              const t2 = this._floorplanStates[this._indoorData.id].selectedBuilding, i2 = t2 ? this._indoorData.buildings.find((e2) => e2.id === t2) : this._indoorData.buildings.length > 0 ? this._indoorData.buildings[0] : null, o2 = this._floorplanStates[this._indoorData.id].selectedLevel, s2 = this._indoorData.levels.find((e2) => e2.id === o2), r2 = this._indoorData.levels.find((e2) => !(!i2 || !i2.levels) && 0 === Number(e2.levelOrder) && i2.levels.includes(e2.id)), n2 = s2 ? s2.id : r2 ? r2.id : void 0;
              this.fire(new e.A("floorplanselected", { buildings: this._indoorData.buildings, levels: this._indoorData.levels, selectedLevelId: n2 })), i2 && this._buildingSelected(i2, false), n2 && this._levelSelected(n2);
            }
            _buildingSelected(t2, i2) {
              if (!t2 || !t2.id) return void console.warn("IndoorManager: Building or building id is undefined");
              i2 && t2.extent && this._map.fitBounds(t2.extent, { pitch: this._map.getPitch(), bearing: this._map.getBearing() }), this._floorplanStates[this._indoorData.id].selectedBuilding = t2 ? t2.id : void 0;
              const o2 = this._indoorData.levels.filter((e2) => t2.levels.includes(e2.id));
              this.fire(new e.A("buildingselected", { buildingId: t2.id, levels: o2 }));
            }
            _levelSelected(t2) {
              const i2 = this._indoorData.levels.find((e2) => e2.id === t2);
              i2 ? (this._updateLevels(i2, true), this.fire(new e.A("levelselected", { levelId: i2.id }))) : console.warn(`IndoorManager: Level with ID ${t2} not found in the current floorplan.`);
            }
            _updateLevels(e2, t2) {
              if (!e2 || !e2.id) throw new Error("IndoorManager: Selected level or level ID is undefined");
              function i2(e3) {
                const t3 = e3.indexOf("/floor/");
                if (-1 === t3) return e3;
                const i3 = t3 + 7, o3 = e3.indexOf("/", i3);
                return -1 === o3 ? e3.slice(i3) : e3.slice(i3, o3);
              }
              this._floorplanStates[this._indoorData.id].selectedLevel = e2.id;
              const o2 = [], s2 = {}, r2 = {}, n2 = {}, a2 = {};
              for (const t3 of this._indoorData.levels) {
                if (o2.push(t3.id), s2[t3.id] = t3.levelOrder >= 0 ? 3 * Math.abs(t3.levelOrder + 1) : 3 * Math.abs(t3.levelOrder), r2[t3.id] = t3.levelOrder >= 0 ? 3 * t3.levelOrder : 0, this.mergeFloors) {
                  const o3 = i2(e2.id), s3 = i2(t3.id);
                  n2[t3.id] = s3 === o3 ? "true" : "false";
                } else n2[t3.id] = t3.id === e2.id ? "true" : "false";
                a2[t3.id] = t3.levelOrder < e2.levelOrder ? "true" : "false";
              }
              this._map.setConfigProperty(this._scope, "mbx-indoor-loaded-levels", ["literal", o2]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-height", ["literal", s2]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-base", ["literal", r2]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-selected", ["literal", n2]), this._map.setConfigProperty(this._scope, "mbx-indoor-level-overlapped", ["literal", a2]), this._map.setConfigProperty(this._scope, "mbx-indoor-underground", e2.levelOrder < 0);
            }
            selectFloorplan(t2) {
              const i2 = { target: { featuresetId: this._queryFeatureSetId, importId: this._scope } }, o2 = [new e.P(0, 0), new e.P(this._map.transform.width, this._map.transform.height)], s2 = this._map.queryRenderedFeatures(o2, i2);
              if (s2.length > 0) {
                for (const e2 of s2) if (JSON.parse(e2.properties["indoor-data"]).id === t2) {
                  this._selectedFloorplan = e2, this._floorplanSelected();
                  break;
                }
              }
            }
            selectBuilding(e2) {
              const t2 = this._indoorData.buildings.find((t3) => t3.id === e2);
              this._buildingSelected(t2, true);
            }
            selectLevel(e2) {
              this._levelSelected(e2);
            }
          }
          function fo(t2) {
            if (!t2.metadata || !t2.metadata.content_area) return;
            const i2 = e.q.devicePixelRatio, { left: o2, top: s2, width: r2, height: n2 } = t2.metadata.content_area, a2 = o2 * i2, l2 = s2 * i2;
            return [a2, l2, a2 + r2 * i2, l2 + n2 * i2];
          }
          function mo(t2) {
            if (t2) return t2.map(([t3, i2]) => [t3 * e.q.devicePixelRatio, i2 * e.q.devicePixelRatio]);
          }
          class go {
            constructor(e2, t2, i2) {
              this.id = e2, this.scope = t2, this.sourceCache = i2, this.pendingRequests = /* @__PURE__ */ new Set(), this.missingRequests = /* @__PURE__ */ new Set();
            }
            addPendingRequest(e2) {
              this.missingRequests.has(e2.name) || this.pendingRequests.has(e2.name) || this.pendingRequests.add(e2.name);
            }
            hasPendingRequests() {
              return this.pendingRequests.size > 0;
            }
            resolvePendingRequests() {
              const t2 = /* @__PURE__ */ new Map();
              if (!this.sourceCache.loaded()) return t2;
              const i2 = this.sourceCache.getVisibleCoordinates();
              if (0 === i2.length) return t2;
              const o2 = this.sourceCache.getSource();
              if (!(o2 instanceof st)) return t2;
              const s2 = i2.map((e2) => this.sourceCache.getTile(e2)), r2 = o2.getImages(s2, Array.from(this.pendingRequests));
              for (const [i3, o3] of r2) t2.set(e.I.from({ name: i3, iconsetId: this.id }), o3), this.pendingRequests.delete(i3);
              for (const e2 of this.pendingRequests) this.missingRequests.add(e2);
              return this.pendingRequests.clear(), t2;
            }
          }
          const vo = (e2, t2) => Ae(e2, t2 && t2.filter((e3) => "source.canvas" !== e3.identifier)), yo = e.aF(zt, ["addLayer", "removeLayer", "setLights", "setPaintProperty", "setLayoutProperty", "setSlot", "setFilter", "addSource", "removeSource", "setLayerZoomRange", "setLight", "setTransition", "setGeoJSONSourceData", "setTerrain", "setFog", "setSnow", "setRain", "setProjection", "setCamera", "addImport", "removeImport", "updateImport", "addIconset", "removeIconset"]), xo = e.aF(zt, ["setCenter", "setZoom", "setBearing", "setPitch"]), bo = /* @__PURE__ */ new Set(["background", "sky", "slot", "custom"]), wo = { version: 8, layers: [], sources: {} }, To = { duration: 300, delay: 0 };
          class Eo extends e.E {
            constructor(t2, i2 = {}) {
              super(), this.map = t2, this.scope = i2.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i2.importDepth || 0, this.importsCache = i2.importsCache || /* @__PURE__ */ new Map(), this.resolvedImports = i2.resolvedImports || /* @__PURE__ */ new Set(), this.transition = e.h({}, To), this._buildingIndex = new At(this), this.crossTileSymbolIndex = new Fi(), this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._clipLayerPresent = false, this._has3DLayers = false, this._hasCircleLayers = false, this._hasSymbolLayers = false, this._changes = i2.styleChanges || new V(), this.dispatcher = i2.dispatcher ? i2.dispatcher : new e.D(e.c$(), this), i2.imageManager ? this.imageManager = i2.imageManager : (this.imageManager = new q(this.map._spriteFormat), this.imageManager.setEventedParent(this)), this.imageManager.addScope(this.scope), this.glyphManager = i2.glyphManager ? i2.glyphManager : new e.d0(t2._requestManager, i2.localFontFamily ? e.d1.all : i2.localIdeographFontFamily ? e.d1.ideographs : e.d1.none, i2.localFontFamily || i2.localIdeographFontFamily), i2.modelManager ? this.modelManager = i2.modelManager : (this.modelManager = new co(t2._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = false, this._precompileDone = false, this._shouldPrecompile = false, this._availableImages = [], this._availableModels = {}, this._order = [], this._markersNeedUpdate = false, this.options = i2.configOptions ? i2.configOptions : /* @__PURE__ */ new Map(), this._configDependentLayers = i2.configDependentLayers ? i2.configDependentLayers : /* @__PURE__ */ new Set(), this._config = i2.config, this._styleColorTheme = { lut: null, lutLoading: false, lutLoadingCorrelationID: 0, colorTheme: null, colorThemeOverride: i2.colorThemeOverride }, this._styleColorThemeForScope = {}, this._initialConfig = i2.initialConfig, this.dispatcher.broadcast("setReferrer", e.d2());
              const o2 = this;
              this._rtlTextPluginCallback = Eo.registerForPluginStateChange((t3) => {
                o2.dispatcher.broadcast("syncRTLPluginState", { pluginStatus: t3.pluginStatus, pluginURL: t3.pluginURL }, (t4, i3) => {
                  if (e.d3(t4), i3 && i3.every((e2) => e2)) for (const e2 in o2._sourceCaches) {
                    const t5 = o2._sourceCaches[e2], i4 = t5.getSource().type;
                    "vector" !== i4 && "geojson" !== i4 || t5.reload();
                  }
                });
              }), this.on("data", (e2) => {
                if ("source" !== e2.dataType || "metadata" !== e2.sourceDataType) return;
                const t3 = this.getOwnSource(e2.sourceId);
                if (t3 && t3.vectorLayerIds) for (const e3 in this._layers) {
                  const i3 = this._layers[e3];
                  i3.source === t3.id && this._validateLayer(i3);
                }
              });
            }
            load(e2) {
              return e2 ? ("string" == typeof e2 ? this.loadURL(e2) : this.loadJSON(e2), this) : this;
            }
            _getGlobalId(t2) {
              if (!t2) return null;
              if ("string" == typeof t2) {
                if (e.j(t2)) return t2;
                const i2 = e.d4(t2);
                if (!i2.startsWith("http")) try {
                  return new URL(i2, location.href).toString();
                } catch (e2) {
                  return i2;
                }
                return i2;
              }
              return `json://${e.d5(JSON.stringify(t2))}`;
            }
            _diffStyle(t2, i2, o2) {
              this.globalId = this._getGlobalId(t2);
              const s2 = (e2, t3) => {
                try {
                  t3(null, this.setState(e2, o2));
                } catch (e3) {
                  t3(e3, false);
                }
              };
              if ("string" == typeof t2) {
                const o3 = this.map._requestManager.normalizeStyleURL(t2), r2 = this.map._requestManager.transformRequest(o3, e.R.Style);
                e.n(r2, (t3, o4) => {
                  t3 ? this.fire(new e.z(t3)) : o4 && s2(o4, i2);
                });
              } else "object" == typeof t2 && s2(t2, i2);
            }
            loadURL(t2, i2 = {}) {
              this.fire(new e.A("dataloading", { dataType: "style" }));
              const o2 = "boolean" == typeof i2.validate ? i2.validate : !e.j(t2);
              this.globalId = this._getGlobalId(t2), t2 = this.map._requestManager.normalizeStyleURL(t2, i2.accessToken), this.resolvedImports.add(t2);
              const s2 = this.importsCache.get(t2);
              if (s2) return this._load(s2, o2);
              const r2 = this.map._requestManager.transformRequest(t2, e.R.Style);
              this._request = e.n(r2, (i3, s3) => {
                if (this._request = null, i3) this.fire(new e.z(i3));
                else if (s3) return this.importsCache.set(t2, s3), this._load(s3, o2);
              });
            }
            loadJSON(t2, i2 = {}) {
              this.fire(new e.A("dataloading", { dataType: "style" })), this.globalId = this._getGlobalId(t2), this._request = e.q.frame(() => {
                this._request = null, this._load(t2, false !== i2.validate);
              });
            }
            loadEmpty() {
              this.fire(new e.A("dataloading", { dataType: "style" })), this._load(wo, false);
            }
            _loadImports(t2, i2, o2) {
              if (this.importDepth >= 4) return e.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
              const s2 = [];
              for (const e2 of t2) {
                const t3 = this._createFragmentStyle(e2), r2 = new Promise((e3) => {
                  t3.once("style.import.load", e3), t3.once("error", e3);
                }).then(() => this.mergeAll());
                if (s2.push(r2), this.resolvedImports.has(e2.url)) {
                  t3.loadEmpty();
                  continue;
                }
                const n2 = e2.data || this.importsCache.get(e2.url);
                n2 ? (t3.loadJSON(n2, { validate: i2 }), this._isInternalStyle(n2) && (t3.globalId = null)) : e2.url ? t3.loadURL(e2.url, { validate: i2 }) : t3.loadEmpty();
                const a2 = { style: t3, id: e2.id, config: e2.config };
                if (o2) {
                  const e3 = this.fragments.findIndex(({ id: e4 }) => e4 === o2);
                  this.fragments = this.fragments.slice(0, e3).concat(a2).concat(this.fragments.slice(e3));
                } else this.fragments.push(a2);
              }
              return Promise.allSettled(s2);
            }
            getImportGlobalIds(e2 = this, t2 = /* @__PURE__ */ new Set()) {
              for (const i2 of e2.fragments) i2.style.globalId && t2.add(i2.style.globalId), this.getImportGlobalIds(i2.style, t2);
              return [...t2.values()];
            }
            _createFragmentStyle(t2) {
              const i2 = this.scope ? e.C(t2.id, this.scope) : t2.id;
              let o2;
              const s2 = this._initialConfig && this._initialConfig[i2];
              (t2.config || s2) && (o2 = e.h({}, t2.config, s2));
              const r2 = new Eo(this.map, { scope: i2, styleChanges: this._changes, importDepth: this.importDepth + 1, importsCache: this.importsCache, resolvedImports: new Set(this.resolvedImports), dispatcher: this.dispatcher, imageManager: this.imageManager, glyphManager: this.glyphManager, modelManager: this.modelManager, config: o2, configOptions: this.options, colorThemeOverride: t2["color-theme"], configDependentLayers: this._configDependentLayers });
              return r2.setEventedParent(this.map, { style: r2 }), r2;
            }
            _reloadImports() {
              this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", { layers: this._serializeLayers(this._order), scope: this.scope, options: this.options }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
            }
            _isInternalStyle(e2) {
              return this.isRootStyle() && (e2.fragment || !!e2.schema && false !== e2.fragment);
            }
            _load(t2, i2) {
              const o2 = t2.indoor ? _o(t2.schema) : t2.schema;
              if (this._isInternalStyle(t2)) {
                const o3 = e.h({}, wo, { imports: [{ id: "basemap", data: t2, url: "" }] });
                return void this._load(o3, i2);
              }
              if (this.updateConfig(this._config, o2), i2 && vo(this, me(t2))) return;
              this._loaded = true, this.stylesheet = e.d6(t2);
              const s2 = () => {
                for (const e2 in t2.sources) this.addSource(e2, t2.sources[e2], { validate: false, isInitialLoad: true });
                if (t2.iconsets) for (const e2 in t2.iconsets) this.addIconset(e2, t2.iconsets[e2]);
                t2.sprite ? this._loadIconset(t2.sprite) : (this.imageManager.setLoaded(true, this.scope), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: true })), this.setGlyphsUrl(t2.glyphs);
                const o3 = Pt(this.stylesheet.layers);
                if (this._order = o3.map((e2) => e2.id), this.stylesheet.light && e.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                  const e2 = this.stylesheet.lights[0];
                  this.light = new Pe(e2.properties, e2.id);
                } else this.setLights(this.stylesheet.lights);
                this.light || (this.light = new Pe(this.stylesheet.light)), this._layers = {};
                for (const t3 of o3) {
                  const i3 = e.db(t3, this.scope, this._styleColorTheme.lut, this.options);
                  0 !== i3.configDependencies.size && this._configDependentLayers.add(i3.fqid), i3.setEventedParent(this, { layer: { id: i3.id } }), this._layers[i3.id] = i3;
                  const o4 = this.getOwnLayerSourceCache(i3), s4 = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                  o4 && i3.canCastShadows() && s4 && (o4.castsShadows = true);
                }
                this.stylesheet.featuresets && this.setFeaturesetSelectors(this.stylesheet.featuresets), this.stylesheet.models && this.addModelURLs(this.stylesheet.models);
                const s3 = this.stylesheet.terrain;
                s3 && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(s3, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.snow && this._createSnow(this.stylesheet.snow), this.stylesheet.rain && this._createRain(this.stylesheet.rain), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e.A("data", { dataType: "style" }));
                const r3 = this.isRootStyle();
                t2.imports ? this._loadImports(t2.imports, i2).then(() => {
                  this._reloadImports(), this.fire(new e.A(r3 ? "style.load" : "style.import.load"));
                }).catch((t3) => {
                  this.fire(new e.z(new Error("Failed to load imports", t3))), this.fire(new e.A(r3 ? "style.load" : "style.import.load"));
                }) : (this._reloadImports(), this.fire(new e.A(r3 ? "style.load" : "style.import.load")));
              };
              this._styleColorTheme.colorTheme = this.stylesheet["color-theme"];
              const r2 = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
              if (r2) {
                const t3 = this._evaluateColorThemeData(r2);
                this._loadColorTheme(t3).then(() => {
                  s2();
                }).catch((t4) => {
                  e.w(`Couldn't load color theme from the stylesheet: ${t4}`), s2();
                });
              } else this._styleColorTheme.lut = null, s2();
            }
            isRootStyle() {
              return 0 === this.importDepth;
            }
            mergeAll() {
              let t2, i2, o2, s2, r2, n2, a2, l2, c2, h3;
              const d2 = {};
              this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((e2) => {
                if (e2.stylesheet) {
                  if (null != e2.light && (t2 = e2.light), e2.stylesheet.lights) for (const t3 of e2.stylesheet.lights) "ambient" === t3.type && null != e2.ambientLight && (i2 = e2.ambientLight), "directional" === t3.type && null != e2.directionalLight && (o2 = e2.directionalLight);
                  s2 = this._prioritizeTerrain(s2, e2.terrain, e2.stylesheet.terrain), e2.stylesheet.fog && null != e2.fog && (r2 = e2.fog), e2.stylesheet.snow && null != e2.snow && (n2 = e2.snow), e2.stylesheet.rain && null != e2.rain && (a2 = e2.rain), null != e2.stylesheet.camera && (h3 = e2.stylesheet.camera), null != e2.stylesheet.projection && (l2 = e2.stylesheet.projection), null != e2.stylesheet.transition && (c2 = e2.stylesheet.transition), d2[e2.scope] = e2._styleColorTheme;
                }
              }), this.light = t2, this.ambientLight = i2, this.directionalLight = o2, this.fog = r2, this.snow = n2, this.rain = a2, this._styleColorThemeForScope = d2, null === s2 ? delete this.terrain : this.terrain = s2, this.camera = h3 || { "camera-projection": "perspective" }, this.projection = l2 || { name: "mercator" }, this.transition = e.h({}, To, c2), this.mergeSources(), this.mergeLayers();
            }
            forEachFragmentStyle(e2) {
              const t2 = (i2) => {
                for (const e3 of i2.fragments) t2(e3.style);
                e2(i2);
              };
              t2(this);
            }
            _prioritizeTerrain(e2, t2, i2) {
              const o2 = e2 && 0 === e2.drapeRenderMode;
              return null === i2 ? t2 && 0 === t2.drapeRenderMode ? t2 : o2 ? e2 : null : null != t2 && (!e2 || o2 || t2 && 1 === t2.drapeRenderMode) ? t2 : e2;
            }
            mergeTerrain() {
              let e2;
              this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t2) => {
                e2 = this._prioritizeTerrain(e2, t2.terrain, t2.stylesheet.terrain);
              }), null === e2 ? delete this.terrain : this.terrain = e2;
            }
            mergeProjection() {
              let e2;
              this.forEachFragmentStyle((t2) => {
                null != t2.stylesheet.projection && (e2 = t2.stylesheet.projection);
              }), this.projection = e2 || { name: "mercator" };
            }
            mergeSources() {
              const t2 = {}, i2 = {}, o2 = {};
              this.forEachFragmentStyle((s2) => {
                for (const i3 in s2._sourceCaches) {
                  const o3 = e.C(i3, s2.scope);
                  t2[o3] = s2._sourceCaches[i3];
                }
                for (const t3 in s2._otherSourceCaches) {
                  const o3 = e.C(t3, s2.scope);
                  i2[o3] = s2._otherSourceCaches[t3];
                }
                for (const t3 in s2._symbolSourceCaches) {
                  const i3 = e.C(t3, s2.scope);
                  o2[i3] = s2._symbolSourceCaches[t3];
                }
              }), this._mergedSourceCaches = t2, this._mergedOtherSourceCaches = i2, this._mergedSymbolSourceCaches = o2;
            }
            mergeLayers() {
              const t2 = {}, i2 = [], o2 = {};
              this._mergedSlots = [], this._has3DLayers = false, this._hasCircleLayers = false, this._hasSymbolLayers = false, this.forEachFragmentStyle((o3) => {
                for (const s3 of o3._order) {
                  const r2 = o3._layers[s3];
                  if ("slot" === r2.type) {
                    const i3 = e.d7(s3);
                    if (t2[i3]) continue;
                    t2[i3] = [];
                  }
                  r2.slot && t2[r2.slot] ? t2[r2.slot].push(r2) : i2.push(r2);
                }
              }), this._mergedOrder = [];
              const s2 = (i3 = []) => {
                for (const r2 of i3) if ("slot" === r2.type) {
                  const i4 = e.d7(r2.id);
                  t2[i4] && s2(t2[i4]), this._mergedSlots.push(i4);
                } else {
                  const t3 = e.C(r2.id, r2.scope);
                  this._mergedOrder.push(t3), o2[t3] = r2, r2.is3D(!!this.terrain) && (this._has3DLayers = true), "circle" === r2.type && (this._hasCircleLayers = true), "symbol" === r2.type && (this._hasSymbolLayers = true), "clip" === r2.type && (this._clipLayerPresent = true);
                }
              };
              s2(i2), this._mergedOrder.sort((e2, t3) => {
                const i3 = o2[e2], s3 = o2[t3];
                return i3.hasInitialOcclusionOpacityProperties ? s3.is3D(!!this.terrain) ? 1 : 0 : i3.is3D(!!this.terrain) && s3.hasInitialOcclusionOpacityProperties ? -1 : 0;
              }), this._mergedLayers = o2, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
            }
            terrainSetForDrapingOnly() {
              return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
              return this.stylesheet.camera;
            }
            setCamera(t2) {
              return this.stylesheet.camera = e.h({}, this.stylesheet.camera, t2), this.camera = this.stylesheet.camera, this;
            }
            _evaluateColorThemeData(t2) {
              return t2.data ? function(t3, i2, o2, s2) {
                const r2 = e.h({}, i2);
                for (const t4 of Object.keys(e.a5.colorTheme)) void 0 === r2[t4] && (r2[t4] = e.a5.colorTheme[t4].default);
                const n2 = new e.a6(ho, t3, new Map(o2));
                return n2.setTransitionOrValue(r2, o2), n2.untransitioned().possiblyEvaluate(new e.aa(0, { worldview: void 0 }));
              }(this.scope, t2, this.options).get("data") : null;
            }
            _loadColorTheme(t2) {
              this._styleColorTheme.lutLoading = true, this._styleColorTheme.lutLoadingCorrelationID += 1;
              const i2 = this._styleColorTheme.lutLoadingCorrelationID;
              return new Promise((o2, s2) => {
                const r2 = "data:image/png;base64,";
                if (!t2 || 0 === t2.length) return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = false, void o2();
                let n2 = t2;
                n2.startsWith(r2) || (n2 = r2 + n2);
                const a2 = e.I.from("mapbox-reserved-lut"), l2 = new Image();
                l2.src = n2, l2.onerror = () => {
                  this._styleColorTheme.lutLoading = false, s2(new Error("Failed to load image data"));
                }, l2.onload = () => {
                  if (this._styleColorTheme.lutLoadingCorrelationID !== i2) return void o2();
                  this._styleColorTheme.lutLoading = false;
                  const { width: r3, height: n3, data: c2 } = e.q.getImageData(l2);
                  if (n3 > 32) return void s2(new Error("The height of the image must be less than or equal to 32 pixels."));
                  if (r3 !== n3 * n3) return void s2(new Error("The width of the image must be equal to the height squared."));
                  this.getImage(a2) && this.removeImage(a2), this.addImage(a2, { data: new e.r({ width: r3, height: n3 }, c2), pixelRatio: 1, sdf: false, usvg: false, version: 0 });
                  const h3 = this.imageManager.getImage(a2, this.scope);
                  h3 ? (this._styleColorTheme.lut = { image: h3.data, data: t2 }, o2()) : s2(new Error("Missing LUT image."));
                };
              });
            }
            getLut(e2) {
              const t2 = this._styleColorThemeForScope[e2];
              return t2 ? t2.lut : null;
            }
            setProjection(e2) {
              e2 ? this.stylesheet.projection = e2 : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
              this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
            }
            _updateMapProjection() {
              this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(t2) {
              this._spriteRequest = function(t3, i2, o2) {
                let s2, r2, n2;
                const a2 = e.q.devicePixelRatio > 1 ? "@2x" : "";
                let l2 = e.n(i2.transformRequest(i2.normalizeSpriteURL(t3, a2, ".json"), e.R.SpriteJSON), (e2, t4) => {
                  l2 = null, n2 || (n2 = e2, s2 = t4, h3());
                }), c2 = e.o(i2.transformRequest(i2.normalizeSpriteURL(t3, a2, ".png"), e.R.SpriteImage), (e2, t4) => {
                  c2 = null, n2 || (n2 = e2, r2 = t4, h3());
                });
                function h3() {
                  if (n2) o2(n2);
                  else if (s2 && r2) {
                    const t4 = e.q.getImageData(r2), i3 = {};
                    for (const o3 in s2) {
                      const { width: r3, height: n3, x: a3, y: l3, sdf: c3, pixelRatio: h4, stretchX: d2, stretchY: u2, content: _2 } = s2[o3], p3 = new e.r({ width: r3, height: n3 });
                      e.r.copy(t4, p3, { x: a3, y: l3 }, { x: 0, y: 0 }, { width: r3, height: n3 }, null), i3[o3] = { data: p3, pixelRatio: h4, sdf: c3, stretchX: d2, stretchY: u2, content: _2, usvg: false };
                    }
                    o2(null, i3);
                  }
                }
                return { cancel() {
                  l2 && (l2.cancel(), l2 = null), c2 && (c2.cancel(), c2 = null);
                } };
              }(t2, this.map._requestManager, (t3, i2) => {
                if (this._spriteRequest = null, t3) this.fire(new e.z(t3));
                else if (i2) {
                  const t4 = /* @__PURE__ */ new Map();
                  for (const o2 in i2) t4.set(e.I.from(o2), i2[o2]);
                  this.addImages(t4);
                }
                this.imageManager.setLoaded(true, this.scope), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: true }), this.fire(new e.A("data", { dataType: "style" }));
              });
            }
            addIconset(t2, i2) {
              if ("sprite" === i2.type) return void this._loadSprite(i2.url);
              const o2 = this.getOwnSourceCache(i2.source);
              if (!o2) return void this.fire(new e.z(new Error(`Source "${i2.source}" as specified by iconset "${t2}" does not exist and cannot be used as an iconset source`)));
              const s2 = o2.getSource();
              if ("raster-array" !== s2.type) return void this.fire(new e.z(new Error(`Source "${i2.source}" as specified by iconset "${t2}" is not a "raster-array" source and cannot be used as an iconset source`)));
              s2.partial = false;
              const r2 = new go(t2, this.scope, o2);
              this.imageManager.addImageProvider(r2, this.scope);
            }
            removeIconset(e2) {
              this.imageManager.removeImageProvider(e2, this.scope);
            }
            _loadIconset(t2) {
              if (!e.j(t2) && "icon_set" !== this.map._spriteFormat || "raster" === this.map._spriteFormat) return void this._loadSprite(t2);
              const i2 = "auto" === this.map._spriteFormat;
              var o2, s2;
              this._spriteRequest = (s2 = (o3, s3) => {
                if (this._spriteRequest = null, o3) i2 ? this._loadSprite(t2) : this.fire(new e.z(o3));
                else if (s3) {
                  const t3 = /* @__PURE__ */ new Map();
                  for (const i3 in s3) t3.set(e.I.from(i3), s3[i3]);
                  this.addImages(t3);
                }
                this.imageManager.setLoaded(true, this.scope), this.dispatcher.broadcast("spriteLoaded", { scope: this.scope, isLoaded: true }), this.fire(new e.A("data", { dataType: "style" }));
              }, e.br((o2 = this.map._requestManager).transformRequest(o2.normalizeIconsetURL(t2), e.R.Iconset), (t3, i3) => {
                if (t3) return void s2(t3);
                const o3 = {}, r2 = e.c_(new e.bq(i3));
                for (const t4 of r2.icons) {
                  const i4 = { version: 1, pixelRatio: e.q.devicePixelRatio, content: fo(t4), stretchX: t4.metadata ? mo(t4.metadata.stretch_x_areas) : void 0, stretchY: t4.metadata ? mo(t4.metadata.stretch_y_areas) : void 0, sdf: false, usvg: true, icon: t4 };
                  o3[t4.name] = i4;
                }
                s2(null, o3);
              }));
            }
            _validateLayer(t2) {
              const i2 = this.getOwnSource(t2.source);
              if (!i2) return;
              const o2 = t2.sourceLayer;
              o2 && ("geojson" === i2.type || i2.vectorLayerIds && -1 === i2.vectorLayerIds.indexOf(o2)) && this.fire(new e.z(new Error(`Source layer "${o2}" does not exist on source "${i2.id}" as specified by style layer "${t2.id}"`)));
            }
            loaded() {
              if (!this._loaded) return false;
              if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return false;
              for (const e2 in this._sourceCaches) if (!this._sourceCaches[e2].loaded()) return false;
              if (!this.imageManager.isLoaded()) return false;
              if (this.imageManager.hasPatternsInFlight()) return false;
              if (!this.modelManager.isLoaded()) return false;
              if (this._styleColorTheme.lutLoading) return false;
              for (const { style: e2 } of this.fragments) if (!e2.loaded()) return false;
              return true;
            }
            _serializeImports() {
              if (this.stylesheet.imports) return this.stylesheet.imports.map((e2, t2) => {
                const i2 = this.fragments[t2];
                return i2 && i2.style && (e2.data = i2.style.serialize()), e2;
              });
            }
            _serializeSources() {
              const e2 = {};
              for (const t2 in this._sourceCaches) {
                const i2 = this._sourceCaches[t2].getSource();
                e2[i2.id] || (e2[i2.id] = i2.serialize());
              }
              return e2;
            }
            _serializeLayers(e2) {
              const t2 = [];
              for (const i2 of e2) {
                const e3 = this._layers[i2];
                e3 && "custom" !== e3.type && t2.push(e3.serialize());
              }
              return t2;
            }
            hasLightTransitions() {
              return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
              return !!this.fog && this.fog.hasTransition();
            }
            hasSnowTransition() {
              return !!this.snow && this.snow.hasTransition();
            }
            hasRainTransition() {
              return !!this.rain && this.rain.hasTransition();
            }
            hasTransitions() {
              if (this.hasLightTransitions()) return true;
              if (this.hasFogTransition()) return true;
              if (this.hasSnowTransition()) return true;
              if (this.hasRainTransition()) return true;
              for (const e2 in this._sourceCaches) if (this._sourceCaches[e2].hasTransition()) return true;
              for (const e2 in this._layers) if (this._layers[e2].hasTransition()) return true;
              return false;
            }
            get order() {
              return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            _getOrder(e2) {
              return e2 ? this.order : this._mergedOrder;
            }
            isLayerDraped(e2) {
              return !!this.terrain && e2.isDraped(this.getLayerSourceCache(e2));
            }
            _checkLoaded() {
              if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(t2) {
              const i2 = this.getOwnLayer(t2);
              if (i2) return i2;
              this.fire(new e.z(new Error(`The layer '${t2}' does not exist in the map's style.`)));
            }
            _checkSource(t2) {
              const i2 = this.getOwnSource(t2);
              if (i2) return i2;
              this.fire(new e.z(new Error(`The source '${t2}' does not exist in the map's style.`)));
            }
            precompilePrograms(e2, t2) {
              const i2 = this.map.painter;
              if (i2) for (let o2 = e2.minzoom || 0; o2 < (e2.maxzoom || 25.5); o2++) {
                const o3 = e2.getProgramIds();
                if (o3) for (const s2 of o3) {
                  const o4 = e2.getDefaultProgramParams(s2, t2.zoom, this._styleColorTheme.lut);
                  o4 && (i2.style = this, this.fog && (i2._fogVisible = true, o4.overrideFog = true, i2.getOrCreateProgram(s2, o4)), i2._fogVisible = false, o4.overrideFog = false, i2.getOrCreateProgram(s2, o4), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (o4.overrideRtt = true, i2.getOrCreateProgram(s2, o4)));
                }
              }
            }
            update(t2) {
              if (!this._loaded) return;
              this.ambientLight && this.ambientLight.recalculate(t2), this.directionalLight && this.directionalLight.recalculate(t2);
              const i2 = this.calculateLightsBrightness();
              t2.brightness = i2 || 0, i2 !== this._brightness && (this._brightness = i2, this.dispatcher.broadcast("setBrightness", i2)), t2.worldview !== this._worldview && (this._worldview = t2.worldview, this.dispatcher.broadcast("setWorldview", this._worldview));
              const o2 = this._changes.isDirty();
              let s2 = false;
              if (this._changes.isDirty()) {
                const e2 = this._changes.getLayerUpdatesByScope();
                for (const t3 in e2) {
                  const { updatedIds: i3, removedIds: o3 } = e2[t3];
                  (i3 || o3) && (this._updateWorkerLayers(t3, i3, o3), s2 = true);
                }
                this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t2), this.light && this.light.updateTransitions(t2), this.ambientLight && this.ambientLight.updateTransitions(t2), this.directionalLight && this.directionalLight.updateTransitions(t2), this.fog && this.fog.updateTransitions(t2), this.snow && this.snow.updateTransitions(t2), this.rain && this.rain.updateTransitions(t2), this._changes.reset();
              }
              const r2 = {};
              for (const e2 in this._mergedSourceCaches) {
                const t3 = this._mergedSourceCaches[e2];
                r2[e2] = t3.used, t3.used = false, t3.tileCoverLift = 0;
              }
              for (const e2 of this._mergedOrder) {
                const i3 = this._mergedLayers[e2];
                if (i3.recalculate(t2, this._availableImages), !i3.isHidden(t2.zoom)) {
                  const e3 = this.getLayerSourceCache(i3);
                  e3 && (e3.used = true, e3.tileCoverLift = Math.max(e3.tileCoverLift, i3.tileCoverLift()));
                }
                !this._precompileDone && this._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(() => {
                  this.precompilePrograms(i3, t2);
                }) : this.precompilePrograms(i3, t2));
              }
              this._shouldPrecompile && (this._precompileDone = true), this.terrain && s2 && this.mergeLayers();
              const n2 = this.imageManager.getPendingImageProviders();
              for (const e2 of n2) e2.sourceCache.used = true;
              for (const t3 in r2) {
                const i3 = this._mergedSourceCaches[t3];
                r2[t3] !== i3.used && i3.getSource().fire(new e.A("data", { sourceDataType: "visibility", dataType: "source", sourceId: i3.getSource().id }));
              }
              this.light && this.light.recalculate(t2), this.terrain && this.terrain.recalculate(t2), this.fog && this.fog.recalculate(t2), this.snow && this.snow.recalculate(t2), this.rain && this.rain.recalculate(t2), this.z = t2.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = false), this.imageManager.clearUpdatedImages(this.scope), o2 && this.fire(new e.A("data", { dataType: "style" }));
            }
            updateImageProviders() {
              const e2 = this.imageManager.getPendingImageProviders();
              for (const t2 of e2) {
                const e3 = t2.resolvePendingRequests(), i2 = this.getFragmentStyle(t2.scope);
                i2 && i2.addImages(e3);
              }
            }
            _updateTilesForChangedImages() {
              const e2 = {};
              for (const t2 in this._mergedSourceCaches) {
                const i2 = this._mergedSourceCaches[t2].getSource().scope;
                e2[i2] = e2[i2] || this._changes.getUpdatedImages(i2), 0 !== e2[i2].length && this._mergedSourceCaches[t2].reloadTilesForDependencies(["icons", "patterns"], e2[i2]);
              }
              for (const t2 in e2) this._changes.resetUpdatedImages(t2);
            }
            _updateWorkerLayers(e2, t2, i2) {
              const o2 = this.getFragmentStyle(e2);
              o2 && this.dispatcher.broadcast("updateLayers", { layers: t2 ? o2._serializeLayers(t2) : [], scope: e2, removedIds: i2 || [], options: o2.options });
            }
            setState(t2, i2) {
              if (this._checkLoaded(), vo(this, me(t2))) return false;
              (t2 = e.d6(t2)).layers = Pt(t2.layers);
              const o2 = function(t3, i3) {
                if (!t3) return [{ command: zt.setStyle, args: [i3] }];
                let o3 = [];
                try {
                  if (!e.bv(t3.version, i3.version)) return [{ command: zt.setStyle, args: [i3] }];
                  if (e.bv(t3.center, i3.center) || o3.push({ command: zt.setCenter, args: [i3.center] }), e.bv(t3.zoom, i3.zoom) || o3.push({ command: zt.setZoom, args: [i3.zoom] }), e.bv(t3.bearing, i3.bearing) || o3.push({ command: zt.setBearing, args: [i3.bearing] }), e.bv(t3.pitch, i3.pitch) || o3.push({ command: zt.setPitch, args: [i3.pitch] }), e.bv(t3.sprite, i3.sprite) || o3.push({ command: zt.setSprite, args: [i3.sprite] }), e.bv(t3.glyphs, i3.glyphs) || o3.push({ command: zt.setGlyphs, args: [i3.glyphs] }), e.bv(t3.imports, i3.imports) || function(t4 = [], i4 = [], o4) {
                    i4 = i4 || [];
                    const s4 = (t4 = t4 || []).map(Nt), r4 = i4.map(Nt), n3 = t4.reduce(Ut, {}), a3 = i4.reduce(Ut, {}), l2 = s4.slice();
                    let c2, h3, d2, u2;
                    for (c2 = 0, h3 = 0; c2 < s4.length; c2++) d2 = s4[c2], a3.hasOwnProperty(d2) ? h3++ : (o4.push({ command: zt.removeImport, args: [d2] }), l2.splice(l2.indexOf(d2, h3), 1));
                    for (c2 = 0, h3 = 0; c2 < r4.length; c2++) d2 = r4[r4.length - 1 - c2], l2[l2.length - 1 - c2] !== d2 && (n3.hasOwnProperty(d2) ? (o4.push({ command: zt.removeImport, args: [d2] }), l2.splice(l2.lastIndexOf(d2, l2.length - h3), 1)) : h3++, u2 = l2[l2.length - c2], o4.push({ command: zt.addImport, args: [a3[d2], u2] }), l2.splice(l2.length - c2, 0, d2));
                    for (const t5 of i4) {
                      const i5 = n3[t5.id];
                      i5 && (delete i5.data, e.bv(i5, t5) || o4.push({ command: zt.updateImport, args: [t5.id, t5] }));
                    }
                  }(t3.imports, i3.imports, o3), e.bv(t3.transition, i3.transition) || o3.push({ command: zt.setTransition, args: [i3.transition] }), e.bv(t3.light, i3.light) || o3.push({ command: zt.setLight, args: [i3.light] }), e.bv(t3.fog, i3.fog) || o3.push({ command: zt.setFog, args: [i3.fog] }), e.bv(t3.snow, i3.snow) || o3.push({ command: zt.setSnow, args: [i3.snow] }), e.bv(t3.rain, i3.rain) || o3.push({ command: zt.setRain, args: [i3.rain] }), e.bv(t3.projection, i3.projection) || o3.push({ command: zt.setProjection, args: [i3.projection] }), e.bv(t3.lights, i3.lights) || o3.push({ command: zt.setLights, args: [i3.lights] }), e.bv(t3.camera, i3.camera) || o3.push({ command: zt.setCamera, args: [i3.camera] }), e.bv(t3.iconsets, i3.iconsets) || function(t4, i4, o4) {
                    let s4;
                    for (s4 in i4 = i4 || {}, t4 = t4 || {}) t4.hasOwnProperty(s4) && (i4.hasOwnProperty(s4) || o4.push({ command: zt.removeIconset, args: [s4] }));
                    for (s4 in i4) {
                      if (!i4.hasOwnProperty(s4)) continue;
                      const r4 = i4[s4];
                      t4.hasOwnProperty(s4) ? e.bv(t4[s4], r4) || (o4.push({ command: zt.removeIconset, args: [s4] }), o4.push({ command: zt.addIconset, args: [s4, r4] })) : o4.push({ command: zt.addIconset, args: [s4, r4] });
                    }
                  }(t3.iconsets, i3.iconsets, o3), !e.bv(t3["color-theme"], i3["color-theme"])) return [{ command: zt.setStyle, args: [i3] }];
                  const s3 = {}, r3 = [];
                  !function(t4, i4, o4, s4) {
                    let r4;
                    for (r4 in i4 = i4 || {}, t4 = t4 || {}) t4.hasOwnProperty(r4) && (i4.hasOwnProperty(r4) || Ot(r4, o4, s4));
                    for (r4 in i4) {
                      if (!i4.hasOwnProperty(r4)) continue;
                      const n3 = i4[r4];
                      t4.hasOwnProperty(r4) ? e.bv(t4[r4], n3) || ("geojson" === t4[r4].type && "geojson" === n3.type && Bt(t4, i4, r4) ? o4.push({ command: zt.setGeoJSONSourceData, args: [r4, n3.data] }) : Ft(r4, i4, o4, s4)) : Mt(r4, i4, o4);
                    }
                  }(t3.sources, i3.sources, r3, s3);
                  const n2 = [];
                  t3.layers && t3.layers.forEach((e2) => {
                    e2.source && s3[e2.source] ? o3.push({ command: zt.removeLayer, args: [e2.id] }) : n2.push(e2);
                  });
                  let a2 = t3.terrain;
                  a2 && s3[a2.source] && (o3.push({ command: zt.setTerrain, args: [void 0] }), a2 = void 0), o3 = o3.concat(r3), e.bv(a2, i3.terrain) || o3.push({ command: zt.setTerrain, args: [i3.terrain] }), function(t4, i4, o4) {
                    i4 = i4 || [];
                    const s4 = (t4 = t4 || []).map(Nt), r4 = i4.map(Nt), n3 = t4.reduce(Ut, {}), a3 = i4.reduce(Ut, {}), l2 = s4.slice(), c2 = /* @__PURE__ */ Object.create(null);
                    let h3, d2, u2, _2, p3, f2, m2;
                    for (h3 = 0, d2 = 0; h3 < s4.length; h3++) u2 = s4[h3], a3.hasOwnProperty(u2) ? d2++ : (o4.push({ command: zt.removeLayer, args: [u2] }), l2.splice(l2.indexOf(u2, d2), 1));
                    for (h3 = 0, d2 = 0; h3 < r4.length; h3++) u2 = r4[r4.length - 1 - h3], l2[l2.length - 1 - h3] !== u2 && (n3.hasOwnProperty(u2) ? (o4.push({ command: zt.removeLayer, args: [u2] }), l2.splice(l2.lastIndexOf(u2, l2.length - d2), 1)) : d2++, f2 = l2[l2.length - h3], o4.push({ command: zt.addLayer, args: [a3[u2], f2] }), l2.splice(l2.length - h3, 0, u2), c2[u2] = true);
                    for (h3 = 0; h3 < r4.length; h3++) if (u2 = r4[h3], _2 = n3[u2], p3 = a3[u2], !c2[u2] && !e.bv(_2, p3)) if (e.bv(_2.source, p3.source) && e.bv(_2["source-layer"], p3["source-layer"]) && e.bv(_2.type, p3.type)) {
                      for (m2 in kt(_2.layout, p3.layout, o4, u2, null, zt.setLayoutProperty), kt(_2.paint, p3.paint, o4, u2, null, zt.setPaintProperty), e.bv(_2.slot, p3.slot) || o4.push({ command: zt.setSlot, args: [u2, p3.slot] }), e.bv(_2.filter, p3.filter) || o4.push({ command: zt.setFilter, args: [u2, p3.filter] }), e.bv(_2.minzoom, p3.minzoom) && e.bv(_2.maxzoom, p3.maxzoom) || o4.push({ command: zt.setLayerZoomRange, args: [u2, p3.minzoom, p3.maxzoom] }), _2) _2.hasOwnProperty(m2) && "layout" !== m2 && "paint" !== m2 && "filter" !== m2 && "metadata" !== m2 && "minzoom" !== m2 && "maxzoom" !== m2 && "slot" !== m2 && (0 === m2.indexOf("paint.") ? kt(_2[m2], p3[m2], o4, u2, m2.slice(6), zt.setPaintProperty) : e.bv(_2[m2], p3[m2]) || o4.push({ command: zt.setLayerProperty, args: [u2, m2, p3[m2]] }));
                      for (m2 in p3) p3.hasOwnProperty(m2) && !_2.hasOwnProperty(m2) && "layout" !== m2 && "paint" !== m2 && "filter" !== m2 && "metadata" !== m2 && "minzoom" !== m2 && "maxzoom" !== m2 && "slot" !== m2 && (0 === m2.indexOf("paint.") ? kt(_2[m2], p3[m2], o4, u2, m2.slice(6), zt.setPaintProperty) : e.bv(_2[m2], p3[m2]) || o4.push({ command: zt.setLayerProperty, args: [u2, m2, p3[m2]] }));
                    } else o4.push({ command: zt.removeLayer, args: [u2] }), f2 = l2[l2.lastIndexOf(u2) + 1], o4.push({ command: zt.addLayer, args: [p3, f2] });
                  }(n2, i3.layers, o3);
                } catch (e2) {
                  console.warn("Unable to compute style diff:", e2), o3 = [{ command: zt.setStyle, args: [i3] }];
                }
                return o3;
              }(this.serialize(), t2).filter((e2) => !(e2.command in xo));
              if (0 === o2.length) return false;
              const s2 = o2.filter((e2) => !(e2.command in yo));
              if (s2.length > 0) throw new Error(`Unimplemented: ${s2.map((e2) => e2.command).join(", ")}.`);
              const r2 = [];
              return o2.forEach((e2) => {
                r2.push(this[e2.command](...e2.args));
              }), i2 && Promise.all(r2).then(i2).catch(i2), this.stylesheet = t2, this.mergeAll(), this.dispatcher.broadcast("setLayers", { layers: this._serializeLayers(this._order), scope: this.scope, options: this.options }), true;
            }
            _updateWorkerImages() {
              this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", { scope: this.scope, images: this._availableImages });
            }
            _updateWorkerModels() {
              this._availableModels = this.modelManager.getModelURIs(this.scope), this.dispatcher.broadcast("setModels", { scope: this.scope, models: this._availableModels });
            }
            addImages(t2) {
              for (const [i2, o2] of t2.entries()) {
                if (this.getImage(i2)) return this.fire(new e.z(new Error(`An image with the name "${i2.name}" already exists.`)));
                this.imageManager.addImage(i2, this.scope, o2), this._changes.updateImage(i2, this.scope);
              }
              return this._updateWorkerImages(), this.fire(new e.A("data", { dataType: "style" })), this;
            }
            addImage(t2, i2) {
              return this.getImage(t2) ? this.fire(new e.z(new Error(`An image with the name "${t2.name}" already exists.`))) : (this.imageManager.addImage(t2, this.scope, i2), this._changes.updateImage(t2, this.scope), this._updateWorkerImages(), this.fire(new e.A("data", { dataType: "style" })), this);
            }
            updateImage(t2, i2, o2 = false) {
              this.imageManager.updateImage(t2, this.scope, i2), o2 && (this._changes.updateImage(t2, this.scope), this._updateWorkerImages(), this.fire(new e.A("data", { dataType: "style" })));
            }
            getImage(e2) {
              return this.imageManager.getImage(e2, this.scope);
            }
            removeImage(t2) {
              return this.getImage(t2) ? (this.imageManager.removeImage(t2, this.scope), this._changes.updateImage(t2, this.scope), this._updateWorkerImages(), this.fire(new e.A("data", { dataType: "style" })), this) : this.fire(new e.z(new Error("No image with this name exists.")));
            }
            listImages() {
              return this._checkLoaded(), this._availableImages.slice();
            }
            addModelURLs(t2) {
              return this.modelManager.addModelURLs(t2, this.scope), this._updateWorkerModels(), this.fire(new e.A("data", { dataType: "style" })), this;
            }
            addModel(t2, i2, o2 = {}) {
              return this._checkLoaded(), this._validate(Re, `models.${t2}`, i2, null, o2) || (this.modelManager.addModel(t2, i2, this.scope), this.fire(new e.A("data", { dataType: "style" }))), this;
            }
            hasModel(e2) {
              return this.modelManager.hasModel(e2, this.scope);
            }
            removeModel(t2) {
              return this.hasModel(t2) ? (this.modelManager.removeModel(t2, this.scope), this.fire(new e.A("data", { dataType: "style" })), this) : this.fire(new e.z(new Error("No model with this ID exists.")));
            }
            listModels() {
              return this._checkLoaded(), this.modelManager.listModels(this.scope);
            }
            addSource(t2, i2, o2 = {}) {
              if (this._checkLoaded(), void 0 !== this.getOwnSource(t2)) throw new Error(`There is already a source with ID "${t2}".`);
              if (!i2.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i2).join(", ")}.`);
              if (["vector", "raster", "geojson", "video", "image"].indexOf(i2.type) >= 0 && this._validate(ge, `sources.${t2}`, i2, null, o2)) return;
              this.map && this.map._collectResourceTiming && (i2.collectResourceTiming = true);
              const s2 = nt(t2, i2, this.dispatcher, this);
              s2.scope = this.scope, s2.setEventedParent(this, () => ({ isSourceLoaded: this._isSourceCacheLoaded(s2.id), source: s2.serialize(), sourceId: s2.id }));
              const r2 = (t3) => {
                const i3 = (t3 ? "symbol:" : "other:") + s2.id, o3 = e.C(i3, this.scope), r3 = this._sourceCaches[i3] = new It(o3, s2, t3);
                (t3 ? this._symbolSourceCaches : this._otherSourceCaches)[s2.id] = r3, r3.onAdd(this.map);
              };
              r2(false), "vector" !== i2.type && "geojson" !== i2.type || r2(true), s2.onAdd && s2.onAdd(this.map), o2.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(t2) {
              this._checkLoaded();
              const i2 = this.getOwnSource(t2);
              if (!i2) throw new Error("There is no source with this ID");
              for (const i3 in this._layers) if (this._layers[i3].source === t2) return this.fire(new e.z(new Error(`Source "${t2}" cannot be removed while layer "${i3}" is using it.`)));
              if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t2) return this.fire(new e.z(new Error(`Source "${t2}" cannot be removed while terrain is using it.`)));
              if (this.stylesheet.iconsets) {
                const i3 = Object.entries(this.stylesheet.iconsets).find(([e2, i4]) => "source" === i4.type && i4.source === t2);
                if (i3) return this.fire(new e.z(new Error(`Source "${t2}" cannot be removed while iconset "${i3[0]}" is using it.`)));
              }
              const o2 = this.getOwnSourceCaches(t2);
              for (const t3 of o2) {
                const i3 = e.d7(t3.id);
                delete this._sourceCaches[i3], this._changes.discardSourceCacheUpdate(t3.id), t3.fire(new e.A("data", { sourceDataType: "metadata", dataType: "source", sourceId: t3.getSource().id })), t3.setEventedParent(null), t3.clearTiles();
              }
              return delete this._otherSourceCaches[t2], delete this._symbolSourceCaches[t2], this.mergeSources(), i2.setEventedParent(null), i2.onRemove && i2.onRemove(this.map), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e2, t2) {
              this._checkLoaded(), this.getOwnSource(e2).setData(t2), this._changes.setDirty();
            }
            getOwnSource(e2) {
              const t2 = this.getOwnSourceCache(e2);
              return t2 && t2.getSource();
            }
            getOwnSources() {
              const e2 = [];
              for (const t2 in this._otherSourceCaches) {
                const i2 = this.getOwnSourceCache(t2);
                i2 && e2.push(i2.getSource());
              }
              return e2;
            }
            areTilesLoaded() {
              const e2 = this._mergedSourceCaches;
              for (const t2 in e2) {
                const i2 = e2[t2]._tiles;
                for (const e3 in i2) {
                  const t3 = i2[e3];
                  if ("loaded" !== t3.state && "errored" !== t3.state) return false;
                }
              }
              return true;
            }
            setLights(t2) {
              if (this._checkLoaded(), !t2) return delete this.ambientLight, void delete this.directionalLight;
              const i2 = this._getTransitionParameters();
              for (const o3 of t2) {
                if (this._validate(ye, "lights", o3)) return;
                switch (o3.type) {
                  case "ambient":
                    if (this.ambientLight) {
                      const e2 = this.ambientLight;
                      e2.set(o3), e2.updateTransitions(i2);
                    } else this.ambientLight = new $e(o3, qe || (qe = new e.a7({ color: new e.a8(e.a5.properties_light_ambient.color), "color-use-theme": new e.a8({ type: "string", default: "default", "property-type": "data-constant" }), intensity: new e.a8(e.a5.properties_light_ambient.intensity) })), this.scope, this.options);
                    break;
                  case "directional":
                    if (this.directionalLight) {
                      const e2 = this.directionalLight;
                      e2.set(o3), e2.updateTransitions(i2);
                    } else this.directionalLight = new $e(o3, Ze || (Ze = new e.a7({ direction: new e.an(e.a5.properties_light_directional.direction), color: new e.a8(e.a5.properties_light_directional.color), "color-use-theme": new e.a8({ type: "string", default: "default", "property-type": "data-constant" }), intensity: new e.a8(e.a5.properties_light_directional.intensity), "cast-shadows": new e.a8(e.a5.properties_light_directional["cast-shadows"]), "shadow-quality": new e.a8(e.a5.properties_light_directional["shadow-quality"]), "shadow-intensity": new e.a8(e.a5.properties_light_directional["shadow-intensity"]) })), this.scope, this.options);
                }
              }
              const o2 = Object.assign(i2, { worldview: this.map.getWorldview() }), s2 = new e.aa(this.z || 0, o2);
              this.ambientLight && this.ambientLight.recalculate(s2), this.directionalLight && this.directionalLight.recalculate(s2), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
            }
            calculateLightsBrightness() {
              const t2 = this.directionalLight, i2 = this.ambientLight;
              if (!t2 || !i2) return;
              const o2 = (e2) => 0.2126 * (e2[0] <= 0.03928 ? e2[0] / 12.92 : Math.pow((e2[0] + 0.055) / 1.055, 2.4)) + 0.7152 * (e2[1] <= 0.03928 ? e2[1] / 12.92 : Math.pow((e2[1] + 0.055) / 1.055, 2.4)) + 0.0722 * (e2[2] <= 0.03928 ? e2[2] / 12.92 : Math.pow((e2[2] + 0.055) / 1.055, 2.4)), s2 = t2.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), r2 = t2.properties.get("intensity"), n2 = t2.properties.get("direction"), a2 = 1 - e.cR(n2.x, n2.y, n2.z)[2] / 90, l2 = o2(s2) * r2 * a2, c2 = i2.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), h3 = i2.properties.get("intensity"), d2 = o2(c2) * h3;
              return Number(((l2 + d2) / 2).toFixed(6));
            }
            getBrightness() {
              return this._brightness;
            }
            getLights() {
              if (!this.enable3dLights()) return null;
              const e2 = [];
              return this.directionalLight && e2.push(this.directionalLight.get()), this.ambientLight && e2.push(this.ambientLight.get()), e2;
            }
            enable3dLights() {
              return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(t2) {
              if (null == t2 || "" === t2 && this.isRootStyle()) return this;
              if (e.d8(t2)) {
                const i2 = e.d9(t2), o2 = this.fragments.find(({ id: e2 }) => e2 === i2);
                if (!o2) return;
                const s2 = e.d7(t2);
                return o2.style.getFragmentStyle(s2);
              }
              {
                const e2 = this.fragments.find(({ id: e3 }) => e3 === t2);
                return e2 ? e2.style : void 0;
              }
            }
            setFeaturesetSelectors(t2) {
              if (!t2) return;
              const i2 = {}, o2 = (e2, t3 = "") => `${e2}::${t3}`;
              this._featuresetSelectors = {};
              for (const s2 in t2) {
                const r2 = this._featuresetSelectors[s2] = [];
                for (const n2 of t2[s2].selectors) {
                  if (n2.featureNamespace) {
                    const t4 = this.getOwnLayer(n2.layer);
                    if (!t4) {
                      e.w(`Layer is undefined for selector: ${n2.layer}`);
                      continue;
                    }
                    const r3 = o2(t4.source, t4.sourceLayer);
                    if (r3 in i2 && i2[r3] !== n2.featureNamespace) {
                      e.w(`"featureNamespace ${n2.featureNamespace} of featureset ${s2}'s selector is not associated to the same source, skip this selector`);
                      continue;
                    }
                    i2[r3] = n2.featureNamespace;
                  }
                  let t3;
                  if (n2.properties) for (const i3 in n2.properties) {
                    const o3 = e.X(n2.properties[i3]);
                    "success" === o3.result && (t3 = t3 || {}, t3[i3] = o3.value);
                  }
                  r2.push({ layerId: n2.layer, namespace: n2.featureNamespace, properties: t3, uniqueFeatureID: n2._uniqueFeatureID });
                }
              }
            }
            getFeaturesetDescriptors(e2) {
              const t2 = this.getFragmentStyle(e2);
              if (!t2 || !t2.stylesheet.featuresets) return [];
              const i2 = [];
              for (const e3 in t2.stylesheet.featuresets) i2.push({ featuresetId: e3, importId: t2.scope ? t2.scope : void 0 });
              return i2;
            }
            getFeaturesetLayers(t2, i2) {
              const o2 = this.getFragmentStyle(i2), s2 = o2.stylesheet.featuresets;
              if (!s2 || !s2[t2]) return this.fire(new e.z(new Error(`The featureset '${t2}' does not exist in the map's style and cannot be queried.`))), [];
              const r2 = [];
              for (const e2 of s2[t2].selectors) {
                const t3 = o2.getOwnLayer(e2.layer);
                t3 && r2.push(t3);
              }
              return r2;
            }
            getConfigProperty(t2, i2) {
              const o2 = this.getFragmentStyle(t2);
              if (!o2) return null;
              const s2 = e.C(i2, o2.scope), r2 = o2.options.get(s2), n2 = r2 ? r2.value || r2.default : null;
              return n2 ? n2.serialize() : null;
            }
            setConfigProperty(t2, i2, o2) {
              const s2 = this.getFragmentStyle(t2);
              if (!s2) return;
              const r2 = s2.stylesheet.indoor ? _o(s2.stylesheet.schema) : s2.stylesheet.schema;
              if (!r2 || !r2[i2]) return;
              const n2 = e.X(o2);
              if ("success" !== n2.result) return void vo(this, n2.value);
              const a2 = n2.value.expression, l2 = e.C(i2, s2.scope), c2 = s2.options.get(l2);
              if (!c2) return;
              let h3;
              const { minValue: d2, maxValue: u2, stepValue: _2, type: p3, values: f2 } = r2[i2], m2 = e.X(r2[i2].default);
              "success" === m2.result && (h3 = m2.value.expression), h3 ? (this.options.set(l2, Object.assign({}, c2, { value: a2, default: h3, minValue: d2, maxValue: u2, stepValue: _2, type: p3, values: f2 })), this.updateConfigDependencies(i2)) : this.fire(new e.z(new Error(`No schema defined for the config option "${i2}" in the "${t2}" fragment.`)));
            }
            getConfig(t2) {
              const i2 = this.getFragmentStyle(t2);
              if (!i2) return null;
              const o2 = i2.stylesheet.schema;
              if (!o2) return null;
              const s2 = {};
              for (const t3 in o2) {
                const o3 = e.C(t3, i2.scope), r2 = i2.options.get(o3), n2 = r2 ? r2.value || r2.default : null;
                s2[t3] = n2 ? n2.serialize() : null;
              }
              return s2;
            }
            setConfig(e2, t2) {
              const i2 = this.getFragmentStyle(e2);
              i2 && (i2.updateConfig(t2, i2.stylesheet.schema), this.updateConfigDependencies());
            }
            getSchema(e2) {
              const t2 = this.getFragmentStyle(e2);
              return t2 ? t2.stylesheet.schema : null;
            }
            setSchema(e2, t2) {
              const i2 = this.getFragmentStyle(e2);
              i2 && (i2.stylesheet.schema = t2, i2.updateConfig(i2._config, t2), this.updateConfigDependencies());
            }
            updateConfig(t2, i2) {
              if (this._config = t2, t2 || i2) if (i2) for (const o2 in i2) {
                let s2, r2;
                const n2 = e.X(i2[o2].default);
                if ("success" === n2.result && (s2 = n2.value.expression), t2 && void 0 !== t2[o2]) {
                  const i3 = e.X(t2[o2]);
                  "success" === i3.result && (r2 = i3.value.expression);
                }
                const { minValue: a2, maxValue: l2, stepValue: c2, type: h3, values: d2 } = i2[o2];
                if (s2) {
                  const t3 = e.C(o2, this.scope);
                  this.options.set(t3, { default: s2, value: r2, minValue: a2, maxValue: l2, stepValue: c2, type: h3, values: d2 });
                } else this.fire(new e.z(new Error(`No schema defined for config option "${o2}".`)));
              }
              else this.fire(new e.z(new Error("Attempting to set config for a style without schema.")));
            }
            updateConfigDependencies(e2) {
              for (const t2 of this._configDependentLayers) {
                const i2 = this.getLayer(t2);
                if (i2) {
                  if (e2 && !i2.configDependencies.has(e2)) continue;
                  i2.possiblyEvaluateVisibility(), this._updateLayer(i2);
                }
              }
              this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.snow && this.snow.updateConfig(this.options), this.rain && this.rain.updateConfig(this.options), this.forEachFragmentStyle((e3) => {
                const t2 = e3._styleColorTheme.colorThemeOverride ? e3._styleColorTheme.colorThemeOverride : e3._styleColorTheme.colorTheme;
                if (t2) {
                  const i2 = e3._evaluateColorThemeData(t2);
                  (!e3._styleColorTheme.lut && "" !== i2 || e3._styleColorTheme.lut && i2 !== e3._styleColorTheme.lut.data) && e3.setColorTheme(t2);
                }
              }), this._changes.setDirty();
            }
            addLayer(t2, i2, o2 = {}) {
              this._checkLoaded();
              const s2 = t2.id;
              if (this._layers[s2]) return void this.fire(new e.z(new Error(`Layer with id "${s2}" already exists on this map`)));
              let r2;
              if ("custom" === t2.type) {
                if (vo(this, e.da(t2))) return;
                r2 = e.db(t2, this.scope, this._styleColorTheme.lut, this.options);
              } else {
                if ("object" == typeof t2.source && (this.addSource(s2, t2.source), t2 = e.d6(t2), t2 = e.h(t2, { source: s2 })), this._validate(Ee, `layers.${s2}`, t2, { arrayIndex: -1 }, o2)) return;
                r2 = e.db(t2, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(r2), r2.setEventedParent(this, { layer: { id: s2 } });
              }
              0 !== r2.configDependencies.size && this._configDependentLayers.add(r2.fqid);
              let n2 = this._order.length;
              if (i2) {
                const t3 = this._order.indexOf(i2);
                if (-1 === t3) return void this.fire(new e.z(new Error(`Layer with id "${i2}" does not exist on this map.`)));
                r2.slot === this._layers[i2].slot ? n2 = t3 : e.w(`Layer with id "${i2}" has a different slot. Layers can only be rearranged within the same slot.`);
              }
              this._order.splice(n2, 0, s2), this._layerOrderChanged = true, this._layers[s2] = r2;
              const a2 = this.getOwnLayerSourceCache(r2), l2 = !!this.directionalLight && this.directionalLight.shadowsEnabled();
              a2 && r2.canCastShadows() && l2 && (a2.castsShadows = true);
              const c2 = this._changes.getRemovedLayer(r2);
              if (c2 && r2.source && a2 && "custom" !== r2.type) {
                this._changes.discardLayerRemoval(r2);
                const t3 = e.C(r2.source, r2.scope);
                c2.type !== r2.type ? this._changes.updateSourceCache(t3, "clear") : (this._changes.updateSourceCache(t3, "reload"), a2.pause());
              }
              this._updateLayer(r2), r2.onAdd && r2.onAdd(this.map), r2.scope = this.scope, this.mergeLayers();
            }
            moveLayer(t2, i2) {
              this._checkLoaded();
              const o2 = this._checkLayer(t2);
              if (!o2) return;
              if (t2 === i2) return;
              const s2 = this._order.indexOf(t2);
              this._order.splice(s2, 1);
              let r2 = this._order.length;
              if (i2) {
                const t3 = this._order.indexOf(i2);
                if (-1 === t3) return void this.fire(new e.z(new Error(`Layer with id "${i2}" does not exist on this map.`)));
                o2.slot === this._layers[i2].slot ? r2 = t3 : e.w(`Layer with id "${i2}" has a different slot. Layers can only be rearranged within the same slot.`);
              }
              this._order.splice(r2, 0, t2), this._changes.setDirty(), this._layerOrderChanged = true, this.mergeLayers();
            }
            removeLayer(e2) {
              this._checkLoaded();
              const t2 = this._checkLayer(e2);
              if (!t2) return;
              t2.setEventedParent(null);
              const i2 = this._order.indexOf(e2);
              this._order.splice(i2, 1), delete this._layers[e2], this._changes.setDirty(), this._layerOrderChanged = true, this._configDependentLayers.delete(t2.fqid), this._changes.removeLayer(t2);
              const o2 = this.getOwnLayerSourceCache(t2);
              if (o2 && o2.castsShadows) {
                let e3 = false;
                for (const i3 in this._layers) if (this._layers[i3].source === t2.source && this._layers[i3].canCastShadows()) {
                  e3 = true;
                  break;
                }
                o2.castsShadows = e3;
              }
              t2.onRemove && t2.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e2) {
              return this._layers[e2];
            }
            hasLayer(e2) {
              return e2 in this._mergedLayers;
            }
            hasLayerType(e2) {
              for (const t2 in this._layers) if (this._layers[t2].type === e2) return true;
              return false;
            }
            setLayerZoomRange(e2, t2, i2) {
              this._checkLoaded();
              const o2 = this._checkLayer(e2);
              o2 && (o2.minzoom === t2 && o2.maxzoom === i2 || (null != t2 && (o2.minzoom = t2), null != i2 && (o2.maxzoom = i2), this._updateLayer(o2)));
            }
            getSlots() {
              return this._checkLoaded(), this._mergedSlots;
            }
            setSlot(e2, t2) {
              this._checkLoaded();
              const i2 = this._checkLayer(e2);
              i2 && i2.slot !== t2 && (i2.slot = t2, this._updateLayer(i2));
            }
            setFilter(t2, i2, o2 = {}) {
              this._checkLoaded();
              const s2 = this._checkLayer(t2);
              if (s2 && !e.bv(s2.filter, i2)) return null == i2 ? (s2.filter = void 0, void this._updateLayer(s2)) : void (this._validate(Se, `layers.${s2.id}.filter`, i2, { layerType: s2.type }, o2) || (s2.filter = e.d6(i2), this._updateLayer(s2)));
            }
            getFilter(t2) {
              const i2 = this._checkLayer(t2);
              if (i2) return e.d6(i2.filter);
            }
            setLayoutProperty(t2, i2, o2, s2 = {}) {
              this._checkLoaded();
              const r2 = this._checkLayer(t2);
              if (r2 && !e.bv(r2.getLayoutProperty(i2), o2)) {
                if (null != o2 && (!s2 || false !== s2.validate) && vo(r2, Ce.call(me, { key: `layers.${t2}.layout.${i2}`, layerType: r2.type, objectKey: i2, value: o2, styleSpec: e.a5, style: { glyphs: true, sprite: true } }))) return;
                r2.setLayoutProperty(i2, o2), 0 !== r2.configDependencies.size && this._configDependentLayers.add(r2.fqid), this._updateLayer(r2);
              }
            }
            getLayoutProperty(e2, t2) {
              const i2 = this._checkLayer(e2);
              if (i2) return i2.getLayoutProperty(t2);
            }
            setPaintProperty(t2, i2, o2, s2 = {}) {
              this._checkLoaded();
              const r2 = this._checkLayer(t2);
              if (!r2) return;
              if (e.bv(r2.getPaintProperty(i2), o2)) return;
              if (null != o2 && (!s2 || false !== s2.validate) && vo(r2, Ie.call(me, { key: `layers.${t2}.paint.${i2}`, layerType: r2.type, objectKey: i2, value: o2, styleSpec: e.a5 }))) return;
              const n2 = r2.setPaintProperty(i2, o2);
              0 !== r2.configDependencies.size && this._configDependentLayers.add(r2.fqid), n2 && this._updateLayer(r2), this._changes.updatePaintProperties(r2);
            }
            getPaintProperty(e2, t2) {
              const i2 = this._checkLayer(e2);
              if (i2) return i2.getPaintProperty(t2);
            }
            setFeatureState(t2, i2) {
              if (this._checkLoaded(), "target" in t2) {
                if ("featuresetId" in t2.target) {
                  const { featuresetId: e2, importId: o3 } = t2.target, s3 = this.getFragmentStyle(o3), r3 = s3.getFeaturesetLayers(e2);
                  for (const { source: e3, sourceLayer: o4 } of r3) s3.setFeatureState({ id: t2.id, source: e3, sourceLayer: o4 }, i2);
                } else if ("layerId" in t2.target) {
                  const { layerId: e2 } = t2.target, o3 = this.getLayer(e2);
                  this.setFeatureState({ id: t2.id, source: o3.source, sourceLayer: o3.sourceLayer }, i2);
                }
                return;
              }
              const o2 = t2.source, s2 = t2.sourceLayer, r2 = this._checkSource(o2);
              if (!r2) return;
              const n2 = r2.type;
              if ("geojson" === n2 && s2) return void this.fire(new e.z(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
              if ("vector" === n2 && !s2) return void this.fire(new e.z(new Error("The sourceLayer parameter must be provided for vector source types.")));
              void 0 === t2.id && this.fire(new e.z(new Error("The feature id parameter must be provided.")));
              const a2 = this.getOwnSourceCaches(o2);
              for (const e2 of a2) e2.setFeatureState(s2, t2.id, i2);
            }
            removeFeatureState(t2, i2) {
              if (this._checkLoaded(), "target" in t2) {
                if ("featuresetId" in t2.target) {
                  const { featuresetId: e2, importId: o3 } = t2.target, s3 = this.getFragmentStyle(o3), r3 = s3.getFeaturesetLayers(e2);
                  for (const { source: e3, sourceLayer: o4 } of r3) s3.removeFeatureState({ id: t2.id, source: e3, sourceLayer: o4 }, i2);
                } else if ("layerId" in t2.target) {
                  const { layerId: e2 } = t2.target, o3 = this.getLayer(e2);
                  this.removeFeatureState({ id: t2.id, source: o3.source, sourceLayer: o3.sourceLayer }, i2);
                }
                return;
              }
              const o2 = t2.source, s2 = this._checkSource(o2);
              if (!s2) return;
              const r2 = s2.type, n2 = "vector" === r2 ? t2.sourceLayer : void 0;
              if ("vector" === r2 && !n2) return void this.fire(new e.z(new Error("The sourceLayer parameter must be provided for vector source types.")));
              if (i2 && "string" != typeof t2.id && "number" != typeof t2.id) return void this.fire(new e.z(new Error("A feature id is required to remove its specific state property.")));
              const a2 = this.getOwnSourceCaches(o2);
              for (const e2 of a2) e2.removeFeatureState(n2, t2.id, i2);
            }
            getFeatureState(t2) {
              if (this._checkLoaded(), "target" in t2) {
                let i3;
                if ("featuresetId" in t2.target) {
                  const { featuresetId: o3, importId: s3 } = t2.target, r2 = this.getFragmentStyle(s3), n2 = r2.getFeaturesetLayers(o3);
                  for (const { source: o4, sourceLayer: s4 } of n2) {
                    const n3 = r2.getFeatureState({ id: t2.id, source: o4, sourceLayer: s4 });
                    if (n3 && !i3) i3 = n3;
                    else if (!e.bv(i3, n3)) return void this.fire(new e.z(new Error("The same feature id exists in multiple sources in the featureset, but their feature states are not consistent through the sources.")));
                  }
                } else if ("layerId" in t2.target) {
                  const { layerId: e2 } = t2.target, o3 = this.getLayer(e2);
                  i3 = this.getFeatureState({ id: t2.id, source: o3.source, sourceLayer: o3.sourceLayer });
                }
                return i3;
              }
              const i2 = t2.source, o2 = t2.sourceLayer, s2 = this._checkSource(i2);
              if (s2) {
                if ("vector" !== s2.type || o2) return void 0 === t2.id && this.fire(new e.z(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i2)[0].getFeatureState(o2, t2.id);
                this.fire(new e.z(new Error("The sourceLayer parameter must be provided for vector source types.")));
              }
            }
            setTransition(t2) {
              return this.stylesheet.transition = e.h({}, this.stylesheet.transition, t2), this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
              return e.h({}, this.stylesheet.transition);
            }
            serialize() {
              this._checkLoaded();
              const t2 = this.getTerrain(), i2 = t2 && this.terrain && this.terrain.scope === this.scope ? t2 : this.stylesheet.terrain;
              return e.dc({ version: this.stylesheet.version, name: this.stylesheet.name, metadata: this.stylesheet.metadata, fragment: this.stylesheet.fragment, iconsets: this.stylesheet.iconsets, imports: this._serializeImports(), schema: this.stylesheet.schema, camera: this.stylesheet.camera, light: this.stylesheet.light, lights: this.stylesheet.lights, terrain: i2, fog: this.stylesheet.fog, snow: this.stylesheet.snow, rain: this.stylesheet.rain, center: this.stylesheet.center, "color-theme": this.stylesheet["color-theme"], zoom: this.stylesheet.zoom, bearing: this.stylesheet.bearing, pitch: this.stylesheet.pitch, sprite: this.stylesheet.sprite, glyphs: this.stylesheet.glyphs, transition: this.stylesheet.transition, projection: this.stylesheet.projection, sources: this._serializeSources(), layers: this._serializeLayers(this._order) }, (e2) => void 0 !== e2);
            }
            _updateFilteredLayers(e2) {
              for (const t2 of Object.values(this._mergedLayers)) e2(t2) && this._updateLayer(t2);
            }
            _updateLayer(t2) {
              this._changes.updateLayer(t2);
              const i2 = this.getLayerSourceCache(t2), o2 = e.C(t2.source, t2.scope), s2 = this._changes.getUpdatedSourceCaches();
              t2.source && !s2[o2] && i2 && "raster" !== i2.getSource().type && (this._changes.updateSourceCache(o2, "reload"), i2.pause()), t2.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e2) {
              const t2 = (e3) => this._mergedLayers[e3].is3D(!!this.terrain), i2 = this.order, o2 = {}, s2 = [];
              for (let r3 = i2.length - 1; r3 >= 0; r3--) {
                const n2 = i2[r3];
                if (t2(n2)) {
                  o2[n2] = r3;
                  for (const t3 of e2) {
                    const e3 = t3[n2];
                    if (e3) for (const t4 of e3) s2.push(t4);
                  }
                }
              }
              s2.sort((e3, t3) => t3.intersectionZ - e3.intersectionZ);
              const r2 = [];
              for (let n2 = i2.length - 1; n2 >= 0; n2--) {
                const a2 = i2[n2];
                if (t2(a2)) for (let e3 = s2.length - 1; e3 >= 0; e3--) {
                  const t3 = s2[e3].feature;
                  if (t3.layer && o2[t3.layer.id] < n2) break;
                  r2.push(t3), s2.pop();
                }
                else for (const t3 of e2) {
                  const e3 = t3[a2];
                  if (e3) for (const t4 of e3) r2.push(t4.feature);
                }
              }
              return r2;
            }
            queryRenderedFeatures(t2, i2, o2) {
              let s2;
              i2 && !Array.isArray(i2) && i2.filter && (this._validate(Se, "queryRenderedFeatures.filter", i2.filter, null, i2), s2 = e.b3(i2.filter));
              const r2 = {}, n2 = (e2) => {
                if (bo.has(e2.type)) return;
                const t3 = this.getOwnLayerSourceCache(e2), i3 = r2[t3.id] = r2[t3.id] || { sourceCache: t3, layers: {}, has3DLayers: false };
                e2.is3D(!!this.terrain) && (i3.has3DLayers = true), i3.layers[e2.fqid] = i3.layers[e2.fqid] || { styleLayer: e2, targets: [] }, i3.layers[e2.fqid].targets.push({ filter: s2 });
              };
              if (i2 && i2.layers) {
                if (!Array.isArray(i2.layers)) return this.fire(new e.z(new Error("parameters.layers must be an Array."))), [];
                for (const t3 of i2.layers) {
                  const i3 = this._layers[t3];
                  if (!i3) return this.fire(new e.z(new Error(`The layer '${t3}' does not exist in the map's style and cannot be queried for features.`))), [];
                  n2(i3);
                }
              } else for (const e2 in this._layers) n2(this._layers[e2]);
              const a2 = this._queryRenderedFeatures(t2, r2, o2), l2 = this._flattenAndSortRenderedFeatures(a2), c2 = [];
              for (const t3 of l2) e.dd(t3.layer.id) === this.scope && c2.push(t3);
              return c2;
            }
            queryRenderedFeatureset(t2, i2, o2) {
              let s2;
              i2 && !Array.isArray(i2) && i2.filter && (this._validate(Se, "queryRenderedFeatures.filter", i2.filter, null, i2), s2 = e.b3(i2.filter));
              const r2 = "mock", n2 = [];
              if (i2 && i2.target) n2.push(Object.assign({}, i2, { targetId: r2, filter: s2 }));
              else {
                const e2 = this.getFeaturesetDescriptors();
                for (const t3 of e2) n2.push({ targetId: r2, filter: s2, target: t3 });
                for (const { style: e3 } of this.fragments) {
                  const t3 = e3.getFeaturesetDescriptors();
                  for (const e4 of t3) n2.push({ targetId: r2, filter: s2, target: e4 });
                }
              }
              const a2 = this.queryRenderedTargets(t2, n2, o2), l2 = [], c2 = /* @__PURE__ */ new Set();
              for (const t3 of a2) for (const i3 of t3.variants[r2]) lt(i3, t3, c2) || l2.push(new e.de(t3, i3));
              return l2;
            }
            queryRenderedTargets(t2, i2, o2) {
              const s2 = {}, r2 = (e2, t3, i3, o3) => {
                const r3 = s2[t3.id] = s2[t3.id] || { sourceCache: t3, layers: {}, has3DLayers: false };
                if (r3.layers[e2.fqid] = r3.layers[e2.fqid] || { styleLayer: e2, targets: [] }, e2.is3D(!!this.terrain) && (r3.has3DLayers = true), !o3) return i3.uniqueFeatureID = false, void r3.layers[e2.fqid].targets.push(i3);
                r3.layers[e2.fqid].targets.push(Object.assign({}, i3, { namespace: o3.namespace, properties: o3.properties, uniqueFeatureID: o3.uniqueFeatureID }));
              };
              for (const t3 of i2) if ("featuresetId" in t3.target) {
                const { featuresetId: i3, importId: o3 } = t3.target, s3 = this.getFragmentStyle(o3);
                if (!s3 || !s3._featuresetSelectors) continue;
                const n3 = s3._featuresetSelectors[i3];
                if (!n3) {
                  this.fire(new e.z(new Error(`The featureset '${i3}' does not exist in the map's style and cannot be queried for features.`)));
                  continue;
                }
                for (const e2 of n3) {
                  const i4 = s3.getOwnLayer(e2.layerId);
                  i4 && !bo.has(i4.type) && r2(i4, s3.getOwnLayerSourceCache(i4), t3, e2);
                }
              } else if ("layerId" in t3.target) {
                const { layerId: e2 } = t3.target, i3 = this.getLayer(e2);
                if (!i3 || bo.has(i3.type)) continue;
                r2(i3, this.getLayerSourceCache(i3), t3);
              }
              const n2 = this._queryRenderedFeatures(t2, s2, o2);
              return this._flattenAndSortRenderedFeatures(n2);
            }
            _queryRenderedFeatures(e2, t2, i2) {
              const o2 = [], s2 = !!this.map._showQueryGeometry, r2 = Xe.createFromScreenPoints(e2, i2);
              for (const e3 in t2) {
                const n2 = ct(r2, t2[e3], this._availableImages, i2, s2);
                Object.keys(n2).length && o2.push(n2);
              }
              if (this.placement) for (const e3 in t2) {
                if (!t2[e3].sourceCache._onlySymbols) continue;
                const i3 = ht(r2.screenGeometry, t2[e3], this._availableImages, this.placement.collisionIndex, this.placement.retainedQueryData, this.map.getWorldview());
                Object.keys(i3).length && o2.push(i3);
              }
              return o2;
            }
            querySourceFeatures(e2, t2) {
              const i2 = t2 && t2.filter;
              i2 && this._validate(Se, "querySourceFeatures.filter", i2, null, t2);
              let o2 = [];
              const s2 = this.getOwnSourceCaches(e2);
              for (const e3 of s2) o2 = o2.concat(dt(e3, t2));
              return o2;
            }
            addSourceType(e2, t2, i2) {
              return Eo.getSourceType(e2) ? i2(new Error(`A source type called "${e2}" already exists.`)) : (Eo.setSourceType(e2, t2), t2.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", { name: e2, url: t2.workerSourceURL }, i2) : i2(null, null));
            }
            getFlatLight() {
              return this.light.getLight();
            }
            setFlatLight(t2, i2, o2 = {}) {
              this._checkLoaded();
              const s2 = this.light.getLight();
              let r2 = false;
              for (const i3 in t2) if (!e.bv(t2[i3], s2[i3])) {
                r2 = true;
                break;
              }
              if (!r2) return;
              const n2 = this._getTransitionParameters();
              this.light.setLight(t2, i2, o2), this.light.updateTransitions(n2);
            }
            getTerrain() {
              return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
              this.setTerrain({ source: "", exaggeration: 0 }, 0);
            }
            checkCanvasFingerprintNoise() {
              void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e.q.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
            }
            setTerrain(t2, i2 = 1) {
              if (this._checkLoaded(), !t2) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i2 && delete this.terrain, null === t2 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = true);
              this.checkCanvasFingerprintNoise();
              let o2 = t2;
              const s2 = null == t2.source;
              if (1 === i2) {
                if (this.disableElevatedTerrain) return;
                if ("object" == typeof o2.source) {
                  const t4 = "terrain-dem-src";
                  this.addSource(t4, o2.source), o2 = e.d6(o2), o2 = e.h(o2, { source: t4 });
                }
                const t3 = e.h({}, o2), i3 = {};
                if (this.terrain && s2) {
                  t3.source = this.terrain.get().source;
                  const e2 = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                  e2 && (i3.style = e2.serialize());
                }
                if (this._validate(xe, "terrain", t3, i3)) return;
              }
              if (!this.terrain || this.terrain.scope !== this.scope && !s2 || this.terrain && i2 !== this.terrain.drapeRenderMode) {
                if (!o2) return;
                this._createTerrain(o2, i2), this.fire(new e.A("data", { dataType: "style" }));
              } else {
                const i3 = this.terrain, s3 = i3.get();
                for (const t3 of Object.keys(e.a5.terrain)) !o2.hasOwnProperty(t3) && e.a5.terrain[t3].default && (o2[t3] = e.a5.terrain[t3].default);
                for (const o3 in t2) if (!e.bv(t2[o3], s3[o3])) {
                  i3.set(t2, this.options), this.stylesheet.terrain = t2;
                  const o4 = this._getTransitionParameters({ duration: 0 });
                  i3.updateTransitions(o4), this.fire(new e.A("data", { dataType: "style" }));
                  break;
                }
              }
              this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = true;
            }
            _createFog(e2) {
              const t2 = this.fog = new je(e2, this.map.transform, this.scope, this.options);
              this.stylesheet.fog = t2.get();
              const i2 = this._getTransitionParameters({ duration: 0 });
              t2.updateTransitions(i2);
            }
            _createSnow(e2) {
              const t2 = this.snow = new He(e2, this.map.transform, this.scope, this.options);
              this.stylesheet.snow = t2.get();
              const i2 = this._getTransitionParameters({ duration: 0 });
              t2.updateTransitions(i2);
            }
            _createRain(e2) {
              const t2 = this.rain = new We(e2, this.map.transform, this.scope, this.options);
              this.stylesheet.rain = t2.get();
              const i2 = this._getTransitionParameters({ duration: 0 });
              t2.updateTransitions(i2);
            }
            _updateMarkersOpacity() {
              0 !== this.map._markers.length && this.map._requestDomTask(() => {
                for (const e2 of this.map._markers) e2._evaluateOpacity();
              });
            }
            getFog() {
              return this.fog ? this.fog.get() : null;
            }
            setFog(t2) {
              if (this._checkLoaded(), !t2) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = true);
              if (this.fog) {
                const i2 = this.fog;
                if (!e.bv(i2.get(), t2)) {
                  i2.set(t2, this.options), this.stylesheet.fog = i2.get();
                  const e2 = this._getTransitionParameters({ duration: 0 });
                  i2.updateTransitions(e2);
                }
              } else this._createFog(t2);
              this._markersNeedUpdate = true;
            }
            getSnow() {
              return this.snow ? this.snow.get() : null;
            }
            setSnow(t2) {
              if (this._checkLoaded(), !t2) return delete this.snow, void delete this.stylesheet.snow;
              if (this.snow) {
                const i2 = this.snow;
                if (!e.bv(i2.get(), t2)) {
                  i2.set(t2, this.options), this.stylesheet.snow = i2.get();
                  const e2 = this._getTransitionParameters({ duration: 0 });
                  i2.updateTransitions(e2);
                }
              } else this._createSnow(t2);
              this._markersNeedUpdate = true;
            }
            getRain() {
              return this.rain ? this.rain.get() : null;
            }
            setRain(t2) {
              if (this._checkLoaded(), !t2) return delete this.rain, void delete this.stylesheet.rain;
              if (this.rain) {
                const i2 = this.rain;
                if (!e.bv(i2.get(), t2)) {
                  i2.set(t2, this.options), this.stylesheet.rain = i2.get();
                  const e2 = this._getTransitionParameters({ duration: 0 });
                  i2.updateTransitions(e2);
                }
              } else this._createRain(t2);
              this._markersNeedUpdate = true;
            }
            _reloadColorTheme() {
              const t2 = () => {
                for (const e2 in this._layers) this._layers[e2].lut = this._styleColorTheme.lut;
                for (const e2 in this._sourceCaches) this._sourceCaches[e2].clearTiles();
              }, i2 = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
              if (!i2) return this._styleColorTheme.lut = null, void t2();
              const o2 = this._evaluateColorThemeData(i2);
              this._loadColorTheme(o2).then(() => {
                this.fire(new e.A("colorthemeset")), t2();
              }).catch((t3) => {
                e.w(`Couldn't set color theme: ${t3}`);
              });
            }
            setColorTheme(t2) {
              this._checkLoaded(), this._styleColorTheme.colorThemeOverride && e.w("Note: setColorTheme is called on a style with a color-theme override, the passed color-theme won't be visible."), this._styleColorTheme.colorTheme = t2, this._reloadColorTheme();
            }
            setImportColorTheme(e2, t2) {
              const i2 = this.getFragmentStyle(e2);
              i2 && (i2._styleColorTheme.colorThemeOverride = t2, i2._reloadColorTheme());
            }
            _getTransitionParameters(t2) {
              return { now: e.q.now(), transition: e.h(this.transition, t2) };
            }
            updateDrapeFirstLayers() {
              if (!this.terrain) return;
              const e2 = [], t2 = [];
              for (const i2 of this._mergedOrder) this.isLayerDraped(this._mergedLayers[i2]) ? e2.push(i2) : t2.push(i2);
              this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e2), this._drapedFirstOrder.push(...t2);
            }
            _createTerrain(e2, t2) {
              const i2 = this.terrain = new ze(e2, t2, this.scope, this.options, this.map.getWorldview());
              1 === t2 && (this.stylesheet.terrain = e2), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
              const o2 = this._getTransitionParameters({ duration: 0 });
              i2.updateTransitions(o2);
            }
            _force3DLayerUpdate() {
              for (const e2 in this._layers) {
                const t2 = this._layers[e2];
                "fill-extrusion" === t2.type && this._updateLayer(t2);
              }
            }
            _forceSymbolLayerUpdate() {
              for (const e2 in this._layers) {
                const t2 = this._layers[e2];
                "symbol" === t2.type && this._updateLayer(t2);
              }
            }
            _validate(t2, i2, o2, s2, r2 = {}) {
              if (r2 && false === r2.validate) return false;
              const n2 = e.h({}, this.serialize());
              return vo(this, t2.call(me, e.h({ key: i2, style: n2, value: o2, styleSpec: e.a5 }, s2)));
            }
            _remove() {
              this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e.df.off("pluginStateChange", this._rtlTextPluginCallback);
              for (const e2 in this._mergedLayers) this._mergedLayers[e2].setEventedParent(null);
              for (const e2 in this._mergedSourceCaches) this._mergedSourceCaches[e2].clearTiles(), this._mergedSourceCaches[e2].setEventedParent(null);
              this.imageManager.removeScope(this.scope), this.setEventedParent(null), delete this.fog, delete this.snow, delete this.rain, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.modelManager.destroy(), this.dispatcher.remove());
            }
            clearSource(e2) {
              const t2 = this.getSourceCaches(e2);
              for (const e3 of t2) e3.clearTiles();
            }
            clearSources() {
              for (const e2 in this._mergedSourceCaches) this._mergedSourceCaches[e2].clearTiles();
            }
            reloadSource(e2) {
              const t2 = this.getSourceCaches(e2);
              for (const e3 of t2) e3.resume(), e3.reload();
            }
            reloadSources() {
              for (const e2 of this.getSources()) e2.reload && e2.reload();
            }
            reloadModels() {
              this.modelManager.reloadModels(""), this.forEachFragmentStyle((e2) => {
                e2.modelManager.reloadModels(e2.scope);
              });
            }
            updateSources(e2) {
              let t2;
              this.directionalLight && (t2 = no(this.directionalLight));
              const i2 = /* @__PURE__ */ new Set();
              for (const e3 in this._mergedLayers) {
                const t3 = this._mergedLayers[e3];
                t3.hasElevation() && !i2.has(t3.source) && i2.add(t3.source);
              }
              for (const o2 in this._mergedSourceCaches) {
                const s2 = this._mergedSourceCaches[o2], r2 = i2.has(s2._source.id);
                s2.update(e2, void 0, void 0, t2, r2);
              }
            }
            _generateCollisionBoxes() {
              for (const e2 in this._sourceCaches) {
                const t2 = this._sourceCaches[e2];
                t2.resume(), t2.reload();
              }
            }
            _updatePlacement(t2, i2, o2, s2, r2, n2, a2 = false) {
              let l2 = false, c2 = false;
              const h3 = {}, d2 = {};
              for (const t3 of this._mergedOrder) {
                const o3 = this._mergedLayers[t3];
                if ("symbol" !== o3.type) continue;
                const s3 = e.C(o3.source, o3.scope);
                let r3 = h3[s3];
                if (!r3) {
                  const e2 = this.getLayerSourceCache(o3);
                  if (!e2) continue;
                  const t4 = e2.getRenderableIds(true).map((t5) => e2.getTileByID(t5));
                  d2[s3] = t4.slice(), r3 = h3[s3] = t4.sort((e3, t5) => t5.tileID.overscaledZ - e3.tileID.overscaledZ || (e3.tileID.isLessThan(t5.tileID) ? -1 : 1));
                }
                const n3 = this.crossTileSymbolIndex.addLayer(o3, r3, i2.center.lng, i2.projection);
                l2 = l2 || n3;
              }
              if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), a2 = a2 || this._layerOrderChanged || 0 === s2, this._layerOrderChanged && this.fire(new e.A("neworder")), (a2 || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(e.q.now(), i2.zoom)) && (this.pauseablePlacement = new Li(i2, this._mergedOrder, a2, o2, s2, r2, this.placement, this.fog && i2.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = false), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, h3, d2, this.map.painter.scaleFactor), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e.q.now()), c2 = true), l2 && this.pauseablePlacement.placement.setStale()), c2 || l2) {
                this._buildingIndex.onNewFrame(i2.zoom);
                for (let t3 = 0; t3 < this._mergedOrder.length; t3++) {
                  const i3 = this._mergedLayers[this._mergedOrder[t3]];
                  if ("symbol" !== i3.type) continue;
                  const o3 = this.isLayerClipped(i3);
                  this.placement.updateLayerOpacities(i3, h3[e.C(i3.source, i3.scope)], t3, o3 ? n2 : null);
                }
              }
              return { needsRerender: !this.pauseablePlacement.isDone() || this.placement.hasTransitions(e.q.now()) };
            }
            _releaseSymbolFadeTiles() {
              for (const e2 in this._sourceCaches) this._sourceCaches[e2].releaseSymbolFadeTiles();
            }
            addImport(t2, i2) {
              this._checkLoaded();
              const o2 = this.stylesheet.imports = this.stylesheet.imports || [];
              if (-1 !== o2.findIndex(({ id: e2 }) => e2 === t2.id)) return void this.fire(new e.z(new Error(`Import with id '${t2.id}' already exists in the map's style.`)));
              if (!i2) return o2.push(t2), this._loadImports([t2], true);
              const s2 = o2.findIndex(({ id: e2 }) => e2 === i2);
              return -1 === s2 && this.fire(new e.z(new Error(`Import with id "${i2}" does not exist on this map.`))), this.stylesheet.imports = o2.slice(0, s2).concat(t2).concat(o2.slice(s2)), this._loadImports([t2], true, i2);
            }
            updateImport(t2, i2) {
              this._checkLoaded();
              const o2 = this.stylesheet.imports || [], s2 = this.getImportIndex(t2);
              return -1 === s2 ? this : "string" == typeof i2 ? (this.setImportUrl(t2, i2), this) : (i2.url && i2.url !== o2[s2].url && this.setImportUrl(t2, i2.url), e.bv(i2.config, o2[s2].config) || this.setImportConfig(t2, i2.config, i2.data.schema), e.bv(i2.data, o2[s2].data) || this.setImportData(t2, i2.data), this);
            }
            moveImport(e2, t2) {
              this._checkLoaded();
              let i2 = this.stylesheet.imports || [];
              const o2 = this.getImportIndex(e2);
              if (-1 === o2) return this;
              const s2 = this.getImportIndex(t2);
              if (-1 === s2) return this;
              const r2 = i2[o2], n2 = this.fragments[o2];
              return i2 = i2.filter(({ id: t3 }) => t3 !== e2), this.fragments = this.fragments.filter(({ id: t3 }) => t3 !== e2), this.stylesheet.imports = i2.slice(0, s2).concat(r2).concat(i2.slice(s2)), this.fragments = this.fragments.slice(0, s2).concat(n2).concat(this.fragments.slice(s2)), this.mergeLayers(), this;
            }
            setImportUrl(e2, t2) {
              this._checkLoaded();
              const i2 = this.stylesheet.imports || [], o2 = this.getImportIndex(e2);
              if (-1 === o2) return this;
              i2[o2].url = t2;
              const s2 = this.fragments[o2];
              return s2.style = this._createFragmentStyle(i2[o2]), s2.style.on("style.import.load", () => this.mergeAll()), s2.style.loadURL(t2), this;
            }
            setImportData(e2, t2) {
              this._checkLoaded();
              const i2 = this.getImportIndex(e2), o2 = this.stylesheet.imports || [];
              return -1 === i2 ? this : t2 ? (this.fragments[i2].style.setState(t2), this._reloadImports(), this) : (delete o2[i2].data, this.setImportUrl(e2, o2[i2].url));
            }
            setImportConfig(e2, t2, i2) {
              this._checkLoaded();
              const o2 = this.getImportIndex(e2), s2 = this.stylesheet.imports || [];
              if (-1 === o2) return this;
              t2 ? s2[o2].config = t2 : delete s2[o2].config;
              const r2 = this.fragments[o2];
              i2 && r2.style.stylesheet && (r2.style.stylesheet.schema = i2);
              const n2 = r2.style.stylesheet && r2.style.stylesheet.schema;
              return r2.config = t2, r2.style.updateConfig(t2, n2), this.updateConfigDependencies(), this;
            }
            removeImport(e2) {
              this._checkLoaded();
              const t2 = this.stylesheet.imports || [], i2 = this.getImportIndex(e2);
              -1 !== i2 && (t2.splice(i2, 1), this.fragments[i2].style._remove(), this.fragments.splice(i2, 1), this._reloadImports());
            }
            getImportIndex(t2) {
              const i2 = (this.stylesheet.imports || []).findIndex((e2) => e2.id === t2);
              return -1 === i2 && this.fire(new e.z(new Error(`Import '${t2}' does not exist in the map's style and cannot be updated.`))), i2;
            }
            getLayer(e2) {
              return this._mergedLayers[e2];
            }
            getSources() {
              const e2 = [];
              for (const t2 in this._mergedOtherSourceCaches) {
                const i2 = this._mergedOtherSourceCaches[t2];
                i2 && e2.push(i2.getSource());
              }
              return e2;
            }
            getSource(e2, t2) {
              const i2 = this.getSourceCache(e2, t2);
              return i2 && i2.getSource();
            }
            getLayerSource(e2) {
              const t2 = this.getLayerSourceCache(e2);
              return t2 && t2.getSource();
            }
            getSourceCache(t2, i2) {
              const o2 = e.C(t2, i2);
              return this._mergedOtherSourceCaches[o2];
            }
            getLayerSourceCache(t2) {
              const i2 = e.C(t2.source, t2.scope);
              return "symbol" === t2.type ? this._mergedSymbolSourceCaches[i2] : this._mergedOtherSourceCaches[i2];
            }
            getSourceCaches(e2) {
              if (null == e2) return Object.values(this._mergedSourceCaches);
              const t2 = [];
              return this._mergedOtherSourceCaches[e2] && t2.push(this._mergedOtherSourceCaches[e2]), this._mergedSymbolSourceCaches[e2] && t2.push(this._mergedSymbolSourceCaches[e2]), t2;
            }
            updateSourceCaches() {
              const e2 = this._changes.getUpdatedSourceCaches();
              for (const t2 in e2) {
                const i2 = e2[t2];
                "reload" === i2 ? this.reloadSource(t2) : "clear" === i2 && this.clearSource(t2);
              }
            }
            updateLayers(e2) {
              const t2 = this._changes.getUpdatedPaintProperties();
              for (const i2 of t2) {
                const t3 = this.getLayer(i2);
                t3 && t3.updateTransitions(e2);
              }
            }
            getGlyphsUrl() {
              return this.stylesheet.glyphs;
            }
            setGlyphsUrl(e2) {
              this.stylesheet.glyphs = e2, this.glyphManager.setURL(e2, this.scope);
            }
            getImages(t2, i2, o2) {
              this.imageManager.getImages(i2.images, i2.scope, o2), this._updateTilesForChangedImages();
              const s2 = (t3) => {
                if (t3) {
                  const o3 = i2.images.map((t4) => e.I.toString(t4));
                  t3.setDependencies(i2.tileID.key, i2.type, o3);
                }
              }, r2 = e.C(i2.source, i2.scope);
              s2(this._mergedOtherSourceCaches[r2]), s2(this._mergedSymbolSourceCaches[r2]);
            }
            rasterizeImages(e2, t2, i2) {
              this.imageManager.rasterizeImages(t2, i2);
            }
            getGlyphs(e2, t2, i2) {
              this.glyphManager.getGlyphs(t2.stacks, t2.scope, i2);
            }
            getResource(t2, i2, o2) {
              return e.dg(i2, o2);
            }
            getOwnSourceCache(e2) {
              return this._otherSourceCaches[e2];
            }
            getOwnLayerSourceCache(e2) {
              return "symbol" === e2.type ? this._symbolSourceCaches[e2.source] : this._otherSourceCaches[e2.source];
            }
            getOwnSourceCaches(e2) {
              const t2 = [];
              return this._otherSourceCaches[e2] && t2.push(this._otherSourceCaches[e2]), this._symbolSourceCaches[e2] && t2.push(this._symbolSourceCaches[e2]), t2;
            }
            _isSourceCacheLoaded(t2) {
              const i2 = this.getOwnSourceCaches(t2);
              return 0 === i2.length ? (this.fire(new e.z(new Error(`There is no source with ID '${t2}'`))), false) : i2.every((e2) => e2.loaded());
            }
            has3DLayers() {
              return this._has3DLayers;
            }
            hasSymbolLayers() {
              return this._hasSymbolLayers;
            }
            hasCircleLayers() {
              return this._hasCircleLayers;
            }
            isLayerClipped(e2, t2) {
              if (!this._clipLayerPresent && "fill-extrusion" !== e2.type && "building" !== e2.type) return false;
              const i2 = "fill-extrusion" === e2.type && "building" === e2.sourceLayer, o2 = "building" === e2.type;
              if (e2.is3D(!!this.terrain)) {
                if (i2 || o2 || t2 && "batched-model" === t2.type) return true;
                if ("model" === e2.type) return true;
              } else if ("symbol" === e2.type) return true;
              return false;
            }
            _clearWorkerCaches() {
              this.dispatcher.broadcast("clearCaches");
            }
            destroy() {
              this._clearWorkerCaches(), this.fragments.forEach((e2) => {
                e2.style._remove();
              }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
          }
          Eo.getSourceType = function(e2) {
            return rt[e2];
          }, Eo.setSourceType = function(e2, t2) {
            rt[e2] = t2;
          }, Eo.registerForPluginStateChange = e.dh;
          var So = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", Io = "\nout vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec3 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color,float height) {\n#ifdef INDICATOR_CUTOUT\nfloat verticalFadeRange=u_indicator_cutout_centers.z*0.25;float holeMinOpacity=mix(1.0,u_indicator_cutout_params.x,smoothstep(u_indicator_cutout_centers.z,u_indicator_cutout_centers.z+verticalFadeRange,height));float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}", Co = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}", Ro = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", Do = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }\n#endif\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;int NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif//DEPTH_OCCLUSION", Ao = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", Lo = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {return color;}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", Po = "#ifdef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", zo = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}", Mo = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif//RENDER_SHADOWS", Oo = "#ifdef RENDER_SHADOWS\nprecision highp sampler2DShadow;uniform sampler2DShadow u_shadowmap_0;uniform sampler2DShadow u_shadowmap_1;uniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;float shadow_sample(sampler2DShadow shadowmap,highp vec3 pos,highp float bias) {highp vec3 coord=vec3(pos.xy*0.5+0.5,pos.z*0.5+0.5-bias);return texture(shadowmap,coord);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {light_view_pos0.xyz/=light_view_pos0.w;\n#ifdef SHADOWS_SINGLE_CASCADE\nvec2 abs_bounds=abs(light_view_pos0.xy);if (abs_bounds.x >=1.0 || abs_bounds.y >=1.0) {return 0.0;}return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);\n#else\nlight_view_pos1.xyz/=light_view_pos1.w;vec4 abs_bounds=abs(vec4(light_view_pos0.xy,light_view_pos1.xy));if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}float occlusion1=shadow_sample(u_shadowmap_1,light_view_pos1.xyz,bias);return clamp(mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth)),0.0,1.0);\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}highp vec2 compute_receiver_plane_depth_bias(highp vec3 pos_dx,highp vec3 pos_dy)\n{highp vec2 biasUV=vec2(\npos_dy.y*pos_dx.z-pos_dx.y*pos_dy.z,pos_dx.x*pos_dy.z-pos_dy.x*pos_dx.z);biasUV*=1.0/((pos_dx.x*pos_dy.y)-(pos_dx.y*pos_dy.x));return biasUV;}float shadowed_light_factor_plane_bias(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {highp vec3 light_view_pos0_xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;highp vec3 light_view_pos0_ddx=dFdx(light_view_pos0_xyz);highp vec3 light_view_pos0_ddy=dFdy(light_view_pos0_xyz);highp vec2 plane_depth_bias=compute_receiver_plane_depth_bias(light_view_pos0_ddx,light_view_pos0_ddy);highp float bias=dot(vec2(u_shadow_texel_size,u_shadow_texel_size),plane_depth_bias)+0.0001;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
          const Fo = [];
          Vo(So, Fo), Vo(Co, Fo), Vo(Io, Fo);
          const Bo = { "_prelude_fog.vertex.glsl": Ao, "_prelude_terrain.vertex.glsl": Do, "_prelude_shadow.vertex.glsl": Mo, "_prelude_fog.fragment.glsl": Lo, "_prelude_shadow.fragment.glsl": Oo, "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif//LIGHTING_3D_MODE", "_prelude_raster_array.glsl": Po, "_prelude_raster_particle.glsl": zo }, ko = {};
          Go("", Do), Go(Lo, Ao), Go(Oo, Mo), Go(Po, ""), Go(zo, "");
          const No = Go(Io, Co), Uo = So;
          var jo = { background: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), backgroundPattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in vec2 a_pos;out highp vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), building: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in highp vec3 v_normal;in highp float v_height;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\nuniform lowp float u_opacity;vec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 apply_lighting_linear(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return color*(ambient_contrib+directional_contrib);}void main() {vec4 color=vec4(v_color.rgb,1.0);vec3 normal=normalize(v_normal);vec3 xy_flipped_normal=vec3(-normal.xy,normal.z);float shadowed_lighting_factor=0.0;\n#ifdef RENDER_SHADOWS\nshadowed_lighting_factor=shadowed_light_factor_normal(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nshadowed_lighting_factor=dot(normal,u_lighting_directional_dir);\n#endif\ncolor.rgb=apply_lighting_linear(color.rgb,xy_flipped_normal,shadowed_lighting_factor);color.rgb=mix(color.rgb,v_color.rgb,v_color.a);\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,v_height));\n#endif\ncolor.rgb=linearTosRGB(color.rgb);color*=u_opacity;\n#ifdef RENDER_CUTOFF\ncolor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,v_height);\n#endif\nglFragColor=color; \n#ifdef DEBUG_SHOW_NORMALS\ncolor.rgb=xy_flipped_normal*0.5+vec3(0.5,0.5,0.5);color.a=1.0;glFragColor=color;\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;in vec3 a_normal_3f;out vec4 v_color;out highp vec3 v_normal;out highp float v_height;uniform mat4 u_matrix;uniform mat4 u_normal_matrix;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#pragma mapbox: define-attribute-vertex-shader-only highp vec2 part_color_emissive\nvoid main() {\n#pragma mapbox: initialize-attribute-custom highp vec2 part_color_emissive\nvec4 color_emissive=decode_color(part_color_emissive);v_color=vec4(sRGBToLinear(color_emissive.rgb),color_emissive.a);v_normal=vec3(u_normal_matrix*vec4(a_normal_3f,0.0));vec3 pos=a_pos_3f;v_height=pos.z;gl_Position=u_matrix*vec4(pos,1.0);\n#ifdef RENDER_SHADOWS\nvec3 shadow_pos=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset_model(v_normal);shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shadow_pos,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(shadow_pos,1.0);v_depth_shadows=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'), buildingDepth: Go("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;void main() {gl_Position=u_matrix*vec4(a_pos_3f,1.0);v_depth=gl_Position.z/gl_Position.w;}"), circle: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float antialiase_blur_opacity=smoothstep(0.0,antialiasblur,extrude_length-1.0);float opacity_t=blur_positive==1.0 ? \nsmoothstep(0.0,-antialiased_blur,1.0-extrude_length) : \nsmoothstep(antialiased_blur,0.0,extrude_length-1.0)-antialiase_blur_opacity;float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\n#ifdef ELEVATED_ROADS\nin float a_circle_z_offset;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\n#ifdef ELEVATED_ROADS\nworld_center.z+=a_circle_z_offset+ELEVATION_BIAS;\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'), clippingMask: Go("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"), heatmap: Go('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), heatmapTexture: Go("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"), collisionBox: Go("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(a_anchor_pos));vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(feature_elevation+terrain_elevation),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'), collisionCircle: Go("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"), debug: Go("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'), elevatedStructuresDepth: Go("void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=vec4(0.);\n#endif\n}", "in vec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform float u_depth_bias;void main() {gl_Position=u_matrix*vec4(a_pos,a_height,1);gl_Position.z=gl_Position.z+u_depth_bias;}"), elevatedStructuresDepthReconstruct: Go("#ifdef DEPTH_RECONSTRUCTION\nin float v_height;\n#endif\nvoid main() {\n#ifdef DEPTH_RECONSTRUCTION\nif (v_height >=0.0)\ndiscard;\n#endif\nglFragColor=vec4(1.0,0.0,0.0,1.0);}", "in vec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform vec3 u_camera_pos;uniform highp float u_depth_bias;uniform lowp float u_height_scale;uniform lowp float u_reset_depth;\n#ifdef DEPTH_RECONSTRUCTION\nout float v_height;\n#endif\nvoid main() {vec3 vpos=vec3(a_pos,a_height*u_height_scale);\n#ifdef DEPTH_RECONSTRUCTION\nif (u_camera_pos.z > vpos.z) {vpos-=(u_camera_pos-vpos)*(vpos.z/(u_camera_pos.z-vpos.z));}v_height=a_height;\n#endif\ngl_Position=u_matrix*vec4(vpos,1);gl_Position.z=u_reset_depth==1.0 ? gl_Position.w : gl_Position.z+u_depth_bias;}"), elevatedStructures: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin vec3 v_normal;in float v_height;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth;\n#endif\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}vec3 compute_view_dependent_emissive_color(float ndotl,float emissive_strength,vec3 color)\n{color=sRGBToLinear(color);color=color*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);color=linearTosRGB(color.rgb);return color;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nvec3 color=structure_color.xyz;\n#ifdef LIGHTING_3D_MODE\nvec3 normal=normalize(v_normal);vec3 transformed_normal=vec3(-normal.xy,normal.z);float ndotl=calculate_NdotL(transformed_normal);float emissive_strength=u_emissive_strength;emissive_strength=0.0;vec3 emissive_color=compute_view_dependent_emissive_color(ndotl,emissive_strength,color.xyz);\n#ifdef RENDER_SHADOWS\nfloat shadowed_lighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);color.rgb=apply_lighting(color.rgb,transformed_normal,shadowed_lighting_factor);\n#else\ncolor=apply_lighting(color,transformed_normal);\n#endif\ncolor=mix(color,emissive_color,emissive_strength);if (v_height < 0.0) {float penetration=max(v_height+7.5,0.0);float occlusion=1.0-1.0/PI*acos(1.0-penetration/4.0);color=color*(1.0-pow(occlusion,2.0)*0.3);}\n#endif\n#ifdef FOG\ncolor=fog_apply(color,v_fog_pos);\n#endif\nvec4 out_color=vec4(color,1.0);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_height);\n#endif\nglFragColor=out_color;HANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;in float a_height;in vec3 a_pos_normal_3;uniform mat4 u_matrix;out vec3 v_normal;out float v_height;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth;\n#endif\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nv_normal=a_pos_normal_3/16384.0;v_height=a_height;vec3 pos=vec3(a_pos,a_height);gl_Position=u_matrix*vec4(pos,1);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(-v_normal.xy,v_normal.z));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fill: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=opacity;\n#ifdef INDICATOR_CUTOUT\nif (v_z_offset >=0.0) {out_color=applyCutout(out_color,v_z_offset);}\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=z_offset;\n#endif\n}'), fillOutline: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillOutlinePattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nuniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nin highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillPattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), fillExtrusion: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nin float v_height;\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float emissive_strength\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,h);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;vec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp float emissive_strength\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#ifdef RENDER_CUTOFF\nvec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_pos.x==0.0 ? pos.xyz : (centroid_random/8.0);vec4 ground=u_matrix*vec4(ground_pos.xy,ele,1.0);cutoff=cutoff_opacity(u_cutoff_params,ground.z);if (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);float ndotl=calculate_NdotL(normal);v_flat.rgb=sRGBToLinear(color.rgb);v_flat.rgb=v_flat.rgb*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);v_flat=vec4(linearTosRGB(v_flat.rgb),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'), fillExtrusionDepth: Go("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nin vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp vec4 color\nout highp float v_depth;void main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp vec4 color\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;float ele=elevation(pos_nx.xy);float c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);float h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);pos.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;pos.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'), fillExtrusionPattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\nin highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,height);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef RENDER_WALL_MODE\nin vec3 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nout highp vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);c_ele=is_flat_height || is_flat_base ? (centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec2 wall_offset=u_width_scale*line_width*(a_join_normal_inside.xy/EXTENT);p.xy+=(1.0-a_join_normal_inside.z)*wall_offset*0.5;p.xy-=a_join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'), groundShadow: Go('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor_plane_bias(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0),0.0).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'), fillExtrusionGroundEffect: Go("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'), hillshadePrepare: Go("precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"), hillshade: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'), line: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform lowp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_floor_width_scale;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;float scaled_floorwidth=(floorwidth*u_floor_width_scale);alpha*=linearstep(0.5-sdfgamma/scaled_floorwidth,0.5+sdfgamma/scaled_floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);out_color=mix(out_color,u_trim_color,transition_factor);trim_alpha=1.0-transition_factor;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=((border_width*u_width_scale)+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color=mix(border_color*trim_alpha,out_color,smoothAlpha);}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS) || defined(VARIABLE_LINE_WIDTH)\nin vec3 a_z_offset_width;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec3 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;uniform float u_width_scale;uniform highp float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth;\n#ifdef VARIABLE_LINE_WIDTH\nfloat left=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);halfwidth=(u_width_scale*(left==1.0 ? a_z_offset_width.y : a_z_offset_width.z))/2.0;\n#else\nhalfwidth=(u_width_scale*width)/2.0;\n#endif\noffset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat epsilon=0.0001;float extrude_length_without_perspective=max(length(dist),epsilon);float extrude_length_with_perspective=max(length(projected_extrude_xy/gl_Position.w*u_units_to_pixels),epsilon);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nhighp float a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float line_progress=a_packed[2];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec3(a_uv_x,a_split_index*texel_height-half_texel_height,line_progress);\n#else\nv_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/(floorwidth*u_floor_width_scale),(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'), linePattern: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;uniform sampler2D u_image;\n#ifdef LINE_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nuniform float u_emissive_strength;\n#pragma mapbox: define mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;highp float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef LINE_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl*texel_size-texel_size,pattern_b_br*texel_size+texel_size,vec2(x,y));vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);color=color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);color=mix(color,color.a*u_trim_color,transition_factor);}\n#endif\n#ifdef LINE_JOIN_NONE\nhighp float pattern_len=pattern_size/aspect;highp float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);highp float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;highp float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_with_emission_ground(color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\ncolor.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\ncolor.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,v_z_offset);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin vec3 a_z_offset_width;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump vec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump vec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=(u_width_scale*width)/2.0;offset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=a_pos_normal.y-2.0*floor(a_pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+a_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+a_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+a_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float a_uv_x=a_packed[0];highp float line_progress=a_packed[2];v_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=(floorwidth*u_floor_width_scale);\n#ifdef LINE_JOIN_NONE\nv_width=(floorwidth*u_floor_width_scale)+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/((pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'), raster: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nfloat w=1.0+dot(a_texture_pos,u_perspective_transform);uv=a_texture_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);    \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}float tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\ngl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'), rasterParticle: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),0.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=a_texture_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'), rasterParticleDraw: Go("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin float a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(a_index,u_particle_texture_side_len),a_index/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'), rasterParticleTexture: Go("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in vec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*a_pos+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"), rasterParticleUpdate: Go('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in vec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*(a_pos+vec2(1.0));gl_Position=vec4(a_pos,0.0,1.0);}"), symbol: Go('#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;uniform lowp float u_scale_factor;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#else\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nin highp float v_z_offset;\n#endif\n#endif\n#endif\nin vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nin float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nin float is_sdf;in vec2 v_tex_a_icon;\n#endif\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];\n#ifdef RENDER_TEXT_AND_SYMBOL\nif (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}\n#endif\n#ifdef RENDER_SDF\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*u_scale_factor*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width*u_scale_factor/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;\n#else\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\n#endif\nout_color*=opacity*fade_opacity;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);out_color.rgb*=mix(v_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_auto_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef ELEVATED_ROADS\nin vec3 a_x_axis;in vec3 a_y_axis;uniform float u_normal_scale;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#else\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nout highp float v_z_offset;\n#endif\n#endif\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nout float is_sdf;out vec2 v_tex_a_icon;\n#endif\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#endif\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\n#pragma mapbox: define lowp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\n#pragma mapbox: initialize lowp float z_offset\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_auto_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=a_globe_anchor+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\n#ifdef PROJECTED_POS_ON_VIEWPORT\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xyz+h,1.0);\n#else\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz,mercator_pos,u_zoom_transition)+h;projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);    \n#endif\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\n#ifdef Z_OFFSET\nz+=u_pitch_with_map ? a_auto_z_offset+z_offset : 0.0;\n#else\nz+=u_pitch_with_map ? z_offset : 0.0;\n#endif\nfloat occlusion_fade=globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));\n#ifdef DEPTH_OCCLUSION\nfloat depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\n#ifdef ELEVATED_ROADS\nvec3 xAxis=vec3(a_x_axis.xy,a_x_axis.z*u_normal_scale);vec3 yAxis=vec3(a_y_axis.xy,a_y_axis.z*u_normal_scale);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\npos=vec3(projected_pos.xy/projected_pos.w+offset,z);\n#endif\n#endif\ngl_Position=mix(u_coord_matrix*vec4(pos,1.0),AWAY,hidden);float gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;\n#ifdef RENDER_TEXT_AND_SYMBOL\nis_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;\n#endif\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nvec4 shd_pos=u_inv_matrix*vec4(pos,1.0);vec3 shd_pos0=shd_pos.xyz;vec3 shd_pos1=shd_pos.xyz;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=e;\n#else\n#ifdef Z_OFFSET\n#ifdef RENDER_SHADOWS\nv_z_offset=e;\n#endif\n#endif\n#endif\n}'), terrainRaster: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'), terrainDepth: Go("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'), skybox: Go('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', Ro), skyboxGradient: Go('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', Ro), skyboxCapture: Go("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"), globeRaster: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;uniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nhighp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;highp float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);highp float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nraster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(clamp(raster.rgb,vec3(0),vec3(1))*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'), globeAtmosphere: Go('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;glFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"), model: Go('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform highp vec2 u_inv_depth_size;uniform highp vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nhighp float unpack_depth(highp float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {highp vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor,v_position_height.w);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'), modelDepth: Go("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"), stars: Go("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"), snowParticle: Go("in highp vec2 uv;in highp float alphaMultiplier;uniform vec4 u_particleColor;uniform vec2 u_simpleShapeParameters;void main() {float t=clamp((length(uv)-u_simpleShapeParameters.x)/(1.0-u_simpleShapeParameters.x),0.0,1.0);float alpha=1.0-pow(t,pow(10.0,u_simpleShapeParameters.y));alpha*=alphaMultiplier;alpha*=u_particleColor.a;vec3 color=u_particleColor.rgb*alpha;glFragColor=vec4(color,alpha) ;HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_snowParticleData;in highp vec4 a_snowParticleDataHorizontalOscillation;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform vec2 u_screenSize;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity;uniform vec3 u_direction;uniform float u_horizontalOscillationRadius; \nuniform float u_horizontalOscillationRate; \nuniform float u_billboardSize;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;out highp vec2 uv;out highp float alphaMultiplier;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos.xyz*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_snowParticleData.z;float coneAngleHeadingRad=a_snowParticleData.w*radians(360.0);vec3 localZ=normalize(u_direction);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 direction;direction.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.z=cos(coneAnglePichRad);direction=normalize(direction);vec3 simPosLocal=vec3(0,0,0);float velocityScale=(1.0+3.0*a_snowParticleData.y)*u_velocity;simPosLocal+=direction*velocityScale*u_time;float horizontalOscillationRadius=u_horizontalOscillationRadius*a_snowParticleDataHorizontalOscillation.x;float horizontalOscillationAngle=u_horizontalOscillationRate*u_time*(-1.0+2.0*a_snowParticleDataHorizontalOscillation.y);simPosLocal.xy+=horizontalOscillationRadius*vec2(cos(horizontalOscillationAngle),sin(horizontalOscillationAngle));vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);float clipZ=-u_cam_pos.z+pos.z;vec4 posView=u_modelview*vec4(pos,1.0);float size=u_billboardSize;alphaMultiplier=1.0;vec4 posScreen=u_projection*posView;posScreen/=posScreen.w;posScreen.xy=vec2(0.5)+posScreen.xy*0.5;posScreen.xy*=u_screenSize;vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=u_screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-posScreen.xy)/(0.5*u_screenSize));screenDist+=a_snowParticleData.x*u_thinningParticleOffset;float scaleFactorMode=0.0;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);if (a_snowParticleData.x < u_thinningAffectedRatio) {scaleFactorMode=1.0-thinningFadeRatio;alphaMultiplier=thinningFadeRatio;}}vec4 posScreen1=u_projection*vec4(posView.x-size,posView.yzw);posScreen1/=posScreen1.w;vec4 posScreen2=u_projection*vec4(posView.x+size,posView.yzw);posScreen2/=posScreen2.w;posScreen1.xy=vec2(0.5)+posScreen1.xy*0.5;posScreen1.xy*=u_screenSize;posScreen2.xy=vec2(0.5)+posScreen2.xy*0.5;posScreen2.xy*=u_screenSize;float screenLength=length(posScreen1.xy-posScreen2.xy);float screenEpsilon=3.0;float scaleFactor=1.0;if (screenLength < screenEpsilon) {scaleFactor=screenEpsilon/max(screenLength,0.01);scaleFactor=mix(scaleFactor,1.0,scaleFactorMode);}float screenEpsilon2=15.0;if (screenLength > screenEpsilon2) {scaleFactor=screenEpsilon2/max(screenLength,0.01);}size*=scaleFactor;vec2 right=size*vec2(1,0);vec2 up=size*vec2(0,1);posView.xy+=right*a_uv.x;posView.xy+=up*a_uv.y;uv=a_uv;gl_Position=u_projection*posView;}"), rainParticle: Go("in highp vec2 uv;in highp float particleRandomValue;uniform sampler2D u_texScreen;uniform float u_distortionStrength;uniform vec4 u_color;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;uniform float u_shapeDirectionalPower;uniform float u_mode;void main() {vec2 st=uv*0.5+vec2(0.5);vec2 uvm=uv;uvm.y=-1.0+2.0*pow(st.y,u_shapeDirectionalPower);float shape=clamp(1.0-length(uvm),0.0,1.0);float alpha=abs(shape)*u_color.a;vec2 screenSize=vec2(textureSize(u_texScreen,0));vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-gl_FragCoord.xy)/(0.5*screenSize));screenDist+=(0.5+0.5*particleRandomValue)*u_thinningParticleOffset;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;float thinningAlpha=1.0;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);thinningAlpha*=thinningFadeRatio;}vec2 offsetXY=normalize(uvm)*abs(shape);vec2 stScreen=(gl_FragCoord.xy+offsetXY*u_distortionStrength*thinningAlpha)/screenSize;vec3 colorScreen=texture(u_texScreen,stScreen).rgb;alpha*=thinningAlpha;glFragColor=mix(vec4(colorScreen,1.0),vec4(u_color.rgb*alpha,alpha),u_mode);HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_rainParticleData;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity; \nuniform vec2 u_rainDropletSize;uniform vec3 u_rainDirection;out highp vec2 uv;out highp float particleRandomValue;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos*=halfBoxSize; \npos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_rainParticleData.z;float coneAngleHeadingRad=a_rainParticleData.w*radians(360.0);vec3 localZ=normalize(u_rainDirection);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 directionLocal;directionLocal.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.z=cos(coneAnglePichRad);directionLocal=normalize(directionLocal);vec3 directionWorld=localX*directionLocal.x+localY*directionLocal.y+localZ*directionLocal.z;float velocityScale=(1.0+3.0*a_rainParticleData.y)*u_velocity;vec3 simPosLocal=vec3(0,0,0);simPosLocal+=directionLocal*velocityScale*u_time;vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);vec4 posView=u_modelview*vec4(pos,1.0);vec3 directionView=normalize((u_modelview*vec4(directionWorld,0.0)).xyz);vec3 side=cross(directionView,normalize(posView.xyz));posView.xyz+=side*a_uv.x*u_rainDropletSize.x;posView.xyz+=directionView*a_uv.y*u_rainDropletSize.y;uv=a_uv;particleRandomValue=a_rainParticleData.x;gl_Position=u_projection*posView;}"), vignette: Go("uniform vec3 u_vignetteShape;uniform vec4 u_vignetteColor;in vec2 st;void main() {float screenDist=length(st);float alpha=clamp((screenDist-u_vignetteShape.x)/u_vignetteShape.y,0.0,1.0);alpha=pow(alpha,u_vignetteShape.z)*u_vignetteColor.a;vec3 color=u_vignetteColor.rgb;glFragColor=vec4(color*alpha,alpha) ;}", "in vec2 a_pos_2f;out vec2 st;void main() {st=a_pos_2f;gl_Position=vec4(a_pos_2f,0,1);}"), occlusion: Go("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}') };
          function Vo(e2, t2) {
            const i2 = e2.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
            for (let e3 of i2) if (e3 = e3.trim(), "#" === e3[0] && e3.includes("if") && !e3.includes("endif")) {
              e3 = e3.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
              const i3 = e3.split(" ");
              for (const e4 of i3) t2.includes(e4) || t2.push(e4);
            }
          }
          function Go(e2, t2) {
            const i2 = /#include\s+"([^"]+)"/g, o2 = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
            let s2 = t2.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
            s2 && (s2 = s2.map((e3) => {
              const t3 = e3.split(" ");
              return t3[t3.length - 1];
            }), s2 = [...new Set(s2)]);
            const r2 = {}, n2 = [], a2 = [];
            if (e2 = e2.replace(i2, (e3, t3) => (a2.push(t3), "")), (t2 = t2.replace(i2, (e3, t3) => (n2.push(t3), ""))).includes("flat out")) return void console.error('The usage of "flat" qualifier is disallowed, see: https://bugs.webkit.org/show_bug.cgi?id=268071');
            let l2 = [...Fo];
            Vo(e2, l2), Vo(t2, l2);
            for (const e3 of [...n2, ...a2]) Bo[e3] || console.error(`Undefined include: ${e3}`), ko[e3] || (ko[e3] = [], Vo(Bo[e3], ko[e3])), l2 = [...l2, ...ko[e3]];
            return { fragmentSource: e2 = e2.replace(o2, (e3, t3, i3, o3, s3) => (r2[s3] = true, "define" === t3 ? `
#ifndef HAS_UNIFORM_u_${s3}
in ${i3} ${o3} ${s3};
#else
uniform ${i3} ${o3} u_${s3};
#endif
` : "initialize" === t3 ? `
#ifdef HAS_UNIFORM_u_${s3}
    ${i3} ${o3} ${s3} = u_${s3};
#endif
` : "define-attribute" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${s3}
    in ${i3} ${o3} ${s3};
#endif
` : "initialize-attribute" === t3 ? "" : void 0)), vertexSource: t2 = t2.replace(o2, (e3, t3, i3, o3, s3) => {
              const n3 = "float" === o3 ? "vec2" : o3, a3 = s3.match(/color/) ? "color" : n3;
              return "define-attribute-vertex-shader-only" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${s3}
in ${i3} ${o3} a_${s3};
#endif
` : r2[s3] ? "define" === t3 ? `
#ifndef HAS_UNIFORM_u_${s3}
uniform lowp float u_${s3}_t;
in ${i3} ${n3} a_${s3};
out ${i3} ${o3} ${s3};
#else
uniform ${i3} ${o3} u_${s3};
#endif
` : "initialize" === t3 ? "vec4" === a3 ? `
#ifndef HAS_UNIFORM_u_${s3}
    ${s3} = a_${s3};
#else
    ${i3} ${o3} ${s3} = u_${s3};
#endif
` : `
#ifndef HAS_UNIFORM_u_${s3}
    ${s3} = unpack_mix_${a3}(a_${s3}, u_${s3}_t);
#else
    ${i3} ${o3} ${s3} = u_${s3};
#endif
` : "define-attribute" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${s3}
    in ${i3} ${o3} a_${s3};
    out ${i3} ${o3} ${s3};
#endif
` : "initialize-attribute" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${s3}
    ${s3} = a_${s3};
#endif
` : void 0 : "define" === t3 ? `
#ifndef HAS_UNIFORM_u_${s3}
uniform lowp float u_${s3}_t;
in ${i3} ${n3} a_${s3};
#else
uniform ${i3} ${o3} u_${s3};
#endif
` : "define-instanced" === t3 ? "mat4" === a3 ? `
#ifdef INSTANCED_ARRAYS
in vec4 a_${s3}0;
in vec4 a_${s3}1;
in vec4 a_${s3}2;
in vec4 a_${s3}3;
#else
uniform ${i3} ${o3} u_${s3};
#endif
` : `
#ifdef INSTANCED_ARRAYS
in ${i3} ${n3} a_${s3};
#else
uniform ${i3} ${o3} u_${s3};
#endif
` : "initialize-attribute-custom" === t3 ? `
#ifdef HAS_ATTRIBUTE_a_${s3}
    ${i3} ${o3} ${s3} = a_${s3};
#endif
` : "vec4" === a3 ? `
#ifndef HAS_UNIFORM_u_${s3}
    ${i3} ${o3} ${s3} = a_${s3};
#else
    ${i3} ${o3} ${s3} = u_${s3};
#endif
` : `
#ifndef HAS_UNIFORM_u_${s3}
    ${i3} ${o3} ${s3} = unpack_mix_${a3}(a_${s3}, u_${s3}_t);
#else
    ${i3} ${o3} ${s3} = u_${s3};
#endif
`;
            }), staticAttributes: s2, usedDefines: l2, vertexIncludes: n2, fragmentIncludes: a2 };
          }
          class qo {
            constructor() {
              this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
            bind(e2, t2, i2, o2, s2, r2, n2, a2) {
              this.context = e2;
              let l2 = this.boundPaintVertexBuffers.length !== o2.length;
              for (let e3 = 0; !l2 && e3 < o2.length; e3++) this.boundPaintVertexBuffers[e3] !== o2[e3] && (l2 = true);
              let c2 = this.boundDynamicVertexBuffers.length !== n2.length;
              for (let e3 = 0; !c2 && e3 < n2.length; e3++) this.boundDynamicVertexBuffers[e3] !== n2[e3] && (c2 = true);
              if (!this.vao || this.boundProgram !== t2 || this.boundLayoutVertexBuffer !== i2 || l2 || c2 || this.boundIndexBuffer !== s2 || this.boundVertexOffset !== r2) this.freshBind(t2, i2, o2, s2, r2, n2, a2);
              else {
                e2.bindVertexArrayOES.set(this.vao);
                for (const i3 of n2) i3 && (i3.bind(), a2 && i3.instanceCount && i3.setVertexAttribDivisor(e2.gl, t2, a2));
                s2 && s2.dynamicDraw && s2.bind();
              }
            }
            freshBind(e2, t2, i2, o2, s2, r2, n2) {
              const a2 = e2.numAttributes, l2 = this.context, c2 = l2.gl;
              this.vao && this.destroy(), this.vao = l2.gl.createVertexArray(), l2.bindVertexArrayOES.set(this.vao), this.boundProgram = e2, this.boundLayoutVertexBuffer = t2, this.boundPaintVertexBuffers = i2, this.boundIndexBuffer = o2, this.boundVertexOffset = s2, this.boundDynamicVertexBuffers = r2, t2.enableAttributes(c2, e2), t2.bind(), t2.setVertexAttribPointers(c2, e2, s2);
              for (const t3 of i2) t3.enableAttributes(c2, e2), t3.bind(), t3.setVertexAttribPointers(c2, e2, s2);
              for (const t3 of r2) t3 && (t3.enableAttributes(c2, e2), t3.bind(), t3.setVertexAttribPointers(c2, e2, s2), n2 && t3.instanceCount && t3.setVertexAttribDivisor(c2, e2, n2));
              o2 && o2.bind(), l2.currentNumAttributes = a2;
            }
            destroy() {
              this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
          }
          function Zo(t2, i2) {
            const o2 = Math.pow(2, i2.canonical.z), s2 = i2.canonical.y;
            return [new e.ac(0, s2 / o2).toLngLat().lat, new e.ac(0, (s2 + 1) / o2).toLngLat().lat];
          }
          function Ho(t2, i2, o2, s2, r2, n2, a2) {
            const l2 = t2.context, c2 = l2.gl, h3 = o2.hillshadeFBO;
            if (!h3) return;
            t2.prepareDrawTile();
            const d2 = t2.isTileAffectedByFog(i2), u2 = t2.getOrCreateProgram("hillshade", { overrideFog: d2 });
            l2.activeTexture.set(c2.TEXTURE0), c2.bindTexture(c2.TEXTURE_2D, h3.colorAttachment.get());
            const _2 = ((t3, i3, o3, s3) => {
              const r3 = o3.paint.get("hillshade-shadow-color"), n3 = "none" === o3.paint.get("hillshade-shadow-color-use-theme").constantOr("default"), a3 = o3.paint.get("hillshade-highlight-color"), l3 = "none" === o3.paint.get("hillshade-highlight-color-use-theme").constantOr("default"), c3 = o3.paint.get("hillshade-accent-color"), h4 = "none" === o3.paint.get("hillshade-accent-color-use-theme").constantOr("default"), d3 = o3.paint.get("hillshade-emissive-strength");
              let u3 = e.al(o3.paint.get("hillshade-illumination-direction"));
              if ("viewport" === o3.paint.get("hillshade-illumination-anchor")) u3 -= t3.transform.angle;
              else if (t3.style && t3.style.enable3dLights() && t3.style.directionalLight) {
                const i4 = t3.style.directionalLight.properties.get("direction"), o4 = e.cR(i4.x, i4.y, i4.z);
                u3 = e.al(o4[1]);
              }
              const _3 = !t3.options.moving;
              return { u_matrix: s3 || t3.transform.calculateProjMatrix(i3.tileID.toUnwrapped(), _3), u_image: 0, u_latrange: Zo(0, i3.tileID), u_light: [o3.paint.get("hillshade-exaggeration"), u3], u_shadow: r3.toPremultipliedRenderColor(n3 ? null : o3.lut), u_highlight: a3.toPremultipliedRenderColor(l3 ? null : o3.lut), u_emissive_strength: d3, u_accent: c3.toPremultipliedRenderColor(h4 ? null : o3.lut) };
            })(t2, o2, s2, t2.terrain ? i2.projMatrix : null);
            t2.uploadCommonUniforms(l2, u2, i2.toUnwrapped());
            const { tileBoundsBuffer: p3, tileBoundsIndexBuffer: f2, tileBoundsSegments: m2 } = t2.getTileBoundsBuffers(o2);
            u2.draw(t2, c2.TRIANGLES, r2, n2, a2, qi.disabled, _2, s2.id, p3, f2, m2);
          }
          function Wo(t2, i2, o2) {
            if (!i2.needsDEMTextureUpload) return;
            const s2 = t2.context, r2 = s2.gl;
            s2.pixelStoreUnpackPremultiplyAlpha.set(false), i2.demTexture = i2.demTexture || t2.getTileTexture(o2.stride);
            const n2 = o2.getPixels();
            i2.demTexture ? i2.demTexture.update(n2, { premultiply: false }) : i2.demTexture = new e.T(s2, n2, r2.R32F, { premultiply: false }), i2.needsDEMTextureUpload = false;
          }
          function $o(t2, i2, o2) {
            const s2 = t2.context, r2 = s2.gl;
            if (!i2.dem) return;
            const n2 = i2.dem;
            if (s2.activeTexture.set(r2.TEXTURE1), Wo(t2, i2, n2), !i2.demTexture) return;
            i2.demTexture.bind(r2.NEAREST, r2.CLAMP_TO_EDGE);
            const a2 = n2.dim;
            s2.activeTexture.set(r2.TEXTURE0);
            let l2 = i2.hillshadeFBO;
            if (!l2) {
              const t3 = new e.T(s2, { width: a2, height: a2, data: null }, r2.RGBA8);
              t3.bind(r2.LINEAR, r2.CLAMP_TO_EDGE), l2 = i2.hillshadeFBO = s2.createFramebuffer(a2, a2, true, "renderbuffer"), l2.colorAttachment.set(t3.texture);
            }
            s2.bindFramebuffer.set(l2.framebuffer), s2.viewport.set([0, 0, a2, a2]);
            const { tileBoundsBuffer: c2, tileBoundsIndexBuffer: h3, tileBoundsSegments: d2 } = t2.getMercatorTileBoundsBuffers(), u2 = [];
            t2.linearFloatFilteringSupported() && u2.push("TERRAIN_DEM_FLOAT_FORMAT"), t2.getOrCreateProgram("hillshadePrepare", { defines: u2 }).draw(t2, r2.TRIANGLES, Ni.disabled, ji.disabled, ki.unblended, qi.disabled, ((t3, i3) => {
              const o3 = i3.stride, s3 = e.bz();
              return e.c5(s3, 0, e.aj, -8192, 0, 0, 1), e.bo(s3, s3, [0, -8192, 0]), { u_matrix: s3, u_image: 1, u_dimension: [o3, o3], u_zoom: t3.overscaledZ };
            })(i2.tileID, n2), o2.id, c2, h3, d2), i2.needsHillshadePrepare = false;
          }
          class Xo {
            constructor(e2) {
              this.gl = e2.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = false;
            }
            get() {
              return this.current;
            }
            set(e2) {
            }
            getDefault() {
              return this.default;
            }
            setDefault() {
              this.set(this.default);
            }
          }
          class Yo extends Xo {
            getDefault() {
              return e.am.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e2) {
              const t2 = this.current;
              (e2.r !== t2.r || e2.g !== t2.g || e2.b !== t2.b || e2.a !== t2.a || this.dirty) && (this.gl.clearColor(e2.r, e2.g, e2.b, e2.a), this.current = e2, this.dirty = false);
            }
          }
          class Ko extends Xo {
            getDefault() {
              return 1;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.clearDepth(e2), this.current = e2, this.dirty = false);
            }
          }
          class Jo extends Xo {
            getDefault() {
              return 0;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.clearStencil(e2), this.current = e2, this.dirty = false);
            }
          }
          class Qo extends Xo {
            getDefault() {
              return [true, true, true, true];
            }
            set(e2) {
              const t2 = this.current;
              (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.colorMask(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
            }
          }
          class es extends Xo {
            getDefault() {
              return true;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.depthMask(e2), this.current = e2, this.dirty = false);
            }
          }
          class ts extends Xo {
            getDefault() {
              return 255;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.stencilMask(e2), this.current = e2, this.dirty = false);
            }
          }
          class is3 extends Xo {
            getDefault() {
              return { func: this.gl.ALWAYS, ref: 0, mask: 255 };
            }
            set(e2) {
              const t2 = this.current;
              (e2.func !== t2.func || e2.ref !== t2.ref || e2.mask !== t2.mask || this.dirty) && (this.gl.stencilFunc(e2.func, e2.ref, e2.mask), this.current = e2, this.dirty = false);
            }
          }
          class os extends Xo {
            getDefault() {
              const e2 = this.gl;
              return [e2.KEEP, e2.KEEP, e2.KEEP];
            }
            set(e2) {
              const t2 = this.current;
              (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || this.dirty) && (this.gl.stencilOp(e2[0], e2[1], e2[2]), this.current = e2, this.dirty = false);
            }
          }
          class ss extends Xo {
            getDefault() {
              return false;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              e2 ? t2.enable(t2.STENCIL_TEST) : t2.disable(t2.STENCIL_TEST), this.current = e2, this.dirty = false;
            }
          }
          class rs extends Xo {
            getDefault() {
              return [0, 1];
            }
            set(e2) {
              const t2 = this.current;
              (e2[0] !== t2[0] || e2[1] !== t2[1] || this.dirty) && (this.gl.depthRange(e2[0], e2[1]), this.current = e2, this.dirty = false);
            }
          }
          class ns extends Xo {
            getDefault() {
              return false;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              e2 ? t2.enable(t2.DEPTH_TEST) : t2.disable(t2.DEPTH_TEST), this.current = e2, this.dirty = false;
            }
          }
          class as extends Xo {
            getDefault() {
              return this.gl.LESS;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.depthFunc(e2), this.current = e2, this.dirty = false);
            }
          }
          class ls extends Xo {
            getDefault() {
              return false;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              e2 ? t2.enable(t2.BLEND) : t2.disable(t2.BLEND), this.current = e2, this.dirty = false;
            }
          }
          class cs extends Xo {
            getDefault() {
              const e2 = this.gl;
              return [e2.ONE, e2.ZERO, e2.ONE, e2.ZERO];
            }
            set(e2) {
              const t2 = this.current;
              (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.blendFuncSeparate(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
            }
          }
          class hs extends Xo {
            getDefault() {
              return e.am.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e2) {
              const t2 = this.current;
              (e2.r !== t2.r || e2.g !== t2.g || e2.b !== t2.b || e2.a !== t2.a || this.dirty) && (this.gl.blendColor(e2.r, e2.g, e2.b, e2.a), this.current = e2, this.dirty = false);
            }
          }
          class ds extends Xo {
            getDefault() {
              return this.gl.FUNC_ADD;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e2, e2), this.current = e2, this.dirty = false);
            }
          }
          class us extends Xo {
            getDefault() {
              return false;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              e2 ? t2.enable(t2.CULL_FACE) : t2.disable(t2.CULL_FACE), this.current = e2, this.dirty = false;
            }
          }
          class _s extends Xo {
            getDefault() {
              return this.gl.BACK;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.cullFace(e2), this.current = e2, this.dirty = false);
            }
          }
          class ps extends Xo {
            getDefault() {
              return this.gl.CCW;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.frontFace(e2), this.current = e2, this.dirty = false);
            }
          }
          let fs = class extends Xo {
            getDefault() {
              return null;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.useProgram(e2), this.current = e2, this.dirty = false);
            }
          };
          class ms extends Xo {
            getDefault() {
              return this.gl.TEXTURE0;
            }
            set(e2) {
              (e2 !== this.current || this.dirty) && (this.gl.activeTexture(e2), this.current = e2, this.dirty = false);
            }
          }
          class gs extends Xo {
            getDefault() {
              const e2 = this.gl;
              return [0, 0, e2.drawingBufferWidth, e2.drawingBufferHeight];
            }
            set(e2) {
              const t2 = this.current;
              (e2[0] !== t2[0] || e2[1] !== t2[1] || e2[2] !== t2[2] || e2[3] !== t2[3] || this.dirty) && (this.gl.viewport(e2[0], e2[1], e2[2], e2[3]), this.current = e2, this.dirty = false);
            }
          }
          class vs extends Xo {
            getDefault() {
              return null;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              t2.bindFramebuffer(t2.FRAMEBUFFER, e2), this.current = e2, this.dirty = false;
            }
          }
          class ys extends Xo {
            getDefault() {
              return null;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              t2.bindRenderbuffer(t2.RENDERBUFFER, e2), this.current = e2, this.dirty = false;
            }
          }
          class xs extends Xo {
            getDefault() {
              return null;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              t2.bindTexture(t2.TEXTURE_2D, e2), this.current = e2, this.dirty = false;
            }
          }
          class bs extends Xo {
            getDefault() {
              return null;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              t2.bindBuffer(t2.ARRAY_BUFFER, e2), this.current = e2, this.dirty = false;
            }
          }
          class ws extends Xo {
            getDefault() {
              return null;
            }
            set(e2) {
              const t2 = this.gl;
              t2.bindBuffer(t2.ELEMENT_ARRAY_BUFFER, e2), this.current = e2, this.dirty = false;
            }
          }
          class Ts extends Xo {
            getDefault() {
              return null;
            }
            set(e2) {
              this.gl && (e2 !== this.current || this.dirty) && (this.gl.bindVertexArray(e2), this.current = e2, this.dirty = false);
            }
          }
          class Es extends Xo {
            getDefault() {
              return 4;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              t2.pixelStorei(t2.UNPACK_ALIGNMENT, e2), this.current = e2, this.dirty = false;
            }
          }
          class Ss extends Xo {
            getDefault() {
              return false;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              t2.pixelStorei(t2.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e2), this.current = e2, this.dirty = false;
            }
          }
          class Is extends Xo {
            getDefault() {
              return false;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              const t2 = this.gl;
              t2.pixelStorei(t2.UNPACK_FLIP_Y_WEBGL, e2), this.current = e2, this.dirty = false;
            }
          }
          class Cs extends Xo {
            constructor(e2, t2) {
              super(e2), this.context = e2, this.parent = t2;
            }
            getDefault() {
              return null;
            }
          }
          class Rs extends Cs {
            setDirty() {
              this.dirty = true;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              this.context.bindFramebuffer.set(this.parent);
              const t2 = this.gl;
              t2.framebufferTexture2D(t2.FRAMEBUFFER, t2.COLOR_ATTACHMENT0, t2.TEXTURE_2D, e2, 0), this.current = e2, this.dirty = false;
            }
          }
          class Ds extends Cs {
            attachment() {
              return this.gl.DEPTH_ATTACHMENT;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              this.context.bindFramebuffer.set(this.parent);
              const t2 = this.gl;
              t2.framebufferRenderbuffer(t2.FRAMEBUFFER, this.attachment(), t2.RENDERBUFFER, e2), this.current = e2, this.dirty = false;
            }
          }
          class As extends Cs {
            attachment() {
              return this.gl.DEPTH_ATTACHMENT;
            }
            set(e2) {
              if (e2 === this.current && !this.dirty) return;
              this.context.bindFramebuffer.set(this.parent);
              const t2 = this.gl;
              t2.framebufferTexture2D(t2.FRAMEBUFFER, this.attachment(), t2.TEXTURE_2D, e2, 0), this.current = e2, this.dirty = false;
            }
          }
          class Ls extends Ds {
            attachment() {
              return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
          }
          const Ps = (e2, t2, i2) => ({ u_matrix: e2, u_image0: 0, u_skirt_height: t2, u_ground_shadow_factor: i2 }), zs = (e2, t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2) => ({ u_proj_matrix: Float32Array.from(e2), u_globe_matrix: t2, u_normalize_matrix: Float32Array.from(o2), u_merc_matrix: i2, u_zoom_transition: s2, u_merc_center: r2, u_image0: 0, u_frustum_tl: n2, u_frustum_tr: a2, u_frustum_br: l2, u_frustum_bl: c2, u_globe_pos: h3, u_globe_radius: d2, u_viewport: u2, u_grid_matrix: f2 ? Float32Array.from(f2) : new Float32Array(9), u_skirt_height: _2, u_far_z_cutoff: p3 });
          function Ms(e2, t2) {
            return null != e2 && null != t2 && !(!e2.hasData() || !t2.hasData()) && null != e2.demTexture && null != t2.demTexture && e2.tileID.key !== t2.tileID.key;
          }
          const Os = new class {
            constructor() {
              this.operations = {};
            }
            newMorphing(e2, t2, i2, o2, s2) {
              if (e2 in this.operations) {
                const t3 = this.operations[e2];
                t3.to.tileID.key !== i2.tileID.key && (t3.queued = i2);
              } else this.operations[e2] = { startTime: o2, phase: 0, duration: s2, from: t2, to: i2, queued: null };
            }
            getMorphValuesForProxy(e2) {
              if (!(e2 in this.operations)) return null;
              const t2 = this.operations[e2];
              return { from: t2.from, to: t2.to, phase: t2.phase };
            }
            update(e2) {
              for (const t2 in this.operations) {
                const i2 = this.operations[t2];
                for (i2.phase = (e2 - i2.startTime) / i2.duration; i2.phase >= 1 || !this._validOp(i2); ) if (!this._nextOp(i2, e2)) {
                  delete this.operations[t2];
                  break;
                }
              }
            }
            _nextOp(e2, t2) {
              return !!e2.queued && (e2.from = e2.to, e2.to = e2.queued, e2.queued = null, e2.phase = 0, e2.startTime = t2, true);
            }
            _validOp(e2) {
              return e2.from.hasData() && e2.to.hasData();
            }
          }(), Fs = { 0: null, 1: "TERRAIN_VERTEX_MORPHING" };
          function Bs(e2, t2, i2) {
            if (0 === t2) return 0;
            const o2 = t2 < 1 && 514 === i2 ? 0.25 / t2 : 1;
            return 6 * Math.pow(1.5, 22 - e2) * Math.max(t2, 1) * o2;
          }
          function ks(e2, t2) {
            const i2 = 1 << e2.z;
            return !t2 && (0 === e2.x || e2.x === i2 - 1) || 0 === e2.y || e2.y === i2 - 1;
          }
          const Ns = (e2) => ({ u_matrix: e2 });
          function Us(t2, i2, o2, s2, r2) {
            if (r2 > 0) {
              const n2 = e.q.now(), a2 = (n2 - t2.timeAdded) / r2, l2 = i2 ? (n2 - i2.timeAdded) / r2 : -1, c2 = o2.getSource(), h3 = s2.coveringZoomLevel({ tileSize: c2.tileSize, roundZoom: c2.roundZoom }), d2 = !i2 || Math.abs(i2.tileID.overscaledZ - h3) > Math.abs(t2.tileID.overscaledZ - h3), u2 = d2 && t2.refreshedUponExpiration ? 1 : e.ay(d2 ? a2 : 1 - l2, 0, 1);
              return t2.refreshedUponExpiration && a2 >= 1 && (t2.refreshedUponExpiration = false), i2 ? { opacity: 1, mix: 1 - u2 } : { opacity: u2, mix: 0 };
            }
            return { opacity: 1, mix: 0 };
          }
          class js extends It {
            constructor(t2) {
              const i2 = { type: "raster-dem", maxzoom: t2.transform.maxZoom }, o2 = new e.D(e.c$(), null), s2 = nt("mock-dem", i2, o2, t2.style);
              super("mock-dem", s2, false), s2.setEventedParent(this), this._sourceLoaded = true;
            }
            _loadTile(e2, t2) {
              e2.state = "loaded", t2(null);
            }
          }
          class Vs extends It {
            constructor(t2) {
              const i2 = nt("proxy", { type: "geojson", maxzoom: t2.transform.maxZoom }, new e.D(e.c$(), null), t2.style);
              super("proxy", i2, false), i2.setEventedParent(this), this.map = this.getSource().map = t2, this.used = this._sourceLoaded = true, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            update(e2, t2, i2) {
              if (e2.freezeTileCoverage) return;
              this.transform = e2;
              const o2 = e2.coveringTiles({ tileSize: this._source.tileSize, minzoom: this._source.minzoom, maxzoom: this._source.maxzoom, roundZoom: this._source.roundZoom, reparseOverscaled: this._source.reparseOverscaled }).reduce((t3, i3) => {
                if (t3[i3.key] = "", !this._tiles[i3.key]) {
                  const t4 = new wt(i3, this._source.tileSize * i3.overscaleFactor(), e2.tileZoom, void 0, void 0, this._source.worldview);
                  t4.state = "loaded", this._tiles[i3.key] = t4;
                }
                return t3;
              }, {});
              for (const e3 in this._tiles) e3 in o2 || (this.freeFBO(e3), this._tiles[e3].unloadVectorData(), delete this._tiles[e3]);
            }
            freeFBO(e2) {
              const t2 = this.proxyCachedFBO[e2];
              if (void 0 !== t2) {
                const i2 = Object.values(t2);
                this.renderCachePool.push(...i2), delete this.proxyCachedFBO[e2];
              }
            }
            deallocRenderCache() {
              this.renderCache.forEach((e2) => e2.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
          }
          class Gs extends e.aM {
            constructor(e2, t2, i2) {
              super(e2.overscaledZ, e2.wrap, e2.canonical.z, e2.canonical.x, e2.canonical.y), this.proxyTileKey = t2, this.projMatrix = i2;
            }
          }
          class qs extends e.dt {
            constructor(t2, i2) {
              super(), this._debugParams = { sortTilesHiZFirst: true, disableRenderCache: false }, t2.tp.registerParameter(this._debugParams, ["Terrain"], "sortTilesHiZFirst", {}, () => {
                this._style.map.triggerRepaint();
              }), t2.tp.registerParameter(this._debugParams, ["Terrain"], "disableRenderCache", {}, () => {
                this._style.map.triggerRepaint();
              }), t2.tp.registerButton(["Terrain"], "Invalidate Render Cache", () => {
                this.invalidateRenderCache = true, this._style.map.triggerRepaint();
              }), this.painter = t2, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
              const [o2, s2, r2] = function(t3) {
                const i3 = new e.ba(), o3 = new e.a_(), s3 = 131;
                i3.reserve(17161), o3.reserve(33800);
                const r3 = e.aj / 128, n3 = e.aj + r3 / 2, a3 = n3 + r3;
                for (let t4 = -64; t4 < a3; t4 += r3) for (let o4 = -64; o4 < a3; o4 += r3) {
                  const s4 = o4 < 0 || o4 > n3 || t4 < 0 || t4 > n3 ? 24575 : 0, r4 = e.ay(Math.round(o4), 0, e.aj), a4 = e.ay(Math.round(t4), 0, e.aj);
                  i3.emplaceBack(r4 + s4, a4);
                }
                const l2 = (e2, t4) => {
                  const i4 = t4 * s3 + e2;
                  o3.emplaceBack(i4 + 1, i4, i4 + s3), o3.emplaceBack(i4 + s3, i4 + s3 + 1, i4 + 1);
                };
                for (let e2 = 1; e2 < 129; e2++) for (let t4 = 1; t4 < 129; t4++) l2(t4, e2);
                return [0, 129].forEach((e2) => {
                  for (let t4 = 0; t4 < 130; t4++) l2(t4, e2), l2(e2, t4);
                }), [i3, o3, 32768];
              }(), n2 = t2.context;
              this.gridBuffer = n2.createVertexBuffer(o2, e.bc.members), this.gridIndexBuffer = n2.createIndexBuffer(s2), this.gridSegments = e.bd.simpleSegment(0, 0, o2.length, s2.length), this.gridNoSkirtSegments = e.bd.simpleSegment(0, 0, o2.length, r2), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new Vs(i2.map), this.orthoMatrix = e.bz(), e.c5(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? 0.015 : 0, e.aj, 0, e.aj, 0, 1);
              const a2 = n2.gl;
              this._overlapStencilMode = new ji({ func: a2.GEQUAL, mask: 255 }, 0, 255, a2.KEEP, a2.KEEP, a2.REPLACE), this._previousZoom = t2.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i2, this._useVertexMorphing = true, this._exaggeration = 1, this._mockSourceCache = new js(i2.map), this._pendingGroundEffectLayers = [];
            }
            set style(e2) {
              e2.on("data", this._onStyleDataEvent.bind(this)), this._style = e2, this._style.map.on("moveend", () => {
                this._clearLineLayersFromRenderCache();
              });
            }
            update(t2, i2, o2) {
              if (t2 && t2.terrain) {
                this._style !== t2 && (this.style = t2, this._evaluationZoom = void 0);
                const s2 = t2.terrain.properties, r2 = 0 === t2.terrain.drapeRenderMode, n2 = t2.terrain.isZoomDependent();
                this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e.q.now();
                const a2 = t2.terrain && t2.terrain.scope, l2 = s2.get("source"), c2 = r2 ? this._mockSourceCache : t2.getSourceCache(l2, a2);
                if (!c2) return void e.w(`Couldn't find terrain source "${l2}".`);
                if (this.sourceCache = c2, this._attenuationRange = t2.terrain.getAttenuationRange(), this._exaggeration = n2 ? this.calculateExaggeration(i2) : s2.get("exaggeration"), !i2.projection.requiresDraping && n2 && 0 === this._exaggeration) return void this._disable();
                this.enabled = true;
                const h3 = () => {
                  this.sourceCache.used && e.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.
This leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                  const t3 = this.getScaledDemTileSize();
                  this.sourceCache.update(i2, t3, true), this.resetTileLookupCache(this.sourceCache.id);
                };
                this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = true, h3(), this._initializing = true), h3(), i2.updateElevation(true, o2), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i2), this._emptyDEMTextureDirty = true, this._previousZoom = i2.zoom;
              } else this._disable();
            }
            calculateExaggeration(t2) {
              if (this._attenuationRange && t2.zoom >= Math.ceil(this._attenuationRange[1])) return this._style.terrain.getExaggeration(t2.zoom);
              const i2 = this._previousCameraAltitude, o2 = t2.getFreeCameraOptions().position.z / t2.pixelsPerMeter * t2.worldSize;
              this._previousCameraAltitude = o2;
              const s2 = null != i2 ? o2 - i2 : Number.MAX_VALUE;
              if (Math.abs(s2) < 2) return this._exaggeration;
              const r2 = t2.zoom, n2 = this._style.terrain;
              if (!this._previousUpdateTimestamp) return n2.getExaggeration(r2);
              let a2 = r2 - this._previousZoom;
              const l2 = this._previousUpdateTimestamp;
              let c2 = r2;
              null != this._evaluationZoom && (c2 = this._evaluationZoom, Math.abs(r2 - c2) > 0.5 && (a2 = 0.5 * (r2 - c2 + a2)), a2 * s2 < 0 && (c2 += a2)), this._evaluationZoom = c2;
              const h3 = n2.getExaggeration(c2), d2 = h3 === n2.getExaggeration(Math.max(0, c2 - 0.1));
              if (d2 && Math.abs(h3 - this._exaggeration) < 0.01) return h3;
              let u2 = Math.min(0.1, 375e-5 * (this._updateTimestamp - l2));
              return (d2 || h3 < 0.1 || Math.abs(a2) < 1e-4) && (u2 = Math.min(0.2, 4 * u2)), e.ai(this._exaggeration, h3, u2);
            }
            resetTileLookupCache(e2) {
              this._findCoveringTileCache[e2] = {};
            }
            attenuationRange() {
              return this._attenuationRange;
            }
            getDemUpscale() {
              return this.proxySourceCache.getSource().tileSize / 128;
            }
            getScaledDemTileSize() {
              return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e2) {
              e2.coord && "source" === e2.dataType ? this._clearRenderCacheForTile(e2.sourceCacheId, e2.coord) : "style" === e2.dataType && (this.invalidateRenderCache = true, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
              if (this.enabled && (this.enabled = false, this._emptyDEMTextureDirty = true, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for (const e2 in this._style._mergedSourceCaches) this._style._mergedSourceCaches[e2].usedForTerrain = false;
            }
            destroy() {
              this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e2) => e2.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
              return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
              return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
              return this.enabled ? this._exaggeration : 0;
            }
            get visibleDemTiles() {
              return this._visibleDemTiles;
            }
            get drapeBufferSize() {
              const e2 = 2 * this.proxySourceCache.getSource().tileSize;
              return [e2, e2];
            }
            set useVertexMorphing(e2) {
              this._useVertexMorphing = e2;
            }
            updateTileBinding(t2) {
              if (!this.enabled) return;
              this.prevTerrainTileForTile = this.terrainTileForTile;
              const i2 = this.proxySourceCache, o2 = this.painter.transform;
              this._initializing && (this._initializing = 0 === o2._centerAltitude && -1 === this.getAtPointOrZero(e.ac.fromLngLat(o2.center), -1), this._emptyDEMTextureDirty = !this._initializing);
              const s2 = this.proxyCoords = i2.getIds().map((e2) => {
                const t3 = i2.getTileByID(e2).tileID;
                return t3.projMatrix = o2.calculateProjMatrix(t3.toUnwrapped()), t3;
              });
              !function(t3, i3) {
                const o3 = i3.transform.pointCoordinate(i3.transform.getCameraPoint()), s3 = new e.P(o3.x, o3.y);
                t3.sort((t4, i4) => {
                  if (i4.overscaledZ - t4.overscaledZ) return i4.overscaledZ - t4.overscaledZ;
                  const o4 = new e.P(t4.canonical.x + (1 << t4.canonical.z) * t4.wrap, t4.canonical.y), r3 = new e.P(i4.canonical.x + (1 << i4.canonical.z) * i4.wrap, i4.canonical.y), n3 = s3.mult(1 << t4.canonical.z);
                  return n3.x -= 0.5, n3.y -= 0.5, n3.distSqr(o4) - n3.distSqr(r3);
                });
              }(s2, this.painter);
              const r2 = this.proxyToSource || {};
              this.proxyToSource = {}, s2.forEach((e2) => {
                this.proxyToSource[e2.key] = {};
              }), this.terrainTileForTile = {};
              const n2 = this._style._mergedSourceCaches;
              for (const e2 in n2) {
                const i3 = n2[e2];
                if (!i3.used) continue;
                if (i3 !== this.sourceCache && this.resetTileLookupCache(i3.id), this._setupProxiedCoordsForOrtho(i3, t2[e2], r2), i3.usedForTerrain) continue;
                const o3 = t2[e2];
                i3.getSource().reparseOverscaled && this._assignTerrainTiles(o3);
              }
              this.proxiedCoords[i2.id] = s2.map((e2) => new Gs(e2, e2.key, this.orthoMatrix)), this._assignTerrainTiles(s2), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(r2), this.renderingToTexture = false;
              const a2 = {};
              this._visibleDemTiles = [];
              for (const e2 of this.proxyCoords) {
                const t3 = this.terrainTileForTile[e2.key];
                if (!t3) continue;
                const i3 = t3.tileID.key;
                i3 in a2 || (this._visibleDemTiles.push(t3), a2[i3] = i3);
              }
            }
            _assignTerrainTiles(e2) {
              this._initializing || e2.forEach((e3) => {
                if (this.terrainTileForTile[e3.key]) return;
                const t2 = this._findTileCoveringTileID(e3, this.sourceCache);
                t2 && (this.terrainTileForTile[e3.key] = t2);
              });
            }
            _prepareDEMTextures() {
              const e2 = this.painter.context, t2 = e2.gl;
              for (const i2 in this.terrainTileForTile) {
                const o2 = this.terrainTileForTile[i2], s2 = o2.dem;
                !s2 || o2.demTexture && !o2.needsDEMTextureUpload || (e2.activeTexture.set(t2.TEXTURE1), Wo(this.painter, o2, s2));
              }
            }
            _prepareDemTileUniforms(e2, t2, i2, o2) {
              if (!t2 || null == t2.demTexture) return false;
              const s2 = e2.tileID.canonical, r2 = Math.pow(2, t2.tileID.canonical.z - s2.z), n2 = o2 || "";
              return i2[`u_dem_tl${n2}`] = [s2.x * r2 % 1, s2.y * r2 % 1], i2[`u_dem_scale${n2}`] = r2, true;
            }
            get emptyDEMTexture() {
              return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            _getLoadedAreaMinimum() {
              if (!this.enabled) return 0;
              let e2 = 0;
              const t2 = this._visibleDemTiles.reduce((t3, i2) => {
                if (!i2.dem) return t3;
                const o2 = i2.dem.tree.minimums[0];
                return o2 > 0 && e2++, t3 + o2;
              }, 0);
              return e2 ? t2 / e2 : 0;
            }
            _updateEmptyDEMTexture() {
              const t2 = this.painter.context, i2 = t2.gl;
              t2.activeTexture.set(i2.TEXTURE2);
              const o2 = this._getLoadedAreaMinimum(), s2 = new e.du({ width: 1, height: 1 }, new Float32Array([o2]));
              this._emptyDEMTextureDirty = false;
              let r2 = this._emptyDEMTexture;
              return r2 ? r2.update(s2, { premultiply: false }) : r2 = this._emptyDEMTexture = new e.T(t2, s2, i2.R32F, { premultiply: false }), r2;
            }
            setupElevationDraw(t2, i2, o2) {
              const s2 = this.painter.context, r2 = s2.gl, n2 = { u_dem: 2, u_dem_prev: 4, u_dem_tl: [0, 0], u_dem_tl_prev: [0, 0], u_dem_scale: 0, u_dem_scale_prev: 0, u_dem_size: 0, u_dem_lerp: 1, u_depth: 3, u_depth_size_inv: [0, 0], u_depth_range_unpack: [0, 1], u_occluder_half_size: 16, u_occlusion_depth_offset: -1e-4, u_exaggeration: 0 };
              n2.u_exaggeration = this.exaggeration();
              let a2 = null, l2 = null, c2 = 1;
              if (o2 && o2.morphing && this._useVertexMorphing) {
                const e2 = o2.morphing.srcDemTile, i3 = o2.morphing.dstDemTile;
                c2 = o2.morphing.phase, e2 && i3 && (this._prepareDemTileUniforms(t2, e2, n2, "_prev") && (l2 = e2), this._prepareDemTileUniforms(t2, i3, n2) && (a2 = i3));
              }
              const h3 = (e2) => e2 && e2.demTexture && this.painter.linearFloatFilteringSupported() ? r2.LINEAR : r2.NEAREST;
              let d2 = null;
              var u2;
              if (this.enabled ? l2 && a2 ? (d2 = a2.demTexture, s2.activeTexture.set(r2.TEXTURE4), l2.demTexture.bind(h3(l2), r2.CLAMP_TO_EDGE), n2.u_dem_lerp = c2) : (a2 = this.terrainTileForTile[t2.tileID.key], d2 = this._prepareDemTileUniforms(t2, a2, n2) ? a2.demTexture : this.emptyDEMTexture) : d2 = this.emptyDEMTexture, s2.activeTexture.set(r2.TEXTURE2), d2 && (n2.u_dem_size = 1 === (u2 = d2).size[0] ? 1 : u2.size[0] - 2, d2.bind(h3(a2), r2.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(o2 && o2.useDepthForOcclusion, i2, n2), o2 && o2.useMeterToDem && a2) {
                const t3 = (1 << a2.tileID.canonical.z) * e.c6(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                n2.u_meter_to_dem = t3;
              }
              if (o2 && o2.labelPlaneMatrixInv && (n2.u_label_plane_matrix_inv = o2.labelPlaneMatrixInv), i2.setTerrainUniformValues(s2, n2), "globe" === this.painter.transform.projection.name) {
                const e2 = this.globeUniformValues(this.painter.transform, t2.tileID.canonical, o2 && o2.useDenormalizedUpVectorScale);
                i2.setGlobeUniformValues(s2, e2);
              }
            }
            globeUniformValues(t2, i2, o2) {
              const s2 = t2.projection;
              return { u_tile_tl_up: s2.upVector(i2, 0, 0), u_tile_tr_up: s2.upVector(i2, e.aj, 0), u_tile_br_up: s2.upVector(i2, e.aj, e.aj), u_tile_bl_up: s2.upVector(i2, 0, e.aj), u_tile_up_scale: o2 ? e.dv(1) : s2.upVectorScale(i2, t2.center.lat, t2.worldSize).metersToTile };
            }
            renderToBackBuffer(t2) {
              const i2 = this.painter, o2 = this.painter.context;
              0 !== t2.length && (o2.bindFramebuffer.set(null), o2.viewport.set([0, 0, i2.width, i2.height]), i2.gpuTimingDeferredRenderStart(), this.renderingToTexture = false, function(t3, i3, o3, s2, r2) {
                if ("globe" === t3.transform.projection.name) !function(t4, i4, o4, s3, r3) {
                  const n2 = t4.context, a2 = n2.gl;
                  let l2, c2;
                  const h3 = t4.transform, d2 = e.dl(t4, n2, h3), u2 = (e2, i5) => {
                    if (c2 === i5) return;
                    const o5 = [Fs[i5], "PROJECTION_GLOBE_VIEW"];
                    d2 && o5.push("CUSTOM_ANTIALIASING");
                    const s4 = t4.isTileAffectedByFog(e2);
                    l2 = t4.getOrCreateProgram("globeRaster", { defines: o5, overrideFog: s4 }), c2 = i5;
                  }, _2 = t4.colorModeForRenderPass(), p3 = new Ni(a2.LEQUAL, Ni.ReadWrite, t4.depthRangeFor3D);
                  Os.update(r3);
                  const f2 = e.dm(h3), m2 = [e.aD(h3.center.lng), e.aH(h3.center.lat)], g2 = t4.globeSharedBuffers, v2 = [h3.width * e.q.devicePixelRatio, h3.height * e.q.devicePixelRatio], y2 = Float32Array.from(h3.globeMatrix), x2 = { useDenormalizedUpVectorScale: true };
                  {
                    const h4 = t4.transform, d3 = Bs(h4.zoom, i4.exaggeration(), i4.sourceCache._source.tileSize);
                    c2 = -1;
                    const b2 = a2.TRIANGLES;
                    for (const c3 of s3) {
                      const s4 = o4.getTile(c3), w2 = ji.disabled, T2 = i4.prevTerrainTileForTile[c3.key], E2 = i4.terrainTileForTile[c3.key];
                      Ms(T2, E2) && Os.newMorphing(c3.key, T2, E2, r3, 250), n2.activeTexture.set(a2.TEXTURE0), s4.texture && s4.texture.bind(a2.LINEAR, a2.CLAMP_TO_EDGE);
                      const S2 = Os.getMorphValuesForProxy(c3.key), I2 = S2 ? 1 : 0;
                      S2 && e.L(x2, { morphing: { srcDemTile: S2.from, dstDemTile: S2.to, phase: e.dk(S2.phase) } });
                      const C2 = e.dn(c3.canonical), R2 = e.dp(C2.getCenter().lat), D2 = e.dq(c3.canonical, C2, R2, h4.worldSize / h4._pixelsPerMercatorPixel), A2 = e.bh(e.dr(c3.canonical)), L2 = zs(h4.expandedFarZProjMatrix, y2, f2, A2, e.ah(h4.zoom), m2, h4.frustumCorners.TL, h4.frustumCorners.TR, h4.frustumCorners.BR, h4.frustumCorners.BL, h4.globeCenterInViewSpace, h4.globeRadius, v2, d3, h4._farZ, D2);
                      if (u2(c3, I2), l2 && (i4.setupElevationDraw(s4, l2, x2), t4.uploadCommonUniforms(n2, l2, c3.toUnwrapped()), g2)) {
                        const [e2, i5, o5] = g2.getGridBuffers(R2, 0 !== d3);
                        l2.draw(t4, b2, p3, w2, _2, qi.backCCW, L2, "globe_raster", e2, i5, o5);
                      }
                    }
                  }
                  if (g2 && (t4.renderDefaultNorthPole || t4.renderDefaultSouthPole)) {
                    const r4 = ["GLOBE_POLES", "PROJECTION_GLOBE_VIEW"];
                    d2 && r4.push("CUSTOM_ANTIALIASING"), l2 = t4.getOrCreateProgram("globeRaster", { defines: r4 });
                    for (const r5 of s3) {
                      const { x: s4, y: c3, z: d3 } = r5.canonical, u3 = 0 === c3, f3 = c3 === (1 << d3) - 1, [y3, b2, w2, T2] = g2.getPoleBuffers(d3, false);
                      if (T2 && (u3 || f3)) {
                        const c4 = o4.getTile(r5);
                        n2.activeTexture.set(a2.TEXTURE0), c4.texture && c4.texture.bind(a2.LINEAR, a2.CLAMP_TO_EDGE);
                        let g3 = e.ds(d3, s4, h3);
                        const E2 = e.bh(e.dr(r5.canonical)), S2 = (e2, i5) => e2.draw(t4, a2.TRIANGLES, p3, ji.disabled, _2, qi.disabled, zs(h3.expandedFarZProjMatrix, g3, g3, E2, 0, m2, h3.frustumCorners.TL, h3.frustumCorners.TR, h3.frustumCorners.BR, h3.frustumCorners.BL, h3.globeCenterInViewSpace, h3.globeRadius, v2, 0, h3._farZ), "globe_pole_raster", i5, w2, T2);
                        i4.setupElevationDraw(c4, l2, x2), t4.uploadCommonUniforms(n2, l2, r5.toUnwrapped()), u3 && t4.renderDefaultNorthPole && S2(l2, y3), f3 && t4.renderDefaultSouthPole && (g3 = e.cE(e.bz(), g3, [1, -1, 1]), S2(l2, b2));
                      }
                    }
                  }
                }(t3, i3, o3, s2, r2);
                else {
                  const n2 = t3.context, a2 = n2.gl;
                  let l2, c2;
                  const h3 = t3.shadowRenderer, d2 = eo(t3, t3.longestCutoffRange), u2 = (e2) => {
                    if (c2 === e2) return;
                    const i4 = [];
                    i4.push(Fs[e2]), d2.shouldRenderCutoff && i4.push("RENDER_CUTOFF"), h3 && (i4.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), h3.useNormalOffset && i4.push("NORMAL_OFFSET")), l2 = t3.getOrCreateProgram("terrainRaster", { defines: i4 }), c2 = e2;
                  }, _2 = t3.colorModeForRenderPass(), p3 = new Ni(a2.LEQUAL, Ni.ReadWrite, t3.depthRangeFor3D);
                  Os.update(r2);
                  const f2 = t3.transform, m2 = Bs(f2.zoom, i3.exaggeration(), i3.sourceCache._source.tileSize);
                  let g2 = [0, 0, 0];
                  if (h3) {
                    const e2 = t3.style.directionalLight, i4 = t3.style.ambientLight;
                    e2 && i4 && (g2 = ao(t3.style, e2, i4));
                  }
                  {
                    c2 = -1;
                    const v2 = a2.TRIANGLES, [y2, x2] = [i3.gridIndexBuffer, i3.gridSegments];
                    for (const c3 of s2) {
                      const s3 = o3.getTile(c3), b2 = ji.disabled, w2 = i3.prevTerrainTileForTile[c3.key], T2 = i3.terrainTileForTile[c3.key];
                      Ms(w2, T2) && Os.newMorphing(c3.key, w2, T2, r2, 250), n2.activeTexture.set(a2.TEXTURE0), s3.texture && s3.texture.bind(a2.LINEAR, a2.CLAMP_TO_EDGE);
                      const E2 = Os.getMorphValuesForProxy(c3.key), S2 = E2 ? 1 : 0;
                      let I2;
                      E2 && (I2 = { morphing: { srcDemTile: E2.from, dstDemTile: E2.to, phase: e.dk(E2.phase) } });
                      const C2 = Ps(c3.projMatrix, ks(c3.canonical, f2.renderWorldCopies) ? m2 / 10 : m2, g2);
                      if (u2(S2), !l2) continue;
                      i3.setupElevationDraw(s3, l2, I2);
                      const R2 = c3.toUnwrapped();
                      h3 && h3.setupShadows(R2, l2), t3.uploadCommonUniforms(n2, l2, R2, null, d2), l2.draw(t3, v2, p3, b2, _2, qi.backCCW, C2, "terrain_raster", i3.gridBuffer, y2, x2);
                    }
                  }
                }
              }(i2, this, this.proxySourceCache, t2, this._updateTimestamp), this.renderingToTexture = true, i2.gpuTimingDeferredRenderEnd(), t2.splice(0, t2.length));
            }
            renderBatch(t2) {
              if (0 === this._drapedRenderBatches.length) return t2 + 1;
              this.renderingToTexture = true;
              const i2 = this.painter, o2 = this.painter.context, s2 = this.proxySourceCache, r2 = this.proxiedCoords[s2.id], n2 = this._drapedRenderBatches.shift(), a2 = i2.style.order, l2 = [];
              let c2 = 0;
              for (const h3 of r2) {
                const r3 = s2.getTileByID(h3.proxyTileKey), d2 = s2.proxyCachedFBO[h3.key] ? s2.proxyCachedFBO[h3.key][t2] : void 0, u2 = void 0 !== d2 ? s2.renderCache[d2] : this.pool[c2++], _2 = void 0 !== d2;
                if (r3.texture = u2.tex, _2 && !u2.dirty) {
                  l2.push(r3.tileID);
                  continue;
                }
                let p3;
                o2.bindFramebuffer.set(u2.fb.framebuffer), this.renderedToTile = false, u2.dirty && (o2.clear({ color: e.am.transparent, stencil: 0 }), u2.dirty = false);
                for (let e2 = n2.start; e2 <= n2.end; ++e2) {
                  const t3 = i2.style._mergedLayers[a2[e2]];
                  if (t3.isHidden(i2.transform.zoom)) continue;
                  const s3 = i2.style.getLayerSourceCache(t3), r4 = s3 ? this.proxyToSource[h3.key][s3.id] : [h3];
                  if (!r4) continue;
                  const n3 = r4;
                  o2.viewport.set([0, 0, u2.fb.width, u2.fb.height]), p3 !== (s3 ? s3.id : null) && (this._setupStencil(u2, r4, t3, s3), p3 = s3 ? s3.id : null), i2.renderLayer(i2, s3, t3, n3);
                }
                if (0 === this._drapedRenderBatches.length) for (const e2 of this._pendingGroundEffectLayers) {
                  const t3 = i2.style._mergedLayers[a2[e2]];
                  if (t3.isHidden(i2.transform.zoom)) continue;
                  const s3 = i2.style.getLayerSourceCache(t3), r4 = s3 ? this.proxyToSource[h3.key][s3.id] : [h3];
                  if (!r4) continue;
                  const n3 = r4;
                  o2.viewport.set([0, 0, u2.fb.width, u2.fb.height]), p3 !== (s3 ? s3.id : null) && (this._setupStencil(u2, r4, t3, s3), p3 = s3 ? s3.id : null), i2.renderLayer(i2, s3, t3, n3);
                }
                this.renderedToTile ? (u2.dirty = true, l2.push(r3.tileID)) : _2 || --c2, 5 === c2 && (c2 = 0, this.renderToBackBuffer(l2));
              }
              return this.renderToBackBuffer(l2), this.renderingToTexture = false, o2.bindFramebuffer.set(null), o2.viewport.set([0, 0, i2.width, i2.height]), n2.end + 1;
            }
            postRender() {
            }
            isLayerOrderingCorrect(e2) {
              const t2 = e2.order.length;
              let i2 = -1, o2 = t2;
              for (let s2 = 0; s2 < t2; ++s2) this._style.isLayerDraped(e2._mergedLayers[e2.order[s2]]) ? i2 = Math.max(i2, s2) : o2 = Math.min(o2, s2);
              return o2 > i2;
            }
            getMinElevationBelowMSL() {
              let e2 = 0;
              return this._visibleDemTiles.filter((e3) => e3.dem).forEach((t2) => {
                e2 = Math.min(e2, t2.dem.tree.minimums[0]);
              }), 0 === e2 ? e2 : (e2 - 30) * this._exaggeration;
            }
            raycast(e2, t2, i2) {
              if (!this._visibleDemTiles) return null;
              const o2 = this._visibleDemTiles.filter((e3) => e3.dem).map((o3) => {
                const s2 = o3.tileID, r2 = 1 << s2.overscaledZ, { x: n2, y: a2 } = s2.canonical, l2 = n2 / r2, c2 = (n2 + 1) / r2, h3 = a2 / r2, d2 = (a2 + 1) / r2;
                return { minx: l2, miny: h3, maxx: c2, maxy: d2, t: o3.dem.tree.raycastRoot(l2, h3, c2, d2, e2, t2, i2), tile: o3 };
              });
              o2.sort((e3, t3) => (null !== e3.t ? e3.t : Number.MAX_VALUE) - (null !== t3.t ? t3.t : Number.MAX_VALUE));
              for (const s2 of o2) {
                if (null == s2.t) return null;
                const o3 = s2.tile.dem.tree.raycast(s2.minx, s2.miny, s2.maxx, s2.maxy, e2, t2, i2);
                if (null != o3) return o3;
              }
              return null;
            }
            _createFBO() {
              const t2 = this.painter.context, i2 = t2.gl, o2 = this.drapeBufferSize;
              t2.activeTexture.set(i2.TEXTURE0);
              const s2 = new e.T(t2, { width: o2[0], height: o2[1], data: null }, i2.RGBA8);
              s2.bind(i2.LINEAR, i2.CLAMP_TO_EDGE);
              const r2 = t2.createFramebuffer(o2[0], o2[1], true, null);
              return r2.colorAttachment.set(s2.texture), r2.depthAttachment = new Ls(t2, r2.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t2.createRenderbuffer(t2.gl.DEPTH_STENCIL, o2[0], o2[1]), this._stencilRef = 0, r2.depthAttachment.set(this._sharedDepthStencil), t2.clear({ stencil: 0 })) : r2.depthAttachment.set(this._sharedDepthStencil), t2.extTextureFilterAnisotropic && i2.texParameterf(i2.TEXTURE_2D, t2.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t2.extTextureFilterAnisotropicMax), { fb: r2, tex: s2, dirty: false };
            }
            _initFBOPool() {
              for (; this.pool.length < Math.min(5, this.proxyCoords.length); ) this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
              if (this._debugParams.disableRenderCache) return true;
              if (this._style.hasLightTransitions()) return true;
              for (const e2 in this._style._mergedSourceCaches) if (this._style._mergedSourceCaches[e2].hasTransition()) return true;
              return this._style.order.some((e2) => {
                const t2 = this._style._mergedLayers[e2], i2 = t2.isHidden(this.painter.transform.zoom);
                return "hillshade" === t2.type || "custom" === t2.type ? !i2 && t2.shouldRedrape() : !i2 && t2.hasTransition();
              });
            }
            _clearLineLayersFromRenderCache() {
              let t2 = false;
              for (const e2 of this._style.getSources()) if (e2 instanceof it) {
                t2 = true;
                break;
              }
              if (!t2) return;
              const i2 = {};
              for (let t3 = 0; t3 < this._style.order.length; ++t3) {
                const o2 = this._style._mergedLayers[this._style.order[t3]], s2 = this._style.getLayerSourceCache(o2);
                if (s2 && !i2[s2.id] && !o2.isHidden(this.painter.transform.zoom) && "line" === o2.type && o2.widthExpression() instanceof e.ab) {
                  i2[s2.id] = true;
                  for (const e2 of this.proxyCoords) {
                    const t4 = this.proxyToSource[e2.key][s2.id];
                    if (t4) for (const e3 of t4) this._clearRenderCacheForTile(s2.id, e3);
                  }
                }
              }
            }
            _clearRasterLayersFromRenderCache() {
              let e2 = false;
              for (const t3 in this._style._mergedSourceCaches) if (this._style._mergedSourceCaches[t3]._source instanceof ot) {
                e2 = true;
                break;
              }
              if (!e2) return;
              const t2 = {};
              for (let e3 = 0; e3 < this._style.order.length; ++e3) {
                const i2 = this._style._mergedLayers[this._style.order[e3]], o2 = this._style.getLayerSourceCache(i2);
                if (!o2 || t2[o2.id]) continue;
                if (i2.isHidden(this.painter.transform.zoom) || "raster" !== i2.type) continue;
                const s2 = i2.paint.get("raster-fade-duration");
                for (const e4 of this.proxyCoords) {
                  const t3 = this.proxyToSource[e4.key][o2.id];
                  if (t3) for (const e5 of t3) {
                    const t4 = Us(o2.getTile(e5), o2.findLoadedParent(e5, 0), o2, this.painter.transform, s2);
                    (1 !== t4.opacity || 0 !== t4.mix) && this._clearRenderCacheForTile(o2.id, e5);
                  }
                }
              }
            }
            _setupDrapedRenderBatches() {
              this._style.updateDrapeFirstLayers();
              const t2 = this._style.order, i2 = t2.length;
              if (0 === i2) return;
              const o2 = [];
              this._pendingGroundEffectLayers = [];
              let s2, r2 = 0, n2 = this._style._mergedLayers[t2[r2]];
              for (; !this._style.isLayerDraped(n2) && n2.isHidden(this.painter.transform.zoom) && ++r2 < i2; ) n2 = this._style._mergedLayers[t2[r2]];
              for (; r2 < i2; ++r2) {
                const e2 = this._style._mergedLayers[t2[r2]];
                e2.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e2) ? void 0 === s2 && (s2 = r2) : ("fill-extrusion" === e2.type && this._pendingGroundEffectLayers.push(r2), void 0 !== s2 && (o2.push({ start: s2, end: r2 - 1 }), s2 = void 0)));
              }
              if (void 0 !== s2 && o2.push({ start: s2, end: r2 - 1 }), 0 !== o2.length) {
                const t3 = o2[o2.length - 1];
                this._pendingGroundEffectLayers.every((e2) => e2 > t3.end) || e.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
              }
              this._drapedRenderBatches = o2;
            }
            _setupRenderCache(e2) {
              const t2 = this.proxySourceCache;
              if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                if (this.invalidateRenderCache = false, t2.renderCache.length > t2.renderCachePool.length) {
                  const e3 = Object.values(t2.proxyCachedFBO);
                  t2.proxyCachedFBO = {};
                  for (let i3 = 0; i3 < e3.length; ++i3) {
                    const o3 = Object.values(e3[i3]);
                    t2.renderCachePool.push(...o3);
                  }
                }
                return;
              }
              this._clearRasterLayersFromRenderCache();
              const i2 = this.proxyCoords, o2 = this._tilesDirty;
              for (let s3 = i2.length - 1; s3 >= 0; s3--) {
                const r2 = i2[s3];
                if (t2.getTileByID(r2.key), void 0 !== t2.proxyCachedFBO[r2.key]) {
                  const i3 = e2[r2.key], s4 = this.proxyToSource[r2.key];
                  let n2 = 0;
                  for (const e3 in s4) {
                    const t3 = s4[e3], r3 = i3[e3];
                    if (!r3 || r3.length !== t3.length || t3.some((t4, i4) => t4 !== r3[i4] || o2[e3] && o2[e3].hasOwnProperty(t4.key))) {
                      n2 = -1;
                      break;
                    }
                    ++n2;
                  }
                  for (const e3 in t2.proxyCachedFBO[r2.key]) t2.renderCache[t2.proxyCachedFBO[r2.key][e3]].dirty = n2 < 0 || n2 !== Object.values(i3).length;
                }
              }
              const s2 = [...this._drapedRenderBatches];
              s2.sort((e3, t3) => t3.end - t3.start - (e3.end - e3.start));
              for (const e3 of s2) for (const o3 of i2) {
                if (t2.proxyCachedFBO[o3.key]) continue;
                let i3 = t2.renderCachePool.pop();
                void 0 === i3 && t2.renderCache.length < 50 && (i3 = t2.renderCache.length, t2.renderCache.push(this._createFBO())), void 0 !== i3 && (t2.proxyCachedFBO[o3.key] = {}, t2.proxyCachedFBO[o3.key][e3.start] = i3, t2.renderCache[i3].dirty = true);
              }
              this._tilesDirty = {};
            }
            _setupStencil(e2, t2, i2, o2) {
              if (!o2 || !this._sourceTilesOverlap[o2.id]) return void (this._overlapStencilType && (this._overlapStencilType = false));
              const s2 = this.painter.context, r2 = s2.gl;
              if (t2.length <= 1) return void (this._overlapStencilType = false);
              let n2;
              if (i2.isTileClipped()) n2 = t2.length, this._overlapStencilMode.test = { func: r2.EQUAL, mask: 255 }, this._overlapStencilType = "Clip";
              else {
                if (!(t2[0].overscaledZ > t2[t2.length - 1].overscaledZ)) return void (this._overlapStencilType = false);
                n2 = 1, this._overlapStencilMode.test = { func: r2.GREATER, mask: 255 }, this._overlapStencilType = "Mask";
              }
              this._stencilRef + n2 > 255 && (s2.clear({ stencil: 0 }), this._stencilRef = 0), this._stencilRef += n2, this._overlapStencilMode.ref = this._stencilRef, i2.isTileClipped() && this._renderTileClippingMasks(t2, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
              return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(e2) {
              return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[e2.key]), this._overlapStencilMode) : ji.disabled;
            }
            _renderTileClippingMasks(e2, t2) {
              const i2 = this.painter, o2 = this.painter.context, s2 = o2.gl;
              i2._tileClippingMaskIDs = {}, o2.setColorMode(ki.disabled), o2.setDepthMode(Ni.disabled);
              const r2 = i2.getOrCreateProgram("clippingMask");
              for (const o3 of e2) {
                const e3 = i2._tileClippingMaskIDs[o3.key] = --t2;
                r2.draw(i2, s2.TRIANGLES, Ni.disabled, new ji({ func: s2.ALWAYS, mask: 0 }, e3, 255, s2.KEEP, s2.KEEP, s2.REPLACE), ki.disabled, qi.disabled, Ns(o3.projMatrix), "$clipping", i2.tileExtentBuffer, i2.quadTriangleIndexBuffer, i2.tileExtentSegments);
              }
            }
            pointCoordinate(t2) {
              const i2 = this.painter.transform;
              if (t2.x < 0 || t2.x > i2.width || t2.y < 0 || t2.y > i2.height) return null;
              const o2 = [t2.x, t2.y, 1, 1];
              e.aA(o2, o2, i2.pixelMatrixInverse), e.cw(o2, o2, 1 / o2[3]), o2[0] /= i2.worldSize, o2[1] /= i2.worldSize;
              const s2 = i2._camera.position, r2 = e.c6(1, i2.center.lat), n2 = [s2[0], s2[1], s2[2] / r2, 0], a2 = e.cX([], o2.slice(0, 3), n2);
              e.au(a2, a2);
              const l2 = this.raycast(n2, a2, this._exaggeration);
              return null !== l2 && l2 ? (e.bE(n2, n2, a2, l2), n2[3] = n2[2], n2[2] *= r2, n2) : null;
            }
            _setupProxiedCoordsForOrtho(t2, i2, o2) {
              if (t2.getSource() instanceof e.aP) return this._setupProxiedCoordsForImageSource(t2, i2, o2);
              this._findCoveringTileCache[t2.id] = this._findCoveringTileCache[t2.id] || {};
              const s2 = this.proxiedCoords[t2.id] = [], r2 = this.proxyCoords;
              for (let e2 = 0; e2 < r2.length; e2++) {
                const i3 = r2[e2], n3 = this._findTileCoveringTileID(i3, t2);
                if (n3) {
                  const e3 = this._createProxiedId(i3, n3, o2[i3.key] && o2[i3.key][t2.id]);
                  s2.push(e3), this.proxyToSource[i3.key][t2.id] = [e3];
                }
              }
              let n2 = false;
              const a2 = /* @__PURE__ */ new Set();
              for (let e2 = 0; e2 < i2.length; e2++) {
                const r3 = t2.getTile(i2[e2]);
                if (!r3 || !r3.hasData()) continue;
                const l2 = this._findTileCoveringTileID(r3.tileID, this.proxySourceCache);
                if (l2 && l2.tileID.canonical.z !== r3.tileID.canonical.z) {
                  const e3 = this.proxyToSource[l2.tileID.key][t2.id], i3 = this._createProxiedId(l2.tileID, r3, o2[l2.tileID.key] && o2[l2.tileID.key][t2.id]);
                  e3 ? e3.splice(e3.length - 1, 0, i3) : this.proxyToSource[l2.tileID.key][t2.id] = [i3];
                  const c2 = this.proxyToSource[l2.tileID.key][t2.id];
                  a2.has(c2) || a2.add(c2), s2.push(i3), n2 = true;
                }
              }
              if (this._sourceTilesOverlap[t2.id] = n2, n2 && this._debugParams.sortTilesHiZFirst) for (const e2 of a2) e2.sort((e3, t3) => t3.overscaledZ - e3.overscaledZ);
            }
            _setupProxiedCoordsForImageSource(t2, i2, o2) {
              if (!t2.getSource().loaded()) return;
              const s2 = this.proxiedCoords[t2.id] = [], r2 = this.proxyCoords, n2 = t2.getSource(), a2 = n2.tileID;
              if (!a2) return;
              const l2 = new e.P(a2.x, a2.y)._div(1 << a2.z), c2 = n2.coordinates.map(e.ac.fromLngLat).reduce((e2, t3) => (e2.min.x = Math.min(e2.min.x, t3.x - l2.x), e2.min.y = Math.min(e2.min.y, t3.y - l2.y), e2.max.x = Math.max(e2.max.x, t3.x - l2.x), e2.max.y = Math.max(e2.max.y, t3.y - l2.y), e2), { min: new e.P(Number.MAX_VALUE, Number.MAX_VALUE), max: new e.P(-Number.MAX_VALUE, -Number.MAX_VALUE) }), h3 = (t3, i3) => {
                const o3 = t3.wrap + t3.canonical.x / (1 << t3.canonical.z), s3 = t3.canonical.y / (1 << t3.canonical.z), r3 = e.aj / (1 << t3.canonical.z), n3 = i3.wrap + i3.canonical.x / (1 << i3.canonical.z), a3 = i3.canonical.y / (1 << i3.canonical.z);
                return o3 + r3 < n3 + c2.min.x || o3 > n3 + c2.max.x || s3 + r3 < a3 + c2.min.y || s3 > a3 + c2.max.y;
              };
              for (let e2 = 0; e2 < r2.length; e2++) {
                const n3 = r2[e2];
                for (let e3 = 0; e3 < i2.length; e3++) {
                  const r3 = t2.getTile(i2[e3]);
                  if (!r3 || !r3.hasData()) continue;
                  if (h3(n3, r3.tileID)) continue;
                  const a3 = this._createProxiedId(n3, r3, o2[n3.key] && o2[n3.key][t2.id]), l3 = this.proxyToSource[n3.key][t2.id];
                  l3 ? l3.push(a3) : this.proxyToSource[n3.key][t2.id] = [a3], s2.push(a3);
                }
              }
            }
            _createProxiedId(t2, i2, o2) {
              let s2 = this.orthoMatrix;
              if (o2) {
                const e2 = o2.find((e3) => e3.key === i2.tileID.key);
                if (e2) return e2;
              }
              if (i2.tileID.key !== t2.key) {
                const o3 = t2.canonical.z - i2.tileID.canonical.z;
                let r2, n2, a2;
                s2 = e.bz();
                const l2 = i2.tileID.wrap - t2.wrap << t2.overscaledZ;
                o3 > 0 ? (r2 = e.aj >> o3, n2 = r2 * ((i2.tileID.canonical.x << o3) - t2.canonical.x + l2), a2 = r2 * ((i2.tileID.canonical.y << o3) - t2.canonical.y)) : (r2 = e.aj << -o3, n2 = e.aj * (i2.tileID.canonical.x - (t2.canonical.x + l2 << -o3)), a2 = e.aj * (i2.tileID.canonical.y - (t2.canonical.y << -o3))), e.c5(s2, 0, r2, 0, r2, 0, 1), e.bo(s2, s2, [n2, a2, 0]);
              }
              return new Gs(i2.tileID, t2.key, s2);
            }
            _findTileCoveringTileID(t2, i2) {
              let o2 = i2.getTile(t2);
              if (o2 && o2.hasData()) return o2;
              const s2 = this._findCoveringTileCache[i2.id], r2 = s2[t2.key];
              if (o2 = r2 ? i2.getTileByID(r2) : null, o2 && o2.hasData() || null === r2) return o2;
              let n2 = o2 ? o2.tileID : t2, a2 = n2.overscaledZ;
              const l2 = i2.getSource().minzoom, c2 = [];
              if (!r2) {
                const s3 = i2.getSource().maxzoom;
                if (t2.canonical.z >= s3) {
                  const o3 = t2.canonical.z - s3;
                  i2.getSource().reparseOverscaled ? (a2 = Math.max(t2.canonical.z + 2, i2.transform.tileZoom), n2 = new e.aM(a2, t2.wrap, s3, t2.canonical.x >> o3, t2.canonical.y >> o3)) : 0 !== o3 && (a2 = s3, n2 = new e.aM(a2, t2.wrap, s3, t2.canonical.x >> o3, t2.canonical.y >> o3));
                }
                n2.key !== t2.key && (c2.push(n2.key), o2 = i2.getTile(n2));
              }
              const h3 = (e2) => {
                c2.forEach((t3) => {
                  s2[t3] = e2;
                }), c2.length = 0;
              };
              for (a2 -= 1; a2 >= l2 && (!o2 || !o2.hasData()); a2--) {
                o2 && h3(o2.tileID.key);
                const e2 = n2.calculateScaledKey(a2);
                if (o2 = i2.getTileByID(e2), o2 && o2.hasData()) break;
                const t3 = s2[e2];
                if (null === t3) break;
                void 0 === t3 ? c2.push(e2) : o2 = i2.getTileByID(t3);
              }
              return h3(o2 ? o2.tileID.key : null), o2 && o2.hasData() ? o2 : null;
            }
            findDEMTileFor(e2) {
              return this.enabled ? this._findTileCoveringTileID(e2, this.sourceCache) : null;
            }
            prepareDrawTile() {
              this.renderedToTile = true;
            }
            _clearRenderCacheForTile(e2, t2) {
              let i2 = this._tilesDirty[e2];
              i2 || (i2 = this._tilesDirty[e2] = {}), i2[t2.key] = true;
            }
          }
          function Zs(t2, i2, o2) {
            const s2 = function(t3, i3, o3) {
              const s3 = e.bG(i3, t3), r3 = e.bG(o3, [0.2126, 0.7152, 0.0722]), n3 = (e2, t4, i4) => (1 - i4) * e2 + i4 * t4, a3 = n3(1 - 0.3 * Math.min(r3, 1), 1, Math.min(s3 + 1, 1));
              return n3(0.92, 1, Math.asin(e.ay(i3[2], -1, 1)) / Math.PI + 0.5) * a3;
            }(t2, [0, 0, 1], i2), r2 = [0, 0, 0];
            e.bY(r2, o2.slice(0, 3), s2);
            const n2 = [0, 0, 0];
            e.bY(n2, i2.slice(0, 3), t2[2]);
            const a2 = [0, 0, 0];
            return e.cV(a2, r2, n2), e.cY(a2);
          }
          const Hs = ["fill", "fillOutline", "fillPattern", "line", "linePattern", "background", "backgroundPattern", "hillshade", "raster"], Ws = ["stars", "rainParticle", "snowParticle", "fillExtrusion", "fillExtrusionGroundEffect", "elevatedStructures", "model", "symbol"];
          class $s {
            static cacheKey(e2, t2, i2, o2) {
              let s2 = `${t2}${o2 ? o2.cacheKey : ""}`;
              for (const t3 of i2) e2.usedDefines.includes(t3) && (s2 += `/${t3}`);
              return s2;
            }
            constructor(t2, i2, o2, s2, r2, n2) {
              const a2 = t2.gl;
              this.program = a2.createProgram(), this.configuration = s2, this.name = i2, this.fixedDefines = [...n2];
              const l2 = s2 ? s2.getBinderAttributes() : [], c2 = (o2.staticAttributes || []).concat(l2);
              let h3 = s2 ? s2.defines() : [];
              h3 = h3.concat(n2.map((e2) => `#define ${e2}`));
              const d2 = "#version 300 es\n";
              let u2 = d2 + h3.concat("precision mediump float;", Uo, No.fragmentSource).join("\n");
              for (const e2 of o2.fragmentIncludes) u2 += `
${Bo[e2]}`;
              u2 += `
${o2.fragmentSource}`;
              let _2 = d2 + h3.concat("precision highp float;", Uo, No.vertexSource).join("\n");
              for (const e2 of o2.vertexIncludes) _2 += `
${Bo[e2]}`;
              this.forceManualRenderingForInstanceIDShaders = t2.forceManualRenderingForInstanceIDShaders && -1 !== o2.vertexSource.indexOf("gl_InstanceID"), this.forceManualRenderingForInstanceIDShaders && (_2 += "\nuniform int u_instanceID;\n"), _2 += `
${o2.vertexSource}`, this.forceManualRenderingForInstanceIDShaders && (_2 = _2.replaceAll("gl_InstanceID", "u_instanceID"));
              const p3 = a2.createShader(a2.FRAGMENT_SHADER);
              if (a2.isContextLost()) return void (this.failedToCreate = true);
              a2.shaderSource(p3, u2), a2.compileShader(p3), a2.attachShader(this.program, p3);
              const f2 = a2.createShader(a2.VERTEX_SHADER);
              if (a2.isContextLost()) this.failedToCreate = true;
              else {
                a2.shaderSource(f2, _2), a2.compileShader(f2), a2.attachShader(this.program, f2), this.attributes = {}, this.numAttributes = c2.length;
                for (let e2 = 0; e2 < this.numAttributes; e2++) if (c2[e2]) {
                  const t3 = c2[e2].startsWith("a_") ? c2[e2] : `a_${c2[e2]}`;
                  a2.bindAttribLocation(this.program, e2, t3), this.attributes[t3] = e2;
                }
                a2.linkProgram(this.program), a2.deleteShader(f2), a2.deleteShader(p3), this.fixedUniforms = r2(t2), this.binderUniforms = s2 ? s2.getUniforms(t2) : [], this.forceManualRenderingForInstanceIDShaders && (this.instancingUniforms = ((t3) => ({ u_instanceID: new e.c8(t3) }))(t2)), (n2.includes("TERRAIN") || -1 !== i2.indexOf("symbol") || -1 !== i2.indexOf("circle")) && (this.terrainUniforms = ((t3) => ({ u_dem: new e.c8(t3), u_dem_prev: new e.c8(t3), u_dem_tl: new e.cb(t3), u_dem_scale: new e.ca(t3), u_dem_tl_prev: new e.cb(t3), u_dem_scale_prev: new e.ca(t3), u_dem_size: new e.ca(t3), u_dem_lerp: new e.ca(t3), u_exaggeration: new e.ca(t3), u_depth: new e.c8(t3), u_depth_size_inv: new e.cb(t3), u_depth_range_unpack: new e.cb(t3), u_occluder_half_size: new e.ca(t3), u_occlusion_depth_offset: new e.ca(t3), u_meter_to_dem: new e.ca(t3), u_label_plane_matrix_inv: new e.cc(t3) }))(t2)), n2.includes("GLOBE") && (this.globeUniforms = ((t3) => ({ u_tile_tl_up: new e.c9(t3), u_tile_tr_up: new e.c9(t3), u_tile_br_up: new e.c9(t3), u_tile_bl_up: new e.c9(t3), u_tile_up_scale: new e.ca(t3) }))(t2)), n2.includes("FOG") && (this.fogUniforms = ((t3) => ({ u_fog_matrix: new e.cc(t3), u_fog_range: new e.cb(t3), u_fog_color: new e.cQ(t3), u_fog_horizon_blend: new e.ca(t3), u_fog_vertical_limit: new e.cb(t3), u_fog_temporal_offset: new e.ca(t3), u_frustum_tl: new e.c9(t3), u_frustum_tr: new e.c9(t3), u_frustum_br: new e.c9(t3), u_frustum_bl: new e.c9(t3), u_globe_pos: new e.c9(t3), u_globe_radius: new e.ca(t3), u_globe_transition: new e.ca(t3), u_is_globe: new e.c8(t3), u_viewport: new e.cb(t3) }))(t2)), n2.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((t3) => ({ u_cutoff_params: new e.cQ(t3) }))(t2)), n2.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t3) => ({ u_lighting_ambient_color: new e.c9(t3), u_lighting_directional_dir: new e.c9(t3), u_lighting_directional_color: new e.c9(t3), u_ground_radiance: new e.c9(t3) }))(t2)), n2.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((t3) => ({ u_light_matrix_0: new e.cc(t3), u_light_matrix_1: new e.cc(t3), u_fade_range: new e.cb(t3), u_shadow_normal_offset: new e.c9(t3), u_shadow_intensity: new e.ca(t3), u_shadow_texel_size: new e.ca(t3), u_shadow_map_resolution: new e.ca(t3), u_shadow_direction: new e.c9(t3), u_shadow_bias: new e.c9(t3), u_shadowmap_0: new e.c8(t3), u_shadowmap_1: new e.c8(t3) }))(t2));
              }
            }
            setTerrainUniformValues(e2, t2) {
              if (!this.terrainUniforms) return;
              const i2 = this.terrainUniforms;
              if (!this.failedToCreate) {
                e2.program.set(this.program);
                for (const e3 in t2) i2[e3] && i2[e3].set(this.program, e3, t2[e3]);
              }
            }
            setGlobeUniformValues(e2, t2) {
              if (!this.globeUniforms) return;
              const i2 = this.globeUniforms;
              if (!this.failedToCreate) {
                e2.program.set(this.program);
                for (const e3 in t2) i2[e3] && i2[e3].set(this.program, e3, t2[e3]);
              }
            }
            setFogUniformValues(e2, t2) {
              if (!this.fogUniforms) return;
              const i2 = this.fogUniforms;
              if (!this.failedToCreate) {
                e2.program.set(this.program);
                for (const e3 in t2) i2[e3].set(this.program, e3, t2[e3]);
              }
            }
            setCutoffUniformValues(e2, t2) {
              if (!this.cutoffUniforms) return;
              const i2 = this.cutoffUniforms;
              if (!this.failedToCreate) {
                e2.program.set(this.program);
                for (const e3 in t2) i2[e3].set(this.program, e3, t2[e3]);
              }
            }
            setLightsUniformValues(e2, t2) {
              if (!this.lightsUniforms) return;
              const i2 = this.lightsUniforms;
              if (!this.failedToCreate) {
                e2.program.set(this.program);
                for (const e3 in t2) i2[e3].set(this.program, e3, t2[e3]);
              }
            }
            setShadowUniformValues(e2, t2) {
              if (this.failedToCreate || !this.shadowUniforms) return;
              const i2 = this.shadowUniforms;
              e2.program.set(this.program);
              for (const e3 in t2) i2[e3].set(this.program, e3, t2[e3]);
            }
            _drawDebugWireframe(t2, i2, o2, s2, r2, n2, a2, l2, c2, h3) {
              const d2 = t2.options.wireframe;
              if (false === d2.terrain && false === d2.layers2D && false === d2.layers3D) return;
              const u2 = t2.context;
              if (!(() => !(!d2.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!d2.layers2D || t2._terrain && t2._terrain.renderingToTexture || !Hs.includes(this.name)) || !(!d2.layers3D || !Ws.includes(this.name)))()) return;
              const _2 = u2.gl, p3 = t2.wireframeDebugCache.getLinesFromTrianglesBuffer(t2.frameCounter, r2, u2);
              if (!p3) return;
              const f2 = [...this.fixedDefines];
              f2.push("DEBUG_WIREFRAME");
              const m2 = t2.getOrCreateProgram(this.name, { config: this.configuration, defines: f2 });
              u2.program.set(m2.program);
              const g2 = (e2, t3, i3) => {
                if (t3[e2] && i3[e2]) for (const o3 in t3[e2]) i3[e2][o3] && i3[e2][o3].set(i3.program, o3, t3[e2][o3].current);
              };
              c2 && c2.setUniforms(m2.program, u2, m2.binderUniforms, a2, { zoom: l2 }), g2("fixedUniforms", this, m2), g2("terrainUniforms", this, m2), g2("globeUniforms", this, m2), g2("fogUniforms", this, m2), g2("lightsUniforms", this, m2), g2("shadowUniforms", this, m2), p3.bind(), u2.setColorMode(new ki([_2.ONE, _2.ONE_MINUS_SRC_ALPHA, _2.ZERO, _2.ONE], e.am.transparent, [true, true, true, false])), u2.setDepthMode(new Ni(i2.func === _2.LESS ? _2.LEQUAL : i2.func, Ni.ReadOnly, i2.range)), u2.setStencilMode(ji.disabled);
              const v2 = 3 * n2.primitiveLength * 2, y2 = 3 * n2.primitiveOffset * 2 * 2;
              if (this.forceManualRenderingForInstanceIDShaders) {
                const e2 = h3 || 1;
                for (let t3 = 0; t3 < e2; ++t3) m2.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", t3), _2.drawElements(_2.LINES, v2, _2.UNSIGNED_SHORT, y2);
              } else h3 && h3 > 1 ? _2.drawElementsInstanced(_2.LINES, v2, _2.UNSIGNED_SHORT, y2, h3) : _2.drawElements(_2.LINES, v2, _2.UNSIGNED_SHORT, y2);
              r2.bind(), u2.program.set(this.program), u2.setDepthMode(i2), u2.setStencilMode(o2), u2.setColorMode(s2);
            }
            checkUniforms(e2, t2, i2) {
              if (this.fixedDefines.includes(t2)) {
                for (const o2 of Object.keys(i2)) if (!i2[o2].initialized) throw new Error(`Program '${this.name}', from draw '${e2}': uniform ${o2} not set but required by ${t2} being defined`);
              }
            }
            draw(e2, t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2) {
              const m2 = e2.context, g2 = m2.gl;
              if (this.failedToCreate) return;
              m2.program.set(this.program), m2.setDepthMode(i2), m2.setStencilMode(o2), m2.setColorMode(s2), m2.setCullFace(r2);
              for (const e3 of Object.keys(this.fixedUniforms)) this.fixedUniforms[e3].set(this.program, e3, n2[e3]);
              _2 && _2.setUniforms(this.program, m2, this.binderUniforms, d2, { zoom: u2 });
              const v2 = { [g2.POINTS]: 1, [g2.LINES]: 2, [g2.TRIANGLES]: 3, [g2.LINE_STRIP]: 1 }[t2];
              this.checkUniforms(a2, "RENDER_SHADOWS", this.shadowUniforms);
              const y2 = f2 && f2 > 0 ? 1 : void 0;
              for (const r3 of h3.get()) {
                const n3 = r3.vaos || (r3.vaos = {});
                if ((n3[a2] || (n3[a2] = new qo())).bind(m2, this, l2, _2 ? _2.getPaintVertexBuffers() : [], c2, r3.vertexOffset, p3 || [], y2), this.forceManualRenderingForInstanceIDShaders) {
                  const e3 = f2 || 1;
                  for (let i3 = 0; i3 < e3; ++i3) this.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", i3), c2 ? g2.drawElements(t2, r3.primitiveLength * v2, g2.UNSIGNED_SHORT, r3.primitiveOffset * v2 * 2) : g2.drawArrays(t2, r3.vertexOffset, r3.vertexLength);
                } else f2 && f2 > 1 ? g2.drawElementsInstanced(t2, r3.primitiveLength * v2, g2.UNSIGNED_SHORT, r3.primitiveOffset * v2 * 2, f2) : c2 ? g2.drawElements(t2, r3.primitiveLength * v2, g2.UNSIGNED_SHORT, r3.primitiveOffset * v2 * 2) : g2.drawArrays(t2, r3.vertexOffset, r3.vertexLength);
                t2 === g2.TRIANGLES && c2 && this._drawDebugWireframe(e2, i2, o2, s2, c2, r3, d2, u2, _2, f2);
              }
            }
          }
          function Xs(t2, i2, o2 = 0) {
            const s2 = Math.pow(2, i2.tileID.overscaledZ), r2 = i2.tileSize * Math.pow(2, t2.transform.tileZoom) / s2, n2 = r2 * (i2.tileID.canonical.x + i2.tileID.wrap * s2), a2 = r2 * i2.tileID.canonical.y;
            return { u_image: 0, u_texsize: i2.imageAtlasTexture ? i2.imageAtlasTexture.size : [0, 0], u_tile_units_to_pixels: 1 / e.aw(i2, 1, t2.transform.tileZoom), u_pixel_coord_upper: [n2 >> 16, a2 >> 16], u_pixel_coord_lower: [65535 & n2, 65535 & a2], u_pattern_transition: o2 };
          }
          const Ys = { terrain: 0, flat: 1 }, Ks = e.bz(), Js = (t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2, m2, g2, v2) => {
            const y2 = i2.style.light, x2 = y2.properties.get("position"), b2 = [x2.x, x2.y, x2.z], w2 = e.dx();
            "viewport" === y2.properties.get("anchor") && (e.dy(w2, -i2.transform.angle), e.dz(b2, b2, w2));
            const T2 = y2.properties.get("color").toPremultipliedRenderColor(null), E2 = i2.transform, S2 = { u_matrix: t2, u_lightpos: b2, u_lightintensity: y2.properties.get("intensity"), u_lightcolor: [T2.r, T2.g, T2.b], u_vertical_gradient: +o2, u_opacity: s2, u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_inv_rot_matrix: Ks, u_merc_center: [0, 0], u_up_dir: [0, 0, 0], u_height_lift: 0, u_height_type: Ys[h3], u_base_type: Ys[d2], u_ao: r2, u_edge_radius: n2, u_width_scale: a2, u_flood_light_color: f2, u_vertical_scale: m2, u_flood_light_intensity: g2, u_ground_shadow_factor: v2 };
            return "globe" === E2.projection.name && (S2.u_tile_id = [l2.canonical.x, l2.canonical.y, 1 << l2.canonical.z], S2.u_zoom_transition = u2, S2.u_inv_rot_matrix = p3, S2.u_merc_center = _2, S2.u_up_dir = E2.projection.upVector(new e.cp(0, 0, 0), _2[0] * e.aj, _2[1] * e.aj), S2.u_height_lift = c2), S2;
          }, Qs = (e2, t2, i2, o2, s2, r2) => ({ u_matrix: e2, u_edge_radius: t2, u_width_scale: i2, u_vertical_scale: o2, u_height_type: Ys[s2], u_base_type: Ys[r2] }), er = (t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2, m2, g2, v2) => {
            const y2 = Js(t2, i2, o2, s2, r2, n2, a2, l2, h3, d2, u2, _2, p3, f2, m2, g2, 1, [0, 0, 0]), x2 = { u_height_factor: -Math.pow(2, l2.overscaledZ) / c2.tileSize / 8 };
            return e.h(y2, Xs(i2, c2, v2), x2);
          }, tr = (e2, t2, i2) => ({ u_matrix: e2, u_emissive_strength: t2, u_ground_shadow_factor: i2 }), ir = (t2, i2, o2, s2, r2, n2 = 0) => e.h(tr(t2, i2, r2), Xs(o2, s2, n2)), or = (e2, t2, i2, o2) => ({ u_matrix: e2, u_world: i2, u_emissive_strength: t2, u_ground_shadow_factor: o2 }), sr = (t2, i2, o2, s2, r2, n2, a2 = 0) => e.h(ir(t2, i2, o2, s2, n2, a2), { u_world: r2 }), rr = (e2, t2) => ({ u_matrix: e2, u_ground_shadow_factor: t2 }), nr = (e2, t2, i2, o2, s2) => ({ u_matrix: e2, u_camera_pos: [t2[0], t2[1], t2[2]], u_depth_bias: i2, u_height_scale: o2, u_reset_depth: s2 }), ar = (t2, i2, o2, s2) => {
            const r2 = e.aj / o2.tileSize;
            return { u_matrix: t2, u_camera_to_center_distance: i2.getCameraToCenterDistance(s2), u_extrude_scale: [i2.pixelsToGLUnits[0] / r2, i2.pixelsToGLUnits[1] / r2] };
          }, lr = (e2, t2, i2 = 1) => ({ u_matrix: e2, u_color: t2, u_overlay: 0, u_overlay_scale: i2 }), cr = e.bz(), hr = (t2, i2, o2, s2, r2, n2, a2) => {
            const l2 = t2.transform, c2 = "globe" === l2.projection.name, h3 = c2 ? e.dA(l2.zoom, i2.canonical) * l2._pixelsPerMercatorPixel : e.aw(o2, 1, n2), d2 = { u_matrix: i2.projMatrix, u_extrude_scale: h3, u_intensity: a2, u_inv_rot_matrix: cr, u_merc_center: [0, 0], u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_up_dir: [0, 0, 0] };
            if (c2) {
              d2.u_inv_rot_matrix = s2, d2.u_merc_center = r2, d2.u_tile_id = [i2.canonical.x, i2.canonical.y, 1 << i2.canonical.z], d2.u_zoom_transition = e.ah(l2.zoom);
              const t3 = r2[0] * e.aj, o3 = r2[1] * e.aj;
              d2.u_up_dir = l2.projection.upVector(new e.cp(0, 0, 0), t3, o3);
            }
            return d2;
          };
          function dr(e2, [t2, i2, o2, s2], [r2, n2]) {
            if (r2 === n2) return [0, 0, 0, 0];
            const a2 = 255 * (e2 - 1) / (e2 * (n2 - r2));
            return [t2 * a2, i2 * a2, o2 * a2, s2 * a2];
          }
          function ur(e2, t2, [i2, o2]) {
            return i2 === o2 ? 0 : 0.5 / e2 + (t2 - i2) * (e2 - 1) / (e2 * (o2 - i2));
          }
          const _r = (t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2, m2, g2, v2, y2, x2, b2) => ({ u_matrix: t2, u_normalize_matrix: i2, u_globe_matrix: o2, u_merc_matrix: s2, u_grid_matrix: r2, u_tl_parent: n2, u_scale_parent: h3, u_fade_t: d2.mix, u_opacity: d2.opacity * u2.paint.get("raster-opacity"), u_image0: 0, u_image1: 1, u_brightness_low: u2.paint.get("raster-brightness-min"), u_brightness_high: u2.paint.get("raster-brightness-max"), u_saturation_factor: e.dC(u2.paint.get("raster-saturation")), u_contrast_factor: e.dB(u2.paint.get("raster-contrast")), u_spin_weights: pr(u2.paint.get("raster-hue-rotate")), u_perspective_transform: _2, u_raster_elevation: p3, u_zoom_transition: a2, u_merc_center: l2, u_cutoff_params: c2, u_colorization_mix: dr(e.dD, m2, v2), u_colorization_offset: ur(e.dD, g2, v2), u_color_ramp: f2, u_texture_offset: [x2 / (y2 + 2 * x2), y2 / (y2 + 2 * x2)], u_texture_res: [y2 + 2 * x2, y2 + 2 * x2], u_emissive_strength: b2 });
          function pr(e2) {
            e2 *= Math.PI / 180;
            const t2 = Math.sin(e2), i2 = Math.cos(e2);
            return [(2 * i2 + 1) / 3, (-Math.sqrt(3) * t2 - i2 + 1) / 3, (Math.sqrt(3) * t2 - i2 + 1) / 3];
          }
          const fr = 0.05, mr = (e2, t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2) => ({ u_matrix: e2, u_normalize_matrix: t2, u_globe_matrix: i2, u_merc_matrix: o2, u_grid_matrix: s2, u_tl_parent: r2, u_scale_parent: c2, u_fade_t: h3.mix, u_opacity: h3.opacity, u_image0: 0, u_image1: 1, u_raster_elevation: d2, u_zoom_transition: n2, u_merc_center: a2, u_cutoff_params: l2 }), gr = (e2, t2, i2, o2, s2, r2, n2, a2, l2, c2) => ({ u_particle_texture: e2, u_particle_texture_side_len: t2, u_tile_offset: i2, u_velocity: o2, u_color_ramp: r2, u_velocity_res: s2, u_max_speed: n2, u_uv_offset: a2, u_data_scale: [255 * l2[0], 255 * l2[1]], u_data_offset: c2, u_particle_pos_scale: 1.1, u_particle_pos_offset: [fr, fr] }), vr = (e2, t2, i2, o2, s2, r2, n2, a2, l2, c2) => ({ u_particle_texture: e2, u_particle_texture_side_len: t2, u_velocity: i2, u_velocity_res: o2, u_max_speed: s2, u_speed_factor: r2, u_reset_rate: n2, u_rand_seed: Math.random(), u_uv_offset: a2, u_data_scale: [255 * l2[0], 255 * l2[1]], u_data_offset: c2, u_particle_pos_scale: 1.1, u_particle_pos_offset: [fr, fr] }), yr = e.bz(), xr = (t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2, m2, g2, v2, y2, x2, b2, w2, T2, E2) => {
            const S2 = r2.transform, I2 = { u_is_size_zoom_constant: +("constant" === t2 || "source" === t2), u_is_size_feature_constant: +("constant" === t2 || "camera" === t2), u_size_t: i2 ? i2.uSizeT : 0, u_size: i2 ? i2.uSize : 0, u_camera_to_center_distance: S2.getCameraToCenterDistance(y2), u_rotate_symbol: +o2, u_aspect_ratio: S2.width / S2.height, u_fade_change: r2.options.fadeDuration ? r2.symbolFadeChange : 1, u_matrix: n2, u_label_plane_matrix: a2, u_coord_matrix: l2, u_is_text: +h3, u_elevation_from_sea: c2 ? 1 : 0, u_pitch_with_map: +s2, u_texsize: d2, u_texsize_icon: u2, u_texture: 0, u_texture_icon: 1, u_tile_id: [0, 0, 0], u_zoom_transition: 0, u_inv_rot_matrix: yr, u_merc_center: [0, 0], u_camera_forward: [0, 0, 0], u_ecef_origin: [0, 0, 0], u_tile_matrix: yr, u_up_vector: [0, -1, 0], u_color_adj_mat: w2, u_icon_transition: T2 || 0, u_gamma_scale: s2 ? r2.transform.getCameraToCenterDistance(y2) * Math.cos(r2.terrain ? 0 : r2.transform._pitch) : 1, u_device_pixel_ratio: e.q.devicePixelRatio, u_is_halo: 1, u_scale_factor: E2 || 1, u_ground_shadow_factor: x2, u_inv_matrix: e.bi(e.bz(), a2), u_normal_scale: b2 };
            return "globe" === y2.name && (I2.u_tile_id = [p3.canonical.x, p3.canonical.y, 1 << p3.canonical.z], I2.u_zoom_transition = f2, I2.u_inv_rot_matrix = g2, I2.u_merc_center = m2, I2.u_camera_forward = S2._camera.forward(), I2.u_ecef_origin = e.dE(S2.globeMatrix, p3.toUnwrapped()), I2.u_tile_matrix = Float32Array.from(S2.globeMatrix), I2.u_up_vector = v2), I2;
          }, br = (e2, t2, i2, o2) => ({ u_matrix: e2, u_emissive_strength: t2, u_opacity: i2, u_color: o2 }), wr = (t2, i2, o2, s2, r2, n2, a2, l2, c2) => e.h(function(t3, i3, o3, s3, r3, n3) {
            const { width: a3, height: l3 } = s3.imageManager.getPixelSize(i3), c3 = Math.pow(2, n3.tileID.overscaledZ), h3 = n3.tileSize * Math.pow(2, s3.transform.tileZoom) / c3, d2 = h3 * (n3.tileID.canonical.x + n3.tileID.wrap * c3), u2 = h3 * n3.tileID.canonical.y;
            return { u_image: 0, u_pattern_tl: o3.tl, u_pattern_br: o3.br, u_texsize: [a3, l3], u_pattern_size: o3.displaySize, u_pattern_units_to_pixels: r3 ? [s3.transform.width, -1 * s3.transform.height] : [1 / e.aw(n3, 1, s3.transform.tileZoom), 1 / e.aw(n3, 1, s3.transform.tileZoom)], u_pixel_coord_upper: [d2 >> 16, u2 >> 16], u_pixel_coord_lower: [65535 & d2, 65535 & u2] };
          }(0, n2, a2, s2, l2, c2), { u_matrix: t2, u_emissive_strength: i2, u_opacity: o2 }), Tr = new Float32Array(e.bx([])), Er = (t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3 = [0, 0, 0], f2) => {
            const m2 = r2.style.light, g2 = m2.properties.get("position"), v2 = [-g2.x, -g2.y, g2.z], y2 = e.dx();
            "viewport" === m2.properties.get("anchor") && (e.dy(y2, -r2.transform.angle), e.dz(v2, v2, y2));
            const x2 = "MASK" === d2.alphaMode, b2 = m2.properties.get("color").toNonPremultipliedRenderColor(null), w2 = _2.paint.get("model-ambient-occlusion-intensity"), T2 = _2.paint.get("model-color").constantOr(e.am.white).toNonPremultipliedRenderColor(null);
            return T2.a = _2.paint.get("model-color-mix-intensity").constantOr(0), { u_matrix: t2, u_lighting_matrix: i2, u_normal_matrix: o2, u_node_matrix: s2 || Tr, u_lightpos: v2, u_lightintensity: m2.properties.get("intensity"), u_lightcolor: [b2.r, b2.g, b2.b], u_camera_pos: p3, u_opacity: n2, u_baseTextureIsAlpha: 0, u_alphaMask: +x2, u_alphaCutoff: d2.alphaCutoff, u_baseColorFactor: a2.toNonPremultipliedRenderColor(null).toArray01(), u_emissiveFactor: l2.toNonPremultipliedRenderColor(null).toArray01(), u_metallicFactor: c2, u_roughnessFactor: h3, u_baseColorTexture: Yi.BaseColor, u_metallicRoughnessTexture: Yi.MetallicRoughness, u_normalTexture: Yi.Normal, u_occlusionTexture: Yi.Occlusion, u_emissionTexture: Yi.Emission, u_lutTexture: Yi.LUT, u_color_mix: T2.toArray01(), u_aoIntensity: w2, u_emissive_strength: u2, u_occlusionTextureTransform: f2 || [0, 0, 0, 0] };
          }, Sr = (e2, t2 = Tr, i2 = Tr) => ({ u_matrix: e2, u_instance: t2, u_node_matrix: i2 }), Ir = { fillExtrusion: (t2) => ({ u_matrix: new e.cc(t2), u_lightpos: new e.c9(t2), u_lightintensity: new e.ca(t2), u_lightcolor: new e.c9(t2), u_vertical_gradient: new e.ca(t2), u_opacity: new e.ca(t2), u_edge_radius: new e.ca(t2), u_width_scale: new e.ca(t2), u_ao: new e.cb(t2), u_height_type: new e.c8(t2), u_base_type: new e.c8(t2), u_tile_id: new e.c9(t2), u_zoom_transition: new e.ca(t2), u_inv_rot_matrix: new e.cc(t2), u_merc_center: new e.cb(t2), u_up_dir: new e.c9(t2), u_height_lift: new e.ca(t2), u_flood_light_color: new e.c9(t2), u_vertical_scale: new e.ca(t2), u_flood_light_intensity: new e.ca(t2), u_ground_shadow_factor: new e.c9(t2) }), fillExtrusionDepth: (t2) => ({ u_matrix: new e.cc(t2), u_edge_radius: new e.ca(t2), u_width_scale: new e.ca(t2), u_vertical_scale: new e.ca(t2), u_height_type: new e.c8(t2), u_base_type: new e.c8(t2) }), fillExtrusionPattern: (t2) => ({ u_matrix: new e.cc(t2), u_lightpos: new e.c9(t2), u_lightintensity: new e.ca(t2), u_lightcolor: new e.c9(t2), u_vertical_gradient: new e.ca(t2), u_height_factor: new e.ca(t2), u_edge_radius: new e.ca(t2), u_width_scale: new e.ca(t2), u_ao: new e.cb(t2), u_height_type: new e.c8(t2), u_base_type: new e.c8(t2), u_tile_id: new e.c9(t2), u_zoom_transition: new e.ca(t2), u_inv_rot_matrix: new e.cc(t2), u_merc_center: new e.cb(t2), u_up_dir: new e.c9(t2), u_height_lift: new e.ca(t2), u_image: new e.c8(t2), u_texsize: new e.cb(t2), u_pixel_coord_upper: new e.cb(t2), u_pixel_coord_lower: new e.cb(t2), u_tile_units_to_pixels: new e.ca(t2), u_opacity: new e.ca(t2), u_pattern_transition: new e.ca(t2) }), fillExtrusionGroundEffect: (t2) => ({ u_matrix: new e.cc(t2), u_opacity: new e.ca(t2), u_ao_pass: new e.ca(t2), u_meter_to_tile: new e.ca(t2), u_ao: new e.cb(t2), u_flood_light_intensity: new e.ca(t2), u_flood_light_color: new e.c9(t2), u_attenuation: new e.ca(t2), u_edge_radius: new e.ca(t2), u_fb: new e.c8(t2), u_fb_size: new e.ca(t2), u_dynamic_offset: new e.ca(t2) }), fill: (t2) => ({ u_matrix: new e.cc(t2), u_emissive_strength: new e.ca(t2), u_ground_shadow_factor: new e.c9(t2) }), fillPattern: (t2) => ({ u_matrix: new e.cc(t2), u_emissive_strength: new e.ca(t2), u_image: new e.c8(t2), u_texsize: new e.cb(t2), u_pixel_coord_upper: new e.cb(t2), u_pixel_coord_lower: new e.cb(t2), u_tile_units_to_pixels: new e.ca(t2), u_ground_shadow_factor: new e.c9(t2), u_pattern_transition: new e.ca(t2) }), fillOutline: (t2) => ({ u_matrix: new e.cc(t2), u_emissive_strength: new e.ca(t2), u_world: new e.cb(t2), u_ground_shadow_factor: new e.c9(t2) }), fillOutlinePattern: (t2) => ({ u_matrix: new e.cc(t2), u_emissive_strength: new e.ca(t2), u_world: new e.cb(t2), u_image: new e.c8(t2), u_texsize: new e.cb(t2), u_pixel_coord_upper: new e.cb(t2), u_pixel_coord_lower: new e.cb(t2), u_tile_units_to_pixels: new e.ca(t2), u_ground_shadow_factor: new e.c9(t2), u_pattern_transition: new e.ca(t2) }), building: (t2) => ({ u_matrix: new e.cc(t2), u_normal_matrix: new e.cc(t2), u_opacity: new e.ca(t2) }), buildingDepth: (t2) => ({ u_matrix: new e.cc(t2) }), elevatedStructuresDepth: (t2) => ({ u_matrix: new e.cc(t2), u_depth_bias: new e.ca(t2) }), elevatedStructures: (t2) => ({ u_matrix: new e.cc(t2), u_ground_shadow_factor: new e.c9(t2) }), elevatedStructuresDepthReconstruct: (t2) => ({ u_matrix: new e.cc(t2), u_camera_pos: new e.c9(t2), u_depth_bias: new e.ca(t2), u_height_scale: new e.ca(t2), u_reset_depth: new e.ca(t2) }), circle: e.dH, collisionBox: (t2) => ({ u_matrix: new e.cc(t2), u_camera_to_center_distance: new e.ca(t2), u_extrude_scale: new e.cb(t2) }), collisionCircle: (t2) => ({ u_matrix: new e.cc(t2), u_inv_matrix: new e.cc(t2), u_camera_to_center_distance: new e.ca(t2), u_viewport_size: new e.cb(t2) }), debug: (t2) => ({ u_color: new e.di(t2), u_matrix: new e.cc(t2), u_overlay: new e.c8(t2), u_overlay_scale: new e.ca(t2) }), clippingMask: (t2) => ({ u_matrix: new e.cc(t2) }), heatmap: (t2) => ({ u_extrude_scale: new e.ca(t2), u_intensity: new e.ca(t2), u_matrix: new e.cc(t2), u_inv_rot_matrix: new e.cc(t2), u_merc_center: new e.cb(t2), u_tile_id: new e.c9(t2), u_zoom_transition: new e.ca(t2), u_up_dir: new e.c9(t2) }), heatmapTexture: (t2) => ({ u_image: new e.c8(t2), u_color_ramp: new e.c8(t2), u_opacity: new e.ca(t2) }), hillshade: (t2) => ({ u_matrix: new e.cc(t2), u_image: new e.c8(t2), u_latrange: new e.cb(t2), u_light: new e.cb(t2), u_shadow: new e.di(t2), u_highlight: new e.di(t2), u_emissive_strength: new e.ca(t2), u_accent: new e.di(t2) }), hillshadePrepare: (t2) => ({ u_matrix: new e.cc(t2), u_image: new e.c8(t2), u_dimension: new e.cb(t2), u_zoom: new e.ca(t2) }), line: e.dG, linePattern: e.dF, raster: (t2) => ({ u_matrix: new e.cc(t2), u_normalize_matrix: new e.cc(t2), u_globe_matrix: new e.cc(t2), u_merc_matrix: new e.cc(t2), u_grid_matrix: new e.dj(t2), u_tl_parent: new e.cb(t2), u_scale_parent: new e.ca(t2), u_fade_t: new e.ca(t2), u_opacity: new e.ca(t2), u_image0: new e.c8(t2), u_image1: new e.c8(t2), u_brightness_low: new e.ca(t2), u_brightness_high: new e.ca(t2), u_saturation_factor: new e.ca(t2), u_contrast_factor: new e.ca(t2), u_spin_weights: new e.c9(t2), u_perspective_transform: new e.cb(t2), u_raster_elevation: new e.ca(t2), u_zoom_transition: new e.ca(t2), u_merc_center: new e.cb(t2), u_cutoff_params: new e.cQ(t2), u_colorization_mix: new e.cQ(t2), u_colorization_offset: new e.ca(t2), u_color_ramp: new e.c8(t2), u_texture_offset: new e.cb(t2), u_texture_res: new e.cb(t2), u_emissive_strength: new e.ca(t2) }), rasterParticle: (t2) => ({ u_matrix: new e.cc(t2), u_normalize_matrix: new e.cc(t2), u_globe_matrix: new e.cc(t2), u_merc_matrix: new e.cc(t2), u_grid_matrix: new e.dj(t2), u_tl_parent: new e.cb(t2), u_scale_parent: new e.ca(t2), u_fade_t: new e.ca(t2), u_opacity: new e.ca(t2), u_image0: new e.c8(t2), u_image1: new e.c8(t2), u_raster_elevation: new e.ca(t2), u_zoom_transition: new e.ca(t2), u_merc_center: new e.cb(t2), u_cutoff_params: new e.cQ(t2) }), rasterParticleTexture: (t2) => ({ u_texture: new e.c8(t2), u_opacity: new e.ca(t2) }), rasterParticleDraw: (t2) => ({ u_particle_texture: new e.c8(t2), u_particle_texture_side_len: new e.ca(t2), u_tile_offset: new e.cb(t2), u_velocity: new e.c8(t2), u_color_ramp: new e.c8(t2), u_velocity_res: new e.cb(t2), u_max_speed: new e.ca(t2), u_uv_offset: new e.cb(t2), u_data_scale: new e.cb(t2), u_data_offset: new e.ca(t2), u_particle_pos_scale: new e.ca(t2), u_particle_pos_offset: new e.cb(t2) }), rasterParticleUpdate: (t2) => ({ u_particle_texture: new e.c8(t2), u_particle_texture_side_len: new e.ca(t2), u_velocity: new e.c8(t2), u_velocity_res: new e.cb(t2), u_max_speed: new e.ca(t2), u_speed_factor: new e.ca(t2), u_reset_rate: new e.ca(t2), u_rand_seed: new e.ca(t2), u_uv_offset: new e.cb(t2), u_data_scale: new e.cb(t2), u_data_offset: new e.ca(t2), u_particle_pos_scale: new e.ca(t2), u_particle_pos_offset: new e.cb(t2) }), symbol: (t2) => ({ u_is_size_zoom_constant: new e.c8(t2), u_is_size_feature_constant: new e.c8(t2), u_size_t: new e.ca(t2), u_size: new e.ca(t2), u_camera_to_center_distance: new e.ca(t2), u_rotate_symbol: new e.c8(t2), u_aspect_ratio: new e.ca(t2), u_fade_change: new e.ca(t2), u_matrix: new e.cc(t2), u_label_plane_matrix: new e.cc(t2), u_coord_matrix: new e.cc(t2), u_is_text: new e.c8(t2), u_elevation_from_sea: new e.c8(t2), u_pitch_with_map: new e.c8(t2), u_texsize: new e.cb(t2), u_texsize_icon: new e.cb(t2), u_texture: new e.c8(t2), u_texture_icon: new e.c8(t2), u_gamma_scale: new e.ca(t2), u_device_pixel_ratio: new e.ca(t2), u_tile_id: new e.c9(t2), u_zoom_transition: new e.ca(t2), u_inv_rot_matrix: new e.cc(t2), u_merc_center: new e.cb(t2), u_camera_forward: new e.c9(t2), u_tile_matrix: new e.cc(t2), u_up_vector: new e.c9(t2), u_ecef_origin: new e.c9(t2), u_is_halo: new e.c8(t2), u_icon_transition: new e.ca(t2), u_color_adj_mat: new e.cc(t2), u_scale_factor: new e.ca(t2), u_ground_shadow_factor: new e.c9(t2), u_inv_matrix: new e.cc(t2), u_normal_scale: new e.ca(t2) }), background: (t2) => ({ u_matrix: new e.cc(t2), u_emissive_strength: new e.ca(t2), u_opacity: new e.ca(t2), u_color: new e.di(t2) }), backgroundPattern: (t2) => ({ u_matrix: new e.cc(t2), u_emissive_strength: new e.ca(t2), u_opacity: new e.ca(t2), u_image: new e.c8(t2), u_pattern_tl: new e.cb(t2), u_pattern_br: new e.cb(t2), u_texsize: new e.cb(t2), u_pattern_size: new e.cb(t2), u_pixel_coord_upper: new e.cb(t2), u_pixel_coord_lower: new e.cb(t2), u_pattern_units_to_pixels: new e.cb(t2) }), terrainRaster: (t2) => ({ u_matrix: new e.cc(t2), u_image0: new e.c8(t2), u_skirt_height: new e.ca(t2), u_ground_shadow_factor: new e.c9(t2) }), skybox: (t2) => ({ u_matrix: new e.cc(t2), u_sun_direction: new e.c9(t2), u_cubemap: new e.c8(t2), u_opacity: new e.ca(t2), u_temporal_offset: new e.ca(t2) }), skyboxGradient: (t2) => ({ u_matrix: new e.cc(t2), u_color_ramp: new e.c8(t2), u_center_direction: new e.c9(t2), u_radius: new e.ca(t2), u_opacity: new e.ca(t2), u_temporal_offset: new e.ca(t2) }), skyboxCapture: (t2) => ({ u_matrix_3f: new e.dj(t2), u_sun_direction: new e.c9(t2), u_sun_intensity: new e.ca(t2), u_color_tint_r: new e.cQ(t2), u_color_tint_m: new e.cQ(t2), u_luminance: new e.ca(t2) }), globeRaster: (t2) => ({ u_proj_matrix: new e.cc(t2), u_globe_matrix: new e.cc(t2), u_normalize_matrix: new e.cc(t2), u_merc_matrix: new e.cc(t2), u_zoom_transition: new e.ca(t2), u_merc_center: new e.cb(t2), u_image0: new e.c8(t2), u_grid_matrix: new e.dj(t2), u_skirt_height: new e.ca(t2), u_far_z_cutoff: new e.ca(t2), u_frustum_tl: new e.c9(t2), u_frustum_tr: new e.c9(t2), u_frustum_br: new e.c9(t2), u_frustum_bl: new e.c9(t2), u_globe_pos: new e.c9(t2), u_globe_radius: new e.ca(t2), u_viewport: new e.cb(t2) }), globeAtmosphere: (t2) => ({ u_frustum_tl: new e.c9(t2), u_frustum_tr: new e.c9(t2), u_frustum_br: new e.c9(t2), u_frustum_bl: new e.c9(t2), u_horizon: new e.ca(t2), u_transition: new e.ca(t2), u_fadeout_range: new e.ca(t2), u_color: new e.cQ(t2), u_high_color: new e.cQ(t2), u_space_color: new e.cQ(t2), u_temporal_offset: new e.ca(t2), u_horizon_angle: new e.ca(t2) }), model: (t2) => ({ u_matrix: new e.cc(t2), u_lighting_matrix: new e.cc(t2), u_normal_matrix: new e.cc(t2), u_node_matrix: new e.cc(t2), u_lightpos: new e.c9(t2), u_lightintensity: new e.ca(t2), u_lightcolor: new e.c9(t2), u_camera_pos: new e.c9(t2), u_opacity: new e.ca(t2), u_baseColorFactor: new e.cQ(t2), u_emissiveFactor: new e.cQ(t2), u_metallicFactor: new e.ca(t2), u_roughnessFactor: new e.ca(t2), u_baseTextureIsAlpha: new e.c8(t2), u_alphaMask: new e.c8(t2), u_alphaCutoff: new e.ca(t2), u_baseColorTexture: new e.c8(t2), u_metallicRoughnessTexture: new e.c8(t2), u_normalTexture: new e.c8(t2), u_occlusionTexture: new e.c8(t2), u_emissionTexture: new e.c8(t2), u_lutTexture: new e.c8(t2), u_color_mix: new e.cQ(t2), u_aoIntensity: new e.ca(t2), u_emissive_strength: new e.ca(t2), u_occlusionTextureTransform: new e.cQ(t2) }), modelDepth: (t2) => ({ u_matrix: new e.cc(t2), u_instance: new e.cc(t2), u_node_matrix: new e.cc(t2) }), groundShadow: (t2) => ({ u_matrix: new e.cc(t2), u_ground_shadow_factor: new e.c9(t2) }), stars: (t2) => ({ u_matrix: new e.cc(t2), u_up: new e.c9(t2), u_right: new e.c9(t2), u_intensity_multiplier: new e.ca(t2) }), snowParticle: (t2) => ({ u_modelview: new e.cc(t2), u_projection: new e.cc(t2), u_time: new e.ca(t2), u_cam_pos: new e.c9(t2), u_velocityConeAperture: new e.ca(t2), u_velocity: new e.ca(t2), u_horizontalOscillationRadius: new e.ca(t2), u_horizontalOscillationRate: new e.ca(t2), u_boxSize: new e.ca(t2), u_billboardSize: new e.ca(t2), u_simpleShapeParameters: new e.cb(t2), u_screenSize: new e.cb(t2), u_thinningCenterPos: new e.cb(t2), u_thinningShape: new e.c9(t2), u_thinningAffectedRatio: new e.ca(t2), u_thinningParticleOffset: new e.ca(t2), u_particleColor: new e.cQ(t2), u_direction: new e.c9(t2) }), rainParticle: (t2) => ({ u_modelview: new e.cc(t2), u_projection: new e.cc(t2), u_time: new e.ca(t2), u_cam_pos: new e.c9(t2), u_texScreen: new e.c8(t2), u_velocityConeAperture: new e.ca(t2), u_velocity: new e.ca(t2), u_boxSize: new e.ca(t2), u_rainDropletSize: new e.cb(t2), u_distortionStrength: new e.ca(t2), u_rainDirection: new e.c9(t2), u_color: new e.cQ(t2), u_screenSize: new e.cb(t2), u_thinningCenterPos: new e.cb(t2), u_thinningShape: new e.c9(t2), u_thinningAffectedRatio: new e.ca(t2), u_thinningParticleOffset: new e.ca(t2), u_shapeDirectionalPower: new e.ca(t2), u_shapeNormalPower: new e.ca(t2), u_mode: new e.ca(t2) }), vignette: (t2) => ({ u_vignetteShape: new e.c9(t2), u_vignetteColor: new e.cQ(t2) }), occlusion: (t2) => ({ u_matrix: new e.cc(t2), u_anchorPos: new e.c9(t2), u_screenSizePx: new e.cb(t2), u_occluderSizePx: new e.cb(t2), u_color: new e.cQ(t2) }) };
          class Cr {
            constructor(e2, t2, i2, o2) {
              this.id = Cr.uniqueIdxCounter, Cr.uniqueIdxCounter++, this.context = e2;
              const s2 = e2.gl;
              this.buffer = s2.createBuffer(), this.dynamicDraw = Boolean(i2), this.context.unbindVAO(), e2.bindElementBuffer.set(this.buffer), s2.bufferData(s2.ELEMENT_ARRAY_BUFFER, t2.arrayBuffer, this.dynamicDraw ? s2.DYNAMIC_DRAW : s2.STATIC_DRAW), this.dynamicDraw || o2 || t2.destroy();
            }
            bind() {
              this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e2) {
              this.id = Cr.uniqueIdxCounter, Cr.uniqueIdxCounter++;
              const t2 = this.context.gl;
              this.context.unbindVAO(), this.bind(), t2.bufferSubData(t2.ELEMENT_ARRAY_BUFFER, 0, e2.arrayBuffer);
            }
            destroy() {
              this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
          }
          Cr.uniqueIdxCounter = 0;
          const Rr = { Int8: "BYTE", Uint8: "UNSIGNED_BYTE", Int16: "SHORT", Uint16: "UNSIGNED_SHORT", Int32: "INT", Uint32: "UNSIGNED_INT", Float32: "FLOAT" };
          class Dr {
            constructor(e2, t2, i2, o2, s2, r2) {
              this.length = t2.length, this.attributes = i2, this.itemSize = t2.bytesPerElement, this.dynamicDraw = o2, this.instanceCount = r2, this.context = e2;
              const n2 = e2.gl;
              this.buffer = n2.createBuffer(), e2.bindVertexBuffer.set(this.buffer), n2.bufferData(n2.ARRAY_BUFFER, t2.arrayBuffer, this.dynamicDraw ? n2.DYNAMIC_DRAW : n2.STATIC_DRAW), this.dynamicDraw || s2 || t2.destroy();
            }
            bind() {
              this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e2) {
              const t2 = this.context.gl;
              this.bind(), t2.bufferSubData(t2.ARRAY_BUFFER, 0, e2.arrayBuffer);
            }
            enableAttributes(e2, t2) {
              for (let i2 = 0; i2 < this.attributes.length; i2++) {
                const o2 = t2.attributes[this.attributes[i2].name];
                void 0 !== o2 && e2.enableVertexAttribArray(o2);
              }
            }
            setVertexAttribPointers(e2, t2, i2) {
              for (let o2 = 0; o2 < this.attributes.length; o2++) {
                const s2 = this.attributes[o2], r2 = t2.attributes[s2.name];
                void 0 !== r2 && e2.vertexAttribPointer(r2, s2.components, e2[Rr[s2.type]], false, this.itemSize, s2.offset + this.itemSize * (i2 || 0));
              }
            }
            setVertexAttribDivisor(e2, t2, i2) {
              for (let o2 = 0; o2 < this.attributes.length; o2++) {
                const s2 = t2.attributes[this.attributes[o2].name];
                void 0 !== s2 && this.instanceCount && this.instanceCount > 0 && e2.vertexAttribDivisor(s2, i2);
              }
            }
            destroy() {
              this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
          }
          class Ar {
            constructor(e2, t2, i2, o2, s2) {
              this.context = e2, this.width = t2, this.height = i2;
              const r2 = this.framebuffer = e2.gl.createFramebuffer();
              o2 && (this.colorAttachment = new Rs(e2, r2)), s2 && (this.depthAttachmentType = s2, this.depthAttachment = "renderbuffer" === s2 ? new Ds(e2, r2) : new As(e2, r2));
            }
            destroy() {
              const e2 = this.context.gl;
              if (this.colorAttachment) {
                const t2 = this.colorAttachment.get();
                t2 && e2.deleteTexture(t2);
              }
              if (this.depthAttachment && this.depthAttachmentType) if ("renderbuffer" === this.depthAttachmentType) {
                const t2 = this.depthAttachment.get();
                t2 && e2.deleteRenderbuffer(t2);
              } else {
                const t2 = this.depthAttachment.get();
                t2 && e2.deleteTexture(t2);
              }
              e2.deleteFramebuffer(this.framebuffer);
            }
          }
          class Lr {
            constructor(e2, t2) {
              this.gl = e2, this.clearColor = new Yo(this), this.clearDepth = new Ko(this), this.clearStencil = new Jo(this), this.colorMask = new Qo(this), this.depthMask = new es(this), this.stencilMask = new ts(this), this.stencilFunc = new is3(this), this.stencilOp = new os(this), this.stencilTest = new ss(this), this.depthRange = new rs(this), this.depthTest = new ns(this), this.depthFunc = new as(this), this.blend = new ls(this), this.blendFunc = new cs(this), this.blendColor = new hs(this), this.blendEquation = new ds(this), this.cullFace = new us(this), this.cullFaceSide = new _s(this), this.frontFace = new ps(this), this.program = new fs(this), this.activeTexture = new ms(this), this.viewport = new gs(this), this.bindFramebuffer = new vs(this), this.bindRenderbuffer = new ys(this), this.bindTexture = new xs(this), this.bindVertexBuffer = new bs(this), this.bindElementBuffer = new ws(this), this.bindVertexArrayOES = new Ts(this), this.pixelStoreUnpack = new Es(this), this.pixelStoreUnpackPremultiplyAlpha = new Ss(this), this.pixelStoreUnpackFlipY = new Is(this), this.options = t2 ? Object.assign({}, t2) : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e2.getExtension("EXT_texture_filter_anisotropic") || e2.getExtension("MOZ_EXT_texture_filter_anisotropic") || e2.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e2.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e2.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e2.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e2.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.forceManualRenderingForInstanceIDShaders = t2 && !!t2.forceManualRenderingForInstanceIDShaders || this.renderer && -1 !== this.renderer.indexOf("PowerVR"), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e2.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e2.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e2.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e2.getParameter(e2.MAX_TEXTURE_SIZE), this.maxPointSize = e2.getParameter(e2.ALIASED_POINT_SIZE_RANGE)[1];
            }
            setDefault() {
              this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
              this.clearColor.dirty = true, this.clearDepth.dirty = true, this.clearStencil.dirty = true, this.colorMask.dirty = true, this.depthMask.dirty = true, this.stencilMask.dirty = true, this.stencilFunc.dirty = true, this.stencilOp.dirty = true, this.stencilTest.dirty = true, this.depthRange.dirty = true, this.depthTest.dirty = true, this.depthFunc.dirty = true, this.blend.dirty = true, this.blendFunc.dirty = true, this.blendColor.dirty = true, this.blendEquation.dirty = true, this.cullFace.dirty = true, this.cullFaceSide.dirty = true, this.frontFace.dirty = true, this.program.dirty = true, this.activeTexture.dirty = true, this.viewport.dirty = true, this.bindFramebuffer.dirty = true, this.bindRenderbuffer.dirty = true, this.bindTexture.dirty = true, this.bindVertexBuffer.dirty = true, this.bindElementBuffer.dirty = true, this.bindVertexArrayOES.dirty = true, this.pixelStoreUnpack.dirty = true, this.pixelStoreUnpackPremultiplyAlpha.dirty = true, this.pixelStoreUnpackFlipY.dirty = true;
            }
            createIndexBuffer(e2, t2, i2) {
              return new Cr(this, e2, t2, i2);
            }
            createVertexBuffer(e2, t2, i2, o2, s2) {
              return new Dr(this, e2, t2, i2, o2, s2);
            }
            createRenderbuffer(e2, t2, i2) {
              const o2 = this.gl, s2 = o2.createRenderbuffer();
              return this.bindRenderbuffer.set(s2), o2.renderbufferStorage(o2.RENDERBUFFER, e2, t2, i2), this.bindRenderbuffer.set(null), s2;
            }
            createFramebuffer(e2, t2, i2, o2) {
              return new Ar(this, e2, t2, i2, o2);
            }
            clear({ color: e2, depth: t2, stencil: i2, colorMask: o2 }) {
              const s2 = this.gl;
              let r2 = 0;
              e2 && (r2 |= s2.COLOR_BUFFER_BIT, this.clearColor.set(e2.toNonPremultipliedRenderColor(null)), this.colorMask.set(o2 || [true, true, true, true])), void 0 !== t2 && (r2 |= s2.DEPTH_BUFFER_BIT, this.depthRange.set([0, 1]), this.clearDepth.set(t2), this.depthMask.set(true)), void 0 !== i2 && (r2 |= s2.STENCIL_BUFFER_BIT, this.clearStencil.set(i2), this.stencilMask.set(255)), s2.clear(r2);
            }
            setCullFace(e2) {
              false === e2.enable ? this.cullFace.set(false) : (this.cullFace.set(true), this.cullFaceSide.set(e2.mode), this.frontFace.set(e2.frontFace));
            }
            setDepthMode(e2) {
              e2.func !== this.gl.ALWAYS || e2.mask ? (this.depthTest.set(true), this.depthFunc.set(e2.func), this.depthMask.set(e2.mask), this.depthRange.set(e2.range)) : this.depthTest.set(false);
            }
            setStencilMode(e2) {
              e2.test.func !== this.gl.ALWAYS || e2.mask ? (this.stencilTest.set(true), this.stencilMask.set(e2.mask), this.stencilOp.set([e2.fail, e2.depthFail, e2.pass]), this.stencilFunc.set({ func: e2.test.func, ref: e2.ref, mask: e2.test.mask })) : this.stencilTest.set(false);
            }
            setColorMode(t2) {
              e.bv(t2.blendFunction, ki.Replace) ? this.blend.set(false) : (this.blend.set(true), this.blendFunc.set(t2.blendFunction), this.blendColor.set(t2.blendColor), t2.blendEquation ? this.blendEquation.set(t2.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t2.mask);
            }
            unbindVAO() {
              this.bindVertexArrayOES.set(null);
            }
          }
          let Pr;
          function zr(t2, i2, o2, s2, r2, n2, a2) {
            const l2 = t2.context, c2 = l2.gl, h3 = t2.transform, d2 = t2.getOrCreateProgram("collisionBox"), u2 = [];
            let _2 = 0, p3 = 0;
            for (let l3 = 0; l3 < s2.length; l3++) {
              const f3 = s2[l3], m3 = i2.getTile(f3), g3 = m3.getBucket(o2);
              if (!g3) continue;
              const v3 = ci(f3, g3, h3);
              let y3 = v3;
              0 === r2[0] && 0 === r2[1] || (y3 = t2.translatePosMatrix(v3, m3, r2, n2));
              const x3 = a2 ? g3.textCollisionBox : g3.iconCollisionBox, b2 = g3.collisionCircleArray;
              if (b2.length > 0) {
                const t3 = e.bz(), i3 = y3;
                e.cB(t3, g3.placementInvProjMatrix, h3.glCoordMatrix), e.cB(t3, t3, g3.placementViewportMatrix), u2.push({ circleArray: b2, circleOffset: p3, transform: i3, invTransform: t3, projection: g3.getProjection() }), _2 += b2.length / 4, p3 = _2;
              }
              x3 && (t2.terrain && t2.terrain.setupElevationDraw(m3, d2), d2.draw(t2, c2.LINES, Ni.disabled, ji.disabled, t2.colorModeForRenderPass(), qi.disabled, ar(y3, h3, m3, g3.getProjection()), o2.id, x3.layoutVertexBuffer, x3.indexBuffer, x3.segments, null, h3.zoom, null, [x3.collisionVertexBuffer, x3.collisionVertexBufferExt]));
            }
            if (!a2 || !u2.length) return;
            const f2 = t2.getOrCreateProgram("collisionCircle"), m2 = new e.dI();
            m2.resize(4 * _2), m2._trim();
            let g2 = 0;
            for (const e2 of u2) for (let t3 = 0; t3 < e2.circleArray.length / 4; t3++) {
              const i3 = 4 * t3, o3 = e2.circleArray[i3 + 0], s3 = e2.circleArray[i3 + 1], r3 = e2.circleArray[i3 + 2], n3 = e2.circleArray[i3 + 3];
              m2.emplace(g2++, o3, s3, r3, n3, 0), m2.emplace(g2++, o3, s3, r3, n3, 1), m2.emplace(g2++, o3, s3, r3, n3, 2), m2.emplace(g2++, o3, s3, r3, n3, 3);
            }
            (!Pr || Pr.length < 2 * _2) && (Pr = function(t3) {
              const i3 = 2 * t3, o3 = new e.a_();
              o3.resize(i3), o3._trim();
              for (let e2 = 0; e2 < i3; e2++) {
                const t4 = 6 * e2;
                o3.uint16[t4 + 0] = 4 * e2 + 0, o3.uint16[t4 + 1] = 4 * e2 + 1, o3.uint16[t4 + 2] = 4 * e2 + 2, o3.uint16[t4 + 3] = 4 * e2 + 2, o3.uint16[t4 + 4] = 4 * e2 + 3, o3.uint16[t4 + 5] = 4 * e2 + 0;
              }
              return o3;
            }(_2));
            const v2 = l2.createIndexBuffer(Pr, true), y2 = l2.createVertexBuffer(m2, e.dJ.members, true);
            for (const i3 of u2) {
              const s3 = { u_matrix: i3.transform, u_inv_matrix: i3.invTransform, u_camera_to_center_distance: (x2 = h3).getCameraToCenterDistance(i3.projection), u_viewport_size: [x2.width, x2.height] };
              f2.draw(t2, c2.TRIANGLES, Ni.disabled, ji.disabled, t2.colorModeForRenderPass(), qi.disabled, s3, o2.id, y2, v2, e.bd.simpleSegment(0, 2 * i3.circleOffset, i3.circleArray.length, i3.circleArray.length / 2), null, h3.zoom);
            }
            var x2;
            y2.destroy(), v2.destroy();
          }
          const Mr = e.bz();
          function Or(t2) {
            const i2 = t2._camera.getWorldToCamera(t2.worldSize, 1), o2 = e.az([], i2, t2.globeMatrix);
            e.bi(o2, o2);
            const s2 = [0, 0, 0], r2 = [0, 1, 0, 0];
            return e.aA(r2, r2, o2), s2[0] = r2[0], s2[1] = r2[1], s2[2] = r2[2], e.au(s2, s2), s2;
          }
          function Fr({ width: t2, height: i2, anchor: o2, textOffset: s2, textScale: r2 }, n2) {
            const { horizontalAlign: a2, verticalAlign: l2 } = e.bT(o2), c2 = -(a2 - 0.5) * t2, h3 = -(l2 - 0.5) * i2, d2 = e.bU(o2, s2);
            return new e.P((c2 / r2 + d2[0]) * n2, (h3 / r2 + d2[1]) * n2);
          }
          function Br(t2, i2, o2, s2, r2, n2, a2, l2, c2, h3) {
            const d2 = t2.text.placedSymbolArray, u2 = t2.text.dynamicLayoutVertexArray, _2 = t2.icon.dynamicLayoutVertexArray, p3 = {}, f2 = t2.getProjection(), m2 = hi(a2, f2, r2), g2 = r2.elevation, v2 = f2.upVectorScale(a2.canonical, r2.center.lat, r2.worldSize).metersToTile;
            u2.clear();
            for (let _3 = 0; _3 < d2.length; _3++) {
              const y2 = d2.get(_3), { tileAnchorX: x2, tileAnchorY: b2, numGlyphs: w2 } = y2, T2 = y2.hidden || !y2.crossTileID || t2.allowVerticalPlacement && !y2.placedOrientation ? null : s2[y2.crossTileID];
              if (T2) {
                let s3 = 0, d3 = 0, _4 = 0;
                if (g2) {
                  const e2 = g2 ? g2.getAtTileOffset(a2, x2, b2) : 0, [t3, i3, o3] = f2.upVector(a2.canonical, x2, b2);
                  s3 = e2 * t3 * v2, d3 = e2 * i3 * v2, _4 = e2 * o3 * v2;
                }
                let [E2, S2, I2, C2] = $t(y2.projectedAnchorX + s3, y2.projectedAnchorY + d3, y2.projectedAnchorZ + _4, o2 ? m2 : n2);
                const R2 = Xt(r2.getCameraToCenterDistance(f2), C2);
                let D2 = e.bJ(t2.textSizeData, c2, y2) * R2 / e.bO;
                o2 && (D2 *= t2.tilePixelRatio / l2);
                const A2 = Fr(T2, D2);
                o2 ? ({ x: E2, y: S2, z: I2 } = f2.projectTilePoint(x2 + A2.x, b2 + A2.y, a2.canonical), [E2, S2, I2] = $t(E2 + s3, S2 + d3, I2 + _4, n2)) : (i2 && A2._rotate(-r2.angle), E2 += A2.x, S2 += A2.y, I2 = 0);
                const L2 = t2.allowVerticalPlacement && y2.placedOrientation === e.bI.vertical ? Math.PI / 2 : 0;
                for (let t3 = 0; t3 < w2; t3++) e.bL(u2, E2, S2, I2, L2);
                h3 && y2.associatedIconIndex >= 0 && (p3[y2.associatedIconIndex] = { x: E2, y: S2, z: I2, angle: L2 });
              } else si(w2, u2);
            }
            if (h3) {
              _2.clear();
              const i3 = t2.icon.placedSymbolArray;
              for (let t3 = 0; t3 < i3.length; t3++) {
                const o3 = i3.get(t3), { numGlyphs: s3 } = o3, r3 = p3[t3];
                if (o3.hidden || !r3) si(s3, _2);
                else {
                  const { x: t4, y: i4, z: o4, angle: n3 } = r3;
                  for (let r4 = 0; r4 < s3; r4++) e.bL(_2, t4, i4, o4, n3);
                }
              }
              t2.icon.dynamicLayoutVertexBuffer.updateData(_2);
            }
            t2.text.dynamicLayoutVertexBuffer.updateData(u2);
          }
          function kr(t2, i2, o2, s2, r2, n2, a2 = {}) {
            const l2 = o2.paint.get("icon-translate"), c2 = o2.paint.get("text-translate"), h3 = o2.paint.get("icon-translate-anchor"), d2 = o2.paint.get("text-translate-anchor"), u2 = o2.layout.get("icon-rotation-alignment"), _2 = o2.layout.get("text-rotation-alignment"), p3 = o2.layout.get("icon-pitch-alignment"), f2 = o2.layout.get("text-pitch-alignment"), m2 = o2.layout.get("icon-keep-upright"), g2 = o2.layout.get("text-keep-upright"), v2 = o2.paint.get("icon-color-saturation"), y2 = o2.paint.get("icon-color-contrast"), x2 = o2.paint.get("icon-color-brightness-min"), b2 = o2.paint.get("icon-color-brightness-max"), w2 = "sea" === o2.layout.get("symbol-elevation-reference"), T2 = t2.context, E2 = T2.gl, S2 = t2.transform, I2 = "map" === u2, C2 = "map" === _2, R2 = "map" === p3, D2 = "map" === f2, A2 = void 0 !== o2.layout.get("symbol-sort-key").constantOr(1);
            let L2 = false;
            const P2 = t2.depthModeForSublayer(0, Ni.ReadOnly), z2 = new Ni(t2.context.gl.LEQUAL, Ni.ReadOnly, t2.depthRangeFor3D), M2 = [e.aD(S2.center.lng), e.aH(S2.center.lat)], O2 = o2.layout.get("text-variable-anchor"), F2 = "globe" === S2.projection.name, B2 = [], k2 = [0, -1, 0];
            for (const r3 of s2) {
              const s3 = i2.getTile(r3), n3 = s3.getBucket(o2);
              if (!n3) continue;
              if ("mercator" === n3.projection.name && F2) continue;
              if (n3.fullyClipped) continue;
              const u3 = "globe" === n3.projection.name, _3 = u3 ? e.ah(S2.zoom) : 0, p4 = hi(r3, n3.getProjection(), S2), f3 = S2.calculatePixelsToTileUnitsMatrix(s3), T3 = O2 && n3.hasTextData(), N2 = n3.hasIconTextFit() && T3 && n3.hasIconData(), U2 = n3.getProjection().createInversionMatrix(S2, r3.canonical), j2 = (1 << s3.tileID.canonical.z) * e.aj / t2.transform.worldSize, V2 = (e2) => {
                let i3 = [0, 0, 0];
                if (e2) {
                  const e3 = t2.style.directionalLight, o3 = t2.style.ambientLight;
                  e3 && o3 && (i3 = ao(t2.style, e3, o3));
                }
                return i3;
              }, G2 = (e2) => {
                S2.depthOcclusionForSymbolsAndCircles && (o2.hasInitialOcclusionOpacityProperties || t2.terrain) && (e2.push("DEPTH_D24"), e2.push("DEPTH_OCCLUSION"));
              }, q2 = () => {
                const i3 = I2 && "point" !== o2.layout.get("symbol-placement"), a3 = [];
                G2(a3);
                const c3 = i3 || N2, d3 = "road" === n3.elevationType && R2, g3 = t2.shadowRenderer, T4 = d3 && !!g3 && g3.enabled, C3 = V2(T4), D3 = d3 ? z2 : P2, A3 = o2.paint.get("icon-image-cross-fade");
                t2.terrainRenderModeElevated() && R2 && a3.push("PITCH_WITH_MAP_TERRAIN"), u3 && (a3.push("PROJECTION_GLOBE_VIEW"), c3 && a3.push("PROJECTED_POS_ON_VIEWPORT")), A3 > 0 && a3.push("ICON_TRANSITION"), n3.icon.zOffsetVertexBuffer && a3.push("Z_OFFSET"), 0 === v2 && 0 === y2 && 0 === x2 && 1 === b2 || a3.push("COLOR_ADJUSTMENT"), n3.sdfIcons && a3.push("RENDER_SDF"), T4 && a3.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET"), d3 && n3.icon.orientationVertexBuffer && a3.push("ELEVATED_ROADS");
                const L3 = n3.icon.programConfigurations.get(o2.id), O3 = t2.getOrCreateProgram("symbol", { config: L3, defines: a3 }), B3 = s3.imageAtlasTexture ? s3.imageAtlasTexture.size : [0, 0], q3 = n3.iconSizeData, Z3 = e.bH(q3, S2.zoom), H3 = R2 || !S2.isOrthographic, W3 = Zt(p4, s3.tileID.canonical, R2, I2, S2, n3.getProjection(), f3), $3 = Wt(p4, s3.tileID.canonical, R2, I2, S2, n3.getProjection(), f3), X3 = t2.translatePosMatrix($3, s3, l2, h3, true), Y3 = t2.translatePosMatrix(p4, s3, l2, h3), K3 = c3 ? Mr : W3, J2 = I2 && !R2 && !i3;
                let Q2 = k2;
                !F2 && !S2.mercatorFromTransition || I2 || (Q2 = Or(S2));
                const ee2 = u3 ? Q2 : k2, te2 = o2.getColorAdjustmentMatrix(v2, y2, x2, b2), ie2 = xr(q3.kind, Z3, J2, R2, t2, Y3, K3, X3, w2, false, B3, [0, 0], 0, r3, _3, M2, U2, ee2, n3.getProjection(), C3, j2, te2, A3, null), oe2 = s3.imageAtlasTexture ? s3.imageAtlasTexture : null, se2 = 1 !== o2.layout.get("icon-size").constantOr(0) || n3.iconsNeedLinear, re2 = n3.sdfIcons || t2.options.rotating || t2.options.zooming || se2 || H3 ? E2.LINEAR : E2.NEAREST, ne2 = n3.sdfIcons && 0 !== o2.paint.get("icon-halo-width").constantOr(1), ae2 = t2.terrain && R2 && i3 ? e.bi(e.bz(), W3) : Mr;
                if (i3 && n3.icon) {
                  const e2 = S2.elevation, i4 = e2 ? e2.getAtTileOffsetFunc(r3, S2.center.lat, S2.worldSize, n3.getProjection()) : null, o3 = Ht(p4, s3.tileID.canonical, R2, I2, S2, n3.getProjection(), f3);
                  Kt(n3, p4, t2, false, o3, $3, R2, m2, i4, r3);
                }
                return { program: O3, buffers: n3.icon, uniformValues: ie2, atlasTexture: oe2, atlasTextureIcon: null, atlasInterpolation: re2, atlasInterpolationIcon: null, isSDF: n3.sdfIcons, hasHalo: ne2, depthMode: D3, tile: s3, renderWithShadows: T4, labelPlaneMatrixInv: ae2 };
              }, Z2 = () => {
                const i3 = C2 && "point" !== o2.layout.get("symbol-placement"), a3 = [], l3 = i3 || O2 || N2, h4 = "road" === n3.elevationType && D2, m3 = t2.shadowRenderer, v3 = h4 && !!m3 && m3.enabled, y3 = V2(v3), x3 = h4 ? z2 : P2;
                t2.terrainRenderModeElevated() && D2 && a3.push("PITCH_WITH_MAP_TERRAIN"), u3 && (a3.push("PROJECTION_GLOBE_VIEW"), l3 && a3.push("PROJECTED_POS_ON_VIEWPORT")), n3.text.zOffsetVertexBuffer && a3.push("Z_OFFSET"), n3.iconsInText && a3.push("RENDER_TEXT_AND_SYMBOL"), a3.push("RENDER_SDF"), v3 && a3.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET"), h4 && n3.text.orientationVertexBuffer && a3.push("ELEVATED_ROADS"), G2(a3);
                const b3 = n3.text.programConfigurations.get(o2.id), T4 = t2.getOrCreateProgram("symbol", { config: b3, defines: a3 });
                let I3, R3 = [0, 0], A3 = null;
                const L3 = n3.textSizeData;
                n3.iconsInText && (R3 = s3.imageAtlasTexture ? s3.imageAtlasTexture.size : [0, 0], A3 = s3.imageAtlasTexture ? s3.imageAtlasTexture : null, I3 = D2 || !S2.isOrthographic || t2.options.rotating || t2.options.zooming || "composite" === L3.kind || "camera" === L3.kind ? E2.LINEAR : E2.NEAREST);
                const B3 = s3.glyphAtlasTexture ? s3.glyphAtlasTexture.size : [0, 0], q3 = o2.layout.get("text-size-scale-range"), Z3 = e.ay(t2.scaleFactor, q3[0], q3[1]), H3 = e.bH(L3, S2.zoom, Z3), W3 = Zt(p4, s3.tileID.canonical, D2, C2, S2, n3.getProjection(), f3), $3 = Wt(p4, s3.tileID.canonical, D2, C2, S2, n3.getProjection(), f3), X3 = t2.translatePosMatrix($3, s3, c2, d2, true), Y3 = t2.translatePosMatrix(p4, s3, c2, d2), K3 = l3 ? Mr : W3, J2 = C2 && !D2 && !i3;
                let Q2 = k2;
                !F2 && !S2.mercatorFromTransition || C2 || (Q2 = Or(S2));
                const ee2 = xr(L3.kind, H3, J2, D2, t2, Y3, K3, X3, w2, true, B3, R3, 0, r3, _3, M2, U2, u3 ? Q2 : k2, n3.getProjection(), y3, j2, null, null, Z3), te2 = s3.glyphAtlasTexture ? s3.glyphAtlasTexture : null, ie2 = E2.LINEAR, oe2 = 0 !== o2.paint.get("text-halo-width").constantOr(1), se2 = t2.terrain && D2 && i3 ? e.bi(e.bz(), W3) : Mr;
                if (i3 && n3.text) {
                  const e2 = S2.elevation, i4 = e2 ? e2.getAtTileOffsetFunc(r3, S2.center.lat, S2.worldSize, n3.getProjection()) : null, o3 = Ht(p4, s3.tileID.canonical, D2, C2, S2, n3.getProjection(), f3);
                  Kt(n3, p4, t2, true, o3, $3, D2, g2, i4, r3);
                }
                return { program: T4, buffers: n3.text, uniformValues: ee2, atlasTexture: te2, atlasTextureIcon: A3, atlasInterpolation: ie2, atlasInterpolationIcon: I3, isSDF: true, hasHalo: oe2, depthMode: x3, tile: s3, renderWithShadows: v3, labelPlaneMatrixInv: se2 };
              }, H2 = n3.icon.segments.get().length, W2 = n3.text.segments.get().length, $2 = H2 && !a2.onlyText ? q2() : null, X2 = W2 && !a2.onlyIcons ? Z2() : null, Y2 = o2.paint.get("icon-opacity").constantOr(1), K2 = o2.paint.get("text-opacity").constantOr(1);
              if (A2 && n3.canOverlap) {
                L2 = true;
                const t3 = Y2 && !a2.onlyText ? n3.icon.segments.get() : [], i3 = K2 && !a2.onlyIcons ? n3.text.segments.get() : [];
                for (const i4 of t3) B2.push({ segments: new e.bd([i4]), sortKey: i4.sortKey, state: $2 });
                for (const t4 of i3) B2.push({ segments: new e.bd([t4]), sortKey: t4.sortKey, state: X2 });
              } else a2.onlyText || B2.push({ segments: Y2 ? n3.icon.segments : new e.bd([]), sortKey: 0, state: $2 }), a2.onlyIcons || B2.push({ segments: K2 ? n3.text.segments : new e.bd([]), sortKey: 0, state: X2 });
            }
            L2 && B2.sort((e2, t3) => e2.sortKey - t3.sortKey);
            for (const e2 of B2) {
              const i3 = e2.state;
              if (i3) if (t2.terrain ? t2.terrain.setupElevationDraw(i3.tile, i3.program, { useDepthForOcclusion: S2.depthOcclusionForSymbolsAndCircles, labelPlaneMatrixInv: i3.labelPlaneMatrixInv }) : t2.setupDepthForOcclusion(S2.depthOcclusionForSymbolsAndCircles, i3.program), T2.activeTexture.set(E2.TEXTURE0), i3.atlasTexture && i3.atlasTexture.bind(i3.atlasInterpolation, E2.CLAMP_TO_EDGE, true), i3.atlasTextureIcon && (T2.activeTexture.set(E2.TEXTURE1), i3.atlasTextureIcon && i3.atlasTextureIcon.bind(i3.atlasInterpolationIcon, E2.CLAMP_TO_EDGE, true)), i3.renderWithShadows && t2.shadowRenderer.setupShadows(i3.tile.tileID.toUnwrapped(), i3.program, "vector-tile", i3.tile.tileID.overscaledZ), t2.uploadCommonLightUniforms(t2.context, i3.program), i3.hasHalo) {
                const s3 = i3.uniformValues;
                s3.u_is_halo = 1, Nr(i3.buffers, e2.segments, o2, t2, i3.program, i3.depthMode, r2, n2, s3, 2), s3.u_is_halo = 0;
              } else {
                if (i3.isSDF) {
                  const s3 = i3.uniformValues;
                  i3.hasHalo && (s3.u_is_halo = 1, Nr(i3.buffers, e2.segments, o2, t2, i3.program, i3.depthMode, r2, n2, s3, 1)), s3.u_is_halo = 0;
                }
                Nr(i3.buffers, e2.segments, o2, t2, i3.program, i3.depthMode, r2, n2, i3.uniformValues, 1);
              }
            }
          }
          function Nr(e2, t2, i2, o2, s2, r2, n2, a2, l2, c2) {
            const h3 = [e2.dynamicLayoutVertexBuffer, e2.opacityVertexBuffer, e2.iconTransitioningVertexBuffer, e2.globeExtVertexBuffer, e2.zOffsetVertexBuffer, e2.orientationVertexBuffer];
            s2.draw(o2, o2.context.gl.TRIANGLES, r2, n2, a2, qi.disabled, l2, i2.id, e2.layoutVertexBuffer, e2.indexBuffer, t2, i2.paint, o2.transform.zoom, e2.programConfigurations.get(i2.id), h3, c2);
          }
          function Ur(t2, i2) {
            const o2 = 1 << t2.canonical.z, s2 = (i2.x * o2 - t2.canonical.x - t2.wrap * o2) * e.aj, r2 = (i2.y * o2 - t2.canonical.y) * e.aj, n2 = e.dS(i2.z, i2.y);
            return e.cS(s2, r2, n2);
          }
          function jr(t2, i2, o2, s2, r2) {
            if (!o2.layout || "none" === o2.layout.get("fill-elevation-reference")) return;
            const n2 = t2.context.gl, a2 = new Ni(t2.context.gl.LEQUAL, Ni.ReadWrite, t2.depthRangeFor3D), l2 = new Ni(t2.context.gl.GREATER, Ni.ReadWrite, t2.depthRangeFor3D), c2 = function(t3) {
              const i3 = e.cJ(t3.pitch);
              let o3 = 0.01;
              return t3.isOrthographic && (o3 = e.ai(1e-4, o3, e.cN(i3 >= Ji ? 1 : i3 / Ji))), 2 * o3;
            }(t2.transform), h3 = t2.transform.getFreeCameraOptions().position, d2 = "elevatedStructuresDepthReconstruct", u2 = t2.getOrCreateProgram(d2, { defines: ["DEPTH_RECONSTRUCTION"] }), _2 = t2.getOrCreateProgram(d2);
            for (const e2 of s2) {
              const s3 = i2.getTile(e2), d3 = s3.getBucket(o2);
              if (!d3) continue;
              const p3 = d3.elevatedStructures;
              if (!p3) continue;
              const f2 = d3.elevationBufferData.heightRange, m2 = Ur(e2.toUnwrapped(), h3), g2 = t2.translatePosMatrix(e2.projMatrix, s3, o2.paint.get("fill-translate"), o2.paint.get("fill-translate-anchor"));
              let v2, y2, x2, b2;
              if ("initialize" === r2) {
                if (!f2 || f2.min >= 1 || 0 === p3.depthSegments.segments[0].primitiveLength) continue;
                v2 = nr(g2, m2, c2, 1, 0), y2 = a2, x2 = p3.depthSegments, b2 = u2;
              } else if ("reset" === r2) {
                if (!f2 || f2.min >= 0 || 0 === p3.maskSegments.segments[0].primitiveLength) continue;
                v2 = nr(g2, m2, 0, 0, 1), y2 = l2, x2 = p3.maskSegments, b2 = u2;
              } else if ("geometry" === r2) {
                if (0 === p3.depthSegments.segments[0].primitiveLength) continue;
                v2 = nr(g2, m2, c2, 1, 0), y2 = a2, x2 = p3.depthSegments, b2 = _2;
              }
              b2.draw(t2, n2.TRIANGLES, y2, ji.disabled, ki.disabled, qi.disabled, v2, o2.id, p3.vertexBuffer, p3.indexBuffer, x2, o2.paint, t2.transform.zoom);
            }
          }
          function Vr(t2, i2, o2) {
            const { painter: s2, sourceCache: r2, layer: n2, coords: a2, colorMode: l2, elevationType: c2, terrainEnabled: h3, pass: d2 } = t2, u2 = s2.context.gl, _2 = n2.paint.get("fill-pattern"), p3 = n2.paint.get("fill-pattern-cross-fade"), f2 = _2.constantOr(null);
            let m2 = c2;
            "road" !== c2 || i2 && !h3 || (m2 = "none");
            const g2 = "road" === m2, v2 = t2.painter.shadowRenderer, y2 = g2 && !!v2 && v2.enabled, x2 = new Ni(s2.context.gl.LEQUAL, Ni.ReadOnly, s2.depthRangeFor3D);
            let b2 = [0, 0, 0];
            if (y2) {
              const e2 = s2.style.directionalLight, t3 = s2.style.ambientLight;
              e2 && t3 && (b2 = ao(s2.style, e2, t3));
            }
            const w2 = _2 && _2.constantOr(1), T2 = (t3, d3) => {
              let _3, m3, T3, E2, S2;
              d3 ? (_3 = w2 && !n2.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", T3 = u2.LINES) : (_3 = w2 ? "fillPattern" : "fill", T3 = u2.TRIANGLES);
              for (const I2 of a2) {
                const a3 = r2.getTile(I2);
                if (w2 && !a3.patternsLoaded()) continue;
                const C2 = a3.getBucket(n2);
                if (!C2) continue;
                const R2 = i2 ? C2.elevationBufferData : C2.bufferData;
                if (R2.isEmpty()) continue;
                s2.prepareDrawTile();
                const D2 = R2.programConfigurations.get(n2.id), A2 = s2.isTileAffectedByFog(I2), L2 = [], P2 = [];
                g2 && (L2.push("ELEVATED_ROADS"), P2.push(R2.elevatedLayoutVertexBuffer)), y2 && L2.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET"), w2 && (s2.context.activeTexture.set(u2.TEXTURE0), a3.imageAtlasTexture && a3.imageAtlasTexture.bind(u2.LINEAR, u2.CLAMP_TO_EDGE), D2.updatePaintBuffers());
                let z2 = false;
                if (f2 && a3.imageAtlas) {
                  const t4 = a3.imageAtlas, i3 = e.dN.from(f2), o3 = i3.getPrimary().scaleSelf(e.q.devicePixelRatio).toString(), s3 = i3.getSecondary(), r3 = t4.patternPositions.get(o3), n3 = s3 ? t4.patternPositions.get(s3.scaleSelf(e.q.devicePixelRatio).toString()) : null;
                  z2 = !!r3 && !!n3, r3 && D2.setConstantPatternPositions(r3, n3);
                }
                p3 > 0 && (z2 || D2.getPatternTransitionVertexBuffer("fill-pattern")) && L2.push("FILL_PATTERN_TRANSITION");
                const M2 = s2.getOrCreateProgram(_3, { config: D2, overrideFog: A2, defines: L2 }), O2 = s2.translatePosMatrix(I2.projMatrix, a3, n2.paint.get("fill-translate"), n2.paint.get("fill-translate-anchor"));
                y2 && v2.setupShadows(a3.tileID.toUnwrapped(), M2, "vector-tile", a3.tileID.overscaledZ);
                const F2 = n2.paint.get("fill-emissive-strength");
                if (d3) {
                  E2 = R2.lineIndexBuffer, S2 = R2.lineSegments;
                  const e2 = s2.terrain && s2.terrain.renderingToTexture ? s2.terrain.drapeBufferSize : [u2.drawingBufferWidth, u2.drawingBufferHeight];
                  m3 = "fillOutlinePattern" === _3 && w2 ? sr(O2, F2, s2, a3, e2, b2, p3) : or(O2, F2, e2, b2);
                } else E2 = R2.indexBuffer, S2 = R2.triangleSegments, m3 = w2 ? ir(O2, F2, s2, a3, b2, p3) : tr(O2, F2, b2);
                s2.uploadCommonUniforms(s2.context, M2, I2.toUnwrapped());
                let B2 = t3;
                ("road" === c2 && !h3 || "offset" === c2) && (B2 = x2), M2.draw(s2, T3, B2, o2 || s2.stencilModeForClipping(I2), l2, qi.disabled, m3, n2.id, R2.layoutVertexBuffer, E2, S2, n2.paint, s2.transform.zoom, D2, P2);
              }
            };
            s2.renderPass === d2 && T2(s2.depthModeForSublayer(1, "opaque" === s2.renderPass ? Ni.ReadWrite : Ni.ReadOnly), false), "none" === m2 && "translucent" === s2.renderPass && n2.paint.get("fill-antialias") && T2(s2.depthModeForSublayer(n2.getPaintProperty("fill-outline-color") ? 2 : 0, Ni.ReadOnly), true);
          }
          function Gr(t2, i2, o2, s2, r2, n2, a2, l2) {
            o2.resetLayerRenderingStats(t2);
            const c2 = t2.context, h3 = c2.gl, d2 = t2.transform, u2 = o2.paint.get("fill-extrusion-pattern"), _2 = o2.paint.get("fill-extrusion-pattern-cross-fade"), p3 = u2.constantOr(null), f2 = u2.constantOr(1), m2 = o2.paint.get("fill-extrusion-opacity"), g2 = t2.style.enable3dLights(), v2 = o2.paint.get(g2 && !f2 ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), y2 = [o2.paint.get("fill-extrusion-ambient-occlusion-intensity"), v2], x2 = o2.layout.get("fill-extrusion-edge-radius"), b2 = x2 > 0 && !o2.paint.get("fill-extrusion-rounded-roof"), w2 = b2 ? 0 : x2, T2 = "globe" === d2.projection.name ? e.dV() : 0, E2 = "globe" === d2.projection.name, S2 = E2 ? e.ah(d2.zoom) : 0, I2 = [e.aD(d2.center.lng), e.aH(d2.center.lat)], C2 = "none" === o2.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), R2 = o2.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(C2 ? null : o2.lut).toArray01().slice(0, 3), D2 = o2.paint.get("fill-extrusion-flood-light-intensity"), A2 = o2.paint.get("fill-extrusion-vertical-scale"), L2 = 0 !== o2.paint.get("fill-extrusion-line-width").constantOr(1), P2 = o2.paint.get("fill-extrusion-height-alignment"), z2 = o2.paint.get("fill-extrusion-base-alignment"), M2 = eo(t2, o2.paint.get("fill-extrusion-cutoff-fade-range")), O2 = [];
            let F2;
            E2 && O2.push("PROJECTION_GLOBE_VIEW"), y2[0] > 0 && O2.push("FAUX_AO"), b2 && O2.push("ZERO_ROOF_RADIUS"), l2 && O2.push("HAS_CENTROID"), D2 > 0 && O2.push("FLOOD_LIGHT"), M2.shouldRenderCutoff && O2.push("RENDER_CUTOFF"), L2 && O2.push("RENDER_WALL_MODE");
            const B2 = "shadow" === t2.renderPass, k2 = t2.shadowRenderer, N2 = B2 && !!k2, U2 = B2 ? qi.disabled : qi.backCCW;
            t2.shadowRenderer && (t2.shadowRenderer.useNormalOffset = true);
            let j2 = [0, 0, 0];
            if (k2) {
              const e2 = t2.style.directionalLight, i3 = t2.style.ambientLight;
              e2 && i3 && (j2 = ao(t2.style, e2, i3)), B2 || (O2.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), k2.useNormalOffset && O2.push("NORMAL_OFFSET")), F2 = O2.concat(["SHADOWS_SINGLE_CASCADE"]);
            }
            const V2 = N2 ? "fillExtrusionDepth" : f2 ? "fillExtrusionPattern" : "fillExtrusion", G2 = o2.getLayerRenderingStats();
            for (const u3 of s2) {
              const s3 = i2.getTile(u3), g3 = s3.getBucket(o2);
              if (!g3 || g3.projection.name !== d2.projection.name) continue;
              let v3 = false;
              k2 && (v3 = 0 === k2.getMaxCascadeForTile(u3.toUnwrapped()));
              const x3 = t2.isTileAffectedByFog(u3), b3 = g3.programConfigurations.get(o2.id);
              let C3 = false;
              if (p3 && s3.imageAtlas) {
                const t3 = s3.imageAtlas, i3 = e.dN.from(p3), o3 = i3.getPrimary().scaleSelf(e.q.devicePixelRatio).toString(), r3 = i3.getSecondary(), n3 = t3.patternPositions.get(o3), a3 = r3 ? t3.patternPositions.get(r3.scaleSelf(e.q.devicePixelRatio).toString()) : null;
                C3 = !!n3 && !!a3, n3 && b3.setConstantPatternPositions(n3, a3);
              }
              _2 > 0 && (C3 || b3.getPatternTransitionVertexBuffer("fill-extrusion-pattern")) && O2.push("FILL_EXTRUSION_PATTERN_TRANSITION");
              const N3 = t2.getOrCreateProgram(V2, { config: b3, defines: v3 ? F2 : O2, overrideFog: x3 });
              if (t2.terrain && t2.terrain.setupElevationDraw(s3, N3, { useMeterToDem: true }), !g3.centroidVertexBuffer) {
                const e2 = N3.attributes.a_centroid_pos;
                void 0 !== e2 && h3.vertexAttrib2f(e2, 0, 0);
              }
              !B2 && k2 && k2.setupShadows(s3.tileID.toUnwrapped(), N3, "vector-tile", s3.tileID.overscaledZ), f2 && (t2.context.activeTexture.set(h3.TEXTURE0), s3.imageAtlasTexture && s3.imageAtlasTexture.bind(h3.LINEAR, h3.CLAMP_TO_EDGE), b3.updatePaintBuffers());
              const q2 = o2.paint.get("fill-extrusion-vertical-gradient"), Z2 = 1 / g3.tileToMeter;
              let H2;
              if (B2 && k2) {
                if (Xr(s3.tileID, g3, t2)) continue;
                const e2 = k2.calculateShadowPassMatrixFromTile(s3.tileID.toUnwrapped());
                H2 = Qs(e2, w2, Z2, A2, P2, z2);
              } else {
                const e2 = t2.translatePosMatrix(u3.expandedProjMatrix, s3, o2.paint.get("fill-extrusion-translate"), o2.paint.get("fill-extrusion-translate-anchor")), i3 = d2.projection.createInversionMatrix(d2, u3.canonical);
                H2 = f2 ? er(e2, t2, q2, m2, y2, w2, Z2, u3, s3, T2, P2, z2, S2, I2, i3, R2, A2, _2) : Js(e2, t2, q2, m2, y2, w2, Z2, u3, T2, P2, z2, S2, I2, i3, R2, A2, D2, j2);
              }
              t2.uploadCommonUniforms(c2, N3, u3.toUnwrapped(), null, M2);
              let W2 = g3.segments;
              if ("mercator" === d2.projection.name && !B2 && (W2 = g3.getVisibleSegments(s3.tileID, t2.terrain, t2.transform.getFrustum(0)), !W2.get().length)) continue;
              if (G2) if (B2) for (const e2 of W2.get()) G2.numRenderedVerticesInShadowPass += e2.primitiveLength;
              else for (const e2 of W2.get()) G2.numRenderedVerticesInTransparentPass += e2.primitiveLength;
              const $2 = [];
              (t2.terrain || l2) && $2.push(g3.centroidVertexBuffer), E2 && $2.push(g3.layoutVertexExtBuffer), L2 && $2.push(g3.wallVertexBuffer), N3.draw(t2, c2.gl.TRIANGLES, r2, n2, a2, U2, H2, o2.id, g3.layoutVertexBuffer, g3.indexBuffer, W2, o2.paint, t2.transform.zoom, b3, $2);
            }
            t2.shadowRenderer && (t2.shadowRenderer.useNormalOffset = false);
          }
          function qr(t2, i2, o2, s2, r2, n2, a2, l2, c2, h3, d2, u2, _2, p3, f2, m2, g2, v2, y2) {
            const x2 = t2.context, b2 = x2.gl, w2 = t2.transform, T2 = t2.transform.zoom, E2 = [], S2 = eo(t2, o2.paint.get("fill-extrusion-cutoff-fade-range"));
            "clear" === h3 ? (E2.push("CLEAR_SUBPASS"), y2 && (E2.push("CLEAR_FROM_TEXTURE"), x2.activeTexture.set(b2.TEXTURE0), y2.bind(b2.LINEAR, b2.CLAMP_TO_EDGE))) : "sdf" === h3 && E2.push("SDF_SUBPASS"), g2 && E2.push("HAS_CENTROID"), S2.shouldRenderCutoff && E2.push("RENDER_CUTOFF");
            const I2 = o2.layout.get("fill-extrusion-edge-radius"), C2 = (e2, i3, s3, h4, v3) => {
              const b3 = i3.programConfigurations.get(o2.id), w3 = t2.isTileAffectedByFog(e2), C3 = t2.getOrCreateProgram("fillExtrusionGroundEffect", { config: b3, defines: E2, overrideFog: w3 }), R2 = /* @__PURE__ */ ((e3, t3, i4, o3, s4, r3, n3, a3, l3, c3, h5) => ({ u_matrix: t3, u_opacity: i4, u_ao_pass: o3 ? 1 : 0, u_meter_to_tile: s4, u_ao: r3, u_flood_light_intensity: n3, u_flood_light_color: a3, u_attenuation: l3, u_edge_radius: c3, u_fb: 0, u_fb_size: h5, u_dynamic_offset: 1 }))(0, h4, d2, c2, v3, [u2, _2 * v3], p3, f2, m2, T2 >= 17 ? 0 : I2 * v3, y2 ? y2.size[0] : 0), D2 = [];
              g2 && D2.push(i3.hiddenByLandmarkVertexBuffer), t2.uploadCommonUniforms(x2, C3, e2.toUnwrapped(), null, S2), C3.draw(t2, x2.gl.TRIANGLES, r2, n2, a2, l2, R2, o2.id, i3.vertexBuffer, i3.indexBuffer, s3, o2.paint, T2, b3, D2);
            };
            for (const r3 of s2) {
              const s3 = i2.getTile(r3), n3 = s3.getBucket(o2);
              if (!n3 || n3.projection.name !== w2.projection.name || !n3.groundEffect || n3.groundEffect && !n3.groundEffect.hasData()) continue;
              const a3 = n3.groundEffect, l3 = 1 / n3.tileToMeter;
              {
                const e2 = t2.translatePosMatrix(r3.projMatrix, s3, o2.paint.get("fill-extrusion-translate"), o2.paint.get("fill-extrusion-translate-anchor")), i3 = a3.getDefaultSegment();
                C2(r3, a3, i3, e2, l3);
              }
              if (v2) for (let n4 = 0; n4 < 4; n4++) {
                const a4 = e.dT[n4](r3), c3 = i2.getTile(a4);
                if (!c3) continue;
                const h4 = c3.getBucket(o2);
                if (!h4 || h4.projection.name !== w2.projection.name || !h4.groundEffect || h4.groundEffect && !h4.groundEffect.hasData()) continue;
                const d3 = h4.groundEffect;
                let u3, _3;
                0 === n4 ? (u3 = [-8192, 0, 0], _3 = 1) : 1 === n4 ? (u3 = [e.aj, 0, 0], _3 = 0) : 2 === n4 ? (u3 = [0, -8192, 0], _3 = 3) : (u3 = [0, e.aj, 0], _3 = 2);
                const p4 = d3.regionSegments[_3];
                if (!p4) continue;
                const f3 = new Float32Array(16);
                e.bo(f3, r3.projMatrix, u3), C2(r3, d3, p4, t2.translatePosMatrix(f3, s3, o2.paint.get("fill-extrusion-translate"), o2.paint.get("fill-extrusion-translate-anchor")), l3);
              }
            }
          }
          function Zr(t2, i2, o2, s2, r2, n2, a2) {
            0 === s2.centroidVertexArray.length && s2.createCentroidsBuffer();
            const l2 = n2 ? n2.findDEMTileFor(o2) : null;
            if (!(l2 && l2.dem || a2)) return;
            n2 && l2 && l2.dem && s2.selfDEMTileTimestamp !== l2.dem._timestamp && (s2.borderDoneWithNeighborZ = [-1, -1, -1, -1], s2.selfDEMTileTimestamp = l2.dem._timestamp);
            const c2 = (t3) => new e.P(Math.ceil((t3 + e.dX) * e.dY), 0), h3 = (e2) => {
              const t3 = i2.getSource().minzoom, o3 = (e3) => {
                const t4 = i2.getTileByID(e3);
                if (t4 && t4.hasData()) return t4.getBucket(r2);
              }, s3 = [0, -1, 1];
              for (const i3 of s3) {
                if (e2.overscaledZ + i3 < t3) continue;
                const s4 = o3(e2.calculateScaledKey(e2.overscaledZ + i3));
                if (s4) return s4;
              }
            }, d2 = [0, 0, 0], u2 = (t3, i3) => (d2[0] = Math.min(t3.min.y, i3.min.y), d2[1] = Math.max(t3.max.y, i3.max.y), d2[2] = e.aj - i3.min.x > t3.max.x ? i3.min.x - e.aj : t3.max.x, d2), _2 = (t3, i3) => (d2[0] = Math.min(t3.min.x, i3.min.x), d2[1] = Math.max(t3.max.x, i3.max.x), d2[2] = e.aj - i3.min.y > t3.max.y ? i3.min.y - e.aj : t3.max.y, d2), p3 = [(e2, t3) => u2(e2, t3), (e2, t3) => u2(t3, e2), (e2, t3) => _2(e2, t3), (e2, t3) => _2(t3, e2)], f2 = (t3, i3, s3, r3, a3, c3, h4) => {
              if (!n2) return 0;
              const d3 = [[c3 ? s3 : t3, c3 ? t3 : s3, 0], [c3 ? s3 : i3, c3 ? i3 : s3, 0]], u3 = h4 < 0 ? e.aj + h4 : h4, _3 = [c3 ? u3 : (t3 + i3) / 2, c3 ? (t3 + i3) / 2 : u3, 0];
              return 0 === s3 && h4 < 0 || 0 !== s3 && h4 > 0 ? n2.getForTilePoints(a3, [_3], true, r3) : d3.push(_3), n2.getForTilePoints(o2, d3, true, l2), Math.max(d3[0][2], d3[1][2], _3[2]) / n2.exaggeration();
            };
            for (let t3 = 0; t3 < 4; t3++) {
              const i3 = s2.borderFeatureIndices[t3];
              if (0 === i3.length) continue;
              const r3 = e.dT[t3](o2), l3 = h3(r3);
              if (!(l3 && l3 instanceof e.dU)) continue;
              const d3 = n2 ? n2.findDEMTileFor(r3) : null;
              if (!(d3 && d3.dem || a2)) continue;
              if (n2 && d3 && d3.dem && s2.borderDEMTileTimestamp[t3] !== d3.dem._timestamp && (s2.borderDoneWithNeighborZ[t3] = -1, s2.borderDEMTileTimestamp[t3] = d3.dem._timestamp), s2.borderDoneWithNeighborZ[t3] === l3.canonical.z) continue;
              0 === l3.centroidVertexArray.length && l3.createCentroidsBuffer();
              const u3 = (t3 < 2 ? 1 : 5) - t3, _3 = l3.borderDoneWithNeighborZ[u3] !== s2.canonical.z, v2 = l3.borderFeatureIndices[u3];
              let y2 = 0;
              if (s2.canonical.z !== l3.canonical.z) {
                for (const e2 of i3) s2.showCentroid(s2.featuresOnBorder[e2]);
                if (_3) for (const e2 of v2) l3.showCentroid(l3.featuresOnBorder[e2]);
                s2.borderDoneWithNeighborZ[t3] = l3.canonical.z, l3.borderDoneWithNeighborZ[u3] = s2.canonical.z;
              }
              for (const o3 of i3) {
                const i4 = s2.featuresOnBorder[o3], n3 = s2.centroidData[i4.centroidDataIndex], h4 = i4.borders[t3];
                let _4;
                for (; y2 < v2.length; ) {
                  _4 = l3.featuresOnBorder[v2[y2]];
                  const e2 = _4.borders[u3];
                  if (e2[1] > h4[0] + 3 || e2[0] > h4[0] - 3) break;
                  l3.showCentroid(_4), y2++;
                }
                if (_4 && y2 < v2.length) {
                  const o4 = y2;
                  let x2 = 0;
                  for (; !(_4.borders[u3][0] > h4[1] - 3) && (x2++, ++y2 !== v2.length); ) _4 = l3.featuresOnBorder[v2[y2]];
                  _4 = l3.featuresOnBorder[v2[o4]];
                  let b2 = false;
                  if (x2 >= 1) {
                    const e2 = _4.borders[u3];
                    Math.abs(h4[0] - e2[0]) < 3 && Math.abs(h4[1] - e2[1]) < 3 && (x2 = 1, b2 = true, y2 = o4 + 1);
                  } else if (0 === x2) {
                    s2.showCentroid(i4);
                    continue;
                  }
                  const w2 = l3.centroidData[_4.centroidDataIndex];
                  a2 && b2 && (((m2 = n3).flags | (g2 = w2).flags) & e.dW ? (m2.flags |= e.dW, g2.flags |= e.dW) : (m2.flags &= 2147483647, g2.flags &= 2147483647));
                  const T2 = i4.intersectsCount() > 1 || _4.intersectsCount() > 1;
                  if (x2 > 1) y2 = o4, n3.centroidXY = w2.centroidXY = new e.P(0, 0);
                  else if (d3 && d3.dem && !T2) {
                    const i5 = p3[t3](n3, w2), o5 = t3 % 2 ? e.aj - 1 : 0, s3 = f2(i5[0], Math.min(e.aj - 1, i5[1]), o5, d3, r3, t3 < 2, i5[2]);
                    n3.centroidXY = w2.centroidXY = c2(s3);
                  } else T2 ? n3.centroidXY = w2.centroidXY = new e.P(0, 0) : (n3.centroidXY = s2.encodeBorderCentroid(i4), w2.centroidXY = l3.encodeBorderCentroid(_4));
                  s2.writeCentroidToBuffer(n3), l3.writeCentroidToBuffer(w2);
                } else s2.showCentroid(i4);
              }
              s2.borderDoneWithNeighborZ[t3] = l3.canonical.z, l3.borderDoneWithNeighborZ[u3] = s2.canonical.z;
            }
            var m2, g2;
            (s2.needsCentroidUpdate || !s2.centroidVertexBuffer && 0 !== s2.centroidVertexArray.length) && s2.uploadCentroid(t2);
          }
          const Hr = [1, 0, 0], Wr = [0, 1, 0], $r = [0, 0, 1];
          function Xr(t2, i2, o2) {
            const s2 = o2.transform, r2 = o2.shadowRenderer;
            if (!r2) return true;
            const n2 = t2.toUnwrapped(), a2 = s2.tileSize * r2._cascades[o2.currentShadowCascade].scale;
            let l2 = i2.maxHeight;
            if (s2.elevation) {
              const e2 = s2.elevation.getMinMaxForTile(t2);
              e2 && (l2 += e2.max);
            }
            const c2 = [...r2.shadowDirection];
            c2[2] = -c2[2];
            const h3 = r2.computeSimplifiedTileShadowVolume(n2, l2, a2, c2);
            if (!h3) return false;
            const d2 = [Hr, Wr, $r, c2, [c2[0], 0, c2[2]], [0, c2[1], c2[2]]], u2 = "globe" === s2.projection.name, _2 = s2.scaleZoom(a2), p3 = e.cn.fromInvProjectionMatrix(s2.invProjMatrix, s2.worldSize, _2, !u2), f2 = r2.getCurrentCascadeFrustum();
            return 0 === p3.intersectsPrecise(h3.vertices, h3.planes, d2) || 0 === f2.intersectsPrecise(h3.vertices, h3.planes, d2);
          }
          function Yr(t2) {
            return [t2[0] * e.dZ, t2[1] * e.dZ, t2[2] * e.dZ, 0];
          }
          function Kr(t2, i2, o2, s2, r2, n2, a2, l2, c2) {
            const h3 = s2.getSource(), d2 = o2.globeSharedBuffers;
            if (!d2) return;
            let u2, _2, p3;
            if (i2 && (u2 = s2.getTile(i2)), h3 instanceof e.aP ? (_2 = h3.texture, p3 = e.ds(0, 0, o2.transform)) : u2 && i2 && (_2 = u2.texture, p3 = e.ds(i2.canonical.z, i2.canonical.x, o2.transform)), !_2 || !p3) return;
            t2 || (p3 = e.cE(e.bz(), p3, [1, -1, 1]));
            const f2 = o2.context, m2 = f2.gl, g2 = "nearest" === r2.paint.get("raster-resampling") ? m2.NEAREST : m2.LINEAR, v2 = o2.colorModeForDrapableLayerRenderPass(n2), y2 = a2.defines;
            y2.push("GLOBE_POLES");
            const x2 = new Ni(m2.LEQUAL, Ni.ReadWrite, o2.depthRangeFor3D), b2 = Float32Array.from(o2.transform.expandedFarZProjMatrix), w2 = Float32Array.from(e.bh(e.dr(new e.cp(0, 0, 0))));
            o2.terrain && o2.terrain.prepareDrawTile(), f2.activeTexture.set(m2.TEXTURE0), _2.bind(g2, m2.CLAMP_TO_EDGE), f2.activeTexture.set(m2.TEXTURE1), _2.bind(g2, m2.CLAMP_TO_EDGE), "useMipmap" in _2 && f2.extTextureFilterAnisotropic && o2.transform.pitch > 20 && m2.texParameterf(m2.TEXTURE_2D, f2.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, f2.extTextureFilterAnisotropicMax);
            const [T2, E2, S2, I2] = i2 ? d2.getPoleBuffers(i2.canonical.z, false) : d2.getPoleBuffers(0, true), C2 = r2.paint.get("raster-elevation");
            let R2;
            t2 ? (R2 = T2, o2.renderDefaultNorthPole = 0 !== C2) : (R2 = E2, o2.renderDefaultSouthPole = 0 !== C2);
            const D2 = Yr(a2.mix), A2 = ((e2, t3, i3, o3, s3, r3, n3, a3, l3, c3, h4, d3, u3) => _r(e2, t3, i3, new Float32Array(16), new Float32Array(9), [0, 0], o3, [0, 0], [0, 0, 0, 0], 1, { opacity: 1, mix: 0 }, r3, [0, 0], a3, 2, c3, h4, d3, 1, 0, u3))(b2, w2, p3, e.ah(o2.transform.zoom), 0, r2, 0, C2, 0, D2, a2.offset, a2.range, n2), L2 = o2.getOrCreateProgram("raster", { defines: y2 });
            o2.uploadCommonUniforms(f2, L2, null), L2.draw(o2, m2.TRIANGLES, x2, c2, v2, l2, A2, r2.id, R2, S2, I2);
          }
          function Jr(e2) {
            const t2 = e2._nearZ, i2 = e2.projection.farthestPixelDistance(e2), o2 = i2 - t2, s2 = 0.2 * e2.height, r2 = t2 + s2;
            return [t2, i2, (r2 - s2 - t2) / o2, (r2 - t2) / o2];
          }
          function Qr(e2, t2, i2, o2) {
            if (e2) return t2 instanceof st && e2 instanceof Tt ? t2.getTextureDescriptor(e2, i2, true) : { texture: e2.texture, mix: Yr(o2.mix), offset: o2.offset, buffer: 0, tileSize: 1 };
          }
          var en2 = e.d_([{ name: "a_index", type: "Int16", components: 1 }]);
          class tn {
            constructor(t2, i2, o2, s2) {
              const r2 = { width: o2[0], height: o2[1], data: null }, n2 = t2.gl;
              this.targetColorTexture = new e.T(t2, r2, n2.RGBA8, { useMipmap: false }), this.backgroundColorTexture = new e.T(t2, r2, n2.RGBA8, { useMipmap: false }), this.context = t2, this.updateParticleTexture(i2, s2), this.lastInvalidatedAt = 0;
            }
            updateParticleTexture(t2, i2) {
              if (this.particleTextureDimension === i2.width) return;
              (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
              const o2 = this.context.gl, s2 = i2.width * i2.height;
              this.particleTexture0 = new e.T(this.context, i2, o2.RGBA8, { premultiply: false, useMipmap: false }), this.particleTexture1 = new e.T(this.context, i2, o2.RGBA8, { premultiply: false, useMipmap: false });
              const r2 = new e.d$();
              r2.reserve(s2);
              for (let e2 = 0; e2 < s2; e2++) r2.emplaceBack(e2);
              this.particleIndexBuffer = this.context.createVertexBuffer(r2, en2.members, true), this.particleSegment = e.bd.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i2.width;
            }
            update(t2) {
              return !(this.lastInvalidatedAt < t2 && (this.lastInvalidatedAt = e.q.now(), 1));
            }
            destroy() {
              this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
            }
          }
          function on2(t2, i2, o2) {
            if (!t2) return null;
            const s2 = i2.getTextureDescriptor(t2, o2, true);
            if (!s2) return null;
            let { texture: r2, mix: n2, offset: a2, tileSize: l2, buffer: c2, format: h3 } = s2;
            if (!r2 || !h3) return null;
            let d2 = false;
            return "uint32" === h3 && (d2 = true, n2[3] = 0, n2 = dr(e.e0, n2, [0, o2.paint.get("raster-particle-max-speed")]), a2 = ur(e.e0, a2, [0, o2.paint.get("raster-particle-max-speed")])), { texture: r2, textureOffset: [c2 / (l2 + 2 * c2), l2 / (l2 + 2 * c2)], tileSize: l2, scalarData: d2, scale: n2, offset: a2, defines: ["RASTER_ARRAY", { uint8: "DATA_FORMAT_UINT8", uint16: "DATA_FORMAT_UINT16", uint32: "DATA_FORMAT_UINT32" }[h3]] };
          }
          function sn(e2) {
            const t2 = e2._nearZ, i2 = e2.projection.farthestPixelDistance(e2), o2 = i2 - t2, s2 = 0.2 * e2.height, r2 = t2 + s2;
            return [t2, i2, (r2 - s2 - t2) / o2, (r2 - t2) / o2];
          }
          const rn = new e.am(1, 0, 0, 1), nn = new e.am(0, 1, 0, 1), an = new e.am(0, 0, 1, 1), ln = new e.am(1, 0, 1, 1), cn = new e.am(0, 1, 1, 1);
          function hn(t2, i2, o2, s2, r2, n2) {
            for (let a2 = 0; a2 < o2.length; a2++) if (r2) {
              const r3 = 1, l2 = 0.8, c2 = new e.am(s2.r * l2, s2.g * l2, s2.b * l2, 1);
              dn(t2, i2, o2[a2], s2, -1, -1, n2), dn(t2, i2, o2[a2], s2, -1, r3, n2), dn(t2, i2, o2[a2], s2, r3, r3, n2), dn(t2, i2, o2[a2], s2, r3, -1, n2), dn(t2, i2, o2[a2], c2, 0, 0, n2);
            } else dn(t2, i2, o2[a2], s2, 0, 0, n2);
          }
          function dn(t2, i2, o2, s2, r2, n2, a2) {
            const l2 = t2.context, c2 = t2.transform, h3 = l2.gl, d2 = "globe" === c2.projection.name, u2 = d2 ? ["PROJECTION_GLOBE_VIEW"] : [];
            let _2 = e.bw(o2.projMatrix);
            if (d2 && e.ah(c2.zoom) > 0) {
              const t3 = e.bg(o2.canonical, c2), i3 = e.e1(t3);
              _2 = e.az(new Float32Array(16), c2.globeMatrix, i3), e.az(_2, c2.projMatrix, _2);
            }
            const p3 = e.bz();
            p3[12] += 2 * r2 / (e.q.devicePixelRatio * c2.width), p3[13] += 2 * n2 / (e.q.devicePixelRatio * c2.height), e.az(_2, p3, _2);
            const f2 = t2.getOrCreateProgram("debug", { defines: u2 }), m2 = i2.getTileByID(o2.key);
            t2.terrain && t2.terrain.setupElevationDraw(m2, f2);
            const g2 = Ni.disabled, v2 = ji.disabled, y2 = t2.colorModeForRenderPass(), x2 = "$debug";
            l2.activeTexture.set(h3.TEXTURE0), t2.emptyTexture.bind(h3.LINEAR, h3.CLAMP_TO_EDGE), d2 ? m2._makeGlobeTileDebugBuffers(t2.context, c2) : m2._makeDebugTileBoundsBuffers(t2.context, c2.projection);
            const b2 = m2._tileDebugBuffer || t2.debugBuffer, w2 = m2._tileDebugIndexBuffer || t2.debugIndexBuffer, T2 = m2._tileDebugSegments || t2.debugSegments;
            if (f2.draw(t2, h3.LINE_STRIP, g2, v2, y2, qi.disabled, lr(_2, s2.toPremultipliedRenderColor(null)), x2, b2, w2, T2, null, null, null, [m2._globeTileDebugBorderBuffer]), a2) {
              const e2 = m2.latestRawTileData, i3 = Math.floor((e2 && e2.byteLength || 0) / 1024);
              let s3 = o2.canonical.toString();
              o2.overscaledZ !== o2.canonical.z && (s3 += ` => ${o2.overscaledZ}`), s3 += ` ${m2.state}`, s3 += ` ${i3}kb`, function(e3, t3) {
                e3.initDebugOverlayCanvas();
                const i4 = e3.debugOverlayCanvas, o3 = e3.context.gl, s4 = e3.debugOverlayCanvas.getContext("2d");
                s4.clearRect(0, 0, i4.width, i4.height), s4.shadowColor = "white", s4.shadowBlur = 2, s4.lineWidth = 1.5, s4.strokeStyle = "white", s4.textBaseline = "top", s4.font = "bold 36px Open Sans, sans-serif", s4.fillText(t3, 5, 5), s4.strokeText(t3, 5, 5), e3.debugOverlayTexture.update(i4), e3.debugOverlayTexture.bind(o3.LINEAR, o3.CLAMP_TO_EDGE);
              }(t2, s3);
            }
            const E2 = i2.getTile(o2).tileSize, S2 = 512 / Math.min(E2, 512) * (o2.overscaledZ / c2.zoom) * 0.5, I2 = m2._tileDebugTextBuffer || t2.debugBuffer, C2 = m2._tileDebugTextIndexBuffer || t2.quadTriangleIndexBuffer, R2 = m2._tileDebugTextSegments || t2.debugSegments;
            f2.draw(t2, h3.TRIANGLES, g2, v2, ki.alphaBlended, qi.disabled, lr(_2, e.am.transparent.toPremultipliedRenderColor(null), S2), x2, I2, C2, R2, null, null, null, [m2._globeTileDebugTextBuffer]);
          }
          function un(e2, t2, i2, o2) {
            pn(e2, 0, t2 + i2 / 2, e2.transform.width, i2, o2);
          }
          function _n(e2, t2, i2, o2) {
            pn(e2, t2 - i2 / 2, 0, i2, e2.transform.height, o2);
          }
          function pn(t2, i2, o2, s2, r2, n2) {
            const a2 = t2.context, l2 = a2.gl;
            l2.enable(l2.SCISSOR_TEST), l2.scissor(i2 * e.q.devicePixelRatio, o2 * e.q.devicePixelRatio, s2 * e.q.devicePixelRatio, r2 * e.q.devicePixelRatio), a2.clear({ color: n2 }), l2.disable(l2.SCISSOR_TEST);
          }
          const fn = e.d_([{ name: "a_pos_3f", components: 3, type: "Float32" }]), { members: mn } = fn;
          function gn(e2, t2, i2, o2) {
            e2.emplaceBack(t2, i2, o2);
          }
          class vn {
            constructor(t2) {
              this.vertexArray = new e.e2(), this.indices = new e.a_(), gn(this.vertexArray, -1, -1, 1), gn(this.vertexArray, 1, -1, 1), gn(this.vertexArray, -1, 1, 1), gn(this.vertexArray, 1, 1, 1), gn(this.vertexArray, -1, -1, -1), gn(this.vertexArray, 1, -1, -1), gn(this.vertexArray, -1, 1, -1), gn(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t2.createVertexBuffer(this.vertexArray, mn), this.indexBuffer = t2.createIndexBuffer(this.indices), this.segment = e.bd.simpleSegment(0, 0, 36, 12);
            }
          }
          function yn(t2, i2, o2, s2, r2, n2) {
            const a2 = t2.context.gl, l2 = i2.paint.get("sky-atmosphere-color"), c2 = i2.paint.get("sky-atmosphere-halo-color"), h3 = i2.paint.get("sky-atmosphere-sun-intensity"), d2 = ((e2, t3, i3, o3, s3) => ({ u_matrix_3f: e2, u_sun_direction: t3, u_sun_intensity: i3, u_color_tint_r: [o3.r, o3.g, o3.b, o3.a], u_color_tint_m: [s3.r, s3.g, s3.b, s3.a], u_luminance: 5e-5 }))(e.e4(e.dx(), s2), r2, h3, l2.toPremultipliedRenderColor(null), c2.toPremultipliedRenderColor(null));
            a2.framebufferTexture2D(a2.FRAMEBUFFER, a2.COLOR_ATTACHMENT0, a2.TEXTURE_CUBE_MAP_POSITIVE_X + n2, i2.skyboxTexture, 0), o2.draw(t2, a2.TRIANGLES, Ni.disabled, ji.disabled, ki.unblended, qi.frontCW, d2, "skyboxCapture", i2.skyboxGeometry.vertexBuffer, i2.skyboxGeometry.indexBuffer, i2.skyboxGeometry.segment);
          }
          const xn = e.d_([{ type: "Float32", name: "a_pos", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }]);
          class bn {
            constructor(t2) {
              const i2 = new e.e5();
              i2.emplaceBack(-1, 1, 1, 0, 0), i2.emplaceBack(1, 1, 1, 1, 0), i2.emplaceBack(1, -1, 1, 1, 1), i2.emplaceBack(-1, -1, 1, 0, 1);
              const o2 = new e.a_();
              o2.emplaceBack(0, 1, 2), o2.emplaceBack(2, 3, 0), this.vertexBuffer = t2.createVertexBuffer(i2, xn.members), this.indexBuffer = t2.createIndexBuffer(o2), this.segments = e.bd.simpleSegment(0, 0, 4, 2);
            }
            destroy() {
              this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
          }
          const wn = e.d_([{ type: "Float32", name: "a_pos_3f", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }, { type: "Float32", name: "a_size_scale", components: 1 }, { type: "Float32", name: "a_fade_opacity", components: 1 }]);
          class Tn {
            constructor() {
              this.starsCount = 16e3, this.sizeMultiplier = 0.15, this.sizeRange = 100, this.intensityRange = 200;
            }
          }
          class En {
            constructor(t2) {
              this.colorModeAlphaBlendedWriteRGB = new ki([1, Bi, 1, Bi], e.am.transparent, [true, true, true, false]), this.colorModeWriteAlpha = new ki([1, 0, 1, 0], e.am.transparent, [false, false, false, true]), this.params = new Tn(), this.updateNeeded = true, t2.tp.registerParameter(this.params, ["Stars"], "starsCount", { min: 100, max: 16e3, step: 1 }, () => {
                this.updateNeeded = true;
              }), t2.tp.registerParameter(this.params, ["Stars"], "sizeMultiplier", { min: 0.01, max: 2, step: 0.01 }), t2.tp.registerParameter(this.params, ["Stars"], "sizeRange", { min: 0, max: 200, step: 1 }, () => {
                this.updateNeeded = true;
              }), t2.tp.registerParameter(this.params, ["Stars"], "intensityRange", { min: 0, max: 200, step: 1 }, () => {
                this.updateNeeded = true;
              });
            }
            update(t2) {
              const i2 = t2.context;
              if (!this.atmosphereBuffer || this.updateNeeded) {
                this.updateNeeded = false, this.atmosphereBuffer = new bn(i2);
                const t3 = this.params.sizeRange, o2 = this.params.intensityRange, s2 = function(t4) {
                  const i3 = e.e7(30), o3 = [];
                  for (let s3 = 0; s3 < t4; ++s3) {
                    const t5 = 2 * Math.PI * i3(), s4 = Math.acos(1 - 2 * i3()) - 0.5 * Math.PI;
                    o3.push(e.cS(Math.cos(s4) * Math.cos(t5), Math.cos(s4) * Math.sin(t5), Math.sin(s4)));
                  }
                  return o3;
                }(this.params.starsCount), r2 = e.e7(300), n2 = new e.e6(), a2 = new e.a_();
                let l2 = 0;
                for (let i3 = 0; i3 < s2.length; ++i3) {
                  const c2 = e.bY([], s2[i3], 200), h3 = Math.max(0, 1 + 0.01 * t3 * (1 * r2() - 0.5)), d2 = Math.max(0, 1 + 0.01 * o2 * (1 * r2() - 0.5));
                  n2.emplaceBack(c2[0], c2[1], c2[2], -1, -1, h3, d2), n2.emplaceBack(c2[0], c2[1], c2[2], 1, -1, h3, d2), n2.emplaceBack(c2[0], c2[1], c2[2], 1, 1, h3, d2), n2.emplaceBack(c2[0], c2[1], c2[2], -1, 1, h3, d2), a2.emplaceBack(l2 + 0, l2 + 1, l2 + 2), a2.emplaceBack(l2 + 0, l2 + 2, l2 + 3), l2 += 4;
                }
                this.starsVx = i2.createVertexBuffer(n2, wn.members), this.starsIdx = i2.createIndexBuffer(a2), this.starsSegments = e.bd.simpleSegment(0, 0, n2.length, a2.length);
              }
            }
            destroy() {
              this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
            }
            drawAtmosphereGlow(t2, i2) {
              const o2 = t2.context, s2 = o2.gl, r2 = t2.transform, n2 = new Ni(s2.LEQUAL, Ni.ReadOnly, [0, 1]), a2 = e.ah(r2.zoom), l2 = t2.style.getLut(i2.scope), c2 = "none" === i2.properties.get("color-use-theme"), h3 = i2.properties.get("color").toNonPremultipliedRenderColor(c2 ? null : l2).toArray01(), d2 = "none" === i2.properties.get("high-color-use-theme"), u2 = i2.properties.get("high-color").toNonPremultipliedRenderColor(d2 ? null : l2).toArray01(), _2 = "none" === i2.properties.get("space-color-use-theme"), p3 = i2.properties.get("space-color").toNonPremultipliedRenderColor(_2 ? null : l2).toArray01(), f2 = 5e-4, m2 = e.e8(i2.properties.get("horizon-blend"), 0, 1, f2, 0.25), g2 = e.dl(t2, o2, r2) && m2 === f2 ? r2.worldSize / (2 * Math.PI * 1.025) - 1 : r2.globeRadius, v2 = t2.frameCounter / 1e3 % 1, y2 = e.ae(r2.globeCenterInViewSpace), x2 = Math.sqrt(Math.pow(y2, 2) - Math.pow(g2, 2)), b2 = Math.acos(x2 / y2), w2 = (e2) => {
                const i3 = "globe" === r2.projection.name ? ["PROJECTION_GLOBE_VIEW", "FOG"] : ["FOG"];
                e2 && i3.push("ALPHA_PASS");
                const l3 = t2.getOrCreateProgram("globeAtmosphere", { defines: i3 }), c3 = /* @__PURE__ */ ((e3, t3, i4, o3, s3, r3, n3, a3, l4, c4, h4, d4) => ({ u_frustum_tl: e3, u_frustum_tr: t3, u_frustum_br: i4, u_frustum_bl: o3, u_horizon: s3, u_transition: r3, u_fadeout_range: n3, u_color: a3, u_high_color: l4, u_space_color: c4, u_temporal_offset: h4, u_horizon_angle: d4 }))(r2.frustumCorners.TL, r2.frustumCorners.TR, r2.frustumCorners.BR, r2.frustumCorners.BL, r2.frustumCorners.horizon, a2, m2, h3, u2, p3, v2, b2);
                t2.uploadCommonUniforms(o2, l3);
                const d3 = this.atmosphereBuffer;
                d3 && l3.draw(t2, s2.TRIANGLES, n2, ji.disabled, e2 ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, qi.backCW, c3, e2 ? "atmosphere_glow_alpha" : "atmosphere_glow", d3.vertexBuffer, d3.indexBuffer, d3.segments);
              };
              w2(false), w2(true);
            }
            drawStars(t2, i2) {
              const o2 = e.ay(i2.properties.get("star-intensity"), 0, 1);
              if (0 === o2) return;
              const s2 = t2.context, r2 = s2.gl, n2 = t2.transform, a2 = t2.getOrCreateProgram("stars"), l2 = e.b_([]);
              e.c0(l2, l2, -n2._pitch), e.b$(l2, l2, -n2.angle), e.c0(l2, l2, e.al(n2._center.lat)), e.e9(l2, l2, -e.al(n2._center.lng));
              const c2 = e.c3(new Float32Array(16), l2), h3 = e.az([], n2.starsProjMatrix, c2), d2 = e.e4([], c2), u2 = e.ea([], d2), _2 = [0, 1, 0];
              e.dz(_2, _2, u2), e.bY(_2, _2, this.params.sizeMultiplier);
              const p3 = [1, 0, 0];
              e.dz(p3, p3, u2), e.bY(p3, p3, this.params.sizeMultiplier);
              const f2 = (m2 = _2, g2 = p3, v2 = o2, { u_matrix: Float32Array.from(h3), u_up: m2, u_right: g2, u_intensity_multiplier: v2 });
              var m2, g2, v2;
              t2.uploadCommonUniforms(s2, a2), this.starsVx && this.starsIdx && a2.draw(t2, r2.TRIANGLES, Ni.disabled, ji.disabled, this.colorModeAlphaBlendedWriteRGB, qi.disabled, f2, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
          }
          function Sn(t2, i2) {
            const o2 = [...t2], s2 = i2.cameraWorldSizeForFog / i2.worldSize, r2 = e.bx([]);
            return e.cE(r2, r2, [s2, s2, 1]), e.az(o2, r2, o2), e.az(o2, i2.worldToFogMatrix, o2), o2;
          }
          function In(t2, i2, o2, s2, r2) {
            const n2 = o2.material, a2 = s2.context, { baseColorTexture: l2, metallicRoughnessTexture: c2 } = n2.pbrMetallicRoughness, { normalTexture: h3, occlusionTexture: d2, emissionTexture: u2 } = n2;
            function _2(e2, i3, o3) {
              if (e2 && (t2.push(i3), a2.activeTexture.set(a2.gl.TEXTURE0 + o3), e2.gfxTexture)) {
                const { minFilter: t3, magFilter: i4, wrapS: o4, wrapT: s3 } = e2.sampler;
                e2.gfxTexture.bindExtraParam(t3, i4, o4, s3);
              }
            }
            _2(l2, "HAS_TEXTURE_u_baseColorTexture", Yi.BaseColor), _2(c2, "HAS_TEXTURE_u_metallicRoughnessTexture", Yi.MetallicRoughness), _2(h3, "HAS_TEXTURE_u_normalTexture", Yi.Normal), _2(d2, "HAS_TEXTURE_u_occlusionTexture", Yi.Occlusion), _2(u2, "HAS_TEXTURE_u_emissionTexture", Yi.Emission), r2 && (r2.texture || (r2.texture = new e.eh(s2.context, r2.image, [r2.image.height, r2.image.height, r2.image.height], a2.gl.RGBA8)), a2.activeTexture.set(a2.gl.TEXTURE0 + Yi.LUT), r2.texture && r2.texture.bind(a2.gl.LINEAR, a2.gl.CLAMP_TO_EDGE), t2.push("APPLY_LUT_ON_GPU")), o2.texcoordBuffer && (t2.push("HAS_ATTRIBUTE_a_uv_2f"), i2.push(o2.texcoordBuffer)), o2.colorBuffer && (t2.push(12 === o2.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), i2.push(o2.colorBuffer)), o2.normalBuffer && (t2.push("HAS_ATTRIBUTE_a_normal_3f"), i2.push(o2.normalBuffer)), o2.pbrBuffer && (t2.push("HAS_ATTRIBUTE_a_pbr"), t2.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), i2.push(o2.pbrBuffer)), "OPAQUE" !== n2.alphaMode && "MASK" !== n2.alphaMode || t2.push("UNPREMULT_TEXTURE_IN_SHADER"), n2.defined || t2.push("DIFFUSE_SHADED");
            const p3 = s2.shadowRenderer;
            p3 && (t2.push("RENDER_SHADOWS", "DEPTH_TEXTURE"), p3.useNormalOffset && t2.push("NORMAL_OFFSET"));
          }
          function Cn(t2, i2, o2, s2, r2, n2) {
            const a2 = o2.paint.get("model-opacity").constantOr(1), l2 = i2.context, c2 = new Ni(i2.context.gl.LEQUAL, Ni.ReadWrite, i2.depthRangeFor3D), h3 = i2.transform, d2 = t2.mesh, u2 = d2.material, _2 = u2.pbrMetallicRoughness, p3 = i2.style.fog;
            let f2;
            f2 = "pixels" === i2.transform.projection.zAxisUnit ? [...t2.nodeModelMatrix] : e.az([], s2.zScaleMatrix, t2.nodeModelMatrix), e.az(f2, s2.negCameraPosMatrix, f2);
            const m2 = e.bi([], f2);
            e.ee(m2, m2);
            const g2 = "none" === o2.paint.get("model-color-use-theme").constantOr("default"), v2 = o2.paint.get("model-emissive-strength").constantOr(0), y2 = Er(new Float32Array(t2.worldViewProjection), new Float32Array(f2), new Float32Array(m2), null, i2, a2, _2.baseColorFactor, u2.emissiveFactor, _2.metallicFactor, _2.roughnessFactor, u2, v2, o2), x2 = { defines: [] }, b2 = [], w2 = i2.shadowRenderer;
            w2 && (w2.useNormalOffset = false), In(x2.defines, b2, d2, i2, g2 ? null : o2.lut);
            let T2 = null;
            if (p3) {
              const e2 = Sn(t2.nodeModelMatrix, i2.transform);
              if (T2 = new Float32Array(e2), "globe" !== h3.projection.name) {
                const t3 = d2.aabb.min, i3 = d2.aabb.max, [o3, s3] = p3.getOpacityForBounds(e2, t3[0], t3[1], i3[0], i3[1]);
                x2.overrideFog = o3 >= Fe || s3 >= Fe;
              }
            }
            const E2 = eo(i2, o2.paint.get("model-cutoff-fade-range"));
            E2.shouldRenderCutoff && x2.defines.push("RENDER_CUTOFF");
            const S2 = i2.getOrCreateProgram("model", x2);
            i2.uploadCommonUniforms(l2, S2, null, T2, E2), "shadow" !== i2.renderPass && w2 && w2.setupShadowsFromMatrix(t2.nodeModelMatrix, S2), S2.draw(i2, l2.gl.TRIANGLES, c2, r2, n2, d2.material.doubleSided ? qi.disabled : qi.backCCW, y2, o2.id, d2.vertexBuffer, d2.indexBuffer, d2.segments, o2.paint, i2.transform.zoom, void 0, b2);
          }
          function Rn(t2, i2, o2, s2, r2, n2, a2) {
            let l2;
            l2 = "globe" === t2.projection.name ? e.ed(o2, t2) : [...o2], e.az(l2, l2, i2.matrix);
            const c2 = e.az([], s2, l2);
            if (i2.meshes) for (const o3 of i2.meshes) {
              if ("BLEND" !== o3.material.alphaMode) {
                a2.push({ mesh: o3, depth: 0, modelIndex: r2, worldViewProjection: c2, nodeModelMatrix: l2 });
                continue;
              }
              const i3 = e.ad([], o3.centroid, c2);
              !t2.isOrthographic && i3[2] <= 0 || n2.push({ mesh: o3, depth: i3[2], modelIndex: r2, worldViewProjection: c2, nodeModelMatrix: l2 });
            }
            if (i2.children) for (const e2 of i2.children) Rn(t2, e2, o2, s2, r2, n2, a2);
          }
          function Dn(e2, t2, i2, o2) {
            const s2 = i2.shadowRenderer;
            if (!s2) return;
            const r2 = s2.getShadowPassDepthMode(), n2 = s2.getShadowPassColorMode(), a2 = s2.calculateShadowPassMatrixFromMatrix(t2), l2 = Sr(a2);
            i2.getOrCreateProgram("modelDepth", { defines: i2._shadowMapDebug ? [] : ["DEPTH_TEXTURE"] }).draw(i2, i2.context.gl.TRIANGLES, r2, ji.disabled, n2, qi.backCCW, l2, o2.id, e2.vertexBuffer, e2.indexBuffer, e2.segments, o2.paint, i2.transform.zoom, void 0, void 0);
          }
          function An(t2, i2, o2) {
            const s2 = i2.updateZoomBasedPaintProperties(), r2 = function(t3, i3, o3) {
              let s3, r3, n2, a2 = t3.terrain ? t3.terrain.exaggeration() : 0;
              if (t3.terrain && a2 > 0) {
                const i4 = t3.terrain, r4 = i4.findDEMTileFor(o3);
                r4 && r4.dem ? s3 = e.ei.create(i4, o3, r4) : a2 = 0;
              }
              if (0 === a2 && (i3.terrainElevationMin = 0, i3.terrainElevationMax = 0), a2 === i3.validForExaggeration && (0 === a2 || s3 && s3._demTile && s3._demTile.tileID === i3.validForDEMTile.id && s3._dem._timestamp === i3.validForDEMTile.timestamp)) return false;
              for (const e2 in i3.instancesPerModel) {
                const t4 = i3.instancesPerModel[e2];
                for (let e3 = 0; e3 < t4.instancedDataArray.length; ++e3) {
                  const o4 = (s3 ? a2 * s3.getElevationAt(0 | t4.instancedDataArray.float32[16 * e3], 0 | t4.instancedDataArray.float32[16 * e3 + 1], true, true) : 0) + t4.instancesEvaluatedElevation[e3];
                  t4.instancedDataArray.float32[16 * e3 + 6] = o4, r3 = r3 ? Math.min(i3.terrainElevationMin, o4) : o4, n2 = n2 ? Math.max(i3.terrainElevationMax, o4) : o4;
                }
              }
              return i3.terrainElevationMin = r3 || 0, i3.terrainElevationMax = n2 || 0, i3.validForExaggeration = a2, i3.validForDEMTile = s3 && s3._demTile ? { id: s3._demTile.tileID, timestamp: s3._dem._timestamp } : { id: void 0, timestamp: 0 }, true;
            }(t2, i2, o2);
            (s2 || r2) && (i2.uploaded = false, i2.upload(t2.context));
          }
          const Ln = { shadowUniformsInitialized: false, useSingleShadowCascade: false, tileMatrix: new Float64Array(16), shadowTileMatrix: new Float32Array(16), aabb: new e.cW([0, 0, 0], [e.aj, e.aj, 0]) };
          function Pn(t2, i2) {
            const o2 = 1 << t2.canonical.z, s2 = i2.getFreeCameraOptions().position, r2 = i2.elevation, n2 = t2.canonical.x / o2, a2 = (t2.canonical.x + 1) / o2, l2 = t2.canonical.y / o2, c2 = (t2.canonical.y + 1) / o2;
            let h3 = i2._centerAltitude;
            if (r2) {
              const e2 = r2.getMinMaxForTile(t2);
              e2 && e2.max > h3 && (h3 = e2.max);
            }
            const d2 = e.ay(s2.x, n2, a2) - s2.x, u2 = e.ay(s2.y, l2, c2) - s2.y, _2 = e.c6(h3, i2.center.lat) - s2.z;
            return i2._zoomFromMercatorZ(Math.sqrt(d2 * d2 + u2 * u2 + _2 * _2));
          }
          function zn(e2, t2, i2, o2, s2, r2, n2) {
            const a2 = e2.context, l2 = "shadow" === e2.renderPass, c2 = e2.shadowRenderer, h3 = l2 && c2 ? c2.getShadowPassDepthMode() : new Ni(a2.gl.LEQUAL, Ni.ReadWrite, e2.depthRangeFor3D), d2 = e2.isTileAffectedByFog(r2);
            if (i2.meshes) for (const u2 of i2.meshes) {
              const _2 = ["MODEL_POSITION_ON_GPU"], p3 = [];
              let f2, m2, g2;
              o2.instancedDataArray.length > 20 && _2.push("INSTANCED_ARRAYS");
              const v2 = eo(e2, t2.paint.get("model-cutoff-fade-range"));
              if (v2.shouldRenderCutoff && _2.push("RENDER_CUTOFF"), l2 && c2) f2 = e2.getOrCreateProgram("modelDepth", { defines: _2 }), m2 = Sr(n2.shadowTileMatrix, n2.shadowTileMatrix, Float32Array.from(i2.matrix)), g2 = c2.getShadowPassColorMode();
              else {
                In(_2, p3, u2, e2, "none" === t2.paint.get("model-color-use-theme").constantOr("default") ? null : t2.lut), f2 = e2.getOrCreateProgram("model", { defines: _2, overrideFog: d2 });
                const o3 = u2.material, l3 = o3.pbrMetallicRoughness, h4 = t2.paint.get("model-opacity").constantOr(1), y3 = t2.paint.get("model-emissive-strength").constantOr(0);
                m2 = Er(r2.expandedProjMatrix, Float32Array.from(i2.matrix), new Float32Array(16), null, e2, h4, l3.baseColorFactor, o3.emissiveFactor, l3.metallicFactor, l3.roughnessFactor, o3, y3, t2, s2), c2 && (n2.shadowUniformsInitialized ? f2.setShadowUniformValues(a2, c2.getShadowUniformValues()) : (c2.setupShadows(r2.toUnwrapped(), f2, "model-tile", r2.overscaledZ), n2.shadowUniformsInitialized = true)), g2 = v2.shouldRenderCutoff || h4 < 1 || "OPAQUE" !== o3.alphaMode ? ki.alphaBlended : ki.unblended;
              }
              e2.uploadCommonUniforms(a2, f2, r2.toUnwrapped(), null, v2);
              const y2 = u2.material.doubleSided ? qi.disabled : qi.backCCW;
              if (o2.instancedDataArray.length > 20) p3.push(o2.instancedDataBuffer), f2.draw(e2, a2.gl.TRIANGLES, h3, ji.disabled, g2, y2, m2, t2.id, u2.vertexBuffer, u2.indexBuffer, u2.segments, t2.paint, e2.transform.zoom, void 0, p3, o2.instancedDataArray.length);
              else {
                const i3 = l2 ? "u_instance" : "u_normal_matrix";
                for (let s3 = 0; s3 < o2.instancedDataArray.length; ++s3) m2[i3] = new Float32Array(o2.instancedDataArray.arrayBuffer, 64 * s3, 16), f2.draw(e2, a2.gl.TRIANGLES, h3, ji.disabled, g2, y2, m2, t2.id, u2.vertexBuffer, u2.indexBuffer, u2.segments, t2.paint, e2.transform.zoom, void 0, p3);
              }
            }
            if (i2.children) for (const a3 of i2.children) zn(e2, t2, a3, o2, s2, r2, n2);
          }
          const Mn = [1, -1, 1];
          function On(t2, i2, o2, s2) {
            if (!o2.modelManager) return true;
            const r2 = o2.modelManager;
            if (!o2.shadowRenderer) return true;
            const n2 = o2.shadowRenderer, a2 = i2.aabb;
            let l2 = true, c2 = t2.maxHeight;
            if (0 === c2) {
              let e2 = 0;
              for (const i3 in t2.instancesPerModel) {
                const t3 = r2.getModel(i3, s2);
                t3 ? e2 = Math.max(e2, Math.max(Math.max(t3.aabb.max[0], t3.aabb.max[1]), t3.aabb.max[2])) : l2 = false;
              }
              c2 = t2.maxScale * e2 * 1.41 + t2.maxVerticalOffset, l2 && (t2.maxHeight = c2);
            }
            a2.max[2] = c2, a2.min[2] += t2.terrainElevationMin, a2.max[2] += t2.terrainElevationMax, e.ad(a2.min, a2.min, i2.tileMatrix), e.ad(a2.max, a2.max, i2.tileMatrix);
            const h3 = a2.intersects(n2.getCurrentCascadeFrustum());
            return 0 === o2.currentShadowCascade && (t2.isInsideFirstShadowMapFrustum = 2 === h3), 0 === h3;
          }
          function Fn(t2, i2) {
            const o2 = t2.uniformValues.u_cutoff_params[0], s2 = t2.uniformValues.u_cutoff_params[1], r2 = t2.uniformValues.u_cutoff_params[2], n2 = t2.uniformValues.u_cutoff_params[3];
            return s2 === o2 || n2 === r2 ? 1 : e.ay(((i2 - o2) / (s2 - o2) - r2) / (n2 - r2), 0, 1);
          }
          function Bn(t2, i2, o2, s2) {
            if (i2.pitch < 20) return 1;
            const r2 = i2.getWorldToCameraMatrix();
            e.az(r2, r2, t2);
            const n2 = e.ej(o2.min[0], o2.min[1], o2.min[2], 1);
            let a2 = e.aA(e.ek(), n2, r2), l2 = a2, c2 = a2;
            n2[1] = o2.max[1], a2 = e.aA(e.ek(), n2, r2), l2 = a2[1] < l2[1] ? a2 : l2, c2 = a2[1] > c2[1] ? a2 : c2, n2[0] = o2.max[0], a2 = e.aA(e.ek(), n2, r2), l2 = a2[1] < l2[1] ? a2 : l2, c2 = a2[1] > c2[1] ? a2 : c2, n2[1] = o2.min[1], a2 = e.aA(e.ek(), n2, r2), l2 = a2[1] < l2[1] ? a2 : l2, c2 = a2[1] > c2[1] ? a2 : c2;
            const h3 = e.ay(s2[0], 0, 1), d2 = 100 * i2.pixelsPerMeter * e.ay(s2[1], 0, 1), u2 = e.ay(s2[2], 0, 1), _2 = e.el(e.ek(), l2, c2, h3), p3 = Math.tan(0.5 * i2.fovX), f2 = -_2[2] * p3;
            if (0 === d2) return _2[1] < -Math.abs(f2) ? u2 : 1;
            const m2 = (-Math.abs(f2) - _2[1]) / d2, g2 = (e2, t3, i3) => (1 - i3) * e2 + i3 * t3, v2 = e.ay(g2(1, u2, m2), u2, 1);
            return g2(1, v2, e.ay((i2.pitch - 20) / 20, 0, 1));
          }
          class kn {
          }
          class Nn {
            constructor() {
              this._storage = /* @__PURE__ */ new Map();
            }
            getLinesFromTrianglesBuffer(t2, i2, o2) {
              {
                const e2 = this._storage.get(i2.id);
                if (e2) return e2.lastUsedFrameIdx = t2, e2.buf;
              }
              const s2 = o2.gl, r2 = s2.getBufferParameter(s2.ELEMENT_ARRAY_BUFFER, s2.BUFFER_SIZE), n2 = new ArrayBuffer(r2), a2 = new Int16Array(n2);
              s2.getBufferSubData(s2.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(n2));
              const l2 = new e.en();
              for (let e2 = 0; e2 < r2 / 2; e2 += 3) {
                const t3 = a2[e2], i3 = a2[e2 + 1], o3 = a2[e2 + 2];
                l2.emplaceBack(t3, i3), l2.emplaceBack(i3, o3), l2.emplaceBack(o3, t3);
              }
              const c2 = o2.bindVertexArrayOES.current, h3 = new kn();
              return h3.buf = new Cr(o2, l2), h3.lastUsedFrameIdx = t2, this._storage.set(i2.id, h3), o2.bindVertexArrayOES.set(c2), h3.buf;
            }
            update(e2) {
              for (const [t2, i2] of this._storage) e2 - i2.lastUsedFrameIdx > 30 && (i2.buf.destroy(), this._storage.delete(t2));
            }
            destroy() {
              for (const [e2, t2] of this._storage) t2.buf.destroy(), this._storage.delete(e2);
            }
          }
          class Un {
            constructor(e2) {
              this.occluderSize = 30, this.depthOffset = -1e-4, e2.registerParameter(this, ["Occlusion"], "occluderSize", { min: 1, max: 100, step: 1 }), e2.registerParameter(this, ["Occlusion"], "depthOffset", { min: -0.05, max: 0, step: 1e-5 });
            }
          }
          const jn = e.d_([{ type: "Float32", name: "a_pos_3f", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }, { type: "Float32", name: "a_rainParticleData", components: 4 }]);
          class Vn {
            registerParameter() {
            }
            registerButton() {
            }
            registerBinding() {
            }
            refreshUI() {
            }
          }
          class Gn {
            constructor(e2, t2) {
              this.revealStart = 11, this.revealRange = 2, e2.registerParameter(this, [...t2, "Reveal"], "revealStart", { min: 0, max: 17, step: 0.05 }), e2.registerParameter(this, [...t2, "Reveal"], "revealRange", { min: 0.1, max: 5.1, step: 0.05 });
            }
          }
          const qn = e.d_([{ type: "Float32", name: "a_pos_2f", components: 2 }]);
          class Zn {
            destroy() {
              this.vignetteVx && this.vignetteVx.destroy(), this.vignetteIdx && this.vignetteIdx.destroy();
            }
            draw(t2, i2) {
              const o2 = t2.getOrCreateProgram("vignette");
              if (!this.vignetteVx || !this.vignetteIdx) {
                const i3 = new e.eo(), o3 = new e.a_();
                i3.emplaceBack(-1, -1), i3.emplaceBack(1, -1), i3.emplaceBack(1, 1), i3.emplaceBack(-1, 1), o3.emplaceBack(0, 1, 2), o3.emplaceBack(0, 2, 3), this.vignetteVx = t2.context.createVertexBuffer(i3, qn.members), this.vignetteIdx = t2.context.createIndexBuffer(o3);
              }
              const s2 = e.bd.simpleSegment(0, 0, 4, 6);
              if (this.vignetteVx && this.vignetteIdx) {
                t2.uploadCommonUniforms(t2.context, o2);
                const e2 = { u_vignetteShape: (r2 = { vignetteShape: [i2.start, i2.range, Math.pow(10, i2.fadePower)], vignetteColor: [i2.color.r, i2.color.g, i2.color.b, i2.color.a * i2.strength] }).vignetteShape, u_vignetteColor: r2.vignetteColor };
                o2.draw(t2, t2.context.gl.TRIANGLES, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, e2, "vignette", this.vignetteVx, this.vignetteIdx, s2);
              }
              var r2;
            }
          }
          class Hn {
            constructor() {
              this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
            }
            update(t2, i2) {
              const o2 = t2.getFreeCameraOptions().position, s2 = o2.toAltitude(), r2 = o2.toLngLat(), n2 = e.al(r2.lng), a2 = e.al(r2.lat), l2 = t2.pixelsPerMeter / i2, c2 = n2 * e.eq, h3 = e.eq * Math.log(Math.tan(Math.PI / 4 + a2 / 2));
              if (void 0 === this._offsetXPrev) this._offsetXPrev = 0, this._offsetYPrev = 0, this._elevationPrev = 0, this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
              else {
                const e2 = -this._offsetYPrev + h3, t3 = -this._elevationPrev + s2;
                this._accumulatedOffsetX += (-this._offsetXPrev + c2) * l2, this._accumulatedOffsetY += e2 * l2, this._accumulatedElevation += t3 * l2, this._offsetXPrev = c2, this._offsetYPrev = h3, this._elevationPrev = s2;
              }
            }
            getPosition() {
              return [this._accumulatedOffsetX, this._accumulatedOffsetY, this._accumulatedElevation];
            }
          }
          function Wn(e2, t2) {
            return [-(e2[0] - Math.floor(e2[0] / t2) * t2), -(e2[1] - Math.floor(e2[1] / t2) * t2), -(e2[2] - Math.floor(e2[2] / t2) * t2)];
          }
          function $n(t2) {
            const i2 = e.e7(1323123451230), o2 = [];
            for (let s2 = 0; s2 < t2; ++s2) {
              const t3 = 2 * i2() - 1, s3 = 2 * i2() - 1, r2 = 2 * i2() - 1;
              o2.push(e.cS(t3, s3, r2));
            }
            return o2;
          }
          function Xn(t2, i2, o2, s2, r2) {
            const n2 = e.ay((r2 - o2) / (s2 - o2), 0, 1);
            return (1 - n2) * t2 + n2 * i2;
          }
          class Yn {
            constructor(e2) {
              this._movement = new Hn(), this._accumulatedTimeFromStart = 0, this._prevTime = Date.now() / 1e3, this._vignette = new Zn(), this._ppmScaleFactor = e2;
            }
            destroy() {
              this.particlesVx && this.particlesVx.destroy(), this.particlesIdx && this.particlesIdx.destroy(), this._vignette && this._vignette.destroy();
            }
            updateOnRender(t2, i2) {
              const o2 = t2.transform;
              this._movement.update(o2, this._ppmScaleFactor);
              const s2 = o2.starsProjMatrix, r2 = e.b_([]);
              e.c0(r2, r2, e.al(90) - o2._pitch), e.b$(r2, r2, -o2.angle);
              const n2 = e.c3(new Float32Array(16), r2), a2 = e.ep(1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1), l2 = e.ee([], a2), c2 = e.az([], l2, n2), h3 = Date.now() / 1e3;
              return this._accumulatedTimeFromStart += (h3 - this._prevTime) * i2, this._prevTime = h3, { projectionMatrix: s2, modelviewMatrix: c2 };
            }
          }
          class Kn extends Yn {
            constructor(e2) {
              super(4.25), this._params = { overrideStyleParameters: false, intensity: 0.5, timeFactor: 1, velocityConeAperture: 0, velocity: 300, boxSize: 2500, dropletSizeX: 1, dropletSizeYScale: 10, distortionStrength: 70, screenThinning: { intensity: 0.57, start: 0.46, range: 1.17, fadePower: 0.17, affectedRatio: 1, particleOffset: -0.2 }, color: { r: 0.66, g: 0.68, b: 0.74, a: 0.7 }, direction: { x: -50, y: -35 }, shapeDirPower: 2, shapeNormalPower: 1 }, this._revealParams = new Gn(e2.tp, ["Precipitation", "Rain"]), this._vignetteParams = { strength: 1, start: 0.7, range: 1, fadePower: 0.4, color: { r: 0.27, g: 0.27, b: 0.27, a: 1 } }, this.particlesCount = 16e3;
            }
            update(t2) {
              const i2 = t2.context;
              if (!this.particlesVx) {
                const t3 = $n(this.particlesCount), o2 = new e.er(), s2 = new e.a_();
                let r2 = 0;
                const n2 = e.e7(1323123451230);
                for (let e2 = 0; e2 < t3.length; ++e2) {
                  const i3 = t3[e2], a2 = [2 * n2() - 1, n2(), n2(), n2()];
                  o2.emplaceBack(i3[0], i3[1], i3[2], -1, -1, ...a2), o2.emplaceBack(i3[0], i3[1], i3[2], 1, -1, ...a2), o2.emplaceBack(i3[0], i3[1], i3[2], 1, 1, ...a2), o2.emplaceBack(i3[0], i3[1], i3[2], -1, 1, ...a2), s2.emplaceBack(r2 + 0, r2 + 1, r2 + 2), s2.emplaceBack(r2 + 0, r2 + 2, r2 + 3), r2 += 4;
                }
                this.particlesVx = i2.createVertexBuffer(o2, jn.members), this.particlesIdx = i2.createIndexBuffer(s2);
              }
            }
            draw(t2) {
              if (!this._params.overrideStyleParameters && !t2.style.rain) return;
              const i2 = this._params.overrideStyleParameters ? this._revealParams : { revealStart: 0, revealRange: 0.01 }, o2 = t2.transform.zoom;
              if (i2.revealStart > o2) return;
              const s2 = Xn(0, 1, i2.revealStart, i2.revealStart + i2.revealRange, o2);
              if (!this.particlesVx || !this.particlesIdx) return;
              const r2 = structuredClone(this._params);
              let n2 = [-r2.direction.x, r2.direction.y, -100];
              e.au(n2, n2);
              const a2 = structuredClone(this._vignetteParams);
              a2.strength *= s2, r2.overrideStyleParameters || (r2.intensity = t2.style.rain.state.density, r2.timeFactor = t2.style.rain.state.intensity, r2.color = structuredClone(t2.style.rain.state.color), n2 = structuredClone(t2.style.rain.state.direction), r2.screenThinning.intensity = t2.style.rain.state.centerThinning, r2.dropletSizeX = t2.style.rain.state.dropletSize[0], r2.dropletSizeYScale = t2.style.rain.state.dropletSize[1] / t2.style.rain.state.dropletSize[0], r2.distortionStrength = 100 * t2.style.rain.state.distortionStrength, a2.strength = 1, a2.color = structuredClone(t2.style.rain.state.vignetteColor));
              const l2 = this.updateOnRender(t2, r2.timeFactor), c2 = t2.context, h3 = c2.gl, d2 = t2.transform;
              this.screenTexture && this.screenTexture.size[0] === t2.width && this.screenTexture.size[1] === t2.height || (this.screenTexture = new e.T(c2, { width: t2.width, height: t2.height, data: null }, h3.RGBA8)), r2.distortionStrength > 0 && (c2.activeTexture.set(h3.TEXTURE0), this.screenTexture.bind(h3.LINEAR, h3.CLAMP_TO_EDGE), h3.copyTexSubImage2D(h3.TEXTURE_2D, 0, 0, 0, 0, 0, t2.width, t2.height));
              const u2 = t2.getOrCreateProgram("rainParticle");
              t2.uploadCommonUniforms(c2, u2), c2.activeTexture.set(h3.TEXTURE0), this.screenTexture.bind(h3.LINEAR, h3.CLAMP_TO_EDGE);
              const _2 = [r2.color.r, r2.color.g, r2.color.b, r2.color.a], p3 = (i3, o3) => {
                const s3 = Wn(this._movement.getPosition(), i3), a3 = r2.dropletSizeX, c3 = r2.dropletSizeX * r2.dropletSizeYScale, p4 = t2.width / 2, f2 = t2.height / 2, m2 = Xn(0, r2.screenThinning.start, 0, 1, r2.screenThinning.intensity), g2 = Xn(1e-3, r2.screenThinning.range, 0, 1, r2.screenThinning.intensity), v2 = Xn(0, r2.screenThinning.particleOffset, 0, 1, r2.screenThinning.intensity), y2 = (x2 = { modelview: l2.modelviewMatrix, projection: l2.projectionMatrix, time: this._accumulatedTimeFromStart, camPos: s3, velocityConeAperture: r2.velocityConeAperture, velocity: r2.velocity, boxSize: i3, rainDropletSize: [a3, c3], distortionStrength: r2.distortionStrength, rainDirection: n2, color: _2, screenSize: [d2.width, d2.height], thinningCenterPos: [p4, f2], thinningShape: [m2, g2, Math.pow(10, r2.screenThinning.fadePower)], thinningAffectedRatio: r2.screenThinning.affectedRatio, thinningParticleOffset: v2, shapeDirectionalPower: r2.shapeDirPower, shapeNormalPower: r2.shapeNormalPower, mode: o3 ? 0 : 1 }, { u_modelview: Float32Array.from(x2.modelview), u_projection: Float32Array.from(x2.projection), u_time: x2.time, u_cam_pos: x2.camPos, u_texScreen: 0, u_velocityConeAperture: x2.velocityConeAperture, u_velocity: x2.velocity, u_boxSize: x2.boxSize, u_rainDropletSize: x2.rainDropletSize, u_distortionStrength: x2.distortionStrength, u_rainDirection: x2.rainDirection, u_color: x2.color, u_screenSize: x2.screenSize, u_thinningCenterPos: x2.thinningCenterPos, u_thinningShape: x2.thinningShape, u_thinningAffectedRatio: x2.thinningAffectedRatio, u_thinningParticleOffset: x2.thinningParticleOffset, u_shapeDirectionalPower: x2.shapeDirectionalPower, u_shapeNormalPower: x2.shapeNormalPower, u_mode: x2.mode });
                var x2;
                const b2 = Math.round(r2.intensity * this.particlesCount), w2 = e.bd.simpleSegment(0, 0, 4 * b2, 2 * b2);
                u2.draw(t2, h3.TRIANGLES, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, y2, "rain_particles", this.particlesVx, this.particlesIdx, w2);
              };
              r2.distortionStrength > 0 && p3(r2.boxSize, true), p3(r2.boxSize, false), this._vignette.draw(t2, a2);
            }
          }
          const Jn = e.d_([{ type: "Float32", name: "a_pos_3f", components: 3 }, { type: "Float32", name: "a_uv", components: 2 }, { type: "Float32", name: "a_snowParticleData", components: 4 }, { type: "Float32", name: "a_snowParticleDataHorizontalOscillation", components: 2 }]);
          class Qn extends Yn {
            constructor(e2) {
              super(2.25), this._params = { overrideStyleParameters: false, intensity: 0.85, timeFactor: 0.75, velocityConeAperture: 70, velocity: 40, horizontalOscillationRadius: 4, horizontalOscillationRate: 1.5, boxSize: 2e3, billboardSize: 2, shapeFadeStart: 0.27, shapeFadePower: 0.21, screenThinning: { intensity: 0.4, start: 0.15, range: 1.4, fadePower: 0.24, affectedRatio: 1, particleOffset: -0.2 }, color: { r: 1, g: 1, b: 1, a: 1 }, direction: { x: -50, y: -35 } }, this._revealParams = new Gn(e2.tp, ["Precipitation", "Snow"]), this._vignetteParams = { strength: 0.3, start: 0.78, range: 0.46, fadePower: 0.2, color: { r: 1, g: 1, b: 1, a: 1 } }, this.particlesCount = 16e3;
            }
            update(t2) {
              const i2 = t2.context;
              if (!this.particlesVx) {
                const t3 = $n(this.particlesCount), o2 = new e.es(), s2 = new e.a_();
                let r2 = 0;
                const n2 = e.e7(1323123451230);
                for (let e2 = 0; e2 < t3.length; ++e2) {
                  const i3 = t3[e2], a2 = n2(), l2 = n2(), c2 = n2(), h3 = [e2 / t3.length, a2, l2, c2], d2 = [n2(), n2()];
                  o2.emplaceBack(i3[0], i3[1], i3[2], -1, -1, ...h3, ...d2), o2.emplaceBack(i3[0], i3[1], i3[2], 1, -1, ...h3, ...d2), o2.emplaceBack(i3[0], i3[1], i3[2], 1, 1, ...h3, ...d2), o2.emplaceBack(i3[0], i3[1], i3[2], -1, 1, ...h3, ...d2), s2.emplaceBack(r2 + 0, r2 + 1, r2 + 2), s2.emplaceBack(r2 + 0, r2 + 2, r2 + 3), r2 += 4;
                }
                this.particlesVx = i2.createVertexBuffer(o2, Jn.members), this.particlesIdx = i2.createIndexBuffer(s2);
              }
            }
            draw(t2) {
              if (!this._params.overrideStyleParameters && !t2.style.snow) return;
              const i2 = structuredClone(this._params);
              let o2 = [-i2.direction.x, i2.direction.y, -100];
              e.au(o2, o2);
              const s2 = structuredClone(this._vignetteParams), r2 = i2.overrideStyleParameters ? this._revealParams : { revealStart: 0, revealRange: 0.01 }, n2 = t2.transform.zoom;
              if (r2.revealStart > n2) return;
              const a2 = Xn(0, 1, r2.revealStart, r2.revealStart + r2.revealRange, n2);
              s2.strength *= a2, i2.overrideStyleParameters || (i2.intensity = t2.style.snow.state.density, i2.timeFactor = t2.style.snow.state.intensity, i2.color = structuredClone(t2.style.snow.state.color), o2 = structuredClone(t2.style.snow.state.direction), i2.screenThinning.intensity = t2.style.snow.state.centerThinning, i2.billboardSize = 2.79 * t2.style.snow.state.flakeSize, s2.strength = 1, s2.color = structuredClone(t2.style.snow.state.vignetteColor));
              const l2 = this.updateOnRender(t2, i2.timeFactor);
              if (!this.particlesVx || !this.particlesIdx) return;
              const c2 = t2.context, h3 = c2.gl, d2 = t2.transform, u2 = t2.getOrCreateProgram("snowParticle");
              t2.uploadCommonUniforms(c2, u2), ((i3, s3, r3) => {
                const n3 = Wn(this._movement.getPosition(), i3), a3 = d2.width / 2, c3 = d2.height / 2, _2 = Xn(0, r3.screenThinning.start, 0, 1, r3.screenThinning.intensity), p3 = Xn(1e-3, r3.screenThinning.range, 0, 1, r3.screenThinning.intensity), f2 = Xn(0, r3.screenThinning.particleOffset, 0, 1, r3.screenThinning.intensity), m2 = (g2 = { modelview: l2.modelviewMatrix, projection: l2.projectionMatrix, time: this._accumulatedTimeFromStart, camPos: n3, velocityConeAperture: r3.velocityConeAperture, velocity: r3.velocity, horizontalOscillationRadius: r3.horizontalOscillationRadius, horizontalOscillationRate: r3.horizontalOscillationRate, boxSize: i3, billboardSize: 1 * r3.billboardSize, simpleShapeParameters: [r3.shapeFadeStart, r3.shapeFadePower], screenSize: [d2.width, d2.height], thinningCenterPos: [a3, c3], thinningShape: [_2, p3, Math.pow(10, r3.screenThinning.fadePower)], thinningAffectedRatio: r3.screenThinning.affectedRatio, thinningParticleOffset: f2, color: [r3.color.r, r3.color.g, r3.color.b, r3.color.a], direction: o2 }, { u_modelview: Float32Array.from(g2.modelview), u_projection: Float32Array.from(g2.projection), u_time: g2.time, u_cam_pos: g2.camPos, u_velocityConeAperture: g2.velocityConeAperture, u_velocity: g2.velocity, u_horizontalOscillationRadius: g2.horizontalOscillationRadius, u_horizontalOscillationRate: g2.horizontalOscillationRate, u_boxSize: g2.boxSize, u_billboardSize: g2.billboardSize, u_simpleShapeParameters: g2.simpleShapeParameters, u_screenSize: g2.screenSize, u_thinningCenterPos: g2.thinningCenterPos, u_thinningShape: g2.thinningShape, u_thinningAffectedRatio: g2.thinningAffectedRatio, u_thinningParticleOffset: g2.thinningParticleOffset, u_particleColor: g2.color, u_direction: g2.direction });
                var g2;
                const v2 = Math.round(r3.intensity * this.particlesCount), y2 = e.bd.simpleSegment(0, 0, 4 * v2, 2 * v2);
                this.particlesVx && this.particlesIdx && u2.draw(t2, h3.TRIANGLES, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, m2, "snow_particles", this.particlesVx, this.particlesIdx, y2);
              })(i2.boxSize, 0, i2), this._vignette.draw(t2, s2);
            }
          }
          const ea = { symbol: function(t2, i2, o2, s2, r2) {
            if ("translucent" !== t2.renderPass) return;
            const n2 = ji.disabled, a2 = t2.colorModeForRenderPass(), l2 = o2.layout.get("text-variable-anchor"), c2 = o2.layout.get("text-size-scale-range"), h3 = e.ay(t2.scaleFactor, c2[0], c2[1]);
            l2 && function(t3, i3, o3, s3, r3, n3, a3, l3) {
              const c3 = i3.transform, h4 = "map" === r3, d3 = "map" === n3;
              for (const i4 of t3) {
                const t4 = s3.getTile(i4), r4 = t4.getBucket(o3);
                if (!r4 || !r4.text || !r4.text.segments.get().length) continue;
                const n4 = e.bH(r4.textSizeData, c3.zoom, l3), u3 = hi(i4, r4.getProjection(), c3), _2 = c3.calculatePixelsToTileUnitsMatrix(t4), p3 = Zt(u3, t4.tileID.canonical, d3, h4, c3, r4.getProjection(), _2), f2 = r4.hasIconTextFit() && r4.hasIconData();
                n4 && Br(r4, h4, d3, a3, c3, p3, i4, Math.pow(2, c3.zoom - t4.tileID.overscaledZ), n4, f2);
              }
            }(s2, t2, o2, i2, o2.layout.get("text-rotation-alignment"), o2.layout.get("text-pitch-alignment"), r2, h3);
            const d2 = 0 !== o2.paint.get("icon-opacity").constantOr(1), u2 = 0 !== o2.paint.get("text-opacity").constantOr(1);
            void 0 !== o2.layout.get("symbol-sort-key").constantOr(1) && (d2 || u2) ? kr(t2, i2, o2, s2, n2, a2) : (d2 && kr(t2, i2, o2, s2, n2, a2, { onlyIcons: true }), u2 && kr(t2, i2, o2, s2, n2, a2, { onlyText: true })), i2.map.showCollisionBoxes && (zr(t2, i2, o2, s2, o2.paint.get("text-translate"), o2.paint.get("text-translate-anchor"), true), zr(t2, i2, o2, s2, o2.paint.get("icon-translate"), o2.paint.get("icon-translate-anchor"), false));
          }, circle: function(t2, i2, o2, s2) {
            if ("translucent" !== t2.renderPass) return;
            const r2 = o2.paint.get("circle-opacity"), n2 = o2.paint.get("circle-stroke-width"), a2 = o2.paint.get("circle-stroke-opacity"), l2 = void 0 !== o2.layout.get("circle-sort-key").constantOr(1), c2 = o2.paint.get("circle-emissive-strength");
            if (0 === r2.constantOr(1) && (0 === n2.constantOr(1) || 0 === a2.constantOr(1))) return;
            const h3 = t2.context, d2 = h3.gl, u2 = t2.transform, _2 = !(!t2.terrain || !t2.terrain.enabled), p3 = o2.layout.get("circle-elevation-reference"), f2 = t2.depthModeForSublayer(0, Ni.ReadOnly), m2 = new Ni(t2.context.gl.LEQUAL, Ni.ReadOnly, t2.depthRangeFor3D), g2 = "none" === p3 || _2 ? f2 : m2, v2 = ji.disabled, y2 = t2.colorModeForDrapableLayerRenderPass(c2), x2 = "globe" === u2.projection.name, b2 = [e.aD(u2.center.lng), e.aH(u2.center.lat)], w2 = [];
            for (let r3 = 0; r3 < s2.length; r3++) {
              const n3 = s2[r3], a3 = i2.getTile(n3), c3 = a3.getBucket(o2);
              if (!c3 || c3.projection.name !== u2.projection.name) continue;
              const h4 = c3.programConfigurations.get(o2.id), d3 = c3.layoutVertexBuffer, _3 = c3.globeExtVertexBuffer, p4 = c3.indexBuffer, f3 = e.dK(o2), m3 = [_3], g3 = t2.isTileAffectedByFog(n3);
              x2 && f3.push("PROJECTION_GLOBE_VIEW"), f3.push("DEPTH_D24"), t2.terrain && u2.depthOcclusionForSymbolsAndCircles && f3.push("DEPTH_OCCLUSION"), c3.hasElevation && (f3.push("ELEVATED_ROADS"), m3.push(c3.elevatedLayoutVertexBuffer));
              const v3 = t2.getOrCreateProgram("circle", { config: h4, defines: f3, overrideFog: g3 }), y3 = u2.projection.createInversionMatrix(u2, n3.canonical), T3 = { programConfiguration: h4, program: v3, layoutVertexBuffer: d3, dynamicBuffers: m3, indexBuffer: p4, uniformValues: e.dL(t2, n3, a3, y3, b2, o2), tile: a3 };
              if (l2) {
                const t3 = c3.segments.get();
                for (const i3 of t3) w2.push({ segments: new e.bd([i3]), sortKey: i3.sortKey, state: T3 });
              } else w2.push({ segments: c3.segments, sortKey: 0, state: T3 });
            }
            l2 && w2.sort((e2, t3) => e2.sortKey - t3.sortKey);
            const T2 = { useDepthForOcclusion: u2.depthOcclusionForSymbolsAndCircles };
            for (const e2 of w2) {
              const { programConfiguration: i3, program: s3, layoutVertexBuffer: r3, dynamicBuffers: n3, indexBuffer: a3, uniformValues: l3, tile: c3 } = e2.state, _3 = e2.segments;
              t2.terrain && t2.terrain.setupElevationDraw(c3, s3, T2), t2.uploadCommonUniforms(h3, s3, c3.tileID.toUnwrapped()), s3.draw(t2, d2.TRIANGLES, g2, v2, y2, qi.disabled, l3, o2.id, r3, a3, _3, o2.paint, u2.zoom, i3, n3);
            }
          }, heatmap: function(t2, i2, o2, s2) {
            if (0 !== o2.paint.get("heatmap-opacity")) if ("offscreen" === t2.renderPass) {
              const r2 = t2.context, n2 = r2.gl, a2 = ji.disabled, l2 = new ki([n2.ONE, n2.ONE, n2.ONE, n2.ONE], e.am.transparent, [true, true, true, true]);
              !function(e2, t3, i3, o3) {
                const s3 = e2.gl, r3 = t3.width * o3, n3 = t3.height * o3;
                e2.activeTexture.set(s3.TEXTURE1), e2.viewport.set([0, 0, r3, n3]);
                let a3 = i3.heatmapFbo;
                if (!a3 || a3 && (a3.width !== r3 || a3.height !== n3)) {
                  a3 && a3.destroy();
                  const t4 = s3.createTexture();
                  s3.bindTexture(s3.TEXTURE_2D, t4), s3.texParameteri(s3.TEXTURE_2D, s3.TEXTURE_WRAP_S, s3.CLAMP_TO_EDGE), s3.texParameteri(s3.TEXTURE_2D, s3.TEXTURE_WRAP_T, s3.CLAMP_TO_EDGE), s3.texParameteri(s3.TEXTURE_2D, s3.TEXTURE_MIN_FILTER, s3.LINEAR), s3.texParameteri(s3.TEXTURE_2D, s3.TEXTURE_MAG_FILTER, s3.LINEAR), a3 = i3.heatmapFbo = e2.createFramebuffer(r3, n3, true, null), function(e3, t5, i4, o4, s4, r4) {
                    const n4 = e3.gl;
                    n4.texImage2D(n4.TEXTURE_2D, 0, e3.extRenderToTextureHalfFloat ? n4.RGBA16F : n4.RGBA, s4, r4, 0, n4.RGBA, e3.extRenderToTextureHalfFloat ? n4.HALF_FLOAT : n4.UNSIGNED_BYTE, null), o4.colorAttachment.set(i4);
                  }(e2, 0, t4, a3, r3, n3);
                } else s3.bindTexture(s3.TEXTURE_2D, a3.colorAttachment.get()), e2.bindFramebuffer.set(a3.framebuffer);
              }(r2, t2, o2, "globe" === t2.transform.projection.name ? 0.5 : 0.25), r2.clear({ color: e.am.transparent });
              const c2 = t2.transform, h3 = "globe" === c2.projection.name, d2 = h3 ? ["PROJECTION_GLOBE_VIEW"] : [], u2 = h3 ? qi.frontCCW : qi.disabled, _2 = [e.aD(c2.center.lng), e.aH(c2.center.lat)];
              for (let e2 = 0; e2 < s2.length; e2++) {
                const p3 = s2[e2];
                if (i2.hasRenderableParent(p3)) continue;
                const f2 = i2.getTile(p3), m2 = f2.getBucket(o2);
                if (!m2 || m2.projection.name !== c2.projection.name) continue;
                const g2 = t2.isTileAffectedByFog(p3), v2 = m2.programConfigurations.get(o2.id), y2 = t2.getOrCreateProgram("heatmap", { config: v2, defines: d2, overrideFog: g2 }), { zoom: x2 } = t2.transform;
                t2.terrain && t2.terrain.setupElevationDraw(f2, y2), t2.uploadCommonUniforms(r2, y2, p3.toUnwrapped());
                const b2 = c2.projection.createInversionMatrix(c2, p3.canonical);
                y2.draw(t2, n2.TRIANGLES, Ni.disabled, a2, l2, u2, hr(t2, p3, f2, b2, _2, x2, o2.paint.get("heatmap-intensity")), o2.id, m2.layoutVertexBuffer, m2.indexBuffer, m2.segments, o2.paint, t2.transform.zoom, v2, h3 ? [m2.globeExtVertexBuffer] : null);
              }
              r2.viewport.set([0, 0, t2.width, t2.height]);
            } else "translucent" === t2.renderPass && (t2.context.setColorMode(t2.colorModeForRenderPass()), function(t3, i3) {
              const o3 = t3.context, s3 = o3.gl, r2 = i3.heatmapFbo;
              if (!r2) return;
              o3.activeTexture.set(s3.TEXTURE0), s3.bindTexture(s3.TEXTURE_2D, r2.colorAttachment.get()), o3.activeTexture.set(s3.TEXTURE1);
              let n2 = i3.colorRampTexture;
              n2 || (n2 = i3.colorRampTexture = new e.T(o3, i3.colorRamp, s3.RGBA8)), n2.bind(s3.LINEAR, s3.CLAMP_TO_EDGE), t3.getOrCreateProgram("heatmapTexture").draw(t3, s3.TRIANGLES, Ni.disabled, ji.disabled, t3.colorModeForRenderPass(), qi.disabled, ((e2, t4, i4, o4) => ({ u_image: 0, u_color_ramp: 1, u_opacity: t4.paint.get("heatmap-opacity") }))(0, i3), i3.id, t3.viewportBuffer, t3.quadTriangleIndexBuffer, t3.viewportSegments, i3.paint, t3.transform.zoom);
            }(t2, o2));
          }, line: function(t2, i2, o2, s2) {
            if ("translucent" !== t2.renderPass) return;
            const r2 = o2.paint.get("line-opacity"), n2 = o2.paint.get("line-width");
            if (0 === r2.constantOr(1) || 0 === n2.constantOr(1)) return;
            const a2 = o2.paint.get("line-emissive-strength"), l2 = o2.paint.get("line-occlusion-opacity"), c2 = o2.layout.get("line-elevation-reference"), h3 = "meters" === o2.layout.get("line-width-unit"), d2 = "sea" === c2, u2 = !(!t2.terrain || !t2.terrain.enabled), _2 = t2.context, p3 = _2.gl;
            if (o2.hasElevatedBuckets && "globe" === t2.transform.projection.name) return;
            const f2 = o2.layout.get("line-cross-slope"), m2 = void 0 !== f2, g2 = f2 < 1, v2 = t2.colorModeForDrapableLayerRenderPass(a2), y2 = t2.terrain && t2.terrain.renderingToTexture, x2 = y2 ? 1 : e.q.devicePixelRatio, b2 = o2.paint.get("line-dasharray"), w2 = b2.constantOr(1), T2 = o2.layout.get("line-cap"), E2 = b2.constantOr(null), S2 = T2.constantOr(null), I2 = o2.paint.get("line-pattern"), C2 = I2.constantOr(1), R2 = o2.paint.get("line-pattern-cross-fade"), D2 = I2.constantOr(null), A2 = o2.paint.get("line-opacity").constantOr(1);
            let L2 = !C2 && 1 !== A2 || t2.depthOcclusion && l2 > 0 && l2 < 1;
            const P2 = o2.paint.get("line-gradient"), z2 = C2 ? "linePattern" : "line", M2 = e.dM(o2);
            let O2;
            if (y2 && t2.terrain && t2.terrain.clipOrMaskOverlapStencilType() && (L2 = false), 0 !== l2 && t2.depthOcclusion) {
              const t3 = o2.paint._values["line-opacity"];
              t3 && t3.value && "constant" === t3.value.kind ? O2 = t3.value : e.w(`Occlusion opacity for layer ${o2.id} is supported only when line-opacity isn't data-driven.`);
            }
            "constant" !== n2.value.kind && false === n2.value.isLineProgressConstant && M2.push("VARIABLE_LINE_WIDTH");
            const F2 = (s3, r3, n3, a3, c3, u3) => {
              for (const f3 of s3) {
                const s4 = i2.getTile(f3);
                if (C2 && !s4.patternsLoaded()) continue;
                const m3 = s4.getBucket(o2);
                if (!m3) continue;
                if ("none" !== m3.elevationType && !c3 || "none" === m3.elevationType && c3) continue;
                t2.prepareDrawTile();
                const g3 = [...r3], b3 = t2.shadowRenderer, T3 = "road" === m3.elevationType && !!b3 && b3.enabled;
                let I3 = [0, 0, 0];
                if (T3) {
                  const e2 = t2.style.directionalLight, i3 = t2.style.ambientLight;
                  e2 && i3 && (I3 = ao(t2.style, e2, i3)), g3.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET");
                }
                const M3 = m3.programConfigurations.get(o2.id);
                let F3 = false;
                if (D2 && s4.imageAtlas) {
                  const t3 = e.dN.from(D2), i3 = t3.getPrimary().scaleSelf(x2).toString(), o3 = s4.imageAtlas.patternPositions.get(i3), r4 = t3.getSecondary(), n4 = r4 ? s4.imageAtlas.patternPositions.get(r4.scaleSelf(x2).toString()) : null;
                  F3 = !!o3 && !!n4, o3 && M3.setConstantPatternPositions(o3, n4);
                }
                R2 > 0 && (F3 || M3.getPatternTransitionVertexBuffer("line-pattern")) && g3.push("LINE_PATTERN_TRANSITION");
                const B3 = t2.isTileAffectedByFog(f3), k3 = t2.getOrCreateProgram(z2, { config: M3, defines: g3, overrideFog: B3, overrideRtt: !c3 && void 0 });
                if (!C2 && E2 && S2 && s4.lineAtlas) {
                  const e2 = s4.lineAtlas.getDash(E2, S2);
                  e2 && M3.setConstantPatternPositions(e2);
                }
                T3 && b3.setupShadows(s4.tileID.toUnwrapped(), k3, "vector-tile", s4.tileID.overscaledZ);
                let [N2, U2] = o2.paint.get("line-trim-offset");
                if ("round" === S2 || "square" === S2) {
                  const e2 = 1;
                  N2 !== U2 && (0 === N2 && (N2 -= e2), 1 === U2 && (U2 += e2));
                }
                const j2 = y2 ? f3.projMatrix : null, V2 = h3 ? 1 / m3.tileToMeter / e.aw(s4, 1, t2.transform.zoom) : 1, G2 = h3 ? 1 / m3.tileToMeter / e.aw(s4, 1, Math.floor(t2.transform.zoom)) : 1, q2 = C2 ? e.dO(t2, s4, o2, j2, x2, V2, G2, [N2, U2], I3, R2) : e.dP(t2, s4, o2, j2, m3.lineClipsArray.length, x2, V2, G2, [N2, U2], I3);
                if (P2) {
                  const s5 = m3.gradients[o2.id];
                  let r4 = s5.texture;
                  if (o2.gradientVersion !== s5.version) {
                    let n4 = 256;
                    if (o2.stepInterpolant) {
                      const o3 = i2.getSource().maxzoom, s6 = f3.canonical.z === o3 ? Math.ceil(1 << t2.transform.maxZoom - f3.canonical.z) : 1;
                      n4 = e.ay(e.dQ(m3.maxLineLength / e.aj * 1024 * s6), 256, _2.maxTextureSize);
                    }
                    s5.gradient = e.dR({ expression: o2.gradientExpression(), evaluationKey: "lineProgress", resolution: n4, image: s5.gradient || void 0, clips: m3.lineClipsArray }), s5.texture ? s5.texture.update(s5.gradient) : s5.texture = new e.T(_2, s5.gradient, p3.RGBA8), s5.version = o2.gradientVersion, r4 = s5.texture;
                  }
                  _2.activeTexture.set(p3.TEXTURE1), r4.bind(o2.stepInterpolant ? p3.NEAREST : p3.LINEAR, p3.CLAMP_TO_EDGE);
                }
                w2 && (_2.activeTexture.set(p3.TEXTURE0), s4.lineAtlasTexture && s4.lineAtlasTexture.bind(p3.LINEAR, p3.REPEAT), M3.updatePaintBuffers()), C2 && (_2.activeTexture.set(p3.TEXTURE0), s4.imageAtlasTexture && s4.imageAtlasTexture.bind(p3.LINEAR, p3.CLAMP_TO_EDGE), M3.updatePaintBuffers()), c3 && !d2 && t2.terrain.setupElevationDraw(s4, k3), t2.uploadCommonUniforms(_2, k3, f3.toUnwrapped());
                const Z2 = (e2) => {
                  null != O2 && (O2.value = A2 * l2), k3.draw(t2, p3.TRIANGLES, n3, e2, v2, qi.disabled, q2, o2.id, m3.layoutVertexBuffer, m3.indexBuffer, m3.segments, o2.paint, t2.transform.zoom, M3, [m3.layoutVertexBuffer2, m3.patternVertexBuffer, m3.zOffsetVertexBuffer]), null != O2 && (O2.value = A2);
                };
                if (L2 && !c3) {
                  const e2 = t2.stencilModeForClipping(f3).ref;
                  0 === e2 && y2 && _2.clear({ stencil: 0 });
                  const i3 = { func: p3.EQUAL, mask: 255 };
                  q2.u_alpha_discard_threshold = 0.8, Z2(new ji(i3, e2, 255, p3.KEEP, p3.KEEP, p3.INVERT)), q2.u_alpha_discard_threshold = 0, Z2(new ji(i3, e2, 255, p3.KEEP, p3.KEEP, p3.KEEP));
                } else q2.u_alpha_discard_threshold = L2 && c3 && u3 ? 0.8 : 0, Z2(c3 ? a3 : t2.stencilModeForClipping(f3));
              }
            };
            let B2 = t2.depthModeForSublayer(0, Ni.ReadOnly);
            const k2 = new Ni(t2.depthOcclusion ? p3.GREATER : p3.LEQUAL, Ni.ReadOnly, t2.depthRangeFor3D);
            if (o2.hasNonElevatedBuckets) {
              const i3 = !y2 && t2.terrain;
              0 !== l2 && i3 ? e.w(`Occlusion opacity for layer ${o2.id} is supported on terrain only if the layer has line-z-offset enabled.`) : i3 ? e.w(`Cannot render non-elevated lines in immediate mode when terrain is enabled. Layer: ${o2.id}.`) : F2(s2, M2, B2, ji.disabled, false, true);
            }
            if (o2.hasElevatedBuckets) {
              "hd-road-markup" === c2 ? u2 || (B2 = k2, M2.push("ELEVATED_ROADS")) : (M2.push("ELEVATED"), B2 = k2, m2 && M2.push(g2 ? "CROSS_SLOPE_HORIZONTAL" : "CROSS_SLOPE_VERTICAL"), d2 && M2.push("ELEVATION_REFERENCE_SEA"));
              const e2 = L2 ? t2.stencilModeFor3D() : ji.disabled;
              t2.forceTerrainMode = true, F2(s2, M2, B2, e2, true, true), L2 && F2(s2, M2, B2, e2, true, false), t2.forceTerrainMode = false;
            }
            L2 && (t2.resetStencilClippingMasks(), y2 && _2.clear({ stencil: 0 })), 0 === l2 || t2.depthOcclusion || y2 || t2.layersWithOcclusionOpacity.push(t2.currentLayer);
          }, fill: function(t2, i2, o2, s2) {
            const r2 = o2.paint.get("fill-color"), n2 = o2.paint.get("fill-opacity");
            if (0 === n2.constantOr(1)) return;
            const a2 = o2.paint.get("fill-emissive-strength"), l2 = t2.colorModeForDrapableLayerRenderPass(a2), c2 = o2.paint.get("fill-pattern"), h3 = t2.opaquePassEnabledForLayer() && !c2.constantOr(1) && 1 === r2.constantOr(e.am.transparent).a && 1 === n2.constantOr(0) ? "opaque" : "translucent";
            let d2 = "none";
            "none" !== o2.layout.get("fill-elevation-reference") ? d2 = "road" : 0 !== o2.paint.get("fill-z-offset").constantOr(1) && (d2 = "offset");
            const u2 = !(!t2.terrain || !t2.terrain.enabled), _2 = { painter: t2, sourceCache: i2, layer: o2, coords: s2, colorMode: l2, elevationType: d2, terrainEnabled: u2, pass: h3 };
            if ("shadow" !== t2.renderPass) if ("offset" !== d2) {
              if (Vr(_2, false), "road" === d2) {
                const e2 = !u2 && "translucent" === t2.renderPass;
                e2 && jr(t2, i2, o2, s2, "geometry"), Vr(_2, true, ji.disabled), e2 && function(e3) {
                  const { painter: t3, sourceCache: i3, layer: o3, coords: s3, colorMode: r3 } = e3, n3 = t3.context.gl, a3 = e3.painter.shadowRenderer, l3 = !!a3 && a3.enabled, c3 = new Ni(t3.context.gl.LEQUAL, Ni.ReadOnly, t3.depthRangeFor3D);
                  let h4 = [0, 0, 0];
                  if (l3) {
                    const e4 = t3.style.directionalLight, i4 = t3.style.ambientLight;
                    e4 && i4 && (h4 = ao(t3.style, e4, i4));
                  }
                  const d3 = (e4) => {
                    for (const d4 of s3) {
                      const s4 = i3.getTile(d4), u3 = s4.getBucket(o3);
                      if (!u3) continue;
                      const _3 = u3.elevatedStructures;
                      if (!_3) continue;
                      let p3, f2;
                      if (e4 ? (p3 = _3.renderableBridgeSegments, f2 = _3.bridgeProgramConfigurations.get(o3.id)) : (p3 = _3.renderableTunnelSegments, f2 = _3.tunnelProgramConfigurations.get(o3.id)), !p3 || 0 === p3.segments[0].primitiveLength) continue;
                      f2.updatePaintBuffers(), t3.prepareDrawTile();
                      const m2 = t3.isTileAffectedByFog(d4), g2 = [];
                      l3 && g2.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET");
                      const v2 = t3.getOrCreateProgram("elevatedStructures", { config: f2, overrideFog: m2, defines: g2 }), y2 = t3.translatePosMatrix(d4.projMatrix, s4, o3.paint.get("fill-translate"), o3.paint.get("fill-translate-anchor"));
                      l3 && a3.setupShadows(s4.tileID.toUnwrapped(), v2, "vector-tile", s4.tileID.overscaledZ);
                      const x2 = rr(y2, h4);
                      t3.uploadCommonUniforms(t3.context, v2, d4.toUnwrapped()), v2.draw(t3, n3.TRIANGLES, c3, ji.disabled, r3, qi.backCCW, x2, o3.id, _3.vertexBuffer, _3.indexBuffer, p3, o3.paint, t3.transform.zoom, f2, [_3.vertexBufferNormal]);
                    }
                  };
                  d3(true), d3(false);
                }(_2);
              }
            } else Vr(_2, false, t2.stencilModeFor3D());
            else t2.shadowRenderer && "road" === d2 && !u2 && function(e2) {
              const { painter: t3, sourceCache: i3, layer: o3, coords: s3 } = e2, r3 = t3.context.gl, n3 = e2.painter.shadowRenderer;
              for (const e3 of s3) {
                const s4 = i3.getTile(e3), a3 = s4.getBucket(o3);
                if (!a3) continue;
                const l3 = a3.elevatedStructures;
                if (!l3) continue;
                if (!l3.shadowCasterSegments || 0 === l3.shadowCasterSegments.segments[0].primitiveLength) continue;
                t3.prepareDrawTile();
                const c3 = a3.bufferData.programConfigurations.get(o3.id), h4 = t3.isTileAffectedByFog(e3), d3 = t3.getOrCreateProgram("elevatedStructuresDepth", { config: c3, overrideFog: h4 }), u3 = n3.calculateShadowPassMatrixFromTile(s4.tileID.toUnwrapped());
                t3.uploadCommonUniforms(t3.context, d3, e3.toUnwrapped());
                const _3 = { u_matrix: u3, u_depth_bias: 1e-3 };
                d3.draw(t3, r3.TRIANGLES, n3.getShadowPassDepthMode(), ji.disabled, n3.getShadowPassColorMode(), qi.disabled, _3, o3.id, l3.vertexBuffer, l3.indexBuffer, l3.shadowCasterSegments, o3.paint, t3.transform.zoom, c3);
              }
            }(_2);
          }, "fill-extrusion": function(t2, i2, o2, s2) {
            const r2 = o2.paint.get("fill-extrusion-opacity"), n2 = t2.context, a2 = n2.gl, l2 = t2.terrain, c2 = l2 && l2.renderingToTexture;
            if (0 === r2) return;
            const h3 = t2.conflationActive && t2.style.isLayerClipped(o2, i2.getSource()), d2 = t2.style.order.indexOf(o2.fqid);
            if (h3 && function(e2, t3, i3, o3, s3) {
              for (const r3 of o3) {
                const o4 = t3.getTile(r3).getBucket(i3);
                o4 && (o4.updateReplacement(r3, e2.replacementSource, s3), o4.uploadCentroid(e2.context));
              }
            }(t2, i2, o2, s2, d2), l2 || h3) for (const e2 of s2) {
              const s3 = i2.getTile(e2).getBucket(o2);
              s3 && Zr(t2.context, i2, e2, s3, o2, l2, h3);
            }
            if ("shadow" === t2.renderPass && t2.shadowRenderer) {
              const n3 = t2.shadowRenderer;
              if (l2 && r2 < 0.65 && o2._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e.ab) return;
              const a3 = n3.getShadowPassDepthMode(), c3 = n3.getShadowPassColorMode();
              Gr(t2, i2, o2, s2, a3, ji.disabled, c3, h3);
            } else if ("translucent" === t2.renderPass) {
              const d3 = !o2.paint.get("fill-extrusion-pattern").constantOr(1), u2 = o2.paint.get("fill-extrusion-color").constantOr(e.am.white);
              if (!c2 && 0 !== u2.a) {
                const e2 = new Ni(t2.context.gl.LEQUAL, Ni.ReadWrite, t2.depthRangeFor3D);
                1 === r2 && d3 ? Gr(t2, i2, o2, s2, e2, ji.disabled, ki.unblended, h3) : (Gr(t2, i2, o2, s2, e2, ji.disabled, ki.disabled, h3), Gr(t2, i2, o2, s2, e2, t2.stencilModeFor3D(), t2.colorModeForRenderPass(), h3), t2.resetStencilClippingMasks());
              }
              if (t2.style.enable3dLights() && d3 && (!l2 && "globe" !== t2.transform.projection.name || c2)) {
                const r3 = o2.paint.get("fill-extrusion-opacity"), d4 = o2.paint.get("fill-extrusion-ambient-occlusion-intensity"), u3 = o2.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), _2 = o2.paint.get("fill-extrusion-flood-light-intensity"), p3 = "none" === o2.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), f2 = o2.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(p3 ? null : o2.lut).toArray01().slice(0, 3), m2 = d4 > 0 && u3 > 0, g2 = _2 > 0, v2 = (e2, t3, i3) => (1 - i3) * e2 + i3 * t3, y2 = (n3) => {
                  const l3 = t2.depthModeForSublayer(1, Ni.ReadOnly, a2.LEQUAL, true), c3 = o2.paint.get(n3 ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), p4 = v2(0.1, 3, c3), m3 = t2._showOverdrawInspector;
                  if (!m3) {
                    const c4 = new ji({ func: a2.ALWAYS, mask: 255 }, 255, 255, a2.KEEP, a2.KEEP, a2.REPLACE), m4 = new ki([a2.ONE, a2.ONE, a2.ONE, a2.ONE], e.am.transparent, [false, false, false, true], a2.MIN);
                    qr(t2, i2, o2, s2, l3, c4, m4, qi.disabled, n3, "sdf", r3, d4, u3, _2, f2, p4, h3, false);
                  }
                  {
                    const c4 = m3 ? ji.disabled : new ji({ func: a2.EQUAL, mask: 255 }, 255, 255, a2.KEEP, a2.DECR, a2.DECR), g3 = m3 ? t2.colorModeForRenderPass() : new ki([a2.ONE_MINUS_DST_ALPHA, a2.DST_ALPHA, a2.ONE, a2.ONE], e.am.transparent, [true, true, true, true]);
                    qr(t2, i2, o2, s2, l3, c4, g3, qi.disabled, n3, "color", r3, d4, u3, _2, f2, p4, h3, false);
                  }
                };
                if (c2) {
                  const c3 = (n3, l3, c4) => {
                    const p4 = t2.depthModeForSublayer(1, Ni.ReadOnly, a2.LEQUAL, false), m3 = o2.paint.get(n3 ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), g3 = v2(0.1, 3, m3);
                    {
                      const c5 = new ki([a2.ONE, a2.ONE, a2.ONE, a2.ONE], e.am.transparent, [false, false, false, true]);
                      qr(t2, i2, o2, s2, p4, ji.disabled, c5, qi.disabled, n3, "clear", r3, d4, u3, _2, f2, g3, h3, l3);
                    }
                    {
                      const c5 = new ji({ func: a2.ALWAYS, mask: 255 }, 255, 255, a2.KEEP, a2.KEEP, a2.REPLACE), m4 = new ki([a2.ONE, a2.ONE, a2.ONE, a2.ONE], e.am.transparent, [false, false, false, true], a2.MIN);
                      qr(t2, i2, o2, s2, p4, c5, m4, qi.disabled, n3, "sdf", r3, d4, u3, _2, f2, g3, h3, l3);
                    }
                    {
                      const c5 = n3 ? a2.ZERO : a2.ONE_MINUS_DST_ALPHA, m4 = new ji({ func: a2.EQUAL, mask: 255 }, 255, 255, a2.KEEP, a2.DECR, a2.DECR), v3 = new ki([c5, a2.DST_ALPHA, a2.ONE_MINUS_DST_ALPHA, a2.ZERO], e.am.transparent, [true, true, true, true]);
                      qr(t2, i2, o2, s2, p4, m4, v3, qi.disabled, n3, "color", r3, d4, u3, _2, f2, g3, h3, l3);
                    }
                    {
                      const m4 = new ki([a2.ONE, a2.ONE, a2.ONE, n3 ? a2.ZERO : a2.ONE], e.am.transparent, [false, false, false, true], n3 ? a2.FUNC_ADD : a2.MAX);
                      qr(t2, i2, o2, s2, p4, ji.disabled, m4, qi.disabled, n3, "clear", r3, d4, u3, _2, f2, g3, h3, l3, c4);
                    }
                  };
                  if (m2 || g2) {
                    let i3;
                    if (t2.prepareDrawTile(), l2) {
                      const t3 = l2.drapeBufferSize[0], o3 = l2.drapeBufferSize[1];
                      i3 = l2.framebufferCopyTexture, i3 && (!i3 || i3.size[0] === t3 && i3.size[1] === o3) || (i3 && i3.destroy(), i3 = l2.framebufferCopyTexture = new e.T(n2, new e.r({ width: t3, height: o3 }), a2.RGBA8)), i3.bind(a2.LINEAR, a2.CLAMP_TO_EDGE), a2.copyTexSubImage2D(a2.TEXTURE_2D, 0, 0, 0, 0, 0, t3, o3);
                    }
                    m2 && c3(true, false, i3), g2 && c3(false, true, i3);
                  }
                } else m2 && y2(true), g2 && y2(false), (m2 || g2) && t2.resetStencilClippingMasks();
              }
            }
          }, building: function(e2, t2, i2, o2) {
          }, hillshade: function(e2, t2, i2, o2) {
            if ("offscreen" !== e2.renderPass && "translucent" !== e2.renderPass) return;
            if (e2.style.disableElevatedTerrain) return;
            const s2 = e2.context, r2 = e2.terrain && e2.terrain.renderingToTexture, [n2, a2] = "translucent" !== e2.renderPass || r2 ? [{}, o2] : e2.stencilConfigForOverlap(o2);
            for (const o3 of a2) {
              const s3 = t2.getTile(o3);
              if (s3.needsHillshadePrepare && "offscreen" === e2.renderPass) $o(e2, s3, i2);
              else if ("translucent" === e2.renderPass) {
                const t3 = e2.depthModeForSublayer(0, Ni.ReadOnly), a3 = i2.paint.get("hillshade-emissive-strength"), l2 = e2.colorModeForDrapableLayerRenderPass(a3), c2 = r2 && e2.terrain ? e2.terrain.stencilModeForRTTOverlap(o3) : n2[o3.overscaledZ];
                Ho(e2, o3, s3, i2, t3, c2, l2);
              }
            }
            s2.viewport.set([0, 0, e2.width, e2.height]), e2.resetStencilClippingMasks();
          }, raster: function(t2, i2, o2, s2, r2, n2) {
            if ("translucent" !== t2.renderPass) return;
            if (0 === o2.paint.get("raster-opacity")) return;
            const a2 = "globe" === t2.transform.projection.name, l2 = 0 !== o2.paint.get("raster-elevation"), c2 = l2 && a2;
            if (t2.renderElevatedRasterBackface && !c2) return;
            const h3 = t2.context, d2 = h3.gl, u2 = i2.getSource(), _2 = function(t3, i3, o3, s3) {
              const r3 = i3.paint.get("raster-color"), n3 = "raster-array" === t3.type, a3 = [], l3 = i3.paint.get("raster-resampling"), c3 = i3.paint.get("raster-color-mix");
              let h4 = i3.paint.get("raster-color-range");
              const d3 = [c3[0], c3[1], c3[2], 0], u3 = c3[3];
              let _3 = "nearest" === l3 ? s3.NEAREST : s3.LINEAR;
              if (n3 && (a3.push("RASTER_ARRAY"), r3 || a3.push("RASTER_COLOR"), "linear" === l3 && a3.push("RASTER_ARRAY_LINEAR"), _3 = s3.NEAREST, !h4 && t3.rasterLayers)) {
                const e2 = t3.rasterLayers.find(({ id: e3 }) => e3 === i3.sourceLayer);
                e2 && e2.fields && e2.fields.range && (h4 = e2.fields.range);
              }
              if (h4 = h4 || [0, 1], r3) {
                a3.push("RASTER_COLOR"), o3.activeTexture.set(s3.TEXTURE2), i3.updateColorRamp(h4);
                let t4 = i3.colorRampTexture;
                t4 || (t4 = i3.colorRampTexture = new e.T(o3, i3.colorRamp, s3.RGBA8)), t4.bind(s3.LINEAR, s3.CLAMP_TO_EDGE);
              }
              return { mix: d3, range: h4, offset: u3, defines: a3, resampling: _3 };
            }(u2, o2, h3, d2);
            if (u2 instanceof e.aP && !s2.length && !a2) return;
            const p3 = o2.paint.get("raster-emissive-strength"), f2 = t2.colorModeForDrapableLayerRenderPass(p3), m2 = t2.terrain && t2.terrain.renderingToTexture, g2 = !t2.options.moving, v2 = "nearest" === o2.paint.get("raster-resampling") ? d2.NEAREST : d2.LINEAR;
            if (u2 instanceof e.aP && !s2.length && (u2.onNorthPole || u2.onSouthPole)) {
              const e2 = l2 ? t2.stencilModeFor3D() : ji.disabled;
              return void Kr(!!u2.onNorthPole, null, t2, i2, o2, p3, _2, qi.disabled, e2);
            }
            if (!s2.length) return;
            const [y2, x2] = u2 instanceof e.aP || m2 ? [{}, s2] : t2.stencilConfigForOverlap(s2), b2 = x2[x2.length - 1].overscaledZ;
            c2 && _2.defines.push("PROJECTION_GLOBE_VIEW"), l2 && _2.defines.push("RENDER_CUTOFF");
            const w2 = (s3, r3, x3) => {
              for (const w3 of s3) {
                const s4 = w3.toUnwrapped(), T2 = i2.getTile(w3);
                if (m2 && (!T2 || !T2.hasData())) continue;
                h3.activeTexture.set(d2.TEXTURE0);
                const E2 = Qr(T2, u2, o2, _2);
                if (!E2 || !E2.texture) continue;
                const { texture: S2, mix: I2, offset: C2, tileSize: R2, buffer: D2 } = E2;
                let A2, L2;
                m2 ? (A2 = Ni.disabled, L2 = w3.projMatrix) : l2 ? (A2 = new Ni(d2.LEQUAL, Ni.ReadWrite, t2.depthRangeFor3D), L2 = a2 ? Float32Array.from(t2.transform.expandedFarZProjMatrix) : t2.transform.calculateProjMatrix(s4, g2)) : (A2 = t2.depthModeForSublayer(w3.overscaledZ - b2, 1 === o2.paint.get("raster-opacity") ? Ni.ReadWrite : Ni.ReadOnly, d2.LESS), L2 = t2.transform.calculateProjMatrix(s4, g2));
                const P2 = t2.terrain && m2 ? t2.terrain.stencilModeForRTTOverlap(w3) : y2[w3.overscaledZ], z2 = n2 ? 0 : o2.paint.get("raster-fade-duration");
                T2.registerFadeDuration(z2);
                const M2 = i2.findLoadedParent(w3, 0), O2 = Us(T2, M2, i2, t2.transform, z2);
                let F2, B2;
                t2.terrain && t2.terrain.prepareDrawTile(), h3.activeTexture.set(d2.TEXTURE0), S2.bind(v2, d2.CLAMP_TO_EDGE), h3.activeTexture.set(d2.TEXTURE1), M2 ? (M2.texture && M2.texture.bind(v2, d2.CLAMP_TO_EDGE), F2 = Math.pow(2, M2.tileID.overscaledZ - T2.tileID.overscaledZ), B2 = [T2.tileID.canonical.x * F2 % 1, T2.tileID.canonical.y * F2 % 1]) : S2.bind(v2, d2.CLAMP_TO_EDGE), "useMipmap" in S2 && h3.extTextureFilterAnisotropic && t2.transform.pitch > 20 && d2.texParameterf(d2.TEXTURE_2D, h3.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, h3.extTextureFilterAnisotropicMax);
                const k2 = t2.transform;
                let N2;
                const U2 = l2 ? Jr(k2) : [0, 0, 0, 0];
                let j2, V2, G2, q2, Z2, H2 = 0;
                if (c2 && u2 instanceof e.aP && u2.coordinates.length > 3) j2 = Float32Array.from(e.bh(e.dr(new e.cp(0, 0, 0)))), V2 = Float32Array.from(k2.globeMatrix), G2 = Float32Array.from(e.dm(k2)), q2 = [e.aD(k2.center.lng), e.aH(k2.center.lat)], N2 = u2.elevatedGlobePerspectiveTransform, Z2 = u2.elevatedGlobeGridMatrix || new Float32Array(9);
                else if (c2) {
                  const t3 = e.dn(w3.canonical);
                  H2 = e.dp(t3.getCenter().lat), j2 = Float32Array.from(e.bh(e.dr(w3.canonical))), V2 = Float32Array.from(k2.globeMatrix), G2 = Float32Array.from(e.dm(k2)), q2 = [e.aD(k2.center.lng), e.aH(k2.center.lat)], N2 = [0, 0], Z2 = Float32Array.from(e.dq(w3.canonical, t3, H2, k2.worldSize / k2._pixelsPerMercatorPixel));
                } else N2 = u2 instanceof e.aP ? u2.perspectiveTransform : [0, 0], j2 = new Float32Array(16), V2 = new Float32Array(9), G2 = new Float32Array(16), q2 = [0, 0], Z2 = new Float32Array(9);
                const W2 = _r(L2, j2, V2, G2, Z2, B2 || [0, 0], e.ah(t2.transform.zoom), q2, U2, F2 || 1, O2, o2, N2, l2 ? o2.paint.get("raster-elevation") : 0, 2, I2, C2, _2.range, R2, D2, p3), $2 = t2.isTileAffectedByFog(w3), X2 = t2.getOrCreateProgram("raster", { defines: _2.defines, overrideFog: $2 });
                if (t2.uploadCommonUniforms(h3, X2, s4), u2 instanceof e.aP) {
                  const i3 = u2.elevatedGlobeVertexBuffer, s5 = u2.elevatedGlobeIndexBuffer;
                  if (m2 || !a2) u2.boundsBuffer && u2.boundsSegments && X2.draw(t2, d2.TRIANGLES, A2, ji.disabled, f2, qi.disabled, W2, o2.id, u2.boundsBuffer, t2.quadTriangleIndexBuffer, u2.boundsSegments);
                  else if (i3 && s5) {
                    const n3 = k2.zoom <= e.cL ? u2.elevatedGlobeSegments : u2.getSegmentsForLongitude(k2.center.lng);
                    n3 && X2.draw(t2, d2.TRIANGLES, A2, ji.disabled, f2, r3, W2, o2.id, i3, s5, n3);
                  }
                } else if (c2) {
                  A2 = new Ni(d2.LEQUAL, Ni.ReadOnly, t2.depthRangeFor3D);
                  const e2 = t2.globeSharedBuffers;
                  if (e2) {
                    const [i3, s5, n3] = e2.getGridBuffers(H2, false);
                    X2.draw(t2, d2.TRIANGLES, A2, x3 || P2, t2.colorModeForRenderPass(), r3, W2, o2.id, i3, s5, n3);
                  }
                } else {
                  const { tileBoundsBuffer: e2, tileBoundsIndexBuffer: i3, tileBoundsSegments: s5 } = t2.getTileBoundsBuffers(T2);
                  X2.draw(t2, d2.TRIANGLES, A2, P2, f2, qi.disabled, W2, o2.id, e2, i3, s5);
                }
              }
              if (!(u2 instanceof e.aP) && c2) for (const e2 of s3) {
                const s4 = e2.canonical.y === (1 << e2.canonical.z) - 1;
                0 === e2.canonical.y && Kr(true, e2, t2, i2, o2, p3, _2, r3, x3 || ji.disabled), s4 && Kr(false, e2, t2, i2, o2, p3, _2, r3 === qi.frontCW ? qi.backCW : qi.frontCW, x3 || ji.disabled);
              }
            };
            c2 ? w2(x2, t2.renderElevatedRasterBackface ? qi.backCW : qi.frontCW, t2.stencilModeFor3D()) : w2(x2, qi.disabled, void 0), t2.resetStencilClippingMasks();
          }, "raster-particle": function(t2, i2, o2, s2, r2, n2) {
            "offscreen" === t2.renderPass && function(t3, i3, o3, s3) {
              if (!s3.length) return;
              const r3 = t3.context, n3 = r3.gl, a2 = i3.getSource();
              if (!(a2 instanceof st)) return;
              const l2 = Math.ceil(Math.sqrt(o3.paint.get("raster-particle-count")));
              let c2 = o3.particlePositionRGBAImage;
              if (!c2 || c2.width !== l2) {
                const t4 = function(e2) {
                  const t5 = e2 * e2, i4 = new Uint8Array(4 * t5), o4 = function(e3) {
                    return e3 |= 0, e3 = Math.imul(2747636419 ^ e3, 2654435769), e3 = Math.imul(e3 ^ e3 >>> 16, 2654435769), ((e3 = Math.imul(e3 ^ e3 >>> 16, 2654435769)) >>> 0) / 4294967296;
                  }, s4 = 1 / 1.1;
                  for (let e3 = 0; e3 < t5; e3++) {
                    const t6 = s4 * (o4(2 * e3 + 0) + fr), r4 = s4 * (o4(2 * e3 + 1) + fr), n4 = 255 * t6 % 1, a3 = 255 * r4 % 1, l3 = n4, c3 = r4 - a3 / 255, h4 = a3;
                    i4[4 * e3 + 0] = 255 * (t6 - n4 / 255), i4[4 * e3 + 1] = 255 * l3, i4[4 * e3 + 2] = 255 * c3, i4[4 * e3 + 3] = 255 * h4;
                  }
                  return i4;
                }(l2);
                c2 = o3.particlePositionRGBAImage = new e.r({ width: l2, height: l2 }, t4);
              }
              let h3 = o3.particleFramebuffer;
              h3 ? h3.width !== l2 && (h3.destroy(), h3 = o3.particleFramebuffer = r3.createFramebuffer(l2, l2, true, null)) : h3 = o3.particleFramebuffer = r3.createFramebuffer(l2, l2, true, null);
              const d2 = [];
              for (const e2 of s3) {
                const t4 = i3.getTile(e2);
                if (!(t4 instanceof Tt)) continue;
                const s4 = on2(t4, a2, o3);
                if (!s4) continue;
                const n4 = [t4.tileSize, t4.tileSize];
                let h4 = o3.tileFramebuffer;
                h4 || (h4 = o3.tileFramebuffer = r3.createFramebuffer(n4[0], n4[1], true, null));
                let u3 = t4.rasterParticleState;
                u3 || (u3 = t4.rasterParticleState = new tn(r3, e2, n4, c2));
                const _3 = u3.update(o3.lastInvalidatedAt);
                u3.particleTextureDimension !== l2 && u3.updateParticleTexture(e2, c2);
                const p3 = u3.targetColorTexture;
                u3.targetColorTexture = u3.backgroundColorTexture, u3.backgroundColorTexture = p3;
                const f2 = u3.particleTexture0;
                u3.particleTexture0 = u3.particleTexture1, u3.particleTexture1 = f2, d2.push([e2, s4, u3, _3]);
              }
              if (0 === d2.length) return;
              const u2 = e.q.now(), _2 = o3.previousDrawTimestamp ? 1e-3 * (u2 - o3.previousDrawTimestamp) : 0.0167;
              if (o3.previousDrawTimestamp = u2, o3.hasColorMap()) {
                r3.activeTexture.set(n3.TEXTURE0 + 2);
                let t4 = o3.colorRampTexture;
                t4 || (t4 = o3.colorRampTexture = new e.T(r3, o3.colorRamp, n3.RGBA8)), t4.bind(n3.LINEAR, n3.CLAMP_TO_EDGE);
              }
              r3.bindFramebuffer.set(o3.tileFramebuffer.framebuffer), function(t4, i4, o4) {
                const s4 = t4.context, r4 = s4.gl, n4 = i4.tileFramebuffer;
                s4.activeTexture.set(r4.TEXTURE0);
                const a3 = { u_texture: 0, u_opacity: 1.05 * (c3 = i4.paint.get("raster-particle-fade-opacity-factor")) / (c3 + 0.05) }, l3 = t4.getOrCreateProgram("rasterParticleTexture", { defines: [], overrideFog: false });
                var c3;
                for (const c4 of o4) {
                  const [, , o5, h4] = c4;
                  n4.colorAttachment.set(o5.targetColorTexture.texture), s4.viewport.set([0, 0, n4.width, n4.height]), s4.clear({ color: e.am.transparent }), h4 && (o5.backgroundColorTexture.bind(r4.NEAREST, r4.CLAMP_TO_EDGE), l3.draw(t4, r4.TRIANGLES, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, a3, i4.id, t4.viewportBuffer, t4.quadTriangleIndexBuffer, t4.viewportSegments));
                }
              }(t3, o3, d2), function(t4, i4, o4, s4) {
                const r4 = t4.context, n4 = r4.gl, a3 = o4.tileFramebuffer, l3 = "globe" === t4.transform.projection.name, c3 = o4.paint.get("raster-particle-max-speed");
                for (const h4 of s4) {
                  const [s5, d3, u3] = h4;
                  r4.activeTexture.set(n4.TEXTURE0 + 0), d3.texture.bind(n4.LINEAR, n4.CLAMP_TO_EDGE), a3.colorAttachment.set(u3.targetColorTexture.texture);
                  const _3 = t4.getOrCreateProgram("rasterParticleDraw", { defines: d3.defines, overrideFog: false });
                  r4.activeTexture.set(n4.TEXTURE0 + 1);
                  const p3 = d3.scalarData ? [] : [0, 1, 2, 3].map((t5) => e.dT[t5](s5));
                  p3.push(s5);
                  const f2 = s5.canonical.x, m2 = s5.canonical.y;
                  for (const e2 of p3) {
                    const r5 = i4.getTile(l3 ? e2.wrapped() : e2);
                    if (!r5) continue;
                    const a4 = r5.rasterParticleState;
                    if (!a4) continue;
                    const h5 = e2.canonical.x + (1 << e2.canonical.z) * (e2.wrap - s5.wrap), u4 = e2.canonical.y;
                    a4.particleTexture0.bind(n4.NEAREST, n4.CLAMP_TO_EDGE);
                    const p4 = gr(1, a4.particleTexture0.size[0], [h5 - f2, u4 - m2], 0, d3.texture.size, 2, c3, d3.textureOffset, d3.scale, d3.offset);
                    _3.draw(t4, n4.POINTS, Ni.disabled, ji.disabled, ki.alphaBlended, qi.disabled, p4, o4.id, a4.particleIndexBuffer, void 0, a4.particleSegment);
                  }
                }
              }(t3, i3, o3, d2), r3.bindFramebuffer.set(o3.particleFramebuffer.framebuffer), function(t4, i4, o4, s4) {
                const r4 = t4.context, n4 = r4.gl, a3 = i4.paint.get("raster-particle-max-speed"), l3 = s4 * i4.paint.get("raster-particle-speed-factor") * 0.15, c3 = function(e2) {
                  return Math.pow(e2, 6);
                }(0.01 + 1 * i4.paint.get("raster-particle-reset-rate-factor")), h4 = i4.particleFramebuffer;
                r4.viewport.set([0, 0, h4.width, h4.height]);
                for (const s5 of o4) {
                  const [, o5, d3] = s5;
                  r4.activeTexture.set(n4.TEXTURE0 + 0), o5.texture.bind(n4.LINEAR, n4.CLAMP_TO_EDGE), r4.activeTexture.set(n4.TEXTURE0 + 1);
                  const u3 = d3.particleTexture0;
                  u3.bind(n4.NEAREST, n4.CLAMP_TO_EDGE);
                  const _3 = vr(1, u3.size[0], 0, o5.texture.size, a3, l3, c3, o5.textureOffset, o5.scale, o5.offset);
                  h4.colorAttachment.set(d3.particleTexture1.texture), r4.clear({ color: e.am.transparent }), t4.getOrCreateProgram("rasterParticleUpdate", { defines: o5.defines }).draw(t4, n4.TRIANGLES, Ni.disabled, ji.disabled, ki.unblended, qi.disabled, _3, i4.id, t4.viewportBuffer, t4.quadTriangleIndexBuffer, t4.viewportSegments);
                }
              }(t3, o3, d2, _2);
            }(t2, i2, o2, s2), "translucent" === t2.renderPass && (function(t3, i3, o3, s3, r3) {
              const n3 = t3.context, a2 = n3.gl, l2 = i3.getSource().tileSize, c2 = 5 * (1 - e.af(e.cx, e.cx + 1, t3.transform.zoom)) * l2 + o3.paint.get("raster-particle-elevation"), h3 = !t3.options.moving, d2 = "globe" === t3.transform.projection.name;
              if (!s3.length) return;
              const [u2, _2] = t3.stencilConfigForOverlap(s3), p3 = [];
              d2 && p3.push("PROJECTION_GLOBE_VIEW");
              const f2 = t3.stencilModeFor3D();
              for (const s4 of _2) {
                const r4 = s4.toUnwrapped(), l3 = i3.getTile(s4);
                if (!l3.rasterParticleState) continue;
                const _3 = l3.rasterParticleState, m2 = 100;
                l3.registerFadeDuration(m2);
                const g2 = i3.findLoadedParent(s4, 0), v2 = Us(l3, g2, i3, t3.transform, m2);
                let y2, x2;
                t3.terrain && t3.terrain.prepareDrawTile(), n3.activeTexture.set(a2.TEXTURE0), _3.targetColorTexture.bind(a2.LINEAR, a2.CLAMP_TO_EDGE), n3.activeTexture.set(a2.TEXTURE1), g2 && g2.rasterParticleState ? (g2.rasterParticleState.targetColorTexture.bind(a2.LINEAR, a2.CLAMP_TO_EDGE), y2 = Math.pow(2, g2.tileID.overscaledZ - l3.tileID.overscaledZ), x2 = [l3.tileID.canonical.x * y2 % 1, l3.tileID.canonical.y * y2 % 1]) : _3.targetColorTexture.bind(a2.LINEAR, a2.CLAMP_TO_EDGE);
                const b2 = d2 ? Float32Array.from(t3.transform.expandedFarZProjMatrix) : t3.transform.calculateProjMatrix(r4, h3), w2 = t3.transform, T2 = sn(w2), E2 = e.dn(s4.canonical), S2 = e.dp(E2.getCenter().lat);
                let I2, C2, R2, D2, A2;
                d2 ? (I2 = Float32Array.from(e.bh(e.dr(s4.canonical))), C2 = Float32Array.from(w2.globeMatrix), R2 = Float32Array.from(e.dm(w2)), D2 = [e.aD(w2.center.lng), e.aH(w2.center.lat)], A2 = Float32Array.from(e.dq(s4.canonical, E2, S2, w2.worldSize / w2._pixelsPerMercatorPixel))) : (I2 = new Float32Array(16), C2 = new Float32Array(9), R2 = new Float32Array(16), D2 = [0, 0], A2 = new Float32Array(9));
                const L2 = mr(b2, I2, C2, R2, A2, x2 || [0, 0], e.ah(t3.transform.zoom), D2, T2, y2 || 1, v2, c2), P2 = t3.isTileAffectedByFog(s4), z2 = t3.getOrCreateProgram("rasterParticle", { defines: p3, overrideFog: P2 });
                if (t3.uploadCommonUniforms(n3, z2, r4), d2) {
                  const e2 = new Ni(a2.LEQUAL, Ni.ReadOnly, t3.depthRangeFor3D), i4 = 0, s5 = t3.globeSharedBuffers;
                  if (s5) {
                    const [r5, n4, l4] = s5.getGridBuffers(S2, 0 !== i4);
                    z2.draw(t3, a2.TRIANGLES, e2, f2, ki.alphaBlended, t3.renderElevatedRasterBackface ? qi.frontCCW : qi.backCCW, L2, o3.id, r5, n4, l4);
                  }
                } else {
                  const e2 = t3.depthModeForSublayer(0, Ni.ReadOnly), i4 = u2[s4.overscaledZ], { tileBoundsBuffer: r5, tileBoundsIndexBuffer: n4, tileBoundsSegments: c3 } = t3.getTileBoundsBuffers(l3);
                  z2.draw(t3, a2.TRIANGLES, e2, i4, ki.alphaBlended, qi.disabled, L2, o3.id, r5, n4, c3);
                }
              }
              t3.resetStencilClippingMasks();
            }(t2, i2, o2, s2), t2.style.map.triggerRepaint());
          }, background: function(t2, i2, o2, s2) {
            const r2 = o2.paint.get("background-color"), n2 = "none" === o2.paint.get("background-color-use-theme").constantOr("default"), a2 = o2.paint.get("background-opacity"), l2 = o2.paint.get("background-emissive-strength"), c2 = "viewport" === o2.paint.get("background-pitch-alignment");
            if (0 === a2) return;
            const h3 = t2.context, d2 = h3.gl, u2 = t2.transform, _2 = u2.tileSize, p3 = o2.paint.get("background-pattern");
            let f2;
            if (void 0 !== p3) {
              if (null === p3) return;
              if (f2 = t2.imageManager.getPattern(e.I.from(p3.toString()), o2.scope, t2.style.getLut(o2.scope)), !f2) return;
            }
            const m2 = !p3 && 1 === r2.a && 1 === a2 && t2.opaquePassEnabledForLayer() ? "opaque" : "translucent";
            if (t2.renderPass !== m2) return;
            const g2 = ji.disabled, v2 = t2.depthModeForSublayer(0, "opaque" === m2 ? Ni.ReadWrite : Ni.ReadOnly), y2 = t2.colorModeForDrapableLayerRenderPass(l2), x2 = p3 ? "backgroundPattern" : "background";
            let b2, w2 = s2;
            if (w2 || (b2 = t2.getBackgroundTiles(), w2 = Object.values(b2).map((e2) => e2.tileID)), p3 && (h3.activeTexture.set(d2.TEXTURE0), t2.imageManager.bind(t2.context, o2.scope)), c2) {
              const i3 = t2.getOrCreateProgram(x2, { overrideFog: false, overrideRtt: true }), s3 = new Float32Array(e.bx([])), h4 = new e.aM(0, 0, 0, 0, 0), u3 = p3 ? wr(s3, l2, a2, t2, 0, o2.scope, f2, c2, { tileID: h4, tileSize: _2 }) : br(s3, l2, a2, r2.toPremultipliedRenderColor(n2 ? null : o2.lut));
              i3.draw(t2, d2.TRIANGLES, v2, g2, y2, qi.disabled, u3, o2.id, t2.viewportBuffer, t2.quadTriangleIndexBuffer, t2.viewportSegments);
            } else for (const e2 of w2) {
              const m3 = t2.isTileAffectedByFog(e2), w3 = t2.getOrCreateProgram(x2, { overrideFog: m3 }), T2 = e2.toUnwrapped(), E2 = s2 ? e2.projMatrix : t2.transform.calculateProjMatrix(T2);
              t2.prepareDrawTile();
              const S2 = i2 ? i2.getTile(e2) : b2 ? b2[e2.key] : new wt(e2, _2, u2.zoom, t2), I2 = p3 ? wr(E2, l2, a2, t2, 0, o2.scope, f2, c2, { tileID: e2, tileSize: _2 }) : br(E2, l2, a2, r2.toPremultipliedRenderColor(n2 ? null : o2.lut));
              t2.uploadCommonUniforms(h3, w3, T2);
              const { tileBoundsBuffer: C2, tileBoundsIndexBuffer: R2, tileBoundsSegments: D2 } = t2.getTileBoundsBuffers(S2);
              w3.draw(t2, d2.TRIANGLES, v2, g2, y2, qi.disabled, I2, o2.id, C2, R2, D2);
            }
          }, sky: function(t2, i2, o2) {
            const s2 = t2._atmosphere ? e.ah(t2.transform.zoom) : 1, r2 = o2.paint.get("sky-opacity") * s2;
            if (0 === r2) return;
            const n2 = t2.context, a2 = o2.paint.get("sky-type"), l2 = new Ni(n2.gl.LEQUAL, Ni.ReadOnly, [0, 1]), c2 = t2.frameCounter / 1e3 % 1;
            "atmosphere" === a2 ? "offscreen" === t2.renderPass ? o2.needsSkyboxCapture(t2) && (function(t3, i3, o3, s3) {
              const r3 = t3.context, n3 = r3.gl;
              let a3 = i3.skyboxFbo;
              if (!a3) {
                a3 = i3.skyboxFbo = r3.createFramebuffer(32, 32, true, null), i3.skyboxGeometry = new vn(r3), i3.skyboxTexture = r3.gl.createTexture(), n3.bindTexture(n3.TEXTURE_CUBE_MAP, i3.skyboxTexture), n3.texParameteri(n3.TEXTURE_CUBE_MAP, n3.TEXTURE_WRAP_S, n3.CLAMP_TO_EDGE), n3.texParameteri(n3.TEXTURE_CUBE_MAP, n3.TEXTURE_WRAP_T, n3.CLAMP_TO_EDGE), n3.texParameteri(n3.TEXTURE_CUBE_MAP, n3.TEXTURE_MIN_FILTER, n3.LINEAR), n3.texParameteri(n3.TEXTURE_CUBE_MAP, n3.TEXTURE_MAG_FILTER, n3.LINEAR);
                for (let e2 = 0; e2 < 6; ++e2) n3.texImage2D(n3.TEXTURE_CUBE_MAP_POSITIVE_X + e2, 0, n3.RGBA, 32, 32, 0, n3.RGBA, n3.UNSIGNED_BYTE, null);
              }
              r3.bindFramebuffer.set(a3.framebuffer), r3.viewport.set([0, 0, 32, 32]);
              const l3 = i3.getCenter(t3, true), c3 = t3.getOrCreateProgram("skyboxCapture"), h3 = new Float64Array(16);
              e.bx(h3), e.e3(h3, h3, 0.5 * -Math.PI), yn(t3, i3, c3, h3, l3, 0), e.bx(h3), e.e3(h3, h3, 0.5 * Math.PI), yn(t3, i3, c3, h3, l3, 1), e.bx(h3), e.cG(h3, h3, 0.5 * -Math.PI), yn(t3, i3, c3, h3, l3, 2), e.bx(h3), e.cG(h3, h3, 0.5 * Math.PI), yn(t3, i3, c3, h3, l3, 3), e.bx(h3), yn(t3, i3, c3, h3, l3, 4), e.bx(h3), e.e3(h3, h3, Math.PI), yn(t3, i3, c3, h3, l3, 5), r3.viewport.set([0, 0, t3.width, t3.height]);
            }(t2, o2), o2.markSkyboxValid(t2)) : "sky" === t2.renderPass && function(e2, t3, i3, o3, s3) {
              const r3 = e2.context, n3 = r3.gl, a3 = e2.transform, l3 = e2.getOrCreateProgram("skybox");
              r3.activeTexture.set(n3.TEXTURE0), n3.bindTexture(n3.TEXTURE_CUBE_MAP, t3.skyboxTexture);
              const c3 = /* @__PURE__ */ ((e3, t4, i4, o4, s4) => ({ u_matrix: e3, u_sun_direction: t4, u_cubemap: 0, u_opacity: o4, u_temporal_offset: s4 }))(a3.skyboxMatrix, t3.getCenter(e2, false), 0, o3, s3);
              e2.uploadCommonUniforms(r3, l3), l3.draw(e2, n3.TRIANGLES, i3, ji.disabled, e2.colorModeForRenderPass(), qi.backCW, c3, "skybox", t3.skyboxGeometry.vertexBuffer, t3.skyboxGeometry.indexBuffer, t3.skyboxGeometry.segment);
            }(t2, o2, l2, r2, c2) : "gradient" === a2 && "sky" === t2.renderPass && function(t3, i3, o3, s3, r3) {
              const n3 = t3.context, a3 = n3.gl, l3 = t3.transform, c3 = t3.getOrCreateProgram("skyboxGradient");
              i3.skyboxGeometry || (i3.skyboxGeometry = new vn(n3)), n3.activeTexture.set(a3.TEXTURE0);
              let h3 = i3.colorRampTexture;
              h3 || (h3 = i3.colorRampTexture = new e.T(n3, i3.colorRamp, a3.RGBA8)), h3.bind(a3.LINEAR, a3.CLAMP_TO_EDGE);
              const d2 = ((t4, i4, o4, s4, r4) => ({ u_matrix: t4, u_color_ramp: 0, u_center_direction: i4, u_radius: e.al(o4), u_opacity: s4, u_temporal_offset: r4 }))(l3.skyboxMatrix, i3.getCenter(t3, false), i3.paint.get("sky-gradient-radius"), s3, r3);
              t3.uploadCommonUniforms(n3, c3), c3.draw(t3, a3.TRIANGLES, o3, ji.disabled, t3.colorModeForRenderPass(), qi.backCW, d2, "skyboxGradient", i3.skyboxGeometry.vertexBuffer, i3.skyboxGeometry.indexBuffer, i3.skyboxGeometry.segment);
            }(t2, o2, l2, r2, c2);
          }, custom: function(t2, i2, o2, s2) {
            const r2 = t2.context, n2 = o2.implementation;
            if (!t2.transform.projection.unsupportedLayers || !t2.transform.projection.unsupportedLayers.includes("custom") || t2.terrain && (t2.terrain.renderingToTexture || "offscreen" === t2.renderPass) && o2.isDraped(i2)) {
              if ("offscreen" === t2.renderPass) {
                const i3 = n2.prerender;
                if (i3) {
                  if (t2.setCustomLayerDefaults(), r2.setColorMode(t2.colorModeForRenderPass()), "globe" === t2.transform.projection.name) {
                    const o3 = t2.transform.pointMerc;
                    i3.call(n2, r2.gl, t2.transform.customLayerMatrix(), t2.transform.getProjection(), t2.transform.globeToMercatorMatrix(), e.ah(t2.transform.zoom), [o3.x, o3.y], t2.transform.pixelsPerMeterRatio);
                  } else i3.call(n2, r2.gl, t2.transform.customLayerMatrix());
                  r2.setDirty(), t2.setBaseState();
                }
              } else if ("translucent" === t2.renderPass) {
                if (t2.terrain && t2.terrain.renderingToTexture) {
                  const e2 = n2.renderToTile;
                  if (e2) {
                    const i4 = s2[0].canonical, o3 = { x: i4.x + s2[0].wrap * (n2.wrapTileId ? 0 : 1 << i4.z), y: i4.y, z: i4.z };
                    r2.setDepthMode(Ni.disabled), r2.setStencilMode(ji.disabled), r2.setColorMode(t2.colorModeForRenderPass()), t2.setCustomLayerDefaults(), e2.call(n2, r2.gl, o3), r2.setDirty(), t2.setBaseState();
                  }
                  return;
                }
                t2.setCustomLayerDefaults(), r2.setColorMode(t2.colorModeForRenderPass()), r2.setStencilMode(ji.disabled);
                const i3 = "3d" === n2.renderingMode ? new Ni(t2.context.gl.LEQUAL, Ni.ReadWrite, t2.depthRangeFor3D) : t2.depthModeForSublayer(0, Ni.ReadOnly);
                if (r2.setDepthMode(i3), "globe" === t2.transform.projection.name) {
                  const i4 = t2.transform.pointMerc;
                  n2.render(r2.gl, t2.transform.customLayerMatrix(), t2.transform.getProjection(), t2.transform.globeToMercatorMatrix(), e.ah(t2.transform.zoom), [i4.x, i4.y], t2.transform.pixelsPerMeterRatio);
                } else n2.render(r2.gl, t2.transform.customLayerMatrix());
                r2.setDirty(), t2.setBaseState(), r2.bindFramebuffer.set(null);
              }
            } else e.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
          }, model: function(t2, i2, o2, s2) {
            if ("opaque" === t2.renderPass) return;
            const r2 = o2.paint.get("model-opacity").constantOr(1);
            if (0 === r2) return;
            const n2 = o2.paint.get("model-cast-shadows");
            if ("shadow" === t2.renderPass) {
              if (!n2) return;
              if (t2.terrain && r2 < 0.65 && o2._transitionablePaint._values["model-opacity"].value.expression instanceof e.ab) return;
            }
            const a2 = t2.shadowRenderer, l2 = o2.paint.get("model-receive-shadows");
            a2 && (a2.useNormalOffset = true, l2 || (a2.enabled = false));
            const c2 = () => {
              a2 && (a2.useNormalOffset = true, l2 || (a2.enabled = true));
            }, h3 = i2.getSource();
            if ("light-beam" === t2.renderPass && "batched-model" !== h3.type) return;
            if ("vector" === h3.type || "geojson" === h3.type) return function(t3, i3, o3, s3, r3) {
              const n3 = t3.transform;
              if ("mercator" !== n3.projection.name) return void e.w(`Drawing 3D models for ${n3.projection.name} projection is not yet implemented`);
              const a3 = n3.getFreeCameraOptions().position;
              if (!t3.modelManager) return;
              const l3 = t3.modelManager;
              o3.modelManager = l3;
              const c3 = t3.shadowRenderer;
              if (!o3._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
              const h4 = o3._unevaluatedLayout._values["model-id"], d3 = Object.assign({}, o3.layout.get("model-id").parameters), u3 = t3.style.order.indexOf(o3.fqid);
              for (const _3 of s3) {
                const s4 = i3.getTile(_3).getBucket(o3);
                if (!s4 || s4.projection.name !== n3.projection.name) continue;
                const p4 = s4.getModelUris();
                p4 && !s4.modelsRequested && (l3.addModelsFromBucket(p4, r3), s4.modelsRequested = true);
                const f3 = Pn(_3, n3);
                d3.zoom = f3;
                const m3 = h4.possiblyEvaluate(d3);
                if (An(t3, s4, _3), Ln.shadowUniformsInitialized = false, Ln.useSingleShadowCascade = !!c3 && 0 === c3.getMaxCascadeForTile(_3.toUnwrapped()), "shadow" === t3.renderPass && c3) {
                  if (1 === t3.currentShadowCascade && s4.isInsideFirstShadowMapFrustum) continue;
                  const i4 = n3.calculatePosMatrix(_3.toUnwrapped(), n3.worldSize);
                  if (Ln.tileMatrix.set(i4), Ln.shadowTileMatrix = Float32Array.from(c3.calculateShadowPassMatrixFromMatrix(i4)), Ln.aabb.min.fill(0), Ln.aabb.max[0] = Ln.aabb.max[1] = e.aj, Ln.aabb.max[2] = 0, On(s4, Ln, t3, o3.scope)) continue;
                }
                const g3 = 1 << _3.canonical.z, v2 = [((a3.x - _3.wrap) * g3 - _3.canonical.x) * e.aj, (a3.y * g3 - _3.canonical.y) * e.aj, a3.z * g3 * e.aj];
                t3.conflationActive && Object.keys(s4.instancesPerModel).length > 0 && t3.style.isLayerClipped(o3, i3.getSource()) && s4.updateReplacement(_3, t3.replacementSource, u3, r3) && (s4.uploaded = false, s4.upload(t3.context));
                for (let e2 in s4.instancesPerModel) {
                  const i4 = s4.instancesPerModel[e2];
                  i4.features.length > 0 && (e2 = m3.evaluate(i4.features[0].feature, {}));
                  const n4 = l3.getModel(e2, r3);
                  if (n4 || l3.hasURLBeenRequested(e2) || s4.modelUris.includes(e2) || (s4.modelUris.push(e2), s4.modelsRequested = false), n4 && n4.uploaded) for (const e3 of n4.nodes) zn(t3, o3, e3, i4, v2, _3, Ln);
                }
              }
            }(t2, i2, o2, s2, "vector" === h3.type ? o2.scope : ""), void c2();
            if (!h3.loaded()) return;
            if ("batched-model" === h3.type) return function(t3, i3, o3, s3) {
              o3.resetLayerRenderingStats(t3);
              const r3 = t3.context, n3 = t3.transform, a3 = t3.style.fog, l3 = t3.shadowRenderer;
              if ("mercator" !== n3.projection.name) return void e.w(`Drawing 3D landmark models for ${n3.projection.name} projection is not yet implemented`);
              const c3 = t3.transform.getFreeCameraOptions().position, h4 = e.bY([], [c3.x, c3.y, c3.z], t3.transform.worldSize), d3 = e.eb([], h4), u3 = e.bx([]), _3 = e.ec(n3.center.lat, n3.zoom), p4 = e.bn([], [1, 1, 1 / _3]);
              e.bo(u3, u3, d3);
              const f3 = o3.paint.get("model-opacity").constantOr(1), m3 = new Ni(r3.gl.LEQUAL, Ni.ReadWrite, t3.depthRangeFor3D), g3 = new Ni(r3.gl.LEQUAL, Ni.ReadOnly, t3.depthRangeFor3D), v2 = new e.cW([1 / 0, 1 / 0, 1 / 0], [-1 / 0, -1 / 0, -1 / 0]), y2 = "shadow" === t3.renderPass, x2 = y2 && l3 ? l3.getCurrentCascadeFrustum() : n3.getFrustum(n3.scaleZoom(n3.worldSize)), b2 = o3.paint.get("model-front-cutoff"), w2 = b2[2] < 1, T2 = eo(t3, o3.paint.get("model-cutoff-fade-range")), E2 = o3.getLayerRenderingStats();
              (function(e2, t4, i4, o4) {
                const s4 = e2.terrain ? e2.terrain.exaggeration() : 0, r4 = e2.transform.zoom;
                for (const n4 of o4) {
                  const o5 = t4.getTile(n4).getBucket(i4);
                  o5 && (o5.setFilter(i4.filter), e2.conflationActive && o5.updateReplacement(n4, e2.replacementSource), o5.evaluateTransform(e2, i4), e2.terrain && s4 > 0 && o5.elevationUpdate(e2.terrain, s4, n4, i4.source), o5.needsReEvaluation(e2, r4, i4) && o5.evaluate(i4));
                }
              })(t3, i3, o3, s3), function() {
                let c4, d4, S2;
                w2 ? (c4 = s3.length - 1, d4 = -1, S2 = -1) : (c4 = 0, d4 = s3.length, S2 = 1);
                const I2 = new Float64Array(16), C2 = e.ef(), R2 = new e.P(0, 0);
                for (let D2 = c4; D2 !== d4; D2 += S2) {
                  const c5 = s3[D2], d5 = i3.getTile(c5).getBucket(o3);
                  if (!d5 || !d5.uploaded) continue;
                  let S3 = false;
                  l3 && (S3 = 0 === l3.getMaxCascadeForTile(c5.toUnwrapped()));
                  const A2 = n3.calculatePosMatrix(c5.toUnwrapped(), n3.worldSize), L2 = d5.modelTraits;
                  !y2 && w2 && (e.bi(I2, A2), e.ad(C2, h4, I2), R2.x = C2[0], R2.y = C2[1]);
                  const P2 = [];
                  d5.setFilter(o3.filter);
                  for (const i4 of d5.getNodesInfo()) {
                    if (i4.hiddenByReplacement) continue;
                    if (!i4.node.meshes) continue;
                    const o4 = i4.node;
                    let s4 = 0;
                    t3.terrain && o4.elevation && (s4 = o4.elevation * t3.terrain.exaggeration());
                    const r4 = (() => {
                      const t4 = i4.aabb;
                      return v2.min = [...t4.min], v2.max = [...t4.max], v2.min[2] += s4, v2.max[2] += s4, e.ad(v2.min, v2.min, A2), e.ad(v2.max, v2.max, A2), v2;
                    })(), a4 = i4.evaluatedScale;
                    if (a4[0] <= 1 && a4[1] <= 1 && a4[2] <= 1 && 0 === r4.intersects(x2)) continue;
                    if (!y2 && w2) {
                      const t4 = 1 / 6;
                      i4.cameraCollisionOpacity = h4[0] > r4.min[0] && h4[0] < r4.max[0] && h4[1] > r4.min[1] && h4[1] < r4.max[1] && h4[2] * _3 < r4.max[2] && o4.footprint && e.bS(R2, o4.footprint) ? Math.max(i4.cameraCollisionOpacity - t4, 0) : Math.min(1, i4.cameraCollisionOpacity + t4);
                    }
                    const l4 = [...A2], d6 = 1 / e.cU(c5.canonical), u4 = o4.anchor ? o4.anchor[0] : 0, p5 = o4.anchor ? o4.anchor[1] : 0;
                    e.bo(l4, l4, [u4 * (a4[0] - 1) + i4.evaluatedTranslation[0] * d6, p5 * (a4[1] - 1) + i4.evaluatedTranslation[1] * d6, s4 + i4.evaluatedTranslation[2]]), e.ci(a4, e.eg) || e.cE(l4, l4, a4);
                    const m4 = e.az([], l4, o4.matrix), g4 = e.az([], n3.expandedFarZProjMatrix, m4), E3 = e.az([], n3.expandedFarZProjMatrix, l4), S4 = e.aA([], [u4, p5, s4, 1], g4)[2];
                    o4.hidden = false;
                    let I3 = f3;
                    y2 || (w2 && (I3 *= i4.cameraCollisionOpacity, I3 *= Bn(l4, n3, i4.aabb, b2)), I3 *= Fn(T2, S4)), 0 !== I3 ? P2.push({ nodeInfo: i4, depth: S4, opacity: I3, wvpForNode: g4, wvpForTile: E3, nodeModelMatrix: m4, tileModelMatrix: l4 }) : o4.hidden = true;
                  }
                  y2 || P2.sort((e2, t4) => !w2 || 1 === e2.opacity && 1 === t4.opacity ? e2.depth < t4.depth ? -1 : 1 : 1 === e2.opacity ? -1 : 1 === t4.opacity ? 1 : e2.depth > t4.depth ? -1 : 1);
                  for (const i4 of P2) {
                    const s4 = i4.nodeInfo, c6 = s4.node;
                    let h5 = e.az([], p4, i4.tileModelMatrix);
                    e.az(h5, u3, h5);
                    const d6 = e.bi([], h5);
                    e.ee(d6, d6), e.cE(d6, d6, Mn), h5 = e.az(h5, h5, c6.matrix);
                    const _4 = "light-beam" === t3.renderPass, f4 = "none" === o3.paint.get("model-color-use-theme").constantOr("default"), v3 = L2 & e.em.HasMapboxMeshFeatures, x3 = v3 ? 0 : s4.evaluatedRMEA[0][2];
                    for (let e2 = 0; e2 < c6.meshes.length; ++e2) {
                      const u4 = c6.meshes[e2], p5 = e2 === c6.lightMeshIndex;
                      let b3 = i4.wvpForNode;
                      if (p5) {
                        if (!_4 && !t3.terrain && t3.shadowRenderer) {
                          t3.currentLayer < t3.firstLightBeamLayer && (t3.firstLightBeamLayer = t3.currentLayer);
                          continue;
                        }
                        b3 = i4.wvpForTile;
                      } else if (_4) continue;
                      const w3 = { defines: [] }, T3 = [];
                      if (!y2 && l3 && (l3.useNormalOffset = !!u4.normalBuffer), In(w3.defines, T3, u4, t3, f4 ? null : o3.lut), v3 || w3.defines.push("DIFFUSE_SHADED"), S3 && w3.defines.push("SHADOWS_SINGLE_CASCADE"), E2 && (y2 ? E2.numRenderedVerticesInShadowPass += u4.vertexArray.length : E2.numRenderedVerticesInTransparentPass += u4.vertexArray.length), y2) {
                        Dn(u4, i4.nodeModelMatrix, t3, o3);
                        continue;
                      }
                      let I3 = null;
                      if (a3) {
                        const e3 = Sn(i4.nodeModelMatrix, t3.transform);
                        if (I3 = new Float32Array(e3), "globe" !== n3.projection.name) {
                          const t4 = u4.aabb.min, i5 = u4.aabb.max, [o4, s5] = a3.getOpacityForBounds(e3, t4[0], t4[1], i5[0], i5[1]);
                          w3.overrideFog = o4 >= Fe || s5 >= Fe;
                        }
                      }
                      const C3 = u4.material;
                      let R3;
                      C3.occlusionTexture && C3.occlusionTexture.offsetScale && (R3 = C3.occlusionTexture.offsetScale, w3.defines.push("OCCLUSION_TEXTURE_TRANSFORM"));
                      const D3 = t3.getOrCreateProgram("model", w3);
                      !y2 && l3 && l3.setupShadowsFromMatrix(i4.tileModelMatrix, D3, l3.useNormalOffset), t3.uploadCommonUniforms(r3, D3, null, I3);
                      const A3 = C3.pbrMetallicRoughness;
                      A3.metallicFactor = 0.9, A3.roughnessFactor = 0.5;
                      const L3 = Er(new Float32Array(b3), new Float32Array(h5), new Float32Array(d6), new Float32Array(c6.matrix), t3, i4.opacity, A3.baseColorFactor, C3.emissiveFactor, A3.metallicFactor, A3.roughnessFactor, C3, x3, o3, [0, 0, 0], R3);
                      !p5 && (s4.hasTranslucentParts || i4.opacity < 1) && D3.draw(t3, r3.gl.TRIANGLES, m3, ji.disabled, ki.disabled, qi.backCCW, L3, o3.id, u4.vertexBuffer, u4.indexBuffer, u4.segments, o3.paint, t3.transform.zoom, void 0, T3), D3.draw(t3, r3.gl.TRIANGLES, p5 ? g3 : m3, ji.disabled, p5 || i4.opacity < 1 || s4.hasTranslucentParts ? ki.alphaBlended : ki.unblended, qi.backCCW, L3, o3.id, u4.vertexBuffer, u4.indexBuffer, u4.segments, o3.paint, t3.transform.zoom, void 0, T3);
                    }
                  }
                }
              }();
            }(t2, i2, o2, s2), void c2();
            if ("model" !== h3.type) return;
            const d2 = h3.getModels(), u2 = [], _2 = t2.transform.getFreeCameraOptions().position, p3 = e.bY([], [_2.x, _2.y, _2.z], t2.transform.worldSize);
            e.eb(p3, p3);
            const f2 = [], m2 = [];
            let g2 = 0;
            for (const i3 of d2) {
              const s3 = o2.paint.get("model-rotation").constantOr(null), r3 = o2.paint.get("model-scale").constantOr(null), n3 = o2.paint.get("model-translation").constantOr(null);
              i3.computeModelMatrix(t2, s3, r3, n3, true, true, false);
              const a3 = e.bx([]), l3 = e.ec(i3.position.lat, t2.transform.zoom), c3 = e.bn([], [1, 1, 1 / l3]);
              e.bo(a3, a3, p3), u2.push({ zScaleMatrix: c3, negCameraPosMatrix: a3 });
              for (const e2 of i3.nodes) Rn(t2.transform, e2, i3.matrix, t2.transform.expandedFarZProjMatrix, g2, f2, m2);
              g2++;
            }
            if (f2.sort((e2, t3) => t3.depth - e2.depth), "shadow" !== t2.renderPass) {
              if (1 === r2) for (const e2 of m2) Cn(e2, t2, o2, u2[e2.modelIndex], ji.disabled, t2.colorModeForRenderPass());
              else {
                for (const e2 of m2) Cn(e2, t2, o2, u2[e2.modelIndex], ji.disabled, ki.disabled);
                for (const e2 of m2) Cn(e2, t2, o2, u2[e2.modelIndex], t2.stencilModeFor3D(), t2.colorModeForRenderPass());
                t2.resetStencilClippingMasks();
              }
              for (const e2 of f2) Cn(e2, t2, o2, u2[e2.modelIndex], ji.disabled, t2.colorModeForRenderPass());
              c2();
            } else {
              for (const e2 of m2) Dn(e2.mesh, e2.nodeModelMatrix, t2, o2);
              for (const e2 of f2) Dn(e2.mesh, e2.nodeModelMatrix, t2, o2);
              c2();
            }
          } }, ta = { line: function(e2, t2, i2) {
            if (e2.hasElevatedBuckets = false, e2.hasNonElevatedBuckets = false, void 0 !== e2._unevaluatedLayout.getValue("line-elevation-reference") || void 0 !== e2._unevaluatedLayout.getValue("line-z-offset")) {
              if (t2) {
                const i3 = t2.getVisibleCoordinates();
                for (const o2 of i3) {
                  const i4 = t2.getTile(o2).getBucket(e2);
                  if (i4 && ("none" !== i4.elevationType ? e2.hasElevatedBuckets = true : e2.hasNonElevatedBuckets = true, e2.hasElevatedBuckets && e2.hasNonElevatedBuckets)) break;
                }
              }
            } else e2.hasNonElevatedBuckets = true;
          }, model: function(e2, t2, i2) {
            const o2 = t2.getSource();
            if (!o2.loaded()) return;
            if ("vector" === o2.type || "geojson" === o2.type) return void (i2.modelManager && i2.modelManager.upload(i2, "vector" === o2.type ? e2.scope : ""));
            if ("batched-model" === o2.type) return;
            if ("model" !== o2.type) return;
            const s2 = o2.getModels();
            for (const e3 of s2) e3.upload(i2.context);
          }, raster: function(e2, t2, i2) {
            const o2 = t2.getSource();
            if (!(o2 instanceof st && o2.loaded())) return;
            const s2 = e2.sourceLayer || o2.rasterLayerIds && o2.rasterLayerIds[0];
            if (!s2) return;
            const r2 = e2.paint.get("raster-array-band") || o2.getInitialBand(s2);
            if (null == r2) return;
            const n2 = t2.getIds().map((e3) => t2.getTileByID(e3));
            for (const e3 of n2) e3.updateNeeded(s2, r2) && o2.prepareTile(e3, s2, r2);
          }, "raster-particle": function(e2, t2, i2) {
            const o2 = t2.getSource();
            if (!(o2 instanceof st && o2.loaded())) return;
            const s2 = e2.sourceLayer || o2.rasterLayerIds && o2.rasterLayerIds[0];
            if (!s2) return;
            const r2 = e2.paint.get("raster-particle-array-band") || o2.getInitialBand(s2);
            if (null == r2) return;
            const n2 = t2.getIds().map((e3) => t2.getTileByID(e3));
            for (const e3 of n2) e3.updateNeeded(s2, r2) && o2.prepareTile(e3, s2, r2);
          } }, ia = { fill: jr }, oa = { fill: function(e2, t2, i2, o2) {
            if (!i2.layout || "none" === i2.layout.get("fill-elevation-reference")) return;
            const s2 = e2.context.gl, r2 = new Ni(s2.LEQUAL, Ni.ReadOnly, e2.depthRangeFor3D), n2 = new ji({ func: s2.ALWAYS, mask: 255 }, 255, 255, s2.KEEP, s2.KEEP, s2.REPLACE), a2 = e2.transform.getFreeCameraOptions().position, l2 = e2.getOrCreateProgram("elevatedStructuresDepthReconstruct", { defines: ["DEPTH_RECONSTRUCTION"] });
            for (const c2 of o2) {
              const o3 = t2.getTile(c2), h3 = o3.getBucket(i2);
              if (!h3) continue;
              const d2 = h3.elevatedStructures;
              if (!d2 || 0 === d2.maskSegments.segments[0].primitiveLength) continue;
              const u2 = Ur(c2.toUnwrapped(), a2), _2 = e2.translatePosMatrix(c2.projMatrix, o3, i2.paint.get("fill-translate"), i2.paint.get("fill-translate-anchor")), p3 = nr(_2, u2, 0, 0, 0);
              l2.draw(e2, s2.TRIANGLES, r2, n2, ki.disabled, qi.disabled, p3, i2.id, d2.vertexBuffer, d2.indexBuffer, d2.maskSegments, i2.paint, e2.transform.zoom);
            }
          } };
          class sa {
            constructor(t2, i2, o2, s2, r2, n2) {
              this.context = new Lr(t2, i2), this.transform = o2, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.tp = r2, this._timeStamp = e.q.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = { forceEnablePrecipitation: false, showTerrainProxyTiles: false, fpsWindow: 30, continousRedraw: false, enabledLayers: {} };
              const a2 = ["fill", "line", "symbol", "circle", "heatmap", "fill-extrusion", "building", "raster", "raster-particle", "hillshade", "model", "background", "sky"];
              for (const e2 of a2) this._debugParams.enabledLayers[e2] = true;
              r2.registerParameter(this._debugParams, ["Terrain"], "showTerrainProxyTiles", {}, () => {
                this.style.map.triggerRepaint();
              }), r2.registerParameter(this._debugParams, ["Precipitation"], "forceEnablePrecipitation"), r2.registerParameter(this._debugParams, ["FPS"], "fpsWindow", { min: 1, max: 100, step: 1 }), r2.registerBinding(this._debugParams, ["FPS"], "continousRedraw", { readonly: true, label: "continuous redraw" }), r2.registerBinding(this, ["FPS"], "_averageFPS", { readonly: true, label: "value" }), r2.registerBinding(this, ["FPS"], "_averageFPS", { readonly: true, label: "graph", view: "graph", min: 0, max: 200 });
              for (const e2 of a2) r2.registerParameter(this._debugParams.enabledLayers, ["Debug", "Layers"], e2);
              this.occlusionParams = new Un(r2), this.setup(), this.numSublayers = It.maxUnderzooming + It.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = false, this.replacementSource = new e.et(), this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = false, this._cachedTileFogOpacities = {}, this._shadowRenderer = new so(this), this._wireframeDebugCache = new Nn(), this.renderDefaultNorthPole = true, this.renderDefaultSouthPole = true, this.layersWithOcclusionOpacity = [];
              const l2 = new e.r({ width: 1, height: 1 }, Uint8Array.of(0, 0, 0, 0));
              this.emptyDepthTexture = new e.T(this.context, l2, t2.RGBA8), this._clippingActiveLastFrame = false, this.scaleFactor = s2, this.worldview = n2;
            }
            updateTerrain(e2, t2) {
              const i2 = !!e2 && !!e2.terrain && this.transform.projection.supportsTerrain;
              if (!(i2 || this._terrain && this._terrain.enabled)) return;
              this._terrain || (this._terrain = new qs(this, e2));
              const o2 = this._terrain;
              this.transform.elevation = i2 ? o2 : null, o2.update(e2, this.transform, t2), this.transform.elevation && !o2.enabled && (this.transform.elevation = null);
            }
            _updateFog(e2) {
              const t2 = e2.fog;
              if (!t2 || "globe" === this.transform.projection.name || t2.getOpacity(this.transform.pitch) < 1 || t2.properties.get("horizon-blend") < 0.03) return void (this.transform.fogCullDistSq = null);
              const [i2, o2] = t2.getFovAdjustedRange(this.transform._fov);
              if (i2 > o2) return void (this.transform.fogCullDistSq = null);
              const s2 = i2 + 0.78 * (o2 - i2);
              this.transform.fogCullDistSq = s2 * s2;
            }
            get terrain() {
              return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
            }
            get forceTerrainMode() {
              return this._forceTerrainMode;
            }
            set forceTerrainMode(e2) {
              e2 && !this._terrain && (this._terrain = new qs(this, this.style)), this._forceTerrainMode = e2;
            }
            get shadowRenderer() {
              return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
              return this._wireframeDebugCache;
            }
            resize(t2, i2) {
              if (this.width = t2 * e.q.devicePixelRatio, this.height = i2 * e.q.devicePixelRatio, this.context.viewport.set([0, 0, this.width, this.height]), this.style) for (const e2 of this.style.order) this.style._mergedLayers[e2].resize();
            }
            setup() {
              const t2 = this.context, i2 = new e.ba();
              i2.emplaceBack(0, 0), i2.emplaceBack(e.aj, 0), i2.emplaceBack(0, e.aj), i2.emplaceBack(e.aj, e.aj), this.tileExtentBuffer = t2.createVertexBuffer(i2, e.bc.members), this.tileExtentSegments = e.bd.simpleSegment(0, 0, 4, 2);
              const o2 = new e.ba();
              o2.emplaceBack(0, 0), o2.emplaceBack(e.aj, 0), o2.emplaceBack(0, e.aj), o2.emplaceBack(e.aj, e.aj), this.debugBuffer = t2.createVertexBuffer(o2, e.bc.members), this.debugSegments = e.bd.simpleSegment(0, 0, 4, 5);
              const s2 = new e.ba();
              s2.emplaceBack(-1, -1), s2.emplaceBack(1, -1), s2.emplaceBack(-1, 1), s2.emplaceBack(1, 1), this.viewportBuffer = t2.createVertexBuffer(s2, e.bc.members), this.viewportSegments = e.bd.simpleSegment(0, 0, 4, 2);
              const r2 = new e.aZ();
              r2.emplaceBack(0, 0, 0, 0), r2.emplaceBack(e.aj, 0, e.aj, 0), r2.emplaceBack(0, e.aj, 0, e.aj), r2.emplaceBack(e.aj, e.aj, e.aj, e.aj), this.mercatorBoundsBuffer = t2.createVertexBuffer(r2, e.bf.members), this.mercatorBoundsSegments = e.bd.simpleSegment(0, 0, 4, 2);
              const n2 = new e.a_();
              n2.emplaceBack(0, 1, 2), n2.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t2.createIndexBuffer(n2);
              const a2 = new e.bb();
              for (const e2 of [0, 1, 3, 2, 0]) a2.emplaceBack(e2);
              this.debugIndexBuffer = t2.createIndexBuffer(a2), this.emptyTexture = new e.T(t2, new e.r({ width: 1, height: 1 }, Uint8Array.of(0, 0, 0, 0)), t2.gl.RGBA8), this.identityMat = e.bz();
              const l2 = this.context.gl;
              this.stencilClearMode = new ji({ func: l2.ALWAYS, mask: 0 }, 0, 255, l2.ZERO, l2.ZERO, l2.ZERO), this.loadTimeStamps.push(performance.now());
            }
            getMercatorTileBoundsBuffers() {
              return { tileBoundsBuffer: this.mercatorBoundsBuffer, tileBoundsIndexBuffer: this.quadTriangleIndexBuffer, tileBoundsSegments: this.mercatorBoundsSegments };
            }
            getTileBoundsBuffers(e2) {
              return e2._makeTileBoundsBuffers(this.context, this.transform.projection), e2._tileBoundsBuffer ? { tileBoundsBuffer: e2._tileBoundsBuffer, tileBoundsIndexBuffer: e2._tileBoundsIndexBuffer, tileBoundsSegments: e2._tileBoundsSegments } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
              const e2 = this.context.gl;
              this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, e2.TRIANGLES, Ni.disabled, this.stencilClearMode, ki.disabled, qi.disabled, Ns(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
              this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(e2, t2, i2) {
              if (!t2 || this.currentStencilSource === t2.id || !e2.isTileClipped() || !i2 || 0 === i2.length) return;
              if (this._tileClippingMaskIDs && !this.terrain) {
                let e3 = false;
                for (const t3 of i2) if (void 0 === this._tileClippingMaskIDs[t3.key]) {
                  e3 = true;
                  break;
                }
                if (!e3) return;
              }
              this.currentStencilSource = t2.id;
              const o2 = this.context, s2 = o2.gl;
              this.nextStencilID + i2.length > 256 && this.clearStencil(), o2.setColorMode(ki.disabled), o2.setDepthMode(Ni.disabled);
              const r2 = this.getOrCreateProgram("clippingMask");
              this._tileClippingMaskIDs = {};
              for (const e3 of i2) {
                const i3 = t2.getTile(e3), o3 = this._tileClippingMaskIDs[e3.key] = this.nextStencilID++, { tileBoundsBuffer: n2, tileBoundsIndexBuffer: a2, tileBoundsSegments: l2 } = this.getTileBoundsBuffers(i3);
                r2.draw(this, s2.TRIANGLES, Ni.disabled, new ji({ func: s2.ALWAYS, mask: 0 }, o3, 255, s2.KEEP, s2.KEEP, s2.REPLACE), ki.disabled, qi.disabled, Ns(e3.projMatrix), "$clipping", n2, a2, l2);
              }
            }
            stencilModeFor3D() {
              this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
              const e2 = this.nextStencilID++, t2 = this.context.gl;
              return new ji({ func: t2.NOTEQUAL, mask: 255 }, e2, 255, t2.KEEP, t2.KEEP, t2.REPLACE);
            }
            stencilModeForClipping(e2) {
              if (this.terrain) return this.terrain.stencilModeForRTTOverlap(e2);
              const t2 = this.context.gl;
              return new ji({ func: t2.EQUAL, mask: 255 }, this._tileClippingMaskIDs[e2.key], 0, t2.KEEP, t2.KEEP, t2.REPLACE);
            }
            stencilConfigForOverlap(e2) {
              const t2 = this.context.gl, i2 = e2.sort((e3, t3) => t3.overscaledZ - e3.overscaledZ), o2 = i2[i2.length - 1].overscaledZ, s2 = i2[0].overscaledZ - o2 + 1;
              if (s2 > 1) {
                this.currentStencilSource = void 0, this.nextStencilID + s2 > 256 && this.clearStencil();
                const e3 = {};
                for (let i3 = 0; i3 < s2; i3++) e3[i3 + o2] = new ji({ func: t2.GEQUAL, mask: 255 }, i3 + this.nextStencilID, 255, t2.KEEP, t2.KEEP, t2.REPLACE);
                return this.nextStencilID += s2, [e3, i2];
              }
              return [{ [o2]: ji.disabled }, i2];
            }
            colorModeForRenderPass() {
              const t2 = this.context.gl;
              if (this._showOverdrawInspector) {
                const i2 = 1 / 8;
                return new ki([t2.CONSTANT_COLOR, t2.ONE, t2.CONSTANT_COLOR, t2.ONE], new e.am(i2, i2, i2, 0), [true, true, true, true]);
              }
              return "opaque" === this.renderPass ? ki.unblended : ki.alphaBlended;
            }
            colorModeForDrapableLayerRenderPass(t2) {
              const i2 = this.context.gl;
              return (() => this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? new ki([i2.ONE, i2.ONE_MINUS_SRC_ALPHA, i2.CONSTANT_ALPHA, i2.ONE_MINUS_SRC_ALPHA], new e.am(0, 0, 0, void 0 === t2 ? 0 : t2), [true, true, true, true]) : this.colorModeForRenderPass();
            }
            depthModeForSublayer(e2, t2, i2, o2 = false) {
              if (this.depthOcclusion) return new Ni(this.context.gl.GREATER, Ni.ReadOnly, this.depthRangeFor3D);
              if (!this.opaquePassEnabledForLayer() && !o2) return Ni.disabled;
              const s2 = 1 - ((1 + this.currentLayer) * this.numSublayers + e2) * this.depthEpsilon;
              return new Ni(i2 || this.context.gl.LEQUAL, t2, [s2, s2]);
            }
            opaquePassEnabledForLayer() {
              return this.currentLayer < this.opaquePassCutoff;
            }
            blitDepth() {
              const t2 = this.context.gl, i2 = Math.ceil(this.width), o2 = Math.ceil(this.height), s2 = this.context.bindFramebuffer.get(), r2 = t2.getParameter(t2.TEXTURE_BINDING_2D);
              this.depthFBO && this.depthFBO.width === i2 && this.depthFBO.height === o2 || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i2 && 0 !== o2 && (this.depthFBO = new Ar(this.context, i2, o2, false, "texture"), this.depthTexture = new e.T(this.context, { width: i2, height: o2, data: null }, t2.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(s2), t2.bindTexture(t2.TEXTURE_2D, r2), this.depthFBO && (t2.bindFramebuffer(t2.READ_FRAMEBUFFER, null), t2.bindFramebuffer(t2.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t2.blitFramebuffer(0, 0, i2, o2, 0, 0, i2, o2, t2.DEPTH_BUFFER_BIT, t2.NEAREST), t2.bindFramebuffer(t2.FRAMEBUFFER, this.context.bindFramebuffer.current));
            }
            updateAverageFPS() {
              this._fpsHistory.push(0 === this._dt ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce((e2, t2) => e2 + t2 / this._fpsHistory.length, 0));
            }
            render(t2, i2) {
              const o2 = e.q.now();
              this._dt = o2 - this._timeStamp, this._timeStamp = o2, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = t2.map.repaint, this.style = t2, this.options = i2;
              const s2 = this.style._mergedLayers, r2 = !(!this.terrain || !this.terrain.enabled), n2 = () => this.style._getOrder(r2).filter((e2) => {
                const t3 = s2[e2];
                return !(t3.type in this._debugParams.enabledLayers) || this._debugParams.enabledLayers[t3.type];
              });
              let a2 = n2(), l2 = false, c2 = false;
              for (const e2 of a2) {
                const t3 = s2[e2];
                "circle" === t3.type && (l2 = true), "symbol" === t3.type && (t3.hasInitialOcclusionOpacityProperties ? c2 = true : l2 = true);
              }
              let h3 = a2.map((e2) => s2[e2]);
              const d2 = this.style._mergedSourceCaches;
              this.imageManager = t2.imageManager, this.modelManager = t2.modelManager, this.symbolFadeChange = t2.placement.symbolFadeChange(e.q.now()), this.imageManager.beginFrame();
              let u2 = 0, _2 = false;
              for (const e2 in d2) {
                const t3 = d2[e2];
                t3.used && (t3.prepare(this.context), t3.getSource().usedInConflation && ++u2);
              }
              let p3 = false;
              for (const e2 of h3) e2.isHidden(this.transform.zoom) || ("clip" === e2.type && (p3 = true), this.prepareLayer(e2));
              const f2 = {}, m2 = {}, g2 = {}, v2 = {}, y2 = {};
              for (const e2 in d2) {
                const t3 = d2[e2];
                f2[e2] = t3.getVisibleCoordinates(), m2[e2] = f2[e2].slice().reverse(), g2[e2] = t3.getVisibleCoordinates(true).reverse(), v2[e2] = t3.getShadowCasterCoordinates(), y2[e2] = t3.sortCoordinatesByDistance(f2[e2]);
              }
              const x2 = (e2) => {
                const t3 = this.style.getLayerSourceCache(e2);
                return t3 && t3.used ? t3.getSource() : null;
              };
              if (u2 || p3 || this._clippingActiveLastFrame) {
                const t3 = [], i3 = [];
                let o3 = 0;
                for (const e2 of h3) this.isSourceForClippingOrConflation(e2, x2(e2)) && (t3.push(e2), i3.push(o3)), o3++;
                if (t3 && (p3 || t3.length > 1) || this._clippingActiveLastFrame) {
                  p3 = false;
                  const o4 = [];
                  for (let s3 = 0; s3 < t3.length; s3++) {
                    const r3 = t3[s3], n3 = i3[s3], a3 = this.style.getLayerSourceCache(r3);
                    if (!a3 || !a3.used || !a3.getSource().usedInConflation && "clip" !== r3.type) continue;
                    let l3 = e.eu, c3 = e.bQ.None;
                    const h4 = [];
                    let d3 = true;
                    if ("clip" === r3.type) {
                      l3 = n3;
                      for (const t4 of r3.layout.get("clip-layer-types")) c3 |= "model" === t4 ? e.bQ.Model : "symbol" === t4 ? e.bQ.Symbol : e.bQ.FillExtrusion;
                      for (const e2 of r3.layout.get("clip-layer-scope")) h4.push(e2);
                      r3.isHidden(this.transform.zoom) ? d3 = false : p3 = true;
                    }
                    d3 && o4.push({ layer: r3.fqid, cache: a3, order: l3, clipMask: c3, clipScope: h4 });
                  }
                  this.replacementSource.setSources(o4), _2 = true;
                }
              }
              this._clippingActiveLastFrame = p3, _2 || this.replacementSource.clear(), this.conflationActive = _2, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
              for (let e2 = 0; e2 < h3.length; e2++) {
                const t3 = h3[e2], i3 = t3.cutoffRange();
                if (this.longestCutoffRange = Math.max(i3, this.longestCutoffRange), i3 > 0) {
                  const e3 = x2(t3);
                  e3 && (this.minCutoffZoom = Math.max(e3.minzoom, this.minCutoffZoom)), t3.minzoom && (this.minCutoffZoom = Math.max(t3.minzoom, this.minCutoffZoom));
                }
                t3.is3D(r2) && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e2), this._lastOcclusionLayer = e2);
              }
              const b2 = this.style && this.style.fog;
              b2 ? (this._fogVisible = 0 !== b2.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = b2.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = false, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(g2), this.opaquePassCutoff = 0, a2 = n2(), h3 = a2.map((e2) => s2[e2]));
              const w2 = this._shadowRenderer;
              if (w2) {
                w2.updateShadowParameters(this.transform, this.style.directionalLight);
                for (const e2 in d2) for (const t3 of f2[e2]) {
                  let e3 = { min: 0, max: 0 };
                  this.terrain && (e3 = this.terrain.getMinMaxForTile(t3) || e3), w2.addShadowReceiver(t3.toUnwrapped(), e3.min, e3.max);
                }
              }
              "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e.ev(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new En(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0);
              const T2 = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.snow), E2 = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.rain);
              if (T2 && !this._snow && (this._snow = new Qn(this)), !T2 && this._snow && (this._snow.destroy(), delete this._snow), E2 && !this._rain && (this._rain = new Kn(this)), !E2 && this._rain && (this._rain.destroy(), delete this._rain), this._snow && this._snow.update(this), this._rain && this._rain.update(this), !U.has(this.context.gl)) return;
              this.renderPass = "offscreen";
              for (const e2 of h3) {
                const i3 = t2.getLayerSourceCache(e2);
                if (!e2.hasOffscreenPass() || e2.isHidden(this.transform.zoom)) continue;
                const o3 = i3 ? m2[i3.id] : void 0;
                ("custom" === e2.type || "raster" === e2.type || "raster-particle" === e2.type || e2.isSky() || o3 && o3.length) && this.renderLayer(this, i3, e2, o3);
              }
              this.depthRangeFor3D = [0, 1 - (h3.length + 2) * this.numSublayers * this.depthEpsilon], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, v2)), this.context.bindFramebuffer.set(null), this.context.viewport.set([0, 0, this.width, this.height]);
              const S2 = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), I2 = (() => {
                if (i2.showOverdrawInspector) return e.am.black;
                const t3 = this.style.fog;
                if (t3 && this.transform.projection.supportsFog) {
                  const i3 = this.style.getLut(t3.scope);
                  if (!S2) {
                    const o3 = "none" === t3.properties.get("color-use-theme"), s3 = t3.properties.get("color").toNonPremultipliedRenderColor(o3 ? null : i3).toArray01();
                    return new e.am(...s3);
                  }
                  if (S2) {
                    const o3 = "none" === t3.properties.get("space-color-use-theme"), s3 = t3.properties.get("space-color").toNonPremultipliedRenderColor(o3 ? null : i3).toArray01();
                    return new e.am(...s3);
                  }
                }
                return e.am.transparent;
              })();
              if (this.context.clear({ color: I2, depth: 1 }), this.clearStencil(), this._showOverdrawInspector = i2.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && S2 && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for (this.currentLayer = a2.length - 1; this.currentLayer >= 0; this.currentLayer--) {
                const e2 = h3[this.currentLayer], i3 = t2.getLayerSourceCache(e2);
                if (e2.isSky()) continue;
                const o3 = i3 ? (e2.is3D(r2) ? y2 : m2)[i3.id] : void 0;
                this._renderTileClippingMasks(e2, i3, o3), this.renderLayer(this, i3, e2, o3);
              }
              if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && S2 && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e.ah(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for (this.currentLayer = 0; this.currentLayer < a2.length; this.currentLayer++) {
                const e2 = h3[this.currentLayer], i3 = t2.getLayerSourceCache(e2);
                e2.isSky() && this.renderLayer(this, i3, e2, i3 ? m2[i3.id] : void 0);
              }
              function C2(e2, t3) {
                let i3;
                return t3 && (i3 = ("symbol" === e2.type ? g2 : e2.is3D(r2) ? y2 : m2)[t3.id]), i3;
              }
              if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
                for (this.renderElevatedRasterBackface = true, this.currentLayer = 0; this.currentLayer < a2.length; ) {
                  const e2 = h3[this.currentLayer];
                  if ("raster" === e2.type || "raster-particle" === e2.type) {
                    const i3 = t2.getLayerSourceCache(e2);
                    this.renderLayer(this, i3, e2, C2(e2, i3));
                  }
                  ++this.currentLayer;
                }
                this.renderElevatedRasterBackface = false;
              }
              this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
              let R2 = 0;
              w2 && (R2 = w2.getShadowCastingLayerCount());
              let D2 = false, A2 = -1;
              for (let e2 = 0; e2 < a2.length; ++e2) {
                const t3 = h3[e2];
                t3.isHidden(this.transform.zoom) || t3.is3D(r2) && (A2 = e2);
              }
              c2 && -1 === A2 && (l2 = true);
              let L2 = false;
              for (; this.currentLayer < a2.length; ) {
                const e2 = h3[this.currentLayer], i3 = t2.getLayerSourceCache(e2);
                if (e2.isSky()) ++this.currentLayer;
                else if (this.terrain && this.style.isLayerDraped(e2)) {
                  if (e2.isHidden(this.transform.zoom)) {
                    ++this.currentLayer;
                    continue;
                  }
                  this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
                } else {
                  if (!L2 && e2.is3D(r2) && !r2) {
                    const e3 = this.currentLayer, t3 = (e4) => {
                      for (this.currentLayer = 0; this.currentLayer < h3.length; this.currentLayer++) {
                        const t4 = h3[this.currentLayer];
                        if (ia[t4.type]) {
                          const i4 = this.style.getLayerSourceCache(t4);
                          ia[t4.type](this, i4, t4, C2(t4, i4), e4);
                        }
                      }
                    };
                    t3("initialize"), t3("reset"), this.currentLayer = e3, L2 = true;
                  }
                  if (l2 && !D2 && this.terrain && !this.transform.isOrthographic && (D2 = true, this.blitDepth()), c2 && -1 !== A2 && this.currentLayer === A2 + 1 && !this.transform.isOrthographic && this.blitDepth(), this.terrain || this._renderTileClippingMasks(e2, i3, i3 ? f2[i3.id] : void 0), this.renderLayer(this, i3, e2, C2(e2, i3)), !this.terrain && w2 && R2 > 0 && e2.hasShadowPass() && 0 == --R2) {
                    {
                      this.clearStencil();
                      const e3 = this.currentLayer;
                      for (this.currentLayer = 0; this.currentLayer < h3.length; this.currentLayer++) {
                        const e4 = h3[this.currentLayer];
                        if (oa[e4.type]) {
                          const t3 = this.style.getLayerSourceCache(e4);
                          oa[e4.type](this, t3, e4, C2(e4, t3));
                        }
                      }
                      this.currentLayer = e3;
                    }
                    if (w2.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer) {
                      const e3 = this.currentLayer;
                      for (this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e3; this.currentLayer++) {
                        const e4 = h3[this.currentLayer];
                        if (!e4.hasLightBeamPass()) continue;
                        const i4 = t2.getLayerSourceCache(e4);
                        this.renderLayer(this, i4, e4, i4 ? m2[i4.id] : void 0);
                      }
                      this.currentLayer = e3, this.renderPass = "translucent";
                    }
                  }
                  if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                    const e3 = this.currentLayer;
                    this.depthOcclusion = true;
                    for (const e4 of this.layersWithOcclusionOpacity) {
                      this.currentLayer = e4;
                      const i4 = h3[this.currentLayer], o3 = t2.getLayerSourceCache(i4), s3 = o3 ? m2[o3.id] : void 0;
                      this.terrain || this._renderTileClippingMasks(i4, o3, o3 ? f2[o3.id] : void 0), this.renderLayer(this, o3, i4, s3);
                    }
                    this.depthOcclusion = false, this.currentLayer = e3, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
                  }
                  ++this.currentLayer;
                }
              }
              if (this.terrain && this.terrain.postRender(), this._snow && this._snow.draw(this), this._rain && this._rain.draw(this), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                let i3 = null;
                h3.forEach((e2) => {
                  const o3 = t2.getLayerSourceCache(e2);
                  o3 && !e2.isHidden(this.transform.zoom) && o3.getVisibleCoordinates().length && (!i3 || i3.getSource().maxzoom < o3.getSource().maxzoom) && (i3 = o3);
                }), i3 && this.options.showTileBoundaries && hn(this, i3, i3.getVisibleCoordinates(), e.am.red, false, this.options.showParseStatus);
              }
              this.terrain && this._debugParams.showTerrainProxyTiles && hn(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new e.am(1, 0.8, 0.1, 1), true, this.options.showParseStatus), this.options.showPadding && function(e2) {
                const t3 = e2.transform.padding;
                un(e2, e2.transform.height - (t3.top || 0), 3, rn), un(e2, t3.bottom || 0, 3, nn), _n(e2, t3.left || 0, 3, an), _n(e2, e2.transform.width - (t3.right || 0), 3, ln);
                const i3 = e2.transform.centerPoint;
                !function(e3, t4, i4, o3) {
                  pn(e3, t4 - 1, i4 - 10, 2, 20, o3), pn(e3, t4 - 10, i4 - 1, 20, 2, o3);
                }(e2, i3.x, e2.transform.height - i3.y, cn);
              }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), _2 || (this.conflationActive = false);
            }
            prepareLayer(e2) {
              this.gpuTimingStart(e2);
              const { unsupportedLayers: t2 } = this.transform.projection, i2 = !t2 || !t2.includes(e2.type);
              if (ta[e2.type] && (i2 || this.terrain && "custom" === e2.type)) {
                const t3 = this.style.getLayerSourceCache(e2);
                ta[e2.type](e2, t3, this);
              }
              this.gpuTimingEnd();
            }
            renderLayer(e2, t2, i2, o2) {
              i2.isHidden(this.transform.zoom) || ("background" === i2.type || "sky" === i2.type || "custom" === i2.type || "model" === i2.type || "raster" === i2.type || "raster-particle" === i2.type || o2 && o2.length) && (this.id = i2.id, this.gpuTimingStart(i2), e2.transform.projection.unsupportedLayers && e2.transform.projection.unsupportedLayers.includes(i2.type) && (!e2.terrain || "custom" !== i2.type) || "clip" === i2.type || ea[i2.type](e2, t2, i2, o2, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e2) {
              if (!this.options.gpuTiming) return;
              const t2 = this.context.extTimerQuery, i2 = this.context.gl;
              let o2 = this.gpuTimers[e2.id];
              o2 || (o2 = this.gpuTimers[e2.id] = { calls: 0, cpuTime: 0, query: i2.createQuery() }), o2.calls++, i2.beginQuery(t2.TIME_ELAPSED_EXT, o2.query);
            }
            gpuTimingDeferredRenderStart() {
              if (this.options.gpuTimingDeferredRender) {
                const e2 = this.context.extTimerQuery, t2 = this.context.gl, i2 = t2.createQuery();
                this.deferredRenderGpuTimeQueries.push(i2), t2.beginQuery(e2.TIME_ELAPSED_EXT, i2);
              }
            }
            gpuTimingDeferredRenderEnd() {
              this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
              this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
              const e2 = this.gpuTimers;
              return this.gpuTimers = {}, e2;
            }
            collectDeferredRenderGpuQueries() {
              const e2 = this.deferredRenderGpuTimeQueries;
              return this.deferredRenderGpuTimeQueries = [], e2;
            }
            queryGpuTimers(e2) {
              const t2 = {};
              for (const i2 in e2) {
                const o2 = e2[i2], s2 = this.context.extTimerQuery, r2 = s2.getQueryParameter(o2.query, this.context.gl.QUERY_RESULT) / 1e6;
                s2.deleteQueryEXT(o2.query), t2[i2] = r2;
              }
              return t2;
            }
            queryGpuTimeDeferredRender(e2) {
              if (!this.options.gpuTimingDeferredRender) return 0;
              const t2 = this.context.gl;
              let i2 = 0;
              for (const o2 of e2) i2 += t2.getQueryParameter(o2, t2.QUERY_RESULT) / 1e6, t2.deleteQuery(o2);
              return i2;
            }
            translatePosMatrix(t2, i2, o2, s2, r2) {
              if (!o2[0] && !o2[1]) return t2;
              const n2 = r2 ? "map" === s2 ? this.transform.angle : 0 : "viewport" === s2 ? -this.transform.angle : 0;
              if (n2) {
                const e2 = Math.sin(n2), t3 = Math.cos(n2);
                o2 = [o2[0] * t3 - o2[1] * e2, o2[0] * e2 + o2[1] * t3];
              }
              const a2 = [r2 ? o2[0] : e.aw(i2, o2[0], this.transform.zoom), r2 ? o2[1] : e.aw(i2, o2[1], this.transform.zoom), 0], l2 = new Float32Array(16);
              return e.bo(l2, t2, a2), l2;
            }
            saveTileTexture(e2) {
              const t2 = e2.size[0], i2 = this._tileTextures[t2];
              i2 ? i2.push(e2) : this._tileTextures[t2] = [e2];
            }
            getTileTexture(e2) {
              const t2 = this._tileTextures[e2];
              return t2 && t2.length > 0 ? t2.pop() : null;
            }
            terrainRenderModeElevated() {
              return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
            }
            linearFloatFilteringSupported() {
              return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e2, t2, i2) {
              const o2 = void 0 === i2 ? this.terrain && this.terrain.renderingToTexture : i2, s2 = [];
              return this.style && this.style.enable3dLights() && ("globeRaster" === e2 || "terrainRaster" === e2 ? (s2.push("LIGHTING_3D_MODE"), s2.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o2 || s2.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass && (this._shadowMapDebug || s2.push("DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (s2.push("TERRAIN"), this.linearFloatFilteringSupported() && s2.push("TERRAIN_DEM_FLOAT_FORMAT")), "globe" === this.transform.projection.name && s2.push("GLOBE"), !this._fogVisible || o2 || void 0 !== t2 && !t2 || s2.push("FOG", "FOG_DITHERING"), o2 && s2.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && s2.push("OVERDRAW_INSPECTOR"), s2;
            }
            getOrCreateProgram(e2, t2) {
              this.cache = this.cache || {};
              const i2 = t2 && t2.defines || [], o2 = t2 && t2.config, s2 = this.currentGlobalDefines(e2, t2 && t2.overrideFog, t2 && t2.overrideRtt).concat(i2), r2 = $s.cacheKey(jo[e2], e2, s2, o2);
              return this.cache[r2] || (this.cache[r2] = new $s(this.context, e2, jo[e2], o2, Ir[e2], s2)), this.cache[r2];
            }
            setCustomLayerDefaults() {
              this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
              const e2 = this.context.gl;
              this.context.cullFace.set(false), this.context.viewport.set([0, 0, this.width, this.height]), this.context.blendEquation.set(e2.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
              null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
            }
            destroy() {
              this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
            }
            prepareDrawTile() {
              this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(t2, i2) {
              if (this.style.enable3dLights()) {
                const o2 = this.style.directionalLight, s2 = this.style.ambientLight;
                if (o2 && s2) {
                  const r2 = ((t3, i3, o3) => {
                    const s3 = t3.properties.get("direction"), r3 = "none" === t3.properties.get("color-use-theme"), n2 = t3.properties.get("color").toNonPremultipliedRenderColor(r3 ? null : o3.getLut(t3.scope)).toArray01(), a2 = t3.properties.get("intensity"), l2 = "none" === i3.properties.get("color-use-theme"), c2 = i3.properties.get("color").toNonPremultipliedRenderColor(l2 ? null : o3.getLut(i3.scope)).toArray01(), h3 = i3.properties.get("intensity"), d2 = [s3.x, s3.y, s3.z], u2 = e.dw(c2, h3), _2 = e.dw(n2, a2);
                    return { u_lighting_ambient_color: u2, u_lighting_directional_dir: d2, u_lighting_directional_color: _2, u_ground_radiance: Zs(d2, _2, u2) };
                  })(o2, s2, this.style);
                  i2.setLightsUniformValues(t2, r2);
                }
              }
            }
            uploadCommonUniforms(t2, i2, o2, s2, r2) {
              if (this.uploadCommonLightUniforms(t2, i2), this.terrain && this.terrain.renderingToTexture) return;
              const n2 = this.style.fog;
              if (n2) {
                const r3 = n2.getOpacity(this.transform.pitch), a2 = ((t3, i3, o3, s3, r4, n3, a3, l2, c2, h3, d2, u2) => {
                  const _2 = t3.transform, p3 = "none" === i3.properties.get("color-use-theme"), f2 = i3.properties.get("color").toNonPremultipliedRenderColor(p3 ? null : t3.style.getLut(i3.scope)).toArray01();
                  f2[3] = s3;
                  const m2 = t3.frameCounter / 1e3 % 1, [g2, v2] = i3.properties.get("vertical-range");
                  return { u_fog_matrix: o3 ? _2.calculateFogTileMatrix(o3) : u2 || t3.identityMat, u_fog_range: i3.getFovAdjustedRange(_2._fov), u_fog_color: f2, u_fog_horizon_blend: i3.properties.get("horizon-blend"), u_fog_vertical_limit: [Math.min(g2, v2), v2], u_fog_temporal_offset: m2, u_frustum_tl: r4, u_frustum_tr: n3, u_frustum_br: a3, u_frustum_bl: l2, u_globe_pos: c2, u_globe_radius: h3, u_viewport: d2, u_globe_transition: e.ah(_2.zoom), u_is_globe: +("globe" === _2.projection.name) };
                })(this, n2, o2, r3, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [this.transform.width * e.q.devicePixelRatio, this.transform.height * e.q.devicePixelRatio], s2);
                i2.setFogUniformValues(t2, a2);
              }
              r2 && i2.setCutoffUniformValues(t2, r2.uniformValues);
            }
            setTileLoadedFlag(e2) {
              this.tileLoaded = e2;
            }
            saveCanvasCopy() {
              const e2 = this.canvasCopy();
              e2 && (this.frameCopies.push(e2), this.tileLoaded = false);
            }
            canvasCopy() {
              const e2 = this.context.gl, t2 = e2.createTexture();
              return e2.bindTexture(e2.TEXTURE_2D, t2), e2.copyTexImage2D(e2.TEXTURE_2D, 0, e2.RGBA, 0, 0, e2.drawingBufferWidth, e2.drawingBufferHeight, 0), t2;
            }
            getCanvasCopiesAndTimestamps() {
              return { canvasCopies: this.frameCopies, timeStamps: this.loadTimeStamps };
            }
            averageElevationNeedsEasing() {
              if (!this.transform._elevation) return false;
              const e2 = this.style && this.style.fog;
              return !!e2 && 0 !== e2.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
              const e2 = this._backgroundTiles, t2 = this._backgroundTiles = {}, i2 = this.transform.coveringTiles({ tileSize: 512 });
              for (const o2 of i2) t2[o2.key] = e2[o2.key] || new wt(o2, 512, this.transform.tileZoom, this, void 0, this.worldview);
              return t2;
            }
            clearBackgroundTiles() {
              this._backgroundTiles = {};
            }
            isSourceForClippingOrConflation(e2, t2) {
              return !(!e2.is3D(!(!this.terrain || !this.terrain.enabled)) || "clip" !== e2.type && (e2.minzoom && e2.minzoom > this.transform.zoom || (this.style._clipLayerPresent || "building" !== e2.sourceLayer) && (!t2 || "batched-model" !== t2.type)));
            }
            isTileAffectedByFog(e2) {
              if (!this.style || !this.style.fog) return false;
              if ("globe" === this.transform.projection.name) return true;
              let t2 = this._cachedTileFogOpacities[e2.key];
              return t2 || (this._cachedTileFogOpacities[e2.key] = t2 = this.style.fog.getOpacityForTile(e2)), t2[0] >= Fe || t2[1] >= Fe;
            }
            setupDepthForOcclusion(e2, t2, i2) {
              const o2 = this.context, s2 = o2.gl, r2 = !!i2;
              var n2;
              i2 || (i2 = { u_dem: 2, u_dem_prev: 4, u_dem_tl: [0, 0], u_dem_tl_prev: [0, 0], u_dem_scale: 0, u_dem_scale_prev: 0, u_dem_size: 0, u_dem_lerp: 1, u_depth: 3, u_depth_size_inv: [0, 0], u_depth_range_unpack: [0, 1], u_occluder_half_size: 16, u_occlusion_depth_offset: -1e-4, u_exaggeration: 0 }), o2.activeTexture.set(s2.TEXTURE3), e2 && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(s2.NEAREST, s2.CLAMP_TO_EDGE), i2.u_depth_size_inv = [1 / this.depthFBO.width, 1 / this.depthFBO.height], i2.u_depth_range_unpack = [2 / ((n2 = this.depthRangeFor3D)[1] - n2[0]), -1 - 2 * n2[0] / (n2[1] - n2[0])], i2.u_occluder_half_size = 0.5 * this.occlusionParams.occluderSize, i2.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(s2.NEAREST, s2.CLAMP_TO_EDGE), o2.activeTexture.set(s2.TEXTURE0), r2 || t2.setTerrainUniformValues(o2, i2);
            }
          }
          function ra(e2, t2) {
            let i2 = false, o2 = null;
            const s2 = () => {
              o2 = null, i2 && (e2(), o2 = setTimeout(s2, t2), i2 = false);
            };
            return () => (i2 = true, o2 || s2(), o2);
          }
          class na {
            constructor(t2) {
              this._hashName = t2 && encodeURIComponent(t2), e.aV(["_getCurrentHash", "_onHashChange", "_updateHash"], this), this._updateHash = ra(this._updateHashUnthrottled.bind(this), 300);
            }
            addTo(e2) {
              return this._map = e2, window.addEventListener("hashchange", this._onHashChange, false), e2.on("moveend", this._updateHash), this;
            }
            remove() {
              return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, false), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
              const e2 = this._map;
              if (!e2) return "";
              const t2 = aa(e2);
              if (this._hashName) {
                const e3 = this._hashName;
                let i2 = false;
                const o2 = location.hash.slice(1).split("&").map((o3) => {
                  const s2 = o3.split("=")[0];
                  return s2 === e3 ? (i2 = true, `${s2}=${t2}`) : o3;
                }).filter((e4) => e4);
                return i2 || o2.push(`${e3}=${t2}`), `#${o2.join("&")}`;
              }
              return `#${t2}`;
            }
            _getCurrentHash() {
              const e2 = location.hash.replace("#", "");
              if (this._hashName) {
                let t2;
                return e2.split("&").map((e3) => e3.split("=")).forEach((e3) => {
                  e3[0] === this._hashName && (t2 = e3);
                }), (t2 && t2[1] || "").split("/");
              }
              return e2.split("/");
            }
            _onHashChange() {
              const e2 = this._map;
              if (!e2) return false;
              const t2 = this._getCurrentHash();
              if (t2.length >= 3 && !t2.some((e3) => isNaN(Number(e3)))) {
                const i2 = e2.dragRotate.isEnabled() && e2.touchZoomRotate.isEnabled() ? +(t2[3] || 0) : e2.getBearing();
                return e2.jumpTo({ center: [+t2[2], +t2[1]], zoom: +t2[0], bearing: i2, pitch: +(t2[4] || 0) }), true;
              }
              return false;
            }
            _updateHashUnthrottled() {
              history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
            }
          }
          function aa(e2, t2) {
            const i2 = e2.getCenter(), o2 = Math.round(100 * e2.getZoom()) / 100, s2 = Math.ceil((o2 * Math.LN2 + Math.log(512 / 360 / 0.5)) / Math.LN10), r2 = Math.pow(10, s2), n2 = Math.round(i2.lng * r2) / r2, a2 = Math.round(i2.lat * r2) / r2, l2 = e2.getBearing(), c2 = e2.getPitch();
            let h3 = t2 ? `/${n2}/${a2}/${o2}` : `${o2}/${a2}/${n2}`;
            return (l2 || c2) && (h3 += "/" + Math.round(10 * l2) / 10), c2 && (h3 += `/${Math.round(c2)}`), h3;
          }
          const la = { linearity: 0.3, easing: e.ew(0, 0, 0.3, 1) }, ca = e.h({ deceleration: 2500, maxSpeed: 1400 }, la), ha = e.h({ deceleration: 20, maxSpeed: 1400 }, la), da = e.h({ deceleration: 1e3, maxSpeed: 360 }, la), ua = e.h({ deceleration: 1e3, maxSpeed: 90 }, la);
          class _a {
            constructor(e2) {
              this._map = e2, this.clear();
            }
            clear() {
              this._inertiaBuffer = [];
            }
            record(t2) {
              this._drainInertiaBuffer(), this._inertiaBuffer.push({ time: e.q.now(), settings: t2 });
            }
            _drainInertiaBuffer() {
              const t2 = this._inertiaBuffer, i2 = e.q.now();
              for (; t2.length > 0 && i2 - t2[0].time > 160; ) t2.shift();
            }
            _onMoveEnd(t2) {
              if (this._map._prefersReducedMotion()) return;
              if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
              const i2 = { zoom: 0, bearing: 0, pitch: 0, pan: new e.P(0, 0), pinchAround: void 0, around: void 0 };
              for (const { settings: e2 } of this._inertiaBuffer) i2.zoom += e2.zoomDelta || 0, i2.bearing += e2.bearingDelta || 0, i2.pitch += e2.pitchDelta || 0, e2.panDelta && i2.pan._add(e2.panDelta), e2.around && (i2.around = e2.around), e2.pinchAround && (i2.pinchAround = e2.pinchAround);
              const o2 = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, s2 = {};
              if (i2.pan.mag()) {
                const r2 = fa(i2.pan.mag(), o2, e.h({}, ca, t2 || {}));
                s2.offset = i2.pan.mult(r2.amount / i2.pan.mag()), s2.center = this._map.transform.center, pa(s2, r2);
              }
              if (i2.zoom) {
                const e2 = fa(i2.zoom, o2, ha);
                s2.zoom = this._map.transform.zoom + e2.amount, pa(s2, e2);
              }
              if (i2.bearing) {
                const t3 = fa(i2.bearing, o2, da);
                s2.bearing = this._map.transform.bearing + e.ay(t3.amount, -179, 179), pa(s2, t3);
              }
              if (i2.pitch) {
                const e2 = fa(i2.pitch, o2, ua);
                s2.pitch = this._map.transform.pitch + e2.amount, pa(s2, e2);
              }
              if (s2.zoom || s2.bearing) {
                const e2 = void 0 === i2.pinchAround ? i2.around : i2.pinchAround;
                s2.around = e2 ? this._map.unproject(e2) : this._map.getCenter();
              }
              return this.clear(), s2.noMoveStart = true, s2;
            }
          }
          function pa(e2, t2) {
            (!e2.duration || e2.duration < t2.duration) && (e2.duration = t2.duration, e2.easing = t2.easing);
          }
          function fa(t2, i2, o2) {
            const { maxSpeed: s2, linearity: r2, deceleration: n2 } = o2, a2 = e.ay(t2 * r2 / (i2 / 1e3), -s2, s2), l2 = Math.abs(a2) / (n2 * r2);
            return { easing: o2.easing, duration: 1e3 * l2, amount: a2 * (l2 / 2) };
          }
          class ma extends e.A {
            preventDefault() {
              this._defaultPrevented = true;
            }
            get defaultPrevented() {
              return this._defaultPrevented;
            }
            constructor(t2, i2, o2, s2 = {}) {
              const r2 = g(i2.getCanvasContainer(), o2), n2 = i2.unproject(r2);
              super(t2, e.h({ point: r2, lngLat: n2, originalEvent: o2 }, s2)), this._defaultPrevented = false, this.target = i2;
            }
          }
          class ga extends e.A {
            preventDefault() {
              this._defaultPrevented = true;
            }
            get defaultPrevented() {
              return this._defaultPrevented;
            }
            constructor(t2, i2, o2) {
              const s2 = "touchend" === t2 ? o2.changedTouches : o2.touches, r2 = v(i2.getCanvasContainer(), s2), n2 = r2.map((e2) => i2.unproject(e2)), a2 = r2.reduce((e2, t3, i3, o3) => e2.add(t3.div(o3.length)), new e.P(0, 0));
              super(t2, { points: r2, point: a2, lngLats: n2, lngLat: i2.unproject(a2), originalEvent: o2 }), this._defaultPrevented = false;
            }
          }
          class va extends e.A {
            preventDefault() {
              this._defaultPrevented = true;
            }
            get defaultPrevented() {
              return this._defaultPrevented;
            }
            constructor(e2, t2) {
              super("wheel", { originalEvent: t2 }), this._defaultPrevented = false;
            }
          }
          class ya {
            constructor(e2, t2) {
              this._map = e2, this._clickTolerance = t2.clickTolerance;
            }
            reset() {
              this._mousedownPos = void 0;
            }
            wheel(e2) {
              return this._firePreventable(new va(this._map, e2));
            }
            mousedown(e2, t2) {
              return this._mousedownPos = t2, this._firePreventable(new ma(e2.type, this._map, e2));
            }
            mouseup(e2) {
              this._map.fire(new ma(e2.type, this._map, e2));
            }
            preclick(t2) {
              const i2 = e.h({}, t2);
              i2.type = "preclick", this._map.fire(new ma(i2.type, this._map, i2));
            }
            click(e2, t2) {
              this._mousedownPos && this._mousedownPos.dist(t2) >= this._clickTolerance || (this.preclick(e2), this._map.fire(new ma(e2.type, this._map, e2)));
            }
            dblclick(e2) {
              return this._firePreventable(new ma(e2.type, this._map, e2));
            }
            mouseover(e2) {
              this._map.fire(new ma(e2.type, this._map, e2));
            }
            mouseout(e2) {
              this._map.fire(new ma(e2.type, this._map, e2));
            }
            touchstart(e2) {
              return this._firePreventable(new ga(e2.type, this._map, e2));
            }
            touchmove(e2) {
              this._map.fire(new ga(e2.type, this._map, e2));
            }
            touchend(e2) {
              this._map.fire(new ga(e2.type, this._map, e2));
            }
            touchcancel(e2) {
              this._map.fire(new ga(e2.type, this._map, e2));
            }
            _firePreventable(e2) {
              if (this._map.fire(e2), e2.defaultPrevented) return {};
            }
            isEnabled() {
              return true;
            }
            isActive() {
              return false;
            }
            enable() {
            }
            disable() {
            }
          }
          class xa {
            constructor(e2) {
              this._map = e2;
            }
            reset() {
              this._delayContextMenu = false, this._contextMenuEvent = void 0;
            }
            mousemove(e2) {
              this._map.fire(new ma(e2.type, this._map, e2));
            }
            mousedown() {
              this._delayContextMenu = true;
            }
            mouseup() {
              this._delayContextMenu = false, this._contextMenuEvent && (this._map.fire(new ma("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e2) {
              this._delayContextMenu ? this._contextMenuEvent = e2 : this._map.fire(new ma(e2.type, this._map, e2)), this._map.listens("contextmenu") && e2.preventDefault();
            }
            isEnabled() {
              return true;
            }
            isActive() {
              return false;
            }
            enable() {
            }
            disable() {
            }
          }
          class ba {
            constructor(e2, t2) {
              this._map = e2, this._el = e2.getCanvasContainer(), this._container = e2.getContainer(), this._clickTolerance = t2.clickTolerance || 1;
            }
            isEnabled() {
              return !!this._enabled;
            }
            isActive() {
              return !!this._active;
            }
            enable() {
              this.isEnabled() || (this._enabled = true);
            }
            disable() {
              this.isEnabled() && (this._enabled = false);
            }
            mousedown(e2, t2) {
              this.isEnabled() && e2.shiftKey && 0 === e2.button && (_(), this._startPos = this._lastPos = t2, this._active = true);
            }
            mousemoveWindow(e2, t2) {
              if (!this._active) return;
              const i2 = t2, o2 = this._startPos, s2 = this._lastPos;
              if (!o2 || !s2 || s2.equals(i2) || !this._box && i2.dist(o2) < this._clickTolerance) return;
              this._lastPos = i2, this._box || (this._box = l("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e2));
              const r2 = Math.min(o2.x, i2.x), n2 = Math.max(o2.x, i2.x), a2 = Math.min(o2.y, i2.y), c2 = Math.max(o2.y, i2.y);
              this._map._requestDomTask(() => {
                this._box && (this._box.style.transform = `translate(${r2}px,${a2}px)`, this._box.style.width = n2 - r2 + "px", this._box.style.height = c2 - a2 + "px");
              });
            }
            mouseupWindow(t2, i2) {
              if (!this._active) return;
              const o2 = this._startPos, s2 = i2;
              if (o2 && 0 === t2.button) {
                if (this.reset(), m(), o2.x !== s2.x || o2.y !== s2.y) return this._map.fire(new e.A("boxzoomend", { originalEvent: t2 })), { cameraAnimation: (e2) => e2.fitScreenCoordinates(o2, s2, this._map.getBearing(), { linear: false }) };
                this._fireEvent("boxzoomcancel", t2);
              }
            }
            keydown(e2) {
              this._active && 27 === e2.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e2));
            }
            blur() {
              this.reset();
            }
            reset() {
              this._active = false, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), p2(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t2, i2) {
              return this._map.fire(new e.A(t2, { originalEvent: i2 }));
            }
          }
          function wa(e2, t2) {
            const i2 = {};
            for (let o2 = 0; o2 < e2.length; o2++) i2[e2[o2].identifier] = t2[o2];
            return i2;
          }
          class Ta {
            constructor(e2) {
              this.reset(), this.numTouches = e2.numTouches;
            }
            reset() {
              this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = false;
            }
            touchstart(t2, i2, o2) {
              (this.centroid || o2.length > this.numTouches) && (this.aborted = true), this.aborted || (0 === this.startTime && (this.startTime = t2.timeStamp), o2.length === this.numTouches && (this.centroid = function(t3) {
                const i3 = new e.P(0, 0);
                for (const e2 of t3) i3._add(e2);
                return i3.div(t3.length);
              }(i2), this.touches = wa(o2, i2)));
            }
            touchmove(e2, t2, i2) {
              if (this.aborted || !this.centroid) return;
              const o2 = wa(i2, t2);
              for (const e3 in this.touches) {
                const t3 = o2[e3];
                (!t3 || t3.dist(this.touches[e3]) > 30) && (this.aborted = true);
              }
            }
            touchend(e2, t2, i2) {
              if ((!this.centroid || e2.timeStamp - this.startTime > 500) && (this.aborted = true), 0 === i2.length) {
                const e3 = !this.aborted && this.centroid;
                if (this.reset(), e3) return e3;
              }
            }
          }
          class Ea {
            constructor(e2) {
              this.singleTap = new Ta(e2), this.numTaps = e2.numTaps, this.reset();
            }
            reset() {
              this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e2, t2, i2) {
              this.singleTap.touchstart(e2, t2, i2);
            }
            touchmove(e2, t2, i2) {
              this.singleTap.touchmove(e2, t2, i2);
            }
            touchend(e2, t2, i2) {
              const o2 = this.singleTap.touchend(e2, t2, i2);
              if (o2) {
                const t3 = e2.timeStamp - this.lastTime < 500, i3 = !this.lastTap || this.lastTap.dist(o2) < 30;
                if (t3 && i3 || this.reset(), this.count++, this.lastTime = e2.timeStamp, this.lastTap = o2, this.count === this.numTaps) return this.reset(), o2;
              }
            }
          }
          class Sa {
            constructor() {
              this._zoomIn = new Ea({ numTouches: 1, numTaps: 2 }), this._zoomOut = new Ea({ numTouches: 2, numTaps: 1 }), this.reset();
            }
            reset() {
              this._active = false, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e2, t2, i2) {
              this._zoomIn.touchstart(e2, t2, i2), this._zoomOut.touchstart(e2, t2, i2);
            }
            touchmove(e2, t2, i2) {
              this._zoomIn.touchmove(e2, t2, i2), this._zoomOut.touchmove(e2, t2, i2);
            }
            touchend(e2, t2, i2) {
              const o2 = this._zoomIn.touchend(e2, t2, i2), s2 = this._zoomOut.touchend(e2, t2, i2);
              return o2 ? (this._active = true, e2.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t3) => t3.easeTo({ duration: 300, zoom: t3.getZoom() + 1, around: t3.unproject(o2) }, { originalEvent: e2 }) }) : s2 ? (this._active = true, e2.preventDefault(), setTimeout(() => this.reset(), 0), { cameraAnimation: (t3) => t3.easeTo({ duration: 300, zoom: t3.getZoom() - 1, around: t3.unproject(s2) }, { originalEvent: e2 }) }) : void 0;
            }
            touchcancel() {
              this.reset();
            }
            enable() {
              this._enabled = true;
            }
            disable() {
              this._enabled = false, this.reset();
            }
            isEnabled() {
              return this._enabled;
            }
            isActive() {
              return this._active;
            }
          }
          const Ia = { 0: 1, 2: 2 }, Ca = { Control: "ctrlKey", Alt: "altKey", Shift: "shiftKey", Meta: "metaKey" };
          class Ra {
            constructor(e2) {
              this.reset(), this._clickTolerance = e2.clickTolerance || 1;
            }
            blur() {
              this.reset();
            }
            reset() {
              this._active = false, this._moved = false, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e2, t2) {
              return false;
            }
            _move(e2, t2) {
              return {};
            }
            mousedown(e2, t2) {
              if (this._lastPoint) return;
              const i2 = y(e2);
              this._correctButton(e2, i2) && (this._lastPoint = t2, this._eventButton = i2);
            }
            mousemoveWindow(e2, t2) {
              const i2 = this._lastPoint;
              if (i2) {
                if (e2.preventDefault(), null != this._eventButton && function(e3, t3) {
                  const i3 = Ia[t3];
                  return void 0 === e3.buttons || (e3.buttons & i3) !== i3;
                }(e2, this._eventButton)) this.reset();
                else if (this._moved || !(t2.dist(i2) < this._clickTolerance)) return this._moved = true, this._lastPoint = t2, this._move(i2, t2);
              }
            }
            mouseupWindow(e2) {
              this._lastPoint && y(e2) === this._eventButton && (this._moved && m(), this.reset());
            }
            enable() {
              this._enabled = true;
            }
            disable() {
              this._enabled = false, this.reset();
            }
            isEnabled() {
              return this._enabled;
            }
            isActive() {
              return this._active;
            }
          }
          class Da extends Ra {
            mousedown(e2, t2) {
              super.mousedown(e2, t2), this._lastPoint && (this._active = true);
            }
            _correctButton(e2, t2) {
              return 0 === t2 && !e2.ctrlKey;
            }
            _move(e2, t2) {
              return { around: t2, panDelta: t2.sub(e2) };
            }
          }
          class Aa extends Ra {
            constructor(e2) {
              super(e2), this._pitchRotateKey = e2.pitchRotateKey ? Ca[e2.pitchRotateKey] : void 0;
            }
            _correctButton(e2, t2) {
              return this._pitchRotateKey ? 0 === t2 && e2[this._pitchRotateKey] : 0 === t2 && e2.ctrlKey || 2 === t2;
            }
            _move(e2, t2) {
              const i2 = 0.8 * (t2.x - e2.x);
              if (i2) return this._active = true, { bearingDelta: i2 };
            }
            contextmenu(e2) {
              this._pitchRotateKey || e2.preventDefault();
            }
          }
          class La extends Ra {
            constructor(e2) {
              super(e2), this._pitchRotateKey = e2.pitchRotateKey ? Ca[e2.pitchRotateKey] : void 0;
            }
            _correctButton(e2, t2) {
              return this._pitchRotateKey ? 0 === t2 && e2[this._pitchRotateKey] : 0 === t2 && e2.ctrlKey || 2 === t2;
            }
            _move(e2, t2) {
              const i2 = -0.5 * (t2.y - e2.y);
              if (i2) return this._active = true, { pitchDelta: i2 };
            }
            contextmenu(e2) {
              this._pitchRotateKey || e2.preventDefault();
            }
          }
          class Pa {
            constructor(t2, i2) {
              this._map = t2, this._el = t2.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i2.clickTolerance || 1, this.reset(), e.aV(["_addTouchPanBlocker", "_showTouchPanBlockerAlert"], this);
            }
            reset() {
              this._active = false, this._touches = {}, this._sum = new e.P(0, 0);
            }
            touchstart(e2, t2, i2) {
              return this._calculateTransform(e2, t2, i2);
            }
            touchmove(t2, i2, o2) {
              if (this._active && !(o2.length < this._minTouches)) {
                if (this._map._cooperativeGestures && !this._map.isMoving()) {
                  if (1 === o2.length && !e.ex()) return void this._showTouchPanBlockerAlert();
                  "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                return t2.cancelable && t2.preventDefault(), this._calculateTransform(t2, i2, o2);
              }
            }
            touchend(e2, t2, i2) {
              this._calculateTransform(e2, t2, i2), this._active && i2.length < this._minTouches && this.reset();
            }
            touchcancel() {
              this.reset();
            }
            _calculateTransform(t2, i2, o2) {
              o2.length > 0 && (this._active = true);
              const s2 = wa(o2, i2), r2 = new e.P(0, 0), n2 = new e.P(0, 0);
              let a2 = 0;
              for (const e2 in s2) {
                const t3 = s2[e2], i3 = this._touches[e2];
                i3 && (r2._add(t3), n2._add(t3.sub(i3)), a2++, s2[e2] = t3);
              }
              if (this._touches = s2, a2 < this._minTouches || !n2.mag()) return;
              const l2 = n2.div(a2);
              return this._sum._add(l2), this._sum.mag() < this._clickTolerance ? void 0 : { around: r2.div(a2), panDelta: l2 };
            }
            enable() {
              this._enabled = true, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
              this._enabled = false, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
              return !!this._enabled;
            }
            isActive() {
              return !!this._active;
            }
            _addTouchPanBlocker() {
              this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
              this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(() => {
                this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
              }, 500);
            }
          }
          class za {
            constructor() {
              this.reset();
            }
            reset() {
              this._active = false, this._firstTwoTouches = void 0;
            }
            _start(e2) {
            }
            _move(e2, t2, i2) {
              return {};
            }
            touchstart(e2, t2, i2) {
              this._firstTwoTouches || i2.length < 2 || (this._firstTwoTouches = [i2[0].identifier, i2[1].identifier], this._start([t2[0], t2[1]]));
            }
            touchmove(e2, t2, i2) {
              const o2 = this._firstTwoTouches;
              if (!o2) return;
              e2.preventDefault();
              const [s2, r2] = o2, n2 = Ma(i2, t2, s2), a2 = Ma(i2, t2, r2);
              if (!n2 || !a2) return;
              const l2 = this._aroundCenter ? null : n2.add(a2).div(2);
              return this._move([n2, a2], l2, e2);
            }
            touchend(e2, t2, i2) {
              if (!this._firstTwoTouches) return;
              const [o2, s2] = this._firstTwoTouches, r2 = Ma(i2, t2, o2), n2 = Ma(i2, t2, s2);
              r2 && n2 || (this._active && m(), this.reset());
            }
            touchcancel() {
              this.reset();
            }
            enable(e2) {
              this._enabled = true, this._aroundCenter = !!e2 && "center" === e2.around;
            }
            disable() {
              this._enabled = false, this.reset();
            }
            isEnabled() {
              return this._enabled;
            }
            isActive() {
              return this._active;
            }
          }
          function Ma(e2, t2, i2) {
            for (let o2 = 0; o2 < e2.length; o2++) if (e2[o2].identifier === i2) return t2[o2];
          }
          function Oa(e2, t2) {
            return Math.log(e2 / t2) / Math.LN2;
          }
          class Fa extends za {
            reset() {
              super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e2) {
              this._startDistance = this._distance = e2[0].dist(e2[1]);
            }
            _move(e2, t2) {
              const i2 = this._distance;
              if (this._distance = e2[0].dist(e2[1]), this._active || !(Math.abs(Oa(this._distance, this._startDistance)) < 0.1)) return this._active = true, { zoomDelta: Oa(this._distance, i2), pinchAround: t2 };
            }
          }
          function Ba(e2, t2) {
            return 180 * e2.angleWith(t2) / Math.PI;
          }
          class ka extends za {
            reset() {
              super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e2) {
              this._startVector = this._vector = e2[0].sub(e2[1]), this._minDiameter = e2[0].dist(e2[1]);
            }
            _move(e2, t2) {
              const i2 = this._vector;
              if (this._vector = e2[0].sub(e2[1]), i2 && (this._active || !this._isBelowThreshold(this._vector))) return this._active = true, { bearingDelta: Ba(this._vector, i2), pinchAround: t2 };
            }
            _isBelowThreshold(e2) {
              this._minDiameter = Math.min(this._minDiameter, e2.mag());
              const t2 = 25 / (Math.PI * this._minDiameter) * 360, i2 = this._startVector;
              if (!i2) return false;
              const o2 = Ba(e2, i2);
              return Math.abs(o2) < t2;
            }
          }
          function Na(e2) {
            return Math.abs(e2.y) > Math.abs(e2.x);
          }
          class Ua extends za {
            constructor(e2) {
              super(), this._map = e2;
            }
            reset() {
              super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e2) {
              this._lastPoints = e2, Na(e2[0].sub(e2[1])) && (this._valid = false);
            }
            _move(t2, i2, o2) {
              const s2 = this._lastPoints;
              if (!s2) return;
              const r2 = t2[0].sub(s2[0]), n2 = t2[1].sub(s2[1]);
              return this._map._cooperativeGestures && !e.ex() && o2.touches.length < 3 || (this._valid = this.gestureBeginsVertically(r2, n2, o2.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t2, this._active = true, { pitchDelta: (r2.y + n2.y) / 2 * -0.5 });
            }
            gestureBeginsVertically(e2, t2, i2) {
              if (void 0 !== this._valid) return this._valid;
              const o2 = e2.mag() >= 2, s2 = t2.mag() >= 2;
              if (!o2 && !s2) return;
              if (!o2 || !s2) return null == this._firstMove && (this._firstMove = i2), i2 - this._firstMove < 100 && void 0;
              const r2 = e2.y > 0 == t2.y > 0;
              return Na(e2) && Na(t2) && r2;
            }
          }
          const ja = { panStep: 100, bearingStep: 15, pitchStep: 10 };
          class Va {
            constructor() {
              const e2 = ja;
              this._panStep = e2.panStep, this._bearingStep = e2.bearingStep, this._pitchStep = e2.pitchStep, this._rotationDisabled = false;
            }
            blur() {
              this.reset();
            }
            reset() {
              this._active = false;
            }
            keydown(e2) {
              if (e2.altKey || e2.ctrlKey || e2.metaKey) return;
              let t2 = 0, i2 = 0, o2 = 0, s2 = 0, r2 = 0;
              switch (e2.keyCode) {
                case 61:
                case 107:
                case 171:
                case 187:
                  t2 = 1;
                  break;
                case 189:
                case 109:
                case 173:
                  t2 = -1;
                  break;
                case 37:
                  e2.shiftKey ? i2 = -1 : (e2.preventDefault(), s2 = -1);
                  break;
                case 39:
                  e2.shiftKey ? i2 = 1 : (e2.preventDefault(), s2 = 1);
                  break;
                case 38:
                  e2.shiftKey ? o2 = 1 : (e2.preventDefault(), r2 = -1);
                  break;
                case 40:
                  e2.shiftKey ? o2 = -1 : (e2.preventDefault(), r2 = 1);
                  break;
                default:
                  return;
              }
              return this._rotationDisabled && (i2 = 0, o2 = 0), { cameraAnimation: (n2) => {
                const a2 = n2.getZoom();
                n2.easeTo({ duration: 300, easeId: "keyboardHandler", easing: Ga, zoom: t2 ? Math.round(a2) + t2 * (e2.shiftKey ? 2 : 1) : a2, bearing: n2.getBearing() + i2 * this._bearingStep, pitch: n2.getPitch() + o2 * this._pitchStep, offset: [-s2 * this._panStep, -r2 * this._panStep], center: n2.getCenter() }, { originalEvent: e2 });
              } };
            }
            enable() {
              this._enabled = true;
            }
            disable() {
              this._enabled = false, this.reset();
            }
            isEnabled() {
              return this._enabled;
            }
            isActive() {
              return this._active;
            }
            disableRotation() {
              this._rotationDisabled = true;
            }
            enableRotation() {
              this._rotationDisabled = false;
            }
          }
          function Ga(e2) {
            return e2 * (2 - e2);
          }
          const qa = 4.000244140625, Za = 1 / 450;
          class Ha {
            constructor(t2, i2) {
              this._map = t2, this._el = t2.getCanvasContainer(), this._handler = i2, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = 0.01, this._wheelZoomRate = Za, e.aV(["_onTimeout", "_addScrollZoomBlocker", "_showBlockerAlert"], this);
            }
            setZoomRate(e2) {
              this._defaultZoomRate = e2;
            }
            setWheelZoomRate(e2) {
              this._wheelZoomRate = e2;
            }
            isEnabled() {
              return !!this._enabled;
            }
            isActive() {
              return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
              return !!this._zooming;
            }
            enable(e2) {
              this.isEnabled() || (this._enabled = true, this._aroundCenter = !!e2 && "center" === e2.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
              this.isEnabled() && (this._enabled = false, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t2) {
              if (!this.isEnabled()) return;
              if (this._map._cooperativeGestures) {
                if (!(t2.ctrlKey || t2.metaKey || this.isZooming() || e.ex())) return void this._showBlockerAlert();
                "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
              }
              let i2 = t2.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t2.deltaY : t2.deltaY;
              const o2 = e.q.now(), s2 = o2 - (this._lastWheelEventTime || 0);
              this._lastWheelEventTime = o2, 0 !== i2 && i2 % qa == 0 ? this._type = "wheel" : 0 !== i2 && Math.abs(i2) < 4 ? this._type = "trackpad" : s2 > 400 ? (this._type = null, this._lastValue = i2, this._timeout = window.setTimeout(this._onTimeout, 40, t2)) : this._type || (this._type = Math.abs(s2 * i2) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i2 += this._lastValue)), t2.shiftKey && i2 && (i2 /= 4), this._type && (this._lastWheelEvent = t2, this._delta -= i2, this._active || this._start(t2)), t2.preventDefault();
            }
            _onTimeout(e2) {
              this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e2);
            }
            _start(e2) {
              if (!this._delta) return;
              this._frameId && (this._frameId = null), this._active = true, this.isZooming() || (this._zooming = true), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
              const t2 = g(this._el, e2);
              this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t2, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = true, this._handler._triggerRenderFrame());
            }
            renderFrame() {
              if (!this._frameId) return;
              if (this._frameId = null, !this.isActive()) return;
              const t2 = this._map.transform;
              "wheel" === this._type && t2.projection.wrap && (t2._center.lng >= 180 || t2._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
              const i2 = () => t2._terrainEnabled() && this._aroundCoord ? t2.computeZoomRelativeTo(this._aroundCoord) : t2.zoom;
              if (0 !== this._delta) {
                const e2 = "wheel" === this._type && Math.abs(this._delta) > qa ? this._wheelZoomRate : this._defaultZoomRate;
                let o3 = 2 / (1 + Math.exp(-Math.abs(this._delta * e2)));
                this._delta < 0 && 0 !== o3 && (o3 = 1 / o3);
                const s3 = i2(), r3 = Math.pow(2, s3), n3 = "number" == typeof this._targetZoom ? t2.zoomScale(this._targetZoom) : r3;
                this._targetZoom = Math.min(t2.maxZoom, Math.max(t2.minZoom, t2.scaleZoom(n3 * o3))), "wheel" === this._type && (this._startZoom = s3, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
              }
              const o2 = "number" == typeof this._targetZoom ? this._targetZoom : i2(), s2 = this._startZoom, r2 = this._easing;
              let n2, a2 = false;
              if ("wheel" === this._type && s2 && r2) {
                const t3 = Math.min((e.q.now() - this._lastWheelEventTime) / 200, 1), i3 = r2(t3);
                n2 = e.ai(s2, o2, i3), t3 < 1 ? this._frameId || (this._frameId = true) : a2 = true;
              } else n2 = o2, a2 = true;
              this._active = true, a2 && (this._active = false, this._finishTimeout = window.setTimeout(() => {
                this._zooming = false, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
              }, 200));
              let l2 = n2 - i2();
              return l2 * this._lastDelta < 0 && (l2 = 0), { noInertia: true, needsRenderFrame: !a2, zoomDelta: l2, around: this._aroundPoint, aroundCoord: this._aroundCoord, originalEvent: this._lastWheelEvent };
            }
            _smoothOutEasing(t2) {
              let i2 = e.ey;
              if (this._prevEase) {
                const t3 = this._prevEase, o2 = (e.q.now() - t3.start) / t3.duration, s2 = t3.easing(o2 + 0.01) - t3.easing(o2), r2 = 0.27 / Math.sqrt(s2 * s2 + 1e-4) * 0.01, n2 = Math.sqrt(0.0729 - r2 * r2);
                i2 = e.ew(r2, n2, 0.25, 1);
              }
              return this._prevEase = { start: e.q.now(), duration: t2, easing: i2 }, i2;
            }
            blur() {
              this.reset();
            }
            reset() {
              this._active = false;
            }
            _addScrollZoomBlocker() {
              this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(0.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
              this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(() => {
                this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
              }, 200);
            }
          }
          class Wa {
            constructor(e2, t2) {
              this._clickZoom = e2, this._tapZoom = t2;
            }
            enable() {
              this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
              this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
              return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
              return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
          }
          class $a {
            constructor() {
              this.reset();
            }
            reset() {
              this._active = false;
            }
            blur() {
              this.reset();
            }
            dblclick(e2, t2) {
              return e2.preventDefault(), { cameraAnimation: (i2) => {
                i2.easeTo({ duration: 300, zoom: i2.getZoom() + (e2.shiftKey ? -1 : 1), around: i2.unproject(t2) }, { originalEvent: e2 });
              } };
            }
            enable() {
              this._enabled = true;
            }
            disable() {
              this._enabled = false, this.reset();
            }
            isEnabled() {
              return this._enabled;
            }
            isActive() {
              return this._active;
            }
          }
          class Xa {
            constructor() {
              this._tap = new Ea({ numTouches: 1, numTaps: 1 }), this.reset();
            }
            reset() {
              this._active = false, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e2, t2, i2) {
              this._swipePoint || (this._tapTime && e2.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i2.length > 0 && (this._swipePoint = t2[0], this._swipeTouch = i2[0].identifier) : this._tap.touchstart(e2, t2, i2));
            }
            touchmove(e2, t2, i2) {
              if (this._tapTime) {
                if (this._swipePoint) {
                  if (i2[0].identifier !== this._swipeTouch) return;
                  const o2 = t2[0], s2 = o2.y - this._swipePoint.y;
                  return this._swipePoint = o2, e2.preventDefault(), this._active = true, { zoomDelta: s2 / 128 };
                }
              } else this._tap.touchmove(e2, t2, i2);
            }
            touchend(e2, t2, i2) {
              this._tapTime ? this._swipePoint && 0 === i2.length && this.reset() : this._tap.touchend(e2, t2, i2) && (this._tapTime = e2.timeStamp);
            }
            touchcancel() {
              this.reset();
            }
            enable() {
              this._enabled = true;
            }
            disable() {
              this._enabled = false, this.reset();
            }
            isEnabled() {
              return this._enabled;
            }
            isActive() {
              return this._active;
            }
          }
          class Ya {
            constructor(e2, t2, i2) {
              this._el = e2, this._mousePan = t2, this._touchPan = i2;
            }
            enable(e2) {
              this._inertiaOptions = e2 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
              this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
              return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
              return this._mousePan.isActive() || this._touchPan.isActive();
            }
          }
          class Ka {
            constructor(e2, t2, i2) {
              this._pitchWithRotate = e2.pitchWithRotate, this._mouseRotate = t2, this._mousePitch = i2;
            }
            enable() {
              this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
              this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
              return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
              return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
          }
          class Ja {
            constructor(e2, t2, i2, o2) {
              this._el = e2, this._touchZoom = t2, this._touchRotate = i2, this._tapDragZoom = o2, this._rotationDisabled = false, this._enabled = true;
            }
            enable(e2) {
              this._touchZoom.enable(e2), this._rotationDisabled || this._touchRotate.enable(e2), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
              this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
              return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
              return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
              this._rotationDisabled = true, this._touchRotate.disable();
            }
            enableRotation() {
              this._rotationDisabled = false, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
          }
          const Qa = (e2) => e2.zoom || e2.drag || e2.pitch || e2.rotate;
          class el extends e.A {
          }
          class tl {
            constructor() {
              this.constants = [1, 1, 0.01], this.radius = 0;
            }
            setup(t2, i2) {
              const o2 = e.at([], i2, t2);
              this.radius = e.ae(o2[2] < 0 ? e.eA([], o2, this.constants) : [o2[0], o2[1], 0]);
            }
            projectRay(t2) {
              e.eA(t2, t2, this.constants), e.au(t2, t2), e.eB(t2, t2, this.constants);
              const i2 = e.bY([], t2, this.radius);
              if (i2[2] > 0) {
                const t3 = e.bY([], [0, 0, 1], e.bG(i2, [0, 0, 1])), o2 = e.bY([], e.au([], [i2[0], i2[1], 0]), this.radius), s2 = e.cV([], i2, e.bY([], e.at([], e.cV([], o2, t3), i2), 2));
                i2[0] = s2[0], i2[1] = s2[1];
              }
              return i2;
            }
          }
          function il(e2) {
            return e2.panDelta && e2.panDelta.mag() || e2.zoomDelta || e2.bearingDelta || e2.pitchDelta;
          }
          class ol {
            constructor(t2, i2) {
              this._map = t2, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new _a(t2), this._bearingSnap = i2.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new tl(), this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i2), e.aV(["handleEvent", "handleWindowEvent"], this);
              const o2 = this._el;
              this._listeners = [[o2, "touchstart", { passive: true }], [o2, "touchmove", { passive: false }], [o2, "touchend", void 0], [o2, "touchcancel", void 0], [o2, "mousedown", void 0], [o2, "mousemove", void 0], [o2, "mouseup", void 0], [document, "mousemove", { capture: true }], [document, "mouseup", void 0], [o2, "mouseover", void 0], [o2, "mouseout", void 0], [o2, "dblclick", void 0], [o2, "click", void 0], [o2, "keydown", { capture: false }], [o2, "keyup", void 0], [o2, "wheel", { passive: false }], [o2, "contextmenu", void 0], [window, "blur", void 0]];
              for (const [e2, t3, i3] of this._listeners) {
                const o3 = e2 === document ? this.handleWindowEvent : this.handleEvent;
                e2.addEventListener(t3, o3, i3);
              }
            }
            destroy() {
              for (const [e2, t2, i2] of this._listeners) {
                const o2 = e2 === document ? this.handleWindowEvent : this.handleEvent;
                e2.removeEventListener(t2, o2, i2);
              }
            }
            _addDefaultHandlers(e2) {
              const t2 = this._map, i2 = t2.getCanvasContainer();
              this._add("mapEvent", new ya(t2, e2));
              const o2 = t2.boxZoom = new ba(t2, e2);
              this._add("boxZoom", o2);
              const s2 = new Sa(), r2 = new $a();
              t2.doubleClickZoom = new Wa(r2, s2), this._add("tapZoom", s2), this._add("clickZoom", r2);
              const n2 = new Xa();
              this._add("tapDragZoom", n2);
              const a2 = t2.touchPitch = new Ua(t2);
              this._add("touchPitch", a2);
              const l2 = new Aa(e2), c2 = new La(e2);
              t2.dragRotate = new Ka(e2, l2, c2), this._add("mouseRotate", l2, ["mousePitch"]), this._add("mousePitch", c2, ["mouseRotate"]);
              const h3 = new Da(e2), d2 = new Pa(t2, e2);
              t2.dragPan = new Ya(i2, h3, d2), this._add("mousePan", h3), this._add("touchPan", d2, ["touchZoom", "touchRotate"]);
              const u2 = new ka(), _2 = new Fa();
              t2.touchZoomRotate = new Ja(i2, _2, u2, n2), this._add("touchRotate", u2, ["touchPan", "touchZoom"]), this._add("touchZoom", _2, ["touchPan", "touchRotate"]), this._add("blockableMapEvent", new xa(t2));
              const p3 = t2.scrollZoom = new Ha(t2, this);
              this._add("scrollZoom", p3, ["mousePan"]);
              const f2 = t2.keyboard = new Va();
              this._add("keyboard", f2);
              for (const i3 of ["boxZoom", "doubleClickZoom", "tapDragZoom", "touchPitch", "dragRotate", "dragPan", "touchZoomRotate", "scrollZoom", "keyboard"]) e2.interactive && e2[i3] && t2[i3].enable(e2[i3]);
            }
            _add(e2, t2, i2) {
              this._handlers.push({ handlerName: e2, handler: t2, allowed: i2 }), this._handlersById[e2] = t2;
            }
            stop(e2) {
              if (!this._updatingCamera) {
                for (const { handler: e3 } of this._handlers) e3.reset();
                this._inertia.clear(), this._fireEvents({}, {}, e2), this._changes = [], this._originalZoom = void 0;
              }
            }
            isActive() {
              for (const { handler: e2 } of this._handlers) if (e2.isActive()) return true;
              return false;
            }
            isZooming() {
              return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
              return !!this._eventsInProgress.rotate;
            }
            isMoving() {
              return !!Qa(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
              return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e2, t2, i2) {
              for (const o2 in e2) if (o2 !== i2 && (!t2 || t2.indexOf(o2) < 0)) return true;
              return false;
            }
            handleWindowEvent(e2) {
              this.handleEvent(e2, `${e2.type}Window`);
            }
            _getMapTouches(e2) {
              const t2 = [];
              for (const i2 of e2) this._el.contains(i2.target) && t2.push(i2);
              return t2;
            }
            handleEvent(e2, t2) {
              this._updatingCamera = true;
              const i2 = "renderFrame" === e2.type, o2 = i2 ? void 0 : e2, s2 = { needsRenderFrame: false }, r2 = {}, n2 = {}, a2 = e2.touches ? this._getMapTouches(e2.touches) : void 0, l2 = a2 ? v(this._el, a2) : i2 ? void 0 : g(this._el, e2);
              for (const { handlerName: i3, handler: c3, allowed: h4 } of this._handlers) {
                if (!c3.isEnabled()) continue;
                let d2;
                this._blockedByActive(n2, h4, i3) ? c3.reset() : c3[t2 || e2.type] && (d2 = c3[t2 || e2.type](e2, l2, a2), this.mergeHandlerResult(s2, r2, d2, i3, o2), d2 && d2.needsRenderFrame && this._triggerRenderFrame()), (d2 || c3.isActive()) && (n2[i3] = c3);
              }
              const c2 = {};
              for (const e3 in this._previousActiveHandlers) n2[e3] || (c2[e3] = o2);
              this._previousActiveHandlers = n2, (Object.keys(c2).length || il(s2)) && (this._changes.push([s2, r2, c2]), this._triggerRenderFrame()), (Object.keys(n2).length || il(s2)) && this._map._stop(true), this._updatingCamera = false;
              const { cameraAnimation: h3 } = s2;
              h3 && (this._inertia.clear(), this._fireEvents({}, {}, true), this._changes = [], h3(this._map));
            }
            mergeHandlerResult(t2, i2, o2, s2, r2) {
              if (!o2) return;
              e.h(t2, o2);
              const n2 = { handlerName: s2, originalEvent: o2.originalEvent || r2 };
              void 0 !== o2.zoomDelta && (i2.zoom = n2), void 0 !== o2.panDelta && (i2.drag = n2), void 0 !== o2.pitchDelta && (i2.pitch = n2), void 0 !== o2.bearingDelta && (i2.rotate = n2);
            }
            _applyChanges() {
              const t2 = {}, i2 = {}, o2 = {};
              for (const [s2, r2, n2] of this._changes) s2.panDelta && (t2.panDelta = (t2.panDelta || new e.P(0, 0))._add(s2.panDelta)), s2.zoomDelta && (t2.zoomDelta = (t2.zoomDelta || 0) + s2.zoomDelta), s2.bearingDelta && (t2.bearingDelta = (t2.bearingDelta || 0) + s2.bearingDelta), s2.pitchDelta && (t2.pitchDelta = (t2.pitchDelta || 0) + s2.pitchDelta), void 0 !== s2.around && (t2.around = s2.around), void 0 !== s2.aroundCoord && (t2.aroundCoord = s2.aroundCoord), void 0 !== s2.pinchAround && (t2.pinchAround = s2.pinchAround), s2.noInertia && (t2.noInertia = s2.noInertia), e.h(i2, r2), e.h(o2, n2);
              this._updateMapTransform(t2, i2, o2), this._changes = [];
            }
            _updateMapTransform(t2, i2, o2) {
              const s2 = this._map, r2 = s2.transform, n2 = (e2) => [e2.x, e2.y, e2.z];
              if (((e2) => {
                const t3 = this._eventsInProgress.drag;
                return t3 && !this._handlersById[t3.handlerName].isActive();
              })() && !il(t2)) {
                const e2 = r2.zoom;
                r2.cameraElevationReference = "sea", null != this._originalZoom && r2._orthographicProjectionAtLowPitch && "globe" !== r2.projection.name && 0 === r2.pitch ? (r2.cameraElevationReference = "ground", r2.zoom = this._originalZoom) : (r2.recenterOnTerrain(), r2.cameraElevationReference = "ground"), e2 !== r2.zoom && this._map._update(true);
              }
              if (r2._isCameraConstrained && s2._stop(true), !il(t2)) return void this._fireEvents(i2, o2, true);
              let { panDelta: a2, zoomDelta: l2, bearingDelta: c2, pitchDelta: h3, around: d2, aroundCoord: u2, pinchAround: _2 } = t2;
              r2._isCameraConstrained && (l2 > 0 && (l2 = 0), r2._isCameraConstrained = false), void 0 !== _2 && (d2 = _2), (l2 || ((e2) => i2[e2] && !this._eventsInProgress[e2])("drag")) && d2 && (this._dragOrigin = n2(r2.pointCoordinate3D(d2)), this._originalZoom = r2.zoom, this._trackingEllipsoid.setup(r2._camera.position, this._dragOrigin)), r2.cameraElevationReference = "sea", s2._stop(true), d2 = d2 || s2.transform.centerPoint, c2 && (r2.bearing += c2), h3 && (r2.pitch += h3), r2._updateCameraState();
              const p3 = [0, 0, 0];
              if (a2) if ("mercator" === r2.projection.name) {
                const e2 = this._trackingEllipsoid.projectRay(r2.screenPointToMercatorRay(d2).dir), t3 = this._trackingEllipsoid.projectRay(r2.screenPointToMercatorRay(d2.sub(a2)).dir);
                p3[0] = t3[0] - e2[0], p3[1] = t3[1] - e2[1];
              } else {
                const t3 = r2.pointCoordinate(d2);
                if ("globe" === r2.projection.name) {
                  a2 = a2.rotate(-r2.angle);
                  const i3 = r2._pixelsPerMercatorPixel / r2.worldSize;
                  p3[0] = -a2.x * e.ez(e.aY(t3.y)) * i3, p3[1] = -a2.y * e.ez(r2.center.lat) * i3;
                } else {
                  const e2 = r2.pointCoordinate(d2.sub(a2));
                  t3 && e2 && (p3[0] = e2.x - t3.x, p3[1] = e2.y - t3.y);
                }
              }
              const f2 = r2.zoom, m2 = [0, 0, 0];
              if (l2) {
                const t3 = n2(u2 || r2.pointCoordinate3D(d2)), i3 = { dir: e.au([], e.at([], t3, r2._camera.position)) };
                if (i3.dir[2] < 0) {
                  const o3 = r2.zoomDeltaToMovement(t3, l2);
                  e.bY(m2, i3.dir, o3);
                }
              }
              const g2 = e.cV(p3, p3, m2);
              r2._translateCameraConstrained(g2), l2 && Math.abs(r2.zoom - f2) > 1e-4 && r2.recenterOnTerrain(), r2.cameraElevationReference = "ground", this._map._update(), t2.noInertia || this._inertia.record(t2), this._fireEvents(i2, o2, true);
            }
            _fireEvents(t2, i2, o2) {
              const s2 = Qa(this._eventsInProgress), r2 = Qa(t2), n2 = {};
              for (const e2 in t2) {
                const { originalEvent: i3 } = t2[e2];
                this._eventsInProgress[e2] || (n2[`${e2}start`] = i3), this._eventsInProgress[e2] = t2[e2];
              }
              !s2 && r2 && this._fireEvent("movestart", r2.originalEvent);
              for (const e2 in n2) this._fireEvent(e2, n2[e2]);
              r2 && this._fireEvent("move", r2.originalEvent);
              for (const e2 in t2) {
                const { originalEvent: i3 } = t2[e2];
                this._fireEvent(e2, i3);
              }
              const a2 = {};
              let l2;
              for (const e2 in this._eventsInProgress) {
                const { handlerName: t3, originalEvent: o3 } = this._eventsInProgress[e2];
                this._handlersById[t3].isActive() || (delete this._eventsInProgress[e2], l2 = i2[t3] || o3, a2[`${e2}end`] = l2);
              }
              for (const e2 in a2) this._fireEvent(e2, a2[e2]);
              const c2 = Qa(this._eventsInProgress);
              if (o2 && (s2 || r2) && !c2) {
                this._updatingCamera = true;
                const t3 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i3 = (e2) => 0 !== e2 && -this._bearingSnap < e2 && e2 < this._bearingSnap;
                t3 ? (i3(t3.bearing || this._map.getBearing()) && (t3.bearing = 0), this._map.easeTo(t3, { originalEvent: l2 })) : (this._map.fire(new e.A("moveend", { originalEvent: l2 })), i3(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = false;
              }
            }
            _fireEvent(t2, i2) {
              this._map.fire(new e.A(t2, i2 ? { originalEvent: i2 } : {}));
            }
            _requestFrame() {
              return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e2) => {
                this._frameId = void 0, this.handleEvent(new el("renderFrame", { timeStamp: e2 })), this._applyChanges();
              });
            }
            _triggerRenderFrame() {
              void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
          }
          const sl = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
          class rl extends e.E {
            constructor(t2, i2) {
              super(), this._moving = false, this._zooming = false, this.transform = t2, this._bearingSnap = i2.bearingSnap, this._respectPrefersReducedMotion = false !== i2.respectPrefersReducedMotion, e.aV(["_renderFrameCallback"], this);
            }
            getCenter() {
              return new e.cd(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e2, t2) {
              return this.jumpTo({ center: e2 }, t2);
            }
            panBy(t2, i2, o2) {
              return t2 = e.P.convert(t2).mult(-1), this.panTo(this.transform.center, e.h({ offset: t2 }, i2), o2);
            }
            panTo(t2, i2, o2) {
              return this.easeTo(e.h({ center: t2 }, i2), o2);
            }
            getZoom() {
              return this.transform.zoom;
            }
            setZoom(e2, t2) {
              return this.jumpTo({ zoom: e2 }, t2), this;
            }
            zoomTo(t2, i2, o2) {
              return this.easeTo(e.h({ zoom: t2 }, i2), o2);
            }
            zoomIn(e2, t2) {
              return this.zoomTo(this.getZoom() + 1, e2, t2), this;
            }
            zoomOut(e2, t2) {
              return this.zoomTo(this.getZoom() - 1, e2, t2), this;
            }
            getBearing() {
              return this.transform.bearing;
            }
            setBearing(e2, t2) {
              return this.jumpTo({ bearing: e2 }, t2), this;
            }
            getPadding() {
              return this.transform.padding;
            }
            setPadding(e2, t2) {
              return this.jumpTo({ padding: e2 }, t2), this;
            }
            rotateTo(t2, i2, o2) {
              return this.easeTo(e.h({ bearing: t2 }, i2), o2);
            }
            resetNorth(t2, i2) {
              return this.rotateTo(0, e.h({ duration: 1e3 }, t2), i2), this;
            }
            resetNorthPitch(t2, i2) {
              return this.easeTo(e.h({ bearing: 0, pitch: 0, duration: 1e3 }, t2), i2), this;
            }
            snapToNorth(e2, t2) {
              return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e2, t2) : this;
            }
            getPitch() {
              return this.transform.pitch;
            }
            setPitch(e2, t2) {
              return this.jumpTo({ pitch: e2 }, t2), this;
            }
            cameraForBounds(t2, i2) {
              t2 = e.aG.convert(t2);
              const o2 = i2 && i2.bearing || 0, s2 = i2 && i2.pitch || 0, r2 = t2.getNorthWest(), n2 = t2.getSouthEast();
              return this._cameraForBounds(this.transform, r2, n2, o2, s2, i2);
            }
            _extendPadding(t2) {
              const i2 = { top: 0, right: 0, bottom: 0, left: 0 };
              return null == t2 ? e.h({}, i2, this.transform.padding) : "number" == typeof t2 ? { top: t2, bottom: t2, right: t2, left: t2 } : e.h({}, i2, t2);
            }
            _extendCameraOptions(t2) {
              return (t2 = e.h({ offset: [0, 0], maxZoom: this.transform.maxZoom }, t2)).padding = this._extendPadding(t2.padding), t2;
            }
            _minimumAABBFrustumDistance(e2, t2) {
              const i2 = t2.max[0] - t2.min[0], o2 = t2.max[1] - t2.min[1];
              return i2 / o2 > e2.aspect ? i2 / (2 * Math.tan(0.5 * e2.fovX) * e2.aspect) : o2 / (2 * Math.tan(0.5 * e2.fovY) * e2.aspect);
            }
            _cameraForBoundsOnGlobe(t2, i2, o2, s2, r2, n2) {
              const a2 = t2.clone(), l2 = this._extendCameraOptions(n2);
              a2.bearing = s2, a2.pitch = r2;
              const c2 = e.cd.convert(i2), h3 = e.cd.convert(o2), d2 = 0.5 * (c2.lat + h3.lat), u2 = 0.5 * (c2.lng + h3.lng), _2 = e.eC(d2, u2), p3 = e.au([], _2), f2 = e.au([], e.bF([], p3, [0, 1, 0])), m2 = e.bF([], f2, p3), g2 = [f2[0], f2[1], f2[2], 0, m2[0], m2[1], m2[2], 0, p3[0], p3[1], p3[2], 0, 0, 0, 0, 1], v2 = [_2, e.eC(c2.lat, c2.lng), e.eC(h3.lat, c2.lng), e.eC(h3.lat, h3.lng), e.eC(c2.lat, h3.lng), e.eC(d2, c2.lng), e.eC(d2, h3.lng), e.eC(c2.lat, u2), e.eC(h3.lat, u2)];
              let y2 = e.cW.fromPoints(v2.map((t3) => [e.bG(f2, t3), e.bG(m2, t3), e.bG(p3, t3)]));
              const x2 = e.ad([], y2.center, g2);
              0 === e.eD(x2) && e.eE(x2, 0, 0, 1), e.au(x2, x2), e.bY(x2, x2, e.aB), a2.center = e.eF(x2);
              const b2 = a2.getWorldToCameraMatrix(), w2 = e.bi(new Float64Array(16), b2);
              y2 = e.cW.applyTransform(y2, e.az([], b2, g2));
              const T2 = this._extendAABB(y2, a2, l2, s2);
              if (!T2) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
              y2 = T2, e.ad(x2, x2, b2);
              const E2 = 0.5 * (y2.max[2] - y2.min[2]), S2 = this._minimumAABBFrustumDistance(a2, y2), I2 = e.bY([], [0, 0, 1], E2), C2 = e.cV(I2, x2, I2), R2 = S2 + (0 === a2.pitch ? 0 : e.bD(x2, C2)), D2 = a2.globeCenterInViewSpace, A2 = e.at([], x2, [D2[0], D2[1], D2[2]]);
              e.au(A2, A2), e.bY(A2, A2, R2);
              const L2 = e.cV([], x2, A2);
              e.ad(L2, L2, w2);
              const P2 = e.eq / e.aB, z2 = e.ae(L2), M2 = e.c6(Math.max(z2 * P2 - e.eq, Number.EPSILON), 0), O2 = Math.min(a2.zoomFromMercatorZAdjusted(M2), l2.maxZoom);
              return O2 > 0.5 * (e.cL + e.cx) ? (a2.setProjection({ name: "mercator" }), a2.zoom = O2, this._cameraForBounds(a2, i2, o2, s2, r2, n2)) : { center: a2.center, zoom: O2, bearing: s2, pitch: r2 };
            }
            _extendAABB(t2, i2, o2, s2) {
              const r2 = 0.5 * ((o2.padding.left || 0) + (o2.padding.right || 0)), n2 = 0.5 * ((o2.padding.top || 0) + (o2.padding.bottom || 0)), a2 = n2, l2 = r2, c2 = r2, h3 = n2, d2 = i2.width - (l2 + c2), u2 = i2.height - (a2 + h3), _2 = e.at([], t2.max, t2.min), p3 = Math.min(d2 / _2[0], u2 / _2[1]), f2 = Math.min(i2.scaleZoom(i2.scale * p3), o2.maxZoom);
              if (isNaN(f2)) return null;
              const m2 = i2.scale / i2.zoomScale(f2), g2 = new e.cW([t2.min[0] - l2 * m2, t2.min[1] - h3 * m2, t2.min[2]], [t2.max[0] + c2 * m2, t2.max[1] + a2 * m2, t2.max[2]]), v2 = ("number" == typeof o2.offset.x && "number" == typeof o2.offset.y ? new e.P(o2.offset.x, o2.offset.y) : e.P.convert(o2.offset)).rotate(-e.al(s2));
              return g2.center[0] -= v2.x * m2, g2.center[1] += v2.y * m2, g2;
            }
            queryTerrainElevation(t2, i2) {
              const o2 = this.transform.elevation;
              return o2 ? (i2 = e.h({}, { exaggerated: true }, i2), o2.getAtPoint(e.ac.fromLngLat(t2), null, i2.exaggerated)) : null;
            }
            _cameraForBounds(t2, i2, o2, s2, r2, n2) {
              if ("globe" === t2.projection.name) return this._cameraForBoundsOnGlobe(t2, i2, o2, s2, r2, n2);
              const a2 = t2.clone(), l2 = this._extendCameraOptions(n2);
              a2.bearing = s2, a2.pitch = r2;
              const c2 = e.cd.convert(i2), h3 = e.cd.convert(o2), d2 = new e.cd(c2.lng, h3.lat), u2 = new e.cd(h3.lng, c2.lat), _2 = a2.project(c2), p3 = a2.project(h3), f2 = this.queryTerrainElevation(c2), m2 = this.queryTerrainElevation(h3), g2 = this.queryTerrainElevation(d2), v2 = this.queryTerrainElevation(u2), y2 = [[_2.x, _2.y, Math.min(f2 || 0, m2 || 0, g2 || 0, v2 || 0)], [p3.x, p3.y, Math.max(f2 || 0, m2 || 0, g2 || 0, v2 || 0)]];
              let x2 = e.cW.fromPoints(y2);
              const b2 = a2.getWorldToCameraMatrix(), w2 = e.bi(new Float64Array(16), b2);
              x2 = e.cW.applyTransform(x2, b2);
              const T2 = this._extendAABB(x2, a2, l2, s2);
              if (!T2) return void e.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
              x2 = T2;
              const E2 = 0.5 * e.at([], x2.max, x2.min)[2], S2 = this._minimumAABBFrustumDistance(a2, x2), I2 = [0, 0, 1, 0];
              e.aA(I2, I2, b2), e.eG(I2, I2);
              const C2 = e.bY([], I2, S2 + E2), R2 = e.cV([], x2.center, C2);
              e.ad(x2.center, x2.center, w2), e.ad(R2, R2, w2);
              const D2 = a2.unproject(new e.P(x2.center[0], x2.center[1])), A2 = e.eH(a2.projection, D2), L2 = Math.pow(2, A2), P2 = Math.min(a2._zoomFromMercatorZ(R2[2] * a2.pixelsPerMeter * L2 / a2.worldSize), l2.maxZoom);
              return a2.mercatorFromTransition && P2 < 0.5 * (e.cL + e.cx) ? (a2.setProjection({ name: "globe" }), a2.zoom = P2, this._cameraForBounds(a2, i2, o2, s2, r2, n2)) : { center: D2, zoom: P2, bearing: s2, pitch: r2 };
            }
            fitBounds(e2, t2, i2) {
              const o2 = this.cameraForBounds(e2, t2);
              return this._fitInternal(o2, t2, i2);
            }
            fitScreenCoordinates(t2, i2, o2, s2, r2) {
              const n2 = e.P.convert(t2), a2 = e.P.convert(i2), l2 = new e.P(Math.min(n2.x, a2.x), Math.min(n2.y, a2.y)), c2 = new e.P(Math.max(n2.x, a2.x), Math.max(n2.y, a2.y));
              if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(n2, a2)) return this;
              const h3 = this.transform.pointLocation3D(l2), d2 = this.transform.pointLocation3D(c2), u2 = this.transform.pointLocation3D(new e.P(l2.x, c2.y)), _2 = this.transform.pointLocation3D(new e.P(c2.x, l2.y)), p3 = [Math.min(h3.lng, d2.lng, u2.lng, _2.lng), Math.min(h3.lat, d2.lat, u2.lat, _2.lat)], f2 = [Math.max(h3.lng, d2.lng, u2.lng, _2.lng), Math.max(h3.lat, d2.lat, u2.lat, _2.lat)], m2 = s2 && s2.pitch ? s2.pitch : this.getPitch(), g2 = this._cameraForBounds(this.transform, p3, f2, o2, m2, s2);
              return this._fitInternal(g2, s2, r2);
            }
            _fitInternal(t2, i2, o2) {
              return t2 ? (i2 = e.h(t2, i2)).linear ? this.easeTo(i2, o2) : this.flyTo(i2, o2) : this;
            }
            jumpTo(t2, i2) {
              this.stop();
              const o2 = t2.preloadOnly ? this.transform.clone() : this.transform;
              let s2 = false, r2 = false, n2 = false;
              "zoom" in t2 && o2.zoom !== +t2.zoom && (s2 = true, o2.zoom = +t2.zoom), void 0 !== t2.center && (o2.center = e.cd.convert(t2.center)), "bearing" in t2 && o2.bearing !== +t2.bearing && (r2 = true, o2.bearing = +t2.bearing), "pitch" in t2 && o2.pitch !== +t2.pitch && (n2 = true, o2.pitch = +t2.pitch);
              const a2 = "number" == typeof t2.padding ? this._extendPadding(t2.padding) : t2.padding;
              if (null != t2.padding && !o2.isPaddingEqual(a2)) if (false === t2.retainPadding) {
                const e2 = o2.clone();
                e2.padding = a2, o2.setLocationAtPoint(o2.center, e2.centerPoint);
              } else o2.padding = a2;
              return t2.preloadOnly ? (this._preloadTiles(o2), this) : (this.fire(new e.A("movestart", i2)).fire(new e.A("move", i2)), s2 && this.fire(new e.A("zoomstart", i2)).fire(new e.A("zoom", i2)).fire(new e.A("zoomend", i2)), r2 && this.fire(new e.A("rotatestart", i2)).fire(new e.A("rotate", i2)).fire(new e.A("rotateend", i2)), n2 && this.fire(new e.A("pitchstart", i2)).fire(new e.A("pitch", i2)).fire(new e.A("pitchend", i2)), this.fire(new e.A("moveend", i2)));
            }
            getFreeCameraOptions() {
              return this.transform.projection.supportsFreeCamera || e.w(sl), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t2, i2) {
              const o2 = this.transform;
              if (!o2.projection.supportsFreeCamera) return e.w(sl), this;
              this.stop();
              const s2 = o2.zoom, r2 = o2.pitch, n2 = o2.bearing;
              o2.setFreeCameraOptions(t2);
              const a2 = s2 !== o2.zoom, l2 = r2 !== o2.pitch, c2 = n2 !== o2.bearing;
              return this.fire(new e.A("movestart", i2)).fire(new e.A("move", i2)), a2 && this.fire(new e.A("zoomstart", i2)).fire(new e.A("zoom", i2)).fire(new e.A("zoomend", i2)), c2 && this.fire(new e.A("rotatestart", i2)).fire(new e.A("rotate", i2)).fire(new e.A("rotateend", i2)), l2 && this.fire(new e.A("pitchstart", i2)).fire(new e.A("pitch", i2)).fire(new e.A("pitchend", i2)), this.fire(new e.A("moveend", i2)), this;
            }
            easeTo(t2, i2) {
              this._stop(false, t2.easeId), (false === (t2 = e.h({ offset: [0, 0], duration: 500, easing: e.ey }, t2)).animate || this._prefersReducedMotion(t2)) && (t2.duration = 0);
              const o2 = this.transform, s2 = this.getZoom(), r2 = this.getBearing(), n2 = this.getPitch(), a2 = this.getPadding(), l2 = "zoom" in t2 ? +t2.zoom : s2, c2 = "bearing" in t2 ? this._normalizeBearing(t2.bearing, r2) : r2, h3 = "pitch" in t2 ? +t2.pitch : n2, d2 = this._extendPadding(t2.padding), u2 = e.P.convert(t2.offset);
              let _2, p3, f2;
              if ("globe" === o2.projection.name) {
                const i3 = e.ac.fromLngLat(o2.center), s3 = u2.rotate(-o2.angle);
                i3.x += s3.x / o2.worldSize, i3.y += s3.y / o2.worldSize;
                const r3 = i3.toLngLat(), n3 = e.cd.convert(t2.center || r3);
                this._normalizeCenter(n3), _2 = o2.centerPoint.add(s3), p3 = new e.P(i3.x, i3.y).mult(o2.worldSize), f2 = new e.P(e.aD(n3.lng), e.aH(n3.lat)).mult(o2.worldSize).sub(p3);
              } else {
                _2 = o2.centerPoint.add(u2);
                const i3 = o2.pointLocation(_2), s3 = e.cd.convert(t2.center || i3);
                this._normalizeCenter(s3), p3 = o2.project(i3), f2 = o2.project(s3).sub(p3);
              }
              const m2 = o2.zoomScale(l2 - s2);
              let g2, v2;
              t2.around && (g2 = e.cd.convert(t2.around), v2 = o2.locationPoint(g2));
              const y2 = this._zooming || l2 !== s2, x2 = this._rotating || r2 !== c2, b2 = this._pitching || h3 !== n2, w2 = !o2.isPaddingEqual(d2), T2 = false === t2.retainPadding ? o2.clone() : o2, E2 = (o3) => (E3) => {
                if (y2 && (o3.zoom = e.ai(s2, l2, E3)), x2 && (o3.bearing = e.ai(r2, c2, E3)), b2 && (o3.pitch = e.ai(n2, h3, E3)), w2 && (T2.interpolatePadding(a2, d2, E3), _2 = T2.centerPoint.add(u2)), g2) o3.setLocationAtPoint(g2, v2);
                else {
                  const e2 = o3.zoomScale(o3.zoom - s2), t3 = l2 > s2 ? Math.min(2, m2) : Math.max(0.5, m2), i3 = Math.pow(t3, 1 - E3), r3 = o3.unproject(p3.add(f2.mult(E3 * i3)).mult(e2));
                  o3.setLocationAtPoint(o3.renderWorldCopies ? r3.wrap() : r3, _2);
                }
                return t2.preloadOnly || this._fireMoveEvents(i2), o3;
              };
              if (t2.preloadOnly) {
                const e2 = this._emulate(E2, t2.duration, o2);
                return this._preloadTiles(e2), this;
              }
              const S2 = { moving: this._moving, zooming: this._zooming, rotating: this._rotating, pitching: this._pitching };
              return this._zooming = y2, this._rotating = x2, this._pitching = b2, this._padding = w2, this._easeId = t2.easeId, this._prepareEase(i2, t2.noMoveStart, S2), this._ease(E2(o2), (e2) => {
                "sea" === o2.cameraElevationReference && o2.recenterOnTerrain(), this._afterEase(i2, e2);
              }, t2), this;
            }
            _prepareEase(t2, i2, o2 = {}) {
              this._moving = true, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i2 || o2.moving || this.fire(new e.A("movestart", t2)), this._zooming && !o2.zooming && this.fire(new e.A("zoomstart", t2)), this._rotating && !o2.rotating && this.fire(new e.A("rotatestart", t2)), this._pitching && !o2.pitching && this.fire(new e.A("pitchstart", t2));
            }
            _fireMoveEvents(t2) {
              this.fire(new e.A("move", t2)), this._zooming && this.fire(new e.A("zoom", t2)), this._rotating && this.fire(new e.A("rotate", t2)), this._pitching && this.fire(new e.A("pitch", t2));
            }
            _afterEase(t2, i2) {
              if (this._easeId && i2 && this._easeId === i2) return;
              this._easeId = void 0, this.transform.cameraElevationReference = "ground";
              const o2 = this._zooming, s2 = this._rotating, r2 = this._pitching;
              this._moving = false, this._zooming = false, this._rotating = false, this._pitching = false, this._padding = false, o2 && this.fire(new e.A("zoomend", t2)), s2 && this.fire(new e.A("rotateend", t2)), r2 && this.fire(new e.A("pitchend", t2)), this.fire(new e.A("moveend", t2));
            }
            flyTo(t2, i2) {
              if (this._prefersReducedMotion(t2)) {
                const o3 = e.aF(t2, ["center", "zoom", "bearing", "pitch", "around", "padding", "retainPadding"]);
                return this.jumpTo(o3, i2);
              }
              this.stop(), t2 = e.h({ offset: [0, 0], speed: 1.2, curve: 1.42, easing: e.ey }, t2);
              const o2 = this.transform, s2 = this.getZoom(), r2 = this.getBearing(), n2 = this.getPitch(), a2 = this.getPadding(), l2 = "zoom" in t2 ? e.ay(+t2.zoom, o2.minZoom, o2.maxZoom) : s2, c2 = "bearing" in t2 ? this._normalizeBearing(t2.bearing, r2) : r2, h3 = "pitch" in t2 ? +t2.pitch : n2, d2 = this._extendPadding(t2.padding), u2 = o2.zoomScale(l2 - s2), _2 = e.P.convert(t2.offset);
              let p3 = o2.centerPoint.add(_2);
              const f2 = o2.pointLocation(p3), m2 = e.cd.convert(t2.center || f2);
              this._normalizeCenter(m2);
              const g2 = o2.project(f2), v2 = o2.project(m2).sub(g2);
              let y2 = t2.curve;
              const x2 = Math.max(o2.width, o2.height), b2 = x2 / u2, w2 = v2.mag();
              if ("minZoom" in t2) {
                const i3 = e.ay(Math.min(t2.minZoom, s2, l2), o2.minZoom, o2.maxZoom), r3 = x2 / o2.zoomScale(i3 - s2);
                y2 = Math.sqrt(r3 / w2 * 2);
              }
              const T2 = y2 * y2;
              function E2(e2) {
                const t3 = (b2 * b2 - x2 * x2 + (e2 ? -1 : 1) * T2 * T2 * w2 * w2) / (2 * (e2 ? b2 : x2) * T2 * w2);
                return Math.log(Math.sqrt(t3 * t3 + 1) - t3);
              }
              function S2(e2) {
                return (Math.exp(e2) - Math.exp(-e2)) / 2;
              }
              function I2(e2) {
                return (Math.exp(e2) + Math.exp(-e2)) / 2;
              }
              const C2 = E2(0);
              let R2 = function(e2) {
                return I2(C2) / I2(C2 + y2 * e2);
              }, D2 = function(e2) {
                return x2 * ((I2(C2) * (S2(t3 = C2 + y2 * e2) / I2(t3)) - S2(C2)) / T2) / w2;
                var t3;
              }, A2 = (E2(1) - C2) / y2;
              if (Math.abs(w2) < 1e-6 || !isFinite(A2)) {
                if (Math.abs(x2 - b2) < 1e-6) return this.easeTo(t2, i2);
                const e2 = b2 < x2 ? -1 : 1;
                A2 = Math.abs(Math.log(b2 / x2)) / y2, D2 = function() {
                  return 0;
                }, R2 = function(t3) {
                  return Math.exp(e2 * y2 * t3);
                };
              }
              t2.duration = "duration" in t2 ? +t2.duration : 1e3 * A2 / ("screenSpeed" in t2 ? +t2.screenSpeed / y2 : +t2.speed), t2.maxDuration && t2.duration > t2.maxDuration && (t2.duration = 0);
              const L2 = r2 !== c2, P2 = h3 !== n2, z2 = !o2.isPaddingEqual(d2), M2 = false === t2.retainPadding ? o2.clone() : o2, O2 = (o3) => (u3) => {
                const f3 = u3 * A2, y3 = 1 / R2(f3);
                o3.zoom = 1 === u3 ? l2 : s2 + o3.scaleZoom(y3), L2 && (o3.bearing = e.ai(r2, c2, u3)), P2 && (o3.pitch = e.ai(n2, h3, u3)), z2 && (M2.interpolatePadding(a2, d2, u3), p3 = M2.centerPoint.add(_2));
                const x3 = 1 === u3 ? m2 : o3.unproject(g2.add(v2.mult(D2(f3))).mult(y3));
                return o3.setLocationAtPoint(o3.renderWorldCopies ? x3.wrap() : x3, p3), o3._updateCameraOnTerrain(), t2.preloadOnly || this._fireMoveEvents(i2), o3;
              };
              if (t2.preloadOnly) {
                const e2 = this._emulate(O2, t2.duration, o2);
                return this._preloadTiles(e2), this;
              }
              return this._zooming = true, this._rotating = L2, this._pitching = P2, this._padding = z2, this._prepareEase(i2, false), this._ease(O2(o2), () => this._afterEase(i2), t2), this;
            }
            isEasing() {
              return !!this._easeFrameId;
            }
            stop() {
              return this._stop();
            }
            _requestRenderFrame(e2) {
            }
            _cancelRenderFrame(e2) {
            }
            _stop(e2, t2) {
              if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                const e3 = this._onEaseEnd;
                this._onEaseEnd = void 0, e3.call(this, t2);
              }
              if (!e2) {
                const e3 = this.handlers;
                e3 && e3.stop(false);
              }
              return this;
            }
            _ease(t2, i2, o2) {
              false === o2.animate || 0 === o2.duration ? (t2(1), i2()) : (this._easeStart = e.q.now(), this._easeOptions = o2, this._onEaseFrame = t2, this._onEaseEnd = i2, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
              const t2 = Math.min((e.q.now() - this._easeStart) / this._easeOptions.duration, 1), i2 = this._onEaseFrame;
              i2 && i2(this._easeOptions.easing(t2)), t2 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t2, i2) {
              t2 = e.bX(t2, -180, 180);
              const o2 = Math.abs(t2 - i2);
              return Math.abs(t2 - 360 - i2) < o2 && (t2 -= 360), Math.abs(t2 + 360 - i2) < o2 && (t2 += 360), t2;
            }
            _normalizeCenter(e2) {
              const t2 = this.transform;
              if (t2.maxBounds) return;
              if ("globe" !== t2.projection.name && !t2.renderWorldCopies) return;
              const i2 = e2.lng - t2.center.lng;
              e2.lng += i2 > 180 ? -360 : i2 < -180 ? 360 : 0;
            }
            _prefersReducedMotion(t2) {
              return this._respectPrefersReducedMotion && e.q.prefersReducedMotion && !(t2 && t2.essential);
            }
            _emulate(e2, t2, i2) {
              const o2 = Math.ceil(15 * t2 / 1e3), s2 = [], r2 = e2(i2.clone());
              for (let e3 = 0; e3 <= o2; e3++) {
                const t3 = r2(e3 / o2);
                s2.push(t3.clone());
              }
              return s2;
            }
            _preloadTiles(e2, t2) {
            }
          }
          class nl {
            constructor(t2 = {}) {
              this.options = t2, e.aV(["_toggleAttribution", "_updateEditLink", "_updateData", "_updateCompact"], this);
            }
            getDefaultPosition() {
              return "bottom-right";
            }
            onAdd(e2) {
              const t2 = this.options && this.options.compact, i2 = e2._getUIString("AttributionControl.ToggleAttribution");
              this._map = e2, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = l("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i2);
              const o2 = l("span", "mapboxgl-ctrl-icon", this._compactButton);
              return o2.setAttribute("aria-hidden", "true"), o2.setAttribute("title", i2), this._innerContainer = l("div", "mapboxgl-ctrl-attrib-inner", this._container), t2 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t2 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
              this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _toggleAttribution() {
              this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
              let t2 = this._editLink;
              t2 || (t2 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
              const i2 = [{ key: "owner", value: this.styleOwner }, { key: "id", value: this.styleId }, { key: "access_token", value: this._map._requestManager._customAccessToken || e.e.ACCESS_TOKEN }];
              if (t2) {
                const o2 = i2.reduce((e2, t3, o3) => (t3.value && (e2 += `${t3.key}=${t3.value}${o3 < i2.length - 1 ? "&" : ""}`), e2), "?");
                t2.href = `${e.e.FEEDBACK_URL}/${o2}#${aa(this._map, true)}`, t2.rel = "noopener nofollow";
              }
            }
            _updateData(e2) {
              !e2 || "metadata" !== e2.sourceDataType && "visibility" !== e2.sourceDataType && "style" !== e2.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
              if (!this._map.style) return;
              let e2 = [];
              if (this._map.style.stylesheet) {
                const e3 = this._map.style.stylesheet;
                this.styleOwner = e3.owner, this.styleId = e3.id;
              }
              const t2 = this._map.style._mergedSourceCaches;
              for (const i3 in t2) {
                const o2 = t2[i3];
                if (o2.used) {
                  const t3 = o2.getSource();
                  t3.attribution && e2.indexOf(t3.attribution) < 0 && e2.push(t3.attribution);
                }
              }
              e2.sort((e3, t3) => e3.length - t3.length), e2 = e2.filter((t3, i3) => {
                for (let o2 = i3 + 1; o2 < e2.length; o2++) if (e2[o2].indexOf(t3) >= 0) return false;
                return true;
              }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e2 = [...this.options.customAttribution, ...e2] : e2.unshift(this.options.customAttribution));
              const i2 = e2.join(" | ");
              i2 !== this._attribHTML && (this._attribHTML = i2, e2.length ? (this._innerContainer.innerHTML = i2, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
              this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
          }
          class al {
            constructor() {
              e.aV(["_updateLogo", "_updateCompact"], this);
            }
            onAdd(e2) {
              this._map = e2, this._container = l("div", "mapboxgl-ctrl");
              const t2 = l("a", "mapboxgl-ctrl-logo");
              return t2.target = "_blank", t2.rel = "noopener nofollow", t2.href = "https://www.mapbox.com/", t2.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t2.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t2), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
              this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
              return "bottom-left";
            }
            _updateLogo(e2) {
              e2 && "metadata" !== e2.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
              if (!this._map.style) return true;
              const e2 = this._map.style._sourceCaches;
              if (0 === Object.entries(e2).length) return true;
              for (const t2 in e2) {
                const i2 = e2[t2].getSource();
                if (i2.hasOwnProperty("mapbox_logo") && !i2.mapbox_logo) return false;
              }
              return true;
            }
            _updateCompact() {
              const e2 = this._container.children;
              if (e2.length) {
                const t2 = e2[0];
                this._map.getCanvasContainer().offsetWidth < 250 ? t2.classList.add("mapboxgl-compact") : t2.classList.remove("mapboxgl-compact");
              }
            }
          }
          class ll {
            constructor() {
              this._queue = [], this._id = 0, this._cleared = false, this._currentlyRunning = false;
            }
            add(e2) {
              const t2 = ++this._id;
              return this._queue.push({ callback: e2, id: t2, cancelled: false }), t2;
            }
            remove(e2) {
              const t2 = this._currentlyRunning, i2 = t2 ? this._queue.concat(t2) : this._queue;
              for (const t3 of i2) if (t3.id === e2) return void (t3.cancelled = true);
            }
            run(e2 = 0) {
              const t2 = this._currentlyRunning = this._queue;
              this._queue = [];
              for (const i2 of t2) if (!i2.cancelled && (i2.callback(e2), this._cleared)) break;
              this._cleared = false, this._currentlyRunning = false;
            }
            clear() {
              this._currentlyRunning && (this._cleared = true), this._queue = [];
            }
          }
          class cl {
            constructor(e2) {
              this.jumpTo(e2);
            }
            getValue(t2) {
              if (t2 <= this._startTime) return this._start;
              if (t2 >= this._endTime) return this._end;
              const i2 = e.dk((t2 - this._startTime) / (this._endTime - this._startTime));
              return this._start * (1 - i2) + this._end * i2;
            }
            isEasing(e2) {
              return e2 >= this._startTime && e2 <= this._endTime;
            }
            jumpTo(e2) {
              this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e2, this._end = e2;
            }
            easeTo(e2, t2, i2) {
              this._start = this.getValue(t2), this._end = e2, this._startTime = t2, this._endTime = t2 + i2;
            }
          }
          const hl = { "AttributionControl.ToggleAttribution": "Toggle attribution", "FullscreenControl.Enter": "Enter fullscreen", "FullscreenControl.Exit": "Exit fullscreen", "GeolocateControl.FindMyLocation": "Find my location", "GeolocateControl.LocationNotAvailable": "Location not available", "LogoControl.Title": "Mapbox homepage", "Map.Title": "Map", "NavigationControl.ResetBearing": "Reset bearing to north", "NavigationControl.ZoomIn": "Zoom in", "NavigationControl.ZoomOut": "Zoom out", "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map", "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map", "TouchPanBlocker.Message": "Use two fingers to move the map" };
          class dl extends e.A {
            constructor(e2, t2, i2, o2) {
              const { point: s2, lngLat: r2, originalEvent: n2, target: a2 } = e2;
              super(e2.type, { point: s2, lngLat: r2, originalEvent: n2, target: a2 }), this.preventDefault = () => {
                e2.preventDefault();
              }, this.id = t2, this.interaction = i2, this.feature = o2;
            }
          }
          class ul {
            constructor(e2) {
              this.map = e2, this.interactionsByType = /* @__PURE__ */ new Map(), this.delegatedInteractions = /* @__PURE__ */ new Map(), this.typeById = /* @__PURE__ */ new Map(), this.filters = /* @__PURE__ */ new Map(), this.handleType = this.handleType.bind(this), this.handleMove = this.handleMove.bind(this), this.handleOut = this.handleOut.bind(this), this.hoveredFeatures = /* @__PURE__ */ new Map(), this.prevHoveredFeatures = /* @__PURE__ */ new Map();
            }
            add(t2, i2) {
              if (this.typeById.has(t2)) throw new Error(`Interaction id "${t2}" already exists.`);
              const o2 = i2.filter;
              let s2 = i2.type;
              o2 && this.filters.set(t2, e.b3(o2)), "mouseover" === s2 && (s2 = "mouseenter"), "mouseout" === s2 && (s2 = "mouseleave");
              const r2 = this.interactionsByType.get(s2) || /* @__PURE__ */ new Map();
              "mouseenter" === s2 || "mouseleave" === s2 ? (0 === this.delegatedInteractions.size && (this.map.on("mousemove", this.handleMove), this.map.on("mouseout", this.handleOut)), this.delegatedInteractions.set(t2, i2)) : 0 === r2.size && this.map.on(s2, this.handleType), 0 === r2.size && this.interactionsByType.set(s2, r2), r2.set(t2, i2), this.typeById.set(t2, s2);
            }
            get(e2) {
              const t2 = this.typeById.get(e2);
              if (!t2) return;
              const i2 = this.interactionsByType.get(t2);
              return i2 ? i2.get(e2) : void 0;
            }
            remove(e2) {
              const t2 = this.typeById.get(e2);
              if (!t2) return;
              this.typeById.delete(e2), this.filters.delete(e2);
              const i2 = this.interactionsByType.get(t2);
              i2 && (i2.delete(e2), "mouseenter" === t2 || "mouseleave" === t2 ? (this.delegatedInteractions.delete(e2), 0 === this.delegatedInteractions.size && (this.map.off("mousemove", this.handleMove), this.map.off("mouseout", this.handleOut))) : 0 === i2.size && this.map.off(t2, this.handleType));
            }
            queryTargets(e2, t2) {
              const i2 = [];
              for (const [e3, o2] of t2) o2.target && i2.push({ targetId: e3, target: o2.target, filter: this.filters.get(e3) });
              return this.map.style.queryRenderedTargets(e2, i2, this.map.transform);
            }
            handleMove(e2) {
              this.prevHoveredFeatures = this.hoveredFeatures, this.hoveredFeatures = /* @__PURE__ */ new Map();
              const t2 = this.queryTargets(e2.point, Array.from(this.delegatedInteractions).reverse());
              t2.length && (e2.type = "mouseenter", this.handleType(e2, t2));
              const i2 = /* @__PURE__ */ new Map();
              for (const [e3, { feature: t3 }] of this.prevHoveredFeatures) this.hoveredFeatures.has(e3) || i2.set(t3.id, t3);
              i2.size && (e2.type = "mouseleave", this.handleType(e2, Array.from(i2.values())));
            }
            handleOut(e2) {
              const t2 = Array.from(this.hoveredFeatures.values()).map(({ feature: e3 }) => e3);
              t2.length && (e2.type = "mouseleave", this.handleType(e2, t2)), this.hoveredFeatures.clear();
            }
            handleType(t2, i2) {
              const o2 = "mouseenter" === t2.type;
              if (o2 && !this.interactionsByType.has(t2.type)) return void e.w("mouseenter interaction required for mouseleave to work.");
              const s2 = Array.from(this.interactionsByType.get(t2.type)).reverse(), r2 = !!i2;
              i2 = i2 || this.queryTargets(t2.point, s2);
              let n2 = false;
              const a2 = /* @__PURE__ */ new Set();
              for (const l2 of i2) {
                for (const [i3, c2] of s2) {
                  if (!c2.target) continue;
                  const s3 = l2.variants ? l2.variants[i3] : null;
                  if (s3) {
                    for (const h3 of s3) {
                      if (lt(h3, l2, a2, i3)) continue;
                      const s4 = new e.de(l2, h3), d2 = at(h3, l2, i3);
                      r2 && (s4.state = this.map.getFeatureState(s4));
                      const u2 = o2 ? this.prevHoveredFeatures.get(d2) : null, _2 = new dl(t2, i3, c2, s4), p3 = u2 ? u2.stop : c2.handler(_2);
                      if (o2 && this.hoveredFeatures.set(d2, { feature: l2, stop: p3 }), false !== p3) {
                        n2 = true;
                        break;
                      }
                    }
                    if (n2) break;
                  }
                }
                if (n2) break;
              }
              if (!n2) for (const [e2, i3] of s2) {
                const { handler: o3, target: s3 } = i3;
                if (!s3 && false !== o3(new dl(t2, e2, i3, null))) break;
              }
            }
          }
          function _l(t2, i2) {
            if (Array.isArray(t2) && Array.isArray(i2)) {
              const e2 = new Set(t2), o2 = new Set(i2);
              return e2.size === o2.size && t2.every((e3) => o2.has(e3));
            }
            return e.bv(t2, i2);
          }
          const pl = { center: [0, 0], zoom: 0, bearing: 0, pitch: 0, minZoom: -2, maxZoom: 22, minPitch: 0, maxPitch: 85, interactive: true, scrollZoom: true, boxZoom: true, dragRotate: true, dragPan: true, keyboard: true, doubleClickZoom: true, touchZoomRotate: true, touchPitch: true, cooperativeGestures: false, performanceMetricsCollection: true, bearingSnap: 7, clickTolerance: 3, pitchWithRotate: true, hash: false, attributionControl: true, antialias: false, failIfMajorPerformanceCaveat: false, preserveDrawingBuffer: false, trackResize: true, renderWorldCopies: true, refreshExpiredTiles: true, minTileCacheSize: null, maxTileCacheSize: null, localIdeographFontFamily: "sans-serif", localFontFamily: null, transformRequest: null, accessToken: null, fadeDuration: 300, respectPrefersReducedMotion: true, crossSourceCollisions: true, collectResourceTiming: false, testMode: false, precompilePrograms: true, scaleFactor: 1, spriteFormat: "auto" }, fl = { showCompass: true, showZoom: true, visualizePitch: false };
          class ml {
            constructor(t2, i2, o2 = false) {
              this._clickTolerance = 10, this.element = i2, this.mouseRotate = new Aa({ clickTolerance: t2.dragRotate._mouseRotate._clickTolerance }), this.map = t2, o2 && (this.mousePitch = new La({ clickTolerance: t2.dragRotate._mousePitch._clickTolerance })), e.aV(["mousedown", "mousemove", "mouseup", "touchstart", "touchmove", "touchend", "reset"], this), i2.addEventListener("mousedown", this.mousedown), i2.addEventListener("touchstart", this.touchstart, { passive: false }), i2.addEventListener("touchmove", this.touchmove), i2.addEventListener("touchend", this.touchend), i2.addEventListener("touchcancel", this.reset);
            }
            down(e2, t2) {
              this.mouseRotate.mousedown(e2, t2), this.mousePitch && this.mousePitch.mousedown(e2, t2), _();
            }
            move(e2, t2) {
              const i2 = this.map, o2 = this.mouseRotate.mousemoveWindow(e2, t2), s2 = o2 && o2.bearingDelta;
              if (s2 && i2.setBearing(i2.getBearing() + s2), this.mousePitch) {
                const o3 = this.mousePitch.mousemoveWindow(e2, t2), s3 = o3 && o3.pitchDelta;
                s3 && i2.setPitch(i2.getPitch() + s3);
              }
            }
            off() {
              const e2 = this.element;
              e2.removeEventListener("mousedown", this.mousedown), e2.removeEventListener("touchstart", this.touchstart), e2.removeEventListener("touchmove", this.touchmove), e2.removeEventListener("touchend", this.touchend), e2.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
              p2(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(t2) {
              this.down(e.h({}, t2, { ctrlKey: true, preventDefault: () => t2.preventDefault() }), g(this.element, t2)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e2) {
              this.move(e2, g(this.element, e2));
            }
            mouseup(e2) {
              this.mouseRotate.mouseupWindow(e2), this.mousePitch && this.mousePitch.mouseupWindow(e2), this.offTemp();
            }
            touchstart(e2) {
              1 !== e2.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = v(this.element, e2.targetTouches)[0], this.down({ type: "mousedown", button: 0, ctrlKey: true, preventDefault: () => e2.preventDefault() }, this._startPos));
            }
            touchmove(e2) {
              1 !== e2.targetTouches.length ? this.reset() : (this._lastPos = v(this.element, e2.targetTouches)[0], this.move({ preventDefault: () => e2.preventDefault() }, this._lastPos));
            }
            touchend(e2) {
              0 === e2.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
              this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
          }
          function gl(t2, i2, o2) {
            if (t2 = new e.cd(t2.lng, t2.lat), i2) {
              const s2 = new e.cd(t2.lng - 360, t2.lat), r2 = new e.cd(t2.lng + 360, t2.lat), n2 = 360 * Math.ceil(Math.abs(t2.lng - o2.center.lng) / 360), a2 = o2.locationPoint3D(t2).distSqr(i2), l2 = i2.x < 0 || i2.y < 0 || i2.x > o2.width || i2.y > o2.height;
              o2.locationPoint3D(s2).distSqr(i2) < a2 && (l2 || Math.abs(s2.lng - o2.center.lng) < n2) ? t2 = s2 : o2.locationPoint3D(r2).distSqr(i2) < a2 && (l2 || Math.abs(r2.lng - o2.center.lng) < n2) && (t2 = r2);
            }
            for (; Math.abs(t2.lng - o2.center.lng) > 180; ) {
              const e2 = o2.locationPoint3D(t2);
              if (e2.x >= 0 && e2.y >= 0 && e2.x <= o2.width && e2.y <= o2.height) break;
              t2.lng > o2.center.lng ? t2.lng -= 360 : t2.lng += 360;
            }
            return t2;
          }
          const vl = { center: "translate(-50%,-50%)", top: "translate(-50%,0)", "top-left": "translate(0,0)", "top-right": "translate(-100%,0)", bottom: "translate(-50%,-100%)", "bottom-left": "translate(0,-100%)", "bottom-right": "translate(-100%,-100%)", left: "translate(0,-50%)", right: "translate(-100%,-50%)" }, yl = { rotation: 0, rotationAlignment: "auto", pitchAlignment: "auto", occludedOpacity: 0.2, altitude: 0 };
          class xl extends e.E {
            constructor(t2, i2) {
              super(), (t2 instanceof HTMLElement || i2) && (t2 = e.h({ element: t2 }, i2)), e.aV(["_update", "_onMove", "_onUp", "_addDragHandler", "_onMapClick", "_onKeyPress", "_clearFadeTimer"], this);
              const { anchor: o2 = "center", color: s2 = "#3FB1CE", scale: r2 = 1, draggable: n2 = false, clickTolerance: a2 = 0, rotation: l2 = yl.rotation, rotationAlignment: c2 = yl.rotationAlignment, pitchAlignment: h3 = yl.pitchAlignment, occludedOpacity: d2 = yl.occludedOpacity, altitude: u2 = yl.altitude } = t2 || {};
              this._anchor = o2, this._color = s2, this._scale = r2, this._draggable = n2, this._clickTolerance = a2, this._rotation = l2, this._rotationAlignment = c2, this._pitchAlignment = h3, this._occludedOpacity = d2, this._altitude = u2, this._state = "inactive", this._isDragging = false, this._updateMoving = () => this._update(true), t2 && t2.element ? (this._element = t2.element, this._offset = e.P.convert(t2 && t2.offset || [0, 0])) : (this._defaultMarker = true, this._element = this._createDefaultMarker(), this._offset = e.P.convert(t2 && t2.offset || [0, -14])), this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e2) => {
                e2.preventDefault();
              }), this._element.addEventListener("mousedown", (e2) => {
                e2.preventDefault();
              });
              const _2 = this._element.classList;
              for (const e2 in vl) _2.remove(`mapboxgl-marker-anchor-${e2}`);
              _2.add(`mapboxgl-marker-anchor-${this._anchor}`);
              const p3 = t2 && t2.className ? t2.className.trim().split(/\s+/) : [];
              _2.add(...p3), this._popup = null;
            }
            _createDefaultMarker() {
              const e2 = l("div"), t2 = c("svg", { display: "block", height: 41 * this._scale + "px", width: 27 * this._scale + "px", viewBox: "0 0 27 41" }, e2);
              if (0 === this._altitude) {
                const e3 = c("radialGradient", { id: "shadowGradient" }, c("defs", {}, t2));
                c("stop", { offset: "10%", "stop-opacity": 0.4 }, e3), c("stop", { offset: "100%", "stop-opacity": 0.05 }, e3), c("ellipse", { cx: 13.5, cy: 34.8, rx: 10.5, ry: 5.25, fill: "url(#shadowGradient)" }, t2);
              }
              return c("path", { fill: this._color, d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z" }, t2), c("path", { opacity: 0.25, d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z" }, t2), c("circle", { fill: "white", cx: 13.5, cy: 13.5, r: 5.5 }, t2), e2;
            }
            addTo(e2) {
              return e2 === this._map || (this.remove(), this._map = e2, e2.getCanvasContainer().appendChild(this._element), e2.on("move", this._updateMoving), e2.on("moveend", this._update), e2.on("remove", this._clearFadeTimer), e2._addMarker(this), this.setDraggable(this._draggable), this._update(), e2.on("click", this._onMapClick)), this;
            }
            remove() {
              const e2 = this._map;
              return e2 && (e2.off("click", this._onMapClick), e2.off("move", this._updateMoving), e2.off("moveend", this._update), e2.off("mousedown", this._addDragHandler), e2.off("touchstart", this._addDragHandler), e2.off("mouseup", this._onUp), e2.off("touchend", this._onUp), e2.off("mousemove", this._onMove), e2.off("touchmove", this._onMove), e2.off("remove", this._clearFadeTimer), e2._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
              return this._lngLat;
            }
            setLngLat(t2) {
              return this._lngLat = e.cd.convert(t2), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(true), this;
            }
            setAltitude(e2) {
              return e2 === this._altitude || (this._defaultMarker && (0 === this._altitude && 0 !== e2 || 0 !== this._altitude && 0 === e2) && (this._element = this._createDefaultMarker()), this._altitude = e2 || yl.altitude, this._update()), this;
            }
            getAltitude() {
              return this._altitude;
            }
            getElement() {
              return this._element;
            }
            setPopup(e2) {
              if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e2) {
                if (!("offset" in e2.options)) {
                  const t2 = 38.1, i2 = 13.5, o2 = Math.sqrt(Math.pow(i2, 2) / 2);
                  e2.options.offset = this._defaultMarker ? { top: [0, 0], "top-left": [0, 0], "top-right": [0, 0], bottom: [0, -38.1], "bottom-left": [o2, -1 * (t2 - i2 + o2)], "bottom-right": [-o2, -1 * (t2 - i2 + o2)], left: [i2, -1 * (t2 - i2)], right: [-13.5, -1 * (t2 - i2)] } : this._offset;
                }
                this._popup = e2, e2._marker = this, e2._altitude = this._altitude, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
              }
              return this;
            }
            _onKeyPress(e2) {
              const t2 = e2.code, i2 = e2.charCode || e2.keyCode;
              "Space" !== t2 && "Enter" !== t2 && 32 !== i2 && 13 !== i2 || this.togglePopup();
            }
            _onMapClick(e2) {
              const t2 = e2.originalEvent.target, i2 = this._element;
              this._popup && (t2 === i2 || i2.contains(t2)) && this.togglePopup();
            }
            getPopup() {
              return this._popup;
            }
            togglePopup() {
              const e2 = this._popup;
              return e2 ? (e2.isOpen() ? (e2.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e2.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
              const e2 = this._map, t2 = this._pos;
              if (!e2 || !t2) return false;
              const i2 = e2.unproject(t2, this._altitude), o2 = e2.getFreeCameraOptions();
              if (!o2.position) return false;
              const s2 = o2.position.toLngLat();
              return s2.distanceTo(i2) < 0.9 * s2.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
              const t2 = this._map;
              if (!t2) return;
              const i2 = this._pos;
              if (!i2 || i2.x < 0 || i2.x > t2.transform.width || i2.y < 0 || i2.y > t2.transform.height) return void this._clearFadeTimer();
              const o2 = t2.unproject(i2, this._altitude);
              let s2;
              t2._showingGlobe() && e.eK(t2.transform, this._lngLat) ? s2 = 0 : (s2 = 1 - t2._queryFogOpacity(o2), t2.transform._terrainEnabled() && t2.getTerrain() && this._behindTerrain() && (s2 *= this._occludedOpacity)), this._element.style.opacity = `${s2}`, this._element.style.pointerEvents = s2 > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(s2), this._fadeTimer = null;
            }
            _clearFadeTimer() {
              this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
              const e2 = this._pos;
              if (!e2 || !this._map) return;
              const t2 = this._offset.mult(this._scale);
              this._element.style.transform = `
            translate(${e2.x}px,${e2.y}px)
            ${vl[this._anchor]}
            ${this._calculateXYTransform()} ${this._calculateZTransform()}
            translate(${t2.x}px,${t2.y}px)
        `;
            }
            _calculateXYTransform() {
              const t2 = this._pos, i2 = this._map, o2 = this.getPitchAlignment();
              if (!i2 || !t2 || "map" !== o2) return "";
              if (!i2._showingGlobe()) {
                const e2 = i2.getPitch();
                return e2 ? `rotateX(${e2}deg)` : "";
              }
              const s2 = e.cJ(e.eL(i2.transform, this._lngLat)), r2 = t2.sub(e.eM(i2.transform)), n2 = Math.abs(r2.x) + Math.abs(r2.y);
              if (0 === n2) return "";
              const a2 = s2 / n2;
              return `rotateX(${-r2.y * a2}deg) rotateY(${r2.x * a2}deg)`;
            }
            _calculateZTransform() {
              const t2 = this._pos, i2 = this._map;
              if (!i2 || !t2) return "";
              let o2 = 0;
              const s2 = this.getRotationAlignment();
              if ("map" === s2) if (i2._showingGlobe()) {
                const t3 = i2.project(new e.cd(this._lngLat.lng, this._lngLat.lat + 1e-3), this._altitude), s3 = i2.project(new e.cd(this._lngLat.lng, this._lngLat.lat - 1e-3), this._altitude).sub(t3);
                o2 = e.cJ(Math.atan2(s3.y, s3.x)) - 90;
              } else o2 = -i2.getBearing();
              else if ("horizon" === s2) {
                const s3 = e.af(4, 6, i2.getZoom()), r2 = e.eM(i2.transform);
                r2.y += s3 * i2.transform.height;
                const n2 = t2.sub(r2), a2 = e.cJ(Math.atan2(n2.y, n2.x));
                o2 = (a2 > 90 ? a2 - 270 : a2 + 90) * (1 - s3);
              }
              return o2 += this._rotation, o2 ? `rotateZ(${o2}deg)` : "";
            }
            _update(e2) {
              cancelAnimationFrame(this._updateFrameId);
              const t2 = this._map;
              t2 && (t2.transform.renderWorldCopies && (this._lngLat = gl(this._lngLat, this._pos, t2.transform)), this._pos = t2.project(this._lngLat, this._altitude), true === e2 ? this._updateFrameId = requestAnimationFrame(() => {
                this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
              }) : this._pos = this._pos.round(), t2._requestDomTask(() => {
                this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t2._showingGlobe() || t2.getTerrain() || t2.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
              }));
            }
            getOffset() {
              return this._offset;
            }
            setOffset(t2) {
              return this._offset = e.P.convert(t2), this._update(), this;
            }
            addClassName(e2) {
              return this._element.classList.add(e2), this;
            }
            removeClassName(e2) {
              return this._element.classList.remove(e2), this;
            }
            toggleClassName(e2) {
              return this._element.classList.toggle(e2);
            }
            _onMove(t2) {
              const i2 = this._map;
              if (!i2) return;
              const o2 = this._pointerdownPos, s2 = this._positionDelta;
              if (o2 && s2) {
                if (!this._isDragging) {
                  const e2 = this._clickTolerance || i2._clickTolerance;
                  if (t2.point.dist(o2) < e2) return;
                  this._isDragging = true;
                }
                this._pos = t2.point.sub(s2), this._lngLat = i2.unproject(this._pos, this._altitude), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e.A("dragstart"))), this.fire(new e.A("drag"));
              }
            }
            _onUp() {
              this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = false;
              const t2 = this._map;
              t2 && (t2.off("mousemove", this._onMove), t2.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e.A("dragend")), this._state = "inactive";
            }
            _addDragHandler(e2) {
              const t2 = this._map, i2 = this._pos;
              t2 && i2 && this._element.contains(e2.originalEvent.target) && (e2.preventDefault(), this._positionDelta = e2.point.sub(i2), this._pointerdownPos = e2.point, this._state = "pending", t2.on("mousemove", this._onMove), t2.on("touchmove", this._onMove), t2.once("mouseup", this._onUp), t2.once("touchend", this._onUp));
            }
            setDraggable(e2) {
              this._draggable = !!e2;
              const t2 = this._map;
              return t2 && (e2 ? (t2.on("mousedown", this._addDragHandler), t2.on("touchstart", this._addDragHandler)) : (t2.off("mousedown", this._addDragHandler), t2.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
              return this._draggable;
            }
            setRotation(e2) {
              return this._rotation = e2 || yl.rotation, this._update(), this;
            }
            getRotation() {
              return this._rotation;
            }
            setRotationAlignment(e2) {
              return this._rotationAlignment = e2 || yl.rotationAlignment, this._update(), this;
            }
            getRotationAlignment() {
              return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e2) {
              return this._pitchAlignment = e2 || yl.pitchAlignment, this._update(), this;
            }
            getPitchAlignment() {
              return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e2) {
              return this._occludedOpacity = e2 || yl.occludedOpacity, this._update(), this;
            }
            getOccludedOpacity() {
              return this._occludedOpacity;
            }
          }
          const bl = { positionOptions: { enableHighAccuracy: false, maximumAge: 0, timeout: 6e3 }, fitBoundsOptions: { maxZoom: 15 }, trackUserLocation: false, showAccuracyCircle: true, showUserLocation: true, showUserHeading: false }, wl = { maxWidth: 100, unit: "metric" }, Tl = { kilometer: "km", meter: "m", mile: "mi", foot: "ft", "nautical-mile": "nm" }, El = { closeButton: true, closeOnClick: true, focusAfterOpen: true, className: "", maxWidth: "240px", altitude: 0 }, Sl = ["a[href]", "[tabindex]:not([tabindex='-1'])", "[contenteditable]:not([contenteditable='false'])", "button:not([disabled])", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].join(", ");
          function Il(t2 = new e.P(0, 0), i2 = "bottom") {
            if ("number" == typeof t2) {
              const o2 = Math.round(Math.sqrt(0.5 * Math.pow(t2, 2)));
              switch (i2) {
                case "top":
                  return new e.P(0, t2);
                case "top-left":
                  return new e.P(o2, o2);
                case "top-right":
                  return new e.P(-o2, o2);
                case "bottom":
                  return new e.P(0, -t2);
                case "bottom-left":
                  return new e.P(o2, -o2);
                case "bottom-right":
                  return new e.P(-o2, -o2);
                case "left":
                  return new e.P(t2, 0);
                case "right":
                  return new e.P(-t2, 0);
              }
              return new e.P(0, 0);
            }
            return t2 instanceof e.P || Array.isArray(t2) ? e.P.convert(t2) : e.P.convert(t2[i2] || [0, 0]);
          }
          const Cl = { version: t, supported: a.supported, setRTLTextPlugin: e.eQ, getRTLTextPluginStatus: e.eP, Map: class extends rl {
            constructor(t2) {
              o.mark(i.create);
              const s2 = t2;
              if (null != (t2 = e.h({}, pl, t2)).minZoom && null != t2.maxZoom && t2.minZoom > t2.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
              if (null != t2.minPitch && null != t2.maxPitch && t2.minPitch > t2.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
              if (null != t2.minPitch && t2.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
              if (null != t2.maxPitch && t2.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
              if (t2.antialias && e.eI(window) && (t2.antialias = false, e.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new Qi(t2.minZoom, t2.maxZoom, t2.minPitch, t2.maxPitch, t2.renderWorldCopies, null, null), t2), this._repaint = !!t2.repaint, this._interactive = t2.interactive, this._minTileCacheSize = t2.minTileCacheSize, this._maxTileCacheSize = t2.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t2.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t2.preserveDrawingBuffer, this._antialias = t2.antialias, this._trackResize = t2.trackResize, this._bearingSnap = t2.bearingSnap, this._refreshExpiredTiles = t2.refreshExpiredTiles, this._fadeDuration = t2.fadeDuration, this._isInitialLoad = true, this._crossSourceCollisions = t2.crossSourceCollisions, this._collectResourceTiming = t2.collectResourceTiming, this._language = this._parseLanguage(t2.language), this._worldview = t2.worldview, this._renderTaskQueue = new ll(), this._domRenderTaskQueue = new ll(), this._controls = [], this._markers = [], this._popups = [], this._mapId = e.a$(), this._locale = e.h({}, hl, t2.locale), this._clickTolerance = t2.clickTolerance, this._cooperativeGestures = t2.cooperativeGestures, this._performanceMetricsCollection = t2.performanceMetricsCollection, this._tessellationStep = t2.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = true, this._precompilePrograms = t2.precompilePrograms, this._scaleFactorChanged = false, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new cl(0), this._interactionRange = [1 / 0, -1 / 0], this._visibilityHidden = 0, this._useExplicitProjection = false, this._frameId = 0, this._scaleFactor = t2.scaleFactor, this._requestManager = new T(t2.transformRequest, t2.accessToken, t2.testMode), this._silenceAuthErrors = !!t2.testMode, this._contextCreateOptions = t2.contextCreateOptions ? Object.assign({}, t2.contextCreateOptions) : {}, "string" == typeof t2.container) {
                const e2 = document.getElementById(t2.container);
                if (!e2) throw new Error(`Container '${t2.container.toString()}' not found.`);
                this._container = e2;
              } else {
                if (!(t2.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                this._container = t2.container;
              }
              if (this._container.childNodes.length > 0 && e.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t2.maxBounds && this.setMaxBounds(t2.maxBounds), this._spriteFormat = t2.spriteFormat, e.aV(["_onWindowOnline", "_onWindowResize", "_onVisibilityChange", "_onMapScroll", "_contextLost", "_contextRestored"], this), this._setupContainer(), this._tp || (this._tp = new Vn()), this._tp.registerParameter(this, ["Debug"], "showOverdrawInspector"), this._tp.registerParameter(this, ["Debug"], "showTileBoundaries"), this._tp.registerParameter(this, ["Debug"], "showParseStatus"), this._tp.registerParameter(this, ["Debug"], "repaint"), this._tp.registerParameter(this, ["Debug"], "showTileAABBs"), this._tp.registerParameter(this, ["Debug"], "showPadding"), this._tp.registerParameter(this, ["Debug"], "showCollisionBoxes", { noSave: true }), this._tp.registerParameter(this.transform, ["Debug"], "freezeTileCoverage", { noSave: true }, () => {
                this._update();
              }), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showTerrainWireframe"), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showLayers2DWireframe"), this._tp.registerParameter(this, ["Debug", "Wireframe"], "showLayers3DWireframe"), this._tp.registerParameter(this, ["Scaling"], "_scaleFactor", { min: 0.1, max: 10, step: 0.1 }, () => {
                this.setScaleFactor(this._scaleFactor);
              }), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
              if (this.on("move", () => this._update(false)), this.on("moveend", () => this._update(false)), this.on("zoom", () => this._update(true)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, false), window.addEventListener("resize", this._onWindowResize, false), window.addEventListener("orientationchange", this._onWindowResize, false), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, false), window.addEventListener("visibilitychange", this._onVisibilityChange, false), this.handlers = new ol(this, t2), this._localFontFamily = t2.localFontFamily, this._localIdeographFontFamily = t2.localIdeographFontFamily, (t2.style || !t2.testMode) && this.setStyle(t2.style || e.e.DEFAULT_STYLE, { config: t2.config, localFontFamily: this._localFontFamily, localIdeographFontFamily: this._localIdeographFontFamily }), t2.projection && this.setProjection(t2.projection), this.indoor = new po(this), t2.hash && (this._hash = new na("string" == typeof t2.hash && t2.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                null == s2.center && null == s2.zoom || (this.transform._unmodified = false), this.jumpTo({ center: t2.center, zoom: t2.zoom, bearing: t2.bearing, pitch: t2.pitch });
                const i2 = t2.bounds;
                i2 && (this.resize(), this.fitBounds(i2, e.h({}, t2.fitBoundsOptions, { duration: 0 })));
              }
              this.resize(), t2.attributionControl && this.addControl(new nl({ customAttribution: t2.customAttribution })), this._logoControl = new al(), this.addControl(this._logoControl, t2.logoPosition), this.on("style.load", () => {
                this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent();
              }), this.on("data", (t3) => {
                this._update("style" === t3.dataType), this.fire(new e.A(`${t3.dataType}data`, t3));
              }), this.on("dataloading", (t3) => {
                this.fire(new e.A(`${t3.dataType}dataloading`, t3));
              }), this._interactions = new ul(this);
            }
            _getMapId() {
              return this._mapId;
            }
            addControl(t2, i2) {
              if (void 0 === i2 && (i2 = t2.getDefaultPosition ? t2.getDefaultPosition() : "top-right"), !t2 || !t2.onAdd) return this.fire(new e.z(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
              const o2 = t2.onAdd(this);
              this._controls.push(t2);
              const s2 = this._controlPositions[i2];
              return -1 !== i2.indexOf("bottom") ? s2.insertBefore(o2, s2.firstChild) : s2.appendChild(o2), this;
            }
            removeControl(t2) {
              if (!t2 || !t2.onRemove) return this.fire(new e.z(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
              const i2 = this._controls.indexOf(t2);
              return i2 > -1 && this._controls.splice(i2, 1), t2.onRemove(this), this;
            }
            hasControl(e2) {
              return this._controls.indexOf(e2) > -1;
            }
            getContainer() {
              return this._container;
            }
            getCanvasContainer() {
              return this._canvasContainer;
            }
            getCanvas() {
              return this._canvas;
            }
            resize(t2) {
              if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
              this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
              const i2 = !this._moving;
              return i2 && this.fire(new e.A("movestart", t2)).fire(new e.A("move", t2)), this.fire(new e.A("resize", t2)), i2 && this.fire(new e.A("moveend", t2)), this;
            }
            getBounds() {
              return this.transform.getBounds();
            }
            getMaxBounds() {
              return this.transform.getMaxBounds() || null;
            }
            setMaxBounds(t2) {
              return this.transform.setMaxBounds(e.aG.convert(t2)), this._update();
            }
            setMinZoom(t2) {
              if ((t2 = t2 ?? -2) >= -2 && t2 <= this.transform.maxZoom) return this.transform.minZoom = t2, this._update(), this.getZoom() < t2 ? this.setZoom(t2) : this.fire(new e.A("zoomstart")).fire(new e.A("zoom")).fire(new e.A("zoomend")), this;
              throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
            }
            getMinZoom() {
              return this.transform.minZoom;
            }
            setMaxZoom(t2) {
              if ((t2 = t2 ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = t2, this._update(), this.getZoom() > t2 ? this.setZoom(t2) : this.fire(new e.A("zoomstart")).fire(new e.A("zoom")).fire(new e.A("zoomend")), this;
              throw new Error("maxZoom must be greater than the current minZoom");
            }
            getMaxZoom() {
              return this.transform.maxZoom;
            }
            setMinPitch(t2) {
              if ((t2 = t2 ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
              if (t2 >= 0 && t2 <= this.transform.maxPitch) return this.transform.minPitch = t2, this._update(), this.getPitch() < t2 ? this.setPitch(t2) : this.fire(new e.A("pitchstart")).fire(new e.A("pitch")).fire(new e.A("pitchend")), this;
              throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
            }
            getMinPitch() {
              return this.transform.minPitch;
            }
            setMaxPitch(t2) {
              if ((t2 = t2 ?? 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
              if (t2 >= this.transform.minPitch) return this.transform.maxPitch = t2, this._update(), this.getPitch() > t2 ? this.setPitch(t2) : this.fire(new e.A("pitchstart")).fire(new e.A("pitch")).fire(new e.A("pitchend")), this;
              throw new Error("maxPitch must be greater than or equal to minPitch");
            }
            getMaxPitch() {
              return this.transform.maxPitch;
            }
            getScaleFactor() {
              return this._scaleFactor;
            }
            setScaleFactor(e2) {
              return this._scaleFactor = e2, this.painter.scaleFactor = e2, this._tp.refreshUI(), this._scaleFactorChanged = true, this.style._updateFilteredLayers((e3) => "symbol" === e3.type), this._update(true), this;
            }
            getRenderWorldCopies() {
              return this.transform.renderWorldCopies;
            }
            setRenderWorldCopies(e2) {
              return this.transform.renderWorldCopies = e2, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(true), this._update();
            }
            getLanguage() {
              return this._language;
            }
            _parseLanguage(e2) {
              return "auto" === e2 ? navigator.language : Array.isArray(e2) ? 0 === e2.length ? void 0 : e2.map((e3) => "auto" === e3 ? navigator.language : e3) : e2;
            }
            setLanguage(e2) {
              const t2 = this._parseLanguage(e2);
              if (!this.style || t2 === this._language) return this;
              this._language = t2, this.style.reloadSources();
              for (const e3 of this._controls) e3._setLanguage && e3._setLanguage(this._language);
              return this;
            }
            getWorldview() {
              return this._worldview;
            }
            setWorldview(e2) {
              return this.style && e2 !== this._worldview ? (this._worldview = e2, this._styleDirty = true, this.style.reloadSources(), this) : this;
            }
            getProjection() {
              return this.transform.mercatorFromTransition ? { name: "globe", center: [0, 0] } : this.transform.getProjection();
            }
            _showingGlobe() {
              return "globe" === this.transform.projection.name;
            }
            setProjection(e2) {
              return this._lazyInitEmptyStyle(), e2 ? "string" == typeof e2 && (e2 = { name: e2 }) : e2 = null, this._useExplicitProjection = !!e2, this._prioritizeAndUpdateProjection(e2, this.style.projection);
            }
            _updateProjectionTransition() {
              if ("globe" !== this.getProjection().name) return;
              const t2 = this.transform, i2 = t2.projection.name;
              let o2;
              "globe" === i2 && t2.zoom >= e.cx ? (t2.setMercatorFromTransition(), o2 = true) : "mercator" === i2 && t2.zoom < e.cx && (t2.setProjection({ name: "globe" }), o2 = true), o2 && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate(), this._update(true));
            }
            _prioritizeAndUpdateProjection(e2, t2) {
              return this._updateProjection(e2 || t2 || { name: "mercator" });
            }
            _updateProjection(t2) {
              let i2;
              return i2 = "globe" === t2.name && this.transform.zoom >= e.cx ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t2), this.style.applyProjectionUpdate(), i2 && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(true), this._forceMarkerAndPopupUpdate(true)), this;
            }
            project(t2, i2) {
              return this.transform.locationPoint3D(e.cd.convert(t2), i2);
            }
            unproject(t2, i2) {
              return this.transform.pointLocation3D(e.P.convert(t2), i2);
            }
            isMoving() {
              return this._moving || this.handlers && this.handlers.isMoving() || false;
            }
            isZooming() {
              return this._zooming || this.handlers && this.handlers.isZooming() || false;
            }
            isRotating() {
              return this._rotating || this.handlers && this.handlers.isRotating() || false;
            }
            _isDragging() {
              return this.handlers && this.handlers._isDragging() || false;
            }
            _createDelegatedListener(e2, t2, i2) {
              const o2 = (e3) => {
                let i3 = [];
                if (Array.isArray(t2)) {
                  const o3 = t2.filter((e4) => this.getLayer(e4));
                  i3 = o3.length ? this.queryRenderedFeatures(e3, { layers: o3 }) : [];
                } else i3 = this.queryRenderedFeatures(e3, { target: t2 });
                return i3;
              };
              if ("mouseenter" === e2 || "mouseover" === e2) {
                let s2 = false;
                const r2 = (t3) => {
                  const r3 = o2(t3.point);
                  r3.length ? s2 || (s2 = true, i2.call(this, new ma(e2, this, t3.originalEvent, { features: r3 }))) : s2 = false;
                };
                return { listener: i2, targets: t2, delegates: { mousemove: r2, mouseout: () => {
                  s2 = false;
                } } };
              }
              if ("mouseleave" === e2 || "mouseout" === e2) {
                let s2 = false;
                const r2 = (t3) => {
                  o2(t3.point).length ? s2 = true : s2 && (s2 = false, i2.call(this, new ma(e2, this, t3.originalEvent)));
                }, n2 = (t3) => {
                  s2 && (s2 = false, i2.call(this, new ma(e2, this, t3.originalEvent)));
                };
                return { listener: i2, targets: t2, delegates: { mousemove: r2, mouseout: n2 } };
              }
              {
                const s2 = (e3) => {
                  const t3 = o2(e3.point);
                  t3.length && (e3.features = t3, i2.call(this, e3), delete e3.features);
                };
                return { listener: i2, targets: t2, delegates: { [e2]: s2 } };
              }
            }
            on(e2, t2, i2) {
              if ("function" == typeof t2 || void 0 === i2) return super.on(e2, t2);
              if ("string" == typeof t2 && (t2 = [t2]), !this._areTargetsValid(t2)) return this;
              const o2 = this._createDelegatedListener(e2, t2, i2);
              this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e2] = this._delegatedListeners[e2] || [], this._delegatedListeners[e2].push(o2);
              for (const e3 in o2.delegates) this.on(e3, o2.delegates[e3]);
              return this;
            }
            once(e2, t2, i2) {
              if ("function" == typeof t2 || void 0 === i2) return super.once(e2, t2);
              if ("string" == typeof t2 && (t2 = [t2]), !this._areTargetsValid(t2)) return this;
              const o2 = this._createDelegatedListener(e2, t2, i2);
              for (const e3 in o2.delegates) this.once(e3, o2.delegates[e3]);
              return this;
            }
            off(e2, t2, i2) {
              if ("function" == typeof t2 || void 0 === i2) return super.off(e2, t2);
              if ("string" == typeof t2 && (t2 = [t2]), !this._areTargetsValid(t2)) return this;
              const o2 = this._delegatedListeners ? this._delegatedListeners[e2] : void 0;
              return o2 && ((e3) => {
                for (let o3 = 0; o3 < e3.length; o3++) {
                  const s2 = e3[o3];
                  if (s2.listener === i2 && _l(s2.targets, t2)) {
                    for (const e4 in s2.delegates) this.off(e4, s2.delegates[e4]);
                    return e3.splice(o3, 1), this;
                  }
                }
              })(o2), this;
            }
            queryRenderedFeatures(t2, i2) {
              if (!this.style) return [];
              if (void 0 === t2 || t2 instanceof e.P || Array.isArray(t2) || void 0 !== i2 || (i2 = t2, t2 = void 0), t2 = t2 || [[0, 0], [this.transform.width, this.transform.height]], !i2) {
                const e2 = this.style.queryRenderedFeatures(t2, void 0, this.transform), i3 = this.style.queryRenderedFeatureset(t2, void 0, this.transform);
                return e2.concat(i3);
              }
              let o2 = true;
              if (i2.target && (o2 = this._isTargetValid(i2.target), o2 && !i2.layers)) return this.style.queryRenderedFeatureset(t2, i2, this.transform);
              let s2 = true;
              if (i2.layers && Array.isArray(i2.layers)) {
                for (const e2 of i2.layers) if (!this._isValidId(e2)) {
                  s2 = false;
                  break;
                }
                if (s2 && !i2.target) return this.style.queryRenderedFeatures(t2, i2, this.transform);
              }
              let r2 = [];
              return s2 && (r2 = r2.concat(this.style.queryRenderedFeatures(t2, i2, this.transform))), o2 && (r2 = r2.concat(this.style.queryRenderedFeatureset(t2, i2, this.transform))), r2;
            }
            querySourceFeatures(e2, t2) {
              return !e2 || "string" == typeof e2 && !this._isValidId(e2) ? [] : this.style.querySourceFeatures(e2, t2);
            }
            isPointOnSurface(t2) {
              const { name: i2 } = this.transform.projection;
              return "globe" !== i2 && "mercator" !== i2 && e.w(`${i2} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e.P.convert(t2));
            }
            addInteraction(e2, t2) {
              return this._interactions.add(e2, t2), this;
            }
            removeInteraction(e2) {
              return this._interactions.remove(e2), this;
            }
            getCooperativeGestures() {
              return this._cooperativeGestures;
            }
            setCooperativeGestures(e2) {
              return this._cooperativeGestures = e2, this;
            }
            setStyle(t2, i2) {
              return i2 = e.h({}, { localIdeographFontFamily: this._localIdeographFontFamily, localFontFamily: this._localFontFamily }, i2), this.style && t2 && false !== i2.diff && i2.localFontFamily === this._localFontFamily && i2.localIdeographFontFamily === this._localIdeographFontFamily && !i2.config ? (this.style._diffStyle(t2, (o2, s2) => {
                if (o2) {
                  const s3 = "string" == typeof o2 ? o2 : o2 instanceof Error ? o2.message : o2.error;
                  e.w(`Unable to perform style diff: ${s3}. Rebuilding the style from scratch.`), this._updateStyle(t2, i2);
                } else s2 && this._update(true);
              }, () => this._postStyleLoadEvent()), this) : (this._localIdeographFontFamily = i2.localIdeographFontFamily, this._localFontFamily = i2.localFontFamily, this._updateStyle(t2, i2));
            }
            _getUIString(e2) {
              const t2 = this._locale[e2];
              if (null == t2) throw new Error(`Missing UI string '${e2}'`);
              return t2;
            }
            _updateStyle(t2, i2) {
              if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), t2) {
                const o2 = e.h({}, i2);
                i2 && i2.config && (o2.initialConfig = i2.config, delete o2.config), this.style = new Eo(this, o2).load(t2), this.style.setEventedParent(this, { style: this.style });
              }
              return this._updateTerrain(), this;
            }
            _lazyInitEmptyStyle() {
              this.style || (this.style = new Eo(this, {}), this.style.setEventedParent(this, { style: this.style }), this.style.loadEmpty());
            }
            getStyle() {
              if (this.style) return this.style.serialize();
            }
            isStyleLoaded() {
              return this.style ? this.style.loaded() : (e.w("There is no style added to the map."), false);
            }
            _isValidId(t2) {
              return null == t2 ? (this.fire(new e.z(new Error("IDs can't be empty."))), false) : !e.d8(t2) || (this.fire(new e.z(new Error(`IDs can't contain special symbols: "${t2}".`))), false);
            }
            _isTargetValid(e2) {
              return "featuresetId" in e2 ? this._isValidId("importId" in e2 ? e2.importId : e2.featuresetId) : "layerId" in e2 && this._isValidId(e2.layerId);
            }
            _areTargetsValid(e2) {
              if (Array.isArray(e2)) {
                for (const t2 of e2) if (!this._isValidId(t2)) return false;
                return true;
              }
              return this._isTargetValid(e2);
            }
            addSource(e2, t2) {
              return this._isValidId(e2) ? (this._lazyInitEmptyStyle(), this.style.addSource(e2, t2), this._update(true)) : this;
            }
            isSourceLoaded(e2) {
              return !!this._isValidId(e2) && !!this.style && this.style._isSourceCacheLoaded(e2);
            }
            areTilesLoaded() {
              return this.style.areTilesLoaded();
            }
            addSourceType(e2, t2, i2) {
              this._lazyInitEmptyStyle(), this.style.addSourceType(e2, t2, i2);
            }
            removeSource(e2) {
              return this._isValidId(e2) ? (this.style.removeSource(e2), this._updateTerrain(), this._update(true)) : this;
            }
            getSource(e2) {
              return this._isValidId(e2) ? this.style.getOwnSource(e2) : null;
            }
            addImage(t2, i2, { pixelRatio: o2 = 1, sdf: s2 = false, stretchX: r2, stretchY: n2, content: a2 } = {}) {
              this._lazyInitEmptyStyle();
              const l2 = e.I.from(t2);
              if (i2 instanceof HTMLImageElement || ImageBitmap && i2 instanceof ImageBitmap) {
                const { width: t3, height: c2, data: h3 } = e.q.getImageData(i2);
                this.style.addImage(l2, { data: new e.r({ width: t3, height: c2 }, h3), pixelRatio: o2, stretchX: r2, stretchY: n2, content: a2, sdf: s2, version: 0, usvg: false });
              } else if (void 0 === i2.width || void 0 === i2.height) this.fire(new e.z(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
              else {
                const { width: c2, height: h3 } = i2, d2 = i2;
                this.style.addImage(l2, { data: new e.r({ width: c2, height: h3 }, new Uint8Array(d2.data)), pixelRatio: o2, stretchX: r2, stretchY: n2, content: a2, sdf: s2, usvg: false, version: 0, userImage: d2 }), d2.onAdd && d2.onAdd(this, t2);
              }
            }
            updateImage(t2, i2) {
              this._lazyInitEmptyStyle();
              const o2 = e.I.from(t2), s2 = this.style.getImage(o2);
              if (!s2) return void this.fire(new e.z(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
              const r2 = i2 instanceof HTMLImageElement || ImageBitmap && i2 instanceof ImageBitmap ? e.q.getImageData(i2) : i2, { width: n2, height: a2, data: l2 } = r2;
              if (void 0 === n2 || void 0 === a2) return void this.fire(new e.z(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
              if (n2 !== (s2.usvg ? s2.icon.usvg_tree.width : s2.data.width) || a2 !== (s2.usvg ? s2.icon.usvg_tree.height : s2.data.height)) return void this.fire(new e.z(new Error(`The width and height of the updated image (${n2}, ${a2})
                must be that same as the previous version of the image
                (${s2.data.width}, ${s2.data.height})`)));
              const c2 = !(i2 instanceof HTMLImageElement || ImageBitmap && i2 instanceof ImageBitmap);
              let h3 = false;
              s2.usvg ? (s2.data = new e.r({ width: n2, height: a2 }, new Uint8Array(l2)), s2.usvg = false, s2.icon = void 0, h3 = true) : s2.data.replace(l2, c2), this.style.updateImage(o2, s2, h3);
            }
            hasImage(t2) {
              return t2 ? !!this.style && !!this.style.getImage(e.I.from(t2)) : (this.fire(new e.z(new Error("Missing required image id"))), false);
            }
            removeImage(t2) {
              this.style.removeImage(e.I.from(t2));
            }
            loadImage(t2, i2) {
              e.o(this._requestManager.transformRequest(t2, e.R.Image), (t3, o2) => {
                i2(t3, o2 instanceof HTMLImageElement ? e.q.getImageData(o2) : o2);
              });
            }
            listImages() {
              return this.style.listImages().map((e2) => e2.name);
            }
            addModel(e2, t2) {
              this._lazyInitEmptyStyle(), this.style.addModel(e2, t2);
            }
            hasModel(t2) {
              return t2 ? this.style.hasModel(t2) : (this.fire(new e.z(new Error("Missing required model id"))), false);
            }
            removeModel(e2) {
              this.style.removeModel(e2);
            }
            listModels() {
              return this.style.listModels();
            }
            addLayer(e2, t2) {
              return this._isValidId(e2.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e2, t2), this._update(true)) : this;
            }
            getSlot(e2) {
              const t2 = this.getLayer(e2);
              return t2 && t2.slot || null;
            }
            setSlot(e2, t2) {
              return this.style.setSlot(e2, t2), this.style.mergeLayers(), this._update(true);
            }
            addImport(t2, i2) {
              return this.style.addImport(t2, i2).catch((t3) => this.fire(new e.z(new Error("Failed to add import", t3)))), this;
            }
            updateImport(e2, t2) {
              return "string" != typeof t2 && t2.id !== e2 ? (this.removeImport(e2), this.addImport(t2)) : (this.style.updateImport(e2, t2), this._update(true));
            }
            removeImport(e2) {
              return this.style.removeImport(e2), this;
            }
            moveImport(e2, t2) {
              return this.style.moveImport(e2, t2), this._update(true);
            }
            moveLayer(e2, t2) {
              return this._isValidId(e2) ? (this.style.moveLayer(e2, t2), this._update(true)) : this;
            }
            removeLayer(e2) {
              return this._isValidId(e2) ? (this.style.removeLayer(e2), this._update(true)) : this;
            }
            getLayer(e2) {
              if (!this._isValidId(e2)) return null;
              const t2 = this.style.getOwnLayer(e2);
              return t2 ? "custom" === t2.type ? t2.implementation : t2.serialize() : void 0;
            }
            getSlots() {
              return this.style.getSlots();
            }
            setLayerZoomRange(e2, t2, i2) {
              return this._isValidId(e2) ? (this.style.setLayerZoomRange(e2, t2, i2), this._update(true)) : this;
            }
            setFilter(e2, t2, i2 = {}) {
              return this._isValidId(e2) ? (this.style.setFilter(e2, t2, i2), this._update(true)) : this;
            }
            getFilter(e2) {
              return this._isValidId(e2) ? this.style.getFilter(e2) : null;
            }
            setPaintProperty(e2, t2, i2, o2 = {}) {
              return this._isValidId(e2) ? (this.style.setPaintProperty(e2, t2, i2, o2), this._update(true)) : this;
            }
            getPaintProperty(e2, t2) {
              return this._isValidId(e2) ? this.style.getPaintProperty(e2, t2) : null;
            }
            setLayoutProperty(e2, t2, i2, o2 = {}) {
              return this._isValidId(e2) ? (this.style.setLayoutProperty(e2, t2, i2, o2), this._update(true)) : this;
            }
            getLayoutProperty(e2, t2) {
              return this._isValidId(e2) ? this.style.getLayoutProperty(e2, t2) : null;
            }
            getGlyphsUrl() {
              return this.style.getGlyphsUrl();
            }
            setGlyphsUrl(e2) {
              return this.style.setGlyphsUrl(e2), this._update(true);
            }
            getSchema(e2) {
              return this.style.getSchema(e2);
            }
            setSchema(e2, t2) {
              return this.style.setSchema(e2, t2), this._update(true);
            }
            getConfig(e2) {
              return this.style.getConfig(e2);
            }
            setConfig(e2, t2) {
              return this.style.setConfig(e2, t2), this._update(true);
            }
            getConfigProperty(e2, t2) {
              return this.style.getConfigProperty(e2, t2);
            }
            setConfigProperty(e2, t2, i2) {
              return this.style.setConfigProperty(e2, t2, i2), this._update(true);
            }
            getFeaturesetDescriptors(e2) {
              return this.style.getFeaturesetDescriptors(e2);
            }
            setLights(e2) {
              if (this._lazyInitEmptyStyle(), e2 && 1 === e2.length && "flat" === e2[0].type) {
                const t2 = e2[0];
                t2.properties ? this.style.setFlatLight(t2.properties, t2.id, {}) : this.style.setFlatLight({}, "flat");
              } else this.style.setLights(e2), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = true);
              return this._update(true);
            }
            getLights() {
              const e2 = this.style.getLights() || [];
              return 0 === e2.length && e2.push({ id: this.style.light.id, type: "flat", properties: this.style.getFlatLight() }), e2;
            }
            setLight(e2, t2 = {}) {
              return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([{ id: "flat", type: "flat", properties: e2 }]);
            }
            getLight() {
              return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
            }
            setTerrain(e2) {
              return this._lazyInitEmptyStyle(), !e2 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e2), this._averageElevationLastSampledAt = -1 / 0, this._update(true);
            }
            getTerrain() {
              return this.style ? this.style.getTerrain() : null;
            }
            setFog(e2) {
              return this._lazyInitEmptyStyle(), this.style.setFog(e2), this._update(true);
            }
            getFog() {
              return this.style ? this.style.getFog() : null;
            }
            setSnow(e2) {
              return this._lazyInitEmptyStyle(), this.style.setSnow(e2), this._update(true);
            }
            getSnow() {
              return this.style ? this.style.getSnow() : null;
            }
            setRain(e2) {
              return this._lazyInitEmptyStyle(), this.style.setRain(e2), this._update(true);
            }
            getRain() {
              return this.style ? this.style.getRain() : null;
            }
            setColorTheme(e2) {
              return this._lazyInitEmptyStyle(), this.style.setColorTheme(e2), this._update(true);
            }
            setImportColorTheme(e2, t2) {
              return this._lazyInitEmptyStyle(), this.style.setImportColorTheme(e2, t2), this._update(true);
            }
            setCamera(e2) {
              return this.style.setCamera(e2), this._triggerCameraUpdate(e2);
            }
            _triggerCameraUpdate(e2) {
              return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e2["camera-projection"]));
            }
            getCamera() {
              return this.style.camera;
            }
            _queryFogOpacity(t2) {
              return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e.cd.convert(t2), this.transform) : 0;
            }
            setFeatureState(e2, t2) {
              return e2.source && !this._isValidId(e2.source) ? this : (this.style.setFeatureState(e2, t2), this._update());
            }
            removeFeatureState(e2, t2) {
              return e2.source && !this._isValidId(e2.source) ? this : (this.style.removeFeatureState(e2, t2), this._update());
            }
            getFeatureState(e2) {
              return e2.source && !this._isValidId(e2.source) ? null : this.style.getFeatureState(e2);
            }
            _updateContainerDimensions() {
              if (!this._container) return;
              const e2 = this._container.getBoundingClientRect().width || 400, t2 = this._container.getBoundingClientRect().height || 300;
              let i2, o2, s2, r2 = this._container;
              for (; r2 && (!o2 || !s2); ) {
                const e3 = window.getComputedStyle(r2).transform;
                e3 && "none" !== e3 && (i2 = e3.match(/matrix.*\((.+)\)/)[1].split(", "), i2[0] && "0" !== i2[0] && "1" !== i2[0] && (o2 = i2[0]), i2[3] && "0" !== i2[3] && "1" !== i2[3] && (s2 = i2[3])), r2 = r2.parentElement;
              }
              this._containerWidth = o2 ? Math.abs(e2 / o2) : e2, this._containerHeight = s2 ? Math.abs(t2 / s2) : t2;
            }
            _detectMissingCSS() {
              "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
            }
            _setupContainer() {
              const e2 = this._container;
              e2.classList.add("mapboxgl-map"), (this._missingCSSCanary = l("div", "mapboxgl-canary", e2)).style.visibility = "hidden", this._detectMissingCSS();
              const t2 = this._canvasContainer = l("div", "mapboxgl-canvas-container", e2);
              this._canvas = l("canvas", "mapboxgl-canvas", t2), this._interactive && (t2.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, false), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, false), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
              const i2 = this._controlContainer = l("div", "mapboxgl-control-container", e2), o2 = this._controlPositions = {};
              ["top-left", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left"].forEach((e3) => {
                o2[e3] = l("div", `mapboxgl-ctrl-${e3}`, i2);
              }), this._container.addEventListener("scroll", this._onMapScroll, false);
            }
            _resizeCanvas(t2, i2) {
              const o2 = e.q.devicePixelRatio || 1;
              this._canvas.width = o2 * Math.ceil(t2), this._canvas.height = o2 * Math.ceil(i2), this._canvas.style.width = `${t2}px`, this._canvas.style.height = `${i2}px`;
            }
            _addMarker(e2) {
              this._markers.push(e2);
            }
            _removeMarker(e2) {
              const t2 = this._markers.indexOf(e2);
              -1 !== t2 && this._markers.splice(t2, 1);
            }
            _addPopup(e2) {
              this._popups.push(e2);
            }
            _removePopup(e2) {
              const t2 = this._popups.indexOf(e2);
              -1 !== t2 && this._popups.splice(t2, 1);
            }
            _setupPainter() {
              const t2 = e.h({}, a.supported.webGLContextAttributes, { failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat, preserveDrawingBuffer: this._preserveDrawingBuffer, antialias: this._antialias || false }), i2 = this._canvas.getContext("webgl2", t2);
              i2 ? (j(i2, true), this.painter = new sa(i2, this._contextCreateOptions, this.transform, this._scaleFactor, this._tp, this._worldview), this.on("data", (e2) => {
                "source" === e2.dataType && this.painter.setTileLoadedFlag(true);
              }), e.l.testSupport(i2)) : this.fire(new e.z(new Error("Failed to initialize WebGL")));
            }
            _contextLost(t2) {
              t2.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e.A("webglcontextlost", { originalEvent: t2 }));
            }
            _contextRestored(t2) {
              this._setupPainter(), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight)), this._updateTerrain(), this.style && (this.style.reloadModels(), this.style.clearSources()), this._update(), this.fire(new e.A("webglcontextrestored", { originalEvent: t2 }));
            }
            _onMapScroll(e2) {
              if (e2.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, false;
            }
            idle() {
              return !this.isMoving() && this.loaded();
            }
            loaded() {
              return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
            }
            frameReady() {
              return this.loaded() && !this._placementDirty;
            }
            _update(e2) {
              return this.style ? (this._styleDirty = this._styleDirty || e2, this._sourcesDirty = true, this.triggerRepaint(), this) : this;
            }
            _requestRenderFrame(e2) {
              return this._update(), this._renderTaskQueue.add(e2);
            }
            _cancelRenderFrame(e2) {
              this._renderTaskQueue.remove(e2);
            }
            _requestDomTask(e2) {
              !this.loaded() || this.loaded() && !this.isMoving() ? e2() : this._domRenderTaskQueue.add(e2);
            }
            _render(t2) {
              let s2;
              this.fire(new e.A("renderstart")), ++this._frameId;
              const r2 = this.painter.context.extTimerQuery, n2 = e.q.now(), a2 = this.painter.context.gl;
              if (this.listens("gpu-timing-frame") && (s2 = a2.createQuery(), a2.beginQuery(r2.TIME_ELAPSED_EXT, s2)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t2), this._domRenderTaskQueue.run(t2), this._removed) return;
              this._updateProjectionTransition();
              const l2 = this._isInitialLoad ? 0 : this._fadeDuration;
              if (this.style && this._styleDirty) {
                this._styleDirty = false;
                const t3 = this.transform.zoom, i2 = this.transform.pitch, o2 = e.q.now(), s3 = new e.aa(t3, { now: o2, fadeDuration: l2, pitch: i2, transition: this.style.transition, worldview: this._worldview });
                this.style.update(s3);
              }
              this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = true, this._sourcesDirty = true);
              let c2 = false;
              this.style && this._sourcesDirty ? (this._sourcesDirty = false, this.painter._updateFog(this.style), this._updateTerrain(), c2 = this._updateAverageElevation(n2), this.style.updateSources(this.transform), this.style.updateImageProviders(), this.isMoving() || this._forceMarkerAndPopupUpdate()) : c2 = this._updateAverageElevation(n2);
              const h3 = this.style && this.style._updatePlacement(this.painter, this.painter.transform, this.showCollisionBoxes, l2, this._crossSourceCollisions, this.painter.replacementSource, this._scaleFactorChanged);
              if (this._scaleFactorChanged && (this._scaleFactorChanged = false), h3 && (this._placementDirty = h3.needsRerender), this.style && this.painter.render(this.style, { showTileBoundaries: this.showTileBoundaries, showParseStatus: this.showParseStatus, wireframe: { terrain: this.showTerrainWireframe, layers2D: this.showLayers2DWireframe, layers3D: this.showLayers3DWireframe }, showOverdrawInspector: this._showOverdrawInspector, showQueryGeometry: !!this._showQueryGeometry, showTileAABBs: this.showTileAABBs, rotating: this.isRotating(), zooming: this.isZooming(), moving: this.isMoving(), fadeDuration: l2, isInitialLoad: this._isInitialLoad, showPadding: this.showPadding, gpuTiming: !!this.listens("gpu-timing-layer"), gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"), speedIndexTiming: this.speedIndexTiming }), this.fire(new e.A("render")), this.loaded() && !this._loaded && (this._loaded = true, o.mark(i.load), this.fire(new e.A("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = true), this.style && (this.style.snow || this.style.rain) && (this._styleDirty = true), this.style && this.style.imageManager.hasPatternsInFlight() && (this._styleDirty = true), this.style && !this.style.modelManager.isLoaded() && (this._styleDirty = true), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), s2) {
                const t3 = e.q.now() - n2;
                a2.endQuery(r2.TIME_ELAPSED_EXT), setTimeout(() => {
                  const i2 = a2.getQueryParameter(s2, a2.QUERY_RESULT) / 1e6;
                  a2.deleteQuery(s2), this.fire(new e.A("gpu-timing-frame", { cpuTime: t3, gpuTime: i2 }));
                }, 50);
              }
              if (this.listens("gpu-timing-layer")) {
                const t3 = this.painter.collectGpuTimers();
                setTimeout(() => {
                  const i2 = this.painter.queryGpuTimers(t3);
                  this.fire(new e.A("gpu-timing-layer", { layerTimes: i2 }));
                }, 50);
              }
              if (this.listens("gpu-timing-deferred-render")) {
                const t3 = this.painter.collectDeferredRenderGpuQueries();
                setTimeout(() => {
                  const i2 = this.painter.queryGpuTimeDeferredRender(t3);
                  this.fire(new e.A("gpu-timing-deferred-render", { gpuTime: i2 }));
                }, 50);
              }
              const d2 = this._sourcesDirty || this._styleDirty || this._placementDirty || c2;
              if (d2 || this._repaint) this.triggerRepaint();
              else {
                const t3 = this.idle();
                if (t3 && (c2 = this._updateAverageElevation(n2, true)), c2) this.triggerRepaint();
                else if (this._triggerFrame(false), t3 && (this.fire(new e.A("idle")), this._isInitialLoad = false, this.speedIndexTiming)) {
                  const t4 = this._calculateSpeedIndex();
                  this.fire(new e.A("speedindexcompleted", { speedIndex: t4 })), this.speedIndexTiming = false;
                }
              }
              !this._loaded || this._fullyLoaded || d2 || (this._fullyLoaded = true, o.mark(i.fullLoad), this._performanceMetricsCollection && B(this._requestManager._customAccessToken, { width: this.painter.width, height: this.painter.height, interactionRange: this._interactionRange, visibilityHidden: this._visibilityHidden, terrainEnabled: !!this.painter.style.getTerrain(), fogEnabled: !!this.painter.style.getFog(), projection: this.getProjection().name, zoom: this.transform.zoom, renderer: this.painter.context.renderer, vendor: this.painter.context.vendor }), this._authenticate());
            }
            _forceMarkerAndPopupUpdate(e2) {
              for (const t2 of this._markers) e2 && !this.getRenderWorldCopies() && (t2._lngLat = t2._lngLat.wrap()), t2._update();
              for (const t2 of this._popups) !e2 || this.getRenderWorldCopies() || t2._trackPointer || (t2._lngLat = t2._lngLat.wrap()), t2._update();
            }
            _updateAverageElevation(e2, t2 = false) {
              const i2 = (e3) => (this.transform.averageElevation = e3, this._update(false), true);
              if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i2(0);
              const o2 = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
              if (o2 || (t2 || e2 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e2)) {
                const t3 = this.transform.averageElevation;
                let s2 = this.transform.sampleAverageElevation();
                null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(s2) ? s2 = 0 : this._averageElevationLastSampledAt = e2;
                const r2 = Math.abs(t3 - s2);
                if (r2 > 1) {
                  if (this._isInitialLoad || o2) return this._averageElevation.jumpTo(s2), i2(s2);
                  this._averageElevation.easeTo(s2, e2, 300);
                } else if (r2 > 1e-4) return this._averageElevation.jumpTo(s2), i2(s2);
              }
              return !!this._averageElevation.isEasing(e2) && i2(this._averageElevation.getValue(e2));
            }
            _authenticate() {
              N(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t2) => {
                if (t2 && (t2.message === w || 401 === t2.status)) {
                  const t3 = this.painter.context.gl;
                  j(t3, false), this._logoControl instanceof al && this._logoControl._updateLogo(), t3 && t3.clear(t3.DEPTH_BUFFER_BIT | t3.COLOR_BUFFER_BIT | t3.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e.z(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                }
              }), z(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, () => {
              });
            }
            _postStyleLoadEvent() {
              this.style.globalId && O(this._requestManager._customAccessToken, { map: this, style: this.style.globalId, importedStyles: this.style.getImportGlobalIds() });
            }
            _updateTerrain() {
              const e2 = this._isDragging();
              this.painter.updateTerrain(this.style, e2);
            }
            _calculateSpeedIndex() {
              const e2 = this.painter.canvasCopy(), t2 = this.painter.getCanvasCopiesAndTimestamps();
              t2.timeStamps.push(performance.now());
              const i2 = this.painter.context.gl, o2 = i2.createFramebuffer();
              function s2(e3) {
                i2.framebufferTexture2D(i2.FRAMEBUFFER, i2.COLOR_ATTACHMENT0, i2.TEXTURE_2D, e3, 0);
                const t3 = new Uint8Array(i2.drawingBufferWidth * i2.drawingBufferHeight * 4);
                return i2.readPixels(0, 0, i2.drawingBufferWidth, i2.drawingBufferHeight, i2.RGBA, i2.UNSIGNED_BYTE, t3), t3;
              }
              return i2.bindFramebuffer(i2.FRAMEBUFFER, o2), this._canvasPixelComparison(s2(e2), t2.canvasCopies.map(s2), t2.timeStamps);
            }
            _canvasPixelComparison(e2, t2, i2) {
              let o2 = i2[1] - i2[0];
              const s2 = e2.length / 4;
              for (let r2 = 0; r2 < t2.length; r2++) {
                const n2 = t2[r2];
                let a2 = 0;
                for (let t3 = 0; t3 < n2.length; t3 += 4) n2[t3] === e2[t3] && n2[t3 + 1] === e2[t3 + 1] && n2[t3 + 2] === e2[t3 + 2] && n2[t3 + 3] === e2[t3 + 3] && (a2 += 1);
                o2 += (i2[r2 + 2] - i2[r2 + 1]) * (1 - a2 / s2);
              }
              return o2;
            }
            remove() {
              this._hash && this._hash.remove();
              for (const e2 of this._controls) e2.onRemove(this);
              this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.indoor.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, false), window.removeEventListener("orientationchange", this._onWindowResize, false), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, false), window.removeEventListener("online", this._onWindowOnline, false), window.removeEventListener("visibilitychange", this._onVisibilityChange, false);
              const t2 = this.painter.context.gl.getExtension("WEBGL_lose_context");
              t2 && t2.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, false), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, false), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, false), U.delete(this.painter.context.gl), k.remove(), P.remove(), this._removed = true, this.fire(new e.A("remove"));
            }
            triggerRepaint() {
              this._triggerFrame(true);
            }
            _triggerFrame(t2) {
              this._renderNextFrame = this._renderNextFrame || t2, this.style && !this._frame && (this._frame = e.q.frame((e2) => {
                const t3 = !!this._renderNextFrame;
                this._frame = null, this._renderNextFrame = null, t3 && this._render(e2);
              }));
            }
            _preloadTiles(t2) {
              const i2 = this.style ? this.style.getSourceCaches() : [];
              return e.bt(i2, (e2, i3) => e2._preloadTiles(t2, i3), () => {
                this.triggerRepaint();
              }), this;
            }
            _onWindowOnline() {
              this._update();
            }
            _onWindowResize(e2) {
              this._trackResize && this.resize({ originalEvent: e2 })._update();
            }
            _onVisibilityChange() {
              "hidden" === document.visibilityState && this._visibilityHidden++;
            }
            get showTileBoundaries() {
              return !!this._showTileBoundaries;
            }
            set showTileBoundaries(e2) {
              this._showTileBoundaries !== e2 && (this._showTileBoundaries = e2, this._tp.refreshUI(), this._update());
            }
            get showParseStatus() {
              return !!this._showParseStatus;
            }
            set showParseStatus(e2) {
              this._showParseStatus !== e2 && (this._showParseStatus = e2, this._tp.refreshUI(), this._update());
            }
            get showTerrainWireframe() {
              return !!this._showTerrainWireframe;
            }
            set showTerrainWireframe(e2) {
              this._showTerrainWireframe !== e2 && (this._showTerrainWireframe = e2, this._tp.refreshUI(), this._update());
            }
            get showLayers2DWireframe() {
              return !!this._showLayers2DWireframe;
            }
            set showLayers2DWireframe(e2) {
              this._showLayers2DWireframe !== e2 && (this._showLayers2DWireframe = e2, this._tp.refreshUI(), this._update());
            }
            get showLayers3DWireframe() {
              return !!this._showLayers3DWireframe;
            }
            set showLayers3DWireframe(e2) {
              this._showLayers3DWireframe !== e2 && (this._showLayers3DWireframe = e2, this._tp.refreshUI(), this._update());
            }
            get speedIndexTiming() {
              return !!this._speedIndexTiming;
            }
            set speedIndexTiming(e2) {
              this._speedIndexTiming !== e2 && (this._speedIndexTiming = e2, this._update());
            }
            get showPadding() {
              return !!this._showPadding;
            }
            set showPadding(e2) {
              this._showPadding !== e2 && (this._showPadding = e2, this._tp.refreshUI(), this._update());
            }
            get showCollisionBoxes() {
              return !!this._showCollisionBoxes;
            }
            set showCollisionBoxes(e2) {
              this._showCollisionBoxes !== e2 && (this._showCollisionBoxes = e2, this._tp.refreshUI(), e2 ? this.style._generateCollisionBoxes() : this._update());
            }
            get showOverdrawInspector() {
              return !!this._showOverdrawInspector;
            }
            set showOverdrawInspector(e2) {
              this._showOverdrawInspector !== e2 && (this._showOverdrawInspector = e2, this._tp.refreshUI(), this._update());
            }
            get repaint() {
              return !!this._repaint;
            }
            set repaint(e2) {
              this._repaint !== e2 && (this._repaint = e2, this._tp.refreshUI(), this.triggerRepaint());
            }
            get vertices() {
              return !!this._vertices;
            }
            set vertices(e2) {
              this._vertices = e2, this._update();
            }
            get showTileAABBs() {
              return !!this._showTileAABBs;
            }
            set showTileAABBs(e2) {
              this._showTileAABBs !== e2 && (this._showTileAABBs = e2, this._tp.refreshUI(), e2 && this._update());
            }
            _setCacheLimits(t2, i2) {
              e.eJ(t2, i2);
            }
            get version() {
              return t;
            }
          }, NavigationControl: class {
            constructor(t2 = {}) {
              this.options = e.h({}, fl, t2), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e2) => e2.preventDefault()), this.options.showZoom && (e.aV(["_setButtonTitle", "_updateZoomButtons"], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e2) => {
                this._map && this._map.zoomIn({}, { originalEvent: e2 });
              }), l("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e2) => {
                this._map && this._map.zoomOut({}, { originalEvent: e2 });
              }), l("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e.aV(["_rotateCompassArrow"], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e2) => {
                const t3 = this._map;
                t3 && (this.options.visualizePitch ? t3.resetNorthPitch({}, { originalEvent: e2 }) : t3.resetNorth({}, { originalEvent: e2 }));
              }), this._compassIcon = l("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
            }
            _updateZoomButtons() {
              const e2 = this._map;
              if (!e2) return;
              const t2 = e2.getZoom(), i2 = t2 === e2.getMaxZoom(), o2 = t2 === e2.getMinZoom();
              this._zoomInButton.disabled = i2, this._zoomOutButton.disabled = o2, this._zoomInButton.setAttribute("aria-disabled", i2.toString()), this._zoomOutButton.setAttribute("aria-disabled", o2.toString());
            }
            _rotateCompassArrow() {
              const e2 = this._map;
              if (!e2) return;
              const t2 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e2.transform.pitch * (Math.PI / 180)), 0.5)}) rotateX(${e2.transform.pitch}deg) rotateZ(${e2.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e2.transform.angle * (180 / Math.PI)}deg)`;
              e2._requestDomTask(() => {
                this._compassIcon && (this._compassIcon.style.transform = t2);
              });
            }
            onAdd(e2) {
              return this._map = e2, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e2.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e2.on("pitch", this._rotateCompassArrow), e2.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new ml(e2, this._compass, this.options.visualizePitch)), this._container;
            }
            onRemove() {
              const e2 = this._map;
              e2 && (this._container.remove(), this.options.showZoom && e2.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e2.off("pitch", this._rotateCompassArrow), e2.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
            }
            _createButton(e2, t2) {
              const i2 = l("button", e2, this._container);
              return i2.type = "button", i2.addEventListener("click", t2), i2;
            }
            _setButtonTitle(e2, t2) {
              if (!this._map) return;
              const i2 = this._map._getUIString(`NavigationControl.${t2}`);
              e2.setAttribute("aria-label", i2), e2.firstElementChild && e2.firstElementChild.setAttribute("title", i2);
            }
          }, GeolocateControl: class extends e.E {
            constructor(t2 = {}) {
              super();
              const i2 = navigator.geolocation;
              this.options = e.h({ geolocation: i2 }, bl, t2), e.aV(["_onSuccess", "_onError", "_onZoom", "_finish", "_setupUI", "_updateCamera", "_updateMarker", "_updateMarkerRotation", "_onDeviceOrientation"], this), this._updateMarkerRotationThrottled = ra(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
            }
            onAdd(e2) {
              return this._map = e2, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
            }
            onRemove() {
              void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = false;
            }
            _checkGeolocationSupport(e2) {
              const t2 = (t3 = !!this.options.geolocation) => {
                this._supportsGeolocation = t3, e2(t3);
              };
              void 0 !== this._supportsGeolocation ? e2(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({ name: "geolocation" }).then((e3) => t2("denied" !== e3.state)).catch(() => t2()) : t2();
            }
            _isOutOfMapMaxBounds(e2) {
              const t2 = this._map.getMaxBounds(), i2 = e2.coords;
              return !!t2 && (i2.longitude < t2.getWest() || i2.longitude > t2.getEast() || i2.latitude < t2.getSouth() || i2.latitude > t2.getNorth());
            }
            _setErrorState() {
              switch (this._watchState) {
                case "WAITING_ACTIVE":
                  this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                  break;
                case "ACTIVE_LOCK":
                  this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                  break;
                case "BACKGROUND":
                  this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
              }
            }
            _onSuccess(t2) {
              if (this._map) {
                if (this._isOutOfMapMaxBounds(t2)) return this._setErrorState(), this.fire(new e.A("outofmaxbounds", t2)), this._updateMarker(), void this._finish();
                if (this.options.trackUserLocation) switch (this._lastKnownPosition = t2, this._watchState) {
                  case "WAITING_ACTIVE":
                  case "ACTIVE_LOCK":
                  case "ACTIVE_ERROR":
                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                    break;
                  case "BACKGROUND":
                  case "BACKGROUND_ERROR":
                    this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                }
                this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t2), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(t2), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.A("geolocate", t2)), this._finish();
              }
            }
            _updateCamera(t2) {
              const i2 = new e.cd(t2.coords.longitude, t2.coords.latitude), o2 = t2.coords.accuracy, s2 = this._map.getBearing(), r2 = e.h({ bearing: s2 }, this.options.fitBoundsOptions);
              this._map.fitBounds(i2.toBounds(o2), r2, { geolocateSource: true });
            }
            _updateMarker(t2) {
              if (t2) {
                const i2 = new e.cd(t2.coords.longitude, t2.coords.latitude);
                this._accuracyCircleMarker.setLngLat(i2).addTo(this._map), this._userLocationDotMarker.setLngLat(i2).addTo(this._map), this._accuracy = t2.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
              } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
            }
            _updateCircleRadius() {
              const t2 = this._map.transform, i2 = e.c6(1, t2._center.lat) * t2.worldSize, o2 = Math.ceil(2 * this._accuracy * i2);
              this._circleElement.style.width = `${o2}px`, this._circleElement.style.height = `${o2}px`;
            }
            _onZoom() {
              this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
            }
            _updateMarkerRotation() {
              this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
            }
            _onError(t2) {
              if (this._map) {
                if (this.options.trackUserLocation) if (1 === t2.code) {
                  this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = true;
                  const e2 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                  this._geolocateButton.setAttribute("aria-label", e2), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e2), void 0 !== this._geolocationWatchID && this._clearWatch();
                } else {
                  if (3 === t2.code && this._noTimeout) return;
                  this._setErrorState();
                }
                "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e.A("error", t2)), this._finish();
              }
            }
            _finish() {
              this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
            }
            _setupUI(t2) {
              if (void 0 !== this._map) {
                if (this._container.addEventListener("contextmenu", (e2) => e2.preventDefault()), this._geolocateButton = l("button", "mapboxgl-ctrl-geolocate", this._container), l("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", false === t2) {
                  e.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                  const t3 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                  this._geolocateButton.disabled = true, this._geolocateButton.setAttribute("aria-label", t3), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t3);
                } else {
                  const e2 = this._map._getUIString("GeolocateControl.FindMyLocation");
                  this._geolocateButton.setAttribute("aria-label", e2), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e2);
                }
                this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = l("div", "mapboxgl-user-location"), this._dotElement.appendChild(l("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(l("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new xl({ element: this._dotElement, rotationAlignment: "map", pitchAlignment: "map" }), this._circleElement = l("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new xl({ element: this._circleElement, pitchAlignment: "map" }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = true, this.options.trackUserLocation && this._map.on("movestart", (t3) => {
                  t3.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t3.originalEvent && "resize" === t3.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e.A("trackuserlocationend")));
                });
              }
            }
            _onDeviceOrientation(e2) {
              this._userLocationDotMarker && (e2.webkitCompassHeading ? this._heading = e2.webkitCompassHeading : true === e2.absolute && (this._heading = -1 * e2.alpha), this._updateMarkerRotationThrottled());
            }
            trigger() {
              if (!this._setup) return e.w("Geolocate control triggered before added to a map"), false;
              if (this.options.trackUserLocation) {
                switch (this._watchState) {
                  case "OFF":
                    this._watchState = "WAITING_ACTIVE", this.fire(new e.A("trackuserlocationstart"));
                    break;
                  case "WAITING_ACTIVE":
                  case "ACTIVE_LOCK":
                  case "ACTIVE_ERROR":
                  case "BACKGROUND_ERROR":
                    this._numberOfWatches--, this._noTimeout = false, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e.A("trackuserlocationend"));
                    break;
                  case "BACKGROUND":
                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e.A("trackuserlocationstart"));
                }
                switch (this._watchState) {
                  case "WAITING_ACTIVE":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                    break;
                  case "ACTIVE_LOCK":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                    break;
                  case "ACTIVE_ERROR":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                    break;
                  case "BACKGROUND":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                    break;
                  case "BACKGROUND_ERROR":
                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                }
                if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                else if (void 0 === this._geolocationWatchID) {
                  let e2;
                  this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e2 = { maximumAge: 6e5, timeout: 0 }, this._noTimeout = true) : (e2 = this.options.positionOptions, this._noTimeout = false), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e2), this.options.showUserHeading && this._addDeviceOrientationListener();
                }
              } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = window.setTimeout(this._finish, 1e4);
              return true;
            }
            _addDeviceOrientationListener() {
              const e2 = () => {
                "ondeviceorientationabsolute" in window ? window.addEventListener("deviceorientationabsolute", this._onDeviceOrientation) : window.addEventListener("deviceorientation", this._onDeviceOrientation);
              };
              "undefined" != typeof DeviceMotionEvent && "function" == typeof DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t2) => {
                "granted" === t2 && e2();
              }).catch(console.error) : e2();
            }
            _clearWatch() {
              this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
            }
          }, AttributionControl: nl, ScaleControl: class {
            constructor(t2 = {}) {
              this.options = e.h({}, wl, t2), this._isNumberFormatSupported = function() {
                try {
                  return new Intl.NumberFormat("en", { style: "unit", unitDisplay: "short", unit: "meter" }), true;
                } catch (e2) {
                  return false;
                }
              }(), e.aV(["_update", "_setScale", "setUnit"], this);
            }
            getDefaultPosition() {
              return "bottom-left";
            }
            _update() {
              const e2 = this.options.maxWidth || 100, t2 = this._map, i2 = t2._containerHeight / 2, o2 = t2._containerWidth / 2 - e2 / 2, s2 = t2.unproject([o2, i2]), r2 = t2.unproject([o2 + e2, i2]), n2 = s2.distanceTo(r2);
              if ("imperial" === this.options.unit) {
                const t3 = 3.2808 * n2;
                t3 > 5280 ? this._setScale(e2, t3 / 5280, "mile") : this._setScale(e2, t3, "foot");
              } else "nautical" === this.options.unit ? this._setScale(e2, n2 / 1852, "nautical-mile") : n2 >= 1e3 ? this._setScale(e2, n2 / 1e3, "kilometer") : this._setScale(e2, n2, "meter");
            }
            _setScale(e2, t2, i2) {
              this._map._requestDomTask(() => {
                const o2 = function(e3) {
                  const t3 = Math.pow(10, `${Math.floor(e3)}`.length - 1);
                  let i3 = e3 / t3;
                  return i3 = i3 >= 10 ? 10 : i3 >= 5 ? 5 : i3 >= 3 ? 3 : i3 >= 2 ? 2 : i3 >= 1 ? 1 : function(e4) {
                    const t4 = Math.pow(10, Math.ceil(-Math.log(e4) / Math.LN10));
                    return Math.round(e4 * t4) / t4;
                  }(i3), t3 * i3;
                }(t2), s2 = o2 / t2;
                this._container.innerHTML = this._isNumberFormatSupported && "nautical-mile" !== i2 ? new Intl.NumberFormat(this._language, { style: "unit", unitDisplay: "short", unit: i2 }).format(o2) : `${o2}&nbsp;${Tl[i2]}`, this._container.style.width = e2 * s2 + "px";
              });
            }
            onAdd(e2) {
              return this._map = e2, this._language = e2.getLanguage(), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e2.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
            }
            onRemove() {
              this._container.remove(), this._map.off("move", this._update), this._map = void 0;
            }
            _setLanguage(e2) {
              this._language = e2, this._update();
            }
            setUnit(e2) {
              this.options.unit = e2, this._update();
            }
          }, FullscreenControl: class {
            constructor(t2 = {}) {
              this._fullscreen = false, t2 && t2.container && (t2.container instanceof HTMLElement ? this._container = t2.container : e.w("Full screen control 'container' must be a DOM element.")), e.aV(["_onClickFullscreen", "_changeIcon"], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
            }
            onAdd(t2) {
              return this._map = t2, this._container || (this._container = this._map.getContainer()), this._controlContainer = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e.w("This device does not support fullscreen mode.")), this._controlContainer;
            }
            onRemove() {
              this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
            }
            _checkFullscreenSupport() {
              return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
            }
            _setupUI() {
              const e2 = this._fullscreenButton = l("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
              l("span", "mapboxgl-ctrl-icon", e2).setAttribute("aria-hidden", "true"), e2.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
            }
            _updateTitle() {
              const e2 = this._getTitle();
              this._fullscreenButton.setAttribute("aria-label", e2), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e2);
            }
            _getTitle() {
              return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
            }
            _isFullscreen() {
              return this._fullscreen;
            }
            _changeIcon() {
              (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
            }
            _onClickFullscreen() {
              this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
            }
          }, Popup: class extends e.E {
            constructor(t2) {
              super(), this.options = e.h(Object.create(El), t2), this._altitude = this.options.altitude, e.aV(["_update", "_onClose", "remove", "_onMouseEvent"], this), this._classList = new Set(t2 && t2.className ? t2.className.trim().split(/\s+/) : []);
            }
            addTo(t2) {
              return this._map && this.remove(), this._map = t2, this.options.closeOnClick && t2.on("preclick", this._onClose), this.options.closeOnMove && t2.on("move", this._onClose), t2.on("remove", this.remove), this._update(), t2._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t2.on("mousemove", this._onMouseEvent), t2.on("mouseup", this._onMouseEvent), t2._canvasContainer.classList.add("mapboxgl-track-pointer")) : t2.on("move", this._update), this.fire(new e.A("open")), this;
            }
            isOpen() {
              return !!this._map;
            }
            remove() {
              this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
              const t2 = this._map;
              return t2 && (t2.off("move", this._update), t2.off("move", this._onClose), t2.off("preclick", this._onClose), t2.off("click", this._onClose), t2.off("remove", this.remove), t2.off("mousemove", this._onMouseEvent), t2.off("mouseup", this._onMouseEvent), t2.off("drag", this._onMouseEvent), t2._canvasContainer && t2._canvasContainer.classList.remove("mapboxgl-track-pointer"), t2._removePopup(this), this._map = void 0), this.fire(new e.A("close")), this;
            }
            getLngLat() {
              return this._lngLat;
            }
            setLngLat(t2) {
              this._lngLat = e.cd.convert(t2), this._pos = null, this._trackPointer = false, this._update();
              const i2 = this._map;
              return i2 && (i2.on("move", this._update), i2.off("mousemove", this._onMouseEvent), i2._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
            }
            getAltitude() {
              return this._altitude;
            }
            setAltitude(e2) {
              return this._altitude = e2, this._update(), this;
            }
            trackPointer() {
              this._trackPointer = true, this._pos = null, this._update();
              const e2 = this._map;
              return e2 && (e2.off("move", this._update), e2.on("mousemove", this._onMouseEvent), e2.on("drag", this._onMouseEvent), e2._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
            }
            getElement() {
              return this._container;
            }
            setText(e2) {
              return this.setDOMContent(document.createTextNode(e2));
            }
            setHTML(e2) {
              const t2 = document.createDocumentFragment(), i2 = document.createElement("body");
              let o2;
              for (i2.innerHTML = e2; o2 = i2.firstChild, o2; ) t2.appendChild(o2);
              return this.setDOMContent(t2);
            }
            getMaxWidth() {
              return this._container && this._container.style.maxWidth;
            }
            setMaxWidth(e2) {
              return this.options.maxWidth = e2, this._update(), this;
            }
            setDOMContent(e2) {
              let t2 = this._content;
              if (t2) for (; t2.hasChildNodes(); ) t2.firstChild && t2.removeChild(t2.firstChild);
              else t2 = this._content = l("div", "mapboxgl-popup-content", this._container || void 0);
              if (t2.appendChild(e2), this.options.closeButton) {
                const e3 = this._closeButton = l("button", "mapboxgl-popup-close-button", t2);
                e3.type = "button", e3.setAttribute("aria-label", "Close popup"), e3.innerHTML = '<span aria-hidden="true">&#215;</span>', e3.addEventListener("click", this._onClose);
              }
              return this._update(), this._focusFirstElement(), this;
            }
            addClassName(e2) {
              return this._classList.add(e2), this._updateClassList(), this;
            }
            removeClassName(e2) {
              return this._classList.delete(e2), this._updateClassList(), this;
            }
            setOffset(e2) {
              return this.options.offset = e2, this._update(), this;
            }
            toggleClassName(e2) {
              let t2;
              return this._classList.delete(e2) ? t2 = false : (this._classList.add(e2), t2 = true), this._updateClassList(), t2;
            }
            _onMouseEvent(e2) {
              this._update(e2.point);
            }
            _getAnchor(e2) {
              if (this.options.anchor) return this.options.anchor;
              const t2 = this._map, i2 = this._container, o2 = this._pos;
              if (!t2 || !i2 || !o2) return "bottom";
              const s2 = i2.offsetWidth, r2 = i2.offsetHeight, n2 = o2.x < s2 / 2, a2 = o2.x > t2.transform.width - s2 / 2;
              if (o2.y + e2 < r2) return n2 ? "top-left" : a2 ? "top-right" : "top";
              if (o2.y > t2.transform.height - r2) {
                if (n2) return "bottom-left";
                if (a2) return "bottom-right";
              }
              return n2 ? "left" : a2 ? "right" : "bottom";
            }
            _updateClassList() {
              const e2 = this._container;
              if (!e2) return;
              const t2 = [...this._classList];
              t2.push("mapboxgl-popup"), this._anchor && t2.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t2.push("mapboxgl-popup-track-pointer"), e2.className = t2.join(" ");
            }
            _update(t2) {
              const i2 = this._map, o2 = this._content;
              if (!i2 || !this._lngLat && !this._trackPointer || !o2) return;
              let s2 = this._container;
              if (s2 || (s2 = this._container = l("div", "mapboxgl-popup", i2.getContainer()), this._tip = l("div", "mapboxgl-popup-tip", s2), s2.appendChild(o2)), this.options.maxWidth && s2.style.maxWidth !== this.options.maxWidth && (s2.style.maxWidth = this.options.maxWidth), i2.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = gl(this._lngLat, this._pos, i2.transform)), !this._trackPointer || t2) {
                const o3 = this._pos = this._trackPointer && t2 instanceof e.P ? t2 : i2.project(this._lngLat, this._altitude), s3 = Il(this.options.offset), r2 = this._anchor = this._getAnchor(s3.y), n2 = Il(this.options.offset, r2), a2 = o3.add(n2).round();
                i2._requestDomTask(() => {
                  this._container && r2 && (this._container.style.transform = `${vl[r2]} translate(${a2.x}px,${a2.y}px)`);
                });
              }
              if (!this._marker && i2._showingGlobe()) {
                const t3 = e.eK(i2.transform, this._lngLat) ? 0 : 1;
                this._setOpacity(t3);
              }
              this._updateClassList();
            }
            _focusFirstElement() {
              if (!this.options.focusAfterOpen || !this._container) return;
              const e2 = this._container.querySelector(Sl);
              e2 && e2.focus();
            }
            _onClose() {
              this.remove();
            }
            _setOpacity(e2) {
              this._container && (this._container.style.opacity = `${e2}`), this._content && (this._content.style.pointerEvents = e2 ? "auto" : "none");
            }
          }, Marker: xl, Style: Eo, LngLat: e.cd, LngLatBounds: e.aG, Point: e.P, MercatorCoordinate: e.ac, FreeCameraOptions: $i, Evented: e.E, config: e.e, prewarm: e.eO, clearPrewarmedResources: e.eN, get accessToken() {
            return e.e.ACCESS_TOKEN;
          }, set accessToken(t2) {
            e.e.ACCESS_TOKEN = t2;
          }, get baseApiUrl() {
            return e.e.API_URL;
          }, set baseApiUrl(t2) {
            e.e.API_URL = t2;
          }, get workerCount() {
            return e.eX.workerCount;
          }, set workerCount(t2) {
            e.eX.workerCount = t2;
          }, get maxParallelImageRequests() {
            return e.e.MAX_PARALLEL_IMAGE_REQUESTS;
          }, set maxParallelImageRequests(t2) {
            e.e.MAX_PARALLEL_IMAGE_REQUESTS = t2;
          }, clearStorage(t2) {
            e.eW(t2);
          }, get workerUrl() {
            return e.eV.workerUrl;
          }, set workerUrl(t2) {
            e.eV.workerUrl = t2;
          }, get workerClass() {
            return e.eV.workerClass;
          }, set workerClass(t2) {
            e.eV.workerClass = t2;
          }, get workerParams() {
            return e.eV.workerParams;
          }, set workerParams(t2) {
            e.eV.workerParams = t2;
          }, get dracoUrl() {
            return e.eU();
          }, set dracoUrl(t2) {
            e.eT(t2);
          }, get meshoptUrl() {
            return e.eS();
          }, set meshoptUrl(t2) {
            e.eR(t2);
          }, setNow: e.q.setNow, restoreNow: e.q.restoreNow };
          return Cl;
        });
        var mapboxgl$1 = mapboxgl2;
        return mapboxgl$1;
      });
    }
  });

  // node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js
  var runtime_dom_esm_bundler_exports = {};
  __export(runtime_dom_esm_bundler_exports, {
    BaseTransition: () => BaseTransition,
    BaseTransitionPropsValidators: () => BaseTransitionPropsValidators,
    Comment: () => Comment,
    DeprecationTypes: () => DeprecationTypes,
    EffectScope: () => EffectScope,
    ErrorCodes: () => ErrorCodes,
    ErrorTypeStrings: () => ErrorTypeStrings,
    Fragment: () => Fragment,
    KeepAlive: () => KeepAlive,
    ReactiveEffect: () => ReactiveEffect,
    Static: () => Static,
    Suspense: () => Suspense,
    Teleport: () => Teleport,
    Text: () => Text,
    TrackOpTypes: () => TrackOpTypes,
    Transition: () => Transition,
    TransitionGroup: () => TransitionGroup,
    TriggerOpTypes: () => TriggerOpTypes,
    VueElement: () => VueElement,
    assertNumber: () => assertNumber,
    callWithAsyncErrorHandling: () => callWithAsyncErrorHandling,
    callWithErrorHandling: () => callWithErrorHandling,
    camelize: () => camelize,
    capitalize: () => capitalize,
    cloneVNode: () => cloneVNode,
    compatUtils: () => compatUtils,
    computed: () => computed2,
    createApp: () => createApp,
    createBlock: () => createBlock,
    createCommentVNode: () => createCommentVNode,
    createElementBlock: () => createElementBlock,
    createElementVNode: () => createBaseVNode,
    createHydrationRenderer: () => createHydrationRenderer,
    createPropsRestProxy: () => createPropsRestProxy,
    createRenderer: () => createRenderer,
    createSSRApp: () => createSSRApp,
    createSlots: () => createSlots,
    createStaticVNode: () => createStaticVNode,
    createTextVNode: () => createTextVNode,
    createVNode: () => createVNode,
    customRef: () => customRef,
    defineAsyncComponent: () => defineAsyncComponent,
    defineComponent: () => defineComponent,
    defineCustomElement: () => defineCustomElement,
    defineEmits: () => defineEmits,
    defineExpose: () => defineExpose,
    defineModel: () => defineModel,
    defineOptions: () => defineOptions,
    defineProps: () => defineProps,
    defineSSRCustomElement: () => defineSSRCustomElement,
    defineSlots: () => defineSlots,
    devtools: () => devtools,
    effect: () => effect,
    effectScope: () => effectScope,
    getCurrentInstance: () => getCurrentInstance,
    getCurrentScope: () => getCurrentScope,
    getCurrentWatcher: () => getCurrentWatcher,
    getTransitionRawChildren: () => getTransitionRawChildren,
    guardReactiveProps: () => guardReactiveProps,
    h: () => h,
    handleError: () => handleError,
    hasInjectionContext: () => hasInjectionContext,
    hydrate: () => hydrate,
    hydrateOnIdle: () => hydrateOnIdle,
    hydrateOnInteraction: () => hydrateOnInteraction,
    hydrateOnMediaQuery: () => hydrateOnMediaQuery,
    hydrateOnVisible: () => hydrateOnVisible,
    initCustomFormatter: () => initCustomFormatter,
    initDirectivesForSSR: () => initDirectivesForSSR,
    inject: () => inject,
    isMemoSame: () => isMemoSame,
    isProxy: () => isProxy,
    isReactive: () => isReactive,
    isReadonly: () => isReadonly,
    isRef: () => isRef2,
    isRuntimeOnly: () => isRuntimeOnly,
    isShallow: () => isShallow,
    isVNode: () => isVNode,
    markRaw: () => markRaw,
    mergeDefaults: () => mergeDefaults,
    mergeModels: () => mergeModels,
    mergeProps: () => mergeProps,
    nextTick: () => nextTick,
    normalizeClass: () => normalizeClass,
    normalizeProps: () => normalizeProps,
    normalizeStyle: () => normalizeStyle,
    onActivated: () => onActivated,
    onBeforeMount: () => onBeforeMount,
    onBeforeUnmount: () => onBeforeUnmount,
    onBeforeUpdate: () => onBeforeUpdate,
    onDeactivated: () => onDeactivated,
    onErrorCaptured: () => onErrorCaptured,
    onMounted: () => onMounted,
    onRenderTracked: () => onRenderTracked,
    onRenderTriggered: () => onRenderTriggered,
    onScopeDispose: () => onScopeDispose,
    onServerPrefetch: () => onServerPrefetch,
    onUnmounted: () => onUnmounted,
    onUpdated: () => onUpdated,
    onWatcherCleanup: () => onWatcherCleanup,
    openBlock: () => openBlock,
    popScopeId: () => popScopeId,
    provide: () => provide,
    proxyRefs: () => proxyRefs,
    pushScopeId: () => pushScopeId,
    queuePostFlushCb: () => queuePostFlushCb,
    reactive: () => reactive,
    readonly: () => readonly,
    ref: () => ref,
    registerRuntimeCompiler: () => registerRuntimeCompiler,
    render: () => render,
    renderList: () => renderList,
    renderSlot: () => renderSlot,
    resolveComponent: () => resolveComponent,
    resolveDirective: () => resolveDirective,
    resolveDynamicComponent: () => resolveDynamicComponent,
    resolveFilter: () => resolveFilter,
    resolveTransitionHooks: () => resolveTransitionHooks,
    setBlockTracking: () => setBlockTracking,
    setDevtoolsHook: () => setDevtoolsHook,
    setTransitionHooks: () => setTransitionHooks,
    shallowReactive: () => shallowReactive,
    shallowReadonly: () => shallowReadonly,
    shallowRef: () => shallowRef,
    ssrContextKey: () => ssrContextKey,
    ssrUtils: () => ssrUtils,
    stop: () => stop,
    toDisplayString: () => toDisplayString,
    toHandlerKey: () => toHandlerKey,
    toHandlers: () => toHandlers,
    toRaw: () => toRaw,
    toRef: () => toRef,
    toRefs: () => toRefs,
    toValue: () => toValue,
    transformVNodeArgs: () => transformVNodeArgs,
    triggerRef: () => triggerRef,
    unref: () => unref,
    useAttrs: () => useAttrs,
    useCssModule: () => useCssModule,
    useCssVars: () => useCssVars,
    useHost: () => useHost,
    useId: () => useId,
    useModel: () => useModel,
    useSSRContext: () => useSSRContext,
    useShadowRoot: () => useShadowRoot,
    useSlots: () => useSlots,
    useTemplateRef: () => useTemplateRef,
    useTransitionState: () => useTransitionState,
    vModelCheckbox: () => vModelCheckbox,
    vModelDynamic: () => vModelDynamic,
    vModelRadio: () => vModelRadio,
    vModelSelect: () => vModelSelect,
    vModelText: () => vModelText,
    vShow: () => vShow,
    version: () => version,
    warn: () => warn2,
    watch: () => watch2,
    watchEffect: () => watchEffect,
    watchPostEffect: () => watchPostEffect,
    watchSyncEffect: () => watchSyncEffect,
    withAsyncContext: () => withAsyncContext,
    withCtx: () => withCtx,
    withDefaults: () => withDefaults,
    withDirectives: () => withDirectives,
    withKeys: () => withKeys,
    withMemo: () => withMemo,
    withModifiers: () => withModifiers,
    withScopeId: () => withScopeId
  });

  // node_modules/@vue/shared/dist/shared.esm-bundler.js
  // @__NO_SIDE_EFFECTS__
  function makeMap(str) {
    const map2 = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(",")) map2[key] = 1;
    return (val) => val in map2;
  }
  var EMPTY_OBJ = true ? Object.freeze({}) : {};
  var EMPTY_ARR = true ? Object.freeze([]) : [];
  var NOOP = () => {
  };
  var NO = () => false;
  var isOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
  (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
  var isModelListener = (key) => key.startsWith("onUpdate:");
  var extend = Object.assign;
  var remove = (arr, el) => {
    const i = arr.indexOf(el);
    if (i > -1) {
      arr.splice(i, 1);
    }
  };
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var hasOwn = (val, key) => hasOwnProperty.call(val, key);
  var isArray = Array.isArray;
  var isMap = (val) => toTypeString(val) === "[object Map]";
  var isSet = (val) => toTypeString(val) === "[object Set]";
  var isDate = (val) => toTypeString(val) === "[object Date]";
  var isRegExp = (val) => toTypeString(val) === "[object RegExp]";
  var isFunction = (val) => typeof val === "function";
  var isString = (val) => typeof val === "string";
  var isSymbol = (val) => typeof val === "symbol";
  var isObject = (val) => val !== null && typeof val === "object";
  var isPromise = (val) => {
    return (isObject(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
  };
  var objectToString = Object.prototype.toString;
  var toTypeString = (value) => objectToString.call(value);
  var toRawType = (value) => {
    return toTypeString(value).slice(8, -1);
  };
  var isPlainObject = (val) => toTypeString(val) === "[object Object]";
  var isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
  var isReservedProp = /* @__PURE__ */ makeMap(
    // the leading comma is intentional so empty string "" is also included
    ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
  );
  var isBuiltInDirective = /* @__PURE__ */ makeMap(
    "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
  );
  var cacheStringFunction = (fn) => {
    const cache = /* @__PURE__ */ Object.create(null);
    return (str) => {
      const hit = cache[str];
      return hit || (cache[str] = fn(str));
    };
  };
  var camelizeRE = /-(\w)/g;
  var camelize = cacheStringFunction(
    (str) => {
      return str.replace(camelizeRE, (_, c) => c ? c.toUpperCase() : "");
    }
  );
  var hyphenateRE = /\B([A-Z])/g;
  var hyphenate = cacheStringFunction(
    (str) => str.replace(hyphenateRE, "-$1").toLowerCase()
  );
  var capitalize = cacheStringFunction((str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  });
  var toHandlerKey = cacheStringFunction(
    (str) => {
      const s = str ? `on${capitalize(str)}` : ``;
      return s;
    }
  );
  var hasChanged = (value, oldValue) => !Object.is(value, oldValue);
  var invokeArrayFns = (fns, ...arg) => {
    for (let i = 0; i < fns.length; i++) {
      fns[i](...arg);
    }
  };
  var def = (obj, key, value, writable = false) => {
    Object.defineProperty(obj, key, {
      configurable: true,
      enumerable: false,
      writable,
      value
    });
  };
  var looseToNumber = (val) => {
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
  };
  var toNumber = (val) => {
    const n = isString(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
  };
  var _globalThis;
  var getGlobalThis = () => {
    return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
  };
  function genCacheKey(source, options3) {
    return source + JSON.stringify(
      options3,
      (_, val) => typeof val === "function" ? val.toString() : val
    );
  }
  var PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
  };
  var slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
  };
  var GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
  var isGloballyAllowed = /* @__PURE__ */ makeMap(GLOBALS_ALLOWED);
  var range = 2;
  function generateCodeFrame(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx) => idx % 2 === 1);
    lines = lines.filter((_, idx) => idx % 2 === 0);
    let count2 = 0;
    const res = [];
    for (let i = 0; i < lines.length; i++) {
      count2 += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
      if (count2 >= start) {
        for (let j = i - range; j <= i + range || end > count2; j++) {
          if (j < 0 || j >= lines.length) continue;
          const line = j + 1;
          res.push(
            `${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`
          );
          const lineLength = lines[j].length;
          const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
          if (j === i) {
            const pad = start - (count2 - (lineLength + newLineSeqLength));
            const length3 = Math.max(
              1,
              end > count2 ? lineLength - pad : end - start
            );
            res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length3));
          } else if (j > i) {
            if (end > count2) {
              const length3 = Math.max(Math.min(end - count2, lineLength), 1);
              res.push(`   |  ` + "^".repeat(length3));
            }
            count2 += lineLength + newLineSeqLength;
          }
        }
        break;
      }
    }
    return res.join("\n");
  }
  function normalizeStyle(value) {
    if (isArray(value)) {
      const res = {};
      for (let i = 0; i < value.length; i++) {
        const item = value[i];
        const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
        if (normalized) {
          for (const key in normalized) {
            res[key] = normalized[key];
          }
        }
      }
      return res;
    } else if (isString(value) || isObject(value)) {
      return value;
    }
  }
  var listDelimiterRE = /;(?![^(]*\))/g;
  var propertyDelimiterRE = /:([^]+)/;
  var styleCommentRE = /\/\*[^]*?\*\//g;
  function parseStringStyle(cssText) {
    const ret = {};
    cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item) => {
      if (item) {
        const tmp = item.split(propertyDelimiterRE);
        tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
      }
    });
    return ret;
  }
  function stringifyStyle(styles) {
    if (!styles) return "";
    if (isString(styles)) return styles;
    let ret = "";
    for (const key in styles) {
      const value = styles[key];
      if (isString(value) || typeof value === "number") {
        const normalizedKey = key.startsWith(`--`) ? key : hyphenate(key);
        ret += `${normalizedKey}:${value};`;
      }
    }
    return ret;
  }
  function normalizeClass(value) {
    let res = "";
    if (isString(value)) {
      res = value;
    } else if (isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        const normalized = normalizeClass(value[i]);
        if (normalized) {
          res += normalized + " ";
        }
      }
    } else if (isObject(value)) {
      for (const name in value) {
        if (value[name]) {
          res += name + " ";
        }
      }
    }
    return res.trim();
  }
  function normalizeProps(props) {
    if (!props) return null;
    let { class: klass, style } = props;
    if (klass && !isString(klass)) {
      props.class = normalizeClass(klass);
    }
    if (style) {
      props.style = normalizeStyle(style);
    }
    return props;
  }
  var HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
  var SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
  var MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
  var VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
  var isHTMLTag = /* @__PURE__ */ makeMap(HTML_TAGS);
  var isSVGTag = /* @__PURE__ */ makeMap(SVG_TAGS);
  var isMathMLTag = /* @__PURE__ */ makeMap(MATH_TAGS);
  var isVoidTag = /* @__PURE__ */ makeMap(VOID_TAGS);
  var specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
  var isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
  var isBooleanAttr = /* @__PURE__ */ makeMap(
    specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`
  );
  function includeBooleanAttr(value) {
    return !!value || value === "";
  }
  var isKnownHtmlAttr = /* @__PURE__ */ makeMap(
    `accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`
  );
  var isKnownSvgAttr = /* @__PURE__ */ makeMap(
    `xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`
  );
  function isRenderableAttrValue(value) {
    if (value == null) {
      return false;
    }
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
  }
  var cssVarNameEscapeSymbolsRE = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
  function getEscapedCssVarName(key, doubleEscape) {
    return key.replace(
      cssVarNameEscapeSymbolsRE,
      (s) => doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`
    );
  }
  function looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for (let i = 0; equal && i < a.length; i++) {
      equal = looseEqual(a[i], b[i]);
    }
    return equal;
  }
  function looseEqual(a, b) {
    if (a === b) return true;
    let aValidType = isDate(a);
    let bValidType = isDate(b);
    if (aValidType || bValidType) {
      return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    }
    aValidType = isSymbol(a);
    bValidType = isSymbol(b);
    if (aValidType || bValidType) {
      return a === b;
    }
    aValidType = isArray(a);
    bValidType = isArray(b);
    if (aValidType || bValidType) {
      return aValidType && bValidType ? looseCompareArrays(a, b) : false;
    }
    aValidType = isObject(a);
    bValidType = isObject(b);
    if (aValidType || bValidType) {
      if (!aValidType || !bValidType) {
        return false;
      }
      const aKeysCount = Object.keys(a).length;
      const bKeysCount = Object.keys(b).length;
      if (aKeysCount !== bKeysCount) {
        return false;
      }
      for (const key in a) {
        const aHasKey = a.hasOwnProperty(key);
        const bHasKey = b.hasOwnProperty(key);
        if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key])) {
          return false;
        }
      }
    }
    return String(a) === String(b);
  }
  function looseIndexOf(arr, val) {
    return arr.findIndex((item) => looseEqual(item, val));
  }
  var isRef = (val) => {
    return !!(val && val["__v_isRef"] === true);
  };
  var toDisplayString = (val) => {
    return isString(val) ? val : val == null ? "" : isArray(val) || isObject(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
  };
  var replacer = (_key, val) => {
    if (isRef(val)) {
      return replacer(_key, val.value);
    } else if (isMap(val)) {
      return {
        [`Map(${val.size})`]: [...val.entries()].reduce(
          (entries, [key, val2], i) => {
            entries[stringifySymbol(key, i) + " =>"] = val2;
            return entries;
          },
          {}
        )
      };
    } else if (isSet(val)) {
      return {
        [`Set(${val.size})`]: [...val.values()].map((v) => stringifySymbol(v))
      };
    } else if (isSymbol(val)) {
      return stringifySymbol(val);
    } else if (isObject(val) && !isArray(val) && !isPlainObject(val)) {
      return String(val);
    }
    return val;
  };
  var stringifySymbol = (v, i = "") => {
    var _a;
    return (
      // Symbol.description in es2019+ so we need to cast here to pass
      // the lib: es2016 check
      isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v
    );
  };

  // node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
  function warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
  }
  var activeEffectScope;
  var EffectScope = class {
    constructor(detached = false) {
      this.detached = detached;
      this._active = true;
      this.effects = [];
      this.cleanups = [];
      this._isPaused = false;
      this.parent = activeEffectScope;
      if (!detached && activeEffectScope) {
        this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(
          this
        ) - 1;
      }
    }
    get active() {
      return this._active;
    }
    pause() {
      if (this._active) {
        this._isPaused = true;
        let i, l;
        if (this.scopes) {
          for (i = 0, l = this.scopes.length; i < l; i++) {
            this.scopes[i].pause();
          }
        }
        for (i = 0, l = this.effects.length; i < l; i++) {
          this.effects[i].pause();
        }
      }
    }
    /**
     * Resumes the effect scope, including all child scopes and effects.
     */
    resume() {
      if (this._active) {
        if (this._isPaused) {
          this._isPaused = false;
          let i, l;
          if (this.scopes) {
            for (i = 0, l = this.scopes.length; i < l; i++) {
              this.scopes[i].resume();
            }
          }
          for (i = 0, l = this.effects.length; i < l; i++) {
            this.effects[i].resume();
          }
        }
      }
    }
    run(fn) {
      if (this._active) {
        const currentEffectScope = activeEffectScope;
        try {
          activeEffectScope = this;
          return fn();
        } finally {
          activeEffectScope = currentEffectScope;
        }
      } else if (true) {
        warn(`cannot run an inactive effect scope.`);
      }
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    on() {
      activeEffectScope = this;
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    off() {
      activeEffectScope = this.parent;
    }
    stop(fromParent) {
      if (this._active) {
        this._active = false;
        let i, l;
        for (i = 0, l = this.effects.length; i < l; i++) {
          this.effects[i].stop();
        }
        this.effects.length = 0;
        for (i = 0, l = this.cleanups.length; i < l; i++) {
          this.cleanups[i]();
        }
        this.cleanups.length = 0;
        if (this.scopes) {
          for (i = 0, l = this.scopes.length; i < l; i++) {
            this.scopes[i].stop(true);
          }
          this.scopes.length = 0;
        }
        if (!this.detached && this.parent && !fromParent) {
          const last = this.parent.scopes.pop();
          if (last && last !== this) {
            this.parent.scopes[this.index] = last;
            last.index = this.index;
          }
        }
        this.parent = void 0;
      }
    }
  };
  function effectScope(detached) {
    return new EffectScope(detached);
  }
  function getCurrentScope() {
    return activeEffectScope;
  }
  function onScopeDispose(fn, failSilently = false) {
    if (activeEffectScope) {
      activeEffectScope.cleanups.push(fn);
    } else if (!failSilently) {
      warn(
        `onScopeDispose() is called when there is no active effect scope to be associated with.`
      );
    }
  }
  var activeSub;
  var pausedQueueEffects = /* @__PURE__ */ new WeakSet();
  var ReactiveEffect = class {
    constructor(fn) {
      this.fn = fn;
      this.deps = void 0;
      this.depsTail = void 0;
      this.flags = 1 | 4;
      this.next = void 0;
      this.cleanup = void 0;
      this.scheduler = void 0;
      if (activeEffectScope && activeEffectScope.active) {
        activeEffectScope.effects.push(this);
      }
    }
    pause() {
      this.flags |= 64;
    }
    resume() {
      if (this.flags & 64) {
        this.flags &= ~64;
        if (pausedQueueEffects.has(this)) {
          pausedQueueEffects.delete(this);
          this.trigger();
        }
      }
    }
    /**
     * @internal
     */
    notify() {
      if (this.flags & 2 && !(this.flags & 32)) {
        return;
      }
      if (!(this.flags & 8)) {
        batch(this);
      }
    }
    run() {
      if (!(this.flags & 1)) {
        return this.fn();
      }
      this.flags |= 2;
      cleanupEffect(this);
      prepareDeps(this);
      const prevEffect = activeSub;
      const prevShouldTrack = shouldTrack;
      activeSub = this;
      shouldTrack = true;
      try {
        return this.fn();
      } finally {
        if (activeSub !== this) {
          warn(
            "Active effect was not restored correctly - this is likely a Vue internal bug."
          );
        }
        cleanupDeps(this);
        activeSub = prevEffect;
        shouldTrack = prevShouldTrack;
        this.flags &= ~2;
      }
    }
    stop() {
      if (this.flags & 1) {
        for (let link = this.deps; link; link = link.nextDep) {
          removeSub(link);
        }
        this.deps = this.depsTail = void 0;
        cleanupEffect(this);
        this.onStop && this.onStop();
        this.flags &= ~1;
      }
    }
    trigger() {
      if (this.flags & 64) {
        pausedQueueEffects.add(this);
      } else if (this.scheduler) {
        this.scheduler();
      } else {
        this.runIfDirty();
      }
    }
    /**
     * @internal
     */
    runIfDirty() {
      if (isDirty(this)) {
        this.run();
      }
    }
    get dirty() {
      return isDirty(this);
    }
  };
  var batchDepth = 0;
  var batchedSub;
  var batchedComputed;
  function batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
      sub.next = batchedComputed;
      batchedComputed = sub;
      return;
    }
    sub.next = batchedSub;
    batchedSub = sub;
  }
  function startBatch() {
    batchDepth++;
  }
  function endBatch() {
    if (--batchDepth > 0) {
      return;
    }
    if (batchedComputed) {
      let e = batchedComputed;
      batchedComputed = void 0;
      while (e) {
        const next = e.next;
        e.next = void 0;
        e.flags &= ~8;
        e = next;
      }
    }
    let error2;
    while (batchedSub) {
      let e = batchedSub;
      batchedSub = void 0;
      while (e) {
        const next = e.next;
        e.next = void 0;
        e.flags &= ~8;
        if (e.flags & 1) {
          try {
            ;
            e.trigger();
          } catch (err) {
            if (!error2) error2 = err;
          }
        }
        e = next;
      }
    }
    if (error2) throw error2;
  }
  function prepareDeps(sub) {
    for (let link = sub.deps; link; link = link.nextDep) {
      link.version = -1;
      link.prevActiveLink = link.dep.activeLink;
      link.dep.activeLink = link;
    }
  }
  function cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while (link) {
      const prev = link.prevDep;
      if (link.version === -1) {
        if (link === tail) tail = prev;
        removeSub(link);
        removeDep(link);
      } else {
        head = link;
      }
      link.dep.activeLink = link.prevActiveLink;
      link.prevActiveLink = void 0;
      link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
  }
  function isDirty(sub) {
    for (let link = sub.deps; link; link = link.nextDep) {
      if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) {
        return true;
      }
    }
    if (sub._dirty) {
      return true;
    }
    return false;
  }
  function refreshComputed(computed3) {
    if (computed3.flags & 4 && !(computed3.flags & 16)) {
      return;
    }
    computed3.flags &= ~16;
    if (computed3.globalVersion === globalVersion) {
      return;
    }
    computed3.globalVersion = globalVersion;
    const dep = computed3.dep;
    computed3.flags |= 2;
    if (dep.version > 0 && !computed3.isSSR && computed3.deps && !isDirty(computed3)) {
      computed3.flags &= ~2;
      return;
    }
    const prevSub = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = computed3;
    shouldTrack = true;
    try {
      prepareDeps(computed3);
      const value = computed3.fn(computed3._value);
      if (dep.version === 0 || hasChanged(value, computed3._value)) {
        computed3._value = value;
        dep.version++;
      }
    } catch (err) {
      dep.version++;
      throw err;
    } finally {
      activeSub = prevSub;
      shouldTrack = prevShouldTrack;
      cleanupDeps(computed3);
      computed3.flags &= ~2;
    }
  }
  function removeSub(link, soft = false) {
    const { dep, prevSub, nextSub } = link;
    if (prevSub) {
      prevSub.nextSub = nextSub;
      link.prevSub = void 0;
    }
    if (nextSub) {
      nextSub.prevSub = prevSub;
      link.nextSub = void 0;
    }
    if (dep.subsHead === link) {
      dep.subsHead = nextSub;
    }
    if (dep.subs === link) {
      dep.subs = prevSub;
      if (!prevSub && dep.computed) {
        dep.computed.flags &= ~4;
        for (let l = dep.computed.deps; l; l = l.nextDep) {
          removeSub(l, true);
        }
      }
    }
    if (!soft && !--dep.sc && dep.map) {
      dep.map.delete(dep.key);
    }
  }
  function removeDep(link) {
    const { prevDep, nextDep } = link;
    if (prevDep) {
      prevDep.nextDep = nextDep;
      link.prevDep = void 0;
    }
    if (nextDep) {
      nextDep.prevDep = prevDep;
      link.nextDep = void 0;
    }
  }
  function effect(fn, options3) {
    if (fn.effect instanceof ReactiveEffect) {
      fn = fn.effect.fn;
    }
    const e = new ReactiveEffect(fn);
    if (options3) {
      extend(e, options3);
    }
    try {
      e.run();
    } catch (err) {
      e.stop();
      throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
  }
  function stop(runner) {
    runner.effect.stop();
  }
  var shouldTrack = true;
  var trackStack = [];
  function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
  }
  function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
  }
  function cleanupEffect(e) {
    const { cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
      const prevSub = activeSub;
      activeSub = void 0;
      try {
        cleanup();
      } finally {
        activeSub = prevSub;
      }
    }
  }
  var globalVersion = 0;
  var Link = class {
    constructor(sub, dep) {
      this.sub = sub;
      this.dep = dep;
      this.version = dep.version;
      this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
  };
  var Dep = class {
    constructor(computed3) {
      this.computed = computed3;
      this.version = 0;
      this.activeLink = void 0;
      this.subs = void 0;
      this.map = void 0;
      this.key = void 0;
      this.sc = 0;
      if (true) {
        this.subsHead = void 0;
      }
    }
    track(debugInfo) {
      if (!activeSub || !shouldTrack || activeSub === this.computed) {
        return;
      }
      let link = this.activeLink;
      if (link === void 0 || link.sub !== activeSub) {
        link = this.activeLink = new Link(activeSub, this);
        if (!activeSub.deps) {
          activeSub.deps = activeSub.depsTail = link;
        } else {
          link.prevDep = activeSub.depsTail;
          activeSub.depsTail.nextDep = link;
          activeSub.depsTail = link;
        }
        addSub(link);
      } else if (link.version === -1) {
        link.version = this.version;
        if (link.nextDep) {
          const next = link.nextDep;
          next.prevDep = link.prevDep;
          if (link.prevDep) {
            link.prevDep.nextDep = next;
          }
          link.prevDep = activeSub.depsTail;
          link.nextDep = void 0;
          activeSub.depsTail.nextDep = link;
          activeSub.depsTail = link;
          if (activeSub.deps === link) {
            activeSub.deps = next;
          }
        }
      }
      if (activeSub.onTrack) {
        activeSub.onTrack(
          extend(
            {
              effect: activeSub
            },
            debugInfo
          )
        );
      }
      return link;
    }
    trigger(debugInfo) {
      this.version++;
      globalVersion++;
      this.notify(debugInfo);
    }
    notify(debugInfo) {
      startBatch();
      try {
        if (true) {
          for (let head = this.subsHead; head; head = head.nextSub) {
            if (head.sub.onTrigger && !(head.sub.flags & 8)) {
              head.sub.onTrigger(
                extend(
                  {
                    effect: head.sub
                  },
                  debugInfo
                )
              );
            }
          }
        }
        for (let link = this.subs; link; link = link.prevSub) {
          if (link.sub.notify()) {
            ;
            link.sub.dep.notify();
          }
        }
      } finally {
        endBatch();
      }
    }
  };
  function addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
      const computed3 = link.dep.computed;
      if (computed3 && !link.dep.subs) {
        computed3.flags |= 4 | 16;
        for (let l = computed3.deps; l; l = l.nextDep) {
          addSub(l);
        }
      }
      const currentTail = link.dep.subs;
      if (currentTail !== link) {
        link.prevSub = currentTail;
        if (currentTail) currentTail.nextSub = link;
      }
      if (link.dep.subsHead === void 0) {
        link.dep.subsHead = link;
      }
      link.dep.subs = link;
    }
  }
  var targetMap = /* @__PURE__ */ new WeakMap();
  var ITERATE_KEY = Symbol(
    true ? "Object iterate" : ""
  );
  var MAP_KEY_ITERATE_KEY = Symbol(
    true ? "Map keys iterate" : ""
  );
  var ARRAY_ITERATE_KEY = Symbol(
    true ? "Array iterate" : ""
  );
  function track(target2, type, key) {
    if (shouldTrack && activeSub) {
      let depsMap = targetMap.get(target2);
      if (!depsMap) {
        targetMap.set(target2, depsMap = /* @__PURE__ */ new Map());
      }
      let dep = depsMap.get(key);
      if (!dep) {
        depsMap.set(key, dep = new Dep());
        dep.map = depsMap;
        dep.key = key;
      }
      if (true) {
        dep.track({
          target: target2,
          type,
          key
        });
      } else {
        dep.track();
      }
    }
  }
  function trigger(target2, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target2);
    if (!depsMap) {
      globalVersion++;
      return;
    }
    const run2 = (dep) => {
      if (dep) {
        if (true) {
          dep.trigger({
            target: target2,
            type,
            key,
            newValue,
            oldValue,
            oldTarget
          });
        } else {
          dep.trigger();
        }
      }
    };
    startBatch();
    if (type === "clear") {
      depsMap.forEach(run2);
    } else {
      const targetIsArray = isArray(target2);
      const isArrayIndex = targetIsArray && isIntegerKey(key);
      if (targetIsArray && key === "length") {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2) => {
          if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !isSymbol(key2) && key2 >= newLength) {
            run2(dep);
          }
        });
      } else {
        if (key !== void 0 || depsMap.has(void 0)) {
          run2(depsMap.get(key));
        }
        if (isArrayIndex) {
          run2(depsMap.get(ARRAY_ITERATE_KEY));
        }
        switch (type) {
          case "add":
            if (!targetIsArray) {
              run2(depsMap.get(ITERATE_KEY));
              if (isMap(target2)) {
                run2(depsMap.get(MAP_KEY_ITERATE_KEY));
              }
            } else if (isArrayIndex) {
              run2(depsMap.get("length"));
            }
            break;
          case "delete":
            if (!targetIsArray) {
              run2(depsMap.get(ITERATE_KEY));
              if (isMap(target2)) {
                run2(depsMap.get(MAP_KEY_ITERATE_KEY));
              }
            }
            break;
          case "set":
            if (isMap(target2)) {
              run2(depsMap.get(ITERATE_KEY));
            }
            break;
        }
      }
    }
    endBatch();
  }
  function getDepFromReactive(object, key) {
    const depMap = targetMap.get(object);
    return depMap && depMap.get(key);
  }
  function reactiveReadArray(array) {
    const raw3 = toRaw(array);
    if (raw3 === array) return raw3;
    track(raw3, "iterate", ARRAY_ITERATE_KEY);
    return isShallow(array) ? raw3 : raw3.map(toReactive);
  }
  function shallowReadArray(arr) {
    track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
    return arr;
  }
  var arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator]() {
      return iterator(this, Symbol.iterator, toReactive);
    },
    concat(...args) {
      return reactiveReadArray(this).concat(
        ...args.map((x) => isArray(x) ? reactiveReadArray(x) : x)
      );
    },
    entries() {
      return iterator(this, "entries", (value) => {
        value[1] = toReactive(value[1]);
        return value;
      });
    },
    every(fn, thisArg) {
      return apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter(fn, thisArg) {
      return apply(this, "filter", fn, thisArg, (v) => v.map(toReactive), arguments);
    },
    find(fn, thisArg) {
      return apply(this, "find", fn, thisArg, toReactive, arguments);
    },
    findIndex(fn, thisArg) {
      return apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast(fn, thisArg) {
      return apply(this, "findLast", fn, thisArg, toReactive, arguments);
    },
    findLastIndex(fn, thisArg) {
      return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach(fn, thisArg) {
      return apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes(...args) {
      return searchProxy(this, "includes", args);
    },
    indexOf(...args) {
      return searchProxy(this, "indexOf", args);
    },
    join(separator) {
      return reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf(...args) {
      return searchProxy(this, "lastIndexOf", args);
    },
    map(fn, thisArg) {
      return apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop() {
      return noTracking(this, "pop");
    },
    push(...args) {
      return noTracking(this, "push", args);
    },
    reduce(fn, ...args) {
      return reduce(this, "reduce", fn, args);
    },
    reduceRight(fn, ...args) {
      return reduce(this, "reduceRight", fn, args);
    },
    shift() {
      return noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some(fn, thisArg) {
      return apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice(...args) {
      return noTracking(this, "splice", args);
    },
    toReversed() {
      return reactiveReadArray(this).toReversed();
    },
    toSorted(comparer) {
      return reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced(...args) {
      return reactiveReadArray(this).toSpliced(...args);
    },
    unshift(...args) {
      return noTracking(this, "unshift", args);
    },
    values() {
      return iterator(this, "values", toReactive);
    }
  };
  function iterator(self2, method, wrapValue) {
    const arr = shallowReadArray(self2);
    const iter = arr[method]();
    if (arr !== self2 && !isShallow(self2)) {
      iter._next = iter.next;
      iter.next = () => {
        const result = iter._next();
        if (result.value) {
          result.value = wrapValue(result.value);
        }
        return result;
      };
    }
    return iter;
  }
  var arrayProto = Array.prototype;
  function apply(self2, method, fn, thisArg, wrappedRetFn, args) {
    const arr = shallowReadArray(self2);
    const needsWrap = arr !== self2 && !isShallow(self2);
    const methodFn = arr[method];
    if (methodFn !== arrayProto[method]) {
      const result2 = methodFn.apply(self2, args);
      return needsWrap ? toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self2) {
      if (needsWrap) {
        wrappedFn = function(item, index) {
          return fn.call(this, toReactive(item), index, self2);
        };
      } else if (fn.length > 2) {
        wrappedFn = function(item, index) {
          return fn.call(this, item, index, self2);
        };
      }
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
  }
  function reduce(self2, method, fn, args) {
    const arr = shallowReadArray(self2);
    let wrappedFn = fn;
    if (arr !== self2) {
      if (!isShallow(self2)) {
        wrappedFn = function(acc, item, index) {
          return fn.call(this, acc, toReactive(item), index, self2);
        };
      } else if (fn.length > 3) {
        wrappedFn = function(acc, item, index) {
          return fn.call(this, acc, item, index, self2);
        };
      }
    }
    return arr[method](wrappedFn, ...args);
  }
  function searchProxy(self2, method, args) {
    const arr = toRaw(self2);
    track(arr, "iterate", ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && isProxy(args[0])) {
      args[0] = toRaw(args[0]);
      return arr[method](...args);
    }
    return res;
  }
  function noTracking(self2, method, args = []) {
    pauseTracking();
    startBatch();
    const res = toRaw(self2)[method].apply(self2, args);
    endBatch();
    resetTracking();
    return res;
  }
  var isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
  var builtInSymbols = new Set(
    /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key) => key !== "arguments" && key !== "caller").map((key) => Symbol[key]).filter(isSymbol)
  );
  function hasOwnProperty2(key) {
    if (!isSymbol(key)) key = String(key);
    const obj = toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
  }
  var BaseReactiveHandler = class {
    constructor(_isReadonly = false, _isShallow = false) {
      this._isReadonly = _isReadonly;
      this._isShallow = _isShallow;
    }
    get(target2, key, receiver) {
      if (key === "__v_skip") return target2["__v_skip"];
      const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
      if (key === "__v_isReactive") {
        return !isReadonly2;
      } else if (key === "__v_isReadonly") {
        return isReadonly2;
      } else if (key === "__v_isShallow") {
        return isShallow2;
      } else if (key === "__v_raw") {
        if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target2) || // receiver is not the reactive proxy, but has the same prototype
        // this means the receiver is a user proxy of the reactive proxy
        Object.getPrototypeOf(target2) === Object.getPrototypeOf(receiver)) {
          return target2;
        }
        return;
      }
      const targetIsArray = isArray(target2);
      if (!isReadonly2) {
        let fn;
        if (targetIsArray && (fn = arrayInstrumentations[key])) {
          return fn;
        }
        if (key === "hasOwnProperty") {
          return hasOwnProperty2;
        }
      }
      const res = Reflect.get(
        target2,
        key,
        // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        isRef2(target2) ? target2 : receiver
      );
      if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
        return res;
      }
      if (!isReadonly2) {
        track(target2, "get", key);
      }
      if (isShallow2) {
        return res;
      }
      if (isRef2(res)) {
        return targetIsArray && isIntegerKey(key) ? res : res.value;
      }
      if (isObject(res)) {
        return isReadonly2 ? readonly(res) : reactive(res);
      }
      return res;
    }
  };
  var MutableReactiveHandler = class extends BaseReactiveHandler {
    constructor(isShallow2 = false) {
      super(false, isShallow2);
    }
    set(target2, key, value, receiver) {
      let oldValue = target2[key];
      if (!this._isShallow) {
        const isOldValueReadonly = isReadonly(oldValue);
        if (!isShallow(value) && !isReadonly(value)) {
          oldValue = toRaw(oldValue);
          value = toRaw(value);
        }
        if (!isArray(target2) && isRef2(oldValue) && !isRef2(value)) {
          if (isOldValueReadonly) {
            return false;
          } else {
            oldValue.value = value;
            return true;
          }
        }
      }
      const hadKey = isArray(target2) && isIntegerKey(key) ? Number(key) < target2.length : hasOwn(target2, key);
      const result = Reflect.set(
        target2,
        key,
        value,
        isRef2(target2) ? target2 : receiver
      );
      if (target2 === toRaw(receiver)) {
        if (!hadKey) {
          trigger(target2, "add", key, value);
        } else if (hasChanged(value, oldValue)) {
          trigger(target2, "set", key, value, oldValue);
        }
      }
      return result;
    }
    deleteProperty(target2, key) {
      const hadKey = hasOwn(target2, key);
      const oldValue = target2[key];
      const result = Reflect.deleteProperty(target2, key);
      if (result && hadKey) {
        trigger(target2, "delete", key, void 0, oldValue);
      }
      return result;
    }
    has(target2, key) {
      const result = Reflect.has(target2, key);
      if (!isSymbol(key) || !builtInSymbols.has(key)) {
        track(target2, "has", key);
      }
      return result;
    }
    ownKeys(target2) {
      track(
        target2,
        "iterate",
        isArray(target2) ? "length" : ITERATE_KEY
      );
      return Reflect.ownKeys(target2);
    }
  };
  var ReadonlyReactiveHandler = class extends BaseReactiveHandler {
    constructor(isShallow2 = false) {
      super(true, isShallow2);
    }
    set(target2, key) {
      if (true) {
        warn(
          `Set operation on key "${String(key)}" failed: target is readonly.`,
          target2
        );
      }
      return true;
    }
    deleteProperty(target2, key) {
      if (true) {
        warn(
          `Delete operation on key "${String(key)}" failed: target is readonly.`,
          target2
        );
      }
      return true;
    }
  };
  var mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
  var readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
  var shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
  var shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
  var toShallow = (value) => value;
  var getProto = (v) => Reflect.getPrototypeOf(v);
  function createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
      const target2 = this["__v_raw"];
      const rawTarget = toRaw(target2);
      const targetIsMap = isMap(rawTarget);
      const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
      const isKeyOnly = method === "keys" && targetIsMap;
      const innerIterator = target2[method](...args);
      const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
      !isReadonly2 && track(
        rawTarget,
        "iterate",
        isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
      );
      return {
        // iterator protocol
        next() {
          const { value, done } = innerIterator.next();
          return done ? { value, done } : {
            value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
            done
          };
        },
        // iterable protocol
        [Symbol.iterator]() {
          return this;
        }
      };
    };
  }
  function createReadonlyMethod(type) {
    return function(...args) {
      if (true) {
        const key = args[0] ? `on key "${args[0]}" ` : ``;
        warn(
          `${capitalize(type)} operation ${key}failed: target is readonly.`,
          toRaw(this)
        );
      }
      return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
  }
  function createInstrumentations(readonly2, shallow) {
    const instrumentations = {
      get(key) {
        const target2 = this["__v_raw"];
        const rawTarget = toRaw(target2);
        const rawKey = toRaw(key);
        if (!readonly2) {
          if (hasChanged(key, rawKey)) {
            track(rawTarget, "get", key);
          }
          track(rawTarget, "get", rawKey);
        }
        const { has: has2 } = getProto(rawTarget);
        const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
        if (has2.call(rawTarget, key)) {
          return wrap(target2.get(key));
        } else if (has2.call(rawTarget, rawKey)) {
          return wrap(target2.get(rawKey));
        } else if (target2 !== rawTarget) {
          target2.get(key);
        }
      },
      get size() {
        const target2 = this["__v_raw"];
        !readonly2 && track(toRaw(target2), "iterate", ITERATE_KEY);
        return Reflect.get(target2, "size", target2);
      },
      has(key) {
        const target2 = this["__v_raw"];
        const rawTarget = toRaw(target2);
        const rawKey = toRaw(key);
        if (!readonly2) {
          if (hasChanged(key, rawKey)) {
            track(rawTarget, "has", key);
          }
          track(rawTarget, "has", rawKey);
        }
        return key === rawKey ? target2.has(key) : target2.has(key) || target2.has(rawKey);
      },
      forEach(callback, thisArg) {
        const observed = this;
        const target2 = observed["__v_raw"];
        const rawTarget = toRaw(target2);
        const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
        !readonly2 && track(rawTarget, "iterate", ITERATE_KEY);
        return target2.forEach((value, key) => {
          return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
      }
    };
    extend(
      instrumentations,
      readonly2 ? {
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear")
      } : {
        add(value) {
          if (!shallow && !isShallow(value) && !isReadonly(value)) {
            value = toRaw(value);
          }
          const target2 = toRaw(this);
          const proto = getProto(target2);
          const hadKey = proto.has.call(target2, value);
          if (!hadKey) {
            target2.add(value);
            trigger(target2, "add", value, value);
          }
          return this;
        },
        set(key, value) {
          if (!shallow && !isShallow(value) && !isReadonly(value)) {
            value = toRaw(value);
          }
          const target2 = toRaw(this);
          const { has: has2, get: get2 } = getProto(target2);
          let hadKey = has2.call(target2, key);
          if (!hadKey) {
            key = toRaw(key);
            hadKey = has2.call(target2, key);
          } else if (true) {
            checkIdentityKeys(target2, has2, key);
          }
          const oldValue = get2.call(target2, key);
          target2.set(key, value);
          if (!hadKey) {
            trigger(target2, "add", key, value);
          } else if (hasChanged(value, oldValue)) {
            trigger(target2, "set", key, value, oldValue);
          }
          return this;
        },
        delete(key) {
          const target2 = toRaw(this);
          const { has: has2, get: get2 } = getProto(target2);
          let hadKey = has2.call(target2, key);
          if (!hadKey) {
            key = toRaw(key);
            hadKey = has2.call(target2, key);
          } else if (true) {
            checkIdentityKeys(target2, has2, key);
          }
          const oldValue = get2 ? get2.call(target2, key) : void 0;
          const result = target2.delete(key);
          if (hadKey) {
            trigger(target2, "delete", key, void 0, oldValue);
          }
          return result;
        },
        clear() {
          const target2 = toRaw(this);
          const hadItems = target2.size !== 0;
          const oldTarget = true ? isMap(target2) ? new Map(target2) : new Set(target2) : void 0;
          const result = target2.clear();
          if (hadItems) {
            trigger(
              target2,
              "clear",
              void 0,
              void 0,
              oldTarget
            );
          }
          return result;
        }
      }
    );
    const iteratorMethods = [
      "keys",
      "values",
      "entries",
      Symbol.iterator
    ];
    iteratorMethods.forEach((method) => {
      instrumentations[method] = createIterableMethod(method, readonly2, shallow);
    });
    return instrumentations;
  }
  function createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = createInstrumentations(isReadonly2, shallow);
    return (target2, key, receiver) => {
      if (key === "__v_isReactive") {
        return !isReadonly2;
      } else if (key === "__v_isReadonly") {
        return isReadonly2;
      } else if (key === "__v_raw") {
        return target2;
      }
      return Reflect.get(
        hasOwn(instrumentations, key) && key in target2 ? instrumentations : target2,
        key,
        receiver
      );
    };
  }
  var mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
  };
  var shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
  };
  var readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
  };
  var shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
  };
  function checkIdentityKeys(target2, has2, key) {
    const rawKey = toRaw(key);
    if (rawKey !== key && has2.call(target2, rawKey)) {
      const type = toRawType(target2);
      warn(
        `Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
      );
    }
  }
  var reactiveMap = /* @__PURE__ */ new WeakMap();
  var shallowReactiveMap = /* @__PURE__ */ new WeakMap();
  var readonlyMap = /* @__PURE__ */ new WeakMap();
  var shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
  function targetTypeMap(rawType) {
    switch (rawType) {
      case "Object":
      case "Array":
        return 1;
      case "Map":
      case "Set":
      case "WeakMap":
      case "WeakSet":
        return 2;
      default:
        return 0;
    }
  }
  function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
  }
  function reactive(target2) {
    if (isReadonly(target2)) {
      return target2;
    }
    return createReactiveObject(
      target2,
      false,
      mutableHandlers,
      mutableCollectionHandlers,
      reactiveMap
    );
  }
  function shallowReactive(target2) {
    return createReactiveObject(
      target2,
      false,
      shallowReactiveHandlers,
      shallowCollectionHandlers,
      shallowReactiveMap
    );
  }
  function readonly(target2) {
    return createReactiveObject(
      target2,
      true,
      readonlyHandlers,
      readonlyCollectionHandlers,
      readonlyMap
    );
  }
  function shallowReadonly(target2) {
    return createReactiveObject(
      target2,
      true,
      shallowReadonlyHandlers,
      shallowReadonlyCollectionHandlers,
      shallowReadonlyMap
    );
  }
  function createReactiveObject(target2, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!isObject(target2)) {
      if (true) {
        warn(
          `value cannot be made ${isReadonly2 ? "readonly" : "reactive"}: ${String(
            target2
          )}`
        );
      }
      return target2;
    }
    if (target2["__v_raw"] && !(isReadonly2 && target2["__v_isReactive"])) {
      return target2;
    }
    const existingProxy = proxyMap.get(target2);
    if (existingProxy) {
      return existingProxy;
    }
    const targetType = getTargetType(target2);
    if (targetType === 0) {
      return target2;
    }
    const proxy = new Proxy(
      target2,
      targetType === 2 ? collectionHandlers : baseHandlers
    );
    proxyMap.set(target2, proxy);
    return proxy;
  }
  function isReactive(value) {
    if (isReadonly(value)) {
      return isReactive(value["__v_raw"]);
    }
    return !!(value && value["__v_isReactive"]);
  }
  function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
  }
  function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
  }
  function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
  }
  function toRaw(observed) {
    const raw3 = observed && observed["__v_raw"];
    return raw3 ? toRaw(raw3) : observed;
  }
  function markRaw(value) {
    if (!hasOwn(value, "__v_skip") && Object.isExtensible(value)) {
      def(value, "__v_skip", true);
    }
    return value;
  }
  var toReactive = (value) => isObject(value) ? reactive(value) : value;
  var toReadonly = (value) => isObject(value) ? readonly(value) : value;
  function isRef2(r) {
    return r ? r["__v_isRef"] === true : false;
  }
  function ref(value) {
    return createRef(value, false);
  }
  function shallowRef(value) {
    return createRef(value, true);
  }
  function createRef(rawValue, shallow) {
    if (isRef2(rawValue)) {
      return rawValue;
    }
    return new RefImpl(rawValue, shallow);
  }
  var RefImpl = class {
    constructor(value, isShallow2) {
      this.dep = new Dep();
      this["__v_isRef"] = true;
      this["__v_isShallow"] = false;
      this._rawValue = isShallow2 ? value : toRaw(value);
      this._value = isShallow2 ? value : toReactive(value);
      this["__v_isShallow"] = isShallow2;
    }
    get value() {
      if (true) {
        this.dep.track({
          target: this,
          type: "get",
          key: "value"
        });
      } else {
        this.dep.track();
      }
      return this._value;
    }
    set value(newValue) {
      const oldValue = this._rawValue;
      const useDirectValue = this["__v_isShallow"] || isShallow(newValue) || isReadonly(newValue);
      newValue = useDirectValue ? newValue : toRaw(newValue);
      if (hasChanged(newValue, oldValue)) {
        this._rawValue = newValue;
        this._value = useDirectValue ? newValue : toReactive(newValue);
        if (true) {
          this.dep.trigger({
            target: this,
            type: "set",
            key: "value",
            newValue,
            oldValue
          });
        } else {
          this.dep.trigger();
        }
      }
    }
  };
  function triggerRef(ref2) {
    if (ref2.dep) {
      if (true) {
        ref2.dep.trigger({
          target: ref2,
          type: "set",
          key: "value",
          newValue: ref2._value
        });
      } else {
        ref2.dep.trigger();
      }
    }
  }
  function unref(ref2) {
    return isRef2(ref2) ? ref2.value : ref2;
  }
  function toValue(source) {
    return isFunction(source) ? source() : unref(source);
  }
  var shallowUnwrapHandlers = {
    get: (target2, key, receiver) => key === "__v_raw" ? target2 : unref(Reflect.get(target2, key, receiver)),
    set: (target2, key, value, receiver) => {
      const oldValue = target2[key];
      if (isRef2(oldValue) && !isRef2(value)) {
        oldValue.value = value;
        return true;
      } else {
        return Reflect.set(target2, key, value, receiver);
      }
    }
  };
  function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
  }
  var CustomRefImpl = class {
    constructor(factory) {
      this["__v_isRef"] = true;
      this._value = void 0;
      const dep = this.dep = new Dep();
      const { get: get2, set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
      this._get = get2;
      this._set = set;
    }
    get value() {
      return this._value = this._get();
    }
    set value(newVal) {
      this._set(newVal);
    }
  };
  function customRef(factory) {
    return new CustomRefImpl(factory);
  }
  function toRefs(object) {
    if (!isProxy(object)) {
      warn(`toRefs() expects a reactive object but received a plain one.`);
    }
    const ret = isArray(object) ? new Array(object.length) : {};
    for (const key in object) {
      ret[key] = propertyToRef(object, key);
    }
    return ret;
  }
  var ObjectRefImpl = class {
    constructor(_object, _key, _defaultValue) {
      this._object = _object;
      this._key = _key;
      this._defaultValue = _defaultValue;
      this["__v_isRef"] = true;
      this._value = void 0;
    }
    get value() {
      const val = this._object[this._key];
      return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
      this._object[this._key] = newVal;
    }
    get dep() {
      return getDepFromReactive(toRaw(this._object), this._key);
    }
  };
  var GetterRefImpl = class {
    constructor(_getter) {
      this._getter = _getter;
      this["__v_isRef"] = true;
      this["__v_isReadonly"] = true;
      this._value = void 0;
    }
    get value() {
      return this._value = this._getter();
    }
  };
  function toRef(source, key, defaultValue) {
    if (isRef2(source)) {
      return source;
    } else if (isFunction(source)) {
      return new GetterRefImpl(source);
    } else if (isObject(source) && arguments.length > 1) {
      return propertyToRef(source, key, defaultValue);
    } else {
      return ref(source);
    }
  }
  function propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return isRef2(val) ? val : new ObjectRefImpl(source, key, defaultValue);
  }
  var ComputedRefImpl = class {
    constructor(fn, setter, isSSR) {
      this.fn = fn;
      this.setter = setter;
      this._value = void 0;
      this.dep = new Dep(this);
      this.__v_isRef = true;
      this.deps = void 0;
      this.depsTail = void 0;
      this.flags = 16;
      this.globalVersion = globalVersion - 1;
      this.next = void 0;
      this.effect = this;
      this["__v_isReadonly"] = !setter;
      this.isSSR = isSSR;
    }
    /**
     * @internal
     */
    notify() {
      this.flags |= 16;
      if (!(this.flags & 8) && // avoid infinite self recursion
      activeSub !== this) {
        batch(this, true);
        return true;
      } else if (true) ;
    }
    get value() {
      const link = true ? this.dep.track({
        target: this,
        type: "get",
        key: "value"
      }) : this.dep.track();
      refreshComputed(this);
      if (link) {
        link.version = this.dep.version;
      }
      return this._value;
    }
    set value(newValue) {
      if (this.setter) {
        this.setter(newValue);
      } else if (true) {
        warn("Write operation failed: computed value is readonly");
      }
    }
  };
  function computed(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if (isFunction(getterOrOptions)) {
      getter = getterOrOptions;
    } else {
      getter = getterOrOptions.get;
      setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, isSSR);
    if (debugOptions && !isSSR) {
      cRef.onTrack = debugOptions.onTrack;
      cRef.onTrigger = debugOptions.onTrigger;
    }
    return cRef;
  }
  var TrackOpTypes = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
  };
  var TriggerOpTypes = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
  };
  var INITIAL_WATCHER_VALUE = {};
  var cleanupMap = /* @__PURE__ */ new WeakMap();
  var activeWatcher = void 0;
  function getCurrentWatcher() {
    return activeWatcher;
  }
  function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
    if (owner) {
      let cleanups = cleanupMap.get(owner);
      if (!cleanups) cleanupMap.set(owner, cleanups = []);
      cleanups.push(cleanupFn);
    } else if (!failSilently) {
      warn(
        `onWatcherCleanup() was called when there was no active watcher to associate with.`
      );
    }
  }
  function watch(source, cb, options3 = EMPTY_OBJ) {
    const { immediate, deep, once, scheduler, augmentJob, call } = options3;
    const warnInvalidSource = (s) => {
      (options3.onWarn || warn)(
        `Invalid watch source: `,
        s,
        `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`
      );
    };
    const reactiveGetter = (source2) => {
      if (deep) return source2;
      if (isShallow(source2) || deep === false || deep === 0)
        return traverse(source2, 1);
      return traverse(source2);
    };
    let effect2;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if (isRef2(source)) {
      getter = () => source.value;
      forceTrigger = isShallow(source);
    } else if (isReactive(source)) {
      getter = () => reactiveGetter(source);
      forceTrigger = true;
    } else if (isArray(source)) {
      isMultiSource = true;
      forceTrigger = source.some((s) => isReactive(s) || isShallow(s));
      getter = () => source.map((s) => {
        if (isRef2(s)) {
          return s.value;
        } else if (isReactive(s)) {
          return reactiveGetter(s);
        } else if (isFunction(s)) {
          return call ? call(s, 2) : s();
        } else {
          warnInvalidSource(s);
        }
      });
    } else if (isFunction(source)) {
      if (cb) {
        getter = call ? () => call(source, 2) : source;
      } else {
        getter = () => {
          if (cleanup) {
            pauseTracking();
            try {
              cleanup();
            } finally {
              resetTracking();
            }
          }
          const currentEffect = activeWatcher;
          activeWatcher = effect2;
          try {
            return call ? call(source, 3, [boundCleanup]) : source(boundCleanup);
          } finally {
            activeWatcher = currentEffect;
          }
        };
      }
    } else {
      getter = NOOP;
      warnInvalidSource(source);
    }
    if (cb && deep) {
      const baseGetter = getter;
      const depth = deep === true ? Infinity : deep;
      getter = () => traverse(baseGetter(), depth);
    }
    const scope = getCurrentScope();
    const watchHandle = () => {
      effect2.stop();
      if (scope && scope.active) {
        remove(scope.effects, effect2);
      }
    };
    if (once && cb) {
      const _cb = cb;
      cb = (...args) => {
        _cb(...args);
        watchHandle();
      };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun) => {
      if (!(effect2.flags & 1) || !effect2.dirty && !immediateFirstRun) {
        return;
      }
      if (cb) {
        const newValue = effect2.run();
        if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i) => hasChanged(v, oldValue[i])) : hasChanged(newValue, oldValue))) {
          if (cleanup) {
            cleanup();
          }
          const currentWatcher = activeWatcher;
          activeWatcher = effect2;
          try {
            const args = [
              newValue,
              // pass undefined as the old value when it's changed for the first time
              oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
              boundCleanup
            ];
            call ? call(cb, 3, args) : (
              // @ts-expect-error
              cb(...args)
            );
            oldValue = newValue;
          } finally {
            activeWatcher = currentWatcher;
          }
        }
      } else {
        effect2.run();
      }
    };
    if (augmentJob) {
      augmentJob(job);
    }
    effect2 = new ReactiveEffect(getter);
    effect2.scheduler = scheduler ? () => scheduler(job, false) : job;
    boundCleanup = (fn) => onWatcherCleanup(fn, false, effect2);
    cleanup = effect2.onStop = () => {
      const cleanups = cleanupMap.get(effect2);
      if (cleanups) {
        if (call) {
          call(cleanups, 4);
        } else {
          for (const cleanup2 of cleanups) cleanup2();
        }
        cleanupMap.delete(effect2);
      }
    };
    if (true) {
      effect2.onTrack = options3.onTrack;
      effect2.onTrigger = options3.onTrigger;
    }
    if (cb) {
      if (immediate) {
        job(true);
      } else {
        oldValue = effect2.run();
      }
    } else if (scheduler) {
      scheduler(job.bind(null, true), true);
    } else {
      effect2.run();
    }
    watchHandle.pause = effect2.pause.bind(effect2);
    watchHandle.resume = effect2.resume.bind(effect2);
    watchHandle.stop = watchHandle;
    return watchHandle;
  }
  function traverse(value, depth = Infinity, seen2) {
    if (depth <= 0 || !isObject(value) || value["__v_skip"]) {
      return value;
    }
    seen2 = seen2 || /* @__PURE__ */ new Set();
    if (seen2.has(value)) {
      return value;
    }
    seen2.add(value);
    depth--;
    if (isRef2(value)) {
      traverse(value.value, depth, seen2);
    } else if (isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        traverse(value[i], depth, seen2);
      }
    } else if (isSet(value) || isMap(value)) {
      value.forEach((v) => {
        traverse(v, depth, seen2);
      });
    } else if (isPlainObject(value)) {
      for (const key in value) {
        traverse(value[key], depth, seen2);
      }
      for (const key of Object.getOwnPropertySymbols(value)) {
        if (Object.prototype.propertyIsEnumerable.call(value, key)) {
          traverse(value[key], depth, seen2);
        }
      }
    }
    return value;
  }

  // node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
  var stack = [];
  function pushWarningContext(vnode) {
    stack.push(vnode);
  }
  function popWarningContext() {
    stack.pop();
  }
  var isWarning = false;
  function warn$1(msg, ...args) {
    if (isWarning) return;
    isWarning = true;
    pauseTracking();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) {
      callWithErrorHandling(
        appWarnHandler,
        instance,
        11,
        [
          // eslint-disable-next-line no-restricted-syntax
          msg + args.map((a) => {
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
          }).join(""),
          instance && instance.proxy,
          trace.map(
            ({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`
          ).join("\n"),
          trace
        ]
      );
    } else {
      const warnArgs = [`[Vue warn]: ${msg}`, ...args];
      if (trace.length && // avoid spamming console during tests
      true) {
        warnArgs.push(`
`, ...formatTrace(trace));
      }
      console.warn(...warnArgs);
    }
    resetTracking();
    isWarning = false;
  }
  function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) {
      return [];
    }
    const normalizedStack = [];
    while (currentVNode) {
      const last = normalizedStack[0];
      if (last && last.vnode === currentVNode) {
        last.recurseCount++;
      } else {
        normalizedStack.push({
          vnode: currentVNode,
          recurseCount: 0
        });
      }
      const parentInstance = currentVNode.component && currentVNode.component.parent;
      currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
  }
  function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i) => {
      logs.push(...i === 0 ? [] : [`
`], ...formatTraceEntry(entry));
    });
    return logs;
  }
  function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${formatComponentName(
      vnode.component,
      vnode.type,
      isRoot
    )}`;
    const close = `>` + postfix;
    return vnode.props ? [open, ...formatProps(vnode.props), close] : [open + close];
  }
  function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key) => {
      res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) {
      res.push(` ...`);
    }
    return res;
  }
  function formatProp(key, value, raw3) {
    if (isString(value)) {
      value = JSON.stringify(value);
      return raw3 ? value : [`${key}=${value}`];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) {
      return raw3 ? value : [`${key}=${value}`];
    } else if (isRef2(value)) {
      value = formatProp(key, toRaw(value.value), true);
      return raw3 ? value : [`${key}=Ref<`, value, `>`];
    } else if (isFunction(value)) {
      return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
    } else {
      value = toRaw(value);
      return raw3 ? value : [`${key}=`, value];
    }
  }
  function assertNumber(val, type) {
    if (false) return;
    if (val === void 0) {
      return;
    } else if (typeof val !== "number") {
      warn$1(`${type} is not a valid number - got ${JSON.stringify(val)}.`);
    } else if (isNaN(val)) {
      warn$1(`${type} is NaN - the duration expression might be incorrect.`);
    }
  }
  var ErrorCodes = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
  };
  var ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
  };
  function callWithErrorHandling(fn, instance, type, args) {
    try {
      return args ? fn(...args) : fn();
    } catch (err) {
      handleError(err, instance, type);
    }
  }
  function callWithAsyncErrorHandling(fn, instance, type, args) {
    if (isFunction(fn)) {
      const res = callWithErrorHandling(fn, instance, type, args);
      if (res && isPromise(res)) {
        res.catch((err) => {
          handleError(err, instance, type);
        });
      }
      return res;
    }
    if (isArray(fn)) {
      const values = [];
      for (let i = 0; i < fn.length; i++) {
        values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
      }
      return values;
    } else if (true) {
      warn$1(
        `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof fn}`
      );
    }
  }
  function handleError(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler2, throwUnhandledErrorInProduction } = instance && instance.appContext.config || EMPTY_OBJ;
    if (instance) {
      let cur = instance.parent;
      const exposedInstance = instance.proxy;
      const errorInfo = true ? ErrorTypeStrings$1[type] : `https://vuejs.org/error-reference/#runtime-${type}`;
      while (cur) {
        const errorCapturedHooks = cur.ec;
        if (errorCapturedHooks) {
          for (let i = 0; i < errorCapturedHooks.length; i++) {
            if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
              return;
            }
          }
        }
        cur = cur.parent;
      }
      if (errorHandler2) {
        pauseTracking();
        callWithErrorHandling(errorHandler2, null, 10, [
          err,
          exposedInstance,
          errorInfo
        ]);
        resetTracking();
        return;
      }
    }
    logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
  }
  function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (true) {
      const info = ErrorTypeStrings$1[type];
      if (contextVNode) {
        pushWarningContext(contextVNode);
      }
      warn$1(`Unhandled error${info ? ` during execution of ${info}` : ``}`);
      if (contextVNode) {
        popWarningContext();
      }
      if (throwInDev) {
        throw err;
      } else {
        console.error(err);
      }
    } else if (throwInProd) {
      throw err;
    } else {
      console.error(err);
    }
  }
  var queue = [];
  var flushIndex = -1;
  var pendingPostFlushCbs = [];
  var activePostFlushCbs = null;
  var postFlushIndex = 0;
  var resolvedPromise = /* @__PURE__ */ Promise.resolve();
  var currentFlushPromise = null;
  var RECURSION_LIMIT = 100;
  function nextTick(fn) {
    const p2 = currentFlushPromise || resolvedPromise;
    return fn ? p2.then(this ? fn.bind(this) : fn) : p2;
  }
  function findInsertionIndex(id) {
    let start = flushIndex + 1;
    let end = queue.length;
    while (start < end) {
      const middle = start + end >>> 1;
      const middleJob = queue[middle];
      const middleJobId = getId(middleJob);
      if (middleJobId < id || middleJobId === id && middleJob.flags & 2) {
        start = middle + 1;
      } else {
        end = middle;
      }
    }
    return start;
  }
  function queueJob(job) {
    if (!(job.flags & 1)) {
      const jobId = getId(job);
      const lastJob = queue[queue.length - 1];
      if (!lastJob || // fast path when the job id is larger than the tail
      !(job.flags & 2) && jobId >= getId(lastJob)) {
        queue.push(job);
      } else {
        queue.splice(findInsertionIndex(jobId), 0, job);
      }
      job.flags |= 1;
      queueFlush();
    }
  }
  function queueFlush() {
    if (!currentFlushPromise) {
      currentFlushPromise = resolvedPromise.then(flushJobs);
    }
  }
  function queuePostFlushCb(cb) {
    if (!isArray(cb)) {
      if (activePostFlushCbs && cb.id === -1) {
        activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
      } else if (!(cb.flags & 1)) {
        pendingPostFlushCbs.push(cb);
        cb.flags |= 1;
      }
    } else {
      pendingPostFlushCbs.push(...cb);
    }
    queueFlush();
  }
  function flushPreFlushCbs(instance, seen2, i = flushIndex + 1) {
    if (true) {
      seen2 = seen2 || /* @__PURE__ */ new Map();
    }
    for (; i < queue.length; i++) {
      const cb = queue[i];
      if (cb && cb.flags & 2) {
        if (instance && cb.id !== instance.uid) {
          continue;
        }
        if (checkRecursiveUpdates(seen2, cb)) {
          continue;
        }
        queue.splice(i, 1);
        i--;
        if (cb.flags & 4) {
          cb.flags &= ~1;
        }
        cb();
        if (!(cb.flags & 4)) {
          cb.flags &= ~1;
        }
      }
    }
  }
  function flushPostFlushCbs(seen2) {
    if (pendingPostFlushCbs.length) {
      const deduped = [...new Set(pendingPostFlushCbs)].sort(
        (a, b) => getId(a) - getId(b)
      );
      pendingPostFlushCbs.length = 0;
      if (activePostFlushCbs) {
        activePostFlushCbs.push(...deduped);
        return;
      }
      activePostFlushCbs = deduped;
      if (true) {
        seen2 = seen2 || /* @__PURE__ */ new Map();
      }
      for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
        const cb = activePostFlushCbs[postFlushIndex];
        if (checkRecursiveUpdates(seen2, cb)) {
          continue;
        }
        if (cb.flags & 4) {
          cb.flags &= ~1;
        }
        if (!(cb.flags & 8)) cb();
        cb.flags &= ~1;
      }
      activePostFlushCbs = null;
      postFlushIndex = 0;
    }
  }
  var getId = (job) => job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
  function flushJobs(seen2) {
    if (true) {
      seen2 = seen2 || /* @__PURE__ */ new Map();
    }
    const check = true ? (job) => checkRecursiveUpdates(seen2, job) : NOOP;
    try {
      for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
        const job = queue[flushIndex];
        if (job && !(job.flags & 8)) {
          if (check(job)) {
            continue;
          }
          if (job.flags & 4) {
            job.flags &= ~1;
          }
          callWithErrorHandling(
            job,
            job.i,
            job.i ? 15 : 14
          );
          if (!(job.flags & 4)) {
            job.flags &= ~1;
          }
        }
      }
    } finally {
      for (; flushIndex < queue.length; flushIndex++) {
        const job = queue[flushIndex];
        if (job) {
          job.flags &= ~1;
        }
      }
      flushIndex = -1;
      queue.length = 0;
      flushPostFlushCbs(seen2);
      currentFlushPromise = null;
      if (queue.length || pendingPostFlushCbs.length) {
        flushJobs(seen2);
      }
    }
  }
  function checkRecursiveUpdates(seen2, fn) {
    const count2 = seen2.get(fn) || 0;
    if (count2 > RECURSION_LIMIT) {
      const instance = fn.i;
      const componentName = instance && getComponentName(instance.type);
      handleError(
        `Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
        null,
        10
      );
      return true;
    }
    seen2.set(fn, count2 + 1);
    return false;
  }
  var isHmrUpdating = false;
  var hmrDirtyComponents = /* @__PURE__ */ new Map();
  if (true) {
    getGlobalThis().__VUE_HMR_RUNTIME__ = {
      createRecord: tryWrap(createRecord),
      rerender: tryWrap(rerender),
      reload: tryWrap(reload)
    };
  }
  var map = /* @__PURE__ */ new Map();
  function registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = map.get(id);
    if (!record) {
      createRecord(id, instance.type);
      record = map.get(id);
    }
    record.instances.add(instance);
  }
  function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
  }
  function createRecord(id, initialDef) {
    if (map.has(id)) {
      return false;
    }
    map.set(id, {
      initialDef: normalizeClassComponent(initialDef),
      instances: /* @__PURE__ */ new Set()
    });
    return true;
  }
  function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
  }
  function rerender(id, newRender) {
    const record = map.get(id);
    if (!record) {
      return;
    }
    record.initialDef.render = newRender;
    [...record.instances].forEach((instance) => {
      if (newRender) {
        instance.render = newRender;
        normalizeClassComponent(instance.type).render = newRender;
      }
      instance.renderCache = [];
      isHmrUpdating = true;
      instance.update();
      isHmrUpdating = false;
    });
  }
  function reload(id, newComp) {
    const record = map.get(id);
    if (!record) return;
    newComp = normalizeClassComponent(newComp);
    updateComponentDef(record.initialDef, newComp);
    const instances = [...record.instances];
    for (let i = 0; i < instances.length; i++) {
      const instance = instances[i];
      const oldComp = normalizeClassComponent(instance.type);
      let dirtyInstances = hmrDirtyComponents.get(oldComp);
      if (!dirtyInstances) {
        if (oldComp !== record.initialDef) {
          updateComponentDef(oldComp, newComp);
        }
        hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
      }
      dirtyInstances.add(instance);
      instance.appContext.propsCache.delete(instance.type);
      instance.appContext.emitsCache.delete(instance.type);
      instance.appContext.optionsCache.delete(instance.type);
      if (instance.ceReload) {
        dirtyInstances.add(instance);
        instance.ceReload(newComp.styles);
        dirtyInstances.delete(instance);
      } else if (instance.parent) {
        queueJob(() => {
          isHmrUpdating = true;
          instance.parent.update();
          isHmrUpdating = false;
          dirtyInstances.delete(instance);
        });
      } else if (instance.appContext.reload) {
        instance.appContext.reload();
      } else if (typeof window !== "undefined") {
        window.location.reload();
      } else {
        console.warn(
          "[HMR] Root or manually mounted instance modified. Full reload required."
        );
      }
      if (instance.root.ce && instance !== instance.root) {
        instance.root.ce._removeChildStyle(oldComp);
      }
    }
    queuePostFlushCb(() => {
      hmrDirtyComponents.clear();
    });
  }
  function updateComponentDef(oldComp, newComp) {
    extend(oldComp, newComp);
    for (const key in oldComp) {
      if (key !== "__file" && !(key in newComp)) {
        delete oldComp[key];
      }
    }
  }
  function tryWrap(fn) {
    return (id, arg) => {
      try {
        return fn(id, arg);
      } catch (e) {
        console.error(e);
        console.warn(
          `[HMR] Something went wrong during Vue component hot-reload. Full reload required.`
        );
      }
    };
  }
  var devtools$1;
  var buffer = [];
  var devtoolsNotInstalled = false;
  function emit$1(event, ...args) {
    if (devtools$1) {
      devtools$1.emit(event, ...args);
    } else if (!devtoolsNotInstalled) {
      buffer.push({ event, args });
    }
  }
  function setDevtoolsHook$1(hook, target2) {
    var _a, _b;
    devtools$1 = hook;
    if (devtools$1) {
      devtools$1.enabled = true;
      buffer.forEach(({ event, args }) => devtools$1.emit(event, ...args));
      buffer = [];
    } else if (
      // handle late devtools injection - only do this if we are in an actual
      // browser environment to avoid the timer handle stalling test runner exit
      // (#4815)
      typeof window !== "undefined" && // some envs mock window but not fully
      window.HTMLElement && // also exclude jsdom
      // eslint-disable-next-line no-restricted-syntax
      !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))
    ) {
      const replay = target2.__VUE_DEVTOOLS_HOOK_REPLAY__ = target2.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
      replay.push((newHook) => {
        setDevtoolsHook$1(newHook, target2);
      });
      setTimeout(() => {
        if (!devtools$1) {
          target2.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
          devtoolsNotInstalled = true;
          buffer = [];
        }
      }, 3e3);
    } else {
      devtoolsNotInstalled = true;
      buffer = [];
    }
  }
  function devtoolsInitApp(app2, version2) {
    emit$1("app:init", app2, version2, {
      Fragment,
      Text,
      Comment,
      Static
    });
  }
  function devtoolsUnmountApp(app2) {
    emit$1("app:unmount", app2);
  }
  var devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook(
    "component:added"
    /* COMPONENT_ADDED */
  );
  var devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook(
    "component:updated"
    /* COMPONENT_UPDATED */
  );
  var _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook(
    "component:removed"
    /* COMPONENT_REMOVED */
  );
  var devtoolsComponentRemoved = (component) => {
    if (devtools$1 && typeof devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !devtools$1.cleanupBuffer(component)) {
      _devtoolsComponentRemoved(component);
    }
  };
  // @__NO_SIDE_EFFECTS__
  function createDevtoolsComponentHook(hook) {
    return (component) => {
      emit$1(
        hook,
        component.appContext.app,
        component.uid,
        component.parent ? component.parent.uid : void 0,
        component
      );
    };
  }
  var devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook(
    "perf:start"
    /* PERFORMANCE_START */
  );
  var devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook(
    "perf:end"
    /* PERFORMANCE_END */
  );
  function createDevtoolsPerformanceHook(hook) {
    return (component, type, time) => {
      emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
  }
  function devtoolsComponentEmit(component, event, params) {
    emit$1(
      "component:emit",
      component.appContext.app,
      component,
      event,
      params
    );
  }
  var currentRenderingInstance = null;
  var currentScopeId = null;
  function setCurrentRenderingInstance(instance) {
    const prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
  }
  function pushScopeId(id) {
    currentScopeId = id;
  }
  function popScopeId() {
    currentScopeId = null;
  }
  var withScopeId = (_id) => withCtx;
  function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) {
      return fn;
    }
    const renderFnWithContext = (...args) => {
      if (renderFnWithContext._d) {
        setBlockTracking(-1);
      }
      const prevInstance = setCurrentRenderingInstance(ctx);
      let res;
      try {
        res = fn(...args);
      } finally {
        setCurrentRenderingInstance(prevInstance);
        if (renderFnWithContext._d) {
          setBlockTracking(1);
        }
      }
      if (true) {
        devtoolsComponentUpdated(ctx);
      }
      return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
  }
  function validateDirectiveName(name) {
    if (isBuiltInDirective(name)) {
      warn$1("Do not use built-in directive ids as custom directive id: " + name);
    }
  }
  function withDirectives(vnode, directives) {
    if (currentRenderingInstance === null) {
      warn$1(`withDirectives can only be used inside render functions.`);
      return vnode;
    }
    const instance = getComponentPublicInstance(currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for (let i = 0; i < directives.length; i++) {
      let [dir, value, arg, modifiers = EMPTY_OBJ] = directives[i];
      if (dir) {
        if (isFunction(dir)) {
          dir = {
            mounted: dir,
            updated: dir
          };
        }
        if (dir.deep) {
          traverse(value);
        }
        bindings.push({
          dir,
          instance,
          value,
          oldValue: void 0,
          arg,
          modifiers
        });
      }
    }
    return vnode;
  }
  function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for (let i = 0; i < bindings.length; i++) {
      const binding = bindings[i];
      if (oldBindings) {
        binding.oldValue = oldBindings[i].value;
      }
      let hook = binding.dir[name];
      if (hook) {
        pauseTracking();
        callWithAsyncErrorHandling(hook, instance, 8, [
          vnode.el,
          binding,
          vnode,
          prevVNode
        ]);
        resetTracking();
      }
    }
  }
  var TeleportEndKey = Symbol("_vte");
  var isTeleport = (type) => type.__isTeleport;
  var isTeleportDisabled = (props) => props && (props.disabled || props.disabled === "");
  var isTeleportDeferred = (props) => props && (props.defer || props.defer === "");
  var isTargetSVG = (target2) => typeof SVGElement !== "undefined" && target2 instanceof SVGElement;
  var isTargetMathML = (target2) => typeof MathMLElement === "function" && target2 instanceof MathMLElement;
  var resolveTarget = (props, select3) => {
    const targetSelector = props && props.to;
    if (isString(targetSelector)) {
      if (!select3) {
        warn$1(
          `Current renderer does not support string target for Teleports. (missing querySelector renderer option)`
        );
        return null;
      } else {
        const target2 = select3(targetSelector);
        if (!target2 && !isTeleportDisabled(props)) {
          warn$1(
            `Failed to locate Teleport target with selector "${targetSelector}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`
          );
        }
        return target2;
      }
    } else {
      if (!targetSelector && !isTeleportDisabled(props)) {
        warn$1(`Invalid Teleport target: ${targetSelector}`);
      }
      return targetSelector;
    }
  };
  var TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
      const {
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        o: { insert, querySelector, createText, createComment }
      } = internals;
      const disabled = isTeleportDisabled(n2.props);
      let { shapeFlag, children, dynamicChildren } = n2;
      if (isHmrUpdating) {
        optimized = false;
        dynamicChildren = null;
      }
      if (n1 == null) {
        const placeholder = n2.el = true ? createComment("teleport start") : createText("");
        const mainAnchor = n2.anchor = true ? createComment("teleport end") : createText("");
        insert(placeholder, container, anchor);
        insert(mainAnchor, container, anchor);
        const mount = (container2, anchor2) => {
          if (shapeFlag & 16) {
            if (parentComponent && parentComponent.isCE) {
              parentComponent.ce._teleportTarget = container2;
            }
            mountChildren(
              children,
              container2,
              anchor2,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          }
        };
        const mountToTarget = () => {
          const target2 = n2.target = resolveTarget(n2.props, querySelector);
          const targetAnchor = prepareAnchor(target2, n2, createText, insert);
          if (target2) {
            if (namespace !== "svg" && isTargetSVG(target2)) {
              namespace = "svg";
            } else if (namespace !== "mathml" && isTargetMathML(target2)) {
              namespace = "mathml";
            }
            if (!disabled) {
              mount(target2, targetAnchor);
              updateCssVars(n2, false);
            }
          } else if (!disabled) {
            warn$1(
              "Invalid Teleport target on mount:",
              target2,
              `(${typeof target2})`
            );
          }
        };
        if (disabled) {
          mount(container, mainAnchor);
          updateCssVars(n2, true);
        }
        if (isTeleportDeferred(n2.props)) {
          queuePostRenderEffect(() => {
            mountToTarget();
            n2.el.__isMounted = true;
          }, parentSuspense);
        } else {
          mountToTarget();
        }
      } else {
        if (isTeleportDeferred(n2.props) && !n1.el.__isMounted) {
          queuePostRenderEffect(() => {
            TeleportImpl.process(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized,
              internals
            );
            delete n1.el.__isMounted;
          }, parentSuspense);
          return;
        }
        n2.el = n1.el;
        n2.targetStart = n1.targetStart;
        const mainAnchor = n2.anchor = n1.anchor;
        const target2 = n2.target = n1.target;
        const targetAnchor = n2.targetAnchor = n1.targetAnchor;
        const wasDisabled = isTeleportDisabled(n1.props);
        const currentContainer = wasDisabled ? container : target2;
        const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
        if (namespace === "svg" || isTargetSVG(target2)) {
          namespace = "svg";
        } else if (namespace === "mathml" || isTargetMathML(target2)) {
          namespace = "mathml";
        }
        if (dynamicChildren) {
          patchBlockChildren(
            n1.dynamicChildren,
            dynamicChildren,
            currentContainer,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds
          );
          traverseStaticChildren(n1, n2, true);
        } else if (!optimized) {
          patchChildren(
            n1,
            n2,
            currentContainer,
            currentAnchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            false
          );
        }
        if (disabled) {
          if (!wasDisabled) {
            moveTeleport(
              n2,
              container,
              mainAnchor,
              internals,
              1
            );
          } else {
            if (n2.props && n1.props && n2.props.to !== n1.props.to) {
              n2.props.to = n1.props.to;
            }
          }
        } else {
          if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
            const nextTarget = n2.target = resolveTarget(
              n2.props,
              querySelector
            );
            if (nextTarget) {
              moveTeleport(
                n2,
                nextTarget,
                null,
                internals,
                0
              );
            } else if (true) {
              warn$1(
                "Invalid Teleport target on update:",
                target2,
                `(${typeof target2})`
              );
            }
          } else if (wasDisabled) {
            moveTeleport(
              n2,
              target2,
              targetAnchor,
              internals,
              1
            );
          }
        }
        updateCssVars(n2, disabled);
      }
    },
    remove(vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
      const {
        shapeFlag,
        children,
        anchor,
        targetStart,
        targetAnchor,
        target: target2,
        props
      } = vnode;
      if (target2) {
        hostRemove(targetStart);
        hostRemove(targetAnchor);
      }
      doRemove && hostRemove(anchor);
      if (shapeFlag & 16) {
        const shouldRemove = doRemove || !isTeleportDisabled(props);
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          unmount(
            child,
            parentComponent,
            parentSuspense,
            shouldRemove,
            !!child.dynamicChildren
          );
        }
      }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
  };
  function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
    if (moveType === 0) {
      insert(vnode.targetAnchor, container, parentAnchor);
    }
    const { el, anchor, shapeFlag, children, props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) {
      insert(el, container, parentAnchor);
    }
    if (!isReorder || isTeleportDisabled(props)) {
      if (shapeFlag & 16) {
        for (let i = 0; i < children.length; i++) {
          move(
            children[i],
            container,
            parentAnchor,
            2
          );
        }
      }
    }
    if (isReorder) {
      insert(anchor, container, parentAnchor);
    }
  }
  function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, {
    o: { nextSibling, parentNode, querySelector, insert, createText }
  }, hydrateChildren) {
    const target2 = vnode.target = resolveTarget(
      vnode.props,
      querySelector
    );
    if (target2) {
      const disabled = isTeleportDisabled(vnode.props);
      const targetNode = target2._lpa || target2.firstChild;
      if (vnode.shapeFlag & 16) {
        if (disabled) {
          vnode.anchor = hydrateChildren(
            nextSibling(node),
            vnode,
            parentNode(node),
            parentComponent,
            parentSuspense,
            slotScopeIds,
            optimized
          );
          vnode.targetStart = targetNode;
          vnode.targetAnchor = targetNode && nextSibling(targetNode);
        } else {
          vnode.anchor = nextSibling(node);
          let targetAnchor = targetNode;
          while (targetAnchor) {
            if (targetAnchor && targetAnchor.nodeType === 8) {
              if (targetAnchor.data === "teleport start anchor") {
                vnode.targetStart = targetAnchor;
              } else if (targetAnchor.data === "teleport anchor") {
                vnode.targetAnchor = targetAnchor;
                target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                break;
              }
            }
            targetAnchor = nextSibling(targetAnchor);
          }
          if (!vnode.targetAnchor) {
            prepareAnchor(target2, vnode, createText, insert);
          }
          hydrateChildren(
            targetNode && nextSibling(targetNode),
            vnode,
            target2,
            parentComponent,
            parentSuspense,
            slotScopeIds,
            optimized
          );
        }
      }
      updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
  }
  var Teleport = TeleportImpl;
  function updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
      let node, anchor;
      if (isDisabled) {
        node = vnode.el;
        anchor = vnode.anchor;
      } else {
        node = vnode.targetStart;
        anchor = vnode.targetAnchor;
      }
      while (node && node !== anchor) {
        if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
        node = node.nextSibling;
      }
      ctx.ut();
    }
  }
  function prepareAnchor(target2, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[TeleportEndKey] = targetAnchor;
    if (target2) {
      insert(targetStart, target2);
      insert(targetAnchor, target2);
    }
    return targetAnchor;
  }
  var leaveCbKey = Symbol("_leaveCb");
  var enterCbKey = Symbol("_enterCb");
  function useTransitionState() {
    const state = {
      isMounted: false,
      isLeaving: false,
      isUnmounting: false,
      leavingVNodes: /* @__PURE__ */ new Map()
    };
    onMounted(() => {
      state.isMounted = true;
    });
    onBeforeUnmount(() => {
      state.isUnmounting = true;
    });
    return state;
  }
  var TransitionHookValidator = [Function, Array];
  var BaseTransitionPropsValidators = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    // leave
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    // appear
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
  };
  var recursiveGetSubtree = (instance) => {
    const subTree = instance.subTree;
    return subTree.component ? recursiveGetSubtree(subTree.component) : subTree;
  };
  var BaseTransitionImpl = {
    name: `BaseTransition`,
    props: BaseTransitionPropsValidators,
    setup(props, { slots }) {
      const instance = getCurrentInstance();
      const state = useTransitionState();
      return () => {
        const children = slots.default && getTransitionRawChildren(slots.default(), true);
        if (!children || !children.length) {
          return;
        }
        const child = findNonCommentChild(children);
        const rawProps = toRaw(props);
        const { mode } = rawProps;
        if (mode && mode !== "in-out" && mode !== "out-in" && mode !== "default") {
          warn$1(`invalid <transition> mode: ${mode}`);
        }
        if (state.isLeaving) {
          return emptyPlaceholder(child);
        }
        const innerChild = getInnerChild$1(child);
        if (!innerChild) {
          return emptyPlaceholder(child);
        }
        let enterHooks = resolveTransitionHooks(
          innerChild,
          rawProps,
          state,
          instance,
          // #11061, ensure enterHooks is fresh after clone
          (hooks) => enterHooks = hooks
        );
        if (innerChild.type !== Comment) {
          setTransitionHooks(innerChild, enterHooks);
        }
        let oldInnerChild = instance.subTree && getInnerChild$1(instance.subTree);
        if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(innerChild, oldInnerChild) && recursiveGetSubtree(instance).type !== Comment) {
          let leavingHooks = resolveTransitionHooks(
            oldInnerChild,
            rawProps,
            state,
            instance
          );
          setTransitionHooks(oldInnerChild, leavingHooks);
          if (mode === "out-in" && innerChild.type !== Comment) {
            state.isLeaving = true;
            leavingHooks.afterLeave = () => {
              state.isLeaving = false;
              if (!(instance.job.flags & 8)) {
                instance.update();
              }
              delete leavingHooks.afterLeave;
              oldInnerChild = void 0;
            };
            return emptyPlaceholder(child);
          } else if (mode === "in-out" && innerChild.type !== Comment) {
            leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
              const leavingVNodesCache = getLeavingNodesForType(
                state,
                oldInnerChild
              );
              leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
              el[leaveCbKey] = () => {
                earlyRemove();
                el[leaveCbKey] = void 0;
                delete enterHooks.delayedLeave;
                oldInnerChild = void 0;
              };
              enterHooks.delayedLeave = () => {
                delayedLeave();
                delete enterHooks.delayedLeave;
                oldInnerChild = void 0;
              };
            };
          } else {
            oldInnerChild = void 0;
          }
        } else if (oldInnerChild) {
          oldInnerChild = void 0;
        }
        return child;
      };
    }
  };
  function findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
      let hasFound = false;
      for (const c of children) {
        if (c.type !== Comment) {
          if (hasFound) {
            warn$1(
              "<transition> can only be used on a single element or component. Use <transition-group> for lists."
            );
            break;
          }
          child = c;
          hasFound = true;
          if (false) break;
        }
      }
    }
    return child;
  }
  var BaseTransition = BaseTransitionImpl;
  function getLeavingNodesForType(state, vnode) {
    const { leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
      leavingVNodesCache = /* @__PURE__ */ Object.create(null);
      leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
  }
  function resolveTransitionHooks(vnode, props, state, instance, postClone) {
    const {
      appear,
      mode,
      persisted = false,
      onBeforeEnter,
      onEnter,
      onAfterEnter,
      onEnterCancelled,
      onBeforeLeave,
      onLeave,
      onAfterLeave,
      onLeaveCancelled,
      onBeforeAppear,
      onAppear,
      onAfterAppear,
      onAppearCancelled
    } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
    const callHook3 = (hook, args) => {
      hook && callWithAsyncErrorHandling(
        hook,
        instance,
        9,
        args
      );
    };
    const callAsyncHook = (hook, args) => {
      const done = args[1];
      callHook3(hook, args);
      if (isArray(hook)) {
        if (hook.every((hook2) => hook2.length <= 1)) done();
      } else if (hook.length <= 1) {
        done();
      }
    };
    const hooks = {
      mode,
      persisted,
      beforeEnter(el) {
        let hook = onBeforeEnter;
        if (!state.isMounted) {
          if (appear) {
            hook = onBeforeAppear || onBeforeEnter;
          } else {
            return;
          }
        }
        if (el[leaveCbKey]) {
          el[leaveCbKey](
            true
            /* cancelled */
          );
        }
        const leavingVNode = leavingVNodesCache[key];
        if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) {
          leavingVNode.el[leaveCbKey]();
        }
        callHook3(hook, [el]);
      },
      enter(el) {
        let hook = onEnter;
        let afterHook = onAfterEnter;
        let cancelHook = onEnterCancelled;
        if (!state.isMounted) {
          if (appear) {
            hook = onAppear || onEnter;
            afterHook = onAfterAppear || onAfterEnter;
            cancelHook = onAppearCancelled || onEnterCancelled;
          } else {
            return;
          }
        }
        let called = false;
        const done = el[enterCbKey] = (cancelled) => {
          if (called) return;
          called = true;
          if (cancelled) {
            callHook3(cancelHook, [el]);
          } else {
            callHook3(afterHook, [el]);
          }
          if (hooks.delayedLeave) {
            hooks.delayedLeave();
          }
          el[enterCbKey] = void 0;
        };
        if (hook) {
          callAsyncHook(hook, [el, done]);
        } else {
          done();
        }
      },
      leave(el, remove3) {
        const key2 = String(vnode.key);
        if (el[enterCbKey]) {
          el[enterCbKey](
            true
            /* cancelled */
          );
        }
        if (state.isUnmounting) {
          return remove3();
        }
        callHook3(onBeforeLeave, [el]);
        let called = false;
        const done = el[leaveCbKey] = (cancelled) => {
          if (called) return;
          called = true;
          remove3();
          if (cancelled) {
            callHook3(onLeaveCancelled, [el]);
          } else {
            callHook3(onAfterLeave, [el]);
          }
          el[leaveCbKey] = void 0;
          if (leavingVNodesCache[key2] === vnode) {
            delete leavingVNodesCache[key2];
          }
        };
        leavingVNodesCache[key2] = vnode;
        if (onLeave) {
          callAsyncHook(onLeave, [el, done]);
        } else {
          done();
        }
      },
      clone(vnode2) {
        const hooks2 = resolveTransitionHooks(
          vnode2,
          props,
          state,
          instance,
          postClone
        );
        if (postClone) postClone(hooks2);
        return hooks2;
      }
    };
    return hooks;
  }
  function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
      vnode = cloneVNode(vnode);
      vnode.children = null;
      return vnode;
    }
  }
  function getInnerChild$1(vnode) {
    if (!isKeepAlive(vnode)) {
      if (isTeleport(vnode.type) && vnode.children) {
        return findNonCommentChild(vnode.children);
      }
      return vnode;
    }
    if (vnode.component) {
      return vnode.component.subTree;
    }
    const { shapeFlag, children } = vnode;
    if (children) {
      if (shapeFlag & 16) {
        return children[0];
      }
      if (shapeFlag & 32 && isFunction(children.default)) {
        return children.default();
      }
    }
  }
  function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
      vnode.transition = hooks;
      setTransitionHooks(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
      vnode.ssContent.transition = hooks.clone(vnode.ssContent);
      vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else {
      vnode.transition = hooks;
    }
  }
  function getTransitionRawChildren(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for (let i = 0; i < children.length; i++) {
      let child = children[i];
      const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
      if (child.type === Fragment) {
        if (child.patchFlag & 128) keyedFragmentCount++;
        ret = ret.concat(
          getTransitionRawChildren(child.children, keepComment, key)
        );
      } else if (keepComment || child.type !== Comment) {
        ret.push(key != null ? cloneVNode(child, { key }) : child);
      }
    }
    if (keyedFragmentCount > 1) {
      for (let i = 0; i < ret.length; i++) {
        ret[i].patchFlag = -2;
      }
    }
    return ret;
  }
  // @__NO_SIDE_EFFECTS__
  function defineComponent(options3, extraOptions) {
    return isFunction(options3) ? (
      // #8236: extend call and options.name access are considered side-effects
      // by Rollup, so we have to wrap it in a pure-annotated IIFE.
      /* @__PURE__ */ (() => extend({ name: options3.name }, extraOptions, { setup: options3 }))()
    ) : options3;
  }
  function useId() {
    const i = getCurrentInstance();
    if (i) {
      return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    } else if (true) {
      warn$1(
        `useId() is called when there is no active component instance to be associated with.`
      );
    }
    return "";
  }
  function markAsyncBoundary(instance) {
    instance.ids = [instance.ids[0] + instance.ids[2]++ + "-", 0, 0];
  }
  var knownTemplateRefs = /* @__PURE__ */ new WeakSet();
  function useTemplateRef(key) {
    const i = getCurrentInstance();
    const r = shallowRef(null);
    if (i) {
      const refs = i.refs === EMPTY_OBJ ? i.refs = {} : i.refs;
      let desc;
      if ((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable) {
        warn$1(`useTemplateRef('${key}') already exists.`);
      } else {
        Object.defineProperty(refs, key, {
          enumerable: true,
          get: () => r.value,
          set: (val) => r.value = val
        });
      }
    } else if (true) {
      warn$1(
        `useTemplateRef() is called when there is no active component instance to be associated with.`
      );
    }
    const ret = true ? readonly(r) : r;
    if (true) {
      knownTemplateRefs.add(ret);
    }
    return ret;
  }
  function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if (isArray(rawRef)) {
      rawRef.forEach(
        (r, i) => setRef(
          r,
          oldRawRef && (isArray(oldRawRef) ? oldRawRef[i] : oldRawRef),
          parentSuspense,
          vnode,
          isUnmount
        )
      );
      return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) {
      if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) {
        setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
      }
      return;
    }
    const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref2 } = rawRef;
    if (!owner) {
      warn$1(
        `Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.`
      );
      return;
    }
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = toRaw(setupState);
    const canSetSetupRef = setupState === EMPTY_OBJ ? () => false : (key) => {
      if (true) {
        if (hasOwn(rawSetupState, key) && !isRef2(rawSetupState[key])) {
          warn$1(
            `Template ref "${key}" used on a non-ref value. It will not work in the production build.`
          );
        }
        if (knownTemplateRefs.has(rawSetupState[key])) {
          return false;
        }
      }
      return hasOwn(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref2) {
      if (isString(oldRef)) {
        refs[oldRef] = null;
        if (canSetSetupRef(oldRef)) {
          setupState[oldRef] = null;
        }
      } else if (isRef2(oldRef)) {
        oldRef.value = null;
      }
    }
    if (isFunction(ref2)) {
      callWithErrorHandling(ref2, owner, 12, [value, refs]);
    } else {
      const _isString = isString(ref2);
      const _isRef = isRef2(ref2);
      if (_isString || _isRef) {
        const doSet = () => {
          if (rawRef.f) {
            const existing = _isString ? canSetSetupRef(ref2) ? setupState[ref2] : refs[ref2] : ref2.value;
            if (isUnmount) {
              isArray(existing) && remove(existing, refValue);
            } else {
              if (!isArray(existing)) {
                if (_isString) {
                  refs[ref2] = [refValue];
                  if (canSetSetupRef(ref2)) {
                    setupState[ref2] = refs[ref2];
                  }
                } else {
                  ref2.value = [refValue];
                  if (rawRef.k) refs[rawRef.k] = ref2.value;
                }
              } else if (!existing.includes(refValue)) {
                existing.push(refValue);
              }
            }
          } else if (_isString) {
            refs[ref2] = value;
            if (canSetSetupRef(ref2)) {
              setupState[ref2] = value;
            }
          } else if (_isRef) {
            ref2.value = value;
            if (rawRef.k) refs[rawRef.k] = value;
          } else if (true) {
            warn$1("Invalid template ref type:", ref2, `(${typeof ref2})`);
          }
        };
        if (value) {
          doSet.id = -1;
          queuePostRenderEffect(doSet, parentSuspense);
        } else {
          doSet();
        }
      } else if (true) {
        warn$1("Invalid template ref type:", ref2, `(${typeof ref2})`);
      }
    }
  }
  var hasLoggedMismatchError = false;
  var logMismatchError = () => {
    if (hasLoggedMismatchError) {
      return;
    }
    console.error("Hydration completed but contains mismatches.");
    hasLoggedMismatchError = true;
  };
  var isSVGContainer = (container) => container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
  var isMathMLContainer = (container) => container.namespaceURI.includes("MathML");
  var getContainerType = (container) => {
    if (container.nodeType !== 1) return void 0;
    if (isSVGContainer(container)) return "svg";
    if (isMathMLContainer(container)) return "mathml";
    return void 0;
  };
  var isComment = (node) => node.nodeType === 8;
  function createHydrationFunctions(rendererInternals) {
    const {
      mt: mountComponent,
      p: patch,
      o: {
        patchProp: patchProp2,
        createText,
        nextSibling,
        parentNode,
        remove: remove3,
        insert,
        createComment
      }
    } = rendererInternals;
    const hydrate3 = (vnode, container) => {
      if (!container.hasChildNodes()) {
        warn$1(
          `Attempting to hydrate existing markup but container is empty. Performing full mount instead.`
        );
        patch(null, vnode, container);
        flushPostFlushCbs();
        container._vnode = vnode;
        return;
      }
      hydrateNode(container.firstChild, vnode, null, null, null);
      flushPostFlushCbs();
      container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false) => {
      optimized = optimized || !!vnode.dynamicChildren;
      const isFragmentStart = isComment(node) && node.data === "[";
      const onMismatch = () => handleMismatch(
        node,
        vnode,
        parentComponent,
        parentSuspense,
        slotScopeIds,
        isFragmentStart
      );
      const { type, ref: ref2, shapeFlag, patchFlag } = vnode;
      let domType = node.nodeType;
      vnode.el = node;
      if (true) {
        def(node, "__vnode", vnode, true);
        def(node, "__vueParentComponent", parentComponent, true);
      }
      if (patchFlag === -2) {
        optimized = false;
        vnode.dynamicChildren = null;
      }
      let nextNode = null;
      switch (type) {
        case Text:
          if (domType !== 3) {
            if (vnode.children === "") {
              insert(vnode.el = createText(""), parentNode(node), node);
              nextNode = node;
            } else {
              nextNode = onMismatch();
            }
          } else {
            if (node.data !== vnode.children) {
              warn$1(
                `Hydration text mismatch in`,
                node.parentNode,
                `
  - rendered on server: ${JSON.stringify(
                  node.data
                )}
  - expected on client: ${JSON.stringify(vnode.children)}`
              );
              logMismatchError();
              node.data = vnode.children;
            }
            nextNode = nextSibling(node);
          }
          break;
        case Comment:
          if (isTemplateNode2(node)) {
            nextNode = nextSibling(node);
            replaceNode(
              vnode.el = node.content.firstChild,
              node,
              parentComponent
            );
          } else if (domType !== 8 || isFragmentStart) {
            nextNode = onMismatch();
          } else {
            nextNode = nextSibling(node);
          }
          break;
        case Static:
          if (isFragmentStart) {
            node = nextSibling(node);
            domType = node.nodeType;
          }
          if (domType === 1 || domType === 3) {
            nextNode = node;
            const needToAdoptContent = !vnode.children.length;
            for (let i = 0; i < vnode.staticCount; i++) {
              if (needToAdoptContent)
                vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
              if (i === vnode.staticCount - 1) {
                vnode.anchor = nextNode;
              }
              nextNode = nextSibling(nextNode);
            }
            return isFragmentStart ? nextSibling(nextNode) : nextNode;
          } else {
            onMismatch();
          }
          break;
        case Fragment:
          if (!isFragmentStart) {
            nextNode = onMismatch();
          } else {
            nextNode = hydrateFragment(
              node,
              vnode,
              parentComponent,
              parentSuspense,
              slotScopeIds,
              optimized
            );
          }
          break;
        default:
          if (shapeFlag & 1) {
            if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode2(node)) {
              nextNode = onMismatch();
            } else {
              nextNode = hydrateElement(
                node,
                vnode,
                parentComponent,
                parentSuspense,
                slotScopeIds,
                optimized
              );
            }
          } else if (shapeFlag & 6) {
            vnode.slotScopeIds = slotScopeIds;
            const container = parentNode(node);
            if (isFragmentStart) {
              nextNode = locateClosingAnchor(node);
            } else if (isComment(node) && node.data === "teleport start") {
              nextNode = locateClosingAnchor(node, node.data, "teleport end");
            } else {
              nextNode = nextSibling(node);
            }
            mountComponent(
              vnode,
              container,
              null,
              parentComponent,
              parentSuspense,
              getContainerType(container),
              optimized
            );
            if (isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
              let subTree;
              if (isFragmentStart) {
                subTree = createVNode(Fragment);
                subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
              } else {
                subTree = node.nodeType === 3 ? createTextVNode("") : createVNode("div");
              }
              subTree.el = node;
              vnode.component.subTree = subTree;
            }
          } else if (shapeFlag & 64) {
            if (domType !== 8) {
              nextNode = onMismatch();
            } else {
              nextNode = vnode.type.hydrate(
                node,
                vnode,
                parentComponent,
                parentSuspense,
                slotScopeIds,
                optimized,
                rendererInternals,
                hydrateChildren
              );
            }
          } else if (shapeFlag & 128) {
            nextNode = vnode.type.hydrate(
              node,
              vnode,
              parentComponent,
              parentSuspense,
              getContainerType(parentNode(node)),
              slotScopeIds,
              optimized,
              rendererInternals,
              hydrateNode
            );
          } else if (true) {
            warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
          }
      }
      if (ref2 != null) {
        setRef(ref2, null, parentSuspense, vnode);
      }
      return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) => {
      optimized = optimized || !!vnode.dynamicChildren;
      const { type, props, patchFlag, shapeFlag, dirs, transition } = vnode;
      const forcePatch = type === "input" || type === "option";
      if (true) {
        if (dirs) {
          invokeDirectiveHook(vnode, null, parentComponent, "created");
        }
        let needCallTransitionHooks = false;
        if (isTemplateNode2(el)) {
          needCallTransitionHooks = needTransition(
            null,
            // no need check parentSuspense in hydration
            transition
          ) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
          const content = el.content.firstChild;
          if (needCallTransitionHooks) {
            transition.beforeEnter(content);
          }
          replaceNode(content, el, parentComponent);
          vnode.el = el = content;
        }
        if (shapeFlag & 16 && // skip if element has innerHTML / textContent
        !(props && (props.innerHTML || props.textContent))) {
          let next = hydrateChildren(
            el.firstChild,
            vnode,
            el,
            parentComponent,
            parentSuspense,
            slotScopeIds,
            optimized
          );
          let hasWarned2 = false;
          while (next) {
            if (!isMismatchAllowed(
              el,
              1
              /* CHILDREN */
            )) {
              if (!hasWarned2) {
                warn$1(
                  `Hydration children mismatch on`,
                  el,
                  `
Server rendered element contains more child nodes than client vdom.`
                );
                hasWarned2 = true;
              }
              logMismatchError();
            }
            const cur = next;
            next = next.nextSibling;
            remove3(cur);
          }
        } else if (shapeFlag & 8) {
          let clientText = vnode.children;
          if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) {
            clientText = clientText.slice(1);
          }
          if (el.textContent !== clientText) {
            if (!isMismatchAllowed(
              el,
              0
              /* TEXT */
            )) {
              warn$1(
                `Hydration text content mismatch on`,
                el,
                `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`
              );
              logMismatchError();
            }
            el.textContent = vnode.children;
          }
        }
        if (props) {
          if (true) {
            const isCustomElement = el.tagName.includes("-");
            for (const key in props) {
              if (// #11189 skip if this node has directives that have created hooks
              // as it could have mutated the DOM in any possible way
              !(dirs && dirs.some((d) => d.dir.created)) && propHasMismatch(el, key, props[key], vnode, parentComponent)) {
                logMismatchError();
              }
              if (forcePatch && (key.endsWith("value") || key === "indeterminate") || isOn(key) && !isReservedProp(key) || // force hydrate v-bind with .prop modifiers
              key[0] === "." || isCustomElement) {
                patchProp2(el, key, null, props[key], void 0, parentComponent);
              }
            }
          } else if (props.onClick) {
            patchProp2(
              el,
              "onClick",
              null,
              props.onClick,
              void 0,
              parentComponent
            );
          } else if (patchFlag & 4 && isReactive(props.style)) {
            for (const key in props.style) props.style[key];
          }
        }
        let vnodeHooks;
        if (vnodeHooks = props && props.onVnodeBeforeMount) {
          invokeVNodeHook(vnodeHooks, parentComponent, vnode);
        }
        if (dirs) {
          invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        }
        if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) {
          queueEffectWithSuspense(() => {
            vnodeHooks && invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
          }, parentSuspense);
        }
      }
      return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) => {
      optimized = optimized || !!parentVNode.dynamicChildren;
      const children = parentVNode.children;
      const l = children.length;
      let hasWarned2 = false;
      for (let i = 0; i < l; i++) {
        const vnode = optimized ? children[i] : children[i] = normalizeVNode(children[i]);
        const isText2 = vnode.type === Text;
        if (node) {
          if (isText2 && !optimized) {
            if (i + 1 < l && normalizeVNode(children[i + 1]).type === Text) {
              insert(
                createText(
                  node.data.slice(vnode.children.length)
                ),
                container,
                nextSibling(node)
              );
              node.data = vnode.children;
            }
          }
          node = hydrateNode(
            node,
            vnode,
            parentComponent,
            parentSuspense,
            slotScopeIds,
            optimized
          );
        } else if (isText2 && !vnode.children) {
          insert(vnode.el = createText(""), container);
        } else {
          if (!isMismatchAllowed(
            container,
            1
            /* CHILDREN */
          )) {
            if (!hasWarned2) {
              warn$1(
                `Hydration children mismatch on`,
                container,
                `
Server rendered element contains fewer child nodes than client vdom.`
              );
              hasWarned2 = true;
            }
            logMismatchError();
          }
          patch(
            null,
            vnode,
            container,
            null,
            parentComponent,
            parentSuspense,
            getContainerType(container),
            slotScopeIds
          );
        }
      }
      return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) => {
      const { slotScopeIds: fragmentSlotScopeIds } = vnode;
      if (fragmentSlotScopeIds) {
        slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
      }
      const container = parentNode(node);
      const next = hydrateChildren(
        nextSibling(node),
        vnode,
        container,
        parentComponent,
        parentSuspense,
        slotScopeIds,
        optimized
      );
      if (next && isComment(next) && next.data === "]") {
        return nextSibling(vnode.anchor = next);
      } else {
        logMismatchError();
        insert(vnode.anchor = createComment(`]`), container, next);
        return next;
      }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) => {
      if (!isMismatchAllowed(
        node.parentElement,
        1
        /* CHILDREN */
      )) {
        warn$1(
          `Hydration node mismatch:
- rendered on server:`,
          node,
          node.nodeType === 3 ? `(text)` : isComment(node) && node.data === "[" ? `(start of fragment)` : ``,
          `
- expected on client:`,
          vnode.type
        );
        logMismatchError();
      }
      vnode.el = null;
      if (isFragment) {
        const end = locateClosingAnchor(node);
        while (true) {
          const next2 = nextSibling(node);
          if (next2 && next2 !== end) {
            remove3(next2);
          } else {
            break;
          }
        }
      }
      const next = nextSibling(node);
      const container = parentNode(node);
      remove3(node);
      patch(
        null,
        vnode,
        container,
        next,
        parentComponent,
        parentSuspense,
        getContainerType(container),
        slotScopeIds
      );
      if (parentComponent) {
        parentComponent.vnode.el = vnode.el;
        updateHOCHostEl(parentComponent, vnode.el);
      }
      return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]") => {
      let match = 0;
      while (node) {
        node = nextSibling(node);
        if (node && isComment(node)) {
          if (node.data === open) match++;
          if (node.data === close) {
            if (match === 0) {
              return nextSibling(node);
            } else {
              match--;
            }
          }
        }
      }
      return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent) => {
      const parentNode2 = oldNode.parentNode;
      if (parentNode2) {
        parentNode2.replaceChild(newNode, oldNode);
      }
      let parent2 = parentComponent;
      while (parent2) {
        if (parent2.vnode.el === oldNode) {
          parent2.vnode.el = parent2.subTree.el = newNode;
        }
        parent2 = parent2.parent;
      }
    };
    const isTemplateNode2 = (node) => {
      return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [hydrate3, hydrateNode];
  }
  function propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
      actual = el.getAttribute("class");
      expected = normalizeClass(clientValue);
      if (!isSetEqual(toClassSet(actual || ""), toClassSet(expected))) {
        mismatchType = 2;
        mismatchKey = `class`;
      }
    } else if (key === "style") {
      actual = el.getAttribute("style") || "";
      expected = isString(clientValue) ? clientValue : stringifyStyle(normalizeStyle(clientValue));
      const actualMap = toStyleMap(actual);
      const expectedMap = toStyleMap(expected);
      if (vnode.dirs) {
        for (const { dir, value } of vnode.dirs) {
          if (dir.name === "show" && !value) {
            expectedMap.set("display", "none");
          }
        }
      }
      if (instance) {
        resolveCssVars(instance, vnode, expectedMap);
      }
      if (!isMapEqual(actualMap, expectedMap)) {
        mismatchType = 3;
        mismatchKey = "style";
      }
    } else if (el instanceof SVGElement && isKnownSvgAttr(key) || el instanceof HTMLElement && (isBooleanAttr(key) || isKnownHtmlAttr(key))) {
      if (isBooleanAttr(key)) {
        actual = el.hasAttribute(key);
        expected = includeBooleanAttr(clientValue);
      } else if (clientValue == null) {
        actual = el.hasAttribute(key);
        expected = false;
      } else {
        if (el.hasAttribute(key)) {
          actual = el.getAttribute(key);
        } else if (key === "value" && el.tagName === "TEXTAREA") {
          actual = el.value;
        } else {
          actual = false;
        }
        expected = isRenderableAttrValue(clientValue) ? String(clientValue) : false;
      }
      if (actual !== expected) {
        mismatchType = 4;
        mismatchKey = key;
      }
    }
    if (mismatchType != null && !isMismatchAllowed(el, mismatchType)) {
      const format = (v) => v === false ? `(not rendered)` : `${mismatchKey}="${v}"`;
      const preSegment = `Hydration ${MismatchTypeString[mismatchType]} mismatch on`;
      const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
      {
        warn$1(preSegment, el, postSegment);
      }
      return true;
    }
    return false;
  }
  function toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
  }
  function isSetEqual(a, b) {
    if (a.size !== b.size) {
      return false;
    }
    for (const s of a) {
      if (!b.has(s)) {
        return false;
      }
    }
    return true;
  }
  function toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")) {
      let [key, value] = item.split(":");
      key = key.trim();
      value = value && value.trim();
      if (key && value) {
        styleMap.set(key, value);
      }
    }
    return styleMap;
  }
  function isMapEqual(a, b) {
    if (a.size !== b.size) {
      return false;
    }
    for (const [key, value] of a) {
      if (value !== b.get(key)) {
        return false;
      }
    }
    return true;
  }
  function resolveCssVars(instance, vnode, expectedMap) {
    const root2 = instance.subTree;
    if (instance.getCssVars && (vnode === root2 || root2 && root2.type === Fragment && root2.children.includes(vnode))) {
      const cssVars = instance.getCssVars();
      for (const key in cssVars) {
        expectedMap.set(
          `--${getEscapedCssVarName(key, false)}`,
          String(cssVars[key])
        );
      }
    }
    if (vnode === root2 && instance.parent) {
      resolveCssVars(instance.parent, instance.vnode, expectedMap);
    }
  }
  var allowMismatchAttr = "data-allow-mismatch";
  var MismatchTypeString = {
    [
      0
      /* TEXT */
    ]: "text",
    [
      1
      /* CHILDREN */
    ]: "children",
    [
      2
      /* CLASS */
    ]: "class",
    [
      3
      /* STYLE */
    ]: "style",
    [
      4
      /* ATTRIBUTE */
    ]: "attribute"
  };
  function isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 || allowedType === 1) {
      while (el && !el.hasAttribute(allowMismatchAttr)) {
        el = el.parentElement;
      }
    }
    const allowedAttr = el && el.getAttribute(allowMismatchAttr);
    if (allowedAttr == null) {
      return false;
    } else if (allowedAttr === "") {
      return true;
    } else {
      const list3 = allowedAttr.split(",");
      if (allowedType === 0 && list3.includes("children")) {
        return true;
      }
      return allowedAttr.split(",").includes(MismatchTypeString[allowedType]);
    }
  }
  var requestIdleCallback2 = getGlobalThis().requestIdleCallback || ((cb) => setTimeout(cb, 1));
  var cancelIdleCallback = getGlobalThis().cancelIdleCallback || ((id) => clearTimeout(id));
  var hydrateOnIdle = (timeout = 1e4) => (hydrate3) => {
    const id = requestIdleCallback2(hydrate3, { timeout });
    return () => cancelIdleCallback(id);
  };
  function elementIsVisibleInViewport(el) {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
  }
  var hydrateOnVisible = (opts) => (hydrate3, forEach2) => {
    const ob = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        ob.disconnect();
        hydrate3();
        break;
      }
    }, opts);
    forEach2((el) => {
      if (!(el instanceof Element)) return;
      if (elementIsVisibleInViewport(el)) {
        hydrate3();
        ob.disconnect();
        return false;
      }
      ob.observe(el);
    });
    return () => ob.disconnect();
  };
  var hydrateOnMediaQuery = (query) => (hydrate3) => {
    if (query) {
      const mql = matchMedia(query);
      if (mql.matches) {
        hydrate3();
      } else {
        mql.addEventListener("change", hydrate3, { once: true });
        return () => mql.removeEventListener("change", hydrate3);
      }
    }
  };
  var hydrateOnInteraction = (interactions = []) => (hydrate3, forEach2) => {
    if (isString(interactions)) interactions = [interactions];
    let hasHydrated = false;
    const doHydrate = (e) => {
      if (!hasHydrated) {
        hasHydrated = true;
        teardown();
        hydrate3();
        e.target.dispatchEvent(new e.constructor(e.type, e));
      }
    };
    const teardown = () => {
      forEach2((el) => {
        for (const i of interactions) {
          el.removeEventListener(i, doHydrate);
        }
      });
    };
    forEach2((el) => {
      for (const i of interactions) {
        el.addEventListener(i, doHydrate, { once: true });
      }
    });
    return teardown;
  };
  function forEachElement(node, cb) {
    if (isComment(node) && node.data === "[") {
      let depth = 1;
      let next = node.nextSibling;
      while (next) {
        if (next.nodeType === 1) {
          const result = cb(next);
          if (result === false) {
            break;
          }
        } else if (isComment(next)) {
          if (next.data === "]") {
            if (--depth === 0) break;
          } else if (next.data === "[") {
            depth++;
          }
        }
        next = next.nextSibling;
      }
    } else {
      cb(node);
    }
  }
  var isAsyncWrapper = (i) => !!i.type.__asyncLoader;
  // @__NO_SIDE_EFFECTS__
  function defineAsyncComponent(source) {
    if (isFunction(source)) {
      source = { loader: source };
    }
    const {
      loader,
      loadingComponent,
      errorComponent,
      delay = 200,
      hydrate: hydrateStrategy,
      timeout,
      // undefined = never times out
      suspensible = true,
      onError: userOnError
    } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = () => {
      retries++;
      pendingRequest = null;
      return load();
    };
    const load = () => {
      let thisRequest;
      return pendingRequest || (thisRequest = pendingRequest = loader().catch((err) => {
        err = err instanceof Error ? err : new Error(String(err));
        if (userOnError) {
          return new Promise((resolve2, reject) => {
            const userRetry = () => resolve2(retry());
            const userFail = () => reject(err);
            userOnError(err, userRetry, userFail, retries + 1);
          });
        } else {
          throw err;
        }
      }).then((comp) => {
        if (thisRequest !== pendingRequest && pendingRequest) {
          return pendingRequest;
        }
        if (!comp) {
          warn$1(
            `Async component loader resolved to undefined. If you are using retry(), make sure to return its return value.`
          );
        }
        if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) {
          comp = comp.default;
        }
        if (comp && !isObject(comp) && !isFunction(comp)) {
          throw new Error(`Invalid async component load result: ${comp}`);
        }
        resolvedComp = comp;
        return comp;
      }));
    };
    return /* @__PURE__ */ defineComponent({
      name: "AsyncComponentWrapper",
      __asyncLoader: load,
      __asyncHydrate(el, instance, hydrate3) {
        const doHydrate = hydrateStrategy ? () => {
          const teardown = hydrateStrategy(
            hydrate3,
            (cb) => forEachElement(el, cb)
          );
          if (teardown) {
            (instance.bum || (instance.bum = [])).push(teardown);
          }
        } : hydrate3;
        if (resolvedComp) {
          doHydrate();
        } else {
          load().then(() => !instance.isUnmounted && doHydrate());
        }
      },
      get __asyncResolved() {
        return resolvedComp;
      },
      setup() {
        const instance = currentInstance;
        markAsyncBoundary(instance);
        if (resolvedComp) {
          return () => createInnerComp(resolvedComp, instance);
        }
        const onError = (err) => {
          pendingRequest = null;
          handleError(
            err,
            instance,
            13,
            !errorComponent
          );
        };
        if (suspensible && instance.suspense || isInSSRComponentSetup) {
          return load().then((comp) => {
            return () => createInnerComp(comp, instance);
          }).catch((err) => {
            onError(err);
            return () => errorComponent ? createVNode(errorComponent, {
              error: err
            }) : null;
          });
        }
        const loaded = ref(false);
        const error2 = ref();
        const delayed = ref(!!delay);
        if (delay) {
          setTimeout(() => {
            delayed.value = false;
          }, delay);
        }
        if (timeout != null) {
          setTimeout(() => {
            if (!loaded.value && !error2.value) {
              const err = new Error(
                `Async component timed out after ${timeout}ms.`
              );
              onError(err);
              error2.value = err;
            }
          }, timeout);
        }
        load().then(() => {
          loaded.value = true;
          if (instance.parent && isKeepAlive(instance.parent.vnode)) {
            instance.parent.update();
          }
        }).catch((err) => {
          onError(err);
          error2.value = err;
        });
        return () => {
          if (loaded.value && resolvedComp) {
            return createInnerComp(resolvedComp, instance);
          } else if (error2.value && errorComponent) {
            return createVNode(errorComponent, {
              error: error2.value
            });
          } else if (loadingComponent && !delayed.value) {
            return createVNode(loadingComponent);
          }
        };
      }
    });
  }
  function createInnerComp(comp, parent2) {
    const { ref: ref2, props, children, ce } = parent2.vnode;
    const vnode = createVNode(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent2.vnode.ce;
    return vnode;
  }
  var isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
  var KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
      include: [String, RegExp, Array],
      exclude: [String, RegExp, Array],
      max: [String, Number]
    },
    setup(props, { slots }) {
      const instance = getCurrentInstance();
      const sharedContext = instance.ctx;
      if (!sharedContext.renderer) {
        return () => {
          const children = slots.default && slots.default();
          return children && children.length === 1 ? children[0] : children;
        };
      }
      const cache = /* @__PURE__ */ new Map();
      const keys = /* @__PURE__ */ new Set();
      let current = null;
      if (true) {
        instance.__v_cache = cache;
      }
      const parentSuspense = instance.suspense;
      const {
        renderer: {
          p: patch,
          m: move,
          um: _unmount,
          o: { createElement }
        }
      } = sharedContext;
      const storageContainer = createElement("div");
      sharedContext.activate = (vnode, container, anchor, namespace, optimized) => {
        const instance2 = vnode.component;
        move(vnode, container, anchor, 0, parentSuspense);
        patch(
          instance2.vnode,
          vnode,
          container,
          anchor,
          instance2,
          parentSuspense,
          namespace,
          vnode.slotScopeIds,
          optimized
        );
        queuePostRenderEffect(() => {
          instance2.isDeactivated = false;
          if (instance2.a) {
            invokeArrayFns(instance2.a);
          }
          const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
          if (vnodeHook) {
            invokeVNodeHook(vnodeHook, instance2.parent, vnode);
          }
        }, parentSuspense);
        if (true) {
          devtoolsComponentAdded(instance2);
        }
      };
      sharedContext.deactivate = (vnode) => {
        const instance2 = vnode.component;
        invalidateMount(instance2.m);
        invalidateMount(instance2.a);
        move(vnode, storageContainer, null, 1, parentSuspense);
        queuePostRenderEffect(() => {
          if (instance2.da) {
            invokeArrayFns(instance2.da);
          }
          const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
          if (vnodeHook) {
            invokeVNodeHook(vnodeHook, instance2.parent, vnode);
          }
          instance2.isDeactivated = true;
        }, parentSuspense);
        if (true) {
          devtoolsComponentAdded(instance2);
        }
      };
      function unmount(vnode) {
        resetShapeFlag(vnode);
        _unmount(vnode, instance, parentSuspense, true);
      }
      function pruneCache(filter) {
        cache.forEach((vnode, key) => {
          const name = getComponentName(vnode.type);
          if (name && !filter(name)) {
            pruneCacheEntry(key);
          }
        });
      }
      function pruneCacheEntry(key) {
        const cached = cache.get(key);
        if (cached && (!current || !isSameVNodeType(cached, current))) {
          unmount(cached);
        } else if (current) {
          resetShapeFlag(current);
        }
        cache.delete(key);
        keys.delete(key);
      }
      watch2(
        () => [props.include, props.exclude],
        ([include, exclude]) => {
          include && pruneCache((name) => matches(include, name));
          exclude && pruneCache((name) => !matches(exclude, name));
        },
        // prune post-render after `current` has been updated
        { flush: "post", deep: true }
      );
      let pendingCacheKey = null;
      const cacheSubtree = () => {
        if (pendingCacheKey != null) {
          if (isSuspense(instance.subTree.type)) {
            queuePostRenderEffect(() => {
              cache.set(pendingCacheKey, getInnerChild(instance.subTree));
            }, instance.subTree.suspense);
          } else {
            cache.set(pendingCacheKey, getInnerChild(instance.subTree));
          }
        }
      };
      onMounted(cacheSubtree);
      onUpdated(cacheSubtree);
      onBeforeUnmount(() => {
        cache.forEach((cached) => {
          const { subTree, suspense } = instance;
          const vnode = getInnerChild(subTree);
          if (cached.type === vnode.type && cached.key === vnode.key) {
            resetShapeFlag(vnode);
            const da = vnode.component.da;
            da && queuePostRenderEffect(da, suspense);
            return;
          }
          unmount(cached);
        });
      });
      return () => {
        pendingCacheKey = null;
        if (!slots.default) {
          return current = null;
        }
        const children = slots.default();
        const rawVNode = children[0];
        if (children.length > 1) {
          if (true) {
            warn$1(`KeepAlive should contain exactly one component child.`);
          }
          current = null;
          return children;
        } else if (!isVNode(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
          current = null;
          return rawVNode;
        }
        let vnode = getInnerChild(rawVNode);
        if (vnode.type === Comment) {
          current = null;
          return vnode;
        }
        const comp = vnode.type;
        const name = getComponentName(
          isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp
        );
        const { include, exclude, max: max3 } = props;
        if (include && (!name || !matches(include, name)) || exclude && name && matches(exclude, name)) {
          vnode.shapeFlag &= ~256;
          current = vnode;
          return rawVNode;
        }
        const key = vnode.key == null ? comp : vnode.key;
        const cachedVNode = cache.get(key);
        if (vnode.el) {
          vnode = cloneVNode(vnode);
          if (rawVNode.shapeFlag & 128) {
            rawVNode.ssContent = vnode;
          }
        }
        pendingCacheKey = key;
        if (cachedVNode) {
          vnode.el = cachedVNode.el;
          vnode.component = cachedVNode.component;
          if (vnode.transition) {
            setTransitionHooks(vnode, vnode.transition);
          }
          vnode.shapeFlag |= 512;
          keys.delete(key);
          keys.add(key);
        } else {
          keys.add(key);
          if (max3 && keys.size > parseInt(max3, 10)) {
            pruneCacheEntry(keys.values().next().value);
          }
        }
        vnode.shapeFlag |= 256;
        current = vnode;
        return isSuspense(rawVNode.type) ? rawVNode : vnode;
      };
    }
  };
  var KeepAlive = KeepAliveImpl;
  function matches(pattern, name) {
    if (isArray(pattern)) {
      return pattern.some((p2) => matches(p2, name));
    } else if (isString(pattern)) {
      return pattern.split(",").includes(name);
    } else if (isRegExp(pattern)) {
      pattern.lastIndex = 0;
      return pattern.test(name);
    }
    return false;
  }
  function onActivated(hook, target2) {
    registerKeepAliveHook(hook, "a", target2);
  }
  function onDeactivated(hook, target2) {
    registerKeepAliveHook(hook, "da", target2);
  }
  function registerKeepAliveHook(hook, type, target2 = currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = () => {
      let current = target2;
      while (current) {
        if (current.isDeactivated) {
          return;
        }
        current = current.parent;
      }
      return hook();
    });
    injectHook(type, wrappedHook, target2);
    if (target2) {
      let current = target2.parent;
      while (current && current.parent) {
        if (isKeepAlive(current.parent.vnode)) {
          injectToKeepAliveRoot(wrappedHook, type, target2, current);
        }
        current = current.parent;
      }
    }
  }
  function injectToKeepAliveRoot(hook, type, target2, keepAliveRoot) {
    const injected = injectHook(
      type,
      hook,
      keepAliveRoot,
      true
      /* prepend */
    );
    onUnmounted(() => {
      remove(keepAliveRoot[type], injected);
    }, target2);
  }
  function resetShapeFlag(vnode) {
    vnode.shapeFlag &= ~256;
    vnode.shapeFlag &= ~512;
  }
  function getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
  }
  function injectHook(type, hook, target2 = currentInstance, prepend = false) {
    if (target2) {
      const hooks = target2[type] || (target2[type] = []);
      const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
        pauseTracking();
        const reset3 = setCurrentInstance(target2);
        const res = callWithAsyncErrorHandling(hook, target2, type, args);
        reset3();
        resetTracking();
        return res;
      });
      if (prepend) {
        hooks.unshift(wrappedHook);
      } else {
        hooks.push(wrappedHook);
      }
      return wrappedHook;
    } else if (true) {
      const apiName = toHandlerKey(ErrorTypeStrings$1[type].replace(/ hook$/, ""));
      warn$1(
        `${apiName} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
      );
    }
  }
  var createHook = (lifecycle) => (hook, target2 = currentInstance) => {
    if (!isInSSRComponentSetup || lifecycle === "sp") {
      injectHook(lifecycle, (...args) => hook(...args), target2);
    }
  };
  var onBeforeMount = createHook("bm");
  var onMounted = createHook("m");
  var onBeforeUpdate = createHook(
    "bu"
  );
  var onUpdated = createHook("u");
  var onBeforeUnmount = createHook(
    "bum"
  );
  var onUnmounted = createHook("um");
  var onServerPrefetch = createHook(
    "sp"
  );
  var onRenderTriggered = createHook("rtg");
  var onRenderTracked = createHook("rtc");
  function onErrorCaptured(hook, target2 = currentInstance) {
    injectHook("ec", hook, target2);
  }
  var COMPONENTS = "components";
  var DIRECTIVES = "directives";
  function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
  }
  var NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
  function resolveDynamicComponent(component) {
    if (isString(component)) {
      return resolveAsset(COMPONENTS, component, false) || component;
    } else {
      return component || NULL_DYNAMIC_COMPONENT;
    }
  }
  function resolveDirective(name) {
    return resolveAsset(DIRECTIVES, name);
  }
  function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
      const Component = instance.type;
      if (type === COMPONENTS) {
        const selfName = getComponentName(
          Component,
          false
        );
        if (selfName && (selfName === name || selfName === camelize(name) || selfName === capitalize(camelize(name)))) {
          return Component;
        }
      }
      const res = (
        // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) || // global registration
        resolve(instance.appContext[type], name)
      );
      if (!res && maybeSelfReference) {
        return Component;
      }
      if (warnMissing && !res) {
        const extra = type === COMPONENTS ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : ``;
        warn$1(`Failed to resolve ${type.slice(0, -1)}: ${name}${extra}`);
      }
      return res;
    } else if (true) {
      warn$1(
        `resolve${capitalize(type.slice(0, -1))} can only be used in render() or setup().`
      );
    }
  }
  function resolve(registry2, name) {
    return registry2 && (registry2[name] || registry2[camelize(name)] || registry2[capitalize(camelize(name))]);
  }
  function renderList(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = isArray(source);
    if (sourceIsArray || isString(source)) {
      const sourceIsReactiveArray = sourceIsArray && isReactive(source);
      let needsWrap = false;
      if (sourceIsReactiveArray) {
        needsWrap = !isShallow(source);
        source = shallowReadArray(source);
      }
      ret = new Array(source.length);
      for (let i = 0, l = source.length; i < l; i++) {
        ret[i] = renderItem(
          needsWrap ? toReactive(source[i]) : source[i],
          i,
          void 0,
          cached && cached[i]
        );
      }
    } else if (typeof source === "number") {
      if (!Number.isInteger(source)) {
        warn$1(`The v-for range expect an integer value but got ${source}.`);
      }
      ret = new Array(source);
      for (let i = 0; i < source; i++) {
        ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
      }
    } else if (isObject(source)) {
      if (source[Symbol.iterator]) {
        ret = Array.from(
          source,
          (item, i) => renderItem(item, i, void 0, cached && cached[i])
        );
      } else {
        const keys = Object.keys(source);
        ret = new Array(keys.length);
        for (let i = 0, l = keys.length; i < l; i++) {
          const key = keys[i];
          ret[i] = renderItem(source[key], key, i, cached && cached[i]);
        }
      }
    } else {
      ret = [];
    }
    if (cache) {
      cache[index] = ret;
    }
    return ret;
  }
  function createSlots(slots, dynamicSlots) {
    for (let i = 0; i < dynamicSlots.length; i++) {
      const slot = dynamicSlots[i];
      if (isArray(slot)) {
        for (let j = 0; j < slot.length; j++) {
          slots[slot[j].name] = slot[j].fn;
        }
      } else if (slot) {
        slots[slot.name] = slot.key ? (...args) => {
          const res = slot.fn(...args);
          if (res) res.key = slot.key;
          return res;
        } : slot.fn;
      }
    }
    return slots;
  }
  function renderSlot(slots, name, props = {}, fallback, noSlotted) {
    if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
      if (name !== "default") props.name = name;
      return openBlock(), createBlock(
        Fragment,
        null,
        [createVNode("slot", props, fallback && fallback())],
        64
      );
    }
    let slot = slots[name];
    if (slot && slot.length > 1) {
      warn$1(
        `SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.`
      );
      slot = () => [];
    }
    if (slot && slot._c) {
      slot._d = false;
    }
    openBlock();
    const validSlotContent = slot && ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = createBlock(
      Fragment,
      {
        key: (slotKey && !isSymbol(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
      },
      validSlotContent || (fallback ? fallback() : []),
      validSlotContent && slots._ === 1 ? 64 : -2
    );
    if (!noSlotted && rendered.scopeId) {
      rendered.slotScopeIds = [rendered.scopeId + "-s"];
    }
    if (slot && slot._c) {
      slot._d = true;
    }
    return rendered;
  }
  function ensureValidVNode(vnodes) {
    return vnodes.some((child) => {
      if (!isVNode(child)) return true;
      if (child.type === Comment) return false;
      if (child.type === Fragment && !ensureValidVNode(child.children))
        return false;
      return true;
    }) ? vnodes : null;
  }
  function toHandlers(obj, preserveCaseIfNecessary) {
    const ret = {};
    if (!isObject(obj)) {
      warn$1(`v-on with no argument expects an object value.`);
      return ret;
    }
    for (const key in obj) {
      ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : toHandlerKey(key)] = obj[key];
    }
    return ret;
  }
  var getPublicInstance = (i) => {
    if (!i) return null;
    if (isStatefulComponent(i)) return getComponentPublicInstance(i);
    return getPublicInstance(i.parent);
  };
  var publicPropertiesMap = (
    // Move PURE marker to new line to workaround compiler discarding it
    // due to type annotation
    /* @__PURE__ */ extend(/* @__PURE__ */ Object.create(null), {
      $: (i) => i,
      $el: (i) => i.vnode.el,
      $data: (i) => i.data,
      $props: (i) => true ? shallowReadonly(i.props) : i.props,
      $attrs: (i) => true ? shallowReadonly(i.attrs) : i.attrs,
      $slots: (i) => true ? shallowReadonly(i.slots) : i.slots,
      $refs: (i) => true ? shallowReadonly(i.refs) : i.refs,
      $parent: (i) => getPublicInstance(i.parent),
      $root: (i) => getPublicInstance(i.root),
      $host: (i) => i.ce,
      $emit: (i) => i.emit,
      $options: (i) => __VUE_OPTIONS_API__ ? resolveMergedOptions(i) : i.type,
      $forceUpdate: (i) => i.f || (i.f = () => {
        queueJob(i.update);
      }),
      $nextTick: (i) => i.n || (i.n = nextTick.bind(i.proxy)),
      $watch: (i) => __VUE_OPTIONS_API__ ? instanceWatch.bind(i) : NOOP
    })
  );
  var isReservedPrefix = (key) => key === "_" || key === "$";
  var hasSetupBinding = (state, key) => state !== EMPTY_OBJ && !state.__isScriptSetup && hasOwn(state, key);
  var PublicInstanceProxyHandlers = {
    get({ _: instance }, key) {
      if (key === "__v_skip") {
        return true;
      }
      const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
      if (key === "__isVue") {
        return true;
      }
      let normalizedProps;
      if (key[0] !== "$") {
        const n = accessCache[key];
        if (n !== void 0) {
          switch (n) {
            case 1:
              return setupState[key];
            case 2:
              return data[key];
            case 4:
              return ctx[key];
            case 3:
              return props[key];
          }
        } else if (hasSetupBinding(setupState, key)) {
          accessCache[key] = 1;
          return setupState[key];
        } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
          accessCache[key] = 2;
          return data[key];
        } else if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (normalizedProps = instance.propsOptions[0]) && hasOwn(normalizedProps, key)
        ) {
          accessCache[key] = 3;
          return props[key];
        } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
          accessCache[key] = 4;
          return ctx[key];
        } else if (!__VUE_OPTIONS_API__ || shouldCacheAccess) {
          accessCache[key] = 0;
        }
      }
      const publicGetter = publicPropertiesMap[key];
      let cssModule, globalProperties;
      if (publicGetter) {
        if (key === "$attrs") {
          track(instance.attrs, "get", "");
          markAttrsAccessed();
        } else if (key === "$slots") {
          track(instance, "get", key);
        }
        return publicGetter(instance);
      } else if (
        // css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])
      ) {
        return cssModule;
      } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
        accessCache[key] = 4;
        return ctx[key];
      } else if (
        // global properties
        globalProperties = appContext.config.globalProperties, hasOwn(globalProperties, key)
      ) {
        {
          return globalProperties[key];
        }
      } else if (currentRenderingInstance && (!isString(key) || // #1091 avoid internal isRef/isVNode checks on component instance leading
      // to infinite warning loop
      key.indexOf("__v") !== 0)) {
        if (data !== EMPTY_OBJ && isReservedPrefix(key[0]) && hasOwn(data, key)) {
          warn$1(
            `Property ${JSON.stringify(
              key
            )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
          );
        } else if (instance === currentRenderingInstance) {
          warn$1(
            `Property ${JSON.stringify(key)} was accessed during render but is not defined on instance.`
          );
        }
      }
    },
    set({ _: instance }, key, value) {
      const { data, setupState, ctx } = instance;
      if (hasSetupBinding(setupState, key)) {
        setupState[key] = value;
        return true;
      } else if (setupState.__isScriptSetup && hasOwn(setupState, key)) {
        warn$1(`Cannot mutate <script setup> binding "${key}" from Options API.`);
        return false;
      } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
        data[key] = value;
        return true;
      } else if (hasOwn(instance.props, key)) {
        warn$1(`Attempting to mutate prop "${key}". Props are readonly.`);
        return false;
      }
      if (key[0] === "$" && key.slice(1) in instance) {
        warn$1(
          `Attempting to mutate public property "${key}". Properties starting with $ are reserved and readonly.`
        );
        return false;
      } else {
        if (key in instance.appContext.config.globalProperties) {
          Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            value
          });
        } else {
          ctx[key] = value;
        }
      }
      return true;
    },
    has({
      _: { data, setupState, accessCache, ctx, appContext, propsOptions }
    }, key) {
      let normalizedProps;
      return !!accessCache[key] || data !== EMPTY_OBJ && hasOwn(data, key) || hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && hasOwn(normalizedProps, key) || hasOwn(ctx, key) || hasOwn(publicPropertiesMap, key) || hasOwn(appContext.config.globalProperties, key);
    },
    defineProperty(target2, key, descriptor) {
      if (descriptor.get != null) {
        target2._.accessCache[key] = 0;
      } else if (hasOwn(descriptor, "value")) {
        this.set(target2, key, descriptor.value, null);
      }
      return Reflect.defineProperty(target2, key, descriptor);
    }
  };
  if (true) {
    PublicInstanceProxyHandlers.ownKeys = (target2) => {
      warn$1(
        `Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.`
      );
      return Reflect.ownKeys(target2);
    };
  }
  var RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ extend({}, PublicInstanceProxyHandlers, {
    get(target2, key) {
      if (key === Symbol.unscopables) {
        return;
      }
      return PublicInstanceProxyHandlers.get(target2, key, target2);
    },
    has(_, key) {
      const has2 = key[0] !== "_" && !isGloballyAllowed(key);
      if (!has2 && PublicInstanceProxyHandlers.has(_, key)) {
        warn$1(
          `Property ${JSON.stringify(
            key
          )} should not start with _ which is a reserved prefix for Vue internals.`
        );
      }
      return has2;
    }
  });
  function createDevRenderContext(instance) {
    const target2 = {};
    Object.defineProperty(target2, `_`, {
      configurable: true,
      enumerable: false,
      get: () => instance
    });
    Object.keys(publicPropertiesMap).forEach((key) => {
      Object.defineProperty(target2, key, {
        configurable: true,
        enumerable: false,
        get: () => publicPropertiesMap[key](instance),
        // intercepted by the proxy so no need for implementation,
        // but needed to prevent set errors
        set: NOOP
      });
    });
    return target2;
  }
  function exposePropsOnRenderContext(instance) {
    const {
      ctx,
      propsOptions: [propsOptions]
    } = instance;
    if (propsOptions) {
      Object.keys(propsOptions).forEach((key) => {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => instance.props[key],
          set: NOOP
        });
      });
    }
  }
  function exposeSetupStateOnRenderContext(instance) {
    const { ctx, setupState } = instance;
    Object.keys(toRaw(setupState)).forEach((key) => {
      if (!setupState.__isScriptSetup) {
        if (isReservedPrefix(key[0])) {
          warn$1(
            `setup() return property ${JSON.stringify(
              key
            )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
          );
          return;
        }
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => setupState[key],
          set: NOOP
        });
      }
    });
  }
  var warnRuntimeUsage = (method) => warn$1(
    `${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`
  );
  function defineProps() {
    if (true) {
      warnRuntimeUsage(`defineProps`);
    }
    return null;
  }
  function defineEmits() {
    if (true) {
      warnRuntimeUsage(`defineEmits`);
    }
    return null;
  }
  function defineExpose(exposed) {
    if (true) {
      warnRuntimeUsage(`defineExpose`);
    }
  }
  function defineOptions(options3) {
    if (true) {
      warnRuntimeUsage(`defineOptions`);
    }
  }
  function defineSlots() {
    if (true) {
      warnRuntimeUsage(`defineSlots`);
    }
    return null;
  }
  function defineModel() {
    if (true) {
      warnRuntimeUsage("defineModel");
    }
  }
  function withDefaults(props, defaults) {
    if (true) {
      warnRuntimeUsage(`withDefaults`);
    }
    return null;
  }
  function useSlots() {
    return getContext().slots;
  }
  function useAttrs() {
    return getContext().attrs;
  }
  function getContext() {
    const i = getCurrentInstance();
    if (!i) {
      warn$1(`useContext() called without active instance.`);
    }
    return i.setupContext || (i.setupContext = createSetupContext(i));
  }
  function normalizePropsOrEmits(props) {
    return isArray(props) ? props.reduce(
      (normalized, p2) => (normalized[p2] = null, normalized),
      {}
    ) : props;
  }
  function mergeDefaults(raw3, defaults) {
    const props = normalizePropsOrEmits(raw3);
    for (const key in defaults) {
      if (key.startsWith("__skip")) continue;
      let opt = props[key];
      if (opt) {
        if (isArray(opt) || isFunction(opt)) {
          opt = props[key] = { type: opt, default: defaults[key] };
        } else {
          opt.default = defaults[key];
        }
      } else if (opt === null) {
        opt = props[key] = { default: defaults[key] };
      } else if (true) {
        warn$1(`props default key "${key}" has no corresponding declaration.`);
      }
      if (opt && defaults[`__skip_${key}`]) {
        opt.skipFactory = true;
      }
    }
    return props;
  }
  function mergeModels(a, b) {
    if (!a || !b) return a || b;
    if (isArray(a) && isArray(b)) return a.concat(b);
    return extend({}, normalizePropsOrEmits(a), normalizePropsOrEmits(b));
  }
  function createPropsRestProxy(props, excludedKeys) {
    const ret = {};
    for (const key in props) {
      if (!excludedKeys.includes(key)) {
        Object.defineProperty(ret, key, {
          enumerable: true,
          get: () => props[key]
        });
      }
    }
    return ret;
  }
  function withAsyncContext(getAwaitable) {
    const ctx = getCurrentInstance();
    if (!ctx) {
      warn$1(
        `withAsyncContext called without active current instance. This is likely a bug.`
      );
    }
    let awaitable = getAwaitable();
    unsetCurrentInstance();
    if (isPromise(awaitable)) {
      awaitable = awaitable.catch((e) => {
        setCurrentInstance(ctx);
        throw e;
      });
    }
    return [awaitable, () => setCurrentInstance(ctx)];
  }
  function createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key) => {
      if (cache[key]) {
        warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
      } else {
        cache[key] = type;
      }
    };
  }
  var shouldCacheAccess = true;
  function applyOptions(instance) {
    const options3 = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options3.beforeCreate) {
      callHook(options3.beforeCreate, instance, "bc");
    }
    const {
      // state
      data: dataOptions,
      computed: computedOptions,
      methods,
      watch: watchOptions,
      provide: provideOptions,
      inject: injectOptions,
      // lifecycle
      created,
      beforeMount,
      mounted,
      beforeUpdate,
      updated,
      activated,
      deactivated,
      beforeDestroy,
      beforeUnmount,
      destroyed,
      unmounted,
      render: render2,
      renderTracked,
      renderTriggered,
      errorCaptured,
      serverPrefetch,
      // public API
      expose,
      inheritAttrs,
      // assets
      components,
      directives,
      filters
    } = options3;
    const checkDuplicateProperties = true ? createDuplicateChecker() : null;
    if (true) {
      const [propsOptions] = instance.propsOptions;
      if (propsOptions) {
        for (const key in propsOptions) {
          checkDuplicateProperties("Props", key);
        }
      }
    }
    if (injectOptions) {
      resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    }
    if (methods) {
      for (const key in methods) {
        const methodHandler = methods[key];
        if (isFunction(methodHandler)) {
          if (true) {
            Object.defineProperty(ctx, key, {
              value: methodHandler.bind(publicThis),
              configurable: true,
              enumerable: true,
              writable: true
            });
          } else {
            ctx[key] = methodHandler.bind(publicThis);
          }
          if (true) {
            checkDuplicateProperties("Methods", key);
          }
        } else if (true) {
          warn$1(
            `Method "${key}" has type "${typeof methodHandler}" in the component definition. Did you reference the function correctly?`
          );
        }
      }
    }
    if (dataOptions) {
      if (!isFunction(dataOptions)) {
        warn$1(
          `The data option must be a function. Plain object usage is no longer supported.`
        );
      }
      const data = dataOptions.call(publicThis, publicThis);
      if (isPromise(data)) {
        warn$1(
          `data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.`
        );
      }
      if (!isObject(data)) {
        warn$1(`data() should return an object.`);
      } else {
        instance.data = reactive(data);
        if (true) {
          for (const key in data) {
            checkDuplicateProperties("Data", key);
            if (!isReservedPrefix(key[0])) {
              Object.defineProperty(ctx, key, {
                configurable: true,
                enumerable: true,
                get: () => data[key],
                set: NOOP
              });
            }
          }
        }
      }
    }
    shouldCacheAccess = true;
    if (computedOptions) {
      for (const key in computedOptions) {
        const opt = computedOptions[key];
        const get2 = isFunction(opt) ? opt.bind(publicThis, publicThis) : isFunction(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
        if (get2 === NOOP) {
          warn$1(`Computed property "${key}" has no getter.`);
        }
        const set = !isFunction(opt) && isFunction(opt.set) ? opt.set.bind(publicThis) : true ? () => {
          warn$1(
            `Write operation failed: computed property "${key}" is readonly.`
          );
        } : NOOP;
        const c = computed2({
          get: get2,
          set
        });
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => c.value,
          set: (v) => c.value = v
        });
        if (true) {
          checkDuplicateProperties("Computed", key);
        }
      }
    }
    if (watchOptions) {
      for (const key in watchOptions) {
        createWatcher(watchOptions[key], ctx, publicThis, key);
      }
    }
    if (provideOptions) {
      const provides = isFunction(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
      Reflect.ownKeys(provides).forEach((key) => {
        provide(key, provides[key]);
      });
    }
    if (created) {
      callHook(created, instance, "c");
    }
    function registerLifecycleHook(register3, hook) {
      if (isArray(hook)) {
        hook.forEach((_hook) => register3(_hook.bind(publicThis)));
      } else if (hook) {
        register3(hook.bind(publicThis));
      }
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if (isArray(expose)) {
      if (expose.length) {
        const exposed = instance.exposed || (instance.exposed = {});
        expose.forEach((key) => {
          Object.defineProperty(exposed, key, {
            get: () => publicThis[key],
            set: (val) => publicThis[key] = val
          });
        });
      } else if (!instance.exposed) {
        instance.exposed = {};
      }
    }
    if (render2 && instance.render === NOOP) {
      instance.render = render2;
    }
    if (inheritAttrs != null) {
      instance.inheritAttrs = inheritAttrs;
    }
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) {
      markAsyncBoundary(instance);
    }
  }
  function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP) {
    if (isArray(injectOptions)) {
      injectOptions = normalizeInject(injectOptions);
    }
    for (const key in injectOptions) {
      const opt = injectOptions[key];
      let injected;
      if (isObject(opt)) {
        if ("default" in opt) {
          injected = inject(
            opt.from || key,
            opt.default,
            true
          );
        } else {
          injected = inject(opt.from || key);
        }
      } else {
        injected = inject(opt);
      }
      if (isRef2(injected)) {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => injected.value,
          set: (v) => injected.value = v
        });
      } else {
        ctx[key] = injected;
      }
      if (true) {
        checkDuplicateProperties("Inject", key);
      }
    }
  }
  function callHook(hook, instance, type) {
    callWithAsyncErrorHandling(
      isArray(hook) ? hook.map((h2) => h2.bind(instance.proxy)) : hook.bind(instance.proxy),
      instance,
      type
    );
  }
  function createWatcher(raw3, ctx, publicThis, key) {
    let getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
    if (isString(raw3)) {
      const handler = ctx[raw3];
      if (isFunction(handler)) {
        {
          watch2(getter, handler);
        }
      } else if (true) {
        warn$1(`Invalid watch handler specified by key "${raw3}"`, handler);
      }
    } else if (isFunction(raw3)) {
      {
        watch2(getter, raw3.bind(publicThis));
      }
    } else if (isObject(raw3)) {
      if (isArray(raw3)) {
        raw3.forEach((r) => createWatcher(r, ctx, publicThis, key));
      } else {
        const handler = isFunction(raw3.handler) ? raw3.handler.bind(publicThis) : ctx[raw3.handler];
        if (isFunction(handler)) {
          watch2(getter, handler, raw3);
        } else if (true) {
          warn$1(`Invalid watch handler specified by key "${raw3.handler}"`, handler);
        }
      }
    } else if (true) {
      warn$1(`Invalid watch option: "${key}"`, raw3);
    }
  }
  function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const {
      mixins: globalMixins,
      optionsCache: cache,
      config: { optionMergeStrategies }
    } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) {
      resolved = cached;
    } else if (!globalMixins.length && !mixins && !extendsOptions) {
      {
        resolved = base;
      }
    } else {
      resolved = {};
      if (globalMixins.length) {
        globalMixins.forEach(
          (m) => mergeOptions(resolved, m, optionMergeStrategies, true)
        );
      }
      mergeOptions(resolved, base, optionMergeStrategies);
    }
    if (isObject(base)) {
      cache.set(base, resolved);
    }
    return resolved;
  }
  function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) {
      mergeOptions(to, extendsOptions, strats, true);
    }
    if (mixins) {
      mixins.forEach(
        (m) => mergeOptions(to, m, strats, true)
      );
    }
    for (const key in from) {
      if (asMixin && key === "expose") {
        warn$1(
          `"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.`
        );
      } else {
        const strat = internalOptionMergeStrats[key] || strats && strats[key];
        to[key] = strat ? strat(to[key], from[key]) : from[key];
      }
    }
    return to;
  }
  var internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeEmitsOrPropsOptions,
    emits: mergeEmitsOrPropsOptions,
    // objects
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    // lifecycle
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    // assets
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    // watch
    watch: mergeWatchOptions,
    // provide / inject
    provide: mergeDataFn,
    inject: mergeInject
  };
  function mergeDataFn(to, from) {
    if (!from) {
      return to;
    }
    if (!to) {
      return from;
    }
    return function mergedDataFn() {
      return extend(
        isFunction(to) ? to.call(this, this) : to,
        isFunction(from) ? from.call(this, this) : from
      );
    };
  }
  function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
  }
  function normalizeInject(raw3) {
    if (isArray(raw3)) {
      const res = {};
      for (let i = 0; i < raw3.length; i++) {
        res[raw3[i]] = raw3[i];
      }
      return res;
    }
    return raw3;
  }
  function mergeAsArray(to, from) {
    return to ? [...new Set([].concat(to, from))] : from;
  }
  function mergeObjectOptions(to, from) {
    return to ? extend(/* @__PURE__ */ Object.create(null), to, from) : from;
  }
  function mergeEmitsOrPropsOptions(to, from) {
    if (to) {
      if (isArray(to) && isArray(from)) {
        return [.../* @__PURE__ */ new Set([...to, ...from])];
      }
      return extend(
        /* @__PURE__ */ Object.create(null),
        normalizePropsOrEmits(to),
        normalizePropsOrEmits(from != null ? from : {})
      );
    } else {
      return from;
    }
  }
  function mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = extend(/* @__PURE__ */ Object.create(null), to);
    for (const key in from) {
      merged[key] = mergeAsArray(to[key], from[key]);
    }
    return merged;
  }
  function createAppContext() {
    return {
      app: null,
      config: {
        isNativeTag: NO,
        performance: false,
        globalProperties: {},
        optionMergeStrategies: {},
        errorHandler: void 0,
        warnHandler: void 0,
        compilerOptions: {}
      },
      mixins: [],
      components: {},
      directives: {},
      provides: /* @__PURE__ */ Object.create(null),
      optionsCache: /* @__PURE__ */ new WeakMap(),
      propsCache: /* @__PURE__ */ new WeakMap(),
      emitsCache: /* @__PURE__ */ new WeakMap()
    };
  }
  var uid$1 = 0;
  function createAppAPI(render2, hydrate3) {
    return function createApp2(rootComponent, rootProps = null) {
      if (!isFunction(rootComponent)) {
        rootComponent = extend({}, rootComponent);
      }
      if (rootProps != null && !isObject(rootProps)) {
        warn$1(`root props passed to app.mount() must be an object.`);
        rootProps = null;
      }
      const context = createAppContext();
      const installedPlugins = /* @__PURE__ */ new WeakSet();
      const pluginCleanupFns = [];
      let isMounted = false;
      const app2 = context.app = {
        _uid: uid$1++,
        _component: rootComponent,
        _props: rootProps,
        _container: null,
        _context: context,
        _instance: null,
        version,
        get config() {
          return context.config;
        },
        set config(v) {
          if (true) {
            warn$1(
              `app.config cannot be replaced. Modify individual options instead.`
            );
          }
        },
        use(plugin2, ...options3) {
          if (installedPlugins.has(plugin2)) {
            warn$1(`Plugin has already been applied to target app.`);
          } else if (plugin2 && isFunction(plugin2.install)) {
            installedPlugins.add(plugin2);
            plugin2.install(app2, ...options3);
          } else if (isFunction(plugin2)) {
            installedPlugins.add(plugin2);
            plugin2(app2, ...options3);
          } else if (true) {
            warn$1(
              `A plugin must either be a function or an object with an "install" function.`
            );
          }
          return app2;
        },
        mixin(mixin) {
          if (__VUE_OPTIONS_API__) {
            if (!context.mixins.includes(mixin)) {
              context.mixins.push(mixin);
            } else if (true) {
              warn$1(
                "Mixin has already been applied to target app" + (mixin.name ? `: ${mixin.name}` : "")
              );
            }
          } else if (true) {
            warn$1("Mixins are only available in builds supporting Options API");
          }
          return app2;
        },
        component(name, component) {
          if (true) {
            validateComponentName(name, context.config);
          }
          if (!component) {
            return context.components[name];
          }
          if (context.components[name]) {
            warn$1(`Component "${name}" has already been registered in target app.`);
          }
          context.components[name] = component;
          return app2;
        },
        directive(name, directive) {
          if (true) {
            validateDirectiveName(name);
          }
          if (!directive) {
            return context.directives[name];
          }
          if (context.directives[name]) {
            warn$1(`Directive "${name}" has already been registered in target app.`);
          }
          context.directives[name] = directive;
          return app2;
        },
        mount(rootContainer, isHydrate, namespace) {
          if (!isMounted) {
            if (rootContainer.__vue_app__) {
              warn$1(
                `There is already an app instance mounted on the host container.
 If you want to mount another app on the same host container, you need to unmount the previous app by calling \`app.unmount()\` first.`
              );
            }
            const vnode = app2._ceVNode || createVNode(rootComponent, rootProps);
            vnode.appContext = context;
            if (namespace === true) {
              namespace = "svg";
            } else if (namespace === false) {
              namespace = void 0;
            }
            if (true) {
              context.reload = () => {
                render2(
                  cloneVNode(vnode),
                  rootContainer,
                  namespace
                );
              };
            }
            if (isHydrate && hydrate3) {
              hydrate3(vnode, rootContainer);
            } else {
              render2(vnode, rootContainer, namespace);
            }
            isMounted = true;
            app2._container = rootContainer;
            rootContainer.__vue_app__ = app2;
            if (true) {
              app2._instance = vnode.component;
              devtoolsInitApp(app2, version);
            }
            return getComponentPublicInstance(vnode.component);
          } else if (true) {
            warn$1(
              `App has already been mounted.
If you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. \`const createMyApp = () => createApp(App)\``
            );
          }
        },
        onUnmount(cleanupFn) {
          if (typeof cleanupFn !== "function") {
            warn$1(
              `Expected function as first argument to app.onUnmount(), but got ${typeof cleanupFn}`
            );
          }
          pluginCleanupFns.push(cleanupFn);
        },
        unmount() {
          if (isMounted) {
            callWithAsyncErrorHandling(
              pluginCleanupFns,
              app2._instance,
              16
            );
            render2(null, app2._container);
            if (true) {
              app2._instance = null;
              devtoolsUnmountApp(app2);
            }
            delete app2._container.__vue_app__;
          } else if (true) {
            warn$1(`Cannot unmount an app that is not mounted.`);
          }
        },
        provide(key, value) {
          if (key in context.provides) {
            warn$1(
              `App already provides property with key "${String(key)}". It will be overwritten with the new value.`
            );
          }
          context.provides[key] = value;
          return app2;
        },
        runWithContext(fn) {
          const lastApp = currentApp;
          currentApp = app2;
          try {
            return fn();
          } finally {
            currentApp = lastApp;
          }
        }
      };
      return app2;
    };
  }
  var currentApp = null;
  function provide(key, value) {
    if (!currentInstance) {
      if (true) {
        warn$1(`provide() can only be used inside setup().`);
      }
    } else {
      let provides = currentInstance.provides;
      const parentProvides = currentInstance.parent && currentInstance.parent.provides;
      if (parentProvides === provides) {
        provides = currentInstance.provides = Object.create(parentProvides);
      }
      provides[key] = value;
    }
  }
  function inject(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = currentInstance || currentRenderingInstance;
    if (instance || currentApp) {
      const provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
      if (provides && key in provides) {
        return provides[key];
      } else if (arguments.length > 1) {
        return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
      } else if (true) {
        warn$1(`injection "${String(key)}" not found.`);
      }
    } else if (true) {
      warn$1(`inject() can only be used inside setup() or functional components.`);
    }
  }
  function hasInjectionContext() {
    return !!(currentInstance || currentRenderingInstance || currentApp);
  }
  var internalObjectProto = {};
  var createInternalObject = () => Object.create(internalObjectProto);
  var isInternalObject = (obj) => Object.getPrototypeOf(obj) === internalObjectProto;
  function initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for (const key in instance.propsOptions[0]) {
      if (!(key in props)) {
        props[key] = void 0;
      }
    }
    if (true) {
      validateProps(rawProps || {}, props, instance);
    }
    if (isStateful) {
      instance.props = isSSR ? props : shallowReactive(props);
    } else {
      if (!instance.type.props) {
        instance.props = attrs;
      } else {
        instance.props = props;
      }
    }
    instance.attrs = attrs;
  }
  function isInHmrContext(instance) {
    while (instance) {
      if (instance.type.__hmrId) return true;
      instance = instance.parent;
    }
  }
  function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const {
      props,
      attrs,
      vnode: { patchFlag }
    } = instance;
    const rawCurrentProps = toRaw(props);
    const [options3] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (
      // always force full diff in dev
      // - #1942 if hmr is enabled with sfc component
      // - vite#872 non-sfc component used by sfc component
      !isInHmrContext(instance) && (optimized || patchFlag > 0) && !(patchFlag & 16)
    ) {
      if (patchFlag & 8) {
        const propsToUpdate = instance.vnode.dynamicProps;
        for (let i = 0; i < propsToUpdate.length; i++) {
          let key = propsToUpdate[i];
          if (isEmitListener(instance.emitsOptions, key)) {
            continue;
          }
          const value = rawProps[key];
          if (options3) {
            if (hasOwn(attrs, key)) {
              if (value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
              }
            } else {
              const camelizedKey = camelize(key);
              props[camelizedKey] = resolvePropValue(
                options3,
                rawCurrentProps,
                camelizedKey,
                value,
                instance,
                false
              );
            }
          } else {
            if (value !== attrs[key]) {
              attrs[key] = value;
              hasAttrsChanged = true;
            }
          }
        }
      }
    } else {
      if (setFullProps(instance, rawProps, props, attrs)) {
        hasAttrsChanged = true;
      }
      let kebabKey;
      for (const key in rawCurrentProps) {
        if (!rawProps || // for camelCase
        !hasOwn(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = hyphenate(key)) === key || !hasOwn(rawProps, kebabKey))) {
          if (options3) {
            if (rawPrevProps && // for camelCase
            (rawPrevProps[key] !== void 0 || // for kebab-case
            rawPrevProps[kebabKey] !== void 0)) {
              props[key] = resolvePropValue(
                options3,
                rawCurrentProps,
                key,
                void 0,
                instance,
                true
              );
            }
          } else {
            delete props[key];
          }
        }
      }
      if (attrs !== rawCurrentProps) {
        for (const key in attrs) {
          if (!rawProps || !hasOwn(rawProps, key) && true) {
            delete attrs[key];
            hasAttrsChanged = true;
          }
        }
      }
    }
    if (hasAttrsChanged) {
      trigger(instance.attrs, "set", "");
    }
    if (true) {
      validateProps(rawProps || {}, props, instance);
    }
  }
  function setFullProps(instance, rawProps, props, attrs) {
    const [options3, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) {
      for (let key in rawProps) {
        if (isReservedProp(key)) {
          continue;
        }
        const value = rawProps[key];
        let camelKey;
        if (options3 && hasOwn(options3, camelKey = camelize(key))) {
          if (!needCastKeys || !needCastKeys.includes(camelKey)) {
            props[camelKey] = value;
          } else {
            (rawCastValues || (rawCastValues = {}))[camelKey] = value;
          }
        } else if (!isEmitListener(instance.emitsOptions, key)) {
          if (!(key in attrs) || value !== attrs[key]) {
            attrs[key] = value;
            hasAttrsChanged = true;
          }
        }
      }
    }
    if (needCastKeys) {
      const rawCurrentProps = toRaw(props);
      const castValues = rawCastValues || EMPTY_OBJ;
      for (let i = 0; i < needCastKeys.length; i++) {
        const key = needCastKeys[i];
        props[key] = resolvePropValue(
          options3,
          rawCurrentProps,
          key,
          castValues[key],
          instance,
          !hasOwn(castValues, key)
        );
      }
    }
    return hasAttrsChanged;
  }
  function resolvePropValue(options3, props, key, value, instance, isAbsent) {
    const opt = options3[key];
    if (opt != null) {
      const hasDefault = hasOwn(opt, "default");
      if (hasDefault && value === void 0) {
        const defaultValue = opt.default;
        if (opt.type !== Function && !opt.skipFactory && isFunction(defaultValue)) {
          const { propsDefaults } = instance;
          if (key in propsDefaults) {
            value = propsDefaults[key];
          } else {
            const reset3 = setCurrentInstance(instance);
            value = propsDefaults[key] = defaultValue.call(
              null,
              props
            );
            reset3();
          }
        } else {
          value = defaultValue;
        }
        if (instance.ce) {
          instance.ce._setProp(key, value);
        }
      }
      if (opt[
        0
        /* shouldCast */
      ]) {
        if (isAbsent && !hasDefault) {
          value = false;
        } else if (opt[
          1
          /* shouldCastTrue */
        ] && (value === "" || value === hyphenate(key))) {
          value = true;
        }
      }
    }
    return value;
  }
  var mixinPropsCache = /* @__PURE__ */ new WeakMap();
  function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) {
      return cached;
    }
    const raw3 = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !isFunction(comp)) {
      const extendProps = (raw22) => {
        hasExtends = true;
        const [props, keys] = normalizePropsOptions(raw22, appContext, true);
        extend(normalized, props);
        if (keys) needCastKeys.push(...keys);
      };
      if (!asMixin && appContext.mixins.length) {
        appContext.mixins.forEach(extendProps);
      }
      if (comp.extends) {
        extendProps(comp.extends);
      }
      if (comp.mixins) {
        comp.mixins.forEach(extendProps);
      }
    }
    if (!raw3 && !hasExtends) {
      if (isObject(comp)) {
        cache.set(comp, EMPTY_ARR);
      }
      return EMPTY_ARR;
    }
    if (isArray(raw3)) {
      for (let i = 0; i < raw3.length; i++) {
        if (!isString(raw3[i])) {
          warn$1(`props must be strings when using array syntax.`, raw3[i]);
        }
        const normalizedKey = camelize(raw3[i]);
        if (validatePropName(normalizedKey)) {
          normalized[normalizedKey] = EMPTY_OBJ;
        }
      }
    } else if (raw3) {
      if (!isObject(raw3)) {
        warn$1(`invalid props options`, raw3);
      }
      for (const key in raw3) {
        const normalizedKey = camelize(key);
        if (validatePropName(normalizedKey)) {
          const opt = raw3[key];
          const prop = normalized[normalizedKey] = isArray(opt) || isFunction(opt) ? { type: opt } : extend({}, opt);
          const propType = prop.type;
          let shouldCast = false;
          let shouldCastTrue = true;
          if (isArray(propType)) {
            for (let index = 0; index < propType.length; ++index) {
              const type = propType[index];
              const typeName = isFunction(type) && type.name;
              if (typeName === "Boolean") {
                shouldCast = true;
                break;
              } else if (typeName === "String") {
                shouldCastTrue = false;
              }
            }
          } else {
            shouldCast = isFunction(propType) && propType.name === "Boolean";
          }
          prop[
            0
            /* shouldCast */
          ] = shouldCast;
          prop[
            1
            /* shouldCastTrue */
          ] = shouldCastTrue;
          if (shouldCast || hasOwn(prop, "default")) {
            needCastKeys.push(normalizedKey);
          }
        }
      }
    }
    const res = [normalized, needCastKeys];
    if (isObject(comp)) {
      cache.set(comp, res);
    }
    return res;
  }
  function validatePropName(key) {
    if (key[0] !== "$" && !isReservedProp(key)) {
      return true;
    } else if (true) {
      warn$1(`Invalid prop name: "${key}" is a reserved property.`);
    }
    return false;
  }
  function getType(ctor) {
    if (ctor === null) {
      return "null";
    }
    if (typeof ctor === "function") {
      return ctor.name || "";
    } else if (typeof ctor === "object") {
      const name = ctor.constructor && ctor.constructor.name;
      return name || "";
    }
    return "";
  }
  function validateProps(rawProps, props, instance) {
    const resolvedValues = toRaw(props);
    const options3 = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key) => camelize(key));
    for (const key in options3) {
      let opt = options3[key];
      if (opt == null) continue;
      validateProp(
        key,
        resolvedValues[key],
        opt,
        true ? shallowReadonly(resolvedValues) : resolvedValues,
        !camelizePropsKey.includes(key)
      );
    }
  }
  function validateProp(name, value, prop, props, isAbsent) {
    const { type, required: required3, validator, skipCheck } = prop;
    if (required3 && isAbsent) {
      warn$1('Missing required prop: "' + name + '"');
      return;
    }
    if (value == null && !required3) {
      return;
    }
    if (type != null && type !== true && !skipCheck) {
      let isValid = false;
      const types = isArray(type) ? type : [type];
      const expectedTypes = [];
      for (let i = 0; i < types.length && !isValid; i++) {
        const { valid, expectedType } = assertType(value, types[i]);
        expectedTypes.push(expectedType || "");
        isValid = valid;
      }
      if (!isValid) {
        warn$1(getInvalidTypeMessage(name, value, expectedTypes));
        return;
      }
    }
    if (validator && !validator(value, props)) {
      warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
    }
  }
  var isSimpleType = /* @__PURE__ */ makeMap(
    "String,Number,Boolean,Function,Symbol,BigInt"
  );
  function assertType(value, type) {
    let valid;
    const expectedType = getType(type);
    if (expectedType === "null") {
      valid = value === null;
    } else if (isSimpleType(expectedType)) {
      const t = typeof value;
      valid = t === expectedType.toLowerCase();
      if (!valid && t === "object") {
        valid = value instanceof type;
      }
    } else if (expectedType === "Object") {
      valid = isObject(value);
    } else if (expectedType === "Array") {
      valid = isArray(value);
    } else {
      valid = value instanceof type;
    }
    return {
      valid,
      expectedType
    };
  }
  function getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) {
      return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    }
    let message3 = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map(capitalize).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = toRawType(value);
    const expectedValue = styleValue(value, expectedType);
    const receivedValue = styleValue(value, receivedType);
    if (expectedTypes.length === 1 && isExplicable(expectedType) && !isBoolean(expectedType, receivedType)) {
      message3 += ` with value ${expectedValue}`;
    }
    message3 += `, got ${receivedType} `;
    if (isExplicable(receivedType)) {
      message3 += `with value ${receivedValue}.`;
    }
    return message3;
  }
  function styleValue(value, type) {
    if (type === "String") {
      return `"${value}"`;
    } else if (type === "Number") {
      return `${Number(value)}`;
    } else {
      return `${value}`;
    }
  }
  function isExplicable(type) {
    const explicitTypes = ["string", "number", "boolean"];
    return explicitTypes.some((elem) => type.toLowerCase() === elem);
  }
  function isBoolean(...args) {
    return args.some((elem) => elem.toLowerCase() === "boolean");
  }
  var isInternalKey = (key) => key[0] === "_" || key === "$stable";
  var normalizeSlotValue = (value) => isArray(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
  var normalizeSlot = (key, rawSlot, ctx) => {
    if (rawSlot._n) {
      return rawSlot;
    }
    const normalized = withCtx((...args) => {
      if (currentInstance && (!ctx || ctx.root === currentInstance.root)) {
        warn$1(
          `Slot "${key}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
        );
      }
      return normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
  };
  var normalizeObjectSlots = (rawSlots, slots, instance) => {
    const ctx = rawSlots._ctx;
    for (const key in rawSlots) {
      if (isInternalKey(key)) continue;
      const value = rawSlots[key];
      if (isFunction(value)) {
        slots[key] = normalizeSlot(key, value, ctx);
      } else if (value != null) {
        if (true) {
          warn$1(
            `Non-function value encountered for slot "${key}". Prefer function slots for better performance.`
          );
        }
        const normalized = normalizeSlotValue(value);
        slots[key] = () => normalized;
      }
    }
  };
  var normalizeVNodeSlots = (instance, children) => {
    if (!isKeepAlive(instance.vnode) && true) {
      warn$1(
        `Non-function value encountered for default slot. Prefer function slots for better performance.`
      );
    }
    const normalized = normalizeSlotValue(children);
    instance.slots.default = () => normalized;
  };
  var assignSlots = (slots, children, optimized) => {
    for (const key in children) {
      if (optimized || key !== "_") {
        slots[key] = children[key];
      }
    }
  };
  var initSlots = (instance, children, optimized) => {
    const slots = instance.slots = createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
      const type = children._;
      if (type) {
        assignSlots(slots, children, optimized);
        if (optimized) {
          def(slots, "_", type, true);
        }
      } else {
        normalizeObjectSlots(children, slots);
      }
    } else if (children) {
      normalizeVNodeSlots(instance, children);
    }
  };
  var updateSlots = (instance, children, optimized) => {
    const { vnode, slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = EMPTY_OBJ;
    if (vnode.shapeFlag & 32) {
      const type = children._;
      if (type) {
        if (isHmrUpdating) {
          assignSlots(slots, children, optimized);
          trigger(instance, "set", "$slots");
        } else if (optimized && type === 1) {
          needDeletionCheck = false;
        } else {
          assignSlots(slots, children, optimized);
        }
      } else {
        needDeletionCheck = !children.$stable;
        normalizeObjectSlots(children, slots);
      }
      deletionComparisonTarget = children;
    } else if (children) {
      normalizeVNodeSlots(instance, children);
      deletionComparisonTarget = { default: 1 };
    }
    if (needDeletionCheck) {
      for (const key in slots) {
        if (!isInternalKey(key) && deletionComparisonTarget[key] == null) {
          delete slots[key];
        }
      }
    }
  };
  var supported;
  var perf;
  function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
      perf.mark(`vue-${type}-${instance.uid}`);
    }
    if (true) {
      devtoolsPerfStart(instance, type, isSupported() ? perf.now() : Date.now());
    }
  }
  function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
      const startTag = `vue-${type}-${instance.uid}`;
      const endTag = startTag + `:end`;
      perf.mark(endTag);
      perf.measure(
        `<${formatComponentName(instance, instance.type)}> ${type}`,
        startTag,
        endTag
      );
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
    }
    if (true) {
      devtoolsPerfEnd(instance, type, isSupported() ? perf.now() : Date.now());
    }
  }
  function isSupported() {
    if (supported !== void 0) {
      return supported;
    }
    if (typeof window !== "undefined" && window.performance) {
      supported = true;
      perf = window.performance;
    } else {
      supported = false;
    }
    return supported;
  }
  function initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") {
      needWarn.push(`__VUE_OPTIONS_API__`);
      getGlobalThis().__VUE_OPTIONS_API__ = true;
    }
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") {
      needWarn.push(`__VUE_PROD_DEVTOOLS__`);
      getGlobalThis().__VUE_PROD_DEVTOOLS__ = false;
    }
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") {
      needWarn.push(`__VUE_PROD_HYDRATION_MISMATCH_DETAILS__`);
      getGlobalThis().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
    }
    if (needWarn.length) {
      const multi = needWarn.length > 1;
      console.warn(
        `Feature flag${multi ? `s` : ``} ${needWarn.join(", ")} ${multi ? `are` : `is`} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
      );
    }
  }
  var queuePostRenderEffect = queueEffectWithSuspense;
  function createRenderer(options3) {
    return baseCreateRenderer(options3);
  }
  function createHydrationRenderer(options3) {
    return baseCreateRenderer(options3, createHydrationFunctions);
  }
  function baseCreateRenderer(options3, createHydrationFns) {
    {
      initFeatureFlags();
    }
    const target2 = getGlobalThis();
    target2.__VUE__ = true;
    if (true) {
      setDevtoolsHook$1(target2.__VUE_DEVTOOLS_GLOBAL_HOOK__, target2);
    }
    const {
      insert: hostInsert,
      remove: hostRemove,
      patchProp: hostPatchProp,
      createElement: hostCreateElement,
      createText: hostCreateText,
      createComment: hostCreateComment,
      setText: hostSetText,
      setElementText: hostSetElementText,
      parentNode: hostParentNode,
      nextSibling: hostNextSibling,
      setScopeId: hostSetScopeId = NOOP,
      insertStaticContent: hostInsertStaticContent
    } = options3;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace = void 0, slotScopeIds = null, optimized = isHmrUpdating ? false : !!n2.dynamicChildren) => {
      if (n1 === n2) {
        return;
      }
      if (n1 && !isSameVNodeType(n1, n2)) {
        anchor = getNextHostNode(n1);
        unmount(n1, parentComponent, parentSuspense, true);
        n1 = null;
      }
      if (n2.patchFlag === -2) {
        optimized = false;
        n2.dynamicChildren = null;
      }
      const { type, ref: ref2, shapeFlag } = n2;
      switch (type) {
        case Text:
          processText(n1, n2, container, anchor);
          break;
        case Comment:
          processCommentNode(n1, n2, container, anchor);
          break;
        case Static:
          if (n1 == null) {
            mountStaticNode(n2, container, anchor, namespace);
          } else if (true) {
            patchStaticNode(n1, n2, container, namespace);
          }
          break;
        case Fragment:
          processFragment(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          break;
        default:
          if (shapeFlag & 1) {
            processElement(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else if (shapeFlag & 6) {
            processComponent(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else if (shapeFlag & 64) {
            type.process(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized,
              internals
            );
          } else if (shapeFlag & 128) {
            type.process(
              n1,
              n2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized,
              internals
            );
          } else if (true) {
            warn$1("Invalid VNode type:", type, `(${typeof type})`);
          }
      }
      if (ref2 != null && parentComponent) {
        setRef(ref2, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
      }
    };
    const processText = (n1, n2, container, anchor) => {
      if (n1 == null) {
        hostInsert(
          n2.el = hostCreateText(n2.children),
          container,
          anchor
        );
      } else {
        const el = n2.el = n1.el;
        if (n2.children !== n1.children) {
          hostSetText(el, n2.children);
        }
      }
    };
    const processCommentNode = (n1, n2, container, anchor) => {
      if (n1 == null) {
        hostInsert(
          n2.el = hostCreateComment(n2.children || ""),
          container,
          anchor
        );
      } else {
        n2.el = n1.el;
      }
    };
    const mountStaticNode = (n2, container, anchor, namespace) => {
      [n2.el, n2.anchor] = hostInsertStaticContent(
        n2.children,
        container,
        anchor,
        namespace,
        n2.el,
        n2.anchor
      );
    };
    const patchStaticNode = (n1, n2, container, namespace) => {
      if (n2.children !== n1.children) {
        const anchor = hostNextSibling(n1.anchor);
        removeStaticNode(n1);
        [n2.el, n2.anchor] = hostInsertStaticContent(
          n2.children,
          container,
          anchor,
          namespace
        );
      } else {
        n2.el = n1.el;
        n2.anchor = n1.anchor;
      }
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
      let next;
      while (el && el !== anchor) {
        next = hostNextSibling(el);
        hostInsert(el, container, nextSibling);
        el = next;
      }
      hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor }) => {
      let next;
      while (el && el !== anchor) {
        next = hostNextSibling(el);
        hostRemove(el);
        el = next;
      }
      hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      if (n2.type === "svg") {
        namespace = "svg";
      } else if (n2.type === "math") {
        namespace = "mathml";
      }
      if (n1 == null) {
        mountElement(
          n2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        patchElement(
          n1,
          n2,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      let el;
      let vnodeHook;
      const { props, shapeFlag, transition, dirs } = vnode;
      el = vnode.el = hostCreateElement(
        vnode.type,
        namespace,
        props && props.is,
        props
      );
      if (shapeFlag & 8) {
        hostSetElementText(el, vnode.children);
      } else if (shapeFlag & 16) {
        mountChildren(
          vnode.children,
          el,
          null,
          parentComponent,
          parentSuspense,
          resolveChildrenNamespace(vnode, namespace),
          slotScopeIds,
          optimized
        );
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "created");
      }
      setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
      if (props) {
        for (const key in props) {
          if (key !== "value" && !isReservedProp(key)) {
            hostPatchProp(el, key, null, props[key], namespace, parentComponent);
          }
        }
        if ("value" in props) {
          hostPatchProp(el, "value", null, props.value, namespace);
        }
        if (vnodeHook = props.onVnodeBeforeMount) {
          invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
      }
      if (true) {
        def(el, "__vnode", vnode, true);
        def(el, "__vueParentComponent", parentComponent, true);
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
      }
      const needCallTransitionHooks = needTransition(parentSuspense, transition);
      if (needCallTransitionHooks) {
        transition.beforeEnter(el);
      }
      hostInsert(el, container, anchor);
      if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
          needCallTransitionHooks && transition.enter(el);
          dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
      }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
      if (scopeId) {
        hostSetScopeId(el, scopeId);
      }
      if (slotScopeIds) {
        for (let i = 0; i < slotScopeIds.length; i++) {
          hostSetScopeId(el, slotScopeIds[i]);
        }
      }
      if (parentComponent) {
        let subTree = parentComponent.subTree;
        if (subTree.patchFlag > 0 && subTree.patchFlag & 2048) {
          subTree = filterSingleRoot(subTree.children) || subTree;
        }
        if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
          const parentVNode = parentComponent.vnode;
          setScopeId(
            el,
            parentVNode,
            parentVNode.scopeId,
            parentVNode.slotScopeIds,
            parentComponent.parent
          );
        }
      }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0) => {
      for (let i = start; i < children.length; i++) {
        const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
        patch(
          null,
          child,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      const el = n2.el = n1.el;
      if (true) {
        el.__vnode = n2;
      }
      let { patchFlag, dynamicChildren, dirs } = n2;
      patchFlag |= n1.patchFlag & 16;
      const oldProps = n1.props || EMPTY_OBJ;
      const newProps = n2.props || EMPTY_OBJ;
      let vnodeHook;
      parentComponent && toggleRecurse(parentComponent, false);
      if (vnodeHook = newProps.onVnodeBeforeUpdate) {
        invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
      }
      if (dirs) {
        invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
      }
      parentComponent && toggleRecurse(parentComponent, true);
      if (isHmrUpdating) {
        patchFlag = 0;
        optimized = false;
        dynamicChildren = null;
      }
      if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) {
        hostSetElementText(el, "");
      }
      if (dynamicChildren) {
        patchBlockChildren(
          n1.dynamicChildren,
          dynamicChildren,
          el,
          parentComponent,
          parentSuspense,
          resolveChildrenNamespace(n2, namespace),
          slotScopeIds
        );
        if (true) {
          traverseStaticChildren(n1, n2);
        }
      } else if (!optimized) {
        patchChildren(
          n1,
          n2,
          el,
          null,
          parentComponent,
          parentSuspense,
          resolveChildrenNamespace(n2, namespace),
          slotScopeIds,
          false
        );
      }
      if (patchFlag > 0) {
        if (patchFlag & 16) {
          patchProps(el, oldProps, newProps, parentComponent, namespace);
        } else {
          if (patchFlag & 2) {
            if (oldProps.class !== newProps.class) {
              hostPatchProp(el, "class", null, newProps.class, namespace);
            }
          }
          if (patchFlag & 4) {
            hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
          }
          if (patchFlag & 8) {
            const propsToUpdate = n2.dynamicProps;
            for (let i = 0; i < propsToUpdate.length; i++) {
              const key = propsToUpdate[i];
              const prev = oldProps[key];
              const next = newProps[key];
              if (next !== prev || key === "value") {
                hostPatchProp(el, key, prev, next, namespace, parentComponent);
              }
            }
          }
        }
        if (patchFlag & 1) {
          if (n1.children !== n2.children) {
            hostSetElementText(el, n2.children);
          }
        }
      } else if (!optimized && dynamicChildren == null) {
        patchProps(el, oldProps, newProps, parentComponent, namespace);
      }
      if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
          dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
      }
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) => {
      for (let i = 0; i < newChildren.length; i++) {
        const oldVNode = oldChildren[i];
        const newVNode = newChildren[i];
        const container = (
          // oldVNode may be an errored async setup() component inside Suspense
          // which will not have a mounted element
          oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
          // of the Fragment itself so it can move its children.
          (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
          // which also requires the correct parent container
          !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
          oldVNode.shapeFlag & (6 | 64)) ? hostParentNode(oldVNode.el) : (
            // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer
          )
        );
        patch(
          oldVNode,
          newVNode,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          true
        );
      }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace) => {
      if (oldProps !== newProps) {
        if (oldProps !== EMPTY_OBJ) {
          for (const key in oldProps) {
            if (!isReservedProp(key) && !(key in newProps)) {
              hostPatchProp(
                el,
                key,
                oldProps[key],
                null,
                namespace,
                parentComponent
              );
            }
          }
        }
        for (const key in newProps) {
          if (isReservedProp(key)) continue;
          const next = newProps[key];
          const prev = oldProps[key];
          if (next !== prev && key !== "value") {
            hostPatchProp(el, key, prev, next, namespace, parentComponent);
          }
        }
        if ("value" in newProps) {
          hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
      }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
      const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
      let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
      if (
        // #5523 dev root fragment may inherit directives
        isHmrUpdating || patchFlag & 2048
      ) {
        patchFlag = 0;
        optimized = false;
        dynamicChildren = null;
      }
      if (fragmentSlotScopeIds) {
        slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
      }
      if (n1 == null) {
        hostInsert(fragmentStartAnchor, container, anchor);
        hostInsert(fragmentEndAnchor, container, anchor);
        mountChildren(
          // #10007
          // such fragment like `<></>` will be compiled into
          // a fragment which doesn't have a children.
          // In this case fallback to an empty array
          n2.children || [],
          container,
          fragmentEndAnchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
          patchBlockChildren(
            n1.dynamicChildren,
            dynamicChildren,
            container,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds
          );
          if (true) {
            traverseStaticChildren(n1, n2);
          } else if (
            // #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree
          ) {
            traverseStaticChildren(
              n1,
              n2,
              true
              /* shallow */
            );
          }
        } else {
          patchChildren(
            n1,
            n2,
            container,
            fragmentEndAnchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        }
      }
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      n2.slotScopeIds = slotScopeIds;
      if (n1 == null) {
        if (n2.shapeFlag & 512) {
          parentComponent.ctx.activate(
            n2,
            container,
            anchor,
            namespace,
            optimized
          );
        } else {
          mountComponent(
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            optimized
          );
        }
      } else {
        updateComponent(n1, n2, optimized);
      }
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) => {
      const instance = initialVNode.component = createComponentInstance(
        initialVNode,
        parentComponent,
        parentSuspense
      );
      if (instance.type.__hmrId) {
        registerHMR(instance);
      }
      if (true) {
        pushWarningContext(initialVNode);
        startMeasure(instance, `mount`);
      }
      if (isKeepAlive(initialVNode)) {
        instance.ctx.renderer = internals;
      }
      {
        if (true) {
          startMeasure(instance, `init`);
        }
        setupComponent(instance, false, optimized);
        if (true) {
          endMeasure(instance, `init`);
        }
      }
      if (instance.asyncDep) {
        if (isHmrUpdating) initialVNode.el = null;
        parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
        if (!initialVNode.el) {
          const placeholder = instance.subTree = createVNode(Comment);
          processCommentNode(null, placeholder, container, anchor);
        }
      } else {
        setupRenderEffect(
          instance,
          initialVNode,
          container,
          anchor,
          parentSuspense,
          namespace,
          optimized
        );
      }
      if (true) {
        popWarningContext();
        endMeasure(instance, `mount`);
      }
    };
    const updateComponent = (n1, n2, optimized) => {
      const instance = n2.component = n1.component;
      if (shouldUpdateComponent(n1, n2, optimized)) {
        if (instance.asyncDep && !instance.asyncResolved) {
          if (true) {
            pushWarningContext(n2);
          }
          updateComponentPreRender(instance, n2, optimized);
          if (true) {
            popWarningContext();
          }
          return;
        } else {
          instance.next = n2;
          instance.update();
        }
      } else {
        n2.el = n1.el;
        instance.vnode = n2;
      }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) => {
      const componentUpdateFn = () => {
        if (!instance.isMounted) {
          let vnodeHook;
          const { el, props } = initialVNode;
          const { bm, m, parent: parent2, root: root2, type } = instance;
          const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
          toggleRecurse(instance, false);
          if (bm) {
            invokeArrayFns(bm);
          }
          if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) {
            invokeVNodeHook(vnodeHook, parent2, initialVNode);
          }
          toggleRecurse(instance, true);
          if (el && hydrateNode) {
            const hydrateSubTree = () => {
              if (true) {
                startMeasure(instance, `render`);
              }
              instance.subTree = renderComponentRoot(instance);
              if (true) {
                endMeasure(instance, `render`);
              }
              if (true) {
                startMeasure(instance, `hydrate`);
              }
              hydrateNode(
                el,
                instance.subTree,
                instance,
                parentSuspense,
                null
              );
              if (true) {
                endMeasure(instance, `hydrate`);
              }
            };
            if (isAsyncWrapperVNode && type.__asyncHydrate) {
              type.__asyncHydrate(
                el,
                instance,
                hydrateSubTree
              );
            } else {
              hydrateSubTree();
            }
          } else {
            if (root2.ce) {
              root2.ce._injectChildStyle(type);
            }
            if (true) {
              startMeasure(instance, `render`);
            }
            const subTree = instance.subTree = renderComponentRoot(instance);
            if (true) {
              endMeasure(instance, `render`);
            }
            if (true) {
              startMeasure(instance, `patch`);
            }
            patch(
              null,
              subTree,
              container,
              anchor,
              instance,
              parentSuspense,
              namespace
            );
            if (true) {
              endMeasure(instance, `patch`);
            }
            initialVNode.el = subTree.el;
          }
          if (m) {
            queuePostRenderEffect(m, parentSuspense);
          }
          if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
            const scopedInitialVNode = initialVNode;
            queuePostRenderEffect(
              () => invokeVNodeHook(vnodeHook, parent2, scopedInitialVNode),
              parentSuspense
            );
          }
          if (initialVNode.shapeFlag & 256 || parent2 && isAsyncWrapper(parent2.vnode) && parent2.vnode.shapeFlag & 256) {
            instance.a && queuePostRenderEffect(instance.a, parentSuspense);
          }
          instance.isMounted = true;
          if (true) {
            devtoolsComponentAdded(instance);
          }
          initialVNode = container = anchor = null;
        } else {
          let { next, bu, u, parent: parent2, vnode } = instance;
          {
            const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
            if (nonHydratedAsyncRoot) {
              if (next) {
                next.el = vnode.el;
                updateComponentPreRender(instance, next, optimized);
              }
              nonHydratedAsyncRoot.asyncDep.then(() => {
                if (!instance.isUnmounted) {
                  componentUpdateFn();
                }
              });
              return;
            }
          }
          let originNext = next;
          let vnodeHook;
          if (true) {
            pushWarningContext(next || instance.vnode);
          }
          toggleRecurse(instance, false);
          if (next) {
            next.el = vnode.el;
            updateComponentPreRender(instance, next, optimized);
          } else {
            next = vnode;
          }
          if (bu) {
            invokeArrayFns(bu);
          }
          if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) {
            invokeVNodeHook(vnodeHook, parent2, next, vnode);
          }
          toggleRecurse(instance, true);
          if (true) {
            startMeasure(instance, `render`);
          }
          const nextTree = renderComponentRoot(instance);
          if (true) {
            endMeasure(instance, `render`);
          }
          const prevTree = instance.subTree;
          instance.subTree = nextTree;
          if (true) {
            startMeasure(instance, `patch`);
          }
          patch(
            prevTree,
            nextTree,
            // parent may have changed if it's in a teleport
            hostParentNode(prevTree.el),
            // anchor may have changed if it's in a fragment
            getNextHostNode(prevTree),
            instance,
            parentSuspense,
            namespace
          );
          if (true) {
            endMeasure(instance, `patch`);
          }
          next.el = nextTree.el;
          if (originNext === null) {
            updateHOCHostEl(instance, nextTree.el);
          }
          if (u) {
            queuePostRenderEffect(u, parentSuspense);
          }
          if (vnodeHook = next.props && next.props.onVnodeUpdated) {
            queuePostRenderEffect(
              () => invokeVNodeHook(vnodeHook, parent2, next, vnode),
              parentSuspense
            );
          }
          if (true) {
            devtoolsComponentUpdated(instance);
          }
          if (true) {
            popWarningContext();
          }
        }
      };
      instance.scope.on();
      const effect2 = instance.effect = new ReactiveEffect(componentUpdateFn);
      instance.scope.off();
      const update = instance.update = effect2.run.bind(effect2);
      const job = instance.job = effect2.runIfDirty.bind(effect2);
      job.i = instance;
      job.id = instance.uid;
      effect2.scheduler = () => queueJob(job);
      toggleRecurse(instance, true);
      if (true) {
        effect2.onTrack = instance.rtc ? (e) => invokeArrayFns(instance.rtc, e) : void 0;
        effect2.onTrigger = instance.rtg ? (e) => invokeArrayFns(instance.rtg, e) : void 0;
      }
      update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized) => {
      nextVNode.component = instance;
      const prevProps = instance.vnode.props;
      instance.vnode = nextVNode;
      instance.next = null;
      updateProps(instance, nextVNode.props, prevProps, optimized);
      updateSlots(instance, nextVNode.children, optimized);
      pauseTracking();
      flushPreFlushCbs(instance);
      resetTracking();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false) => {
      const c1 = n1 && n1.children;
      const prevShapeFlag = n1 ? n1.shapeFlag : 0;
      const c2 = n2.children;
      const { patchFlag, shapeFlag } = n2;
      if (patchFlag > 0) {
        if (patchFlag & 128) {
          patchKeyedChildren(
            c1,
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          return;
        } else if (patchFlag & 256) {
          patchUnkeyedChildren(
            c1,
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          return;
        }
      }
      if (shapeFlag & 8) {
        if (prevShapeFlag & 16) {
          unmountChildren(c1, parentComponent, parentSuspense);
        }
        if (c2 !== c1) {
          hostSetElementText(container, c2);
        }
      } else {
        if (prevShapeFlag & 16) {
          if (shapeFlag & 16) {
            patchKeyedChildren(
              c1,
              c2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else {
            unmountChildren(c1, parentComponent, parentSuspense, true);
          }
        } else {
          if (prevShapeFlag & 8) {
            hostSetElementText(container, "");
          }
          if (shapeFlag & 16) {
            mountChildren(
              c2,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          }
        }
      }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      c1 = c1 || EMPTY_ARR;
      c2 = c2 || EMPTY_ARR;
      const oldLength = c1.length;
      const newLength = c2.length;
      const commonLength = Math.min(oldLength, newLength);
      let i;
      for (i = 0; i < commonLength; i++) {
        const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
        patch(
          c1[i],
          nextChild,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
      if (oldLength > newLength) {
        unmountChildren(
          c1,
          parentComponent,
          parentSuspense,
          true,
          false,
          commonLength
        );
      } else {
        mountChildren(
          c2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized,
          commonLength
        );
      }
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
      let i = 0;
      const l2 = c2.length;
      let e1 = c1.length - 1;
      let e2 = l2 - 1;
      while (i <= e1 && i <= e2) {
        const n1 = c1[i];
        const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
        if (isSameVNodeType(n1, n2)) {
          patch(
            n1,
            n2,
            container,
            null,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else {
          break;
        }
        i++;
      }
      while (i <= e1 && i <= e2) {
        const n1 = c1[e1];
        const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
        if (isSameVNodeType(n1, n2)) {
          patch(
            n1,
            n2,
            container,
            null,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else {
          break;
        }
        e1--;
        e2--;
      }
      if (i > e1) {
        if (i <= e2) {
          const nextPos = e2 + 1;
          const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
          while (i <= e2) {
            patch(
              null,
              c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]),
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
            i++;
          }
        }
      } else if (i > e2) {
        while (i <= e1) {
          unmount(c1[i], parentComponent, parentSuspense, true);
          i++;
        }
      } else {
        const s1 = i;
        const s2 = i;
        const keyToNewIndexMap = /* @__PURE__ */ new Map();
        for (i = s2; i <= e2; i++) {
          const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
          if (nextChild.key != null) {
            if (keyToNewIndexMap.has(nextChild.key)) {
              warn$1(
                `Duplicate keys found during update:`,
                JSON.stringify(nextChild.key),
                `Make sure keys are unique.`
              );
            }
            keyToNewIndexMap.set(nextChild.key, i);
          }
        }
        let j;
        let patched = 0;
        const toBePatched = e2 - s2 + 1;
        let moved = false;
        let maxNewIndexSoFar = 0;
        const newIndexToOldIndexMap = new Array(toBePatched);
        for (i = 0; i < toBePatched; i++) newIndexToOldIndexMap[i] = 0;
        for (i = s1; i <= e1; i++) {
          const prevChild = c1[i];
          if (patched >= toBePatched) {
            unmount(prevChild, parentComponent, parentSuspense, true);
            continue;
          }
          let newIndex;
          if (prevChild.key != null) {
            newIndex = keyToNewIndexMap.get(prevChild.key);
          } else {
            for (j = s2; j <= e2; j++) {
              if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
                newIndex = j;
                break;
              }
            }
          }
          if (newIndex === void 0) {
            unmount(prevChild, parentComponent, parentSuspense, true);
          } else {
            newIndexToOldIndexMap[newIndex - s2] = i + 1;
            if (newIndex >= maxNewIndexSoFar) {
              maxNewIndexSoFar = newIndex;
            } else {
              moved = true;
            }
            patch(
              prevChild,
              c2[newIndex],
              container,
              null,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
            patched++;
          }
        }
        const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
        j = increasingNewIndexSequence.length - 1;
        for (i = toBePatched - 1; i >= 0; i--) {
          const nextIndex = s2 + i;
          const nextChild = c2[nextIndex];
          const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
          if (newIndexToOldIndexMap[i] === 0) {
            patch(
              null,
              nextChild,
              container,
              anchor,
              parentComponent,
              parentSuspense,
              namespace,
              slotScopeIds,
              optimized
            );
          } else if (moved) {
            if (j < 0 || i !== increasingNewIndexSequence[j]) {
              move(nextChild, container, anchor, 2);
            } else {
              j--;
            }
          }
        }
      }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
      const { el, type, transition, children, shapeFlag } = vnode;
      if (shapeFlag & 6) {
        move(vnode.component.subTree, container, anchor, moveType);
        return;
      }
      if (shapeFlag & 128) {
        vnode.suspense.move(container, anchor, moveType);
        return;
      }
      if (shapeFlag & 64) {
        type.move(vnode, container, anchor, internals);
        return;
      }
      if (type === Fragment) {
        hostInsert(el, container, anchor);
        for (let i = 0; i < children.length; i++) {
          move(children[i], container, anchor, moveType);
        }
        hostInsert(vnode.anchor, container, anchor);
        return;
      }
      if (type === Static) {
        moveStaticNode(vnode, container, anchor);
        return;
      }
      const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
      if (needTransition2) {
        if (moveType === 0) {
          transition.beforeEnter(el);
          hostInsert(el, container, anchor);
          queuePostRenderEffect(() => transition.enter(el), parentSuspense);
        } else {
          const { leave, delayLeave, afterLeave } = transition;
          const remove22 = () => hostInsert(el, container, anchor);
          const performLeave = () => {
            leave(el, () => {
              remove22();
              afterLeave && afterLeave();
            });
          };
          if (delayLeave) {
            delayLeave(el, remove22, performLeave);
          } else {
            performLeave();
          }
        }
      } else {
        hostInsert(el, container, anchor);
      }
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
      const {
        type,
        props,
        ref: ref2,
        children,
        dynamicChildren,
        shapeFlag,
        patchFlag,
        dirs,
        cacheIndex
      } = vnode;
      if (patchFlag === -2) {
        optimized = false;
      }
      if (ref2 != null) {
        setRef(ref2, null, parentSuspense, vnode, true);
      }
      if (cacheIndex != null) {
        parentComponent.renderCache[cacheIndex] = void 0;
      }
      if (shapeFlag & 256) {
        parentComponent.ctx.deactivate(vnode);
        return;
      }
      const shouldInvokeDirs = shapeFlag & 1 && dirs;
      const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
      let vnodeHook;
      if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) {
        invokeVNodeHook(vnodeHook, parentComponent, vnode);
      }
      if (shapeFlag & 6) {
        unmountComponent(vnode.component, parentSuspense, doRemove);
      } else {
        if (shapeFlag & 128) {
          vnode.suspense.unmount(parentSuspense, doRemove);
          return;
        }
        if (shouldInvokeDirs) {
          invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
        }
        if (shapeFlag & 64) {
          vnode.type.remove(
            vnode,
            parentComponent,
            parentSuspense,
            internals,
            doRemove
          );
        } else if (dynamicChildren && // #5154
        // when v-once is used inside a block, setBlockTracking(-1) marks the
        // parent block with hasOnce: true
        // so that it doesn't take the fast path during unmount - otherwise
        // components nested in v-once are never unmounted.
        !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
        (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
          unmountChildren(
            dynamicChildren,
            parentComponent,
            parentSuspense,
            false,
            true
          );
        } else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
          unmountChildren(children, parentComponent, parentSuspense);
        }
        if (doRemove) {
          remove3(vnode);
        }
      }
      if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) {
        queuePostRenderEffect(() => {
          vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
          shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
      }
    };
    const remove3 = (vnode) => {
      const { type, el, anchor, transition } = vnode;
      if (type === Fragment) {
        if (vnode.patchFlag > 0 && vnode.patchFlag & 2048 && transition && !transition.persisted) {
          vnode.children.forEach((child) => {
            if (child.type === Comment) {
              hostRemove(child.el);
            } else {
              remove3(child);
            }
          });
        } else {
          removeFragment(el, anchor);
        }
        return;
      }
      if (type === Static) {
        removeStaticNode(vnode);
        return;
      }
      const performRemove = () => {
        hostRemove(el);
        if (transition && !transition.persisted && transition.afterLeave) {
          transition.afterLeave();
        }
      };
      if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
        const { leave, delayLeave } = transition;
        const performLeave = () => leave(el, performRemove);
        if (delayLeave) {
          delayLeave(vnode.el, performRemove, performLeave);
        } else {
          performLeave();
        }
      } else {
        performRemove();
      }
    };
    const removeFragment = (cur, end) => {
      let next;
      while (cur !== end) {
        next = hostNextSibling(cur);
        hostRemove(cur);
        cur = next;
      }
      hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove) => {
      if (instance.type.__hmrId) {
        unregisterHMR(instance);
      }
      const { bum, scope, job, subTree, um, m, a } = instance;
      invalidateMount(m);
      invalidateMount(a);
      if (bum) {
        invokeArrayFns(bum);
      }
      scope.stop();
      if (job) {
        job.flags |= 8;
        unmount(subTree, instance, parentSuspense, doRemove);
      }
      if (um) {
        queuePostRenderEffect(um, parentSuspense);
      }
      queuePostRenderEffect(() => {
        instance.isUnmounted = true;
      }, parentSuspense);
      if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
        parentSuspense.deps--;
        if (parentSuspense.deps === 0) {
          parentSuspense.resolve();
        }
      }
      if (true) {
        devtoolsComponentRemoved(instance);
      }
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
      for (let i = start; i < children.length; i++) {
        unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
      }
    };
    const getNextHostNode = (vnode) => {
      if (vnode.shapeFlag & 6) {
        return getNextHostNode(vnode.component.subTree);
      }
      if (vnode.shapeFlag & 128) {
        return vnode.suspense.next();
      }
      const el = hostNextSibling(vnode.anchor || vnode.el);
      const teleportEnd = el && el[TeleportEndKey];
      return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render2 = (vnode, container, namespace) => {
      if (vnode == null) {
        if (container._vnode) {
          unmount(container._vnode, null, null, true);
        }
      } else {
        patch(
          container._vnode || null,
          vnode,
          container,
          null,
          null,
          null,
          namespace
        );
      }
      container._vnode = vnode;
      if (!isFlushing) {
        isFlushing = true;
        flushPreFlushCbs();
        flushPostFlushCbs();
        isFlushing = false;
      }
    };
    const internals = {
      p: patch,
      um: unmount,
      m: move,
      r: remove3,
      mt: mountComponent,
      mc: mountChildren,
      pc: patchChildren,
      pbc: patchBlockChildren,
      n: getNextHostNode,
      o: options3
    };
    let hydrate3;
    let hydrateNode;
    if (createHydrationFns) {
      [hydrate3, hydrateNode] = createHydrationFns(
        internals
      );
    }
    return {
      render: render2,
      hydrate: hydrate3,
      createApp: createAppAPI(render2, hydrate3)
    };
  }
  function resolveChildrenNamespace({ type, props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
  }
  function toggleRecurse({ effect: effect2, job }, allowed) {
    if (allowed) {
      effect2.flags |= 32;
      job.flags |= 4;
    } else {
      effect2.flags &= ~32;
      job.flags &= ~4;
    }
  }
  function needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
  }
  function traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if (isArray(ch1) && isArray(ch2)) {
      for (let i = 0; i < ch1.length; i++) {
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
          if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
            c2 = ch2[i] = cloneIfMounted(ch2[i]);
            c2.el = c1.el;
          }
          if (!shallow && c2.patchFlag !== -2)
            traverseStaticChildren(c1, c2);
        }
        if (c2.type === Text) {
          c2.el = c1.el;
        }
        if (c2.type === Comment && !c2.el) {
          c2.el = c1.el;
        }
      }
    }
  }
  function getSequence(arr) {
    const p2 = arr.slice();
    const result = [0];
    let i, j, u, v, c;
    const len = arr.length;
    for (i = 0; i < len; i++) {
      const arrI = arr[i];
      if (arrI !== 0) {
        j = result[result.length - 1];
        if (arr[j] < arrI) {
          p2[i] = j;
          result.push(i);
          continue;
        }
        u = 0;
        v = result.length - 1;
        while (u < v) {
          c = u + v >> 1;
          if (arr[result[c]] < arrI) {
            u = c + 1;
          } else {
            v = c;
          }
        }
        if (arrI < arr[result[u]]) {
          if (u > 0) {
            p2[i] = result[u - 1];
          }
          result[u] = i;
        }
      }
    }
    u = result.length;
    v = result[u - 1];
    while (u-- > 0) {
      result[u] = v;
      v = p2[v];
    }
    return result;
  }
  function locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
      if (subComponent.asyncDep && !subComponent.asyncResolved) {
        return subComponent;
      } else {
        return locateNonHydratedAsyncRoot(subComponent);
      }
    }
  }
  function invalidateMount(hooks) {
    if (hooks) {
      for (let i = 0; i < hooks.length; i++)
        hooks[i].flags |= 8;
    }
  }
  var ssrContextKey = Symbol.for("v-scx");
  var useSSRContext = () => {
    {
      const ctx = inject(ssrContextKey);
      if (!ctx) {
        warn$1(
          `Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build.`
        );
      }
      return ctx;
    }
  };
  function watchEffect(effect2, options3) {
    return doWatch(effect2, null, options3);
  }
  function watchPostEffect(effect2, options3) {
    return doWatch(
      effect2,
      null,
      true ? extend({}, options3, { flush: "post" }) : { flush: "post" }
    );
  }
  function watchSyncEffect(effect2, options3) {
    return doWatch(
      effect2,
      null,
      true ? extend({}, options3, { flush: "sync" }) : { flush: "sync" }
    );
  }
  function watch2(source, cb, options3) {
    if (!isFunction(cb)) {
      warn$1(
        `\`watch(fn, options?)\` signature has been moved to a separate API. Use \`watchEffect(fn, options?)\` instead. \`watch\` now only supports \`watch(source, cb, options?) signature.`
      );
    }
    return doWatch(source, cb, options3);
  }
  function doWatch(source, cb, options3 = EMPTY_OBJ) {
    const { immediate, deep, flush, once } = options3;
    if (!cb) {
      if (immediate !== void 0) {
        warn$1(
          `watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.`
        );
      }
      if (deep !== void 0) {
        warn$1(
          `watch() "deep" option is only respected when using the watch(source, callback, options?) signature.`
        );
      }
      if (once !== void 0) {
        warn$1(
          `watch() "once" option is only respected when using the watch(source, callback, options?) signature.`
        );
      }
    }
    const baseWatchOptions = extend({}, options3);
    if (true) baseWatchOptions.onWarn = warn$1;
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if (isInSSRComponentSetup) {
      if (flush === "sync") {
        const ctx = useSSRContext();
        ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
      } else if (!runsImmediately) {
        const watchStopHandle = () => {
        };
        watchStopHandle.stop = NOOP;
        watchStopHandle.resume = NOOP;
        watchStopHandle.pause = NOOP;
        return watchStopHandle;
      }
    }
    const instance = currentInstance;
    baseWatchOptions.call = (fn, type, args) => callWithAsyncErrorHandling(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") {
      baseWatchOptions.scheduler = (job) => {
        queuePostRenderEffect(job, instance && instance.suspense);
      };
    } else if (flush !== "sync") {
      isPre = true;
      baseWatchOptions.scheduler = (job, isFirstRun) => {
        if (isFirstRun) {
          job();
        } else {
          queueJob(job);
        }
      };
    }
    baseWatchOptions.augmentJob = (job) => {
      if (cb) {
        job.flags |= 4;
      }
      if (isPre) {
        job.flags |= 2;
        if (instance) {
          job.id = instance.uid;
          job.i = instance;
        }
      }
    };
    const watchHandle = watch(source, cb, baseWatchOptions);
    if (isInSSRComponentSetup) {
      if (ssrCleanup) {
        ssrCleanup.push(watchHandle);
      } else if (runsImmediately) {
        watchHandle();
      }
    }
    return watchHandle;
  }
  function instanceWatch(source, value, options3) {
    const publicThis = this.proxy;
    const getter = isString(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if (isFunction(value)) {
      cb = value;
    } else {
      cb = value.handler;
      options3 = value;
    }
    const reset3 = setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options3);
    reset3();
    return res;
  }
  function createPathGetter(ctx, path) {
    const segments = path.split(".");
    return () => {
      let cur = ctx;
      for (let i = 0; i < segments.length && cur; i++) {
        cur = cur[segments[i]];
      }
      return cur;
    };
  }
  function useModel(props, name, options3 = EMPTY_OBJ) {
    const i = getCurrentInstance();
    if (!i) {
      warn$1(`useModel() called without active instance.`);
      return ref();
    }
    const camelizedName = camelize(name);
    if (!i.propsOptions[0][camelizedName]) {
      warn$1(`useModel() called with prop "${name}" which is not declared.`);
      return ref();
    }
    const hyphenatedName = hyphenate(name);
    const modifiers = getModelModifiers(props, camelizedName);
    const res = customRef((track2, trigger2) => {
      let localValue;
      let prevSetValue = EMPTY_OBJ;
      let prevEmittedValue;
      watchSyncEffect(() => {
        const propValue = props[camelizedName];
        if (hasChanged(localValue, propValue)) {
          localValue = propValue;
          trigger2();
        }
      });
      return {
        get() {
          track2();
          return options3.get ? options3.get(localValue) : localValue;
        },
        set(value) {
          const emittedValue = options3.set ? options3.set(value) : value;
          if (!hasChanged(emittedValue, localValue) && !(prevSetValue !== EMPTY_OBJ && hasChanged(value, prevSetValue))) {
            return;
          }
          const rawProps = i.vnode.props;
          if (!(rawProps && // check if parent has passed v-model
          (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
            localValue = value;
            trigger2();
          }
          i.emit(`update:${name}`, emittedValue);
          if (hasChanged(value, emittedValue) && hasChanged(value, prevSetValue) && !hasChanged(emittedValue, prevEmittedValue)) {
            trigger2();
          }
          prevSetValue = value;
          prevEmittedValue = emittedValue;
        }
      };
    });
    res[Symbol.iterator] = () => {
      let i2 = 0;
      return {
        next() {
          if (i2 < 2) {
            return { value: i2++ ? modifiers || EMPTY_OBJ : res, done: false };
          } else {
            return { done: true };
          }
        }
      };
    };
    return res;
  }
  var getModelModifiers = (props, modelName) => {
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${camelize(modelName)}Modifiers`] || props[`${hyphenate(modelName)}Modifiers`];
  };
  function emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || EMPTY_OBJ;
    if (true) {
      const {
        emitsOptions,
        propsOptions: [propsOptions]
      } = instance;
      if (emitsOptions) {
        if (!(event in emitsOptions) && true) {
          if (!propsOptions || !(toHandlerKey(camelize(event)) in propsOptions)) {
            warn$1(
              `Component emitted event "${event}" but it is neither declared in the emits option nor as an "${toHandlerKey(camelize(event))}" prop.`
            );
          }
        } else {
          const validator = emitsOptions[event];
          if (isFunction(validator)) {
            const isValid = validator(...rawArgs);
            if (!isValid) {
              warn$1(
                `Invalid event arguments: event validation failed for event "${event}".`
              );
            }
          }
        }
      }
    }
    let args = rawArgs;
    const isModelListener2 = event.startsWith("update:");
    const modifiers = isModelListener2 && getModelModifiers(props, event.slice(7));
    if (modifiers) {
      if (modifiers.trim) {
        args = rawArgs.map((a) => isString(a) ? a.trim() : a);
      }
      if (modifiers.number) {
        args = rawArgs.map(looseToNumber);
      }
    }
    if (true) {
      devtoolsComponentEmit(instance, event, args);
    }
    if (true) {
      const lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && props[toHandlerKey(lowerCaseEvent)]) {
        warn$1(
          `Event "${lowerCaseEvent}" is emitted in component ${formatComponentName(
            instance,
            instance.type
          )} but the handler is registered for "${event}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${hyphenate(
            event
          )}" instead of "${event}".`
        );
      }
    }
    let handlerName;
    let handler = props[handlerName = toHandlerKey(event)] || // also try camelCase event handler (#2249)
    props[handlerName = toHandlerKey(camelize(event))];
    if (!handler && isModelListener2) {
      handler = props[handlerName = toHandlerKey(hyphenate(event))];
    }
    if (handler) {
      callWithAsyncErrorHandling(
        handler,
        instance,
        6,
        args
      );
    }
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
      if (!instance.emitted) {
        instance.emitted = {};
      } else if (instance.emitted[handlerName]) {
        return;
      }
      instance.emitted[handlerName] = true;
      callWithAsyncErrorHandling(
        onceHandler,
        instance,
        6,
        args
      );
    }
  }
  function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) {
      return cached;
    }
    const raw3 = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !isFunction(comp)) {
      const extendEmits = (raw22) => {
        const normalizedFromExtend = normalizeEmitsOptions(raw22, appContext, true);
        if (normalizedFromExtend) {
          hasExtends = true;
          extend(normalized, normalizedFromExtend);
        }
      };
      if (!asMixin && appContext.mixins.length) {
        appContext.mixins.forEach(extendEmits);
      }
      if (comp.extends) {
        extendEmits(comp.extends);
      }
      if (comp.mixins) {
        comp.mixins.forEach(extendEmits);
      }
    }
    if (!raw3 && !hasExtends) {
      if (isObject(comp)) {
        cache.set(comp, null);
      }
      return null;
    }
    if (isArray(raw3)) {
      raw3.forEach((key) => normalized[key] = null);
    } else {
      extend(normalized, raw3);
    }
    if (isObject(comp)) {
      cache.set(comp, normalized);
    }
    return normalized;
  }
  function isEmitListener(options3, key) {
    if (!options3 || !isOn(key)) {
      return false;
    }
    key = key.slice(2).replace(/Once$/, "");
    return hasOwn(options3, key[0].toLowerCase() + key.slice(1)) || hasOwn(options3, hyphenate(key)) || hasOwn(options3, key);
  }
  var accessedAttrs = false;
  function markAttrsAccessed() {
    accessedAttrs = true;
  }
  function renderComponentRoot(instance) {
    const {
      type: Component,
      vnode,
      proxy,
      withProxy,
      propsOptions: [propsOptions],
      slots,
      attrs,
      emit: emit3,
      render: render2,
      renderCache,
      props,
      data,
      setupState,
      ctx,
      inheritAttrs
    } = instance;
    const prev = setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    if (true) {
      accessedAttrs = false;
    }
    try {
      if (vnode.shapeFlag & 4) {
        const proxyToUse = withProxy || proxy;
        const thisProxy = setupState.__isScriptSetup ? new Proxy(proxyToUse, {
          get(target2, key, receiver) {
            warn$1(
              `Property '${String(
                key
              )}' was accessed via 'this'. Avoid using 'this' in templates.`
            );
            return Reflect.get(target2, key, receiver);
          }
        }) : proxyToUse;
        result = normalizeVNode(
          render2.call(
            thisProxy,
            proxyToUse,
            renderCache,
            true ? shallowReadonly(props) : props,
            setupState,
            data,
            ctx
          )
        );
        fallthroughAttrs = attrs;
      } else {
        const render22 = Component;
        if (attrs === props) {
          markAttrsAccessed();
        }
        result = normalizeVNode(
          render22.length > 1 ? render22(
            true ? shallowReadonly(props) : props,
            true ? {
              get attrs() {
                markAttrsAccessed();
                return shallowReadonly(attrs);
              },
              slots,
              emit: emit3
            } : { attrs, slots, emit: emit3 }
          ) : render22(
            true ? shallowReadonly(props) : props,
            null
          )
        );
        fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
      }
    } catch (err) {
      blockStack.length = 0;
      handleError(err, instance, 1);
      result = createVNode(Comment);
    }
    let root2 = result;
    let setRoot = void 0;
    if (result.patchFlag > 0 && result.patchFlag & 2048) {
      [root2, setRoot] = getChildRoot(result);
    }
    if (fallthroughAttrs && inheritAttrs !== false) {
      const keys = Object.keys(fallthroughAttrs);
      const { shapeFlag } = root2;
      if (keys.length) {
        if (shapeFlag & (1 | 6)) {
          if (propsOptions && keys.some(isModelListener)) {
            fallthroughAttrs = filterModelListeners(
              fallthroughAttrs,
              propsOptions
            );
          }
          root2 = cloneVNode(root2, fallthroughAttrs, false, true);
        } else if (!accessedAttrs && root2.type !== Comment) {
          const allAttrs = Object.keys(attrs);
          const eventAttrs = [];
          const extraAttrs = [];
          for (let i = 0, l = allAttrs.length; i < l; i++) {
            const key = allAttrs[i];
            if (isOn(key)) {
              if (!isModelListener(key)) {
                eventAttrs.push(key[2].toLowerCase() + key.slice(3));
              }
            } else {
              extraAttrs.push(key);
            }
          }
          if (extraAttrs.length) {
            warn$1(
              `Extraneous non-props attributes (${extraAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
            );
          }
          if (eventAttrs.length) {
            warn$1(
              `Extraneous non-emits event listeners (${eventAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
            );
          }
        }
      }
    }
    if (vnode.dirs) {
      if (!isElementRoot(root2)) {
        warn$1(
          `Runtime directive used on component with non-element root node. The directives will not function as intended.`
        );
      }
      root2 = cloneVNode(root2, null, false, true);
      root2.dirs = root2.dirs ? root2.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
      if (!isElementRoot(root2)) {
        warn$1(
          `Component inside <Transition> renders non-element root node that cannot be animated.`
        );
      }
      setTransitionHooks(root2, vnode.transition);
    }
    if (setRoot) {
      setRoot(root2);
    } else {
      result = root2;
    }
    setCurrentRenderingInstance(prev);
    return result;
  }
  var getChildRoot = (vnode) => {
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = filterSingleRoot(rawChildren, false);
    if (!childRoot) {
      return [vnode, void 0];
    } else if (childRoot.patchFlag > 0 && childRoot.patchFlag & 2048) {
      return getChildRoot(childRoot);
    }
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot) => {
      rawChildren[index] = updatedRoot;
      if (dynamicChildren) {
        if (dynamicIndex > -1) {
          dynamicChildren[dynamicIndex] = updatedRoot;
        } else if (updatedRoot.patchFlag > 0) {
          vnode.dynamicChildren = [...dynamicChildren, updatedRoot];
        }
      }
    };
    return [normalizeVNode(childRoot), setRoot];
  };
  function filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (isVNode(child)) {
        if (child.type !== Comment || child.children === "v-if") {
          if (singleRoot) {
            return;
          } else {
            singleRoot = child;
            if (recurse && singleRoot.patchFlag > 0 && singleRoot.patchFlag & 2048) {
              return filterSingleRoot(singleRoot.children);
            }
          }
        }
      } else {
        return;
      }
    }
    return singleRoot;
  }
  var getFunctionalFallthrough = (attrs) => {
    let res;
    for (const key in attrs) {
      if (key === "class" || key === "style" || isOn(key)) {
        (res || (res = {}))[key] = attrs[key];
      }
    }
    return res;
  };
  var filterModelListeners = (attrs, props) => {
    const res = {};
    for (const key in attrs) {
      if (!isModelListener(key) || !(key.slice(9) in props)) {
        res[key] = attrs[key];
      }
    }
    return res;
  };
  var isElementRoot = (vnode) => {
    return vnode.shapeFlag & (6 | 1) || vnode.type === Comment;
  };
  function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if ((prevChildren || nextChildren) && isHmrUpdating) {
      return true;
    }
    if (nextVNode.dirs || nextVNode.transition) {
      return true;
    }
    if (optimized && patchFlag >= 0) {
      if (patchFlag & 1024) {
        return true;
      }
      if (patchFlag & 16) {
        if (!prevProps) {
          return !!nextProps;
        }
        return hasPropsChanged(prevProps, nextProps, emits);
      } else if (patchFlag & 8) {
        const dynamicProps = nextVNode.dynamicProps;
        for (let i = 0; i < dynamicProps.length; i++) {
          const key = dynamicProps[i];
          if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) {
            return true;
          }
        }
      }
    } else {
      if (prevChildren || nextChildren) {
        if (!nextChildren || !nextChildren.$stable) {
          return true;
        }
      }
      if (prevProps === nextProps) {
        return false;
      }
      if (!prevProps) {
        return !!nextProps;
      }
      if (!nextProps) {
        return true;
      }
      return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
  }
  function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) {
      return true;
    }
    for (let i = 0; i < nextKeys.length; i++) {
      const key = nextKeys[i];
      if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) {
        return true;
      }
    }
    return false;
  }
  function updateHOCHostEl({ vnode, parent: parent2 }, el) {
    while (parent2) {
      const root2 = parent2.subTree;
      if (root2.suspense && root2.suspense.activeBranch === vnode) {
        root2.el = vnode.el;
      }
      if (root2 === vnode) {
        (vnode = parent2.vnode).el = el;
        parent2 = parent2.parent;
      } else {
        break;
      }
    }
  }
  var isSuspense = (type) => type.__isSuspense;
  var suspenseId = 0;
  var SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
      if (n1 == null) {
        mountSuspense(
          n2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized,
          rendererInternals
        );
      } else {
        if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
          n2.suspense = n1.suspense;
          n2.suspense.vnode = n2;
          n2.el = n1.el;
          return;
        }
        patchSuspense(
          n1,
          n2,
          container,
          anchor,
          parentComponent,
          namespace,
          slotScopeIds,
          optimized,
          rendererInternals
        );
      }
    },
    hydrate: hydrateSuspense,
    normalize: normalizeSuspenseChildren
  };
  var Suspense = SuspenseImpl;
  function triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if (isFunction(eventListener)) {
      eventListener();
    }
  }
  function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const {
      p: patch,
      o: { createElement }
    } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = createSuspenseBoundary(
      vnode,
      parentSuspense,
      parentComponent,
      container,
      hiddenContainer,
      anchor,
      namespace,
      slotScopeIds,
      optimized,
      rendererInternals
    );
    patch(
      null,
      suspense.pendingBranch = vnode.ssContent,
      hiddenContainer,
      null,
      parentComponent,
      suspense,
      namespace,
      slotScopeIds
    );
    if (suspense.deps > 0) {
      triggerEvent(vnode, "onPending");
      triggerEvent(vnode, "onFallback");
      patch(
        null,
        vnode.ssFallback,
        container,
        anchor,
        parentComponent,
        null,
        // fallback tree will not have suspense context
        namespace,
        slotScopeIds
      );
      setActiveBranch(suspense, vnode.ssFallback);
    } else {
      suspense.resolve(false, true);
    }
  }
  function patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch, pendingBranch, isInFallback, isHydrating } = suspense;
    if (pendingBranch) {
      suspense.pendingBranch = newBranch;
      if (isSameVNodeType(newBranch, pendingBranch)) {
        patch(
          pendingBranch,
          newBranch,
          suspense.hiddenContainer,
          null,
          parentComponent,
          suspense,
          namespace,
          slotScopeIds,
          optimized
        );
        if (suspense.deps <= 0) {
          suspense.resolve();
        } else if (isInFallback) {
          if (!isHydrating) {
            patch(
              activeBranch,
              newFallback,
              container,
              anchor,
              parentComponent,
              null,
              // fallback tree will not have suspense context
              namespace,
              slotScopeIds,
              optimized
            );
            setActiveBranch(suspense, newFallback);
          }
        }
      } else {
        suspense.pendingId = suspenseId++;
        if (isHydrating) {
          suspense.isHydrating = false;
          suspense.activeBranch = pendingBranch;
        } else {
          unmount(pendingBranch, parentComponent, suspense);
        }
        suspense.deps = 0;
        suspense.effects.length = 0;
        suspense.hiddenContainer = createElement("div");
        if (isInFallback) {
          patch(
            null,
            newBranch,
            suspense.hiddenContainer,
            null,
            parentComponent,
            suspense,
            namespace,
            slotScopeIds,
            optimized
          );
          if (suspense.deps <= 0) {
            suspense.resolve();
          } else {
            patch(
              activeBranch,
              newFallback,
              container,
              anchor,
              parentComponent,
              null,
              // fallback tree will not have suspense context
              namespace,
              slotScopeIds,
              optimized
            );
            setActiveBranch(suspense, newFallback);
          }
        } else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
          patch(
            activeBranch,
            newBranch,
            container,
            anchor,
            parentComponent,
            suspense,
            namespace,
            slotScopeIds,
            optimized
          );
          suspense.resolve(true);
        } else {
          patch(
            null,
            newBranch,
            suspense.hiddenContainer,
            null,
            parentComponent,
            suspense,
            namespace,
            slotScopeIds,
            optimized
          );
          if (suspense.deps <= 0) {
            suspense.resolve();
          }
        }
      }
    } else {
      if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
        patch(
          activeBranch,
          newBranch,
          container,
          anchor,
          parentComponent,
          suspense,
          namespace,
          slotScopeIds,
          optimized
        );
        setActiveBranch(suspense, newBranch);
      } else {
        triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) {
          suspense.pendingId = newBranch.component.suspenseId;
        } else {
          suspense.pendingId = suspenseId++;
        }
        patch(
          null,
          newBranch,
          suspense.hiddenContainer,
          null,
          parentComponent,
          suspense,
          namespace,
          slotScopeIds,
          optimized
        );
        if (suspense.deps <= 0) {
          suspense.resolve();
        } else {
          const { timeout, pendingId } = suspense;
          if (timeout > 0) {
            setTimeout(() => {
              if (suspense.pendingId === pendingId) {
                suspense.fallback(newFallback);
              }
            }, timeout);
          } else if (timeout === 0) {
            suspense.fallback(newFallback);
          }
        }
      }
    }
  }
  var hasWarned = false;
  function createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    if (!hasWarned) {
      hasWarned = true;
      console[console.info ? "info" : "log"](
        `<Suspense> is an experimental feature and its API will likely change.`
      );
    }
    const {
      p: patch,
      m: move,
      um: unmount,
      n: next,
      o: { parentNode, remove: remove3 }
    } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = isVNodeSuspensible(vnode);
    if (isSuspensible) {
      if (parentSuspense && parentSuspense.pendingBranch) {
        parentSuspenseId = parentSuspense.pendingId;
        parentSuspense.deps++;
      }
    }
    const timeout = vnode.props ? toNumber(vnode.props.timeout) : void 0;
    if (true) {
      assertNumber(timeout, `Suspense timeout`);
    }
    const initialAnchor = anchor;
    const suspense = {
      vnode,
      parent: parentSuspense,
      parentComponent,
      namespace,
      container,
      hiddenContainer,
      deps: 0,
      pendingId: suspenseId++,
      timeout: typeof timeout === "number" ? timeout : -1,
      activeBranch: null,
      pendingBranch: null,
      isInFallback: !isHydrating,
      isHydrating,
      isUnmounted: false,
      effects: [],
      resolve(resume = false, sync = false) {
        if (true) {
          if (!resume && !suspense.pendingBranch) {
            throw new Error(
              `suspense.resolve() is called without a pending branch.`
            );
          }
          if (suspense.isUnmounted) {
            throw new Error(
              `suspense.resolve() is called on an already unmounted suspense boundary.`
            );
          }
        }
        const {
          vnode: vnode2,
          activeBranch,
          pendingBranch,
          pendingId,
          effects,
          parentComponent: parentComponent2,
          container: container2
        } = suspense;
        let delayEnter = false;
        if (suspense.isHydrating) {
          suspense.isHydrating = false;
        } else if (!resume) {
          delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
          if (delayEnter) {
            activeBranch.transition.afterLeave = () => {
              if (pendingId === suspense.pendingId) {
                move(
                  pendingBranch,
                  container2,
                  anchor === initialAnchor ? next(activeBranch) : anchor,
                  0
                );
                queuePostFlushCb(effects);
              }
            };
          }
          if (activeBranch) {
            if (parentNode(activeBranch.el) === container2) {
              anchor = next(activeBranch);
            }
            unmount(activeBranch, parentComponent2, suspense, true);
          }
          if (!delayEnter) {
            move(pendingBranch, container2, anchor, 0);
          }
        }
        setActiveBranch(suspense, pendingBranch);
        suspense.pendingBranch = null;
        suspense.isInFallback = false;
        let parent2 = suspense.parent;
        let hasUnresolvedAncestor = false;
        while (parent2) {
          if (parent2.pendingBranch) {
            parent2.effects.push(...effects);
            hasUnresolvedAncestor = true;
            break;
          }
          parent2 = parent2.parent;
        }
        if (!hasUnresolvedAncestor && !delayEnter) {
          queuePostFlushCb(effects);
        }
        suspense.effects = [];
        if (isSuspensible) {
          if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0 && !sync) {
              parentSuspense.resolve();
            }
          }
        }
        triggerEvent(vnode2, "onResolve");
      },
      fallback(fallbackVNode) {
        if (!suspense.pendingBranch) {
          return;
        }
        const { vnode: vnode2, activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
        triggerEvent(vnode2, "onFallback");
        const anchor2 = next(activeBranch);
        const mountFallback = () => {
          if (!suspense.isInFallback) {
            return;
          }
          patch(
            null,
            fallbackVNode,
            container2,
            anchor2,
            parentComponent2,
            null,
            // fallback tree will not have suspense context
            namespace2,
            slotScopeIds,
            optimized
          );
          setActiveBranch(suspense, fallbackVNode);
        };
        const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
        if (delayEnter) {
          activeBranch.transition.afterLeave = mountFallback;
        }
        suspense.isInFallback = true;
        unmount(
          activeBranch,
          parentComponent2,
          null,
          // no suspense so unmount hooks fire now
          true
          // shouldRemove
        );
        if (!delayEnter) {
          mountFallback();
        }
      },
      move(container2, anchor2, type) {
        suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
        suspense.container = container2;
      },
      next() {
        return suspense.activeBranch && next(suspense.activeBranch);
      },
      registerDep(instance, setupRenderEffect, optimized2) {
        const isInPendingSuspense = !!suspense.pendingBranch;
        if (isInPendingSuspense) {
          suspense.deps++;
        }
        const hydratedEl = instance.vnode.el;
        instance.asyncDep.catch((err) => {
          handleError(err, instance, 0);
        }).then((asyncSetupResult) => {
          if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) {
            return;
          }
          instance.asyncResolved = true;
          const { vnode: vnode2 } = instance;
          if (true) {
            pushWarningContext(vnode2);
          }
          handleSetupResult(instance, asyncSetupResult, false);
          if (hydratedEl) {
            vnode2.el = hydratedEl;
          }
          const placeholder = !hydratedEl && instance.subTree.el;
          setupRenderEffect(
            instance,
            vnode2,
            // component may have been moved before resolve.
            // if this is not a hydration, instance.subTree will be the comment
            // placeholder.
            parentNode(hydratedEl || instance.subTree.el),
            // anchor will not be used if this is hydration, so only need to
            // consider the comment placeholder case.
            hydratedEl ? null : next(instance.subTree),
            suspense,
            namespace,
            optimized2
          );
          if (placeholder) {
            remove3(placeholder);
          }
          updateHOCHostEl(instance, vnode2.el);
          if (true) {
            popWarningContext();
          }
          if (isInPendingSuspense && --suspense.deps === 0) {
            suspense.resolve();
          }
        });
      },
      unmount(parentSuspense2, doRemove) {
        suspense.isUnmounted = true;
        if (suspense.activeBranch) {
          unmount(
            suspense.activeBranch,
            parentComponent,
            parentSuspense2,
            doRemove
          );
        }
        if (suspense.pendingBranch) {
          unmount(
            suspense.pendingBranch,
            parentComponent,
            parentSuspense2,
            doRemove
          );
        }
      }
    };
    return suspense;
  }
  function hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = createSuspenseBoundary(
      vnode,
      parentSuspense,
      parentComponent,
      node.parentNode,
      // eslint-disable-next-line no-restricted-globals
      document.createElement("div"),
      null,
      namespace,
      slotScopeIds,
      optimized,
      rendererInternals,
      true
    );
    const result = hydrateNode(
      node,
      suspense.pendingBranch = vnode.ssContent,
      parentComponent,
      suspense,
      slotScopeIds,
      optimized
    );
    if (suspense.deps === 0) {
      suspense.resolve(false, true);
    }
    return result;
  }
  function normalizeSuspenseChildren(vnode) {
    const { shapeFlag, children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = normalizeSuspenseSlot(
      isSlotChildren ? children.default : children
    );
    vnode.ssFallback = isSlotChildren ? normalizeSuspenseSlot(children.fallback) : createVNode(Comment);
  }
  function normalizeSuspenseSlot(s) {
    let block;
    if (isFunction(s)) {
      const trackBlock = isBlockTreeEnabled && s._c;
      if (trackBlock) {
        s._d = false;
        openBlock();
      }
      s = s();
      if (trackBlock) {
        s._d = true;
        block = currentBlock;
        closeBlock();
      }
    }
    if (isArray(s)) {
      const singleChild = filterSingleRoot(s);
      if (!singleChild && s.filter((child) => child !== NULL_DYNAMIC_COMPONENT).length > 0) {
        warn$1(`<Suspense> slots expect a single root node.`);
      }
      s = singleChild;
    }
    s = normalizeVNode(s);
    if (block && !s.dynamicChildren) {
      s.dynamicChildren = block.filter((c) => c !== s);
    }
    return s;
  }
  function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
      if (isArray(fn)) {
        suspense.effects.push(...fn);
      } else {
        suspense.effects.push(fn);
      }
    } else {
      queuePostFlushCb(fn);
    }
  }
  function setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode, parentComponent } = suspense;
    let el = branch.el;
    while (!el && branch.component) {
      branch = branch.component.subTree;
      el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
      parentComponent.vnode.el = el;
      updateHOCHostEl(parentComponent, el);
    }
  }
  function isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
  }
  var Fragment = Symbol.for("v-fgt");
  var Text = Symbol.for("v-txt");
  var Comment = Symbol.for("v-cmt");
  var Static = Symbol.for("v-stc");
  var blockStack = [];
  var currentBlock = null;
  function openBlock(disableTracking = false) {
    blockStack.push(currentBlock = disableTracking ? null : []);
  }
  function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
  }
  var isBlockTreeEnabled = 1;
  function setBlockTracking(value, inVOnce = false) {
    isBlockTreeEnabled += value;
    if (value < 0 && currentBlock && inVOnce) {
      currentBlock.hasOnce = true;
    }
  }
  function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) {
      currentBlock.push(vnode);
    }
    return vnode;
  }
  function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(
      createBaseVNode(
        type,
        props,
        children,
        patchFlag,
        dynamicProps,
        shapeFlag,
        true
      )
    );
  }
  function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(
      createVNode(
        type,
        props,
        children,
        patchFlag,
        dynamicProps,
        true
      )
    );
  }
  function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
  }
  function isSameVNodeType(n1, n2) {
    if (n2.shapeFlag & 6 && n1.component) {
      const dirtyInstances = hmrDirtyComponents.get(n2.type);
      if (dirtyInstances && dirtyInstances.has(n1.component)) {
        n1.shapeFlag &= ~256;
        n2.shapeFlag &= ~512;
        return false;
      }
    }
    return n1.type === n2.type && n1.key === n2.key;
  }
  var vnodeArgsTransformer;
  function transformVNodeArgs(transformer) {
    vnodeArgsTransformer = transformer;
  }
  var createVNodeWithArgsTransform = (...args) => {
    return _createVNode(
      ...vnodeArgsTransformer ? vnodeArgsTransformer(args, currentRenderingInstance) : args
    );
  };
  var normalizeKey = ({ key }) => key != null ? key : null;
  var normalizeRef = ({
    ref: ref2,
    ref_key,
    ref_for
  }) => {
    if (typeof ref2 === "number") {
      ref2 = "" + ref2;
    }
    return ref2 != null ? isString(ref2) || isRef2(ref2) || isFunction(ref2) ? { i: currentRenderingInstance, r: ref2, k: ref_key, f: !!ref_for } : ref2 : null;
  };
  function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
      __v_isVNode: true,
      __v_skip: true,
      type,
      props,
      key: props && normalizeKey(props),
      ref: props && normalizeRef(props),
      scopeId: currentScopeId,
      slotScopeIds: null,
      children,
      component: null,
      suspense: null,
      ssContent: null,
      ssFallback: null,
      dirs: null,
      transition: null,
      el: null,
      anchor: null,
      target: null,
      targetStart: null,
      targetAnchor: null,
      staticCount: 0,
      shapeFlag,
      patchFlag,
      dynamicProps,
      dynamicChildren: null,
      appContext: null,
      ctx: currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
      normalizeChildren(vnode, children);
      if (shapeFlag & 128) {
        type.normalize(vnode);
      }
    } else if (children) {
      vnode.shapeFlag |= isString(children) ? 8 : 16;
    }
    if (vnode.key !== vnode.key) {
      warn$1(`VNode created with invalid key (NaN). VNode type:`, vnode.type);
    }
    if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) {
      currentBlock.push(vnode);
    }
    return vnode;
  }
  var createVNode = true ? createVNodeWithArgsTransform : _createVNode;
  function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) {
      if (!type) {
        warn$1(`Invalid vnode type when creating vnode: ${type}.`);
      }
      type = Comment;
    }
    if (isVNode(type)) {
      const cloned = cloneVNode(
        type,
        props,
        true
        /* mergeRef: true */
      );
      if (children) {
        normalizeChildren(cloned, children);
      }
      if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
        if (cloned.shapeFlag & 6) {
          currentBlock[currentBlock.indexOf(type)] = cloned;
        } else {
          currentBlock.push(cloned);
        }
      }
      cloned.patchFlag = -2;
      return cloned;
    }
    if (isClassComponent(type)) {
      type = type.__vccOpts;
    }
    if (props) {
      props = guardReactiveProps(props);
      let { class: klass, style } = props;
      if (klass && !isString(klass)) {
        props.class = normalizeClass(klass);
      }
      if (isObject(style)) {
        if (isProxy(style) && !isArray(style)) {
          style = extend({}, style);
        }
        props.style = normalizeStyle(style);
      }
    }
    const shapeFlag = isString(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject(type) ? 4 : isFunction(type) ? 2 : 0;
    if (shapeFlag & 4 && isProxy(type)) {
      type = toRaw(type);
      warn$1(
        `Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with \`markRaw\` or using \`shallowRef\` instead of \`ref\`.`,
        `
Component that was made reactive: `,
        type
      );
    }
    return createBaseVNode(
      type,
      props,
      children,
      patchFlag,
      dynamicProps,
      shapeFlag,
      isBlockNode,
      true
    );
  }
  function guardReactiveProps(props) {
    if (!props) return null;
    return isProxy(props) || isInternalObject(props) ? extend({}, props) : props;
  }
  function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props, ref: ref2, patchFlag, children, transition } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
      __v_isVNode: true,
      __v_skip: true,
      type: vnode.type,
      props: mergedProps,
      key: mergedProps && normalizeKey(mergedProps),
      ref: extraProps && extraProps.ref ? (
        // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref2 ? isArray(ref2) ? ref2.concat(normalizeRef(extraProps)) : [ref2, normalizeRef(extraProps)] : normalizeRef(extraProps)
      ) : ref2,
      scopeId: vnode.scopeId,
      slotScopeIds: vnode.slotScopeIds,
      children: patchFlag === -1 && isArray(children) ? children.map(deepCloneVNode) : children,
      target: vnode.target,
      targetStart: vnode.targetStart,
      targetAnchor: vnode.targetAnchor,
      staticCount: vnode.staticCount,
      shapeFlag: vnode.shapeFlag,
      // if the vnode is cloned with extra props, we can no longer assume its
      // existing patch flag to be reliable and need to add the FULL_PROPS flag.
      // note: preserve flag for fragments since they use the flag for children
      // fast paths only.
      patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
      dynamicProps: vnode.dynamicProps,
      dynamicChildren: vnode.dynamicChildren,
      appContext: vnode.appContext,
      dirs: vnode.dirs,
      transition,
      // These should technically only be non-null on mounted VNodes. However,
      // they *should* be copied for kept-alive vnodes. So we just always copy
      // them since them being non-null during a mount doesn't affect the logic as
      // they will simply be overwritten.
      component: vnode.component,
      suspense: vnode.suspense,
      ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
      ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
      el: vnode.el,
      anchor: vnode.anchor,
      ctx: vnode.ctx,
      ce: vnode.ce
    };
    if (transition && cloneTransition) {
      setTransitionHooks(
        cloned,
        transition.clone(cloned)
      );
    }
    return cloned;
  }
  function deepCloneVNode(vnode) {
    const cloned = cloneVNode(vnode);
    if (isArray(vnode.children)) {
      cloned.children = vnode.children.map(deepCloneVNode);
    }
    return cloned;
  }
  function createTextVNode(text3 = " ", flag = 0) {
    return createVNode(Text, null, text3, flag);
  }
  function createStaticVNode(content, numberOfNodes) {
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
  }
  function createCommentVNode(text3 = "", asBlock = false) {
    return asBlock ? (openBlock(), createBlock(Comment, null, text3)) : createVNode(Comment, null, text3);
  }
  function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") {
      return createVNode(Comment);
    } else if (isArray(child)) {
      return createVNode(
        Fragment,
        null,
        // #3666, avoid reference pollution when reusing vnode
        child.slice()
      );
    } else if (isVNode(child)) {
      return cloneIfMounted(child);
    } else {
      return createVNode(Text, null, String(child));
    }
  }
  function cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
  }
  function normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children == null) {
      children = null;
    } else if (isArray(children)) {
      type = 16;
    } else if (typeof children === "object") {
      if (shapeFlag & (1 | 64)) {
        const slot = children.default;
        if (slot) {
          slot._c && (slot._d = false);
          normalizeChildren(vnode, slot());
          slot._c && (slot._d = true);
        }
        return;
      } else {
        type = 32;
        const slotFlag = children._;
        if (!slotFlag && !isInternalObject(children)) {
          children._ctx = currentRenderingInstance;
        } else if (slotFlag === 3 && currentRenderingInstance) {
          if (currentRenderingInstance.slots._ === 1) {
            children._ = 1;
          } else {
            children._ = 2;
            vnode.patchFlag |= 1024;
          }
        }
      }
    } else if (isFunction(children)) {
      children = { default: children, _ctx: currentRenderingInstance };
      type = 32;
    } else {
      children = String(children);
      if (shapeFlag & 64) {
        type = 16;
        children = [createTextVNode(children)];
      } else {
        type = 8;
      }
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
  }
  function mergeProps(...args) {
    const ret = {};
    for (let i = 0; i < args.length; i++) {
      const toMerge = args[i];
      for (const key in toMerge) {
        if (key === "class") {
          if (ret.class !== toMerge.class) {
            ret.class = normalizeClass([ret.class, toMerge.class]);
          }
        } else if (key === "style") {
          ret.style = normalizeStyle([ret.style, toMerge.style]);
        } else if (isOn(key)) {
          const existing = ret[key];
          const incoming = toMerge[key];
          if (incoming && existing !== incoming && !(isArray(existing) && existing.includes(incoming))) {
            ret[key] = existing ? [].concat(existing, incoming) : incoming;
          }
        } else if (key !== "") {
          ret[key] = toMerge[key];
        }
      }
    }
    return ret;
  }
  function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7, [
      vnode,
      prevVNode
    ]);
  }
  var emptyAppContext = createAppContext();
  var uid = 0;
  function createComponentInstance(vnode, parent2, suspense) {
    const type = vnode.type;
    const appContext = (parent2 ? parent2.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
      uid: uid++,
      vnode,
      type,
      parent: parent2,
      appContext,
      root: null,
      // to be immediately set
      next: null,
      subTree: null,
      // will be set synchronously right after creation
      effect: null,
      update: null,
      // will be set synchronously right after creation
      job: null,
      scope: new EffectScope(
        true
        /* detached */
      ),
      render: null,
      proxy: null,
      exposed: null,
      exposeProxy: null,
      withProxy: null,
      provides: parent2 ? parent2.provides : Object.create(appContext.provides),
      ids: parent2 ? parent2.ids : ["", 0, 0],
      accessCache: null,
      renderCache: [],
      // local resolved assets
      components: null,
      directives: null,
      // resolved props and emits options
      propsOptions: normalizePropsOptions(type, appContext),
      emitsOptions: normalizeEmitsOptions(type, appContext),
      // emit
      emit: null,
      // to be set immediately
      emitted: null,
      // props default value
      propsDefaults: EMPTY_OBJ,
      // inheritAttrs
      inheritAttrs: type.inheritAttrs,
      // state
      ctx: EMPTY_OBJ,
      data: EMPTY_OBJ,
      props: EMPTY_OBJ,
      attrs: EMPTY_OBJ,
      slots: EMPTY_OBJ,
      refs: EMPTY_OBJ,
      setupState: EMPTY_OBJ,
      setupContext: null,
      // suspense related
      suspense,
      suspenseId: suspense ? suspense.pendingId : 0,
      asyncDep: null,
      asyncResolved: false,
      // lifecycle hooks
      // not using enums here because it results in computed properties
      isMounted: false,
      isUnmounted: false,
      isDeactivated: false,
      bc: null,
      c: null,
      bm: null,
      m: null,
      bu: null,
      u: null,
      um: null,
      bum: null,
      da: null,
      a: null,
      rtg: null,
      rtc: null,
      ec: null,
      sp: null
    };
    if (true) {
      instance.ctx = createDevRenderContext(instance);
    } else {
      instance.ctx = { _: instance };
    }
    instance.root = parent2 ? parent2.root : instance;
    instance.emit = emit.bind(null, instance);
    if (vnode.ce) {
      vnode.ce(instance);
    }
    return instance;
  }
  var currentInstance = null;
  var getCurrentInstance = () => currentInstance || currentRenderingInstance;
  var internalSetCurrentInstance;
  var setInSSRSetupState;
  {
    const g = getGlobalThis();
    const registerGlobalSetter = (key, setter) => {
      let setters;
      if (!(setters = g[key])) setters = g[key] = [];
      setters.push(setter);
      return (v) => {
        if (setters.length > 1) setters.forEach((set) => set(v));
        else setters[0](v);
      };
    };
    internalSetCurrentInstance = registerGlobalSetter(
      `__VUE_INSTANCE_SETTERS__`,
      (v) => currentInstance = v
    );
    setInSSRSetupState = registerGlobalSetter(
      `__VUE_SSR_SETTERS__`,
      (v) => isInSSRComponentSetup = v
    );
  }
  var setCurrentInstance = (instance) => {
    const prev = currentInstance;
    internalSetCurrentInstance(instance);
    instance.scope.on();
    return () => {
      instance.scope.off();
      internalSetCurrentInstance(prev);
    };
  };
  var unsetCurrentInstance = () => {
    currentInstance && currentInstance.scope.off();
    internalSetCurrentInstance(null);
  };
  var isBuiltInTag = /* @__PURE__ */ makeMap("slot,component");
  function validateComponentName(name, { isNativeTag }) {
    if (isBuiltInTag(name) || isNativeTag(name)) {
      warn$1(
        "Do not use built-in or reserved HTML elements as component id: " + name
      );
    }
  }
  function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
  }
  var isInSSRComponentSetup = false;
  function setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && setInSSRSetupState(isSSR);
    const { props, children } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children, optimized);
    const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && setInSSRSetupState(false);
    return setupResult;
  }
  function setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    if (true) {
      if (Component.name) {
        validateComponentName(Component.name, instance.appContext.config);
      }
      if (Component.components) {
        const names = Object.keys(Component.components);
        for (let i = 0; i < names.length; i++) {
          validateComponentName(names[i], instance.appContext.config);
        }
      }
      if (Component.directives) {
        const names = Object.keys(Component.directives);
        for (let i = 0; i < names.length; i++) {
          validateDirectiveName(names[i]);
        }
      }
      if (Component.compilerOptions && isRuntimeOnly()) {
        warn$1(
          `"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.`
        );
      }
    }
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
    if (true) {
      exposePropsOnRenderContext(instance);
    }
    const { setup } = Component;
    if (setup) {
      pauseTracking();
      const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
      const reset3 = setCurrentInstance(instance);
      const setupResult = callWithErrorHandling(
        setup,
        instance,
        0,
        [
          true ? shallowReadonly(instance.props) : instance.props,
          setupContext
        ]
      );
      const isAsyncSetup = isPromise(setupResult);
      resetTracking();
      reset3();
      if ((isAsyncSetup || instance.sp) && !isAsyncWrapper(instance)) {
        markAsyncBoundary(instance);
      }
      if (isAsyncSetup) {
        setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
        if (isSSR) {
          return setupResult.then((resolvedResult) => {
            handleSetupResult(instance, resolvedResult, isSSR);
          }).catch((e) => {
            handleError(e, instance, 0);
          });
        } else {
          instance.asyncDep = setupResult;
          if (!instance.suspense) {
            const name = (_a = Component.name) != null ? _a : "Anonymous";
            warn$1(
              `Component <${name}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
            );
          }
        }
      } else {
        handleSetupResult(instance, setupResult, isSSR);
      }
    } else {
      finishComponentSetup(instance, isSSR);
    }
  }
  function handleSetupResult(instance, setupResult, isSSR) {
    if (isFunction(setupResult)) {
      if (instance.type.__ssrInlineRender) {
        instance.ssrRender = setupResult;
      } else {
        instance.render = setupResult;
      }
    } else if (isObject(setupResult)) {
      if (isVNode(setupResult)) {
        warn$1(
          `setup() should not return VNodes directly - return a render function instead.`
        );
      }
      if (true) {
        instance.devtoolsRawSetupState = setupResult;
      }
      instance.setupState = proxyRefs(setupResult);
      if (true) {
        exposeSetupStateOnRenderContext(instance);
      }
    } else if (setupResult !== void 0) {
      warn$1(
        `setup() should return an object. Received: ${setupResult === null ? "null" : typeof setupResult}`
      );
    }
    finishComponentSetup(instance, isSSR);
  }
  var compile;
  var installWithProxy;
  function registerRuntimeCompiler(_compile) {
    compile = _compile;
    installWithProxy = (i) => {
      if (i.render._rc) {
        i.withProxy = new Proxy(i.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
      }
    };
  }
  var isRuntimeOnly = () => !compile;
  function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
      if (!isSSR && compile && !Component.render) {
        const template = Component.template || __VUE_OPTIONS_API__ && resolveMergedOptions(instance).template;
        if (template) {
          if (true) {
            startMeasure(instance, `compile`);
          }
          const { isCustomElement, compilerOptions } = instance.appContext.config;
          const { delimiters, compilerOptions: componentCompilerOptions } = Component;
          const finalCompilerOptions = extend(
            extend(
              {
                isCustomElement,
                delimiters
              },
              compilerOptions
            ),
            componentCompilerOptions
          );
          Component.render = compile(template, finalCompilerOptions);
          if (true) {
            endMeasure(instance, `compile`);
          }
        }
      }
      instance.render = Component.render || NOOP;
      if (installWithProxy) {
        installWithProxy(instance);
      }
    }
    if (__VUE_OPTIONS_API__ && true) {
      const reset3 = setCurrentInstance(instance);
      pauseTracking();
      try {
        applyOptions(instance);
      } finally {
        resetTracking();
        reset3();
      }
    }
    if (!Component.render && instance.render === NOOP && !isSSR) {
      if (!compile && Component.template) {
        warn$1(
          `Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".`
        );
      } else {
        warn$1(`Component is missing template or render function: `, Component);
      }
    }
  }
  var attrsProxyHandlers = true ? {
    get(target2, key) {
      markAttrsAccessed();
      track(target2, "get", "");
      return target2[key];
    },
    set() {
      warn$1(`setupContext.attrs is readonly.`);
      return false;
    },
    deleteProperty() {
      warn$1(`setupContext.attrs is readonly.`);
      return false;
    }
  } : {
    get(target2, key) {
      track(target2, "get", "");
      return target2[key];
    }
  };
  function getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
      get(target2, key) {
        track(instance, "get", "$slots");
        return target2[key];
      }
    });
  }
  function createSetupContext(instance) {
    const expose = (exposed) => {
      if (true) {
        if (instance.exposed) {
          warn$1(`expose() should be called only once per setup().`);
        }
        if (exposed != null) {
          let exposedType = typeof exposed;
          if (exposedType === "object") {
            if (isArray(exposed)) {
              exposedType = "array";
            } else if (isRef2(exposed)) {
              exposedType = "ref";
            }
          }
          if (exposedType !== "object") {
            warn$1(
              `expose() should be passed a plain object, received ${exposedType}.`
            );
          }
        }
      }
      instance.exposed = exposed || {};
    };
    if (true) {
      let attrsProxy;
      let slotsProxy;
      return Object.freeze({
        get attrs() {
          return attrsProxy || (attrsProxy = new Proxy(instance.attrs, attrsProxyHandlers));
        },
        get slots() {
          return slotsProxy || (slotsProxy = getSlotsProxy(instance));
        },
        get emit() {
          return (event, ...args) => instance.emit(event, ...args);
        },
        expose
      });
    } else {
      return {
        attrs: new Proxy(instance.attrs, attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose
      };
    }
  }
  function getComponentPublicInstance(instance) {
    if (instance.exposed) {
      return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
        get(target2, key) {
          if (key in target2) {
            return target2[key];
          } else if (key in publicPropertiesMap) {
            return publicPropertiesMap[key](instance);
          }
        },
        has(target2, key) {
          return key in target2 || key in publicPropertiesMap;
        }
      }));
    } else {
      return instance.proxy;
    }
  }
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = (str) => str.replace(classifyRE, (c) => c.toUpperCase()).replace(/[-_]/g, "");
  function getComponentName(Component, includeInferred = true) {
    return isFunction(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
  }
  function formatComponentName(instance, Component, isRoot = false) {
    let name = getComponentName(Component);
    if (!name && Component.__file) {
      const match = Component.__file.match(/([^/\\]+)\.\w+$/);
      if (match) {
        name = match[1];
      }
    }
    if (!name && instance && instance.parent) {
      const inferFromRegistry = (registry2) => {
        for (const key in registry2) {
          if (registry2[key] === Component) {
            return key;
          }
        }
      };
      name = inferFromRegistry(
        instance.components || instance.parent.type.components
      ) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
  }
  function isClassComponent(value) {
    return isFunction(value) && "__vccOpts" in value;
  }
  var computed2 = (getterOrOptions, debugOptions) => {
    const c = computed(getterOrOptions, debugOptions, isInSSRComponentSetup);
    if (true) {
      const i = getCurrentInstance();
      if (i && i.appContext.config.warnRecursiveComputed) {
        c._warnRecursive = true;
      }
    }
    return c;
  };
  function h(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
      if (isObject(propsOrChildren) && !isArray(propsOrChildren)) {
        if (isVNode(propsOrChildren)) {
          return createVNode(type, null, [propsOrChildren]);
        }
        return createVNode(type, propsOrChildren);
      } else {
        return createVNode(type, null, propsOrChildren);
      }
    } else {
      if (l > 3) {
        children = Array.prototype.slice.call(arguments, 2);
      } else if (l === 3 && isVNode(children)) {
        children = [children];
      }
      return createVNode(type, propsOrChildren, children);
    }
  }
  function initCustomFormatter() {
    if (typeof window === "undefined") {
      return;
    }
    const vueStyle = { style: "color:#3ba776" };
    const numberStyle = { style: "color:#1677ff" };
    const stringStyle = { style: "color:#f5222d" };
    const keywordStyle = { style: "color:#eb2f96" };
    const formatter = {
      __vue_custom_formatter: true,
      header(obj) {
        if (!isObject(obj)) {
          return null;
        }
        if (obj.__isVue) {
          return ["div", vueStyle, `VueInstance`];
        } else if (isRef2(obj)) {
          return [
            "div",
            {},
            ["span", vueStyle, genRefFlag(obj)],
            "<",
            // avoid debugger accessing value affecting behavior
            formatValue("_value" in obj ? obj._value : obj),
            `>`
          ];
        } else if (isReactive(obj)) {
          return [
            "div",
            {},
            ["span", vueStyle, isShallow(obj) ? "ShallowReactive" : "Reactive"],
            "<",
            formatValue(obj),
            `>${isReadonly(obj) ? ` (readonly)` : ``}`
          ];
        } else if (isReadonly(obj)) {
          return [
            "div",
            {},
            ["span", vueStyle, isShallow(obj) ? "ShallowReadonly" : "Readonly"],
            "<",
            formatValue(obj),
            ">"
          ];
        }
        return null;
      },
      hasBody(obj) {
        return obj && obj.__isVue;
      },
      body(obj) {
        if (obj && obj.__isVue) {
          return [
            "div",
            {},
            ...formatInstance(obj.$)
          ];
        }
      }
    };
    function formatInstance(instance) {
      const blocks = [];
      if (instance.type.props && instance.props) {
        blocks.push(createInstanceBlock("props", toRaw(instance.props)));
      }
      if (instance.setupState !== EMPTY_OBJ) {
        blocks.push(createInstanceBlock("setup", instance.setupState));
      }
      if (instance.data !== EMPTY_OBJ) {
        blocks.push(createInstanceBlock("data", toRaw(instance.data)));
      }
      const computed3 = extractKeys(instance, "computed");
      if (computed3) {
        blocks.push(createInstanceBlock("computed", computed3));
      }
      const injected = extractKeys(instance, "inject");
      if (injected) {
        blocks.push(createInstanceBlock("injected", injected));
      }
      blocks.push([
        "div",
        {},
        [
          "span",
          {
            style: keywordStyle.style + ";opacity:0.66"
          },
          "$ (internal): "
        ],
        ["object", { object: instance }]
      ]);
      return blocks;
    }
    function createInstanceBlock(type, target2) {
      target2 = extend({}, target2);
      if (!Object.keys(target2).length) {
        return ["span", {}];
      }
      return [
        "div",
        { style: "line-height:1.25em;margin-bottom:0.6em" },
        [
          "div",
          {
            style: "color:#476582"
          },
          type
        ],
        [
          "div",
          {
            style: "padding-left:1.25em"
          },
          ...Object.keys(target2).map((key) => {
            return [
              "div",
              {},
              ["span", keywordStyle, key + ": "],
              formatValue(target2[key], false)
            ];
          })
        ]
      ];
    }
    function formatValue(v, asRaw = true) {
      if (typeof v === "number") {
        return ["span", numberStyle, v];
      } else if (typeof v === "string") {
        return ["span", stringStyle, JSON.stringify(v)];
      } else if (typeof v === "boolean") {
        return ["span", keywordStyle, v];
      } else if (isObject(v)) {
        return ["object", { object: asRaw ? toRaw(v) : v }];
      } else {
        return ["span", stringStyle, String(v)];
      }
    }
    function extractKeys(instance, type) {
      const Comp = instance.type;
      if (isFunction(Comp)) {
        return;
      }
      const extracted = {};
      for (const key in instance.ctx) {
        if (isKeyOfType(Comp, key, type)) {
          extracted[key] = instance.ctx[key];
        }
      }
      return extracted;
    }
    function isKeyOfType(Comp, key, type) {
      const opts = Comp[type];
      if (isArray(opts) && opts.includes(key) || isObject(opts) && key in opts) {
        return true;
      }
      if (Comp.extends && isKeyOfType(Comp.extends, key, type)) {
        return true;
      }
      if (Comp.mixins && Comp.mixins.some((m) => isKeyOfType(m, key, type))) {
        return true;
      }
    }
    function genRefFlag(v) {
      if (isShallow(v)) {
        return `ShallowRef`;
      }
      if (v.effect) {
        return `ComputedRef`;
      }
      return `Ref`;
    }
    if (window.devtoolsFormatters) {
      window.devtoolsFormatters.push(formatter);
    } else {
      window.devtoolsFormatters = [formatter];
    }
  }
  function withMemo(memo2, render2, cache, index) {
    const cached = cache[index];
    if (cached && isMemoSame(cached, memo2)) {
      return cached;
    }
    const ret = render2();
    ret.memo = memo2.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
  }
  function isMemoSame(cached, memo2) {
    const prev = cached.memo;
    if (prev.length != memo2.length) {
      return false;
    }
    for (let i = 0; i < prev.length; i++) {
      if (hasChanged(prev[i], memo2[i])) {
        return false;
      }
    }
    if (isBlockTreeEnabled > 0 && currentBlock) {
      currentBlock.push(cached);
    }
    return true;
  }
  var version = "3.5.13";
  var warn2 = true ? warn$1 : NOOP;
  var ErrorTypeStrings = ErrorTypeStrings$1;
  var devtools = true ? devtools$1 : void 0;
  var setDevtoolsHook = true ? setDevtoolsHook$1 : NOOP;
  var _ssrUtils = {
    createComponentInstance,
    setupComponent,
    renderComponentRoot,
    setCurrentRenderingInstance,
    isVNode,
    normalizeVNode,
    getComponentPublicInstance,
    ensureValidVNode,
    pushWarningContext,
    popWarningContext
  };
  var ssrUtils = _ssrUtils;
  var resolveFilter = null;
  var compatUtils = null;
  var DeprecationTypes = null;

  // node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js
  var policy = void 0;
  var tt = typeof window !== "undefined" && window.trustedTypes;
  if (tt) {
    try {
      policy = /* @__PURE__ */ tt.createPolicy("vue", {
        createHTML: (val) => val
      });
    } catch (e) {
      warn2(`Error creating trusted types policy: ${e}`);
    }
  }
  var unsafeToTrustedHTML = policy ? (val) => policy.createHTML(val) : (val) => val;
  var svgNS = "http://www.w3.org/2000/svg";
  var mathmlNS = "http://www.w3.org/1998/Math/MathML";
  var doc = typeof document !== "undefined" ? document : null;
  var templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
  var nodeOps = {
    insert: (child, parent2, anchor) => {
      parent2.insertBefore(child, anchor || null);
    },
    remove: (child) => {
      const parent2 = child.parentNode;
      if (parent2) {
        parent2.removeChild(child);
      }
    },
    createElement: (tag, namespace, is3, props) => {
      const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is3 ? doc.createElement(tag, { is: is3 }) : doc.createElement(tag);
      if (tag === "select" && props && props.multiple != null) {
        el.setAttribute("multiple", props.multiple);
      }
      return el;
    },
    createText: (text3) => doc.createTextNode(text3),
    createComment: (text3) => doc.createComment(text3),
    setText: (node, text3) => {
      node.nodeValue = text3;
    },
    setElementText: (el, text3) => {
      el.textContent = text3;
    },
    parentNode: (node) => node.parentNode,
    nextSibling: (node) => node.nextSibling,
    querySelector: (selector) => doc.querySelector(selector),
    setScopeId(el, id) {
      el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent(content, parent2, anchor, namespace, start, end) {
      const before = anchor ? anchor.previousSibling : parent2.lastChild;
      if (start && (start === end || start.nextSibling)) {
        while (true) {
          parent2.insertBefore(start.cloneNode(true), anchor);
          if (start === end || !(start = start.nextSibling)) break;
        }
      } else {
        templateContainer.innerHTML = unsafeToTrustedHTML(
          namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content
        );
        const template = templateContainer.content;
        if (namespace === "svg" || namespace === "mathml") {
          const wrapper3 = template.firstChild;
          while (wrapper3.firstChild) {
            template.appendChild(wrapper3.firstChild);
          }
          template.removeChild(wrapper3);
        }
        parent2.insertBefore(template, anchor);
      }
      return [
        // first
        before ? before.nextSibling : parent2.firstChild,
        // last
        anchor ? anchor.previousSibling : parent2.lastChild
      ];
    }
  };
  var TRANSITION = "transition";
  var ANIMATION = "animation";
  var vtcKey = Symbol("_vtc");
  var DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
      type: Boolean,
      default: true
    },
    duration: [String, Number, Object],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
  };
  var TransitionPropsValidators = /* @__PURE__ */ extend(
    {},
    BaseTransitionPropsValidators,
    DOMTransitionPropsValidators
  );
  var decorate$1 = (t) => {
    t.displayName = "Transition";
    t.props = TransitionPropsValidators;
    return t;
  };
  var Transition = /* @__PURE__ */ decorate$1(
    (props, { slots }) => h(BaseTransition, resolveTransitionProps(props), slots)
  );
  var callHook2 = (hook, args = []) => {
    if (isArray(hook)) {
      hook.forEach((h2) => h2(...args));
    } else if (hook) {
      hook(...args);
    }
  };
  var hasExplicitCallback = (hook) => {
    return hook ? isArray(hook) ? hook.some((h2) => h2.length > 1) : hook.length > 1 : false;
  };
  function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for (const key in rawProps) {
      if (!(key in DOMTransitionPropsValidators)) {
        baseProps[key] = rawProps[key];
      }
    }
    if (rawProps.css === false) {
      return baseProps;
    }
    const {
      name = "v",
      type,
      duration,
      enterFromClass = `${name}-enter-from`,
      enterActiveClass = `${name}-enter-active`,
      enterToClass = `${name}-enter-to`,
      appearFromClass = enterFromClass,
      appearActiveClass = enterActiveClass,
      appearToClass = enterToClass,
      leaveFromClass = `${name}-leave-from`,
      leaveActiveClass = `${name}-leave-active`,
      leaveToClass = `${name}-leave-to`
    } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const {
      onBeforeEnter,
      onEnter,
      onEnterCancelled,
      onLeave,
      onLeaveCancelled,
      onBeforeAppear = onBeforeEnter,
      onAppear = onEnter,
      onAppearCancelled = onEnterCancelled
    } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled) => {
      el._enterCancelled = isCancelled;
      removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
      removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
      done && done();
    };
    const finishLeave = (el, done) => {
      el._isLeaving = false;
      removeTransitionClass(el, leaveFromClass);
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
      done && done();
    };
    const makeEnterHook = (isAppear) => {
      return (el, done) => {
        const hook = isAppear ? onAppear : onEnter;
        const resolve2 = () => finishEnter(el, isAppear, done);
        callHook2(hook, [el, resolve2]);
        nextFrame(() => {
          removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
          addTransitionClass(el, isAppear ? appearToClass : enterToClass);
          if (!hasExplicitCallback(hook)) {
            whenTransitionEnds(el, type, enterDuration, resolve2);
          }
        });
      };
    };
    return extend(baseProps, {
      onBeforeEnter(el) {
        callHook2(onBeforeEnter, [el]);
        addTransitionClass(el, enterFromClass);
        addTransitionClass(el, enterActiveClass);
      },
      onBeforeAppear(el) {
        callHook2(onBeforeAppear, [el]);
        addTransitionClass(el, appearFromClass);
        addTransitionClass(el, appearActiveClass);
      },
      onEnter: makeEnterHook(false),
      onAppear: makeEnterHook(true),
      onLeave(el, done) {
        el._isLeaving = true;
        const resolve2 = () => finishLeave(el, done);
        addTransitionClass(el, leaveFromClass);
        if (!el._enterCancelled) {
          forceReflow();
          addTransitionClass(el, leaveActiveClass);
        } else {
          addTransitionClass(el, leaveActiveClass);
          forceReflow();
        }
        nextFrame(() => {
          if (!el._isLeaving) {
            return;
          }
          removeTransitionClass(el, leaveFromClass);
          addTransitionClass(el, leaveToClass);
          if (!hasExplicitCallback(onLeave)) {
            whenTransitionEnds(el, type, leaveDuration, resolve2);
          }
        });
        callHook2(onLeave, [el, resolve2]);
      },
      onEnterCancelled(el) {
        finishEnter(el, false, void 0, true);
        callHook2(onEnterCancelled, [el]);
      },
      onAppearCancelled(el) {
        finishEnter(el, true, void 0, true);
        callHook2(onAppearCancelled, [el]);
      },
      onLeaveCancelled(el) {
        finishLeave(el);
        callHook2(onLeaveCancelled, [el]);
      }
    });
  }
  function normalizeDuration(duration) {
    if (duration == null) {
      return null;
    } else if (isObject(duration)) {
      return [NumberOf(duration.enter), NumberOf(duration.leave)];
    } else {
      const n = NumberOf(duration);
      return [n, n];
    }
  }
  function NumberOf(val) {
    const res = toNumber(val);
    if (true) {
      assertNumber(res, "<transition> explicit duration");
    }
    return res;
  }
  function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c) => c && el.classList.add(c));
    (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
  }
  function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c) => c && el.classList.remove(c));
    const _vtc = el[vtcKey];
    if (_vtc) {
      _vtc.delete(cls);
      if (!_vtc.size) {
        el[vtcKey] = void 0;
      }
    }
  }
  function nextFrame(cb) {
    requestAnimationFrame(() => {
      requestAnimationFrame(cb);
    });
  }
  var endId = 0;
  function whenTransitionEnds(el, expectedType, explicitTimeout, resolve2) {
    const id = el._endId = ++endId;
    const resolveIfNotStale = () => {
      if (id === el._endId) {
        resolve2();
      }
    };
    if (explicitTimeout != null) {
      return setTimeout(resolveIfNotStale, explicitTimeout);
    }
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) {
      return resolve2();
    }
    const endEvent = type + "end";
    let ended = 0;
    const end = () => {
      el.removeEventListener(endEvent, onEnd);
      resolveIfNotStale();
    };
    const onEnd = (e) => {
      if (e.target === el && ++ended >= propCount) {
        end();
      }
    };
    setTimeout(() => {
      if (ended < propCount) {
        end();
      }
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
  }
  function getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key) => (styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${TRANSITION}Duration`);
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${ANIMATION}Duration`);
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === TRANSITION) {
      if (transitionTimeout > 0) {
        type = TRANSITION;
        timeout = transitionTimeout;
        propCount = transitionDurations.length;
      }
    } else if (expectedType === ANIMATION) {
      if (animationTimeout > 0) {
        type = ANIMATION;
        timeout = animationTimeout;
        propCount = animationDurations.length;
      }
    } else {
      timeout = Math.max(transitionTimeout, animationTimeout);
      type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
      propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === TRANSITION && /\b(transform|all)(,|$)/.test(
      getStyleProperties(`${TRANSITION}Property`).toString()
    );
    return {
      type,
      timeout,
      propCount,
      hasTransform
    };
  }
  function getTimeout(delays, durations) {
    while (delays.length < durations.length) {
      delays = delays.concat(delays);
    }
    return Math.max(...durations.map((d, i) => toMs(d) + toMs(delays[i])));
  }
  function toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
  }
  function forceReflow() {
    return document.body.offsetHeight;
  }
  function patchClass(el, value, isSVG) {
    const transitionClasses = el[vtcKey];
    if (transitionClasses) {
      value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
    }
    if (value == null) {
      el.removeAttribute("class");
    } else if (isSVG) {
      el.setAttribute("class", value);
    } else {
      el.className = value;
    }
  }
  var vShowOriginalDisplay = Symbol("_vod");
  var vShowHidden = Symbol("_vsh");
  var vShow = {
    beforeMount(el, { value }, { transition }) {
      el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
      if (transition && value) {
        transition.beforeEnter(el);
      } else {
        setDisplay(el, value);
      }
    },
    mounted(el, { value }, { transition }) {
      if (transition && value) {
        transition.enter(el);
      }
    },
    updated(el, { value, oldValue }, { transition }) {
      if (!value === !oldValue) return;
      if (transition) {
        if (value) {
          transition.beforeEnter(el);
          setDisplay(el, true);
          transition.enter(el);
        } else {
          transition.leave(el, () => {
            setDisplay(el, false);
          });
        }
      } else {
        setDisplay(el, value);
      }
    },
    beforeUnmount(el, { value }) {
      setDisplay(el, value);
    }
  };
  if (true) {
    vShow.name = "show";
  }
  function setDisplay(el, value) {
    el.style.display = value ? el[vShowOriginalDisplay] : "none";
    el[vShowHidden] = !value;
  }
  function initVShowForSSR() {
    vShow.getSSRProps = ({ value }) => {
      if (!value) {
        return { style: { display: "none" } };
      }
    };
  }
  var CSS_VAR_TEXT = Symbol(true ? "CSS_VAR_TEXT" : "");
  function useCssVars(getter) {
    const instance = getCurrentInstance();
    if (!instance) {
      warn2(`useCssVars is called without current active component instance.`);
      return;
    }
    const updateTeleports = instance.ut = (vars = getter(instance.proxy)) => {
      Array.from(
        document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)
      ).forEach((node) => setVarsOnNode(node, vars));
    };
    if (true) {
      instance.getCssVars = () => getter(instance.proxy);
    }
    const setVars = () => {
      const vars = getter(instance.proxy);
      if (instance.ce) {
        setVarsOnNode(instance.ce, vars);
      } else {
        setVarsOnVNode(instance.subTree, vars);
      }
      updateTeleports(vars);
    };
    onBeforeUpdate(() => {
      queuePostFlushCb(setVars);
    });
    onMounted(() => {
      watch2(setVars, NOOP, { flush: "post" });
      const ob = new MutationObserver(setVars);
      ob.observe(instance.subTree.el.parentNode, { childList: true });
      onUnmounted(() => ob.disconnect());
    });
  }
  function setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
      const suspense = vnode.suspense;
      vnode = suspense.activeBranch;
      if (suspense.pendingBranch && !suspense.isHydrating) {
        suspense.effects.push(() => {
          setVarsOnVNode(suspense.activeBranch, vars);
        });
      }
    }
    while (vnode.component) {
      vnode = vnode.component.subTree;
    }
    if (vnode.shapeFlag & 1 && vnode.el) {
      setVarsOnNode(vnode.el, vars);
    } else if (vnode.type === Fragment) {
      vnode.children.forEach((c) => setVarsOnVNode(c, vars));
    } else if (vnode.type === Static) {
      let { el, anchor } = vnode;
      while (el) {
        setVarsOnNode(el, vars);
        if (el === anchor) break;
        el = el.nextSibling;
      }
    }
  }
  function setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
      const style = el.style;
      let cssText = "";
      for (const key in vars) {
        style.setProperty(`--${key}`, vars[key]);
        cssText += `--${key}: ${vars[key]};`;
      }
      style[CSS_VAR_TEXT] = cssText;
    }
  }
  var displayRE = /(^|;)\s*display\s*:/;
  function patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = isString(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
      if (prev) {
        if (!isString(prev)) {
          for (const key in prev) {
            if (next[key] == null) {
              setStyle(style, key, "");
            }
          }
        } else {
          for (const prevStyle of prev.split(";")) {
            const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
            if (next[key] == null) {
              setStyle(style, key, "");
            }
          }
        }
      }
      for (const key in next) {
        if (key === "display") {
          hasControlledDisplay = true;
        }
        setStyle(style, key, next[key]);
      }
    } else {
      if (isCssString) {
        if (prev !== next) {
          const cssVarText = style[CSS_VAR_TEXT];
          if (cssVarText) {
            next += ";" + cssVarText;
          }
          style.cssText = next;
          hasControlledDisplay = displayRE.test(next);
        }
      } else if (prev) {
        el.removeAttribute("style");
      }
    }
    if (vShowOriginalDisplay in el) {
      el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
      if (el[vShowHidden]) {
        style.display = "none";
      }
    }
  }
  var semicolonRE = /[^\\];\s*$/;
  var importantRE = /\s*!important$/;
  function setStyle(style, name, val) {
    if (isArray(val)) {
      val.forEach((v) => setStyle(style, name, v));
    } else {
      if (val == null) val = "";
      if (true) {
        if (semicolonRE.test(val)) {
          warn2(
            `Unexpected semicolon at the end of '${name}' style value: '${val}'`
          );
        }
      }
      if (name.startsWith("--")) {
        style.setProperty(name, val);
      } else {
        const prefixed = autoPrefix(style, name);
        if (importantRE.test(val)) {
          style.setProperty(
            hyphenate(prefixed),
            val.replace(importantRE, ""),
            "important"
          );
        } else {
          style[prefixed] = val;
        }
      }
    }
  }
  var prefixes = ["Webkit", "Moz", "ms"];
  var prefixCache = {};
  function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) {
      return cached;
    }
    let name = camelize(rawName);
    if (name !== "filter" && name in style) {
      return prefixCache[rawName] = name;
    }
    name = capitalize(name);
    for (let i = 0; i < prefixes.length; i++) {
      const prefixed = prefixes[i] + name;
      if (prefixed in style) {
        return prefixCache[rawName] = prefixed;
      }
    }
    return rawName;
  }
  var xlinkNS = "http://www.w3.org/1999/xlink";
  function patchAttr(el, key, value, isSVG, instance, isBoolean2 = isSpecialBooleanAttr(key)) {
    if (isSVG && key.startsWith("xlink:")) {
      if (value == null) {
        el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
      } else {
        el.setAttributeNS(xlinkNS, key, value);
      }
    } else {
      if (value == null || isBoolean2 && !includeBooleanAttr(value)) {
        el.removeAttribute(key);
      } else {
        el.setAttribute(
          key,
          isBoolean2 ? "" : isSymbol(value) ? String(value) : value
        );
      }
    }
  }
  function patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
      if (value != null) {
        el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
      }
      return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
      const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
      const newValue = value == null ? (
        // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : ""
      ) : String(value);
      if (oldValue !== newValue || !("_value" in el)) {
        el.value = newValue;
      }
      if (value == null) {
        el.removeAttribute(key);
      }
      el._value = value;
      return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
      const type = typeof el[key];
      if (type === "boolean") {
        value = includeBooleanAttr(value);
      } else if (value == null && type === "string") {
        value = "";
        needRemove = true;
      } else if (type === "number") {
        value = 0;
        needRemove = true;
      }
    }
    try {
      el[key] = value;
    } catch (e) {
      if (!needRemove) {
        warn2(
          `Failed setting prop "${key}" on <${tag.toLowerCase()}>: value ${value} is invalid.`,
          e
        );
      }
    }
    needRemove && el.removeAttribute(attrName || key);
  }
  function addEventListener(el, event, handler, options3) {
    el.addEventListener(event, handler, options3);
  }
  function removeEventListener(el, event, handler, options3) {
    el.removeEventListener(event, handler, options3);
  }
  var veiKey = Symbol("_vei");
  function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[veiKey] || (el[veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) {
      existingInvoker.value = true ? sanitizeEventValue(nextValue, rawName) : nextValue;
    } else {
      const [name, options3] = parseName(rawName);
      if (nextValue) {
        const invoker = invokers[rawName] = createInvoker(
          true ? sanitizeEventValue(nextValue, rawName) : nextValue,
          instance
        );
        addEventListener(el, name, invoker, options3);
      } else if (existingInvoker) {
        removeEventListener(el, name, existingInvoker, options3);
        invokers[rawName] = void 0;
      }
    }
  }
  var optionsModifierRE = /(?:Once|Passive|Capture)$/;
  function parseName(name) {
    let options3;
    if (optionsModifierRE.test(name)) {
      options3 = {};
      let m;
      while (m = name.match(optionsModifierRE)) {
        name = name.slice(0, name.length - m[0].length);
        options3[m[0].toLowerCase()] = true;
      }
    }
    const event = name[2] === ":" ? name.slice(3) : hyphenate(name.slice(2));
    return [event, options3];
  }
  var cachedNow = 0;
  var p = /* @__PURE__ */ Promise.resolve();
  var getNow = () => cachedNow || (p.then(() => cachedNow = 0), cachedNow = Date.now());
  function createInvoker(initialValue2, instance) {
    const invoker = (e) => {
      if (!e._vts) {
        e._vts = Date.now();
      } else if (e._vts <= invoker.attached) {
        return;
      }
      callWithAsyncErrorHandling(
        patchStopImmediatePropagation(e, invoker.value),
        instance,
        5,
        [e]
      );
    };
    invoker.value = initialValue2;
    invoker.attached = getNow();
    return invoker;
  }
  function sanitizeEventValue(value, propName) {
    if (isFunction(value) || isArray(value)) {
      return value;
    }
    warn2(
      `Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`
    );
    return NOOP;
  }
  function patchStopImmediatePropagation(e, value) {
    if (isArray(value)) {
      const originalStop = e.stopImmediatePropagation;
      e.stopImmediatePropagation = () => {
        originalStop.call(e);
        e._stopped = true;
      };
      return value.map(
        (fn) => (e2) => !e2._stopped && fn && fn(e2)
      );
    } else {
      return value;
    }
  }
  var isNativeOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
  key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
  var patchProp = (el, key, prevValue, nextValue, namespace, parentComponent) => {
    const isSVG = namespace === "svg";
    if (key === "class") {
      patchClass(el, nextValue, isSVG);
    } else if (key === "style") {
      patchStyle(el, prevValue, nextValue);
    } else if (isOn(key)) {
      if (!isModelListener(key)) {
        patchEvent(el, key, prevValue, nextValue, parentComponent);
      }
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
      patchDOMProp(el, key, nextValue);
      if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) {
        patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
      }
    } else if (
      // #11081 force set props for possible async custom element
      el._isVueCE && (/[A-Z]/.test(key) || !isString(nextValue))
    ) {
      patchDOMProp(el, camelize(key), nextValue, parentComponent, key);
    } else {
      if (key === "true-value") {
        el._trueValue = nextValue;
      } else if (key === "false-value") {
        el._falseValue = nextValue;
      }
      patchAttr(el, key, nextValue, isSVG);
    }
  };
  function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
      if (key === "innerHTML" || key === "textContent") {
        return true;
      }
      if (key in el && isNativeOn(key) && isFunction(value)) {
        return true;
      }
      return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") {
      return false;
    }
    if (key === "form") {
      return false;
    }
    if (key === "list" && el.tagName === "INPUT") {
      return false;
    }
    if (key === "type" && el.tagName === "TEXTAREA") {
      return false;
    }
    if (key === "width" || key === "height") {
      const tag = el.tagName;
      if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") {
        return false;
      }
    }
    if (isNativeOn(key) && isString(value)) {
      return false;
    }
    return key in el;
  }
  var REMOVAL = {};
  // @__NO_SIDE_EFFECTS__
  function defineCustomElement(options3, extraOptions, _createApp) {
    const Comp = defineComponent(options3, extraOptions);
    if (isPlainObject(Comp)) extend(Comp, extraOptions);
    class VueCustomElement extends VueElement {
      constructor(initialProps) {
        super(Comp, initialProps, _createApp);
      }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
  }
  var defineSSRCustomElement = /* @__NO_SIDE_EFFECTS__ */ (options3, extraOptions) => {
    return /* @__PURE__ */ defineCustomElement(options3, extraOptions, createSSRApp);
  };
  var BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
  };
  var VueElement = class _VueElement extends BaseClass {
    constructor(_def, _props = {}, _createApp = createApp) {
      super();
      this._def = _def;
      this._props = _props;
      this._createApp = _createApp;
      this._isVueCE = true;
      this._instance = null;
      this._app = null;
      this._nonce = this._def.nonce;
      this._connected = false;
      this._resolved = false;
      this._numberProps = null;
      this._styleChildren = /* @__PURE__ */ new WeakSet();
      this._ob = null;
      if (this.shadowRoot && _createApp !== createApp) {
        this._root = this.shadowRoot;
      } else {
        if (this.shadowRoot) {
          warn2(
            `Custom element has pre-rendered declarative shadow root but is not defined as hydratable. Use \`defineSSRCustomElement\`.`
          );
        }
        if (_def.shadowRoot !== false) {
          this.attachShadow({ mode: "open" });
          this._root = this.shadowRoot;
        } else {
          this._root = this;
        }
      }
      if (!this._def.__asyncLoader) {
        this._resolveProps(this._def);
      }
    }
    connectedCallback() {
      if (!this.isConnected) return;
      if (!this.shadowRoot) {
        this._parseSlots();
      }
      this._connected = true;
      let parent2 = this;
      while (parent2 = parent2 && (parent2.parentNode || parent2.host)) {
        if (parent2 instanceof _VueElement) {
          this._parent = parent2;
          break;
        }
      }
      if (!this._instance) {
        if (this._resolved) {
          this._setParent();
          this._update();
        } else {
          if (parent2 && parent2._pendingResolve) {
            this._pendingResolve = parent2._pendingResolve.then(() => {
              this._pendingResolve = void 0;
              this._resolveDef();
            });
          } else {
            this._resolveDef();
          }
        }
      }
    }
    _setParent(parent2 = this._parent) {
      if (parent2) {
        this._instance.parent = parent2._instance;
        this._instance.provides = parent2._instance.provides;
      }
    }
    disconnectedCallback() {
      this._connected = false;
      nextTick(() => {
        if (!this._connected) {
          if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
          }
          this._app && this._app.unmount();
          if (this._instance) this._instance.ce = void 0;
          this._app = this._instance = null;
        }
      });
    }
    /**
     * resolve inner component definition (handle possible async component)
     */
    _resolveDef() {
      if (this._pendingResolve) {
        return;
      }
      for (let i = 0; i < this.attributes.length; i++) {
        this._setAttr(this.attributes[i].name);
      }
      this._ob = new MutationObserver((mutations) => {
        for (const m of mutations) {
          this._setAttr(m.attributeName);
        }
      });
      this._ob.observe(this, { attributes: true });
      const resolve2 = (def2, isAsync = false) => {
        this._resolved = true;
        this._pendingResolve = void 0;
        const { props, styles } = def2;
        let numberProps;
        if (props && !isArray(props)) {
          for (const key in props) {
            const opt = props[key];
            if (opt === Number || opt && opt.type === Number) {
              if (key in this._props) {
                this._props[key] = toNumber(this._props[key]);
              }
              (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[camelize(key)] = true;
            }
          }
        }
        this._numberProps = numberProps;
        if (isAsync) {
          this._resolveProps(def2);
        }
        if (this.shadowRoot) {
          this._applyStyles(styles);
        } else if (styles) {
          warn2(
            "Custom element style injection is not supported when using shadowRoot: false"
          );
        }
        this._mount(def2);
      };
      const asyncDef = this._def.__asyncLoader;
      if (asyncDef) {
        this._pendingResolve = asyncDef().then(
          (def2) => resolve2(this._def = def2, true)
        );
      } else {
        resolve2(this._def);
      }
    }
    _mount(def2) {
      if (!def2.name) {
        def2.name = "VueElement";
      }
      this._app = this._createApp(def2);
      if (def2.configureApp) {
        def2.configureApp(this._app);
      }
      this._app._ceVNode = this._createVNode();
      this._app.mount(this._root);
      const exposed = this._instance && this._instance.exposed;
      if (!exposed) return;
      for (const key in exposed) {
        if (!hasOwn(this, key)) {
          Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: () => unref(exposed[key])
          });
        } else if (true) {
          warn2(`Exposed property "${key}" already exists on custom element.`);
        }
      }
    }
    _resolveProps(def2) {
      const { props } = def2;
      const declaredPropKeys = isArray(props) ? props : Object.keys(props || {});
      for (const key of Object.keys(this)) {
        if (key[0] !== "_" && declaredPropKeys.includes(key)) {
          this._setProp(key, this[key]);
        }
      }
      for (const key of declaredPropKeys.map(camelize)) {
        Object.defineProperty(this, key, {
          get() {
            return this._getProp(key);
          },
          set(val) {
            this._setProp(key, val, true, true);
          }
        });
      }
    }
    _setAttr(key) {
      if (key.startsWith("data-v-")) return;
      const has2 = this.hasAttribute(key);
      let value = has2 ? this.getAttribute(key) : REMOVAL;
      const camelKey = camelize(key);
      if (has2 && this._numberProps && this._numberProps[camelKey]) {
        value = toNumber(value);
      }
      this._setProp(camelKey, value, false, true);
    }
    /**
     * @internal
     */
    _getProp(key) {
      return this._props[key];
    }
    /**
     * @internal
     */
    _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
      if (val !== this._props[key]) {
        if (val === REMOVAL) {
          delete this._props[key];
        } else {
          this._props[key] = val;
          if (key === "key" && this._app) {
            this._app._ceVNode.key = val;
          }
        }
        if (shouldUpdate && this._instance) {
          this._update();
        }
        if (shouldReflect) {
          const ob = this._ob;
          ob && ob.disconnect();
          if (val === true) {
            this.setAttribute(hyphenate(key), "");
          } else if (typeof val === "string" || typeof val === "number") {
            this.setAttribute(hyphenate(key), val + "");
          } else if (!val) {
            this.removeAttribute(hyphenate(key));
          }
          ob && ob.observe(this, { attributes: true });
        }
      }
    }
    _update() {
      render(this._createVNode(), this._root);
    }
    _createVNode() {
      const baseProps = {};
      if (!this.shadowRoot) {
        baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
      }
      const vnode = createVNode(this._def, extend(baseProps, this._props));
      if (!this._instance) {
        vnode.ce = (instance) => {
          this._instance = instance;
          instance.ce = this;
          instance.isCE = true;
          if (true) {
            instance.ceReload = (newStyles) => {
              if (this._styles) {
                this._styles.forEach((s) => this._root.removeChild(s));
                this._styles.length = 0;
              }
              this._applyStyles(newStyles);
              this._instance = null;
              this._update();
            };
          }
          const dispatch = (event, args) => {
            this.dispatchEvent(
              new CustomEvent(
                event,
                isPlainObject(args[0]) ? extend({ detail: args }, args[0]) : { detail: args }
              )
            );
          };
          instance.emit = (event, ...args) => {
            dispatch(event, args);
            if (hyphenate(event) !== event) {
              dispatch(hyphenate(event), args);
            }
          };
          this._setParent();
        };
      }
      return vnode;
    }
    _applyStyles(styles, owner) {
      if (!styles) return;
      if (owner) {
        if (owner === this._def || this._styleChildren.has(owner)) {
          return;
        }
        this._styleChildren.add(owner);
      }
      const nonce = this._nonce;
      for (let i = styles.length - 1; i >= 0; i--) {
        const s = document.createElement("style");
        if (nonce) s.setAttribute("nonce", nonce);
        s.textContent = styles[i];
        this.shadowRoot.prepend(s);
        if (true) {
          if (owner) {
            if (owner.__hmrId) {
              if (!this._childStyles) this._childStyles = /* @__PURE__ */ new Map();
              let entry = this._childStyles.get(owner.__hmrId);
              if (!entry) {
                this._childStyles.set(owner.__hmrId, entry = []);
              }
              entry.push(s);
            }
          } else {
            (this._styles || (this._styles = [])).push(s);
          }
        }
      }
    }
    /**
     * Only called when shadowRoot is false
     */
    _parseSlots() {
      const slots = this._slots = {};
      let n;
      while (n = this.firstChild) {
        const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
        (slots[slotName] || (slots[slotName] = [])).push(n);
        this.removeChild(n);
      }
    }
    /**
     * Only called when shadowRoot is false
     */
    _renderSlots() {
      const outlets = (this._teleportTarget || this).querySelectorAll("slot");
      const scopeId = this._instance.type.__scopeId;
      for (let i = 0; i < outlets.length; i++) {
        const o = outlets[i];
        const slotName = o.getAttribute("name") || "default";
        const content = this._slots[slotName];
        const parent2 = o.parentNode;
        if (content) {
          for (const n of content) {
            if (scopeId && n.nodeType === 1) {
              const id = scopeId + "-s";
              const walker = document.createTreeWalker(n, 1);
              n.setAttribute(id, "");
              let child;
              while (child = walker.nextNode()) {
                child.setAttribute(id, "");
              }
            }
            parent2.insertBefore(n, o);
          }
        } else {
          while (o.firstChild) parent2.insertBefore(o.firstChild, o);
        }
        parent2.removeChild(o);
      }
    }
    /**
     * @internal
     */
    _injectChildStyle(comp) {
      this._applyStyles(comp.styles, comp);
    }
    /**
     * @internal
     */
    _removeChildStyle(comp) {
      if (true) {
        this._styleChildren.delete(comp);
        if (this._childStyles && comp.__hmrId) {
          const oldStyles = this._childStyles.get(comp.__hmrId);
          if (oldStyles) {
            oldStyles.forEach((s) => this._root.removeChild(s));
            oldStyles.length = 0;
          }
        }
      }
    }
  };
  function useHost(caller) {
    const instance = getCurrentInstance();
    const el = instance && instance.ce;
    if (el) {
      return el;
    } else if (true) {
      if (!instance) {
        warn2(
          `${caller || "useHost"} called without an active component instance.`
        );
      } else {
        warn2(
          `${caller || "useHost"} can only be used in components defined via defineCustomElement.`
        );
      }
    }
    return null;
  }
  function useShadowRoot() {
    const el = true ? useHost("useShadowRoot") : useHost();
    return el && el.shadowRoot;
  }
  function useCssModule(name = "$style") {
    {
      const instance = getCurrentInstance();
      if (!instance) {
        warn2(`useCssModule must be called inside setup()`);
        return EMPTY_OBJ;
      }
      const modules = instance.type.__cssModules;
      if (!modules) {
        warn2(`Current instance does not have CSS modules injected.`);
        return EMPTY_OBJ;
      }
      const mod = modules[name];
      if (!mod) {
        warn2(`Current instance does not have CSS module named "${name}".`);
        return EMPTY_OBJ;
      }
      return mod;
    }
  }
  var positionMap = /* @__PURE__ */ new WeakMap();
  var newPositionMap = /* @__PURE__ */ new WeakMap();
  var moveCbKey = Symbol("_moveCb");
  var enterCbKey2 = Symbol("_enterCb");
  var decorate = (t) => {
    delete t.props.mode;
    return t;
  };
  var TransitionGroupImpl = /* @__PURE__ */ decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ extend({}, TransitionPropsValidators, {
      tag: String,
      moveClass: String
    }),
    setup(props, { slots }) {
      const instance = getCurrentInstance();
      const state = useTransitionState();
      let prevChildren;
      let children;
      onUpdated(() => {
        if (!prevChildren.length) {
          return;
        }
        const moveClass = props.moveClass || `${props.name || "v"}-move`;
        if (!hasCSSTransform(
          prevChildren[0].el,
          instance.vnode.el,
          moveClass
        )) {
          return;
        }
        prevChildren.forEach(callPendingCbs);
        prevChildren.forEach(recordPosition);
        const movedChildren = prevChildren.filter(applyTranslation);
        forceReflow();
        movedChildren.forEach((c) => {
          const el = c.el;
          const style = el.style;
          addTransitionClass(el, moveClass);
          style.transform = style.webkitTransform = style.transitionDuration = "";
          const cb = el[moveCbKey] = (e) => {
            if (e && e.target !== el) {
              return;
            }
            if (!e || /transform$/.test(e.propertyName)) {
              el.removeEventListener("transitionend", cb);
              el[moveCbKey] = null;
              removeTransitionClass(el, moveClass);
            }
          };
          el.addEventListener("transitionend", cb);
        });
      });
      return () => {
        const rawProps = toRaw(props);
        const cssTransitionProps = resolveTransitionProps(rawProps);
        let tag = rawProps.tag || Fragment;
        prevChildren = [];
        if (children) {
          for (let i = 0; i < children.length; i++) {
            const child = children[i];
            if (child.el && child.el instanceof Element) {
              prevChildren.push(child);
              setTransitionHooks(
                child,
                resolveTransitionHooks(
                  child,
                  cssTransitionProps,
                  state,
                  instance
                )
              );
              positionMap.set(
                child,
                child.el.getBoundingClientRect()
              );
            }
          }
        }
        children = slots.default ? getTransitionRawChildren(slots.default()) : [];
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          if (child.key != null) {
            setTransitionHooks(
              child,
              resolveTransitionHooks(child, cssTransitionProps, state, instance)
            );
          } else if (child.type !== Text) {
            warn2(`<TransitionGroup> children must be keyed.`);
          }
        }
        return createVNode(tag, null, children);
      };
    }
  });
  var TransitionGroup = TransitionGroupImpl;
  function callPendingCbs(c) {
    const el = c.el;
    if (el[moveCbKey]) {
      el[moveCbKey]();
    }
    if (el[enterCbKey2]) {
      el[enterCbKey2]();
    }
  }
  function recordPosition(c) {
    newPositionMap.set(c, c.el.getBoundingClientRect());
  }
  function applyTranslation(c) {
    const oldPos = positionMap.get(c);
    const newPos = newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
      const s = c.el.style;
      s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
      s.transitionDuration = "0s";
      return c;
    }
  }
  function hasCSSTransform(el, root2, moveClass) {
    const clone2 = el.cloneNode();
    const _vtc = el[vtcKey];
    if (_vtc) {
      _vtc.forEach((cls) => {
        cls.split(/\s+/).forEach((c) => c && clone2.classList.remove(c));
      });
    }
    moveClass.split(/\s+/).forEach((c) => c && clone2.classList.add(c));
    clone2.style.display = "none";
    const container = root2.nodeType === 1 ? root2 : root2.parentNode;
    container.appendChild(clone2);
    const { hasTransform } = getTransitionInfo(clone2);
    container.removeChild(clone2);
    return hasTransform;
  }
  var getModelAssigner = (vnode) => {
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return isArray(fn) ? (value) => invokeArrayFns(fn, value) : fn;
  };
  function onCompositionStart(e) {
    e.target.composing = true;
  }
  function onCompositionEnd(e) {
    const target2 = e.target;
    if (target2.composing) {
      target2.composing = false;
      target2.dispatchEvent(new Event("input"));
    }
  }
  var assignKey = Symbol("_assign");
  var vModelText = {
    created(el, { modifiers: { lazy, trim, number: number4 } }, vnode) {
      el[assignKey] = getModelAssigner(vnode);
      const castToNumber = number4 || vnode.props && vnode.props.type === "number";
      addEventListener(el, lazy ? "change" : "input", (e) => {
        if (e.target.composing) return;
        let domValue = el.value;
        if (trim) {
          domValue = domValue.trim();
        }
        if (castToNumber) {
          domValue = looseToNumber(domValue);
        }
        el[assignKey](domValue);
      });
      if (trim) {
        addEventListener(el, "change", () => {
          el.value = el.value.trim();
        });
      }
      if (!lazy) {
        addEventListener(el, "compositionstart", onCompositionStart);
        addEventListener(el, "compositionend", onCompositionEnd);
        addEventListener(el, "change", onCompositionEnd);
      }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted(el, { value }) {
      el.value = value == null ? "" : value;
    },
    beforeUpdate(el, { value, oldValue, modifiers: { lazy, trim, number: number4 } }, vnode) {
      el[assignKey] = getModelAssigner(vnode);
      if (el.composing) return;
      const elValue = (number4 || el.type === "number") && !/^0\d/.test(el.value) ? looseToNumber(el.value) : el.value;
      const newValue = value == null ? "" : value;
      if (elValue === newValue) {
        return;
      }
      if (document.activeElement === el && el.type !== "range") {
        if (lazy && value === oldValue) {
          return;
        }
        if (trim && el.value.trim() === newValue) {
          return;
        }
      }
      el.value = newValue;
    }
  };
  var vModelCheckbox = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created(el, _, vnode) {
      el[assignKey] = getModelAssigner(vnode);
      addEventListener(el, "change", () => {
        const modelValue = el._modelValue;
        const elementValue = getValue(el);
        const checked = el.checked;
        const assign = el[assignKey];
        if (isArray(modelValue)) {
          const index = looseIndexOf(modelValue, elementValue);
          const found = index !== -1;
          if (checked && !found) {
            assign(modelValue.concat(elementValue));
          } else if (!checked && found) {
            const filtered = [...modelValue];
            filtered.splice(index, 1);
            assign(filtered);
          }
        } else if (isSet(modelValue)) {
          const cloned = new Set(modelValue);
          if (checked) {
            cloned.add(elementValue);
          } else {
            cloned.delete(elementValue);
          }
          assign(cloned);
        } else {
          assign(getCheckboxValue(el, checked));
        }
      });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: setChecked,
    beforeUpdate(el, binding, vnode) {
      el[assignKey] = getModelAssigner(vnode);
      setChecked(el, binding, vnode);
    }
  };
  function setChecked(el, { value, oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if (isArray(value)) {
      checked = looseIndexOf(value, vnode.props.value) > -1;
    } else if (isSet(value)) {
      checked = value.has(vnode.props.value);
    } else {
      if (value === oldValue) return;
      checked = looseEqual(value, getCheckboxValue(el, true));
    }
    if (el.checked !== checked) {
      el.checked = checked;
    }
  }
  var vModelRadio = {
    created(el, { value }, vnode) {
      el.checked = looseEqual(value, vnode.props.value);
      el[assignKey] = getModelAssigner(vnode);
      addEventListener(el, "change", () => {
        el[assignKey](getValue(el));
      });
    },
    beforeUpdate(el, { value, oldValue }, vnode) {
      el[assignKey] = getModelAssigner(vnode);
      if (value !== oldValue) {
        el.checked = looseEqual(value, vnode.props.value);
      }
    }
  };
  var vModelSelect = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created(el, { value, modifiers: { number: number4 } }, vnode) {
      const isSetModel = isSet(value);
      addEventListener(el, "change", () => {
        const selectedVal = Array.prototype.filter.call(el.options, (o) => o.selected).map(
          (o) => number4 ? looseToNumber(getValue(o)) : getValue(o)
        );
        el[assignKey](
          el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]
        );
        el._assigning = true;
        nextTick(() => {
          el._assigning = false;
        });
      });
      el[assignKey] = getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted(el, { value }) {
      setSelected(el, value);
    },
    beforeUpdate(el, _binding, vnode) {
      el[assignKey] = getModelAssigner(vnode);
    },
    updated(el, { value }) {
      if (!el._assigning) {
        setSelected(el, value);
      }
    }
  };
  function setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = isArray(value);
    if (isMultiple && !isArrayValue && !isSet(value)) {
      warn2(
        `<select multiple v-model> expects an Array or Set value for its binding, but got ${Object.prototype.toString.call(value).slice(8, -1)}.`
      );
      return;
    }
    for (let i = 0, l = el.options.length; i < l; i++) {
      const option2 = el.options[i];
      const optionValue2 = getValue(option2);
      if (isMultiple) {
        if (isArrayValue) {
          const optionType = typeof optionValue2;
          if (optionType === "string" || optionType === "number") {
            option2.selected = value.some((v) => String(v) === String(optionValue2));
          } else {
            option2.selected = looseIndexOf(value, optionValue2) > -1;
          }
        } else {
          option2.selected = value.has(optionValue2);
        }
      } else if (looseEqual(getValue(option2), value)) {
        if (el.selectedIndex !== i) el.selectedIndex = i;
        return;
      }
    }
    if (!isMultiple && el.selectedIndex !== -1) {
      el.selectedIndex = -1;
    }
  }
  function getValue(el) {
    return "_value" in el ? el._value : el.value;
  }
  function getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
  }
  var vModelDynamic = {
    created(el, binding, vnode) {
      callModelHook(el, binding, vnode, null, "created");
    },
    mounted(el, binding, vnode) {
      callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate(el, binding, vnode, prevVNode) {
      callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated(el, binding, vnode, prevVNode) {
      callModelHook(el, binding, vnode, prevVNode, "updated");
    }
  };
  function resolveDynamicModel(tagName, type) {
    switch (tagName) {
      case "SELECT":
        return vModelSelect;
      case "TEXTAREA":
        return vModelText;
      default:
        switch (type) {
          case "checkbox":
            return vModelCheckbox;
          case "radio":
            return vModelRadio;
          default:
            return vModelText;
        }
    }
  }
  function callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = resolveDynamicModel(
      el.tagName,
      vnode.props && vnode.props.type
    );
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
  }
  function initVModelForSSR() {
    vModelText.getSSRProps = ({ value }) => ({ value });
    vModelRadio.getSSRProps = ({ value }, vnode) => {
      if (vnode.props && looseEqual(vnode.props.value, value)) {
        return { checked: true };
      }
    };
    vModelCheckbox.getSSRProps = ({ value }, vnode) => {
      if (isArray(value)) {
        if (vnode.props && looseIndexOf(value, vnode.props.value) > -1) {
          return { checked: true };
        }
      } else if (isSet(value)) {
        if (vnode.props && value.has(vnode.props.value)) {
          return { checked: true };
        }
      } else if (value) {
        return { checked: true };
      }
    };
    vModelDynamic.getSSRProps = (binding, vnode) => {
      if (typeof vnode.type !== "string") {
        return;
      }
      const modelToUse = resolveDynamicModel(
        // resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(),
        vnode.props && vnode.props.type
      );
      if (modelToUse.getSSRProps) {
        return modelToUse.getSSRProps(binding, vnode);
      }
    };
  }
  var systemModifiers = ["ctrl", "shift", "alt", "meta"];
  var modifierGuards = {
    stop: (e) => e.stopPropagation(),
    prevent: (e) => e.preventDefault(),
    self: (e) => e.target !== e.currentTarget,
    ctrl: (e) => !e.ctrlKey,
    shift: (e) => !e.shiftKey,
    alt: (e) => !e.altKey,
    meta: (e) => !e.metaKey,
    left: (e) => "button" in e && e.button !== 0,
    middle: (e) => "button" in e && e.button !== 1,
    right: (e) => "button" in e && e.button !== 2,
    exact: (e, modifiers) => systemModifiers.some((m) => e[`${m}Key`] && !modifiers.includes(m))
  };
  var withModifiers = (fn, modifiers) => {
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args) => {
      for (let i = 0; i < modifiers.length; i++) {
        const guard = modifierGuards[modifiers[i]];
        if (guard && guard(event, modifiers)) return;
      }
      return fn(event, ...args);
    });
  };
  var keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
  };
  var withKeys = (fn, modifiers) => {
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event) => {
      if (!("key" in event)) {
        return;
      }
      const eventKey = hyphenate(event.key);
      if (modifiers.some(
        (k) => k === eventKey || keyNames[k] === eventKey
      )) {
        return fn(event);
      }
    });
  };
  var rendererOptions = /* @__PURE__ */ extend({ patchProp }, nodeOps);
  var renderer;
  var enabledHydration = false;
  function ensureRenderer() {
    return renderer || (renderer = createRenderer(rendererOptions));
  }
  function ensureHydrationRenderer() {
    renderer = enabledHydration ? renderer : createHydrationRenderer(rendererOptions);
    enabledHydration = true;
    return renderer;
  }
  var render = (...args) => {
    ensureRenderer().render(...args);
  };
  var hydrate = (...args) => {
    ensureHydrationRenderer().hydrate(...args);
  };
  var createApp = (...args) => {
    const app2 = ensureRenderer().createApp(...args);
    if (true) {
      injectNativeTagCheck(app2);
      injectCompilerOptionsCheck(app2);
    }
    const { mount } = app2;
    app2.mount = (containerOrSelector) => {
      const container = normalizeContainer(containerOrSelector);
      if (!container) return;
      const component = app2._component;
      if (!isFunction(component) && !component.render && !component.template) {
        component.template = container.innerHTML;
      }
      if (container.nodeType === 1) {
        container.textContent = "";
      }
      const proxy = mount(container, false, resolveRootNamespace(container));
      if (container instanceof Element) {
        container.removeAttribute("v-cloak");
        container.setAttribute("data-v-app", "");
      }
      return proxy;
    };
    return app2;
  };
  var createSSRApp = (...args) => {
    const app2 = ensureHydrationRenderer().createApp(...args);
    if (true) {
      injectNativeTagCheck(app2);
      injectCompilerOptionsCheck(app2);
    }
    const { mount } = app2;
    app2.mount = (containerOrSelector) => {
      const container = normalizeContainer(containerOrSelector);
      if (container) {
        return mount(container, true, resolveRootNamespace(container));
      }
    };
    return app2;
  };
  function resolveRootNamespace(container) {
    if (container instanceof SVGElement) {
      return "svg";
    }
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) {
      return "mathml";
    }
  }
  function injectNativeTagCheck(app2) {
    Object.defineProperty(app2.config, "isNativeTag", {
      value: (tag) => isHTMLTag(tag) || isSVGTag(tag) || isMathMLTag(tag),
      writable: false
    });
  }
  function injectCompilerOptionsCheck(app2) {
    if (isRuntimeOnly()) {
      const isCustomElement = app2.config.isCustomElement;
      Object.defineProperty(app2.config, "isCustomElement", {
        get() {
          return isCustomElement;
        },
        set() {
          warn2(
            `The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`
          );
        }
      });
      const compilerOptions = app2.config.compilerOptions;
      const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
      Object.defineProperty(app2.config, "compilerOptions", {
        get() {
          warn2(msg);
          return compilerOptions;
        },
        set() {
          warn2(msg);
        }
      });
    }
  }
  function normalizeContainer(container) {
    if (isString(container)) {
      const res = document.querySelector(container);
      if (!res) {
        warn2(
          `Failed to mount app: mount target selector "${container}" returned null.`
        );
      }
      return res;
    }
    if (window.ShadowRoot && container instanceof window.ShadowRoot && container.mode === "closed") {
      warn2(
        `mounting on a ShadowRoot with \`{mode: "closed"}\` may lead to unpredictable bugs`
      );
    }
    return container;
  }
  var ssrDirectiveInitialized = false;
  var initDirectivesForSSR = () => {
    if (!ssrDirectiveInitialized) {
      ssrDirectiveInitialized = true;
      initVModelForSSR();
      initVShowForSSR();
    }
  };

  // node_modules/@vue/compiler-core/dist/compiler-core.esm-bundler.js
  var FRAGMENT = Symbol(true ? `Fragment` : ``);
  var TELEPORT = Symbol(true ? `Teleport` : ``);
  var SUSPENSE = Symbol(true ? `Suspense` : ``);
  var KEEP_ALIVE = Symbol(true ? `KeepAlive` : ``);
  var BASE_TRANSITION = Symbol(
    true ? `BaseTransition` : ``
  );
  var OPEN_BLOCK = Symbol(true ? `openBlock` : ``);
  var CREATE_BLOCK = Symbol(true ? `createBlock` : ``);
  var CREATE_ELEMENT_BLOCK = Symbol(
    true ? `createElementBlock` : ``
  );
  var CREATE_VNODE = Symbol(true ? `createVNode` : ``);
  var CREATE_ELEMENT_VNODE = Symbol(
    true ? `createElementVNode` : ``
  );
  var CREATE_COMMENT = Symbol(
    true ? `createCommentVNode` : ``
  );
  var CREATE_TEXT = Symbol(
    true ? `createTextVNode` : ``
  );
  var CREATE_STATIC = Symbol(
    true ? `createStaticVNode` : ``
  );
  var RESOLVE_COMPONENT = Symbol(
    true ? `resolveComponent` : ``
  );
  var RESOLVE_DYNAMIC_COMPONENT = Symbol(
    true ? `resolveDynamicComponent` : ``
  );
  var RESOLVE_DIRECTIVE = Symbol(
    true ? `resolveDirective` : ``
  );
  var RESOLVE_FILTER = Symbol(
    true ? `resolveFilter` : ``
  );
  var WITH_DIRECTIVES = Symbol(
    true ? `withDirectives` : ``
  );
  var RENDER_LIST = Symbol(true ? `renderList` : ``);
  var RENDER_SLOT = Symbol(true ? `renderSlot` : ``);
  var CREATE_SLOTS = Symbol(true ? `createSlots` : ``);
  var TO_DISPLAY_STRING = Symbol(
    true ? `toDisplayString` : ``
  );
  var MERGE_PROPS = Symbol(true ? `mergeProps` : ``);
  var NORMALIZE_CLASS = Symbol(
    true ? `normalizeClass` : ``
  );
  var NORMALIZE_STYLE = Symbol(
    true ? `normalizeStyle` : ``
  );
  var NORMALIZE_PROPS = Symbol(
    true ? `normalizeProps` : ``
  );
  var GUARD_REACTIVE_PROPS = Symbol(
    true ? `guardReactiveProps` : ``
  );
  var TO_HANDLERS = Symbol(true ? `toHandlers` : ``);
  var CAMELIZE = Symbol(true ? `camelize` : ``);
  var CAPITALIZE = Symbol(true ? `capitalize` : ``);
  var TO_HANDLER_KEY = Symbol(
    true ? `toHandlerKey` : ``
  );
  var SET_BLOCK_TRACKING = Symbol(
    true ? `setBlockTracking` : ``
  );
  var PUSH_SCOPE_ID = Symbol(true ? `pushScopeId` : ``);
  var POP_SCOPE_ID = Symbol(true ? `popScopeId` : ``);
  var WITH_CTX = Symbol(true ? `withCtx` : ``);
  var UNREF = Symbol(true ? `unref` : ``);
  var IS_REF = Symbol(true ? `isRef` : ``);
  var WITH_MEMO = Symbol(true ? `withMemo` : ``);
  var IS_MEMO_SAME = Symbol(true ? `isMemoSame` : ``);
  var helperNameMap = {
    [FRAGMENT]: `Fragment`,
    [TELEPORT]: `Teleport`,
    [SUSPENSE]: `Suspense`,
    [KEEP_ALIVE]: `KeepAlive`,
    [BASE_TRANSITION]: `BaseTransition`,
    [OPEN_BLOCK]: `openBlock`,
    [CREATE_BLOCK]: `createBlock`,
    [CREATE_ELEMENT_BLOCK]: `createElementBlock`,
    [CREATE_VNODE]: `createVNode`,
    [CREATE_ELEMENT_VNODE]: `createElementVNode`,
    [CREATE_COMMENT]: `createCommentVNode`,
    [CREATE_TEXT]: `createTextVNode`,
    [CREATE_STATIC]: `createStaticVNode`,
    [RESOLVE_COMPONENT]: `resolveComponent`,
    [RESOLVE_DYNAMIC_COMPONENT]: `resolveDynamicComponent`,
    [RESOLVE_DIRECTIVE]: `resolveDirective`,
    [RESOLVE_FILTER]: `resolveFilter`,
    [WITH_DIRECTIVES]: `withDirectives`,
    [RENDER_LIST]: `renderList`,
    [RENDER_SLOT]: `renderSlot`,
    [CREATE_SLOTS]: `createSlots`,
    [TO_DISPLAY_STRING]: `toDisplayString`,
    [MERGE_PROPS]: `mergeProps`,
    [NORMALIZE_CLASS]: `normalizeClass`,
    [NORMALIZE_STYLE]: `normalizeStyle`,
    [NORMALIZE_PROPS]: `normalizeProps`,
    [GUARD_REACTIVE_PROPS]: `guardReactiveProps`,
    [TO_HANDLERS]: `toHandlers`,
    [CAMELIZE]: `camelize`,
    [CAPITALIZE]: `capitalize`,
    [TO_HANDLER_KEY]: `toHandlerKey`,
    [SET_BLOCK_TRACKING]: `setBlockTracking`,
    [PUSH_SCOPE_ID]: `pushScopeId`,
    [POP_SCOPE_ID]: `popScopeId`,
    [WITH_CTX]: `withCtx`,
    [UNREF]: `unref`,
    [IS_REF]: `isRef`,
    [WITH_MEMO]: `withMemo`,
    [IS_MEMO_SAME]: `isMemoSame`
  };
  function registerRuntimeHelpers(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach((s) => {
      helperNameMap[s] = helpers[s];
    });
  }
  var locStub = {
    start: { line: 1, column: 1, offset: 0 },
    end: { line: 1, column: 1, offset: 0 },
    source: ""
  };
  function createRoot(children, source = "") {
    return {
      type: 0,
      source,
      children,
      helpers: /* @__PURE__ */ new Set(),
      components: [],
      directives: [],
      hoists: [],
      imports: [],
      cached: [],
      temps: 0,
      codegenNode: void 0,
      loc: locStub
    };
  }
  function createVNodeCall(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent3 = false, loc = locStub) {
    if (context) {
      if (isBlock) {
        context.helper(OPEN_BLOCK);
        context.helper(getVNodeBlockHelper(context.inSSR, isComponent3));
      } else {
        context.helper(getVNodeHelper(context.inSSR, isComponent3));
      }
      if (directives) {
        context.helper(WITH_DIRECTIVES);
      }
    }
    return {
      type: 13,
      tag,
      props,
      children,
      patchFlag,
      dynamicProps,
      directives,
      isBlock,
      disableTracking,
      isComponent: isComponent3,
      loc
    };
  }
  function createArrayExpression(elements, loc = locStub) {
    return {
      type: 17,
      loc,
      elements
    };
  }
  function createObjectExpression(properties, loc = locStub) {
    return {
      type: 15,
      loc,
      properties
    };
  }
  function createObjectProperty(key, value) {
    return {
      type: 16,
      loc: locStub,
      key: isString(key) ? createSimpleExpression(key, true) : key,
      value
    };
  }
  function createSimpleExpression(content, isStatic = false, loc = locStub, constType = 0) {
    return {
      type: 4,
      loc,
      content,
      isStatic,
      constType: isStatic ? 3 : constType
    };
  }
  function createCompoundExpression(children, loc = locStub) {
    return {
      type: 8,
      loc,
      children
    };
  }
  function createCallExpression(callee, args = [], loc = locStub) {
    return {
      type: 14,
      loc,
      callee,
      arguments: args
    };
  }
  function createFunctionExpression(params, returns = void 0, newline = false, isSlot = false, loc = locStub) {
    return {
      type: 18,
      params,
      returns,
      newline,
      isSlot,
      loc
    };
  }
  function createConditionalExpression(test, consequent, alternate, newline = true) {
    return {
      type: 19,
      test,
      consequent,
      alternate,
      newline,
      loc: locStub
    };
  }
  function createCacheExpression(index, value, needPauseTracking = false, inVOnce = false) {
    return {
      type: 20,
      index,
      value,
      needPauseTracking,
      inVOnce,
      needArraySpread: false,
      loc: locStub
    };
  }
  function createBlockStatement(body) {
    return {
      type: 21,
      body,
      loc: locStub
    };
  }
  function getVNodeHelper(ssr, isComponent3) {
    return ssr || isComponent3 ? CREATE_VNODE : CREATE_ELEMENT_VNODE;
  }
  function getVNodeBlockHelper(ssr, isComponent3) {
    return ssr || isComponent3 ? CREATE_BLOCK : CREATE_ELEMENT_BLOCK;
  }
  function convertToBlock(node, { helper, removeHelper, inSSR }) {
    if (!node.isBlock) {
      node.isBlock = true;
      removeHelper(getVNodeHelper(inSSR, node.isComponent));
      helper(OPEN_BLOCK);
      helper(getVNodeBlockHelper(inSSR, node.isComponent));
    }
  }
  var defaultDelimitersOpen = new Uint8Array([123, 123]);
  var defaultDelimitersClose = new Uint8Array([125, 125]);
  function isTagStartChar(c) {
    return c >= 97 && c <= 122 || c >= 65 && c <= 90;
  }
  function isWhitespace(c) {
    return c === 32 || c === 10 || c === 9 || c === 12 || c === 13;
  }
  function isEndOfTagSection(c) {
    return c === 47 || c === 62 || isWhitespace(c);
  }
  function toCharCodes(str) {
    const ret = new Uint8Array(str.length);
    for (let i = 0; i < str.length; i++) {
      ret[i] = str.charCodeAt(i);
    }
    return ret;
  }
  var Sequences = {
    Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
    // CDATA[
    CdataEnd: new Uint8Array([93, 93, 62]),
    // ]]>
    CommentEnd: new Uint8Array([45, 45, 62]),
    // `-->`
    ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
    // `<\/script`
    StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
    // `</style`
    TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
    // `</title`
    TextareaEnd: new Uint8Array([
      60,
      47,
      116,
      101,
      120,
      116,
      97,
      114,
      101,
      97
    ])
    // `</textarea
  };
  var Tokenizer = class {
    constructor(stack3, cbs) {
      this.stack = stack3;
      this.cbs = cbs;
      this.state = 1;
      this.buffer = "";
      this.sectionStart = 0;
      this.index = 0;
      this.entityStart = 0;
      this.baseState = 1;
      this.inRCDATA = false;
      this.inXML = false;
      this.inVPre = false;
      this.newlines = [];
      this.mode = 0;
      this.delimiterOpen = defaultDelimitersOpen;
      this.delimiterClose = defaultDelimitersClose;
      this.delimiterIndex = -1;
      this.currentSequence = void 0;
      this.sequenceIndex = 0;
    }
    get inSFCRoot() {
      return this.mode === 2 && this.stack.length === 0;
    }
    reset() {
      this.state = 1;
      this.mode = 0;
      this.buffer = "";
      this.sectionStart = 0;
      this.index = 0;
      this.baseState = 1;
      this.inRCDATA = false;
      this.currentSequence = void 0;
      this.newlines.length = 0;
      this.delimiterOpen = defaultDelimitersOpen;
      this.delimiterClose = defaultDelimitersClose;
    }
    /**
     * Generate Position object with line / column information using recorded
     * newline positions. We know the index is always going to be an already
     * processed index, so all the newlines up to this index should have been
     * recorded.
     */
    getPos(index) {
      let line = 1;
      let column = index + 1;
      for (let i = this.newlines.length - 1; i >= 0; i--) {
        const newlineIndex = this.newlines[i];
        if (index > newlineIndex) {
          line = i + 2;
          column = index - newlineIndex;
          break;
        }
      }
      return {
        column,
        line,
        offset: index
      };
    }
    peek() {
      return this.buffer.charCodeAt(this.index + 1);
    }
    stateText(c) {
      if (c === 60) {
        if (this.index > this.sectionStart) {
          this.cbs.ontext(this.sectionStart, this.index);
        }
        this.state = 5;
        this.sectionStart = this.index;
      } else if (!this.inVPre && c === this.delimiterOpen[0]) {
        this.state = 2;
        this.delimiterIndex = 0;
        this.stateInterpolationOpen(c);
      }
    }
    stateInterpolationOpen(c) {
      if (c === this.delimiterOpen[this.delimiterIndex]) {
        if (this.delimiterIndex === this.delimiterOpen.length - 1) {
          const start = this.index + 1 - this.delimiterOpen.length;
          if (start > this.sectionStart) {
            this.cbs.ontext(this.sectionStart, start);
          }
          this.state = 3;
          this.sectionStart = start;
        } else {
          this.delimiterIndex++;
        }
      } else if (this.inRCDATA) {
        this.state = 32;
        this.stateInRCDATA(c);
      } else {
        this.state = 1;
        this.stateText(c);
      }
    }
    stateInterpolation(c) {
      if (c === this.delimiterClose[0]) {
        this.state = 4;
        this.delimiterIndex = 0;
        this.stateInterpolationClose(c);
      }
    }
    stateInterpolationClose(c) {
      if (c === this.delimiterClose[this.delimiterIndex]) {
        if (this.delimiterIndex === this.delimiterClose.length - 1) {
          this.cbs.oninterpolation(this.sectionStart, this.index + 1);
          if (this.inRCDATA) {
            this.state = 32;
          } else {
            this.state = 1;
          }
          this.sectionStart = this.index + 1;
        } else {
          this.delimiterIndex++;
        }
      } else {
        this.state = 3;
        this.stateInterpolation(c);
      }
    }
    stateSpecialStartSequence(c) {
      const isEnd = this.sequenceIndex === this.currentSequence.length;
      const isMatch = isEnd ? (
        // If we are at the end of the sequence, make sure the tag name has ended
        isEndOfTagSection(c)
      ) : (
        // Otherwise, do a case-insensitive comparison
        (c | 32) === this.currentSequence[this.sequenceIndex]
      );
      if (!isMatch) {
        this.inRCDATA = false;
      } else if (!isEnd) {
        this.sequenceIndex++;
        return;
      }
      this.sequenceIndex = 0;
      this.state = 6;
      this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> and <textarea>, also decode entities. */
    stateInRCDATA(c) {
      if (this.sequenceIndex === this.currentSequence.length) {
        if (c === 62 || isWhitespace(c)) {
          const endOfText = this.index - this.currentSequence.length;
          if (this.sectionStart < endOfText) {
            const actualIndex = this.index;
            this.index = endOfText;
            this.cbs.ontext(this.sectionStart, endOfText);
            this.index = actualIndex;
          }
          this.sectionStart = endOfText + 2;
          this.stateInClosingTagName(c);
          this.inRCDATA = false;
          return;
        }
        this.sequenceIndex = 0;
      }
      if ((c | 32) === this.currentSequence[this.sequenceIndex]) {
        this.sequenceIndex += 1;
      } else if (this.sequenceIndex === 0) {
        if (this.currentSequence === Sequences.TitleEnd || this.currentSequence === Sequences.TextareaEnd && !this.inSFCRoot) {
          if (!this.inVPre && c === this.delimiterOpen[0]) {
            this.state = 2;
            this.delimiterIndex = 0;
            this.stateInterpolationOpen(c);
          }
        } else if (this.fastForwardTo(60)) {
          this.sequenceIndex = 1;
        }
      } else {
        this.sequenceIndex = Number(c === 60);
      }
    }
    stateCDATASequence(c) {
      if (c === Sequences.Cdata[this.sequenceIndex]) {
        if (++this.sequenceIndex === Sequences.Cdata.length) {
          this.state = 28;
          this.currentSequence = Sequences.CdataEnd;
          this.sequenceIndex = 0;
          this.sectionStart = this.index + 1;
        }
      } else {
        this.sequenceIndex = 0;
        this.state = 23;
        this.stateInDeclaration(c);
      }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */
    fastForwardTo(c) {
      while (++this.index < this.buffer.length) {
        const cc = this.buffer.charCodeAt(this.index);
        if (cc === 10) {
          this.newlines.push(this.index);
        }
        if (cc === c) {
          return true;
        }
      }
      this.index = this.buffer.length - 1;
      return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */
    stateInCommentLike(c) {
      if (c === this.currentSequence[this.sequenceIndex]) {
        if (++this.sequenceIndex === this.currentSequence.length) {
          if (this.currentSequence === Sequences.CdataEnd) {
            this.cbs.oncdata(this.sectionStart, this.index - 2);
          } else {
            this.cbs.oncomment(this.sectionStart, this.index - 2);
          }
          this.sequenceIndex = 0;
          this.sectionStart = this.index + 1;
          this.state = 1;
        }
      } else if (this.sequenceIndex === 0) {
        if (this.fastForwardTo(this.currentSequence[0])) {
          this.sequenceIndex = 1;
        }
      } else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
        this.sequenceIndex = 0;
      }
    }
    startSpecial(sequence, offset) {
      this.enterRCDATA(sequence, offset);
      this.state = 31;
    }
    enterRCDATA(sequence, offset) {
      this.inRCDATA = true;
      this.currentSequence = sequence;
      this.sequenceIndex = offset;
    }
    stateBeforeTagName(c) {
      if (c === 33) {
        this.state = 22;
        this.sectionStart = this.index + 1;
      } else if (c === 63) {
        this.state = 24;
        this.sectionStart = this.index + 1;
      } else if (isTagStartChar(c)) {
        this.sectionStart = this.index;
        if (this.mode === 0) {
          this.state = 6;
        } else if (this.inSFCRoot) {
          this.state = 34;
        } else if (!this.inXML) {
          if (c === 116) {
            this.state = 30;
          } else {
            this.state = c === 115 ? 29 : 6;
          }
        } else {
          this.state = 6;
        }
      } else if (c === 47) {
        this.state = 8;
      } else {
        this.state = 1;
        this.stateText(c);
      }
    }
    stateInTagName(c) {
      if (isEndOfTagSection(c)) {
        this.handleTagName(c);
      }
    }
    stateInSFCRootTagName(c) {
      if (isEndOfTagSection(c)) {
        const tag = this.buffer.slice(this.sectionStart, this.index);
        if (tag !== "template") {
          this.enterRCDATA(toCharCodes(`</` + tag), 0);
        }
        this.handleTagName(c);
      }
    }
    handleTagName(c) {
      this.cbs.onopentagname(this.sectionStart, this.index);
      this.sectionStart = -1;
      this.state = 11;
      this.stateBeforeAttrName(c);
    }
    stateBeforeClosingTagName(c) {
      if (isWhitespace(c)) ;
      else if (c === 62) {
        if (true) {
          this.cbs.onerr(14, this.index);
        }
        this.state = 1;
        this.sectionStart = this.index + 1;
      } else {
        this.state = isTagStartChar(c) ? 9 : 27;
        this.sectionStart = this.index;
      }
    }
    stateInClosingTagName(c) {
      if (c === 62 || isWhitespace(c)) {
        this.cbs.onclosetag(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = 10;
        this.stateAfterClosingTagName(c);
      }
    }
    stateAfterClosingTagName(c) {
      if (c === 62) {
        this.state = 1;
        this.sectionStart = this.index + 1;
      }
    }
    stateBeforeAttrName(c) {
      if (c === 62) {
        this.cbs.onopentagend(this.index);
        if (this.inRCDATA) {
          this.state = 32;
        } else {
          this.state = 1;
        }
        this.sectionStart = this.index + 1;
      } else if (c === 47) {
        this.state = 7;
        if (this.peek() !== 62) {
          this.cbs.onerr(22, this.index);
        }
      } else if (c === 60 && this.peek() === 47) {
        this.cbs.onopentagend(this.index);
        this.state = 5;
        this.sectionStart = this.index;
      } else if (!isWhitespace(c)) {
        if (c === 61) {
          this.cbs.onerr(
            19,
            this.index
          );
        }
        this.handleAttrStart(c);
      }
    }
    handleAttrStart(c) {
      if (c === 118 && this.peek() === 45) {
        this.state = 13;
        this.sectionStart = this.index;
      } else if (c === 46 || c === 58 || c === 64 || c === 35) {
        this.cbs.ondirname(this.index, this.index + 1);
        this.state = 14;
        this.sectionStart = this.index + 1;
      } else {
        this.state = 12;
        this.sectionStart = this.index;
      }
    }
    stateInSelfClosingTag(c) {
      if (c === 62) {
        this.cbs.onselfclosingtag(this.index);
        this.state = 1;
        this.sectionStart = this.index + 1;
        this.inRCDATA = false;
      } else if (!isWhitespace(c)) {
        this.state = 11;
        this.stateBeforeAttrName(c);
      }
    }
    stateInAttrName(c) {
      if (c === 61 || isEndOfTagSection(c)) {
        this.cbs.onattribname(this.sectionStart, this.index);
        this.handleAttrNameEnd(c);
      } else if (c === 34 || c === 39 || c === 60) {
        this.cbs.onerr(
          17,
          this.index
        );
      }
    }
    stateInDirName(c) {
      if (c === 61 || isEndOfTagSection(c)) {
        this.cbs.ondirname(this.sectionStart, this.index);
        this.handleAttrNameEnd(c);
      } else if (c === 58) {
        this.cbs.ondirname(this.sectionStart, this.index);
        this.state = 14;
        this.sectionStart = this.index + 1;
      } else if (c === 46) {
        this.cbs.ondirname(this.sectionStart, this.index);
        this.state = 16;
        this.sectionStart = this.index + 1;
      }
    }
    stateInDirArg(c) {
      if (c === 61 || isEndOfTagSection(c)) {
        this.cbs.ondirarg(this.sectionStart, this.index);
        this.handleAttrNameEnd(c);
      } else if (c === 91) {
        this.state = 15;
      } else if (c === 46) {
        this.cbs.ondirarg(this.sectionStart, this.index);
        this.state = 16;
        this.sectionStart = this.index + 1;
      }
    }
    stateInDynamicDirArg(c) {
      if (c === 93) {
        this.state = 14;
      } else if (c === 61 || isEndOfTagSection(c)) {
        this.cbs.ondirarg(this.sectionStart, this.index + 1);
        this.handleAttrNameEnd(c);
        if (true) {
          this.cbs.onerr(
            27,
            this.index
          );
        }
      }
    }
    stateInDirModifier(c) {
      if (c === 61 || isEndOfTagSection(c)) {
        this.cbs.ondirmodifier(this.sectionStart, this.index);
        this.handleAttrNameEnd(c);
      } else if (c === 46) {
        this.cbs.ondirmodifier(this.sectionStart, this.index);
        this.sectionStart = this.index + 1;
      }
    }
    handleAttrNameEnd(c) {
      this.sectionStart = this.index;
      this.state = 17;
      this.cbs.onattribnameend(this.index);
      this.stateAfterAttrName(c);
    }
    stateAfterAttrName(c) {
      if (c === 61) {
        this.state = 18;
      } else if (c === 47 || c === 62) {
        this.cbs.onattribend(0, this.sectionStart);
        this.sectionStart = -1;
        this.state = 11;
        this.stateBeforeAttrName(c);
      } else if (!isWhitespace(c)) {
        this.cbs.onattribend(0, this.sectionStart);
        this.handleAttrStart(c);
      }
    }
    stateBeforeAttrValue(c) {
      if (c === 34) {
        this.state = 19;
        this.sectionStart = this.index + 1;
      } else if (c === 39) {
        this.state = 20;
        this.sectionStart = this.index + 1;
      } else if (!isWhitespace(c)) {
        this.sectionStart = this.index;
        this.state = 21;
        this.stateInAttrValueNoQuotes(c);
      }
    }
    handleInAttrValue(c, quote) {
      if (c === quote || this.fastForwardTo(quote)) {
        this.cbs.onattribdata(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.cbs.onattribend(
          quote === 34 ? 3 : 2,
          this.index + 1
        );
        this.state = 11;
      }
    }
    stateInAttrValueDoubleQuotes(c) {
      this.handleInAttrValue(c, 34);
    }
    stateInAttrValueSingleQuotes(c) {
      this.handleInAttrValue(c, 39);
    }
    stateInAttrValueNoQuotes(c) {
      if (isWhitespace(c) || c === 62) {
        this.cbs.onattribdata(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.cbs.onattribend(1, this.index);
        this.state = 11;
        this.stateBeforeAttrName(c);
      } else if (c === 34 || c === 39 || c === 60 || c === 61 || c === 96) {
        this.cbs.onerr(
          18,
          this.index
        );
      } else ;
    }
    stateBeforeDeclaration(c) {
      if (c === 91) {
        this.state = 26;
        this.sequenceIndex = 0;
      } else {
        this.state = c === 45 ? 25 : 23;
      }
    }
    stateInDeclaration(c) {
      if (c === 62 || this.fastForwardTo(62)) {
        this.state = 1;
        this.sectionStart = this.index + 1;
      }
    }
    stateInProcessingInstruction(c) {
      if (c === 62 || this.fastForwardTo(62)) {
        this.cbs.onprocessinginstruction(this.sectionStart, this.index);
        this.state = 1;
        this.sectionStart = this.index + 1;
      }
    }
    stateBeforeComment(c) {
      if (c === 45) {
        this.state = 28;
        this.currentSequence = Sequences.CommentEnd;
        this.sequenceIndex = 2;
        this.sectionStart = this.index + 1;
      } else {
        this.state = 23;
      }
    }
    stateInSpecialComment(c) {
      if (c === 62 || this.fastForwardTo(62)) {
        this.cbs.oncomment(this.sectionStart, this.index);
        this.state = 1;
        this.sectionStart = this.index + 1;
      }
    }
    stateBeforeSpecialS(c) {
      if (c === Sequences.ScriptEnd[3]) {
        this.startSpecial(Sequences.ScriptEnd, 4);
      } else if (c === Sequences.StyleEnd[3]) {
        this.startSpecial(Sequences.StyleEnd, 4);
      } else {
        this.state = 6;
        this.stateInTagName(c);
      }
    }
    stateBeforeSpecialT(c) {
      if (c === Sequences.TitleEnd[3]) {
        this.startSpecial(Sequences.TitleEnd, 4);
      } else if (c === Sequences.TextareaEnd[3]) {
        this.startSpecial(Sequences.TextareaEnd, 4);
      } else {
        this.state = 6;
        this.stateInTagName(c);
      }
    }
    startEntity() {
    }
    stateInEntity() {
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */
    parse(input2) {
      this.buffer = input2;
      while (this.index < this.buffer.length) {
        const c = this.buffer.charCodeAt(this.index);
        if (c === 10) {
          this.newlines.push(this.index);
        }
        switch (this.state) {
          case 1: {
            this.stateText(c);
            break;
          }
          case 2: {
            this.stateInterpolationOpen(c);
            break;
          }
          case 3: {
            this.stateInterpolation(c);
            break;
          }
          case 4: {
            this.stateInterpolationClose(c);
            break;
          }
          case 31: {
            this.stateSpecialStartSequence(c);
            break;
          }
          case 32: {
            this.stateInRCDATA(c);
            break;
          }
          case 26: {
            this.stateCDATASequence(c);
            break;
          }
          case 19: {
            this.stateInAttrValueDoubleQuotes(c);
            break;
          }
          case 12: {
            this.stateInAttrName(c);
            break;
          }
          case 13: {
            this.stateInDirName(c);
            break;
          }
          case 14: {
            this.stateInDirArg(c);
            break;
          }
          case 15: {
            this.stateInDynamicDirArg(c);
            break;
          }
          case 16: {
            this.stateInDirModifier(c);
            break;
          }
          case 28: {
            this.stateInCommentLike(c);
            break;
          }
          case 27: {
            this.stateInSpecialComment(c);
            break;
          }
          case 11: {
            this.stateBeforeAttrName(c);
            break;
          }
          case 6: {
            this.stateInTagName(c);
            break;
          }
          case 34: {
            this.stateInSFCRootTagName(c);
            break;
          }
          case 9: {
            this.stateInClosingTagName(c);
            break;
          }
          case 5: {
            this.stateBeforeTagName(c);
            break;
          }
          case 17: {
            this.stateAfterAttrName(c);
            break;
          }
          case 20: {
            this.stateInAttrValueSingleQuotes(c);
            break;
          }
          case 18: {
            this.stateBeforeAttrValue(c);
            break;
          }
          case 8: {
            this.stateBeforeClosingTagName(c);
            break;
          }
          case 10: {
            this.stateAfterClosingTagName(c);
            break;
          }
          case 29: {
            this.stateBeforeSpecialS(c);
            break;
          }
          case 30: {
            this.stateBeforeSpecialT(c);
            break;
          }
          case 21: {
            this.stateInAttrValueNoQuotes(c);
            break;
          }
          case 7: {
            this.stateInSelfClosingTag(c);
            break;
          }
          case 23: {
            this.stateInDeclaration(c);
            break;
          }
          case 22: {
            this.stateBeforeDeclaration(c);
            break;
          }
          case 25: {
            this.stateBeforeComment(c);
            break;
          }
          case 24: {
            this.stateInProcessingInstruction(c);
            break;
          }
          case 33: {
            this.stateInEntity();
            break;
          }
        }
        this.index++;
      }
      this.cleanup();
      this.finish();
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */
    cleanup() {
      if (this.sectionStart !== this.index) {
        if (this.state === 1 || this.state === 32 && this.sequenceIndex === 0) {
          this.cbs.ontext(this.sectionStart, this.index);
          this.sectionStart = this.index;
        } else if (this.state === 19 || this.state === 20 || this.state === 21) {
          this.cbs.onattribdata(this.sectionStart, this.index);
          this.sectionStart = this.index;
        }
      }
    }
    finish() {
      this.handleTrailingData();
      this.cbs.onend();
    }
    /** Handle any trailing data. */
    handleTrailingData() {
      const endIndex = this.buffer.length;
      if (this.sectionStart >= endIndex) {
        return;
      }
      if (this.state === 28) {
        if (this.currentSequence === Sequences.CdataEnd) {
          this.cbs.oncdata(this.sectionStart, endIndex);
        } else {
          this.cbs.oncomment(this.sectionStart, endIndex);
        }
      } else if (this.state === 6 || this.state === 11 || this.state === 18 || this.state === 17 || this.state === 12 || this.state === 13 || this.state === 14 || this.state === 15 || this.state === 16 || this.state === 20 || this.state === 19 || this.state === 21 || this.state === 9) ;
      else {
        this.cbs.ontext(this.sectionStart, endIndex);
      }
    }
    emitCodePoint(cp, consumed) {
    }
  };
  var deprecationData = {
    ["COMPILER_IS_ON_ELEMENT"]: {
      message: `Platform-native elements with "is" prop will no longer be treated as components in Vue 3 unless the "is" value is explicitly prefixed with "vue:".`,
      link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
    },
    ["COMPILER_V_BIND_SYNC"]: {
      message: (key) => `.sync modifier for v-bind has been removed. Use v-model with argument instead. \`v-bind:${key}.sync\` should be changed to \`v-model:${key}\`.`,
      link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
    },
    ["COMPILER_V_BIND_OBJECT_ORDER"]: {
      message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript object spread: it will now overwrite an existing non-mergeable attribute that appears before v-bind in the case of conflict. To retain 2.x behavior, move v-bind to make it the first attribute. You can also suppress this warning if the usage is intended.`,
      link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
    },
    ["COMPILER_V_ON_NATIVE"]: {
      message: `.native modifier for v-on has been removed as is no longer necessary.`,
      link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
    },
    ["COMPILER_V_IF_V_FOR_PRECEDENCE"]: {
      message: `v-if / v-for precedence when used on the same element has changed in Vue 3: v-if now takes higher precedence and will no longer have access to v-for scope variables. It is best to avoid the ambiguity with <template> tags or use a computed property that filters v-for data source.`,
      link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
    },
    ["COMPILER_NATIVE_TEMPLATE"]: {
      message: `<template> with no special directives will render as a native template element instead of its inner content in Vue 3.`
    },
    ["COMPILER_INLINE_TEMPLATE"]: {
      message: `"inline-template" has been removed in Vue 3.`,
      link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
    },
    ["COMPILER_FILTERS"]: {
      message: `filters have been removed in Vue 3. The "|" symbol will be treated as native JavaScript bitwise OR operator. Use method calls or computed properties instead.`,
      link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
    }
  };
  function getCompatValue(key, { compatConfig }) {
    const value = compatConfig && compatConfig[key];
    if (key === "MODE") {
      return value || 3;
    } else {
      return value;
    }
  }
  function isCompatEnabled(key, context) {
    const mode = getCompatValue("MODE", context);
    const value = getCompatValue(key, context);
    return mode === 3 ? value === true : value !== false;
  }
  function checkCompatEnabled(key, context, loc, ...args) {
    const enabled2 = isCompatEnabled(key, context);
    if (enabled2) {
      warnDeprecation(key, context, loc, ...args);
    }
    return enabled2;
  }
  function warnDeprecation(key, context, loc, ...args) {
    const val = getCompatValue(key, context);
    if (val === "suppress-warning") {
      return;
    }
    const { message: message3, link } = deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message3 === "function" ? message3(...args) : message3}${link ? `
  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc) err.loc = loc;
    context.onWarn(err);
  }
  function defaultOnError(error2) {
    throw error2;
  }
  function defaultOnWarn(msg) {
    console.warn(`[Vue warn] ${msg.message}`);
  }
  function createCompilerError(code, loc, messages3, additionalMessage) {
    const msg = true ? (messages3 || errorMessages)[code] + (additionalMessage || ``) : `https://vuejs.org/error-reference/#compiler-${code}`;
    const error2 = new SyntaxError(String(msg));
    error2.code = code;
    error2.loc = loc;
    return error2;
  }
  var errorMessages = {
    // parse errors
    [0]: "Illegal comment.",
    [1]: "CDATA section is allowed only in XML context.",
    [2]: "Duplicate attribute.",
    [3]: "End tag cannot have attributes.",
    [4]: "Illegal '/' in tags.",
    [5]: "Unexpected EOF in tag.",
    [6]: "Unexpected EOF in CDATA section.",
    [7]: "Unexpected EOF in comment.",
    [8]: "Unexpected EOF in script.",
    [9]: "Unexpected EOF in tag.",
    [10]: "Incorrectly closed comment.",
    [11]: "Incorrectly opened comment.",
    [12]: "Illegal tag name. Use '&lt;' to print '<'.",
    [13]: "Attribute value was expected.",
    [14]: "End tag name was expected.",
    [15]: "Whitespace was expected.",
    [16]: "Unexpected '<!--' in comment.",
    [17]: `Attribute name cannot contain U+0022 ("), U+0027 ('), and U+003C (<).`,
    [18]: "Unquoted attribute value cannot contain U+0022 (\"), U+0027 ('), U+003C (<), U+003D (=), and U+0060 (`).",
    [19]: "Attribute name cannot start with '='.",
    [21]: "'<?' is allowed only in XML context.",
    [20]: `Unexpected null character.`,
    [22]: "Illegal '/' in tags.",
    // Vue-specific parse errors
    [23]: "Invalid end tag.",
    [24]: "Element is missing end tag.",
    [25]: "Interpolation end sign was not found.",
    [27]: "End bracket for dynamic directive argument was not found. Note that dynamic directive argument cannot contain spaces.",
    [26]: "Legal directive name was expected.",
    // transform errors
    [28]: `v-if/v-else-if is missing expression.`,
    [29]: `v-if/else branches must use unique keys.`,
    [30]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
    [31]: `v-for is missing expression.`,
    [32]: `v-for has invalid expression.`,
    [33]: `<template v-for> key should be placed on the <template> tag.`,
    [34]: `v-bind is missing expression.`,
    [52]: `v-bind with same-name shorthand only allows static argument.`,
    [35]: `v-on is missing expression.`,
    [36]: `Unexpected custom directive on <slot> outlet.`,
    [37]: `Mixed v-slot usage on both the component and nested <template>. When there are multiple named slots, all slots should use <template> syntax to avoid scope ambiguity.`,
    [38]: `Duplicate slot names found. `,
    [39]: `Extraneous children found when component already has explicitly named default slot. These children will be ignored.`,
    [40]: `v-slot can only be used on components or <template> tags.`,
    [41]: `v-model is missing expression.`,
    [42]: `v-model value must be a valid JavaScript member expression.`,
    [43]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
    [44]: `v-model cannot be used on a prop, because local prop bindings are not writable.
Use a v-bind binding combined with a v-on listener that emits update:x event instead.`,
    [45]: `Error parsing JavaScript expression: `,
    [46]: `<KeepAlive> expects exactly one child component.`,
    [51]: `@vnode-* hooks in templates are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in 3.4.`,
    // generic errors
    [47]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
    [48]: `ES module mode is not supported in this build of compiler.`,
    [49]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
    [50]: `"scopeId" option is only supported in module mode.`,
    // just to fulfill types
    [53]: ``
  };
  var isStaticExp = (p2) => p2.type === 4 && p2.isStatic;
  function isCoreComponent(tag) {
    switch (tag) {
      case "Teleport":
      case "teleport":
        return TELEPORT;
      case "Suspense":
      case "suspense":
        return SUSPENSE;
      case "KeepAlive":
      case "keep-alive":
        return KEEP_ALIVE;
      case "BaseTransition":
      case "base-transition":
        return BASE_TRANSITION;
    }
  }
  var nonIdentifierRE = /^\d|[^\$\w\xA0-\uFFFF]/;
  var isSimpleIdentifier = (name) => !nonIdentifierRE.test(name);
  var validFirstIdentCharRE = /[A-Za-z_$\xA0-\uFFFF]/;
  var validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
  var whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
  var getExpSource = (exp) => exp.type === 4 ? exp.content : exp.loc.source;
  var isMemberExpressionBrowser = (exp) => {
    const path = getExpSource(exp).trim().replace(whitespaceRE, (s) => s.trim());
    let state = 0;
    let stateStack = [];
    let currentOpenBracketCount = 0;
    let currentOpenParensCount = 0;
    let currentStringType = null;
    for (let i = 0; i < path.length; i++) {
      const char = path.charAt(i);
      switch (state) {
        case 0:
          if (char === "[") {
            stateStack.push(state);
            state = 1;
            currentOpenBracketCount++;
          } else if (char === "(") {
            stateStack.push(state);
            state = 2;
            currentOpenParensCount++;
          } else if (!(i === 0 ? validFirstIdentCharRE : validIdentCharRE).test(char)) {
            return false;
          }
          break;
        case 1:
          if (char === `'` || char === `"` || char === "`") {
            stateStack.push(state);
            state = 3;
            currentStringType = char;
          } else if (char === `[`) {
            currentOpenBracketCount++;
          } else if (char === `]`) {
            if (!--currentOpenBracketCount) {
              state = stateStack.pop();
            }
          }
          break;
        case 2:
          if (char === `'` || char === `"` || char === "`") {
            stateStack.push(state);
            state = 3;
            currentStringType = char;
          } else if (char === `(`) {
            currentOpenParensCount++;
          } else if (char === `)`) {
            if (i === path.length - 1) {
              return false;
            }
            if (!--currentOpenParensCount) {
              state = stateStack.pop();
            }
          }
          break;
        case 3:
          if (char === currentStringType) {
            state = stateStack.pop();
            currentStringType = null;
          }
          break;
      }
    }
    return !currentOpenBracketCount && !currentOpenParensCount;
  };
  var isMemberExpression = isMemberExpressionBrowser;
  var fnExpRE = /^\s*(async\s*)?(\([^)]*?\)|[\w$_]+)\s*(:[^=]+)?=>|^\s*(async\s+)?function(?:\s+[\w$]+)?\s*\(/;
  var isFnExpressionBrowser = (exp) => fnExpRE.test(getExpSource(exp));
  var isFnExpression = isFnExpressionBrowser;
  function assert(condition, msg) {
    if (!condition) {
      throw new Error(msg || `unexpected compiler condition`);
    }
  }
  function findDir(node, name, allowEmpty = false) {
    for (let i = 0; i < node.props.length; i++) {
      const p2 = node.props[i];
      if (p2.type === 7 && (allowEmpty || p2.exp) && (isString(name) ? p2.name === name : name.test(p2.name))) {
        return p2;
      }
    }
  }
  function findProp(node, name, dynamicOnly = false, allowEmpty = false) {
    for (let i = 0; i < node.props.length; i++) {
      const p2 = node.props[i];
      if (p2.type === 6) {
        if (dynamicOnly) continue;
        if (p2.name === name && (p2.value || allowEmpty)) {
          return p2;
        }
      } else if (p2.name === "bind" && (p2.exp || allowEmpty) && isStaticArgOf(p2.arg, name)) {
        return p2;
      }
    }
  }
  function isStaticArgOf(arg, name) {
    return !!(arg && isStaticExp(arg) && arg.content === name);
  }
  function hasDynamicKeyVBind(node) {
    return node.props.some(
      (p2) => p2.type === 7 && p2.name === "bind" && (!p2.arg || // v-bind="obj"
      p2.arg.type !== 4 || // v-bind:[_ctx.foo]
      !p2.arg.isStatic)
      // v-bind:[foo]
    );
  }
  function isText$1(node) {
    return node.type === 5 || node.type === 2;
  }
  function isVSlot(p2) {
    return p2.type === 7 && p2.name === "slot";
  }
  function isTemplateNode(node) {
    return node.type === 1 && node.tagType === 3;
  }
  function isSlotOutlet(node) {
    return node.type === 1 && node.tagType === 2;
  }
  var propsHelperSet = /* @__PURE__ */ new Set([NORMALIZE_PROPS, GUARD_REACTIVE_PROPS]);
  function getUnnormalizedProps(props, callPath = []) {
    if (props && !isString(props) && props.type === 14) {
      const callee = props.callee;
      if (!isString(callee) && propsHelperSet.has(callee)) {
        return getUnnormalizedProps(
          props.arguments[0],
          callPath.concat(props)
        );
      }
    }
    return [props, callPath];
  }
  function injectProp(node, prop, context) {
    let propsWithInjection;
    let props = node.type === 13 ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props && !isString(props) && props.type === 14) {
      const ret = getUnnormalizedProps(props);
      props = ret[0];
      callPath = ret[1];
      parentCall = callPath[callPath.length - 1];
    }
    if (props == null || isString(props)) {
      propsWithInjection = createObjectExpression([prop]);
    } else if (props.type === 14) {
      const first = props.arguments[0];
      if (!isString(first) && first.type === 15) {
        if (!hasProp(prop, first)) {
          first.properties.unshift(prop);
        }
      } else {
        if (props.callee === TO_HANDLERS) {
          propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
            createObjectExpression([prop]),
            props
          ]);
        } else {
          props.arguments.unshift(createObjectExpression([prop]));
        }
      }
      !propsWithInjection && (propsWithInjection = props);
    } else if (props.type === 15) {
      if (!hasProp(prop, props)) {
        props.properties.unshift(prop);
      }
      propsWithInjection = props;
    } else {
      propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
        createObjectExpression([prop]),
        props
      ]);
      if (parentCall && parentCall.callee === GUARD_REACTIVE_PROPS) {
        parentCall = callPath[callPath.length - 2];
      }
    }
    if (node.type === 13) {
      if (parentCall) {
        parentCall.arguments[0] = propsWithInjection;
      } else {
        node.props = propsWithInjection;
      }
    } else {
      if (parentCall) {
        parentCall.arguments[0] = propsWithInjection;
      } else {
        node.arguments[2] = propsWithInjection;
      }
    }
  }
  function hasProp(prop, props) {
    let result = false;
    if (prop.key.type === 4) {
      const propKeyName = prop.key.content;
      result = props.properties.some(
        (p2) => p2.key.type === 4 && p2.key.content === propKeyName
      );
    }
    return result;
  }
  function toValidAssetId(name, type) {
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue) => {
      return searchValue === "-" ? "_" : name.charCodeAt(replaceValue).toString();
    })}`;
  }
  function getMemoedVNodeCall(node) {
    if (node.type === 14 && node.callee === WITH_MEMO) {
      return node.arguments[1].returns;
    } else {
      return node;
    }
  }
  var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/;
  var defaultParserOptions = {
    parseMode: "base",
    ns: 0,
    delimiters: [`{{`, `}}`],
    getNamespace: () => 0,
    isVoidTag: NO,
    isPreTag: NO,
    isIgnoreNewlineTag: NO,
    isCustomElement: NO,
    onError: defaultOnError,
    onWarn: defaultOnWarn,
    comments: true,
    prefixIdentifiers: false
  };
  var currentOptions = defaultParserOptions;
  var currentRoot = null;
  var currentInput = "";
  var currentOpenTag = null;
  var currentProp = null;
  var currentAttrValue = "";
  var currentAttrStartIndex = -1;
  var currentAttrEndIndex = -1;
  var inPre = 0;
  var inVPre = false;
  var currentVPreBoundary = null;
  var stack2 = [];
  var tokenizer = new Tokenizer(stack2, {
    onerr: emitError,
    ontext(start, end) {
      onText(getSlice(start, end), start, end);
    },
    ontextentity(char, start, end) {
      onText(char, start, end);
    },
    oninterpolation(start, end) {
      if (inVPre) {
        return onText(getSlice(start, end), start, end);
      }
      let innerStart = start + tokenizer.delimiterOpen.length;
      let innerEnd = end - tokenizer.delimiterClose.length;
      while (isWhitespace(currentInput.charCodeAt(innerStart))) {
        innerStart++;
      }
      while (isWhitespace(currentInput.charCodeAt(innerEnd - 1))) {
        innerEnd--;
      }
      let exp = getSlice(innerStart, innerEnd);
      if (exp.includes("&")) {
        {
          exp = currentOptions.decodeEntities(exp, false);
        }
      }
      addNode({
        type: 5,
        content: createExp(exp, false, getLoc(innerStart, innerEnd)),
        loc: getLoc(start, end)
      });
    },
    onopentagname(start, end) {
      const name = getSlice(start, end);
      currentOpenTag = {
        type: 1,
        tag: name,
        ns: currentOptions.getNamespace(name, stack2[0], currentOptions.ns),
        tagType: 0,
        // will be refined on tag close
        props: [],
        children: [],
        loc: getLoc(start - 1, end),
        codegenNode: void 0
      };
    },
    onopentagend(end) {
      endOpenTag(end);
    },
    onclosetag(start, end) {
      const name = getSlice(start, end);
      if (!currentOptions.isVoidTag(name)) {
        let found = false;
        for (let i = 0; i < stack2.length; i++) {
          const e = stack2[i];
          if (e.tag.toLowerCase() === name.toLowerCase()) {
            found = true;
            if (i > 0) {
              emitError(24, stack2[0].loc.start.offset);
            }
            for (let j = 0; j <= i; j++) {
              const el = stack2.shift();
              onCloseTag(el, end, j < i);
            }
            break;
          }
        }
        if (!found) {
          emitError(23, backTrack(start, 60));
        }
      }
    },
    onselfclosingtag(end) {
      const name = currentOpenTag.tag;
      currentOpenTag.isSelfClosing = true;
      endOpenTag(end);
      if (stack2[0] && stack2[0].tag === name) {
        onCloseTag(stack2.shift(), end);
      }
    },
    onattribname(start, end) {
      currentProp = {
        type: 6,
        name: getSlice(start, end),
        nameLoc: getLoc(start, end),
        value: void 0,
        loc: getLoc(start)
      };
    },
    ondirname(start, end) {
      const raw3 = getSlice(start, end);
      const name = raw3 === "." || raw3 === ":" ? "bind" : raw3 === "@" ? "on" : raw3 === "#" ? "slot" : raw3.slice(2);
      if (!inVPre && name === "") {
        emitError(26, start);
      }
      if (inVPre || name === "") {
        currentProp = {
          type: 6,
          name: raw3,
          nameLoc: getLoc(start, end),
          value: void 0,
          loc: getLoc(start)
        };
      } else {
        currentProp = {
          type: 7,
          name,
          rawName: raw3,
          exp: void 0,
          arg: void 0,
          modifiers: raw3 === "." ? [createSimpleExpression("prop")] : [],
          loc: getLoc(start)
        };
        if (name === "pre") {
          inVPre = tokenizer.inVPre = true;
          currentVPreBoundary = currentOpenTag;
          const props = currentOpenTag.props;
          for (let i = 0; i < props.length; i++) {
            if (props[i].type === 7) {
              props[i] = dirToAttr(props[i]);
            }
          }
        }
      }
    },
    ondirarg(start, end) {
      if (start === end) return;
      const arg = getSlice(start, end);
      if (inVPre) {
        currentProp.name += arg;
        setLocEnd(currentProp.nameLoc, end);
      } else {
        const isStatic = arg[0] !== `[`;
        currentProp.arg = createExp(
          isStatic ? arg : arg.slice(1, -1),
          isStatic,
          getLoc(start, end),
          isStatic ? 3 : 0
        );
      }
    },
    ondirmodifier(start, end) {
      const mod = getSlice(start, end);
      if (inVPre) {
        currentProp.name += "." + mod;
        setLocEnd(currentProp.nameLoc, end);
      } else if (currentProp.name === "slot") {
        const arg = currentProp.arg;
        if (arg) {
          arg.content += "." + mod;
          setLocEnd(arg.loc, end);
        }
      } else {
        const exp = createSimpleExpression(mod, true, getLoc(start, end));
        currentProp.modifiers.push(exp);
      }
    },
    onattribdata(start, end) {
      currentAttrValue += getSlice(start, end);
      if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
      currentAttrEndIndex = end;
    },
    onattribentity(char, start, end) {
      currentAttrValue += char;
      if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
      currentAttrEndIndex = end;
    },
    onattribnameend(end) {
      const start = currentProp.loc.start.offset;
      const name = getSlice(start, end);
      if (currentProp.type === 7) {
        currentProp.rawName = name;
      }
      if (currentOpenTag.props.some(
        (p2) => (p2.type === 7 ? p2.rawName : p2.name) === name
      )) {
        emitError(2, start);
      }
    },
    onattribend(quote, end) {
      if (currentOpenTag && currentProp) {
        setLocEnd(currentProp.loc, end);
        if (quote !== 0) {
          if (currentAttrValue.includes("&")) {
            currentAttrValue = currentOptions.decodeEntities(
              currentAttrValue,
              true
            );
          }
          if (currentProp.type === 6) {
            if (currentProp.name === "class") {
              currentAttrValue = condense(currentAttrValue).trim();
            }
            if (quote === 1 && !currentAttrValue) {
              emitError(13, end);
            }
            currentProp.value = {
              type: 2,
              content: currentAttrValue,
              loc: quote === 1 ? getLoc(currentAttrStartIndex, currentAttrEndIndex) : getLoc(currentAttrStartIndex - 1, currentAttrEndIndex + 1)
            };
            if (tokenizer.inSFCRoot && currentOpenTag.tag === "template" && currentProp.name === "lang" && currentAttrValue && currentAttrValue !== "html") {
              tokenizer.enterRCDATA(toCharCodes(`</template`), 0);
            }
          } else {
            let expParseMode = 0;
            currentProp.exp = createExp(
              currentAttrValue,
              false,
              getLoc(currentAttrStartIndex, currentAttrEndIndex),
              0,
              expParseMode
            );
            if (currentProp.name === "for") {
              currentProp.forParseResult = parseForExpression(currentProp.exp);
            }
            let syncIndex = -1;
            if (currentProp.name === "bind" && (syncIndex = currentProp.modifiers.findIndex(
              (mod) => mod.content === "sync"
            )) > -1 && checkCompatEnabled(
              "COMPILER_V_BIND_SYNC",
              currentOptions,
              currentProp.loc,
              currentProp.rawName
            )) {
              currentProp.name = "model";
              currentProp.modifiers.splice(syncIndex, 1);
            }
          }
        }
        if (currentProp.type !== 7 || currentProp.name !== "pre") {
          currentOpenTag.props.push(currentProp);
        }
      }
      currentAttrValue = "";
      currentAttrStartIndex = currentAttrEndIndex = -1;
    },
    oncomment(start, end) {
      if (currentOptions.comments) {
        addNode({
          type: 3,
          content: getSlice(start, end),
          loc: getLoc(start - 4, end + 3)
        });
      }
    },
    onend() {
      const end = currentInput.length;
      if (tokenizer.state !== 1) {
        switch (tokenizer.state) {
          case 5:
          case 8:
            emitError(5, end);
            break;
          case 3:
          case 4:
            emitError(
              25,
              tokenizer.sectionStart
            );
            break;
          case 28:
            if (tokenizer.currentSequence === Sequences.CdataEnd) {
              emitError(6, end);
            } else {
              emitError(7, end);
            }
            break;
          case 6:
          case 7:
          case 9:
          case 11:
          case 12:
          case 13:
          case 14:
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
          // "
          case 20:
          // '
          case 21:
            emitError(9, end);
            break;
        }
      }
      for (let index = 0; index < stack2.length; index++) {
        onCloseTag(stack2[index], end - 1);
        emitError(24, stack2[index].loc.start.offset);
      }
    },
    oncdata(start, end) {
      if (stack2[0].ns !== 0) {
        onText(getSlice(start, end), start, end);
      } else {
        emitError(1, start - 9);
      }
    },
    onprocessinginstruction(start) {
      if ((stack2[0] ? stack2[0].ns : currentOptions.ns) === 0) {
        emitError(
          21,
          start - 1
        );
      }
    }
  });
  var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
  var stripParensRE = /^\(|\)$/g;
  function parseForExpression(input2) {
    const loc = input2.loc;
    const exp = input2.content;
    const inMatch = exp.match(forAliasRE);
    if (!inMatch) return;
    const [, LHS, RHS] = inMatch;
    const createAliasExpression = (content, offset, asParam = false) => {
      const start = loc.start.offset + offset;
      const end = start + content.length;
      return createExp(
        content,
        false,
        getLoc(start, end),
        0,
        asParam ? 1 : 0
        /* Normal */
      );
    };
    const result = {
      source: createAliasExpression(RHS.trim(), exp.indexOf(RHS, LHS.length)),
      value: void 0,
      key: void 0,
      index: void 0,
      finalized: false
    };
    let valueContent = LHS.trim().replace(stripParensRE, "").trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match(forIteratorRE);
    if (iteratorMatch) {
      valueContent = valueContent.replace(forIteratorRE, "").trim();
      const keyContent = iteratorMatch[1].trim();
      let keyOffset;
      if (keyContent) {
        keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
        result.key = createAliasExpression(keyContent, keyOffset, true);
      }
      if (iteratorMatch[2]) {
        const indexContent = iteratorMatch[2].trim();
        if (indexContent) {
          result.index = createAliasExpression(
            indexContent,
            exp.indexOf(
              indexContent,
              result.key ? keyOffset + keyContent.length : trimmedOffset + valueContent.length
            ),
            true
          );
        }
      }
    }
    if (valueContent) {
      result.value = createAliasExpression(valueContent, trimmedOffset, true);
    }
    return result;
  }
  function getSlice(start, end) {
    return currentInput.slice(start, end);
  }
  function endOpenTag(end) {
    if (tokenizer.inSFCRoot) {
      currentOpenTag.innerLoc = getLoc(end + 1, end + 1);
    }
    addNode(currentOpenTag);
    const { tag, ns } = currentOpenTag;
    if (ns === 0 && currentOptions.isPreTag(tag)) {
      inPre++;
    }
    if (currentOptions.isVoidTag(tag)) {
      onCloseTag(currentOpenTag, end);
    } else {
      stack2.unshift(currentOpenTag);
      if (ns === 1 || ns === 2) {
        tokenizer.inXML = true;
      }
    }
    currentOpenTag = null;
  }
  function onText(content, start, end) {
    {
      const tag = stack2[0] && stack2[0].tag;
      if (tag !== "script" && tag !== "style" && content.includes("&")) {
        content = currentOptions.decodeEntities(content, false);
      }
    }
    const parent2 = stack2[0] || currentRoot;
    const lastNode = parent2.children[parent2.children.length - 1];
    if (lastNode && lastNode.type === 2) {
      lastNode.content += content;
      setLocEnd(lastNode.loc, end);
    } else {
      parent2.children.push({
        type: 2,
        content,
        loc: getLoc(start, end)
      });
    }
  }
  function onCloseTag(el, end, isImplied = false) {
    if (isImplied) {
      setLocEnd(el.loc, backTrack(end, 60));
    } else {
      setLocEnd(el.loc, lookAhead(end, 62) + 1);
    }
    if (tokenizer.inSFCRoot) {
      if (el.children.length) {
        el.innerLoc.end = extend({}, el.children[el.children.length - 1].loc.end);
      } else {
        el.innerLoc.end = extend({}, el.innerLoc.start);
      }
      el.innerLoc.source = getSlice(
        el.innerLoc.start.offset,
        el.innerLoc.end.offset
      );
    }
    const { tag, ns, children } = el;
    if (!inVPre) {
      if (tag === "slot") {
        el.tagType = 2;
      } else if (isFragmentTemplate(el)) {
        el.tagType = 3;
      } else if (isComponent(el)) {
        el.tagType = 1;
      }
    }
    if (!tokenizer.inRCDATA) {
      el.children = condenseWhitespace(children);
    }
    if (ns === 0 && currentOptions.isIgnoreNewlineTag(tag)) {
      const first = children[0];
      if (first && first.type === 2) {
        first.content = first.content.replace(/^\r?\n/, "");
      }
    }
    if (ns === 0 && currentOptions.isPreTag(tag)) {
      inPre--;
    }
    if (currentVPreBoundary === el) {
      inVPre = tokenizer.inVPre = false;
      currentVPreBoundary = null;
    }
    if (tokenizer.inXML && (stack2[0] ? stack2[0].ns : currentOptions.ns) === 0) {
      tokenizer.inXML = false;
    }
    {
      const props = el.props;
      if (isCompatEnabled(
        "COMPILER_V_IF_V_FOR_PRECEDENCE",
        currentOptions
      )) {
        let hasIf = false;
        let hasFor = false;
        for (let i = 0; i < props.length; i++) {
          const p2 = props[i];
          if (p2.type === 7) {
            if (p2.name === "if") {
              hasIf = true;
            } else if (p2.name === "for") {
              hasFor = true;
            }
          }
          if (hasIf && hasFor) {
            warnDeprecation(
              "COMPILER_V_IF_V_FOR_PRECEDENCE",
              currentOptions,
              el.loc
            );
            break;
          }
        }
      }
      if (!tokenizer.inSFCRoot && isCompatEnabled(
        "COMPILER_NATIVE_TEMPLATE",
        currentOptions
      ) && el.tag === "template" && !isFragmentTemplate(el)) {
        warnDeprecation(
          "COMPILER_NATIVE_TEMPLATE",
          currentOptions,
          el.loc
        );
        const parent2 = stack2[0] || currentRoot;
        const index = parent2.children.indexOf(el);
        parent2.children.splice(index, 1, ...el.children);
      }
      const inlineTemplateProp = props.find(
        (p2) => p2.type === 6 && p2.name === "inline-template"
      );
      if (inlineTemplateProp && checkCompatEnabled(
        "COMPILER_INLINE_TEMPLATE",
        currentOptions,
        inlineTemplateProp.loc
      ) && el.children.length) {
        inlineTemplateProp.value = {
          type: 2,
          content: getSlice(
            el.children[0].loc.start.offset,
            el.children[el.children.length - 1].loc.end.offset
          ),
          loc: inlineTemplateProp.loc
        };
      }
    }
  }
  function lookAhead(index, c) {
    let i = index;
    while (currentInput.charCodeAt(i) !== c && i < currentInput.length - 1) i++;
    return i;
  }
  function backTrack(index, c) {
    let i = index;
    while (currentInput.charCodeAt(i) !== c && i >= 0) i--;
    return i;
  }
  var specialTemplateDir = /* @__PURE__ */ new Set(["if", "else", "else-if", "for", "slot"]);
  function isFragmentTemplate({ tag, props }) {
    if (tag === "template") {
      for (let i = 0; i < props.length; i++) {
        if (props[i].type === 7 && specialTemplateDir.has(props[i].name)) {
          return true;
        }
      }
    }
    return false;
  }
  function isComponent({ tag, props }) {
    if (currentOptions.isCustomElement(tag)) {
      return false;
    }
    if (tag === "component" || isUpperCase(tag.charCodeAt(0)) || isCoreComponent(tag) || currentOptions.isBuiltInComponent && currentOptions.isBuiltInComponent(tag) || currentOptions.isNativeTag && !currentOptions.isNativeTag(tag)) {
      return true;
    }
    for (let i = 0; i < props.length; i++) {
      const p2 = props[i];
      if (p2.type === 6) {
        if (p2.name === "is" && p2.value) {
          if (p2.value.content.startsWith("vue:")) {
            return true;
          } else if (checkCompatEnabled(
            "COMPILER_IS_ON_ELEMENT",
            currentOptions,
            p2.loc
          )) {
            return true;
          }
        }
      } else if (
        // :is on plain element - only treat as component in compat mode
        p2.name === "bind" && isStaticArgOf(p2.arg, "is") && checkCompatEnabled(
          "COMPILER_IS_ON_ELEMENT",
          currentOptions,
          p2.loc
        )
      ) {
        return true;
      }
    }
    return false;
  }
  function isUpperCase(c) {
    return c > 64 && c < 91;
  }
  var windowsNewlineRE = /\r\n/g;
  function condenseWhitespace(nodes, tag) {
    const shouldCondense = currentOptions.whitespace !== "preserve";
    let removedWhitespace = false;
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (node.type === 2) {
        if (!inPre) {
          if (isAllWhitespace(node.content)) {
            const prev = nodes[i - 1] && nodes[i - 1].type;
            const next = nodes[i + 1] && nodes[i + 1].type;
            if (!prev || !next || shouldCondense && (prev === 3 && (next === 3 || next === 1) || prev === 1 && (next === 3 || next === 1 && hasNewlineChar(node.content)))) {
              removedWhitespace = true;
              nodes[i] = null;
            } else {
              node.content = " ";
            }
          } else if (shouldCondense) {
            node.content = condense(node.content);
          }
        } else {
          node.content = node.content.replace(windowsNewlineRE, "\n");
        }
      }
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
  }
  function isAllWhitespace(str) {
    for (let i = 0; i < str.length; i++) {
      if (!isWhitespace(str.charCodeAt(i))) {
        return false;
      }
    }
    return true;
  }
  function hasNewlineChar(str) {
    for (let i = 0; i < str.length; i++) {
      const c = str.charCodeAt(i);
      if (c === 10 || c === 13) {
        return true;
      }
    }
    return false;
  }
  function condense(str) {
    let ret = "";
    let prevCharIsWhitespace = false;
    for (let i = 0; i < str.length; i++) {
      if (isWhitespace(str.charCodeAt(i))) {
        if (!prevCharIsWhitespace) {
          ret += " ";
          prevCharIsWhitespace = true;
        }
      } else {
        ret += str[i];
        prevCharIsWhitespace = false;
      }
    }
    return ret;
  }
  function addNode(node) {
    (stack2[0] || currentRoot).children.push(node);
  }
  function getLoc(start, end) {
    return {
      start: tokenizer.getPos(start),
      // @ts-expect-error allow late attachment
      end: end == null ? end : tokenizer.getPos(end),
      // @ts-expect-error allow late attachment
      source: end == null ? end : getSlice(start, end)
    };
  }
  function cloneLoc(loc) {
    return getLoc(loc.start.offset, loc.end.offset);
  }
  function setLocEnd(loc, end) {
    loc.end = tokenizer.getPos(end);
    loc.source = getSlice(loc.start.offset, end);
  }
  function dirToAttr(dir) {
    const attr = {
      type: 6,
      name: dir.rawName,
      nameLoc: getLoc(
        dir.loc.start.offset,
        dir.loc.start.offset + dir.rawName.length
      ),
      value: void 0,
      loc: dir.loc
    };
    if (dir.exp) {
      const loc = dir.exp.loc;
      if (loc.end.offset < dir.loc.end.offset) {
        loc.start.offset--;
        loc.start.column--;
        loc.end.offset++;
        loc.end.column++;
      }
      attr.value = {
        type: 2,
        content: dir.exp.content,
        loc
      };
    }
    return attr;
  }
  function createExp(content, isStatic = false, loc, constType = 0, parseMode = 0) {
    const exp = createSimpleExpression(content, isStatic, loc, constType);
    return exp;
  }
  function emitError(code, index, message3) {
    currentOptions.onError(
      createCompilerError(code, getLoc(index, index), void 0, message3)
    );
  }
  function reset() {
    tokenizer.reset();
    currentOpenTag = null;
    currentProp = null;
    currentAttrValue = "";
    currentAttrStartIndex = -1;
    currentAttrEndIndex = -1;
    stack2.length = 0;
  }
  function baseParse(input2, options3) {
    reset();
    currentInput = input2;
    currentOptions = extend({}, defaultParserOptions);
    if (options3) {
      let key;
      for (key in options3) {
        if (options3[key] != null) {
          currentOptions[key] = options3[key];
        }
      }
    }
    if (true) {
      if (!currentOptions.decodeEntities) {
        throw new Error(
          `[@vue/compiler-core] decodeEntities option is required in browser builds.`
        );
      }
    }
    tokenizer.mode = currentOptions.parseMode === "html" ? 1 : currentOptions.parseMode === "sfc" ? 2 : 0;
    tokenizer.inXML = currentOptions.ns === 1 || currentOptions.ns === 2;
    const delimiters = options3 && options3.delimiters;
    if (delimiters) {
      tokenizer.delimiterOpen = toCharCodes(delimiters[0]);
      tokenizer.delimiterClose = toCharCodes(delimiters[1]);
    }
    const root2 = currentRoot = createRoot([], input2);
    tokenizer.parse(currentInput);
    root2.loc = getLoc(0, input2.length);
    root2.children = condenseWhitespace(root2.children);
    currentRoot = null;
    return root2;
  }
  function cacheStatic(root2, context) {
    walk(
      root2,
      void 0,
      context,
      // Root node is unfortunately non-hoistable due to potential parent
      // fallthrough attributes.
      isSingleElementRoot(root2, root2.children[0])
    );
  }
  function isSingleElementRoot(root2, child) {
    const { children } = root2;
    return children.length === 1 && child.type === 1 && !isSlotOutlet(child);
  }
  function walk(node, parent2, context, doNotHoistNode = false, inFor = false) {
    const { children } = node;
    const toCache = [];
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (child.type === 1 && child.tagType === 0) {
        const constantType = doNotHoistNode ? 0 : getConstantType(child, context);
        if (constantType > 0) {
          if (constantType >= 2) {
            child.codegenNode.patchFlag = -1;
            toCache.push(child);
            continue;
          }
        } else {
          const codegenNode = child.codegenNode;
          if (codegenNode.type === 13) {
            const flag = codegenNode.patchFlag;
            if ((flag === void 0 || flag === 512 || flag === 1) && getGeneratedPropsConstantType(child, context) >= 2) {
              const props = getNodeProps(child);
              if (props) {
                codegenNode.props = context.hoist(props);
              }
            }
            if (codegenNode.dynamicProps) {
              codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
            }
          }
        }
      } else if (child.type === 12) {
        const constantType = doNotHoistNode ? 0 : getConstantType(child, context);
        if (constantType >= 2) {
          toCache.push(child);
          continue;
        }
      }
      if (child.type === 1) {
        const isComponent3 = child.tagType === 1;
        if (isComponent3) {
          context.scopes.vSlot++;
        }
        walk(child, node, context, false, inFor);
        if (isComponent3) {
          context.scopes.vSlot--;
        }
      } else if (child.type === 11) {
        walk(child, node, context, child.children.length === 1, true);
      } else if (child.type === 9) {
        for (let i2 = 0; i2 < child.branches.length; i2++) {
          walk(
            child.branches[i2],
            node,
            context,
            child.branches[i2].children.length === 1,
            inFor
          );
        }
      }
    }
    let cachedAsArray = false;
    if (toCache.length === children.length && node.type === 1) {
      if (node.tagType === 0 && node.codegenNode && node.codegenNode.type === 13 && isArray(node.codegenNode.children)) {
        node.codegenNode.children = getCacheExpression(
          createArrayExpression(node.codegenNode.children)
        );
        cachedAsArray = true;
      } else if (node.tagType === 1 && node.codegenNode && node.codegenNode.type === 13 && node.codegenNode.children && !isArray(node.codegenNode.children) && node.codegenNode.children.type === 15) {
        const slot = getSlotNode(node.codegenNode, "default");
        if (slot) {
          slot.returns = getCacheExpression(
            createArrayExpression(slot.returns)
          );
          cachedAsArray = true;
        }
      } else if (node.tagType === 3 && parent2 && parent2.type === 1 && parent2.tagType === 1 && parent2.codegenNode && parent2.codegenNode.type === 13 && parent2.codegenNode.children && !isArray(parent2.codegenNode.children) && parent2.codegenNode.children.type === 15) {
        const slotName = findDir(node, "slot", true);
        const slot = slotName && slotName.arg && getSlotNode(parent2.codegenNode, slotName.arg);
        if (slot) {
          slot.returns = getCacheExpression(
            createArrayExpression(slot.returns)
          );
          cachedAsArray = true;
        }
      }
    }
    if (!cachedAsArray) {
      for (const child of toCache) {
        child.codegenNode = context.cache(child.codegenNode);
      }
    }
    function getCacheExpression(value) {
      const exp = context.cache(value);
      if (inFor && context.hmr) {
        exp.needArraySpread = true;
      }
      return exp;
    }
    function getSlotNode(node2, name) {
      if (node2.children && !isArray(node2.children) && node2.children.type === 15) {
        const slot = node2.children.properties.find(
          (p2) => p2.key === name || p2.key.content === name
        );
        return slot && slot.value;
      }
    }
    if (toCache.length && context.transformHoist) {
      context.transformHoist(children, context, node);
    }
  }
  function getConstantType(node, context) {
    const { constantCache } = context;
    switch (node.type) {
      case 1:
        if (node.tagType !== 0) {
          return 0;
        }
        const cached = constantCache.get(node);
        if (cached !== void 0) {
          return cached;
        }
        const codegenNode = node.codegenNode;
        if (codegenNode.type !== 13) {
          return 0;
        }
        if (codegenNode.isBlock && node.tag !== "svg" && node.tag !== "foreignObject" && node.tag !== "math") {
          return 0;
        }
        if (codegenNode.patchFlag === void 0) {
          let returnType2 = 3;
          const generatedPropsType = getGeneratedPropsConstantType(node, context);
          if (generatedPropsType === 0) {
            constantCache.set(node, 0);
            return 0;
          }
          if (generatedPropsType < returnType2) {
            returnType2 = generatedPropsType;
          }
          for (let i = 0; i < node.children.length; i++) {
            const childType = getConstantType(node.children[i], context);
            if (childType === 0) {
              constantCache.set(node, 0);
              return 0;
            }
            if (childType < returnType2) {
              returnType2 = childType;
            }
          }
          if (returnType2 > 1) {
            for (let i = 0; i < node.props.length; i++) {
              const p2 = node.props[i];
              if (p2.type === 7 && p2.name === "bind" && p2.exp) {
                const expType = getConstantType(p2.exp, context);
                if (expType === 0) {
                  constantCache.set(node, 0);
                  return 0;
                }
                if (expType < returnType2) {
                  returnType2 = expType;
                }
              }
            }
          }
          if (codegenNode.isBlock) {
            for (let i = 0; i < node.props.length; i++) {
              const p2 = node.props[i];
              if (p2.type === 7) {
                constantCache.set(node, 0);
                return 0;
              }
            }
            context.removeHelper(OPEN_BLOCK);
            context.removeHelper(
              getVNodeBlockHelper(context.inSSR, codegenNode.isComponent)
            );
            codegenNode.isBlock = false;
            context.helper(getVNodeHelper(context.inSSR, codegenNode.isComponent));
          }
          constantCache.set(node, returnType2);
          return returnType2;
        } else {
          constantCache.set(node, 0);
          return 0;
        }
      case 2:
      case 3:
        return 3;
      case 9:
      case 11:
      case 10:
        return 0;
      case 5:
      case 12:
        return getConstantType(node.content, context);
      case 4:
        return node.constType;
      case 8:
        let returnType = 3;
        for (let i = 0; i < node.children.length; i++) {
          const child = node.children[i];
          if (isString(child) || isSymbol(child)) {
            continue;
          }
          const childType = getConstantType(child, context);
          if (childType === 0) {
            return 0;
          } else if (childType < returnType) {
            returnType = childType;
          }
        }
        return returnType;
      case 20:
        return 2;
      default:
        if (true) ;
        return 0;
    }
  }
  var allowHoistedHelperSet = /* @__PURE__ */ new Set([
    NORMALIZE_CLASS,
    NORMALIZE_STYLE,
    NORMALIZE_PROPS,
    GUARD_REACTIVE_PROPS
  ]);
  function getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 && !isString(value.callee) && allowHoistedHelperSet.has(value.callee)) {
      const arg = value.arguments[0];
      if (arg.type === 4) {
        return getConstantType(arg, context);
      } else if (arg.type === 14) {
        return getConstantTypeOfHelperCall(arg, context);
      }
    }
    return 0;
  }
  function getGeneratedPropsConstantType(node, context) {
    let returnType = 3;
    const props = getNodeProps(node);
    if (props && props.type === 15) {
      const { properties } = props;
      for (let i = 0; i < properties.length; i++) {
        const { key, value } = properties[i];
        const keyType = getConstantType(key, context);
        if (keyType === 0) {
          return keyType;
        }
        if (keyType < returnType) {
          returnType = keyType;
        }
        let valueType;
        if (value.type === 4) {
          valueType = getConstantType(value, context);
        } else if (value.type === 14) {
          valueType = getConstantTypeOfHelperCall(value, context);
        } else {
          valueType = 0;
        }
        if (valueType === 0) {
          return valueType;
        }
        if (valueType < returnType) {
          returnType = valueType;
        }
      }
    }
    return returnType;
  }
  function getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13) {
      return codegenNode.props;
    }
  }
  function createTransformContext(root2, {
    filename = "",
    prefixIdentifiers = false,
    hoistStatic = false,
    hmr = false,
    cacheHandlers = false,
    nodeTransforms = [],
    directiveTransforms = {},
    transformHoist = null,
    isBuiltInComponent = NOOP,
    isCustomElement = NOOP,
    expressionPlugins = [],
    scopeId = null,
    slotted = true,
    ssr = false,
    inSSR = false,
    ssrCssVars = ``,
    bindingMetadata = EMPTY_OBJ,
    inline = false,
    isTS = false,
    onError = defaultOnError,
    onWarn = defaultOnWarn,
    compatConfig
  }) {
    const nameMatch = filename.replace(/\?.*$/, "").match(/([^/\\]+)\.\w+$/);
    const context = {
      // options
      filename,
      selfName: nameMatch && capitalize(camelize(nameMatch[1])),
      prefixIdentifiers,
      hoistStatic,
      hmr,
      cacheHandlers,
      nodeTransforms,
      directiveTransforms,
      transformHoist,
      isBuiltInComponent,
      isCustomElement,
      expressionPlugins,
      scopeId,
      slotted,
      ssr,
      inSSR,
      ssrCssVars,
      bindingMetadata,
      inline,
      isTS,
      onError,
      onWarn,
      compatConfig,
      // state
      root: root2,
      helpers: /* @__PURE__ */ new Map(),
      components: /* @__PURE__ */ new Set(),
      directives: /* @__PURE__ */ new Set(),
      hoists: [],
      imports: [],
      cached: [],
      constantCache: /* @__PURE__ */ new WeakMap(),
      temps: 0,
      identifiers: /* @__PURE__ */ Object.create(null),
      scopes: {
        vFor: 0,
        vSlot: 0,
        vPre: 0,
        vOnce: 0
      },
      parent: null,
      grandParent: null,
      currentNode: root2,
      childIndex: 0,
      inVOnce: false,
      // methods
      helper(name) {
        const count2 = context.helpers.get(name) || 0;
        context.helpers.set(name, count2 + 1);
        return name;
      },
      removeHelper(name) {
        const count2 = context.helpers.get(name);
        if (count2) {
          const currentCount = count2 - 1;
          if (!currentCount) {
            context.helpers.delete(name);
          } else {
            context.helpers.set(name, currentCount);
          }
        }
      },
      helperString(name) {
        return `_${helperNameMap[context.helper(name)]}`;
      },
      replaceNode(node) {
        if (true) {
          if (!context.currentNode) {
            throw new Error(`Node being replaced is already removed.`);
          }
          if (!context.parent) {
            throw new Error(`Cannot replace root node.`);
          }
        }
        context.parent.children[context.childIndex] = context.currentNode = node;
      },
      removeNode(node) {
        if (!context.parent) {
          throw new Error(`Cannot remove root node.`);
        }
        const list3 = context.parent.children;
        const removalIndex = node ? list3.indexOf(node) : context.currentNode ? context.childIndex : -1;
        if (removalIndex < 0) {
          throw new Error(`node being removed is not a child of current parent`);
        }
        if (!node || node === context.currentNode) {
          context.currentNode = null;
          context.onNodeRemoved();
        } else {
          if (context.childIndex > removalIndex) {
            context.childIndex--;
            context.onNodeRemoved();
          }
        }
        context.parent.children.splice(removalIndex, 1);
      },
      onNodeRemoved: NOOP,
      addIdentifiers(exp) {
      },
      removeIdentifiers(exp) {
      },
      hoist(exp) {
        if (isString(exp)) exp = createSimpleExpression(exp);
        context.hoists.push(exp);
        const identifier = createSimpleExpression(
          `_hoisted_${context.hoists.length}`,
          false,
          exp.loc,
          2
        );
        identifier.hoisted = exp;
        return identifier;
      },
      cache(exp, isVNode2 = false, inVOnce = false) {
        const cacheExp = createCacheExpression(
          context.cached.length,
          exp,
          isVNode2,
          inVOnce
        );
        context.cached.push(cacheExp);
        return cacheExp;
      }
    };
    {
      context.filters = /* @__PURE__ */ new Set();
    }
    return context;
  }
  function transform(root2, options3) {
    const context = createTransformContext(root2, options3);
    traverseNode(root2, context);
    if (options3.hoistStatic) {
      cacheStatic(root2, context);
    }
    if (!options3.ssr) {
      createRootCodegen(root2, context);
    }
    root2.helpers = /* @__PURE__ */ new Set([...context.helpers.keys()]);
    root2.components = [...context.components];
    root2.directives = [...context.directives];
    root2.imports = context.imports;
    root2.hoists = context.hoists;
    root2.temps = context.temps;
    root2.cached = context.cached;
    root2.transformed = true;
    {
      root2.filters = [...context.filters];
    }
  }
  function createRootCodegen(root2, context) {
    const { helper } = context;
    const { children } = root2;
    if (children.length === 1) {
      const child = children[0];
      if (isSingleElementRoot(root2, child) && child.codegenNode) {
        const codegenNode = child.codegenNode;
        if (codegenNode.type === 13) {
          convertToBlock(codegenNode, context);
        }
        root2.codegenNode = codegenNode;
      } else {
        root2.codegenNode = child;
      }
    } else if (children.length > 1) {
      let patchFlag = 64;
      if (children.filter((c) => c.type !== 3).length === 1) {
        patchFlag |= 2048;
      }
      root2.codegenNode = createVNodeCall(
        context,
        helper(FRAGMENT),
        void 0,
        root2.children,
        patchFlag,
        void 0,
        void 0,
        true,
        void 0,
        false
      );
    } else ;
  }
  function traverseChildren(parent2, context) {
    let i = 0;
    const nodeRemoved = () => {
      i--;
    };
    for (; i < parent2.children.length; i++) {
      const child = parent2.children[i];
      if (isString(child)) continue;
      context.grandParent = context.parent;
      context.parent = parent2;
      context.childIndex = i;
      context.onNodeRemoved = nodeRemoved;
      traverseNode(child, context);
    }
  }
  function traverseNode(node, context) {
    context.currentNode = node;
    const { nodeTransforms } = context;
    const exitFns = [];
    for (let i2 = 0; i2 < nodeTransforms.length; i2++) {
      const onExit = nodeTransforms[i2](node, context);
      if (onExit) {
        if (isArray(onExit)) {
          exitFns.push(...onExit);
        } else {
          exitFns.push(onExit);
        }
      }
      if (!context.currentNode) {
        return;
      } else {
        node = context.currentNode;
      }
    }
    switch (node.type) {
      case 3:
        if (!context.ssr) {
          context.helper(CREATE_COMMENT);
        }
        break;
      case 5:
        if (!context.ssr) {
          context.helper(TO_DISPLAY_STRING);
        }
        break;
      // for container types, further traverse downwards
      case 9:
        for (let i2 = 0; i2 < node.branches.length; i2++) {
          traverseNode(node.branches[i2], context);
        }
        break;
      case 10:
      case 11:
      case 1:
      case 0:
        traverseChildren(node, context);
        break;
    }
    context.currentNode = node;
    let i = exitFns.length;
    while (i--) {
      exitFns[i]();
    }
  }
  function createStructuralDirectiveTransform(name, fn) {
    const matches3 = isString(name) ? (n) => n === name : (n) => name.test(n);
    return (node, context) => {
      if (node.type === 1) {
        const { props } = node;
        if (node.tagType === 3 && props.some(isVSlot)) {
          return;
        }
        const exitFns = [];
        for (let i = 0; i < props.length; i++) {
          const prop = props[i];
          if (prop.type === 7 && matches3(prop.name)) {
            props.splice(i, 1);
            i--;
            const onExit = fn(node, prop, context);
            if (onExit) exitFns.push(onExit);
          }
        }
        return exitFns;
      }
    };
  }
  var PURE_ANNOTATION = `/*@__PURE__*/`;
  var aliasHelper = (s) => `${helperNameMap[s]}: _${helperNameMap[s]}`;
  function createCodegenContext(ast, {
    mode = "function",
    prefixIdentifiers = mode === "module",
    sourceMap = false,
    filename = `template.vue.html`,
    scopeId = null,
    optimizeImports = false,
    runtimeGlobalName = `Vue`,
    runtimeModuleName = `vue`,
    ssrRuntimeModuleName = "vue/server-renderer",
    ssr = false,
    isTS = false,
    inSSR = false
  }) {
    const context = {
      mode,
      prefixIdentifiers,
      sourceMap,
      filename,
      scopeId,
      optimizeImports,
      runtimeGlobalName,
      runtimeModuleName,
      ssrRuntimeModuleName,
      ssr,
      isTS,
      inSSR,
      source: ast.source,
      code: ``,
      column: 1,
      line: 1,
      offset: 0,
      indentLevel: 0,
      pure: false,
      map: void 0,
      helper(key) {
        return `_${helperNameMap[key]}`;
      },
      push(code, newlineIndex = -2, node) {
        context.code += code;
      },
      indent() {
        newline(++context.indentLevel);
      },
      deindent(withoutNewLine = false) {
        if (withoutNewLine) {
          --context.indentLevel;
        } else {
          newline(--context.indentLevel);
        }
      },
      newline() {
        newline(context.indentLevel);
      }
    };
    function newline(n) {
      context.push(
        "\n" + `  `.repeat(n),
        0
        /* Start */
      );
    }
    return context;
  }
  function generate(ast, options3 = {}) {
    const context = createCodegenContext(ast, options3);
    if (options3.onContextCreated) options3.onContextCreated(context);
    const {
      mode,
      push,
      prefixIdentifiers,
      indent,
      deindent,
      newline,
      scopeId,
      ssr
    } = context;
    const helpers = Array.from(ast.helpers);
    const hasHelpers = helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== "module";
    const preambleContext = context;
    {
      genFunctionPreamble(ast, preambleContext);
    }
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? ["_ctx", "_push", "_parent", "_attrs"] : ["_ctx", "_cache"];
    const signature = args.join(", ");
    {
      push(`function ${functionName}(${signature}) {`);
    }
    indent();
    if (useWithBlock) {
      push(`with (_ctx) {`);
      indent();
      if (hasHelpers) {
        push(
          `const { ${helpers.map(aliasHelper).join(", ")} } = _Vue
`,
          -1
          /* End */
        );
        newline();
      }
    }
    if (ast.components.length) {
      genAssets(ast.components, "component", context);
      if (ast.directives.length || ast.temps > 0) {
        newline();
      }
    }
    if (ast.directives.length) {
      genAssets(ast.directives, "directive", context);
      if (ast.temps > 0) {
        newline();
      }
    }
    if (ast.filters && ast.filters.length) {
      newline();
      genAssets(ast.filters, "filter", context);
      newline();
    }
    if (ast.temps > 0) {
      push(`let `);
      for (let i = 0; i < ast.temps; i++) {
        push(`${i > 0 ? `, ` : ``}_temp${i}`);
      }
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
      push(
        `
`,
        0
        /* Start */
      );
      newline();
    }
    if (!ssr) {
      push(`return `);
    }
    if (ast.codegenNode) {
      genNode(ast.codegenNode, context);
    } else {
      push(`null`);
    }
    if (useWithBlock) {
      deindent();
      push(`}`);
    }
    deindent();
    push(`}`);
    return {
      ast,
      code: context.code,
      preamble: ``,
      map: context.map ? context.map.toJSON() : void 0
    };
  }
  function genFunctionPreamble(ast, context) {
    const {
      ssr,
      prefixIdentifiers,
      push,
      newline,
      runtimeModuleName,
      runtimeGlobalName,
      ssrRuntimeModuleName
    } = context;
    const VueBinding = runtimeGlobalName;
    const helpers = Array.from(ast.helpers);
    if (helpers.length > 0) {
      {
        push(
          `const _Vue = ${VueBinding}
`,
          -1
          /* End */
        );
        if (ast.hoists.length) {
          const staticHelpers = [
            CREATE_VNODE,
            CREATE_ELEMENT_VNODE,
            CREATE_COMMENT,
            CREATE_TEXT,
            CREATE_STATIC
          ].filter((helper) => helpers.includes(helper)).map(aliasHelper).join(", ");
          push(
            `const { ${staticHelpers} } = _Vue
`,
            -1
            /* End */
          );
        }
      }
    }
    genHoists(ast.hoists, context);
    newline();
    push(`return `);
  }
  function genAssets(assets, type, { helper, push, newline, isTS }) {
    const resolver = helper(
      type === "filter" ? RESOLVE_FILTER : type === "component" ? RESOLVE_COMPONENT : RESOLVE_DIRECTIVE
    );
    for (let i = 0; i < assets.length; i++) {
      let id = assets[i];
      const maybeSelfReference = id.endsWith("__self");
      if (maybeSelfReference) {
        id = id.slice(0, -6);
      }
      push(
        `const ${toValidAssetId(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`
      );
      if (i < assets.length - 1) {
        newline();
      }
    }
  }
  function genHoists(hoists, context) {
    if (!hoists.length) {
      return;
    }
    context.pure = true;
    const { push, newline } = context;
    newline();
    for (let i = 0; i < hoists.length; i++) {
      const exp = hoists[i];
      if (exp) {
        push(`const _hoisted_${i + 1} = `);
        genNode(exp, context);
        newline();
      }
    }
    context.pure = false;
  }
  function isText(n) {
    return isString(n) || n.type === 4 || n.type === 2 || n.type === 5 || n.type === 8;
  }
  function genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 || nodes.some((n) => isArray(n) || !isText(n));
    context.push(`[`);
    multilines && context.indent();
    genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
  }
  function genNodeList(nodes, context, multilines = false, comma = true) {
    const { push, newline } = context;
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (isString(node)) {
        push(
          node,
          -3
          /* Unknown */
        );
      } else if (isArray(node)) {
        genNodeListAsArray(node, context);
      } else {
        genNode(node, context);
      }
      if (i < nodes.length - 1) {
        if (multilines) {
          comma && push(",");
          newline();
        } else {
          comma && push(", ");
        }
      }
    }
  }
  function genNode(node, context) {
    if (isString(node)) {
      context.push(
        node,
        -3
        /* Unknown */
      );
      return;
    }
    if (isSymbol(node)) {
      context.push(context.helper(node));
      return;
    }
    switch (node.type) {
      case 1:
      case 9:
      case 11:
        assert(
          node.codegenNode != null,
          `Codegen node is missing for element/if/for node. Apply appropriate transforms first.`
        );
        genNode(node.codegenNode, context);
        break;
      case 2:
        genText(node, context);
        break;
      case 4:
        genExpression(node, context);
        break;
      case 5:
        genInterpolation(node, context);
        break;
      case 12:
        genNode(node.codegenNode, context);
        break;
      case 8:
        genCompoundExpression(node, context);
        break;
      case 3:
        genComment(node, context);
        break;
      case 13:
        genVNodeCall(node, context);
        break;
      case 14:
        genCallExpression(node, context);
        break;
      case 15:
        genObjectExpression(node, context);
        break;
      case 17:
        genArrayExpression(node, context);
        break;
      case 18:
        genFunctionExpression(node, context);
        break;
      case 19:
        genConditionalExpression(node, context);
        break;
      case 20:
        genCacheExpression(node, context);
        break;
      case 21:
        genNodeList(node.body, context, true, false);
        break;
      // SSR only types
      case 22:
        break;
      case 23:
        break;
      case 24:
        break;
      case 25:
        break;
      case 26:
        break;
      /* v8 ignore start */
      case 10:
        break;
      default:
        if (true) {
          assert(false, `unhandled codegen node type: ${node.type}`);
          const exhaustiveCheck = node;
          return exhaustiveCheck;
        }
    }
  }
  function genText(node, context) {
    context.push(JSON.stringify(node.content), -3, node);
  }
  function genExpression(node, context) {
    const { content, isStatic } = node;
    context.push(
      isStatic ? JSON.stringify(content) : content,
      -3,
      node
    );
  }
  function genInterpolation(node, context) {
    const { push, helper, pure } = context;
    if (pure) push(PURE_ANNOTATION);
    push(`${helper(TO_DISPLAY_STRING)}(`);
    genNode(node.content, context);
    push(`)`);
  }
  function genCompoundExpression(node, context) {
    for (let i = 0; i < node.children.length; i++) {
      const child = node.children[i];
      if (isString(child)) {
        context.push(
          child,
          -3
          /* Unknown */
        );
      } else {
        genNode(child, context);
      }
    }
  }
  function genExpressionAsPropertyKey(node, context) {
    const { push } = context;
    if (node.type === 8) {
      push(`[`);
      genCompoundExpression(node, context);
      push(`]`);
    } else if (node.isStatic) {
      const text3 = isSimpleIdentifier(node.content) ? node.content : JSON.stringify(node.content);
      push(text3, -2, node);
    } else {
      push(`[${node.content}]`, -3, node);
    }
  }
  function genComment(node, context) {
    const { push, helper, pure } = context;
    if (pure) {
      push(PURE_ANNOTATION);
    }
    push(
      `${helper(CREATE_COMMENT)}(${JSON.stringify(node.content)})`,
      -3,
      node
    );
  }
  function genVNodeCall(node, context) {
    const { push, helper, pure } = context;
    const {
      tag,
      props,
      children,
      patchFlag,
      dynamicProps,
      directives,
      isBlock,
      disableTracking,
      isComponent: isComponent3
    } = node;
    let patchFlagString;
    if (patchFlag) {
      if (true) {
        if (patchFlag < 0) {
          patchFlagString = patchFlag + ` /* ${PatchFlagNames[patchFlag]} */`;
        } else {
          const flagNames = Object.keys(PatchFlagNames).map(Number).filter((n) => n > 0 && patchFlag & n).map((n) => PatchFlagNames[n]).join(`, `);
          patchFlagString = patchFlag + ` /* ${flagNames} */`;
        }
      } else {
        patchFlagString = String(patchFlag);
      }
    }
    if (directives) {
      push(helper(WITH_DIRECTIVES) + `(`);
    }
    if (isBlock) {
      push(`(${helper(OPEN_BLOCK)}(${disableTracking ? `true` : ``}), `);
    }
    if (pure) {
      push(PURE_ANNOTATION);
    }
    const callHelper = isBlock ? getVNodeBlockHelper(context.inSSR, isComponent3) : getVNodeHelper(context.inSSR, isComponent3);
    push(helper(callHelper) + `(`, -2, node);
    genNodeList(
      genNullableArgs([tag, props, children, patchFlagString, dynamicProps]),
      context
    );
    push(`)`);
    if (isBlock) {
      push(`)`);
    }
    if (directives) {
      push(`, `);
      genNode(directives, context);
      push(`)`);
    }
  }
  function genNullableArgs(args) {
    let i = args.length;
    while (i--) {
      if (args[i] != null) break;
    }
    return args.slice(0, i + 1).map((arg) => arg || `null`);
  }
  function genCallExpression(node, context) {
    const { push, helper, pure } = context;
    const callee = isString(node.callee) ? node.callee : helper(node.callee);
    if (pure) {
      push(PURE_ANNOTATION);
    }
    push(callee + `(`, -2, node);
    genNodeList(node.arguments, context);
    push(`)`);
  }
  function genObjectExpression(node, context) {
    const { push, indent, deindent, newline } = context;
    const { properties } = node;
    if (!properties.length) {
      push(`{}`, -2, node);
      return;
    }
    const multilines = properties.length > 1 || properties.some((p2) => p2.value.type !== 4);
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for (let i = 0; i < properties.length; i++) {
      const { key, value } = properties[i];
      genExpressionAsPropertyKey(key, context);
      push(`: `);
      genNode(value, context);
      if (i < properties.length - 1) {
        push(`,`);
        newline();
      }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
  }
  function genArrayExpression(node, context) {
    genNodeListAsArray(node.elements, context);
  }
  function genFunctionExpression(node, context) {
    const { push, indent, deindent } = context;
    const { params, returns, body, newline, isSlot } = node;
    if (isSlot) {
      push(`_${helperNameMap[WITH_CTX]}(`);
    }
    push(`(`, -2, node);
    if (isArray(params)) {
      genNodeList(params, context);
    } else if (params) {
      genNode(params, context);
    }
    push(`) => `);
    if (newline || body) {
      push(`{`);
      indent();
    }
    if (returns) {
      if (newline) {
        push(`return `);
      }
      if (isArray(returns)) {
        genNodeListAsArray(returns, context);
      } else {
        genNode(returns, context);
      }
    } else if (body) {
      genNode(body, context);
    }
    if (newline || body) {
      deindent();
      push(`}`);
    }
    if (isSlot) {
      if (node.isNonScopedSlot) {
        push(`, undefined, true`);
      }
      push(`)`);
    }
  }
  function genConditionalExpression(node, context) {
    const { test, consequent, alternate, newline: needNewline } = node;
    const { push, indent, deindent, newline } = context;
    if (test.type === 4) {
      const needsParens = !isSimpleIdentifier(test.content);
      needsParens && push(`(`);
      genExpression(test, context);
      needsParens && push(`)`);
    } else {
      push(`(`);
      genNode(test, context);
      push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19;
    if (!isNested) {
      context.indentLevel++;
    }
    genNode(alternate, context);
    if (!isNested) {
      context.indentLevel--;
    }
    needNewline && deindent(
      true
      /* without newline */
    );
  }
  function genCacheExpression(node, context) {
    const { push, helper, indent, deindent, newline } = context;
    const { needPauseTracking, needArraySpread } = node;
    if (needArraySpread) {
      push(`[...(`);
    }
    push(`_cache[${node.index}] || (`);
    if (needPauseTracking) {
      indent();
      push(`${helper(SET_BLOCK_TRACKING)}(-1`);
      if (node.inVOnce) push(`, true`);
      push(`),`);
      newline();
      push(`(`);
    }
    push(`_cache[${node.index}] = `);
    genNode(node.value, context);
    if (needPauseTracking) {
      push(`).cacheIndex = ${node.index},`);
      newline();
      push(`${helper(SET_BLOCK_TRACKING)}(1),`);
      newline();
      push(`_cache[${node.index}]`);
      deindent();
    }
    push(`)`);
    if (needArraySpread) {
      push(`)]`);
    }
  }
  var prohibitedKeywordRE = new RegExp(
    "\\b" + "arguments,await,break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,let,new,return,super,switch,throw,try,var,void,while,with,yield".split(",").join("\\b|\\b") + "\\b"
  );
  var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
  function validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    if (!exp.trim()) {
      return;
    }
    try {
      new Function(
        asRawStatements ? ` ${exp} ` : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`
      );
    } catch (e) {
      let message3 = e.message;
      const keywordMatch = exp.replace(stripStringRE, "").match(prohibitedKeywordRE);
      if (keywordMatch) {
        message3 = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
      }
      context.onError(
        createCompilerError(
          45,
          node.loc,
          void 0,
          message3
        )
      );
    }
  }
  var transformExpression = (node, context) => {
    if (node.type === 5) {
      node.content = processExpression(
        node.content,
        context
      );
    } else if (node.type === 1) {
      const memo2 = findDir(node, "memo");
      for (let i = 0; i < node.props.length; i++) {
        const dir = node.props[i];
        if (dir.type === 7 && dir.name !== "for") {
          const exp = dir.exp;
          const arg = dir.arg;
          if (exp && exp.type === 4 && !(dir.name === "on" && arg) && // key has been processed in transformFor(vMemo + vFor)
          !(memo2 && arg && arg.type === 4 && arg.content === "key")) {
            dir.exp = processExpression(
              exp,
              context,
              // slot args must be processed as function params
              dir.name === "slot"
            );
          }
          if (arg && arg.type === 4 && !arg.isStatic) {
            dir.arg = processExpression(arg, context);
          }
        }
      }
    }
  };
  function processExpression(node, context, asParams = false, asRawStatements = false, localVars = Object.create(context.identifiers)) {
    {
      if (true) {
        validateBrowserExpression(node, context, asParams, asRawStatements);
      }
      return node;
    }
  }
  var transformIf = createStructuralDirectiveTransform(
    /^(if|else|else-if)$/,
    (node, dir, context) => {
      return processIf(node, dir, context, (ifNode, branch, isRoot) => {
        const siblings2 = context.parent.children;
        let i = siblings2.indexOf(ifNode);
        let key = 0;
        while (i-- >= 0) {
          const sibling = siblings2[i];
          if (sibling && sibling.type === 9) {
            key += sibling.branches.length;
          }
        }
        return () => {
          if (isRoot) {
            ifNode.codegenNode = createCodegenNodeForBranch(
              branch,
              key,
              context
            );
          } else {
            const parentCondition = getParentCondition(ifNode.codegenNode);
            parentCondition.alternate = createCodegenNodeForBranch(
              branch,
              key + ifNode.branches.length - 1,
              context
            );
          }
        };
      });
    }
  );
  function processIf(node, dir, context, processCodegen) {
    if (dir.name !== "else" && (!dir.exp || !dir.exp.content.trim())) {
      const loc = dir.exp ? dir.exp.loc : node.loc;
      context.onError(
        createCompilerError(28, dir.loc)
      );
      dir.exp = createSimpleExpression(`true`, false, loc);
    }
    if (dir.exp) {
      validateBrowserExpression(dir.exp, context);
    }
    if (dir.name === "if") {
      const branch = createIfBranch(node, dir);
      const ifNode = {
        type: 9,
        loc: cloneLoc(node.loc),
        branches: [branch]
      };
      context.replaceNode(ifNode);
      if (processCodegen) {
        return processCodegen(ifNode, branch, true);
      }
    } else {
      const siblings2 = context.parent.children;
      const comments = [];
      let i = siblings2.indexOf(node);
      while (i-- >= -1) {
        const sibling = siblings2[i];
        if (sibling && sibling.type === 3) {
          context.removeNode(sibling);
          comments.unshift(sibling);
          continue;
        }
        if (sibling && sibling.type === 2 && !sibling.content.trim().length) {
          context.removeNode(sibling);
          continue;
        }
        if (sibling && sibling.type === 9) {
          if (dir.name === "else-if" && sibling.branches[sibling.branches.length - 1].condition === void 0) {
            context.onError(
              createCompilerError(30, node.loc)
            );
          }
          context.removeNode();
          const branch = createIfBranch(node, dir);
          if (comments.length && // #3619 ignore comments if the v-if is direct child of <transition>
          !(context.parent && context.parent.type === 1 && (context.parent.tag === "transition" || context.parent.tag === "Transition"))) {
            branch.children = [...comments, ...branch.children];
          }
          if (true) {
            const key = branch.userKey;
            if (key) {
              sibling.branches.forEach(({ userKey }) => {
                if (isSameKey(userKey, key)) {
                  context.onError(
                    createCompilerError(
                      29,
                      branch.userKey.loc
                    )
                  );
                }
              });
            }
          }
          sibling.branches.push(branch);
          const onExit = processCodegen && processCodegen(sibling, branch, false);
          traverseNode(branch, context);
          if (onExit) onExit();
          context.currentNode = null;
        } else {
          context.onError(
            createCompilerError(30, node.loc)
          );
        }
        break;
      }
    }
  }
  function createIfBranch(node, dir) {
    const isTemplateIf = node.tagType === 3;
    return {
      type: 10,
      loc: node.loc,
      condition: dir.name === "else" ? void 0 : dir.exp,
      children: isTemplateIf && !findDir(node, "for") ? node.children : [node],
      userKey: findProp(node, `key`),
      isTemplateIf
    };
  }
  function createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) {
      return createConditionalExpression(
        branch.condition,
        createChildrenCodegenNode(branch, keyIndex, context),
        // make sure to pass in asBlock: true so that the comment node call
        // closes the current block.
        createCallExpression(context.helper(CREATE_COMMENT), [
          true ? '"v-if"' : '""',
          "true"
        ])
      );
    } else {
      return createChildrenCodegenNode(branch, keyIndex, context);
    }
  }
  function createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper } = context;
    const keyProperty = createObjectProperty(
      `key`,
      createSimpleExpression(
        `${keyIndex}`,
        false,
        locStub,
        2
      )
    );
    const { children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1;
    if (needFragmentWrapper) {
      if (children.length === 1 && firstChild.type === 11) {
        const vnodeCall = firstChild.codegenNode;
        injectProp(vnodeCall, keyProperty, context);
        return vnodeCall;
      } else {
        let patchFlag = 64;
        if (!branch.isTemplateIf && children.filter((c) => c.type !== 3).length === 1) {
          patchFlag |= 2048;
        }
        return createVNodeCall(
          context,
          helper(FRAGMENT),
          createObjectExpression([keyProperty]),
          children,
          patchFlag,
          void 0,
          void 0,
          true,
          false,
          false,
          branch.loc
        );
      }
    } else {
      const ret = firstChild.codegenNode;
      const vnodeCall = getMemoedVNodeCall(ret);
      if (vnodeCall.type === 13) {
        convertToBlock(vnodeCall, context);
      }
      injectProp(vnodeCall, keyProperty, context);
      return ret;
    }
  }
  function isSameKey(a, b) {
    if (!a || a.type !== b.type) {
      return false;
    }
    if (a.type === 6) {
      if (a.value.content !== b.value.content) {
        return false;
      }
    } else {
      const exp = a.exp;
      const branchExp = b.exp;
      if (exp.type !== branchExp.type) {
        return false;
      }
      if (exp.type !== 4 || exp.isStatic !== branchExp.isStatic || exp.content !== branchExp.content) {
        return false;
      }
    }
    return true;
  }
  function getParentCondition(node) {
    while (true) {
      if (node.type === 19) {
        if (node.alternate.type === 19) {
          node = node.alternate;
        } else {
          return node;
        }
      } else if (node.type === 20) {
        node = node.value;
      }
    }
  }
  var transformBind = (dir, _node, context) => {
    const { modifiers, loc } = dir;
    const arg = dir.arg;
    let { exp } = dir;
    if (exp && exp.type === 4 && !exp.content.trim()) {
      {
        exp = void 0;
      }
    }
    if (!exp) {
      if (arg.type !== 4 || !arg.isStatic) {
        context.onError(
          createCompilerError(
            52,
            arg.loc
          )
        );
        return {
          props: [
            createObjectProperty(arg, createSimpleExpression("", true, loc))
          ]
        };
      }
      transformBindShorthand(dir);
      exp = dir.exp;
    }
    if (arg.type !== 4) {
      arg.children.unshift(`(`);
      arg.children.push(`) || ""`);
    } else if (!arg.isStatic) {
      arg.content = `${arg.content} || ""`;
    }
    if (modifiers.some((mod) => mod.content === "camel")) {
      if (arg.type === 4) {
        if (arg.isStatic) {
          arg.content = camelize(arg.content);
        } else {
          arg.content = `${context.helperString(CAMELIZE)}(${arg.content})`;
        }
      } else {
        arg.children.unshift(`${context.helperString(CAMELIZE)}(`);
        arg.children.push(`)`);
      }
    }
    if (!context.inSSR) {
      if (modifiers.some((mod) => mod.content === "prop")) {
        injectPrefix(arg, ".");
      }
      if (modifiers.some((mod) => mod.content === "attr")) {
        injectPrefix(arg, "^");
      }
    }
    return {
      props: [createObjectProperty(arg, exp)]
    };
  };
  var transformBindShorthand = (dir, context) => {
    const arg = dir.arg;
    const propName = camelize(arg.content);
    dir.exp = createSimpleExpression(propName, false, arg.loc);
  };
  var injectPrefix = (arg, prefix2) => {
    if (arg.type === 4) {
      if (arg.isStatic) {
        arg.content = prefix2 + arg.content;
      } else {
        arg.content = `\`${prefix2}\${${arg.content}}\``;
      }
    } else {
      arg.children.unshift(`'${prefix2}' + (`);
      arg.children.push(`)`);
    }
  };
  var transformFor = createStructuralDirectiveTransform(
    "for",
    (node, dir, context) => {
      const { helper, removeHelper } = context;
      return processFor(node, dir, context, (forNode) => {
        const renderExp = createCallExpression(helper(RENDER_LIST), [
          forNode.source
        ]);
        const isTemplate = isTemplateNode(node);
        const memo2 = findDir(node, "memo");
        const keyProp = findProp(node, `key`, false, true);
        const isDirKey = keyProp && keyProp.type === 7;
        if (isDirKey && !keyProp.exp) {
          transformBindShorthand(keyProp);
        }
        let keyExp = keyProp && (keyProp.type === 6 ? keyProp.value ? createSimpleExpression(keyProp.value.content, true) : void 0 : keyProp.exp);
        const keyProperty = keyProp && keyExp ? createObjectProperty(`key`, keyExp) : null;
        const isStableFragment = forNode.source.type === 4 && forNode.source.constType > 0;
        const fragmentFlag = isStableFragment ? 64 : keyProp ? 128 : 256;
        forNode.codegenNode = createVNodeCall(
          context,
          helper(FRAGMENT),
          void 0,
          renderExp,
          fragmentFlag,
          void 0,
          void 0,
          true,
          !isStableFragment,
          false,
          node.loc
        );
        return () => {
          let childBlock;
          const { children } = forNode;
          if (isTemplate) {
            node.children.some((c) => {
              if (c.type === 1) {
                const key = findProp(c, "key");
                if (key) {
                  context.onError(
                    createCompilerError(
                      33,
                      key.loc
                    )
                  );
                  return true;
                }
              }
            });
          }
          const needFragmentWrapper = children.length !== 1 || children[0].type !== 1;
          const slotOutlet = isSlotOutlet(node) ? node : isTemplate && node.children.length === 1 && isSlotOutlet(node.children[0]) ? node.children[0] : null;
          if (slotOutlet) {
            childBlock = slotOutlet.codegenNode;
            if (isTemplate && keyProperty) {
              injectProp(childBlock, keyProperty, context);
            }
          } else if (needFragmentWrapper) {
            childBlock = createVNodeCall(
              context,
              helper(FRAGMENT),
              keyProperty ? createObjectExpression([keyProperty]) : void 0,
              node.children,
              64,
              void 0,
              void 0,
              true,
              void 0,
              false
            );
          } else {
            childBlock = children[0].codegenNode;
            if (isTemplate && keyProperty) {
              injectProp(childBlock, keyProperty, context);
            }
            if (childBlock.isBlock !== !isStableFragment) {
              if (childBlock.isBlock) {
                removeHelper(OPEN_BLOCK);
                removeHelper(
                  getVNodeBlockHelper(context.inSSR, childBlock.isComponent)
                );
              } else {
                removeHelper(
                  getVNodeHelper(context.inSSR, childBlock.isComponent)
                );
              }
            }
            childBlock.isBlock = !isStableFragment;
            if (childBlock.isBlock) {
              helper(OPEN_BLOCK);
              helper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
            } else {
              helper(getVNodeHelper(context.inSSR, childBlock.isComponent));
            }
          }
          if (memo2) {
            const loop = createFunctionExpression(
              createForLoopParams(forNode.parseResult, [
                createSimpleExpression(`_cached`)
              ])
            );
            loop.body = createBlockStatement([
              createCompoundExpression([`const _memo = (`, memo2.exp, `)`]),
              createCompoundExpression([
                `if (_cached`,
                ...keyExp ? [` && _cached.key === `, keyExp] : [],
                ` && ${context.helperString(
                  IS_MEMO_SAME
                )}(_cached, _memo)) return _cached`
              ]),
              createCompoundExpression([`const _item = `, childBlock]),
              createSimpleExpression(`_item.memo = _memo`),
              createSimpleExpression(`return _item`)
            ]);
            renderExp.arguments.push(
              loop,
              createSimpleExpression(`_cache`),
              createSimpleExpression(String(context.cached.length))
            );
            context.cached.push(null);
          } else {
            renderExp.arguments.push(
              createFunctionExpression(
                createForLoopParams(forNode.parseResult),
                childBlock,
                true
              )
            );
          }
        };
      });
    }
  );
  function processFor(node, dir, context, processCodegen) {
    if (!dir.exp) {
      context.onError(
        createCompilerError(31, dir.loc)
      );
      return;
    }
    const parseResult = dir.forParseResult;
    if (!parseResult) {
      context.onError(
        createCompilerError(32, dir.loc)
      );
      return;
    }
    finalizeForParseResult(parseResult, context);
    const { addIdentifiers, removeIdentifiers, scopes } = context;
    const { source, value, key, index } = parseResult;
    const forNode = {
      type: 11,
      loc: dir.loc,
      source,
      valueAlias: value,
      keyAlias: key,
      objectIndexAlias: index,
      parseResult,
      children: isTemplateNode(node) ? node.children : [node]
    };
    context.replaceNode(forNode);
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return () => {
      scopes.vFor--;
      if (onExit) onExit();
    };
  }
  function finalizeForParseResult(result, context) {
    if (result.finalized) return;
    if (true) {
      validateBrowserExpression(result.source, context);
      if (result.key) {
        validateBrowserExpression(
          result.key,
          context,
          true
        );
      }
      if (result.index) {
        validateBrowserExpression(
          result.index,
          context,
          true
        );
      }
      if (result.value) {
        validateBrowserExpression(
          result.value,
          context,
          true
        );
      }
    }
    result.finalized = true;
  }
  function createForLoopParams({ value, key, index }, memoArgs = []) {
    return createParamsList([value, key, index, ...memoArgs]);
  }
  function createParamsList(args) {
    let i = args.length;
    while (i--) {
      if (args[i]) break;
    }
    return args.slice(0, i + 1).map((arg, i2) => arg || createSimpleExpression(`_`.repeat(i2 + 1), false));
  }
  var defaultFallback = createSimpleExpression(`undefined`, false);
  var trackSlotScopes = (node, context) => {
    if (node.type === 1 && (node.tagType === 1 || node.tagType === 3)) {
      const vSlot = findDir(node, "slot");
      if (vSlot) {
        vSlot.exp;
        context.scopes.vSlot++;
        return () => {
          context.scopes.vSlot--;
        };
      }
    }
  };
  var buildClientSlotFn = (props, _vForExp, children, loc) => createFunctionExpression(
    props,
    children,
    false,
    true,
    children.length ? children[0].loc : loc
  );
  function buildSlots(node, context, buildSlotFn = buildClientSlotFn) {
    context.helper(WITH_CTX);
    const { children, loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    const onComponentSlot = findDir(node, "slot", true);
    if (onComponentSlot) {
      const { arg, exp } = onComponentSlot;
      if (arg && !isStaticExp(arg)) {
        hasDynamicSlots = true;
      }
      slotsProperties.push(
        createObjectProperty(
          arg || createSimpleExpression("default", true),
          buildSlotFn(exp, void 0, children, loc)
        )
      );
    }
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = /* @__PURE__ */ new Set();
    let conditionalBranchIndex = 0;
    for (let i = 0; i < children.length; i++) {
      const slotElement = children[i];
      let slotDir;
      if (!isTemplateNode(slotElement) || !(slotDir = findDir(slotElement, "slot", true))) {
        if (slotElement.type !== 3) {
          implicitDefaultChildren.push(slotElement);
        }
        continue;
      }
      if (onComponentSlot) {
        context.onError(
          createCompilerError(37, slotDir.loc)
        );
        break;
      }
      hasTemplateSlots = true;
      const { children: slotChildren, loc: slotLoc } = slotElement;
      const {
        arg: slotName = createSimpleExpression(`default`, true),
        exp: slotProps,
        loc: dirLoc
      } = slotDir;
      let staticSlotName;
      if (isStaticExp(slotName)) {
        staticSlotName = slotName ? slotName.content : `default`;
      } else {
        hasDynamicSlots = true;
      }
      const vFor = findDir(slotElement, "for");
      const slotFunction = buildSlotFn(slotProps, vFor, slotChildren, slotLoc);
      let vIf;
      let vElse;
      if (vIf = findDir(slotElement, "if")) {
        hasDynamicSlots = true;
        dynamicSlots.push(
          createConditionalExpression(
            vIf.exp,
            buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++),
            defaultFallback
          )
        );
      } else if (vElse = findDir(
        slotElement,
        /^else(-if)?$/,
        true
        /* allowEmpty */
      )) {
        let j = i;
        let prev;
        while (j--) {
          prev = children[j];
          if (prev.type !== 3) {
            break;
          }
        }
        if (prev && isTemplateNode(prev) && findDir(prev, /^(else-)?if$/)) {
          let conditional = dynamicSlots[dynamicSlots.length - 1];
          while (conditional.alternate.type === 19) {
            conditional = conditional.alternate;
          }
          conditional.alternate = vElse.exp ? createConditionalExpression(
            vElse.exp,
            buildDynamicSlot(
              slotName,
              slotFunction,
              conditionalBranchIndex++
            ),
            defaultFallback
          ) : buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++);
        } else {
          context.onError(
            createCompilerError(30, vElse.loc)
          );
        }
      } else if (vFor) {
        hasDynamicSlots = true;
        const parseResult = vFor.forParseResult;
        if (parseResult) {
          finalizeForParseResult(parseResult, context);
          dynamicSlots.push(
            createCallExpression(context.helper(RENDER_LIST), [
              parseResult.source,
              createFunctionExpression(
                createForLoopParams(parseResult),
                buildDynamicSlot(slotName, slotFunction),
                true
              )
            ])
          );
        } else {
          context.onError(
            createCompilerError(
              32,
              vFor.loc
            )
          );
        }
      } else {
        if (staticSlotName) {
          if (seenSlotNames.has(staticSlotName)) {
            context.onError(
              createCompilerError(
                38,
                dirLoc
              )
            );
            continue;
          }
          seenSlotNames.add(staticSlotName);
          if (staticSlotName === "default") {
            hasNamedDefaultSlot = true;
          }
        }
        slotsProperties.push(createObjectProperty(slotName, slotFunction));
      }
    }
    if (!onComponentSlot) {
      const buildDefaultSlotProperty = (props, children2) => {
        const fn = buildSlotFn(props, void 0, children2, loc);
        if (context.compatConfig) {
          fn.isNonScopedSlot = true;
        }
        return createObjectProperty(`default`, fn);
      };
      if (!hasTemplateSlots) {
        slotsProperties.push(buildDefaultSlotProperty(void 0, children));
      } else if (implicitDefaultChildren.length && // #3766
      // with whitespace: 'preserve', whitespaces between slots will end up in
      // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
      implicitDefaultChildren.some((node2) => isNonWhitespaceContent(node2))) {
        if (hasNamedDefaultSlot) {
          context.onError(
            createCompilerError(
              39,
              implicitDefaultChildren[0].loc
            )
          );
        } else {
          slotsProperties.push(
            buildDefaultSlotProperty(void 0, implicitDefaultChildren)
          );
        }
      }
    }
    const slotFlag = hasDynamicSlots ? 2 : hasForwardedSlots(node.children) ? 3 : 1;
    let slots = createObjectExpression(
      slotsProperties.concat(
        createObjectProperty(
          `_`,
          // 2 = compiled but dynamic = can skip normalization, but must run diff
          // 1 = compiled and static = can skip normalization AND diff as optimized
          createSimpleExpression(
            slotFlag + (true ? ` /* ${slotFlagsText[slotFlag]} */` : ``),
            false
          )
        )
      ),
      loc
    );
    if (dynamicSlots.length) {
      slots = createCallExpression(context.helper(CREATE_SLOTS), [
        slots,
        createArrayExpression(dynamicSlots)
      ]);
    }
    return {
      slots,
      hasDynamicSlots
    };
  }
  function buildDynamicSlot(name, fn, index) {
    const props = [
      createObjectProperty(`name`, name),
      createObjectProperty(`fn`, fn)
    ];
    if (index != null) {
      props.push(
        createObjectProperty(`key`, createSimpleExpression(String(index), true))
      );
    }
    return createObjectExpression(props);
  }
  function hasForwardedSlots(children) {
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      switch (child.type) {
        case 1:
          if (child.tagType === 2 || hasForwardedSlots(child.children)) {
            return true;
          }
          break;
        case 9:
          if (hasForwardedSlots(child.branches)) return true;
          break;
        case 10:
        case 11:
          if (hasForwardedSlots(child.children)) return true;
          break;
      }
    }
    return false;
  }
  function isNonWhitespaceContent(node) {
    if (node.type !== 2 && node.type !== 12)
      return true;
    return node.type === 2 ? !!node.content.trim() : isNonWhitespaceContent(node.content);
  }
  var directiveImportMap = /* @__PURE__ */ new WeakMap();
  var transformElement = (node, context) => {
    return function postTransformElement() {
      node = context.currentNode;
      if (!(node.type === 1 && (node.tagType === 0 || node.tagType === 1))) {
        return;
      }
      const { tag, props } = node;
      const isComponent3 = node.tagType === 1;
      let vnodeTag = isComponent3 ? resolveComponentType(node, context) : `"${tag}"`;
      const isDynamicComponent = isObject(vnodeTag) && vnodeTag.callee === RESOLVE_DYNAMIC_COMPONENT;
      let vnodeProps;
      let vnodeChildren;
      let patchFlag = 0;
      let vnodeDynamicProps;
      let dynamicPropNames;
      let vnodeDirectives;
      let shouldUseBlock = (
        // dynamic component may resolve to plain elements
        isDynamicComponent || vnodeTag === TELEPORT || vnodeTag === SUSPENSE || !isComponent3 && // <svg> and <foreignObject> must be forced into blocks so that block
        // updates inside get proper isSVG flag at runtime. (#639, #643)
        // This is technically web-specific, but splitting the logic out of core
        // leads to too much unnecessary complexity.
        (tag === "svg" || tag === "foreignObject" || tag === "math")
      );
      if (props.length > 0) {
        const propsBuildResult = buildProps(
          node,
          context,
          void 0,
          isComponent3,
          isDynamicComponent
        );
        vnodeProps = propsBuildResult.props;
        patchFlag = propsBuildResult.patchFlag;
        dynamicPropNames = propsBuildResult.dynamicPropNames;
        const directives = propsBuildResult.directives;
        vnodeDirectives = directives && directives.length ? createArrayExpression(
          directives.map((dir) => buildDirectiveArgs(dir, context))
        ) : void 0;
        if (propsBuildResult.shouldUseBlock) {
          shouldUseBlock = true;
        }
      }
      if (node.children.length > 0) {
        if (vnodeTag === KEEP_ALIVE) {
          shouldUseBlock = true;
          patchFlag |= 1024;
          if (node.children.length > 1) {
            context.onError(
              createCompilerError(46, {
                start: node.children[0].loc.start,
                end: node.children[node.children.length - 1].loc.end,
                source: ""
              })
            );
          }
        }
        const shouldBuildAsSlots = isComponent3 && // Teleport is not a real component and has dedicated runtime handling
        vnodeTag !== TELEPORT && // explained above.
        vnodeTag !== KEEP_ALIVE;
        if (shouldBuildAsSlots) {
          const { slots, hasDynamicSlots } = buildSlots(node, context);
          vnodeChildren = slots;
          if (hasDynamicSlots) {
            patchFlag |= 1024;
          }
        } else if (node.children.length === 1 && vnodeTag !== TELEPORT) {
          const child = node.children[0];
          const type = child.type;
          const hasDynamicTextChild = type === 5 || type === 8;
          if (hasDynamicTextChild && getConstantType(child, context) === 0) {
            patchFlag |= 1;
          }
          if (hasDynamicTextChild || type === 2) {
            vnodeChildren = child;
          } else {
            vnodeChildren = node.children;
          }
        } else {
          vnodeChildren = node.children;
        }
      }
      if (dynamicPropNames && dynamicPropNames.length) {
        vnodeDynamicProps = stringifyDynamicPropNames(dynamicPropNames);
      }
      node.codegenNode = createVNodeCall(
        context,
        vnodeTag,
        vnodeProps,
        vnodeChildren,
        patchFlag === 0 ? void 0 : patchFlag,
        vnodeDynamicProps,
        vnodeDirectives,
        !!shouldUseBlock,
        false,
        isComponent3,
        node.loc
      );
    };
  };
  function resolveComponentType(node, context, ssr = false) {
    let { tag } = node;
    const isExplicitDynamic = isComponentTag(tag);
    const isProp = findProp(
      node,
      "is",
      false,
      true
      /* allow empty */
    );
    if (isProp) {
      if (isExplicitDynamic || isCompatEnabled(
        "COMPILER_IS_ON_ELEMENT",
        context
      )) {
        let exp;
        if (isProp.type === 6) {
          exp = isProp.value && createSimpleExpression(isProp.value.content, true);
        } else {
          exp = isProp.exp;
          if (!exp) {
            exp = createSimpleExpression(`is`, false, isProp.arg.loc);
          }
        }
        if (exp) {
          return createCallExpression(context.helper(RESOLVE_DYNAMIC_COMPONENT), [
            exp
          ]);
        }
      } else if (isProp.type === 6 && isProp.value.content.startsWith("vue:")) {
        tag = isProp.value.content.slice(4);
      }
    }
    const builtIn = isCoreComponent(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
      if (!ssr) context.helper(builtIn);
      return builtIn;
    }
    context.helper(RESOLVE_COMPONENT);
    context.components.add(tag);
    return toValidAssetId(tag, `component`);
  }
  function buildProps(node, context, props = node.props, isComponent3, isDynamicComponent, ssr = false) {
    const { tag, loc: elementLoc, children } = node;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const pushMergeArg = (arg) => {
      if (properties.length) {
        mergeArgs.push(
          createObjectExpression(dedupeProperties(properties), elementLoc)
        );
        properties = [];
      }
      if (arg) mergeArgs.push(arg);
    };
    const pushRefVForMarker = () => {
      if (context.scopes.vFor > 0) {
        properties.push(
          createObjectProperty(
            createSimpleExpression("ref_for", true),
            createSimpleExpression("true")
          )
        );
      }
    };
    const analyzePatchFlag = ({ key, value }) => {
      if (isStaticExp(key)) {
        const name = key.content;
        const isEventHandler = isOn(name);
        if (isEventHandler && (!isComponent3 || isDynamicComponent) && // omit the flag for click handlers because hydration gives click
        // dedicated fast path.
        name.toLowerCase() !== "onclick" && // omit v-model handlers
        name !== "onUpdate:modelValue" && // omit onVnodeXXX hooks
        !isReservedProp(name)) {
          hasHydrationEventBinding = true;
        }
        if (isEventHandler && isReservedProp(name)) {
          hasVnodeHook = true;
        }
        if (isEventHandler && value.type === 14) {
          value = value.arguments[0];
        }
        if (value.type === 20 || (value.type === 4 || value.type === 8) && getConstantType(value, context) > 0) {
          return;
        }
        if (name === "ref") {
          hasRef = true;
        } else if (name === "class") {
          hasClassBinding = true;
        } else if (name === "style") {
          hasStyleBinding = true;
        } else if (name !== "key" && !dynamicPropNames.includes(name)) {
          dynamicPropNames.push(name);
        }
        if (isComponent3 && (name === "class" || name === "style") && !dynamicPropNames.includes(name)) {
          dynamicPropNames.push(name);
        }
      } else {
        hasDynamicKeys = true;
      }
    };
    for (let i = 0; i < props.length; i++) {
      const prop = props[i];
      if (prop.type === 6) {
        const { loc, name, nameLoc, value } = prop;
        let isStatic = true;
        if (name === "ref") {
          hasRef = true;
          pushRefVForMarker();
        }
        if (name === "is" && (isComponentTag(tag) || value && value.content.startsWith("vue:") || isCompatEnabled(
          "COMPILER_IS_ON_ELEMENT",
          context
        ))) {
          continue;
        }
        properties.push(
          createObjectProperty(
            createSimpleExpression(name, true, nameLoc),
            createSimpleExpression(
              value ? value.content : "",
              isStatic,
              value ? value.loc : loc
            )
          )
        );
      } else {
        const { name, arg, exp, loc, modifiers } = prop;
        const isVBind = name === "bind";
        const isVOn = name === "on";
        if (name === "slot") {
          if (!isComponent3) {
            context.onError(
              createCompilerError(40, loc)
            );
          }
          continue;
        }
        if (name === "once" || name === "memo") {
          continue;
        }
        if (name === "is" || isVBind && isStaticArgOf(arg, "is") && (isComponentTag(tag) || isCompatEnabled(
          "COMPILER_IS_ON_ELEMENT",
          context
        ))) {
          continue;
        }
        if (isVOn && ssr) {
          continue;
        }
        if (
          // #938: elements with dynamic keys should be forced into blocks
          isVBind && isStaticArgOf(arg, "key") || // inline before-update hooks need to force block so that it is invoked
          // before children
          isVOn && hasChildren && isStaticArgOf(arg, "vue:before-update")
        ) {
          shouldUseBlock = true;
        }
        if (isVBind && isStaticArgOf(arg, "ref")) {
          pushRefVForMarker();
        }
        if (!arg && (isVBind || isVOn)) {
          hasDynamicKeys = true;
          if (exp) {
            if (isVBind) {
              pushRefVForMarker();
              pushMergeArg();
              {
                if (true) {
                  const hasOverridableKeys = mergeArgs.some((arg2) => {
                    if (arg2.type === 15) {
                      return arg2.properties.some(({ key }) => {
                        if (key.type !== 4 || !key.isStatic) {
                          return true;
                        }
                        return key.content !== "class" && key.content !== "style" && !isOn(key.content);
                      });
                    } else {
                      return true;
                    }
                  });
                  if (hasOverridableKeys) {
                    checkCompatEnabled(
                      "COMPILER_V_BIND_OBJECT_ORDER",
                      context,
                      loc
                    );
                  }
                }
                if (isCompatEnabled(
                  "COMPILER_V_BIND_OBJECT_ORDER",
                  context
                )) {
                  mergeArgs.unshift(exp);
                  continue;
                }
              }
              mergeArgs.push(exp);
            } else {
              pushMergeArg({
                type: 14,
                loc,
                callee: context.helper(TO_HANDLERS),
                arguments: isComponent3 ? [exp] : [exp, `true`]
              });
            }
          } else {
            context.onError(
              createCompilerError(
                isVBind ? 34 : 35,
                loc
              )
            );
          }
          continue;
        }
        if (isVBind && modifiers.some((mod) => mod.content === "prop")) {
          patchFlag |= 32;
        }
        const directiveTransform = context.directiveTransforms[name];
        if (directiveTransform) {
          const { props: props2, needRuntime } = directiveTransform(prop, node, context);
          !ssr && props2.forEach(analyzePatchFlag);
          if (isVOn && arg && !isStaticExp(arg)) {
            pushMergeArg(createObjectExpression(props2, elementLoc));
          } else {
            properties.push(...props2);
          }
          if (needRuntime) {
            runtimeDirectives.push(prop);
            if (isSymbol(needRuntime)) {
              directiveImportMap.set(prop, needRuntime);
            }
          }
        } else if (!isBuiltInDirective(name)) {
          runtimeDirectives.push(prop);
          if (hasChildren) {
            shouldUseBlock = true;
          }
        }
      }
    }
    let propsExpression = void 0;
    if (mergeArgs.length) {
      pushMergeArg();
      if (mergeArgs.length > 1) {
        propsExpression = createCallExpression(
          context.helper(MERGE_PROPS),
          mergeArgs,
          elementLoc
        );
      } else {
        propsExpression = mergeArgs[0];
      }
    } else if (properties.length) {
      propsExpression = createObjectExpression(
        dedupeProperties(properties),
        elementLoc
      );
    }
    if (hasDynamicKeys) {
      patchFlag |= 16;
    } else {
      if (hasClassBinding && !isComponent3) {
        patchFlag |= 2;
      }
      if (hasStyleBinding && !isComponent3) {
        patchFlag |= 4;
      }
      if (dynamicPropNames.length) {
        patchFlag |= 8;
      }
      if (hasHydrationEventBinding) {
        patchFlag |= 32;
      }
    }
    if (!shouldUseBlock && (patchFlag === 0 || patchFlag === 32) && (hasRef || hasVnodeHook || runtimeDirectives.length > 0)) {
      patchFlag |= 512;
    }
    if (!context.inSSR && propsExpression) {
      switch (propsExpression.type) {
        case 15:
          let classKeyIndex = -1;
          let styleKeyIndex = -1;
          let hasDynamicKey = false;
          for (let i = 0; i < propsExpression.properties.length; i++) {
            const key = propsExpression.properties[i].key;
            if (isStaticExp(key)) {
              if (key.content === "class") {
                classKeyIndex = i;
              } else if (key.content === "style") {
                styleKeyIndex = i;
              }
            } else if (!key.isHandlerKey) {
              hasDynamicKey = true;
            }
          }
          const classProp = propsExpression.properties[classKeyIndex];
          const styleProp = propsExpression.properties[styleKeyIndex];
          if (!hasDynamicKey) {
            if (classProp && !isStaticExp(classProp.value)) {
              classProp.value = createCallExpression(
                context.helper(NORMALIZE_CLASS),
                [classProp.value]
              );
            }
            if (styleProp && // the static style is compiled into an object,
            // so use `hasStyleBinding` to ensure that it is a dynamic style binding
            (hasStyleBinding || styleProp.value.type === 4 && styleProp.value.content.trim()[0] === `[` || // v-bind:style and style both exist,
            // v-bind:style with static literal object
            styleProp.value.type === 17)) {
              styleProp.value = createCallExpression(
                context.helper(NORMALIZE_STYLE),
                [styleProp.value]
              );
            }
          } else {
            propsExpression = createCallExpression(
              context.helper(NORMALIZE_PROPS),
              [propsExpression]
            );
          }
          break;
        case 14:
          break;
        default:
          propsExpression = createCallExpression(
            context.helper(NORMALIZE_PROPS),
            [
              createCallExpression(context.helper(GUARD_REACTIVE_PROPS), [
                propsExpression
              ])
            ]
          );
          break;
      }
    }
    return {
      props: propsExpression,
      directives: runtimeDirectives,
      patchFlag,
      dynamicPropNames,
      shouldUseBlock
    };
  }
  function dedupeProperties(properties) {
    const knownProps = /* @__PURE__ */ new Map();
    const deduped = [];
    for (let i = 0; i < properties.length; i++) {
      const prop = properties[i];
      if (prop.key.type === 8 || !prop.key.isStatic) {
        deduped.push(prop);
        continue;
      }
      const name = prop.key.content;
      const existing = knownProps.get(name);
      if (existing) {
        if (name === "style" || name === "class" || isOn(name)) {
          mergeAsArray2(existing, prop);
        }
      } else {
        knownProps.set(name, prop);
        deduped.push(prop);
      }
    }
    return deduped;
  }
  function mergeAsArray2(existing, incoming) {
    if (existing.value.type === 17) {
      existing.value.elements.push(incoming.value);
    } else {
      existing.value = createArrayExpression(
        [existing.value, incoming.value],
        existing.loc
      );
    }
  }
  function buildDirectiveArgs(dir, context) {
    const dirArgs = [];
    const runtime = directiveImportMap.get(dir);
    if (runtime) {
      dirArgs.push(context.helperString(runtime));
    } else {
      {
        context.helper(RESOLVE_DIRECTIVE);
        context.directives.add(dir.name);
        dirArgs.push(toValidAssetId(dir.name, `directive`));
      }
    }
    const { loc } = dir;
    if (dir.exp) dirArgs.push(dir.exp);
    if (dir.arg) {
      if (!dir.exp) {
        dirArgs.push(`void 0`);
      }
      dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
      if (!dir.arg) {
        if (!dir.exp) {
          dirArgs.push(`void 0`);
        }
        dirArgs.push(`void 0`);
      }
      const trueExpression = createSimpleExpression(`true`, false, loc);
      dirArgs.push(
        createObjectExpression(
          dir.modifiers.map(
            (modifier) => createObjectProperty(modifier, trueExpression)
          ),
          loc
        )
      );
    }
    return createArrayExpression(dirArgs, dir.loc);
  }
  function stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for (let i = 0, l = props.length; i < l; i++) {
      propsNamesString += JSON.stringify(props[i]);
      if (i < l - 1) propsNamesString += ", ";
    }
    return propsNamesString + `]`;
  }
  function isComponentTag(tag) {
    return tag === "component" || tag === "Component";
  }
  var transformSlotOutlet = (node, context) => {
    if (isSlotOutlet(node)) {
      const { children, loc } = node;
      const { slotName, slotProps } = processSlotOutlet(node, context);
      const slotArgs = [
        context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
        slotName,
        "{}",
        "undefined",
        "true"
      ];
      let expectedLen = 2;
      if (slotProps) {
        slotArgs[2] = slotProps;
        expectedLen = 3;
      }
      if (children.length) {
        slotArgs[3] = createFunctionExpression([], children, false, false, loc);
        expectedLen = 4;
      }
      if (context.scopeId && !context.slotted) {
        expectedLen = 5;
      }
      slotArgs.splice(expectedLen);
      node.codegenNode = createCallExpression(
        context.helper(RENDER_SLOT),
        slotArgs,
        loc
      );
    }
  };
  function processSlotOutlet(node, context) {
    let slotName = `"default"`;
    let slotProps = void 0;
    const nonNameProps = [];
    for (let i = 0; i < node.props.length; i++) {
      const p2 = node.props[i];
      if (p2.type === 6) {
        if (p2.value) {
          if (p2.name === "name") {
            slotName = JSON.stringify(p2.value.content);
          } else {
            p2.name = camelize(p2.name);
            nonNameProps.push(p2);
          }
        }
      } else {
        if (p2.name === "bind" && isStaticArgOf(p2.arg, "name")) {
          if (p2.exp) {
            slotName = p2.exp;
          } else if (p2.arg && p2.arg.type === 4) {
            const name = camelize(p2.arg.content);
            slotName = p2.exp = createSimpleExpression(name, false, p2.arg.loc);
          }
        } else {
          if (p2.name === "bind" && p2.arg && isStaticExp(p2.arg)) {
            p2.arg.content = camelize(p2.arg.content);
          }
          nonNameProps.push(p2);
        }
      }
    }
    if (nonNameProps.length > 0) {
      const { props, directives } = buildProps(
        node,
        context,
        nonNameProps,
        false,
        false
      );
      slotProps = props;
      if (directives.length) {
        context.onError(
          createCompilerError(
            36,
            directives[0].loc
          )
        );
      }
    }
    return {
      slotName,
      slotProps
    };
  }
  var transformOn = (dir, node, context, augmentor) => {
    const { loc, modifiers, arg } = dir;
    if (!dir.exp && !modifiers.length) {
      context.onError(createCompilerError(35, loc));
    }
    let eventName;
    if (arg.type === 4) {
      if (arg.isStatic) {
        let rawName = arg.content;
        if (rawName.startsWith("vnode")) {
          context.onError(createCompilerError(51, arg.loc));
        }
        if (rawName.startsWith("vue:")) {
          rawName = `vnode-${rawName.slice(4)}`;
        }
        const eventString = node.tagType !== 0 || rawName.startsWith("vnode") || !/[A-Z]/.test(rawName) ? (
          // for non-element and vnode lifecycle event listeners, auto convert
          // it to camelCase. See issue #2249
          toHandlerKey(camelize(rawName))
        ) : (
          // preserve case for plain element listeners that have uppercase
          // letters, as these may be custom elements' custom events
          `on:${rawName}`
        );
        eventName = createSimpleExpression(eventString, true, arg.loc);
      } else {
        eventName = createCompoundExpression([
          `${context.helperString(TO_HANDLER_KEY)}(`,
          arg,
          `)`
        ]);
      }
    } else {
      eventName = arg;
      eventName.children.unshift(`${context.helperString(TO_HANDLER_KEY)}(`);
      eventName.children.push(`)`);
    }
    let exp = dir.exp;
    if (exp && !exp.content.trim()) {
      exp = void 0;
    }
    let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
    if (exp) {
      const isMemberExp = isMemberExpression(exp);
      const isInlineStatement = !(isMemberExp || isFnExpression(exp));
      const hasMultipleStatements = exp.content.includes(`;`);
      if (true) {
        validateBrowserExpression(
          exp,
          context,
          false,
          hasMultipleStatements
        );
      }
      if (isInlineStatement || shouldCache && isMemberExp) {
        exp = createCompoundExpression([
          `${isInlineStatement ? `$event` : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
          exp,
          hasMultipleStatements ? `}` : `)`
        ]);
      }
    }
    let ret = {
      props: [
        createObjectProperty(
          eventName,
          exp || createSimpleExpression(`() => {}`, false, loc)
        )
      ]
    };
    if (augmentor) {
      ret = augmentor(ret);
    }
    if (shouldCache) {
      ret.props[0].value = context.cache(ret.props[0].value);
    }
    ret.props.forEach((p2) => p2.key.isHandlerKey = true);
    return ret;
  };
  var transformText = (node, context) => {
    if (node.type === 0 || node.type === 1 || node.type === 11 || node.type === 10) {
      return () => {
        const children = node.children;
        let currentContainer = void 0;
        let hasText = false;
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          if (isText$1(child)) {
            hasText = true;
            for (let j = i + 1; j < children.length; j++) {
              const next = children[j];
              if (isText$1(next)) {
                if (!currentContainer) {
                  currentContainer = children[i] = createCompoundExpression(
                    [child],
                    child.loc
                  );
                }
                currentContainer.children.push(` + `, next);
                children.splice(j, 1);
                j--;
              } else {
                currentContainer = void 0;
                break;
              }
            }
          }
        }
        if (!hasText || // if this is a plain element with a single text child, leave it
        // as-is since the runtime has dedicated fast path for this by directly
        // setting textContent of the element.
        // for component root it's always normalized anyway.
        children.length === 1 && (node.type === 0 || node.type === 1 && node.tagType === 0 && // #3756
        // custom directives can potentially add DOM elements arbitrarily,
        // we need to avoid setting textContent of the element at runtime
        // to avoid accidentally overwriting the DOM elements added
        // by the user through custom directives.
        !node.props.find(
          (p2) => p2.type === 7 && !context.directiveTransforms[p2.name]
        ) && // in compat mode, <template> tags with no special directives
        // will be rendered as a fragment so its children must be
        // converted into vnodes.
        !(node.tag === "template"))) {
          return;
        }
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          if (isText$1(child) || child.type === 8) {
            const callArgs = [];
            if (child.type !== 2 || child.content !== " ") {
              callArgs.push(child);
            }
            if (!context.ssr && getConstantType(child, context) === 0) {
              callArgs.push(
                1 + (true ? ` /* ${PatchFlagNames[1]} */` : ``)
              );
            }
            children[i] = {
              type: 12,
              content: child,
              loc: child.loc,
              codegenNode: createCallExpression(
                context.helper(CREATE_TEXT),
                callArgs
              )
            };
          }
        }
      };
    }
  };
  var seen$1 = /* @__PURE__ */ new WeakSet();
  var transformOnce = (node, context) => {
    if (node.type === 1 && findDir(node, "once", true)) {
      if (seen$1.has(node) || context.inVOnce || context.inSSR) {
        return;
      }
      seen$1.add(node);
      context.inVOnce = true;
      context.helper(SET_BLOCK_TRACKING);
      return () => {
        context.inVOnce = false;
        const cur = context.currentNode;
        if (cur.codegenNode) {
          cur.codegenNode = context.cache(
            cur.codegenNode,
            true,
            true
          );
        }
      };
    }
  };
  var transformModel = (dir, node, context) => {
    const { exp, arg } = dir;
    if (!exp) {
      context.onError(
        createCompilerError(41, dir.loc)
      );
      return createTransformProps();
    }
    const rawExp = exp.loc.source.trim();
    const expString = exp.type === 4 ? exp.content : rawExp;
    const bindingType = context.bindingMetadata[rawExp];
    if (bindingType === "props" || bindingType === "props-aliased") {
      context.onError(createCompilerError(44, exp.loc));
      return createTransformProps();
    }
    const maybeRef = false;
    if (!expString.trim() || !isMemberExpression(exp) && !maybeRef) {
      context.onError(
        createCompilerError(42, exp.loc)
      );
      return createTransformProps();
    }
    const propName = arg ? arg : createSimpleExpression("modelValue", true);
    const eventName = arg ? isStaticExp(arg) ? `onUpdate:${camelize(arg.content)}` : createCompoundExpression(['"onUpdate:" + ', arg]) : `onUpdate:modelValue`;
    let assignmentExp;
    const eventArg = context.isTS ? `($event: any)` : `$event`;
    {
      assignmentExp = createCompoundExpression([
        `${eventArg} => ((`,
        exp,
        `) = $event)`
      ]);
    }
    const props = [
      // modelValue: foo
      createObjectProperty(propName, dir.exp),
      // "onUpdate:modelValue": $event => (foo = $event)
      createObjectProperty(eventName, assignmentExp)
    ];
    if (dir.modifiers.length && node.tagType === 1) {
      const modifiers = dir.modifiers.map((m) => m.content).map((m) => (isSimpleIdentifier(m) ? m : JSON.stringify(m)) + `: true`).join(`, `);
      const modifiersKey = arg ? isStaticExp(arg) ? `${arg.content}Modifiers` : createCompoundExpression([arg, ' + "Modifiers"']) : `modelModifiers`;
      props.push(
        createObjectProperty(
          modifiersKey,
          createSimpleExpression(
            `{ ${modifiers} }`,
            false,
            dir.loc,
            2
          )
        )
      );
    }
    return createTransformProps(props);
  };
  function createTransformProps(props = []) {
    return { props };
  }
  var validDivisionCharRE = /[\w).+\-_$\]]/;
  var transformFilter = (node, context) => {
    if (!isCompatEnabled("COMPILER_FILTERS", context)) {
      return;
    }
    if (node.type === 5) {
      rewriteFilter(node.content, context);
    } else if (node.type === 1) {
      node.props.forEach((prop) => {
        if (prop.type === 7 && prop.name !== "for" && prop.exp) {
          rewriteFilter(prop.exp, context);
        }
      });
    }
  };
  function rewriteFilter(node, context) {
    if (node.type === 4) {
      parseFilter(node, context);
    } else {
      for (let i = 0; i < node.children.length; i++) {
        const child = node.children[i];
        if (typeof child !== "object") continue;
        if (child.type === 4) {
          parseFilter(child, context);
        } else if (child.type === 8) {
          rewriteFilter(node, context);
        } else if (child.type === 5) {
          rewriteFilter(child.content, context);
        }
      }
    }
  }
  function parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters = [];
    for (i = 0; i < exp.length; i++) {
      prev = c;
      c = exp.charCodeAt(i);
      if (inSingle) {
        if (c === 39 && prev !== 92) inSingle = false;
      } else if (inDouble) {
        if (c === 34 && prev !== 92) inDouble = false;
      } else if (inTemplateString) {
        if (c === 96 && prev !== 92) inTemplateString = false;
      } else if (inRegex) {
        if (c === 47 && prev !== 92) inRegex = false;
      } else if (c === 124 && // pipe
      exp.charCodeAt(i + 1) !== 124 && exp.charCodeAt(i - 1) !== 124 && !curly && !square && !paren) {
        if (expression === void 0) {
          lastFilterIndex = i + 1;
          expression = exp.slice(0, i).trim();
        } else {
          pushFilter();
        }
      } else {
        switch (c) {
          case 34:
            inDouble = true;
            break;
          // "
          case 39:
            inSingle = true;
            break;
          // '
          case 96:
            inTemplateString = true;
            break;
          // `
          case 40:
            paren++;
            break;
          // (
          case 41:
            paren--;
            break;
          // )
          case 91:
            square++;
            break;
          // [
          case 93:
            square--;
            break;
          // ]
          case 123:
            curly++;
            break;
          // {
          case 125:
            curly--;
            break;
        }
        if (c === 47) {
          let j = i - 1;
          let p2;
          for (; j >= 0; j--) {
            p2 = exp.charAt(j);
            if (p2 !== " ") break;
          }
          if (!p2 || !validDivisionCharRE.test(p2)) {
            inRegex = true;
          }
        }
      }
    }
    if (expression === void 0) {
      expression = exp.slice(0, i).trim();
    } else if (lastFilterIndex !== 0) {
      pushFilter();
    }
    function pushFilter() {
      filters.push(exp.slice(lastFilterIndex, i).trim());
      lastFilterIndex = i + 1;
    }
    if (filters.length) {
      warnDeprecation(
        "COMPILER_FILTERS",
        context,
        node.loc
      );
      for (i = 0; i < filters.length; i++) {
        expression = wrapFilter(expression, filters[i], context);
      }
      node.content = expression;
      node.ast = void 0;
    }
  }
  function wrapFilter(exp, filter, context) {
    context.helper(RESOLVE_FILTER);
    const i = filter.indexOf("(");
    if (i < 0) {
      context.filters.add(filter);
      return `${toValidAssetId(filter, "filter")}(${exp})`;
    } else {
      const name = filter.slice(0, i);
      const args = filter.slice(i + 1);
      context.filters.add(name);
      return `${toValidAssetId(name, "filter")}(${exp}${args !== ")" ? "," + args : args}`;
    }
  }
  var seen = /* @__PURE__ */ new WeakSet();
  var transformMemo = (node, context) => {
    if (node.type === 1) {
      const dir = findDir(node, "memo");
      if (!dir || seen.has(node)) {
        return;
      }
      seen.add(node);
      return () => {
        const codegenNode = node.codegenNode || context.currentNode.codegenNode;
        if (codegenNode && codegenNode.type === 13) {
          if (node.tagType !== 1) {
            convertToBlock(codegenNode, context);
          }
          node.codegenNode = createCallExpression(context.helper(WITH_MEMO), [
            dir.exp,
            createFunctionExpression(void 0, codegenNode),
            `_cache`,
            String(context.cached.length)
          ]);
          context.cached.push(null);
        }
      };
    }
  };
  function getBaseTransformPreset(prefixIdentifiers) {
    return [
      [
        transformOnce,
        transformIf,
        transformMemo,
        transformFor,
        ...[transformFilter],
        ...true ? [transformExpression] : [],
        transformSlotOutlet,
        transformElement,
        trackSlotScopes,
        transformText
      ],
      {
        on: transformOn,
        bind: transformBind,
        model: transformModel
      }
    ];
  }
  function baseCompile(source, options3 = {}) {
    const onError = options3.onError || defaultOnError;
    const isModuleMode = options3.mode === "module";
    {
      if (options3.prefixIdentifiers === true) {
        onError(createCompilerError(47));
      } else if (isModuleMode) {
        onError(createCompilerError(48));
      }
    }
    const prefixIdentifiers = false;
    if (options3.cacheHandlers) {
      onError(createCompilerError(49));
    }
    if (options3.scopeId && !isModuleMode) {
      onError(createCompilerError(50));
    }
    const resolvedOptions = extend({}, options3, {
      prefixIdentifiers
    });
    const ast = isString(source) ? baseParse(source, resolvedOptions) : source;
    const [nodeTransforms, directiveTransforms] = getBaseTransformPreset();
    transform(
      ast,
      extend({}, resolvedOptions, {
        nodeTransforms: [
          ...nodeTransforms,
          ...options3.nodeTransforms || []
          // user transforms
        ],
        directiveTransforms: extend(
          {},
          directiveTransforms,
          options3.directiveTransforms || {}
          // user transforms
        )
      })
    );
    return generate(ast, resolvedOptions);
  }
  var noopDirectiveTransform = () => ({ props: [] });

  // node_modules/@vue/compiler-dom/dist/compiler-dom.esm-bundler.js
  var V_MODEL_RADIO = Symbol(true ? `vModelRadio` : ``);
  var V_MODEL_CHECKBOX = Symbol(
    true ? `vModelCheckbox` : ``
  );
  var V_MODEL_TEXT = Symbol(true ? `vModelText` : ``);
  var V_MODEL_SELECT = Symbol(
    true ? `vModelSelect` : ``
  );
  var V_MODEL_DYNAMIC = Symbol(
    true ? `vModelDynamic` : ``
  );
  var V_ON_WITH_MODIFIERS = Symbol(
    true ? `vOnModifiersGuard` : ``
  );
  var V_ON_WITH_KEYS = Symbol(
    true ? `vOnKeysGuard` : ``
  );
  var V_SHOW = Symbol(true ? `vShow` : ``);
  var TRANSITION2 = Symbol(true ? `Transition` : ``);
  var TRANSITION_GROUP = Symbol(
    true ? `TransitionGroup` : ``
  );
  registerRuntimeHelpers({
    [V_MODEL_RADIO]: `vModelRadio`,
    [V_MODEL_CHECKBOX]: `vModelCheckbox`,
    [V_MODEL_TEXT]: `vModelText`,
    [V_MODEL_SELECT]: `vModelSelect`,
    [V_MODEL_DYNAMIC]: `vModelDynamic`,
    [V_ON_WITH_MODIFIERS]: `withModifiers`,
    [V_ON_WITH_KEYS]: `withKeys`,
    [V_SHOW]: `vShow`,
    [TRANSITION2]: `Transition`,
    [TRANSITION_GROUP]: `TransitionGroup`
  });
  var decoder;
  function decodeHtmlBrowser(raw3, asAttr = false) {
    if (!decoder) {
      decoder = document.createElement("div");
    }
    if (asAttr) {
      decoder.innerHTML = `<div foo="${raw3.replace(/"/g, "&quot;")}">`;
      return decoder.children[0].getAttribute("foo");
    } else {
      decoder.innerHTML = raw3;
      return decoder.textContent;
    }
  }
  var parserOptions = {
    parseMode: "html",
    isVoidTag,
    isNativeTag: (tag) => isHTMLTag(tag) || isSVGTag(tag) || isMathMLTag(tag),
    isPreTag: (tag) => tag === "pre",
    isIgnoreNewlineTag: (tag) => tag === "pre" || tag === "textarea",
    decodeEntities: decodeHtmlBrowser,
    isBuiltInComponent: (tag) => {
      if (tag === "Transition" || tag === "transition") {
        return TRANSITION2;
      } else if (tag === "TransitionGroup" || tag === "transition-group") {
        return TRANSITION_GROUP;
      }
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
    getNamespace(tag, parent2, rootNamespace) {
      let ns = parent2 ? parent2.ns : rootNamespace;
      if (parent2 && ns === 2) {
        if (parent2.tag === "annotation-xml") {
          if (tag === "svg") {
            return 1;
          }
          if (parent2.props.some(
            (a) => a.type === 6 && a.name === "encoding" && a.value != null && (a.value.content === "text/html" || a.value.content === "application/xhtml+xml")
          )) {
            ns = 0;
          }
        } else if (/^m(?:[ions]|text)$/.test(parent2.tag) && tag !== "mglyph" && tag !== "malignmark") {
          ns = 0;
        }
      } else if (parent2 && ns === 1) {
        if (parent2.tag === "foreignObject" || parent2.tag === "desc" || parent2.tag === "title") {
          ns = 0;
        }
      }
      if (ns === 0) {
        if (tag === "svg") {
          return 1;
        }
        if (tag === "math") {
          return 2;
        }
      }
      return ns;
    }
  };
  var transformStyle = (node) => {
    if (node.type === 1) {
      node.props.forEach((p2, i) => {
        if (p2.type === 6 && p2.name === "style" && p2.value) {
          node.props[i] = {
            type: 7,
            name: `bind`,
            arg: createSimpleExpression(`style`, true, p2.loc),
            exp: parseInlineCSS(p2.value.content, p2.loc),
            modifiers: [],
            loc: p2.loc
          };
        }
      });
    }
  };
  var parseInlineCSS = (cssText, loc) => {
    const normalized = parseStringStyle(cssText);
    return createSimpleExpression(
      JSON.stringify(normalized),
      false,
      loc,
      3
    );
  };
  function createDOMCompilerError(code, loc) {
    return createCompilerError(
      code,
      loc,
      true ? DOMErrorMessages : void 0
    );
  }
  var DOMErrorMessages = {
    [53]: `v-html is missing expression.`,
    [54]: `v-html will override element children.`,
    [55]: `v-text is missing expression.`,
    [56]: `v-text will override element children.`,
    [57]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
    [58]: `v-model argument is not supported on plain elements.`,
    [59]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
    [60]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
    [61]: `v-show is missing expression.`,
    [62]: `<Transition> expects exactly one child element or component.`,
    [63]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
  };
  var transformVHtml = (dir, node, context) => {
    const { exp, loc } = dir;
    if (!exp) {
      context.onError(
        createDOMCompilerError(53, loc)
      );
    }
    if (node.children.length) {
      context.onError(
        createDOMCompilerError(54, loc)
      );
      node.children.length = 0;
    }
    return {
      props: [
        createObjectProperty(
          createSimpleExpression(`innerHTML`, true, loc),
          exp || createSimpleExpression("", true)
        )
      ]
    };
  };
  var transformVText = (dir, node, context) => {
    const { exp, loc } = dir;
    if (!exp) {
      context.onError(
        createDOMCompilerError(55, loc)
      );
    }
    if (node.children.length) {
      context.onError(
        createDOMCompilerError(56, loc)
      );
      node.children.length = 0;
    }
    return {
      props: [
        createObjectProperty(
          createSimpleExpression(`textContent`, true),
          exp ? getConstantType(exp, context) > 0 ? exp : createCallExpression(
            context.helperString(TO_DISPLAY_STRING),
            [exp],
            loc
          ) : createSimpleExpression("", true)
        )
      ]
    };
  };
  var transformModel2 = (dir, node, context) => {
    const baseResult = transformModel(dir, node, context);
    if (!baseResult.props.length || node.tagType === 1) {
      return baseResult;
    }
    if (dir.arg) {
      context.onError(
        createDOMCompilerError(
          58,
          dir.arg.loc
        )
      );
    }
    function checkDuplicatedValue() {
      const value = findDir(node, "bind");
      if (value && isStaticArgOf(value.arg, "value")) {
        context.onError(
          createDOMCompilerError(
            60,
            value.loc
          )
        );
      }
    }
    const { tag } = node;
    const isCustomElement = context.isCustomElement(tag);
    if (tag === "input" || tag === "textarea" || tag === "select" || isCustomElement) {
      let directiveToUse = V_MODEL_TEXT;
      let isInvalidType = false;
      if (tag === "input" || isCustomElement) {
        const type = findProp(node, `type`);
        if (type) {
          if (type.type === 7) {
            directiveToUse = V_MODEL_DYNAMIC;
          } else if (type.value) {
            switch (type.value.content) {
              case "radio":
                directiveToUse = V_MODEL_RADIO;
                break;
              case "checkbox":
                directiveToUse = V_MODEL_CHECKBOX;
                break;
              case "file":
                isInvalidType = true;
                context.onError(
                  createDOMCompilerError(
                    59,
                    dir.loc
                  )
                );
                break;
              default:
                checkDuplicatedValue();
                break;
            }
          }
        } else if (hasDynamicKeyVBind(node)) {
          directiveToUse = V_MODEL_DYNAMIC;
        } else {
          checkDuplicatedValue();
        }
      } else if (tag === "select") {
        directiveToUse = V_MODEL_SELECT;
      } else {
        checkDuplicatedValue();
      }
      if (!isInvalidType) {
        baseResult.needRuntime = context.helper(directiveToUse);
      }
    } else {
      context.onError(
        createDOMCompilerError(
          57,
          dir.loc
        )
      );
    }
    baseResult.props = baseResult.props.filter(
      (p2) => !(p2.key.type === 4 && p2.key.content === "modelValue")
    );
    return baseResult;
  };
  var isEventOptionModifier = /* @__PURE__ */ makeMap(`passive,once,capture`);
  var isNonKeyModifier = /* @__PURE__ */ makeMap(
    // event propagation management
    `stop,prevent,self,ctrl,shift,alt,meta,exact,middle`
  );
  var maybeKeyModifier = /* @__PURE__ */ makeMap("left,right");
  var isKeyboardEvent = /* @__PURE__ */ makeMap(`onkeyup,onkeydown,onkeypress`);
  var resolveModifiers = (key, modifiers, context, loc) => {
    const keyModifiers = [];
    const nonKeyModifiers = [];
    const eventOptionModifiers = [];
    for (let i = 0; i < modifiers.length; i++) {
      const modifier = modifiers[i].content;
      if (modifier === "native" && checkCompatEnabled(
        "COMPILER_V_ON_NATIVE",
        context,
        loc
      )) {
        eventOptionModifiers.push(modifier);
      } else if (isEventOptionModifier(modifier)) {
        eventOptionModifiers.push(modifier);
      } else {
        if (maybeKeyModifier(modifier)) {
          if (isStaticExp(key)) {
            if (isKeyboardEvent(key.content.toLowerCase())) {
              keyModifiers.push(modifier);
            } else {
              nonKeyModifiers.push(modifier);
            }
          } else {
            keyModifiers.push(modifier);
            nonKeyModifiers.push(modifier);
          }
        } else {
          if (isNonKeyModifier(modifier)) {
            nonKeyModifiers.push(modifier);
          } else {
            keyModifiers.push(modifier);
          }
        }
      }
    }
    return {
      keyModifiers,
      nonKeyModifiers,
      eventOptionModifiers
    };
  };
  var transformClick = (key, event) => {
    const isStaticClick = isStaticExp(key) && key.content.toLowerCase() === "onclick";
    return isStaticClick ? createSimpleExpression(event, true) : key.type !== 4 ? createCompoundExpression([
      `(`,
      key,
      `) === "onClick" ? "${event}" : (`,
      key,
      `)`
    ]) : key;
  };
  var transformOn2 = (dir, node, context) => {
    return transformOn(dir, node, context, (baseResult) => {
      const { modifiers } = dir;
      if (!modifiers.length) return baseResult;
      let { key, value: handlerExp } = baseResult.props[0];
      const { keyModifiers, nonKeyModifiers, eventOptionModifiers } = resolveModifiers(key, modifiers, context, dir.loc);
      if (nonKeyModifiers.includes("right")) {
        key = transformClick(key, `onContextmenu`);
      }
      if (nonKeyModifiers.includes("middle")) {
        key = transformClick(key, `onMouseup`);
      }
      if (nonKeyModifiers.length) {
        handlerExp = createCallExpression(context.helper(V_ON_WITH_MODIFIERS), [
          handlerExp,
          JSON.stringify(nonKeyModifiers)
        ]);
      }
      if (keyModifiers.length && // if event name is dynamic, always wrap with keys guard
      (!isStaticExp(key) || isKeyboardEvent(key.content.toLowerCase()))) {
        handlerExp = createCallExpression(context.helper(V_ON_WITH_KEYS), [
          handlerExp,
          JSON.stringify(keyModifiers)
        ]);
      }
      if (eventOptionModifiers.length) {
        const modifierPostfix = eventOptionModifiers.map(capitalize).join("");
        key = isStaticExp(key) ? createSimpleExpression(`${key.content}${modifierPostfix}`, true) : createCompoundExpression([`(`, key, `) + "${modifierPostfix}"`]);
      }
      return {
        props: [createObjectProperty(key, handlerExp)]
      };
    });
  };
  var transformShow = (dir, node, context) => {
    const { exp, loc } = dir;
    if (!exp) {
      context.onError(
        createDOMCompilerError(61, loc)
      );
    }
    return {
      props: [],
      needRuntime: context.helper(V_SHOW)
    };
  };
  var transformTransition = (node, context) => {
    if (node.type === 1 && node.tagType === 1) {
      const component = context.isBuiltInComponent(node.tag);
      if (component === TRANSITION2) {
        return () => {
          if (!node.children.length) {
            return;
          }
          if (hasMultipleChildren(node)) {
            context.onError(
              createDOMCompilerError(
                62,
                {
                  start: node.children[0].loc.start,
                  end: node.children[node.children.length - 1].loc.end,
                  source: ""
                }
              )
            );
          }
          const child = node.children[0];
          if (child.type === 1) {
            for (const p2 of child.props) {
              if (p2.type === 7 && p2.name === "show") {
                node.props.push({
                  type: 6,
                  name: "persisted",
                  nameLoc: node.loc,
                  value: void 0,
                  loc: node.loc
                });
              }
            }
          }
        };
      }
    }
  };
  function hasMultipleChildren(node) {
    const children = node.children = node.children.filter(
      (c) => c.type !== 3 && !(c.type === 2 && !c.content.trim())
    );
    const child = children[0];
    return children.length !== 1 || child.type === 11 || child.type === 9 && child.branches.some(hasMultipleChildren);
  }
  var ignoreSideEffectTags = (node, context) => {
    if (node.type === 1 && node.tagType === 0 && (node.tag === "script" || node.tag === "style")) {
      context.onError(
        createDOMCompilerError(
          63,
          node.loc
        )
      );
      context.removeNode();
    }
  };
  function isValidHTMLNesting(parent2, child) {
    if (parent2 in onlyValidChildren) {
      return onlyValidChildren[parent2].has(child);
    }
    if (child in onlyValidParents) {
      return onlyValidParents[child].has(parent2);
    }
    if (parent2 in knownInvalidChildren) {
      if (knownInvalidChildren[parent2].has(child)) return false;
    }
    if (child in knownInvalidParents) {
      if (knownInvalidParents[child].has(parent2)) return false;
    }
    return true;
  }
  var headings = /* @__PURE__ */ new Set(["h1", "h2", "h3", "h4", "h5", "h6"]);
  var emptySet = /* @__PURE__ */ new Set([]);
  var onlyValidChildren = {
    head: /* @__PURE__ */ new Set([
      "base",
      "basefront",
      "bgsound",
      "link",
      "meta",
      "title",
      "noscript",
      "noframes",
      "style",
      "script",
      "template"
    ]),
    optgroup: /* @__PURE__ */ new Set(["option"]),
    select: /* @__PURE__ */ new Set(["optgroup", "option", "hr"]),
    // table
    table: /* @__PURE__ */ new Set(["caption", "colgroup", "tbody", "tfoot", "thead"]),
    tr: /* @__PURE__ */ new Set(["td", "th"]),
    colgroup: /* @__PURE__ */ new Set(["col"]),
    tbody: /* @__PURE__ */ new Set(["tr"]),
    thead: /* @__PURE__ */ new Set(["tr"]),
    tfoot: /* @__PURE__ */ new Set(["tr"]),
    // these elements can not have any children elements
    script: emptySet,
    iframe: emptySet,
    option: emptySet,
    textarea: emptySet,
    style: emptySet,
    title: emptySet
  };
  var onlyValidParents = {
    // sections
    html: emptySet,
    body: /* @__PURE__ */ new Set(["html"]),
    head: /* @__PURE__ */ new Set(["html"]),
    // table
    td: /* @__PURE__ */ new Set(["tr"]),
    colgroup: /* @__PURE__ */ new Set(["table"]),
    caption: /* @__PURE__ */ new Set(["table"]),
    tbody: /* @__PURE__ */ new Set(["table"]),
    tfoot: /* @__PURE__ */ new Set(["table"]),
    col: /* @__PURE__ */ new Set(["colgroup"]),
    th: /* @__PURE__ */ new Set(["tr"]),
    thead: /* @__PURE__ */ new Set(["table"]),
    tr: /* @__PURE__ */ new Set(["tbody", "thead", "tfoot"]),
    // data list
    dd: /* @__PURE__ */ new Set(["dl", "div"]),
    dt: /* @__PURE__ */ new Set(["dl", "div"]),
    // other
    figcaption: /* @__PURE__ */ new Set(["figure"]),
    // li: new Set(["ul", "ol"]),
    summary: /* @__PURE__ */ new Set(["details"]),
    area: /* @__PURE__ */ new Set(["map"])
  };
  var knownInvalidChildren = {
    p: /* @__PURE__ */ new Set([
      "address",
      "article",
      "aside",
      "blockquote",
      "center",
      "details",
      "dialog",
      "dir",
      "div",
      "dl",
      "fieldset",
      "figure",
      "footer",
      "form",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "header",
      "hgroup",
      "hr",
      "li",
      "main",
      "nav",
      "menu",
      "ol",
      "p",
      "pre",
      "section",
      "table",
      "ul"
    ]),
    svg: /* @__PURE__ */ new Set([
      "b",
      "blockquote",
      "br",
      "code",
      "dd",
      "div",
      "dl",
      "dt",
      "em",
      "embed",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "hr",
      "i",
      "img",
      "li",
      "menu",
      "meta",
      "ol",
      "p",
      "pre",
      "ruby",
      "s",
      "small",
      "span",
      "strong",
      "sub",
      "sup",
      "table",
      "u",
      "ul",
      "var"
    ])
  };
  var knownInvalidParents = {
    a: /* @__PURE__ */ new Set(["a"]),
    button: /* @__PURE__ */ new Set(["button"]),
    dd: /* @__PURE__ */ new Set(["dd", "dt"]),
    dt: /* @__PURE__ */ new Set(["dd", "dt"]),
    form: /* @__PURE__ */ new Set(["form"]),
    li: /* @__PURE__ */ new Set(["li"]),
    h1: headings,
    h2: headings,
    h3: headings,
    h4: headings,
    h5: headings,
    h6: headings
  };
  var validateHtmlNesting = (node, context) => {
    if (node.type === 1 && node.tagType === 0 && context.parent && context.parent.type === 1 && context.parent.tagType === 0 && !isValidHTMLNesting(context.parent.tag, node.tag)) {
      const error2 = new SyntaxError(
        `<${node.tag}> cannot be child of <${context.parent.tag}>, according to HTML specifications. This can cause hydration errors or potentially disrupt future functionality.`
      );
      error2.loc = node.loc;
      context.onWarn(error2);
    }
  };
  var DOMNodeTransforms = [
    transformStyle,
    ...true ? [transformTransition, validateHtmlNesting] : []
  ];
  var DOMDirectiveTransforms = {
    cloak: noopDirectiveTransform,
    html: transformVHtml,
    text: transformVText,
    model: transformModel2,
    // override compiler-core
    on: transformOn2,
    // override compiler-core
    show: transformShow
  };
  function compile2(src, options3 = {}) {
    return baseCompile(
      src,
      extend({}, parserOptions, options3, {
        nodeTransforms: [
          // ignore <script> and <tag>
          // this is not put inside DOMNodeTransforms because that list is used
          // by compiler-ssr to generate vnode fallback branches
          ignoreSideEffectTags,
          ...DOMNodeTransforms,
          ...options3.nodeTransforms || []
        ],
        directiveTransforms: extend(
          {},
          DOMDirectiveTransforms,
          options3.directiveTransforms || {}
        ),
        transformHoist: null
      })
    );
  }

  // node_modules/vue/dist/vue.esm-bundler.js
  function initDev() {
    {
      initCustomFormatter();
    }
  }
  if (true) {
    initDev();
  }
  var compileCache = /* @__PURE__ */ Object.create(null);
  function compileToFunction(template, options3) {
    if (!isString(template)) {
      if (template.nodeType) {
        template = template.innerHTML;
      } else {
        warn2(`invalid template option: `, template);
        return NOOP;
      }
    }
    const key = genCacheKey(template, options3);
    const cached = compileCache[key];
    if (cached) {
      return cached;
    }
    if (template[0] === "#") {
      const el = document.querySelector(template);
      if (!el) {
        warn2(`Template element not found or is empty: ${template}`);
      }
      template = el ? el.innerHTML : ``;
    }
    const opts = extend(
      {
        hoistStatic: true,
        onError: true ? onError : void 0,
        onWarn: true ? (e) => onError(e, true) : NOOP
      },
      options3
    );
    if (!opts.isCustomElement && typeof customElements !== "undefined") {
      opts.isCustomElement = (tag) => !!customElements.get(tag);
    }
    const { code } = compile2(template, opts);
    function onError(err, asWarning = false) {
      const message3 = asWarning ? err.message : `Template compilation error: ${err.message}`;
      const codeFrame = err.loc && generateCodeFrame(
        template,
        err.loc.start.offset,
        err.loc.end.offset
      );
      warn2(codeFrame ? `${message3}
${codeFrame}` : message3);
    }
    const render2 = new Function("Vue", code)(runtime_dom_esm_bundler_exports);
    render2._rc = true;
    return compileCache[key] = render2;
  }
  registerRuntimeCompiler(compileToFunction);

  // node_modules/vue/dist/vue.runtime.esm-bundler.js
  function initDev2() {
    {
      initCustomFormatter();
    }
  }
  if (true) {
    initDev2();
  }

  // node_modules/@formkit/utils/dist/index.mjs
  var isBrowser = typeof window !== "undefined";
  var explicitKeys = [
    "__key",
    "__init",
    "__shim",
    "__original",
    "__index",
    "__prevKey"
  ];
  function token() {
    return Math.random().toString(36).substring(2, 15);
  }
  function dedupe(arr1, arr2) {
    const original = arr1 instanceof Set ? arr1 : new Set(arr1);
    if (arr2)
      arr2.forEach((item) => original.add(item));
    return [...original];
  }
  function has(obj, property) {
    return Object.prototype.hasOwnProperty.call(obj, property);
  }
  function eq(valA, valB, deep = true, explicit = ["__key"]) {
    if (valA === valB)
      return true;
    if (typeof valB === "object" && typeof valA === "object") {
      if (valA instanceof Map)
        return false;
      if (valA instanceof Set)
        return false;
      if (valA instanceof Date && valB instanceof Date)
        return valA.getTime() === valB.getTime();
      if (valA instanceof RegExp && valB instanceof RegExp)
        return eqRegExp(valA, valB);
      if (valA === null || valB === null)
        return false;
      if (Object.keys(valA).length !== Object.keys(valB).length)
        return false;
      for (const k of explicit) {
        if ((k in valA || k in valB) && valA[k] !== valB[k])
          return false;
      }
      for (const key in valA) {
        if (!(key in valB))
          return false;
        if (valA[key] !== valB[key] && !deep)
          return false;
        if (deep && !eq(valA[key], valB[key], deep, explicit))
          return false;
      }
      return true;
    }
    return false;
  }
  function eqRegExp(x, y) {
    return x.source === y.source && x.flags.split("").sort().join("") === y.flags.split("").sort().join("");
  }
  function empty(value) {
    const type = typeof value;
    if (type === "number")
      return false;
    if (value === void 0)
      return true;
    if (type === "string") {
      return value === "";
    }
    if (type === "object") {
      if (value === null)
        return true;
      for (const _i in value)
        return false;
      if (value instanceof RegExp)
        return false;
      if (value instanceof Date)
        return false;
      return true;
    }
    return false;
  }
  function escapeExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  function regexForFormat(format) {
    const escaped = `^${escapeExp(format)}$`;
    const formats = {
      MM: "(0[1-9]|1[012])",
      M: "([1-9]|1[012])",
      DD: "([012][0-9]|3[01])",
      D: "([012]?[0-9]|3[01])",
      YYYY: "\\d{4}",
      YY: "\\d{2}"
    };
    const tokens = Object.keys(formats);
    return new RegExp(
      tokens.reduce((regex, format2) => {
        return regex.replace(format2, formats[format2]);
      }, escaped)
    );
  }
  function isRecord(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
  }
  function isObject2(o) {
    return isRecord(o) || Array.isArray(o);
  }
  function isPojo(o) {
    if (isRecord(o) === false)
      return false;
    if (o.__FKNode__ || o.__POJO__ === false)
      return false;
    const ctor = o.constructor;
    if (ctor === void 0)
      return true;
    const prot = ctor.prototype;
    if (isRecord(prot) === false)
      return false;
    if (prot.hasOwnProperty("isPrototypeOf") === false) {
      return false;
    }
    return true;
  }
  var extend2 = /* @__NO_SIDE_EFFECTS__ */ (original, additional, extendArrays = false, ignoreUndefined = false) => {
    if (additional === null)
      return null;
    const merged = {};
    if (typeof additional === "string")
      return additional;
    for (const key in original) {
      if (has(additional, key) && (additional[key] !== void 0 || !ignoreUndefined)) {
        if (extendArrays && Array.isArray(original[key]) && Array.isArray(additional[key])) {
          merged[key] = original[key].concat(additional[key]);
          continue;
        }
        if (additional[key] === void 0) {
          continue;
        }
        if (isPojo(original[key]) && isPojo(additional[key])) {
          merged[key] = /* @__PURE__ */ extend2(
            original[key],
            additional[key],
            extendArrays,
            ignoreUndefined
          );
        } else {
          merged[key] = additional[key];
        }
      } else {
        merged[key] = original[key];
      }
    }
    for (const key in additional) {
      if (!has(merged, key) && additional[key] !== void 0) {
        merged[key] = additional[key];
      }
    }
    return merged;
  };
  function isQuotedString(str) {
    if (str[0] !== '"' && str[0] !== "'")
      return false;
    if (str[0] !== str[str.length - 1])
      return false;
    const quoteType = str[0];
    for (let p2 = 1; p2 < str.length; p2++) {
      if (str[p2] === quoteType && (p2 === 1 || str[p2 - 1] !== "\\") && p2 !== str.length - 1) {
        return false;
      }
    }
    return true;
  }
  function rmEscapes(str) {
    if (!str.length)
      return "";
    let clean2 = "";
    let lastChar = "";
    for (let p2 = 0; p2 < str.length; p2++) {
      const char = str.charAt(p2);
      if (char !== "\\" || lastChar === "\\") {
        clean2 += char;
      }
      lastChar = char;
    }
    return clean2;
  }
  function nodeProps(...sets) {
    return sets.reduce((valid, props) => {
      const { value, name, modelValue, config, plugins, ...validProps } = props;
      return Object.assign(valid, validProps);
    }, {});
  }
  function parseArgs(str) {
    const args = [];
    let arg = "";
    let depth = 0;
    let quote = "";
    let lastChar = "";
    for (let p2 = 0; p2 < str.length; p2++) {
      const char = str.charAt(p2);
      if (char === quote && lastChar !== "\\") {
        quote = "";
      } else if ((char === "'" || char === '"') && !quote && lastChar !== "\\") {
        quote = char;
      } else if (char === "(" && !quote) {
        depth++;
      } else if (char === ")" && !quote) {
        depth--;
      }
      if (char === "," && !quote && depth === 0) {
        args.push(arg);
        arg = "";
      } else if (char !== " " || quote) {
        arg += char;
      }
      lastChar = char;
    }
    if (arg) {
      args.push(arg);
    }
    return args;
  }
  function except(obj, toRemove) {
    const clean2 = {};
    const exps = toRemove.filter((n) => n instanceof RegExp);
    const keysToRemove = new Set(toRemove);
    for (const key in obj) {
      if (!keysToRemove.has(key) && !exps.some((exp) => exp.test(key))) {
        clean2[key] = obj[key];
      }
    }
    return clean2;
  }
  function only(obj, include) {
    const clean2 = {};
    const exps = include.filter((n) => n instanceof RegExp);
    include.forEach((key) => {
      if (!(key instanceof RegExp)) {
        clean2[key] = obj[key];
      }
    });
    Object.keys(obj).forEach((key) => {
      if (exps.some((exp) => exp.test(key))) {
        clean2[key] = obj[key];
      }
    });
    return clean2;
  }
  function camel(str) {
    return str.replace(
      /-([a-z0-9])/gi,
      (_s, g) => g.toUpperCase()
    );
  }
  function kebab(str) {
    return str.replace(
      /([a-z0-9])([A-Z])/g,
      (_s, trail, cap) => trail + "-" + cap.toLowerCase()
    ).replace(" ", "-").toLowerCase();
  }
  function shallowClone(obj, explicit = explicitKeys) {
    if (obj !== null && typeof obj === "object") {
      let returnObject;
      if (Array.isArray(obj))
        returnObject = [...obj];
      else if (isPojo(obj))
        returnObject = { ...obj };
      if (returnObject) {
        applyExplicit(obj, returnObject, explicit);
        return returnObject;
      }
    }
    return obj;
  }
  function clone(obj, explicit = explicitKeys) {
    if (obj === null || obj instanceof RegExp || obj instanceof Date || obj instanceof Map || obj instanceof Set || typeof File === "function" && obj instanceof File)
      return obj;
    let returnObject;
    if (Array.isArray(obj)) {
      returnObject = obj.map((value) => {
        if (typeof value === "object")
          return clone(value, explicit);
        return value;
      });
    } else {
      returnObject = Object.keys(obj).reduce((newObj, key) => {
        newObj[key] = typeof obj[key] === "object" ? clone(obj[key], explicit) : obj[key];
        return newObj;
      }, {});
    }
    for (const key of explicit) {
      if (key in obj) {
        Object.defineProperty(returnObject, key, {
          enumerable: false,
          value: obj[key]
        });
      }
    }
    return returnObject;
  }
  function cloneAny(obj) {
    return typeof obj === "object" ? clone(obj) : obj;
  }
  function getAt(obj, addr) {
    if (!obj || typeof obj !== "object")
      return null;
    const segments = addr.split(".");
    let o = obj;
    for (const i in segments) {
      const segment = segments[i];
      if (has(o, segment)) {
        o = o[segment];
      }
      if (+i === segments.length - 1)
        return o;
      if (!o || typeof o !== "object")
        return null;
    }
    return null;
  }
  function undefine(value) {
    return value !== void 0 && value !== "false" && value !== false ? true : void 0;
  }
  function init(obj) {
    return !Object.isFrozen(obj) ? Object.defineProperty(obj, "__init", {
      enumerable: false,
      value: true
    }) : obj;
  }
  function slugify(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, " ").trim().replace(/\s+/g, "-");
  }
  function applyExplicit(original, obj, explicit) {
    for (const key of explicit) {
      if (key in original) {
        Object.defineProperty(obj, key, {
          enumerable: false,
          value: original[key]
        });
      }
    }
    return obj;
  }
  function whenAvailable(childId, callback, root2) {
    if (!isBrowser)
      return;
    if (!root2)
      root2 = document;
    const el = root2.getElementById(childId);
    if (el)
      return callback(el);
    const observer = new MutationObserver(() => {
      const el2 = root2?.getElementById(childId);
      if (el2) {
        observer?.disconnect();
        callback(el2);
      }
    });
    observer.observe(root2, { childList: true, subtree: true });
  }
  function oncePerTick(fn) {
    let called = false;
    return (...args) => {
      if (called)
        return;
      called = true;
      queueMicrotask(() => called = false);
      return fn(...args);
    };
  }
  function boolGetter(value) {
    if (value === "false" || value === false)
      return void 0;
    return true;
  }

  // node_modules/@formkit/core/dist/index.mjs
  function createDispatcher() {
    const middleware = [];
    let currentIndex = 0;
    const use2 = (dispatchable) => middleware.push(dispatchable);
    const dispatch = (payload) => {
      const current = middleware[currentIndex];
      if (typeof current === "function") {
        return current(payload, (explicitPayload) => {
          currentIndex++;
          return dispatch(explicitPayload);
        });
      }
      currentIndex = 0;
      return payload;
    };
    use2.dispatch = dispatch;
    use2.unshift = (dispatchable) => middleware.unshift(dispatchable);
    use2.remove = (dispatchable) => {
      const index = middleware.indexOf(dispatchable);
      if (index > -1)
        middleware.splice(index, 1);
    };
    return use2;
  }
  function createEmitter() {
    const listeners = /* @__PURE__ */ new Map();
    const receipts2 = /* @__PURE__ */ new Map();
    let buffer2 = void 0;
    const emitter = (node, event) => {
      if (buffer2) {
        buffer2.set(event.name, [node, event]);
        return;
      }
      if (listeners.has(event.name)) {
        listeners.get(event.name).forEach((wrapper3) => {
          if (event.origin === node || wrapper3.modifiers.includes("deep")) {
            wrapper3.listener(event);
          }
        });
      }
      if (event.bubble) {
        node.bubble(event);
      }
    };
    emitter.flush = () => {
      listeners.clear();
      receipts2.clear();
      buffer2?.clear();
    };
    emitter.on = (eventName, listener, pos = "push") => {
      const [event, ...modifiers] = eventName.split(".");
      const receipt = listener.receipt || token();
      const wrapper3 = {
        modifiers,
        event,
        listener,
        receipt
      };
      listeners.has(event) ? listeners.get(event)[pos](wrapper3) : listeners.set(event, [wrapper3]);
      receipts2.has(receipt) ? receipts2.get(receipt)[pos](event) : receipts2.set(receipt, [event]);
      return receipt;
    };
    emitter.off = (receipt) => {
      if (receipts2.has(receipt)) {
        receipts2.get(receipt)?.forEach((event) => {
          const eventListeners = listeners.get(event);
          if (Array.isArray(eventListeners)) {
            listeners.set(
              event,
              eventListeners.filter((wrapper3) => wrapper3.receipt !== receipt)
            );
          }
        });
        receipts2.delete(receipt);
      }
    };
    emitter.pause = (node) => {
      if (!buffer2)
        buffer2 = /* @__PURE__ */ new Map();
      if (node) {
        node.walk((child) => child._e.pause());
      }
    };
    emitter.play = (node) => {
      if (!buffer2)
        return;
      const events = buffer2;
      buffer2 = void 0;
      events.forEach(([node2, event]) => emitter(node2, event));
      if (node) {
        node.walk((child) => child._e.play());
      }
    };
    return emitter;
  }
  function emit2(node, context, name, payload, bubble2 = true, meta2) {
    context._e(node, {
      payload,
      name,
      bubble: bubble2,
      origin: node,
      meta: meta2
    });
    return node;
  }
  function bubble(node, _context, event) {
    if (isNode(node.parent)) {
      node.parent._e(node.parent, event);
    }
    return node;
  }
  function on(_node, context, name, listener, pos) {
    return context._e.on(name, listener, pos);
  }
  function off(node, context, receipt) {
    context._e.off(receipt);
    return node;
  }
  var errorHandler = createDispatcher();
  errorHandler((error2, next) => {
    if (!error2.message)
      error2.message = String(`E${error2.code}`);
    return next(error2);
  });
  var warningHandler = createDispatcher();
  warningHandler((warning, next) => {
    if (!warning.message)
      warning.message = String(`W${warning.code}`);
    const result = next(warning);
    if (console && typeof console.warn === "function")
      console.warn(result.message);
    return result;
  });
  function warn3(code, data = {}) {
    warningHandler.dispatch({ code, data });
  }
  function error(code, data = {}) {
    throw Error(errorHandler.dispatch({ code, data }).message);
  }
  function createMessage(conf, node) {
    const m = {
      blocking: false,
      key: token(),
      meta: {},
      type: "state",
      visible: true,
      ...conf
    };
    if (node && m.value && m.meta.localize !== false) {
      m.value = node.t(m);
      m.meta.locale = node.config.locale;
    }
    return m;
  }
  var storeTraps = {
    apply: applyMessages,
    set: setMessage,
    remove: removeMessage,
    filter: filterMessages,
    reduce: reduceMessages,
    release: releaseBuffer,
    touch: touchMessages
  };
  function createStore(_buffer = false) {
    const messages3 = {};
    let node;
    let buffer2 = _buffer;
    let _b = [];
    const _m = /* @__PURE__ */ new Map();
    let _r = void 0;
    const store = new Proxy(messages3, {
      get(...args) {
        const [_target, property] = args;
        if (property === "buffer")
          return buffer2;
        if (property === "_b")
          return _b;
        if (property === "_m")
          return _m;
        if (property === "_r")
          return _r;
        if (has(storeTraps, property)) {
          return storeTraps[property].bind(
            null,
            messages3,
            store,
            node
          );
        }
        return Reflect.get(...args);
      },
      set(_t, prop, value) {
        if (prop === "_n") {
          node = value;
          if (_r === "__n")
            releaseMissed(node, store);
          return true;
        } else if (prop === "_b") {
          _b = value;
          return true;
        } else if (prop === "buffer") {
          buffer2 = value;
          return true;
        } else if (prop === "_r") {
          _r = value;
          return true;
        }
        error(101, node);
        return false;
      }
    });
    return store;
  }
  function setMessage(messageStore, store, node, message3) {
    if (store.buffer) {
      store._b.push([[message3]]);
      return store;
    }
    if (messageStore[message3.key] !== message3) {
      if (typeof message3.value === "string" && message3.meta.localize !== false) {
        const previous = message3.value;
        message3.value = node.t(message3);
        if (message3.value !== previous) {
          message3.meta.locale = node.props.locale;
        }
      }
      const e = `message-${has(messageStore, message3.key) ? "updated" : "added"}`;
      messageStore[message3.key] = Object.freeze(
        node.hook.message.dispatch(message3)
      );
      node.emit(e, message3);
    }
    return store;
  }
  function touchMessages(messageStore, store) {
    for (const key in messageStore) {
      const message3 = { ...messageStore[key] };
      store.set(message3);
    }
  }
  function removeMessage(messageStore, store, node, key) {
    if (has(messageStore, key)) {
      const message3 = messageStore[key];
      delete messageStore[key];
      node.emit("message-removed", message3);
    }
    if (store.buffer === true) {
      store._b = store._b.filter((buffered) => {
        buffered[0] = buffered[0].filter((m) => m.key !== key);
        return buffered[1] || buffered[0].length;
      });
    }
    return store;
  }
  function filterMessages(messageStore, store, node, callback, type) {
    for (const key in messageStore) {
      const message3 = messageStore[key];
      if ((!type || message3.type === type) && !callback(message3)) {
        removeMessage(messageStore, store, node, key);
      }
    }
  }
  function reduceMessages(messageStore, _store, _node, reducer, accumulator) {
    for (const key in messageStore) {
      const message3 = messageStore[key];
      accumulator = reducer(accumulator, message3);
    }
    return accumulator;
  }
  function applyMessages(_messageStore, store, node, messages3, clear) {
    if (Array.isArray(messages3)) {
      if (store.buffer) {
        store._b.push([messages3, clear]);
        return;
      }
      const applied = new Set(
        messages3.map((message3) => {
          store.set(message3);
          return message3.key;
        })
      );
      if (typeof clear === "string") {
        store.filter(
          (message3) => message3.type !== clear || applied.has(message3.key)
        );
      } else if (typeof clear === "function") {
        store.filter((message3) => !clear(message3) || applied.has(message3.key));
      }
    } else {
      for (const address in messages3) {
        const child = node.at(address);
        if (child) {
          child.store.apply(messages3[address], clear);
        } else {
          missed(node, store, address, messages3[address], clear);
        }
      }
    }
  }
  function createMessages(node, ...errors2) {
    const sourceKey = `${node.name}-set`;
    const make = (error2) => /* @__PURE__ */ createMessage({
      key: slugify(error2),
      type: "error",
      value: error2,
      meta: { source: sourceKey, autoClear: true }
    });
    return errors2.filter((m) => !!m).map((errorSet) => {
      if (typeof errorSet === "string")
        errorSet = [errorSet];
      if (Array.isArray(errorSet)) {
        return errorSet.map((error2) => make(error2));
      } else {
        const errors22 = {};
        for (const key in errorSet) {
          if (Array.isArray(errorSet[key])) {
            errors22[key] = errorSet[key].map(
              (error2) => make(error2)
            );
          } else {
            errors22[key] = [make(errorSet[key])];
          }
        }
        return errors22;
      }
    });
  }
  function missed(node, store, address, messages3, clear) {
    const misses = store._m;
    if (!misses.has(address))
      misses.set(address, []);
    if (!store._r)
      store._r = releaseMissed(node, store);
    misses.get(address)?.push([messages3, clear]);
  }
  function releaseMissed(node, store) {
    return node.on(
      "child.deep",
      ({ payload: child }) => {
        store._m.forEach((misses, address) => {
          if (node.at(address) === child) {
            misses.forEach(([messages3, clear]) => {
              child.store.apply(messages3, clear);
            });
            store._m.delete(address);
          }
        });
        if (store._m.size === 0 && store._r) {
          node.off(store._r);
          store._r = void 0;
        }
      }
    );
  }
  function releaseBuffer(_messageStore, store) {
    store.buffer = false;
    store._b.forEach(([messages3, clear]) => store.apply(messages3, clear));
    store._b = [];
  }
  function createLedger() {
    const ledger = {};
    let n;
    return {
      count: (...args) => createCounter(n, ledger, ...args),
      init(node) {
        n = node;
        node.on("message-added.deep", add(ledger, 1));
        node.on("message-removed.deep", add(ledger, -1));
      },
      merge: (child) => merge(n, ledger, child),
      settled(counterName) {
        return has(ledger, counterName) ? ledger[counterName].promise : Promise.resolve();
      },
      unmerge: (child) => merge(n, ledger, child, true),
      value(counterName) {
        return has(ledger, counterName) ? ledger[counterName].count : 0;
      }
    };
  }
  function createCounter(node, ledger, counterName, condition, increment = 0) {
    condition = parseCondition(condition || counterName);
    if (!has(ledger, counterName)) {
      const counter = {
        condition,
        count: 0,
        name: counterName,
        node,
        promise: Promise.resolve(),
        resolve: () => {
        }
        // eslint-disable-line @typescript-eslint/no-empty-function
      };
      ledger[counterName] = counter;
      increment = node.store.reduce(
        (sum, m) => sum + counter.condition(m) * 1,
        increment
      );
      node.each((child) => {
        child.ledger.count(counter.name, counter.condition);
        increment += child.ledger.value(counter.name);
      });
    }
    return count(ledger[counterName], increment).promise;
  }
  function parseCondition(condition) {
    if (typeof condition === "function") {
      return condition;
    }
    return (m) => m.type === condition;
  }
  function count(counter, increment) {
    const initial = counter.count;
    const post = counter.count + increment;
    counter.count = post;
    if (initial === 0 && post !== 0) {
      counter.node.emit(`unsettled:${counter.name}`, counter.count, false);
      counter.promise = new Promise((r) => counter.resolve = r);
    } else if (initial !== 0 && post === 0) {
      counter.node.emit(`settled:${counter.name}`, counter.count, false);
      counter.resolve();
    }
    counter.node.emit(`count:${counter.name}`, counter.count, false);
    return counter;
  }
  function add(ledger, delta) {
    return (e) => {
      for (const name in ledger) {
        const counter = ledger[name];
        if (counter.condition(e.payload)) {
          count(counter, delta);
        }
      }
    };
  }
  function merge(parent2, ledger, child, remove3 = false) {
    const originalParent = parent2;
    for (const key in ledger) {
      const condition = ledger[key].condition;
      if (!remove3)
        child.ledger.count(key, condition);
      const increment = child.ledger.value(key) * (remove3 ? -1 : 1);
      if (!parent2)
        continue;
      do {
        parent2.ledger.count(key, condition, increment);
        parent2 = parent2.parent;
      } while (parent2);
      parent2 = originalParent;
    }
  }
  var registry = /* @__PURE__ */ new Map();
  var reflected = /* @__PURE__ */ new Map();
  var emit22 = createEmitter();
  var receipts = [];
  function register(node) {
    if (node.props.id) {
      registry.set(node.props.id, node);
      reflected.set(node, node.props.id);
      emit22(node, {
        payload: node,
        name: node.props.id,
        bubble: false,
        origin: node
      });
    }
  }
  function deregister(node) {
    if (reflected.has(node)) {
      const id = reflected.get(node);
      reflected.delete(node);
      registry.delete(id);
      emit22(node, {
        payload: null,
        name: id,
        bubble: false,
        origin: node
      });
    }
  }
  function getNode(id) {
    return registry.get(id);
  }
  function watchRegistry(id, callback) {
    const receipt = emit22.on(id, callback);
    receipts.push(receipt);
    return receipt;
  }
  function configChange(node, prop, value) {
    let usingFallback = true;
    !(prop in node.config._t) ? node.emit(`config:${prop}`, value, false) : usingFallback = false;
    if (!(prop in node.props)) {
      node.emit("prop", { prop, value });
      node.emit(`prop:${prop}`, value);
    }
    return usingFallback;
  }
  function createConfig(options3 = {}) {
    const nodes = /* @__PURE__ */ new Set();
    const target2 = {
      ...options3,
      ...{
        _add: (node) => nodes.add(node),
        _rm: (node) => nodes.delete(node)
      }
    };
    const rootConfig = new Proxy(target2, {
      set(t, prop, value, r) {
        if (typeof prop === "string") {
          nodes.forEach((node) => configChange(node, prop, value));
        }
        return Reflect.set(t, prop, value, r);
      }
    });
    return rootConfig;
  }
  function submitForm(id, root2) {
    const formElement = (root2 || document).getElementById(id);
    if (formElement instanceof HTMLFormElement) {
      const event = new Event("submit", { cancelable: true, bubbles: true });
      formElement.dispatchEvent(event);
      return;
    }
    warn3(151, id);
  }
  function clearState(node) {
    const clear = (n) => {
      for (const key in n.store) {
        const message3 = n.store[key];
        if (message3.type === "error" || message3.type === "ui" && key === "incomplete") {
          n.store.remove(key);
        } else if (message3.type === "state") {
          n.store.set({ ...message3, value: false });
        }
      }
    };
    clear(node);
    node.walk(clear);
  }
  function reset2(id, resetTo) {
    const node = typeof id === "string" ? getNode(id) : id;
    if (node) {
      const initial = (n) => {
        const initial2 = cloneAny(n.props.initial);
        if (initial2 !== void 0)
          return initial2;
        return n.type === "group" ? {} : n.type === "list" ? [] : void 0;
      };
      node._e.pause(node);
      const resetValue2 = cloneAny(resetTo);
      if (resetTo && !empty(resetTo)) {
        node.props.initial = isObject2(resetValue2) ? init(resetValue2) : resetValue2;
        node.props._init = node.props.initial;
      }
      node.input(initial(node), false);
      node.walk((child) => {
        if (child.type === "list" && child.sync)
          return;
        child.input(initial(child), false);
      });
      node.input(
        empty(resetValue2) && resetValue2 ? resetValue2 : initial(node),
        false
      );
      const isDeepReset = node.type !== "input" && resetTo && !empty(resetTo) && isObject2(resetTo);
      if (isDeepReset) {
        node.walk((child) => {
          child.props.initial = isObject2(child.value) ? init(child.value) : child.value;
          child.props._init = child.props.initial;
        });
      }
      node._e.play(node);
      clearState(node);
      node.emit("reset", node);
      return node;
    }
    warn3(152, id);
    return;
  }
  var defaultConfig = {
    delimiter: ".",
    delay: 0,
    locale: "en",
    rootClasses: (key) => ({ [`formkit-${kebab(key)}`]: true })
  };
  var useIndex = Symbol("index");
  var valueRemoved = Symbol("removed");
  var valueMoved = Symbol("moved");
  var valueInserted = Symbol("inserted");
  function isList(arg) {
    return arg.type === "list" && Array.isArray(arg._value);
  }
  function isNode(node) {
    return node && typeof node === "object" && node.__FKNode__ === true;
  }
  var invalidSetter = (node, _context, property) => {
    error(102, [node, property]);
  };
  var traps = {
    _c: trap(getContext2, invalidSetter, false),
    add: trap(addChild),
    addProps: trap(addProps),
    address: trap(getAddress, invalidSetter, false),
    at: trap(getNode2),
    bubble: trap(bubble),
    clearErrors: trap(clearErrors),
    calm: trap(calm),
    config: trap(false),
    define: trap(define2),
    disturb: trap(disturb),
    destroy: trap(destroy),
    extend: trap(extend3),
    hydrate: trap(hydrate2),
    index: trap(getIndex, setIndex, false),
    input: trap(input),
    each: trap(eachChild),
    emit: trap(emit2),
    find: trap(find),
    on: trap(on),
    off: trap(off),
    parent: trap(false, setParent),
    plugins: trap(false),
    remove: trap(removeChild),
    root: trap(getRoot, invalidSetter, false),
    reset: trap(resetValue),
    resetConfig: trap(resetConfig),
    setErrors: trap(setErrors),
    submit: trap(submit),
    t: trap(text),
    use: trap(use),
    name: trap(getName, false, false),
    walk: trap(walkTree)
  };
  function createTraps() {
    return new Map(Object.entries(traps));
  }
  function trap(getter, setter, curryGetter = true) {
    return {
      get: getter ? (node, context) => curryGetter ? (...args) => getter(node, context, ...args) : getter(node, context) : false,
      set: setter !== void 0 ? setter : invalidSetter.bind(null)
    };
  }
  function createHooks() {
    const hooks = /* @__PURE__ */ new Map();
    return new Proxy(hooks, {
      get(_, property) {
        if (!hooks.has(property)) {
          hooks.set(property, createDispatcher());
        }
        return hooks.get(property);
      }
    });
  }
  var nameCount = 0;
  var idCount = 0;
  function createName(options3) {
    if (options3.parent?.type === "list")
      return useIndex;
    return options3.name || `${options3.props?.type || "input"}_${++nameCount}`;
  }
  function createValue(options3) {
    if (options3.type === "group") {
      return init(
        options3.value && typeof options3.value === "object" && !Array.isArray(options3.value) ? options3.value : {}
      );
    } else if (options3.type === "list") {
      return init(Array.isArray(options3.value) ? options3.value : []);
    }
    return options3.value;
  }
  function input(node, context, value, async = true) {
    context._value = validateInput(node, node.hook.input.dispatch(value));
    node.emit("input", context._value);
    if (node.isCreated && node.type === "input" && eq(context._value, context.value) && !node.props.mergeStrategy) {
      node.emit("commitRaw", context.value);
      return context.settled;
    }
    if (context.isSettled)
      node.disturb();
    if (async) {
      if (context._tmo)
        clearTimeout(context._tmo);
      context._tmo = setTimeout(
        commit,
        node.props.delay,
        node,
        context
      );
    } else {
      commit(node, context);
    }
    return context.settled;
  }
  function validateInput(node, value) {
    switch (node.type) {
      case "input":
        break;
      case "group":
        if (!value || typeof value !== "object")
          error(107, [node, value]);
        break;
      case "list":
        if (!Array.isArray(value))
          error(108, [node, value]);
        break;
    }
    return value;
  }
  function commit(node, context, calm2 = true, hydrate22 = true) {
    context._value = context.value = node.hook.commit.dispatch(context._value);
    if (node.type !== "input" && hydrate22)
      node.hydrate();
    node.emit("commitRaw", context.value);
    node.emit("commit", context.value);
    if (calm2)
      node.calm();
  }
  function partial(context, { name, value, from }) {
    if (Object.isFrozen(context._value))
      return;
    if (isList(context)) {
      const insert = value === valueRemoved ? [] : value === valueMoved && typeof from === "number" ? context._value.splice(from, 1) : [value];
      context._value.splice(
        name,
        value === valueMoved || from === valueInserted ? 0 : 1,
        ...insert
      );
      return;
    }
    if (value !== valueRemoved) {
      context._value[name] = value;
    } else {
      delete context._value[name];
    }
  }
  function hydrate2(node, context) {
    const _value = context._value;
    if (node.type === "list" && node.sync)
      syncListNodes(node, context);
    context.children.forEach((child) => {
      if (typeof _value !== "object")
        return;
      if (child.name in _value) {
        const childValue = child.type !== "input" || _value[child.name] && typeof _value[child.name] === "object" ? init(_value[child.name]) : _value[child.name];
        if (!child.isSettled || (!isObject2(childValue) || child.props.mergeStrategy) && eq(childValue, child._value))
          return;
        child.input(childValue, false);
      } else {
        if (node.type !== "list" || typeof child.name === "number") {
          partial(context, { name: child.name, value: child.value });
        }
        if (!_value.__init) {
          if (child.type === "group")
            child.input({}, false);
          else if (child.type === "list")
            child.input([], false);
          else
            child.input(void 0, false);
        }
      }
    });
    return node;
  }
  function syncListNodes(node, context) {
    const _value = node._value;
    if (!Array.isArray(_value))
      return;
    const newChildren = [];
    const unused = new Set(context.children);
    const placeholderValues = /* @__PURE__ */ new Map();
    _value.forEach((value, i) => {
      if (context.children[i] && context.children[i]._value === value) {
        newChildren.push(context.children[i]);
        unused.delete(context.children[i]);
      } else {
        newChildren.push(null);
        const indexes = placeholderValues.get(value) || [];
        indexes.push(i);
        placeholderValues.set(value, indexes);
      }
    });
    if (unused.size && placeholderValues.size) {
      unused.forEach((child) => {
        if (placeholderValues.has(child._value)) {
          const indexes = placeholderValues.get(child._value);
          const index = indexes.shift();
          newChildren[index] = child;
          unused.delete(child);
          if (!indexes.length)
            placeholderValues.delete(child._value);
        }
      });
    }
    const emptyIndexes = [];
    placeholderValues.forEach((indexes) => {
      emptyIndexes.push(...indexes);
    });
    while (unused.size && emptyIndexes.length) {
      const child = unused.values().next().value;
      const index = emptyIndexes.shift();
      if (index === void 0)
        break;
      newChildren[index] = child;
      unused.delete(child);
    }
    emptyIndexes.forEach((index, value) => {
      newChildren[index] = createPlaceholder({ value });
    });
    if (unused.size) {
      unused.forEach((child) => {
        if (!("__FKP" in child)) {
          const parent2 = child._c.parent;
          if (!parent2 || isPlaceholder(parent2))
            return;
          parent2.ledger.unmerge(child);
          child._c.parent = null;
          child.destroy();
        }
      });
    }
    context.children = newChildren;
  }
  function disturb(node, context) {
    if (context._d <= 0) {
      context.isSettled = false;
      node.emit("settled", false, false);
      context.settled = new Promise((resolve2) => {
        context._resolve = resolve2;
      });
      if (node.parent)
        node.parent?.disturb();
    }
    context._d++;
    return node;
  }
  function calm(node, context, value) {
    if (value !== void 0 && node.type !== "input") {
      partial(context, value);
      const shouldHydrate = !!(node.config.mergeStrategy && node.config.mergeStrategy[value.name]);
      return commit(node, context, true, shouldHydrate);
    }
    if (context._d > 0)
      context._d--;
    if (context._d === 0) {
      context.isSettled = true;
      node.emit("settled", true, false);
      if (node.parent)
        node.parent?.calm({ name: node.name, value: context.value });
      if (context._resolve)
        context._resolve(context.value);
    }
  }
  function destroy(node, context) {
    node.emit("destroying", node);
    node.store.filter(() => false);
    if (node.parent) {
      node.parent.remove(node);
    }
    deregister(node);
    node.emit("destroyed", node);
    context._e.flush();
    context._value = context.value = void 0;
    for (const property in context.context) {
      delete context.context[property];
    }
    context.plugins.clear();
    context.context = null;
  }
  function define2(node, context, definition3) {
    context.type = definition3.type;
    const clonedDef = clone(definition3);
    node.props.__propDefs = mergeProps2(
      node.props.__propDefs ?? [],
      clonedDef?.props || []
    );
    clonedDef.props = node.props.__propDefs;
    context.props.definition = clonedDef;
    context.value = context._value = createValue({
      type: node.type,
      value: context.value
    });
    if (definition3.forceTypeProp) {
      if (node.props.type)
        node.props.originalType = node.props.type;
      context.props.type = definition3.forceTypeProp;
    }
    if (definition3.family) {
      context.props.family = definition3.family;
    }
    if (definition3.features) {
      definition3.features.forEach((feature2) => feature2(node));
    }
    if (definition3.props) {
      node.addProps(definition3.props);
    }
    node.emit("defined", definition3);
  }
  function addProps(node, context, props) {
    const propNames = Array.isArray(props) ? props : Object.keys(props);
    const defaults = !Array.isArray(props) ? propNames.reduce((defaults2, name) => {
      if ("default" in props[name]) {
        defaults2[name] = props[name].default;
      }
      return defaults2;
    }, {}) : {};
    if (node.props.attrs) {
      const attrs = { ...node.props.attrs };
      node.props._emit = false;
      for (const attr in attrs) {
        const camelName = camel(attr);
        if (propNames.includes(camelName)) {
          node.props[camelName] = attrs[attr];
          delete attrs[attr];
        }
      }
      if (!Array.isArray(props)) {
        propNames.forEach((prop) => {
          if ("default" in props[prop] && node.props[prop] === void 0) {
            node.props[prop] = defaults[prop];
          }
        });
      }
      const initial = cloneAny(context._value);
      node.props.initial = node.type !== "input" ? init(initial) : initial;
      node.props._emit = true;
      node.props.attrs = attrs;
    }
    const mergedProps = mergeProps2(node.props.__propDefs ?? [], props);
    if (node.props.definition) {
      node.props.definition.props = mergedProps;
    }
    node.props.__propDefs = mergedProps;
    node.emit("added-props", props);
    return node;
  }
  function toPropsObj(props) {
    return !Array.isArray(props) ? props : props.reduce((props2, prop) => {
      props2[prop] = {};
      return props2;
    }, {});
  }
  function mergeProps2(props, newProps) {
    if (Array.isArray(props) && Array.isArray(newProps))
      return props.concat(newProps);
    return extend2(toPropsObj(props), toPropsObj(newProps));
  }
  function addChild(parent2, parentContext, child, listIndex) {
    if (parent2.type === "input")
      error(100, parent2);
    if (child.parent && child.parent !== parent2) {
      child.parent.remove(child);
    }
    if (!parentContext.children.includes(child)) {
      if (listIndex !== void 0 && parent2.type === "list") {
        const existingNode = parentContext.children[listIndex];
        if (existingNode && "__FKP" in existingNode) {
          child._c.uid = existingNode.uid;
          parentContext.children.splice(listIndex, 1, child);
        } else {
          parentContext.children.splice(listIndex, 0, child);
        }
        if (Array.isArray(parent2.value) && parent2.value.length < parentContext.children.length) {
          parent2.disturb().calm({
            name: listIndex,
            value: child.value,
            from: valueInserted
          });
        }
      } else {
        parentContext.children.push(child);
      }
      if (!child.isSettled)
        parent2.disturb();
    }
    if (child.parent !== parent2) {
      child.parent = parent2;
      if (child.parent !== parent2) {
        parent2.remove(child);
        child.parent.add(child);
        return parent2;
      }
    } else {
      child.use(parent2.plugins);
    }
    commit(parent2, parentContext, false);
    parent2.ledger.merge(child);
    parent2.emit("child", child);
    return parent2;
  }
  function setParent(child, context, _property, parent2) {
    if (isNode(parent2)) {
      if (child.parent && child.parent !== parent2) {
        child.parent.remove(child);
      }
      context.parent = parent2;
      child.resetConfig();
      !parent2.children.includes(child) ? parent2.add(child) : child.use(parent2.plugins);
      return true;
    }
    if (parent2 === null) {
      context.parent = null;
      return true;
    }
    return false;
  }
  function removeChild(node, context, child) {
    const childIndex = context.children.indexOf(child);
    if (childIndex !== -1) {
      if (child.isSettled)
        node.disturb();
      context.children.splice(childIndex, 1);
      let preserve = undefine(child.props.preserve);
      let parent2 = child.parent;
      while (preserve === void 0 && parent2) {
        preserve = undefine(parent2.props.preserve);
        parent2 = parent2.parent;
      }
      if (!preserve) {
        node.calm({
          name: node.type === "list" ? childIndex : child.name,
          value: valueRemoved
        });
      } else {
        node.calm();
      }
      child.parent = null;
      child.config._rmn = child;
    }
    node.ledger.unmerge(child);
    node.emit("childRemoved", child);
    return node;
  }
  function eachChild(_node, context, callback) {
    context.children.forEach((child) => !("__FKP" in child) && callback(child));
  }
  function walkTree(_node, context, callback, stopIfFalse = false, skipSubtreeOnFalse = false) {
    context.children.some((child) => {
      if ("__FKP" in child)
        return false;
      const val = callback(child);
      if (stopIfFalse && val === false)
        return true;
      if (skipSubtreeOnFalse && val === false)
        return false;
      return child.walk(callback, stopIfFalse, skipSubtreeOnFalse);
    });
  }
  function resetConfig(node, context) {
    const parent2 = node.parent || void 0;
    context.config = createConfig2(node.config._t, parent2);
    node.walk((n) => n.resetConfig());
  }
  function use(node, context, plugin2, run2 = true, library = true) {
    if (Array.isArray(plugin2) || plugin2 instanceof Set) {
      plugin2.forEach((p2) => use(node, context, p2));
      return node;
    }
    if (!context.plugins.has(plugin2)) {
      if (library && typeof plugin2.library === "function")
        plugin2.library(node);
      if (run2 && plugin2(node) !== false) {
        context.plugins.add(plugin2);
        node.children.forEach((child) => child.use(plugin2));
      }
    }
    return node;
  }
  function setIndex(node, _context, _property, setIndex2) {
    if (isNode(node.parent)) {
      const children = node.parent.children;
      const index = setIndex2 >= children.length ? children.length - 1 : setIndex2 < 0 ? 0 : setIndex2;
      const oldIndex = children.indexOf(node);
      if (oldIndex === -1)
        return false;
      children.splice(oldIndex, 1);
      children.splice(index, 0, node);
      node.parent.children = children;
      if (node.parent.type === "list")
        node.parent.disturb().calm({ name: index, value: valueMoved, from: oldIndex });
      return true;
    }
    return false;
  }
  function getIndex(node) {
    if (node.parent) {
      const index = [...node.parent.children].indexOf(node);
      return index === -1 ? node.parent.children.length : index;
    }
    return -1;
  }
  function getContext2(_node, context) {
    return context;
  }
  function getName(node, context) {
    if (node.parent?.type === "list")
      return node.index;
    return context.name !== useIndex ? context.name : node.index;
  }
  function getAddress(node, context) {
    return context.parent ? context.parent.address.concat([node.name]) : [node.name];
  }
  function getNode2(node, _context, locator) {
    const address = typeof locator === "string" ? locator.split(node.config.delimiter) : locator;
    if (!address.length)
      return void 0;
    const first = address[0];
    let pointer = node.parent;
    if (!pointer) {
      if (String(address[0]) === String(node.name))
        address.shift();
      pointer = node;
    }
    if (first === "$parent")
      address.shift();
    while (pointer && address.length) {
      const name = address.shift();
      switch (name) {
        case "$root":
          pointer = node.root;
          break;
        case "$parent":
          pointer = pointer.parent;
          break;
        case "$self":
          pointer = node;
          break;
        default:
          pointer = pointer.children.find(
            (c) => !("__FKP" in c) && String(c.name) === String(name)
          ) || select(pointer, name);
      }
    }
    return pointer || void 0;
  }
  function select(node, selector) {
    const matches3 = String(selector).match(/^(find)\((.*)\)$/);
    if (matches3) {
      const [, action, argStr] = matches3;
      const args = argStr.split(",").map((arg) => arg.trim());
      switch (action) {
        case "find":
          return node.find(args[0], args[1]);
        default:
          return void 0;
      }
    }
    return void 0;
  }
  function find(node, _context, searchTerm, searcher) {
    return bfs(node, searchTerm, searcher);
  }
  function bfs(tree, searchValue, searchGoal = "name") {
    const search = typeof searchGoal === "string" ? (n) => n[searchGoal] == searchValue : searchGoal;
    const stack3 = [tree];
    while (stack3.length) {
      const node = stack3.shift();
      if ("__FKP" in node)
        continue;
      if (search(node, searchValue))
        return node;
      stack3.push(...node.children);
    }
    return void 0;
  }
  function getRoot(n) {
    let node = n;
    while (node.parent) {
      node = node.parent;
    }
    return node;
  }
  function createConfig2(target2 = {}, parent2) {
    let node = void 0;
    return new Proxy(target2, {
      get(...args) {
        const prop = args[1];
        if (prop === "_t")
          return target2;
        const localValue = Reflect.get(...args);
        if (localValue !== void 0)
          return localValue;
        if (parent2) {
          const parentVal = parent2.config[prop];
          if (parentVal !== void 0)
            return parentVal;
        }
        if (target2.rootConfig && typeof prop === "string") {
          const rootValue = target2.rootConfig[prop];
          if (rootValue !== void 0)
            return rootValue;
        }
        if (prop === "delay" && node?.type === "input")
          return 20;
        return defaultConfig[prop];
      },
      set(...args) {
        const prop = args[1];
        const value = args[2];
        if (prop === "_n") {
          node = value;
          if (target2.rootConfig)
            target2.rootConfig._add(node);
          return true;
        }
        if (prop === "_rmn") {
          if (target2.rootConfig)
            target2.rootConfig._rm(node);
          node = void 0;
          return true;
        }
        if (!eq(target2[prop], value, false)) {
          const didSet = Reflect.set(...args);
          if (node) {
            node.emit(`config:${prop}`, value, false);
            configChange(node, prop, value);
            node.walk((n) => configChange(n, prop, value), false, true);
          }
          return didSet;
        }
        return true;
      }
    });
  }
  function text(node, _context, key, type = "ui") {
    const fragment2 = typeof key === "string" ? { key, value: key, type } : key;
    const value = node.hook.text.dispatch(fragment2);
    node.emit("text", value, false);
    return value.value;
  }
  function submit(node) {
    const name = node.name;
    do {
      if (node.props.isForm === true)
        break;
      if (!node.parent)
        error(106, name);
      node = node.parent;
    } while (node);
    if (node.props.id) {
      submitForm(node.props.id, node.props.__root);
    }
  }
  function resetValue(node, _context, value) {
    return reset2(node, value);
  }
  function setErrors(node, _context, localErrors, childErrors) {
    const sourceKey = `${node.name}-set`;
    const errors2 = node.hook.setErrors.dispatch({ localErrors, childErrors });
    createMessages(node, errors2.localErrors, errors2.childErrors).forEach(
      (errors22) => {
        node.store.apply(errors22, (message3) => message3.meta.source === sourceKey);
      }
    );
    return node;
  }
  function clearErrors(node, _context, clearChildErrors = true, sourceKey) {
    node.store.filter((m) => {
      return !(sourceKey === void 0 || m.meta.source === sourceKey);
    }, "error");
    if (clearChildErrors) {
      sourceKey = sourceKey || `${node.name}-set`;
      node.walk((child) => {
        child.store.filter((message3) => {
          return !(message3.type === "error" && message3.meta && message3.meta.source === sourceKey);
        });
      });
    }
    return node;
  }
  function createProps(initial) {
    const props = {
      initial: typeof initial === "object" ? cloneAny(initial) : initial
    };
    let node;
    let isEmitting = true;
    let propDefs = {};
    return new Proxy(props, {
      get(...args) {
        const [_t, prop] = args;
        let val;
        if (has(props, prop)) {
          val = Reflect.get(...args);
          if (propDefs[prop]?.boolean)
            val = boolGetter(val);
        } else if (node && typeof prop === "string" && node.config[prop] !== void 0) {
          val = node.config[prop];
          if (prop === "mergeStrategy" && node?.type === "input" && isRecord(val) && node.name in val) {
            val = val[node.name];
          }
        } else {
          val = propDefs[prop]?.default;
        }
        const getter = propDefs[prop]?.getter;
        if (propDefs[prop]?.boolean)
          val = !!val;
        return getter ? getter(val, node) : val;
      },
      set(target2, property, originalValue, receiver) {
        if (property === "_n") {
          node = originalValue;
          return true;
        }
        if (property === "_emit") {
          isEmitting = originalValue;
          return true;
        }
        let { prop, value } = node.hook.prop.dispatch({
          prop: property,
          value: originalValue
        });
        const setter = propDefs[prop]?.setter;
        value = setter ? setter(value, node) : value;
        if (!eq(props[prop], value, false) || typeof value === "object") {
          const didSet = Reflect.set(target2, prop, value, receiver);
          if (prop === "__propDefs")
            propDefs = toPropsObj(value);
          if (isEmitting) {
            node.emit("prop", { prop, value });
            if (typeof prop === "string")
              node.emit(`prop:${prop}`, value);
          }
          return didSet;
        }
        return true;
      }
    });
  }
  function extend3(node, context, property, trap2) {
    context.traps.set(property, trap2);
    return node;
  }
  function findDefinition(node, plugins) {
    if (node.props.definition)
      return node.define(node.props.definition);
    for (const plugin2 of plugins) {
      if (node.props.definition)
        return;
      if (typeof plugin2.library === "function") {
        plugin2.library(node);
      }
    }
  }
  function createContext(options3) {
    const value = createValue(options3);
    const config = createConfig2(options3.config || {}, options3.parent);
    return {
      _d: 0,
      _e: createEmitter(),
      uid: Symbol(),
      _resolve: false,
      _tmo: false,
      _value: value,
      children: dedupe(options3.children || []),
      config,
      hook: createHooks(),
      isCreated: false,
      isSettled: true,
      ledger: createLedger(),
      name: createName(options3),
      parent: options3.parent || null,
      plugins: /* @__PURE__ */ new Set(),
      props: createProps(value),
      settled: Promise.resolve(value),
      store: createStore(true),
      sync: options3.sync || false,
      traps: createTraps(),
      type: options3.type || "input",
      value
    };
  }
  function nodeInit(node, options3) {
    const hasInitialId = options3.props?.id;
    if (!hasInitialId)
      delete options3.props?.id;
    node.ledger.init(node.store._n = node.props._n = node.config._n = node);
    node.props._emit = false;
    Object.assign(
      node.props,
      hasInitialId ? {} : { id: `input_${idCount++}` },
      options3.props ?? {}
    );
    node.props._emit = true;
    findDefinition(
      node,
      /* @__PURE__ */ new Set([
        ...options3.plugins || [],
        ...node.parent ? node.parent.plugins : []
      ])
    );
    if (options3.plugins) {
      for (const plugin2 of options3.plugins) {
        use(node, node._c, plugin2, true, false);
      }
    }
    node.each((child) => node.add(child));
    if (node.parent)
      node.parent.add(node, options3.index);
    if (node.type === "input" && node.children.length)
      error(100, node);
    input(node, node._c, node._value, false);
    node.store.release();
    if (hasInitialId)
      register(node);
    node.emit("created", node);
    node.isCreated = true;
    return node;
  }
  function createPlaceholder(options3) {
    return {
      __FKP: true,
      uid: Symbol(),
      name: options3?.name ?? `p_${nameCount++}`,
      value: options3?.value ?? null,
      _value: options3?.value ?? null,
      type: options3?.type ?? "input",
      props: {},
      use: () => {
      },
      input(value) {
        this._value = value;
        this.value = value;
        return Promise.resolve();
      },
      isSettled: true
    };
  }
  function isPlaceholder(node) {
    return "__FKP" in node;
  }
  function createNode(options3) {
    const ops = options3 || {};
    const context = createContext(ops);
    const node = new Proxy(context, {
      get(...args) {
        const [, property] = args;
        if (property === "__FKNode__")
          return true;
        const trap2 = context.traps.get(property);
        if (trap2 && trap2.get)
          return trap2.get(node, context);
        return Reflect.get(...args);
      },
      set(...args) {
        const [, property, value] = args;
        const trap2 = context.traps.get(property);
        if (trap2 && trap2.set)
          return trap2.set(node, context, property, value);
        return Reflect.set(...args);
      }
    });
    return nodeInit(node, ops);
  }
  function isDOM(node) {
    return typeof node !== "string" && has(node, "$el");
  }
  function isComponent2(node) {
    return typeof node !== "string" && has(node, "$cmp");
  }
  function isConditional(node) {
    if (!node || typeof node === "string")
      return false;
    return has(node, "if") && has(node, "then");
  }
  function isSugar(node) {
    return typeof node !== "string" && "$formkit" in node;
  }
  function sugar(node) {
    if (typeof node === "string") {
      return {
        $el: "text",
        children: node
      };
    }
    if (isSugar(node)) {
      const {
        $formkit: type,
        for: iterator2,
        if: condition,
        children,
        bind,
        ...props
      } = node;
      return Object.assign(
        {
          $cmp: "FormKit",
          props: { ...props, type }
        },
        condition ? { if: condition } : {},
        iterator2 ? { for: iterator2 } : {},
        children ? { children } : {},
        bind ? { bind } : {}
      );
    }
    return node;
  }
  function compile3(expr) {
    let provideTokens;
    const requirements = /* @__PURE__ */ new Set();
    const x = function expand(operand, tokens) {
      return typeof operand === "function" ? operand(tokens) : operand;
    };
    const operatorRegistry = [
      {
        "&&": (l, r, t) => x(l, t) && x(r, t),
        "||": (l, r, t) => x(l, t) || x(r, t)
      },
      {
        "===": (l, r, t) => !!(x(l, t) === x(r, t)),
        "!==": (l, r, t) => !!(x(l, t) !== x(r, t)),
        "==": (l, r, t) => !!(x(l, t) == x(r, t)),
        "!=": (l, r, t) => !!(x(l, t) != x(r, t)),
        ">=": (l, r, t) => !!(x(l, t) >= x(r, t)),
        "<=": (l, r, t) => !!(x(l, t) <= x(r, t)),
        ">": (l, r, t) => !!(x(l, t) > x(r, t)),
        "<": (l, r, t) => !!(x(l, t) < x(r, t))
      },
      {
        "+": (l, r, t) => x(l, t) + x(r, t),
        "-": (l, r, t) => x(l, t) - x(r, t)
      },
      {
        "*": (l, r, t) => x(l, t) * x(r, t),
        "/": (l, r, t) => x(l, t) / x(r, t),
        "%": (l, r, t) => x(l, t) % x(r, t)
      }
    ];
    const operatorSymbols = operatorRegistry.reduce((s, g) => {
      return s.concat(Object.keys(g));
    }, []);
    const operatorChars = new Set(operatorSymbols.map((key) => key.charAt(0)));
    function getOp(symbols, char, p2, expression) {
      const candidates = symbols.filter((s) => s.startsWith(char));
      if (!candidates.length)
        return false;
      return candidates.find((symbol2) => {
        if (expression.length >= p2 + symbol2.length) {
          const nextChars = expression.substring(p2, p2 + symbol2.length);
          if (nextChars === symbol2)
            return symbol2;
        }
        return false;
      });
    }
    function getStep(p2, expression, direction = 1) {
      let next = direction ? expression.substring(p2 + 1).trim() : expression.substring(0, p2).trim();
      if (!next.length)
        return -1;
      if (!direction) {
        const reversed = next.split("").reverse();
        const start = reversed.findIndex((char2) => operatorChars.has(char2));
        next = reversed.slice(start).join("");
      }
      const char = next[0];
      return operatorRegistry.findIndex((operators) => {
        const symbols = Object.keys(operators);
        return !!getOp(symbols, char, 0, next);
      });
    }
    function getTail(pos, expression) {
      let tail = "";
      const length3 = expression.length;
      let depth = 0;
      for (let p2 = pos; p2 < length3; p2++) {
        const char = expression.charAt(p2);
        if (char === "(") {
          depth++;
        } else if (char === ")") {
          depth--;
        } else if (depth === 0 && char === " ") {
          continue;
        }
        if (depth === 0 && getOp(operatorSymbols, char, p2, expression)) {
          return [tail, p2 - 1];
        } else {
          tail += char;
        }
      }
      return [tail, expression.length - 1];
    }
    function parseLogicals(expression, step2 = 0) {
      const operators = operatorRegistry[step2];
      const length3 = expression.length;
      const symbols = Object.keys(operators);
      let depth = 0;
      let quote = false;
      let op = null;
      let operand = "";
      let left = null;
      let operation;
      let lastChar = "";
      let char = "";
      let parenthetical = "";
      let parenQuote = "";
      let startP = 0;
      const addTo = (depth2, char2) => {
        depth2 ? parenthetical += char2 : operand += char2;
      };
      for (let p2 = 0; p2 < length3; p2++) {
        lastChar = char;
        char = expression.charAt(p2);
        if ((char === "'" || char === '"') && lastChar !== "\\" && (depth === 0 && !quote || depth && !parenQuote)) {
          if (depth) {
            parenQuote = char;
          } else {
            quote = char;
          }
          addTo(depth, char);
          continue;
        } else if (quote && (char !== quote || lastChar === "\\") || parenQuote && (char !== parenQuote || lastChar === "\\")) {
          addTo(depth, char);
          continue;
        } else if (quote === char) {
          quote = false;
          addTo(depth, char);
          continue;
        } else if (parenQuote === char) {
          parenQuote = false;
          addTo(depth, char);
          continue;
        } else if (char === " ") {
          continue;
        } else if (char === "(") {
          if (depth === 0) {
            startP = p2;
          } else {
            parenthetical += char;
          }
          depth++;
        } else if (char === ")") {
          depth--;
          if (depth === 0) {
            const fn = typeof operand === "string" && operand.startsWith("$") ? operand : void 0;
            const hasTail = fn && expression.charAt(p2 + 1) === ".";
            let tail = "";
            if (hasTail) {
              [tail, p2] = getTail(p2 + 2, expression);
            }
            const lStep = op ? step2 : getStep(startP, expression, 0);
            const rStep = getStep(p2, expression);
            if (lStep === -1 && rStep === -1) {
              operand = evaluate(parenthetical, -1, fn, tail);
              if (typeof operand === "string")
                operand = parenthetical;
            } else if (op && (lStep >= rStep || rStep === -1) && step2 === lStep) {
              left = op.bind(null, evaluate(parenthetical, -1, fn, tail));
              op = null;
              operand = "";
            } else if (rStep > lStep && step2 === rStep) {
              operand = evaluate(parenthetical, -1, fn, tail);
            } else {
              operand += `(${parenthetical})${hasTail ? `.${tail}` : ""}`;
            }
            parenthetical = "";
          } else {
            parenthetical += char;
          }
        } else if (depth === 0 && (operation = getOp(symbols, char, p2, expression))) {
          if (p2 === 0) {
            error(103, [operation, expression]);
          }
          p2 += operation.length - 1;
          if (p2 === expression.length - 1) {
            error(104, [operation, expression]);
          }
          if (!op) {
            if (left) {
              op = operators[operation].bind(null, evaluate(left, step2));
              left = null;
            } else {
              op = operators[operation].bind(null, evaluate(operand, step2));
              operand = "";
            }
          } else if (operand) {
            left = op.bind(null, evaluate(operand, step2));
            op = operators[operation].bind(null, left);
            operand = "";
          }
          continue;
        } else {
          addTo(depth, char);
        }
      }
      if (operand && op) {
        op = op.bind(null, evaluate(operand, step2));
      }
      op = !op && left ? left : op;
      if (!op && operand) {
        op = (v, t) => {
          return typeof v === "function" ? v(t) : v;
        };
        op = op.bind(null, evaluate(operand, step2));
      }
      if (!op && !operand) {
        error(105, expression);
      }
      return op;
    }
    function evaluate(operand, step2, fnToken, tail) {
      if (fnToken) {
        const fn = evaluate(fnToken, operatorRegistry.length);
        let userFuncReturn;
        let tailCall = tail ? compile3(`$${tail}`) : false;
        if (typeof fn === "function") {
          const args = parseArgs(String(operand)).map(
            (arg) => evaluate(arg, -1)
          );
          return (tokens) => {
            const userFunc = fn(tokens);
            if (typeof userFunc !== "function") {
              warn3(150, fnToken);
              return userFunc;
            }
            userFuncReturn = userFunc(
              ...args.map(
                (arg) => typeof arg === "function" ? arg(tokens) : arg
              )
            );
            if (tailCall) {
              tailCall = tailCall.provide((subTokens) => {
                const rootTokens = provideTokens(subTokens);
                const t = subTokens.reduce(
                  (tokenSet, token3) => {
                    const isTail = token3 === tail || tail?.startsWith(`${token3}(`);
                    if (isTail) {
                      const value = getAt(userFuncReturn, token3);
                      tokenSet[token3] = () => value;
                    } else {
                      tokenSet[token3] = rootTokens[token3];
                    }
                    return tokenSet;
                  },
                  {}
                );
                return t;
              });
            }
            return tailCall ? tailCall() : userFuncReturn;
          };
        }
      } else if (typeof operand === "string") {
        if (operand === "true")
          return true;
        if (operand === "false")
          return false;
        if (operand === "undefined")
          return void 0;
        if (isQuotedString(operand))
          return rmEscapes(operand.substring(1, operand.length - 1));
        if (!isNaN(+operand))
          return Number(operand);
        if (step2 < operatorRegistry.length - 1) {
          return parseLogicals(operand, step2 + 1);
        } else {
          if (operand.startsWith("$")) {
            const cleaned = operand.substring(1);
            requirements.add(cleaned);
            return function getToken(tokens) {
              return cleaned in tokens ? tokens[cleaned]() : void 0;
            };
          }
          return operand;
        }
      }
      return operand;
    }
    const compiled = parseLogicals(
      expr.startsWith("$:") ? expr.substring(2) : expr
    );
    const reqs = Array.from(requirements);
    function provide2(callback) {
      provideTokens = callback;
      return Object.assign(
        // @ts-ignore - @rollup/plugin-typescript doesn't like this
        compiled.bind(null, callback(reqs)),
        { provide: provide2 }
      );
    }
    return Object.assign(compiled, {
      provide: provide2
    });
  }
  function createClasses(propertyKey, node, sectionClassList) {
    if (!sectionClassList)
      return {};
    if (typeof sectionClassList === "string") {
      const classKeys = sectionClassList.split(" ");
      return classKeys.reduce(
        (obj, key) => Object.assign(obj, { [key]: true }),
        {}
      );
    } else if (typeof sectionClassList === "function") {
      return createClasses(
        propertyKey,
        node,
        sectionClassList(node, propertyKey)
      );
    }
    return sectionClassList;
  }
  function generateClassList(node, property, ...args) {
    const combinedClassList = args.reduce((finalClassList, currentClassList) => {
      if (!currentClassList)
        return handleNegativeClasses(finalClassList);
      const { $reset, ...classList } = currentClassList;
      if ($reset) {
        return handleNegativeClasses(classList);
      }
      return handleNegativeClasses(Object.assign(finalClassList, classList));
    }, {});
    return Object.keys(
      node.hook.classes.dispatch({ property, classes: combinedClassList }).classes
    ).filter((key) => combinedClassList[key]).join(" ") || null;
  }
  function handleNegativeClasses(classList) {
    const removalToken = "$remove:";
    let hasNegativeClassValue = false;
    const applicableClasses = Object.keys(classList).filter((className) => {
      if (classList[className] && className.startsWith(removalToken)) {
        hasNegativeClassValue = true;
      }
      return classList[className];
    });
    if (applicableClasses.length > 1 && hasNegativeClassValue) {
      const negativeClasses = applicableClasses.filter((className) => className.startsWith(removalToken));
      negativeClasses.map((negativeClass) => {
        const targetClass = negativeClass.substring(removalToken.length);
        classList[targetClass] = false;
        classList[negativeClass] = false;
      });
    }
    return classList;
  }
  function setErrors2(id, localErrors, childErrors) {
    const node = getNode(id);
    if (node) {
      node.setErrors(localErrors, childErrors);
    } else {
      warn3(651, id);
    }
  }
  function clearErrors2(id, clearChildren = true) {
    const node = getNode(id);
    if (node) {
      node.clearErrors(clearChildren);
    } else {
      warn3(652, id);
    }
  }
  var FORMKIT_VERSION = "1.6.9";

  // node_modules/@formkit/observer/dist/index.mjs
  var revokedObservers = /* @__PURE__ */ new WeakSet();
  function createObserver(node, dependencies) {
    const deps = dependencies || Object.assign(/* @__PURE__ */ new Map(), { active: false });
    const receipts2 = /* @__PURE__ */ new Map();
    const addDependency = function(event) {
      if (!deps.active)
        return;
      if (!deps.has(node))
        deps.set(node, /* @__PURE__ */ new Set());
      deps.get(node)?.add(event);
    };
    const observeProps = function(props) {
      return new Proxy(props, {
        get(...args) {
          typeof args[1] === "string" && addDependency(`prop:${args[1]}`);
          return Reflect.get(...args);
        }
      });
    };
    const observeLedger = function(ledger) {
      return new Proxy(ledger, {
        get(...args) {
          if (args[1] === "value") {
            return (key) => {
              addDependency(`count:${key}`);
              return ledger.value(key);
            };
          }
          return Reflect.get(...args);
        }
      });
    };
    const observe = function(value, property) {
      if (isNode(value)) {
        return createObserver(value, deps);
      }
      if (property === "value")
        addDependency("commit");
      if (property === "_value")
        addDependency("input");
      if (property === "props")
        return observeProps(value);
      if (property === "ledger")
        return observeLedger(value);
      if (property === "children") {
        addDependency("child");
        addDependency("childRemoved");
      }
      return value;
    };
    const {
      proxy: observed,
      revoke
    } = Proxy.revocable(node, {
      get(...args) {
        switch (args[1]) {
          case "_node":
            return node;
          case "deps":
            return deps;
          case "watch":
            return (block, after, pos) => watch3(observed, block, after, pos);
          case "observe":
            return () => {
              const old = new Map(deps);
              deps.clear();
              deps.active = true;
              return old;
            };
          case "stopObserve":
            return () => {
              const newDeps = new Map(deps);
              deps.active = false;
              return newDeps;
            };
          case "receipts":
            return receipts2;
          case "kill":
            return () => {
              removeListeners(receipts2);
              revokedObservers.add(args[2]);
              revoke();
              return void 0;
            };
        }
        const value = Reflect.get(...args);
        if (typeof value === "function") {
          return (...subArgs) => {
            const subValue = value(...subArgs);
            return observe(subValue, args[1]);
          };
        }
        return observe(value, args[1]);
      }
    });
    return observed;
  }
  function applyListeners(node, [toAdd, toRemove], callback, pos) {
    toAdd.forEach((events, depNode) => {
      events.forEach((event) => {
        node.receipts.has(depNode) || node.receipts.set(depNode, {});
        const events2 = node.receipts.get(depNode) ?? {};
        events2[event] = events2[event] ?? [];
        events2[event].push(depNode.on(event, callback, pos));
        node.receipts.set(depNode, events2);
      });
    });
    toRemove.forEach((events, depNode) => {
      events.forEach((event) => {
        if (node.receipts.has(depNode)) {
          const nodeReceipts = node.receipts.get(depNode);
          if (nodeReceipts && has(nodeReceipts, event)) {
            nodeReceipts[event].map(depNode.off);
            delete nodeReceipts[event];
            node.receipts.set(depNode, nodeReceipts);
          }
        }
      });
    });
  }
  function removeListeners(receipts2) {
    receipts2.forEach((events, node) => {
      for (const event in events) {
        events[event].map(node.off);
      }
    });
    receipts2.clear();
  }
  function watch3(node, block, after, pos) {
    const doAfterObservation = (res2) => {
      const newDeps = node.stopObserve();
      applyListeners(
        node,
        diffDeps(oldDeps, newDeps),
        () => watch3(node, block, after, pos),
        pos
      );
      if (after)
        after(res2);
    };
    const oldDeps = new Map(node.deps);
    node.observe();
    const res = block(node);
    if (res instanceof Promise)
      res.then((val) => doAfterObservation(val));
    else
      doAfterObservation(res);
  }
  function diffDeps(previous, current) {
    const toAdd = /* @__PURE__ */ new Map();
    const toRemove = /* @__PURE__ */ new Map();
    current.forEach((events, node) => {
      if (!previous.has(node)) {
        toAdd.set(node, events);
      } else {
        const eventsToAdd = /* @__PURE__ */ new Set();
        const previousEvents = previous.get(node);
        events.forEach(
          (event) => !previousEvents?.has(event) && eventsToAdd.add(event)
        );
        toAdd.set(node, eventsToAdd);
      }
    });
    previous.forEach((events, node) => {
      if (!current.has(node)) {
        toRemove.set(node, events);
      } else {
        const eventsToRemove = /* @__PURE__ */ new Set();
        const newEvents = current.get(node);
        events.forEach(
          (event) => !newEvents?.has(event) && eventsToRemove.add(event)
        );
        toRemove.set(node, eventsToRemove);
      }
    });
    return [toAdd, toRemove];
  }
  function isKilled(node) {
    return revokedObservers.has(node);
  }

  // node_modules/@formkit/rules/dist/index.mjs
  var dist_exports = {};
  __export(dist_exports, {
    accepted: () => accepted_default,
    alpha: () => alpha_default,
    alpha_spaces: () => alpha_spaces_default,
    alphanumeric: () => alphanumeric_default,
    between: () => between_default,
    confirm: () => confirm_default,
    contains_alpha: () => contains_alpha_default,
    contains_alpha_spaces: () => contains_alpha_spaces_default,
    contains_alphanumeric: () => contains_alphanumeric_default,
    contains_lowercase: () => contains_lowercase_default,
    contains_numeric: () => contains_numeric_default,
    contains_symbol: () => contains_symbol_default,
    contains_uppercase: () => contains_uppercase_default,
    date_after: () => date_after_default,
    date_after_node: () => date_after_node_default,
    date_after_or_equal: () => date_after_or_equal_default,
    date_before: () => date_before_default,
    date_before_node: () => date_before_node_default,
    date_before_or_equal: () => date_before_or_equal_default,
    date_between: () => date_between_default,
    date_format: () => date_format_default,
    email: () => email_default,
    ends_with: () => ends_with_default,
    is: () => is_default,
    length: () => length_default,
    lowercase: () => lowercase_default,
    matches: () => matches_default,
    max: () => max_default,
    min: () => min_default,
    not: () => not_default,
    number: () => number_default,
    require_one: () => require_one_default,
    required: () => required_default,
    starts_with: () => starts_with_default,
    symbol: () => symbol_default,
    uppercase: () => uppercase_default,
    url: () => url_default
  });
  var accepted = function accepted2({ value }) {
    return ["yes", "on", "1", 1, true, "true"].includes(value);
  };
  accepted.skipEmpty = false;
  var accepted_default = accepted;
  var date_after = function({ value }, compare = false) {
    const timestamp = Date.parse(compare || /* @__PURE__ */ new Date());
    const fieldValue = Date.parse(String(value));
    return isNaN(fieldValue) ? false : fieldValue > timestamp;
  };
  var date_after_default = date_after;
  var date_after_or_equal = function({ value }, compare = false) {
    const timestamp = Date.parse(compare || /* @__PURE__ */ new Date());
    const fieldValue = Date.parse(String(value));
    return isNaN(fieldValue) ? false : fieldValue > timestamp || fieldValue === timestamp;
  };
  var date_after_or_equal_default = date_after_or_equal;
  var date_after_node = function(node, address) {
    if (!address)
      return false;
    const fieldValue = Date.parse(String(node.value));
    const foreignValue = Date.parse(String(node.at(address)?.value));
    if (isNaN(foreignValue))
      return true;
    return isNaN(fieldValue) ? false : fieldValue > foreignValue;
  };
  var date_after_node_default = date_after_node;
  var alpha = function({ value }, set = "default") {
    const sets = {
      default: /^\p{L}+$/u,
      latin: /^[a-z]+$/i
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var alpha_default = alpha;
  var alpha_spaces = function({ value }, set = "default") {
    const sets = {
      default: /^[\p{L} ]+$/u,
      latin: /^[a-z ]+$/i
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var alpha_spaces_default = alpha_spaces;
  var alphanumeric = function({ value }, set = "default") {
    const sets = {
      default: /^[0-9\p{L}]+$/u,
      latin: /^[0-9a-z]+$/i
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var alphanumeric_default = alphanumeric;
  var date_before = function({ value }, compare = false) {
    const timestamp = Date.parse(compare || /* @__PURE__ */ new Date());
    const fieldValue = Date.parse(String(value));
    return isNaN(fieldValue) ? false : fieldValue < timestamp;
  };
  var date_before_default = date_before;
  var date_before_node = function(node, address) {
    if (!address)
      return false;
    const fieldValue = Date.parse(String(node.value));
    const foreignValue = Date.parse(String(node.at(address)?.value));
    if (isNaN(foreignValue))
      return true;
    return isNaN(fieldValue) ? false : fieldValue < foreignValue;
  };
  var date_before_node_default = date_before_node;
  var date_before_or_equal = function({ value }, compare = false) {
    const timestamp = Date.parse(compare || /* @__PURE__ */ new Date());
    const fieldValue = Date.parse(String(value));
    return isNaN(fieldValue) ? false : fieldValue < timestamp || fieldValue === timestamp;
  };
  var date_before_or_equal_default = date_before_or_equal;
  var between = function between2({ value }, from, to) {
    if (!isNaN(value) && !isNaN(from) && !isNaN(to)) {
      const val = 1 * value;
      from = Number(from);
      to = Number(to);
      const [a, b] = from <= to ? [from, to] : [to, from];
      return val >= 1 * a && val <= 1 * b;
    }
    return false;
  };
  var between_default = between;
  var hasConfirm = /(_confirm(?:ed)?)$/;
  var confirm = function confirm2(node, address, comparison = "loose") {
    if (!address) {
      address = hasConfirm.test(node.name) ? node.name.replace(hasConfirm, "") : `${node.name}_confirm`;
    }
    const foreignValue = node.at(address)?.value;
    return comparison === "strict" ? node.value === foreignValue : node.value == foreignValue;
  };
  var confirm_default = confirm;
  var contains_alpha = function({ value }, set = "default") {
    const sets = {
      default: /\p{L}/u,
      latin: /[a-z]/i
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var contains_alpha_default = contains_alpha;
  var contains_alpha_spaces = function({ value }, set = "default") {
    const sets = {
      default: /[\p{L} ]/u,
      latin: /[a-z ]/i
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var contains_alpha_spaces_default = contains_alpha_spaces;
  var contains_alphanumeric = function({ value }, set = "default") {
    const sets = {
      default: /[0-9\p{L}]/u,
      latin: /[0-9a-z]/i
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var contains_alphanumeric_default = contains_alphanumeric;
  var contains_lowercase = function({ value }, set = "default") {
    const sets = {
      default: /\p{Ll}/u,
      latin: /[a-z]/
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var contains_lowercase_default = contains_lowercase;
  var contains_numeric = function number({ value }) {
    return /[0-9]/.test(String(value));
  };
  var contains_numeric_default = contains_numeric;
  var contains_symbol = function({ value }) {
    return /[!-/:-@[-`{-~]/.test(String(value));
  };
  var contains_symbol_default = contains_symbol;
  var contains_uppercase = function({ value }, set = "default") {
    const sets = {
      default: /\p{Lu}/u,
      latin: /[A-Z]/
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var contains_uppercase_default = contains_uppercase;
  var date_between = function date_between2({ value }, dateA, dateB) {
    dateA = dateA instanceof Date ? dateA.getTime() : Date.parse(dateA);
    dateB = dateB instanceof Date ? dateB.getTime() : Date.parse(dateB);
    const compareTo = value instanceof Date ? value.getTime() : Date.parse(String(value));
    if (dateA && !dateB) {
      dateB = dateA;
      dateA = Date.now();
    } else if (!dateA || !compareTo) {
      return false;
    }
    return compareTo >= dateA && compareTo <= dateB;
  };
  var date_between_default = date_between;
  var date_format = function date({ value }, format) {
    if (format && typeof format === "string") {
      return regexForFormat(format).test(String(value));
    }
    return !isNaN(Date.parse(String(value)));
  };
  var date_format_default = date_format;
  var email = function email2({ value }) {
    const isEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return isEmail.test(String(value));
  };
  var email_default = email;
  var ends_with = function ends_with2({ value }, ...stack3) {
    if (typeof value === "string" && stack3.length) {
      return stack3.some((item) => {
        return value.endsWith(item);
      });
    } else if (typeof value === "string" && stack3.length === 0) {
      return true;
    }
    return false;
  };
  var ends_with_default = ends_with;
  var is = function is2({ value }, ...stack3) {
    return stack3.some((item) => {
      if (typeof item === "object") {
        return eq(item, value);
      }
      return item == value;
    });
  };
  var is_default = is;
  var length = function length2({ value }, first = 0, second = Infinity) {
    first = parseInt(first);
    second = isNaN(parseInt(second)) ? Infinity : parseInt(second);
    const min3 = first <= second ? first : second;
    const max3 = second >= first ? second : first;
    if (typeof value === "string" || Array.isArray(value)) {
      return value.length >= min3 && value.length <= max3;
    } else if (value && typeof value === "object") {
      const length3 = Object.keys(value).length;
      return length3 >= min3 && length3 <= max3;
    }
    return false;
  };
  var length_default = length;
  var lowercase = function({ value }, set = "default") {
    const sets = {
      default: /^\p{Ll}+$/u,
      allow_non_alpha: /^[0-9\p{Ll}!-/:-@[-`{-~]+$/u,
      allow_numeric: /^[0-9\p{Ll}]+$/u,
      allow_numeric_dashes: /^[0-9\p{Ll}-]+$/u,
      latin: /^[a-z]+$/
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var lowercase_default = lowercase;
  var matches2 = function matches22({ value }, ...stack3) {
    return stack3.some((pattern) => {
      if (typeof pattern === "string" && pattern.substr(0, 1) === "/" && pattern.substr(-1) === "/") {
        pattern = new RegExp(pattern.substr(1, pattern.length - 2));
      }
      if (pattern instanceof RegExp) {
        return pattern.test(String(value));
      }
      return pattern === value;
    });
  };
  var matches_default = matches2;
  var max = function max2({ value }, maximum = 10) {
    if (Array.isArray(value)) {
      return value.length <= maximum;
    }
    return Number(value) <= Number(maximum);
  };
  var max_default = max;
  var min = function min2({ value }, minimum = 1) {
    if (Array.isArray(value)) {
      return value.length >= minimum;
    }
    return Number(value) >= Number(minimum);
  };
  var min_default = min;
  var not = function not2({ value }, ...stack3) {
    return !stack3.some((item) => {
      if (typeof item === "object") {
        return eq(item, value);
      }
      return item === value;
    });
  };
  var not_default = not;
  var number2 = function number3({ value }) {
    return !isNaN(value);
  };
  var number_default = number2;
  var require_one = function(node, ...inputNames) {
    if (!empty(node.value))
      return true;
    const values = inputNames.map((name) => node.at(name)?.value);
    return values.some((value) => !empty(value));
  };
  require_one.skipEmpty = false;
  var require_one_default = require_one;
  var required = function required2({ value }, action = "default") {
    return action === "trim" && typeof value === "string" ? !empty(value.trim()) : !empty(value);
  };
  required.skipEmpty = false;
  var required_default = required;
  var starts_with = function starts_with2({ value }, ...stack3) {
    if (typeof value === "string" && stack3.length) {
      return stack3.some((item) => {
        return value.startsWith(item);
      });
    } else if (typeof value === "string" && stack3.length === 0) {
      return true;
    }
    return false;
  };
  var starts_with_default = starts_with;
  var symbol = function({ value }) {
    return /^[!-/:-@[-`{-~]+$/.test(String(value));
  };
  var symbol_default = symbol;
  var uppercase = function({ value }, set = "default") {
    const sets = {
      default: /^\p{Lu}+$/u,
      latin: /^[A-Z]+$/
    };
    const selectedSet = has(sets, set) ? set : "default";
    return sets[selectedSet].test(String(value));
  };
  var uppercase_default = uppercase;
  var url = function url2({ value }, ...stack3) {
    try {
      const protocols = stack3.length ? stack3 : ["http:", "https:"];
      const url32 = new URL(String(value));
      return protocols.includes(url32.protocol);
    } catch {
      return false;
    }
  };
  var url_default = url;

  // node_modules/@formkit/validation/dist/index.mjs
  var validatingMessage = /* @__PURE__ */ createMessage({
    type: "state",
    blocking: true,
    visible: false,
    value: true,
    key: "validating"
  });
  function createValidationPlugin(baseRules = {}) {
    return function validationPlugin(node) {
      let propRules = cloneAny(node.props.validationRules || {});
      let availableRules = { ...baseRules, ...propRules };
      const state = { input: token(), rerun: null, isPassing: true };
      let validation = cloneAny(node.props.validation);
      node.on("prop:validation", ({ payload }) => reboot(payload, propRules));
      node.on(
        "prop:validationRules",
        ({ payload }) => reboot(validation, payload)
      );
      function reboot(newValidation, newRules) {
        if (eq(Object.keys(propRules || {}), Object.keys(newRules || {})) && eq(validation, newValidation))
          return;
        propRules = cloneAny(newRules);
        validation = cloneAny(newValidation);
        availableRules = { ...baseRules, ...propRules };
        node.props.parsedRules?.forEach((validation2) => {
          removeMessage2(validation2);
          removeListeners(validation2.observer.receipts);
          validation2.observer.kill();
        });
        node.store.filter(() => false, "validation");
        node.props.parsedRules = parseRules(newValidation, availableRules, node);
        state.isPassing = true;
        validate(node, node.props.parsedRules, state);
      }
      node.props.parsedRules = parseRules(validation, availableRules, node);
      validate(node, node.props.parsedRules, state);
    };
  }
  function validate(node, validations, state) {
    if (isKilled(node))
      return;
    state.input = token();
    node.store.set(
      /* @__PURE__ */ createMessage({
        key: "failing",
        value: !state.isPassing,
        visible: false
      })
    );
    state.isPassing = true;
    node.store.filter((message3) => !message3.meta.removeImmediately, "validation");
    validations.forEach(
      (validation) => validation.debounce && clearTimeout(validation.timer)
    );
    if (validations.length) {
      node.store.set(validatingMessage);
      run(0, validations, state, false, () => {
        node.store.remove(validatingMessage.key);
        node.store.set(
          /* @__PURE__ */ createMessage({
            key: "failing",
            value: !state.isPassing,
            visible: false
          })
        );
      });
    }
  }
  function run(current, validations, state, removeImmediately, complete) {
    const validation = validations[current];
    if (!validation)
      return complete();
    const node = validation.observer;
    if (isKilled(node))
      return;
    const currentRun = state.input;
    validation.state = null;
    function next(async, result) {
      if (state.input !== currentRun)
        return;
      state.isPassing = state.isPassing && !!result;
      validation.queued = false;
      const newDeps = node.stopObserve();
      const diff = diffDeps(validation.deps, newDeps);
      applyListeners(
        node,
        diff,
        function revalidate() {
          try {
            node.store.set(validatingMessage);
          } catch (e) {
          }
          validation.queued = true;
          if (state.rerun)
            clearTimeout(state.rerun);
          state.rerun = setTimeout(
            validate,
            0,
            node,
            validations,
            state
          );
        },
        "unshift"
        // We want these listeners to run before other events are emitted so the 'state.validating' will be reliable.
      );
      validation.deps = newDeps;
      validation.state = result;
      if (result === false) {
        createFailedMessage(validation, removeImmediately || async);
      } else {
        removeMessage2(validation);
      }
      if (validations.length > current + 1) {
        const nextValidation = validations[current + 1];
        if ((result || nextValidation.force || !nextValidation.skipEmpty) && nextValidation.state === null) {
          nextValidation.queued = true;
        }
        run(current + 1, validations, state, removeImmediately || async, complete);
      } else {
        complete();
      }
    }
    if ((!empty(node.value) || !validation.skipEmpty) && (state.isPassing || validation.force)) {
      if (validation.queued) {
        runRule(validation, node, (result) => {
          result instanceof Promise ? result.then((r) => next(true, r)) : next(false, result);
        });
      } else {
        run(current + 1, validations, state, removeImmediately, complete);
      }
    } else if (empty(node.value) && validation.skipEmpty && state.isPassing) {
      node.observe();
      node.value;
      next(false, state.isPassing);
    } else {
      next(false, null);
    }
  }
  function runRule(validation, node, after) {
    if (validation.debounce) {
      validation.timer = setTimeout(() => {
        node.observe();
        after(validation.rule(node, ...validation.args));
      }, validation.debounce);
    } else {
      node.observe();
      after(validation.rule(node, ...validation.args));
    }
  }
  function removeMessage2(validation) {
    const key = `rule_${validation.name}`;
    if (validation.messageObserver) {
      validation.messageObserver = validation.messageObserver.kill();
    }
    if (has(validation.observer.store, key)) {
      validation.observer.store.remove(key);
    }
  }
  function createFailedMessage(validation, removeImmediately) {
    const node = validation.observer;
    if (isKilled(node))
      return;
    if (!validation.messageObserver) {
      validation.messageObserver = createObserver(node._node);
    }
    validation.messageObserver.watch(
      (node2) => {
        const i18nArgs = createI18nArgs(
          node2,
          validation
        );
        return i18nArgs;
      },
      (i18nArgs) => {
        const customMessage = createCustomMessage(node, validation, i18nArgs);
        const message3 = /* @__PURE__ */ createMessage({
          blocking: validation.blocking,
          key: `rule_${validation.name}`,
          meta: {
            /**
             * Use this key instead of the message root key to produce i18n validation
             * messages.
             */
            messageKey: validation.name,
            /**
             * For messages that were created *by or after* a debounced or async
             * validation rule — we make note of it so we can immediately remove them
             * as soon as the next commit happens.
             */
            removeImmediately,
            /**
             * Determines if this message should be passed to localization.
             */
            localize: !customMessage,
            /**
             * The arguments that will be passed to the validation rules
             */
            i18nArgs
          },
          type: "validation",
          value: customMessage || "This field is not valid."
        });
        node.store.set(message3);
      }
    );
  }
  function createCustomMessage(node, validation, i18nArgs) {
    const customMessage = node.props.validationMessages && has(node.props.validationMessages, validation.name) ? node.props.validationMessages[validation.name] : void 0;
    if (typeof customMessage === "function") {
      return customMessage(...i18nArgs);
    }
    return customMessage;
  }
  function createI18nArgs(node, validation) {
    return [
      {
        node,
        name: createMessageName(node),
        args: validation.args
      }
    ];
  }
  function createMessageName(node) {
    if (typeof node.props.validationLabel === "function") {
      return node.props.validationLabel(node);
    }
    return node.props.validationLabel || node.props.label || node.props.name || String(node.name);
  }
  var hintPattern = "(?:[\\*+?()0-9]+)";
  var rulePattern = "[a-zA-Z][a-zA-Z0-9_]+";
  var ruleExtractor = new RegExp(
    `^(${hintPattern}?${rulePattern})(?:\\:(.*)+)?$`,
    "i"
  );
  var hintExtractor = new RegExp(`^(${hintPattern})(${rulePattern})$`, "i");
  var debounceExtractor = /([\*+?]+)?(\(\d+\))([\*+?]+)?/;
  var hasDebounce = /\(\d+\)/;
  var defaultHints = {
    blocking: true,
    debounce: 0,
    force: false,
    skipEmpty: true,
    name: ""
  };
  function parseRules(validation, rules, node) {
    if (!validation)
      return [];
    const intents = typeof validation === "string" ? extractRules(validation) : clone(validation);
    return intents.reduce((validations, args) => {
      let rule = args.shift();
      const hints = {};
      if (typeof rule === "string") {
        const [ruleName, parsedHints] = parseHints(rule);
        if (has(rules, ruleName)) {
          rule = rules[ruleName];
          Object.assign(hints, parsedHints);
        }
      }
      if (typeof rule === "function") {
        validations.push({
          observer: createObserver(node),
          rule,
          args,
          timer: 0,
          state: null,
          queued: true,
          deps: /* @__PURE__ */ new Map(),
          ...defaultHints,
          ...fnHints(hints, rule)
        });
      }
      return validations;
    }, []);
  }
  function extractRules(validation) {
    return validation.split("|").reduce((rules, rule) => {
      const parsedRule = parseRule(rule);
      if (parsedRule) {
        rules.push(parsedRule);
      }
      return rules;
    }, []);
  }
  function parseRule(rule) {
    const trimmed = rule.trim();
    if (trimmed) {
      const matches3 = trimmed.match(ruleExtractor);
      if (matches3 && typeof matches3[1] === "string") {
        const ruleName = matches3[1].trim();
        const args = matches3[2] && typeof matches3[2] === "string" ? matches3[2].split(",").map((s) => s.trim()) : [];
        return [ruleName, ...args];
      }
    }
    return false;
  }
  function parseHints(ruleName) {
    const matches3 = ruleName.match(hintExtractor);
    if (!matches3) {
      return [ruleName, { name: ruleName }];
    }
    const map2 = {
      "*": { force: true },
      "+": { skipEmpty: false },
      "?": { blocking: false }
    };
    const [, hints, rule] = matches3;
    const hintGroups = hasDebounce.test(hints) ? hints.match(debounceExtractor) || [] : [, hints];
    return [
      rule,
      [hintGroups[1], hintGroups[2], hintGroups[3]].reduce(
        (hints2, group2) => {
          if (!group2)
            return hints2;
          if (hasDebounce.test(group2)) {
            hints2.debounce = parseInt(group2.substr(1, group2.length - 1));
          } else {
            group2.split("").forEach(
              (hint) => has(map2, hint) && Object.assign(hints2, map2[hint])
            );
          }
          return hints2;
        },
        { name: rule }
      )
    ];
  }
  function fnHints(existingHints, rule) {
    if (!existingHints.name) {
      existingHints.name = rule.ruleName || rule.name;
    }
    return ["skipEmpty", "force", "debounce", "blocking"].reduce(
      (hints, hint) => {
        if (has(rule, hint) && !has(hints, hint)) {
          Object.assign(hints, {
            [hint]: rule[hint]
          });
        }
        return hints;
      },
      existingHints
    );
  }

  // node_modules/@formkit/i18n/dist/index.mjs
  function sentence(str) {
    return str[0].toUpperCase() + str.substr(1);
  }
  function list(items, conjunction = "or") {
    return items.reduce((oxford, item, index) => {
      oxford += item;
      if (index <= items.length - 2 && items.length > 2) {
        oxford += ", ";
      }
      if (index === items.length - 2) {
        oxford += `${items.length === 2 ? " " : ""}${conjunction} `;
      }
      return oxford;
    }, "");
  }
  function date2(date22) {
    const dateTime = typeof date22 === "string" ? new Date(Date.parse(date22)) : date22;
    if (!(dateTime instanceof Date)) {
      return "(unknown)";
    }
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeZone: "UTC"
    }).format(dateTime);
  }
  function order(first, second) {
    return Number(first) >= Number(second) ? [second, first] : [first, second];
  }
  var ui8 = {
    /**
     * Shown on buttons for adding new items.
     */
    add: "Hinzuf\xFCgen",
    /**
     * Shown when a button to remove items is visible.
     */
    remove: "Entfernen",
    /**
     * Shown when there are multiple items to remove at the same time.
     */
    removeAll: "Alles entfernen",
    /**
     * Shown when all fields are not filled out correctly.
     */
    incomplete: "Entschuldigung, nicht alle Felder wurden korrekt ausgef\xFCllt.",
    /**
     * Shown in a button inside a form to submit the form.
     */
    submit: "Senden",
    /**
     * Shown when no files are selected.
     */
    noFiles: "Keine Datei ausgew\xE4hlt",
    /**
     * Shown on buttons that move fields up in a list.
     */
    moveUp: "Gehe nach oben",
    /**
     * Shown on buttons that move fields down in a list.
     */
    moveDown: "Gehen Sie nach unten",
    /**
     * Shown when something is actively loading.
     */
    isLoading: "Wird geladen...",
    /**
     * Shown when there is more to load.
     */
    loadMore: "Mehr laden",
    /**
     * Shown on buttons that navigate state forward
     */
    next: "Weiter",
    /**
     * Shown on buttons that navigate state backward
     */
    prev: "Zur\xFCck",
    /**
     * Shown when adding all values.
     */
    addAllValues: "Alle Werte hinzuf\xFCgen",
    /**
     * Shown when adding selected values.
     */
    addSelectedValues: "Ausgew\xE4hlte Werte hinzuf\xFCgen",
    /**
     * Shown when removing all values.
     */
    removeAllValues: "Alle Werte entfernen",
    /**
     * Shown when removing selected values.
     */
    removeSelectedValues: "Ausgew\xE4hlte Werte entfernen",
    /**
     * Shown when there is a date to choose.
     */
    chooseDate: "Datum w\xE4hlen",
    /**
     * Shown when there is a date to change.
     */
    changeDate: "Datum \xE4ndern",
    /**
     * Shown when there is something to close
     */
    close: "Schliessen",
    /**
     * Shown when there is something to open.
     */
    open: "Offen"
  };
  var validation8 = {
    /**
     * The value is not an accepted value.
     * @see {@link https://formkit.com/essentials/validation#accepted}
     */
    accepted({ name }) {
      return `Bitte ${name} akzeptieren.`;
    },
    /**
     * The date is not after
     * @see {@link https://formkit.com/essentials/validation#date-after}
     */
    date_after({ name, args }) {
      if (Array.isArray(args) && args.length) {
        return `${sentence(name)} muss nach dem ${date2(args[0])} liegen.`;
      }
      return `${sentence(name)} muss in der Zukunft liegen.`;
    },
    /**
     * The value is not a letter.
     * @see {@link https://formkit.com/essentials/validation#alpha}
     */
    alpha({ name }) {
      return `${sentence(name)} darf nur Buchstaben enthalten.`;
    },
    /**
     * The value is not alphanumeric
     * @see {@link https://formkit.com/essentials/validation#alphanumeric}
     */
    alphanumeric({ name }) {
      return `${sentence(name)} darf nur Buchstaben und Zahlen enthalten.`;
    },
    /**
     * The value is not letter and/or spaces
     * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
     */
    alpha_spaces({ name }) {
      return `${sentence(name)} d\xFCrfen nur Buchstaben und Leerzeichen enthalten.`;
    },
    /**
     * The value have no letter.
     * @see {@link https://formkit.com/essentials/validation#contains_alpha}
     */
    contains_alpha({ name }) {
      return `${sentence(name)} muss alphabetische Zeichen enthalten.`;
    },
    /**
     * The value have no alphanumeric
     * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
     */
    contains_alphanumeric({ name }) {
      return `${sentence(name)} muss Buchstaben oder Zahlen enthalten.`;
    },
    /**
     * The value have no letter and/or spaces
     * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
     */
    contains_alpha_spaces({ name }) {
      return `${sentence(name)} muss Buchstaben oder Leerzeichen enthalten.`;
    },
    /**
     * The value have no symbol
     * @see {@link https://formkit.com/essentials/validation#contains_symbol}
     */
    contains_symbol({ name }) {
      return `${sentence(name)} muss ein Symbol enthalten.`;
    },
    /**
     * The value have no uppercase
     * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
     */
    contains_uppercase({ name }) {
      return `${sentence(name)} muss Gro\xDFbuchstaben enthalten.`;
    },
    /**
     * The value have no lowercase
     * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
     */
    contains_lowercase({ name }) {
      return `${sentence(name)} muss Kleinbuchstaben enthalten.`;
    },
    /**
     *  The value have no numeric
     * @see {@link https://formkit.com/essentials/validation#contains_numeric}
     */
    contains_numeric({ name }) {
      return `${sentence(name)} muss Zahlen enthalten.`;
    },
    /**
     * The value is not symbol
     * @see {@link https://formkit.com/essentials/validation#symbol}
     */
    symbol({ name }) {
      return `${sentence(name)} muss ein Symbol sein.`;
    },
    /**
     * The value is not uppercase
     * @see {@link https://formkit.com/essentials/validation#uppercase}
     */
    uppercase({ name }) {
      return `${sentence(name)} kann nur Gro\xDFbuchstaben enthalten.`;
    },
    /**
     * The value is not lowercase
     * @see {@link https://formkit.com/essentials/validation#lowercase}
     */
    lowercase({ name }) {
      return `${sentence(name)} kann nur Kleinbuchstaben enthalten.`;
    },
    /**
     * The date is not before
     * @see {@link https://formkit.com/essentials/validation#date-before}
     */
    date_before({ name, args }) {
      if (Array.isArray(args) && args.length) {
        return `${sentence(name)} muss vor dem ${date2(args[0])} liegen.`;
      }
      return `${sentence(name)} muss in der Vergangenheit liegen.`;
    },
    /**
     * The value is not between two numbers
     * @see {@link https://formkit.com/essentials/validation#between}
     */
    between({ name, args }) {
      if (isNaN(args[0]) || isNaN(args[1])) {
        return `Dieses Feld wurde falsch konfiguriert und kann nicht \xFCbermittelt werden.`;
      }
      return `${sentence(name)} muss zwischen ${args[0]} und ${args[1]} sein.`;
    },
    /**
     * The confirmation field does not match
     * @see {@link https://formkit.com/essentials/validation#confirm}
     */
    confirm({ name }) {
      return `${sentence(name)} stimmt nicht \xFCberein.`;
    },
    /**
     * The value is not a valid date
     * @see {@link https://formkit.com/essentials/validation#date-format}
     */
    date_format({ name, args }) {
      if (Array.isArray(args) && args.length) {
        return `${sentence(name)} ist kein g\xFCltiges Datum im Format ${args[0]}.`;
      }
      return "Dieses Feld wurde falsch konfiguriert und kann nicht \xFCbermittelt werden.";
    },
    /**
     * Is not within expected date range
     * @see {@link https://formkit.com/essentials/validation#date-between}
     */
    date_between({ name, args }) {
      return `${sentence(name)} muss zwischen ${date2(args[0])} und ${date2(
        args[1]
      )} liegen.`;
    },
    /**
     * Shown when the user-provided value is not a valid email address.
     * @see {@link https://formkit.com/essentials/validation#email}
     */
    email: "E-Mail Adresse ist ung\xFCltig.",
    /**
     * Does not end with the specified value
     * @see {@link https://formkit.com/essentials/validation#ends-with}
     */
    ends_with({ name, args }) {
      return `${sentence(name)} endet nicht mit ${list(args)}.`;
    },
    /**
     * Is not an allowed value
     * @see {@link https://formkit.com/essentials/validation#is}
     */
    is({ name }) {
      return `${sentence(name)} enth\xE4lt einen ung\xFCltigen Wert.`;
    },
    /**
     * Does not match specified length
     * @see {@link https://formkit.com/essentials/validation#length}
     */
    length({ name, args: [first = 0, second = Infinity] }) {
      const min3 = first <= second ? first : second;
      const max3 = second >= first ? second : first;
      if (min3 == 1 && max3 === Infinity) {
        return `${sentence(name)} muss mindestens ein Zeichen enthalten.`;
      }
      if (min3 == 0 && max3) {
        return `${sentence(name)} darf maximal ${max3} Zeichen enthalten.`;
      }
      if (min3 === max3) {
        return `${sentence(name)} sollte ${max3} Zeichen lang sein.`;
      }
      if (min3 && max3 === Infinity) {
        return `${sentence(name)} muss mindestens ${min3} Zeichen enthalten.`;
      }
      return `${sentence(name)} muss zwischen ${min3} und ${max3} Zeichen enthalten.`;
    },
    /**
     * Value is not a match
     * @see {@link https://formkit.com/essentials/validation#matches}
     */
    matches({ name }) {
      return `${sentence(name)} enth\xE4lt einen ung\xFCltigen Wert.`;
    },
    /**
     * Exceeds maximum allowed value
     * @see {@link https://formkit.com/essentials/validation#max}
     */
    max({ name, node: { value }, args }) {
      if (Array.isArray(value)) {
        return `Darf maximal ${args[0]} ${name} haben.`;
      }
      return `${sentence(name)} darf maximal ${args[0]} sein.`;
    },
    /**
     * The (field-level) value does not match specified mime type
     * @see {@link https://formkit.com/essentials/validation#mime}
     */
    mime({ name, args }) {
      if (!args[0]) {
        return "Keine Dateiformate konfiguriert.";
      }
      return `${sentence(name)} muss vom Typ ${args[0]} sein.`;
    },
    /**
     * Does not fulfill minimum allowed value
     * @see {@link https://formkit.com/essentials/validation#min}
     */
    min({ name, node: { value }, args }) {
      if (Array.isArray(value)) {
        return `Mindestens ${args[0]} ${name} erforderlich.`;
      }
      return `${sentence(name)} muss mindestens ${args[0]} sein.`;
    },
    /**
     * Is not an allowed value
     * @see {@link https://formkit.com/essentials/validation#not}
     */
    not({ name, node: { value } }) {
      return `\u201C${value}\u201D ist kein g\xFCltiger Wert f\xFCr ${name}.`;
    },
    /**
     *  Is not a number
     * @see {@link https://formkit.com/essentials/validation#number}
     */
    number({ name }) {
      return `${sentence(name)} muss eine Zahl sein.`;
    },
    /**
     * Require one field.
     * @see {@link https://formkit.com/essentials/validation#require-one}
     */
    require_one: ({ name, node, args: inputNames }) => {
      const labels = inputNames.map((name2) => {
        const dependentNode = node.at(name2);
        if (dependentNode) {
          return createMessageName(dependentNode);
        }
        return false;
      }).filter((name2) => !!name2);
      labels.unshift(name);
      return `${labels.join(" oder ")} ist erforderlich.`;
    },
    /**
     * Required field.
     * @see {@link https://formkit.com/essentials/validation#required}
     */
    required({ name }) {
      return `${sentence(name)} ist erforderlich.`;
    },
    /**
     * Does not start with specified value
     * @see {@link https://formkit.com/essentials/validation#starts-with}
     */
    starts_with({ name, args }) {
      return `${sentence(name)} beginnt nicht mit ${list(args)}.`;
    },
    /**
     * Is not a url
     * @see {@link https://formkit.com/essentials/validation#url}
     */
    url() {
      return `Bitte geben Sie eine g\xFCltige URL ein.`;
    },
    /**
     * Shown when the date is invalid.
     */
    invalidDate: "Das gew\xE4hlte Datum ist ung\xFCltig."
  };
  var de = { ui: ui8, validation: validation8 };
  var ui10 = {
    /**
     * Shown on a button for adding additional items.
     */
    add: "Add",
    /**
     * Shown when a button to remove items is visible.
     */
    remove: "Remove",
    /**
     * Shown when there are multiple items to remove at the same time.
     */
    removeAll: "Remove all",
    /**
     * Shown when all fields are not filled out correctly.
     */
    incomplete: "Sorry, not all fields are filled out correctly.",
    /**
     * Shown in a button inside a form to submit the form.
     */
    submit: "Submit",
    /**
     * Shown when no files are selected.
     */
    noFiles: "No file chosen",
    /**
     * Shown on buttons that move fields up in a list.
     */
    moveUp: "Move up",
    /**
     * Shown on buttons that move fields down in a list.
     */
    moveDown: "Move down",
    /**
     * Shown when something is actively loading.
     */
    isLoading: "Loading...",
    /**
     * Shown when there is more to load.
     */
    loadMore: "Load more",
    /**
     * Show on buttons that navigate state forward
     */
    next: "Next",
    /**
     * Show on buttons that navigate state backward
     */
    prev: "Previous",
    /**
     * Shown when adding all values.
     */
    addAllValues: "Add all values",
    /**
     * Shown when adding selected values.
     */
    addSelectedValues: "Add selected values",
    /**
     * Shown when removing all values.
     */
    removeAllValues: "Remove all values",
    /**
     * Shown when removing selected values.
     */
    removeSelectedValues: "Remove selected values",
    /**
     * Shown when there is a date to choose.
     */
    chooseDate: "Choose date",
    /**
     * Shown when there is a date to change.
     */
    changeDate: "Change date",
    /**
     * Shown above error summaries when someone attempts to submit a form with
     * errors and the developer has implemented `<FormKitSummary />`.
     */
    summaryHeader: "There were errors in your form.",
    /*
     * Shown when there is something to close
     */
    close: "Close",
    /**
     * Shown when there is something to open.
     */
    open: "Open"
  };
  var validation10 = {
    /**
     * The value is not an accepted value.
     * @see {@link https://formkit.com/essentials/validation#accepted}
     */
    accepted({ name }) {
      return `Please accept the ${name}.`;
    },
    /**
     * The date is not after
     * @see {@link https://formkit.com/essentials/validation#date-after}
     */
    date_after({ name, args }) {
      if (Array.isArray(args) && args.length) {
        return `${sentence(name)} must be after ${date2(args[0])}.`;
      }
      return `${sentence(name)} must be in the future.`;
    },
    /**
     * The value is not a letter.
     * @see {@link https://formkit.com/essentials/validation#alpha}
     */
    alpha({ name }) {
      return `${sentence(name)} can only contain alphabetical characters.`;
    },
    /**
     * The value is not alphanumeric
     * @see {@link https://formkit.com/essentials/validation#alphanumeric}
     */
    alphanumeric({ name }) {
      return `${sentence(name)} can only contain letters and numbers.`;
    },
    /**
     * The value is not letter and/or spaces
     * @see {@link https://formkit.com/essentials/validation#alpha-spaces}
     */
    alpha_spaces({ name }) {
      return `${sentence(name)} can only contain letters and spaces.`;
    },
    /**
     * The value have no letter.
     * @see {@link https://formkit.com/essentials/validation#contains_alpha}
     */
    contains_alpha({ name }) {
      return `${sentence(name)} must contain alphabetical characters.`;
    },
    /**
     * The value have no alphanumeric
     * @see {@link https://formkit.com/essentials/validation#contains_alphanumeric}
     */
    contains_alphanumeric({ name }) {
      return `${sentence(name)} must contain letters or numbers.`;
    },
    /**
     * The value have no letter and/or spaces
     * @see {@link https://formkit.com/essentials/validation#contains_alpha-spaces}
     */
    contains_alpha_spaces({ name }) {
      return `${sentence(name)} must contain letters or spaces.`;
    },
    /**
     * The value have no symbol
     * @see {@link https://formkit.com/essentials/validation#contains_symbol}
     */
    contains_symbol({ name }) {
      return `${sentence(name)} must contain a symbol.`;
    },
    /**
     * The value have no uppercase
     * @see {@link https://formkit.com/essentials/validation#contains_uppercase}
     */
    contains_uppercase({ name }) {
      return `${sentence(name)} must contain an uppercase letter.`;
    },
    /**
     * The value have no lowercase
     * @see {@link https://formkit.com/essentials/validation#contains_lowercase}
     */
    contains_lowercase({ name }) {
      return `${sentence(name)} must contain a lowercase letter.`;
    },
    /**
     *  The value have no numeric
     * @see {@link https://formkit.com/essentials/validation#contains_numeric}
     */
    contains_numeric({ name }) {
      return `${sentence(name)} must contain numbers.`;
    },
    /**
     * The value is not symbol
     * @see {@link https://formkit.com/essentials/validation#symbol}
     */
    symbol({ name }) {
      return `${sentence(name)} must be a symbol.`;
    },
    /**
     * The value is not uppercase
     * @see {@link https://formkit.com/essentials/validation#uppercase}
     */
    uppercase({ name }) {
      return `${sentence(name)} can only contain uppercase letters.`;
    },
    /**
     * The value is not lowercase
     * @see {@link https://formkit.com/essentials/validation#lowercase}
     */
    lowercase({ name, args }) {
      let postfix = "";
      if (Array.isArray(args) && args.length) {
        if (args[0] === "allow_non_alpha")
          postfix = ", numbers and symbols";
        if (args[0] === "allow_numeric")
          postfix = " and numbers";
        if (args[0] === "allow_numeric_dashes")
          postfix = ", numbers and dashes";
      }
      return `${sentence(name)} can only contain lowercase letters${postfix}.`;
    },
    /**
     * The date is not before
     * @see {@link https://formkit.com/essentials/validation#date-before}
     */
    date_before({ name, args }) {
      if (Array.isArray(args) && args.length) {
        return `${sentence(name)} must be before ${date2(args[0])}.`;
      }
      return `${sentence(name)} must be in the past.`;
    },
    /**
     * The value is not between two numbers
     * @see {@link https://formkit.com/essentials/validation#between}
     */
    between({ name, args }) {
      if (isNaN(args[0]) || isNaN(args[1])) {
        return `This field was configured incorrectly and can\u2019t be submitted.`;
      }
      const [a, b] = order(args[0], args[1]);
      return `${sentence(name)} must be between ${a} and ${b}.`;
    },
    /**
     * The confirmation field does not match
     * @see {@link https://formkit.com/essentials/validation#confirm}
     */
    confirm({ name }) {
      return `${sentence(name)} does not match.`;
    },
    /**
     * The value is not a valid date
     * @see {@link https://formkit.com/essentials/validation#date-format}
     */
    date_format({ name, args }) {
      if (Array.isArray(args) && args.length) {
        return `${sentence(name)} is not a valid date, please use the format ${args[0]}`;
      }
      return "This field was configured incorrectly and can\u2019t be submitted";
    },
    /**
     * Is not within expected date range
     * @see {@link https://formkit.com/essentials/validation#date-between}
     */
    date_between({ name, args }) {
      return `${sentence(name)} must be between ${date2(args[0])} and ${date2(args[1])}`;
    },
    /**
     * Shown when the user-provided value is not a valid email address.
     * @see {@link https://formkit.com/essentials/validation#email}
     */
    email: "Please enter a valid email address.",
    /**
     * Does not end with the specified value
     * @see {@link https://formkit.com/essentials/validation#ends-with}
     */
    ends_with({ name, args }) {
      return `${sentence(name)} doesn\u2019t end with ${list(args)}.`;
    },
    /**
     * Is not an allowed value
     * @see {@link https://formkit.com/essentials/validation#is}
     */
    is({ name }) {
      return `${sentence(name)} is not an allowed value.`;
    },
    /**
     * Does not match specified length
     * @see {@link https://formkit.com/essentials/validation#length}
     */
    length({ name, args: [first = 0, second = Infinity] }) {
      const min3 = Number(first) <= Number(second) ? first : second;
      const max3 = Number(second) >= Number(first) ? second : first;
      if (min3 == 1 && max3 === Infinity) {
        return `${sentence(name)} must be at least one character.`;
      }
      if (min3 == 0 && max3) {
        return `${sentence(name)} must be less than or equal to ${max3} characters.`;
      }
      if (min3 === max3) {
        return `${sentence(name)} should be ${max3} characters long.`;
      }
      if (min3 && max3 === Infinity) {
        return `${sentence(name)} must be greater than or equal to ${min3} characters.`;
      }
      return `${sentence(name)} must be between ${min3} and ${max3} characters.`;
    },
    /**
     * Value is not a match
     * @see {@link https://formkit.com/essentials/validation#matches}
     */
    matches({ name }) {
      return `${sentence(name)} is not an allowed value.`;
    },
    /**
     * Exceeds maximum allowed value
     * @see {@link https://formkit.com/essentials/validation#max}
     */
    max({ name, node: { value }, args }) {
      if (Array.isArray(value)) {
        return `Cannot have more than ${args[0]} ${name}.`;
      }
      return `${sentence(name)} must be no more than ${args[0]}.`;
    },
    /**
     * The (field-level) value does not match specified mime type
     * @see {@link https://formkit.com/essentials/validation#mime}
     */
    mime({ name, args }) {
      if (!args[0]) {
        return "No file formats allowed.";
      }
      return `${sentence(name)} must be of the type: ${args[0]}`;
    },
    /**
     * Does not fulfill minimum allowed value
     * @see {@link https://formkit.com/essentials/validation#min}
     */
    min({ name, node: { value }, args }) {
      if (Array.isArray(value)) {
        return `Cannot have fewer than ${args[0]} ${name}.`;
      }
      return `${sentence(name)} must be at least ${args[0]}.`;
    },
    /**
     * Is not an allowed value
     * @see {@link https://formkit.com/essentials/validation#not}
     */
    not({ name, node: { value } }) {
      return `\u201C${value}\u201D is not an allowed ${name}.`;
    },
    /**
     *  Is not a number
     * @see {@link https://formkit.com/essentials/validation#number}
     */
    number({ name }) {
      return `${sentence(name)} must be a number.`;
    },
    /**
     * Require one field.
     * @see {@link https://formkit.com/essentials/validation#require-one}
     */
    require_one: ({ name, node, args: inputNames }) => {
      const labels = inputNames.map((name2) => {
        const dependentNode = node.at(name2);
        if (dependentNode) {
          return createMessageName(dependentNode);
        }
        return false;
      }).filter((name2) => !!name2);
      labels.unshift(name);
      return `${labels.join(" or ")} is required.`;
    },
    /**
     * Required field.
     * @see {@link https://formkit.com/essentials/validation#required}
     */
    required({ name }) {
      return `${sentence(name)} is required.`;
    },
    /**
     * Does not start with specified value
     * @see {@link https://formkit.com/essentials/validation#starts-with}
     */
    starts_with({ name, args }) {
      return `${sentence(name)} doesn\u2019t start with ${list(args)}.`;
    },
    /**
     * Is not a url
     * @see {@link https://formkit.com/essentials/validation#url}
     */
    url() {
      return `Please enter a valid URL.`;
    },
    /**
     * Shown when the date is invalid.
     */
    invalidDate: "The selected date is invalid."
  };
  var en = { ui: ui10, validation: validation10 };
  var i18nNodes = /* @__PURE__ */ new Set();
  var activeLocale = null;
  function createI18nPlugin(registry2) {
    return function i18nPlugin(node) {
      i18nNodes.add(node);
      if (activeLocale)
        node.config.locale = activeLocale;
      node.on("destroying", () => i18nNodes.delete(node));
      let localeKey = parseLocale(node.config.locale, registry2);
      let locale = localeKey ? registry2[localeKey] : {};
      node.on("prop:locale", ({ payload: lang }) => {
        localeKey = parseLocale(lang, registry2);
        locale = localeKey ? registry2[localeKey] : {};
        node.store.touch();
      });
      node.on("prop:label", () => node.store.touch());
      node.on("prop:validationLabel", () => node.store.touch());
      node.hook.text((fragment2, next) => {
        const key = fragment2.meta?.messageKey || fragment2.key;
        if (has(locale, fragment2.type) && has(locale[fragment2.type], key)) {
          const t = locale[fragment2.type][key];
          if (typeof t === "function") {
            fragment2.value = Array.isArray(fragment2.meta?.i18nArgs) ? t(...fragment2.meta.i18nArgs) : t(fragment2);
          } else {
            fragment2.value = t;
          }
        }
        return next(fragment2);
      });
    };
  }
  function parseLocale(locale, availableLocales) {
    if (has(availableLocales, locale)) {
      return locale;
    }
    const [lang] = locale.split("-");
    if (has(availableLocales, lang)) {
      return lang;
    }
    for (const locale2 in availableLocales) {
      return locale2;
    }
    return false;
  }

  // node_modules/@formkit/inputs/dist/index.mjs
  function createLibraryPlugin(...libraries) {
    const library = libraries.reduce(
      (merged, lib) => extend2(merged, lib),
      {}
    );
    const plugin2 = () => {
    };
    plugin2.library = function(node) {
      const type = camel(node.props.type);
      if (has(library, type)) {
        node.define(library[type]);
      }
    };
    return plugin2;
  }
  var runtimeProps = [
    "classes",
    "config",
    "delay",
    "errors",
    "id",
    "index",
    "inputErrors",
    "library",
    "modelValue",
    "onUpdate:modelValue",
    "name",
    "number",
    "parent",
    "plugins",
    "sectionsSchema",
    "type",
    "validation",
    "validationLabel",
    "validationMessages",
    "validationRules",
    // Runtime event props:
    "onInput",
    "onInputRaw",
    "onUpdate:modelValue",
    "onNode",
    "onSubmit",
    "onSubmitInvalid",
    "onSubmitRaw"
  ];
  function isGroupOption(option2) {
    return option2 && typeof option2 === "object" && "group" in option2 && Array.isArray(option2.options);
  }
  function normalizeOptions(options22, i = { count: 1 }) {
    if (Array.isArray(options22)) {
      return options22.map(
        (option2) => {
          if (typeof option2 === "string" || typeof option2 === "number") {
            return {
              label: String(option2),
              value: String(option2)
            };
          }
          if (typeof option2 == "object") {
            if ("group" in option2) {
              option2.options = normalizeOptions(option2.options || [], i);
              return option2;
            } else if ("value" in option2 && typeof option2.value !== "string") {
              Object.assign(option2, {
                value: `__mask_${i.count++}`,
                __original: option2.value
              });
            }
          }
          return option2;
        }
      );
    }
    return Object.keys(options22).map((value) => {
      return {
        label: options22[value],
        value
      };
    });
  }
  function optionValue(options22, value, undefinedIfNotFound = false) {
    if (Array.isArray(options22)) {
      for (const option2 of options22) {
        if (typeof option2 !== "object" && option2)
          continue;
        if (isGroupOption(option2)) {
          const found = optionValue(option2.options, value, true);
          if (found !== void 0) {
            return found;
          }
        } else if (value == option2.value) {
          return "__original" in option2 ? option2.__original : option2.value;
        }
      }
    }
    return undefinedIfNotFound ? void 0 : value;
  }
  function shouldSelect(valueA, valueB) {
    if (valueA === null && valueB === void 0 || valueA === void 0 && valueB === null)
      return false;
    if (valueA == valueB)
      return true;
    if (isPojo(valueA) && isPojo(valueB))
      return eq(valueA, valueB);
    return false;
  }
  function options(node) {
    node.hook.prop((prop, next) => {
      var _a;
      if (prop.prop === "options") {
        if (typeof prop.value === "function") {
          node.props.optionsLoader = prop.value;
          prop.value = [];
        } else {
          (_a = node.props)._normalizeCounter ?? (_a._normalizeCounter = { count: 1 });
          prop.value = normalizeOptions(prop.value, node.props._normalizeCounter);
        }
      }
      return next(prop);
    });
  }
  // @__NO_SIDE_EFFECTS__
  function createSection(section, el, fragment2 = false) {
    return (...children) => {
      const extendable = (extensions) => {
        const node = !el || typeof el === "string" ? { $el: el } : el();
        if (isDOM(node) || isComponent2(node)) {
          if (!node.meta) {
            node.meta = { section };
          } else {
            node.meta.section = section;
          }
          if (children.length && !node.children) {
            node.children = [
              ...children.map(
                (child) => typeof child === "function" ? child(extensions) : child
              )
            ];
          }
          if (isDOM(node)) {
            node.attrs = {
              class: `$classes.${section}`,
              ...node.attrs || {}
            };
          }
        }
        return {
          if: `$slots.${section}`,
          then: `$slots.${section}`,
          else: section in extensions ? /* @__PURE__ */ extendSchema(node, extensions[section]) : node
        };
      };
      extendable._s = section;
      return fragment2 ? /* @__PURE__ */ createRoot2(extendable) : extendable;
    };
  }
  // @__NO_SIDE_EFFECTS__
  function createRoot2(rootSection) {
    return (extensions) => {
      return [rootSection(extensions)];
    };
  }
  function isSchemaObject(schema) {
    return !!(schema && typeof schema === "object" && ("$el" in schema || "$cmp" in schema || "$formkit" in schema));
  }
  // @__NO_SIDE_EFFECTS__
  function extendSchema(schema, extension = {}) {
    if (typeof schema === "string") {
      return isSchemaObject(extension) || typeof extension === "string" ? extension : schema;
    } else if (Array.isArray(schema)) {
      return isSchemaObject(extension) ? extension : schema;
    }
    return extend2(schema, extension);
  }
  var actions = /* @__PURE__ */ createSection("actions", () => ({
    $el: "div",
    if: "$actions"
  }));
  var box = /* @__PURE__ */ createSection("input", () => ({
    $el: "input",
    bind: "$attrs",
    attrs: {
      type: "$type",
      name: "$node.props.altName || $node.name",
      disabled: "$option.attrs.disabled || $disabled",
      onInput: "$handlers.toggleChecked",
      checked: "$fns.eq($_value, $onValue)",
      onBlur: "$handlers.blur",
      value: "$: true",
      id: "$id",
      "aria-describedby": {
        if: "$options.length",
        then: {
          if: "$option.help",
          then: '$: "help-" + $option.attrs.id',
          else: void 0
        },
        else: {
          if: "$help",
          then: '$: "help-" + $id',
          else: void 0
        }
      }
    }
  }));
  var boxHelp = /* @__PURE__ */ createSection("optionHelp", () => ({
    $el: "div",
    if: "$option.help",
    attrs: {
      id: '$: "help-" + $option.attrs.id'
    }
  }));
  var boxInner = /* @__PURE__ */ createSection("inner", "span");
  var boxLabel = /* @__PURE__ */ createSection("label", "span");
  var boxOption = /* @__PURE__ */ createSection("option", () => ({
    $el: "li",
    for: ["option", "$options"],
    attrs: {
      "data-disabled": "$option.attrs.disabled || $disabled || undefined"
    }
  }));
  var boxOptions = /* @__PURE__ */ createSection("options", "ul");
  var boxWrapper = /* @__PURE__ */ createSection("wrapper", () => ({
    $el: "label",
    attrs: {
      "data-disabled": {
        if: "$options.length",
        then: void 0,
        else: "$disabled || undefined"
      },
      "data-checked": {
        if: "$options == undefined",
        then: "$fns.eq($_value, $onValue) || undefined",
        else: "$fns.isChecked($option.value) || undefined"
      }
    }
  }));
  var buttonInput = /* @__PURE__ */ createSection("input", () => ({
    $el: "button",
    bind: "$attrs",
    attrs: {
      type: "$type",
      disabled: "$disabled",
      name: "$node.name",
      id: "$id"
    }
  }));
  var buttonLabel = /* @__PURE__ */ createSection("default", null);
  var decorator = /* @__PURE__ */ createSection("decorator", () => ({
    $el: "span",
    attrs: {
      "aria-hidden": "true"
    }
  }));
  var fieldset = /* @__PURE__ */ createSection("fieldset", () => ({
    $el: "fieldset",
    attrs: {
      id: "$id",
      "aria-describedby": {
        if: "$help",
        then: '$: "help-" + $id',
        else: void 0
      }
    }
  }));
  var fileInput = /* @__PURE__ */ createSection("input", () => ({
    $el: "input",
    bind: "$attrs",
    attrs: {
      type: "file",
      disabled: "$disabled",
      name: "$node.name",
      onChange: "$handlers.files",
      onBlur: "$handlers.blur",
      id: "$id",
      "aria-describedby": "$describedBy",
      "aria-required": "$state.required || undefined"
    }
  }));
  var fileItem = /* @__PURE__ */ createSection("fileItem", () => ({
    $el: "li",
    for: ["file", "$value"]
  }));
  var fileList = /* @__PURE__ */ createSection("fileList", () => ({
    $el: "ul",
    if: "$value.length",
    attrs: {
      "data-has-multiple": "$_hasMultipleFiles"
    }
  }));
  var fileName = /* @__PURE__ */ createSection("fileName", () => ({
    $el: "span",
    attrs: {
      class: "$classes.fileName"
    }
  }));
  var fileRemove = /* @__PURE__ */ createSection("fileRemove", () => ({
    $el: "button",
    attrs: {
      type: "button",
      onClick: "$handlers.resetFiles"
    }
  }));
  var formInput = /* @__PURE__ */ createSection("form", () => ({
    $el: "form",
    bind: "$attrs",
    meta: {
      autoAnimate: true
    },
    attrs: {
      id: "$id",
      name: "$node.name",
      onSubmit: "$handlers.submit",
      "data-loading": "$state.loading || undefined"
    }
  }));
  var fragment = /* @__PURE__ */ createSection("wrapper", null, true);
  var help = /* @__PURE__ */ createSection("help", () => ({
    $el: "div",
    if: "$help",
    attrs: {
      id: '$: "help-" + $id'
    }
  }));
  var icon = (sectionKey, el) => {
    return (/* @__PURE__ */ createSection(`${sectionKey}Icon`, () => {
      const rawIconProp = `_raw${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}Icon`;
      return {
        if: `$${sectionKey}Icon && $${rawIconProp}`,
        $el: `${el ? el : "span"}`,
        attrs: {
          class: `$classes.${sectionKey}Icon + " " + $classes.icon`,
          innerHTML: `$${rawIconProp}`,
          onClick: `$handlers.iconClick(${sectionKey})`,
          role: `$fns.iconRole(${sectionKey})`,
          tabindex: `$fns.iconRole(${sectionKey}) === "button" && "0" || undefined`,
          for: {
            if: `${el === "label"}`,
            then: "$id"
          }
        }
      };
    }))();
  };
  var inner = /* @__PURE__ */ createSection("inner", "div");
  var label = /* @__PURE__ */ createSection("label", () => ({
    $el: "label",
    if: "$label",
    attrs: {
      for: "$id"
    }
  }));
  var legend = /* @__PURE__ */ createSection("legend", () => ({
    $el: "legend",
    if: "$label"
  }));
  var message = /* @__PURE__ */ createSection("message", () => ({
    $el: "li",
    for: ["message", "$messages"],
    attrs: {
      key: "$message.key",
      id: `$id + '-' + $message.key`,
      "data-message-type": "$message.type"
    }
  }));
  var messages = /* @__PURE__ */ createSection("messages", () => ({
    $el: "ul",
    if: "$defaultMessagePlacement && $fns.length($messages)"
  }));
  var noFiles = /* @__PURE__ */ createSection("noFiles", () => ({
    $el: "span",
    if: "$value == null || $value.length == 0"
  }));
  var optGroup = /* @__PURE__ */ createSection("optGroup", () => ({
    $el: "optgroup",
    bind: "$option.attrs",
    attrs: {
      label: "$option.group"
    }
  }));
  var option = /* @__PURE__ */ createSection("option", () => ({
    $el: "option",
    bind: "$option.attrs",
    attrs: {
      class: "$classes.option",
      value: "$option.value",
      selected: "$fns.isSelected($option)"
    }
  }));
  var optionSlot = /* @__PURE__ */ createSection("options", () => ({
    $el: null,
    if: "$options.length",
    for: ["option", "$option.options || $options"]
  }));
  var outer = /* @__PURE__ */ createSection("outer", () => ({
    $el: "div",
    meta: {
      autoAnimate: true
    },
    attrs: {
      key: "$id",
      "data-family": "$family || undefined",
      "data-type": "$type",
      "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
      "data-has-multiple": "$_hasMultipleFiles",
      "data-disabled": '$: ($disabled !== "false" && $disabled) || undefined',
      "data-empty": "$state.empty || undefined",
      "data-complete": "$state.complete || undefined",
      "data-invalid": "$state.invalid || undefined",
      "data-errors": "$state.errors || undefined",
      "data-submitted": "$state.submitted || undefined",
      "data-prefix-icon": "$_rawPrefixIcon !== undefined || undefined",
      "data-suffix-icon": "$_rawSuffixIcon !== undefined || undefined",
      "data-prefix-icon-click": "$onPrefixIconClick !== undefined || undefined",
      "data-suffix-icon-click": "$onSuffixIconClick !== undefined || undefined"
    }
  }));
  var prefix = /* @__PURE__ */ createSection("prefix", null);
  var selectInput = /* @__PURE__ */ createSection("input", () => ({
    $el: "select",
    bind: "$attrs",
    attrs: {
      id: "$id",
      "data-placeholder": "$fns.showPlaceholder($_value, $placeholder)",
      disabled: "$disabled",
      class: "$classes.input",
      name: "$node.name",
      onChange: "$handlers.onChange",
      onInput: "$handlers.selectInput",
      onBlur: "$handlers.blur",
      "aria-describedby": "$describedBy",
      "aria-required": "$state.required || undefined"
    }
  }));
  var submitInput = /* @__PURE__ */ createSection("submit", () => ({
    $cmp: "FormKit",
    bind: "$submitAttrs",
    props: {
      type: "submit",
      label: "$submitLabel"
    }
  }));
  var suffix = /* @__PURE__ */ createSection("suffix", null);
  var textInput = /* @__PURE__ */ createSection("input", () => ({
    $el: "input",
    bind: "$attrs",
    attrs: {
      type: "$type",
      disabled: "$disabled",
      name: "$node.name",
      onInput: "$handlers.DOMInput",
      onBlur: "$handlers.blur",
      value: "$_value",
      id: "$id",
      "aria-describedby": "$describedBy",
      "aria-required": "$state.required || undefined"
    }
  }));
  var textareaInput = /* @__PURE__ */ createSection("input", () => ({
    $el: "textarea",
    bind: "$attrs",
    attrs: {
      disabled: "$disabled",
      name: "$node.name",
      onInput: "$handlers.DOMInput",
      onBlur: "$handlers.blur",
      value: "$_value",
      id: "$id",
      "aria-describedby": "$describedBy",
      "aria-required": "$state.required || undefined"
    },
    children: "$initialValue"
  }));
  var wrapper = /* @__PURE__ */ createSection("wrapper", "div");
  var radioInstance = 0;
  function renamesRadios(node) {
    if (node.type === "group" || node.type === "list") {
      node.plugins.add(renamesRadiosPlugin);
    }
  }
  function renamesRadiosPlugin(node) {
    if (node.props.type === "radio") {
      node.addProps(["altName"]);
      node.props.altName = `${node.name}_${radioInstance++}`;
    }
  }
  function normalizeBoxes(node) {
    return function(prop, next) {
      if (prop.prop === "options" && Array.isArray(prop.value)) {
        prop.value = prop.value.map((option2) => {
          if (!option2.attrs?.id) {
            return extend2(option2, {
              attrs: {
                id: `${node.props.id}-option-${slugify(String(option2.value))}`
              }
            });
          }
          return option2;
        });
        if (node.props.type === "checkbox" && !Array.isArray(node.value)) {
          if (node.isCreated) {
            node.input([], false);
          } else {
            node.on("created", () => {
              if (!Array.isArray(node.value)) {
                node.input([], false);
              }
            });
          }
        }
      }
      return next(prop);
    };
  }
  function toggleChecked(node, e) {
    const el = e.target;
    if (el instanceof HTMLInputElement) {
      const value = Array.isArray(node.props.options) ? optionValue(node.props.options, el.value) : el.value;
      if (Array.isArray(node.props.options) && node.props.options.length) {
        if (!Array.isArray(node._value)) {
          node.input([value]);
        } else if (!node._value.some((existingValue) => shouldSelect(value, existingValue))) {
          node.input([...node._value, value]);
        } else {
          node.input(
            node._value.filter(
              (existingValue) => !shouldSelect(value, existingValue)
            )
          );
        }
      } else {
        if (el.checked) {
          node.input(node.props.onValue);
        } else {
          node.input(node.props.offValue);
        }
      }
    }
  }
  function isChecked(node, value) {
    node.context?.value;
    node.context?._value;
    if (Array.isArray(node._value)) {
      return node._value.some(
        (existingValue) => shouldSelect(optionValue(node.props.options, value), existingValue)
      );
    }
    return false;
  }
  function checkboxes(node) {
    node.on("created", () => {
      if (node.context?.handlers) {
        node.context.handlers.toggleChecked = toggleChecked.bind(null, node);
      }
      if (node.context?.fns) {
        node.context.fns.isChecked = isChecked.bind(null, node);
      }
      if (!has(node.props, "onValue"))
        node.props.onValue = true;
      if (!has(node.props, "offValue"))
        node.props.offValue = false;
    });
    node.hook.prop(normalizeBoxes(node));
  }
  function defaultIcon(sectionKey, defaultIcon2) {
    return (node) => {
      if (node.props[`${sectionKey}Icon`] === void 0) {
        node.props[`${sectionKey}Icon`] = defaultIcon2.startsWith("<svg") ? defaultIcon2 : `default:${defaultIcon2}`;
      }
    };
  }
  function disables(node) {
    node.on("created", () => {
      if ("disabled" in node.props) {
        node.props.disabled = undefine(node.props.disabled);
        node.config.disabled = undefine(node.props.disabled);
      }
    });
    node.hook.prop(({ prop, value }, next) => {
      value = prop === "disabled" ? undefine(value) : value;
      return next({ prop, value });
    });
    node.on("prop:disabled", ({ payload: value }) => {
      node.config.disabled = undefine(value);
    });
  }
  function localize(key, value) {
    return (node) => {
      node.store.set(
        /* @__PURE__ */ createMessage({
          key,
          type: "ui",
          value: value || key,
          meta: {
            localize: true,
            i18nArgs: [node]
          }
        })
      );
    };
  }
  var isBrowser2 = typeof window !== "undefined";
  function removeHover(e) {
    if (e.target instanceof HTMLElement && e.target.hasAttribute("data-file-hover")) {
      e.target.removeAttribute("data-file-hover");
    }
  }
  function preventStrayDrop(type, e) {
    if (!(e.target instanceof HTMLInputElement)) {
      e.preventDefault();
    } else if (type === "dragover") {
      e.target.setAttribute("data-file-hover", "true");
    }
    if (type === "drop") {
      removeHover(e);
    }
  }
  function files(node) {
    localize("noFiles", "Select file")(node);
    localize("removeAll", "Remove all")(node);
    localize("remove")(node);
    node.addProps(["_hasMultipleFiles"]);
    if (isBrowser2) {
      if (!window._FormKit_File_Drop) {
        window.addEventListener(
          "dragover",
          preventStrayDrop.bind(null, "dragover")
        );
        window.addEventListener("drop", preventStrayDrop.bind(null, "drop"));
        window.addEventListener("dragleave", removeHover);
        window._FormKit_File_Drop = true;
      }
    }
    node.hook.input((value, next) => next(Array.isArray(value) ? value : []));
    node.on("input", ({ payload: value }) => {
      node.props._hasMultipleFiles = Array.isArray(value) && value.length > 1 ? true : void 0;
    });
    node.on("reset", () => {
      if (node.props.id && isBrowser2) {
        const el = document.getElementById(node.props.id);
        if (el)
          el.value = "";
      }
    });
    node.on("created", () => {
      if (!Array.isArray(node.value))
        node.input([], false);
      if (!node.context)
        return;
      node.context.handlers.resetFiles = (e) => {
        e.preventDefault();
        node.input([]);
        if (node.props.id && isBrowser2) {
          const el = document.getElementById(node.props.id);
          if (el)
            el.value = "";
          el?.focus();
        }
      };
      node.context.handlers.files = (e) => {
        const files2 = [];
        if (e.target instanceof HTMLInputElement && e.target.files) {
          for (let i = 0; i < e.target.files.length; i++) {
            let file2;
            if (file2 = e.target.files.item(i)) {
              files2.push({ name: file2.name, file: file2 });
            }
          }
          node.input(files2);
        }
        if (node.context)
          node.context.files = files2;
        if (typeof node.props.attrs?.onChange === "function") {
          node.props.attrs?.onChange(e);
        }
      };
    });
  }
  var loading = /* @__PURE__ */ createMessage({
    key: "loading",
    value: true,
    visible: false
  });
  async function handleSubmit(node, submitEvent) {
    const submitNonce = Math.random();
    node.props._submitNonce = submitNonce;
    submitEvent.preventDefault();
    await node.settled;
    if (node.ledger.value("validating")) {
      node.store.set(loading);
      await node.ledger.settled("validating");
      node.store.remove("loading");
      if (node.props._submitNonce !== submitNonce)
        return;
    }
    const setSubmitted = (n) => n.store.set(
      /* @__PURE__ */ createMessage({
        key: "submitted",
        value: true,
        visible: false
      })
    );
    node.walk(setSubmitted);
    setSubmitted(node);
    node.emit("submit-raw");
    if (typeof node.props.onSubmitRaw === "function") {
      node.props.onSubmitRaw(submitEvent, node);
    }
    if (node.ledger.value("blocking")) {
      if (typeof node.props.onSubmitInvalid === "function") {
        node.props.onSubmitInvalid(node);
      }
      if (node.props.incompleteMessage !== false) {
        setIncompleteMessage(node);
      }
    } else {
      if (typeof node.props.onSubmit === "function") {
        const retVal = node.props.onSubmit(
          node.hook.submit.dispatch(clone(node.value)),
          node
        );
        if (retVal instanceof Promise) {
          const autoDisable = node.props.disabled === void 0 && node.props.submitBehavior !== "live";
          if (autoDisable)
            node.props.disabled = true;
          node.store.set(loading);
          await retVal;
          if (autoDisable)
            node.props.disabled = false;
          node.store.remove("loading");
        }
      } else {
        if (submitEvent.target instanceof HTMLFormElement) {
          submitEvent.target.submit();
        }
      }
    }
  }
  function setIncompleteMessage(node) {
    node.store.set(
      /* @__PURE__ */ createMessage({
        blocking: false,
        key: `incomplete`,
        meta: {
          localize: node.props.incompleteMessage === void 0,
          i18nArgs: [{ node }],
          showAsMessage: true
        },
        type: "ui",
        value: node.props.incompleteMessage || "Form incomplete."
      })
    );
  }
  function form(node) {
    var _a;
    node.props.isForm = true;
    node.ledger.count("validating", (m) => m.key === "validating");
    (_a = node.props).submitAttrs ?? (_a.submitAttrs = {
      disabled: node.props.disabled
    });
    node.on("prop:disabled", ({ payload: disabled }) => {
      node.props.submitAttrs = { ...node.props.submitAttrs, disabled };
    });
    node.on("created", () => {
      if (node.context?.handlers) {
        node.context.handlers.submit = handleSubmit.bind(null, node);
      }
      if (!has(node.props, "actions")) {
        node.props.actions = true;
      }
    });
    node.on("prop:incompleteMessage", () => {
      if (node.store.incomplete)
        setIncompleteMessage(node);
    });
    node.on("settled:blocking", () => node.store.remove("incomplete"));
  }
  function ignore(node) {
    if (node.props.ignore === void 0) {
      node.props.ignore = true;
      node.parent = null;
    }
  }
  function initialValue(node) {
    node.on("created", () => {
      if (node.context) {
        node.context.initialValue = node.value || "";
      }
    });
  }
  function casts(node) {
    if (typeof node.props.number === "undefined")
      return;
    const strict = ["number", "range", "hidden"].includes(node.props.type);
    node.hook.input((value, next) => {
      if (value === "")
        return next(void 0);
      const numericValue = node.props.number === "integer" ? parseInt(value) : parseFloat(value);
      if (!Number.isFinite(numericValue))
        return strict ? next(void 0) : next(value);
      return next(numericValue);
    });
  }
  function toggleChecked2(node, event) {
    if (event.target instanceof HTMLInputElement) {
      node.input(optionValue(node.props.options, event.target.value));
    }
  }
  function isChecked2(node, value) {
    node.context?.value;
    node.context?._value;
    return shouldSelect(optionValue(node.props.options, value), node._value);
  }
  function radios(node) {
    node.on("created", () => {
      if (!Array.isArray(node.props.options)) {
        warn3(350, {
          node,
          inputType: "radio"
        });
      }
      if (node.context?.handlers) {
        node.context.handlers.toggleChecked = toggleChecked2.bind(null, node);
      }
      if (node.context?.fns) {
        node.context.fns.isChecked = isChecked2.bind(null, node);
      }
    });
    node.hook.prop(normalizeBoxes(node));
  }
  function isSelected(node, option2) {
    if (isGroupOption(option2))
      return false;
    node.context && node.context.value;
    const optionValue2 = "__original" in option2 ? option2.__original : option2.value;
    return Array.isArray(node._value) ? node._value.some((optionA) => shouldSelect(optionA, optionValue2)) : (node._value === void 0 || node._value === null && !containsValue(node.props.options, null)) && option2.attrs && option2.attrs["data-is-placeholder"] ? true : shouldSelect(optionValue2, node._value);
  }
  function containsValue(options22, value) {
    return options22.some((option2) => {
      if (isGroupOption(option2)) {
        return containsValue(option2.options, value);
      } else {
        return ("__original" in option2 ? option2.__original : option2.value) === value;
      }
    });
  }
  async function deferChange(node, e) {
    if (typeof node.props.attrs?.onChange === "function") {
      await new Promise((r) => setTimeout(r, 0));
      await node.settled;
      node.props.attrs.onChange(e);
    }
  }
  function selectInput2(node, e) {
    const target2 = e.target;
    const value = target2.hasAttribute("multiple") ? Array.from(target2.selectedOptions).map(
      (o) => optionValue(node.props.options, o.value)
    ) : optionValue(node.props.options, target2.value);
    node.input(value);
  }
  function applyPlaceholder(options22, placeholder) {
    if (!options22.some(
      (option2) => option2.attrs && option2.attrs["data-is-placeholder"]
    )) {
      return [
        {
          label: placeholder,
          value: "",
          attrs: {
            hidden: true,
            disabled: true,
            "data-is-placeholder": "true"
          }
        },
        ...options22
      ];
    }
    return options22;
  }
  function firstValue(options22) {
    const option2 = options22.length > 0 ? options22[0] : void 0;
    if (!option2)
      return void 0;
    if (isGroupOption(option2))
      return firstValue(option2.options);
    return "__original" in option2 ? option2.__original : option2.value;
  }
  function select2(node) {
    node.on("created", () => {
      const isMultiple = undefine(node.props.attrs?.multiple);
      if (!isMultiple && node.props.placeholder && Array.isArray(node.props.options)) {
        node.hook.prop(({ prop, value }, next) => {
          if (prop === "options") {
            value = applyPlaceholder(value, node.props.placeholder);
          }
          return next({ prop, value });
        });
        node.props.options = applyPlaceholder(
          node.props.options,
          node.props.placeholder
        );
      }
      if (isMultiple) {
        if (node.value === void 0) {
          node.input([], false);
        }
      } else if (node.context && !node.context.options) {
        node.props.attrs = Object.assign({}, node.props.attrs, {
          value: node._value
        });
        node.on("input", ({ payload }) => {
          node.props.attrs = Object.assign({}, node.props.attrs, {
            value: payload
          });
        });
      }
      if (node.context?.handlers) {
        node.context.handlers.selectInput = selectInput2.bind(null, node);
        node.context.handlers.onChange = deferChange.bind(null, node);
      }
      if (node.context?.fns) {
        node.context.fns.isSelected = isSelected.bind(null, node);
        node.context.fns.showPlaceholder = (value, placeholder) => {
          if (!Array.isArray(node.props.options))
            return false;
          const hasMatchingValue = node.props.options.some(
            (option2) => {
              if (option2.attrs && "data-is-placeholder" in option2.attrs)
                return false;
              const optionValue2 = "__original" in option2 ? option2.__original : option2.value;
              return eq(value, optionValue2);
            }
          );
          return placeholder && !hasMatchingValue ? true : void 0;
        };
      }
    });
    node.hook.input((value, next) => {
      if (!node.props.placeholder && value === void 0 && Array.isArray(node.props?.options) && node.props.options.length && !undefine(node.props?.attrs?.multiple)) {
        value = firstValue(node.props.options);
      }
      return next(value);
    });
  }
  // @__NO_SIDE_EFFECTS__
  function isSlotCondition(node) {
    if (isConditional(node) && node.if && node.if.startsWith("$slots.") && typeof node.then === "string" && node.then.startsWith("$slots.") && "else" in node) {
      return true;
    }
    return false;
  }
  // @__NO_SIDE_EFFECTS__
  function $if(condition, then, otherwise) {
    const extendable = (extensions) => {
      const node = then(extensions);
      if (otherwise || isSchemaObject(node) && "if" in node || /* @__PURE__ */ isSlotCondition(node)) {
        const conditionalNode = {
          if: condition,
          then: node
        };
        if (otherwise) {
          conditionalNode.else = otherwise(extensions);
        }
        return conditionalNode;
      } else if (/* @__PURE__ */ isSlotCondition(node)) {
        Object.assign(node.else, { if: condition });
      } else if (isSchemaObject(node)) {
        Object.assign(node, { if: condition });
      }
      return node;
    };
    extendable._s = token();
    return extendable;
  }
  // @__NO_SIDE_EFFECTS__
  function $extend(section, extendWith) {
    const extendable = (extensions) => {
      const node = section({});
      if (/* @__PURE__ */ isSlotCondition(node)) {
        if (Array.isArray(node.else))
          return node;
        node.else = /* @__PURE__ */ extendSchema(
          /* @__PURE__ */ extendSchema(node.else, extendWith),
          section._s ? extensions[section._s] : {}
        );
        return node;
      }
      return /* @__PURE__ */ extendSchema(
        /* @__PURE__ */ extendSchema(node, extendWith),
        section._s ? extensions[section._s] : {}
      );
    };
    extendable._s = section._s;
    return extendable;
  }
  var button = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ outer(
      /* @__PURE__ */ messages(/* @__PURE__ */ message("$message.value")),
      /* @__PURE__ */ wrapper(
        /* @__PURE__ */ buttonInput(
          /* @__PURE__ */ icon("prefix"),
          /* @__PURE__ */ prefix(),
          /* @__PURE__ */ buttonLabel("$label || $ui.submit.value"),
          /* @__PURE__ */ suffix(),
          /* @__PURE__ */ icon("suffix")
        )
      ),
      /* @__PURE__ */ help("$help")
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "input",
    /**
     * The family of inputs this one belongs too. For example "text" and "email"
     * are both part of the "text" family. This is primary used for styling.
     */
    family: "button",
    /**
     * An array of extra props to accept for this input.
     */
    props: [],
    /**
     * Additional features that should be added to your input
     */
    features: [localize("submit"), ignore],
    /**
     * A key to use for memoizing the schema. This is used to prevent the schema
     * from needing to be stringified when performing a memo lookup.
     */
    schemaMemoKey: "h6st4epl3j8"
  };
  var checkbox = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ outer(
      /* @__PURE__ */ $if(
        "$options == undefined",
        /**
         * Single checkbox structure.
         */
        /* @__PURE__ */ boxWrapper(
          /* @__PURE__ */ boxInner(/* @__PURE__ */ prefix(), /* @__PURE__ */ box(), /* @__PURE__ */ decorator(/* @__PURE__ */ icon("decorator")), /* @__PURE__ */ suffix()),
          /* @__PURE__ */ $extend(/* @__PURE__ */ boxLabel("$label"), {
            if: "$label"
          })
        ),
        /**
         * Multi checkbox structure.
         */
        /* @__PURE__ */ fieldset(
          /* @__PURE__ */ legend("$label"),
          /* @__PURE__ */ help("$help"),
          /* @__PURE__ */ boxOptions(
            /* @__PURE__ */ boxOption(
              /* @__PURE__ */ boxWrapper(
                /* @__PURE__ */ boxInner(
                  /* @__PURE__ */ prefix(),
                  /* @__PURE__ */ $extend(/* @__PURE__ */ box(), {
                    bind: "$option.attrs",
                    attrs: {
                      id: "$option.attrs.id",
                      value: "$option.value",
                      checked: "$fns.isChecked($option.value)"
                    }
                  }),
                  /* @__PURE__ */ decorator(/* @__PURE__ */ icon("decorator")),
                  /* @__PURE__ */ suffix()
                ),
                /* @__PURE__ */ $extend(/* @__PURE__ */ boxLabel("$option.label"), {
                  if: "$option.label"
                })
              ),
              /* @__PURE__ */ boxHelp("$option.help")
            )
          )
        )
      ),
      // Help text only goes under the input when it is a single.
      /* @__PURE__ */ $if("$options == undefined && $help", /* @__PURE__ */ help("$help")),
      /* @__PURE__ */ messages(/* @__PURE__ */ message("$message.value"))
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "input",
    /**
     * The family of inputs this one belongs too. For example "text" and "email"
     * are both part of the "text" family. This is primary used for styling.
     */
    family: "box",
    /**
     * An array of extra props to accept for this input.
     */
    props: ["options", "onValue", "offValue", "optionsLoader"],
    /**
     * Additional features that should be added to your input
     */
    features: [
      options,
      checkboxes,
      defaultIcon("decorator", "checkboxDecorator")
    ],
    /**
     * The key used to memoize the schema.
     */
    schemaMemoKey: "qje02tb3gu8"
  };
  var file = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ outer(
      /* @__PURE__ */ wrapper(
        /* @__PURE__ */ label("$label"),
        /* @__PURE__ */ inner(
          /* @__PURE__ */ icon("prefix", "label"),
          /* @__PURE__ */ prefix(),
          /* @__PURE__ */ fileInput(),
          /* @__PURE__ */ fileList(
            /* @__PURE__ */ fileItem(
              /* @__PURE__ */ icon("fileItem"),
              /* @__PURE__ */ fileName("$file.name"),
              /* @__PURE__ */ $if(
                "$value.length === 1",
                /* @__PURE__ */ fileRemove(
                  /* @__PURE__ */ icon("fileRemove"),
                  '$ui.remove.value + " " + $file.name'
                )
              )
            )
          ),
          /* @__PURE__ */ $if("$value.length > 1", /* @__PURE__ */ fileRemove("$ui.removeAll.value")),
          /* @__PURE__ */ noFiles(/* @__PURE__ */ icon("noFiles"), "$ui.noFiles.value"),
          /* @__PURE__ */ suffix(),
          /* @__PURE__ */ icon("suffix")
        )
      ),
      /* @__PURE__ */ help("$help"),
      /* @__PURE__ */ messages(/* @__PURE__ */ message("$message.value"))
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "input",
    /**
     * The family of inputs this one belongs too. For example "text" and "email"
     * are both part of the "text" family. This is primary used for styling.
     */
    family: "text",
    /**
     * An array of extra props to accept for this input.
     */
    props: [],
    /**
     * Additional features that should be added to your input
     */
    features: [
      files,
      defaultIcon("fileItem", "fileItem"),
      defaultIcon("fileRemove", "fileRemove"),
      defaultIcon("noFiles", "noFiles")
    ],
    /**
     * The key used to memoize the schema.
     */
    schemaMemoKey: "9kqc4852fv8"
  };
  var form2 = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ formInput(
      "$slots.default",
      /* @__PURE__ */ messages(/* @__PURE__ */ message("$message.value")),
      /* @__PURE__ */ actions(/* @__PURE__ */ submitInput())
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "group",
    /**
     * An array of extra props to accept for this input.
     */
    props: [
      "actions",
      "submit",
      "submitLabel",
      "submitAttrs",
      "submitBehavior",
      "incompleteMessage"
    ],
    /**
     * Additional features that should be added to your input
     */
    features: [form, disables],
    /**
     * The key used to memoize the schema.
     */
    schemaMemoKey: "5bg016redjo"
  };
  var group = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ fragment("$slots.default"),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "group",
    /**
     * An array of extra props to accept for this input.
     */
    props: [],
    /**
     * Additional features that should be added to your input
     */
    features: [disables, renamesRadios]
  };
  var hidden = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ textInput(),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "input",
    /**
     * An array of extra props to accept for this input.
     */
    props: [],
    /**
     * Additional features that should be added to your input
     */
    features: [casts]
  };
  var list2 = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ fragment("$slots.default"),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "list",
    /**
     * An array of extra props to accept for this input.
     */
    props: ["sync", "dynamic"],
    /**
     * Additional features that should be added to your input
     */
    features: [disables, renamesRadios]
  };
  var meta = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ fragment(),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "input",
    /**
     * An array of extra props to accept for this input.
     */
    props: [],
    /**
     * Additional features that should be added to your input
     */
    features: []
  };
  var radio = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ outer(
      /* @__PURE__ */ $if(
        "$options == undefined",
        /**
         * Single radio structure.
         */
        /* @__PURE__ */ boxWrapper(
          /* @__PURE__ */ boxInner(/* @__PURE__ */ prefix(), /* @__PURE__ */ box(), /* @__PURE__ */ decorator(/* @__PURE__ */ icon("decorator")), /* @__PURE__ */ suffix()),
          /* @__PURE__ */ $extend(/* @__PURE__ */ boxLabel("$label"), {
            if: "$label"
          })
        ),
        /**
         * Multi radio structure.
         */
        /* @__PURE__ */ fieldset(
          /* @__PURE__ */ legend("$label"),
          /* @__PURE__ */ help("$help"),
          /* @__PURE__ */ boxOptions(
            /* @__PURE__ */ boxOption(
              /* @__PURE__ */ boxWrapper(
                /* @__PURE__ */ boxInner(
                  /* @__PURE__ */ prefix(),
                  /* @__PURE__ */ $extend(/* @__PURE__ */ box(), {
                    bind: "$option.attrs",
                    attrs: {
                      id: "$option.attrs.id",
                      value: "$option.value",
                      checked: "$fns.isChecked($option.value)"
                    }
                  }),
                  /* @__PURE__ */ decorator(/* @__PURE__ */ icon("decorator")),
                  /* @__PURE__ */ suffix()
                ),
                /* @__PURE__ */ $extend(/* @__PURE__ */ boxLabel("$option.label"), {
                  if: "$option.label"
                })
              ),
              /* @__PURE__ */ boxHelp("$option.help")
            )
          )
        )
      ),
      // Help text only goes under the input when it is a single.
      /* @__PURE__ */ $if("$options == undefined && $help", /* @__PURE__ */ help("$help")),
      /* @__PURE__ */ messages(/* @__PURE__ */ message("$message.value"))
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "input",
    /**
     * The family of inputs this one belongs too. For example "text" and "email"
     * are both part of the "text" family. This is primary used for styling.
     */
    family: "box",
    /**
     * An array of extra props to accept for this input.
     */
    props: ["options", "onValue", "offValue", "optionsLoader"],
    /**
     * Additional features that should be added to your input
     */
    features: [options, radios, defaultIcon("decorator", "radioDecorator")],
    /**
     * The key used to memoize the schema.
     */
    schemaMemoKey: "qje02tb3gu8"
  };
  var select22 = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ outer(
      /* @__PURE__ */ wrapper(
        /* @__PURE__ */ label("$label"),
        /* @__PURE__ */ inner(
          /* @__PURE__ */ icon("prefix"),
          /* @__PURE__ */ prefix(),
          /* @__PURE__ */ selectInput(
            /* @__PURE__ */ $if(
              "$slots.default",
              () => "$slots.default",
              /* @__PURE__ */ optionSlot(
                /* @__PURE__ */ $if(
                  "$option.group",
                  /* @__PURE__ */ optGroup(/* @__PURE__ */ optionSlot(/* @__PURE__ */ option("$option.label"))),
                  /* @__PURE__ */ option("$option.label")
                )
              )
            )
          ),
          /* @__PURE__ */ $if("$attrs.multiple !== undefined", () => "", /* @__PURE__ */ icon("select")),
          /* @__PURE__ */ suffix(),
          /* @__PURE__ */ icon("suffix")
        )
      ),
      /* @__PURE__ */ help("$help"),
      /* @__PURE__ */ messages(/* @__PURE__ */ message("$message.value"))
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "input",
    /**
     * An array of extra props to accept for this input.
     */
    props: ["options", "placeholder", "optionsLoader"],
    /**
     * Additional features that should be added to your input
     */
    features: [options, select2, defaultIcon("select", "select")],
    /**
     * The key used to memoize the schema.
     */
    schemaMemoKey: "cb119h43krg"
  };
  var textarea = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ outer(
      /* @__PURE__ */ wrapper(
        /* @__PURE__ */ label("$label"),
        /* @__PURE__ */ inner(
          /* @__PURE__ */ icon("prefix", "label"),
          /* @__PURE__ */ prefix(),
          /* @__PURE__ */ textareaInput(),
          /* @__PURE__ */ suffix(),
          /* @__PURE__ */ icon("suffix")
        )
      ),
      /* @__PURE__ */ help("$help"),
      /* @__PURE__ */ messages(/* @__PURE__ */ message("$message.value"))
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "input",
    /**
     * An array of extra props to accept for this input.
     */
    props: [],
    /**
     * Additional features that should be added to your input
     */
    features: [initialValue],
    /**
     * The key used to memoize the schema.
     */
    schemaMemoKey: "b1n0td79m9g"
  };
  var text2 = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: /* @__PURE__ */ outer(
      /* @__PURE__ */ wrapper(
        /* @__PURE__ */ label("$label"),
        /* @__PURE__ */ inner(
          /* @__PURE__ */ icon("prefix", "label"),
          /* @__PURE__ */ prefix(),
          /* @__PURE__ */ textInput(),
          /* @__PURE__ */ suffix(),
          /* @__PURE__ */ icon("suffix")
        )
      ),
      /* @__PURE__ */ help("$help"),
      /* @__PURE__ */ messages(/* @__PURE__ */ message("$message.value"))
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "input",
    /**
     * The family of inputs this one belongs too. For example "text" and "email"
     * are both part of the "text" family. This is primary used for styling.
     */
    family: "text",
    /**
     * An array of extra props to accept for this input.
     */
    props: [],
    /**
     * Additional features that should be added to your input
     */
    features: [casts],
    /**
     * The key used to memoize the schema.
     */
    schemaMemoKey: "c3cc4kflsg"
  };
  var inputs = {
    button,
    submit: button,
    checkbox,
    file,
    form: form2,
    group,
    hidden,
    list: list2,
    meta,
    radio,
    select: select22,
    textarea,
    text: text2,
    color: text2,
    date: text2,
    datetimeLocal: text2,
    email: text2,
    month: text2,
    number: text2,
    password: text2,
    search: text2,
    tel: text2,
    time: text2,
    url: text2,
    week: text2,
    range: text2
  };

  // node_modules/@formkit/vue/node_modules/@formkit/themes/dist/index.mjs
  var documentStyles = void 0;
  var documentThemeLinkTag = null;
  var themeDidLoad;
  var themeHasLoaded = false;
  var themeWasRequested = false;
  var themeLoaded = /* @__PURE__ */ new Promise((res) => {
    themeDidLoad = () => {
      themeHasLoaded = true;
      res();
    };
  });
  var isClient = typeof window !== "undefined" && typeof fetch !== "undefined";
  documentStyles = isClient ? /* @__PURE__ */ getComputedStyle(document.documentElement) : void 0;
  var iconRegistry = {};
  var iconRequests = {};
  function createThemePlugin(theme, icons, iconLoaderUrl, iconLoader) {
    if (icons) {
      Object.assign(iconRegistry, icons);
    }
    if (isClient && !themeWasRequested && documentStyles?.getPropertyValue("--formkit-theme")) {
      themeDidLoad();
      themeWasRequested = true;
    } else if (theme && !themeWasRequested && isClient) {
      loadTheme(theme);
    } else if (!themeWasRequested && isClient) {
      themeDidLoad();
    }
    const themePlugin = function themePlugin2(node) {
      node.addProps(["iconLoader", "iconLoaderUrl"]);
      node.props.iconHandler = createIconHandler(
        node.props?.iconLoader ? node.props.iconLoader : iconLoader,
        node.props?.iconLoaderUrl ? node.props.iconLoaderUrl : iconLoaderUrl
      );
      loadIconPropIcons(node, node.props.iconHandler);
      node.on("created", () => {
        if (node?.context?.handlers) {
          node.context.handlers.iconClick = (sectionKey) => {
            const clickHandlerProp = `on${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}IconClick`;
            const handlerFunction = node.props[clickHandlerProp];
            if (handlerFunction && typeof handlerFunction === "function") {
              return (e) => {
                return handlerFunction(node, e);
              };
            }
            return void 0;
          };
        }
        if (node?.context?.fns) {
          node.context.fns.iconRole = (sectionKey) => {
            const clickHandlerProp = `on${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}IconClick`;
            return typeof node.props[clickHandlerProp] === "function" ? "button" : null;
          };
        }
      });
    };
    themePlugin.iconHandler = createIconHandler(iconLoader, iconLoaderUrl);
    return themePlugin;
  }
  function loadTheme(theme) {
    if (!theme || !isClient || typeof getComputedStyle !== "function") {
      return;
    }
    themeWasRequested = true;
    documentThemeLinkTag = document.getElementById("formkit-theme");
    if (theme && // if we have a window object
    isClient && // we don't have an existing theme OR the theme being set up is different
    (!documentStyles?.getPropertyValue("--formkit-theme") && !documentThemeLinkTag || documentThemeLinkTag?.getAttribute("data-theme") && documentThemeLinkTag?.getAttribute("data-theme") !== theme)) {
      const formkitVersion = FORMKIT_VERSION.startsWith("__") ? "latest" : FORMKIT_VERSION;
      const themeUrl = `https://cdn.jsdelivr.net/npm/@formkit/themes@${formkitVersion}/dist/${theme}/theme.css`;
      const link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.id = "formkit-theme";
      link.setAttribute("data-theme", theme);
      link.onload = () => {
        documentStyles = getComputedStyle(document.documentElement);
        themeDidLoad();
      };
      document.head.appendChild(link);
      link.href = themeUrl;
      if (documentThemeLinkTag) {
        documentThemeLinkTag.remove();
      }
    }
  }
  function createIconHandler(iconLoader, iconLoaderUrl) {
    return (iconName) => {
      if (typeof iconName !== "string")
        return;
      if (iconName.startsWith("<svg")) {
        return iconName;
      }
      const isDefault = iconName.startsWith("default:");
      iconName = isDefault ? iconName.split(":")[1] : iconName;
      const iconWasAlreadyLoaded = iconName in iconRegistry;
      let loadedIcon = void 0;
      if (iconWasAlreadyLoaded) {
        return iconRegistry[iconName];
      } else if (!iconRequests[iconName]) {
        loadedIcon = getIconFromStylesheet(iconName);
        loadedIcon = isClient && typeof loadedIcon === "undefined" ? Promise.resolve(loadedIcon) : loadedIcon;
        if (loadedIcon instanceof Promise) {
          iconRequests[iconName] = loadedIcon.then((iconValue) => {
            if (!iconValue && typeof iconName === "string" && !isDefault) {
              return loadedIcon = typeof iconLoader === "function" ? iconLoader(iconName) : getRemoteIcon(iconName, iconLoaderUrl);
            }
            return iconValue;
          }).then((finalIcon) => {
            if (typeof iconName === "string") {
              iconRegistry[isDefault ? `default:${iconName}` : iconName] = finalIcon;
            }
            return finalIcon;
          });
        } else if (typeof loadedIcon === "string") {
          iconRegistry[isDefault ? `default:${iconName}` : iconName] = loadedIcon;
          return loadedIcon;
        }
      }
      return iconRequests[iconName];
    };
  }
  function getIconFromStylesheet(iconName) {
    if (!isClient)
      return;
    if (themeHasLoaded) {
      return loadStylesheetIcon(iconName);
    } else {
      return themeLoaded.then(() => {
        return loadStylesheetIcon(iconName);
      });
    }
  }
  function loadStylesheetIcon(iconName) {
    const cssVarIcon = documentStyles?.getPropertyValue(`--fk-icon-${iconName}`);
    if (cssVarIcon) {
      const icon2 = atob(cssVarIcon);
      if (icon2.startsWith("<svg")) {
        iconRegistry[iconName] = icon2;
        return icon2;
      }
    }
    return void 0;
  }
  function getRemoteIcon(iconName, iconLoaderUrl) {
    const formkitVersion = FORMKIT_VERSION.startsWith("__") ? "latest" : FORMKIT_VERSION;
    const fetchUrl = typeof iconLoaderUrl === "function" ? iconLoaderUrl(iconName) : `https://cdn.jsdelivr.net/npm/@formkit/icons@${formkitVersion}/dist/icons/${iconName}.svg`;
    if (!isClient)
      return void 0;
    return fetch(`${fetchUrl}`).then(async (r) => {
      const icon2 = await r.text();
      if (icon2.startsWith("<svg")) {
        return icon2;
      }
      return void 0;
    }).catch((e) => {
      console.error(e);
      return void 0;
    });
  }
  function loadIconPropIcons(node, iconHandler) {
    const iconRegex = /^[a-zA-Z-]+(?:-icon|Icon)$/;
    const iconProps = Object.keys(node.props).filter((prop) => {
      return iconRegex.test(prop);
    });
    iconProps.forEach((sectionKey) => {
      return loadPropIcon(node, iconHandler, sectionKey);
    });
  }
  function loadPropIcon(node, iconHandler, sectionKey) {
    const iconName = node.props[sectionKey];
    const loadedIcon = iconHandler(iconName);
    const rawIconProp = `_raw${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}`;
    const clickHandlerProp = `on${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}Click`;
    node.addProps([rawIconProp, clickHandlerProp]);
    node.on(`prop:${sectionKey}`, reloadIcon);
    if (loadedIcon instanceof Promise) {
      return loadedIcon.then((svg) => {
        node.props[rawIconProp] = svg;
      });
    } else {
      node.props[rawIconProp] = loadedIcon;
    }
    return;
  }
  function reloadIcon(event) {
    const node = event.origin;
    const iconName = event.payload;
    const iconHandler = node?.props?.iconHandler;
    const sectionKey = event.name.split(":")[1];
    const rawIconProp = `_raw${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}`;
    if (iconHandler && typeof iconHandler === "function") {
      const loadedIcon = iconHandler(iconName);
      if (loadedIcon instanceof Promise) {
        return loadedIcon.then((svg) => {
          node.props[rawIconProp] = svg;
        });
      } else {
        node.props[rawIconProp] = loadedIcon;
      }
    }
  }

  // node_modules/@formkit/dev/dist/index.mjs
  var errors = {
    /**
     * FormKit errors:
     */
    100: ({ data: node }) => `Only groups, lists, and forms can have children (${node.name}).`,
    101: ({ data: node }) => `You cannot directly modify the store (${node.name}). See: https://formkit.com/advanced/core#message-store`,
    102: ({
      data: [node, property]
    }) => `You cannot directly assign node.${property} (${node.name})`,
    103: ({ data: [operator] }) => `Schema expressions cannot start with an operator (${operator})`,
    104: ({ data: [operator, expression] }) => `Schema expressions cannot end with an operator (${operator} in "${expression}")`,
    105: ({ data: expression }) => `Invalid schema expression: ${expression}`,
    106: ({ data: name }) => `Cannot submit because (${name}) is not in a form.`,
    107: ({ data: [node, value] }) => `Cannot set ${node.name} to non object value: ${value}`,
    108: ({ data: [node, value] }) => `Cannot set ${node.name} to non array value: ${value}`,
    /**
     * Input specific errors:
     */
    300: ({ data: [node] }) => `Cannot set behavior prop to overscroll (on ${node.name} input) when options prop is a function.`,
    /**
     * FormKit vue errors:
     */
    600: ({ data: node }) => `Unknown input type${typeof node.props.type === "string" ? ' "' + node.props.type + '"' : ""} ("${node.name}")`,
    601: ({ data: node }) => `Input definition${typeof node.props.type === "string" ? ' "' + node.props.type + '"' : ""} is missing a schema or component property (${node.name}).`
  };
  var warnings = {
    /**
     * Core warnings:
     */
    150: ({ data: fn }) => `Schema function "${fn}()" is not a valid function.`,
    151: ({ data: id }) => `No form element with id: ${id}`,
    152: ({ data: id }) => `No input element with id: ${id}`,
    /**
     * Input specific warnings:
     */
    350: ({
      data: { node, inputType }
    }) => `Invalid options prop for ${node.name} input (${inputType}). See https://formkit.com/inputs/${inputType}`,
    /**
     * Vue warnings:
     */
    650: 'Schema "$get()" must use the id of an input to access.',
    651: ({ data: id }) => `Cannot setErrors() on "${id}" because no such id exists.`,
    652: ({ data: id }) => `Cannot clearErrors() on "${id}" because no such id exists.`,
    /**
     * Deprecation warnings:
     */
    800: ({ data: name }) => `${name} is deprecated.`
  };
  var decodeErrors = (error2, next) => {
    if (error2.code in errors) {
      const err = errors[error2.code];
      error2.message = typeof err === "function" ? err(error2) : err;
    }
    return next(error2);
  };
  var registered = false;
  function register2() {
    if (!registered) {
      errorHandler(decodeErrors);
      warningHandler(decodeWarnings);
      registered = true;
    }
  }
  var decodeWarnings = (warning, next) => {
    if (warning.code in warnings) {
      const warn4 = warnings[warning.code];
      warning.message = typeof warn4 === "function" ? warn4(warning) : warn4;
    }
    return next(warning);
  };

  // node_modules/@formkit/vue/dist/index.mjs
  var __defProp2 = Object.defineProperty;
  var __getOwnPropNames2 = Object.getOwnPropertyNames;
  var __esm = (fn, res) => function __init() {
    return fn && (res = (0, fn[__getOwnPropNames2(fn)[0]])(fn = 0)), res;
  };
  var __export2 = (target2, all) => {
    for (var name in all)
      __defProp2(target2, name, { get: all[name], enumerable: true });
  };
  var vueBindings;
  var bindings_default;
  var init_bindings = __esm({
    "packages/vue/src/bindings.ts"() {
      vueBindings = function vueBindings2(node) {
        node.ledger.count("blocking", (m) => m.blocking);
        const isValid = ref(!node.ledger.value("blocking"));
        node.ledger.count("errors", (m) => m.type === "error");
        const hasErrors = ref(!!node.ledger.value("errors"));
        let hasTicked = false;
        nextTick(() => {
          hasTicked = true;
        });
        const availableMessages = reactive(
          node.store.reduce((store, message3) => {
            if (message3.visible) {
              store[message3.key] = message3;
            }
            return store;
          }, {})
        );
        const validationVisibility = ref(
          node.props.validationVisibility || (node.props.type === "checkbox" ? "dirty" : "blur")
        );
        node.on("prop:validationVisibility", ({ payload }) => {
          validationVisibility.value = payload;
        });
        const hasShownErrors = ref(validationVisibility.value === "live");
        const isRequired = ref(false);
        const checkForRequired = (parsedRules) => {
          isRequired.value = (parsedRules ?? []).some(
            (rule) => rule.name === "required"
          );
        };
        checkForRequired(node.props.parsedRules);
        node.on("prop:parsedRules", ({ payload }) => checkForRequired(payload));
        const items = ref(node.children.map((child) => child.uid));
        const validationVisible = computed2(() => {
          if (!context.state)
            return false;
          if (context.state.submitted)
            return true;
          if (!hasShownErrors.value && !context.state.settled) {
            return false;
          }
          switch (validationVisibility.value) {
            case "live":
              return true;
            case "blur":
              return context.state.blurred;
            case "dirty":
              return context.state.dirty;
            default:
              return false;
          }
        });
        const isInvalid = computed2(() => {
          return context.state.failing && validationVisible.value;
        });
        const isComplete = computed2(() => {
          return context && hasValidation.value ? isValid.value && !hasErrors.value : context.state.dirty && !empty(context.value);
        });
        const hasValidation = ref(
          Array.isArray(node.props.parsedRules) && node.props.parsedRules.length > 0
        );
        node.on("prop:parsedRules", ({ payload: rules }) => {
          hasValidation.value = Array.isArray(rules) && rules.length > 0;
        });
        const messages3 = computed2(() => {
          const visibleMessages = {};
          for (const key in availableMessages) {
            const message3 = availableMessages[key];
            if (message3.type !== "validation" || validationVisible.value) {
              visibleMessages[key] = message3;
            }
          }
          return visibleMessages;
        });
        const ui = reactive(
          node.store.reduce((messages4, message3) => {
            if (message3.type === "ui" && message3.visible)
              messages4[message3.key] = message3;
            return messages4;
          }, {})
        );
        const passing = computed2(() => !context.state.failing);
        const cachedClasses = reactive({});
        const classes2 = new Proxy(cachedClasses, {
          get(...args) {
            if (!node)
              return "";
            const [target2, property] = args;
            let className = Reflect.get(...args);
            if (!className && typeof property === "string") {
              if (!has(target2, property) && !property.startsWith("__v")) {
                const observedNode = createObserver(node);
                observedNode.watch((node2) => {
                  const rootClasses = typeof node2.config.rootClasses === "function" ? node2.config.rootClasses(property, node2) : {};
                  const globalConfigClasses = node2.config.classes ? createClasses(property, node2, node2.config.classes[property]) : {};
                  const classesPropClasses = createClasses(
                    property,
                    node2,
                    node2.props[`_${property}Class`]
                  );
                  const sectionPropClasses = createClasses(
                    property,
                    node2,
                    node2.props[`${property}Class`]
                  );
                  className = generateClassList(
                    node2,
                    property,
                    rootClasses,
                    globalConfigClasses,
                    classesPropClasses,
                    sectionPropClasses
                  );
                  target2[property] = className ?? "";
                });
              }
            }
            return className;
          }
        });
        node.on("prop:rootClasses", () => {
          const keys = Object.keys(cachedClasses);
          for (const key of keys) {
            delete cachedClasses[key];
          }
        });
        const describedBy = computed2(() => {
          if (!node)
            return void 0;
          const describers = [];
          if (context.help) {
            describers.push(`help-${node.props.id}`);
          }
          for (const key in messages3.value) {
            describers.push(`${node.props.id}-${key}`);
          }
          return describers.length ? describers.join(" ") : void 0;
        });
        const value = ref(node.value);
        const _value = ref(node.value);
        const context = reactive({
          _value,
          attrs: node.props.attrs,
          disabled: node.props.disabled,
          describedBy,
          fns: {
            length: (obj) => Object.keys(obj).length,
            number: (value2) => Number(value2),
            string: (value2) => String(value2),
            json: (value2) => JSON.stringify(value2),
            eq
          },
          handlers: {
            blur: (e) => {
              if (!node)
                return;
              node.store.set(
                /* @__PURE__ */ createMessage({ key: "blurred", visible: false, value: true })
              );
              if (typeof node.props.attrs.onBlur === "function") {
                node.props.attrs.onBlur(e);
              }
            },
            touch: () => {
              const doCompare = context.dirtyBehavior === "compare";
              if (node.store.dirty?.value && !doCompare)
                return;
              const isDirty2 = !eq(node.props._init, node._value);
              if (!isDirty2 && !doCompare)
                return;
              node.store.set(
                /* @__PURE__ */ createMessage({ key: "dirty", visible: false, value: isDirty2 })
              );
            },
            DOMInput: (e) => {
              node.input(e.target.value);
              node.emit("dom-input-event", e);
            }
          },
          help: node.props.help,
          id: node.props.id,
          items,
          label: node.props.label,
          messages: messages3,
          didMount: false,
          node: markRaw(node),
          options: node.props.options,
          defaultMessagePlacement: true,
          slots: node.props.__slots,
          state: {
            blurred: false,
            complete: isComplete,
            dirty: false,
            empty: empty(value),
            submitted: false,
            settled: node.isSettled,
            valid: isValid,
            invalid: isInvalid,
            errors: hasErrors,
            rules: hasValidation,
            validationVisible,
            required: isRequired,
            failing: false,
            passing
          },
          type: node.props.type,
          family: node.props.family,
          ui,
          value,
          classes: classes2
        });
        node.on("created", () => {
          if (!eq(context.value, node.value)) {
            _value.value = node.value;
            value.value = node.value;
            triggerRef(value);
            triggerRef(_value);
          }
          (async () => {
            await node.settled;
            if (node)
              node.props._init = cloneAny(node.value);
          })();
        });
        node.on("mounted", () => {
          context.didMount = true;
        });
        node.on("settled", ({ payload: isSettled }) => {
          context.state.settled = isSettled;
        });
        function observeProps(observe) {
          const propNames = Array.isArray(observe) ? observe : Object.keys(observe);
          propNames.forEach((prop) => {
            prop = camel(prop);
            if (!has(context, prop)) {
              context[prop] = node.props[prop];
            }
            node.on(`prop:${prop}`, ({ payload }) => {
              context[prop] = payload;
            });
          });
        }
        const rootProps = () => {
          const props = [
            "__root",
            "help",
            "label",
            "disabled",
            "options",
            "type",
            "attrs",
            "preserve",
            "preserveErrors",
            "id",
            "dirtyBehavior"
          ];
          const iconPattern = /^[a-zA-Z-]+(?:-icon|Icon)$/;
          const matchingProps = Object.keys(node.props).filter((prop) => {
            return iconPattern.test(prop);
          });
          return props.concat(matchingProps);
        };
        observeProps(rootProps());
        function definedAs(definition3) {
          if (definition3.props)
            observeProps(definition3.props);
        }
        node.props.definition && definedAs(node.props.definition);
        node.on("added-props", ({ payload }) => observeProps(payload));
        node.on("input", ({ payload }) => {
          if (node.type !== "input" && !isRef2(payload) && !isReactive(payload)) {
            _value.value = shallowClone(payload);
          } else {
            _value.value = payload;
            triggerRef(_value);
          }
        });
        node.on("commitRaw", ({ payload }) => {
          if (node.type !== "input" && !isRef2(payload) && !isReactive(payload)) {
            value.value = _value.value = shallowClone(payload);
          } else {
            value.value = _value.value = payload;
            triggerRef(value);
          }
          node.emit("modelUpdated");
        });
        node.on("commit", ({ payload }) => {
          if ((!context.state.dirty || context.dirtyBehavior === "compare") && node.isCreated && hasTicked) {
            if (!node.store.validating?.value) {
              context.handlers.touch();
            } else {
              const receipt = node.on("message-removed", ({ payload: message3 }) => {
                if (message3.key === "validating") {
                  context.handlers.touch();
                  node.off(receipt);
                }
              });
            }
          }
          if (isComplete && node.type === "input" && hasErrors.value && !undefine(node.props.preserveErrors)) {
            node.store.filter(
              (message3) => !(message3.type === "error" && message3.meta?.autoClear === true)
            );
          }
          if (node.type === "list" && node.sync) {
            items.value = node.children.map((child) => child.uid);
          }
          context.state.empty = empty(payload);
        });
        const updateState = async (message3) => {
          if (message3.type === "ui" && message3.visible && !message3.meta.showAsMessage) {
            ui[message3.key] = message3;
          } else if (message3.visible) {
            availableMessages[message3.key] = message3;
          } else if (message3.type === "state") {
            context.state[message3.key] = !!message3.value;
          }
        };
        node.on("message-added", (e) => updateState(e.payload));
        node.on("message-updated", (e) => updateState(e.payload));
        node.on("message-removed", ({ payload: message3 }) => {
          delete ui[message3.key];
          delete availableMessages[message3.key];
          delete context.state[message3.key];
        });
        node.on("settled:blocking", () => {
          isValid.value = true;
        });
        node.on("unsettled:blocking", () => {
          isValid.value = false;
        });
        node.on("settled:errors", () => {
          hasErrors.value = false;
        });
        node.on("unsettled:errors", () => {
          hasErrors.value = true;
        });
        watch2(validationVisible, (value2) => {
          if (value2) {
            hasShownErrors.value = true;
          }
        });
        node.context = context;
        node.emit("context", node, false);
        node.on("destroyed", () => {
          node.context = void 0;
          node = null;
        });
      };
      bindings_default = vueBindings;
    }
  });
  var defaultConfig_exports = {};
  __export2(defaultConfig_exports, {
    defaultConfig: () => defaultConfig2
  });
  var defaultConfig2;
  var init_defaultConfig = __esm({
    "packages/vue/src/defaultConfig.ts"() {
      init_bindings();
      defaultConfig2 = (options3 = {}) => {
        register2();
        const {
          rules = {},
          locales = {},
          inputs: inputs$1 = {},
          messages: messages3 = {},
          locale = void 0,
          theme = void 0,
          iconLoaderUrl = void 0,
          iconLoader = void 0,
          icons = {},
          ...nodeOptions
        } = options3;
        const validation = createValidationPlugin({
          ...dist_exports,
          ...rules || {}
        });
        const i18n = createI18nPlugin(
          extend2({ en, ...locales || {} }, messages3)
        );
        const library = createLibraryPlugin(inputs, inputs$1);
        const themePlugin = createThemePlugin(theme, icons, iconLoaderUrl, iconLoader);
        return extend2(
          {
            plugins: [library, themePlugin, bindings_default, i18n, validation],
            ...!locale ? {} : { config: { locale } }
          },
          nodeOptions || {},
          true
        );
      };
    }
  });
  var isServer = typeof window === "undefined";
  var ssrCompleteRegistry = /* @__PURE__ */ new Map();
  function onSSRComplete(app2, callback) {
    if (!isServer || !app2)
      return;
    if (!ssrCompleteRegistry.has(app2))
      ssrCompleteRegistry.set(app2, /* @__PURE__ */ new Set());
    ssrCompleteRegistry.get(app2)?.add(callback);
  }
  var isServer2 = typeof window === "undefined";
  var memo = {};
  var memoKeys = {};
  var instanceKey;
  var instanceScopes = /* @__PURE__ */ new WeakMap();
  var raw = "__raw__";
  var isClassProp = /[a-zA-Z0-9\-][cC]lass$/;
  function getRef(token3, data) {
    const value = ref(null);
    if (token3 === "get") {
      const nodeRefs = {};
      value.value = get.bind(null, nodeRefs);
      return value;
    }
    const path = token3.split(".");
    watchEffect(() => {
      value.value = getValue2(
        isRef2(data) ? data.value : data,
        path
      );
    });
    return value;
  }
  function getValue2(set, path) {
    if (Array.isArray(set)) {
      for (const subset of set) {
        const value = subset !== false && getValue2(subset, path);
        if (value !== void 0)
          return value;
      }
      return void 0;
    }
    let foundValue = void 0;
    let obj = set;
    for (const i in path) {
      const key = path[i];
      if (typeof obj !== "object" || obj === null) {
        foundValue = void 0;
        break;
      }
      const currentValue = obj[key];
      if (Number(i) === path.length - 1 && currentValue !== void 0) {
        foundValue = typeof currentValue === "function" ? currentValue.bind(obj) : currentValue;
        break;
      }
      obj = currentValue;
    }
    return foundValue;
  }
  function get(nodeRefs, id) {
    if (typeof id !== "string")
      return warn3(650);
    if (!(id in nodeRefs))
      nodeRefs[id] = ref(void 0);
    if (nodeRefs[id].value === void 0) {
      nodeRefs[id].value = null;
      const root2 = getNode(id);
      if (root2)
        nodeRefs[id].value = root2.context;
      watchRegistry(id, ({ payload: node }) => {
        nodeRefs[id].value = isNode(node) ? node.context : node;
      });
    }
    return nodeRefs[id].value;
  }
  function parseSchema(library, schema, memoKey) {
    function parseCondition2(library2, node) {
      const condition = provider(compile3(node.if), { if: true });
      const children = createElements(library2, node.then);
      const alternate = node.else ? createElements(library2, node.else) : null;
      return [condition, children, alternate];
    }
    function parseConditionAttr(attr, _default) {
      const condition = provider(compile3(attr.if));
      let b = () => _default;
      let a = () => _default;
      if (typeof attr.then === "object") {
        a = parseAttrs(attr.then, void 0);
      } else if (typeof attr.then === "string" && attr.then?.startsWith("$")) {
        a = provider(compile3(attr.then));
      } else {
        a = () => attr.then;
      }
      if (has(attr, "else")) {
        if (typeof attr.else === "object") {
          b = parseAttrs(attr.else);
        } else if (typeof attr.else === "string" && attr.else?.startsWith("$")) {
          b = provider(compile3(attr.else));
        } else {
          b = () => attr.else;
        }
      }
      return () => condition() ? a() : b();
    }
    function parseAttrs(unparsedAttrs, bindExp, _default = {}) {
      const explicitAttrs = new Set(Object.keys(unparsedAttrs || {}));
      const boundAttrs = bindExp ? provider(compile3(bindExp)) : () => ({});
      const setters = [
        (attrs) => {
          const bound = boundAttrs();
          for (const attr in bound) {
            if (!explicitAttrs.has(attr)) {
              attrs[attr] = bound[attr];
            }
          }
        }
      ];
      if (unparsedAttrs) {
        if (isConditional(unparsedAttrs)) {
          const condition = parseConditionAttr(
            unparsedAttrs,
            _default
          );
          return condition;
        }
        for (let attr in unparsedAttrs) {
          const value = unparsedAttrs[attr];
          let getValue22;
          const isStr = typeof value === "string";
          if (attr.startsWith(raw)) {
            attr = attr.substring(7);
            getValue22 = () => value;
          } else if (isStr && value.startsWith("$") && value.length > 1 && !(value.startsWith("$reset") && isClassProp.test(attr))) {
            getValue22 = provider(compile3(value));
          } else if (typeof value === "object" && isConditional(value)) {
            getValue22 = parseConditionAttr(value, void 0);
          } else if (typeof value === "object" && isPojo(value)) {
            getValue22 = parseAttrs(value);
          } else {
            getValue22 = () => value;
          }
          setters.push((attrs) => {
            attrs[attr] = getValue22();
          });
        }
      }
      return () => {
        const attrs = Array.isArray(unparsedAttrs) ? [] : {};
        setters.forEach((setter) => setter(attrs));
        return attrs;
      };
    }
    function parseNode(library2, _node) {
      let element = null;
      let attrs = () => null;
      let condition = false;
      let children = null;
      let alternate = null;
      let iterator2 = null;
      let resolve2 = false;
      const node = sugar(_node);
      if (isDOM(node)) {
        element = node.$el;
        attrs = node.$el !== "text" ? parseAttrs(node.attrs, node.bind) : () => null;
      } else if (isComponent2(node)) {
        if (typeof node.$cmp === "string") {
          if (has(library2, node.$cmp)) {
            element = library2[node.$cmp];
          } else {
            element = node.$cmp;
            resolve2 = true;
          }
        } else {
          element = node.$cmp;
        }
        attrs = parseAttrs(node.props, node.bind);
      } else if (isConditional(node)) {
        [condition, children, alternate] = parseCondition2(library2, node);
      }
      if (!isConditional(node) && "if" in node) {
        condition = provider(compile3(node.if));
      } else if (!isConditional(node) && element === null) {
        condition = () => true;
      }
      if ("children" in node && node.children) {
        if (typeof node.children === "string") {
          if (node.children.startsWith("$slots.")) {
            element = element === "text" ? "slot" : element;
            children = provider(compile3(node.children));
          } else if (node.children.startsWith("$") && node.children.length > 1) {
            const value = provider(compile3(node.children));
            children = () => String(value());
          } else {
            children = () => String(node.children);
          }
        } else if (Array.isArray(node.children)) {
          children = createElements(library2, node.children);
        } else {
          const [childCondition, c, a] = parseCondition2(library2, node.children);
          children = (iterationData) => childCondition && childCondition() ? c && c(iterationData) : a && a(iterationData);
        }
      }
      if (isComponent2(node)) {
        if (children) {
          const produceChildren = children;
          children = (iterationData) => {
            return {
              default(slotData2, key) {
                const currentKey = instanceKey;
                if (key)
                  instanceKey = key;
                if (slotData2)
                  instanceScopes.get(instanceKey)?.unshift(slotData2);
                if (iterationData)
                  instanceScopes.get(instanceKey)?.unshift(iterationData);
                const c = produceChildren(iterationData);
                if (slotData2)
                  instanceScopes.get(instanceKey)?.shift();
                if (iterationData)
                  instanceScopes.get(instanceKey)?.shift();
                instanceKey = currentKey;
                return c;
              }
            };
          };
          children.slot = true;
        } else {
          children = () => ({});
        }
      }
      if ("for" in node && node.for) {
        const values = node.for.length === 3 ? node.for[2] : node.for[1];
        const getValues = typeof values === "string" && values.startsWith("$") ? provider(compile3(values)) : () => values;
        iterator2 = [
          getValues,
          node.for[0],
          node.for.length === 3 ? String(node.for[1]) : null
        ];
      }
      return [condition, element, attrs, children, alternate, iterator2, resolve2];
    }
    function createSlots2(children, iterationData) {
      const slots = children(iterationData);
      const currentKey = instanceKey;
      return Object.keys(slots).reduce((allSlots, slotName) => {
        const slotFn = slots && slots[slotName];
        allSlots[slotName] = (data) => {
          return slotFn && slotFn(data, currentKey) || null;
        };
        return allSlots;
      }, {});
    }
    function createElement(library2, node) {
      const [condition, element, attrs, children, alternate, iterator2, resolve2] = parseNode(library2, node);
      let createNodes = (iterationData) => {
        if (condition && element === null && children) {
          return condition() ? children(iterationData) : alternate && alternate(iterationData);
        }
        if (element && (!condition || condition())) {
          if (element === "text" && children) {
            return createTextVNode(String(children()));
          }
          if (element === "slot" && children)
            return children(iterationData);
          const el = resolve2 ? resolveComponent(element) : element;
          const slots = children?.slot ? createSlots2(children, iterationData) : null;
          return h(
            el,
            attrs(),
            slots || (children ? children(iterationData) : [])
          );
        }
        return typeof alternate === "function" ? alternate(iterationData) : alternate;
      };
      if (iterator2) {
        const repeatedNode = createNodes;
        const [getValues, valueName, keyName] = iterator2;
        createNodes = () => {
          const _v = getValues();
          const values = Number.isFinite(_v) ? Array(Number(_v)).fill(0).map((_, i) => i) : _v;
          const fragment2 = [];
          if (typeof values !== "object")
            return null;
          const instanceScope = instanceScopes.get(instanceKey) || [];
          const isArray2 = Array.isArray(values);
          for (const key in values) {
            if (isArray2 && key in Array.prototype)
              continue;
            const iterationData = Object.defineProperty(
              {
                ...instanceScope.reduce(
                  (previousIterationData, scopedData) => {
                    if (previousIterationData.__idata) {
                      return { ...previousIterationData, ...scopedData };
                    }
                    return scopedData;
                  },
                  {}
                ),
                [valueName]: values[key],
                ...keyName !== null ? { [keyName]: isArray2 ? Number(key) : key } : {}
              },
              "__idata",
              { enumerable: false, value: true }
            );
            instanceScope.unshift(iterationData);
            fragment2.push(repeatedNode.bind(null, iterationData)());
            instanceScope.shift();
          }
          return fragment2;
        };
      }
      return createNodes;
    }
    function createElements(library2, schema2) {
      if (Array.isArray(schema2)) {
        const els = schema2.map(createElement.bind(null, library2));
        return (iterationData) => els.map((element2) => element2(iterationData));
      }
      const element = createElement(library2, schema2);
      return (iterationData) => element(iterationData);
    }
    const providers = [];
    function provider(compiled, hints = {}) {
      const compiledFns = /* @__PURE__ */ new WeakMap();
      providers.push((callback, key) => {
        compiledFns.set(
          key,
          compiled.provide((tokens) => callback(tokens, hints))
        );
      });
      return () => compiledFns.get(instanceKey)();
    }
    function createInstance(providerCallback, key) {
      memoKey ?? (memoKey = toMemoKey(schema));
      const [render2, compiledProviders] = has(memo, memoKey) ? memo[memoKey] : [createElements(library, schema), providers];
      if (!isServer2) {
        memoKeys[memoKey] ?? (memoKeys[memoKey] = 0);
        memoKeys[memoKey]++;
        memo[memoKey] = [render2, compiledProviders];
      }
      compiledProviders.forEach((compiledProvider) => {
        compiledProvider(providerCallback, key);
      });
      return () => {
        instanceKey = key;
        return render2();
      };
    }
    return createInstance;
  }
  function useScope(token3, defaultValue) {
    const scopedData = instanceScopes.get(instanceKey) || [];
    let scopedValue = void 0;
    if (scopedData.length) {
      scopedValue = getValue2(scopedData, token3.split("."));
    }
    return scopedValue === void 0 ? defaultValue : scopedValue;
  }
  function slotData(data, key) {
    return new Proxy(data, {
      get(...args) {
        let data2 = void 0;
        const property = args[1];
        if (typeof property === "string") {
          const prevKey = instanceKey;
          instanceKey = key;
          data2 = useScope(property, void 0);
          instanceKey = prevKey;
        }
        return data2 !== void 0 ? data2 : Reflect.get(...args);
      }
    });
  }
  function createRenderFn(instanceCreator, data, instanceKey2) {
    return instanceCreator(
      (requirements, hints = {}) => {
        return requirements.reduce((tokens, token3) => {
          if (token3.startsWith("slots.")) {
            const slot = token3.substring(6);
            const hasSlot = () => data.slots && has(data.slots, slot) && typeof data.slots[slot] === "function";
            if (hints.if) {
              tokens[token3] = hasSlot;
            } else if (data.slots) {
              const scopedData = slotData(data, instanceKey2);
              tokens[token3] = () => hasSlot() ? data.slots[slot](scopedData) : null;
            }
          } else {
            const value = getRef(token3, data);
            tokens[token3] = () => useScope(token3, value.value);
          }
          return tokens;
        }, {});
      },
      instanceKey2
    );
  }
  function clean(schema, memoKey, instanceKey2) {
    memoKey ?? (memoKey = toMemoKey(schema));
    memoKeys[memoKey]--;
    if (memoKeys[memoKey] === 0) {
      delete memoKeys[memoKey];
      const [, providers] = memo[memoKey];
      delete memo[memoKey];
      providers.length = 0;
    }
    instanceScopes.delete(instanceKey2);
  }
  function toMemoKey(schema) {
    return JSON.stringify(schema, (_, value) => {
      if (typeof value === "function") {
        return value.toString();
      }
      return value;
    });
  }
  var FormKitSchema = /* @__PURE__ */ defineComponent({
    name: "FormKitSchema",
    props: {
      schema: {
        type: [Array, Object],
        required: true
      },
      data: {
        type: Object,
        default: () => ({})
      },
      library: {
        type: Object,
        default: () => ({})
      },
      memoKey: {
        type: String,
        required: false
      }
    },
    emits: ["mounted"],
    setup(props, context) {
      const instance = getCurrentInstance();
      let instanceKey2 = {};
      instanceScopes.set(instanceKey2, []);
      const library = { FormKit: markRaw(FormKit_default), ...props.library };
      let provider = parseSchema(library, props.schema, props.memoKey);
      let render2;
      let data;
      if (!isServer2) {
        watch2(
          () => props.schema,
          (newSchema, oldSchema) => {
            const oldKey = instanceKey2;
            instanceKey2 = {};
            instanceScopes.set(instanceKey2, []);
            provider = parseSchema(library, props.schema, props.memoKey);
            render2 = createRenderFn(provider, data, instanceKey2);
            if (newSchema === oldSchema) {
              (instance?.proxy?.$forceUpdate)();
            }
            clean(props.schema, props.memoKey, oldKey);
          },
          { deep: true }
        );
      }
      watchEffect(() => {
        data = Object.assign(reactive(props.data ?? {}), {
          slots: context.slots
        });
        context.slots;
        render2 = createRenderFn(provider, data, instanceKey2);
      });
      function cleanUp2() {
        clean(props.schema, props.memoKey, instanceKey2);
        if (data) {
          if (data.node)
            data.node.destroy();
          data.slots = null;
          data = null;
        }
        render2 = null;
      }
      onMounted(() => context.emit("mounted"));
      onUnmounted(cleanUp2);
      onSSRComplete(getCurrentInstance()?.appContext.app, cleanUp2);
      return () => render2 ? render2() : null;
    }
  });
  var FormKitSchema_default = FormKitSchema;
  var isServer3 = typeof window === "undefined";
  var parentSymbol = Symbol("FormKitParent");
  var componentSymbol = Symbol("FormKitComponentCallback");
  var currentSchemaNode = null;
  function FormKit(props, context) {
    const node = useInput(props, context);
    if (!node.props.definition)
      error(600, node);
    if (node.props.definition.component) {
      return () => h(
        node.props.definition?.component,
        {
          context: node.context
        },
        { ...context.slots }
      );
    }
    const schema = ref([]);
    let memoKey = node.props.definition.schemaMemoKey;
    const generateSchema = () => {
      const schemaDefinition = node.props?.definition?.schema;
      if (!schemaDefinition)
        error(601, node);
      if (typeof schemaDefinition === "function") {
        currentSchemaNode = node;
        schema.value = schemaDefinition({ ...props.sectionsSchema || {} });
        currentSchemaNode = null;
        if (memoKey && props.sectionsSchema || "memoKey" in schemaDefinition && typeof schemaDefinition.memoKey === "string") {
          memoKey = (memoKey ?? schemaDefinition?.memoKey) + JSON.stringify(props.sectionsSchema);
        }
      } else {
        schema.value = schemaDefinition;
      }
    };
    generateSchema();
    if (!isServer3) {
      node.on("schema", () => {
        memoKey += "\u267B\uFE0F";
        generateSchema();
      });
    }
    context.emit("node", node);
    const definitionLibrary = node.props.definition.library;
    const library = {
      FormKit: markRaw(formkitComponent),
      ...definitionLibrary,
      ...props.library ?? {}
    };
    function didMount() {
      node.emit("mounted");
    }
    context.expose({ node });
    return () => h(
      FormKitSchema,
      {
        schema: schema.value,
        data: node.context,
        onMounted: didMount,
        library,
        memoKey
      },
      { ...context.slots }
    );
  }
  var formkitComponent = /* @__PURE__ */ defineComponent(
    FormKit,
    {
      props: runtimeProps,
      inheritAttrs: false
    }
  );
  var FormKit_default = formkitComponent;
  var rootSymbol = Symbol();
  function createPlugin(app2, options3) {
    app2.component(options3.alias || "FormKit", FormKit_default).component(options3.schemaAlias || "FormKitSchema", FormKitSchema_default);
    return {
      get: getNode,
      setLocale: (locale) => {
        if (options3.config?.rootConfig) {
          options3.config.rootConfig.locale = locale;
        }
      },
      clearErrors: clearErrors2,
      setErrors: setErrors2,
      submit: submitForm,
      reset: reset2
    };
  }
  var optionsSymbol = Symbol.for("FormKitOptions");
  var configSymbol = Symbol.for("FormKitConfig");
  var plugin = {
    install(app2, _options) {
      const options3 = Object.assign(
        {
          alias: "FormKit",
          schemaAlias: "FormKitSchema"
        },
        typeof _options === "function" ? _options() : _options
      );
      const rootConfig = createConfig(options3.config || {});
      options3.config = { rootConfig };
      app2.config.globalProperties.$formkit = createPlugin(app2, options3);
      app2.provide(optionsSymbol, options3);
      app2.provide(configSymbol, rootConfig);
      if (typeof window !== "undefined") {
        globalThis.__FORMKIT_CONFIGS__ = (globalThis.__FORMKIT_CONFIGS__ || []).concat([rootConfig]);
      }
    }
  };
  var isBrowser3 = typeof window !== "undefined";
  var pseudoProps = [
    // Boolean props
    "ignore",
    "disabled",
    "preserve",
    // String props
    "help",
    "label",
    /^preserve(-e|E)rrors/,
    /^[a-z]+(?:-visibility|Visibility|-behavior|Behavior)$/,
    /^[a-zA-Z-]+(?:-class|Class)$/,
    "prefixIcon",
    "suffixIcon",
    /^[a-zA-Z-]+(?:-icon|Icon)$/
  ];
  var boolProps = ["disabled", "ignore", "preserve"];
  function classesToNodeProps(node, props) {
    if (props.classes) {
      Object.keys(props.classes).forEach(
        (key) => {
          if (typeof key === "string") {
            node.props[`_${key}Class`] = props.classes[key];
            if (isObject2(props.classes[key]) && key === "inner")
              Object.values(props.classes[key]);
          }
        }
      );
    }
  }
  function onlyListeners(props) {
    if (!props)
      return {};
    const knownListeners = ["Submit", "SubmitRaw", "SubmitInvalid"].reduce(
      (listeners, listener) => {
        const name = `on${listener}`;
        if (name in props) {
          if (typeof props[name] === "function") {
            listeners[name] = props[name];
          }
        }
        return listeners;
      },
      {}
    );
    return knownListeners;
  }
  function useInput(props, context, options3 = {}) {
    const config = Object.assign({}, inject(optionsSymbol) || {}, options3);
    const __root = inject(rootSymbol, ref(isBrowser3 ? document : void 0));
    const __cmpCallback = inject(componentSymbol, () => {
    });
    const instance = getCurrentInstance();
    const listeners = onlyListeners(instance?.vnode.props);
    const isVModeled = ["modelValue", "model-value"].some(
      (prop) => prop in (instance?.vnode.props ?? {})
    );
    let isMounted = false;
    onMounted(() => {
      isMounted = true;
    });
    const value = props.modelValue !== void 0 ? props.modelValue : cloneAny(context.attrs.value);
    function createInitialProps() {
      const initialProps2 = {
        ...nodeProps(props),
        ...listeners,
        type: props.type ?? "text",
        __root: __root.value,
        __slots: context.slots
      };
      const attrs = except(nodeProps(context.attrs), pseudoProps);
      if (!attrs.key)
        attrs.key = token();
      initialProps2.attrs = attrs;
      const propValues = only(nodeProps(context.attrs), pseudoProps);
      for (const propName in propValues) {
        if (boolProps.includes(propName) && propValues[propName] === "") {
          propValues[propName] = true;
        }
        initialProps2[camel(propName)] = propValues[propName];
      }
      const classesProps = { props: {} };
      classesToNodeProps(classesProps, props);
      Object.assign(initialProps2, classesProps.props);
      if (typeof initialProps2.type !== "string") {
        initialProps2.definition = initialProps2.type;
        delete initialProps2.type;
      }
      return initialProps2;
    }
    const initialProps = createInitialProps();
    const parent2 = initialProps.ignore ? null : props.parent || inject(parentSymbol, null);
    const node = createNode(
      extend2(
        config || {},
        {
          name: props.name || void 0,
          value,
          parent: parent2,
          plugins: (config.plugins || []).concat(props.plugins ?? []),
          config: props.config || {},
          props: initialProps,
          index: props.index,
          sync: !!undefine(context.attrs.sync || context.attrs.dynamic)
        },
        false,
        true
      )
    );
    __cmpCallback(node);
    if (!node.props.definition)
      error(600, node);
    const lateBoundProps = ref(
      new Set(
        Array.isArray(node.props.__propDefs) ? node.props.__propDefs : Object.keys(node.props.__propDefs ?? {})
      )
    );
    node.on(
      "added-props",
      ({ payload: lateProps }) => {
        const propNames = Array.isArray(lateProps) ? lateProps : Object.keys(lateProps ?? {});
        propNames.forEach((newProp) => lateBoundProps.value.add(newProp));
      }
    );
    const pseudoPropNames = computed2(
      () => pseudoProps.concat([...lateBoundProps.value]).reduce((names, prop) => {
        if (typeof prop === "string") {
          names.push(camel(prop));
          names.push(kebab(prop));
        } else {
          names.push(prop);
        }
        return names;
      }, [])
    );
    watchEffect(() => classesToNodeProps(node, props));
    const passThrough = nodeProps(props);
    for (const prop in passThrough) {
      watch2(
        () => props[prop],
        () => {
          if (props[prop] !== void 0) {
            node.props[prop] = props[prop];
          }
        }
      );
    }
    watchEffect(() => {
      node.props.__root = __root.value;
    });
    const attributeWatchers = /* @__PURE__ */ new Set();
    const possibleProps = nodeProps(context.attrs);
    watchEffect(() => {
      watchAttributes(only(possibleProps, pseudoPropNames.value));
    });
    function watchAttributes(attrProps) {
      attributeWatchers.forEach((stop2) => {
        stop2();
        attributeWatchers.delete(stop2);
      });
      for (const prop in attrProps) {
        const camelName = camel(prop);
        attributeWatchers.add(
          watch2(
            () => context.attrs[prop],
            () => {
              node.props[camelName] = context.attrs[prop];
            }
          )
        );
      }
    }
    watchEffect(() => {
      const attrs = except(nodeProps(context.attrs), pseudoPropNames.value);
      if ("multiple" in attrs)
        attrs.multiple = undefine(attrs.multiple);
      if (typeof attrs.onBlur === "function") {
        attrs.onBlur = oncePerTick(attrs.onBlur);
      }
      node.props.attrs = Object.assign({}, node.props.attrs || {}, attrs);
    });
    watchEffect(() => {
      const messages3 = (props.errors ?? []).map(
        (error3) => /* @__PURE__ */ createMessage({
          key: slugify(error3),
          type: "error",
          value: error3,
          meta: { source: "prop" }
        })
      );
      node.store.apply(
        messages3,
        (message3) => message3.type === "error" && message3.meta.source === "prop"
      );
    });
    if (node.type !== "input") {
      const sourceKey = `${node.name}-prop`;
      watchEffect(() => {
        const inputErrors = props.inputErrors ?? {};
        const keys = Object.keys(inputErrors);
        if (!keys.length)
          node.clearErrors(true, sourceKey);
        const messages3 = keys.reduce((messages4, key) => {
          let value2 = inputErrors[key];
          if (typeof value2 === "string")
            value2 = [value2];
          if (Array.isArray(value2)) {
            messages4[key] = value2.map(
              (error3) => /* @__PURE__ */ createMessage({
                key: error3,
                type: "error",
                value: error3,
                meta: { source: sourceKey }
              })
            );
          }
          return messages4;
        }, {});
        node.store.apply(
          messages3,
          (message3) => message3.type === "error" && message3.meta.source === sourceKey
        );
      });
    }
    watchEffect(() => Object.assign(node.config, props.config));
    if (node.type !== "input") {
      provide(parentSymbol, node);
    }
    let clonedValueBeforeVmodel = void 0;
    node.on("modelUpdated", () => {
      context.emit("inputRaw", node.context?.value, node);
      if (isMounted) {
        context.emit("input", node.context?.value, node);
      }
      if (isVModeled && node.context) {
        clonedValueBeforeVmodel = cloneAny(node.value);
        context.emit("update:modelValue", shallowClone(node.value));
      }
    });
    if (isVModeled) {
      watch2(
        toRef(props, "modelValue"),
        (value2) => {
          if (!eq(clonedValueBeforeVmodel, value2)) {
            node.input(value2, false);
          }
        },
        { deep: true }
      );
      if (node.value !== value) {
        node.emit("modelUpdated");
      }
    }
    onBeforeUnmount(() => node.destroy());
    return node;
  }
  var messages2 = createSection("messages", () => ({
    $el: "ul",
    if: "$fns.length($messages)"
  }));
  var message2 = createSection("message", () => ({
    $el: "li",
    for: ["message", "$messages"],
    attrs: {
      key: "$message.key",
      id: `$id + '-' + $message.key`,
      "data-message-type": "$message.type"
    }
  }));
  var definition = messages2(message2("$message.value"));
  var summary = createSection("summary", () => ({
    $el: "div",
    attrs: {
      "aria-live": "polite"
    }
  }));
  var summaryInner = createSection("summaryInner", () => ({
    $el: "div",
    if: "$summaries.length && $showSummaries"
  }));
  var messages22 = createSection("messages", () => ({
    $el: "ul",
    if: "$summaries.length && $showSummaries"
  }));
  var message22 = createSection("message", () => ({
    $el: "li",
    for: ["summary", "$summaries"],
    attrs: {
      key: "$summary.key",
      "data-message-type": "$summary.type"
    }
  }));
  var summaryHeader = createSection("summaryHeader", () => ({
    $el: "h2",
    attrs: {
      id: "$id"
    }
  }));
  var messageLink = createSection("messageLink", () => ({
    $el: "a",
    attrs: {
      id: "$summary.key",
      href: '$: "#" + $summary.id',
      onClick: "$jumpLink"
    }
  }));
  var definition2 = summary(
    summaryInner(
      summaryHeader("$summaryHeader"),
      messages22(message22(messageLink("$summary.message")))
    )
  );
  init_defaultConfig();
  init_bindings();

  // node_modules/@formkit/auto-animate/index.mjs
  var parents = /* @__PURE__ */ new Set();
  var coords = /* @__PURE__ */ new WeakMap();
  var siblings = /* @__PURE__ */ new WeakMap();
  var animations = /* @__PURE__ */ new WeakMap();
  var intersections = /* @__PURE__ */ new WeakMap();
  var options2 = /* @__PURE__ */ new WeakMap();
  var debounces = /* @__PURE__ */ new WeakMap();
  var enabled = /* @__PURE__ */ new WeakSet();
  var root;
  var scrollX = 0;
  var scrollY = 0;
  var TGT = "__aa_tgt";
  var DEL = "__aa_del";
  var NEW = "__aa_new";
  var handleMutations = (mutations) => {
    const elements = getElements(mutations);
    if (elements) {
      elements.forEach((el) => animate(el));
    }
  };
  var handleResizes = (entries) => {
    entries.forEach((entry) => {
      if (entry.target === root)
        updateAllPos();
      if (coords.has(entry.target))
        updatePos(entry.target);
    });
  };
  function isOffscreen(el) {
    const rect = el.getBoundingClientRect();
    const vw = (root === null || root === void 0 ? void 0 : root.clientWidth) || 0;
    const vh = (root === null || root === void 0 ? void 0 : root.clientHeight) || 0;
    return rect.bottom < 0 || rect.top > vh || rect.right < 0 || rect.left > vw;
  }
  function observePosition(el) {
    const oldObserver = intersections.get(el);
    oldObserver === null || oldObserver === void 0 ? void 0 : oldObserver.disconnect();
    let rect = coords.get(el);
    let invocations = 0;
    const buffer2 = 5;
    if (!rect) {
      rect = getCoords(el);
      coords.set(el, rect);
    }
    const { offsetWidth, offsetHeight } = root;
    const rootMargins = [
      rect.top - buffer2,
      offsetWidth - (rect.left + buffer2 + rect.width),
      offsetHeight - (rect.top + buffer2 + rect.height),
      rect.left - buffer2
    ];
    const rootMargin = rootMargins.map((px) => `${-1 * Math.floor(px)}px`).join(" ");
    const observer = new IntersectionObserver(() => {
      ++invocations > 1 && updatePos(el);
    }, {
      root,
      threshold: 1,
      rootMargin
    });
    observer.observe(el);
    intersections.set(el, observer);
  }
  function updatePos(el, debounce = true) {
    clearTimeout(debounces.get(el));
    const optionsOrPlugin = getOptions(el);
    const delay = debounce ? isPlugin(optionsOrPlugin) ? 500 : optionsOrPlugin.duration : 0;
    debounces.set(el, setTimeout(async () => {
      const currentAnimation = animations.get(el);
      try {
        await (currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.finished);
        coords.set(el, getCoords(el));
        observePosition(el);
      } catch {
      }
    }, delay));
  }
  function updateAllPos() {
    clearTimeout(debounces.get(root));
    debounces.set(root, setTimeout(() => {
      parents.forEach((parent2) => forEach(parent2, (el) => lowPriority(() => updatePos(el))));
    }, 100));
  }
  function lowPriority(callback) {
    if (typeof requestIdleCallback === "function") {
      requestIdleCallback(() => callback());
    } else {
      requestAnimationFrame(() => callback());
    }
  }
  var resize;
  var supportedBrowser = typeof window !== "undefined" && "ResizeObserver" in window;
  if (supportedBrowser) {
    root = document.documentElement;
    new MutationObserver(handleMutations);
    resize = new ResizeObserver(handleResizes);
    window.addEventListener("scroll", () => {
      scrollY = window.scrollY;
      scrollX = window.scrollX;
    });
    resize.observe(root);
  }
  function getElements(mutations) {
    const observedNodes = mutations.reduce((nodes, mutation) => {
      return [
        ...nodes,
        ...Array.from(mutation.addedNodes),
        ...Array.from(mutation.removedNodes)
      ];
    }, []);
    const onlyCommentNodesObserved = observedNodes.every((node) => node.nodeName === "#comment");
    if (onlyCommentNodesObserved)
      return false;
    return mutations.reduce((elements, mutation) => {
      if (elements === false)
        return false;
      if (mutation.target instanceof Element) {
        target(mutation.target);
        if (!elements.has(mutation.target)) {
          elements.add(mutation.target);
          for (let i = 0; i < mutation.target.children.length; i++) {
            const child = mutation.target.children.item(i);
            if (!child)
              continue;
            if (DEL in child) {
              return false;
            }
            target(mutation.target, child);
            elements.add(child);
          }
        }
        if (mutation.removedNodes.length) {
          for (let i = 0; i < mutation.removedNodes.length; i++) {
            const child = mutation.removedNodes[i];
            if (DEL in child) {
              return false;
            }
            if (child instanceof Element) {
              elements.add(child);
              target(mutation.target, child);
              siblings.set(child, [
                mutation.previousSibling,
                mutation.nextSibling
              ]);
            }
          }
        }
      }
      return elements;
    }, /* @__PURE__ */ new Set());
  }
  function target(el, child) {
    if (!child && !(TGT in el))
      Object.defineProperty(el, TGT, { value: el });
    else if (child && !(TGT in child))
      Object.defineProperty(child, TGT, { value: el });
  }
  function animate(el) {
    var _a, _b;
    const isMounted = el.isConnected;
    const preExisting = coords.has(el);
    if (isMounted && siblings.has(el))
      siblings.delete(el);
    if (((_a = animations.get(el)) === null || _a === void 0 ? void 0 : _a.playState) !== "finished") {
      (_b = animations.get(el)) === null || _b === void 0 ? void 0 : _b.cancel();
    }
    if (NEW in el) {
      add2(el);
    } else if (preExisting && isMounted) {
      remain(el);
    } else if (preExisting && !isMounted) {
      remove2(el);
    } else {
      add2(el);
    }
  }
  function raw2(str) {
    return Number(str.replace(/[^0-9.\-]/g, ""));
  }
  function getScrollOffset(el) {
    let p2 = el.parentElement;
    while (p2) {
      if (p2.scrollLeft || p2.scrollTop) {
        return { x: p2.scrollLeft, y: p2.scrollTop };
      }
      p2 = p2.parentElement;
    }
    return { x: 0, y: 0 };
  }
  function getCoords(el) {
    const rect = el.getBoundingClientRect();
    const { x, y } = getScrollOffset(el);
    return {
      top: rect.top + y,
      left: rect.left + x,
      width: rect.width,
      height: rect.height
    };
  }
  function getTransitionSizes(el, oldCoords, newCoords) {
    let widthFrom = oldCoords.width;
    let heightFrom = oldCoords.height;
    let widthTo = newCoords.width;
    let heightTo = newCoords.height;
    const styles = getComputedStyle(el);
    const sizing = styles.getPropertyValue("box-sizing");
    if (sizing === "content-box") {
      const paddingY = raw2(styles.paddingTop) + raw2(styles.paddingBottom) + raw2(styles.borderTopWidth) + raw2(styles.borderBottomWidth);
      const paddingX = raw2(styles.paddingLeft) + raw2(styles.paddingRight) + raw2(styles.borderRightWidth) + raw2(styles.borderLeftWidth);
      widthFrom -= paddingX;
      widthTo -= paddingX;
      heightFrom -= paddingY;
      heightTo -= paddingY;
    }
    return [widthFrom, widthTo, heightFrom, heightTo].map(Math.round);
  }
  function getOptions(el) {
    return TGT in el && options2.has(el[TGT]) ? options2.get(el[TGT]) : { duration: 250, easing: "ease-in-out" };
  }
  function getTarget(el) {
    if (TGT in el)
      return el[TGT];
    return void 0;
  }
  function isEnabled(el) {
    const target2 = getTarget(el);
    return target2 ? enabled.has(target2) : false;
  }
  function forEach(parent2, ...callbacks) {
    callbacks.forEach((callback) => callback(parent2, options2.has(parent2)));
    for (let i = 0; i < parent2.children.length; i++) {
      const child = parent2.children.item(i);
      if (child) {
        callbacks.forEach((callback) => callback(child, options2.has(child)));
      }
    }
  }
  function getPluginTuple(pluginReturn) {
    if (Array.isArray(pluginReturn))
      return pluginReturn;
    return [pluginReturn];
  }
  function isPlugin(config) {
    return typeof config === "function";
  }
  function remain(el) {
    const oldCoords = coords.get(el);
    const newCoords = getCoords(el);
    if (!isEnabled(el))
      return coords.set(el, newCoords);
    if (isOffscreen(el)) {
      coords.set(el, newCoords);
      observePosition(el);
      return;
    }
    let animation;
    if (!oldCoords)
      return;
    const pluginOrOptions = getOptions(el);
    if (typeof pluginOrOptions !== "function") {
      let deltaLeft = oldCoords.left - newCoords.left;
      let deltaTop = oldCoords.top - newCoords.top;
      const deltaRight = oldCoords.left + oldCoords.width - (newCoords.left + newCoords.width);
      const deltaBottom = oldCoords.top + oldCoords.height - (newCoords.top + newCoords.height);
      if (deltaBottom == 0)
        deltaTop = 0;
      if (deltaRight == 0)
        deltaLeft = 0;
      const [widthFrom, widthTo, heightFrom, heightTo] = getTransitionSizes(el, oldCoords, newCoords);
      const start = {
        transform: `translate(${deltaLeft}px, ${deltaTop}px)`
      };
      const end = {
        transform: `translate(0, 0)`
      };
      if (widthFrom !== widthTo) {
        start.width = `${widthFrom}px`;
        end.width = `${widthTo}px`;
      }
      if (heightFrom !== heightTo) {
        start.height = `${heightFrom}px`;
        end.height = `${heightTo}px`;
      }
      animation = el.animate([start, end], {
        duration: pluginOrOptions.duration,
        easing: pluginOrOptions.easing
      });
    } else {
      const [keyframes] = getPluginTuple(pluginOrOptions(el, "remain", oldCoords, newCoords));
      animation = new Animation(keyframes);
      animation.play();
    }
    animations.set(el, animation);
    coords.set(el, newCoords);
    animation.addEventListener("finish", updatePos.bind(null, el, false), {
      once: true
    });
  }
  function add2(el) {
    if (NEW in el)
      delete el[NEW];
    const newCoords = getCoords(el);
    coords.set(el, newCoords);
    const pluginOrOptions = getOptions(el);
    if (!isEnabled(el))
      return;
    if (isOffscreen(el)) {
      observePosition(el);
      return;
    }
    let animation;
    if (typeof pluginOrOptions !== "function") {
      animation = el.animate([
        { transform: "scale(.98)", opacity: 0 },
        { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
        { transform: "scale(1)", opacity: 1 }
      ], {
        duration: pluginOrOptions.duration * 1.5,
        easing: "ease-in"
      });
    } else {
      const [keyframes] = getPluginTuple(pluginOrOptions(el, "add", newCoords));
      animation = new Animation(keyframes);
      animation.play();
    }
    animations.set(el, animation);
    animation.addEventListener("finish", updatePos.bind(null, el, false), {
      once: true
    });
  }
  function cleanUp(el, styles) {
    var _a;
    el.remove();
    coords.delete(el);
    siblings.delete(el);
    animations.delete(el);
    (_a = intersections.get(el)) === null || _a === void 0 ? void 0 : _a.disconnect();
    setTimeout(() => {
      if (DEL in el)
        delete el[DEL];
      Object.defineProperty(el, NEW, { value: true, configurable: true });
      if (styles && el instanceof HTMLElement) {
        for (const style in styles) {
          el.style[style] = "";
        }
      }
    }, 0);
  }
  function remove2(el) {
    var _a;
    if (!siblings.has(el) || !coords.has(el))
      return;
    const [prev, next] = siblings.get(el);
    Object.defineProperty(el, DEL, { value: true, configurable: true });
    const finalX = window.scrollX;
    const finalY = window.scrollY;
    if (next && next.parentNode && next.parentNode instanceof Element) {
      next.parentNode.insertBefore(el, next);
    } else if (prev && prev.parentNode) {
      prev.parentNode.appendChild(el);
    } else {
      (_a = getTarget(el)) === null || _a === void 0 ? void 0 : _a.appendChild(el);
    }
    if (!isEnabled(el))
      return cleanUp(el);
    const [top, left, width, height] = deletePosition(el);
    const optionsOrPlugin = getOptions(el);
    const oldCoords = coords.get(el);
    if (finalX !== scrollX || finalY !== scrollY) {
      adjustScroll(el, finalX, finalY, optionsOrPlugin);
    }
    let animation;
    let styleReset = {
      position: "absolute",
      top: `${top}px`,
      left: `${left}px`,
      width: `${width}px`,
      height: `${height}px`,
      margin: "0",
      pointerEvents: "none",
      transformOrigin: "center",
      zIndex: "100"
    };
    if (!isPlugin(optionsOrPlugin)) {
      Object.assign(el.style, styleReset);
      animation = el.animate([
        {
          transform: "scale(1)",
          opacity: 1
        },
        {
          transform: "scale(.98)",
          opacity: 0
        }
      ], {
        duration: optionsOrPlugin.duration,
        easing: "ease-out"
      });
    } else {
      const [keyframes, options3] = getPluginTuple(optionsOrPlugin(el, "remove", oldCoords));
      if ((options3 === null || options3 === void 0 ? void 0 : options3.styleReset) !== false) {
        styleReset = (options3 === null || options3 === void 0 ? void 0 : options3.styleReset) || styleReset;
        Object.assign(el.style, styleReset);
      }
      animation = new Animation(keyframes);
      animation.play();
    }
    animations.set(el, animation);
    animation.addEventListener("finish", () => cleanUp(el, styleReset), {
      once: true
    });
  }
  function adjustScroll(el, finalX, finalY, optionsOrPlugin) {
    const scrollDeltaX = scrollX - finalX;
    const scrollDeltaY = scrollY - finalY;
    const scrollBefore = document.documentElement.style.scrollBehavior;
    const scrollBehavior = getComputedStyle(root).scrollBehavior;
    if (scrollBehavior === "smooth") {
      document.documentElement.style.scrollBehavior = "auto";
    }
    window.scrollTo(window.scrollX + scrollDeltaX, window.scrollY + scrollDeltaY);
    if (!el.parentElement)
      return;
    const parent2 = el.parentElement;
    let lastHeight = parent2.clientHeight;
    let lastWidth = parent2.clientWidth;
    const startScroll = performance.now();
    function smoothScroll() {
      requestAnimationFrame(() => {
        if (!isPlugin(optionsOrPlugin)) {
          const deltaY = lastHeight - parent2.clientHeight;
          const deltaX = lastWidth - parent2.clientWidth;
          if (startScroll + optionsOrPlugin.duration > performance.now()) {
            window.scrollTo({
              left: window.scrollX - deltaX,
              top: window.scrollY - deltaY
            });
            lastHeight = parent2.clientHeight;
            lastWidth = parent2.clientWidth;
            smoothScroll();
          } else {
            document.documentElement.style.scrollBehavior = scrollBefore;
          }
        }
      });
    }
    smoothScroll();
  }
  function deletePosition(el) {
    var _a;
    const oldCoords = coords.get(el);
    const [width, , height] = getTransitionSizes(el, oldCoords, getCoords(el));
    let offsetParent = el.parentElement;
    while (offsetParent && (getComputedStyle(offsetParent).position === "static" || offsetParent instanceof HTMLBodyElement)) {
      offsetParent = offsetParent.parentElement;
    }
    if (!offsetParent)
      offsetParent = document.body;
    const parentStyles = getComputedStyle(offsetParent);
    const parentCoords = !animations.has(el) || ((_a = animations.get(el)) === null || _a === void 0 ? void 0 : _a.playState) === "finished" ? getCoords(offsetParent) : coords.get(offsetParent);
    const top = Math.round(oldCoords.top - parentCoords.top) - raw2(parentStyles.borderTopWidth);
    const left = Math.round(oldCoords.left - parentCoords.left) - raw2(parentStyles.borderLeftWidth);
    return [top, left, width, height];
  }

  // node_modules/@formkit/addons/dist/index.mjs
  var wrapper2 = createSection("wrapper", () => ({
    $el: "div",
    attrs: {
      "data-tab-style": "$tabStyle",
      "data-hide-labels": "$hideProgressLabels"
    }
  }));
  var badge = createSection("badge", () => ({
    $el: "span",
    attrs: {
      role: "presentation"
    }
  }));
  var stepActions = createSection("stepActions", () => ({
    $el: "div"
  }));
  var stepInner = createSection("stepInner", "div");
  var stepNext = createSection("stepNext", () => ({
    $el: "div",
    if: "$isLastStep === false || $stepIndex === 0",
    children: [
      {
        $cmp: "FormKit",
        bind: "$nextAttrs",
        props: {
          type: "button",
          label: {
            if: "$nextLabel",
            then: "$nextLabel",
            else: "$ui.next.value"
          },
          "data-next": "$isLastStep === false",
          onClick: "$handlers.next"
        }
      }
    ]
  }));
  var stepOuter = createSection("stepOuter", () => ({
    $el: "div",
    attrs: {
      key: "$id",
      "data-type": "step",
      "data-disabled": "$disabled || undefined",
      "data-invalid": "$state.valid === false && $state.validationVisible || undefined",
      "data-errors": "$state.errors || undefined",
      "data-submitted": "$state.submitted || undefined",
      id: "$id",
      role: "tabpanel",
      "aria-labelledby": '$node.parent.props.id + "_tab_" + $stepIndex',
      class: "$classes.step",
      hidden: "$isActiveStep === false || undefined"
    }
  }));
  var stepPrevious = createSection("stepPrevious", () => ({
    $el: "div",
    if: "$isFirstStep === false",
    children: [
      {
        $cmp: "FormKit",
        bind: "$previousAttrs",
        props: {
          type: "button",
          label: {
            if: "$previousLabel",
            then: "$previousLabel",
            else: "$ui.prev.value"
          },
          "data-prev": "$isFirstStep === false",
          onClick: "$handlers.previous"
        }
      }
    ]
  }));
  var steps = createSection("steps", () => ({
    $el: "div"
  }));
  var stepIcon = (sectionKey, el) => {
    return createSection(`${sectionKey}Icon`, () => {
      const rawIconProp = `_raw${sectionKey.charAt(0).toUpperCase()}${sectionKey.slice(1)}Icon`;
      return {
        if: `$step.${sectionKey}Icon && $step.${rawIconProp}`,
        then: {
          $el: `${el ? el : "span"}`,
          attrs: {
            class: `$classes.${sectionKey}Icon + " formkit-icon"`,
            innerHTML: `$step.${rawIconProp}`,
            role: "presentation",
            onClick: `$handlers.iconClick(${sectionKey})`
          }
        },
        else: {
          if: `$${sectionKey}Icon && $${rawIconProp}`,
          then: {
            $el: `${el ? el : "span"}`,
            attrs: {
              class: `$classes.${sectionKey}Icon + " formkit-icon"`,
              innerHTML: `$${rawIconProp}`,
              role: "presentation",
              onClick: `$handlers.iconClick(${sectionKey})`
            }
          }
        }
      };
    })();
  };
  var tab = createSection("tab", () => ({
    $el: "button",
    for: ["step", "index", "$fns.getSteps()"],
    attrs: {
      key: "$step.id",
      type: "button",
      onClick: "$step.makeActive",
      "data-active": "$step.isActiveStep",
      "data-valid": "$step.isValid",
      "data-visited": "$step.hasBeenVisited",
      role: "tab",
      id: '$id + "_tab_" + $index',
      "aria-selected": "$step.isActiveStep || false",
      "aria-controls": "$step.id",
      tabindex: {
        if: "$step.isActiveStep",
        then: "0",
        else: "-1"
      }
    }
  }));
  var tabLabel = createSection("tabLabel", () => ({
    $el: "span"
  }));
  var tabs = createSection("tabs", () => ({
    $el: "div",
    attrs: {
      role: "tablist"
    }
  }));
  var multiStepOuter = createSection("multiStepOuter", () => ({
    $el: "div",
    attrs: {
      key: "$id",
      id: "$id",
      class: "$classes.outer",
      "data-prerender": "$fns.preRenderSteps()",
      "data-family": "$family || undefined",
      "data-type": "$type",
      "data-multiple": '$attrs.multiple || ($type != "select" && $options != undefined) || undefined',
      "data-disabled": "$disabled || undefined",
      "data-invalid": "$state.valid === false && $state.validationVisible || undefined",
      "data-errors": "$state.errors || undefined",
      "data-submitted": "$state.submitted || undefined"
    }
  }));
  var multiStep = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: multiStepOuter(
      wrapper2(
        tabs(
          tab(
            $if(
              '$tabStyle === "tab" || ($tabStyle === "progress" && $hideProgressLabels === false)',
              tabLabel("$step.stepName")
            ),
            $if(
              "($step.totalErrorCount > 0) && $step.showStepErrors",
              badge("$step.totalErrorCount")
            ),
            $if(
              "$step.isValid && $step.hasBeenVisited",
              badge(stepIcon("validStep"))
            )
          )
        ),
        steps("$slots.default")
      )
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "group",
    /**
     * The family of inputs this one belongs too. For example "text" and "email"
     * are both part of the "text" family. This is primary used for styling.
     */
    family: "multi-step",
    /**
     * An array of extra props to accept for this input.
     */
    props: [
      "allowIncomplete",
      "hideProgressLabels",
      "tabStyle",
      "beforeStepChange",
      "validStepIcon"
    ],
    /**
     * Additional features that should be added to your input
     */
    features: [defaultIcon("validStep", "check"), disables]
  };
  var step = {
    /**
     * The actual schema of the input, or a function that returns the schema.
     */
    schema: stepOuter(
      stepInner("$slots.default"),
      stepActions(stepPrevious(), stepNext())
    ),
    /**
     * The type of node, can be a list, group, or input.
     */
    type: "group",
    /**
     * The family of inputs this one belongs too. For example "text" and "email"
     * are both part of the "text" family. This is primary used for styling.
     */
    family: "",
    /**
     * An array of extra props to accept for this input.
     */
    props: [
      "previousLabel",
      "nextLabel",
      "beforeStepChange",
      "previousAttrs",
      "nextAttrs",
      "validStepIcon"
    ],
    /**
     * Additional features that should be added to your input
     */
    features: [localize("next"), localize("prev"), disables]
  };
  var isBrowser4 = typeof window !== "undefined";
  var camel2title = (str) => {
    if (!str)
      return str;
    return str.replace(/([A-Z])/g, (match) => ` ${match}`).replace(/^./, (match) => match.toUpperCase()).trim();
  };
  function orderSteps(node, steps2) {
    if (!isBrowser4 || !steps2)
      return steps2;
    const orderedSteps = [...steps2];
    orderedSteps.sort((a, b) => {
      const aEl = node.props.__root?.getElementById(a.id);
      const bEl = node.props.__root?.getElementById(b.id);
      if (!aEl || !bEl)
        return 0;
      return aEl.compareDocumentPosition(bEl) === 2 ? 1 : -1;
    });
    orderedSteps.map((step2) => {
      step2.ordered = true;
    });
    return orderedSteps;
  }
  function setNodePositionProps(steps2) {
    if (!steps2)
      return;
    steps2.forEach((step2, index) => {
      step2.isFirstStep = index === 0;
      step2.isLastStep = index === steps2.length - 1;
      step2.stepIndex = index;
      step2.steps = steps2;
    });
  }
  function showStepErrors(step2) {
    if (!step2.showStepErrors)
      return;
    return parseInt(step2.blockingCount) + parseInt(step2.errorCount) > 0;
  }
  async function isTargetStepAllowed(currentStep, targetStep) {
    if (currentStep === targetStep)
      return true;
    const { allowIncomplete } = currentStep.node.parent?.props || {};
    const parentNode = currentStep.node.parent;
    const currentStepIndex = parentNode?.props.steps.indexOf(currentStep);
    const targetStepIndex = parentNode?.props.steps.indexOf(targetStep);
    const currentStepIsValid = triggerStepValidations(currentStep);
    currentStep.showStepErrors = true;
    if (targetStepIndex >= currentStepIndex) {
      if (!currentStepIsValid && !allowIncomplete) {
        return false;
      }
    }
    const delta = targetStepIndex - currentStepIndex;
    for (let i = 0; i < delta; i++) {
      const intermediateStep = parentNode?.props.steps[currentStepIndex + i];
      const stepIsAllowed = allowIncomplete || intermediateStep.state?.valid;
      if (!stepIsAllowed) {
        return false;
      }
    }
    const beforeStepChange = currentStep.node.props.beforeStepChange || currentStep.node.parent?.props.beforeStepChange;
    if (beforeStepChange && typeof beforeStepChange === "function") {
      if (parentNode) {
        parentNode?.store.set(
          /* @__PURE__ */ createMessage({
            key: "loading",
            value: true,
            visible: false
          })
        );
        parentNode.props.disabled = true;
        currentStep.disabled = true;
      }
      const result = await beforeStepChange({
        currentStep,
        targetStep,
        delta: targetStepIndex - currentStepIndex
      });
      if (parentNode) {
        parentNode?.store.remove("loading");
        parentNode.props.disabled = false;
        currentStep.disabled = false;
      }
      if (typeof result === "boolean" && !result)
        return false;
    }
    return true;
  }
  async function setActiveStep(targetStep, e) {
    if (e) {
      e.preventDefault();
    }
    if (targetStep && targetStep.node.name && targetStep.node.parent) {
      const currentStep = targetStep.node.parent.props.steps.find(
        (step2) => step2.node.name === targetStep.node.parent?.props.activeStep
      );
      const stepIsAllowed = await isTargetStepAllowed(currentStep, targetStep);
      if (stepIsAllowed && targetStep.node.parent.context) {
        targetStep.node.parent.props.activeStep = targetStep.node.name;
      }
    }
  }
  async function incrementStep(delta, currentStep) {
    if (currentStep && currentStep.node.name && currentStep.node.parent) {
      const steps2 = currentStep.node.parent.props.steps;
      const stepIndex = currentStep.stepIndex;
      const targetStep = steps2[stepIndex + delta];
      if (!targetStep)
        return;
      const stepIsAllowed = await isTargetStepAllowed(currentStep, targetStep);
      if (targetStep && stepIsAllowed) {
        currentStep.node.parent.props.activeStep = targetStep.node.name;
      }
    }
  }
  function triggerStepValidations(step2) {
    step2.node.walk((n) => {
      n.store.set(
        /* @__PURE__ */ createMessage({
          key: "submitted",
          value: true,
          visible: false
        })
      );
    });
    return step2.node.context?.state.valid || step2.node.parent?.props.allowIncomplete;
  }
  function initEvents(node, el) {
    if (!(el instanceof HTMLElement))
      return;
    el.addEventListener("keydown", (event) => {
      if (event.target instanceof HTMLButtonElement) {
        if (event.key === "Tab" && "data-next" in event.target?.attributes && !event.shiftKey) {
          event.preventDefault();
          const activeStepContext = node.children.find(
            (step2) => !isPlaceholder(step2) && step2.name === node.props.activeStep
          );
          if (activeStepContext && activeStepContext.context) {
            incrementStep(1, activeStepContext.context);
          }
        }
      }
    });
  }
  function createSSRStepsFromTabs(tabs2) {
    if (!tabs2 || !tabs2.length)
      return [];
    const tabsToRender = tabs2[0].type == Symbol.for("v-fgt") && tabs2[0].children ? tabs2[0].children : tabs2;
    const placeholderTabs = tabsToRender.map(
      (tab2, index) => {
        return {
          __isPlaceholder: true,
          stepName: tab2.props?.label || camel2title(tab2.props?.name),
          isFirstStep: index === 0,
          isLastStep: index === tabs2.length - 1,
          isActiveStep: index === 0,
          node: {
            name: tab2.props?.name
          }
        };
      }
    );
    return placeholderTabs;
  }
  function createPreRenderStepsFunction(node) {
    return () => {
      if (!node.context || node.props.steps)
        return;
      let tabs2 = [];
      if (node.context.slots && node.context.slots.default) {
        tabs2 = node.context.slots.default();
      }
      node.props.steps = node.props.steps || createSSRStepsFromTabs(tabs2);
      node.context.stepCount = node.props.steps.length;
    };
  }
  function createMultiStepPlugin(options3) {
    let isFirstStep = true;
    const multiStepPlugin = (node) => {
      if (node.props.type === "multi-step") {
        if (!node.context)
          return;
        isFirstStep = true;
        node.addProps(["steps", "tabs", "activeStep"]);
        node.context.fns.preRenderSteps = createPreRenderStepsFunction(node);
        node.context.fns.getStepCount = () => {
          if (!node.context)
            return;
          return node.context.stepCount;
        };
        node.context.fns.getSteps = () => {
          if (!node.context)
            return;
          return node.context.steps;
        };
        node.props.allowIncomplete = typeof node.props.allowIncomplete === "boolean" ? node.props.allowIncomplete : typeof options3?.allowIncomplete === "boolean" ? options3?.allowIncomplete : true;
        node.props.hideProgressLabels = typeof node.props.hideProgressLabels === "boolean" ? node.props.hideProgressLabels : options3?.hideProgressLabels || false;
        node.props.tabStyle = node.props.tabStyle || options3?.tabStyle || "tab";
        node.context.handlers.triggerStepValidations = triggerStepValidations;
        node.context.handlers.showStepErrors = showStepErrors;
        node.on("created", () => {
          if (!node.context)
            return;
          node.extend("next", {
            get: (node2) => () => {
              incrementStep(
                1,
                node2?.props?.steps.find(
                  (step2) => step2.isActiveStep
                )
              );
            },
            set: false
          });
          node.extend("previous", {
            get: (node2) => () => {
              incrementStep(
                -1,
                node2?.props?.steps.find(
                  (step2) => step2.isActiveStep
                )
              );
            },
            set: false
          });
          node.extend("goTo", {
            get: (node2) => (target2) => {
              if (typeof target2 === "number") {
                const targetStep = node2.props.steps[target2];
                setActiveStep(targetStep);
              } else if (typeof target2 === "string") {
                const targetStep = node2.props.steps.find(
                  (step2) => step2.node.name === target2
                );
                setActiveStep(targetStep);
              }
            },
            set: false
          });
          whenAvailable(
            `${node.props.id}`,
            (el) => {
              initEvents(node, el);
            },
            node.props.__root
          );
        });
        node.on("child", ({ payload: childNode }) => {
          if (node.props.steps && node.props.steps.length) {
            node.props.steps = node.props.steps.filter(
              (step2) => !step2.__isPlaceholder
            );
          }
          node.props.steps = Array.isArray(node.props.steps) && node.props.steps.length > 0 ? [...node.props.steps, childNode.context] : [childNode.context];
          node.props.steps = orderSteps(node, node.props.steps);
          setNodePositionProps(node.props.steps);
          childNode.props.stepName = childNode.props.label || camel2title(childNode.name);
          childNode.props.errorCount = 0;
          childNode.props.blockingCount = 0;
          childNode.props.isActiveStep = isFirstStep;
          isFirstStep = false;
          node.props.activeStep = node.props.activeStep ? node.props.activeStep : node.props.steps[0] ? node.props.steps[0].node.name : "";
        });
        node.on("prop:activeStep", ({ payload }) => {
          node.children.forEach((child) => {
            if (isPlaceholder(child))
              return;
            child.props.isActiveStep = child.name === payload;
            if (isBrowser4 && child.name === payload) {
              const el = node.props.__root?.querySelector(
                `[aria-controls="${child.props.id}"]`
              );
              if (el instanceof HTMLButtonElement) {
                el.focus();
              }
            }
          });
        });
        node.on("childRemoved", ({ payload: childNode }) => {
          let removedStepIndex = -1;
          childNode.props.ordered = false;
          node.props.steps = node.props.steps.filter(
            (step2, index) => {
              if (step2.node.name !== childNode.name) {
                return true;
              }
              removedStepIndex = index;
              return false;
            }
          );
          setNodePositionProps(node.props.steps);
          if (node.props.activeStep === childNode.name) {
            const targetIndex = removedStepIndex > 0 ? removedStepIndex - 1 : 0;
            node.props.activeStep = node.props.steps[targetIndex] ? node.props.steps[targetIndex].node.name : "";
          }
        });
      } else if (node.props.type === "step" && node.parent?.props.type === "multi-step") {
        let updateTotalErrorCount2 = function(node2) {
          node2.props.totalErrorCount = node2.props.errorCount + node2.props.blockingCount;
        };
        if (!node.context || !node.parent || !node.parent.context)
          return;
        node.addProps([
          "isActiveStep",
          "isFirstStep",
          "isLastStep",
          "stepName",
          "errorCount",
          "blockingCount",
          "totalErrorCount",
          "showStepErrors",
          "isValid",
          "hasBeenVisited",
          "ordered"
        ]);
        const parentNode = node.parent;
        node.on("created", () => {
          if (!node.context || !parentNode.context)
            return;
          whenAvailable(
            `${node.props.id}`,
            () => {
              parentNode.props.steps = orderSteps(node, parentNode.props.steps);
              setNodePositionProps(parentNode.props.steps);
            },
            node.props.__root
          );
        });
        if (node.context && parentNode.context) {
          parentNode.context.handlers.setActiveStep = (stepNode) => setActiveStep.bind(null, stepNode);
          node.context.handlers.incrementStep = (delta) => () => incrementStep(delta, node.context);
          node.context.makeActive = () => {
            setActiveStep(node.context);
          };
          node.context.handlers.next = () => incrementStep(1, node.context);
          node.context.handlers.previous = () => incrementStep(-1, node.context);
        }
        node.on("count:errors", ({ payload: count2 }) => {
          node.props.errorCount = count2;
        });
        node.on("count:blocking", ({ payload: count2 }) => {
          node.props.blockingCount = count2;
        });
        node.on("prop:errorCount", () => updateTotalErrorCount2(node));
        node.on("prop:blockingCount", () => updateTotalErrorCount2(node));
        node.on("prop:totalErrorCount", () => {
          node.props.isValid = node.props.totalErrorCount <= 0;
        });
        node.on("message-added", ({ payload }) => {
          if (payload.key === "submitted") {
            updateTotalErrorCount2(node);
            if (node.context) {
              triggerStepValidations(node.context);
              node.props.showStepErrors = true;
            }
          }
        });
        node.on("prop:isActiveStep", () => {
          if (!node.props.hasBeenVisited && node.props.isActiveStep) {
            node.props.hasBeenVisited = true;
          }
        });
      } else if (node.parent?.props.type === "multi-step") {
        console.warn(
          'Invalid FormKit input location. <FormKit type="multi-step"> should only have <FormKit type="step"> inputs as immediate children. Failure to wrap child inputs in <FormKit type="step"> can lead to undesired behaviors.'
        );
      }
    };
    multiStepPlugin.library = (node) => {
      switch (node.props.type) {
        case "multi-step":
          return node.define(multiStep);
        case "step":
          const isInvalid = !node.parent || node.parent.props.type !== "multi-step";
          if (isInvalid) {
            console.warn(
              'Invalid use of <FormKit type="step">. <FormKit type="step"> must be an immediate child of a <FormKit type="multi-step"> component.'
            );
          }
          return node.define(step);
      }
    };
    return multiStepPlugin;
  }

  // formkit.config.js
  var formkit_config_default = defaultConfig2({
    locales: { de },
    locale: "de",
    plugins: [createMultiStepPlugin()]
  });

  // vue-script:/Users/mona/Documents/workspace/tonton-shopify/src/js/components/map.vue?type=script
  var import_mapbox_gl = __toESM(require_mapbox_gl());

  // node_modules/@turf/helpers/dist/esm/index.js
  var earthRadius = 63710088e-1;
  var factors = {
    centimeters: earthRadius * 100,
    centimetres: earthRadius * 100,
    degrees: 360 / (2 * Math.PI),
    feet: earthRadius * 3.28084,
    inches: earthRadius * 39.37,
    kilometers: earthRadius / 1e3,
    kilometres: earthRadius / 1e3,
    meters: earthRadius,
    metres: earthRadius,
    miles: earthRadius / 1609.344,
    millimeters: earthRadius * 1e3,
    millimetres: earthRadius * 1e3,
    nauticalmiles: earthRadius / 1852,
    radians: 1,
    yards: earthRadius * 1.0936
  };
  function feature(geom, properties, options3 = {}) {
    const feat = { type: "Feature" };
    if (options3.id === 0 || options3.id) {
      feat.id = options3.id;
    }
    if (options3.bbox) {
      feat.bbox = options3.bbox;
    }
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
  }
  function point(coordinates, properties, options3 = {}) {
    if (!coordinates) {
      throw new Error("coordinates is required");
    }
    if (!Array.isArray(coordinates)) {
      throw new Error("coordinates must be an Array");
    }
    if (coordinates.length < 2) {
      throw new Error("coordinates must be at least 2 numbers long");
    }
    if (!isNumber(coordinates[0]) || !isNumber(coordinates[1])) {
      throw new Error("coordinates must contain numbers");
    }
    const geom = {
      type: "Point",
      coordinates
    };
    return feature(geom, properties, options3);
  }
  function polygon(coordinates, properties, options3 = {}) {
    for (const ring of coordinates) {
      if (ring.length < 4) {
        throw new Error(
          "Each LinearRing of a Polygon must have 4 or more Positions."
        );
      }
      if (ring[ring.length - 1].length !== ring[0].length) {
        throw new Error("First and last Position are not equivalent.");
      }
      for (let j = 0; j < ring[ring.length - 1].length; j++) {
        if (ring[ring.length - 1][j] !== ring[0][j]) {
          throw new Error("First and last Position are not equivalent.");
        }
      }
    }
    const geom = {
      type: "Polygon",
      coordinates
    };
    return feature(geom, properties, options3);
  }
  function radiansToLength(radians, units = "kilometers") {
    const factor = factors[units];
    if (!factor) {
      throw new Error(units + " units is invalid");
    }
    return radians * factor;
  }
  function lengthToRadians(distance2, units = "kilometers") {
    const factor = factors[units];
    if (!factor) {
      throw new Error(units + " units is invalid");
    }
    return distance2 / factor;
  }
  function radiansToDegrees(radians) {
    const normalisedRadians = radians % (2 * Math.PI);
    return normalisedRadians * 180 / Math.PI;
  }
  function degreesToRadians(degrees) {
    const normalisedDegrees = degrees % 360;
    return normalisedDegrees * Math.PI / 180;
  }
  function isNumber(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
  }

  // node_modules/@turf/invariant/dist/esm/index.js
  function getCoord(coord) {
    if (!coord) {
      throw new Error("coord is required");
    }
    if (!Array.isArray(coord)) {
      if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") {
        return [...coord.geometry.coordinates];
      }
      if (coord.type === "Point") {
        return [...coord.coordinates];
      }
    }
    if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) {
      return [...coord];
    }
    throw new Error("coord must be GeoJSON Point or an Array of numbers");
  }

  // node_modules/@turf/destination/dist/esm/index.js
  function destination(origin, distance2, bearing, options3 = {}) {
    const coordinates1 = getCoord(origin);
    const longitude1 = degreesToRadians(coordinates1[0]);
    const latitude1 = degreesToRadians(coordinates1[1]);
    const bearingRad = degreesToRadians(bearing);
    const radians = lengthToRadians(distance2, options3.units);
    const latitude2 = Math.asin(
      Math.sin(latitude1) * Math.cos(radians) + Math.cos(latitude1) * Math.sin(radians) * Math.cos(bearingRad)
    );
    const longitude2 = longitude1 + Math.atan2(
      Math.sin(bearingRad) * Math.sin(radians) * Math.cos(latitude1),
      Math.cos(radians) - Math.sin(latitude1) * Math.sin(latitude2)
    );
    const lng = radiansToDegrees(longitude2);
    const lat = radiansToDegrees(latitude2);
    return point([lng, lat], options3.properties);
  }

  // node_modules/@turf/distance/dist/esm/index.js
  function distance(from, to, options3 = {}) {
    var coordinates1 = getCoord(from);
    var coordinates2 = getCoord(to);
    var dLat = degreesToRadians(coordinates2[1] - coordinates1[1]);
    var dLon = degreesToRadians(coordinates2[0] - coordinates1[0]);
    var lat1 = degreesToRadians(coordinates1[1]);
    var lat2 = degreesToRadians(coordinates2[1]);
    var a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    return radiansToLength(
      2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)),
      options3.units
    );
  }

  // node_modules/@turf/meta/dist/esm/index.js
  function coordEach(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords2, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop2 = isFeatureCollection ? geojson.features.length : 1;
    for (var featureIndex = 0; featureIndex < stop2; featureIndex++) {
      geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
      isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
      stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
      for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
        var multiFeatureIndex = 0;
        var geometryIndex = 0;
        geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
        if (geometry === null) continue;
        coords2 = geometry.coordinates;
        var geomType = geometry.type;
        wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
        switch (geomType) {
          case null:
            break;
          case "Point":
            if (callback(
              coords2,
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false)
              return false;
            coordIndex++;
            multiFeatureIndex++;
            break;
          case "LineString":
          case "MultiPoint":
            for (j = 0; j < coords2.length; j++) {
              if (callback(
                coords2[j],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false)
                return false;
              coordIndex++;
              if (geomType === "MultiPoint") multiFeatureIndex++;
            }
            if (geomType === "LineString") multiFeatureIndex++;
            break;
          case "Polygon":
          case "MultiLineString":
            for (j = 0; j < coords2.length; j++) {
              for (k = 0; k < coords2[j].length - wrapShrink; k++) {
                if (callback(
                  coords2[j][k],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false)
                  return false;
                coordIndex++;
              }
              if (geomType === "MultiLineString") multiFeatureIndex++;
              if (geomType === "Polygon") geometryIndex++;
            }
            if (geomType === "Polygon") multiFeatureIndex++;
            break;
          case "MultiPolygon":
            for (j = 0; j < coords2.length; j++) {
              geometryIndex = 0;
              for (k = 0; k < coords2[j].length; k++) {
                for (l = 0; l < coords2[j][k].length - wrapShrink; l++) {
                  if (callback(
                    coords2[j][k][l],
                    coordIndex,
                    featureIndex,
                    multiFeatureIndex,
                    geometryIndex
                  ) === false)
                    return false;
                  coordIndex++;
                }
                geometryIndex++;
              }
              multiFeatureIndex++;
            }
            break;
          case "GeometryCollection":
            for (j = 0; j < geometry.geometries.length; j++)
              if (coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false)
                return false;
            break;
          default:
            throw new Error("Unknown Geometry Type");
        }
      }
    }
  }

  // node_modules/@turf/bbox/dist/esm/index.js
  function bbox(geojson, options3 = {}) {
    if (geojson.bbox != null && true !== options3.recompute) {
      return geojson.bbox;
    }
    const result = [Infinity, Infinity, -Infinity, -Infinity];
    coordEach(geojson, (coord) => {
      if (result[0] > coord[0]) {
        result[0] = coord[0];
      }
      if (result[1] > coord[1]) {
        result[1] = coord[1];
      }
      if (result[2] < coord[0]) {
        result[2] = coord[0];
      }
      if (result[3] < coord[1]) {
        result[3] = coord[1];
      }
    });
    return result;
  }

  // node_modules/@turf/circle/dist/esm/index.js
  function circle(center, radius, options3 = {}) {
    const steps2 = options3.steps || 64;
    const properties = options3.properties ? options3.properties : !Array.isArray(center) && center.type === "Feature" && center.properties ? center.properties : {};
    const coordinates = [];
    for (let i = 0; i < steps2; i++) {
      coordinates.push(
        destination(center, radius, i * -360 / steps2, options3).geometry.coordinates
      );
    }
    coordinates.push(coordinates[0]);
    return polygon([coordinates], properties);
  }

  // vue-script:/Users/mona/Documents/workspace/tonton-shopify/src/js/components/map.vue?type=script
  var _hoisted_1 = {
    key: 0,
    class: "hm:absolute hm:inset-0 hm:w-full hm:h-max-full hm:h-[70vh] hm:overflow-hidden hm:rounded-2xl hm:bg-gray-200 hm:flex hm:items-center hm:justify-center hm:p-12 hm:text-center"
  };
  var map_default = {
    __name: "map",
    props: {
      goals: {
        type: Array,
        required: true
      },
      currentGoal: {
        type: String,
        required: true
      },
      shouldZoomToGermany: {
        type: Boolean,
        default: false
      },
      umkreisCoords: {
        type: Array,
        default: null
      },
      umkreisRadius: {
        type: [Number, String],
        default: 25
      },
      zoomToUmkreis: {
        type: Boolean,
        default: false
      }
    },
    emits: ["goalChanged"],
    setup(__props, { emit: __emit }) {
      const props = __props;
      import_mapbox_gl.default.accessToken = "pk.eyJ1IjoiaGVycmxpY2gtbWVkaWEiLCJhIjoiY2xrbWNqOHIxMWxncjNvcnp5bG43NGwyMiJ9.iovcIqHyqXr027ymiK45EQ";
      let center = [];
      let map2 = null;
      let markerData = [];
      let markers = [];
      let c = null;
      const mapContainer = ref(null);
      const emit3 = __emit;
      let circleId = "umkreis-circle";
      let circleSourceId = "umkreis-circle-source";
      const allowMapbox = ref(false);
      onMounted(() => {
        if (typeof window.CCM == "object" && CCM.acceptedEmbeddings) {
          checkConsent();
        } else {
          allowMapbox.value = false;
        }
      });
      function embeddingExists(name) {
        return CCM.acceptedEmbeddings.some((el) => {
          return el.name === name;
        });
      }
      function checkConsent() {
        if (embeddingExists("Mapbox")) {
          initMap();
        } else {
          allowMapbox.value = false;
          if (localStorage.getItem("contentblocker") != null) {
            const storage = JSON.parse(localStorage.getItem("contentblocker"));
            if (storage.mapbox == true) {
              initMap();
            }
          }
        }
      }
      function initMap() {
        allowMapbox.value = true;
        const storage = JSON.parse(localStorage.getItem("contentblocker")) || {};
        storage.mapbox = true;
        localStorage.setItem("contentblocker", JSON.stringify(storage));
        map2 = new import_mapbox_gl.default.Map({
          container: mapContainer.value,
          style: "mapbox://styles/herrlich-media/cl2ps5141001015lf50w714yp"
        });
        addMarkers(props.goals);
        map2.on("style.load", () => {
          addMarkers(markerData.length ? markerData : props.goals);
        });
        map2.on("load", () => {
          const layers = map2.getStyle().layers;
          if (layers) {
            layers.forEach((layer) => {
              if (layer.type === "symbol" && layer.layout && layer.layout["text-field"]) {
                if (layer.layout["text-field"].includes("name")) {
                  map2.setLayoutProperty(layer.id, "text-field", ["get", "name_de"]);
                }
              }
            });
          }
        });
        map2.addControl(new import_mapbox_gl.default.NavigationControl(), "bottom-right");
        map2.on("click", (e) => {
          emit3("goalChanged", goal.title);
        });
        if (props.shouldZoomToGermany) {
          map2.flyTo({ center: [10.4515, 51.1657], zoom: 5 });
        }
        map2.scrollZoom.disable();
      }
      function addMarkers(goals) {
        markerData = goals;
        if (markers.length > 0) {
          markers.forEach((m) => m.remove());
          markers = [];
        }
        if (goals.length > 0) {
          for (let i = 0; i < goals.length; i++) {
            const goal2 = goals[i];
            if (goal2.long != "" && goal2.lat != "" && goal2.long != null && goal2.lat != null && !isNaN(goal2.long) && !isNaN(goal2.lat)) {
              const popupHtml = `
                        <div class="hm:flex hm:flex-col hm:gap-2 hm:max-w-48">
                            <div class="hm:w-full hm:h-16">
                                ${goal2.image ? `<img src="${goal2.image}" loading="lazy" alt="${goal2.title}" class="hm:w-full hm:h-full hm:object-contain" />` : ""}
                            </div>
                            <h4 class="hm:!font-sans hm:!font-bold hm:!text-base hm:!leading-tight hm:px-2">${goal2.title}</h4>
                            ${goal2.address ? `<p class="hm:text-sm hm:text-gray-600 hm:px-2">${goal2.address}</p>` : ""}
                        </div>
                    `;
              const popup = new import_mapbox_gl.default.Popup({
                closeButton: false,
                closeOnClick: false,
                offset: 12,
                // Offset für den kleineren Kreis
                maxWidth: "300px"
              }).setHTML(popupHtml);
              const pinElement = document.createElement("div");
              pinElement.innerHTML = `
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
                                    <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.3)"/>
                                </filter>
                            </defs>
                            <circle cx="12" cy="12" r="8" fill="var(--accent-color)" stroke="white" stroke-width="2" filter="url(#shadow)"/>
                        </svg>
                    `;
              const marker = new import_mapbox_gl.default.Marker({
                element: pinElement,
                anchor: "bottom"
                // Pin-Spitze zeigt auf den genauen Punkt
              }).setLngLat([goal2.long, goal2.lat]).setPopup(popup).addTo(map2);
              marker.getElement().addEventListener("mouseenter", () => marker.togglePopup());
              marker.getElement().addEventListener("mouseleave", () => marker.togglePopup());
              marker.getElement().addEventListener("click", (e) => {
                e.stopPropagation();
                emit3("goalChanged", goal2.title);
              });
              markers.push(marker);
            }
          }
        }
      }
      function drawCircle(coords2, radiusKm) {
        if (!map2 || !coords2 || !radiusKm) return;
        removeCircle();
        const circle2 = circle(coords2, Number(radiusKm), { units: "kilometers", steps: 80 });
        map2.addSource(circleSourceId, {
          type: "geojson",
          data: circle2
        });
        map2.addLayer({
          id: circleId,
          type: "fill",
          source: circleSourceId,
          layout: {},
          paint: {
            "fill-color": "#2196f3",
            "fill-opacity": 0.18
          }
        });
        map2.addLayer({
          id: circleId + "-outline",
          type: "line",
          source: circleSourceId,
          layout: {},
          paint: {
            "line-color": "#2196f3",
            "line-width": 2
          }
        });
      }
      function removeCircle() {
        if (!map2) return;
        if (map2.getLayer(circleId)) map2.removeLayer(circleId);
        if (map2.getLayer(circleId + "-outline")) map2.removeLayer(circleId + "-outline");
        if (map2.getSource(circleSourceId)) map2.removeSource(circleSourceId);
      }
      watch2(
        () => props.zoomToUmkreis,
        (val) => {
          if (val && props.umkreisCoords && props.umkreisRadius && map2) {
            drawCircle(props.umkreisCoords, props.umkreisRadius);
            const circle2 = circle(props.umkreisCoords, Number(props.umkreisRadius), { units: "kilometers", steps: 80 });
            const bbox2 = bbox(circle2);
            map2.fitBounds([[bbox2[0], bbox2[1]], [bbox2[2], bbox2[3]]], { padding: 40 });
          }
        }
      );
      watch2(
        () => props.umkreisCoords,
        (coords2) => {
          if (!coords2) {
            removeCircle();
          }
        }
      );
      watch2(
        () => props.shouldZoomToGermany,
        (newVal) => {
          if (newVal && map2) {
            map2.flyTo({
              center: [10.4515, 51.1657],
              zoom: 5,
              duration: 1e3,
              essential: true
            });
          }
        },
        { immediate: true }
      );
      watch2(
        () => props.goals,
        (newGoals) => {
          if (map2 && newGoals) {
            addMarkers(newGoals);
          }
        },
        { deep: true }
      );
      return (_ctx, _cache) => {
        return openBlock(), createElementBlock(
          Fragment,
          null,
          [
            allowMapbox.value == false ? (openBlock(), createElementBlock("div", _hoisted_1, [
              createBaseVNode("div", { class: "hm:flex hm:flex-col hm:gap-4" }, [
                _cache[0] || (_cache[0] = createBaseVNode(
                  "p",
                  { class: "hm:text-gray-500" },
                  "Mapbox ist nicht verf\xFCgbar. Bitte akzeptiere die Cookies, um die Karte anzuzeigen.",
                  -1
                  /* HOISTED */
                )),
                createBaseVNode("div", null, [
                  createBaseVNode("button", {
                    class: "button button--primary focus-inset",
                    onClick: initMap
                  }, "Karte laden")
                ])
              ])
            ])) : createCommentVNode("v-if", true),
            createBaseVNode(
              "div",
              {
                ref_key: "mapContainer",
                ref: mapContainer,
                class: "mapboxContainer hm:w-full hm:h-max-full hm:h-[70vh] hm:overflow-hidden hm:rounded-2xl"
              },
              null,
              512
              /* NEED_PATCH */
            )
          ],
          64
          /* STABLE_FRAGMENT */
        );
      };
    }
  };

  // src/js/components/map.vue
  var map_default2 = map_default;

  // vue-script:/Users/mona/Documents/workspace/tonton-shopify/src/js/components/info.vue?type=script
  var info_default = {
    __name: "info",
    props: {
      goal: {
        type: Object,
        required: true
      }
    },
    setup(__props) {
      const props = __props;
      return (_ctx, _cache) => {
        return createCommentVNode(` <div class="hm:group hm:absolute hm:right-3 hm:bottom-3">
        <span class="hm:block hm:w-5 hm:h-5 hm:bg-dark hm:rounded-full hm:text-center hm:opacity-50">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#171B1C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.25 11.25H12V16.5H12.75" stroke="#171B1C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.8125 9C12.4338 9 12.9375 8.49632 12.9375 7.875C12.9375 7.25368 12.4338 6.75 11.8125 6.75C11.1912 6.75 10.6875 7.25368 10.6875 7.875C10.6875 8.49632 11.1912 9 11.8125 9Z" fill="#171B1C"/>
            </svg>

        </span>

        <div class="hm:opacity-0 hm:absolute hm:invisible hm:group-hover:opacity-100 hm:group-hover:visible hm:transition-opacity hm:duration-300 hm:bg-white hm:rounded-2xl hm:p-6 hm:w-[300px] hm:z-10 hm:flex hm:flex-col hm:gap-4 hm:text-left">

            <h5 class="h6 hm:!leading-5">{{ goal.title }}</h5>
            <p v-if="goal.address">{{ goal.address }}</p>

            <p v-if="goal.description">{{ goal.description }}</p>

            <a
                v-if="goal.link_url"
                :href="goal.link_url"
                class="button button--simple button--arrow focus-inset"
                target="_blank"
            >
                <span v-if="goal.link_text == ''">Mehr erfahren</span>
                <span v-else>{{ goal.link_text }}</span>

                <svg class="icon icon-button-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.30644 5.5C6.89223 5.5 6.55644 5.83579 6.55644 6.25C6.55644 6.66421 6.89223 7 7.30644 7L12.5669 7L5.5976 13.9693C5.30471 14.2622 5.30471 14.7371 5.5976 15.0299C5.89049 15.3228 6.36537 15.3228 6.65826 15.0299L13.6275 8.06069V13.3211C13.6275 13.7353 13.9633 14.0711 14.3775 14.0711C14.7917 14.0711 15.1275 13.7353 15.1275 13.3211V6.25C15.1275 6.14102 15.1043 6.03747 15.0625 5.94404C15.034 5.88021 14.9961 5.81955 14.9489 5.76414C14.8817 5.68521 14.7985 5.62038 14.7042 5.5747C14.6055 5.52684 14.4946 5.5 14.3775 5.5H7.30644Z" fill="currentColor"></path>
                </svg>
            </a>

        </div>
    </div> `);
      };
    }
  };

  // src/js/components/info.vue
  var info_default2 = info_default;

  // vue-script:/Users/mona/Documents/workspace/tonton-shopify/src/js/components/popup.vue?type=script
  var _hoisted_12 = { class: "hm:flex hm:gap-6 hm:items-center hm:justify-between hm:mb-6 hm:pe-12" };
  var _hoisted_2 = { class: "title" };
  var _hoisted_3 = {
    key: 0,
    class: "hm:flex hm:flex-col hm:gap-2 hm:md:grid hm:md:gap-4 hm:md:grid-cols-12 hm:relative"
  };
  var _hoisted_4 = { class: "charityItems hm:flex hm:flex-col hm:gap-4 hm:col-span-4 hm:md:overflow-y-auto hm:md:max-h-[70vh]" };
  var _hoisted_5 = { class: "hm:relative hm:flex hm:flex-col hm:w-full hm:gap-4" };
  var _hoisted_6 = { class: "hm:w-full hm:h-20 hm:overflow-hidden hm:relative hm:flex hm:items-center hm:justify-center" };
  var _hoisted_7 = ["src", "alt"];
  var _hoisted_8 = { class: "hm:px-4 hm:pb-2 hm:!font-sans hm:!font-bold hm:!text-xl hm:!leading-4" };
  var _hoisted_9 = ["value", "id", "onChange"];
  var _hoisted_10 = {
    key: 1,
    class: "hm:col-span-4 hm:text-center hm:py-8 hm:text-gray-500",
    role: "status"
  };
  var _hoisted_11 = { class: "hm:col-span-8 hm:relative hm:-order-1 hm:md:order-2" };
  var _hoisted_122 = ["aria-expanded"];
  var _hoisted_13 = {
    key: 0,
    class: "hm:absolute hm:-top-0.5 hm:-right-0.5 hm:w-3 hm:h-3 hm:bg-red-500 hm:rounded-full hm:border-2 hm:border-white",
    title: "Aktive Filter"
  };
  var _hoisted_14 = {
    key: 0,
    class: "hm:absolute hm:top-12 hm:md:top-4 hm:left-0 hm:md:left-auto hm:right-0 hm:md:right-4 hm:w-80 hm:max-w-full hm:bg-white hm:rounded-lg hm:shadow-xl hm:border hm:border-gray-200 hm:z-50"
  };
  var _hoisted_15 = { class: "hm:p-4 hm:space-y-4" };
  var _hoisted_16 = { class: "hm:relative" };
  var _hoisted_17 = { class: "hm:relative" };
  var _hoisted_18 = {
    key: 0,
    class: "hm:relative hm:inset-0 hm:w-full hm:h-max-full hm:overflow-hidden hm:rounded-2xl hm:bg-gray-200 hm:flex hm:items-center hm:justify-center hm:p-12 hm:text-center"
  };
  var _hoisted_19 = {
    key: 1,
    class: "hm:space-y-3"
  };
  var _hoisted_20 = { class: "hm:hidden hm:md:block" };
  var _hoisted_21 = {
    key: 0,
    class: "hm:mt-1 hm:text-sm hm:text-red-600 hm:flex hm:items-center hm:gap-1"
  };
  var _hoisted_22 = { class: "hm:flex hm:gap-2" };
  var _hoisted_23 = { class: "hm:flex-1 hm:hidden hm:md:block" };
  var _hoisted_24 = {
    key: 0,
    class: "hm:pt-3 hm:border-t hm:border-gray-200"
  };
  var _hoisted_25 = { class: "hm:space-y-2" };
  var _hoisted_26 = {
    key: 0,
    class: "hm:flex hm:items-center hm:justify-between hm:px-3 hm:py-2 hm:bg-blue-50 hm:rounded-md"
  };
  var _hoisted_27 = { class: "hm:text-sm hm:text-blue-800" };
  var _hoisted_28 = {
    key: 1,
    class: "hm:flex hm:items-center hm:justify-between hm:px-3 hm:py-2 hm:bg-green-50 hm:rounded-md"
  };
  var _hoisted_29 = { class: "hm:text-sm hm:text-green-800" };
  var popup_default = {
    __name: "popup",
    props: {
      goals: {
        type: String,
        required: true
      },
      preselectedCurrentGoal: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: "W\xE4hle dein Spendenziel"
      }
    },
    emits: ["goalChanged"],
    setup(__props, { emit: __emit }) {
      const props = __props;
      const allowUmkreisSearch = ref(false);
      const emit3 = __emit;
      const currentGoal = ref("");
      const allGoals = ref(JSON.parse(props.goals));
      const zoomToGermany = ref(true);
      const zoomToUmkreis = ref(false);
      const isTabletOrLarger = ref(false);
      const checkScreenSize = () => {
        isTabletOrLarger.value = window.innerWidth >= 768;
      };
      const searchTerm = ref("");
      const searchVisible = ref(false);
      const searchInput = ref(null);
      const toggleSearch = () => {
        searchVisible.value = !searchVisible.value;
        if (searchVisible.value) {
          nextTick(() => {
            if (searchInput.value) searchInput.value.focus();
          });
        }
      };
      const hideSearch = () => {
        searchVisible.value = false;
      };
      const filteredGoals = computed2(() => {
        let filtered = allGoals.value;
        if (searchTerm.value) {
          filtered = filtered.filter(
            (goal2) => goal2.title && goal2.title.toLowerCase().includes(searchTerm.value.toLowerCase())
          );
        }
        if (umkreisAktiv.value && umkreisCoords.value && umkreisRadius.value) {
          filtered = filtered.filter((goal2) => {
            if (!goal2.long || !goal2.lat || goal2.long === "" || goal2.lat === "") {
              return false;
            }
            try {
              const distance2 = distance(
                [goal2.long, goal2.lat],
                umkreisCoords.value,
                { units: "kilometers" }
              );
              return distance2 <= umkreisRadius.value;
            } catch (error2) {
              console.warn("Fehler bei Distanzberechnung f\xFCr:", goal2.title, error2);
              return false;
            }
          });
        }
        return filtered;
      });
      const resetSearch = () => {
        searchTerm.value = "";
        if (searchInput.value) searchInput.value.focus();
      };
      const changeGoal = (goal2) => {
        emit3("goalChanged", goal2.title ? goal2.title : goal2);
        window.dispatchEvent(new CustomEvent("changegoal", { detail: { goal: goal2 } }));
      };
      const umkreisOrt = ref("");
      const umkreisRadius = ref(25);
      const umkreisOrtInput = ref(null);
      const umkreisCoords = ref(null);
      const umkreisAktiv = ref(false);
      const ortError = ref("");
      const timeoutId = ref(null);
      const clearOrtError = () => {
        ortError.value = "";
      };
      const searchOrt = async (ort) => {
        if (!ort || ort.trim() === "") {
          ortError.value = "";
          umkreisCoords.value = null;
          return;
        }
        try {
          const url4 = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(ort)}`;
          const res = await fetch(url4, { headers: { "Accept-Language": "de" } });
          const data = await res.json();
          if (!data || !data[0]) {
            ortError.value = "Ort nicht gefunden. Bitte \xFCberpr\xFCfe deine Eingabe.";
            umkreisCoords.value = null;
            return;
          }
          const lat = parseFloat(data[0].lat);
          const lon = parseFloat(data[0].lon);
          umkreisCoords.value = [lon, lat];
          ortError.value = "";
        } catch (error2) {
          console.error("Fehler bei der Ortssuche:", error2);
          ortError.value = "Fehler bei der Ortssuche. Bitte versuche es erneut.";
          umkreisCoords.value = null;
        }
      };
      const onOrtInput = () => {
        if (timeoutId.value) {
          clearTimeout(timeoutId.value);
        }
        clearOrtError();
        timeoutId.value = setTimeout(() => {
          searchOrt(umkreisOrt.value);
        }, 500);
      };
      const starteUmkreissuche = async () => {
        if (searchTerm.value && (!umkreisOrt.value || !umkreisRadius.value)) {
          hideSearch();
          return;
        }
        if (!umkreisOrt.value || !umkreisRadius.value) return;
        if (!umkreisCoords.value) {
          ortError.value = "Bitte warte, bis der Ort gefunden wurde.";
          return;
        }
        umkreisAktiv.value = true;
        zoomToUmkreis.value = true;
        setTimeout(() => {
          zoomToUmkreis.value = false;
        }, 100);
        hideSearch();
      };
      const resetUmkreissuche = () => {
        umkreisAktiv.value = false;
        umkreisCoords.value = null;
        zoomToGermany.value = true;
        umkreisOrt.value = "";
        zoomToGermany.value = true;
        setTimeout(() => {
          zoomToGermany.value = false;
        }, 200);
      };
      const umkreisRadiusValue = computed2(() => {
        if (umkreisAktiv.value && umkreisCoords.value) {
          return umkreisRadius.value;
        }
        return null;
      });
      const resetAllFilters = () => {
        searchTerm.value = "";
        umkreisOrt.value = "";
        umkreisRadius.value = 25;
        umkreisCoords.value = null;
        umkreisAktiv.value = false;
        ortError.value = "";
        if (timeoutId.value) {
          clearTimeout(timeoutId.value);
          timeoutId.value = null;
        }
        zoomToGermany.value = true;
        setTimeout(() => {
          zoomToGermany.value = false;
        }, 200);
        hideSearch();
      };
      const hasActiveFilters = computed2(() => {
        return searchTerm.value || umkreisAktiv.value;
      });
      const checkConsent = () => {
        console.log("Checking consent for OpenStreetMap embedding");
        if (embeddingExists("OpenStreetMap")) {
          console.log("OpenStreetMap embedding accepted");
          initUmkreisSearch();
        } else {
          console.log("OpenStreetMap embedding not accepted");
          allowUmkreisSearch.value = false;
          if (localStorage.getItem("contentblocker") != null) {
            console.log("OpenStreetMap Content blocker found in localStorage");
            const storage = JSON.parse(localStorage.getItem("contentblocker"));
            console.log("Content blocker storage:", storage);
            if (storage.openStreetMap == true) {
              initUmkreisSearch();
            }
          }
        }
      };
      const embeddingExists = (name) => {
        return CCM.acceptedEmbeddings.some((el) => {
          return el.name === name;
        });
      };
      const initUmkreisSearch = () => {
        console.log("Initializing Umkreissuche");
        allowUmkreisSearch.value = true;
        const storage = JSON.parse(localStorage.getItem("contentblocker")) || {};
        storage.openStreetMap = true;
        localStorage.setItem("contentblocker", JSON.stringify(storage));
      };
      onMounted(() => {
        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);
        if (typeof window.CCM == "object" && CCM.acceptedEmbeddings) {
          console.log("Accepted Embeddings:");
          console.log("Number of accepted embeddings:", CCM.acceptedEmbeddings.length);
          console.log("Embedding names:", CCM.acceptedEmbeddings.map((embedding) => embedding.name));
          checkConsent();
        } else {
          allowUmkreisSearch.value = false;
        }
      });
      onUnmounted(() => {
        window.removeEventListener("resize", checkScreenSize);
      });
      return (_ctx, _cache) => {
        return openBlock(), createElementBlock(
          Fragment,
          null,
          [
            createBaseVNode("div", _hoisted_12, [
              createBaseVNode(
                "h3",
                _hoisted_2,
                toDisplayString(__props.title),
                1
                /* TEXT */
              )
            ]),
            createCommentVNode(" Charity List "),
            allGoals.value ? (openBlock(), createElementBlock("div", _hoisted_3, [
              createBaseVNode("div", _hoisted_4, [
                filteredGoals.value.length > 0 ? (openBlock(true), createElementBlock(
                  Fragment,
                  { key: 0 },
                  renderList(filteredGoals.value, (goal2) => {
                    return openBlock(), createElementBlock(
                      "label",
                      {
                        key: goal2.handle,
                        class: normalizeClass(["product__text-icon product__text-icon--shadow hm:!bg-white hm:flex hm:flex-col hm:transition hm:cursor-pointer hm:border-4 hm:text-center hm:hover:border-button-500 hm:opacity-80 hm:hover:opacity-100 hm:relative hm:hover:z-10 hm:!p-6", { "hm:border-[var(--color-foreground-title)] hm:opacity-100": __props.preselectedCurrentGoal === goal2.title, "hm:border-transparent": __props.preselectedCurrentGoal !== goal2.title }])
                      },
                      [
                        createBaseVNode("div", _hoisted_5, [
                          createBaseVNode("div", _hoisted_6, [
                            goal2.image ? (openBlock(), createElementBlock("img", {
                              key: 0,
                              src: goal2.image,
                              alt: `${goal2.title} Logo`,
                              class: "hm:max-w-full hm:max-h-full"
                            }, null, 8, _hoisted_7)) : createCommentVNode("v-if", true)
                          ]),
                          createBaseVNode(
                            "h4",
                            _hoisted_8,
                            toDisplayString(goal2.title),
                            1
                            /* TEXT */
                          )
                        ]),
                        createBaseVNode("input", {
                          type: "radio",
                          name: "Spendenziel",
                          value: goal2.title,
                          id: goal2.handle,
                          onChange: ($event) => changeGoal(goal2),
                          class: "hm:sr-only"
                        }, null, 40, _hoisted_9),
                        createCommentVNode(` <a
                        v-if="goal.link_url"
                        :href="goal.link_url"
                        class="button button--simple button--arrow focus-inset"
                        target="_blank"
                    >
                        <span v-if="goal.link_text == ''">Mehr erfahren</span>
                        <span v-else>{{ goal.link_text }}</span>
                        <svg class="icon icon-button-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.30644 5.5C6.89223 5.5 6.55644 5.83579 6.55644 6.25C6.55644 6.66421 6.89223 7 7.30644 7L12.5669 7L5.5976 13.9693C5.30471 14.2622 5.30471 14.7371 5.5976 15.0299C5.89049 15.3228 6.36537 15.3228 6.65826 15.0299L13.6275 8.06069V13.3211C13.6275 13.7353 13.9633 14.0711 14.3775 14.0711C14.7917 14.0711 15.1275 13.7353 15.1275 13.3211V6.25C15.1275 6.14102 15.1043 6.03747 15.0625 5.94404C15.034 5.88021 14.9961 5.81955 14.9489 5.76414C14.8817 5.68521 14.7985 5.62038 14.7042 5.5747C14.6055 5.52684 14.4946 5.5 14.3775 5.5H7.30644Z" fill="currentColor"></path>
                        </svg>
                    </a> `),
                        createVNode(info_default2, { goal: goal2 }, null, 8, ["goal"])
                      ],
                      2
                      /* CLASS */
                    );
                  }),
                  128
                  /* KEYED_FRAGMENT */
                )) : (openBlock(), createElementBlock("div", _hoisted_10, " Keine Treffer gefunden. "))
              ]),
              createBaseVNode("div", _hoisted_11, [
                createBaseVNode("button", {
                  onClick: toggleSearch,
                  class: "hm:relative hm:md:absolute hm:top-0 hm:right-0 hm:left-0 hm:md:top-4 hm:md:left-auto hm:md:right-4 hm:z-40 hm:p-3 hm:rounded-lg hm:bg-white hm:shadow-md hm:flex hm:items-center hm:justify-center hm:pointer-cursor focus:hm:outline-none focus:hm:ring-2 focus:hm:ring-button hover:hm:shadow-lg hm:transition-all",
                  "aria-label": "Filter \xF6ffnen",
                  "aria-expanded": searchVisible.value.toString(),
                  type: "button"
                }, [
                  _cache[3] || (_cache[3] = createBaseVNode(
                    "svg",
                    {
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "hm:w-5 hm:h-5 hm:text-gray-600",
                      viewBox: "0 0 512 512"
                    },
                    [
                      createBaseVNode("path", {
                        d: "M35.4 87.12l168.65 196.44A16.07 16.07 0 01208 294v119.32a7.93 7.93 0 005.39 7.59l80.15 26.67A7.94 7.94 0 00304 440V294a16.07 16.07 0 014-10.44L476.6 87.12A14 14 0 00466 64H46.05A14 14 0 0035.4 87.12z",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "32"
                      })
                    ],
                    -1
                    /* HOISTED */
                  )),
                  createCommentVNode(" Aktive Filter Indikator "),
                  hasActiveFilters.value ? (openBlock(), createElementBlock("div", _hoisted_13)) : createCommentVNode("v-if", true)
                ], 8, _hoisted_122),
                createCommentVNode(" Dropdown Filter Container "),
                searchVisible.value ? (openBlock(), createElementBlock("div", _hoisted_14, [
                  createCommentVNode(" Filter Header "),
                  createBaseVNode("div", { class: "hm:flex hm:items-center hm:justify-between hm:p-4 hm:border-b hm:border-gray-200" }, [
                    _cache[5] || (_cache[5] = createBaseVNode(
                      "h4",
                      { class: "hm:text-lg hm:font-semibold hm:text-gray-800" },
                      "Filter & Suche",
                      -1
                      /* HOISTED */
                    )),
                    createBaseVNode("button", {
                      onClick: hideSearch,
                      class: "hm:p-1 hm:rounded-full hover:hm:bg-gray-100 hm:transition-colors",
                      type: "button",
                      "aria-label": "Filter schlie\xDFen"
                    }, _cache[4] || (_cache[4] = [
                      createBaseVNode(
                        "svg",
                        {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "hm:w-5 hm:h-5 hm:text-gray-500",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        },
                        [
                          createBaseVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ],
                        -1
                        /* HOISTED */
                      )
                    ]))
                  ]),
                  createCommentVNode(" Filter Content "),
                  createBaseVNode("div", _hoisted_15, [
                    createCommentVNode(" Text-Suche "),
                    createBaseVNode("div", null, [
                      _cache[7] || (_cache[7] = createBaseVNode(
                        "label",
                        {
                          for: "searchTerm",
                          class: "hm:block hm:text-sm hm:font-medium hm:text-gray-700 hm:mb-2"
                        },
                        " Nach Namen suchen ",
                        -1
                        /* HOISTED */
                      )),
                      createBaseVNode("div", _hoisted_16, [
                        withDirectives(createBaseVNode(
                          "input",
                          {
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchTerm.value = $event),
                            placeholder: "Spendenziel eingeben...",
                            id: "searchTerm",
                            class: "hm:w-full hm:px-3 hm:py-2 hm:border hm:border-gray-300 hm:rounded-md focus:hm:outline-none focus:hm:ring-2 focus:hm:ring-button focus:hm:border-transparent",
                            ref_key: "searchInput",
                            ref: searchInput,
                            onKeydown: withKeys(hideSearch, ["esc"]),
                            autocomplete: "off"
                          },
                          null,
                          544
                          /* NEED_HYDRATION, NEED_PATCH */
                        ), [
                          [vModelText, searchTerm.value]
                        ]),
                        searchTerm.value ? (openBlock(), createElementBlock("button", {
                          key: 0,
                          onClick: resetSearch,
                          class: "hm:absolute hm:right-2 hm:top-1/2 hm:-translate-y-1/2 hm:p-1 hm:rounded-full hover:hm:bg-gray-100 hm:transition-colors",
                          type: "button",
                          "aria-label": "Suche zur\xFCcksetzen"
                        }, _cache[6] || (_cache[6] = [
                          createBaseVNode(
                            "svg",
                            {
                              xmlns: "http://www.w3.org/2000/svg",
                              class: "hm:w-4 hm:h-4 hm:text-gray-400",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            },
                            [
                              createBaseVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M6 18L18 6M6 6l12 12"
                              })
                            ],
                            -1
                            /* HOISTED */
                          )
                        ]))) : createCommentVNode("v-if", true)
                      ])
                    ]),
                    createCommentVNode(" Umkreissuche "),
                    createBaseVNode("div", _hoisted_17, [
                      _cache[12] || (_cache[12] = createBaseVNode(
                        "label",
                        { class: "hm:hidden hm:md:block hm:text-sm hm:font-medium hm:text-gray-700 hm:mb-2" },
                        " Umkreissuche ",
                        -1
                        /* HOISTED */
                      )),
                      allowUmkreisSearch.value == false ? (openBlock(), createElementBlock("div", _hoisted_18, [
                        createBaseVNode("div", { class: "hm:flex hm:flex-col hm:gap-4" }, [
                          _cache[8] || (_cache[8] = createBaseVNode(
                            "p",
                            { class: "hm:text-gray-500" },
                            "Umkreissuche ist nicht verf\xFCgbar. Bitte akzeptiere die Cookies, um die Suche zu verwenden.",
                            -1
                            /* HOISTED */
                          )),
                          createBaseVNode("div", null, [
                            createBaseVNode("button", {
                              class: "button button--primary focus-inset",
                              onClick: initUmkreisSearch
                            }, "Umkreissuche laden")
                          ])
                        ])
                      ])) : createCommentVNode("v-if", true),
                      allowUmkreisSearch.value == true ? (openBlock(), createElementBlock("div", _hoisted_19, [
                        createBaseVNode("div", _hoisted_20, [
                          _cache[10] || (_cache[10] = createBaseVNode(
                            "label",
                            {
                              for: "umkreisOrt",
                              class: "hm:block hm:text-xs hm:text-gray-600 hm:mb-1"
                            },
                            "Ort",
                            -1
                            /* HOISTED */
                          )),
                          withDirectives(createBaseVNode(
                            "input",
                            {
                              type: "text",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => umkreisOrt.value = $event),
                              placeholder: "Stadt oder Ort eingeben...",
                              id: "umkreisOrt",
                              class: "hm:w-full hm:px-3 hm:py-2 hm:border hm:border-gray-300 hm:rounded-md focus:hm:outline-none focus:hm:ring-2 focus:hm:ring-button focus:hm:border-transparent",
                              ref_key: "umkreisOrtInput",
                              ref: umkreisOrtInput,
                              autocomplete: "off",
                              onInput: onOrtInput
                            },
                            null,
                            544
                            /* NEED_HYDRATION, NEED_PATCH */
                          ), [
                            [vModelText, umkreisOrt.value]
                          ]),
                          createCommentVNode(" Fehlermeldung f\xFCr Ort nicht gefunden "),
                          ortError.value ? (openBlock(), createElementBlock("div", _hoisted_21, [
                            _cache[9] || (_cache[9] = createBaseVNode(
                              "svg",
                              {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "hm:w-4 hm:h-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              },
                              [
                                createBaseVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                              ],
                              -1
                              /* HOISTED */
                            )),
                            createTextVNode(
                              " " + toDisplayString(ortError.value),
                              1
                              /* TEXT */
                            )
                          ])) : createCommentVNode("v-if", true)
                        ]),
                        createBaseVNode("div", _hoisted_22, [
                          createBaseVNode("div", _hoisted_23, [
                            _cache[11] || (_cache[11] = createBaseVNode(
                              "label",
                              {
                                for: "umkreisRadius",
                                class: "hm:block hm:text-xs hm:text-gray-600 hm:mb-1"
                              },
                              "Radius",
                              -1
                              /* HOISTED */
                            )),
                            withDirectives(createBaseVNode(
                              "input",
                              {
                                type: "number",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => umkreisRadius.value = $event),
                                placeholder: "KM",
                                id: "umkreisRadius",
                                class: "hm:w-full hm:px-3 hm:py-2 hm:border hm:border-gray-300 hm:rounded-md focus:hm:outline-none focus:hm:ring-2 focus:hm:ring-button focus:hm:border-transparent",
                                min: "1",
                                max: "500"
                              },
                              null,
                              512
                              /* NEED_PATCH */
                            ), [
                              [
                                vModelText,
                                umkreisRadius.value,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          createBaseVNode("div", { class: "hm:flex hm:items-end" }, [
                            createBaseVNode("button", {
                              onClick: starteUmkreissuche,
                              class: "hm:px-4 hm:py-2 hm:bg-button hm:text-white hm:rounded-md hover:hm:bg-button/90 focus:hm:outline-none focus:hm:ring-2 focus:hm:ring-button focus:hm:ring-offset-2 hm:transition-colors",
                              type: "button"
                            }, " Suchen ")
                          ])
                        ])
                      ])) : createCommentVNode("v-if", true)
                    ]),
                    createCommentVNode(" Aktive Filter anzeigen "),
                    umkreisAktiv.value || searchTerm.value ? (openBlock(), createElementBlock("div", _hoisted_24, [
                      _cache[13] || (_cache[13] = createBaseVNode(
                        "h5",
                        { class: "hm:text-sm hm:font-medium hm:text-gray-700 hm:mb-2" },
                        "Aktive Filter:",
                        -1
                        /* HOISTED */
                      )),
                      createBaseVNode("div", _hoisted_25, [
                        searchTerm.value ? (openBlock(), createElementBlock("div", _hoisted_26, [
                          createBaseVNode(
                            "span",
                            _hoisted_27,
                            'Text: "' + toDisplayString(searchTerm.value) + '"',
                            1
                            /* TEXT */
                          ),
                          createBaseVNode("button", {
                            onClick: resetSearch,
                            class: "hm:text-blue-600 hover:hm:text-blue-800 hm:text-xs"
                          }, "Entfernen")
                        ])) : createCommentVNode("v-if", true),
                        umkreisAktiv.value ? (openBlock(), createElementBlock("div", _hoisted_28, [
                          createBaseVNode(
                            "span",
                            _hoisted_29,
                            toDisplayString(umkreisRadius.value) + "km um " + toDisplayString(umkreisOrt.value),
                            1
                            /* TEXT */
                          ),
                          createBaseVNode("button", {
                            onClick: resetUmkreissuche,
                            class: "hm:text-green-600 hover:hm:text-green-800 hm:text-xs"
                          }, "Entfernen")
                        ])) : createCommentVNode("v-if", true)
                      ]),
                      createCommentVNode(" Alle Filter zur\xFCcksetzen Button "),
                      createBaseVNode("div", { class: "hm:pt-3" }, [
                        createBaseVNode("button", {
                          onClick: resetAllFilters,
                          class: "hm:w-full hm:px-4 hm:py-2 hm:bg-gray-100 hm:text-gray-700 hm:rounded-md hover:hm:bg-gray-200 focus:hm:outline-none focus:hm:ring-2 focus:hm:ring-gray-400 focus:hm:ring-offset-2 hm:transition-colors hm:font-medium",
                          type: "button"
                        }, " Alle Filter zur\xFCcksetzen ")
                      ])
                    ])) : createCommentVNode("v-if", true)
                  ])
                ])) : createCommentVNode("v-if", true),
                createCommentVNode(" Karte nur auf Tablets und gr\xF6\xDFeren Ger\xE4ten anzeigen "),
                isTabletOrLarger.value ? (openBlock(), createBlock(map_default2, {
                  key: 1,
                  onGoalChanged: changeGoal,
                  currentGoal: currentGoal.value,
                  goals: filteredGoals.value,
                  umkreisCoords: umkreisAktiv.value ? umkreisCoords.value : null,
                  umkreisRadius: umkreisAktiv.value ? umkreisRadiusValue.value : null,
                  shouldZoomToGermany: zoomToGermany.value,
                  zoomToUmkreis: zoomToUmkreis.value
                }, null, 8, ["currentGoal", "goals", "umkreisCoords", "umkreisRadius", "shouldZoomToGermany", "zoomToUmkreis"])) : createCommentVNode("v-if", true)
              ])
            ])) : createCommentVNode("v-if", true)
          ],
          64
          /* STABLE_FRAGMENT */
        );
      };
    }
  };

  // src/js/components/popup.vue
  var popup_default2 = popup_default;

  // vue-script:/Users/mona/Documents/workspace/tonton-shopify/src/js/components/goal.vue?type=script
  var _hoisted_110 = { class: "hm:gap-4 hm:flex hm:flex-col hm:max-w-full" };
  var _hoisted_210 = {
    key: 0,
    class: "hm:w-full hm:h-20 hm:overflow-hidden hm:relative hm:flex hm:items-center hm:justify-center"
  };
  var _hoisted_32 = ["src", "alt"];
  var _hoisted_42 = { class: "hm:px-4 hm:pb-2 hm:!font-sans hm:!font-bold hm:!text-lg hm:!leading-4" };
  var _hoisted_52 = ["value", "id"];
  var goal_default = {
    __name: "goal",
    props: {
      goal: {
        type: Object,
        required: true
      },
      currentGoal: {
        type: String,
        required: true
      }
    },
    emits: ["goalChanged"],
    setup(__props, { emit: __emit }) {
      const props = __props;
      const emit3 = __emit;
      const changeGoal = (goal2) => {
        emit3("goalChanged", goal2);
        window.dispatchEvent(new CustomEvent("changegoal", { detail: { goal: goal2 } }));
      };
      return (_ctx, _cache) => {
        return openBlock(), createElementBlock(
          "label",
          {
            "aria-disabled": "false",
            class: normalizeClass(["product__text-icon product__text-icon--shadow hm:!bg-white hm:flex hm:flex-col hm:min-h-full hm:transition hm:cursor-pointer hm:text-center hm:opacity-50 hm:hover:opacity-100 hm:relative hm:hover:z-10 hm:!p-6", { "hm:border-[var(--color-foreground-title)] hm:opacity-100": __props.currentGoal === __props.goal.title, "": __props.currentGoal !== __props.goal.title }])
          },
          [
            createBaseVNode("div", _hoisted_110, [
              __props.goal.image ? (openBlock(), createElementBlock("div", _hoisted_210, [
                createBaseVNode("img", {
                  src: __props.goal.image,
                  alt: `${__props.goal.title} Logo`,
                  class: "hm:max-w-full hm:max-h-full"
                }, null, 8, _hoisted_32)
              ])) : createCommentVNode("v-if", true),
              createBaseVNode(
                "h4",
                _hoisted_42,
                toDisplayString(__props.goal.title),
                1
                /* TEXT */
              )
            ]),
            createBaseVNode("input", {
              type: "radio",
              name: "Spendenziel",
              value: __props.goal.title,
              id: __props.goal.handle,
              onChange: _cache[0] || (_cache[0] = ($event) => changeGoal(__props.goal.title)),
              class: "hm:sr-only"
            }, null, 40, _hoisted_52),
            createVNode(info_default2, { goal: __props.goal }, null, 8, ["goal"])
          ],
          2
          /* CLASS */
        );
      };
    }
  };

  // src/js/components/goal.vue
  var goal_default2 = goal_default;

  // vue-script:/Users/mona/Documents/workspace/tonton-shopify/src/js/components/charity.vue?type=script
  var _hoisted_111 = {
    key: 0,
    class: "charityItems hm:grid hm:grid-cols-1 hm:md:grid-cols-2 hm:lg:grid-cols-3 hm:gap-4 hm:w-full hm:mt-6 hm:!list-none"
  };
  var _hoisted_211 = {
    class: "product-popup__button button button--simple button--arrow focus-inset hm:mt-6 hm:!text-[rgb(var(--color-foreground-secondary))]",
    type: "button",
    "aria-haspopup": "dialog"
  };
  var _hoisted_33 = {
    key: 0,
    class: "hm:fixed hm:inset-0 hm:bg-overlay-100 hm:backdrop-blur-xs hm:z-100 hm:pointer-events-none hm:w-[100vw]"
  };
  var numPreviewItems = 3;
  var charity_default = {
    __name: "charity",
    props: {
      goals: {
        type: String,
        required: true
      },
      title: {
        type: String,
        default: "W\xE4hle dein Spendenziel"
      },
      btnTitle: {
        type: String,
        default: "Weitere Spendenziele"
      }
    },
    setup(__props) {
      const props = __props;
      const currentGoal = ref("");
      const allGoals = ref(JSON.parse(props.goals));
      const filteredGoals = ref([]);
      let hadFirst = false;
      const showPopup = ref(false);
      const customDiv = ref(null);
      const toggle = () => {
        showPopup.value = !showPopup.value;
      };
      const handleClickOutside = (event) => {
        if (customDiv.value && !customDiv.value.contains(event.target)) {
          showPopup.value = false;
        }
      };
      const changeGoal = (goal2) => {
        const wasPopupOpen = showPopup.value;
        showPopup.value = false;
        if (wasPopupOpen && !filteredGoals.value.some((g) => g.title === goal2)) {
          const newGoal = allGoals.value.find((g) => g.title === goal2);
          if (newGoal) {
            filteredGoals.value[0] = newGoal;
            currentGoal.value = newGoal.title;
          }
        } else {
          currentGoal.value = goal2;
        }
        window.dispatchEvent(new CustomEvent("changegoal", { detail: { goal: goal2 } }));
      };
      onMounted(() => {
        document.addEventListener("click", handleClickOutside);
        for (let i = 0; i < allGoals.value.length; i++) {
          const goal2 = allGoals.value[i];
          if (filteredGoals.value.length < numPreviewItems) {
            if (goal2.preselected == "true") {
              changeGoal(goal2.title);
              filteredGoals.value.unshift(goal2);
              hadFirst = true;
            } else if (hadFirst == false && filteredGoals.value.length < numPreviewItems - 1 || hadFirst == true && filteredGoals.value.length <= numPreviewItems) {
              filteredGoals.value.push(goal2);
            }
          } else {
            break;
          }
        }
      });
      onUnmounted(() => {
        document.removeEventListener("click", handleClickOutside);
      });
      return (_ctx, _cache) => {
        return openBlock(), createElementBlock(
          Fragment,
          null,
          [
            allGoals.value ? (openBlock(), createElementBlock("ul", _hoisted_111, [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList(filteredGoals.value, (goalItem) => {
                  return openBlock(), createElementBlock(
                    "li",
                    {
                      key: goalItem.handle,
                      class: normalizeClass({ "hm:block": currentGoal.value === goalItem.title, "hm:!hidden hm:lg:!block": currentGoal.value !== goalItem.title })
                    },
                    [
                      createVNode(goal_default2, {
                        goal: goalItem,
                        currentGoal: currentGoal.value,
                        onGoalChanged: changeGoal
                      }, null, 8, ["goal", "currentGoal"])
                    ],
                    2
                    /* CLASS */
                  );
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ])) : createCommentVNode("v-if", true),
            createCommentVNode(" <span>value: {{currentGoal}}</span> "),
            createBaseVNode(
              "div",
              {
                ref_key: "customDiv",
                ref: customDiv
              },
              [
                createBaseVNode("div", { onClick: toggle }, [
                  createBaseVNode("button", _hoisted_211, [
                    createBaseVNode(
                      "span",
                      null,
                      toDisplayString(__props.btnTitle),
                      1
                      /* TEXT */
                    ),
                    _cache[1] || (_cache[1] = createBaseVNode(
                      "svg",
                      {
                        class: "icon icon-button-arrow",
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none"
                      },
                      [
                        createBaseVNode("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.30644 5.5C6.89223 5.5 6.55644 5.83579 6.55644 6.25C6.55644 6.66421 6.89223 7 7.30644 7L12.5669 7L5.5976 13.9693C5.30471 14.2622 5.30471 14.7371 5.5976 15.0299C5.89049 15.3228 6.36537 15.3228 6.65826 15.0299L13.6275 8.06069V13.3211C13.6275 13.7353 13.9633 14.0711 14.3775 14.0711C14.7917 14.0711 15.1275 13.7353 15.1275 13.3211V6.25C15.1275 6.14102 15.1043 6.03747 15.0625 5.94404C15.034 5.88021 14.9961 5.81955 14.9489 5.76414C14.8817 5.68521 14.7985 5.62038 14.7042 5.5747C14.6055 5.52684 14.4946 5.5 14.3775 5.5H7.30644Z",
                          fill: "currentColor"
                        })
                      ],
                      -1
                      /* HOISTED */
                    ))
                  ])
                ]),
                showPopup.value ? (openBlock(), createElementBlock("div", _hoisted_33, [
                  createBaseVNode("div", {
                    class: "product-popup-modal__content hm:md:!overflow-hidden hm:transition-all hm:pointer-events-auto hm:!w-[calc(100vw-3.2rem)]",
                    onClick: _cache[0] || (_cache[0] = withModifiers(() => {
                    }, ["stop"]))
                  }, [
                    createBaseVNode("button", {
                      onClick: toggle,
                      type: "button",
                      class: "product-popup-modal__close modal-close-button focus-inset",
                      "aria-label": "Schlie\xDFen"
                    }, _cache[2] || (_cache[2] = [
                      createBaseVNode(
                        "svg",
                        {
                          class: "icon icon-close",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "18",
                          height: "18",
                          viewBox: "0 0 18 18",
                          fill: "none"
                        },
                        [
                          createBaseVNode("path", {
                            d: "M14.0625 3.9375L3.9375 14.0625",
                            stroke: "currentColor",
                            "stroke-width": "1.8",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }),
                          createBaseVNode("path", {
                            d: "M14.0625 14.0625L3.9375 3.9375",
                            stroke: "currentColor",
                            "stroke-width": "1.8",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ],
                        -1
                        /* HOISTED */
                      )
                    ])),
                    createVNode(popup_default2, {
                      onGoalChanged: changeGoal,
                      title: __props.title,
                      goals: props.goals,
                      preselectedCurrentGoal: currentGoal.value
                    }, null, 8, ["title", "goals", "preselectedCurrentGoal"])
                  ])
                ])) : createCommentVNode("v-if", true)
              ],
              512
              /* NEED_PATCH */
            )
          ],
          64
          /* STABLE_FRAGMENT */
        );
      };
    }
  };

  // src/js/components/charity.vue
  var charity_default2 = charity_default;

  // vue-script:/Users/mona/Documents/workspace/tonton-shopify/src/js/components/register.vue?type=script
  var _hoisted_112 = {
    key: 1,
    class: "hm:text-foreground"
  };
  var _hoisted_212 = {
    key: 0,
    class: "hm:text-2xl hm:font-bold hm:mb-2 hm:text-center"
  };
  var _hoisted_34 = {
    key: 1,
    class: "hm:text-2xl hm:text-center"
  };
  var _hoisted_43 = { class: "hm:w-full hm:min-w-full hm:lg:flex hm:flex-wrap hm:gap-4 hm:items-center hm:justify-between hm:mb-5" };
  var _hoisted_53 = { class: "hm:w-full hm:min-w-full hm:lg:flex hm:flex-wrap hm:gap-4 hm:items-center hm:justify-between" };
  var _hoisted_62 = { class: "hm:w-full hm:min-w-full hm:lg:flex hm:flex-wrap hm:gap-4 hm:items-center hm:justify-between" };
  var _hoisted_72 = { class: "hm:w-full hm:lg:flex hm:flex-wrap hm:gap-4 hm:items-center hm:mb-5 hm:justify-between" };
  var _hoisted_82 = { key: 2 };
  var _hoisted_92 = { class: "hm:mt-2" };
  var _hoisted_102 = { class: "hm:mt-2" };
  var url3 = "https://tonton.herrlich-media.de/tontonRegister.php";
  var register_default = {
    __name: "register",
    props: {
      title: {
        type: String,
        default: "Registriere dich als Partner"
      },
      description: {
        type: String,
        default: "Mit dem tonton Partnerprogramm unterst\xFCtzen wir gezielt gemeinn\xFCtzige Organisationen. Nach deiner Registrierung pr\xFCfen wir die Angaben und schalten dich frei. Anschlie\xDFend erh\xE4ltst du Zugang zu hochwertigen tonton Schulranzen zu Vorzugspreisen \u2013 und profitierst zus\xE4tzlich von unserem 1:1-Prinzip: F\xFCr jeden verkauften Schulranzen spenden wir ein \xE4hnliches Modell an die gemeinn\xFCtzige Organisation, die beim Kauf von Kund*innen ausgew\xE4hlt wurde. Beim tonton Mini flie\xDFen 5 \u20AC an eine Kita. So wird deine Teilnahme am Partnerprogramm doppelt wirksam \u2013 durch faire Konditionen und durch konkrete Hilfe f\xFCr Kinder."
      },
      btnTitle: {
        type: String,
        default: "Registrierung abschlie\xDFen"
      },
      popup: {
        type: String,
        default: "true"
      },
      textalign: {
        type: String,
        default: "center"
      }
    },
    setup(__props) {
      const props = __props;
      const showPopup = ref(false);
      const togglePopup = () => {
        showPopup.value = !showPopup.value;
      };
      window.addEventListener("openPartnerRegistration", (e) => {
        togglePopup();
      });
      const activateB2b = ref(false);
      const submitted = ref(false);
      const tryAgain = ref(false);
      const error2 = ref(false);
      const errorMessage = ref("");
      const successMessage = ref("");
      const schoolbagDonation = ref("Ja");
      const miniDonation = ref("Ja");
      const shipping_address_1 = ref("");
      const zip = ref("");
      const city = ref("");
      const lat = ref("");
      const long = ref("");
      const result = ref(null);
      const loading2 = ref(false);
      const errorGeo = ref("");
      async function geocode() {
        const address = ref(`${shipping_address_1.value}, ${zip.value} ${city.value}, Deutschland`);
        if (!address.value) return;
        loading2.value = true;
        errorGeo.value = "";
        try {
          const params = new URLSearchParams({
            q: address.value,
            format: "json",
            limit: 1,
            addressdetails: 1
          });
          const url4 = `https://nominatim.openstreetmap.org/search?${params.toString()}`;
          const response = await fetch(url4, {
            headers: {
              "User-Agent": "MyVueApp/1.0 (info@herrlich-media.de)",
              // <- bitte anpassen!
              "Accept-Language": "de"
            }
          });
          if (!response.ok) throw new Error(`HTTP-Fehler ${response.status}`);
          const data = await response.json();
          if (!data.length) {
            errorGeo.value = "Adresse nicht gefunden.";
            return;
          }
          lat.value = data[0].lat;
          long.value = data[0].lon;
        } catch (err) {
          errorGeo.value = "Fehler bei der Abfrage: " + err.message;
        } finally {
          loading2.value = false;
        }
      }
      const submitHandler = async (data) => {
        const body = new FormData();
        body.append("first_name", data["multi-step_2"].contactData.first_name);
        body.append("last_name", data["multi-step_2"].contactData.last_name);
        body.append("email", data["multi-step_2"].contactData.email);
        body.append("phone", data["multi-step_2"].contactData.phone || "");
        body.append("company", data["multi-step_2"].organisationData.name);
        body.append("note", data["multi-step_2"].organisationData.description || "");
        body.append("website", data["multi-step_2"].organisationData.website || "");
        body.append("schoolbagDonation", data["multi-step_2"].organisationData.schoolbagDonation == "Ja" ? true : false);
        body.append("miniDonation", data["multi-step_2"].organisationData.miniDonation == "Ja" ? true : false);
        body.append("createB2B", activateB2b.value);
        data["multi-step_2"].organisationData.logo.forEach((fileItem2) => {
          body.append("logo", fileItem2.file);
        });
        body.append("address1", data["multi-step_2"].contactData.shipping_address_1 || "");
        body.append("address2", data["multi-step_2"].contactData.shipping_address_2 || "");
        body.append("city", data["multi-step_2"].contactData.shipping_city || "");
        body.append("zip", data["multi-step_2"].contactData.shipping_zip || "");
        body.append("country", data["multi-step_2"].contactData.shipping_country || "");
        body.append("lat", lat.value || "");
        body.append("long", long.value || "");
        try {
          const response = await fetch(url3, {
            method: "POST",
            body
          });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const result2 = await response.json();
          if (result2.response.customer.status == "error") {
            error2.value = true;
            if (result2.response.customer.data.phone) {
              errorMessage.value = "Die Telefonnummer ist ung\xFCltig.";
              tryAgain.value = true;
            } else if (result2.response.customer.data.email) {
              errorMessage.value = "Die E-Mail Adresse ist ung\xFCltig oder es besteht bereits ein Account mit dieser E-Mail Adresse.";
              tryAgain.value = true;
            } else {
              errorMessage.value = "Es sind ung\xFCltige Daten vorhanden, bitte \xFCberpr\xFCfe deine Eingaben.";
              tryAgain.value = true;
            }
          } else if (result2.response.customer.status == "notcreated") {
            submitted.value = true;
            tryAgain.value = false;
            error2.value = false;
            successMessage.value = "Deine Registrierung wurde erfolgreich \xFCbermittelt. Wir pr\xFCfen deine Angaben und schalten dich schnellstm\xF6glich frei.";
          } else {
            submitted.value = true;
            tryAgain.value = false;
            error2.value = false;
            successMessage.value = "Deine Registrierung wurde erfolgreich \xFCbermittelt. Wir pr\xFCfen deine Angaben und schalten dich schnellstm\xF6glich frei. Anschlie\xDFend erh\xE4ltst du Zugang zu unserem B2B Bereich und kannst Schulranzen zu Vorzugspreisen bestellen.";
          }
        } catch (error3) {
          console.error("Error:", error3);
        }
      };
      return (_ctx, _cache) => {
        return openBlock(), createElementBlock(
          Fragment,
          null,
          [
            __props.popup == "true" ? (openBlock(), createElementBlock(
              "div",
              {
                key: 0,
                class: normalizeClass({ "hm:text-center": __props.textalign == "center", "hm:text-left": __props.textalign == "left", "hm:text-right": __props.textalign == "right" })
              },
              [
                createBaseVNode("button", {
                  class: "button button--primary focus-inset",
                  onClick: togglePopup
                }, "Partner werden")
              ],
              2
              /* CLASS */
            )) : createCommentVNode("v-if", true),
            __props.popup == "false" || __props.popup == "true" && showPopup.value ? (openBlock(), createElementBlock(
              "div",
              {
                key: 1,
                class: normalizeClass({ "hm:fixed hm:inset-0 hm:bg-overlay-100 hm:backdrop-blur-xs hm:z-100 hm:pointer-events-none hm:w-[100vw]": __props.popup === "true", "hm:max-w-7xl hm:m-auto hm:p-8 hm:lg:p-12 hm:bg-white hm:rounded-[3.2rem] hm:lg:rounded-[5.2rem] hm:shadow-lg hm:flex hm:flex-col hm:items-center hm:gap-6": __props.popup === "false" })
              },
              [
                createBaseVNode(
                  "div",
                  {
                    class: normalizeClass({ "register-popup-modal__content hm:md:!overflow-y-auto hm:transition-all hm:pointer-events-auto hm:!w-[calc(100vw-3.2rem)] hm:!rounded-[3.2rem] hm:lg:!rounded-[5.2rem]": __props.popup == "true" })
                  },
                  [
                    __props.popup == "true" ? (openBlock(), createElementBlock("button", {
                      key: 0,
                      onClick: togglePopup,
                      type: "button",
                      class: "register-popup-modal__close modal-close-button focus-inset hm:absolute hm:right-4 hm:top-4",
                      "aria-label": "Schlie\xDFen"
                    }, _cache[6] || (_cache[6] = [
                      createBaseVNode(
                        "svg",
                        {
                          class: "icon icon-close",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "18",
                          height: "18",
                          viewBox: "0 0 18 18",
                          fill: "none"
                        },
                        [
                          createBaseVNode("path", {
                            d: "M14.0625 3.9375L3.9375 14.0625",
                            stroke: "currentColor",
                            "stroke-width": "1.8",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }),
                          createBaseVNode("path", {
                            d: "M14.0625 14.0625L3.9375 3.9375",
                            stroke: "currentColor",
                            "stroke-width": "1.8",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ],
                        -1
                        /* HOISTED */
                      )
                    ]))) : createCommentVNode("v-if", true),
                    submitted.value == false && (error2.value == false || tryAgain.value == true) ? (openBlock(), createElementBlock("div", _hoisted_112, [
                      __props.title ? (openBlock(), createElementBlock(
                        "h2",
                        _hoisted_212,
                        toDisplayString(__props.title),
                        1
                        /* TEXT */
                      )) : createCommentVNode("v-if", true),
                      __props.description ? (openBlock(), createElementBlock(
                        "p",
                        _hoisted_34,
                        toDisplayString(__props.description),
                        1
                        /* TEXT */
                      )) : createCommentVNode("v-if", true),
                      createVNode(unref(FormKit_default), {
                        type: "form",
                        id: "registration-example",
                        "form-class": submitted.value ? "hide" : "show",
                        "submit-label": "Register",
                        onSubmit: submitHandler,
                        actions: false
                      }, {
                        default: withCtx(() => [
                          createVNode(unref(FormKit_default), {
                            type: "multi-step",
                            "tab-style": "progress",
                            "allow-incomplete": false,
                            "before-step-change": geocode
                          }, {
                            default: withCtx(() => [
                              createVNode(unref(FormKit_default), {
                                type: "step",
                                name: "organisationData",
                                label: "Organisation",
                                "next-label": "Weiter"
                              }, {
                                default: withCtx(() => [
                                  _cache[7] || (_cache[7] = createBaseVNode(
                                    "div",
                                    { class: "hm:mb-6" },
                                    [
                                      createBaseVNode("h3", { class: "h4 hm:!text-foreground hm:mb-3" }, "Erz\xE4hl uns etwas \xFCber deine Organisation"),
                                      createBaseVNode("p", { class: "hm:text-2xl" }, " Bitte teile uns den Namen und die Art deiner Organisation mit, damit wir deine Registrierung schnellstm\xF6glich bearbeiten k\xF6nnen. ")
                                    ],
                                    -1
                                    /* HOISTED */
                                  )),
                                  createVNode(unref(FormKit_default), {
                                    type: "text",
                                    name: "name",
                                    label: "Name der Organisation",
                                    placeholder: "Deine Organisation.",
                                    validation: "required",
                                    "outer-class": "hm:mb-5",
                                    "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0",
                                    "inner-class": "hm:mb-1",
                                    "input-class": ""
                                  }),
                                  createVNode(unref(FormKit_default), {
                                    type: "textarea",
                                    name: "description",
                                    label: "Beschreibung der Organisation",
                                    placeholder: "Eine kurze Beschreibung deiner Organisation und was euch ausmacht",
                                    validation: "required|length:20,500",
                                    "outer-class": "hm:mb-5",
                                    "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0",
                                    "inner-class": "hm:mb-1",
                                    "input-class": "hm:h-30"
                                  }),
                                  _cache[8] || (_cache[8] = createBaseVNode(
                                    "h4",
                                    { class: "h5 hm:!text-foreground hm:mb-3" },
                                    "Bei welchen Spendenprojekten m\xF6chtest du teilnehmen?",
                                    -1
                                    /* HOISTED */
                                  )),
                                  createBaseVNode("div", _hoisted_43, [
                                    createVNode(unref(FormKit_default), {
                                      modelValue: schoolbagDonation.value,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => schoolbagDonation.value = $event),
                                      name: "schoolbagDonation",
                                      type: "radio",
                                      label: "Schulranzen Spendenziel",
                                      options: ["Ja", "Nein"],
                                      help: "Deine Organisation kann als Spendenziel bei Schulranzenverk\xE4ufen ausgew\xE4hlt werden.",
                                      "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0"
                                    }, null, 8, ["modelValue"]),
                                    createVNode(unref(FormKit_default), {
                                      modelValue: miniDonation.value,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => miniDonation.value = $event),
                                      name: "miniDonation",
                                      type: "radio",
                                      label: "tonton Minis Spendenziel",
                                      options: ["Ja", "Nein"],
                                      help: "Deine Organisation kann als Spendenziel bei tonton Minis ausgew\xE4hlt werden.",
                                      "label-class": "hm:block hm:mb-1 hm:font-bold"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  createVNode(unref(FormKit_default), {
                                    type: "file",
                                    name: "logo",
                                    label: "Logo",
                                    accept: ".jpg,.svg,.png, .jpeg",
                                    multiple: "false",
                                    placeholder: "test",
                                    help: "Datei als .jpg, .svg, .png, oder .jpeg (max. 2MB).",
                                    validation: "maxSize:2048|mimes:image/jpeg,image/png,image/svg+xml",
                                    "outer-class": "hm:mb-5",
                                    "label-class": "hm:block hm:mb-1 hm:font-bold",
                                    "inner-class": "hm:mb-1 hm:appearance-none",
                                    "input-class": ""
                                  }),
                                  createVNode(unref(FormKit_default), {
                                    type: "text",
                                    name: "website",
                                    label: "Website der Organisation",
                                    placeholder: "deine-organisation.de",
                                    "outer-class": "hm:mb-5",
                                    "label-class": "hm:block hm:mb-1 hm:font-bold",
                                    "inner-class": "hm:mb-1",
                                    "input-class": ""
                                  })
                                ]),
                                _: 1
                                /* STABLE */
                              }),
                              createVNode(unref(FormKit_default), {
                                type: "step",
                                name: "contactData",
                                label: "Ansprechpartner:in",
                                "next-label": "Weiter"
                              }, {
                                default: withCtx(() => [
                                  _cache[9] || (_cache[9] = createBaseVNode(
                                    "div",
                                    { class: "hm:mb-6" },
                                    [
                                      createBaseVNode("h3", { class: "h4 hm:!text-foreground hm:mb-3" }, "Ansprechpartner:in")
                                    ],
                                    -1
                                    /* HOISTED */
                                  )),
                                  createBaseVNode("div", _hoisted_53, [
                                    createVNode(unref(FormKit_default), {
                                      type: "text",
                                      name: "first_name",
                                      label: "Vorname",
                                      validation: "required",
                                      "outer-class": "hm:mb-5 hm:flex-1",
                                      "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0",
                                      "inner-class": "hm:mb-1",
                                      "input-class": "",
                                      "help-class": "hm:text-md hm:text-gray-500"
                                    }),
                                    createVNode(unref(FormKit_default), {
                                      type: "text",
                                      name: "last_name",
                                      label: "Nachname",
                                      validation: "required",
                                      "outer-class": "hm:mb-5 hm:flex-1",
                                      "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0",
                                      "inner-class": "hm:mb-1",
                                      "input-class": "",
                                      "help-class": "hm:text-md hm:text-gray-500"
                                    })
                                  ]),
                                  createBaseVNode("div", _hoisted_62, [
                                    createVNode(unref(FormKit_default), {
                                      type: "email",
                                      name: "email",
                                      label: "E-mail Adresse",
                                      validation: "required|email",
                                      "outer-class": "hm:mb-5 hm:flex-1",
                                      "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0"
                                    }),
                                    createVNode(unref(FormKit_default), {
                                      type: "tel",
                                      name: "phone",
                                      label: "Telefonnummer",
                                      "validation-visibility": "dirty",
                                      "validation-messages": {
                                        matches: "Telefonnummer darf nur aus Zahlen bestehen"
                                      },
                                      "outer-class": "hm:mb-5 hm:flex-1",
                                      "label-class": "hm:block hm:mb-1 hm:font-bold",
                                      "inner-class": "hm:mb-1",
                                      "input-class": "",
                                      "help-class": "hm:text-md hm:text-gray-500"
                                    })
                                  ]),
                                  _cache[10] || (_cache[10] = createBaseVNode(
                                    "h4",
                                    { class: "h5 hm:!text-foreground hm:mb-3" },
                                    "Lieferadresse",
                                    -1
                                    /* HOISTED */
                                  )),
                                  createVNode(unref(FormKit_default), {
                                    type: "text",
                                    name: "shipping_address_1",
                                    label: "Adresse",
                                    validation: "required",
                                    "outer-class": "hm:mb-5 hm:flex-1",
                                    "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0",
                                    "inner-class": "hm:mb-1",
                                    "input-class": "",
                                    modelValue: shipping_address_1.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => shipping_address_1.value = $event)
                                  }, null, 8, ["modelValue"]),
                                  createVNode(unref(FormKit_default), {
                                    type: "text",
                                    name: "shipping_address_2",
                                    label: "Adresszusatz",
                                    "outer-class": "hm:mb-5 hm:flex-1",
                                    "label-class": "hm:block hm:mb-1 hm:font-bold",
                                    "inner-class": "hm:mb-1",
                                    "input-class": ""
                                  }),
                                  createBaseVNode("div", _hoisted_72, [
                                    createVNode(unref(FormKit_default), {
                                      type: "text",
                                      name: "shipping_zip",
                                      label: "Postleitzahl",
                                      validation: "required|length:5",
                                      "outer-class": "hm:mb-5 hm:flex-1",
                                      "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0",
                                      "inner-class": "hm:mb-1",
                                      "input-class": "",
                                      modelValue: zip.value,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => zip.value = $event)
                                    }, null, 8, ["modelValue"]),
                                    createVNode(unref(FormKit_default), {
                                      type: "text",
                                      name: "shipping_city",
                                      label: "Stadt",
                                      validation: "required",
                                      "outer-class": "hm:mb-5 hm:flex-1",
                                      "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0",
                                      "inner-class": "hm:mb-1",
                                      "input-class": "",
                                      modelValue: city.value,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => city.value = $event)
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  createVNode(unref(FormKit_default), {
                                    type: "select",
                                    name: "shipping_country",
                                    label: "Land",
                                    validation: "required",
                                    value: "Deutschland",
                                    "outer-class": "hm:mb-5 hm:flex-1",
                                    "label-class": "hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0",
                                    "inner-class": "hm:mb-1",
                                    "input-class": "",
                                    options: ["Deutschland"]
                                  })
                                ]),
                                _: 1
                                /* STABLE */
                              }),
                              createVNode(unref(FormKit_default), {
                                type: "step",
                                name: "b2bData",
                                label: "B2Nonprofit"
                              }, {
                                default: withCtx(() => [
                                  _cache[11] || (_cache[11] = createBaseVNode(
                                    "div",
                                    { class: "hm:mb-6" },
                                    [
                                      createBaseVNode("h3", { class: "h4 hm:!text-foreground hm:mb-3" }, "B2Nonprofit Account erstellen"),
                                      createBaseVNode("p", { class: "hm:text-2xl" }, " Mit dem B2Nonprofit Account haben Partner die M\xF6glichkeit, Schulranzen f\xFCr Ihr Projekt direkt zu beziehen \u2013 zum sozialen Partnerpreis f\xFCr ca. 75 Euro pro St\xFCck. Keine Mindestabnahme, kein b\xFCrokratischer Aufwand \u2013 nur echte Partnerschaft. ")
                                    ],
                                    -1
                                    /* HOISTED */
                                  )),
                                  createVNode(unref(FormKit_default), {
                                    type: "checkbox",
                                    label: "B2Nonprofit Account erstellen?",
                                    name: "b2b_account",
                                    modelValue: activateB2b.value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => activateB2b.value = $event),
                                    "label-class": "hm:font-bold hm:cursor-pointer hm:ps-2"
                                  }, null, 8, ["modelValue"]),
                                  createCommentVNode(' <div v-if="activateB2b" class="hm:mt-6"> '),
                                  createCommentVNode(' <FormKit\n                                type="text"\n                                name="tax_id"\n                                label="USt-ID"\n                                \n                                outer-class="hm:mb-5 hm:flex-1"\n                                label-class="hm:block hm:mb-1 hm:font-bold"\n                                inner-class="hm:mb-1"\n                                input-class=""\n                                help-class="hm:text-md hm:text-gray-500"\n                            /> '),
                                  createCommentVNode(" </div> ")
                                ]),
                                _: 1
                                /* STABLE */
                              }),
                              createVNode(unref(FormKit_default), {
                                type: "step",
                                name: "termsData",
                                label: "Abschlie\xDFen"
                              }, {
                                stepNext: withCtx(() => [
                                  createVNode(unref(FormKit_default), {
                                    type: "submit",
                                    label: __props.btnTitle,
                                    "input-class": "button button--primary button--fullwidth focus-inset"
                                  }, null, 8, ["label"])
                                ]),
                                default: withCtx(() => [
                                  _cache[12] || (_cache[12] = createBaseVNode(
                                    "div",
                                    { class: "hm:mb-6" },
                                    [
                                      createBaseVNode("h3", { class: "h4 hm:!text-foreground hm:mb-3" }, "Registrierung Abschlie\xDFen")
                                    ],
                                    -1
                                    /* HOISTED */
                                  )),
                                  createVNode(unref(FormKit_default), {
                                    type: "checkbox",
                                    label: "Ich habe die Datenschutzerkl\xE4rung und AGB gelesen und akzeptiere sie.",
                                    help: "Ich best\xE4tige, dass die angegebenen Daten korrekt sind und ich berechtigt bin, im Namen der Organisation zu handeln.",
                                    name: "terms",
                                    value: false,
                                    validation: "accepted",
                                    "validation-visibility": "dirty",
                                    "label-class": "hm:cursor-pointer hm:ps-2 hm:inline-block hm:pe-3 hm:mb-1 hm:font-bold hm:relative hm:after:content-['*'] hm:after:text-red-500 hm:after:absolute hm:after:top-0 hm:after:right-0"
                                  })
                                ]),
                                _: 1
                                /* STABLE */
                              })
                            ]),
                            _: 1
                            /* STABLE */
                          })
                        ]),
                        _: 1
                        /* STABLE */
                      }, 8, ["form-class"])
                    ])) : createCommentVNode("v-if", true),
                    submitted.value ? (openBlock(), createElementBlock("div", _hoisted_82, [
                      _cache[13] || (_cache[13] = createBaseVNode(
                        "h3",
                        { class: "h4 hm:text-xl hm:text-green-500" },
                        "Registrierung erfolgreich!",
                        -1
                        /* HOISTED */
                      )),
                      createBaseVNode(
                        "p",
                        _hoisted_92,
                        toDisplayString(successMessage.value),
                        1
                        /* TEXT */
                      )
                    ])) : createCommentVNode("v-if", true),
                    error2.value ? (openBlock(), createElementBlock(
                      "div",
                      {
                        key: 3,
                        class: normalizeClass({ "hm:mt-6": tryAgain.value == true })
                      },
                      [
                        _cache[14] || (_cache[14] = createBaseVNode(
                          "h3",
                          { class: "h4 hm:text-xl hm:text-red-500" },
                          " Es ist ein Fehler aufgetreten. ",
                          -1
                          /* HOISTED */
                        )),
                        createBaseVNode(
                          "p",
                          _hoisted_102,
                          toDisplayString(errorMessage.value),
                          1
                          /* TEXT */
                        )
                      ],
                      2
                      /* CLASS */
                    )) : createCommentVNode("v-if", true)
                  ],
                  2
                  /* CLASS */
                )
              ],
              2
              /* CLASS */
            )) : createCommentVNode("v-if", true)
          ],
          64
          /* STABLE_FRAGMENT */
        );
      };
    }
  };

  // src/js/components/register.vue
  var register_default2 = register_default;

  // src/js/herrlich-app.js
  var app = createApp({
    components: {
      charity: charity_default2,
      map: map_default2,
      goal: goal_default2,
      register: register_default2
    },
    setup() {
    }
  });
  app.config.devtools = true;
  app.use(plugin, defaultConfig2(formkit_config_default));
  app.mount("#app");
  window.addEventListener("changegoal", (e) => {
    const input2 = document.querySelectorAll('input[name="properties[Spendenziel]"]')[0];
    if (input2 != null) {
      input2.setAttribute("value", e.detail.goal);
    }
  });
})();
/*! Bundled license information:

mapbox-gl/dist/mapbox-gl.js:
  (**
   * martinez v0.7.4
   * Martinez polygon clipping algorithm, does boolean operation on polygons (multipolygons, polygons with holes etc): intersection, union, difference, xor
   *
   * @author Alex Milevski <info@w8r.name>
   * @license MIT
   * @preserve
   *)
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

@vue/shared/dist/shared.esm-bundler.js:
  (**
  * @vue/shared v3.5.13
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)
  (*! #__NO_SIDE_EFFECTS__ *)

@vue/reactivity/dist/reactivity.esm-bundler.js:
  (**
  * @vue/reactivity v3.5.13
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)

@vue/runtime-core/dist/runtime-core.esm-bundler.js:
  (**
  * @vue/runtime-core v3.5.13
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)
  (*! #__NO_SIDE_EFFECTS__ *)

@vue/runtime-dom/dist/runtime-dom.esm-bundler.js:
  (**
  * @vue/runtime-dom v3.5.13
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)
  (*! #__NO_SIDE_EFFECTS__ *)

@vue/compiler-core/dist/compiler-core.esm-bundler.js:
  (**
  * @vue/compiler-core v3.5.13
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)

@vue/compiler-dom/dist/compiler-dom.esm-bundler.js:
  (**
  * @vue/compiler-dom v3.5.13
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)

vue/dist/vue.esm-bundler.js:
  (**
  * vue v3.5.13
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)

vue/dist/vue.runtime.esm-bundler.js:
  (**
  * vue v3.5.13
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)
*/
